(function () {
    'use strict';

    angular.module('app', [
        'angular-img-cropper',
        'app.administration',
        'app.administration.assetManagement',
        'app.administration.annualSeasonPlan',
        'app.administration.annualSeasonPlan.annualSeasonPlanReportPage1',
        'app.administration.annualSeasonPlan.annualSeasonPlanReportPage2',
        'app.administration.annualSeasonPlan.annualSeasonPlanReportPage3',
        'app.administration.annualSeasonPlan.annualSeasonPlanReportPage4',
        'app.administration.annualSeasonPlan.annualSeasonPlanReportPage5',
        'app.administration.annualSeasonPlan.annualSeasonPlanReportPage6',
        'app.administration.annualSeasonPlan.annualSeasonPlanList',
        'app.administration.awayBudgetPlan',
        'app.administration.awayBudgetPlan.awayBudgetPlanCreate',
        'app.administration.awayBudgetPlan.awayBudgetPlanList',
        'app.administration.exercises',
        'app.administration.exercises.exercisesList',
        'app.administration.exercises.exercisesCreate',
        'app.administration.trainingPlan',
        'app.administration.trainingPlan.trainingPlanTemplate',
        'app.administration.trainingPlan.trainingPlanCreate',
        'app.administration.trainingPlan.trainingPlanList',
        'app.administration.competitiveMonthlyPlan',
        'app.administration.resultReportAthletes',
        'app.administration.resultReportTeam',
        'app.administration.monthlyAttendance',
        'app.administration.monthlyAttendance.monthlyAttendanceList',
        'app.administration.monthlyAttendance.monthlyAttendanceReport',
        'app.administration.monthlyTrainingPlan',
        'app.administration.monthlyTrainingPlan.monthlyTrainingPlanList',
        'app.administration.monthlyTrainingPlan.monthlyTrainingPlanReport',
        'app.administration.quickCompetitionResults',
        'app.administration.dailyAttendance',
        'app.administration.trainingDiary',
        'app.administration.sportSpecificTest',
        'app.athletes.athletesManagement.athleteModify.athletesSportSpecificTestList',
        'app.administration.sportSpecificTest.newSportSpecificTestList',
        'app.administration.sportSpecificTest.newSportSpecificTest',
        'app.administration.test',
        'app.administration.test.newTest',
        'app.administration.test.testList',
        'app.administration.test.testResults',
        'app.administration.competitiveMonthlyPlan.competitiveMonthlyPlanList',
        'app.administration.competitiveMonthlyPlan.competitiveMonthlyPlanReport',
        'app.administration.weeklyTrainingPlan',
        'app.administration.weeklyTrainingPlan.weeklyTrainingPlanList',
        'app.administration.weeklyTrainingPlan.weeklyTrainingPlanReport',
        'app.athleteDashboard',
        'app.athletes',
        'app.athletes.ageGroups',
        'app.athletes.ageGroups.addAgeGroup',
        'app.athletes.ageGroups.ageGroupMembersList',
        'app.athletes.ageGroups.ageGroupsList',
        'app.athletes.ageGroups.modifyAgeGroup',
        'app.athletes.athletesManagement',
        'app.athletes.athletesManagement.athleteNew',
        'app.athletes.athletesManagement.athleteModify',
        'app.athletes.athletesManagement.athleteModify.dataSheet',
        'app.athletes.athletesManagement.athleteModify.athleteFees',
        'app.athletes.athletesManagement.athleteModify.raceResultsReport',
        'app.athletes.athletesManagement.athleteModify.anthropometry',
        'app.athletes.athletesManagement.athleteModify.athleteLog',
        'app.athletes.athletesManagement.athletesList',
        'app.athletes.athletesManagement.athleteModify.competitionResultsChart',
        'app.athletes.athletesManagement.athleteModify.athletesAssets',
        'app.athletes.teams',
        'app.athletes.teams.addTeam',
        'app.athletes.teams.addTeamMember',
        'app.athletes.teams.modifyTeam',
        'app.athletes.teams.teamList',
        'app.athletes.teams.teamMembersList',
        'app.athletes.sections',
        'app.business',
        'app.business.annualEducationalFeeByAthletes',
        'app.business.annualEducationalFeeByCoach',
        'app.business.annualEducationalFeeByOneSection',
        'app.business.annualEducationalFeeBySection',
        'app.business.monthlyAttendanceArrears',
        'app.business.annualSportServiceFeeByAthletes',
        'app.business.annualSportServiceFeeByCoach',
        'app.business.annualSportServiceFeeByOneSection',
        'app.business.annualSportServiceFeeBySection',
        'app.business.checkPayment',
        'app.business.csvPayment',
        'app.business.checkPrintingExport',
        'app.business.dailyEducationalFeePayments',
        'app.business.dailySportServiceFeePayments',
        'app.business.educationalFeeRegister',
        'app.business.modifyFees',
        'app.business.sportServiceFeeArrears',
        'app.business.sportServiceFeeRegister',
        'app.business.dailyEducationalFeesPerCoach',
        'app.business.dailySportServiceFeesPerCoach',
        'app.athletes.athletesManagement.athleteModify.health',
        'app.athletes.athletesManagement.athleteModify.health.healthList',
        'app.athletes.athletesManagement.athleteModify.health.newHealthEvent',
        'app.athletes.athletesManagement.athleteModify.health.modifyHealthEvent',
        'app.reports.annualPresenceReports',
        'app.reports.annualPresenceReports.annualPresenceReportsByTrainers',
        'app.reports.annualPresenceReports.annualPresenceReportsBySections',
        'app.reports.annualPresenceReports.annualPresenceReportsBySportSchool',
        'app.reports.annualPresenceReports',
        'app.athletes.athletesManagement.athleteModify.athletesBodyStat',
        'app.reports.awayBudgetPlanSummary',
        'app.reports.assetInventoryReports',
        'app.reports.assetInventoryReportByUsers',
        'app.reports.assetInventoryReportByType',
        'app.reports.weeklyTravelReport',
        'app.reports.weeklyTrainingReport',
        'app.core',
        'app.dashboard',
        'app.layout',
        'app.login',
        'app.messageCenter',
        'app.messageCenter.messageCenter',
        'app.messageCenter.newMessage',
        'app.messageCenter.sentMessages',
        'app.paint',
        'app.parentDashboard',
        'app.parentMonthlyAttendance',
        'app.athletes.athletesManagement.athleteModify.files',
        'app.athletes.athletesManagement.athleteModify.psychology',
        'app.athletes.athletesManagement.athleteModify.psychology.performanceMotivationTest',
        'app.athletes.athletesManagement.athleteModify.psychology.performanceMotivationTestEvaluation',
        'app.athletes.athletesManagement.athleteModify.psychology.pieronTest',
        'app.athletes.athletesManagement.athleteModify.psychology.pieronTestEvaluation',
        'app.athletes.athletesManagement.athleteModify.psychology.summary',
        'app.athletes.athletesManagement.athleteModify.psychology.tenesseeSelfImageScale',
        'app.athletes.athletesManagement.athleteModify.psychology.tenesseeSelfImageScaleEvaluation',
        'app.athletes.athletesManagement.athleteModify.psychology.wartegg',
        'app.reports',
        'app.reports.anthropometryTestPrinting',
        'app.reports.athleteTransfer',
        'app.reports.duplicatedAthletes',
        'app.reports.managementReports',
        'app.reports.managementReports.annualCompetitivePlans',
        'app.reports.managementReports.monthlyAttendanceReports',
        'app.reports.managementReports.monthlyCompetitivePlans',
        'app.reports.managementReports.weeklyTrainingPlans',
        'app.reports.managementReports.trainingDiaryReports',
        'app.reports.monthlyCompetitivePlans',
        'app.reports.playUpAndDown',
        'app.reports.raceResultsReport',
        'app.reports.statisticalReports',
        'app.reports.trainingAttendanceReport',
        'app.reports.sportSpecificReport',
        'app.reports.expiringDocuments',
        'app.reports.absenceReport',
        'app.reports.centralReport',
        'app.reports.centralReport.centralReportAllIn',
        'app.reports.centralReport.centralReportByRating',
        'app.athletes.athletesManagement.athleteModify.centralReportOfAthlete',
        'app.reports.statisticalReports.activeAthletesByCoach',
        'app.reports.statisticalReports.activeAthletesBySection',
        'app.reports.statisticalReports.joinedAthletesBySection',
        'app.reports.statisticalReports.leavingAthletesBySection',
        'app.reports.statisticalReports.listAthletes',
        'app.reports.statisticalReports.leavingAthletesByCoach',
        'app.reports.statisticalReports.joinedAthletesByCoach',
        'app.reports.statisticalReports.activeAthletesByAge',
        'app.reports.statisticalReports.activeAthletesByMonth',
        'app.reports.statisticalReports.athletesByBirthYear',
        'app.reports.statisticalReports.athletesByYear',
        'app.reports.statisticalReports.activeAthletesInSectionByMonth',
        'app.reports.statisticalReports.athletesNotPresentOnMonthlyAttendance',
        'app.athletes.athletesManagement.athleteModify.trainingVisitReport',
        'app.reports.healthReport',
        'app.schedule',
        'app.search',
        'app.search.athletes',
        'app.search.athletes.simple',
        'app.search.athletes.memberList',
        'app.search.user',
        'app.search.user.searchuser',
        'app.settings',
        'app.settings.ageGroupChange',
        'app.settings.athleteTransfer',
        'app.settings.createSportSpecificTest',
        'app.settings.editSection',
        'app.settings.editHealthType',
        'app.settings.schoolManagement',
        'app.settings.schoolManagement.addSchool',
        'app.settings.schoolManagement.editSchool',
        'app.settings.schoolManagement.schoolList',
        'app.settings.systemSettings',
        'app.settings.userGroupsManagement',
        'app.settings.userManagement',
        'app.settings.userManagement.newUser',
        'app.settings.userManagement.modifyUser',
        'app.settings.userManagement.userSettings',
        'app.settings.userManagement.userList',
        'app.settings.userRights',
        'app.settings.usersBelongingToAthletes',
        'ejangular',
        'gettext',
        'LocalStorageModule',
        'app.other',
        'app.other.files'
    ]);
})();

(function () {
    'use strict';

    angular.module('app.administration', []);
})();

(function () {
    'use strict';

    angular.module('app.administration.annualSeasonPlan', []);
})();

(function () {
    'use strict';

    angular.module('app.administration.annualSeasonPlan.annualSeasonPlanList', []);
})();

(function () {
    'use strict';

    angular.module('app.administration.annualSeasonPlan.annualSeasonPlanReportPage1', []);
})();

(function () {
    'use strict';

    angular.module('app.administration.annualSeasonPlan.annualSeasonPlanReportPage2', []);
})();

(function () {
    'use strict';

    angular.module('app.administration.annualSeasonPlan.annualSeasonPlanReportPage3', []);
})();

(function () {
    'use strict';

    angular.module('app.administration.annualSeasonPlan.annualSeasonPlanReportPage4', []);
})();

(function () {
    'use strict';

    angular.module('app.administration.annualSeasonPlan.annualSeasonPlanReportPage5', []);
})();

(function () {
    'use strict';

    angular.module('app.administration.annualSeasonPlan.annualSeasonPlanReportPage6', []);
})();

(function () {
    'use strict';

    angular.module('app.administration.assetManagement', []);
})();

(function () {
    'use strict';

    angular.module('app.administration.awayBudgetPlan', []);
})();

(function () {
    'use strict';

    angular.module('app.administration.awayBudgetPlan.awayBudgetPlanCreate', []);
})();

(function () {
    'use strict';

    angular.module('app.administration.awayBudgetPlan.awayBudgetPlanList', []);
})();

(function () {
    'use strict';

    angular.module('app.administration.competitiveMonthlyPlan', []);
})();

(function () {
    'use strict';

    angular.module('app.administration.competitiveMonthlyPlan.competitiveMonthlyPlanList', []);
})();

(function () {
    'use strict';

    angular.module('app.administration.competitiveMonthlyPlan.competitiveMonthlyPlanReport', []);
})();

(function () {
    'use strict';

    angular.module('app.administration.dailyAttendance', []);
})();

(function () {
    'use strict';

    angular.module('app.administration.exercises', []);
})();

(function () {
    'use strict';

    angular.module('app.administration.exercises.exercisesCreate', []);
})();

(function () {
    'use strict';

    angular.module('app.administration.exercises.exercisesList', []);
})();

(function () {
    'use strict';

    angular.module('app.administration.monthlyAttendance', []);
})();

(function () {
    'use strict';

    angular.module('app.administration.monthlyAttendance.monthlyAttendanceList', []);
})();

(function () {
    'use strict';

    angular.module('app.administration.monthlyAttendance.monthlyAttendanceReport', []);
})();

(function () {
    'use strict';

    angular.module('app.administration.monthlyTrainingPlan', []);
})();

(function () {
    'use strict';

    angular.module('app.administration.monthlyTrainingPlan.monthlyTrainingPlanList', []);
})();

(function () {
    'use strict';

    angular.module('app.administration.monthlyTrainingPlan.monthlyTrainingPlanReport', []);
})();

(function () {
    'use strict';

    angular.module('app.administration.quickCompetitionResults', []);
})();

(function () {
    'use strict';

    angular.module('app.administration.resultReportAthletes', []);
})();

(function () {
    'use strict';

    angular.module('app.administration.resultReportTeam', []);
})();

(function () {
    'use strict';

    angular.module('app.administration.sportSpecificTest.newSportSpecificTest', []);
})();

(function () {
    'use strict';

    angular.module('app.administration.sportSpecificTest.newSportSpecificTestList', []);
})();

(function () {
    'use strict';

    angular.module('app.administration.sportSpecificTest', []);
})();

(function () {
    'use strict';

    angular.module('app.administration.test.newTest', []);
})();

(function () {
    'use strict';

    angular.module('app.administration.test', []);
})();

(function () {
    'use strict';

    angular.module('app.administration.test.testList', []);
})();

(function () {
    'use strict';

    angular.module('app.administration.test.testResults', []);
})();

(function () {
    'use strict';

    angular.module('app.administration.trainingDiary', []);
})();

(function () {
    'use strict';

    angular.module('app.administration.trainingPlan', []);
})();

(function () {
    'use strict';

    angular.module('app.administration.trainingPlan.trainingPlanCreate', []);
})();

(function () {
    'use strict';

    angular.module('app.administration.trainingPlan.trainingPlanList', []);
})();

(function () {
    'use strict';

    angular.module('app.administration.trainingPlan.trainingPlanTemplate', []);
})();

(function () {
    'use strict';

    angular.module('app.administration.weeklyTrainingPlan', []);
})();

(function () {
    'use strict';

    angular.module('app.administration.weeklyTrainingPlan.weeklyTrainingPlanList', [
    ]);
})();

(function () {
    'use strict';

    angular.module('app.administration.weeklyTrainingPlan.weeklyTrainingPlanReport', []);
})();

(function () {
    'use strict';

    angular.module('app.athleteDashboard', []);
})();

(function () {
    'use strict';

    angular.module('app.athletes.ageGroups.addAgeGroup', []);
})();

(function () {
    'use strict';

    angular.module('app.athletes.ageGroups.ageGroupMembersList', []);
})();

(function () {
    'use strict';

    angular.module('app.athletes.ageGroups', []);
})();

(function () {
    'use strict';

    angular.module('app.athletes.ageGroups.ageGroupsList', []);
})();

(function () {
    'use strict';

    angular.module('app.athletes.ageGroups.modifyAgeGroup', []);
})();

(function () {
    'use strict';

    angular.module('app.athletes', []);
})();

(function () {
    'use strict';

    angular.module('app.athletes.athletesManagement.athleteModify.anthropometry', []);
})();

(function () {
    'use strict';

    angular.module('app.athletes.athletesManagement.athleteModify.athleteFees', []);
})();

(function () {
    'use strict';

    angular.module('app.athletes.athletesManagement.athleteModify.athleteLog', []);
})();

(function () {
    'use strict';

    angular.module('app.athletes.athletesManagement.athleteModify', []);
})();

(function () {
    'use strict';

    angular.module('app.athletes.athletesManagement.athleteModify.athletesAssets', []);
})();

(function () {
    'use strict';

    angular.module('app.athletes.athletesManagement.athleteModify.athletesBodyStat', []);
})();

(function () {
    'use strict';

    angular.module('app.athletes.athletesManagement.athleteModify.athletesSportSpecificTestList', []);
})();

(function () {
    'use strict';

    angular.module('app.athletes.athletesManagement.athleteModify.centralReportOfAthlete', []);
})();

(function () {
    'use strict';

    angular.module('app.athletes.athletesManagement.athleteModify.competitionResultsChart', []);
})();

(function () {
    'use strict';

    angular.module('app.athletes.athletesManagement.athleteModify.dataSheet', []);
})();

(function () {
    'use strict';

    angular.module('app.athletes.athletesManagement.athleteModify.files', []);
})();

(function () {
    'use strict';

    angular.module('app.athletes.athletesManagement.athleteModify.health', []);
})();

(function () {
    'use strict';

    angular.module('app.athletes.athletesManagement.athleteModify.health.healthList', []);
})();

(function () {
    'use strict';

    angular.module('app.athletes.athletesManagement.athleteModify.health.modifyHealthEvent', []);
})();

(function () {
    'use strict';

    angular.module('app.athletes.athletesManagement.athleteModify.health.newHealthEvent', []);
})();

(function () {
    'use strict';

    angular.module('app.athletes.athletesManagement.athleteModify.psychology.performanceMotivationTest', []);
})();

(function () {
    'use strict';

    angular.module('app.athletes.athletesManagement.athleteModify.psychology.performanceMotivationTestEvaluation', []);
})();

(function () {
    'use strict';

    angular.module('app.athletes.athletesManagement.athleteModify.psychology.pieronTest', []);
})();

(function () {
    'use strict';

    angular.module('app.athletes.athletesManagement.athleteModify.psychology.pieronTestEvaluation', []);
})();

(function () {
    'use strict';

    angular.module('app.athletes.athletesManagement.athleteModify.psychology', []);
})();

(function () {
    'use strict';

    angular.module('app.athletes.athletesManagement.athleteModify.psychology.summary', []);
})();

(function () {
    'use strict';

    angular.module('app.athletes.athletesManagement.athleteModify.psychology.tenesseeSelfImageScale', []);
})();

(function () {
    'use strict';

    angular.module('app.athletes.athletesManagement.athleteModify.psychology.tenesseeSelfImageScaleEvaluation', []);
})();

(function () {
    'use strict';

    angular.module('app.athletes.athletesManagement.athleteModify.psychology.wartegg', []);
})();

(function () {
    'use strict';

    angular.module('app.athletes.athletesManagement.athleteModify.raceResultsReport', []);
})();

(function () {
    'use strict';

    angular.module('app.athletes.athletesManagement.athleteModify.trainingVisitReport', []);
})();

(function () {
    'use strict';

    angular.module('app.athletes.athletesManagement.athleteNew', []);
})();

(function () {
    'use strict';

    angular.module('app.athletes.athletesManagement.athletesList', []);
})();

(function () {
    'use strict';

    angular.module('app.athletes.athletesManagement', []);
})();

(function () {
    'use strict';

    angular.module('app.athletes.sections', []);
})();

(function () {
    'use strict';

    angular.module('app.athletes.teams.addTeam', []);
})();

(function () {
    'use strict';

    angular.module('app.athletes.teams.addTeamMember', []);
})();

(function () {
    'use strict';

    angular.module('app.athletes.teams.modifyTeam', []);
})();

(function () {
    'use strict';

    angular.module('app.athletes.teams.teamList', []);
})();

(function () {
    'use strict';

    angular.module('app.athletes.teams.teamMembersList', []);
})();

(function () {
    'use strict';

    angular.module('app.athletes.teams', []);
})();

(function () {
    'use strict';

    angular.module('blocks.exception', ['blocks.logger']);
})();

(function () {
    'use strict';

    angular.module('blocks.logger', []);
})();

(function () {
    'use strict';

    angular.module('blocks.router', [
        'ui.router',
        'blocks.logger'
    ]);
})();

(function () {
    'use strict';

    angular.module('app.business.annualEducationalFeeByAthletes', []);
})();

(function () {
    'use strict';

    angular.module('app.business.annualEducationalFeeByCoach', []);
})();

(function () {
    'use strict';

    angular.module('app.business.annualEducationalFeeByOneSection', []);
})();

(function () {
    'use strict';

    angular.module('app.business.annualEducationalFeeBySection', []);
})();

(function () {
    'use strict';

    angular.module('app.business.annualSportServiceFeeByAthletes', []);
})();

(function () {
    'use strict';

    angular.module('app.business.annualSportServiceFeeByCoach', []);
})();

(function () {
    'use strict';

    angular.module('app.business.annualSportServiceFeeByOneSection', []);
})();

(function () {
    'use strict';

    angular.module('app.business.annualSportServiceFeeBySection', []);
})();

(function () {
    'use strict';

    angular.module('app.business', []);
})();

(function () {
    'use strict';

    angular.module('app.business.checkPayment', []);
})();

(function () {
    'use strict';

    angular.module('app.business.checkPrintingExport', []);
})();

(function () {
    'use strict';

    angular.module('app.business.csvPayment', []);
})();

(function () {
    'use strict';

    angular.module('app.business.dailyEducationalFeePayments', []);
})();

(function () {
    'use strict';

    angular.module('app.business.dailyEducationalFeesPerCoach', []);
})();

(function () {
    'use strict';

    angular.module('app.business.dailySportServiceFeePayments', []);
})();

(function () {
    'use strict';

    angular.module('app.business.dailySportServiceFeesPerCoach', []);
})();

(function () {
    'use strict';

    angular.module('app.business.educationalFeeRegister', []);
})();

(function () {
    'use strict';

    angular.module('app.business.modifyFees', []);
})();

(function () {
    'use strict';

    angular.module('app.business.monthlyAttendanceArrears', []);
})();

(function () {
    'use strict';

    angular.module('app.business.sportServiceFeeArrears', []);
})();

(function () {
    'use strict';

    angular.module('app.business.sportServiceFeeRegister', []);
})();

(function () {
    'use strict';

    angular
        .module('app.core', [
            'blocks.exception', 'blocks.logger', 'blocks.router',
            'ui.router', 'ngCookies', 'ui.router.state.events'
        ]);
})();

(function () {
    'use strict';

    angular.module('app.dashboard', []);
})();

(function () {
    'use strict';

    angular.module('app.layout', ['app.core']);
})();

(function () {
    'use strict';

    angular.module('app.login', []);
})();

(function () {
    'use strict';

    angular.module('app.messageCenter', []);
})();

(function () {
    'use strict';

    angular.module('app.messageCenter.messageCenter', []);
})();

(function () {
    'use strict';

    angular.module('app.messageCenter.newMessage', []);
})();

(function () {
    'use strict';

    angular.module('app.messageCenter.sentMessages', []);
})();

(function () {
    'use strict';

    angular.module('app.other.files', []);
})();

(function () {
    'use strict';

    angular.module('app.other', []);
})();

(function () {
    'use strict';

    angular.module('app.paint', []);
})();

(function () {
    'use strict';

    angular.module('app.parentDashboard', []);
})();

(function () {
    'use strict';

    angular.module('app.parentMonthlyAttendance', []);
})();

(function () {
    'use strict';

    angular.module('app.reports.absenceReport', []);
})();

(function () {
    'use strict';

    angular.module('app.reports.annualPresenceReports', []);
})();

(function () {
    'use strict';

    angular.module('app.reports.annualPresenceReports.annualPresenceReportsBySections', []);
})();

(function () {
    'use strict';

    angular.module('app.reports.annualPresenceReports.annualPresenceReportsBySportSchool', []);
})();

(function () {
    'use strict';

    angular.module('app.reports.annualPresenceReports.annualPresenceReportsByTrainers', []);
})();

(function () {
    'use strict';

    angular.module('app.reports.anthropometryTestPrinting', []);
})();

(function () {
    'use strict';

    angular.module('app.reports.assetInventoryReportByType', []);
})();

(function () {
    'use strict';

    angular.module('app.reports.assetInventoryReportByUsers', []);
})();

(function () {
    'use strict';

    angular.module('app.reports.assetInventoryReports', []);
})();

(function () {
    'use strict';

    angular.module('app.reports.athleteTransfer', []);
})();

(function () {
    'use strict';

    angular.module('app.reports.awayBudgetPlanSummary', []);
})();

(function () {
    'use strict';

    angular.module('app.reports.centralReport', []);
})();

(function () {
    'use strict';

    angular.module('app.reports.centralReport.centralReportAllIn', []);
})();

(function () {
    'use strict';

    angular.module('app.reports.centralReport.centralReportByRating', []);
})();

(function () {
    'use strict';

    angular.module('app.reports.duplicatedAthletes', []);
})();

(function () {
    'use strict';

    angular.module('app.reports.expiringDocuments', []);
})();

(function () {
    'use strict';

    angular.module('app.reports.healthReport', []);
})();

(function () {
    'use strict';

    angular.module('app.reports.managementReports.annualCompetitivePlans', []);
})();

(function () {
    'use strict';

    angular.module('app.reports.managementReports', []);
})();

(function () {
    'use strict';

    angular.module('app.reports.managementReports.monthlyAttendanceReports', []);
})();

(function () {
    'use strict';

    angular.module('app.reports.managementReports.monthlyCompetitivePlans', []);
})();

(function () {
    'use strict';

    angular.module('app.reports.managementReports.trainingDiaryReports', []);
})();

(function () {
    'use strict';

    angular.module('app.reports.managementReports.weeklyTrainingPlans', []);
})();

(function () {
    'use strict';

    angular.module('app.reports.monthlyCompetitivePlans', []);
})();

(function () {
    'use strict';

    angular.module('app.reports.playUpAndDown', []);
})();

(function () {
    'use strict';

    angular.module('app.reports.raceResultsReport', []);
})();

(function () {
    'use strict';

    angular.module('app.reports', []);
})();

(function () {
    'use strict';

    angular.module('app.reports.sportSpecificReport', []);
})();

(function () {
    'use strict';

    angular.module('app.reports.statisticalReports.activeAthletesByAge', []);
})();

(function () {
    'use strict';

    angular.module('app.reports.statisticalReports.activeAthletesByCoach', []);
})();

(function () {
    'use strict';

    angular.module('app.reports.statisticalReports.activeAthletesByMonth', []);
})();

(function () {
    'use strict';

    angular.module('app.reports.statisticalReports.activeAthletesBySection', []);
})();

(function () {
    'use strict';

    angular.module('app.reports.statisticalReports.activeAthletesInSectionByMonth', []);
})();

(function () {
    'use strict';

    angular.module('app.reports.statisticalReports.athletesByBirthYear', []);
})();

(function () {
    'use strict';

    angular.module('app.reports.statisticalReports.athletesByYear', []);
})();

(function () {
    'use strict';

    angular.module('app.reports.statisticalReports.athletesNotPresentOnMonthlyAttendance', []);
})();

(function () {
    'use strict';

    angular.module('app.reports.statisticalReports.joinedAthletesByCoach', []);
})();

(function () {
    'use strict';

    angular.module('app.reports.statisticalReports.joinedAthletesBySection', []);
})();

(function () {
    'use strict';

    angular.module('app.reports.statisticalReports.leavingAthletesByCoach', []);
})();

(function () {
    'use strict';

    angular.module('app.reports.statisticalReports.leavingAthletesBySection', []);
})();

(function () {
    'use strict';

    angular.module('app.reports.statisticalReports.listAthletes', []);
})();

(function () {
    'use strict';

    angular.module('app.reports.statisticalReports', []);
})();

(function () {
    'use strict';

    angular.module('app.reports.trainingAttendanceReport', []);
})();

(function () {
    'use strict';

    angular.module('app.reports.weeklyTrainingReport', []);
})();

(function () {
    'use strict';

    angular.module('app.reports.weeklyTravelReport', []);
})();

(function () {
    'use strict';

    angular.module('app.schedule', []);
})();

(function () {
    'use strict';

    angular.module('app.search.athletes', []);
})();

(function () {
    'use strict';

    angular.module('app.search.athletes.memberList', []);
})();

(function () {
    'use strict';

    angular.module('app.search.athletes.simple', []);
})();

(function () {
    'use strict';

    angular.module('app.search', []);
})();

(function () {
    'use strict';

    angular.module('app.search.user.searchuser', []);
})();

(function () {
    'use strict';

    angular.module('app.search.user', []);
})();

(function () {
    'use strict';

    angular.module('app.settings.ageGroupChange', []);
})();

(function () {
    'use strict';

    angular.module('app.settings.athleteTransfer', []);
})();

(function () {
    'use strict';

    angular.module('app.settings.createSportSpecificTest', []);
})();

(function () {
    'use strict';

    angular.module('app.settings.editHealthType', []);
})();

(function () {
    'use strict';

    angular.module('app.settings.editSection', []);
})();

(function () {
    'use strict';

    angular.module('app.settings.schoolManagement.addSchool', []);
})();

(function () {
    'use strict';

    angular.module('app.settings.schoolManagement.editSchool', []);
})();

(function () {
    'use strict';

    angular.module('app.settings.schoolManagement.schoolList', []);
})();

(function () {
    'use strict';

    angular.module('app.settings.schoolManagement', []);
})();

(function () {
    'use strict';

    angular.module('app.settings', []);
})();

(function () {
    'use strict';

    angular.module('app.settings.systemSettings', []);
})();

(function () {
    'use strict';

    angular.module('app.settings.userGroupsManagement', []);
})();

(function () {
    'use strict';

    angular.module('app.settings.userManagement.modifyUser', []);
})();

(function () {
    'use strict';

    angular.module('app.settings.userManagement.newUser', []);
})();

(function () {
    'use strict';

    angular.module('app.settings.userManagement.userList', []);
})();

(function () {
    'use strict';

    angular.module('app.settings.userManagement', []);
})();

(function () {
    'use strict';

    angular.module('app.settings.userManagement.userSettings', []);
})();

(function () {
    'use strict';

    angular.module('app.settings.userRights', []);
})();

(function () {
    'use strict';

    angular.module('app.settings.usersBelongingToAthletes', []);
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.administration')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'administration',
                config: {
                    title: 'Administration',
                    url: '/administration',
                    templateUrl: 'app/administration/administration.html',
                    settings: {
                        navId: 2,
                        level: 1,
                        order: 2,
                        parentId: 0,
                        content: 'Administration',
                        activatorPermission: ['"MEGTEVVERST"', '"ESZKNYILVMEGT"', '"MEGTIDEGENKOLTSTERV"', '"MEGTHAVIVERST"', '"MEGTHAVIJEL"', '"MEGTHAVIEDZTERV"',
                                              '"UJEERJEL"', '"MEGTEERJEL"', '"MEGTCSERJEL"', '"MEGTSPFELM"', '"MEGTKPFELM"', '"MEGTEDZESSABLON"']
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.administration.annualSeasonPlan')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'administration.annualSeasonPlan',
                config: {
                    url: '/annualSeasonPlan',
                    templateUrl: 'app/administration/annualSeasonPlan/annualSeasonPlan.html',
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    AnnualSeasonPlanListController.$inject = ["$rootScope", "gettextCatalog", "dataservice", "log", "$q", "authenticationService", "paramHelper", "$scope", "$state"];
    angular
        .module('app.administration.annualSeasonPlan.annualSeasonPlanList')
        .controller('AnnualSeasonPlanListController', AnnualSeasonPlanListController);

    function AnnualSeasonPlanListController($rootScope, gettextCatalog, dataservice, log, $q, authenticationService, paramHelper, $scope, $state) {
        var vm = this; $rootScope.vm = vm; // jshint ignore: line

        // Page title
        $rootScope.title = gettextCatalog.getString('AnnualSeasonPlanList');
        vm.columns = [];
        //Évek (2010-től az aktuális évig)
        vm.yearList = [];
        for (var ev = 2010; ev <= new Date().getFullYear(); ev++) {
            vm.yearList.push(ev + ' / ' + (ev + 1));
        }
        //Kiválasztott év (alapból az aktuális)
        vm.selectedYear = new Date().getFullYear() + ' / ' + (new Date().getFullYear() + 1);

        vm.yearDataBound = yearDataBound;
        vm.yearSelect = yearSelect;
        vm.goToNewAgeGroup = goToNewAgeGroup;
        vm.goToNewCoach = goToNewCoach;
        vm.goToAnnualSeasonPlan = goToAnnualSeasonPlan;

        vm.columns = [
            {
                field: 'Id',
                visible: false,
                isPrimaryKey: true,
                isIdentity: true
            },

            {
                field: 'Link',
                width: 60,
                headerText: '',
                textAlign: 'center',
                allowEditing: false,
                template: '#ansepllitemplateDataColumn6'
            },
            {
                field: 'EgyeniTerv',
                headerText: gettextCatalog.getString('Egyeni'),
                textAlign: 'center',
                allowEditing: false,
                editType: ej.Grid.EditingType.Boolean,
                template: '#ansepllitemplateDataColumn1'
            },
            {
                field: 'SzakosztalyNeve',
                headerText: gettextCatalog.getString('Section'),
                textAlign: 'center',
                allowEditing: false
            },
            {
                field: 'KorosztalyNeve',
                headerText: gettextCatalog.getString('AgeGroup'),
                textAlign: 'center',
                allowEditing: false,
                template: '#ansepllitemplateDataColumn2'
            },
            {
                field: 'EdzoNeve',
                headerText: gettextCatalog.getString('Coach'),
                textAlign: 'center',
                allowEditing: false,
                template: '#ansepllitemplateDataColumn3'
            },
            {
                field: 'EdzoLezarta',
                headerText: gettextCatalog.getString('Closed'),
                textAlign: 'center',
                allowEditing: false,
                editType: ej.Grid.EditingType.Boolean,
                template: '#ansepllitemplateDataColumn4'
            },
            {
                field: 'SzakosztalyvezetoJovahagyta',
                headerText: gettextCatalog.getString('LeaderAccepted'),
                textAlign: 'center',
                allowEditing: false,
                editType: ej.Grid.EditingType.Boolean,
                template: '#ansepllitemplateDataColumn5'
            }];

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItems,
            allowPaging: true,
            allowTextWrap: true,
            allowSorting: true,
            allowExcelExport: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            beforePrint: $rootScope.beforePrintGrid,
            printComplete: $rootScope.printCompleteGrid,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#Grid'), $scope);
                }
            },
            rowSelected: function (args) {
                vm.selectedRowId = args.data.Id;
                vm.delEnabled = vm.MODHETIEDZTERV;
                $scope.$apply();
            },
            rowDeselected: function () {
                vm.delEnabled = false;
                vm.selectedRowId = -1;
                $scope.$apply();
            },
            beforePrint: $rootScope.beforePrintGrid,
            printComplete: $rootScope.printCompleteGrid
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        activate();

        function activate() {
            $q.all([paramHelper.getParams([], ['AnnualSeasonPlanReport.Id', 'AnnualSeasonPlanList.Year']),
                authenticationService.getRight('EDZO'),
                authenticationService.getRight('ADMIN'),
                authenticationService.getRight('SZAKOSZTVEZ'),
                authenticationService.getRight('TECHIGAZGATO'),
                authenticationService.getRight('MEGTKOROSZT'),
                authenticationService.getRight('MEGTFELH'),
                authenticationService.getRight('MEGTEVVERST')])
                .then(function (results) {
                    vm.EDZO = results[1];
                    vm.ADMIN = results[2];
                    vm.SZAKOSZTVEZ = results[3];
                    vm.TECHIGAZGATO = results[4];
                    vm.MEGTKOROSZT = results[5];
                    vm.MEGTFELH = results[6];
                    vm.MEGTEVVERST = results[7];
                    vm.selectedYear = results[0]['AnnualSeasonPlanList.Year'];
                    if (!vm.MEGTEVVERST) {
                        log.permissionError(true);
                        return;
                    }
                    if (!vm.selectedYear) {
                        vm.selectedYear = new Date().getFullYear() + ' / ' + (new Date().getFullYear() + 1);
                    }

                    dataservice.annualSeasonPlanList(vm.selectedYear.split('/')[0])
                        .then(function (args) {
                            grid.dataSource = args.itemsList;
                        });
                    paramHelper.removeParam('AnnualSeasonPlanReport.Id');
                });
        }

        // Run after data bounded
        function yearDataBound() {
            if (vm.yearList.length === 1) {
                angular.element('#maEv').ejDropDownList('selectItemByValue', vm.yearList[0].value);
                vm.selectedYear = vm.yearList[0].value;
            } else {
                angular.element('#maEv').ejDropDownList('selectItemByValue', vm.selectedYear);
            }
        }

        // Run after selection
        function yearSelect(args) {
            vm.selectedYear = args.value;
            paramHelper.setParams([{'AnnualSeasonPlanList.Year': vm.selectedYear}]);

            dataservice.annualSeasonPlanList(vm.selectedYear.split('/')[0])
                .then(function (args) {
                    grid.dataSource = args.itemsList;
                });
        }

        function goToNewAgeGroup(args) {
            if (!vm.MEGTKOROSZT) {
                log.permissionError();
                return;
            }
            paramHelper.setParams([{
                'ageGroups.ageGroup': args
            }]);
            $state.go('athletes.ageGroups.modifyAgeGroup');
        }

        function goToNewCoach(args) {
            if (!vm.MEGTFELH) {
                log.permissionError();
                return;
            }
            paramHelper.setParams([{
                'newUser.userId': args
            }]);
            $state.go('settings.userManagement.modifyUser');
        }

        function goToAnnualSeasonPlan(args) {
            if (!vm.MEGTEVVERST) {
                log.permissionError();
                return;
            }
            paramHelper.setParams([{
                'AnnualSeasonPlanReport.Id': args,
                'AnnualSeasonPlanList.Year': vm.selectedYear
            }]);
            $state.go('administration.annualSeasonPlan.annualSeasonPlanReportPage1');
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.administration.annualSeasonPlan.annualSeasonPlanList')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'administration.annualSeasonPlan.annualSeasonPlanList',
                config: {
                    url: '/annualSeasonPlanList',
                    templateUrl: 'app/administration/annualSeasonPlan/annualSeasonPlanList/annualSeasonPlanList.html',
                    controller: 'AnnualSeasonPlanListController',
                    controllerAs: 'vm',
                    title: 'AnnualSeasonPlanList',
                    settings: {
                        navId: 284,
                        level: 2,
                        order: 8,
                        orderTitle_hu: 'Éves felkészítési és versenyeztetési terv lista',
                        orderTitle_en: 'Annual Preparation and Competition Plan List',
                        parentId: 4,
                        content: 'AnnualSeasonPlanList',
                        activatorPermission: '"MEGTEVVERST"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    AnnualSeasonPlanReportPage1Controller.$inject = ["$rootScope", "gettextCatalog", "dataservice", "log", "$q", "authenticationService", "paramHelper", "$scope", "$state", "$timeout"];
    angular
        .module('app.administration.annualSeasonPlan.annualSeasonPlanReportPage1')
        .controller('AnnualSeasonPlanReportPage1Controller', AnnualSeasonPlanReportPage1Controller);

    function AnnualSeasonPlanReportPage1Controller($rootScope, gettextCatalog, dataservice, log, $q, authenticationService, paramHelper, $scope, $state, $timeout) {
        var vm = this;
        $rootScope.vm = vm; // jshint ignore: line

        // Page title
        $rootScope.title = gettextCatalog.getString('AnnualSeasonPlan');
        vm.columns = [];
        vm.egyeni = false;
        vm.annualSeasonPlanReportId = 0;
        vm.loadedById = false;

        //Évek (2010-től az aktuális évig)
        vm.years = [];
        for (var ev = 2010; ev <= new Date().getFullYear(); ev++) {
            vm.years.push(ev + ' / ' + (ev + 1));
        }
        //Kiválasztott év (alapból az aktuális)
        vm.selectedYear = new Date().getFullYear() + ' / ' + (new Date().getFullYear() + 1);
        //Edzők listája, kiválasztott edző
        vm.coachList = [];
        vm.selectedCoach = -1;
        vm.coachContact = '';
        vm.coachEmail = '';
        //Szakosztályok listája, kiválasztott szakosztály
        vm.sectionList = [];
        vm.selectedSection = -1;
        //Korcsoportok listája, kiválasztott korcsoport
        vm.ageGroupList = [];
        vm.selectedAgeGroup = -1;
        // coach dropdown
        vm.coachDataBound = coachDataBound;
        vm.coachSelect = coachSelect;
        // section dropdown
        vm.sectionDataBound = sectionDataBound;
        vm.sectionSelect = sectionSelect;
        // ageGroup dropdown
        vm.ageGroupDataBound = ageGroupDataBound;
        vm.ageGroupSelect = ageGroupSelect;
        // year dropdown
        vm.yearSelect = yearSelect;
        // jump page
        vm.JumpPageList = [
            '1 - ' + gettextCatalog.getString('TheMostImportantDataOfAGroupsMembers'),
            '2 - ' + gettextCatalog.getString('PreparationAndCompetitionPast'),
            '3 - ' + gettextCatalog.getString('OutstandingResults'),
            '4 - ' + gettextCatalog.getString('CapitalObjectives'),
            '5 - ' + gettextCatalog.getString('CompetitionPlansAndObjectives'),
            '6 - ' + gettextCatalog.getString('YearlyTablePlan')
        ];

        vm.noAnnualSeasonPlan = false;
        vm.hasAnnualSeasonPlan = false;
        vm.hasSignedAnnualSeasonPlan = false;
        vm.hasAcceptedAnnualSeasonPlan = false;

        vm.data = [];
        vm.autoSelect = false;

        // functions
        vm.coachDataBound = coachDataBound;
        vm.coachSelect = coachSelect;
        vm.sectionDataBound = sectionDataBound;
        vm.sectionSelect = sectionSelect;
        vm.ageGroupDataBound = ageGroupDataBound;
        vm.ageGroupSelect = ageGroupSelect;
        vm.annualSeasonPlanReportSelect = annualSeasonPlanReportSelect;
        vm.goToNewAthlete = goToNewAthlete;
        vm.refreshData = refreshData;
        vm.goToNextPage = goToNextPage;
        vm.annualSeasonPlanReportCreate = annualSeasonPlanReportCreate;
        vm.goToOlderAnnualSeasonPlanReports = goToOlderAnnualSeasonPlanReports;
        vm.jumpPageDataBound = jumpPageDataBound;
        vm.jumpPageSelect = jumpPageSelect;

        initGrid();

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItemsWithSearch,
            editSettings: {allowEditing: true, mode: 'Batch', showConfirmDialog: false},
            allowTextWrap: true,
            allowSorting: true,
            allowExcelExport: true,
            allowDeleting: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile(angular.element('#Grid'), $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        activate();

        function activate() {
            vm.jumpedPage = '1 - ' + gettextCatalog.getString('TheMostImportantDataOfAGroupsMembers');
            vm.defaultJumpPage = '1 - ' + gettextCatalog.getString('TheMostImportantDataOfAGroupsMembers');
            $q.all([paramHelper.getParams([],
                [
                    'AnnualSeasonPlanReport.Id',
                    'AnnualSeasonPlanReport.sectionId',
                    'AnnualSeasonPlanReport.ageGroupId',
                    'AnnualSeasonPlanReport.coachId',
                    'AnnualSeasonPlanReport.year'
                ]),
                    authenticationService.getRight('EDZO'),
                    authenticationService.getRight('ADMIN'),
                    authenticationService.getRight('SZAKOSZTVEZ'),
                    authenticationService.getRight('TECHIGAZGATO'),
                    authenticationService.getRight('EVVERSTALAIR1'),
                    authenticationService.getRight('EVVERSTALAIR2'),
                    authenticationService.getRight('UJEVVERST'),
                    authenticationService.getRight('MEGTSPORTLIST'),
                    authenticationService.getRight('MEGTEVVERST')])
                .then(function (results) {
                    vm.EDZO = results[1];
                    vm.ADMIN = results[2];
                    vm.SZAKOSZTVEZ = results[3];
                    vm.TECHIGAZGATO = results[4];
                    vm.EVVERSTALAIR1 = results[5];
                    vm.EVVERSTALAIR2 = results[6];
                    vm.UJEVVERST = results[7];
                    vm.MEGTSPORTLIST = results[8];
                    vm.MEGTEVVERST = results[9];
                    if (!vm.MEGTEVVERST) {
                        log.permissionError(true);
                        return;
                    }

                    vm.selectedSection = results[0]['AnnualSeasonPlanReport.sectionId'];
                    vm.selectedAgeGroup = results[0]['AnnualSeasonPlanReport.ageGroupId'];
                    vm.selectedCoach = results[0]['AnnualSeasonPlanReport.coachId'];
                    if (results[0]['AnnualSeasonPlanReport.year'] != null) {
                        vm.selectedYear = results[0]['AnnualSeasonPlanReport.year'];
                    }
                    if (results[0]['AnnualSeasonPlanReport.Id'] && results[0]['AnnualSeasonPlanReport.Id'] !== -1) {
                        dataservice.annualSeasonPlanReportSelectById(results[0]['AnnualSeasonPlanReport.Id'])
                            .then(function (data) {
                                if (data.EdzoLezarta) {
                                    vm.hasSignedAnnualSeasonPlan = true;
                                } else if (data.SzakosztalyvezetoJovahagyta) {
                                    vm.hasAcceptedAnnualSeasonPlan = true;
                                } else {
                                    vm.hasAnnualSeasonPlan = true;
                                }
                                vm.selectedCoach = data.IdEdzo;
                                vm.selectedSection = data.IdSzakosztaly;
                                vm.selectedAgeGroup = data.IdKorosztaly;
                                vm.loadedById = true;
                                $timeout(function () {
                                    angular.element('#maEv').ejDropDownList('selectItemByValue', new Date(data.ErvenyessegTol).getFullYear() + ' / ' + new Date(data.ErvenyessegIg).getFullYear());
                                    getCoaches();
                                    vm.autoSelect = true;
                                    viewAnnualSeasonPlanReport(data);
                                    annualSeasonPlanReportSelect();
                                    paramHelper.removeParam('AnnualSeasonPlanReport.Id');
                                }, 333);
                            });
                    } else {
                        getCoaches();
                    }
                });
        }

        //edzők lekérése
        function getCoaches() {
            return dataservice.coachSelect().then(
                function (data) {
                    vm.coachList = data.itemsList;
                }
            );
        }

        // Run after data bounded
        function coachDataBound() {
            if (vm.coachList.length === 1) {
                angular.element('#maEdzo').ejDropDownList('selectItemByValue', vm.coachList[0].value);
            } else {
                angular.element('#maEdzo').ejDropDownList('selectItemByValue', vm.selectedCoach);
            }
        }

        // Run after selection
        function coachSelect(args) {
            vm.selectedCoach = args.value;
            vm.sectionList = [];
            vm.ageGroupList = [];
            getSections();
            dataservice.getTrainerEmailContact(vm.selectedCoach)
                .then(function (data) {
                    vm.coachContact = data.retValue.contact;
                    vm.coachEmail = data.retValue.email;
                });
        }

        //szakosztályok lekérése
        function getSections() {
            return dataservice.sectionDropDownList(vm.selectedCoach, true)
                .then(function (data) {
                    vm.sectionList = data.itemsList;
                });
        }

        // Run after data bounded
        function sectionDataBound() {
            if (vm.sectionList.length === 1) {
                angular.element('#maSzakosztaly').ejDropDownList('selectItemByValue', vm.sectionList[0].value);
            } else {
                angular.element('#maSzakosztaly').ejDropDownList('selectItemByValue', vm.selectedSection);
            }
        }

        // Run after selection
        function sectionSelect(args) {
            vm.selectedSection = args.value;
            getAgeGroups();
            dataservice.sectionIndividualOrTeam(vm.selectedSection)
                .then(function (data) {
                    vm.egyeni = data.retValue;
                });
        }

        //korcsoportok lekérése
        function getAgeGroups() {
            return dataservice.ageGroupSelectYear(vm.selectedCoach, vm.selectedSection, vm.selectedYear.split('/')[0])
                .then(function (data) {
                    vm.ageGroupList = data.itemsList;
                });
        }

        // Run after data bounded
        function ageGroupDataBound() {
            if (vm.ageGroupList.length === 1) {
                angular.element('#maKorosztaly').ejDropDownList('selectItemByValue', vm.ageGroupList[0].value);
            } else {
                angular.element('#maKorosztaly').ejDropDownList('selectItemByValue', vm.selectedAgeGroup);
                var vmi = angular.element('#maKorosztaly').data('ejDropDownList');
                if (vm.autoSelect && vmi.selectedIndexValue >= 0) {
                    annualSeasonPlanReportSelect();
                }
            }
        }

        // Run after selection
        function ageGroupSelect(args) {
            vm.selectedAgeGroup = args.value;
        }

        // Run after selection
        function yearSelect(args) {
            vm.selectedYear = args.value;
            if (vm.loadedById === false) {
                getAgeGroups();
            } else {
                vm.loadedById = false;
            }
        }

        function jumpPageDataBound() {
            angular.element('#maKorabbi').ejDropDownList('selectItemByValue', vm.defaultJumpPage);
            vm.selectedJumpPage = vm.defaultJumpPage;
        }

        function jumpPageSelect(args) {
            vm.selectedJumpPage = args.value;
            var sorszam = vm.selectedJumpPage.split('-')[0];
            if (sorszam === '1 ') {
                return;
            }

            if (!vm.hasSignedAnnualSeasonPlan) {
                dataservice.saveAnnualSeasonPlanMembers(vm.data)
                    .then(function () {
                        log.successMsg('SaveCompleted');
                    });
            }
            $timeout(function () {
                paramHelper.setParams([{'AnnualSeasonPlanReport.Id': vm.annualSeasonPlanReportId}]);
                switch (sorszam) {
                    case '1 ':
                        $state.go('administration.annualSeasonPlan.annualSeasonPlanReportPage1');
                        break;
                    case '2 ':
                        $state.go('administration.annualSeasonPlan.annualSeasonPlanReportPage2');
                        break;
                    case '3 ':
                        $state.go('administration.annualSeasonPlan.annualSeasonPlanReportPage3');
                        break;
                    case '4 ':
                        $state.go('administration.annualSeasonPlan.annualSeasonPlanReportPage4');
                        break;
                    case '5 ':
                        $state.go('administration.annualSeasonPlan.annualSeasonPlanReportPage5');
                        break;
                    case '6 ':
                        $state.go('administration.annualSeasonPlan.annualSeasonPlanReportPage6');
                        break;
                }
            }, 100);
        }

        function annualSeasonPlanReportSelect() {
            vm.annualSeasonPlanReportId = 0;
            vm.coachContact = '';
            vm.coachEmail = '';
            vm.data = [];
            grid.dataSource = vm.data;
            // a syncfusion direktívák miatt
            $scope.$broadcast('submitted');
            if ($scope.form.$valid === false) {
                log.errorMsg(gettextCatalog.getString('RequiredFieldsError'));
                return;
            }

            paramHelper.setParams([{'AnnualSeasonPlanReport.coachId': vm.selectedCoach}]);
            paramHelper.setParams([{'AnnualSeasonPlanReport.sectionId': vm.selectedSection}]);
            paramHelper.setParams([{'AnnualSeasonPlanReport.ageGroupId': vm.selectedAgeGroup}]);
            paramHelper.setParams([{'AnnualSeasonPlanReport.year': vm.selectedYear}]);

            dataservice.getTrainerEmailContact(vm.selectedCoach)
                .then(function (data) {
                    if (data.retValue.contact) {
                        vm.coachContact = data.retValue.contact;
                    }
                    if (data.retValue.email) {
                        vm.coachEmail = data.retValue.email;
                    }
                });
            vm.data = [];
            dataservice.annualSeasonPlanReportSelect(vm.selectedSection, vm.selectedAgeGroup, vm.selectedCoach, vm.selectedYear.split('/')[0], vm.egyeni)
                .then(function (args) {
                    showMessages(args);
                });
        }

        function showMessages(args) {
            if (args.Id === 0) {
                vm.noAnnualSeasonPlan = true;
                vm.hasAnnualSeasonPlan = false;
                vm.hasSignedAnnualSeasonPlan = false;
                vm.hasAcceptedAnnualSeasonPlan = false;
            } else {
                vm.noAnnualSeasonPlan = false;
                vm.hasAnnualSeasonPlan = false;
                vm.hasSignedAnnualSeasonPlan = false;
                vm.hasAcceptedAnnualSeasonPlan = false;
                if (args.EdzoLezarta) {
                    vm.hasSignedAnnualSeasonPlan = true;
                } else if (args.SzakosztalyvezetoJovahagyta) {
                    vm.hasAcceptedAnnualSeasonPlan = true;
                } else {
                    vm.hasAnnualSeasonPlan = true;
                }
                viewAnnualSeasonPlanReport(args);
            }
        }

        function viewAnnualSeasonPlanReport(args) {
            vm.annualSeasonPlanReportId = args.Id;
            vm.coachContact = args.EdzoMobil;
            vm.coachEmail = args.EdzoEmail;
            if (vm.annualSeasonPlanReportId) {
                dataservice.annualSeasonPlanReportMembersDataByIdSelect(vm.annualSeasonPlanReportId)
                    .then(function (data) {
                        vm.data = data.itemsList;
                        grid.dataSource = vm.data;
                    });
            }
        }

        function initGrid() {
            vm.columns = [];
            vm.columns = [
                {
                    field: 'Id',
                    visible: false,
                    isPrimaryKey: true,
                    isIdentity: true
                },
                {
                    field: 'Sorszam',
                    headerText: gettextCatalog.getString('RowNumber'),
                    textAlign: 'center',
                    width: 40,
                    allowEditing: false
                },
                {
                    field: 'SportoloNeve',
                    headerText: gettextCatalog.getString('AtlethesName'),
                    textAlign: 'center',
                    width: 100,
                    allowEditing: false,
                    template: '#anseplrepa1templateDataColumn1'
                },
                {
                    field: 'SzuletesiIdo',
                    headerText: gettextCatalog.getString('BirthDate'),
                    textAlign: 'center',
                    width: 75,
                    allowEditing: false
                },
                {
                    field: 'SITagsagKezdete',
                    headerText: gettextCatalog.getString('StartMemberDate'),
                    textAlign: 'center',
                    width: 75,
                    allowEditing: false
                },
                {
                    field: 'IskolaNeveCime',
                    headerText: gettextCatalog.getString('SchoolNameAddress'),
                    textAlign: 'center',
                    width: 150,
                    allowEditing: false
                },
                {
                    field: 'TestneveloTanarNeve',
                    headerText: gettextCatalog.getString('SportingTeacherName'),
                    textAlign: 'center',
                    width: 100,
                    allowEditing: false
                },
                {
                    field: 'Lakcim',
                    headerText: gettextCatalog.getString('Address'),
                    textAlign: 'center',
                    width: 150,
                    allowEditing: false
                }
            ];
        }

        function goToNewAthlete(Id) {
            if (vm.MEGTSPORTLIST) {
                swal({
                    title: gettextCatalog.getString('AreYouSureGo'),
                    text: gettextCatalog.getString('AreYouSureYouWantToGoToAthlete'),
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: gettextCatalog.getString('GoToAthlete')
                }).then(function (isConfirmed) {
                    if (isConfirmed.value) {
                        paramHelper.setParams([
                            {'athleteModify.sportoloId': Id}
                        ]);
                        $state.go('athletes.athletesManagement.athleteModify.dataSheet');
                    }
                });
            } else {
                log.permissionError();
            }
        }

        function refreshData() {
            if (vm.annualSeasonPlanReportId) {
                dataservice.annualSeasonPlanDeleteMembers(vm.annualSeasonPlanReportId)
                    .then(function () {
                        dataservice.coachAthletesByAgeGroupForAnnualSeasonPlan(vm.selectedCoach, vm.selectedSection, vm.selectedAgeGroup, vm.annualSeasonPlanReportId)
                            .then(function (args) {
                                vm.data = [];
                                vm.data = args.itemsList;
                                grid.dataSource = vm.data;
                                log.successMsg(gettextCatalog.getString('RefreshComplete'));
                            });
                    });
            } else {
                dataservice.coachAthletesByAgeGroupForAnnualSeasonPlan(vm.selectedCoach, vm.selectedSection, vm.selectedAgeGroup, vm.annualSeasonPlanReportId)
                    .then(function (args) {
                        vm.data = [];
                        vm.data = args.itemsList;
                        grid.dataSource = vm.data;
                        log.successMsg(gettextCatalog.getString('RefreshComplete'));
                    });
            }
        }

        function goToNextPage() {
            if (!vm.hasSignedAnnualSeasonPlan) {
                dataservice.saveAnnualSeasonPlanMembers(vm.data)
                    .then(function () {
                        log.successMsg('SaveCompleted');
                    });
            }
            $timeout(function () {
                paramHelper.setParams([{'AnnualSeasonPlanReport.Id': vm.annualSeasonPlanReportId}]);
                $state.go('administration.annualSeasonPlan.annualSeasonPlanReportPage2');
            }, 100);
        }

        function annualSeasonPlanReportCreate() {
            vm.fej = {};
            vm.fej.DSIVezetoJovahagyta = false;
            vm.fej.EdzoEmail = vm.coachEmail;
            vm.fej.EdzoLezarta = false;
            vm.fej.EdzoMobil = vm.coachContact;
            vm.fej.EdzoNeve = angular.element('#maEdzo').data('ejDropDownList').getSelectedItem()[0].innerText;
            vm.fej.EgyebCelkituzesek = '';
            vm.fej.Egyeni = vm.egyeni;
            vm.fej.ErvenyessegIg = moment({y: vm.selectedYear.split('/')[1].trim(), M: 6, d: 31}).format('YYYY-MM-DD');
            vm.fej.ErvenyessegTol = moment({y: vm.selectedYear.split('/')[0].trim(), M: 7, d: 1}).format('YYYY-MM-DD');
            vm.fej.IdEdzo = vm.selectedCoach;
            vm.fej.IdKorosztaly = vm.selectedAgeGroup;
            vm.fej.IdSzakosztaly = vm.selectedSection;
            vm.fej.KeszitesDatum = moment().format('YYYY-MM-DD');
            vm.fej.KorosztalyNeve = angular.element('#maKorosztaly').data('ejDropDownList').getSelectedItem()[0].innerText;
            vm.fej.SzakosztalyNeve = angular.element('#maSzakosztaly').data('ejDropDownList').getSelectedItem()[0].innerText;
            dataservice.saveAnnualSeasonPlanHead(vm.fej)
                .then(function (args) {
                    vm.annualSeasonPlanReportId = args.retValue;
                    vm.fej.Id = args.retValue;
                    dataservice.coachAthletesByAgeGroupForAnnualSeasonPlan(vm.selectedCoach, vm.selectedSection, vm.selectedAgeGroup, vm.fej.Id)
                        .then(function (args) {
                            vm.data = [];
                            vm.data = args.itemsList;
                            grid.dataSource = vm.data;
                            log.successMsg(gettextCatalog.getString('AnnualSeasonPlanCreated'));
                        });
                    showMessages(vm.fej);
                });
        }

        function goToOlderAnnualSeasonPlanReports() {
            paramHelper.setParams([{
                'AnnualSeasonPlanReport.Id': vm.annualSeasonPlanReportId
            }]);
            $state.go('administration.annualSeasonPlan.annualSeasonPlanList');
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular .module('app.administration.annualSeasonPlan.annualSeasonPlanReportPage1')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'administration.annualSeasonPlan.annualSeasonPlanReportPage1',
                config: {
                    url: '/annualSeasonPlanReportPage1',
                    templateUrl: 'app/administration/annualSeasonPlan/annualSeasonPlanReportPage1/annualSeasonPlanReportPage1.html',
                    controller: 'AnnualSeasonPlanReportPage1Controller',
                    controllerAs: 'vm',
                    title: 'AnnualSeasonPlan',
                    settings: {
                        navId: 252,
                        level: 2,
                        order: 5,
                        orderTitle_hu: 'Éves felkészítési és versenyeztetési terv',
                        orderTitle_en: 'Annual Preparation and Competition Plan',
                        parentId: 2,
                        content: 'AnnualSeasonPlan',
                        activatorPermission: '"MEGTEVVERST"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    AnnualSeasonPlanReportPage2Controller.$inject = ["$rootScope", "gettextCatalog", "dataservice", "log", "$q", "authenticationService", "paramHelper", "$scope", "$state", "$timeout"];
    angular
        .module('app.administration.annualSeasonPlan.annualSeasonPlanReportPage2')
        .controller('AnnualSeasonPlanReportPage2Controller', AnnualSeasonPlanReportPage2Controller);

    function AnnualSeasonPlanReportPage2Controller($rootScope, gettextCatalog, dataservice, log, $q, authenticationService, paramHelper, $scope, $state, $timeout) {
        var vm = this; $rootScope.vm = vm; // jshint ignore: line

        // Page title
        $rootScope.title = gettextCatalog.getString('AnnualSeasonPlanReport');
        vm.columns = [];
        vm.egyeni = false;
        vm.editable = true;
        vm.disable = false;
        vm.annualSeasonPlanReportId = 0;

        vm.head = {};
        vm.data = [];
        // jump page
        vm.JumpPageList = [
            '1 - ' + gettextCatalog.getString('TheMostImportantDataOfAGroupsMembers'),
            '2 - ' + gettextCatalog.getString('PreparationAndCompetitionPast'),
            '3 - ' + gettextCatalog.getString('OutstandingResults'),
            '4 - ' + gettextCatalog.getString('CapitalObjectives'),
            '5 - ' + gettextCatalog.getString('CompetitionPlansAndObjectives'),
            '6 - ' + gettextCatalog.getString('YearlyTablePlan')
        ];
        // functions
        vm.goToNewAthlete = goToNewAthlete;
        vm.refreshData = refreshData;
        vm.goToNextPage = goToNextPage;
        vm.goToPreviousPage = goToPreviousPage;
        vm.jumpPageDataBound = jumpPageDataBound;
        vm.jumpPageSelect = jumpPageSelect;

        initGrid();

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItemsWithSearch,
            editSettings: {allowEditing: true, mode: 'Batch', showConfirmDialog: false},
            allowTextWrap: true,
            allowSorting: true,
            allowExcelExport: true,
            allowDeleting: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile(angular.element('#Grid'), $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        activate();

        function activate() {
            vm.jumpedPage = '2 - ' + gettextCatalog.getString('PreparationAndCompetitionPast');
            vm.defaultJumpPage = '2 - ' + gettextCatalog.getString('PreparationAndCompetitionPast');
            $q.all([paramHelper.getParams([], ['AnnualSeasonPlanReport.Id']),
                authenticationService.getRight('EDZO'),
                authenticationService.getRight('ADMIN'),
                authenticationService.getRight('SZAKOSZTVEZ'),
                authenticationService.getRight('TECHIGAZGATO'),
                authenticationService.getRight('EVVERSTALAIR1'),
                authenticationService.getRight('EVVERSTALAIR2'),
                authenticationService.getRight('UJEVVERST'),
                authenticationService.getRight('MEGTSPORTLIST'),
                authenticationService.getRight('MEGTEVVERST')])
                .then(function (results) {
                    vm.EDZO = results[1];
                    vm.ADMIN = results[2];
                    vm.SZAKOSZTVEZ = results[3];
                    vm.TECHIGAZGATO = results[4];
                    vm.EVVERSTALAIR1 = results[5];
                    vm.EVVERSTALAIR2 = results[6];
                    vm.UJEVVERST = results[7];
                    vm.MEGTSPORTLIST = results[8];
                    vm.MEGTEVVERST = results[9];
                    if (!vm.MEGTEVVERST) {
                        log.permissionError(true);
                        return;
                    }
                    if (results[0]['AnnualSeasonPlanReport.Id'] && results[0]['AnnualSeasonPlanReport.Id'] !== -1) {
                        vm.annualSeasonPlanReportId = results[0]['AnnualSeasonPlanReport.Id'];
                        paramHelper.removeParam('AnnualSeasonPlanReport.Id');
                        dataservice.annualSeasonPlanReportSelectById(vm.annualSeasonPlanReportId)
                            .then(function (data) {
                                vm.head = data;
                                if (data.EdzoLezarta) {
                                    vm.editable = false;
                                    vm.disable = true;
                                } else {
                                    vm.editable = true;
                                    vm.disable = false;
                                }
                                viewAnnualSeasonPlanReport(data);
                            });
                    } else {
                        $rootScope.back();
                    }
                });
        }

        function jumpPageDataBound() {
            angular.element('#maKorabbi').ejDropDownList('selectItemByValue', vm.defaultJumpPage);
            vm.selectedJumpPage = vm.defaultJumpPage;
        }

        function jumpPageSelect(args) {
            vm.selectedJumpPage = args.value;
            var sorszam = vm.selectedJumpPage.split('-')[0];
            if (sorszam === '2 ') {
                return;
            }

            if (vm.editable) {
                grid.editModule.endEdit();
                dataservice.saveAnnualSeasonPlanMembersPast(vm.data)
                    .then(function () {
                        log.successMsg('SaveCompleted');
                    });
            }

            $timeout(function () {
                paramHelper.setParams([{'AnnualSeasonPlanReport.Id': vm.annualSeasonPlanReportId}]);
                switch (sorszam) {
                    case '1 ':
                        $state.go('administration.annualSeasonPlan.annualSeasonPlanReportPage1');
                        break;
                    case '2 ':
                        $state.go('administration.annualSeasonPlan.annualSeasonPlanReportPage2');
                        break;
                    case '3 ':
                        $state.go('administration.annualSeasonPlan.annualSeasonPlanReportPage3');
                        break;
                    case '4 ':
                        $state.go('administration.annualSeasonPlan.annualSeasonPlanReportPage4');
                        break;
                    case '5 ':
                        $state.go('administration.annualSeasonPlan.annualSeasonPlanReportPage5');
                        break;
                    case '6 ':
                        $state.go('administration.annualSeasonPlan.annualSeasonPlanReportPage6');
                        break;
                }
            }, 100);
        }

        function viewAnnualSeasonPlanReport() {
            dataservice.annualSeasonPlanReportMembersPastSelect(vm.annualSeasonPlanReportId)
                .then(function (data) {
                    vm.data = data.itemsList;
                    grid.dataSource = vm.data;
                    if (vm.editable && data.itemsList.length === 0) {
                        refreshData();
                    }
                });
        }

        function initGrid() {
            vm.columns = [];
            vm.columns = [
                {
                    field: 'Id',
                    visible: false,
                    isPrimaryKey: true,
                    isIdentity: true
                },
                {
                    field: 'Sorszam',
                    headerText: gettextCatalog.getString('RowNumber'),
                    textAlign: 'center',
                    width: 40,
                    allowEditing: false
                },
                {
                    field: 'SportoloNeve',
                    headerText: gettextCatalog.getString('AtlethesName'),
                    textAlign: 'center',
                    width: 100,
                    allowEditing: false,
                    template: '#anseplrepa2templateDataColumn1'
                },
                {
                    field: 'VersSportKezd',
                    headerText: gettextCatalog.getString('BeginningOfCompetitiveSports'),
                    textAlign: 'center',
                    width: 75,
                    allowEditing: false
                },
                {
                    field: 'EddigiEdzoi',
                    headerText: gettextCatalog.getString('HisCoachesUntilNow'),
                    textAlign: 'center',
                    width: 150,
                    allowEditing: false
                },
                {
                    field: 'EddigiSportEgyesuletei',
                    headerText: gettextCatalog.getString('HisTeamsUntilNow'),
                    textAlign: 'center',
                    width: 150,
                    allowEditing: false
                }
            ];
        }

        function goToNewAthlete(Id) {
            if (vm.MEGTSPORTLIST) {
                swal({
                    title: gettextCatalog.getString('AreYouSureGo'),
                    text: gettextCatalog.getString('AreYouSureYouWantToGoToAthlete'),
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: gettextCatalog.getString('GoToAthlete')
                }).then(function (isConfirmed) {
                    if (isConfirmed.value) {
                        paramHelper.setParams([
                            {'athleteModify.sportoloId': Id}
                        ]);
                        $state.go('athletes.athletesManagement.athleteModify.dataSheet');
                    }
                });
            } else {
                log.permissionError();
            }
        }

        function refreshData() {
            dataservice.annualSeasonPlanReportMembersPastDelete(vm.annualSeasonPlanReportId)
                .then(function () {
                    dataservice.annualSeasonPlanReportMembersPastRefresh(vm.annualSeasonPlanReportId,
                        vm.head.IdSzakosztaly, vm.head.IdKorosztaly, vm.head.IdEdzo)
                        .then(function (args) {
                            vm.data = [];
                            vm.data = args.itemsList;
                            grid.dataSource = vm.data;
                            log.successMsg(gettextCatalog.getString('RefreshComplete'));
                        });
                });
        }

        function goToNextPage() {
            if (vm.editable) {
                dataservice.saveAnnualSeasonPlanMembersPast(vm.data)
                    .then(function () {
                        log.successMsg('SaveCompleted');
                    });
            }
            $timeout(function () {
                paramHelper.setParams([{
                    'AnnualSeasonPlanReport.Id': vm.annualSeasonPlanReportId
                }]);
                $state.go('administration.annualSeasonPlan.annualSeasonPlanReportPage3');
            }, 100);
        }

        function goToPreviousPage() {
            if (vm.editable) {
                dataservice.saveAnnualSeasonPlanMembersPast(vm.data)
                    .then(function () {
                        log.successMsg('SaveCompleted');
                    });
            }
            $timeout(function () {
                paramHelper.setParams([{
                    'AnnualSeasonPlanReport.Id': vm.annualSeasonPlanReportId
                }]);
                $state.go('administration.annualSeasonPlan.annualSeasonPlanReportPage1');
            }, 100);
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular .module('app.administration.annualSeasonPlan.annualSeasonPlanReportPage2')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'administration.annualSeasonPlan.annualSeasonPlanReportPage2',
                config: {
                    url: '/annualSeasonPlanReportPage2',
                    templateUrl: 'app/administration/annualSeasonPlan/annualSeasonPlanReportPage2/annualSeasonPlanReportPage2.html',
                    controller: 'AnnualSeasonPlanReportPage2Controller',
                    controllerAs: 'vm',
                    title: 'AnnualSeasonPlan'
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    AnnualSeasonPlanReportPage3Controller.$inject = ["$rootScope", "gettextCatalog", "dataservice", "log", "$q", "authenticationService", "paramHelper", "$scope", "$state", "$timeout"];
    angular
        .module('app.administration.annualSeasonPlan.annualSeasonPlanReportPage3')
        .controller('AnnualSeasonPlanReportPage3Controller', AnnualSeasonPlanReportPage3Controller);

    function AnnualSeasonPlanReportPage3Controller($rootScope, gettextCatalog, dataservice, log, $q, authenticationService, paramHelper, $scope, $state, $timeout) {
        var vm = this; $rootScope.vm = vm; // jshint ignore: line

        // Page title
        $rootScope.title = gettextCatalog.getString('AnnualSeasonPlanReport');
        vm.columns = [];
        vm.columnsPopup = [];
        vm.egyeni = false;
        vm.editable = true;
        vm.disable = false;
        vm.annualSeasonPlanReportId = 0;
        vm.selectedRowIndexPopup = -1;
        vm.selectedRowRecords;

        vm.head = {};
        vm.data = [];
        vm.dataPopup = [];

        // jump page
        vm.JumpPageList = [
            '1 - ' + gettextCatalog.getString('TheMostImportantDataOfAGroupsMembers'),
            '2 - ' + gettextCatalog.getString('PreparationAndCompetitionPast'),
            '3 - ' + gettextCatalog.getString('OutstandingResults'),
            '4 - ' + gettextCatalog.getString('CapitalObjectives'),
            '5 - ' + gettextCatalog.getString('CompetitionPlansAndObjectives'),
            '6 - ' + gettextCatalog.getString('YearlyTablePlan')
        ];

        // functions
        vm.goToNextPage = goToNextPage;
        vm.goToPreviousPage = goToPreviousPage;
        vm.newAthletesNewRow = newAthletesNewRow;
        vm.oldAthletesNewRow = oldAthletesNewRow;
        vm.search = search;
        vm.search2 = search2;
        vm.closeOutstandingResultsWindow = closeOutstandingResultsWindow;
        vm.selectOutstandingResults = selectOutstandingResults;
        vm.jumpPageDataBound = jumpPageDataBound;
        vm.jumpPageSelect = jumpPageSelect;

        initGrid();

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItemsWithDelete,
            editSettings: {allowEditing: true, mode: 'Batch', showConfirmDialog: false, allowDeleting: true, showDeleteConfirmDialog: false},
            allowTextWrap: true,
            allowSorting: true,
            allowExcelExport: true,
            allowDeleting: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            rowSelected: function() {
                grid.editSettings.allowDeleting = true;
                vm.selectedRowRecords = grid.getSelectedRecords();
                document.getElementById('oldNew').removeAttribute('disabled');
            },
            rowDeselected: function() {
                grid.editSettings.allowDeleting = false;
                document.getElementById('oldNew').setAttribute('disabled', 'disabled');
            },
            actionBegin: function() {
                grid.editSettings.allowDeleting = false;
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile(angular.element('#Grid'), $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        var gridSearch = new ej2.grids.Grid({
            dataSource: [],
            editSettings: {allowEditing: false},
            allowTextWrap: true,
            allowSorting: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columnsPopup,
            selectedRowIndex: vm.selectedRowIndexPopup,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile(angular.element('#GridPopup'), $scope);
                }
            }
        });
        gridSearch.appendTo('#GridPopup');
        gridSearch.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, gridSearch);
        };

        activate();

        function activate() {
            vm.jumpedPage = '3 - ' + gettextCatalog.getString('OutstandingResults');
            vm.defaultJumpPage = '3 - ' + gettextCatalog.getString('OutstandingResults');
            $q.all([paramHelper.getParams([], ['AnnualSeasonPlanReport.Id']),
                authenticationService.getRight('EDZO'),
                authenticationService.getRight('ADMIN'),
                authenticationService.getRight('SZAKOSZTVEZ'),
                authenticationService.getRight('TECHIGAZGATO'),
                authenticationService.getRight('EVVERSTALAIR1'),
                authenticationService.getRight('EVVERSTALAIR2'),
                authenticationService.getRight('UJEVVERST'),
                authenticationService.getRight('MEGTSPORTLIST'),
                authenticationService.getRight('MEGTSPORTLIST'),
                authenticationService.getRight('MEGTEVVERST')])
                .then(function (results) {
                    vm.EDZO = results[1];
                    vm.ADMIN = results[2];
                    vm.SZAKOSZTVEZ = results[3];
                    vm.TECHIGAZGATO = results[4];
                    vm.EVVERSTALAIR1 = results[5];
                    vm.EVVERSTALAIR2 = results[6];
                    vm.UJEVVERST = results[7];
                    vm.MEGTSPORTLIST = results[8];
                    vm.MEGTSPORTLIST = results[9];
                    vm.MEGTEVVERST = results[10];
                    if (!vm.MEGTEVVERST) {
                        log.permissionError(true);
                        return;
                    }
                    if (results[0]['AnnualSeasonPlanReport.Id'] && results[0]['AnnualSeasonPlanReport.Id'] !== -1) {
                        vm.annualSeasonPlanReportId = results[0]['AnnualSeasonPlanReport.Id'];
                        paramHelper.removeParam('AnnualSeasonPlanReport.Id');
                        dataservice.annualSeasonPlanReportSelectById(vm.annualSeasonPlanReportId)
                            .then(function (data) {
                                vm.head = data;
                                vm.egyeni = data.Egyeni;
                                if (data.EdzoLezarta) {
                                    vm.editable = false;
                                    vm.disable = true;
                                } else {
                                    vm.editable = true;
                                    vm.disable = false;
                                }

                                initGrid();
                                dataservice.annualSeasonPlanReportBestResultsList(vm.annualSeasonPlanReportId)
                                    .then(function (data) {
                                        vm.data = data.itemsList;
                                        grid.dataSource = vm.data;
                                        grid.editSettings.allowEditing = vm.editable;
                                        grid.editSettings.allowDeleting = vm.editable;
                                    });
                            });
                    } else {
                        $rootScope.back();
                    }
                });
        }

        function jumpPageDataBound() {
            angular.element('#maKorabbi').ejDropDownList('selectItemByValue', vm.defaultJumpPage);
            vm.selectedJumpPage = vm.defaultJumpPage;
        }

        function SaveResults() {
            if (vm.editable) {
                grid.editModule.endEdit();
            }

            if (vm.data.length === 0) {
                vm.data.push({IdVersenyeztetesiTervFej: vm.annualSeasonPlanReportId});
            }
            dataservice.saveAnnualSeasonPlanBestResults(vm.data).then(function () {
                log.successMsg('SaveCompleted');
            });
        }

        function jumpPageSelect(args) {
            vm.selectedJumpPage = args.value;
            var sorszam = vm.selectedJumpPage.split('-')[0];
            if (sorszam === '3 ') {
                return;
            }
            if (vm.editable) {
                grid.editModule.endEdit();
                SaveResults();
            }
            $timeout(function () {
                paramHelper.setParams([{'AnnualSeasonPlanReport.Id': vm.annualSeasonPlanReportId}]);
                switch (sorszam) {
                    case '1 ':
                        $state.go('administration.annualSeasonPlan.annualSeasonPlanReportPage1');
                        break;
                    case '2 ':
                        $state.go('administration.annualSeasonPlan.annualSeasonPlanReportPage2');
                        break;
                    case '3 ':
                        $state.go('administration.annualSeasonPlan.annualSeasonPlanReportPage3');
                        break;
                    case '4 ':
                        $state.go('administration.annualSeasonPlan.annualSeasonPlanReportPage4');
                        break;
                    case '5 ':
                        $state.go('administration.annualSeasonPlan.annualSeasonPlanReportPage5');
                        break;
                    case '6 ':
                        $state.go('administration.annualSeasonPlan.annualSeasonPlanReportPage6');
                        break;
                }
            }, 100);
        }

        function initGrid() {
            vm.columns = [];
            vm.columns = [
                {
                    field: 'Id',
                    visible: false,
                    isPrimaryKey: true,
                    isIdentity: true
                },
                {
                    field: 'Sorszam',
                    headerText: gettextCatalog.getString('RowNumber'),
                    textAlign: 'center',
                    width: 40,
                    allowEditing: false
                },
                {
                    field: 'VersenyzoNeve',
                    headerText: gettextCatalog.getString('VersenyzoNeve'),
                    textAlign: 'center',
                    width: 100,
                    allowEditing: vm.editable,
                    visible: vm.egyeni
                },
                {
                    field: 'EsemenyNeve',
                    headerText: gettextCatalog.getString('EsemenyNeve'),
                    textAlign: 'center',
                    width: 100,
                    allowEditing: vm.editable
                },
                {
                    field: 'EsemenyIdopontja',
                    headerText: gettextCatalog.getString('EsemenyIdopontja'),
                    textAlign: 'center',
                    width: 75,
                    allowEditing: vm.editable
                },
                {
                    field: 'EsemenyHelye',
                    headerText: gettextCatalog.getString('EsemenyHelye'),
                    textAlign: 'center',
                    width: 150,
                    allowEditing: vm.editable
                },
                {
                    field: 'ElertHelyezes',
                    headerText: gettextCatalog.getString('ElertHelyezes'),
                    textAlign: 'center',
                    width: 150,
                    allowEditing: vm.editable
                },
                {
                    field: 'KiemelkSportolo',
                    headerText: gettextCatalog.getString('KiemelkSportolo'),
                    textAlign: 'center',
                    width: 150,
                    allowEditing: vm.editable,
                    visible: !vm.egyeni
                }
            ];

            vm.columnsPopup = [];
            vm.columnsPopup = [
                {
                    field: 'Id',
                    visible: false,
                    isPrimaryKey: true,
                    isIdentity: true
                },
                {
                    field: 'Helyezes',
                    headerText: gettextCatalog.getString('Helyezes'),
                    textAlign: 'center',
                    width: 100,
                    allowEditing: false
                },
                {
                    field: 'Helyszin',
                    headerText: gettextCatalog.getString('Helyszin'),
                    textAlign: 'center',
                    width: 100,
                    allowEditing: false
                },
                {
                    field: 'DatumTol',
                    headerText: gettextCatalog.getString('DatumTol'),
                    textAlign: 'center',
                    width: 100,
                    allowEditing: false
                },
                {
                    field: 'DatumIg',
                    headerText: gettextCatalog.getString('DatumIg'),
                    textAlign: 'center',
                    width: 100,
                    allowEditing: false
                },
                {
                    field: 'CsapatSportolo',
                    headerText: gettextCatalog.getString('CsapatSportolo'),
                    textAlign: 'center',
                    width: 150,
                    allowEditing: false
                }
            ];
        }

        function goToNextPage() {
            if (vm.editable) {
                grid.editModule.endEdit();
                SaveResults();
            }
            $timeout(function () {
                paramHelper.setParams([{
                    'AnnualSeasonPlanReport.Id': vm.annualSeasonPlanReportId
                }]);
                $state.go('administration.annualSeasonPlan.annualSeasonPlanReportPage4');
            }, 100);
        }

        function goToPreviousPage() {
            if (vm.editable) {
                grid.editModule.endEdit();
                SaveResults();
            }
            $timeout(function () {
                paramHelper.setParams([{
                    'AnnualSeasonPlanReport.Id': vm.annualSeasonPlanReportId
                }]);
                $state.go('administration.annualSeasonPlan.annualSeasonPlanReportPage2');
            }, 100);
        }

        function newAthletesNewRow() {
            grid.editModule.endEdit();
            var sorszam = 0;
            for (var i = 0; i < vm.data.length; i++) {
                if (vm.data[i].Sorszam > sorszam) {
                    sorszam = vm.data[i].Sorszam;
                }
            }
            vm.data.push({
                Id: (vm.data.length + 1) * -1,
                Sorszam: sorszam + 1,
                IdVersenyeztetesiTervFej: vm.annualSeasonPlanReportId,
                ElertHelyezes: '',
                EsemenyHelye: '',
                EsemenyIdopontja: '',
                EsemenyNeve: '',
                KiemelkSportolo: '',
                VersenyzoNeve: ''
            });
            grid.dataSource = vm.data;
        }

        function oldAthletesNewRow() {
            grid.editModule.endEdit();
            vm.data.push({
                Id: (vm.data.length + 1) * -1,
                Sorszam: vm.selectedRowRecords[0].Sorszam,
                IdVersenyeztetesiTervFej: vm.annualSeasonPlanReportId,
                ElertHelyezes: '',
                EsemenyHelye: '',
                EsemenyIdopontja: '',
                EsemenyNeve: '',
                KiemelkSportolo: '',
                VersenyzoNeve: ''
            });
            grid.dataSource = vm.data;
        }

        function search() {
            vm.same = false;
            vm.selectedRowIndexPopup = -1;
            var dialogObj = angular.element('#searchWindow').data('ejDialog');
            dialogObj.open();

            dataservice.annualSeasonPlanReportBestResultsSelect(vm.annualSeasonPlanReportId)
                .then(function (args) {
                    vm.dataPopup = [];
                    vm.dataPopup = args.itemsList;
                    gridSearch.dataSource = vm.dataPopup;
                });
        }

        function search2() {
            vm.same = true;
            vm.selectedRowIndexPopup = -1;
            var dialogObj = angular.element('#searchWindow').data('ejDialog');
            dialogObj.open();

            dataservice.annualSeasonPlanReportBestResultsSelect(vm.annualSeasonPlanReportId)
                .then(function (args) {
                    vm.dataPopup = [];
                    vm.dataPopup = args.itemsList;
                    gridSearch.dataSource = vm.dataPopup;
                });
        }

        function closeOutstandingResultsWindow() {
            var dialogObj = angular.element('#searchWindow').data('ejDialog');
            dialogObj.close();
        }

        function selectOutstandingResults(same) {
            if (vm.selectedRowIndexPopup > -1) {
                var vmi = vm.dataPopup[vm.selectedRowIndexPopup];
                if (vmi) {
                    var sorszam = 0;
                    for (var i = 0; i < vm.data.length; i++) {
                        if (vm.data[i].Sorszam > sorszam) {
                            sorszam = vm.data[i].Sorszam;
                        }
                    }
                    if (!same) {
                        sorszam++;
                    }
                    vm.data.push(
                        {
                            Id: -1 * vmi.Id,
                            Sorszam: sorszam,
                            IdVersenyeztetesiTervFej: vm.annualSeasonPlanReportId,
                            ElertHelyezes: vmi.Helyezes,
                            EsemenyHelye: vmi.Helyszin,
                            EsemenyIdopontja: (vmi.DatumTol ? vmi.DatumTol : '') + (vm.Datumig ? '-' + vm.DatumIg : ''),
                            EsemenyNeve: vmi.EsemenyNeve,
                            VersenyzoNeve: vmi.CsapatSportolo
                        });
                    grid.dataSource = vm.data;
                }
            }
            var dialogObj = angular.element('#searchWindow').data('ejDialog');
            dialogObj.close();
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular .module('app.administration.annualSeasonPlan.annualSeasonPlanReportPage3')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'administration.annualSeasonPlan.annualSeasonPlanReportPage3',
                config: {
                    url: '/annualSeasonPlanReportPage3',
                    templateUrl: 'app/administration/annualSeasonPlan/annualSeasonPlanReportPage3/annualSeasonPlanReportPage3.html',
                    controller: 'AnnualSeasonPlanReportPage3Controller',
                    controllerAs: 'vm',
                    title: 'AnnualSeasonPlan'
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    AnnualSeasonPlanReportPage4Controller.$inject = ["$rootScope", "gettextCatalog", "dataservice", "log", "$q", "authenticationService", "paramHelper", "$state", "$window", "DOMAIN", "$timeout", "$scope"];
    angular
        .module('app.administration.annualSeasonPlan.annualSeasonPlanReportPage4')
        .controller('AnnualSeasonPlanReportPage4Controller', AnnualSeasonPlanReportPage4Controller);

    function AnnualSeasonPlanReportPage4Controller($rootScope, gettextCatalog, dataservice, log, $q, authenticationService, paramHelper, $state, $window, DOMAIN, $timeout, $scope) {
        var vm = this;
        $rootScope.vm = vm; // jshint ignore: line

        // Page title
        $rootScope.title = gettextCatalog.getString('AnnualSeasonPlanReport');
        vm.egyeni = false;
        vm.editable = true;
        vm.disable = false;
        vm.columnsPopup = [];
        vm.annualSeasonPlanReportId = 0;
        vm.head = {};
        vm.data = {};
        vm.dataPopup = [];
        vm.selectedRowIndexPopup = 0;

        vm.file = {};
        // jump page
        vm.JumpPageList = [
            '1 - ' + gettextCatalog.getString('TheMostImportantDataOfAGroupsMembers'),
            '2 - ' + gettextCatalog.getString('PreparationAndCompetitionPast'),
            '3 - ' + gettextCatalog.getString('OutstandingResults'),
            '4 - ' + gettextCatalog.getString('CapitalObjectives'),
            '5 - ' + gettextCatalog.getString('CompetitionPlansAndObjectives'),
            '6 - ' + gettextCatalog.getString('YearlyTablePlan')
        ];
        // functions
        vm.goToNextPage = goToNextPage;
        vm.goToPreviousPage = goToPreviousPage;
        vm.closeOutstandingResultsWindow = closeOutstandingResultsWindow;
        vm.selectOutstandingResults = selectOutstandingResults;
        vm.numberChange = numberChange;
        vm.openTechnicalTrainingObjectives = openTechnicalTrainingObjectives;
        vm.removeTechnicalTrainingObjectives = removeTechnicalTrainingObjectives;
        vm.openTacticalTrainingObjectives = openTacticalTrainingObjectives;
        vm.removeTacticalTrainingObjectives = removeTacticalTrainingObjectives;
        vm.openAbilitydevelopmentObjectives = openAbilitydevelopmentObjectives;
        vm.removeAbilitydevelopmentObjectives = removeAbilitydevelopmentObjectives;
        vm.openEducationalObjectives = openEducationalObjectives;
        vm.removeEducationalObjectives = removeEducationalObjectives;
        vm.openEfficiencyObjectives = openEfficiencyObjectives;
        vm.removeEfficiencyObjectives = removeEfficiencyObjectives;
        vm.openSportSpecificTrainingObjectives = openSportSpecificTrainingObjectives;
        vm.removeSportSpecificTrainingObjectives = removeSportSpecificTrainingObjectives;
        vm.closeEarlierAnnualSeasonPlanWindow = closeEarlierAnnualSeasonPlanWindow;
        vm.selectEarlierAnnualSeasonPlan = selectEarlierAnnualSeasonPlan;

        vm.search = search;
        vm.closeEarlierAnnualSeasonPlanWindow = closeEarlierAnnualSeasonPlanWindow;
        vm.selectEarlierAnnualSeasonPlan = selectEarlierAnnualSeasonPlan;
        vm.jumpPageDataBound = jumpPageDataBound;
        vm.jumpPageSelect = jumpPageSelect;

        vm.columnsPopup = [
            {
                field: 'Id',
                visible: false,
                isPrimaryKey: true,
                isIdentity: true
            },
            {
                field: 'Szakosztaly',
                headerText: gettextCatalog.getString('Section'),
                textAlign: 'center',
                width: 100,
            },
            {
                field: 'Korosztaly',
                headerText: gettextCatalog.getString('AgeGroup'),
                textAlign: 'center',
                width: 100,
            },
            {
                field: 'DatumTol',
                headerText: gettextCatalog.getString('DatumTol'),
                textAlign: 'center',
                width: 100,
            },
            {
                field: 'DatumIg',
                headerText: gettextCatalog.getString('DatumIg'),
                textAlign: 'center',
                width: 100,
            }
        ];

        var grid = new ej2.grids.Grid({
            dataSource: [],
            allowTextWrap: true,
            allowSorting: true,
            allowScrolling: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            columns: vm.columnsPopup,
            selectedRowIndex: vm.selectedRowIndexPopup,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile(angular.element('#GridPopup'), $scope);
                }
            }
        });
        grid.appendTo('#GridPopup');

        activate();

        function activate() {
            vm.jumpedPage = '4 - ' + gettextCatalog.getString('CapitalObjectives');
            vm.defaultJumpPage = '4 - ' + gettextCatalog.getString('CapitalObjectives');
            $q.all([paramHelper.getParams([], ['AnnualSeasonPlanReport.Id']), authenticationService.getRight('EDZO'), authenticationService.getRight('ADMIN'), authenticationService.getRight('SZAKOSZTVEZ'), authenticationService.getRight('TECHIGAZGATO'), authenticationService.getRight('EVVERSTALAIR1'), authenticationService.getRight('EVVERSTALAIR2'), authenticationService.getRight('UJEVVERST'), authenticationService.getRight('MEGTSPORTLIST'), authenticationService.getRight('MEGTSPORTLIST'), authenticationService.getRight('MEGTEVVERST')])
                .then(function (results) {
                    vm.EDZO = results[1];
                    vm.ADMIN = results[2];
                    vm.SZAKOSZTVEZ = results[3];
                    vm.TECHIGAZGATO = results[4];
                    vm.EVVERSTALAIR1 = results[5];
                    vm.EVVERSTALAIR2 = results[6];
                    vm.UJEVVERST = results[7];
                    vm.MEGTSPORTLIST = results[8];
                    vm.MEGTSPORTLIST = results[9];
                    vm.MEGTEVVERST = results[10];
                    if (results[0]['AnnualSeasonPlanReport.Id'] && results[0]['AnnualSeasonPlanReport.Id'] !== -1) {
                        vm.annualSeasonPlanReportId = results[0]['AnnualSeasonPlanReport.Id'];
                        paramHelper.removeParam('AnnualSeasonPlanReport.Id');
                        dataservice.annualSeasonPlanReportSelectById(vm.annualSeasonPlanReportId)
                            .then(function (data) {
                                vm.head = data;
                                vm.egyeni = data.Egyeni;
                                if (data.EdzoLezarta) {
                                    vm.editable = false;
                                    vm.disable = true;
                                } else {
                                    vm.editable = true;
                                    vm.disable = false;
                                }
                                initUploadBox();
                                dataservice.annualSeasonPlanReportObjectivesSelect(vm.annualSeasonPlanReportId)
                                    .then(function (data) {
                                        vm.data = data;
                                        if (vm.data.IdVersenyeztetesiTervFej == null) {
                                            vm.data.IdVersenyeztetesiTervFej = vm.annualSeasonPlanReportId;
                                        }
                                    });
                            });
                    } else {
                        $rootScope.back();
                    }
                });
        }

        function initUploadBox() {
            angular.element('#uploadbox1').ejUploadbox({
                saveUrl: DOMAIN.baseURL + DOMAIN.webService + 'FileUploadEvesVersTerv',
                autoUpload: true,
                uploadName: 'Uploadbox',
                allowDragAndDrop: false,
                buttonText: {
                    browse: gettextCatalog.getString('UploadFile'),
                    upload: gettextCatalog.getString('UploadFile'),
                    cancel: gettextCatalog.getString('CancelUpload')
                },
                dialogAction: {modal: true, closeOnComplete: true, resize: false, drag: false},
                dialogText: {
                    title: gettextCatalog.getString('UploadedFilesTitle'),
                    name: gettextCatalog.getString('FileName'),
                    size: gettextCatalog.getString('FileSize'),
                    status: gettextCatalog.getString('FileStatus')
                },
                dropAreaText: gettextCatalog.getString('DropFileToUpload'),
                extensionsAllow: '.doc,.docx,.pdf',
                enabled: vm.editable,
                complete: function (args) {
                    if (args.responseText && args.responseText.length > 0) {
                        if (args.responseText.indexOf('>') !== -1) {
                            args.responseText = args.responseText.slice(args.responseText.indexOf('>') + 1, args.responseText.indexOf('</'));
                        }
                        log.successMsg(gettextCatalog.getString('UploadSuccessed'));
                        vm.data.TechKepzesFeladatokFile = args.responseText;
                        dataservice.saveAnnualSeasonPlanCapitalObjectives(vm.data)
                            .then(function (args) {
                                vm.Id = args.res;
                                log.successMsg(gettextCatalog.getString('SaveSuccessed'));
                            });
                    } else {
                        log.htmlError(gettextCatalog.getString('UploadError') + '<br>' + args.error);
                    }
                },
                error: function (args) {
                    var err = '';
                    if (args.error === 'Only files with .doc,.docx,.pdf extensions are allowed.') {
                        err = gettextCatalog.getString('OnlyDocPdf');
                    } else if (args.error === '500 Internal Server Error') {
                        err = gettextCatalog.getString('ToLongFile');
                    }
                    log.htmlError(gettextCatalog.getString('UploadError') + '<br>' + err);
                },
                begin: function (args) {
                    args.data = {tipus: 'EvesVersTerv|techKepzes', tablaId: vm.annualSeasonPlanReportId};
                }
            });
            angular.element('#uploadbox2').ejUploadbox({
                saveUrl: DOMAIN.baseURL + DOMAIN.webService + 'FileUploadEvesVersTerv',
                autoUpload: true,
                uploadName: 'Uploadbox',
                allowDragAndDrop: false,
                buttonText: {
                    browse: gettextCatalog.getString('UploadFile'),
                    upload: gettextCatalog.getString('UploadFile'),
                    cancel: gettextCatalog.getString('CancelUpload')
                },
                dialogAction: {modal: true, closeOnComplete: true, resize: false, drag: false},
                dialogText: {
                    title: gettextCatalog.getString('UploadedFilesTitle'),
                    name: gettextCatalog.getString('FileName'),
                    size: gettextCatalog.getString('FileSize'),
                    status: gettextCatalog.getString('FileStatus')
                },
                dropAreaText: gettextCatalog.getString('DropFileToUpload'),
                extensionsAllow: '.doc,.docx,.pdf',
                enabled: vm.editable,
                complete: function (args) {
                    if (args.responseText && args.responseText.length > 0) {
                        if (args.responseText.indexOf('>') !== -1) {
                            args.responseText = args.responseText.slice(args.responseText.indexOf('>') + 1, args.responseText.indexOf('</'));
                        }
                        log.successMsg(gettextCatalog.getString('UploadSuccessed'));
                        vm.data.TaktikaiKepzesFeladatokFile = args.responseText;
                        dataservice.saveAnnualSeasonPlanCapitalObjectives(vm.data)
                            .then(function (args) {
                                vm.Id = args.res;
                                log.successMsg(gettextCatalog.getString('SaveSuccessed'));
                            });
                    } else {
                        log.htmlError(gettextCatalog.getString('UploadError') + '<br>' + args.error);
                    }
                },
                error: function (args) {
                    var err = '';
                    if (args.error === 'Only files with .doc,.docx,.pdf extensions are allowed.') {
                        err = gettextCatalog.getString('OnlyDocPdf');
                    } else if (args.error === '500 Internal Server Error') {
                        err = gettextCatalog.getString('ToLongFile');
                    }
                    log.htmlError(gettextCatalog.getString('UploadError') + '<br>' + err);
                },
                begin: function (args) {
                    args.data = {tipus: 'EvesVersTerv|taktKepzes', tablaId: vm.annualSeasonPlanReportId};
                }
            });
            angular.element('#uploadbox3').ejUploadbox({
                saveUrl: DOMAIN.baseURL + DOMAIN.webService + 'FileUploadEvesVersTerv',
                autoUpload: true,
                uploadName: 'Uploadbox',
                allowDragAndDrop: false,
                buttonText: {
                    browse: gettextCatalog.getString('UploadFile'),
                    upload: gettextCatalog.getString('UploadFile'),
                    cancel: gettextCatalog.getString('CancelUpload')
                },
                dialogAction: {modal: true, closeOnComplete: true, resize: false, drag: false},
                dialogText: {
                    title: gettextCatalog.getString('UploadedFilesTitle'),
                    name: gettextCatalog.getString('FileName'),
                    size: gettextCatalog.getString('FileSize'),
                    status: gettextCatalog.getString('FileStatus')
                },
                dropAreaText: gettextCatalog.getString('DropFileToUpload'),
                extensionsAllow: '.doc,.docx,.pdf',
                enabled: vm.editable,
                complete: function (args) {
                    if (args.responseText && args.responseText.length > 0) {
                        if (args.responseText.indexOf('>') !== -1) {
                            args.responseText = args.responseText.slice(args.responseText.indexOf('>') + 1, args.responseText.indexOf('</'));
                        }
                        log.successMsg(gettextCatalog.getString('UploadSuccessed'));
                        vm.data.KepessegFejlFeladatokFile = args.responseText;
                        dataservice.saveAnnualSeasonPlanCapitalObjectives(vm.data)
                            .then(function (args) {
                                vm.Id = args.res;
                                log.successMsg(gettextCatalog.getString('SaveSuccessed'));
                            });
                    } else {
                        log.htmlError(gettextCatalog.getString('UploadError') + '<br>' + args.error);
                    }
                },
                error: function (args) {
                    var err = '';
                    if (args.error === 'Only files with .doc,.docx,.pdf extensions are allowed.') {
                        err = gettextCatalog.getString('OnlyDocPdf');
                    } else if (args.error === '500 Internal Server Error') {
                        err = gettextCatalog.getString('ToLongFile');
                    }
                    log.htmlError(gettextCatalog.getString('UploadError') + '<br>' + err);
                },
                begin: function (args) {
                    args.data = {tipus: 'EvesVersTerv|kepessegFejl', tablaId: vm.annualSeasonPlanReportId};
                }
            });
            angular.element('#uploadbox4').ejUploadbox({
                saveUrl: DOMAIN.baseURL + DOMAIN.webService + 'FileUploadEvesVersTerv',
                autoUpload: true,
                uploadName: 'Uploadbox',
                allowDragAndDrop: false,
                buttonText: {
                    browse: gettextCatalog.getString('UploadFile'),
                    upload: gettextCatalog.getString('UploadFile'),
                    cancel: gettextCatalog.getString('CancelUpload')
                },
                dialogAction: {modal: true, closeOnComplete: true, resize: false, drag: false},
                dialogText: {
                    title: gettextCatalog.getString('UploadedFilesTitle'),
                    name: gettextCatalog.getString('FileName'),
                    size: gettextCatalog.getString('FileSize'),
                    status: gettextCatalog.getString('FileStatus')
                },
                dropAreaText: gettextCatalog.getString('DropFileToUpload'),
                extensionsAllow: '.doc,.docx,.pdf',
                enabled: vm.editable,
                complete: function (args) {
                    if (args.responseText && args.responseText.length > 0) {
                        if (args.responseText.indexOf('>') !== -1) {
                            args.responseText = args.responseText.slice(args.responseText.indexOf('>') + 1, args.responseText.indexOf('</'));
                        }
                        log.successMsg(gettextCatalog.getString('UploadSuccessed'));
                        vm.data.NevelesiFeladatokFile = args.responseText;
                        dataservice.saveAnnualSeasonPlanCapitalObjectives(vm.data)
                            .then(function (args) {
                                vm.Id = args.res;
                                log.successMsg(gettextCatalog.getString('SaveSuccessed'));
                            });
                    } else {
                        log.htmlError(gettextCatalog.getString('UploadError') + '<br>' + args.error);
                    }
                },
                error: function (args) {
                    var err = '';
                    if (args.error === 'Only files with .doc,.docx,.pdf extensions are allowed.') {
                        err = gettextCatalog.getString('OnlyDocPdf');
                    } else if (args.error === '500 Internal Server Error') {
                        err = gettextCatalog.getString('ToLongFile');
                    }
                    log.htmlError(gettextCatalog.getString('UploadError') + '<br>' + err);
                },
                begin: function (args) {
                    args.data = {tipus: 'EvesVersTerv|nevFelad', tablaId: vm.annualSeasonPlanReportId};
                }
            });
            angular.element('#uploadbox5').ejUploadbox({
                saveUrl: DOMAIN.baseURL + DOMAIN.webService + 'FileUploadEvesVersTerv',
                autoUpload: true,
                uploadName: 'Uploadbox',
                allowDragAndDrop: false,
                buttonText: {
                    browse: gettextCatalog.getString('UploadFile'),
                    upload: gettextCatalog.getString('UploadFile'),
                    cancel: gettextCatalog.getString('CancelUpload')
                },
                dialogAction: {modal: true, closeOnComplete: true, resize: false, drag: false},
                dialogText: {
                    title: gettextCatalog.getString('UploadedFilesTitle'),
                    name: gettextCatalog.getString('FileName'),
                    size: gettextCatalog.getString('FileSize'),
                    status: gettextCatalog.getString('FileStatus')
                },
                dropAreaText: gettextCatalog.getString('DropFileToUpload'),
                extensionsAllow: '.doc,.docx,.pdf',
                enabled: vm.editable,
                complete: function (args) {
                    if (args.responseText && args.responseText.length > 0) {
                        if (args.responseText.indexOf('>') !== -1) {
                            args.responseText = args.responseText.slice(args.responseText.indexOf('>') + 1, args.responseText.indexOf('</'));
                        }
                        log.successMsg(gettextCatalog.getString('UploadSuccessed'));
                        vm.data.EredmenyessegiFeladatokFile = args.responseText;
                        dataservice.saveAnnualSeasonPlanCapitalObjectives(vm.data)
                            .then(function (args) {
                                vm.Id = args.res;
                                log.successMsg(gettextCatalog.getString('SaveSuccessed'));
                            });
                    } else {
                        log.htmlError(gettextCatalog.getString('UploadError') + '<br>' + args.error);
                    }
                },
                error: function (args) {
                    var err = '';
                    if (args.error === 'Only files with .doc,.docx,.pdf extensions are allowed.') {
                        err = gettextCatalog.getString('OnlyDocPdf');
                    } else if (args.error === '500 Internal Server Error') {
                        err = gettextCatalog.getString('ToLongFile');
                    }
                    log.htmlError(gettextCatalog.getString('UploadError') + '<br>' + err);
                },
                begin: function (args) {
                    args.data = {tipus: 'EvesVersTerv|eredmFelad', tablaId: vm.annualSeasonPlanReportId};
                }
            });

            angular.element('#uploadbox6').ejUploadbox({
                saveUrl: DOMAIN.baseURL + DOMAIN.webService + 'FileUploadEvesVersTerv',
                autoUpload: true,
                uploadName: 'Uploadbox',
                allowDragAndDrop: false,
                buttonText: {
                    browse: gettextCatalog.getString('UploadFile'),
                    upload: gettextCatalog.getString('UploadFile'),
                    cancel: gettextCatalog.getString('CancelUpload')
                },
                dialogAction: {modal: true, closeOnComplete: true, resize: false, drag: false},
                dialogText: {
                    title: gettextCatalog.getString('UploadedFilesTitle'),
                    name: gettextCatalog.getString('FileName'),
                    size: gettextCatalog.getString('FileSize'),
                    status: gettextCatalog.getString('FileStatus')
                },
                dropAreaText: gettextCatalog.getString('DropFileToUpload'),
                extensionsAllow: '.doc,.docx,.pdf',
                enabled: vm.editable,
                complete: function (args) {
                    if (args.responseText && args.responseText.length > 0) {
                        if (args.responseText.indexOf('>') !== -1) {
                            args.responseText = args.responseText.slice(args.responseText.indexOf('>') + 1, args.responseText.indexOf('</'));
                        }
                        log.successMsg(gettextCatalog.getString('UploadSuccessed'));
                        vm.data.SportagSpecFeladatokFile = args.responseText;
                        dataservice.saveAnnualSeasonPlanCapitalObjectives(vm.data)
                            .then(function (args) {
                                vm.Id = args.res;
                                log.successMsg(gettextCatalog.getString('SaveSuccessed'));
                            });
                    } else {
                        log.htmlError(gettextCatalog.getString('UploadError') + '<br>' + args.error);
                    }
                },
                error: function (args) {
                    var err = '';
                    if (args.error === 'Only files with .doc,.docx,.pdf extensions are allowed.') {
                        err = gettextCatalog.getString('OnlyDocPdf');
                    } else if (args.error === '500 Internal Server Error') {
                        err = gettextCatalog.getString('ToLongFile');
                    }
                    log.htmlError(gettextCatalog.getString('UploadError') + '<br>' + err);
                },
                begin: function (args) {
                    args.data = {tipus: 'EvesVersTerv|spSpec', tablaId: vm.annualSeasonPlanReportId};
                }
            });
        }

        function jumpPageDataBound() {
            angular.element('#maKorabbi').ejDropDownList('selectItemByValue', vm.defaultJumpPage);
            vm.selectedJumpPage = vm.defaultJumpPage;
        }

        function jumpPageSelect(args) {
            vm.selectedJumpPage = args.value;
            var sorszam = vm.selectedJumpPage.split('-')[0];
            if (sorszam === '4 ') {
                return;
            }

            if (!vm.hasSignedAnnualSeasonPlan) {
                dataservice.saveAnnualSeasonPlanCapitalObjectives(vm.data)
                    .then(function (args) {
                        vm.Id = args.res;
                        log.successMsg('SaveCompleted');
                    });
            }
            $timeout(function () {
                paramHelper.setParams([{'AnnualSeasonPlanReport.Id': vm.annualSeasonPlanReportId}]);
                switch (sorszam) {
                    case '1 ':
                        $state.go('administration.annualSeasonPlan.annualSeasonPlanReportPage1');
                        break;
                    case '2 ':
                        $state.go('administration.annualSeasonPlan.annualSeasonPlanReportPage2');
                        break;
                    case '3 ':
                        $state.go('administration.annualSeasonPlan.annualSeasonPlanReportPage3');
                        break;
                    case '4 ':
                        $state.go('administration.annualSeasonPlan.annualSeasonPlanReportPage4');
                        break;
                    case '5 ':
                        $state.go('administration.annualSeasonPlan.annualSeasonPlanReportPage5');
                        break;
                    case '6 ':
                        $state.go('administration.annualSeasonPlan.annualSeasonPlanReportPage6');
                        break;
                }
            }, 100);
        }

        function goToNextPage() {
            if (vm.editable) {
                dataservice.saveAnnualSeasonPlanCapitalObjectives(vm.data)
                    .then(function (args) {
                        vm.Id = args.res;
                        log.successMsg('SaveCompleted');
                    });
            }

            $timeout(function () {
                paramHelper.setParams([{
                    'AnnualSeasonPlanReport.Id': vm.annualSeasonPlanReportId
                }]);
                $state.go('administration.annualSeasonPlan.annualSeasonPlanReportPage5');
            }, 100);
        }

        function goToPreviousPage() {
            if (vm.editable) {
                dataservice.saveAnnualSeasonPlanCapitalObjectives(vm.data)
                    .then(function (args) {
                        vm.Id = args.res;
                        log.successMsg('SaveCompleted');
                    });
            }
            $timeout(function () {
                paramHelper.setParams([{
                    'AnnualSeasonPlanReport.Id': vm.annualSeasonPlanReportId
                }]);
                $state.go('administration.annualSeasonPlan.annualSeasonPlanReportPage3');
            }, 100);
        }

        function closeOutstandingResultsWindow() {
            var dialogObj = angular.element('#searchWindow').data('ejDialog');
            dialogObj.close();
        }

        function selectOutstandingResults() {
            if (vm.selectedRowIndexPopup > -1) {
                var vmi = vm.dataPopup[vm.selectedRowIndexPopup];
                if (vmi) {
                    var sorszam = 0;
                    for (var i = 0; i < vm.data.length; i++) {
                        if (vm.data[i].Sorszam > sorszam) {
                            sorszam = vm.data[i].Sorszam;
                        }
                    }
                    vm.data.push(
                        {
                            Sorszam: sorszam + 1,
                            IdVersenyeztetesiTervFej: vm.annualSeasonPlanReportId,
                            ElertHelyezes: vmi.Helyezes,
                            EsemenyHelye: vmi.Helyszin,
                            EsemenyIdopontja: (vmi.DatumTol ? vmi.DatumTol : '') + (vm.Datumig ? '-' + vm.DatumIg : ''),
                            EsemenyNeve: vmi.EsemenyNeve,
                            VersenyzoNeve: vmi.CsapatSportolo
                        });
                }
            }
            var dialogObj = angular.element('#searchWindow').data('ejDialog');
            dialogObj.close();
        }

        function numberChange() {
            var tx1 = angular.element('#teSpSpec').data('ejNumericTextbox');
            var tx2 = angular.element('#teAddTraining').data('ejNumericTextbox');
            vm.data.HetiEdzesOsszesen = Number(tx1.model.value) + Number(tx2.model.value);
        }

        function openTechnicalTrainingObjectives() {
            if (vm.data.TechKepzesFeladatokFile) {
                openLink(vm.data.TechKepzesFeladatokFile.replace(/\"/g, ''));
            }
        }

        function removeTechnicalTrainingObjectives() {
            var host = DOMAIN.baseURL + DOMAIN.webService;
            dataservice.deleteFileAnnualSeasonPlan(vm.data.TechKepzesFeladatokFile, host)
                .then(function () {
                    vm.data.TechKepzesFeladatokFile = undefined;
                    dataservice.saveAnnualSeasonPlanCapitalObjectives(vm.data)
                        .then(function () {
                            log.successMsg('SaveDone.');
                        });
                });
        }

        function openTacticalTrainingObjectives() {
            if (vm.data.TaktikaiKepzesFeladatokFile) {
                openLink(vm.data.TaktikaiKepzesFeladatokFile.replace(/\"/g, ''));
            }
        }

        function removeTacticalTrainingObjectives() {
            var host = DOMAIN.baseURL + DOMAIN.webService;
            dataservice.deleteFileAnnualSeasonPlan(vm.data.TaktikaiKepzesFeladatokFile, host)
                .then(function () {
                    vm.data.TaktikaiKepzesFeladatokFile = undefined;
                    dataservice.saveAnnualSeasonPlanCapitalObjectives(vm.data)
                        .then(function () {
                            log.successMsg('SaveDone.');
                        });
                });
        }

        function openAbilitydevelopmentObjectives() {
            if (vm.data.KepessegFejlFeladatokFile) {
                openLink(vm.data.KepessegFejlFeladatokFile.replace(/\"/g, ''));
            }
        }

        function removeAbilitydevelopmentObjectives() {
            var host = DOMAIN.baseURL + DOMAIN.webService;
            dataservice.deleteFileAnnualSeasonPlan(vm.data.KepessegFejlFeladatokFile, host)
                .then(function () {
                    vm.data.KepessegFejlFeladatokFile = undefined;
                    dataservice.saveAnnualSeasonPlanCapitalObjectives(vm.data)
                        .then(function () {
                            log.successMsg('SaveDone.');
                        });
                });
        }

        function openEducationalObjectives() {
            if (vm.data.NevelesiFeladatokFile) {
                openLink(vm.data.NevelesiFeladatokFile.replace(/\"/g, ''));
            }
        }

        function removeEducationalObjectives() {
            var host = DOMAIN.baseURL + DOMAIN.webService;
            dataservice.deleteFileAnnualSeasonPlan(vm.data.NevelesiFeladatokFile, host)
                .then(function () {
                    vm.data.NevelesiFeladatokFile = undefined;
                    dataservice.saveAnnualSeasonPlanCapitalObjectives(vm.data)
                        .then(function () {
                            log.successMsg('SaveDone.');
                        });
                });
        }

        function openEfficiencyObjectives() {
            if (vm.data.EredmenyessegiFeladatokFile) {
                openLink(vm.data.EredmenyessegiFeladatokFile.replace(/\"/g, ''));
            }
        }

        function removeEfficiencyObjectives() {
            var host = DOMAIN.baseURL + DOMAIN.webService;
            dataservice.deleteFileAnnualSeasonPlan(vm.data.EredmenyessegiFeladatokFile, host)
                .then(function () {
                    vm.data.EredmenyessegiFeladatokFile = undefined;
                    dataservice.saveAnnualSeasonPlanCapitalObjectives(vm.data)
                        .then(function () {
                            log.successMsg('SaveDone.');
                        });
                });
        }

        function openSportSpecificTrainingObjectives() {
            if (vm.data.SportagSpecFeladatokFile) {
                openLink(vm.data.SportagSpecFeladatokFile.replace(/\"/g, ''));
            }
        }

        function removeSportSpecificTrainingObjectives() {
            var host = DOMAIN.baseURL + DOMAIN.webService;
            dataservice.deleteFileAnnualSeasonPlan(vm.data.SportagSpecFeladatokFile, host)
                .then(function () {
                    vm.data.SportagSpecFeladatokFile = undefined;
                    dataservice.saveAnnualSeasonPlanCapitalObjectives(vm.data)
                        .then(function () {
                            log.successMsg('SaveDone.');
                        });
                });
        }

        function openLink(url) {
            $window.open(url, '_blank');
        }

        function search() {
            vm.selectedRowIndexPopup = -1;
            var dialogObj = angular.element('#searchWindow').data('ejDialog');
            dialogObj.open();
            dataservice.getAnnualSeasonPlanListByTrainer(vm.head.IdEdzo, vm.annualSeasonPlanReportId)
                .then(function (args) {
                    vm.dataPopup = args.itemsList;
                    grid.dataSource = args.itemsList;
                });
        }

        function closeEarlierAnnualSeasonPlanWindow() {
            var dialogObj = angular.element('#searchWindow').data('ejDialog');
            dialogObj.close();
        }

        function selectEarlierAnnualSeasonPlan() {
            vm.selectedRowIndexPopup = grid.selectedRowIndex;
            if (vm.selectedRowIndexPopup > -1) {
                var vmi = vm.dataPopup[vm.selectedRowIndexPopup];
                if (vmi) {
                    dataservice.annualSeasonPlanReportObjectivesSelect(vmi.Id)
                        .then(function (data) {
                            vm.data.HetiEdzesSportag = data.HetiEdzesSportag;
                            vm.data.HetiEdzesKiegeszito = data.HetiEdzesKiegeszito;
                            vm.data.HetiEdzesOsszesen = data.HetiEdzesOsszesen;
                            vm.data.SportagSpecFeladatok = data.SportagSpecFeladatok;
                            vm.data.SportagSpecFeladatokFile = data.SportagSpecFeladatokFile;
                            vm.data.KepessegFejlFeladatok = data.KepessegFejlFeladatok;
                            vm.data.KepessegFejlFeladatokFile = data.KepessegFejlFeladatokFile;
                            vm.data.NevelesiFeladatok = data.NevelesiFeladatok;
                            vm.data.NevelesiFeladatokFile = data.NevelesiFeladatokFile;
                            vm.data.TechKepzesFeladatok = data.TechKepzesFeladatok;
                            vm.data.TechKepzesFeladatokFile = data.TechKepzesFeladatokFile;
                            vm.data.TaktikaiKepzesFeladatok = data.TaktikaiKepzesFeladatok;
                            vm.data.TaktikaiKepzesFeladatokFile = data.TaktikaiKepzesFeladatokFile;
                            vm.data.EredmenyessegiFeladatok = data.EredmenyessegiFeladatok;
                            vm.data.EredmenyessegiFeladatokFile = data.EredmenyessegiFeladatokFile;
                        });
                    var dialogObj = angular.element('#searchWindow').data('ejDialog');
                    dialogObj.close();
                }
            }
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular .module('app.administration.annualSeasonPlan.annualSeasonPlanReportPage4')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'administration.annualSeasonPlan.annualSeasonPlanReportPage4',
                config: {
                    url: '/annualSeasonPlanReportPage4',
                    templateUrl: 'app/administration/annualSeasonPlan/annualSeasonPlanReportPage4/annualSeasonPlanReportPage4.html',
                    controller: 'AnnualSeasonPlanReportPage4Controller',
                    controllerAs: 'vm',
                    title: 'AnnualSeasonPlan'
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    AnnualSeasonPlanReportPage5Controller.$inject = ["$rootScope", "gettextCatalog", "dataservice", "log", "$q", "authenticationService", "paramHelper", "$scope", "$compile", "$state", "$timeout"];
    angular
        .module('app.administration.annualSeasonPlan.annualSeasonPlanReportPage5')
        .controller('AnnualSeasonPlanReportPage5Controller', AnnualSeasonPlanReportPage5Controller);

    function AnnualSeasonPlanReportPage5Controller($rootScope, gettextCatalog, dataservice, log, $q, authenticationService, paramHelper, $scope, $compile, $state, $timeout) {
        var vm = this;
        $rootScope.vm = vm; // jshint ignore: line

        // Page title
        $rootScope.title = gettextCatalog.getString('AnnualSeasonPlanReport');
        vm.columns = [];
        vm.columnsPopup = [];
        vm.egyeni = false;
        vm.editable = true;
        vm.annualSeasonPlanReportId = 0;
        vm.selectedRowIndex = -1;
        vm.selectedRowIndexPopup = -1;

        vm.head = {};
        vm.data = [];
        vm.dataPopup = [];
        // jump page
        vm.JumpPageList = [
            '1 - ' + gettextCatalog.getString('TheMostImportantDataOfAGroupsMembers'),
            '2 - ' + gettextCatalog.getString('PreparationAndCompetitionPast'),
            '3 - ' + gettextCatalog.getString('OutstandingResults'),
            '4 - ' + gettextCatalog.getString('CapitalObjectives'),
            '5 - ' + gettextCatalog.getString('CompetitionPlansAndObjectives'),
            '6 - ' + gettextCatalog.getString('YearlyTablePlan')
        ];
        // functions
        vm.goToNextPage = goToNextPage;
        vm.goToPreviousPage = goToPreviousPage;
        vm.newRow = newRow;
        vm.removeRow = removeRow;
        vm.search = search;
        vm.closeOutstandingResultsWindow = closeOutstandingResultsWindow;
        vm.selectOutstandingResults = selectOutstandingResults;
        vm.jumpPageDataBound = jumpPageDataBound;
        vm.jumpPageSelect = jumpPageSelect;

        vm.maskObject = {};
        vm.elem = {};

        vm.dateTimeEditorTemplate = {
            create: function () {
                vm.elem = document.createElement('input');
                vm.elem.addEventListener('focus', function () {
                    this.select();
                });
                return vm.elem;
            },
            read: function () {
                return vm.maskObject.getMaskedValue();
            },
            destroy: function () {
                if (vm.maskObject != null) {
                    vm.maskObject.destroy();
                }
            },
            write: function (args) {
                vm.maskObject = new ej2.inputs.MaskedTextBox({
                    minWidth: '100%',
                    mask: '>0000.00.00.',
                    value: args.rowData[args.column.field],
                    readOnly: vm.editable,
                });
                vm.editedRowId = args.rowData['Id'];
                $compile(args.element[0])($scope);
                vm.maskObject.appendTo(vm.elem);
            }
        };

        initGrid();

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItems,
            editSettings: {allowEditing: vm.editable, mode: 'Batch', showConfirmDialog: false, allowDeleting: vm.editable, showDeleteConfirmDialog: true},
            allowTextWrap: true,
            allowSorting: true,
            allowExcelExport: true,
            allowDeleting: vm.editable,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile(angular.element('#Grid'), $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        var gridPopup = new ej2.grids.Grid({
            dataSource: [],
            allowTextWrap: true,
            allowSorting: true,
            allowScrolling: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            columns: vm.columnsPopup,
            selectedRowIndex: vm.selectedRowIndexPopup,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile(angular.element('#GridPopup'), $scope);
                }
            }
        });
        gridPopup.appendTo('#GridPopup');

        activate();

        function activate() {
            vm.jumpedPage = '5 - ' + gettextCatalog.getString('CompetitionPlansAndObjectives');
            vm.defaultJumpPage = '5 - ' + gettextCatalog.getString('CompetitionPlansAndObjectives');
            $q.all([paramHelper.getParams([], ['AnnualSeasonPlanReport.Id']),
                    authenticationService.getRight('EDZO'),
                    authenticationService.getRight('ADMIN'),
                    authenticationService.getRight('SZAKOSZTVEZ'),
                    authenticationService.getRight('TECHIGAZGATO'),
                    authenticationService.getRight('EVVERSTALAIR1'),
                    authenticationService.getRight('EVVERSTALAIR2'),
                    authenticationService.getRight('UJEVVERST'),
                    authenticationService.getRight('MEGTSPORTLIST'),
                    authenticationService.getRight('MEGTSPORTLIST'),
                    authenticationService.getRight('MEGTEVVERST')
                ])
                .then(function (results) {
                    vm.EDZO = results[1];
                    vm.ADMIN = results[2];
                    vm.SZAKOSZTVEZ = results[3];
                    vm.TECHIGAZGATO = results[4];
                    vm.EVVERSTALAIR1 = results[5];
                    vm.EVVERSTALAIR2 = results[6];
                    vm.UJEVVERST = results[7];
                    vm.MEGTSPORTLIST = results[8];
                    vm.MEGTSPORTLIST = results[9];
                    vm.MEGTEVVERST = results[10];
                    if (!vm.MEGTEVVERST) {
                        log.permissionError(true);
                        return;
                    }
                    if (results[0]['AnnualSeasonPlanReport.Id'] && results[0]['AnnualSeasonPlanReport.Id'] !== -1) {
                        vm.annualSeasonPlanReportId = results[0]['AnnualSeasonPlanReport.Id'];
                        paramHelper.removeParam('AnnualSeasonPlanReport.Id');
                        dataservice.annualSeasonPlanReportSelectById(vm.annualSeasonPlanReportId)
                            .then(function (data) {
                                vm.head = data;
                                vm.egyeni = data.Egyeni;
                                vm.editable = !data.EdzoLezarta;

                                initGrid();
                                dataservice.annualSeasonPlanCompetitionPlansAndObjectivesSelect(vm.annualSeasonPlanReportId)
                                    .then(function (data) {
                                        vm.data = data.itemsList;
                                        grid.dataSource = vm.data;
                                        grid.editSettings.allowEditing = vm.editable;
                                        grid.editSettings.allowDeleting = vm.editable;
                                    });
                            });
                    } else {
                        $rootScope.back();
                    }
                });
        }

        function jumpPageDataBound() {
            angular.element('#maKorabbi').ejDropDownList('selectItemByValue', vm.defaultJumpPage);
            vm.selectedJumpPage = vm.defaultJumpPage;
        }

        function jumpPageSelect(args) {
            vm.selectedJumpPage = args.value;
            var sorszam = vm.selectedJumpPage.split('-')[0];
            if (sorszam === '5 ') {
                return;
            }

            if (vm.editable) {
                grid.editModule.endEdit();
                dataservice.saveAnnualSeasonPlanCompetitionPlansAndObjectives(vm.data)
                    .then(function () {
                        log.successMsg('SaveCompleted');
                    });
            }
            $timeout(function () {
                paramHelper.setParams([{'AnnualSeasonPlanReport.Id': vm.annualSeasonPlanReportId}]);
                switch (sorszam) {
                case '1 ':
                    $state.go('administration.annualSeasonPlan.annualSeasonPlanReportPage1');
                    break;
                case '2 ':
                    $state.go('administration.annualSeasonPlan.annualSeasonPlanReportPage2');
                    break;
                case '3 ':
                    $state.go('administration.annualSeasonPlan.annualSeasonPlanReportPage3');
                    break;
                case '4 ':
                    $state.go('administration.annualSeasonPlan.annualSeasonPlanReportPage4');
                    break;
                case '5 ':
                    $state.go('administration.annualSeasonPlan.annualSeasonPlanReportPage5');
                    break;
                case '6 ':
                    $state.go('administration.annualSeasonPlan.annualSeasonPlanReportPage6');
                    break;
            }
            }, 100);
        }

        function initGrid() {
            vm.columns = [];
            vm.columns = [{
                    field: 'Id',
                    visible: false,
                    isPrimaryKey: true,
                    isIdentity: true
                },
                {
                    field: 'Sorszam',
                    headerText: gettextCatalog.getString('RowNumber'),
                    textAlign: 'center',
                    width: 40,
                    allowEditing: false
                },
                {
                    field: 'EsemenyIdopont',
                    headerText: gettextCatalog.getString('DateInText'),
                    textAlign: 'center',
                    width: 100,
                    allowEditing: vm.editable
                },
                {
                    field: 'EsemenyIdopont2',
                    headerText: gettextCatalog.getString('Datumn'),
                    textAlign: 'center',
                    allowEditing: vm.editable,
                    width: 100,
                    edit: vm.dateTimeEditorTemplate,
                    validationRules: {date: true},
                },
                {
                    field: 'EsemenyNeve',
                    headerText: gettextCatalog.getString('EsemenyNeve'),
                    textAlign: 'center',
                    width: 100,
                    allowEditing: vm.editable
                },
                {
                    field: 'EsemenyHelyszin',
                    headerText: gettextCatalog.getString('EsemenyHelye'),
                    textAlign: 'center',
                    width: 150,
                    allowEditing: vm.editable
                },
                {
                    field: 'VersenyzoNeve',
                    headerText: gettextCatalog.getString('VersenyzoNeve'),
                    textAlign: 'center',
                    width: 150,
                    allowEditing: vm.editable
                },
                {
                    field: 'EredmenyTerv',
                    headerText: gettextCatalog.getString('EredmenyTerv'),
                    textAlign: 'center',
                    width: 150,
                    allowEditing: vm.editable,
                    visible: !vm.egyeni
                }
            ];

            vm.columnsPopup = [];
            vm.columnsPopup = [{
                    field: 'Id',
                    visible: false,
                    isPrimaryKey: true,
                    isIdentity: true
                },
                {
                    field: 'Szakosztaly',
                    headerText: gettextCatalog.getString('Section'),
                    textAlign: 'center',
                    width: 100,
                },
                {
                    field: 'Korosztaly',
                    headerText: gettextCatalog.getString('AgeGroup'),
                    textAlign: 'center',
                    width: 100,
                },
                {
                    field: 'DatumTol',
                    headerText: gettextCatalog.getString('DatumTol'),
                    textAlign: 'center',
                    width: 100,
                },
                {
                    field: 'DatumIg',
                    headerText: gettextCatalog.getString('DatumIg'),
                    textAlign: 'center',
                    width: 100,
                }
            ];
        }

        function goToNextPage() {
            if (vm.editable) {
                grid.editModule.endEdit();
                dataservice.saveAnnualSeasonPlanCompetitionPlansAndObjectives(vm.data)
                    .then(function () {
                        log.successMsg('SaveCompleted');
                    });
            }

            $timeout(function () {
                paramHelper.setParams([{
                    'AnnualSeasonPlanReport.Id': vm.annualSeasonPlanReportId
                }]);
                $state.go('administration.annualSeasonPlan.annualSeasonPlanReportPage6');
            }, 100);
        }

        function goToPreviousPage() {
            if (vm.editable) {
                grid.editModule.endEdit();
                dataservice.saveAnnualSeasonPlanCompetitionPlansAndObjectives(vm.data)
                    .then(function () {
                        log.successMsg('SaveCompleted');
                    });
            }
            $timeout(function () {
                paramHelper.setParams([{
                    'AnnualSeasonPlanReport.Id': vm.annualSeasonPlanReportId
                }]);
                $state.go('administration.annualSeasonPlan.annualSeasonPlanReportPage4');
            }, 100);
        }

        function newRow() {
            grid.editModule.endEdit();
            var sorszam = 0;
            for (var i = 0; i < vm.data.length; i++) {
                if (vm.data[i].Sorszam > sorszam) {
                    sorszam = vm.data[i].Sorszam;
                }
            }
            vm.data.push({
                Id: (vm.data.length + 1) * -1,
                Sorszam: sorszam + 1,
                IdVersenyeztetesiTervFej: vm.annualSeasonPlanReportId,
                EredmenyTerv: '',
                EsemenyHelyszin: '',
                EsemenyIdopont: '',
                EsemenyIdopont2: '',
                EsemenyNeve: '',
                VersenyzoNeve: ''
            });
            grid.dataSource = vm.data;
        }

        function removeRow() {
            grid.editModule.endEdit();
            vm.selectedRowIndex = grid.selectedRowIndex;
            if (vm.selectedRowIndex > -1) {
                var vmi = vm.data[vm.selectedRowIndex];
                if (vmi.Id > 0) {
                    dataservice.deleteAnnualSeasonPlanCompetitionPlansAndObjective(vmi.Id)
                        .then(function () {
                            deleteRow(vm.selectedRowIndex);
                        });
                } else {
                    deleteRow(vm.selectedRowIndex);
                }
            }
        }

        function deleteRow(index) {
            vm.data.splice(index, 1);
            var i = 1;
            angular.forEach(vm.data, function (value) {
                value.Sorszam = i++;
            });
            grid.dataSource = vm.data;
            grid.refresh();
        }

        function search() {
            vm.selectedRowIndexPopup = -1;
            var dialogObj = angular.element('#searchWindow').data('ejDialog');
            dialogObj.open();
            dataservice.getAnnualSeasonPlanListByTrainer(vm.head.IdEdzo, vm.annualSeasonPlanReportId)
                .then(function (args) {
                    vm.dataPopup = [];
                    vm.dataPopup = args.itemsList;
                    gridPopup.dataSource = args.itemsList;
                });
        }

        function closeOutstandingResultsWindow() {
            var dialogObj = angular.element('#searchWindow').data('ejDialog');
            dialogObj.close();
        }

        function selectOutstandingResults() {
            vm.selectedRowIndexPopup = gridPopup.selectedRowIndex;
            if (vm.selectedRowIndexPopup > -1) {
                var vmi = vm.dataPopup[vm.selectedRowIndexPopup];
                if (vmi) {
                    dataservice.deleteAnnualSeasonPlanCompetitionPlansAndObjectives(vm.annualSeasonPlanReportId)
                        .then(function () {
                            vm.data = [];
                            dataservice.annualSeasonPlanCompetitionPlansAndObjectivesSelect(vmi.Id)
                                .then(function (data) {
                                    angular.forEach(data.itemsList, function (value) {
                                        value.Id = 0;
                                        value.IdVersenyeztetesiTervFej = vm.annualSeasonPlanReportId;
                                        vm.data.push(value);
                                    });
                                    grid.dataSource = vm.data;
                                    log.successMsg('refreshSuccessed');
                                });
                        });
                }
            }
            var dialogObj = angular.element('#searchWindow').data('ejDialog');
            dialogObj.close();
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular .module('app.administration.annualSeasonPlan.annualSeasonPlanReportPage5')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'administration.annualSeasonPlan.annualSeasonPlanReportPage5',
                config: {
                    url: '/annualSeasonPlanReportPage5',
                    templateUrl: 'app/administration/annualSeasonPlan/annualSeasonPlanReportPage5/annualSeasonPlanReportPage5.html',
                    controller: 'AnnualSeasonPlanReportPage5Controller',
                    controllerAs: 'vm',
                    title: 'AnnualSeasonPlan'
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    AnnualSeasonPlanReportPage6Controller.$inject = ["$rootScope", "gettextCatalog", "dataservice", "log", "$q", "authenticationService", "paramHelper", "$scope", "$state", "$timeout"];
    angular
        .module('app.administration.annualSeasonPlan.annualSeasonPlanReportPage6')
        .controller('AnnualSeasonPlanReportPage6Controller', AnnualSeasonPlanReportPage6Controller);

    function AnnualSeasonPlanReportPage6Controller($rootScope, gettextCatalog, dataservice, log, $q, authenticationService, paramHelper, $scope, $state, $timeout) {
        var vm = this;
        $rootScope.vm = vm; // jshint ignore: line
        var printOpened = false;
        // Page title
        $rootScope.title = gettextCatalog.getString('AnnualSeasonPlanReport');
        vm.columns = [];
        vm.stackedHeaderRows = [];
        vm.egyeni = false;
        vm.editable = true;
        vm.disable = false;
        vm.closed = false;
        vm.annualSeasonPlanReportId = 0;
        vm.rejectAttendanceText = '';
        vm.reportParameters = {};

        vm.head = {};
        vm.data = [];
        vm.months = ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X', 'XI', 'XII'];
        // jump page
        vm.JumpPageList = [
            '1 - ' + gettextCatalog.getString('TheMostImportantDataOfAGroupsMembers'),
            '2 - ' + gettextCatalog.getString('PreparationAndCompetitionPast'),
            '3 - ' + gettextCatalog.getString('OutstandingResults'),
            '4 - ' + gettextCatalog.getString('CapitalObjectives'),
            '5 - ' + gettextCatalog.getString('CompetitionPlansAndObjectives'),
            '6 - ' + gettextCatalog.getString('YearlyTablePlan')
        ];

        // functions
        vm.goToPreviousPage = goToPreviousPage;
        vm.gotoMainPage = gotoMainPage;
        vm.savePlan = savePlan;
        vm.print = print;
        vm.refreshCompetition = refreshCompetition;
        vm.closePlan = closePlan;
        vm.rejectPlan = rejectPlan;
        vm.acceptPlan = acceptPlan;
        vm.rejectAttendance = rejectAttendance;
        vm.closerejectingWindow = closerejectingWindow;
        vm.jumpPageDataBound = jumpPageDataBound;
        vm.jumpPageSelect = jumpPageSelect;
        vm.cellEdit = cellEdit;
        vm.cellsave = cellsave;

        vm.tableEditorTemplate = {
            create: function () {
                return '<input>';
            },
            read: function (args) {
                return args.ejMaskEdit('get_StrippedValue');
            },
            write: function (args) {
                var s = args.element[0].id.toString().replace('Grid', '');
                args.element.ejMaskEdit({
                    width: '100%',
                    maskFormat: 'C',
                    customCharacter: 'xX',
                    value: args.rowdata !== undefined ? args.rowdata[s] : '',
                    readOnly: !vm.editable
                });
            }
        };

        vm.tableEditorTemplateNumX = {
            create: function () {
                elem = document.createElement('input');
                elem.addEventListener('focus', function () {
                    this.select();
                });
                return elem;
            },
            read: function () {
                return gridMaskEdit.value;
            },
            destroy: function () {
                gridMaskEdit.destroy();
            },
            write: function (args) {
                gridMaskEdit = new ej2.inputs.MaskedTextBox({
                    minWidth: '20px',
                    mask: '>C',
                    customCharacters: {C: 'xX0123456789'},
                    value: args.rowData !== undefined ? (args.rowData[args.column.field]).toString().trim() : '',
                    readOnly: !vm.editable
                });
                gridMaskEdit.appendTo(elem);
            }
        };

        vm.tableEditorTemplateNum = {
            create: function () {
                elem = document.createElement('input');
                elem.addEventListener('focus', function () {
                    this.select();
                });
                return elem;
            },
            read: function () {
                return gridMaskEdit.value;
            },
            destroy: function () {
                gridMaskEdit.destroy();
            },
            write: function (args) {
                gridMaskEdit = new ej2.inputs.MaskedTextBox({
                    minWidth: '20px',
                    mask: '>C',
                    customCharacters: {C: '0123456789'},
                    value: args.rowData !== undefined ? (args.rowData[args.column.field]).toString().trim() : '',
                    readOnly: !vm.editable
                });
                gridMaskEdit.appendTo(elem);
            }
        };

        vm.smallColumnWidth = 40;
        vm.columns = [{
            headerText: gettextCatalog.getString('FelkHetSzam') + '<br>(1-52)',
            textAlign: 'center',
            columns: [{
                field: 'Id',
                visible: false,
                isPrimaryKey: true,
                isIdentity: true,
                width: vm.smallColumnWidth
            },
                {
                    field: 'HetSzam',
                    headerText: gettextCatalog.getString('WeekNumber'),
                    textAlign: 'center',
                    width: 50,
                    customAttributes: {class: 'orientationcss'},
                    allowEditing: false
                },
                {
                    field: 'FelkHetSzam',
                    headerText: gettextCatalog.getString('PreparationWeekNumber'),
                    textAlign: 'center',
                    width: 50,
                    type: 'number',
                    customAttributes: {class: 'orientationcss'},
                    allowEditing: vm.editable
                },
                {
                    field: 'Datum',
                    headerText: gettextCatalog.getString('Date'),
                    textAlign: 'center',
                    allowEditing: false,
                    width: 140
                }
            ]
        },
            {
                headerText: gettextCatalog.getString('FelkIdJelleg') + '<br>(X)',
                textAlign: 'center',
                columns: [{
                    field: 'FelkIdJellTiszta',
                    headerText: gettextCatalog.getString('FelkeszulesiIdoTiszta'),
                    textAlign: 'center',
                    width: vm.smallColumnWidth,
                    customAttributes: {class: 'orientationcss', padding: 0},
                    allowEditing: vm.editable
                },
                    {
                        field: 'FelkIdJellVegyes',
                        headerText: gettextCatalog.getString('FelkeszulesiIdoVegyes'),
                        textAlign: 'center',
                        width: vm.smallColumnWidth,
                        customAttributes: {class: 'orientationcss'},
                        allowEditing: vm.editable
                    },
                    {
                        field: 'FelkIdJellVerseny',
                        headerText: gettextCatalog.getString('FelkeszulesiIdoVerseny'),
                        textAlign: 'center',
                        width: vm.smallColumnWidth,
                        customAttributes: {class: 'orientationcss'},
                        allowEditing: vm.editable
                    }
                ]
            },
            {
                headerText: gettextCatalog.getString('HetiEdzesSzam') + '<br>(0-21)',
                textAlign: 'center',
                columns: [{
                    field: 'HetiEdzesSzamAlt',
                    headerText: gettextCatalog.getString('HetiEdzesSzamAltalanos'),
                    textAlign: 'center',
                    width: vm.smallColumnWidth,
                    customAttributes: {class: 'orientationcss', id: 'annualseason'},
                    editType: 'numericedit',
                    edit: {params: {decimals: 2, showSpinButton: false, min: 0, max: 21}},
                    allowEditing: vm.editable
                },
                    {
                        field: 'HetiEdzesSzamSpSpec',
                        headerText: gettextCatalog.getString('HetiEdzesSzamSportagSpecifikus'),
                        textAlign: 'center',
                        width: vm.smallColumnWidth,
                        customAttributes: {class: 'orientationcss', id: 'annualseason'},
                        editType: 'numericedit',
                        edit: {params: {decimals: 2, showSpinButton: false, min: 0, max: 21}},
                        allowEditing: vm.editable
                    },
                    {
                        field: 'HetiEdzesSzamOsszesen',
                        headerText: gettextCatalog.getString('HetiEdzesSzamOsszesen'),
                        textAlign: 'center',
                        width: vm.smallColumnWidth,
                        customAttributes: {class: 'orientationcss', id: 'annualseason'},
                        readOnly: true
                    }
                ]
            },
            {
                headerText: gettextCatalog.getString('HetiTerheles') + '<br>(X, 0-9)',
                textAlign: 'center',
                columns: [{
                    field: 'HetiTerhelesMagas',
                    headerText: gettextCatalog.getString('HetiTerhelesMagas'),
                    textAlign: 'center',
                    width: vm.smallColumnWidth,
                    customAttributes: {class: 'orientationcss', id: 'annualseason'},
                    edit: vm.tableEditorTemplateNumX,
                    allowEditing: vm.editable
                },
                    {
                        field: 'HetiTerhelesKozepes',
                        headerText: gettextCatalog.getString('HetiTerhelesKozepes'),
                        textAlign: 'center',
                        width: vm.smallColumnWidth,
                        customAttributes: {class: 'orientationcss', id: 'annualseason'},
                        edit: vm.tableEditorTemplateNumX,
                        allowEditing: vm.editable
                    },
                    {
                        field: 'HetiTerhelesAlacsony',
                        headerText: gettextCatalog.getString('HetiTerhelesAlacsony'),
                        textAlign: 'center',
                        width: vm.smallColumnWidth,
                        customAttributes: {class: 'orientationcss', id: 'annualseason'},
                        edit: vm.tableEditorTemplateNumX,
                        allowEditing: vm.editable
                    }
                ]
            },
            {
                headerText: gettextCatalog.getString('HetiEdzesJell') + '<br>(X, 0-9)',
                textAlign: 'center',
                columns: [{
                    field: 'HetiEdzMunkaTechnikai',
                    headerText: gettextCatalog.getString('HetiEdzesMunkaTechnikai'),
                    textAlign: 'center',
                    width: vm.smallColumnWidth,
                    customAttributes: {class: 'orientationcss', id: 'annualseason'},
                    edit: vm.tableEditorTemplateNumX,
                    allowEditing: vm.editable
                },
                    {
                        field: 'HetiEdzMunkaKepFejl',
                        headerText: gettextCatalog.getString('HetiEdzesMunkaKepessegFejlesztes'),
                        textAlign: 'center',
                        width: vm.smallColumnWidth,
                        customAttributes: {class: 'orientationcss', id: 'annualseason'},
                        edit: vm.tableEditorTemplateNumX,
                        allowEditing: vm.editable
                    },
                    {
                        field: 'HetiEdzMunkaKieg',
                        headerText: gettextCatalog.getString('HetiEdzesMunkaKiegeszito'),
                        textAlign: 'center',
                        width: vm.smallColumnWidth,
                        customAttributes: {class: 'orientationcss', id: 'annualseason'},
                        edit: vm.tableEditorTemplateNumX,
                        allowEditing: vm.editable
                    },
                    {
                        field: 'HetiEdzMunkaEgyeb',
                        headerText: gettextCatalog.getString('HetiEdzesMunkaEgyeb'),
                        textAlign: 'center',
                        width: vm.smallColumnWidth,
                        customAttributes: {class: 'orientationcss', id: 'annualseason'},
                        edit: vm.tableEditorTemplateNumX,
                        allowEditing: vm.editable
                    }
                ]
            },
            {
                headerText: gettextCatalog.getString('Felmeresek') + '<br>(0-9)',
                textAlign: 'center',
                columns: [{
                    field: 'FelmeresekAlt',
                    headerText: gettextCatalog.getString('GeneralSurveys'),
                    textAlign: 'center',
                    width: 45,
                    customAttributes: {class: 'orientationcss', id: 'annualseason'},
                    edit: vm.tableEditorTemplateNum,
                    allowEditing: vm.editable
                },
                    {
                        field: 'FelmeresekSpSpec',
                        headerText: gettextCatalog.getString('SportagSpecifikusFelmeresek'),
                        textAlign: 'center',
                        width: 45,
                        customAttributes: {class: 'orientationcss', id: 'annualseason'},
                        edit: vm.tableEditorTemplateNum,
                        allowEditing: vm.editable
                    }
                ]
            },
            {
                headerText: gettextCatalog.getString('Edzotaborozas'),
                textAlign: 'center',
                columns: [{
                    field: 'EdzTabIdopont',
                    headerText: gettextCatalog.getString('EdzotaborozasIdopont'),
                    textAlign: 'center',
                    allowEditing: vm.editable,
                    width: 90,
                    customAttributes: {id: 'annualseason'}
                },
                    {
                        field: 'EdzTabHely',
                        headerText: gettextCatalog.getString('EdzotaborozasHely'),
                        textAlign: 'center',
                        allowEditing: vm.editable,
                        customAttributes: {id: 'annualseason'},
                        width: 150
                    },
                    {
                        field: 'EdzTabLetszam',
                        headerText: gettextCatalog.getString('EdzotaborozasLetszam'),
                        textAlign: 'center',
                        allowEditing: vm.editable,
                        customAttributes: {id: 'annualseason'},
                        width: 80
                    }
                ]
            },
            {
                headerText: gettextCatalog.getString('Verseny'),
                textAlign: 'center',
                columns: [{
                    field: 'Verseny',
                    headerText: gettextCatalog.getString('Verseny'),
                    textAlign: 'center',
                    allowEditing: vm.editable,
                    customAttributes: {id: 'annualseason'},
                    width: 100
                }]
            }
        ];

        activate();

        var gridMaskEdit;
        var elem;
        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: ['ExcelExport'],
            allowExcelExport: true,
            height: 325,
            allowPdfExport: true,
            editSettings: {allowEditing: true, mode: 'Batch', showConfirmDialog: false},
            locale: 'hu-HU',
            gridLines: 'Both',
            allowTextWrap: true,
            columns: vm.columns,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            cellSave: cellsave,
            cellEdit: cellEdit
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        function activate() {
            vm.jumpedPage = '6 - ' + gettextCatalog.getString('YearlyTablePlan');
            vm.defaultJumpPage = '6 - ' + gettextCatalog.getString('YearlyTablePlan');
            $q.all([paramHelper.getParams([], ['AnnualSeasonPlanReport.Id']),
                    authenticationService.getRight('EDZO'),
                    authenticationService.getRight('ADMIN'),
                    authenticationService.getRight('SZAKOSZTVEZ'),
                    authenticationService.getRight('TECHIGAZGATO'),
                    authenticationService.getRight('EVVERSTALAIR1'),
                    authenticationService.getRight('EVVERSTALAIR2'),
                    authenticationService.getRight('UJEVVERST'),
                    authenticationService.getRight('MEGTSPORTLIST'),
                    authenticationService.getRight('MEGTEVVERST')
                ])
                .then(function (results) {
                    {
                        vm.EDZO = results[1];
                        vm.ADMIN = results[2];
                        vm.SZAKOSZTVEZ = results[3];
                        vm.TECHIGAZGATO = results[4];
                        vm.EVVERSTALAIR1 = results[5];
                        vm.EVVERSTALAIR2 = results[6];
                        vm.UJEVVERST = results[7];
                        vm.MEGTSPORTLIST = results[8];
                        vm.MEGTEVVERST = results[9];
                        if (!vm.MEGTEVVERST) {
                            log.permissionError(true);
                            return;
                        }
                        if (results[0]['AnnualSeasonPlanReport.Id'] && results[0]['AnnualSeasonPlanReport.Id'] !== -1) {
                            vm.annualSeasonPlanReportId = results[0]['AnnualSeasonPlanReport.Id'];
                            paramHelper.removeParam('AnnualSeasonPlanReport.Id');
                            dataservice.annualSeasonPlanReportSelectById(vm.annualSeasonPlanReportId)
                                .then(function (data) {
                                    vm.head = data;
                                    vm.egyeni = data.Egyeni;
                                    if (data.EdzoLezarta) {
                                        vm.editable = false;
                                        vm.disable = true;
                                    } else {
                                        vm.editable = true;
                                        vm.disable = false;
                                    }
                                    vm.closed = (data.SzakosztalyvezetoJovahagyta == null || data.SzakosztalyvezetoJovahagyta === true) && !vm.EVVERSTALAIR1;

                                    dataservice.annualSeasponPlanTableListSelect(vm.annualSeasonPlanReportId)
                                        .then(function (data) {
                                            vm.data = data.itemsList;
                                            grid.dataSource = vm.data;
                                            if (vm.data.length === 0) {
                                                //megkeressük az első hétfőt augusztusban
                                                var datum = new Date(vm.head.ErvenyessegTol);
                                                while (datum.getDay() > 1 || datum.getDay() === 0) {
                                                    datum.setDate(datum.getDate() + 1);
                                                }
                                                for (var i = 1; i <= 52; i++) {
                                                    var datumstr = vm.months[datum.getMonth()] + '.' + datum.getDate() + '. - ';
                                                    //vasárnap
                                                    datum.setDate(datum.getDate() + 6);
                                                    datumstr += vm.months[datum.getMonth()] + '.' + datum.getDate() + '.';
                                                    //hétfő
                                                    datum.setDate(datum.getDate() + 1);
                                                    var obj = {
                                                        Datum: datumstr,
                                                        EdzTabHely: '',
                                                        EdzTabIdopont: '',
                                                        EdzTabLetszam: '',
                                                        FelkHetSzam: '',
                                                        FelkIdJellTiszta: '',
                                                        FelkIdJellVegyes: '',
                                                        FelkIdJellVerseny: '',
                                                        FelmeresekAlt: '',
                                                        FelmeresekSpSpec: '',
                                                        HetiEdzesSzamAlt: '',
                                                        HetiEdzesSzamOsszesen: '',
                                                        HetiEdzesSzamSpSpec: '',
                                                        HetiEdzMunkaEgyeb: '',
                                                        HetiEdzMunkaKepFejl: '',
                                                        HetiEdzMunkaKieg: '',
                                                        HetiEdzMunkaTechnikai: '',
                                                        HetiTerhelesAlacsony: '',
                                                        HetiTerhelesKozepes: '',
                                                        HetiTerhelesMagas: '',
                                                        HetSzam: i,
                                                        IdVersenyeztetesiTervFej: vm.annualSeasonPlanReportId,
                                                        Verseny: '',
                                                        Id: -1 * i
                                                    };
                                                    vm.data.push(obj);
                                                }
                                            }
                                        });
                                });
                        } else {
                            $rootScope.back();
                        }
                    }
                });
        }

        function jumpPageDataBound() {
            angular.element('#maKorabbi').ejDropDownList('selectItemByValue', vm.defaultJumpPage);
            vm.selectedJumpPage = vm.defaultJumpPage;
        }

        function jumpPageSelect(args) {
            vm.selectedJumpPage = args.value;
            var sorszam = vm.selectedJumpPage.split('-')[0];
            if (sorszam === '6 ') {
                return;
            }

            if (vm.editable) {
                grid.endEdit();
                dataservice.saveAnnualSeasonPlanHead(vm.head)
                    .then(function () {
                        dataservice.saveAnnualSeasonPlanTable(vm.data)
                            .then(function () {
                                log.successMsg('SaveCompleted');
                            });
                    });
            }
            $timeout(function () {
                paramHelper.setParams([{'AnnualSeasonPlanReport.Id': vm.annualSeasonPlanReportId}]);
                switch (sorszam) {
                    case '1 ':
                        $state.go('administration.annualSeasonPlan.annualSeasonPlanReportPage1');
                        break;
                    case '2 ':
                        $state.go('administration.annualSeasonPlan.annualSeasonPlanReportPage2');
                        break;
                    case '3 ':
                        $state.go('administration.annualSeasonPlan.annualSeasonPlanReportPage3');
                        break;
                    case '4 ':
                        $state.go('administration.annualSeasonPlan.annualSeasonPlanReportPage4');
                        break;
                    case '5 ':
                        $state.go('administration.annualSeasonPlan.annualSeasonPlanReportPage5');
                        break;
                    case '6 ':
                        $state.go('administration.annualSeasonPlan.annualSeasonPlanReportPage6');
                        break;
                }
            }, 100);
        }

        function goToPreviousPage() {
            grid.endEdit();
            dataservice.saveAnnualSeasonPlanHead(vm.head).then(function () {
                dataservice.saveAnnualSeasonPlanTable(vm.data).then(function () {
                    paramHelper.setParams([{
                        'AnnualSeasonPlanReport.Id': vm.annualSeasonPlanReportId
                    }]);
                    $state.go('administration.annualSeasonPlan.annualSeasonPlanReportPage5');
                });
            });
        }

        function gotoMainPage() {
            $state.go('administration.annualSeasonPlan.annualSeasonPlanReportPage1');
        }

        function savePlan() {
            grid.endEdit();
            dataservice.saveAnnualSeasonPlanHead(vm.head)
                .then(function () {
                    dataservice.saveAnnualSeasonPlanTable(vm.data)
                        .then(function () {
                            log.successMsg('SaveSuccessed');
                        });
                });
        }

        function getAccepterCoachById() {
            if (vm.head.SzakosztalyvezetoJovahagytaId === null) {
                return '';
            } else {
                return $q(function (resolve) {
                    dataservice.getUserData(vm.head.SzakosztalyvezetoJovahagytaId)
                        .then(function (args) {
                            resolve(args.retValue.name);
                        });
                });
            }
        }

        function print() {
            $q.all([getAccepterCoachById()])
                .then(function (results) {
                    vm.reportParameters = {
                        Szakosztaly: vm.head.SzakosztalyNeve,
                        Korcsoport: vm.head.KorosztalyNeve,
                        Edzo: vm.head.EdzoNeve,
                        Mobil: vm.head.EdzoMobil === undefined ? '' : vm.head.EdzoMobil,
                        Email: vm.head.EdzoEmail === undefined ? '' : vm.head.EdzoEmail,
                        FejId: vm.head.Id,
                        Jovahagyta: results[0],
                        Keszitette: vm.head.EdzoNeve,
                        techKepzes: ''
                    };
                    if (printOpened) {
                        angular.element('#printDialog').ejDialog('open');
                    } else {
                        printOpened = true;
                        angular.element('#printDialog').ejDialog({
                            height: '99%',
                            width: '99%',
                            enablemodal: 'true',
                            'position-x': '0',
                            'position-y': '0',
                            target: '#mainContent',
                            enableresize: 'false'
                        });
                    }
                });
        }

        function refreshCompetition() {
            dataservice.annualSeasonPlanCompetitionPlansAndObjectivesSelect(vm.annualSeasonPlanReportId)
                .then(function (args) {
                    var dt = new Date(vm.head.ErvenyessegTol);
                    var di = new Date(dt);
                    di.setDate(dt.getDate() + 7);
                    grid.endEdit();
                    for (var j = 0; j < grid.getRows().length; j++) {
                        for (var i = 0; i < args.itemsList.length; i++) {
                            var esDate = new Date((args.itemsList[i].EsemenyIdopont2).replace('. ', '-').replace('. ', '-').replace('.', ''));
                            if (esDate >= dt && esDate < di) {
                                var row = grid.getRowByIndex(j);
                                vm.data[j]['Verseny'] += '; ' + args.itemsList[i].EsemenyNeve;
                            }
                        }
                        dt = new Date(di);
                        di.setDate(dt.getDate() + 7);
                    }
                    grid.dataSource = vm.data;
                    // grid.refresh();
                });
        }

        function closePlan() {
            vm.head.EdzoLezarta = true;
            vm.head.EdzoLezartaDatum = new Date().toDateString();
            dataservice.saveAnnualSeasonPlanHead(vm.head)
                .then(function () {
                    if (!vm.hasErrorAtSave) {
                        vm.editable = false;
                    }
                });
        }

        function rejectPlan() {
            var dialogObj = angular.element('#rejectAttendanceWindow').data('ejDialog');
            dialogObj.open();
        }

        //Felugró ablak 'Mégsem' gomb click
        function closerejectingWindow() {
            var dialogObj = angular.element('#rejectAttendanceWindow').data('ejDialog');
            dialogObj.close();
        }

        //Felugró ablak 'Rendben' gomb click - visszautasítás elmentése
        function rejectAttendance() {
            if (vm.rejectAttendanceText.length > 0) {
                var dialogObj = angular.element('#rejectAttendanceWindow').data('ejDialog');
                dialogObj.close();
            } else {
                return;
            }
            var uzi = gettextCatalog.getString('SystemMessage') + '\r\n' + gettextCatalog.getString('The') + ' ' + vm.head.SzakosztalyNeve + ' - ' +
                vm.head.KorosztalyNeve + ' ' + new Date(vm.head.ErvenyessegTol).getFullYear() + '/' + new Date(vm.head.ErvenyessegIg).getFullYear() +
                ' ' + gettextCatalog.getString('AnnualSeasonPlanReportRejected') + '\r\n' + gettextCatalog.getString('Cause') + vm.rejectAttendanceText;
            vm.head.EdzoLezarta = false;
            vm.head.EdzoAlairtaDatum = undefined;
            vm.head.SzakosztalyVezetoJovahagyva = undefined;
            vm.head.SzakosztalyVezetoJovahagytaId = undefined;
            vm.head.SzakosztalyVezetoJovahagyta = false;
            dataservice.saveAnnualSeasonPlanHead(vm.head)
                .then(function () {
                    if (!vm.hasErrorAtSave) {
                        dataservice.messageSave(uzi, [vm.head.IdEdzo], vm.head.IdSzakosztaly).then(function () {
                            vm.editable = true;
                        });
                    }
                });
        }

        function acceptPlan() {
            var uzi = gettextCatalog.getString('SystemMessage') + '\r\n' + gettextCatalog.getString('The') + ' ' + vm.head.SzakosztalyNeve + ' - ' +
                vm.head.KorosztalyNeve + ' ' + new Date(vm.head.ErvenyessegTol).getFullYear() + '/' + new Date(vm.head.ErvenyessegIg).getFullYear() +
                ' ' + gettextCatalog.getString('AnnualSeasonPlanReportAccepted');
            dataservice.messageSave(uzi, [vm.head.IdEdzo], vm.head.IdSzakosztaly).then(function () {
                vm.head.SzakosztalyvezetoJovahagyta = true;
                vm.head.SzakosztalyvezetoJovahagyva = new Date();
                vm.head.SzakosztalyvezetoJovahagytaId = authenticationService.getAuthData().id;
                dataservice.saveAnnualSeasonPlanHead(vm.head)
                    .then(function () {
                        log.successMsg('AnnualSeasonPlanAccepted');
                    });
            });
        }

        function cellsave(args) {
            if (args.columnName === 'HetiEdzesSzamSpSpec') {
                var alt = args.rowData.HetiEdzesSzamAlt;
                if (alt === undefined || alt == null || (alt.trim && alt.trim() === '')) {
                    alt = 0;
                }
                var sp = args.value;
                if (sp === undefined || sp == null || (sp.trim && sp.trim() === '')) {
                    sp = 0;
                }
                alt = checkNumberInterval(alt, 0, 21);
                sp = checkNumberInterval(sp, 0, 21);
                vm.data[args.rowData.HetSzam - 1]['HetiEdzesSzamAlt'] = parseInt(alt);
                vm.data[args.rowData.HetSzam - 1]['HetiEdzesSzamSpSpec'] = parseInt(sp);
                vm.data[args.rowData.HetSzam - 1]['HetiEdzesSzamOsszesen'] = (parseInt(alt) + parseInt(sp));
                grid.refresh();
            } else if (args.columnName === 'HetiEdzesSzamAlt') {
                var sp = args.rowData.HetiEdzesSzamSpSpec;
                if (sp === undefined || sp == null || (sp.trim && sp.trim() === '')) {
                    sp = 0;
                }
                var alt = args.value;
                if (alt === undefined || alt == null || (alt.trim && alt.trim() === '')) {
                    alt = 0;
                }
                alt = checkNumberInterval(alt, 0, 21);
                sp = checkNumberInterval(sp, 0, 21);
                vm.data[args.rowData.HetSzam - 1]['HetiEdzesSzamAlt'] = parseInt(alt);
                vm.data[args.rowData.HetSzam - 1]['HetiEdzesSzamSpSpec'] = parseInt(sp);
                vm.data[args.rowData.HetSzam - 1]['HetiEdzesSzamOsszesen'] = (parseInt(alt) + parseInt(sp));
                grid.refresh();
            } else {
                vm.data[args.rowData.HetSzam - 1][args.columnName] = args.value;
                // grid.refresh();
            }
        }

        function checkNumberInterval(number, min, max) {
            if (number > max) {
                return max;
            }
            if (number < min) {
                return min;
            }
            return number;
        }

        function cellEdit(args) {
            if (args.columnName === 'HetiEdzesSzamOsszesen') {
                args.cancel = true;
                return;
            }
            if (args.columnName === 'FelkHetSzam') {
                var ssz = 1;
                for (var j = args.rowData.HetSzam; j <= 52; j++) {
                    vm.data[j - 1]['FelkHetSzam'] = ssz++;
                }
                ssz = 52;
                for (var j = args.rowData.HetSzam - 1; j > 0; j--) {
                    vm.data[j - 1]['FelkHetSzam'] = ssz--;
                }
                grid.endEdit();
                args.cancel = true;
            } else if (args.columnName === 'FelkIdJellTiszta') {
                if (args.rowData['FelkIdJellTiszta'] === 'x' || args.rowData['FelkIdJellTiszta'] === 'X') {
                    vm.data[args.rowData['HetSzam'] - 1]['FelkIdJellTiszta'] = '';
                } else {
                    vm.data[args.rowData['HetSzam'] - 1]['FelkIdJellTiszta'] = 'X';
                }
                vm.data[args.rowData['HetSzam'] - 1]['FelkIdJellVegyes'] = '';
                vm.data[args.rowData['HetSzam'] - 1]['FelkIdJellVerseny'] = '';
                grid.endEdit();
                args.cancel = true;
            } else if (args.columnName === 'FelkIdJellVegyes') {
                if (args.rowData['FelkIdJellVegyes'] === 'x' || args.rowData['FelkIdJellVegyes'] === 'X') {
                    vm.data[args.rowData['HetSzam'] - 1]['FelkIdJellVegyes'] = '';
                } else {
                    vm.data[args.rowData['HetSzam'] - 1]['FelkIdJellVegyes'] = 'X';
                }
                vm.data[args.rowData['HetSzam'] - 1]['FelkIdJellTiszta'] = '';
                vm.data[args.rowData['HetSzam'] - 1]['FelkIdJellVerseny'] = '';
                grid.endEdit();
                args.cancel = true;
            } else if (args.columnName === 'FelkIdJellVerseny') {
                if (args.rowData['FelkIdJellVerseny'] === 'x' || args.rowData['FelkIdJellVerseny'] === 'X') {
                    vm.data[args.rowData['HetSzam'] - 1]['FelkIdJellVerseny'] = '';
                } else {
                    vm.data[args.rowData['HetSzam'] - 1]['FelkIdJellVerseny'] = 'X';
                }
                vm.data[args.rowData['HetSzam'] - 1]['FelkIdJellTiszta'] = '';
                vm.data[args.rowData['HetSzam'] - 1]['FelkIdJellVegyes'] = '';
                grid.endEdit();
                args.cancel = true;
            }
            /*else if (args.columnName === 'HetiTerhelesMagas') {
                           if (args.rowData['HetiTerhelesMagas'] === 'X') {
                               grid.setCellValue(args.rowData['HetSzam'] - 1, 'HetiTerhelesMagas', '');
                           } else {
                               grid.setCellValue(args.rowData['HetSzam'] - 1, 'HetiTerhelesMagas', 'X');
                           }
                       } else if (args.columnName === 'HetiTerhelesKozepes') {
                           if (args.rowData['HetiTerhelesKozepes'] === 'X') {
                               grid.setCellValue(args.rowData['HetSzam'] - 1, 'HetiTerhelesKozepes', '');
                           } else {
                               grid.setCellValue(args.rowData['HetSzam'] - 1, 'HetiTerhelesKozepes', 'X');
                           }
                       } else if (args.columnName === 'HetiTerhelesAlacsony') {
                           if (args.rowData['HetiTerhelesAlacsony'] === 'X') {
                               grid.setCellValue(args.rowData['HetSzam'] - 1, 'HetiTerhelesAlacsony', '');
                           } else {
                               grid.setCellValue(args.rowData['HetSzam'] - 1, 'HetiTerhelesAlacsony', 'X');
                           }
                       } else if (args.columnName === 'HetiEdzMunkaTechnikai') {
                           if (args.rowData['HetiEdzMunkaTechnikai'] === 'X') {
                               grid.setCellValue(args.rowData['HetSzam'] - 1, 'HetiEdzMunkaTechnikai', '');
                           } else {
                               grid.setCellValue(args.rowData['HetSzam'] - 1, 'HetiEdzMunkaTechnikai', 'X');
                           }
                       } else if (args.columnName === 'HetiEdzMunkaKepFejl') {
                           if (args.rowData['HetiEdzMunkaKepFejl'] === 'X') {
                               grid.setCellValue(args.rowData['HetSzam'] - 1, 'HetiEdzMunkaKepFejl', '');
                           } else {
                               grid.setCellValue(args.rowData['HetSzam'] - 1, 'HetiEdzMunkaKepFejl', 'X');
                           }
                       } else if (args.columnName === 'HetiEdzMunkaKieg') {
                           if (args.rowData['HetiEdzMunkaKieg'] === 'X') {
                               grid.setCellValue(args.rowData['HetSzam'] - 1, 'HetiEdzMunkaKieg', '');
                           } else {
                               grid.setCellValue(args.rowData['HetSzam'] - 1, 'HetiEdzMunkaKieg', 'X');
                           }
                       } else if (args.columnName === 'HetiEdzMunkaEgyeb') {
                           if (args.rowData['HetiEdzMunkaEgyeb'] === 'X') {
                               grid.setCellValue(args.rowData['HetSzam'] - 1, 'HetiEdzMunkaEgyeb', '');
                           } else {
                               grid.setCellValue(args.rowData['HetSzam'] - 1, 'HetiEdzMunkaEgyeb', 'X');
                           }
                       }*/
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular .module('app.administration.annualSeasonPlan.annualSeasonPlanReportPage6')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'administration.annualSeasonPlan.annualSeasonPlanReportPage6',
                config: {
                    url: '/annualSeasonPlanReportPage6',
                    templateUrl: 'app/administration/annualSeasonPlan/annualSeasonPlanReportPage6/annualSeasonPlanReportPage6.html',
                    controller: 'AnnualSeasonPlanReportPage6Controller',
                    controllerAs: 'vm',
                    title: 'AnnualSeasonPlan'
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    AssetManagementController.$inject = ["$q", "paramHelper", "gettextCatalog", "$state", "dataservice", "authenticationService", "$rootScope", "$scope", "log", "$timeout", "$filter"];
    angular
        .module('app.administration.assetManagement')
        .controller('AssetManagementController', AssetManagementController);

    function AssetManagementController($q, paramHelper, gettextCatalog, $state, dataservice, authenticationService, $rootScope, $scope, log, $timeout, $filter) {
        $rootScope.title = gettextCatalog.getString('AssetManagement');
        var vm = this;
        $rootScope.vm = vm;
        vm.userid = authenticationService.getAuthData().id;
        vm.groupList = [];
        vm.groupId = undefined;
        vm.dropdownDataBound = dropdownDataBound;
        vm.groupSelect = groupSelect;
        vm.athleteSelect = athleteSelect;
        vm.coachSelect = coachSelect;
        vm.Issue = Issue;
        vm.choosen = -1;

        vm.filter = 'issuable';
        vm.types = [];
        vm.assets = [];
        vm.athletes = [];
        vm.coaches = [];
        vm.selectedAssets = [];
        vm.athletecoachList = [
            {value: 'athlete', text: gettextCatalog.getString('Athlete')},
            {value: 'coach', text: gettextCatalog.getString('User')}
        ];
        vm.assetFilterList = [
            {value: 'issuable', text: gettextCatalog.getString('IssuableOnly')},
            {value: 'issued', text: gettextCatalog.getString('IssuedOnly')},
            {value: 'all', text: gettextCatalog.getString('All')},
            {value: 'active', text: gettextCatalog.getString('ActiveOnly')},
            {value: 'deleted', text: gettextCatalog.getString('DeletedOnly')}
        ];
        vm.assetTypeColumns = [
            {type: 'checkbox', textAlign: 'center', width: 45},
            {field: 'TipusId', visible: false, isPrimaryKey: true},
            {field: 'TipusNev', headerText: gettextCatalog.getString('AssetType'), textAlign: 'left'},
            {field: 'aktivDarab', headerText: gettextCatalog.getString('ActiveItem'), textAlign: 'left'},
            {field: 'inaktivDarab', headerText: gettextCatalog.getString('InactiveItem'), textAlign: 'left'},
            {field: 'szabadDarab', headerText: gettextCatalog.getString('Issuable'), textAlign: 'left'}
        ];

        vm.assetColumns = [
            {type: 'checkbox', textAlign: 'center', width: 45},
            {field: 'EszkozId', visible: false, isPrimaryKey: true},
            {field: 'Megnevezes', headerText: gettextCatalog.getString('Megnevezes'), textAlign: 'left'},
            {field: 'Leiras', headerText: gettextCatalog.getString('Leiras'), textAlign: 'left'},
            {field: 'Azonosito', headerText: gettextCatalog.getString('Azonosito'), textAlign: 'left'},
            {field: 'Meret', headerText: gettextCatalog.getString('Meret'), textAlign: 'left'},
            {field: 'Ar', headerText: gettextCatalog.getString('Ar'), textAlign: 'left'},
            {field: 'Szabad', headerText: gettextCatalog.getString('Issuable'), textAlign: 'left', displayAsCheckBox: true},
            {field: 'deleted', headerText: gettextCatalog.getString('Deleted'), textAlign: 'left', displayAsCheckBox: true},
            {field: 'NalaVan', headerText: gettextCatalog.getString('WhoHasIt'), textAlign: 'left'}
        ];

        vm.athleteColumns = [
            {field: 'SportoloId', visible: false, isPrimaryKey: true},
            {field: 'SportoloNev', headerText: gettextCatalog.getString('AthleteName'), textAlign: 'left'},
            {field: 'Section', headerText: gettextCatalog.getString('Section'), textAlign: 'left'},
            {field: 'AgeGroup', headerText: gettextCatalog.getString('AgeGroup'), textAlign: 'left'}
        ];

        vm.coachColumns = [
            {field: 'EdzoId', visible: false, isPrimaryKey: true},
            {field: 'EdzoNev', headerText: gettextCatalog.getString('CoachName'), textAlign: 'left'},
            {field: 'Section', headerText: gettextCatalog.getString('Section'), textAlign: 'left'},
            {field: 'AgeGroup', headerText: gettextCatalog.getString('AgeGroup'), textAlign: 'left'}
        ];

        vm.AddAssetType = AddAssetType;
        vm.EditAssetType = EditAssetType;
        vm.DeleteAssetType = DeleteAssetType;

        vm.AddAsset = AddAsset;
        vm.EditAsset = EditAsset;
        vm.DeleteAsset = DeleteAsset;
        vm.UndeleteAsset = UndeleteAsset;

        vm.filterSelect = filterSelect;

        vm.SelectAll = SelectAll;
        vm.clearSelection = clearSelection;

        vm.IssuePopup = IssuePopup;
        vm.TakeBack = TakeBack;
        vm.issueToSelect = issueToSelect;

        vm.ESZKNYILVMEGT = false;
        vm.ESZKNYILVMOD = false;
        vm.ESZKMOZG = false;
        vm.AddAssetTypeEnabled = false;
        vm.EditAssetTypeEnabled = false;
        vm.DeleteAssetTypeEnabled = false;
        vm.AddAssetEnabled = false;
        vm.EditAssetEnabled = false;
        vm.DeleteAssetEnabled = false;
        vm.UndeleteAssetEnabled = false;
        vm.IssueEnabled = false;
        vm.TakeBackEnabled = false;
        vm.issueToAthlete = false;
        vm.issueToCoach = false;
        vm.chooseEnabled = false;

        var TypeGrid2 = null;
        var AssetGrid2 = null;
        var AthleteGrid2 = null;
        var CoachGrid2 = null;

        CreateTypeGrid();
        CreateAssetGrid();
        CreateAthleteGrid();
        CreateCoachGrid();

        activate();

        function activate() {
            $q.all([authenticationService.getRight('ESZKNYILVMEGT'), authenticationService.getRight('ESZKNYILVMOD'), authenticationService.getRight('ESZKMOZG')]).then(function (data) {
                $timeout(function () {
                    vm.ESZKNYILVMEGT = data[0];
                    vm.ESZKNYILVMOD = data[1];
                    vm.ESZKMOZG = data[2];
                    if (vm.ESZKNYILVMEGT) {
                        GridRefresh();
                        if (vm.ESZKNYILVMOD) {
                            vm.AddAssetTypeEnabled = true;
                        }
                    } else {
                        log.permissionError(true);
                    }
                }, 100);
            });
        }

        function CreateAthleteGrid() {
            AthleteGrid2 = new ej2.grids.Grid({
                dataSource: vm.athletes,
                columns: vm.athleteColumns,
                allowPaging: false,
                allowSorting: false,
                allowTextWrap: false,
                allowExcelExport: false,
                editSettings: {
                    allowEditing: false, allowAdding: false, allowDeleting: false
                },
                locale: 'hu-HU',
                gridLines: 'Both',
                selectionSettings: {type: 'single', mode: 'Row'},
                rowSelected: function (args) {
                    athleteSelect(args);
                }
            });
            AthleteGrid2.appendTo('#AthleteGrid2');
        }

        function CreateCoachGrid() {
            CoachGrid2 = new ej2.grids.Grid({
                dataSource: vm.coaches,
                columns: vm.coachColumns,
                allowPaging: false,
                allowSorting: false,
                allowTextWrap: false,
                allowExcelExport: false,
                editSettings: {
                    allowEditing: false, allowAdding: false, allowDeleting: false
                },
                locale: 'hu-HU',
                gridLines: 'Both',
                selectionSettings: {type: 'single', mode: 'Row'},
                rowSelected: function (args) {
                    coachSelect(args);
                }
            });
            CoachGrid2.appendTo('#CoachGrid2');
        }

        function CreateTypeGrid() {
            TypeGrid2 = new ej2.grids.Grid({
                dataSource: vm.types,
                columns: vm.assetTypeColumns,
                allowPaging: false,
                allowSorting: false,
                allowTextWrap: false,
                allowExcelExport: false,
                editSettings: {
                    allowEditing: false, allowAdding: false, allowDeleting: false
                },
                locale: 'hu-HU',
                gridLines: 'Both',
                selectionSettings: {type: 'Single', mode: 'Row'},
                rowSelected: function (args) {
                    assetTypeSelect(args);
                },
                rowSelecting: function () {
                    TypeGrid2.clearSelection();
                },
                checkBoxChange: function (args) {
                    $rootScope.checkBoxChangeOnlyOne(args, TypeGrid2);
                }
            });
            TypeGrid2.appendTo('#TypeGrid2');
        }

        function CreateAssetGrid() {
            AssetGrid2 = new ej2.grids.Grid({
                dataSource: vm.assets,
                columns: vm.assetColumns,
                allowPaging: false,
                allowSorting: true,
                allowTextWrap: false,
                allowExcelExport: false,
                editSettings: {
                    allowEditing: false, allowAdding: false, allowDeleting: false
                },
                locale: 'hu-HU',
                gridLines: 'Both',
                selectionSettings: {type: 'Multiple', mode: 'Row'},
                rowSelected: function () {
                    assetSelectOrDeselect();
                },
                rowDeselected: function () {
                    assetSelectOrDeselect();
                }
            });
            AssetGrid2.appendTo('#AssetGrid2');
        }

        // ESZKÖZ TÍPUSOK
        function AddAssetType() {
            swal({
                title: gettextCatalog.getString('CreateAssetType'),
                type: 'info',
                input: 'text',
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: gettextCatalog.getString('Ok'),
                cancelButtonText: gettextCatalog.getString('Cancel'),
            }).then(function (inputValue) {
                if (!inputValue || inputValue.value.length < 1 || inputValue.dismiss === 'cancel' || inputValue.dismiss === 'esc') {
                    log.errorMsg(gettextCatalog.getString('AssetTypeNameMustNotBeEmpty'));
                } else {
                    dataservice.AssetManager({TipusId: -1, TipusNev: inputValue.value}).then(function (response) {
                        log.successMsg(gettextCatalog.getString('saveSuccess'));
                        vm.editDeleteMainTypeEnabled = false;
                        GridRefresh(response.TipusId);
                    });
                }
            });
        }

        function EditAssetType() {
            swal({
                title: gettextCatalog.getString('EditAssetType'),
                type: 'info',
                input: 'text',
                inputValue: vm.editype.TipusNev,
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: gettextCatalog.getString('Ok'),
                cancelButtonText: gettextCatalog.getString('Cancel'),
            }).then(function (inputValue) {
                if (!inputValue || inputValue.value.length < 1 || inputValue.dismiss === 'cancel' || inputValue.dismiss === 'esc') {
                    log.errorMsg(gettextCatalog.getString('AssetTypeNameMustNotBeEmpty'));
                } else {
                    dataservice.AssetManager({TipusId: vm.editype.TipusId, TipusNev: inputValue.value}).then(function () {
                        log.successMsg(gettextCatalog.getString('saveSuccess'));
                        vm.editDeleteMainTypeEnabled = false;
                        GridRefresh(vm.editype.TipusId);
                    });
                }
            });
        }

        function DeleteAssetType() {
            var warningText = '';
            if (vm.assets.length > 0) {
                log.errorMsg(gettextCatalog.getString('Only empty asset types can be deleted.'));
                return;
            }
            swal({
                title: gettextCatalog.getString('Are you sure you want to delete the selected asset type?'),
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: gettextCatalog.getString('Yes, delete this asset type'),
                cancelButtonText: gettextCatalog.getString('Cancel'),
                closeOnConfirm: false,
                closeOnCancel: false
            }).then(function (isConfirm) {
                if (isConfirm.value) {
                    dataservice.AssetManager({TipusId: vm.editype.TipusId, TipusTorles: true}).then(function () {
                        vm.addNewSubType = false;
                        GridRefresh();
                    });
                }
            });
        }

        // ESZKÖZÖK
        function AddAsset() {
            var HTMLtext = createHtmlSwalContent([
                {id: 'Megnevezes', text: gettextCatalog.getString('Megnevezes'), value: ''},
                {id: 'Leiras', text: gettextCatalog.getString('Leiras'), value: ''},
                {id: 'Azonosito', text: gettextCatalog.getString('Azonosito'), value: ''},
                {id: 'Meret', text: gettextCatalog.getString('Meret'), value: ''},
                {id: 'Ar', text: gettextCatalog.getString('Ar'), value: ''},
                {id: 'darab', text: gettextCatalog.getString('NumberMassAdd'), value: ''}
            ]);
            swal({
                title: gettextCatalog.getString('CreateAsset'),
                html: HTMLtext,
                type: 'info',
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: gettextCatalog.getString('Ok'),
                cancelButtonText: gettextCatalog.getString('Cancel'),
            }).then(function (isConfirm) {
                if (isConfirm.value) {
                    vm.newAsset = {};
                    vm.newAsset.EszkozId = -1;
                    vm.newAsset.TipusId = vm.editype.TipusId;
                    vm.newAsset.Megnevezes = document.getElementById('Megnevezes').value;
                    vm.newAsset.Leiras = document.getElementById('Leiras').value;
                    vm.newAsset.Azonosito = document.getElementById('Azonosito').value;
                    vm.newAsset.Meret = document.getElementById('Meret').value;
                    vm.newAsset.Ar = document.getElementById('Ar').value;
                    vm.newAsset.darab = document.getElementById('darab').value;
                    if (vm.newAsset.Megnevezes && vm.newAsset.Megnevezes.length > 0) {
                        dataservice.AssetManager(vm.newAsset).then(function () {
                            log.successMsg(gettextCatalog.getString('saveSuccess'));
                            vm.editDeleteMainTypeEnabled = false;
                            GridRefresh(vm.editype.TipusId);
                        });
                    } else {
                        log.errorMsg(gettextCatalog.getString('AssetNameMustNotBeEmpty'));
                    }
                }
            });
        }

        function EditAsset() {
            if (getSelectedAssetIds().length != 1) {
                log.errorMsg(gettextCatalog.getString('MultipleAssetsCannotBeEditedAtOnce'));
                return;
            }
            console.log('EDIT ASSET vm.editAsset', vm.editAsset);
            var HTMLtext = createHtmlSwalContent([
                {id: 'Megnevezes', text: gettextCatalog.getString('Megnevezes'), value: vm.editAsset.Megnevezes},
                {id: 'Leiras', text: gettextCatalog.getString('Leiras'), value: vm.editAsset.Leiras},
                {id: 'Azonosito', text: gettextCatalog.getString('Azonosito'), value: vm.editAsset.Azonosito},
                {id: 'Meret', text: gettextCatalog.getString('Meret'), value: vm.editAsset.Meret},
                {
                    id: 'Ar',
                    text: gettextCatalog.getString('Ar'),
                    value: vm.editAsset.Ar ? vm.editAsset.Ar.toString() : ''
                },
                {id: 'AssetType', text: gettextCatalog.getString('AssetType'), value: '', dd: true}
            ]);
            swal({
                title: gettextCatalog.getString('EditAsset'),
                html: HTMLtext,
                type: 'info',
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: gettextCatalog.getString('Ok'),
                cancelButtonText: gettextCatalog.getString('Cancel'),
            }).then(function (isConfirm) {
                if (isConfirm.value) {
                    vm.editAsset.Megnevezes = document.getElementById('Megnevezes').value;
                    vm.editAsset.Leiras = document.getElementById('Leiras').value;
                    vm.editAsset.Azonosito = document.getElementById('Azonosito').value;
                    vm.editAsset.Meret = document.getElementById('Meret').value;
                    vm.editAsset.Ar = document.getElementById('Ar').value;
                    if (vm.editAsset.Megnevezes && vm.editAsset.Megnevezes.length > 0) {
                        dataservice.AssetManager(vm.editAsset).then(function () {
                            vm.EditAssetEnabled = false;
                            vm.DeleteAssetEnabled = false;
                            log.successMsg(gettextCatalog.getString('saveSuccess'));
                            vm.editDeleteMainTypeEnabled = false;
                            GridRefresh(vm.editAsset.TipusId);
                        });
                    } else {
                        log.errorMsg(gettextCatalog.getString('AssetNameMustNotBeEmpty'));
                    }
                }
            });
            angular.element('#DropDownSwal').ejDropDownList({
                dataSource: vm.types,
                select: function (arg) {
                    vm.editAsset.TipusId = arg.value;
                },
                value: vm.editAsset.TipusId,
                width: '100%'
            });
        }

        function DeleteAsset() {
            swal({
                title: gettextCatalog.getString('Are you sure you want to delete the selected asset?'),
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: gettextCatalog.getString('Yes, delete this asset'),
                cancelButtonText: gettextCatalog.getString('Cancel'),
                closeOnConfirm: false,
                closeOnCancel: false
            }).then(function (isConfirm) {
                if (isConfirm.value) {
                    dataservice.DeleteUndeleteAssets({
                        action: 'delete',
                        assetList: getSelectedAssetIds()
                    }).then(function () {
                        vm.EditAssetEnabled = false;
                        vm.DeleteAssetEnabled = false;
                        GridRefresh(vm.editype.TipusId);
                    });
                }
            });
        }

        function UndeleteAsset() {
            swal({
                title: gettextCatalog.getString('Are you sure you want to undelete the selected asset?'),
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: gettextCatalog.getString('Yes, undelete this asset'),
                cancelButtonText: gettextCatalog.getString('Cancel'),
                closeOnConfirm: false,
                closeOnCancel: false
            }).then(function (isConfirm) {
                if (isConfirm.value) {
                    dataservice.DeleteUndeleteAssets({
                        action: 'undelete',
                        assetList: getSelectedAssetIds()
                    }).then(function () {
                        vm.EditAssetEnabled = false;
                        vm.DeleteAssetEnabled = false;
                        GridRefresh(vm.editype.TipusId);
                    });
                }
            });
        }

        function GridRefresh(tipusId) {
            console.log('GridRefresh');
            clearSelection();
            vm.EditAssetTypeEnabled = false;
            vm.DeleteAssetTypeEnabled = false;
            AssetGrid2.dataSource = vm.assets;
            AssetGrid2.refresh();
            dataservice.assetTypeList().then(function (data) {
                vm.types = data.itemsList;
                vm.types.forEach(function (item) {
                    item.value = item.TipusId;
                    item.text = item.TipusNev;
                });
                TypeGrid2.dataSource = vm.types;
                var index = $filter('getIndex')(vm.types, 'TipusId', tipusId);
                if (index !== false && index !== null && index >= 0) {
                    $timeout(function () {
                        TypeGrid2.selectRows([index]);
                        $scope.$apply();
                    }, 10);
                }
            });
        }

        function assetTypeSelect(args) {
            log.infoMsg(gettextCatalog.getString('DetailsAreShownInTheGridBelow'));
            clearSelection();
            if (vm.ESZKNYILVMOD) {
                if (vm.filter != 'deleted') {
                    vm.AddAssetEnabled = true;
                    vm.EditAssetEnabled = false;
                    vm.DeleteAssetEnabled = false;
                    vm.UndeleteAssetEnabled = false;
                    vm.EditAssetTypeEnabled = true;
                    vm.DeleteAssetTypeEnabled = true;
                }
            }
            vm.editype = args.data;
            getAssetsByType(args.data.TipusId, vm.filter);
            $scope.$apply();
        }

        function assetSelectOrDeselect() {
            $timeout(function () {
                vm.selectedAssets = getSelectedAssets();
                console.log('vm.selectedAssets', vm.selectedAssets.length, vm.selectedAssets);
                vm.DeleteAssetEnabled = false;
                vm.UndeleteAssetEnabled = false;
                vm.EditAssetEnabled = false;
                vm.IssueEnabled = false;
                vm.TakeBackEnabled = false;
                if (vm.selectedAssets.length == 1) {
                    vm.editAsset = vm.selectedAssets[0];
                    if (vm.ESZKNYILVMOD) {
                        if (vm.filter != 'deleted') {
                            vm.AddAssetEnabled = true;
                        }
                        if (vm.editAsset.Aktiv && vm.editAsset.Szabad) {
                            console.log('vm.ESZKNYILVMOD', vm.ESZKNYILVMOD);
                            vm.EditAssetEnabled = true;
                            vm.DeleteAssetEnabled = true;
                        }
                        vm.UndeleteAssetEnabled = !vm.editAsset.Aktiv;
                    }
                    if (vm.ESZKMOZG) {
                        vm.IssueEnabled = allIssuable();
                        vm.TakeBackEnabled = allIssued();
                    }
                } else if (vm.selectedAssets.length > 1) {
                    vm.editAsset = null;
                    vm.DeleteAssetEnabled = allIssuable();
                    vm.UndeleteAssetEnabled = allDeleted();
                    console.log('EZUISlefut');
                    vm.EditAssetEnabled = false;
                    if (vm.ESZKMOZG) {
                        vm.IssueEnabled = allIssuable();
                        vm.TakeBackEnabled = allIssued();
                    }
                }
            }, 100);
        }

        // MINDEGYIK TÖRÖLT
        function allDeleted() {
            var ret = true;
            vm.selectedAssets.forEach(function (asset) {
                if (asset.Aktiv == true) {
                    ret = false;
                }
            });
            return ret;
        }

        // MINDEGYIK SZABAD
        function allIssuable() {
            var ret = true;
            vm.selectedAssets.forEach(function (asset) {
                if (asset.Szabad == false || asset.Aktiv == false) { // Ha valamelyik ki van adva, vagy törölt akkor return false
                    ret = false;
                }
            });
            return ret;
        }

        // MINDEGYIK KI VAN ADVA
        function allIssued() {
            var ret = true;
            vm.selectedAssets.forEach(function (asset) {
                if (asset.Szabad == true || asset.Aktiv == false) { // Ha valamelyik Nincs kiadva, vagy törölt akkor return false
                    ret = false;
                }
            });
            return ret;
        }

        function getAssetsByType(TipusId) {
            clearSelection();
            dataservice.AssetsByType(TipusId, vm.filter).then(function (data) {
                vm.assets = data.data;
                AssetGrid2.dataSource = vm.assets;
            });
        }

        function filterSelect(arg) {
            console.log('filterSelect', arg);
            clearSelection();
            vm.filter = arg.value;
            vm.AddAssetEnabled = (vm.filter != 'deleted');
            vm.EditAssetEnabled = false;
            vm.DeleteAssetEnabled = false;
            vm.UndeleteAssetEnabled = false;
            if (vm.editype && vm.editype.TipusId > 0) {
                getAssetsByType(vm.editype.TipusId);
            }
        }

        function createHtmlSwalContent(arr) {
            var HTMLtext = '<div style="margin-top: 10px;" >';
            arr.forEach(function (item) {
                HTMLtext += '<div class="row">';
                if (item.hasOwnProperty('dd')) {
                    HTMLtext += '<label class="col-lg-6" style="text-align: left; margin-top:5px;">' + item.text + '</label>';
                    HTMLtext += '<input class="col-lg-6 col-lg-offset-6" id="DropDownSwal" ej-dropdownlist></input><br>';
                } else {
                    HTMLtext += '<label class="col-lg-6" style="text-align: left; margin-top:5px;">' + item.text + '</label>';
                    if (item.value && item.value.length > 0) {
                        HTMLtext += '<input type="text" value="' + item.value + '" id="' + item.id + '"></input><br>';
                    } else {
                        HTMLtext += '<input type="text" value="" id="' + item.id + '"></input><br>';
                    }
                }
                HTMLtext += '</div>';
            });
            HTMLtext += '</div><br>';
            return HTMLtext;
        }

        function getSelectedAssets() {
            vm.selectedAssets = AssetGrid2.getSelectedRecords();
            return vm.selectedAssets;
        }

        function getSelectedAssetIds() {
            var selectedAssets = getSelectedAssets();
            var assetIds = [];
            selectedAssets.forEach(function (asset) {
                assetIds.push(asset.EszkozId);
            });
            return assetIds;
        }

        function clearSelection() {
            vm.IssueEnabled = false;
            vm.TakeBackEnabled = false;
            AssetGrid2.clearSelection();
        }

        function SelectAll() {
            var indexes = [];
            for (var i = 0; i < vm.assets.length; i++) {
                indexes.push(i);
            }
            AssetGrid2.selectRows(indexes);
        }

        function IssuePopup() {
            angular.element('#issueDialog').data('ejDialog').open();
        }

        function TakeBack() {
            angular.element('#issueDialog').data('ejDialog').close();
            swal({
                title: gettextCatalog.getString('TakeBackAssetComment'),
                type: 'info',
                input: 'text',
                showCancelButton: false,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: gettextCatalog.getString('Ok')
            }).then(function (inputValue) {
                if (!inputValue || !inputValue.value || inputValue.dismiss === 'cancel' || inputValue.dismiss === 'esc') {
                    return;
                }
                dataservice.AssetTakeBack(getSelectedAssetIds(), inputValue.value).then(function () {
                    log.successMsg('TakenBackSuccessfully');
                    getAssetsByType(vm.editype.TipusId);
                });
            });
        }

        function issueToSelect(arg) {
            vm.chooseEnabled = false;
            switch (arg.value) {
                case 'athlete':
                    getSections(vm.userid);
                    vm.issueToAthlete = true;
                    vm.issueToCoach = false;
                    vm.dropdownlabel = gettextCatalog.getString('Section');
                    break;
                case 'coach':
                    getUserGroups();
                    vm.issueToAthlete = false;
                    vm.issueToCoach = true;
                    vm.dropdownlabel = gettextCatalog.getString('UserGroup');
                    break;
            }
        }

        function getSections(userid) {
            dataservice.sectionDropDownList(userid).then(function (data) {
                vm.groupList = data.itemsList;
            });
        }

        function getUserGroups() {
            dataservice.userGroupList().then(function (data) {
                vm.groupList = data.itemsList;
            });
        }

        function dropdownDataBound() {
            if (vm.groupList.length > 0) {
                vm.groupId = vm.groupList[0].value;
            }
        }

        function groupSelect(arg) {
            vm.chooseEnabled = false;
            vm.groupId = arg.value;
            if (vm.issueToAthlete) {
                AthletesInSection(arg.value);
            } else if (vm.issueToCoach) {
                UsersInGroup(arg.value);
            }
        }

        function athleteSelect(arg) {
            $timeout(function () {
                vm.chooseEnabled = true;
                vm.choosen = arg.data.SportoloId;
            }, 100);
        }

        function coachSelect(arg) {
            $timeout(function () {
                vm.chooseEnabled = true;
                vm.choosen = arg.data.EdzoId;
            }, 100);
        }

        function Issue() {
            angular.element('#issueDialog').data('ejDialog').close();
            swal({
                title: gettextCatalog.getString('IssueAssetComment'),
                type: 'info',
                input: 'text',
                showCancelButton: false,
                allowOutsideClick: false,
                allowEscapeKey: false,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: gettextCatalog.getString('Ok')
            }).then(function (inputValue) {
                if (!inputValue || inputValue.dismiss === 'cancel' || inputValue.dismiss === 'esc') {
                    return;
                }
                var edzo = 0;
                var sportolo = 0;
                if (vm.issueToAthlete) {
                    sportolo = vm.choosen;
                } else if (vm.issueToCoach) {
                    edzo = vm.choosen;
                }
                dataservice.AssetIssue(getSelectedAssetIds(), edzo, sportolo, inputValue.value).then(function () {
                    log.successMsg('IssuedSuccessfully');
                    getAssetsByType(vm.editype.TipusId);
                });
            });
        }

        function AthletesInSection(section) {
            dataservice.AthletesInSection(section).then(function (data) {
                vm.athletes = data.itemsList;
                AthleteGrid2.dataSource = vm.athletes;
            });
        }

        function UsersInGroup(usergroup) {
            dataservice.UsersInGroup(usergroup).then(function (data) {
                vm.coaches = data.itemsList;
                CoachGrid2.dataSource = vm.coaches;
            });
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.administration.assetManagement')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'administration.assetManagement',
                config: {
                    url: '/assetManagement',
                    templateUrl: 'app/administration/assetManagement/assetManagement.html',
                    controller: 'AssetManagementController',
                    controllerAs: 'vm',
                    title: 'AssetManagement',
                    settings: {
                        navId: 2132,
                        level: 2,
                        order: 13,
                        orderTitle_hu: 'Eszköznyilvántartó',
                        orderTitle_en: 'AssetManagement',
                        parentId: 2,
                        content: 'AssetManagement',
                        activatorPermission: '"ESZKNYILVMEGT"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.administration.awayBudgetPlan')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'administration.awayBudgetPlan',
                config: {
                    url: '/awayBudgetPlan',
                    templateUrl: 'app/administration/awayBudgetPlan/awayBudgetPlan.html'
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    AwayBudgetPlanCreateController.$inject = ["log", "paramHelper", "dataservice", "$q", "$rootScope", "gettextCatalog", "authenticationService", "$scope", "$timeout", "$filter", "$state"];
    angular
        .module('app.administration.awayBudgetPlan.awayBudgetPlanCreate')
        .controller('AwayBudgetPlanCreateController', AwayBudgetPlanCreateController);

    function AwayBudgetPlanCreateController(log, paramHelper, dataservice, $q, $rootScope, gettextCatalog, authenticationService, $scope, $timeout, $filter, $state) {
        $rootScope.title = gettextCatalog.getString('AwayBudgetPlanCreate');
        var vm = this;
        $rootScope.vm = vm;
        vm.tervId = -1;
        vm.tenyId = -1;
        vm.printOpened = false;
        vm.title = '';
        vm.subtitle = '';
        vm.data = {};
        vm.data.Id = 0;
        vm.currentUserId = authenticationService.getAuthData().id;
        vm.saveIsBusy = false;
        vm.forceDisableEdit = false; // Ha ez true, akkor nem lehet módosítani sehogy (olyan terv, amihez van tény)
        disableEverything();
        vm.SZAKOSZTVEZ = false;
        vm.GAZDASAGI = false;
        vm.TECHIGAZGATO = false;

        vm.sectionList = [];
        vm.ageGroupList = [];
        vm.coachList = [];
        vm.allusers = [];

        vm.athleteList = [];
        vm.otherPersonName = '';
        vm.otherPersonYear = '';
        vm.sorszam = 1;
        vm.szint = 0;
        // Plans Grid
        vm.reportParameters = [];
        vm.busOwners = [];
        vm.busLists = [];
        vm.columns = [
            {type: 'checkbox', textAlign: 'center', width: 35},
            {
                field: 'Sorszam',
                headerText: gettextCatalog.getString('PlanNumber'),
                isPrimaryKey: true,
                isIdentity: true,
                width: 90,
                allowEditing: false
            },
            {
                field: 'Nev',
                headerText: gettextCatalog.getString('Name'),
                width: 120,
                allowEditing: false
            },
            {
                field: 'SzuletesiEv',
                headerText: gettextCatalog.getString('BirthYear'),
                width: 120,
                allowEditing: false
            },
            {
                field: 'UtazasiKoltseg',
                headerText: gettextCatalog.getString('TravelCost'),
                width: 120,
                editType: 'numericedit',
                edit: {params: {decimals: 2, showSpinButton: false}},
                format: 'N2',
            },
            {
                field: 'Etkezes',
                headerText: gettextCatalog.getString('Meal'),
                width: 120,
                editType: 'numericedit',
                edit: {params: {decimals: 2, showSpinButton: false}},
                format: 'N2',
            },
            {
                field: 'Szallas',
                headerText: gettextCatalog.getString('Accommodation'),
                width: 120,
                editType: 'numericedit',
                edit: {params: {decimals: 2, showSpinButton: false}},
                format: 'N2',
            },
            {
                field: 'NevezesiDij',
                headerText: gettextCatalog.getString('RegistrationFee'),
                width: 120,
                editType: 'numericedit',
                edit: {params: {decimals: 2, showSpinButton: false}},
                format: 'N2',
            },
            {
                field: 'KikuldetesiKoltseg',
                headerText: gettextCatalog.getString('SecondmentCost'),
                width: 120,
                editType: 'numericedit',
                edit: {params: {decimals: 2, showSpinButton: false}},
                format: 'N2',
            },
            {
                field: 'Egyeb',
                headerText: gettextCatalog.getString('Other'),
                width: 120,
                editType: 'numericedit',
                edit: {params: {decimals: 2, showSpinButton: false}},
                format: 'N2',
            }
        ];

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItems,
            allowExcelExport: true,
            allowTextWrap: true,
            editSettings: {
                allowEditing: vm.allowEdit,
                allowDeleting: vm.allowEdit,
                allowSelection: vm.allowEdit,
                mode: 'Batch',
                showConfirmDialog: false
            },
            selectionSettings: {type: 'multiple', mode: 'Row'},
            locale: 'hu-HU',
            gridLines: 'Both',
            columns: vm.columns,
            cellSave: cellsave,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#Grid'), $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        // Public functions
        vm.sectionDataBound = sectionDataBound;
        vm.sectionSelect = sectionSelect;
        vm.ageGroupDataBound = ageGroupDataBound;
        vm.coachDataBound = coachDataBound;
        vm.ageGroupSelect = ageGroupSelect;
        vm.athleteSelect = athleteSelect;
        vm.coachSelect = coachSelect;
        vm.edzoSelect = edzoSelect;

        vm.addAthlete = addAthlete;
        vm.addAllAthlete = addAllAthlete;
        vm.addUser = addUser;
        vm.addOtherPersonName = addOtherPersonName;

        vm.travelCostDivide = travelCostDivide;
        vm.mealDivide = mealDivide;
        vm.accommodationDivide = accommodationDivide;
        vm.registrationFeeDivide = registrationFeeDivide;
        vm.secondmentCostDivide = secondmentCostDivide;
        vm.otherDivide = otherDivide;

        vm.UtazasiKoltsegOsszegChange = UtazasiKoltsegOsszegChange;
        vm.EtkezesOsszegChange = EtkezesOsszegChange;
        vm.SzallasOsszegChange = SzallasOsszegChange;
        vm.NevezesiOsszegChange = NevezesiOsszegChange;
        vm.KikuldetesiKoltsegOsszegChange = KikuldetesiKoltsegOsszegChange;
        vm.EgyebOsszegChange = EgyebOsszegChange;
        vm.excel = excel;

        vm.cellsave = cellsave;
        vm.ADMIN = false;
        vm.JOVIDEGENSZAK = false;
        vm.TORLIDEGENKOLTSTERV = false;
        vm.JOVIDEGENGAZD = false;
        vm.JOVIDEGENVEZ = false;
        vm.print = print;
        vm.finalize = finalize;
        vm.close = close;
        vm.open = open;
        vm.deleteSelected = deleteSelected;
        vm.openPlan = openPlan;
        vm.openFact = openFact;
        vm.deletePlan = deletePlan;

        vm.enableEdit = enableEdit;

        vm.save = save;
        vm.IWillAccept1 = IWillAccept1;
        vm.IWillAccept2 = IWillAccept2;
        vm.IWillAccept3 = IWillAccept3;
        vm.accept1 = accept1;
        vm.accept2 = accept2;
        vm.accept3 = accept3;
        vm.UndoAccept1 = UndoAccept1;
        vm.UndoAccept2 = UndoAccept2;
        vm.UndoAccept3 = UndoAccept3;

        vm.moreAgeGroups = [];

        activate();

        function activate() {
            var promises = [
                authenticationService.getRight('MEGTIDEGENKOLTSTERV'),
                authenticationService.getRight('MODIDEGENKOLTSTERV'),
                authenticationService.getRight('UJIDEGENKOLTSTERV'),
                authenticationService.getRight('JOVAHAGYIDEGENKOLTSTERV'),
                paramHelper.getParams([], ['awayBudgetPlan.planId', 'awayBudgetPlan.planSection', 'awayBudgetPlan.planAgeGroup']),
                getSections(),
                authenticationService.getRight('SZAKOSZTVEZ'),
                authenticationService.getRight('GAZDASAGI'),
                authenticationService.getRight('TECHIGAZGATO'),
                authenticationService.getRight('ADMIN'),
                authenticationService.getRight('JOVIDEGENSZAK'),
                authenticationService.getRight('JOVIDEGENGAZD'),
                authenticationService.getRight('JOVIDEGENVEZ'),
                authenticationService.getRight('TORLIDEGENKOLTSTERV'),
                authenticationService.getRight('VEGLIDEGENKOLTSTERV')
            ];
            $q.all(promises).then(function (results) {
                if (!results[0] && results[1] && results[2]) {
                    log.permissionError(true);
                }
                vm.MEGTIDEGENKOLTSTERV = results[0];
                vm.MODIDEGENKOLTSTERV = results[1];
                vm.UJIDEGENKOLTSTERV = results[2];
                vm.JOVAHAGYIDEGENKOLTSTERV = results[3];
                vm.SZAKOSZTVEZ = results[6];
                vm.GAZDASAGI = results[7];
                vm.TECHIGAZGATO = results[8];
                vm.ADMIN = (results[9] || results[13]); // Admin vagy Gazdasági
                vm.JOVIDEGENSZAK = results[10];
                vm.JOVIDEGENGAZD = results[11];
                vm.JOVIDEGENVEZ = results[12];
                vm.TORLIDEGENKOLTSTERV = results[13];
                vm.VEGLIDEGENKOLTSTERV = results[14];
                var tervId = results[4]['awayBudgetPlan.planId'];

                disableEverything();
                initAgeGroupDropDown();
                initAthleteDropDownMS();
                initUserDropDownMS();
                getBusOwners();
                getBuses();
                //getAllUsers();
                if (tervId && tervId > 0) {
                    if (!vm.MODIDEGENKOLTSTERV) {
                        $timeout(function () {
                            vm.allowEdit = false;
                            $scope.$apply();
                        }, 0);
                    }
                    LoadPlan(tervId);
                } else {
                    vm.title = gettextCatalog.getString('DetailedPlan');
                    if (!vm.UJIDEGENKOLTSTERV) {
                        log.permissionError(true);
                    }
                    vm.data.SzakosztalyId = (results[4]['awayBudgetPlan.planSection'] !== null && parseInt(results[4]['awayBudgetPlan.planSection']) > 0) ? results[4]['awayBudgetPlan.planSection'] : null;
                    if (results[4]['awayBudgetPlan.planAgeGroup'] !== null && parseInt(results[4]['awayBudgetPlan.planAgeGroup']) > 0) {
                        vm.data.KorosztalyId = results[4]['awayBudgetPlan.planAgeGroup'];
                    } else {
                        vm.data.KorosztalyId = null;
                    }
                }
            });
        }

        function LoadPlan(Id) {
            disableEverything();
            dataservice.GetAwayBudgetPlan(Id).then(function (resp) {
                paramHelper.setParams([{'awayBudgetPlan.planId': Id}]);
                vm.szint = resp.Szint;
                if (!resp.Teny) {
                    vm.terv = true;
                    vm.teny = false;
                    vm.tenyId = resp.TenyId;
                    vm.forceDisableEdit = resp.retValue.Veglegesitve !== null;
                    enableEdit(resp.retValue.Lezarva === null);
                }
                if (!resp.Terv) {
                    vm.terv = false;
                    vm.teny = true;
                    vm.tervId = resp.TervId;
                    vm.forceDisableEdit = false;
                    enableEdit(resp.retValue.Lezarva === null);
                }
                vm.subtitle1 = resp.Jovahagyo1;
                vm.subtitle2 = resp.Jovahagyo2;
                vm.subtitle3 = resp.Jovahagyo3;
                // Megnyitáskor akkor van letiltva a szerkesztés ha: edző lezárta, vagy nem ugyanaz nyitja meg aki csinálta,
                //  ÉS jóvá van hagyva valamilyen szinten && (vm.data.Jovahagyta1Datum || vm.data.Jovahagyta2Datum || vm.data.Jovahagyta3Datum) EZis kell ???
                if (resp.retValue.Lezarva || vm.data.EdzoId != vm.currentUserId) {
                    enableEdit(false);
                }
                // Ha az edző sajátsa, vagy ADMIN
                if (resp.retValue.EdzoId == vm.currentUserId || vm.ADMIN || vm.SZAKOSZTVEZ) {
                    if (resp.retValue.Lezarva) {
                        vm.allowOpen = true;
                        enableEdit(false);
                    } else {
                        vm.allowClose = true;
                        enableEdit(true);
                    }
                }
                if (resp.retValue.Vegleges) {
                    vm.title = gettextCatalog.getString('DetailedFinal');
                } else {
                    vm.title = gettextCatalog.getString('DetailedPlan');
                }
                if (resp.retValue.Sorszam > 0) {
                    vm.title += ' - ' + gettextCatalog.getString('Number') + ': ' + resp.retValue.Sorszam;
                }
                vm.data = resp.retValue;
                vm.Terv = resp.Terv;
                vm.data.EdzoIdValue = resp.retValue.EdzoId;
                vm.allowFinalize = resp.Veglegesithet;
                vm.UserName = resp.EdzoNeve;
                vm.EdzoElerhetosege = resp.EdzoElerhetosege;
                grid.dataSource = resp.people;
                if (grid.dataSource.length > 0) {
                    vm.sorszam = grid.dataSource[grid.dataSource.length - 1].Sorszam + 1;
                } else {
                    vm.sorszam = 1;
                }
                setButtons();
            });
        }

        function disableEverything() {
            vm.allowEdit = true;
            vm.allowFinalize = false;
            vm.allowClose = false;
            vm.allowOpen = false;
            vm.allowIWillAccept1 = false;
            vm.allowIWillAccept2 = false;
            vm.allowIWillAccept3 = false;
            vm.allowAccept1 = false;
            vm.allowAccept2 = false;
            vm.allowAccept3 = false;
            vm.allowUndoAccept1 = false;
            vm.allowUndoAccept2 = false;
            vm.allowUndoAccept3 = false;
            vm.Accept1Enabled = false;
            vm.Accept2Enabled = false;
            vm.Accept3Enabled = false;
            vm.UndoAccept1Enabled = false;
            vm.UndoAccept2Enabled = false;
            vm.UndoAccept3Enabled = false;
        }

        function setButtons() {
            switch (vm.szint) {
                case 0:
                    if (vm.JOVIDEGENSZAK) {
                        vm.Accept1Enabled = true;
                    }
                    if (vm.JOVIDEGENGAZD) {
                        vm.Accept2Enabled = false;
                    }
                    if (vm.JOVIDEGENVEZ) {
                        vm.Accept3Enabled = false;
                    }
                    break;
                case 1:
                    if (vm.JOVIDEGENSZAK) {
                        vm.UndoAccept1Enabled = true;
                        vm.Accept1Enabled = false;
                    }
                    if (vm.JOVIDEGENGAZD) {
                        vm.Accept2Enabled = true;
                    }
                    if (vm.JOVIDEGENVEZ) {
                        vm.Accept3Enabled = false;
                    }
                    break;
                case 2:
                    if (vm.JOVIDEGENSZAK) {
                        vm.Accept1Enabled = false;
                    }
                    if (vm.JOVIDEGENGAZD) {
                        vm.UndoAccept2Enabled = true;
                        vm.Accept2Enabled = false;
                    }
                    if (vm.JOVIDEGENVEZ) {
                        vm.Accept3Enabled = true;
                    }
                    break;
                case 3:
                    if (vm.JOVIDEGENSZAK) {
                        vm.Accept1Enabled = false;
                    }
                    if (vm.JOVIDEGENGAZD) {
                        vm.Accept2Enabled = false;
                    }
                    if (vm.JOVIDEGENVEZ) {
                        vm.UndoAccept3Enabled = true;
                        vm.Accept3Enabled = false;
                    }
                    break;
            }
            // Ha levan zárva edző által
            if (vm.data.Lezarva) {
                // Szakmai
                // ő az aki már jóvahagyta
                if (vm.currentUserId == vm.data.Jovahagyta1Id) {
                    // és nem vonta vissza akkor visszavonhatja
                    if (vm.data.Jovahagyta1Datum) {
                        vm.allowUndoAccept1 = true;
                    }
                    //de visszavonta akkor Jóváhagyhatja újra
                    else {
                        vm.allowAccept1 = true;
                    }
                }
                // ÉS még nem hagyta jóvá akkor kijelölheti magát jóváhagyónak
                if (!vm.data.Jovahagyta1Id) {
                    vm.allowIWillAccept1 = true;
                }

                // Gazdasági
                if (vm.currentUserId == vm.data.Jovahagyta2Id) {
                    if (vm.data.Jovahagyta2Datum) {
                        vm.allowUndoAccept2 = true;
                    } else {
                        vm.allowAccept2 = true;
                    }
                }
                if (!vm.data.Jovahagyta2Id) {
                    vm.allowIWillAccept2 = true;
                }

                // Vezetői
                if (vm.currentUserId == vm.data.Jovahagyta3Id) {
                    if (vm.data.Jovahagyta3Datum) {
                        vm.allowUndoAccept3 = true;
                    } else {
                        vm.allowAccept3 = true;
                    }
                }
                if (!vm.data.Jovahagyta3Id) {
                    vm.allowIWillAccept3 = true;
                }
            }
        }

        function getSections() {
            dataservice.sectionDropDownList(0)
                .then(function (data) {
                    vm.sectionList = data.itemsList;
                });
        }

        function sectionDataBound() {
            $('#sectionDropDown').ejDropDownList('selectItemByValue', vm.data.SzakosztalyId);
        }

        function sectionSelect(args) {
            vm.data.SzakosztalyId = args.value;
            vm.athleteList = [];
            getAgeGroups(args.value);
        }

        function getAgeGroups(sectionId) {
            dataservice.ageGroupDropDownList(sectionId)
                .then(function (data) {
                    if (data.itemsList.length > 1) {
                        data.itemsList.unshift({value: -1, text: gettextCatalog.getString('All')});
                    }
                    vm.ageGroupList = data.itemsList;
                    initAgeGroupDropDown();
                });
        }

        function ageGroupDataBound() {
            if (vm.ageGroupList.length === 1) {
                angular.element('#ageGroupDropDown').ejDropDownList('selectItemByValue', vm.ageGroupList[0].value);
            } else {
                angular.element('#ageGroupDropDown').ejDropDownList('selectItemByValue', vm.data.KorosztalyId);
            }
        }

        function ageGroupSelect(args) {
            vm.data.KorosztalyId = args.value;
            getAthleteList(args.value);
            getCoachList(args.value);
        }

        function getAthleteList(ageGroupId, AgeGroups) {
            if (!AgeGroups) {
                AgeGroups = [];
            }
            AgeGroups.push(ageGroupId);
            return dataservice.getIdegenbeliKoltsegvetesiTervSportoloList(vm.data.SzakosztalyId, AgeGroups)
                .then(function (data) {
                    vm.athleteList = data.itemsList;
                    initAthleteDropDownMS();
                });
        }

        function getCoachList(ageGroupId) {
            return dataservice.getIdegenbeliKoltsegvetesiTervEdzoList(vm.data.SzakosztalyId, ageGroupId)
                .then(function (data) {
                    vm.coachList = data.itemsList;
                    initUserDropDownMS();
                });
        }

        function coachDataBound() {
            if (vm.coachList.length === 1) {
                $('#coachDropDown').ejDropDownList('selectItemByValue', vm.coachList[0].value);
            } else {
                $('#coachDropDown').ejDropDownList('selectItemByValue', vm.data.EdzoIdValue);
            }
        }

        // Ez a terv tulajdonosa
        function edzoSelect(args) {
            vm.data.EdzoId = args.value;
            vm.UserName = args.text;
            dataservice.getCoachContant(vm.data.EdzoId).then(function (response) {
                vm.EdzoElerhetosege = response.data;
            });
        }

        function athleteSelect(args) {
            vm.selectedAthlete = vm.athleteList[args.itemId];
            vm.selectedAthlete.index = args.itemId;
        }

        function coachSelect(args) {
            vm.selectedCoach = vm.coachList[args.itemId];
            vm.selectedCoach.index = args.itemId;
        }

        function addAthlete() {
            var selectedItems = $('#AthleteDropDownMS').data('ejDropDownList').getSelectedItem();
            for (var i = 0; i < selectedItems.length; i++) {
                var index = $filter('getIndex')(vm.athleteList, 'value', Number(selectedItems[i].dataset.value));
                var existing = $filter('getIndex')(grid.dataSource, 'SportoloId', vm.athleteList[index].value);
                if (existing === false) {
                    grid.dataSource.push({
                        SportoloId: vm.athleteList[index].value,
                        FelhasznaloId: null,
                        Sorszam: vm.sorszam++,
                        Nev: vm.athleteList[index].text,
                        SzuletesiEv: vm.athleteList[index].szuletesiEv,
                        UtazasiKoltseg: 0,
                        Etkezes: 0,
                        Szallas: 0,
                        NevezesiDij: 0,
                        KikuldetesiKoltseg: 0,
                        Egyeb: 0
                    });
                }
            }
            angular.element('#AthleteDropDownMS').ejDropDownList('uncheckAll');
            grid.refresh();
            vm.selectedAthlete = null;
            $scope.$apply();
        }

        function addAllAthlete() {
            if (vm.athleteList.length <= 0) {
                return;
            }
            vm.athleteList.forEach(function (t) {
                var existing = $filter('getIndex')(grid.dataSource, 'SportoloId', t.value);
                if (existing === false) {
                    grid.dataSource.push({
                        SportoloId: t.value,
                        FelhasznaloId: null,
                        Sorszam: vm.sorszam++,
                        Nev: t.text,
                        SzuletesiEv: t.szuletesiEv,
                        UtazasiKoltseg: 0,
                        Etkezes: 0,
                        Szallas: 0,
                        NevezesiDij: 0,
                        KikuldetesiKoltseg: 0,
                        Egyeb: 0
                    });
                }
            });
            grid.refresh();
            vm.selectedAthlete = null;
            $scope.$apply();
        }

        function addUser() {
            var selectedItems = $('#UserDropDownMS').data('ejDropDownList').getSelectedItem();
            for (var i = 0; i < selectedItems.length; i++) {
                var index = $filter('getIndex')(vm.coachList, 'value', Number(selectedItems[i].dataset.value));
                var existing = $filter('getIndex')(grid.dataSource, 'FelhasznaloId', vm.coachList[index].value);
                if (existing === false) {
                    grid.dataSource.push({
                        SportoloId: null,
                        FelhasznaloId: vm.coachList[index].value,
                        Sorszam: vm.sorszam++,
                        Nev: vm.coachList[index].text,
                        SzuletesiEv: vm.coachList[index].szuletesiEv,
                        UtazasiKoltseg: 0,
                        Etkezes: 0,
                        Szallas: 0,
                        NevezesiDij: 0,
                        KikuldetesiKoltseg: 0,
                        Egyeb: 0
                    });
                }
            }
            angular.element('#UserDropDownMS').ejDropDownList('uncheckAll');
            grid.refresh();
            vm.selectedCoach = null;
            $scope.$apply();
        }

        function addOtherPersonName() {
            if (!vm.otherPersonName || !vm.otherPersonYear) {
                swal({
                    title: gettextCatalog.getString('PersonNameOrPersonYearEmpty'),
                    type: 'error',
                    confirmButtonColor: '#DD6B55',
                    confirmButtonText: gettextCatalog.getString('Ok'),
                });
                return;
            }
            grid.dataSource.push({
                SportoloId: null,
                FelhasznaloId: null,
                Sorszam: vm.sorszam++,
                Nev: vm.otherPersonName,
                SzuletesiEv: vm.otherPersonYear,
                UtazasiKoltseg: 0,
                Etkezes: 0,
                Szallas: 0,
                NevezesiDij: 0,
                KikuldetesiKoltseg: 0,
                Egyeb: 0
            });
            vm.otherPersonName = '';
            vm.otherPersonYear = '';
            grid.refresh();
            $scope.$apply();
        }

        function ToFixedTwo(n) {
            return n;
            var f = parseFloat(n).toFixed(2);
            f = parseFloat(f).toLocaleString('en');
            f = f.replace(/,/g, ' ');
            return f;
        }

        function travelCostDivide() {
            var result = 0;
            if (vm.data.UtazasiKoltsegOsszeg && vm.data.UtazasiKoltsegOsszeg !== 0) {
                result = ToFixedTwo(vm.data.UtazasiKoltsegOsszeg / grid.dataSource.length);
            }
            grid.dataSource.forEach(function (t) {
                t.UtazasiKoltseg = result;
            });
            grid.refresh();
        }

        function mealDivide() {
            var result = 0;
            if (vm.data.EtkezesOsszeg && vm.data.EtkezesOsszeg != 0) {
                result = ToFixedTwo(vm.data.EtkezesOsszeg / grid.dataSource.length);
            }
            grid.dataSource.forEach(function (t) {
                t.Etkezes = result;
            });
            grid.refresh();
        }

        function accommodationDivide() {
            var result = 0;
            if (vm.data.SzallasOsszeg && vm.data.SzallasOsszeg != 0) {
                result = ToFixedTwo(vm.data.SzallasOsszeg / grid.dataSource.length);
            }
            grid.dataSource.forEach(function (t) {
                t.Szallas = result;
            });
            grid.refresh();
        }

        function registrationFeeDivide() {
            var result = 0;
            if (vm.data.NevezesiOsszeg && vm.data.NevezesiOsszeg != 0) {
                result = ToFixedTwo(vm.data.NevezesiOsszeg / grid.dataSource.length);
            }
            grid.dataSource.forEach(function (t) {
                t.NevezesiDij = result;
            });
            grid.refresh();
        }

        function secondmentCostDivide() {
            var result = 0;
            if (vm.data.KikuldetesiKoltsegOsszeg && vm.data.KikuldetesiKoltsegOsszeg != 0) {
                result = ToFixedTwo(vm.data.KikuldetesiKoltsegOsszeg / grid.dataSource.length);
            }
            grid.dataSource.forEach(function (t) {
                t.KikuldetesiKoltseg = result;
            });
            grid.refresh();
        }

        function otherDivide() {
            var result = 0;
            if (vm.data.EgyebOsszeg && vm.data.EgyebOsszeg != 0) {
                result = ToFixedTwo(vm.data.EgyebOsszeg / grid.dataSource.length);
            }
            grid.dataSource.forEach(function (t) {
                t.Egyeb = result;
            });
            grid.refresh();
        }

        function UtazasiKoltsegOsszegChange(args) {
            vm.data.OsszesenOszeg = args.value + vm.data.EtkezesOsszeg + vm.data.SzallasOsszeg + vm.data.NevezesiOsszeg + vm.data.KikuldetesiKoltsegOsszeg + vm.data.EgyebOsszeg;
        }

        function EtkezesOsszegChange(args) {
            vm.data.OsszesenOszeg = vm.data.UtazasiKoltsegOsszeg + args.value + vm.data.SzallasOsszeg + vm.data.NevezesiOsszeg + vm.data.KikuldetesiKoltsegOsszeg + vm.data.EgyebOsszeg;
        }

        function SzallasOsszegChange(args) {
            vm.data.OsszesenOszeg = vm.data.UtazasiKoltsegOsszeg + vm.data.EtkezesOsszeg + args.value + vm.data.NevezesiOsszeg + vm.data.KikuldetesiKoltsegOsszeg + vm.data.EgyebOsszeg;
        }

        function NevezesiOsszegChange(args) {
            vm.data.OsszesenOszeg = vm.data.UtazasiKoltsegOsszeg + vm.data.EtkezesOsszeg + vm.data.SzallasOsszeg + args.value + vm.data.KikuldetesiKoltsegOsszeg + vm.data.EgyebOsszeg;
        }

        function KikuldetesiKoltsegOsszegChange(args) {
            vm.data.OsszesenOszeg = vm.data.UtazasiKoltsegOsszeg + vm.data.EtkezesOsszeg + vm.data.SzallasOsszeg + vm.data.NevezesiOsszeg + args.value + vm.data.EgyebOsszeg;
        }

        function EgyebOsszegChange(args) {
            vm.data.OsszesenOszeg = vm.data.UtazasiKoltsegOsszeg + vm.data.EtkezesOsszeg + vm.data.SzallasOsszeg + vm.data.NevezesiOsszeg + vm.data.KikuldetesiKoltsegOsszeg + args.value;
        }

        function reCalculate(args, column, property) {
            return $q(function () {
                grid.dataSource[args.rowData.Sorszam - 1][column] = args.value;
                vm.data[property] = 0;
                grid.dataSource.forEach(function (t) {
                    if (!isNaN(parseFloat(t[column]))) {
                        vm.data[property] += parseFloat(t[column]);
                    }
                });
            });
        }

        function cellsave(args) {
            new ej2.data.DataManager(grid.dataSource).executeQuery(new ej2.data.Query().where('Sorszam', 'equal', args.rowData.Sorszam)).then(function (result) {
                result.result[0][args.columnName] = args.value;
                grid.refresh();
            });

            if (args.columnName === 'UtazasiKoltseg') {
                args.cancel = true;
                reCalculate(args, 'UtazasiKoltseg', 'UtazasiKoltsegOsszeg').then(function () {
                    args.cancel = false;
                });
            }
            if (args.columnName === 'Etkezes') {
                args.cancel = true;
                reCalculate(args, 'Etkezes', 'EtkezesOsszeg').then(function () {
                    args.cancel = false;
                });
            }
            if (args.columnName === 'Szallas') {
                args.cancel = true;
                reCalculate(args, 'Szallas', 'SzallasOsszeg').then(function () {
                    args.cancel = false;
                });
            }
            if (args.columnName === 'NevezesiDij') {
                args.cancel = true;
                reCalculate(args, 'NevezesiDij', 'NevezesiOsszeg').then(function () {
                    args.cancel = false;
                });
            }
            if (args.columnName === 'KikuldetesiKoltseg') {
                args.cancel = true;
                reCalculate(args, 'KikuldetesiKoltseg', 'KikuldetesiKoltsegOsszeg').then(function () {
                    args.cancel = false;
                });
            }
            if (args.columnName === 'Egyeb') {
                args.cancel = true;
                reCalculate(args, 'Egyeb', 'EgyebOsszeg').then(function () {
                    args.cancel = false;
                });
            }

            args.cancel = false;
            $scope.$apply();
        }

        function save(arg) {
            if (vm.saveIsBusy) {
                log.warningMsg(gettextCatalog.getString('PleaseWaitWhileSaving'));
                return;
            }
            vm.saveIsBusy = true;
            if (vm.allowEdit) {
                grid.editModule.batchSave();
            }
            vm.data.people = grid.dataSource;
            if (arg && arg.target && arg.target.name === 'saveAwayBudgetPlan') {
                arg = 'save';
            }
            ['UtazasiKoltsegOsszeg', 'EtkezesOsszeg', 'SzallasOsszeg', 'NevezesiOsszeg', 'KikuldetesiKoltsegOsszeg', 'EgyebOsszeg']
                .forEach(function (f) {
                    if (!vm.data.hasOwnProperty(f) || vm.data[f] === null || vm.data[f] === '' || isNaN(vm.data[f])) {
                        vm.data[f] = 0;
                    }
                });
            $timeout(function () {
                $scope.$broadcast('submitted');
                if ($scope.form.$valid === false) {
                    log.errorMsg(gettextCatalog.getString('RequiredFieldsError'));
                    vm.saveIsBusy = false;
                    return;
                }
                return dataservice.SaveAwayBudgetPlan(vm.data).then(function (response) {
                    vm.data.Id = response.retValue;
                    log.successMsg('SaveCompleted');
                    switch (arg) {
                        case 'save':
                            LoadPlan(vm.data.Id);
                            vm.saveIsBusy = false;
                            break;
                        case 'print':
                            vm.reportParameters = {
                                Header: vm.title,
                                Szakosztaly: angular.element('#sectionDropDown').data('ejDropDownList').getSelectedItem()[0].innerText,
                                Korosztaly: angular.element('#ageGroupDropDown').data('ejDropDownList').getSelectedItem()[0].innerText,
                                Edzo: vm.UserName,
                                EdzoElerhetosege: vm.EdzoElerhetosege == undefined ? ' ' : vm.EdzoElerhetosege,
                                Tervadat: vm.data.Vegleges ? 'Végleges' : 'Tervadat',
                                UtaslistaNev: vm.data.Vegleges ? 'Végleges utaslista' : 'Tervezett utaslista',
                                Sorszam: vm.data.Sorszam == undefined ? ' ' : vm.data.Sorszam,
                                FejId: vm.data.Id,
                                Lezaras: vm.data.Lezarva ? vm.data.Lezarva : 'Még nincs lezárva',
                                Jovahagyas1: vm.subtitle1 == undefined ? ' ' : vm.subtitle1,
                                Jovahagyas2: vm.subtitle2 == undefined ? ' ' : vm.subtitle2,
                                Jovahagyas3: vm.subtitle3 == undefined ? ' ' : vm.subtitle3,
                            };
                            if (vm.printOpened) {
                                angular.element('#printDialog').ejDialog('open');
                            } else {
                                vm.printOpened = true;
                                angular.element('#printDialog').ejDialog({
                                    height: '95%',
                                    width: '95%',
                                    enablemodal: 'true',
                                    'position-x': '0',
                                    'position-y': '1',
                                    target: '#mainContent',
                                    enableresize: 'false'
                                });
                            }
                            vm.saveIsBusy = false;
                            break;
                        case 'excel':
                            dataservice.KoltesegvetesiTervExcelExport(vm.data.Id).then(function (response) {
                                var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
                                if (urlCreator) {
                                    var url = response.data;
                                    var a = document.createElement('a');
                                    document.body.appendChild(a);
                                    a.href = url;
                                    a.click();
                                    window.URL.revokeObjectURL(url);
                                }
                                vm.saveIsBusy = false;
                            });
                            break;
                        case 'finalize':
                            console.log('vm.VEGLIDEGENKOLTSTERV', vm.VEGLIDEGENKOLTSTERV);
                            if (!vm.VEGLIDEGENKOLTSTERV) {
                                log.permissionError();
                                vm.saveIsBusy = false;
                            } else {
                                dataservice.KoltesegvetesiTervVeglegesites(vm.data.Id).then(function (veglegesResponse) {
                                    log.infoMsg('Finalized');
                                    LoadPlan(veglegesResponse.data.id);
                                    vm.saveIsBusy = false;
                                });
                            }
                            break;
                        case 'close':
                            dataservice.KoltesegvetesiTervLezaras(vm.data.Id, true).then(function (lezarasResponse) {
                                log.infoMsg('Closed');
                                vm.allowClose = false;
                                LoadPlan(lezarasResponse.data.id);
                                enableEdit(false);
                                vm.saveIsBusy = false;
                            });
                            break;
                        case 'open':
                            dataservice.KoltesegvetesiTervLezaras(vm.data.Id, false).then(function (lezarasResponse) {
                                log.infoMsg('ReOpened');
                                vm.allowOpen = false;
                                LoadPlan(lezarasResponse.data.id);
                                enableEdit(true);
                                vm.saveIsBusy = false;
                            });
                            break;
                        case -1:
                            dataservice.KoltesegvetesiTervJovahagyas(vm.data.Id, arg).then(function () {
                                vm.allowAccept1 = true;
                                vm.allowUndoAccept1 = false;
                                log.infoMsg('AcceptUndone');
                                enableEdit(true);
                                LoadPlan(vm.data.Id);
                                vm.saveIsBusy = false;
                            });
                            break;
                        case 1:
                            dataservice.KoltesegvetesiTervJovahagyas(vm.data.Id, arg).then(function () {
                                vm.allowAccept1 = false;
                                log.infoMsg('Approved');
                                enableEdit(false);
                                LoadPlan(vm.data.Id);
                                vm.saveIsBusy = false;
                            });
                            break;
                        case 11:
                            dataservice.KoltesegvetesiTervJovahagyas(vm.data.Id, arg).then(function () {
                                vm.allowAccept1 = true;
                                log.infoMsg('ApproverUserSelected');
                                enableEdit(true);
                                LoadPlan(vm.data.Id);
                                vm.saveIsBusy = false;
                            });
                            break;
                        case -2:
                            dataservice.KoltesegvetesiTervJovahagyas(vm.data.Id, arg).then(function () {
                                vm.allowAccept2 = true;
                                vm.allowUndoAccept2 = false;
                                log.infoMsg('AcceptUndone');
                                enableEdit(true);
                                LoadPlan(vm.data.Id);
                                vm.saveIsBusy = false;
                            });
                            break;
                        case 2:
                            dataservice.KoltesegvetesiTervJovahagyas(vm.data.Id, arg).then(function () {
                                vm.allowAccept2 = false;
                                log.infoMsg('Approved');
                                enableEdit(false);
                                LoadPlan(vm.data.Id);
                                vm.saveIsBusy = false;
                            });
                            break;
                        case 22:
                            dataservice.KoltesegvetesiTervJovahagyas(vm.data.Id, arg).then(function () {
                                vm.allowAccept2 = true;
                                log.infoMsg('ApproverUserSelected');
                                enableEdit(true);
                                LoadPlan(vm.data.Id);
                                vm.saveIsBusy = false;
                            });
                            break;
                        case -3:
                            dataservice.KoltesegvetesiTervJovahagyas(vm.data.Id, arg).then(function () {
                                vm.allowAccept3 = true;
                                vm.allowUndoAccept3 = false;
                                log.infoMsg('AcceptUndone');
                                enableEdit(true);
                                LoadPlan(vm.data.Id);
                                vm.saveIsBusy = false;
                            });
                            break;
                        case 3:
                            dataservice.KoltesegvetesiTervJovahagyas(vm.data.Id, arg).then(function () {
                                vm.allowAccept3 = false;
                                log.infoMsg('Approved');
                                enableEdit(false);
                                LoadPlan(vm.data.Id);
                                vm.saveIsBusy = false;
                            });
                            break;
                        case 33:
                            dataservice.KoltesegvetesiTervJovahagyas(vm.data.Id, arg).then(function () {
                                vm.allowAccept3 = true;
                                log.infoMsg('ApproverUserSelected');
                                enableEdit(true);
                                LoadPlan(vm.data.Id);
                                vm.saveIsBusy = false;
                            });
                            break;
                    }
                });
            }, 300);
        }

        function IWillAccept1() {
            if (!vm.JOVIDEGENSZAK) {
                log.permissionError();
                return;
            }
            save(11);
        }

        function IWillAccept2() {
            if (!vm.JOVIDEGENGAZD) {
                log.permissionError();
                return;
            }
            save(22);
        }

        function IWillAccept3() {
            if (!vm.JOVIDEGENVEZ) {
                log.permissionError();
                return;
            }
            save(33);
        }

        function excel() {
            save('excel');
        }

        function accept1() {
            save(1);
        }

        function accept2() {
            save(2);
        }

        function accept3() {
            save(3);
        }

        function UndoAccept1() {
            save(-1);
        }

        function UndoAccept2() {
            save(-2);
        }

        function UndoAccept3() {
            save(-3);
        }

        function close() {
            save('close');
        }

        function open() {
            save('open');
        }

        function finalize() {
            swal({
                title: gettextCatalog.getString('Away Budget Plan Finalize Warning!'),
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: gettextCatalog.getString('Yes'),
                cancelButtonText: gettextCatalog.getString('No'),
                closeOnConfirm: true,
                closeOnCancel: true
            }).then(function (isConfirm) {
                if (isConfirm.value) {
                    save('finalize');
                }
            });
        }

        function print() {
            save('print');
        }

        function deleteSelected() {
            var selectedRecords = grid.getSelectedRecords();
            for (var i = selectedRecords.length - 1; i >= 0; i--) {
                var delIdx = $filter('getIndex')(grid.dataSource, 'Sorszam', selectedRecords[i].Sorszam);
                vm.data.UtazasiKoltsegOsszeg -= (!isNaN(selectedRecords[i].UtazasiKoltseg) && Number(selectedRecords[i].UtazasiKoltseg)) ? selectedRecords[i].UtazasiKoltseg : 0;
                vm.data.EtkezesOsszeg -= (!isNaN(selectedRecords[i].Etkezes) && Number(selectedRecords[i].Etkezes)) ? selectedRecords[i].Etkezes : 0;
                vm.data.SzallasOsszeg -= (!isNaN(selectedRecords[i].Szallas) && Number(selectedRecords[i].Szallas)) ? selectedRecords[i].Szallas : 0;
                vm.data.NevezesiOsszeg -= (!isNaN(selectedRecords[i].NevezesiDij) && Number(selectedRecords[i].NevezesiDij)) ? selectedRecords[i].NevezesiDij : 0;
                vm.data.KikuldetesiKoltsegOsszeg -= (!isNaN(selectedRecords[i].KikuldetesiKoltseg) && Number(selectedRecords[i].KikuldetesiKoltseg)) ? selectedRecords[i].KikuldetesiKoltseg : 0;
                vm.data.EgyebOsszeg -= (!isNaN(selectedRecords[i].Egyeb) && Number(selectedRecords[i].Egyeb)) ? selectedRecords[i].Egyeb : 0;
                grid.dataSource.splice(delIdx, 1);
                $scope.$apply();
            }
            if (selectedRecords) {
                $timeout(function () {
                    vm.sorszam = 1;
                    grid.dataSource.forEach(function (t) {
                        t.Sorszam = vm.sorszam++;
                    });
                    grid.refresh();
                }, 333);
            }
        }

        function enableEdit(arg) {
            if (arg && vm.forceDisableEdit) {
                return;
            }
            vm.allowEdit = arg;
            grid.editSettings.allowEditing = arg;
            grid.editSettings.allowSelection = arg;
            grid.editSettings.allowDeleting = arg;
            $timeout(function () {
                $scope.$apply();
            }, 100);
            $('#MoreAgeGroups').ejDropDownList({enabled: arg});
            $('#AthleteDropDownMS').ejDropDownList({enabled: arg});
            $('#UserDropDownMS').ejDropDownList({enabled: arg});
        }

        function openPlan() {
            // megkeresem a véglegesités évével és a tény sorszámával.
            LoadPlan(vm.tervId);
        }

        function openFact() {
            LoadPlan(vm.tenyId);
        }

        function initAgeGroupDropDown() {
            $('#MoreAgeGroups').ejDropDownList({
                dataSource: vm.ageGroupList,
                fields: {text: 'text'},
                showCheckbox: true,
                width: '100%',
                multiSelectMode: ej.MultiSelectMode.Delimiter,
                change: function (arg) {
                    if (arg.isChecked) {
                        if (arg.value == 0) {
                            for (var a = 1; a < vm.ageGroupList.length; a++) {
                                $('#MoreAgeGroups').ejDropDownList('unselectItemByValue', vm.ageGroupList[a].value);
                            }
                        } else {
                            $('#MoreAgeGroups').ejDropDownList('unselectItemByValue', 0);
                        }
                    }
                    var selectedItems = $('#MoreAgeGroups').data('ejDropDownList').getSelectedItem();
                    var moreAgeGroups = [];
                    for (var i = 0; i < selectedItems.length; i++) {
                        moreAgeGroups.push(Number(selectedItems[i].dataset.value));
                    }
                    getAthleteList(vm.data.KorosztalyId, moreAgeGroups);
                }
            });
        }

        function initAthleteDropDownMS() {
            $('#AthleteDropDownMS').ejDropDownList({
                dataSource: vm.athleteList,
                fields: {text: 'text'},
                showCheckbox: true,
                width: '100%',
                multiSelectMode: ej.MultiSelectMode.Delimiter
            });
        }

        function initUserDropDownMS() {
            $('#UserDropDownMS').ejDropDownList({
                dataSource: vm.coachList,
                fields: {text: 'text'},
                showCheckbox: true,
                width: '100%',
                multiSelectMode: ej.MultiSelectMode.Delimiter
            });
        }

        function getBusOwners() {
            dataservice.IdegenKoltsegTervBuszTulaj().then(function (response) {
                vm.busOwners = response.data;
            });
        }

        function getBuses() {
            dataservice.IdegenKoltsegTervBusz().then(function (resp) {
                vm.busLists = resp.data;
            });
        }

        function deletePlan() {
            if (!vm.TORLIDEGENKOLTSTERV) {
                log.permissionError();
                return;
            }
            if (vm.data.Id && vm.data.Id > 0) {
                swal({
                    title: gettextCatalog.getString('Are you sure you want to delete the selected away budget Plan?'),
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#DD6B55',
                    confirmButtonText: gettextCatalog.getString('Yes'),
                    cancelButtonText: gettextCatalog.getString('Cancel'),
                    closeOnConfirm: true,
                    closeOnCancel: true
                }).then(function (isConfirm) {
                    if (isConfirm.value) {
                        return dataservice.deleteAwayBudgetPlan(vm.data.Id).then(function (res) {
                            if (res.retValue) {
                                log.successMsg(gettextCatalog.getString('PlanDeleted'));
                                $state.go('administration.awayBudgetPlan.awayBudgetPlanList');
                            }
                        });
                    }
                });
            }
        }
    }
})
();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.administration.awayBudgetPlan.awayBudgetPlanCreate')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'administration.awayBudgetPlan.awayBudgetPlanCreate',
                config: {
                    url: '/awayBudgetPlanCreate',
                    templateUrl: 'app/administration/awayBudgetPlan/awayBudgetPlanCreate/awayBudgetPlanCreate.html',
                    controller: 'AwayBudgetPlanCreateController',
                    controllerAs: 'vm',
                    title: 'AwayBudgetPlanCreate',
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    AwayBudgetPlanListController.$inject = ["log", "$timeout", "paramHelper", "dataservice", "$q", "$rootScope", "gettextCatalog", "authenticationService", "$scope", "$state", "$filter"];
    angular
        .module('app.administration.awayBudgetPlan.awayBudgetPlanList')
        .controller('AwayBudgetPlanListController', AwayBudgetPlanListController);

    function AwayBudgetPlanListController(log, $timeout, paramHelper, dataservice, $q, $rootScope, gettextCatalog, authenticationService, $scope, $state, $filter) {
        var vm = this;
        $rootScope.vm = vm;

        // Title
        $rootScope.title = gettextCatalog.getString('AwayBudgetPlanList');

        // Section DropDown
        vm.sectionList = [];
        vm.sectionId = 0;
        // Age Group DropDown
        vm.ageGroupList = [];
        vm.ageGroupId = 0;
        // Coach DropDown
        vm.coachList = [];
        vm.coachId = 0;
        // DatePicker
        vm.typeId = 0;
        vm.typeList = [
            {value: 0, text: gettextCatalog.getString('All')},
            {value: 1, text: gettextCatalog.getString('Plan')},
            {value: 2, text: gettextCatalog.getString('Fact')}
        ];

        vm.dateFrom = new Date();
        vm.dateFrom.setMonth(vm.dateFrom.getMonth() - 1);
        vm.dateTo = new Date();
        vm.dateTo.setMonth(vm.dateTo.getMonth() + 1);

        // Checkbox
        vm.onlyStartDate = false;
        // Plans Grid
        vm.columns = [
            {
                field: 'Id',
                visible: false,
                isPrimaryKey: true,
                isIdentity: true
            },
            {
                field: 'Link',
                headerText: '',
                template: '#PlanOpenTemplate',
                width: 60
            },
            {
                field: 'Sorszam',
                headerText: gettextCatalog.getString('PlanNumber'),
                textAlign: 'center',
                width: 110
            },
            {
                field: 'VersenyNeve',
                headerText: gettextCatalog.getString('CompetitionName'),
                textAlign: 'center',
                width: 125
            },
            {
                field: 'VersenyHelye',
                headerText: gettextCatalog.getString('CompetitionPlace'),
                textAlign: 'center',
                width: 125
            },
            {
                field: 'Szakosztaly',
                headerText: gettextCatalog.getString('Section'),
                textAlign: 'center',
                width: 125
            },
            {
                field: 'Korosztaly',
                headerText: gettextCatalog.getString('AgeGroup'),
                textAlign: 'center',
                width: 120
            },
            {
                field: 'Edzo',
                headerText: gettextCatalog.getString('Coach'),
                textAlign: 'center',
                width: 120
            },
            {
                field: 'CompetitionStart',
                headerText: gettextCatalog.getString('CompetitionStart'),
                textAlign: 'center',
                width: 120
            },
            {
                field: 'CompetitionEnd',
                headerText: gettextCatalog.getString('CompetitionEnd'),
                textAlign: 'center',
                width: 120
            },
            {
                field: 'Lezarva',
                headerText: gettextCatalog.getString('Closed'),
                textAlign: 'center',
                type: 'boolean', displayAsCheckBox: true,
                width: 120
            },
            {
                field: 'Vegleges',
                headerText: gettextCatalog.getString('Final'),
                textAlign: 'center',
                type: 'boolean', displayAsCheckBox: true,
                width: 120
            },
            {
                field: 'Jovahagyva1',
                headerText: gettextCatalog.getString('ProfessionalApproved'),
                textAlign: 'center',
                type: 'boolean', displayAsCheckBox: true,
                width: 120
            },
            {
                field: 'Jovahagyva2',
                headerText: gettextCatalog.getString('EconomicApproved'),
                textAlign: 'center',
                type: 'boolean', displayAsCheckBox: true,
                width: 120
            },
            {
                field: 'Jovahagyva3',
                headerText: gettextCatalog.getString('LeaderApproved'),
                textAlign: 'center',
                type: 'boolean', displayAsCheckBox: true,
                width: 120
            }
        ];

        var grid = new ej2.grids.Grid({
            dataSource: [],
            allowPaging: true,
            allowSorting: true,
            allowExcelExport: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            allowTextWrap: true,
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#Grid'), $scope);
                }
            },
            beforePrint: $rootScope.beforePrintGrid,
            printComplete: $rootScope.printCompleteGrid
        });
        grid.appendTo('#Grid');

        // Public functions
        vm.sectionDataBound = sectionDataBound;
        vm.sectionSelect = sectionSelect;
        vm.ageGroupDataBound = ageGroupDataBound;
        vm.ageGroupSelect = ageGroupSelect;
        vm.coachDataBound = coachDataBound;
        vm.coachSelect = coachSelect;
        vm.typeDataBound = typeDataBound;
        vm.typeSelect = typeSelect;

        vm.search = search;
        vm.openPlan = openPlan;
        vm.create = create;
        vm.delete = deletePlan;

        vm.selectedCoach = 0;
        vm.selectedSection = 0;
        vm.selectedAgeGroup = 0;
        vm.selectedType = 0;
        vm.selectedOnlyStartedDate = false;
        vm.selectedFromDate = vm.dateFrom;
        vm.selectedToDate = vm.dateTo;

        // Activate page
        activate();

        function activate() {
            var promises = [
                authenticationService.getRight('MEGTIDEGENKOLTSTERV'),
                authenticationService.getRight('MODIDEGENKOLTSTERV'),
                authenticationService.getRight('UJIDEGENKOLTSTERV'),
                authenticationService.getRight('TORLIDEGENKOLTSTERV'),
                getSections(),
                paramHelper.getParams([], ['awayBudgetPlanList.edzoId', 'awayBudgetPlanList.szakosztalyId', 'awayBudgetPlanList.korosztalyId', 'awayBudgetPlanList.tipus', 'awayBudgetPlanList.csakKezdoDatum', 'awayBudgetPlanList.datumTol', 'awayBudgetPlanList.datumIg', 'awayBudgetPlanList.versenyHelye']),
                getCompetitionPlaces()
            ];
            $q.all(promises).then(function (results) {
                if (!results[0]) {
                    log.permissionError(true);
                }
                vm.MODIDEGENKOLTSTERV = results[1];
                vm.UJIDEGENKOLTSTERV = results[2];
                vm.TORLIDEGENKOLTSTERV = results[3];
                if (results[5]['awayBudgetPlanList.edzoId'] !== undefined) {
                    vm.selectedCoach = results[5]['awayBudgetPlanList.edzoId'];
                }
                if (results[5]['awayBudgetPlanList.szakosztalyId'] !== undefined) {
                    vm.selectedSection = results[5]['awayBudgetPlanList.szakosztalyId'];
                }
                if (results[5]['awayBudgetPlanList.korosztalyId'] !== undefined) {
                    vm.selectedAgeGroup = results[5]['awayBudgetPlanList.korosztalyId'];
                }
                if (results[5]['awayBudgetPlanList.tipus'] !== undefined) {
                    vm.selectedType = results[5]['awayBudgetPlanList.tipus'];
                }
                if (results[5]['awayBudgetPlanList.csakKezdoDatum'] !== undefined) {
                    vm.selectedOnlyStartedDate = results[5]['awayBudgetPlanList.csakKezdoDatum'];
                }
                if (results[5]['awayBudgetPlanList.datumTol'] !== undefined) {
                    vm.dateFrom = results[5]['awayBudgetPlanList.datumTol'];
                }
                if (results[5]['awayBudgetPlanList.datumIg'] !== undefined) {
                    vm.dateTo = results[5]['awayBudgetPlanList.datumIg'];
                }
                if (results[5]['awayBudgetPlanList.versenyHelye'] !== undefined) {
                    vm.competitionPlace = results[5]['awayBudgetPlanList.versenyHelye'];
                }

                if (vm.selectedOnlyStartedDate) {
                    angular.element('#onlyStartDate').ejCheckBox({checked: vm.selectedOnlyStartedDate});
                }
            });
        }

        function getCompetitionPlaces() {
            dataservice.getCompetitionPlaces().then(function (data) {
                vm.competitionPlaceList = data.itemsList;
            });
        }

        function typeDataBound() {
            if (!vm.selectedType) {
                vm.selectedType = 0;
            }
            angular.element('#typeDropDown').ejDropDownList('selectItemByValue', vm.selectedType);
        }

        function typeSelect(args) {
            vm.typeId = args.value;
        }

        function getSections() {
            dataservice.sectionDropDownList(0)
                .then(function (data) {
                    if (data.itemsList.length > 1) {
                        data.itemsList.unshift({value: 0, text: gettextCatalog.getString('All')});
                    }
                    vm.sectionList = data.itemsList;
                });
        }

        function sectionDataBound() {
            if (vm.sectionList.length === 1) {
                $('#sectionDropDown').ejDropDownList('selectItemByValue', vm.sectionList[0].value);
            } else {
                $('#sectionDropDown').ejDropDownList('selectItemByValue', vm.selectedSection);
            }
        }

        function sectionSelect(args) {
            vm.sectionId = args.value;
            vm.coachList = [];
            getAgeGroups();
        }

        function getAgeGroups() {
            dataservice.ageGroupDropDownList(vm.sectionId)
                .then(function (data) {
                    if (data.itemsList.length > 1) {
                        data.itemsList.unshift({value: 0, text: gettextCatalog.getString('All')});
                    }
                    vm.ageGroupList = data.itemsList;
                });
        }

        function ageGroupDataBound() {
            if (vm.ageGroupList.length === 1) {
                $('#ageGroupDropDown').ejDropDownList('selectItemByValue', vm.ageGroupList[0].value);
            } else {
                $('#ageGroupDropDown').ejDropDownList('selectItemByValue', vm.selectedAgeGroup);
            }
        }

        function ageGroupSelect(args) {
            vm.ageGroupId = args.value;
            getCoachList();
        }

        // Section dropDownList function Get coach' list
        function getCoachList() {
            return dataservice.coachDropDownList(vm.sectionId, vm.ageGroupId, vm.dateFrom, vm.dateTo)
                .then(function (data) {
                    if (data.itemsList.length > 1) {
                        data.itemsList.unshift({value: 0, text: gettextCatalog.getString('All')});
                    }
                    vm.coachList = data.itemsList;
                });
        }

        // Run after data bounded
        function coachDataBound() {
            if (vm.coachList.length === 1) {
                $('#coachDropDown').ejDropDownList('selectItemByValue', vm.coachList[0].value);
            } else {
                $('#coachDropDown').ejDropDownList('selectItemByValue', vm.selectedCoach);
            }
        }

        // Run after age group selected
        function coachSelect(args) {
            vm.coachId = args.value;
        }

        function search() {
            // a syncfusion direktívák miatt
            $scope.$broadcast('submitted');
            if ($scope.form.$valid === false) {
                log.errorMsg(gettextCatalog.getString('RequiredFieldsError'));
                return;
            }
            paramHelper.setParams([
                {'awayBudgetPlanList.edzoId': vm.coachId},
                {'awayBudgetPlanList.szakosztalyId': vm.sectionId},
                {'awayBudgetPlanList.korosztalyId': vm.ageGroupId},
                {'awayBudgetPlanList.tipus': vm.typeId},
                {'awayBudgetPlanList.csakKezdoDatum': $('#onlyStartDate').ejCheckBox('isChecked')},
                {'awayBudgetPlanList.datumTol': vm.dateFrom},
                {'awayBudgetPlanList.datumIg': vm.dateTo},
                {'awayBudgetPlanList.versenyHelye': vm.competitionPlace}
            ]);

            return dataservice.getAwayBudgetPlanList(vm.sectionId, vm.ageGroupId, vm.coachId, vm.dateFrom, vm.dateTo, vm.onlyStartDate, vm.typeId, vm.competitionPlace).then(function (data) {
                var planList = $filter('dateStringFilter')(data.itemsList, 'CompetitionEnd');
                grid.dataSource = $filter('dateStringFilter')(planList, 'CompetitionStart');
            });
        }

        function openPlan(planId) {
            paramHelper.setParams([{
                'awayBudgetPlan.planId': planId,
                'awayBudgetPlan.planSection': $('#sectionDropDown').ejDropDownList('getSelectedValue'),
                'awayBudgetPlan.planAgeGroup': $('#ageGroupDropDown').ejDropDownList('getSelectedValue')
            }]);
            paramHelper.setParams([
                {'awayBudgetPlanList.edzoId': vm.coachId},
                {'awayBudgetPlanList.szakosztalyId': vm.sectionId},
                {'awayBudgetPlanList.korosztalyId': vm.ageGroupId},
                {'awayBudgetPlanList.tipus': vm.typeId},
                {'awayBudgetPlanList.csakKezdoDatum': $('#onlyStartDate').ejCheckBox('isChecked')},
                {'awayBudgetPlanList.datumTol': vm.dateFrom},
                {'awayBudgetPlanList.datumIg': vm.dateTo}
            ]);
            $state.go('administration.awayBudgetPlan.awayBudgetPlanCreate');
        }

        function create() {
            if (!vm.UJIDEGENKOLTSTERV) {
                log.permissionError();
                return;
            }
            openPlan(-1);
        }

        function deletePlan() {
            if (!vm.TORLIDEGENKOLTSTERV) {
                log.permissionError();
                return;
            }
            var selected = $rootScope.getSelectedItems(grid);
            if (selected.length != 1) {
                log.errorMsg(gettextCatalog.getString('SelectAPlanToDelete'));
            } else if (selected.length == 1) {
                swal({
                    title: gettextCatalog.getString('Are you sure you want to delete the selected away budget Plan?'),
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#DD6B55',
                    confirmButtonText: gettextCatalog.getString('Yes'),
                    cancelButtonText: gettextCatalog.getString('Cancel'),
                    closeOnConfirm: true,
                    closeOnCancel: true
                }).then(function (isConfirm) {
                    if (isConfirm.value) {
                        return dataservice.deleteAwayBudgetPlan(selected[0].Id).then(function () {
                            search();
                            log.infoMsg(gettextCatalog.getString('PlanDeleted'));
                        });
                    }
                }, function () {
                });
            }
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.administration.awayBudgetPlan.awayBudgetPlanList')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'administration.awayBudgetPlan.awayBudgetPlanList',
                config: {
                    url: '/awayBudgetPlanList',
                    templateUrl: 'app/administration/awayBudgetPlan/awayBudgetPlanList/awayBudgetPlanList.html',
                    controller: 'AwayBudgetPlanListController',
                    controllerAs: 'vm',
                    title: 'AwayBudgetPlanList',
                    settings: {
                        navId: 2122,
                        level: 2,
                        order: 12,
                        orderTitle_hu: 'Idegenbeli költségvetési terv lista',
                        orderTitle_en: 'Away Budget Plan',
                        parentId: 2,
                        content: 'AwayBudgetPlanList',
                        activatorPermission: '"MEGTIDEGENKOLTSTERV"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular .module('app.administration.competitiveMonthlyPlan')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'administration.competitiveMonthlyPlan',
                config: {
                    url: '/competitiveMonthlyPlan',
                    templateUrl: 'app/administration/competitiveMonthlyPlan/competitiveMonthlyPlan.html',
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    CompetitiveMonthlyPlanListController.$inject = ["dataservice", "log", "$q", "$state", "gettextCatalog", "paramHelper", "$scope", "authenticationService", "$filter", "$timeout", "$rootScope"];
    angular
        .module('app.administration.competitiveMonthlyPlan.competitiveMonthlyPlanList')
        .controller('CompetitiveMonthlyPlanListController', CompetitiveMonthlyPlanListController);

    function CompetitiveMonthlyPlanListController(dataservice, log, $q, $state, gettextCatalog, paramHelper, $scope, authenticationService, $filter, $timeout, $rootScope) {
        var vm = this;

        $rootScope.title = gettextCatalog.getString('CompetitiveMonthlyPlanList');
        //grid adatai
        vm.data = [];
        vm.columns = [];

        vm.selectedCoach = undefined;
        vm.coachList = [];
        vm.selectedSection = undefined;
        vm.selectedYear = new Date().getFullYear();
        vm.allowAddNew = {
            team: false,
            individual: false
        };
        vm.sectionList = [];
        vm.years = [];
        for (var ev = 2010; ev <= new Date().getFullYear(); ev++) {
            vm.years.push(ev);
        }
        vm.refreshData = refreshData;

        vm.openText = gettextCatalog.getString('Open');

        // Public functions
        vm.coachChanged = coachChanged;
        vm.yearChanged = yearChanged;
        vm.sectionDataBound = sectionDataBound;
        vm.sectionChanged = sectionChanged;
        vm.goToNewUser = goToNewUser;
        vm.goToCompetitiveMonthlyPlan = goToCompetitiveMonthlyPlan;
        vm.goToNewCompetitiveMonthlyPlan = goToNewCompetitiveMonthlyPlan;
        vm.versernytervTorlese = versernytervTorlese;
        var coachId = -1;
        var sectionId = -1;
        var year = -1;

        vm.columns = [{
            field: 'Id',
            visible: false,
            isPrimaryKey: true,
            isIdentity: true
        }, {
            field: 'Link',
            headerText: '',
            template: '#openDeleteColumnTemplate',
            textAlign: 'center',
            allowEditing: false,
            width: 70
        }, {
            field: 'Edzo',
            headerText: gettextCatalog.getString('Coach'),
            textAlign: 'left',
            allowEditing: false,
            template: '#coachColumnTemplate',
            width: 200
        }, {
            field: 'Szakosztaly',
            headerText: gettextCatalog.getString('Section'),
            textAlign: 'left',
            allowEditing: false,
            width: 150
        }, {
            field: 'Datum',
            headerText: gettextCatalog.getString('Date'),
            textAlign: 'left',
            allowEditing: false,
            width: 120
        }, {
            field: 'Tipus',
            headerText: gettextCatalog.getString('Type'),
            textAlign: 'left',
            allowEditing: false,
            width: 120
        }, {
            field: 'Lezart',
            headerText: gettextCatalog.getString('Closed'),
            textAlign: 'center',
            allowEditing: false,
            displayAsCheckBox: true,
            type: 'boolean',
            width: 120
        }, {
            field: 'Elfogadott',
            headerText: gettextCatalog.getString('Accepted'),
            textAlign: 'center',
            allowEditing: false,
            displayAsCheckBox: true,
            type: 'boolean',
            width: 120
        }, {
            field: 'Megjegyzes',
            headerText: gettextCatalog.getString('Megjegyzes'),
            textAlign: 'left',
            allowEditing: false,
            width: 200
        }];

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItems,
            allowPaging: true,
            allowSorting: true,
            allowExcelExport: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#Grid'), $scope);
                }
            },
            rowSelecting: function () {
                grid.clearSelection();
            },
            checkBoxChange: function (args) {
                $rootScope.checkBoxChangeOnlyOne(args, grid);
            },
            beforePrint: $rootScope.beforePrintGrid,
            printComplete: $rootScope.printCompleteGrid
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        activate();

        function activate() {
            var promises = [paramHelper.getParams([], ['competitiveMonthlyPlan.edzoId', 'competitiveMonthlyPlan.szakosztalyId', 'competitiveMonthlyPlan.korosztalyId', 'competitiveMonthlyPlan.year']),
                getCoaches(),
                authenticationService.getRight('UJHAVIVERST'),
                authenticationService.getRight('HAVIVERSTALAIR1'),
                authenticationService.getRight('HAVIVERSTALAIR2'),
                authenticationService.getRight('MEGTHAVIVERST'),
                authenticationService.getRight('MEGTFELH'),
                authenticationService.getRight('MEGTKOROSZT')
            ];

            return $q.all(promises).then(function (results) {
                angular.element('#maEdzo').ejDropDownList({
                    dataSource: vm.coachList
                });
                if (vm.coachList.length === 1) {
                    vm.selectedCoach = vm.coachList[0].value;
                }
                vm.UJHAVIVERST = results[2];
                vm.HAVIVERSTALAIR1 = results[3];
                vm.HAVIVERSTALAIR2 = results[4];
                vm.MEGTHAVIVERST = results[5];
                vm.MEGTFELH = results[6];
                vm.MEGTKOROSZT = results[7];
                if (!vm.MEGTHAVIVERST) {
                    log.permissionError(true);
                    return;
                }
                if (results[0]['competitiveMonthlyPlan.edzoId']) {
                    vm.selectedCoach = results[0]['competitiveMonthlyPlan.edzoId'];
                }
                if (results[0]['competitiveMonthlyPlan.szakosztalyId']) {
                    vm.selectedSection = results[0]['competitiveMonthlyPlan.szakosztalyId'];
                }
                if (results[0]['competitiveMonthlyPlan.year']) {
                    vm.selectedYear = results[0]['competitiveMonthlyPlan.year'];
                }
                if (vm.selectedCoach || vm.selectedSection || vm.selectedYear) {
                    refreshData();
                }
            });
        }

        function versernytervTorlese(id, SzakosztalyId) {
            swal({
                title: gettextCatalog.getString('Are you sure you want to delete the selected competitive monthly plan?'),
                text: gettextCatalog.getString('You will not be able to recover the plan!'),
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: gettextCatalog.getString('Yes, delete this competitive monthly plan'),
                cancelButtonText: gettextCatalog.getString('Cancel'),
                closeOnConfirm: false,
                closeOnCancel: false
            }).then(function (isConfirm) {
                if (isConfirm.value) {
                    return dataservice.VersenyTervHaviDeleteById(id, SzakosztalyId).then(
                        function () {
                            refreshData();
                        }
                    );
                }
            });
        }

        //edzők lekérése
        function getCoaches() {
            return dataservice.coachSelect().then(
                function (data) {
                    vm.coachList = data.itemsList;
                    return vm.coachList;
                }
            );
        }

        function yearChanged(args) {
            vm.selectedYear = args.value;
            if (vm) {
                refreshData();
            }
            paramHelper.setParams([{'competitiveMonthlyPlan.year': vm.selectedYear}]);
        }

        function coachChanged(args) {
            vm.selectedCoach = args.value;
            vm.sectionList = [];
            vm.ageGroupList = [];
            paramHelper.setParams([{'competitiveMonthlyPlan.edzoId': vm.selectedCoach}]);
            return dataservice.sectionDropDownListWithGroupStatus(vm.selectedCoach).then(
                function (data) {
                    vm.sectionList = data.itemsList;
                }
            );
        }

        function sectionDataBound() {
            if (vm.sectionList.length === 1) {
                angular.element('#maSzakosztaly').ejDropDownList('selectItemByValue', vm.sectionList[0].value);
                vm.selectedSection = vm.sectionList[0].value;
            } else if (vm.selectedSection !== undefined) {
                angular.element('#maSzakosztaly').ejDropDownList('selectItemByValue', vm.selectedSection);
            }
        }

        function sectionChanged(args) {
            vm.selectedSection = args.value;
            vm.allowAddNew = vm.sectionList.find(function (element) {
                return element.value === args.value;
            });
            vm.ageGroupList = [];
            vm.selectedAgeGroup = 0;
            refreshData();
            paramHelper.setParams([{'competitiveMonthlyPlan.szakosztalyId': vm.selectedSection}]);
        }

        function refreshData() {
            if (vm.selectedSection && vm.selectedCoach !== 0 && vm.selectedYear !== 0) {
                sectionId = vm.selectedSection;
                coachId = vm.selectedCoach;
                year = vm.selectedYear;
            } else {
                return;
            }
            dataservice.getCompetitiveMonthlyPlanList(coachId, sectionId, year).then(
                function (data) {
                    data.itemsList = $filter('dateStringFilter')(data.itemsList, 'Honap');
                    $timeout(function () {
                        vm.data = data.itemsList;
                        grid.dataSource = vm.data;
                        $scope.$apply();
                    }, 0);
                }
            );
        }

        function goToNewUser(edzoId) {
            if (!vm.MEGTFELH) {
                log.permissionError();
                return;
            }
            paramHelper.setParams([{
                'competitiveMonthlyPlan.edzoId': vm.selectedCoach
            }, {
                'competitiveMonthlyPlan.szakosztalyId': vm.selectedSection
            }, {
                'newUser.userId': edzoId
            }]);
            $state.go('settings.userManagement.modifyUser');
        }

        function goToCompetitiveMonthlyPlan(competitivePlanId) {
            if (!vm.MEGTHAVIVERST) {
                log.permissionError();
                return;
            }

            var elem = vm.data.filter(function (a) {
                return a.Id == competitivePlanId;
            });
            if (elem.length === 0) {
                return;
            }

            paramHelper.setParams([{
                'competitiveMonthlyPlan.edzoId': elem[0].EdzoId
            }, {
                'competitiveMonthlyPlan.edzoNev': elem[0].Edzo
            }, {
                'competitiveMonthlyPlan.szakosztalyNev': elem[0].Szakosztaly
            }, {
                'competitiveMonthlyPlan.szakosztalyId': elem[0].SzakosztalyId
            }, {
                'competitiveMonthlyPlan.competitivePlanId': elem[0].Id
            },
                {'competitiveMonthlyPlan.egyeni': elem[0].Egyeni}
            ]);
            $state.go('administration.competitiveMonthlyPlan.competitiveMonthlyPlanReport');
        }

        function goToNewCompetitiveMonthlyPlan(arg) {
            if (!vm.UJHAVIVERST) {
                log.permissionError();
                return;
            }
            $scope.$broadcast('submitted');
            if ($scope.form.$valid === false) {
                log.errorMsg(gettextCatalog.getString('RequiredFieldsError'));
                return;
            }
            var egyeni = (arg == 'egyeni');
            var datum = new Date();
            dataservice.ujHaviVersenyeztetesiTerv(datum, vm.selectedSection, vm.selectedCoach, egyeni).then(function (result) {
                datum = result.data;
                paramHelper.setParams([
                    {'competitiveMonthlyPlan.edzoId': vm.selectedCoach},
                    {'competitiveMonthlyPlan.edzoNev': angular.element('#maEdzo').data('ejDropDownList').getSelectedItem()[0].innerText},
                    {'competitiveMonthlyPlan.szakosztalyNev': angular.element('#maSzakosztaly').data('ejDropDownList').getSelectedItem()[0].innerText},
                    {'competitiveMonthlyPlan.szakosztalyId': vm.selectedSection},
                    {'competitiveMonthlyPlan.competitivePlanId': -1},
                    {'competitiveMonthlyPlan.egyeni': egyeni},
                    {'competitiveMonthlyPlan.datum': datum}
                ]);
                $state.go('administration.competitiveMonthlyPlan.competitiveMonthlyPlanReport');
            });
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.administration.competitiveMonthlyPlan.competitiveMonthlyPlanList')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'administration.competitiveMonthlyPlan.competitiveMonthlyPlanList',
                config: {
                    url: '/competitiveMonthlyPlanList',
                    templateUrl: 'app/administration/competitiveMonthlyPlan/competitiveMonthlyPlanList/competitiveMonthlyPlanList.html',
                    controller: 'CompetitiveMonthlyPlanListController',
                    controllerAs: 'vm',
                    title: 'CompetitiveMonthlyPlanList',
                    settings: {
                        navId: 262,
                        level: 2,
                        order: 6,
                        orderTitle_hu: 'Havi versenyeztetési terv',
                        orderTitle_en: 'Monthly Competition Plan',
                        parentId: 2,
                        content: 'CompetitiveMonthlyPlanList',
                        activatorPermission: '"MEGTHAVIVERST"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    TeamsCtrl.$inject = ["dataservice", "log", "$q", "$state", "$rootScope", "gettextCatalog", "authenticationService", "paramHelper", "$scope", "$compile", "$filter", "$timeout"];
    angular
        .module('app.administration.competitiveMonthlyPlan.competitiveMonthlyPlanReport')
        .controller('CompetitiveMonthlyPlanReportController', TeamsCtrl);

    function TeamsCtrl(dataservice, log, $q, $state, $rootScope, gettextCatalog, authenticationService, paramHelper, $scope, $compile, $filter, $timeout) {
        var vm = this;
        $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('CompetitiveMonthlyPlanReport');

        var lang = authenticationService.getAuthData().language;
        moment.locale(lang);

        var gridHasAppended = false;
        // Grid's details
        vm.selectedAgeGroup = undefined;
        vm.ageGroupSelect = ageGroupSelect;
        vm.data = [];
        vm.dataYear = [];
        vm.columnsYear = [];
        vm.stackedHeaderRows = [];
        vm.coachsAgeGroups = [];
        initEvesGrid();

        vm.SzakosztalyNeve = '';
        vm.EdzoNeve = '';
        vm.SzakosztalyId = 0;
        vm.EdzoId = 0;
        vm.MODHAVIVERST = false;
        vm.readOnlyMonthlyPlan = true;
        vm.reportParameters = {};
        //Évek (2010-től az aktuális évig)
        vm.years = [];
        vm.alreadyCreated = false;

        var evIg = new Date().getFullYear();
        var evvege = (new Date().getMonth() >= 9);
        if (evvege) {
            evIg++;
        }
        var year = new Date().getFullYear();
        var month = new Date().getMonth();

        for (var ev = year - 10; ev <= evIg; ev++) {
            vm.years.push({text: ev, value: ev});
        }

        //Hónapok
        vm.months = [
            {text: gettextCatalog.getString('January'), value: 0},
            {text: gettextCatalog.getString('February'), value: 1},
            {text: gettextCatalog.getString('March'), value: 2},
            {text: gettextCatalog.getString('April'), value: 3},
            {text: gettextCatalog.getString('May'), value: 4},
            {text: gettextCatalog.getString('June'), value: 5},
            {text: gettextCatalog.getString('July'), value: 6},
            {text: gettextCatalog.getString('August'), value: 7},
            {text: gettextCatalog.getString('September'), value: 8},
            {text: gettextCatalog.getString('October'), value: 9},
            {text: gettextCatalog.getString('November'), value: 10},
            {text: gettextCatalog.getString('December'), value: 11}
        ];

        vm.individualText = gettextCatalog.getString('Individual');
        vm.teamText = gettextCatalog.getString('Team');

        vm.selectedYear = undefined;
        vm.selectedMonth = undefined;

        //Edzők listája, kiválasztott edző
        vm.coachList = [];
        //Szakosztályok listája, kiválasztott szakosztály
        vm.sectionList = [];
        vm.selectedSection = 0;

        vm.saveButton = false;
        vm.closeButton = false;
        vm.acceptButton = false;
        vm.rejectButton = false;

        vm.egyeni = false;

        vm.noMonthlyPlan = false;
        vm.hasMonthlyPlan = false;
        vm.hasSignedMonthlyPlan = false;
        vm.hasAcceptedMonthlyPlan = false;

        //A szerkesztés alatt álló havi versenyterv
        vm.editedMonthlyPlan = {};

        //Jelenlét hiba volt a mentés során
        vm.hasErrorAtSave = false;
        //Visszautasítás indoka kerül bele
        vm.rejectMonthlyPlanText = '';

        vm.coachDataBound = coachDataBound;
        vm.deletePlan = deletePlan;
        vm.closeMonthlyPlan = closeMonthlyPlan;
        vm.acceptMonthlyPlan = acceptMonthlyPlan;
        vm.rejectMonthlyPlan = rejectMonthlyPlan;
        vm.saveMonthlyPlan = saveMonthlyPlan;
        vm.closerejectingWindow = closerejectingWindow;
        vm.rejectMonthlyPlan = rejectMonthlyPlan;
        vm.rejectMonthlyPlanOk = rejectMonthlyPlanOk;
        //vm.lefut = lefut;
        vm.actionBegin = actionBegin;
        vm.printMonthlyPlan = printMonthlyPlan;
        vm.openAthlete = openAthlete;
        vm.openTeam = openTeam;
        vm.cellEdit = cellEdit;
        vm.cellSave = cellSave;

        vm.yearSelect = yearSelect;
        vm.monthSelect = monthSelect;

        vm.selectedRowIndexPopup = -1;
        vm.goToOlderMonthlyCompetitiveReports = goToOlderMonthlyCompetitiveReports;
        vm.closeEarlierCompetitvePlanWindow = closeEarlierCompetitvePlanWindow;
        vm.selectEarlierCompetitvePlanWindow = selectEarlierCompetitvePlanWindow;

        vm.dataPopup = [];

        vm.Id = 0;
        vm.editedRowId = 0;
        var coachId = -1;
        var sectionId = -1;
        var reopen = false;
        var newplan = false;

        var printOpenedCS = false;
        var printOpenedE = false;

        vm.AthleteUnderEditing = '';
        vm.AthleteUnderEditingText = gettextCatalog.getString('ActualAthlete');
        vm.editedColumnName = '';
        vm.CopyCellToColumn = CopyCellToColumn;

        vm.dateTimeEditorTemplate = {
            create: function () {
                vm.elem = document.createElement('input');
                vm.elem.addEventListener('focus', function () {
                    this.select();
                });
                return vm.elem;
            },
            read: function () {
                return vm.maskObject.getMaskedValue();
            },
            destroy: function () {
                if (vm.maskObject != null) {
                    vm.maskObject.destroy();
                }
            },
            write: function (args) {
                vm.maskObject = new ej2.inputs.MaskedTextBox({
                    minWidth: '100%',
                    mask: '>0000.00.00.',
                    value: args.rowData[args.column.field],
                    readOnly: vm.readOnlyMonthlyPlan,
                });
                vm.editedRowId = args.rowData['Id'];
                $compile(args.element[0])($scope);
                vm.maskObject.appendTo(vm.elem);
            }
        };

        vm.columns = [];
        vm.columnsPopup = [];
        var columnsSet = -1;

        activate();
        refreshGrid();

        function EdzoKorcsoportjai(EdzoId) {
            dataservice.getEdzoKorcsoportjai(EdzoId).then(function (data) {
                vm.coachsAgeGroups = data.itemsList;
            });
        }

        function ageGroupSelect(arg) {
            vm.selectedAgeGroup = arg.value;
            VersenyTervTablazat(vm.EdzoId, vm.selectedAgeGroup, vm.selectedMonth);
        }

        function VersenyTervTablazat(edzo, korcsoport, honap) {
            initEvesGrid();
            dataservice.annualSeasponPlanTableListSelect2(edzo, korcsoport, honap)
                .then(function (data) {
                    vm.dataYear = data.itemsList;
                    gridSearch.dataSource = vm.dataYear;
                });
        }

        vm.columns = [
            {field: 'Id', visible: false, isPrimaryKey: true, isIdentity: true},
            {field: 'RowNumber', headerText: '', textAlign: 'center', width: 40, allowEditing: false},
            {
                field: 'KorosztalySportolo',
                headerText: gettextCatalog.getString('Korosztály, sportoló'),
                textAlign: 'left',
                allowEditing: false,
                width: 175,
                //template: '#cmpropenathlete'
            },
            {
                field: 'KorosztalyCsapat',
                headerText: gettextCatalog.getString('AgeGroupTeam'),
                textAlign: 'left',
                allowEditing: false,
                width: 175,
            },
            {
                field: 'Merkozes1',
                headerText: gettextCatalog.getString('Verseny') + ' 1',
                textAlign: 'left',
                width: 150,
                //allowEditing: !vm.readOnlyMonthlyPlan
                //editTemplate: vm.editTextTemplate('Merkozes1')
            },
            {
                field: 'Versenyszam1',
                headerText: gettextCatalog.getString('Versenyszam') + ' 1',
                textAlign: 'left',
                width: 150,
                //allowEditing: !vm.readOnlyMonthlyPlan
                //editTemplate: vm.editTextTemplate('Versenyszam1')
            },
            {
                field: 'Helyszin1',
                headerText: gettextCatalog.getString('Helyszin') + ' 1',
                textAlign: 'left',
                width: 150,
                //allowEditing: !vm.readOnlyMonthlyPlan
                //editTemplate: vm.editTextTemplate('Helyszin1')
            },
            {
                field: 'Eredmeny1',
                headerText: gettextCatalog.getString('VarhEredm') + ' 1',
                textAlign: 'left',
                width: 150,
                //allowEditing: !vm.readOnlyMonthlyPlan
                //editTemplate: vm.editTextTemplate('Eredmeny1')
            },
            {
                field: 'DatumTol1',
                headerText: gettextCatalog.getString('DatumTol') + ' 1',
                textAlign: 'left',
                width: 90,
                edit: vm.dateTimeEditorTemplate,
                //allowEditing: !vm.readOnlyMonthlyPlan
            },
            {
                field: 'DatumIg1',
                headerText: gettextCatalog.getString('DatumIg') + ' 1',
                textAlign: 'left',
                width: 90,
                edit: vm.dateTimeEditorTemplate,
                //allowEditing: !vm.readOnlyMonthlyPlan
            },
            {
                field: 'Merkozes2',
                headerText: gettextCatalog.getString('Verseny') + ' 2',
                textAlign: 'left',
                width: 150,
                //allowEditing: !vm.readOnlyMonthlyPlan
                //editTemplate: vm.editTextTemplate('Merkozes2')
            },
            {
                field: 'Versenyszam2',
                headerText: gettextCatalog.getString('Versenyszam') + ' 2',
                textAlign: 'left',
                width: 150,
                //allowEditing: !vm.readOnlyMonthlyPlan
                //editTemplate: vm.editTextTemplate('Versenyszam2')
            },
            {
                field: 'Helyszin2',
                headerText: gettextCatalog.getString('Helyszin') + ' 2',
                textAlign: 'left',
                width: 150,
                //allowEditing: !vm.readOnlyMonthlyPlan
                //editTemplate: vm.editTextTemplate('Helyszin2')
            },
            {
                field: 'Eredmeny2',
                headerText: gettextCatalog.getString('VarhEredm') + ' 2',
                textAlign: 'left',
                width: 150,
                //allowEditing: !vm.readOnlyMonthlyPlan
                //editTemplate: vm.editTextTemplate('Eredmeny2')
            },
            {
                field: 'DatumTol2',
                headerText: gettextCatalog.getString('DatumTol') + ' 2',
                textAlign: 'left',
                width: 90,
                //allowEditing: !vm.readOnlyMonthlyPlan,
                edit: vm.dateTimeEditorTemplate
            },
            {
                field: 'DatumIg2',
                headerText: gettextCatalog.getString('DatumIg') + ' 2',
                textAlign: 'left',
                width: 90,
                //allowEditing: !vm.readOnlyMonthlyPlan,
                edit: vm.dateTimeEditorTemplate
            },
            {
                field: 'Merkozes3',
                headerText: gettextCatalog.getString('Verseny') + ' 3',
                textAlign: 'left',
                width: 150,
                //allowEditing: !vm.readOnlyMonthlyPlan
                //editTemplate: vm.editTextTemplate('Merkozes3')
            },
            {
                field: 'Versenyszam3',
                headerText: gettextCatalog.getString('Versenyszam') + ' 3',
                textAlign: 'left',
                width: 150,
                //allowEditing: !vm.readOnlyMonthlyPlan
                //editTemplate: vm.editTextTemplate('Versenyszam3')
            },
            {
                field: 'Helyszin3',
                headerText: gettextCatalog.getString('Helyszin') + ' 3',
                textAlign: 'left',
                width: 150,
                //allowEditing: !vm.readOnlyMonthlyPlan
                //editTemplate: vm.editTextTemplate('Helyszin3')
            },
            {
                field: 'Eredmeny3',
                headerText: gettextCatalog.getString('VarhEredm') + ' 3',
                textAlign: 'left',
                width: 150,
                //allowEditing: !vm.readOnlyMonthlyPlan
                //editTemplate: vm.editTextTemplate('Eredmeny3')
            },
            {
                field: 'DatumTol3',
                headerText: gettextCatalog.getString('DatumTol') + ' 3',
                textAlign: 'left',
                width: 90,
                //allowEditing: !vm.readOnlyMonthlyPlan,
                edit: vm.dateTimeEditorTemplate
            },
            {
                field: 'DatumIg3',
                headerText: gettextCatalog.getString('DatumIg') + ' 3',
                textAlign: 'left',
                width: 90,
                //allowEditing: !vm.readOnlyMonthlyPlan,
                edit: vm.dateTimeEditorTemplate
            },
            {
                field: 'Merkozes4',
                headerText: gettextCatalog.getString('Verseny') + ' 4',
                textAlign: 'left',
                width: 150,
                //allowEditing: !vm.readOnlyMonthlyPlan
                //editTemplate: vm.editTextTemplate('Merkozes4')
            },
            {
                field: 'Versenyszam4',
                headerText: gettextCatalog.getString('Versenyszam') + ' 4',
                textAlign: 'left',
                width: 150,
                //allowEditing: !vm.readOnlyMonthlyPlan
                //editTemplate: vm.editTextTemplate('Versenyszam4')
            },
            {
                field: 'Helyszin4',
                headerText: gettextCatalog.getString('Helyszin') + ' 4',
                textAlign: 'left',
                width: 150,
                //allowEditing: !vm.readOnlyMonthlyPlan
                //editTemplate: vm.editTextTemplate('Helyszin4')
            },
            {
                field: 'Eredmeny4',
                headerText: gettextCatalog.getString('VarhEredm') + ' 4',
                textAlign: 'left',
                width: 150,
                //allowEditing: !vm.readOnlyMonthlyPlan
                //editTemplate: vm.editTextTemplate('Eredmeny4')
            },
            {
                field: 'DatumTol4',
                headerText: gettextCatalog.getString('DatumTol') + ' 4',
                textAlign: 'left',
                width: 90,
                edit: vm.dateTimeEditorTemplate,
                //allowEditing: !vm.readOnlyMonthlyPlan
            },
            {
                field: 'DatumIg4',
                headerText: gettextCatalog.getString('DatumIg') + ' 4',
                textAlign: 'left',
                width: 90,
                edit: vm.dateTimeEditorTemplate,
                //allowEditing: !vm.readOnlyMonthlyPlan
            },
            {
                field: 'Merkozes5',
                headerText: gettextCatalog.getString('Verseny') + ' 5',
                textAlign: 'left',
                width: 150,
                //allowEditing: !vm.readOnlyMonthlyPlan
                //editTemplate: vm.editTextTemplate('Merkozes5')
            },
            {
                field: 'Versenyszam5',
                headerText: gettextCatalog.getString('Versenyszam') + ' 5',
                textAlign: 'left',
                width: 150,
                //allowEditing: !vm.readOnlyMonthlyPlan
                //editTemplate: vm.editTextTemplate('Versenyszam5')
            },
            {
                field: 'Helyszin5',
                headerText: gettextCatalog.getString('Helyszin') + ' 5',
                textAlign: 'left',
                width: 150,
                //allowEditing: !vm.readOnlyMonthlyPlan
                //editTemplate: vm.editTextTemplate('Helyszin5')
            },
            {
                field: 'Eredmeny5',
                headerText: gettextCatalog.getString('VarhEredm') + ' 5',
                textAlign: 'left',
                width: 150,
                //allowEditing: !vm.readOnlyMonthlyPlan
                //editTemplate: vm.editTextTemplate('Eredmeny5')
            },
            {
                field: 'DatumTol5',
                headerText: gettextCatalog.getString('DatumTol') + ' 5',
                textAlign: 'left',
                width: 90,
                edit: vm.dateTimeEditorTemplate,
                // allowEditing: !vm.readOnlyMonthlyPlan
            },
            {
                field: 'DatumIg5',
                headerText: gettextCatalog.getString('DatumIg') + ' 5',
                textAlign: 'left',
                width: 90,
                edit: vm.dateTimeEditorTemplate,
                //allowEditing: !vm.readOnlyMonthlyPlan
            },
            {
                field: 'Merkozes6',
                headerText: gettextCatalog.getString('Verseny') + ' 6',
                textAlign: 'left',
                width: 150,
                //allowEditing: !vm.readOnlyMonthlyPlan
                //editTemplate: vm.editTextTemplate('Merkozes6')
            },
            {
                field: 'Versenyszam6',
                headerText: gettextCatalog.getString('Versenyszam') + ' 6',
                textAlign: 'left',
                width: 150,
                //allowEditing: !vm.readOnlyMonthlyPlan
                //editTemplate: vm.editTextTemplate('Versenyszam6')
            },
            {
                field: 'Helyszin6',
                headerText: gettextCatalog.getString('Helyszin') + ' 6',
                textAlign: 'left',
                width: 150,
                //allowEditing: !vm.readOnlyMonthlyPlan
                //editTemplate: vm.editTextTemplate('Helyszin6')
            },
            {
                field: 'Eredmeny6',
                headerText: gettextCatalog.getString('VarhEredm') + ' 6',
                textAlign: 'left',
                width: 150,
                //allowEditing: !vm.readOnlyMonthlyPlan
                //editTemplate: vm.editTextTemplate('Eredmeny6')
            },
            {
                field: 'DatumTol6',
                headerText: gettextCatalog.getString('DatumTol') + ' 6',
                textAlign: 'left',
                width: 90,
                edit: vm.dateTimeEditorTemplate,
                //allowEditing: !vm.readOnlyMonthlyPlan
            },
            {
                field: 'DatumIg6',
                headerText: gettextCatalog.getString('DatumIg') + ' 6',
                textAlign: 'left',
                width: 90,
                edit: vm.dateTimeEditorTemplate,
                //allowEditing: !vm.readOnlyMonthlyPlan
            },
            {
                field: 'Merkozes7',
                headerText: gettextCatalog.getString('Verseny') + ' 7',
                textAlign: 'left',
                width: 150,
                //allowEditing: !vm.readOnlyMonthlyPlan
                //editTemplate: vm.editTextTemplate('Merkozes7')
            },
            {
                field: 'Versenyszam7',
                headerText: gettextCatalog.getString('Versenyszam') + ' 7',
                textAlign: 'left',
                width: 150,
                //allowEditing: !vm.readOnlyMonthlyPlan
                //editTemplate: vm.editTextTemplate('Versenyszam7')
            },
            {
                field: 'Helyszin7',
                headerText: gettextCatalog.getString('Helyszin') + ' 7',
                textAlign: 'left',
                width: 150,
                //allowEditing: !vm.readOnlyMonthlyPlan
                //editTemplate: vm.editTextTemplate('Helyszin7')
            },
            {
                field: 'Eredmeny7',
                headerText: gettextCatalog.getString('VarhEredm') + ' 7',
                textAlign: 'left',
                width: 150,
                //allowEditing: !vm.readOnlyMonthlyPlan
                //editTemplate: vm.editTextTemplate('Eredmeny7')
            },
            {
                field: 'DatumTol7',
                headerText: gettextCatalog.getString('DatumTol') + ' 7',
                textAlign: 'left',
                width: 90,
                edit: vm.dateTimeEditorTemplate,
                //allowEditing: !vm.readOnlyMonthlyPlan
            },
            {
                field: 'DatumIg7',
                headerText: gettextCatalog.getString('DatumIg') + ' 7',
                textAlign: 'left',
                width: 90,
                edit: vm.dateTimeEditorTemplate,
                //allowEditing: !vm.readOnlyMonthlyPlan
            },
            {
                field: 'Merkozes8',
                headerText: gettextCatalog.getString('Verseny') + ' 8',
                textAlign: 'left',
                width: 150,
                //allowEditing: !vm.readOnlyMonthlyPlan
                //editTemplate: vm.editTextTemplate('Merkozes8')
            },
            {
                field: 'Versenyszam8',
                headerText: gettextCatalog.getString('Versenyszam') + ' 8',
                textAlign: 'left',
                width: 150,
                //allowEditing: !vm.readOnlyMonthlyPlan
                //editTemplate: vm.editTextTemplate('Versenyszam8')
            },
            {
                field: 'Helyszin8',
                headerText: gettextCatalog.getString('Helyszin') + ' 8',
                textAlign: 'left',
                width: 150,
                //allowEditing: !vm.readOnlyMonthlyPlan
                //editTemplate: vm.editTextTemplate('Helyszin8')
            },
            {
                field: 'Eredmeny8',
                headerText: gettextCatalog.getString('VarhEredm') + ' 8',
                textAlign: 'left',
                width: 150,
                //allowEditing: !vm.readOnlyMonthlyPlan
                //editTemplate: vm.editTextTemplate('Eredmeny8')
            },
            {
                field: 'DatumTol8',
                headerText: gettextCatalog.getString('DatumTol') + ' 8',
                textAlign: 'left',
                width: 90,
                edit: vm.dateTimeEditorTemplate,
                //allowEditing: !vm.readOnlyMonthlyPlan
            },
            {
                field: 'DatumIg8',
                headerText: gettextCatalog.getString('DatumIg') + ' 8',
                textAlign: 'left',
                width: 90,
                edit: vm.dateTimeEditorTemplate,
                //allowEditing: !vm.readOnlyMonthlyPlan
            }
        ];

        var gridNew = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItems,
            allowPaging: false,
            allowTextWrap: true,
            allowExcelExport: true,
            editSettings: {allowEditing: true, mode: 'Batch', showConfirmDialog: false},
            locale: 'hu-HU',
            gridLines: 'Both',
            columns: vm.columns,
            cellSave: vm.cellSave,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            rowSelected: vm.gridRowSelected,
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#GridNew'), $scope);
                }
            },
            cellEdit: function (arg) {
                vm.AthleteUnderEditing = arg.rowData.SportoloId != null ? arg.rowData.KorosztalySportolo : arg.rowData.KorosztalyCsapat;
                vm.editedColumnName = arg.columnName;
                $timeout(function () {
                    $scope.$apply();
                }, 0);
            }
        });
        gridNew.appendTo('#GridNew');
        gridNew.keyConfigs.escape = '';
        gridNew.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, gridNew);
        };

        var gridSearch = new ej2.grids.Grid({
            dataSource: [],
            editSettings: {allowEditing: false},
            allowTextWrap: true,
            allowSorting: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            height: 200,
            columns: vm.columnsYear,
            stackedHeaderRows: vm.stackedHeaderRows,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile(angular.element('#GridYear'), $scope);
                }
            }
        });
        gridSearch.appendTo('#GridYear');
        gridSearch.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, gridSearch);
        };

        var gridPopup = new ej2.grids.Grid({
            dataSource: [],
            editSettings: {allowEditing: false},
            allowTextWrap: true,
            allowSorting: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            height: 200,
            columns: vm.columnsPopup,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile(angular.element('#GridPopup'), $scope);
                }
            }
        });
        gridPopup.appendTo('#GridPopup');
        gridPopup.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, gridPopup);
        };

        function activate() {
            // $scope.$watch('vm.data', function (args) {
            //     //console.log('watcher: ', args);
            // });
            // $scope.$watch('vm.editedMonthlyPlan.tetelek', function (args) {
            //     //console.log('watcher tetelek: ', args);
            // });

            $q.all([paramHelper.getParams([], ['competitiveMonthlyPlan.competitivePlanId', 'competitiveMonthlyPlan.szakosztalyId', 'competitiveMonthlyPlan.szakosztalyNev', 'competitiveMonthlyPlan.edzoId', 'competitiveMonthlyPlan.edzoNev', 'competitiveMonthlyPlan.egyeni', 'competitiveMonthlyPlan.datum']),
                    authenticationService.getRight('EDZO'),
                    authenticationService.getRight('ADMIN'),
                    authenticationService.getRight('SZAKOSZTVEZ'),
                    authenticationService.getRight('TECHIGAZGATO'),
                    authenticationService.getRight('HAVIVERSTALAIR1'),
                    authenticationService.getRight('HAVIVERSTALAIR2'),
                    authenticationService.getRight('UJHAVIVERST'),
                    authenticationService.getRight('MEGTSPORTLIST'),
                    authenticationService.getRight('MEGTHAVIVERST'),
                    authenticationService.getRight('TORLHAVIVERS'),
                    authenticationService.getRight('MODHAVIVERST')
                ])
                .then(function (results) {
                    if (!results[9]) {
                        log.permissionError(true);
                    } else {
                        //VersenyTervTablazat();

                        $timeout(function () {
                            vm.EDZO = results[1];
                            vm.ADMIN = results[2];
                            vm.SZAKOSZTVEZ = results[3];
                            vm.TECHIGAZGATO = results[4];
                            vm.HAVIVERSTALAIR1 = results[5];
                            vm.HAVIVERSTALAIR2 = results[6];
                            vm.UJHAVIVERST = results[7];
                            vm.MEGTSPORTLIST = results[8];
                            vm.MEGTHAVIJEL = results[9];
                            vm.TORLHAVIVERS = results[10];
                            vm.MODHAVIVERST = results[11];

                            if (results[0]['competitiveMonthlyPlan.szakosztalyNev']) {
                                vm.SzakosztalyNeve = results[0]['competitiveMonthlyPlan.szakosztalyNev'];
                            }
                            if (results[0]['competitiveMonthlyPlan.edzoNev']) {
                                vm.EdzoNeve = results[0]['competitiveMonthlyPlan.edzoNev'];
                            }
                            if (results[0]['competitiveMonthlyPlan.szakosztalyId']) {
                                vm.SzakosztalyId = results[0]['competitiveMonthlyPlan.szakosztalyId'];
                            }
                            vm.egyeni = false;
                            if (results[0]['competitiveMonthlyPlan.egyeni'] != undefined) {
                                vm.egyeni = results[0]['competitiveMonthlyPlan.egyeni'];
                                if (vm.egyeni) {
                                    vm.columns[3].visible = false;
                                    vm.columns[2].visible = true;
                                } else {
                                    vm.columns[2].visible = false;
                                    vm.columns[3].visible = true;
                                }
                                gridNew.refresh();
                            }
                            if (results[0]['competitiveMonthlyPlan.edzoId']) {
                                vm.EdzoId = results[0]['competitiveMonthlyPlan.edzoId'];
                                EdzoKorcsoportjai(vm.EdzoId);
                            }

                            //létezőt nyit vissza
                            if (results[0]['competitiveMonthlyPlan.competitivePlanId'] && results[0]['competitiveMonthlyPlan.competitivePlanId'] !== -1) {
                                paramHelper.removeParam('competitiveMonthlyPlan.competitivePlanId');
                                reopen = true;
                                dataservice.monthlyPlanSelectById(results[0]['competitiveMonthlyPlan.competitivePlanId'], results[0]['competitiveMonthlyPlan.szakosztalyId'], vm.egyeni)
                                    .then(function (data) {
                                        viewMonthlyPlan(data);
                                        var date = data.fej.Datum.split('-');
                                        $timeout(function () {
                                            var Datum = new Date(date[0], date[1] - 1, 1, 0, 0, 0);
                                            angular.element('#maEv').ejDropDownList('selectItemByValue', Datum.getFullYear());
                                            angular.element('#maHonap').ejDropDownList('selectItemByValue', Datum.getMonth());
                                            $scope.$apply();
                                        }, 100);
                                        vm.defaultSection = vm.editedMonthlyPlan.fej.IdSzakosztaly;
                                        sectionId = vm.editedMonthlyPlan.fej.IdSzakosztaly;
                                        vm.defaultCoach = vm.editedMonthlyPlan.fej.IdEdzo;
                                        coachId = vm.editedMonthlyPlan.fej.IdEdzo;
                                        vm.editedMonthlyPlan.fej.SzakosztalyNeve = data.fej.SzakosztalyNeve;
                                        vm.editedMonthlyPlan.fej.EdzoNeve = data.fej.EdzoNeve;
                                        vm.Id = vm.editedMonthlyPlan.fej.Id;
                                    });
                                //új versenyeztetési terv
                            } else {
                                newplan = true;
                                vm.noMonthlyPlan = true;
                                vm.editedMonthlyPlan = {};
                                vm.editedMonthlyPlan.fej = {};
                                vm.editedMonthlyPlan.fej.Id = -1;
                                vm.editedMonthlyPlan.fej.Tipus = vm.egyeni;
                                if (results[0]['competitiveMonthlyPlan.szakosztalyNev']) {
                                    vm.editedMonthlyPlan.fej.SzakosztalyNeve = results[0]['competitiveMonthlyPlan.szakosztalyNev'];
                                }
                                if (results[0]['competitiveMonthlyPlan.edzoNev']) {
                                    vm.editedMonthlyPlan.fej.EdzoNeve = results[0]['competitiveMonthlyPlan.edzoNev'];
                                }
                                if (results[0]['competitiveMonthlyPlan.szakosztalyId']) {
                                    vm.editedMonthlyPlan.fej.SzakosztalyId = results[0]['competitiveMonthlyPlan.szakosztalyId'];
                                }
                                if (results[0]['competitiveMonthlyPlan.edzoId']) {
                                    vm.EdzoId = results[0]['competitiveMonthlyPlan.edzoId'];
                                    vm.editedMonthlyPlan.fej.EdzoId = results[0]['competitiveMonthlyPlan.edzoId'];
                                    EdzoKorcsoportjai(vm.EdzoId);
                                }
                                $timeout(function () {
                                    var datum = new Date(results[0]['competitiveMonthlyPlan.datum']);
                                    vm.selectedYear = datum.getFullYear();
                                    vm.selectedMonth = datum.getMonth();
                                    vm.editedMonthlyPlan.fej.Datum = moment({
                                        y: vm.selectedYear,
                                        M: vm.selectedMonth,
                                        d: 1
                                    }).format('YYYY-MM-DD');
                                    vm.editedMonthlyPlan.fej.Vegleges = false;
                                    viewMonthlyPlan(vm.editedMonthlyPlan);
                                    $scope.$apply();
                                }, 0);
                                // selectByDate(); // Ha az adott hónapra már van terv, akkor azt tölti vissza
                            }
                        }, 0);
                    }
                });
        }

        function actionBegin(args) {
            if (args.requestType && (args.requestType === 'paging' || args.requestType === 'sorting')) {
                args.cancel = true;
                gridNew.editModule.batchSave();
            }
        }

        function viewMonthlyPlan(data) {
            vm.editedMonthlyPlan = data;
            vm.editedMonthlyPlan.tetelek = $filter('dateStringFilter')(vm.editedMonthlyPlan.tetelek, 'DatumTol1');
            vm.editedMonthlyPlan.tetelek = $filter('dateStringFilter')(vm.editedMonthlyPlan.tetelek, 'DatumTol2');
            vm.editedMonthlyPlan.tetelek = $filter('dateStringFilter')(vm.editedMonthlyPlan.tetelek, 'DatumTol3');
            vm.editedMonthlyPlan.tetelek = $filter('dateStringFilter')(vm.editedMonthlyPlan.tetelek, 'DatumTol4');
            vm.editedMonthlyPlan.tetelek = $filter('dateStringFilter')(vm.editedMonthlyPlan.tetelek, 'DatumTol5');
            vm.editedMonthlyPlan.tetelek = $filter('dateStringFilter')(vm.editedMonthlyPlan.tetelek, 'DatumTol6');
            vm.editedMonthlyPlan.tetelek = $filter('dateStringFilter')(vm.editedMonthlyPlan.tetelek, 'DatumTol7');
            vm.editedMonthlyPlan.tetelek = $filter('dateStringFilter')(vm.editedMonthlyPlan.tetelek, 'DatumTol8');

            vm.editedMonthlyPlan.tetelek = $filter('dateStringFilter')(vm.editedMonthlyPlan.tetelek, 'DatumIg1');
            vm.editedMonthlyPlan.tetelek = $filter('dateStringFilter')(vm.editedMonthlyPlan.tetelek, 'DatumIg2');
            vm.editedMonthlyPlan.tetelek = $filter('dateStringFilter')(vm.editedMonthlyPlan.tetelek, 'DatumIg3');
            vm.editedMonthlyPlan.tetelek = $filter('dateStringFilter')(vm.editedMonthlyPlan.tetelek, 'DatumIg4');
            vm.editedMonthlyPlan.tetelek = $filter('dateStringFilter')(vm.editedMonthlyPlan.tetelek, 'DatumIg5');
            vm.editedMonthlyPlan.tetelek = $filter('dateStringFilter')(vm.editedMonthlyPlan.tetelek, 'DatumIg6');
            vm.editedMonthlyPlan.tetelek = $filter('dateStringFilter')(vm.editedMonthlyPlan.tetelek, 'DatumIg7');
            vm.editedMonthlyPlan.tetelek = $filter('dateStringFilter')(vm.editedMonthlyPlan.tetelek, 'DatumIg8');

            vm.noMonthlyPlan = false;
            vm.hasAcceptedMonthlyPlan = false;
            vm.hasSignedMonthlyPlan = false;
            vm.hasMonthlyPlan = false;
            // UJ
            if (!vm.editedMonthlyPlan.fej || vm.editedMonthlyPlan.fej.Id < 0) {
                vm.acceptButton = false;
                vm.rejectButton = false;
                vm.noMonthlyPlan = true;
                if ((vm.ADMIN || vm.SZAKOSZTVEZ) && vm.UJHAVIVERST) {
                    vm.saveButton = true;
                    vm.closeButton = true;
                } else if (vm.EDZO && vm.UJHAVIVERST) {
                    vm.saveButton = true;
                    vm.closeButton = true;
                } else {
                    vm.saveButton = false;
                    vm.closeButton = false;
                }
                // if(vm.selectedMonth) {
                //     createNewMonthlyPlan();
                //     refreshGrid();
                // }
                // LETEZO
            } else {
                if (vm.editedMonthlyPlan.fej.Vegleges) {
                    if (vm.editedMonthlyPlan.fej.SzakosztalyVezetoId) {
                        vm.hasAcceptedMonthlyPlan = true;
                        vm.saveButton = false;
                        vm.closeButton = false;
                        vm.acceptButton = false;
                        vm.rejectButton = false;
                    } else {
                        vm.hasSignedMonthlyPlan = true;
                        if (vm.UJHAVIVERST) {
                            vm.saveButton = false;
                            vm.closeButton = false;
                        }
                        if ((vm.ADMIN || vm.SZAKOSZTVEZ) && vm.HAVIVERSTALAIR1) {
                            vm.acceptButton = true;
                            vm.rejectButton = true;
                        } else {
                            vm.acceptButton = false;
                            vm.rejectButton = false;
                        }
                    }
                } else {
                    vm.hasMonthlyPlan = true;
                    vm.acceptButton = false;
                    vm.rejectButton = false;
                    if ((vm.ADMIN || vm.SZAKOSZTVEZ) && vm.MODHAVIVERST) {
                        vm.saveButton = true;
                        vm.closeButton = true;
                    } else if (vm.EDZO && vm.MODHAVIVERST) {
                        vm.saveButton = true;
                        vm.closeButton = true;
                    } else {
                        vm.saveButton = false;
                        vm.closeButton = false;
                    }
                }
                vm.data = vm.editedMonthlyPlan.tetelek;
            }

            vm.readOnlyMonthlyPlan = !vm.saveButton;
            gridNew.editSettings.allowEditing = !vm.readOnlyMonthlyPlan;

            if (vm.editedMonthlyPlan.fej) {
                vm.leadvaStr = $filter('dateStringFilter')(vm.editedMonthlyPlan.fej.Leadva);
                vm.elfogadvaStr = $filter('dateStringFilter')(vm.editedMonthlyPlan.fej.Elfogadas1);
            }
            refreshGrid();
        }

        function refreshGrid() {
            //vm.columns = [];

            if (gridNew) {
                gridNew.columns = vm.columns;
                gridNew.dataSource = vm.data; //[{Id: 1, RowNumber:1}, {Id: 2, RowNumber:2}];
            }

            vm.columnsPopup = [];
            vm.columnsPopup = [{
                field: 'Id',
                visible: false,
                isPrimaryKey: true,
                isIdentity: true
            },
                {
                    field: 'Szakosztaly',
                    headerText: gettextCatalog.getString('Section'),
                    textAlign: 'center',
                    width: 100,
                    allowEditing: false
                },
                {
                    field: 'Edzo',
                    headerText: gettextCatalog.getString('Trainer'),
                    textAlign: 'center',
                    width: 100,
                    allowEditing: false
                },
                {
                    field: 'Megjegyzes',
                    headerText: gettextCatalog.getString('Comment'),
                    textAlign: 'center',
                    width: 150,
                    allowEditing: false
                },
                {
                    field: 'Datum',
                    headerText: gettextCatalog.getString('Date'),
                    textAlign: 'center',
                    width: 100,
                    allowEditing: false
                }
            ];
        }

        function createNewMonthlyPlan() {
            if (vm.editedMonthlyPlan.fej.SzakosztalyId) {
                sectionId = vm.editedMonthlyPlan.fej.SzakosztalyId;
            }
            if (vm.editedMonthlyPlan.fej.EdzoId) {
                coachId = vm.editedMonthlyPlan.fej.EdzoId;
            }
            // TODO a versenyterven nem szerepelnek csak azok akik 1-én tagok voltak (nem lehete utólag helyesen tölteni)
            // dataservice.getCompetitiveMonthlyPlanItems(coachId, sectionId, moment(vm.editedMonthlyPlan.fej.Datum).endOf('month').format('YYYY-MM-DD'), vm.egyeni)
            dataservice.getCompetitiveMonthlyPlanItems(coachId, sectionId, moment(vm.editedMonthlyPlan.fej.Datum).format('YYYY-MM-DD'), vm.egyeni)
                .then(function (data2) {
                    vm.data = data2.itemsList;
                    vm.editedMonthlyPlan.tetelek = vm.data;
                    gridNew.editSettings.allowEditing = true;
                    refreshGrid();
                    //saveMonthlyPlan();
                });
        }

        // Run after data bounded
        function coachDataBound() {
            if (vm.coachList.length === 1) {
                angular.element('#maEdzo').ejDropDownList('selectItemByValue', vm.coachList[0].value);
                vm.selectedCoach = vm.coachList[0].value;
            } else {
                angular.element('#maEdzo').ejDropDownList('selectItemByValue', vm.defaultCoach);
                vm.selectedCoach = vm.defaultCoach;
            }
        }

        function closeMonthlyPlan() {
            $scope.$broadcast('submitted');
            vm.editedMonthlyPlan.fej.Vegleges = true;
            vm.editedMonthlyPlan.fej.Leadva = moment();
            saveMonthlyPlan();
            if (!vm.hasErrorAtSave) {
                vm.readOnlyMonthlyPlan = true;
            }
        }

        function acceptMonthlyPlan() {
            dataservice.monthlyCompetitionPlanAcceptByLeader(vm.editedMonthlyPlan.fej.Id, vm.editedMonthlyPlan.fej.SzakosztalyId, vm.editedMonthlyPlan.fej.Tipus).then(function () {
                log.successMsg('CompetitionPlanAccepted');
                dataservice.monthlyPlanSelectById(vm.editedMonthlyPlan.fej.Id, vm.editedMonthlyPlan.fej.SzakosztalyId, vm.egyeni).then(function (data) {
                    viewMonthlyPlan(data);
                });
            });
        }

        //Havi jelenléti visszautasítása gomb click
        function rejectMonthlyPlan() {
            var dialogObj = angular.element('#rejectAttendanceWindow').data('ejDialog');
            dialogObj.open();
        }

        //Felugró ablak 'Mégsem' gomb click
        function closerejectingWindow() {
            var dialogObj = angular.element('#rejectAttendanceWindow').data('ejDialog');
            dialogObj.close();
        }

        //Felugró ablak 'Rendben' gomb click - visszautasítás elmentése
        function rejectMonthlyPlanOk() {
            if (vm.rejectMonthlyPlanText.length > 0) {
                var dialogObj = angular.element('#rejectAttendanceWindow').data('ejDialog');
                dialogObj.close();
            } else {
                return;
            }
            var uzi = gettextCatalog.getString('SystemMessage') + '<br>' + gettextCatalog.getString('The') + ' ' + vm.editedMonthlyPlan.fej.SzakosztalyNev + ' - ' + ' ' + vm.selectedYear +
                ' ' + vm.months[vm.selectedMonth].text +
                ' ' + gettextCatalog.getString('MonthlyAttendanceReportRejected') + '<br>' + gettextCatalog.getString('Cause') + vm.MonthlyPlanText;

            dataservice.messageSave(uzi, [vm.selectedCoach], vm.selectedSection).then(function () {
                vm.editedMonthlyPlan.fej.Vegleges = false;
                vm.editedMonthlyPlan.fej.Leadva = null;
                vm.editedMonthlyPlan.fej.Elfogadas1 = null;
                vm.editedMonthlyPlan.fej.Elfogadas2 = null;
                vm.editedMonthlyPlan.fej.SzakosztalyVezetoId = null;
                vm.editedMonthlyPlan.fej.GazdasagiId = null;
                saveMonthlyPlan();
                if (!vm.hasErrorAtSave) {
                    vm.readOnlyMonthlyPlan = false;
                }
                viewMonthlyPlan(vm.editedMonthlyPlan);
            });
        }

        function saveMonthlyPlan() {
            $scope.$broadcast('submitted');
            if (gridNew.editSettings.allowEditing) {
                gridNew.editModule.endEdit();
            }
            if ($scope.form.$valid === false) {
                log.errorMsg(gettextCatalog.getString('RequiredFieldsError'));
                return;
            }
            if (!vm.MODHAVIVERST && vm.editedMonthlyPlan.fej.Id > 0) {
                log.permissionError();
                return;
            }
            vm.editedMonthlyPlan.tetelek = vm.data;
            dataservice.saveMonthlyCompetitionPlan(vm.editedMonthlyPlan)
                .then(function (/*id*/) {
                    log.successMsg('aaaaCompetitionPlanSaved');
                    $rootScope.back();
                    /*
                    if (vm.editedMonthlyPlan.fej.Id < 0) {
                        dataservice.monthlyPlanSelectById(id.res, vm.editedMonthlyPlan.fej.SzakosztalyId, vm.egyeni).then(function (data) {
                            viewMonthlyPlan(data);
                        });
                    }
                    */
                });
        }

        vm.yearDatabound = function () {
            $timeout(function () {
                vm.selectedYear = year;
                angular.element('#maEv').ejDropDownList('selectItemByValue', vm.selectedYear);
            }, 0);
        };

        function yearSelect(args) {
            if (!vm.editedMonthlyPlan || !vm.editedMonthlyPlan.fej || !vm.editedMonthlyPlan.fej.Datum) {
                return;
            }
            if (vm.selectedYear != args.value) {
                vm.alreadyCreated = false;
            }
            vm.selectedYear = args.value;
            vm.editedMonthlyPlan.fej.Datum = moment(vm.editedMonthlyPlan.fej.Datum).year(vm.selectedYear).format('YYYY-MM-DD');
        }

        vm.monthDatabound = function () {
            $timeout(function () {
                vm.selectedMonth = month;
                angular.element('#maHonap').ejDropDownList('selectItemByValue', vm.selectedMonth);
            }, 0);
        };

        function monthSelect(args) {
            if (!vm.editedMonthlyPlan || !vm.editedMonthlyPlan.fej || !vm.editedMonthlyPlan.fej.Datum) {
                return;
            }
            if (vm.selectedMonth != args.value) {
                vm.alreadyCreated = false;
            }
            vm.selectedMonth = args.value;

            vm.editedMonthlyPlan.fej.Datum = moment({
                y: vm.selectedYear,
                M: vm.selectedMonth,
                d: 1
            }).format('YYYY-MM-DD');
            if (vm.selectedYear && vm.selectedMonth >= 0) {
                selectByDate();
            }
            if (vm.selectedAgeGroup) {
                VersenyTervTablazat(vm.EdzoId, vm.selectedAgeGroup, vm.selectedMonth);
            }
        }

        function selectByDate() {
            if (reopen || angular.isUndefined(vm.selectedMonth) || vm.alreadyCreated) {
                return;
            }
            vm.alreadyCreated = true;
            if (vm.editedMonthlyPlan.fej.SzakosztalyId) {
                sectionId = vm.editedMonthlyPlan.fej.SzakosztalyId;
            }
            if (vm.editedMonthlyPlan.fej.EdzoId) {
                coachId = vm.editedMonthlyPlan.fej.EdzoId;
            }
            dataservice.monthlyPlanSelectByDate(vm.selectedYear, vm.selectedMonth + 1, sectionId, coachId, newplan, vm.egyeni).then(function (data) {
                if (!data.status) { // nem null érkezett (új terv, és van az adott hónapra terv)
                    vm.readOnlyMonthlyPlan = true;
                    viewMonthlyPlan(data);
                } else { // null érkezett (új terv, és nincs még az adott hónapra)
                    vm.editedMonthlyPlan.fej.Vegleges = false;
                    vm.editedMonthlyPlan.fej.Datum = moment({
                        y: vm.selectedYear,
                        M: vm.selectedMonth,
                        d: 1
                    }).format('YYYY-MM-DD');
                    vm.editedMonthlyPlan.fej.Leadva = null;
                    vm.editedMonthlyPlan.fej.Elfogadas1 = null;
                    vm.editedMonthlyPlan.fej.Id = -1;
                    vm.editedMonthlyPlan.fej.Megjegyzes = '';
                    vm.elfogadvaStr = '';
                    vm.leadvaStr = '';
                    vm.saveButton = true;
                    vm.rejectButton = false;
                    vm.closeButton = false;
                    vm.acceptButton = false;
                    vm.noMonthlyPlan = true;
                    vm.hasMonthlyPlan = false;
                    vm.hasSignedMonthlyPlan = false;
                    vm.hasAcceptedMonthlyPlan = false;
                    vm.readOnlyMonthlyPlan = false;
                    createNewMonthlyPlan();
                }
            });
        }

        function getAccepterCoachById() {
            if (vm.editedMonthlyPlan.fej.SzakosztalyVezetoId === null) {
                return '';
            } else {
                return $q(function (resolve) {
                    dataservice.getUserData(vm.editedMonthlyPlan.fej.SzakosztalyVezetoId)
                        .then(function (args) {
                            resolve(args.retValue.name);
                        });
                });
            }
        }

        function printMonthlyPlan() {
            $q.all([getAccepterCoachById(), getSystemSettings()])
                .then(function (results) {
                    var honap = moment(vm.editedMonthlyPlan.fej.Datum).format('YYYY-MM');
                    var masodiklap = 1;
                    if (vm.editedMonthlyPlan.tetelek == null || vm.editedMonthlyPlan.tetelek.length == 0) {
                        masodiklap = 1;
                    } else {
                        vm.editedMonthlyPlan.tetelek.forEach(function (element) {
                            if (
                                element.Merkozes7 !== null || element.Merkozes8 !== null ||
                                element.Eredmeny7 !== null || element.Eredmeny8 !== null ||
                                element.Helyezes7 !== null || element.Helyezes8 !== null) {
                                masodiklap = masodiklap < 4 ? 4 : masodiklap;
                            } else if (
                                element.Merkozes5 !== null || element.Merkozes6 !== null ||
                                element.Eredmeny5 !== null || element.Eredmeny6 !== null ||
                                element.Helyezes5 !== null || element.Helyezes6 !== null) {
                                masodiklap = masodiklap < 3 ? 3 : masodiklap;
                            } else if (
                                element.Merkozes3 !== null || element.Merkozes4 !== null ||
                                element.Eredmeny3 !== null || element.Eredmeny4 !== null ||
                                element.Helyezes3 !== null || element.Helyezes4 !== null) {
                                masodiklap = masodiklap < 2 ? 2 : masodiklap;
                            }
                        });
                    }
                    vm.reportParameters = {
                        Honap: honap,
                        Szakosztaly: vm.editedMonthlyPlan.fej.SzakosztalyNeve,
                        EdzoNeve: vm.editedMonthlyPlan.fej.EdzoNeve,
                        Edzo: vm.editedMonthlyPlan.fej.EdzoNeve,
                        Varos: results[1] == null ? '' : (results[1] + ', '),
                        Jovahagyta1: results[0],
                        Veglegesitve: vm.leadvaStr,
                        Elfogadas1: vm.elfogadvaStr,
                        Jovahagyta2: '',
                        Merkozes1: vm.editedMonthlyPlan.tetelek.length == 0 || vm.editedMonthlyPlan.tetelek[0].Merkozes1 === null ? '' : vm.editedMonthlyPlan.tetelek[0].Merkozes1,
                        Merkozes2: vm.editedMonthlyPlan.tetelek.length == 0 || vm.editedMonthlyPlan.tetelek[0].Merkozes2 === null ? '' : vm.editedMonthlyPlan.tetelek[0].Merkozes2,
                        Merkozes3: vm.editedMonthlyPlan.tetelek.length == 0 || vm.editedMonthlyPlan.tetelek[0].Merkozes3 === null ? '' : vm.editedMonthlyPlan.tetelek[0].Merkozes3,
                        Merkozes4: vm.editedMonthlyPlan.tetelek.length == 0 || vm.editedMonthlyPlan.tetelek[0].Merkozes4 === null ? '' : vm.editedMonthlyPlan.tetelek[0].Merkozes4,
                        Merkozes5: vm.editedMonthlyPlan.tetelek.length == 0 || vm.editedMonthlyPlan.tetelek[0].Merkozes5 === null ? '' : vm.editedMonthlyPlan.tetelek[0].Merkozes5,
                        Merkozes6: vm.editedMonthlyPlan.tetelek.length == 0 || vm.editedMonthlyPlan.tetelek[0].Merkozes6 === null ? '' : vm.editedMonthlyPlan.tetelek[0].Merkozes6,
                        Merkozes7: vm.editedMonthlyPlan.tetelek.length == 0 || vm.editedMonthlyPlan.tetelek[0].Merkozes7 === null ? '' : vm.editedMonthlyPlan.tetelek[0].Merkozes7,
                        Merkozes8: vm.editedMonthlyPlan.tetelek.length == 0 || vm.editedMonthlyPlan.tetelek[0].Merkozes8 === null ? '' : vm.editedMonthlyPlan.tetelek[0].Merkozes8,
                        TervId: vm.editedMonthlyPlan.fej.Id,
                        Masodiklap: masodiklap
                    };
                    if (vm.egyeni == true) {
                        if (printOpenedE) {
                            angular.element('#printDialogE').ejDialog('open');
                        } else {
                            printOpenedE = true;
                            angular.element('#printDialogE').ejDialog({
                                height: '95%',
                                width: '95%',
                                enablemodal: 'true',
                                'position-x': '0',
                                'position-y': '1',
                                target: '#mainContent',
                                enableresize: 'false'
                            });
                        }
                    } else {
                        if (printOpenedCS) {
                            angular.element('#printDialogCS').ejDialog('open');
                        } else {
                            printOpenedCS = true;
                            angular.element('#printDialogCS').ejDialog({
                                height: '95%',
                                width: '95%',
                                enablemodal: 'true',
                                'position-x': '0',
                                'position-y': '1',
                                target: '#mainContent',
                                enableresize: 'false'
                            });
                        }
                    }
                });
        }

        function openAthlete(id) {
            if (vm.MEGTSPORTLIST) {
                paramHelper.setParams([{'athleteModify.sportoloId': id}]);
                $state.go('athletes.athletesManagement.athleteModify.dataSheet');
            } else {
                log.permissionError();
            }
        }

        function openTeam(teamid, ageGroupId, sectionId) {
            paramHelper.setParams([
                {'teams.team': teamid},
                {'teams.ageGroupId': ageGroupId},
                {'teams.sectionId': sectionId}
            ]);
            $state.go('athletes.teams.teamMembersList');
        }

        function cellEdit(args) {
            if (vm.readOnlyMonthlyPlan) {
                args.cancel = true;
            }
        }

        function goToOlderMonthlyCompetitiveReports() {
            vm.selectedRowIndexPopup = -1;
            var dialogObj = angular.element('#searchWindow').data('ejDialog');
            dialogObj.open();
            dataservice.getOldCompetitivePlanByUserId(vm.editedMonthlyPlan.fej.EdzoId, vm.editedMonthlyPlan.fej.Id).then(function (args) {
                vm.dataPopup = args.itemsList;
                gridPopup.dataSource = vm.dataPopup;
            });
        }

        function closeEarlierCompetitvePlanWindow() {
            var dialogObj = angular.element('#searchWindow').data('ejDialog');
            dialogObj.close();
        }

        function selectEarlierCompetitvePlanWindow() {
            vm.selectedRowIndexPopup = gridPopup.getSelectedRowIndexes();
            if (vm.selectedRowIndexPopup > -1) {
                var vmi = vm.dataPopup[vm.selectedRowIndexPopup];
                if (vmi) {
                    dataservice.monthlyPlanSelectById(vmi.Id, vmi.SzakosztalyId).then(function (data) {
                        vm.editedMonthlyPlan = {};
                        vm.editedMonthlyPlan.fej = {};
                        vm.editedMonthlyPlan.fej.Datum = moment({
                            y: vm.selectedYear,
                            M: vm.selectedMonth,
                            d: 1
                        }).format('YYYY-MM-DD');
                        vm.editedMonthlyPlan.fej.EdzoId = vm.EdzoId;
                        vm.editedMonthlyPlan.fej.EdzoNeve = vm.EdzoNeve;
                        vm.editedMonthlyPlan.fej.Elfogadas1 = null;
                        vm.editedMonthlyPlan.fej.Elfogadas2 = null;
                        vm.editedMonthlyPlan.fej.GazdasagiId = null;
                        vm.Id = 0;
                        vm.editedMonthlyPlan.fej.Leadva = null;
                        vm.editedMonthlyPlan.fej.Megjegyzes = data.fej.Megjegyzes;
                        vm.editedMonthlyPlan.fej.SzakosztalyNeve = vm.SzakosztalyNeve;
                        vm.editedMonthlyPlan.fej.SzakosztalyId = vm.SzakosztalyId;
                        vm.editedMonthlyPlan.fej.Vegleges = false;
                        vm.editedMonthlyPlan.fej.SzakosztalyVezetoId = null;
                        vm.editedMonthlyPlan.tetelek = data.tetelek;
                        vm.leadvaStr = null;
                        vm.elfogadvaStr = null;
                        viewMonthlyPlan(vm.editedMonthlyPlan);
                        vm.Id = 0;
                    });
                    var dialogObj = angular.element('#searchWindow').data('ejDialog');
                    dialogObj.close();
                }
            }
        }

        function deletePlan() {
            if (!vm.TORLHAVIVERS) {
                log.permissionError();
                return;
            }
            swal({
                title: gettextCatalog.getString('Are you sure you want to delete the selected competitive monthly plan?'),
                text: gettextCatalog.getString('You will not be able to recover the plan!'),
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: gettextCatalog.getString('Yes, delete this competitive monthly plan'),
                cancelButtonText: gettextCatalog.getString('Cancel'),
                closeOnConfirm: false,
                closeOnCancel: false
            }).then(function (isConfirm) {
                if (isConfirm.value) {
                    return dataservice.VersenyTervHaviDeleteById(vm.editedMonthlyPlan.fej.Id, vm.SzakosztalyId, vm.egyeni).then(
                        function () {
                            $state.go('administration.competitiveMonthlyPlan.competitiveMonthlyPlanList');
                        }
                    );
                }
            });
        }

        function getSystemSettings() {
            return dataservice.getSystemSettingsValue('VAROS').then(function (response) {
                return response.retValue;
            });
        }

        function CopyCellToColumn() {
            var db = vm.data.length;
            for (var rowCntr = 0; rowCntr < db; rowCntr++) {
                vm.data[rowCntr][vm.editedColumnName] = vm.editedColumnValue;
            }
            gridNew.refresh();
        }

        function cellSave(arg) {
            $timeout(function () {
                vm.AthleteUnderEditing = '';
                vm.editedColumnValue = arg.value;
                $scope.$apply();
            }, 0);
        }

        function initEvesGrid() {
            vm.columnsYear = [];
            vm.columnsYear = [{
                field: 'Id',
                visible: false,
                isPrimaryKey: true,
                isIdentity: true,
                width: 30
            },
                {
                    field: 'HetSzam',
                    headerText: gettextCatalog.getString('WeekNumber'),
                    textAlign: 'center',
                    width: 130,
                    cssClass: 'rotate90degreegridheader3'
                },
                {
                    field: 'FelkHetSzam',
                    headerText: gettextCatalog.getString('PreparationWeekNumber'),
                    textAlign: 'center',
                    width: 130,
                    cssClass: 'rotate90degreegridheader3'
                },
                {
                    field: 'Datum',
                    headerText: gettextCatalog.getString('Date'),
                    textAlign: 'center',
                    width: 130
                },
                {
                    field: 'FelkIdJellTiszta',
                    headerText: gettextCatalog.getString('FelkeszulesiIdoTiszta'),
                    textAlign: 'center',
                    width: 130,
                    cssClass: 'rotate90degreegridheader3'
                },
                {
                    field: 'FelkIdJellVegyes',
                    headerText: gettextCatalog.getString('FelkeszulesiIdoVegyes'),
                    textAlign: 'center',
                    width: 130,
                    cssClass: 'rotate90degreegridheader3'
                },
                {
                    field: 'FelkIdJellVerseny',
                    headerText: gettextCatalog.getString('FelkeszulesiIdoVerseny'),
                    textAlign: 'center',
                    width: 130,
                    cssClass: 'rotate90degreegridheader3'
                },
                {
                    field: 'HetiEdzesSzamAlt',
                    headerText: gettextCatalog.getString('HetiEdzesSzamAltalanos'),
                    textAlign: 'center',
                    width: 130,
                    cssClass: 'rotate90degreegridheader3'
                },
                {
                    field: 'HetiEdzesSzamSpSpec',
                    headerText: gettextCatalog.getString('HetiEdzesSzamSportagSpecifikus'),
                    textAlign: 'center',
                    width: 130,
                    cssClass: 'rotate90degreegridheader3'
                },
                {
                    field: 'HetiEdzesSzamOsszesen',
                    headerText: gettextCatalog.getString('HetiEdzesSzamOsszesen'),
                    textAlign: 'center',
                    width: 130,
                    cssClass: 'rotate90degreegridheader3'
                },
                {
                    field: 'HetiTerhelesMagas',
                    headerText: gettextCatalog.getString('HetiTerhelesMagas'),
                    textAlign: 'center',
                    width: 130,
                    cssClass: 'rotate90degreegridheader3'
                },
                {
                    field: 'HetiTerhelesKozepes',
                    headerText: gettextCatalog.getString('HetiTerhelesKozepes'),
                    textAlign: 'center',
                    width: 130,
                    cssClass: 'rotate90degreegridheader3'
                },
                {
                    field: 'HetiTerhelesAlacsony',
                    headerText: gettextCatalog.getString('HetiTerhelesAlacsony'),
                    textAlign: 'center',
                    width: 130,
                    cssClass: 'rotate90degreegridheader3'
                },
                {
                    field: 'HetiEdzMunkaTechnikai',
                    headerText: gettextCatalog.getString('HetiEdzesMunkaTechnikai'),
                    textAlign: 'center',
                    width: 130,
                    cssClass: 'rotate90degreegridheader3'
                },
                {
                    field: 'HetiEdzMunkaKepFejl',
                    headerText: gettextCatalog.getString('HetiEdzesMunkaKepessegFejlesztes'),
                    textAlign: 'center',
                    width: 130,
                    cssClass: 'rotate90degreegridheader3'
                },
                {
                    field: 'HetiEdzMunkaKieg',
                    headerText: gettextCatalog.getString('HetiEdzesMunkaKiegeszito'),
                    textAlign: 'center',
                    width: 130,
                    cssClass: 'rotate90degreegridheader3'
                },
                {
                    field: 'HetiEdzMunkaEgyeb',
                    headerText: gettextCatalog.getString('HetiEdzesMunkaEgyeb'),
                    textAlign: 'center',
                    width: 130,
                    cssClass: 'rotate90degreegridheader3'
                },
                {
                    field: 'FelmeresekAlt',
                    headerText: gettextCatalog.getString('GeneralSurveys'),
                    textAlign: 'center',
                    width: 130,
                    cssClass: 'rotate90degreegridheader3'
                },
                {
                    field: 'FelmeresekSpSpec',
                    headerText: gettextCatalog.getString('SportagSpecifikusFelmeresek'),
                    textAlign: 'center',
                    width: 130,
                    cssClass: 'rotate90degreegridheader3'
                },
                {
                    field: 'EdzTabIdopont',
                    headerText: gettextCatalog.getString('EdzotaborozasIdopont'),
                    textAlign: 'left',
                    width: 130
                },
                {
                    field: 'EdzTabHely',
                    headerText: gettextCatalog.getString('EdzotaborozasHely'),
                    textAlign: 'left',
                    width: 130
                },
                {
                    field: 'EdzTabLetszam',
                    headerText: gettextCatalog.getString('EdzotaborozasLetszam'),
                    textAlign: 'left',
                    width: 130
                },
                {
                    field: 'Verseny',
                    headerText: gettextCatalog.getString('Verseny'),
                    textAlign: 'left',
                    width: 130
                }
            ];

            vm.stackedHeaderRows = [{
                stackedHeaderColumns: [{
                    headerText: gettextCatalog.getString('FelkHetSzam') + '<br>(1-52)',
                    column: 'HetSzam, FelkHetSzam, Datum',
                    textAlign: 'center'
                },
                    {
                        headerText: gettextCatalog.getString('FelkIdJelleg') + '<br>(X)',
                        column: 'FelkIdJellTiszta, FelkIdJellVegyes, FelkIdJellVerseny',
                        textAlign: 'center'
                    },
                    {
                        headerText: gettextCatalog.getString('HetiEdzesSzam') + '<br>(0-21)',
                        column: 'HetiEdzesSzamAlt, HetiEdzesSzamSpSpec, HetiEdzesSzamOsszesen',
                        textAlign: 'center'
                    },
                    {
                        headerText: gettextCatalog.getString('HetiTerheles') + '<br>(X, 0-9)',
                        column: 'HetiTerhelesMagas, HetiTerhelesKozepes, HetiTerhelesAlacsony',
                        textAlign: 'center'
                    },
                    {
                        headerText: gettextCatalog.getString('HetiEdzesJell') + '<br>(X, 0-9)',
                        column: 'HetiEdzMunkaTechnikai, HetiEdzMunkaKepFejl, HetiEdzMunkaKieg, HetiEdzMunkaEgyeb',
                        textAlign: 'center'
                    },
                    {
                        headerText: gettextCatalog.getString('Felmeresek') + '<br>(0-9)',
                        column: 'FelmeresekAlt, FelmeresekSpSpec',
                        textAlign: 'center'
                    },
                    {
                        headerText: gettextCatalog.getString('Edzotaborozas') + '<br>',
                        column: 'EdzTabIdopont, EdzTabHely, EdzTabLetszam',
                        textAlign: 'center'
                    },
                    {
                        headerText: gettextCatalog.getString('Verseny') + '<br>',
                        column: 'Verseny',
                        textAlign: 'center'
                    }
                ]
            }];
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.administration.competitiveMonthlyPlan.competitiveMonthlyPlanReport')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'administration.competitiveMonthlyPlan.competitiveMonthlyPlanReport',
                config: {
                    url: '/competitiveMonthlyPlanReport',
                    templateUrl: 'app/administration/competitiveMonthlyPlan/competitiveMonthlyPlanReport/competitiveMonthlyPlanReport.html',
                    controller: 'CompetitiveMonthlyPlanReportController',
                    controllerAs: 'vm'
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    DailyAttendanceController.$inject = ["log", "logger", "DOMAIN", "paramHelper", "$state", "dataservice", "$q", "$rootScope", "gettextCatalog", "authenticationService", "$scope"];
    angular
        .module('app.administration.dailyAttendance')
        .controller('DailyAttendanceController', DailyAttendanceController);

    function DailyAttendanceController(log, logger, DOMAIN, paramHelper, $state, dataservice, $q, $rootScope, gettextCatalog, authenticationService, $scope) {
        var vm = this;
        $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('dailyAttendance');
        vm.presenceText = gettextCatalog.getString('presenceText');
        vm.absenceText = gettextCatalog.getString('absenceText');
        vm.provenabsenceText = gettextCatalog.getString('provenabsenceText');
        vm.competitionText = gettextCatalog.getString('competitionText');
        vm.holidayText = gettextCatalog.getString('holidayText');
        vm.sicknessText = gettextCatalog.getString('sicknessText');
        vm.injuryText = gettextCatalog.getString('injuryText');
        vm.noImgUrl = DOMAIN.baseURL + DOMAIN.userImage;
        var newAthletesId = -1;
        vm.allAgeGroupfill = false;
        vm.coachList = [];
        vm.thereIsIncativeAthlete = false;
        vm.clicked = null;
        vm.sectionDataBound = sectionDataBound;
        vm.sectionSelect = sectionSelect;
        vm.ageGroupDataBound = ageGroupDataBound;
        vm.ageGroupSelect = ageGroupSelect;
        vm.saveAttendance = saveAttendance;
        vm.loadAttendance = loadAttendance;
        vm.iconClicked = iconClicked;
        vm.refreshAthletes = refreshAthletes;
        vm.DDClick = DDClick;
        vm.sectionId = undefined;
        vm.ageGroupId = undefined;
        vm.userid = undefined;
        vm.editedAttendance = {};
        vm.dayz = {};
        vm.today = {};
        vm.today.Year = new Date().getFullYear();
        vm.today.Month = new Date().getMonth() + 1;
        vm.today.Day = new Date().getDate();
        var button = {
            UNDEFINED: -1,
            PRESENCE: 1,
            ABSENCE: 2,
            PROVENABSENCE: 3, //22,
            HOLIDAY: 4,
            SICKNESS: 5,
            INJURY: 6,
            COMPETITION: 7, //3,
            NOTPRESSED: 10
        };
        vm.b = button;

        activate();

        function activate() {
            var promises = [authenticationService.getRight('HJFELVIHET'), authenticationService.getRight('MEGTHAVIJEL'), authenticationService.getRight('EDZO'), authenticationService.getRight('SZAKOSZTVEZ'), paramHelper.getParams([], ['dailyAttendance.SzakosztalyId'])];
            $q.all(promises).then(function (results) {
                vm.userid = authenticationService.getAuthData().id;
                if (!(results[1])) {
                    log.permissionError(true);
                    return;
                }
                vm.allowEdit = results[0];
                if (!results[2] && !results[3]) {
                    log.errorMsg(gettextCatalog.getString('YouMustBeACoachOrSectionLeaderToUseDailyAttendance'));
                    log.permissionError(true);
                } else {
                    getCoaches();
                    getSections(vm.userid);
                }
                if (results[4]['dailyAttendance.SzakosztalyId']) {
                    vm.sectionId = results[4]['dailyAttendance.SzakosztalyId'];
                }
            });
        }

        function isMobile() {
            var check = false;
            (function (a) {
                if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) {
                    check = true;
                }
            })(navigator.userAgent || navigator.vendor || window.opera);
            return check;
        }

        function iconClicked(index, setTo) {
            var tetel = vm.editedAttendance.tetelek[index];
            // console.log('iconClicked index:', index, 'Nev:', tetel.SportoloNev, 'prevState: ', tetel.selectedIcon, 'setTo:', setTo);
            //console.log('tetel[index]', tetel);
            // Ha volt már aznap jelenlét, és átkattintok máshova akkor a napi jelenlét értékét csökkentem
            if (setTo != button.PRESENCE && tetel.selectedIcon == button.PRESENCE && tetel.today > 0) {
                tetel.today--;
            }
            // HA ugyanarra kattintok, akkor leveszem a kijelölést
            if (tetel.selectedIcon == setTo) {
                tetel.selectedIcon = button.UNDEFINED;
                // Ha a jelenlét kivan jelölve, és arról szedem le a kijelölést, akkor csökkentem a mellette lévő számot
                if (setTo == button.PRESENCE) {
                    tetel.today--;
                }
            }
            // Ha valamelyik szürkére kattintok
            else {
                // Ha a pipára kattintok
                if (setTo == button.PRESENCE) {
                    // de már volt aznapra jelenlét (1,2,3),
                    if (tetel.today > 0) {
                        // három eddigi napi jelenlétnél már nem lehet több
                        if (tetel.today == 3) {
                            log.htmlError(gettextCatalog.getString('Max3TrainingsPerDay') + ' ' + tetel.SportoloNev);
                            tetel.selectedIcon = button.UNDEFINED;
                        }
                        //  1,2 nél lehet. Akkor a napi jelenlét nő eggyel.
                        else {
                            tetel.today++;
                            tetel.selectedIcon = button.PRESENCE;
                        }
                    }
                    // Pipára kattintok, de ez a mai első jelenlét
                    else {
                        tetel.today = 1;
                        tetel.selectedIcon = button.PRESENCE;
                    }
                }
                // Ha a hiányzásra kattintok, és ma még nem volt edzésen
                else if (setTo == button.ABSENCE) {
                    if (tetel.today == 3) {
                        log.htmlError(gettextCatalog.getString('Max3TrainingsPerDay') + ' ' + tetel.SportoloNev);
                        tetel.selectedIcon = button.UNDEFINED;
                    } else {
                        tetel.selectedIcon = button.ABSENCE;
                    }
                }
                // Ha az igazolt hiányzásra kattintok, és ma még nem volt edzésen
                else if (setTo == button.PROVENABSENCE && !(tetel.today > 0)) {
                    tetel.selectedIcon = button.PROVENABSENCE;
                }
                // Ha a sérülésre vagy betegségre kattintok (az is jelenlétnek számít)
                else if (setTo == button.INJURY || setTo == button.SICKNESS) {
                    tetel.selectedIcon = setTo;
                }
                // Nem a pipára kattintok
                else {
                    tetel.selectedIcon = setTo;
                }
            }
        }

        function loadAttendance() {
            $scope.$broadcast('submitted');
            if ($scope.form.$valid === false) {
                log.errorMsg(gettextCatalog.getString('RequiredFieldsError'));
                return;
            }
            if (!vm.allAgeGroupfill) {
                loadMonthlyAttendance(vm.userid, vm.sectionId, 0, vm.today.Year, vm.today.Month, vm.today.Day);
            } else {
                if (!(vm.ageGroupId > 0)) {
                    log.errorMsg(gettextCatalog.getString('ChooseAgeGroup'));
                    return;
                }
                loadMonthlyAttendance(vm.userid, vm.sectionId, vm.ageGroupId, vm.today.Year, vm.today.Month, vm.today.Day);
            }
        }

        function setIcons() {
            //console.log('vm.editedAttendance', vm.editedAttendance);
            for (var t = 0; t < vm.editedAttendance.tetelek.length; t++) {
                var active = '';
                if (vm.editedAttendance.aktiv[t]['Nap' + vm.today.Day]) {
                    active = vm.editedAttendance.aktiv[t]['Nap' + vm.today.Day].trim();
                }
                if (active == '1') {
                    vm.editedAttendance.tetelek[t].activeToday = true;
                } else {
                    vm.thereIsIncativeAthlete = true;
                    vm.editedAttendance.tetelek[t].activeToday = false;
                }
                vm.editedAttendance.tetelek[t].selectedIcon = button.UNDEFINED;
                vm.editedAttendance.tetelek[t].img = DOMAIN.baseURL + DOMAIN.profileImgBaseUrl + vm.editedAttendance.tetelek[t].img;
                setIconsForToday(t, vm.editedAttendance.tetelek[t]);
            }
        }

        function setIconsForToday(sor, tetel) {
            var nap = tetel['Nap' + vm.today.Day];
            if (nap) {
                nap = nap.trim();
                if (isNaN(nap)) {
                    nap = nap.toUpperCase();
                } else if (nap.length > 0) {
                    //console.log('setIconsForToday Nev:', vm.editedAttendance.tetelek[sor].SportoloNev, '  nap:', nap);
                    nap = Number(nap);
                }
            }
            vm.editedAttendance.tetelek[sor].today = ' ';
            switch (nap) {
                case 'V':
                    vm.editedAttendance.tetelek[sor].selectedIcon = button.COMPETITION;
                    break;
                case 'Ü':
                    vm.editedAttendance.tetelek[sor].selectedIcon = button.HOLIDAY;
                    break;
                case 'B':
                    vm.editedAttendance.tetelek[sor].selectedIcon = button.SICKNESS;
                    break;
                case 'S':
                    vm.editedAttendance.tetelek[sor].selectedIcon = button.INJURY;
                    break;
                case 'H':
                    vm.editedAttendance.tetelek[sor].selectedIcon = button.PROVENABSENCE;
                    break;
                case 0:
                    vm.editedAttendance.tetelek[sor].selectedIcon = button.ABSENCE;
                    break;
                case 1:
                    vm.editedAttendance.tetelek[sor].selectedIcon = button.NOTPRESSED;
                    vm.editedAttendance.tetelek[sor].today = 1;
                    break;
                case 2:
                    vm.editedAttendance.tetelek[sor].selectedIcon = button.NOTPRESSED;
                    vm.editedAttendance.tetelek[sor].today = 2;
                    break;
                case 3:
                    vm.editedAttendance.tetelek[sor].selectedIcon = button.NOTPRESSED;
                    vm.editedAttendance.tetelek[sor].today = 3;
                    break;
                case '':
                    vm.editedAttendance.tetelek[sor].selectedIcon = button.NOTPRESSED;
                    break;
                default:
                    vm.editedAttendance.tetelek[sor].selectedIcon = button.NOTPRESSED;
            }
        }

        /*
                Gomb állapotok:
                -1      Marad az előző állapot
				1 - 1++ presence  	    (jelenlét)
				2 - 0   absence     	(hiányzás)
                3 - H   provenabsence   (igazolt hiányzás)
				4 - Ü   holiday     	(ünnep)
				5 - B   sickness    	(betegség)
				6 - S   injury      	(sérülés)
				7 - V   competition 	(verseny)
                10 - visszatöltésnél ha van már jelenlét
        */

        function loadMonthlyAttendance(coach, section, agegroup, year, month) {
            //console.log('loadMonthlyAttendance', coach, section, agegroup, year, month, day);
            dataservice.monthlyAttendanceSelect(coach, section, agegroup, year, month)
                .then(function (data) {
                    if (data.fej) {
                        if (data.fej.EdzoAlairta) {
                            log.errorMsg(gettextCatalog.getString('MonthlyAttendanceIsAlreadyClosed'));
                            return;
                        }
                        vm.editedAttendance = data;
                        console.log('EXISTING vm.editedAttendance.tetelek', vm.editedAttendance.tetelek);
                        setIcons();
                    } else {
                        createNewAttendance();
                    }
                });
        }

        function createNewAttendance() {
            dataservice.getLastMonthlyAttendanceTrainingLocationAndTime(vm.userid, vm.sectionId, vm.ageGroupId).then(function (data) {
                vm.editedAttendance.fej = {};
                vm.editedAttendance.fej.CsoportLetszam = 0;
                vm.editedAttendance.fej.Datum = new Date(vm.today.Year, vm.today.Month - 1, 1, 0, 0, 0);
                vm.editedAttendance.fej.Erkezett = 0;
                vm.editedAttendance.fej.Id = -1;
                vm.editedAttendance.fej.IdEdzo = vm.userid;
                vm.editedAttendance.fej.IdKorcsoport = vm.ageGroupId;
                vm.editedAttendance.fej.IdSzakosztaly = vm.sectionId;
                vm.editedAttendance.fej.KorosztalyosToltes = vm.allAgeGroupfill;
                vm.editedAttendance.fej.Megjegyzes = '';
                vm.editedAttendance.fej.Tavozott = 0;
                //vm.editedAttendance.fej.EdzoNev = angular.element('#maEdzo').data('ejDropDownList').getSelectedItem()[0].innerText;
                vm.editedAttendance.fej.SzakosztalyNev = angular.element('#sectionDropDown').data('ejDropDownList').getSelectedItem()[0].innerText;
                if (angular.element('#ageGroupDropDown').data('ejDropDownList') && angular.element('#ageGroupDropDown').data('ejDropDownList').getSelectedItem().length > 0) {
                    vm.editedAttendance.fej.KorcsoportNev = angular.element('#ageGroupDropDown').data('ejDropDownList').getSelectedItem()[0].innerText;
                } else {
                    vm.editedAttendance.fej.KorcsoportNev = 0;
                    vm.ageGroupId = 0;
                }
                if (data !== null) {
                    vm.dayz.CsutortokHely = data.CsutortokHely;
                    vm.dayz.CsutortokIdo = data.CsutortokIdo;
                    vm.dayz.HetfoHely = data.HetfoHely;
                    vm.dayz.HetfoIdo = data.HetfoIdo;
                    vm.dayz.IdHaviJelenletiFej = -1;
                    vm.dayz.KeddHely = data.KeddHely;
                    vm.dayz.KeddIdo = data.KeddIdo;
                    vm.dayz.PentekHely = data.PentekHely;
                    vm.dayz.PentekIdo = data.PentekIdo;
                    vm.dayz.SzerdaHely = data.SzerdaHely;
                    vm.dayz.SzerdaIdo = data.SzerdaIdo;
                    vm.dayz.SzombatHely = data.SzombatHely;
                    vm.dayz.SzombatIdo = data.SzombatIdo;
                    vm.dayz.VasarnapHely = data.VasarnapHely;
                    vm.dayz.VasarnapIdo = data.VasarnapIdo;
                } else {
                    vm.dayz.CsutortokHely = '';
                    vm.dayz.CsutortokIdo = '';
                    vm.dayz.HetfoHely = '';
                    vm.dayz.HetfoIdo = '';
                    vm.dayz.IdHaviJelenletiFej = -1;
                    vm.dayz.KeddHely = '';
                    vm.dayz.KeddIdo = '';
                    vm.dayz.PentekHely = '';
                    vm.dayz.PentekIdo = '';
                    vm.dayz.SzerdaHely = '';
                    vm.dayz.SzerdaIdo = '';
                    vm.dayz.SzombatHely = '';
                    vm.dayz.SzombatIdo = '';
                    vm.dayz.VasarnapHely = '';
                    vm.dayz.VasarnapIdo = '';
                }
                vm.editedAttendance.edzesek = vm.dayz;
                dataservice.getAthletesForMonthlyAttendance(vm.userid, vm.sectionId, vm.ageGroupId, vm.editedAttendance.fej.Datum)
                    .then(function (data2) {
                        if (data2.tetelek.length == 0) {
                            log.errorMsg(gettextCatalog.getString('ThereAreNoAthletesAtTheSelectedTimeForThisCoach'));
                        } else {
                            vm.data = data2.tetelek;
                            vm.editedAttendance.tetelek = vm.data;
                            console.log('UJ vm.editedAttendance.tetelek', vm.editedAttendance.tetelek);
                            vm.editedAttendance.aktiv = data2.aktiv;
                            vm.activePeriods = data2.aktiv;
                            setIcons();
                        }
                    });
            });
        }

        function refreshAthletes() {
            if (!vm.editedAttendance.fej) {
                return true;
            } else if (vm.editedAttendance.fej.Id > 0) {
                // JELENLÉTIN LÉVŐ SPORTOLÓ ADATOK FRISSÍTÉSE
                dataservice.monthlyAttendanceRefreshAthleteData(vm.editedAttendance.fej.Id)
                    .then(function (refreshData) {
                        for (var r = 0; r < refreshData.tetelek.length; r++) {
                            for (var ea = 0; ea < vm.editedAttendance.tetelek.length; ea++) {
                                if (refreshData.tetelek[r].IdSportolo == vm.editedAttendance.tetelek[ea].IdSportolo) {
                                    vm.editedAttendance.tetelek[ea].SportoloNev = refreshData.tetelek[r].SportoloNev;
                                    vm.editedAttendance.tetelek[ea].SzuletesiDatum = refreshData.tetelek[r].SzuletesiDatum;
                                    break;
                                }
                            }
                        }
                    });
                // JELENLÉTIN NEM SZEREPLŐ SPORTOLÓK HOZZÁADÁSA
                dataservice.getNewAthletesInSelectedYearMonth(vm.editedAttendance.fej.Id)
                    .then(function (data) {
                        for (var i = 0; i < data.tetelek.length; i++) {
                            var duplicate = false;
                            for (var e = 0; e < vm.editedAttendance.tetelek.length; e++) {
                                if (data.tetelek[i].IdSportolo == vm.editedAttendance.tetelek[e].IdSportolo) {
                                    duplicate = true;
                                    break;
                                }
                            }
                            if (!duplicate) {
                                var ujTetel = data.tetelek[i];
                                ujTetel.Id = newAthletesId--;
                                ujTetel.RowNumber = vm.editedAttendance.tetelek.length + 1;
                                ujTetel.ujsportolo = true;
                                ujTetel.activeToday = true;
                                ujTetel.img = DOMAIN.baseURL + DOMAIN.profileImgBaseUrl + ujTetel.img;
                                ujTetel.selectedIcon = button.NOTPRESSED;
                                ujTetel.today = ' ';
                                vm.editedAttendance.tetelek.push(ujTetel);
                                //console.log('refreshAthletes vm.editedAttendance.tetelek', vm.editedAttendance.tetelek);
                            }
                        }
                        log.successMsg('AthletesRefreshingDone');
                    });
            }
        }

        function chechButtonStates() {
            for (var t = 0; t < vm.editedAttendance.tetelek.length; t++) {
                vm.editedAttendance.tetelek[t].JelenletOsszesen = -1;
                vm.editedAttendance.tetelek[t].HianyzasOsszesen = -1;
                vm.editedAttendance.tetelek[t].VersenyOsszesen = -1;
                var pressedButton = Number(vm.editedAttendance.tetelek[t].selectedIcon);
                if (vm.editedAttendance.tetelek[t].activeToday) {
                    //console.log('chechButtonStates', vm.editedAttendance.tetelek[t].SportoloNev, pressedButton);
                    switch (pressedButton) {
                        case button.PRESENCE:
                            //console.log('PRESENCE', vm.editedAttendance.tetelek[t]);
                            if (vm.editedAttendance.tetelek[t]['Nap' + vm.today.Day]) {
                                if (isNaN(vm.editedAttendance.tetelek[t]['Nap' + vm.today.Day])) {
                                    vm.editedAttendance.tetelek[t]['Nap' + vm.today.Day] = 1;
                                } else {
                                    if (vm.editedAttendance.tetelek[t]['Nap' + vm.today.Day] == 3) {
                                        log.htmlError(gettextCatalog.getString('Max3TrainingsPerDay') + ' ' + vm.editedAttendance.tetelek[t].SportoloNev);
                                        return false;
                                    } else {
                                        vm.editedAttendance.tetelek[t]['Nap' + vm.today.Day]++;
                                    }
                                }
                            } else {
                                vm.editedAttendance.tetelek[t]['Nap' + vm.today.Day] = 1;
                            }
                            break;
                        case button.ABSENCE:
                            vm.editedAttendance.tetelek[t]['Nap' + vm.today.Day] = '0';
                            break;
                        case button.COMPETITION:
                            vm.editedAttendance.tetelek[t]['Nap' + vm.today.Day] = 'V';
                            break;
                        case button.HOLIDAY:
                            vm.editedAttendance.tetelek[t]['Nap' + vm.today.Day] = 'Ü';
                            break;
                        case button.SICKNESS:
                            vm.editedAttendance.tetelek[t]['Nap' + vm.today.Day] = 'B';
                            break;
                        case button.INJURY:
                            vm.editedAttendance.tetelek[t]['Nap' + vm.today.Day] = 'S';
                            break;
                        case button.PROVENABSENCE:
                            vm.editedAttendance.tetelek[t]['Nap' + vm.today.Day] = 'H';
                            break;
                    }
                } else {
                    vm.editedAttendance.tetelek[t]['Nap' + vm.today.Day] = null;
                }
            }
            return true;
        }

        function saveAttendance() {
            if (chechButtonStates()) {
                saveAttendanceOK();
            }
        }

        function saveAttendanceOK() {
            dataservice.saveDailyAttendance(vm.editedAttendance).then(function (id) {
                if (!isMobile()) {
                    paramHelper.setParams([{'monthlyAttendance.id': id.res}]);
                    $state.go('administration.monthlyAttendance.monthlyAttendanceReport');
                } else {
                    $state.go('dashboard');
                }
            });
        }

        function getSections(userid) {
            dataservice.sectionDropDownList(userid)
                .then(function (data) {
                    vm.sectionList = data.itemsList;
                });
        }

        function sectionDataBound() {
            if (vm.sectionList.length === 1) {
                vm.sectionId = vm.sectionList[0].value;
                $('#sectionDropDown').ejDropDownList('selectItemByValue', vm.sectionId);
            } else {
                angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.sectionId);
            }
        }

        function sectionSelect(args) {
            vm.sectionId = args.value;
            getAgeGroups();
            paramHelper.setParams([{'dailyAttendance.SzakosztalyId': args.value}]);
        }

        function getAgeGroups() {
            dataservice.ageGroupSelect(vm.userid, vm.sectionId)
                .then(function (data) {
                    vm.ageGroupList = data.itemsList;
                    if (vm.userid > 0 && vm.ageGroupList.length == 1 && vm.sectionList.length == 1) {
                        setTimeout(function () {
                            loadAttendance();
                        }, 1000);
                    }
                });
        }

        function ageGroupDataBound() {
            if (vm.ageGroupList.length === 1) {
                vm.ageGroupId = vm.ageGroupList[0].value;
            } else {
                vm.ageGroupId = 0;
            }
        }

        function ageGroupSelect(args) {
            vm.ageGroupId = args.value;
        }

        function getCoaches() {
            dataservice.coachSelect().then(
                function (data) {
                    vm.coachList = data.itemsList;
                    var item = ej.DataManager(vm.coachList).executeLocal(new ej.Query().where('value', 'equal', vm.userid))[0];
                    if (item) {
                        vm.allAgeGroupfill = item.HaviJelenletiKorosztalyonkent;
                    }
                }
            );
        }

        function DDClick(sportolo, action) {
            // console.log('DDClick sportolo=', sportolo, '  action=', action, 'coordinates=',vm.coordinates);
            if (sportolo == -1) {
                if (vm.clicked) {
                    var now = new Date();
                    var diff = now - vm.clicked;
                    if (diff > 100) { // mert egymas utan ketszer fut le, eloszor a sportoloid-vel, utana -1 el. 100ms felett valodi kattintas
                        CloseEveryOtherDropDowns(sportolo);
                    }
                    if (diff > 310) {
                        $('#containerDiv').animate({marginBottom: '0px'}, 300);
                    }
                }
                return;
            } else {
                $('#containerDiv').animate({marginBottom: '0px'}, 300);
                vm.clicked = new Date();
                CloseEveryOtherDropDowns(sportolo);
            }
            var SportoloItem = ej.DataManager(vm.editedAttendance.tetelek).executeLocal(new ej.Query().where('IdSportolo', 'equal', sportolo))[0];
            if (SportoloItem.hasOwnProperty('open') == false) {
                SportoloItem.open = false;
            }
            switch (action) {
                case 'open':
                    SportoloItem.open = true;
                    $('#DDL' + sportolo).addClass('open');
                    break;
                case 'close':
                    $('#DDL' + sportolo).removeClass('open');
                    SportoloItem.open = false;
                    break;
                case 'toggle':
                    if (SportoloItem.open === true) {
                        $('#DDL' + sportolo).removeClass('open');
                        SportoloItem.open = false;
                    } else {
                        $('#DDL' + sportolo).addClass('open');
                        SportoloItem.open = true;
                    }
                    break;
            }
            if (sportolo == vm.editedAttendance.tetelek[vm.editedAttendance.tetelek.length - 1].IdSportolo && SportoloItem.open) {
                $('#containerDiv').animate({marginBottom: '230px'}, 300);
            }
            if (sportolo > 0 && SportoloItem.open) {
                setTimeout(function () {
                    ScrollDownIfNeeded(sportolo, vm.coordinates);
                }, 250);
            }
        }

        function ScrollDownIfNeeded(sportolo) {
            var DropDownSize = 290;
            var ImgPos = $('#IMG_' + sportolo).offset();
            var DdPosStart = ImgPos.top + 164;
            var DdPosEnd = DdPosStart + DropDownSize;
            var TopOfPage = $(window).scrollTop();
            var BottomOfPage = TopOfPage + window.screen.height;
            var diff = BottomOfPage - DdPosEnd;
            if (diff < 0) {
                $('html, body').stop().animate({scrollTop: TopOfPage - diff + 70}, 300);
            }
        }

        function CloseEveryOtherDropDowns(except) {
            vm.editedAttendance.tetelek.forEach(function (athlete) {
                if (athlete.IdSportolo !== except) {
                    $('#DDL' + athlete.IdSportolo).removeClass('open');
                    athlete.open = false;
                }
            });
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.administration.dailyAttendance')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'administration.dailyAttendance',
                config: {
                    url: '/dailyAttendance',
                    templateUrl: 'app/administration/dailyAttendance/dailyAttendance.html',
                    controller: 'DailyAttendanceController',
                    controllerAs: 'vm',
                    title: 'dailyAttendance',
                    settings: {
                        navId: 212,
                        level: 2,
                        order: 1,
                        orderTitle_hu: 'Napi jelenlét',
                        orderTitle_en: 'Daily Attendance',
                        parentId: 2,
                        content: 'dailyAttendance',
                        activatorPermission: '"MEGTHAVIJEL"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.administration.exercises')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'administration.exercises',
                config: {
                    url: '/exercises',
                    templateUrl: 'app/administration/exercises/exercises.html'
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    ExercisesCreateController.$inject = ["log", "paramHelper", "dataservice", "$q", "$rootScope", "gettextCatalog", "authenticationService", "DOMAIN", "$scope", "$state", "$timeout"];
    angular
        .module('app.administration.exercises.exercisesCreate')
        .controller('ExercisesCreateController', ExercisesCreateController)
        .config(["$sceProvider", function ($sceProvider) {
            // Completely disable SCE.  For demonstration purposes only!
            // Do not use in new projects or libraries.
            $sceProvider.enabled(false);
        }]);

    function ExercisesCreateController(log, paramHelper, dataservice, $q, $rootScope, gettextCatalog, authenticationService, DOMAIN, $scope, $state, $timeout) {
        var vm = this;
        $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('ExercisesCreate');

        $scope.files = [];
        $scope.imageDatas = [];

        $scope.imageThumb = DOMAIN.baseURL + DOMAIN.imgBaseUrl + 'MS-thumbnail.png';
        $scope.dustbin = DOMAIN.baseURL + DOMAIN.imgBaseUrl + 'MS-dustbin.png';

        vm.formdata = {
            id: 0,
            bodyParts: '',
            sectionId: 0,
            ageGroupId: 0,
            coachId: 0,
            imageList: [],
            savedImageList: []
        };

        vm.addNewText = gettextCatalog.getString('addNewText');

        vm.save = save;
        vm.sectionDataBound = sectionDataBound;
        vm.sectionSelect = sectionSelect;
        vm.ageGroupDataBound = ageGroupDataBound;
        vm.ageGroupSelect = ageGroupSelect;
        vm.coachDataBound = coachDataBound;
        vm.coachSelect = coachSelect;
        vm.publicChanged = publicChanged;
        vm.paintDataBound = paintDataBound;
        vm.paintSelect = paintSelect;
        vm.deleteExistingImg = deleteExistingImg;
        vm.deleteImg = deleteImg;
        vm.makeToThumb = makeToThumb;
        vm.openPaint = openPaint;
        vm.goToCreatePaint = goToCreatePaint;

        activate();

        function activate() {
            $q.all([authenticationService.getRight('UJGYAKORLAT'), authenticationService.getRight('MODGYAKORLAT'), authenticationService.getRight('MEGTGYAKORLAT')]).then(function (results) {
                vm.UJGYAKORLAT = results[0];
                vm.MODGYAKORLAT = results[1];
                vm.MEGTGYAKORLAT = results[2];
                if (vm.UJGYAKORLAT !== true && vm.MODGYAKORLAT !== true && vm.MEGTGYAKORLAT !== true) {
                    log.permissionError(true);
                } else {
                    $q.all([paramHelper.getParams([], ['exercises.exerciseId'])]).then(function (results) {
                        vm.exerciseId = results[0]['exercises.exerciseId'];
                        paramHelper.removeParam('exercises.exerciseId');
                        getSections();
                        getTrainingPracticeAutoComplete();
                        if (vm.exerciseId) {
                            getExercise(vm.exerciseId);
                        }
                    });
                }
            });
        }

        function getTrainingPracticeAutoComplete() {
            dataservice.getTrainingPracticeAutoComplete().then(function (data) {
                vm.bodyPartsList = data.data.Testresz;
                vm.typeList = data.data.Tipus;
                vm.individualTeamList = data.data.Jellege;
                vm.assertsList = data.data.Felszerelesek;
            });
        }

        function getExercise(exerciseId) {
            dataservice.getExercise(exerciseId).then(function (result) {
                $('#bodyParts').ejAutocomplete('clearText');
                $('#type').ejAutocomplete('clearText');
                $('#individualTeam').ejAutocomplete('clearText');
                $('#asserts').ejAutocomplete('clearText');
                vm.formdata = result.gyakorlat;

                // YOUTUBE
                vm.formdata.youtubeSeeing = angular.copy(vm.formdata.youtube);

                vm.formdata.youtubeSeeing = vm.formdata.youtubeSeeing.replace('watch?v=', 'embed/');
                if (vm.formdata.youtubeSeeing.indexOf('&') !== -1) {
                    vm.formdata.youtubeSeeing = vm.formdata.youtubeSeeing.substring(0, vm.formdata.youtubeSeeing.indexOf('&'));
                }

                vm.formdata.youtubeSeeing = vm.formdata.youtubeSeeing.split('embed/')[1];

                $('#playerWrapper').empty();
                $('#playerWrapper').append('<div id="player" data-plyr-provider="youtube" data-plyr-embed-id="' + vm.formdata.youtubeSeeing + '"></div>');
                vm.player = new Plyr(document.getElementById('player'));

                vm.youtube = '';
                // YOUTUBE

                vm.thumbnail = false;

                var index = 0;
                vm.formdata.savedImageList.forEach(function (image) {
                    if (vm.formdata.thumbnail == image.fileName) {
                        vm.thumbnailIndex = index;
                    }
                    index++;
                });

                if (vm.formdata.thumbnail) {
                    vm.thumbnail = true;
                }
                if (vm.formdata.thumbnail) {
                    vm.thumbnail = DOMAIN.baseURL + DOMAIN.exerciseBaseUrl + vm.formdata.thumbnail;
                }
                vm.formdata.savedImageList.forEach(function (t) {
                    t.fileUrl = DOMAIN.baseURL + DOMAIN.exerciseBaseUrl + t.fileName;
                });
                angular.element('#public').ejCheckBox({checked: vm.formdata.publikus});
                $('#sectionId').ejDropDownList('selectItemByValue', vm.formdata.sectionId);
                // angular.element('#number').ejDropDownList('selectItemByValue', results[0]['dailySportServiceFeePayments.number']);
                // angular.element('#number').ejDropDownList('selectItemByValue', results[0]['dailySportServiceFeePayments.number']);
                $timeout(function () {
                    $('.gallery-item').magnificPopup({
                        type: 'image',
                        gallery: {
                            enabled: true,
                        }
                    });
                }, 1);
            });
        }

        vm.youtubeChanged = function () {
            if (vm.youtube) {
                // YOUTUBE
                vm.formdata.youtubeSeeing = angular.copy(vm.youtube);
                vm.formdata.youtubeSeeing = vm.formdata.youtubeSeeing.replace('watch?v=', 'embed/');
                vm.formdata.youtube = vm.formdata.youtubeSeeing;
                if (vm.formdata.youtubeSeeing.indexOf('&') !== -1) {
                    vm.formdata.youtubeSeeing = vm.formdata.youtubeSeeing.substring(0, vm.formdata.youtubeSeeing.indexOf('&'));
                }

                vm.formdata.youtubeSeeing = vm.formdata.youtubeSeeing.split('embed/')[1];

                $('#playerWrapper').empty();
                $('#playerWrapper').append('<div id="player" data-plyr-provider="youtube" data-plyr-embed-id="' + vm.formdata.youtubeSeeing + '"></div>');
                vm.player = new Plyr(document.getElementById('player'));
                // YOUTUBE
                vm.youtube = '';
            }
        };

        function getSections() {
            return dataservice.sectionDropDownList(0).then(function (data) {
                data.itemsList.unshift({text: gettextCatalog.getString('All'), value: 0});
                vm.sectionList = data.itemsList;
            });
        }

        function sectionDataBound() {
            if (vm.sectionList.length === 1) {
                angular.element('#sectionId').ejDropDownList('selectItemByValue', vm.sectionList[0].value);
            } else {
                $('#sectionId').ejDropDownList('selectItemByValue', vm.formdata.sectionId);
            }
        }

        function sectionSelect(args) {
            vm.formdata.sectionId = args.value;
            getAgeGroups();
        }

        function getAgeGroups() {
            return dataservice.ageGroupDropDownList(vm.formdata.sectionId)
                .then(function (data) {
                    data.itemsList.unshift({text: gettextCatalog.getString('All'), value: 0});
                    vm.ageGroupList = data.itemsList;
                });
        }

        function ageGroupDataBound() {
            if (vm.ageGroupList.length === 1) {
                angular.element('#ageGroupId').ejDropDownList('selectItemByValue', vm.ageGroupList[0].value);
            } else {
                angular.element('#ageGroupId').ejDropDownList('selectItemByValue', vm.formdata.ageGroupId);
            }
        }

        function ageGroupSelect(args) {
            vm.formdata.ageGroupId = args.value;
            getCoaches();
        }

        function getCoaches() {
            return dataservice.coachDropDownList(vm.formdata.sectionId, vm.formdata.ageGroupId).then(function (data) {
                data.itemsList.unshift({text: gettextCatalog.getString('All'), value: 0});
                vm.coachList = data.itemsList;
            });
        }

        function coachDataBound() {
            if (vm.coachList.length === 1) {
                angular.element('#coachId').ejDropDownList('selectItemByValue', vm.coachList[0].value);
            } else {
                angular.element('#coachId').ejDropDownList('selectItemByValue', vm.formdata.coachId);
            }
        }

        function coachSelect(args) {
            vm.formdata.coachId = args.value;
            getPaints();
        }

        function getPaints() {
            return dataservice.GetPaints(vm.formdata.sectionId, vm.formdata.ageGroupId, vm.formdata.coachId)
                .then(function (data) {
                    data.itemsList.unshift({text: gettextCatalog.getString('None'), value: 0});
                    vm.paintList = data.itemsList;
                });
        }

        function paintDataBound() {
            if (vm.formdata.paintId && vm.formdata.paintId > 0) {
                angular.element('#paintId').ejDropDownList('selectItemByValue', vm.formdata.paintId);
            } else {
                angular.element('#paintId').ejDropDownList('selectItemByValue', 0);
            }
        }

        function paintSelect(args) {
            vm.formdata.paintId = args.value;
        }

        function save() {
            $scope.$broadcast('submitted');
            if ($scope.form.$valid === false) {
                log.errorMsg('RequiredFieldsError');
            } else {
                vm.formdata.imageList = [];
                for (var i = 0; i < $scope.files.length; i++) {
                    vm.formdata.imageList.push({
                        fileName: $scope.files[i].name,
                        fileData: $scope.imageDatas[i]
                    });
                }

                /* vagy a getExercise-ban az alábbi sor előtt kell egy
                   angular.element('#bodyParts').ejAutocomplete('clearText');
                   vm.formdata = result.gyakorlat;
                 */
                vm.formdata.bodyParts = angular.element('#bodyParts').ejAutocomplete('getValue');
                vm.formdata.type = angular.element('#type').ejAutocomplete('getValue');
                vm.formdata.individualTeam = angular.element('#individualTeam').ejAutocomplete('getValue');
                vm.formdata.asserts = angular.element('#asserts').ejAutocomplete('getValue');
                return dataservice.saveExercise(vm.formdata).then(function (results) {
                    vm.formdata.id = results.res;
                    vm.formdata.imageList = [];
                    $scope.imageDatas = [];
                    $scope.files = [];
                    log.htmlSuccess(gettextCatalog.getString('Saved'));
                    getExercise(vm.formdata.id);
                });
            }
        }

        function deleteImg(index) {
            $scope.files.splice(index, 1);
            $scope.imageDatas.splice(index, 1);
        }

        function deleteExistingImg(index) {
            if (vm.thumbnailIndex === index) {
                vm.thumbnail = null;
                vm.formdata.thumbnail = null;
            }
            vm.formdata.savedImageList.splice(index, 1);
        }

        function publicChanged(args) {
            vm.formdata.publikus = args.value;
        }

        function makeToThumb(fileIndex) {
            var volt = false;
            $.each(vm.formdata.savedImageList, function (index, item) {
                item.thumbnail = index === fileIndex;
                if (index === fileIndex) {
                    volt = true;
                    vm.thumbnailIndex = fileIndex;
                    vm.thumbnail = DOMAIN.baseURL + DOMAIN.exerciseBaseUrl + item.fileName;
                }
            });
            if (!volt) {
                vm.thumbnail = null;
            }
        }

        function openPaint() {
            var id = $('#paintId').ejDropDownList('getSelectedValue');
            var saved = save();
            if (id > 0 && saved) {
                saved.then(function () {
                    paramHelper.setParams([{'Paint.id': id}, {'exercises.exerciseId': vm.formdata.id}]);
                    $state.go('paint');
                });
            }
        }

        function goToCreatePaint() {
            var saved = save();
            if (saved) {
                saved.then(function () {
                    paramHelper.setParams([{'exercises.exerciseId': vm.formdata.id}]);
                    $state.go('paint');
                });
            }
        }

        vm.deleteVideo = function () {
            vm.formdata.youtube = '';
            if (vm.player) {
                vm.player.destroy();
            }
            $('#player').remove();
        };
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.administration.exercises.exercisesCreate')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'administration.exercises.exercisesCreate',
                config: {
                    url: '/exercisesCreate',
                    templateUrl: 'app/administration/exercises/exercisesCreate/exercisesCreate.html',
                    controller: 'ExercisesCreateController',
                    controllerAs: 'vm',
                    title: 'ExercisesCreate',
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    ExercisesListController.$inject = ["log", "paramHelper", "dataservice", "$q", "$rootScope", "gettextCatalog", "DOMAIN", "$scope", "$timeout", "authenticationService", "$state", "$filter"];
    angular
        .module('app.administration.exercises.exercisesList')
        .controller('ExercisesListController', ExercisesListController);

    function ExercisesListController(log, paramHelper, dataservice, $q, $rootScope, gettextCatalog, DOMAIN, $scope, $timeout, authenticationService, $state, $filter) {
        var vm = this; $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('ExercisesList');

        vm.imageRoot = DOMAIN.baseURL + DOMAIN.exerciseBaseUrl;
        vm.youtubeIcon = DOMAIN.baseURL + DOMAIN.youtubeIcon;

        vm.SzakosztalyId = 0;
        vm.KorosztalyId = 0;
        vm.EdzoId = 0;
        vm.dataSource = [];
        vm.MODGYAKORLAT = false;
        vm.UJGYAKORLAT = false;

        // autoComplete
        vm.bodyPartValue = '';
        vm.TypeValue = '';
        vm.individualTeamValue = '';
        vm.AssetValue = '';
        vm.difficultyValue = '';
        vm.timeValue = '';
        vm.necessaryAreaValue = '';
        vm.withVideo = false;
        vm.withPattern = false;
        vm.withPaint = false;

        vm.columns = [
            {type: 'checkbox', headerText: '', textAlign: 'center', width: 55},
            {field: 'GyakorlatId', isPrimaryKey: true, visible: false},
            {field: 'Nev', headerText: gettextCatalog.getString('Name'), width: 150, textAlign: 'center', template: '#wtpropentemp'},
            {field: 'Mintakep', headerText: gettextCatalog.getString('Pattern'), width: 180, textAlign: 'center', template: '#imagetemplateGrid'},
            {field: 'Video', headerText: gettextCatalog.getString('Video'), width: 115, type: 'boolean', displayAsCheckBox: true, textAlign: 'center'},
            {field: 'Szakosztaly', headerText: gettextCatalog.getString('Section'), width: 150, textAlign: 'center'},
            {field: 'SzakosztalyId', visible: false},
            {field: 'Korosztaly', headerText: gettextCatalog.getString('AgeGroup'), width: 150, textAlign: 'center'},
            {field: 'KorosztalyId', visible: false},
            {field: 'Edzo', headerText: gettextCatalog.getString('Coach'), width: 150, textAlign: 'center'},
            {field: 'EdzoId', visible: false},
            {field: 'Ido', headerText: gettextCatalog.getString('TimeLength'), width: 150, textAlign: 'center'},
            {field: 'Testresz', headerText: gettextCatalog.getString('BodyParts'), width: 150, textAlign: 'center'},
            {field: 'Tipus', headerText: gettextCatalog.getString('Type'), width: 150, textAlign: 'center'},
            {field: 'Jellege', headerText: gettextCatalog.getString('individualTeam'), width: 150, textAlign: 'center'},
            {field: 'Felszerelesek', headerText: gettextCatalog.getString('Assets'), width: 150, textAlign: 'center'},
            {field: 'Publikus', headerText: gettextCatalog.getString('Public'), width: 150, type: 'boolean', displayAsCheckBox: true, textAlign: 'center'},
            {field: 'Kifesto', headerText: gettextCatalog.getString('Paint'), width: 150, textAlign: 'center'},
            {field: 'JatekosokSzama', headerText: gettextCatalog.getString('Players'), width: 150, textAlign: 'center'},
            {field: 'Nehezseg', headerText: gettextCatalog.getString('Difficulty'), width: 150, textAlign: 'center'},
            {field: 'SzuksegesTerulet', headerText: gettextCatalog.getString('Space'), width: 150, textAlign: 'center'},
        ];

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItems,
            allowPaging: true,
            allowSorting: true,
            allowExcelExport: true,
            allowTextWrap: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#Grid'), $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        vm.sectionDataBound = sectionDataBound;
        vm.sectionSelect = sectionSelect;
        vm.ageGroupDataBound = ageGroupDataBound;
        vm.ageGroupSelect = ageGroupSelect;
        vm.coachDataBound = coachDataBound;
        vm.coachSelect = coachSelect;
        vm.getDatas = getDatas;
        vm.goToExercise = goToExercise;
        vm.deleteExercise = deleteExercise;
        vm.create = create;

        activate();

        function activate() {
            $q.all([getSections(), paramHelper.getParams([], ['exercisesList.SzakosztalyId', 'exercisesList.KorosztalyId', 'exercisesList.EdzoId']), authenticationService.getRight('MODGYAKORLAT'), authenticationService.getRight('UJGYAKORLAT')]).then(function (results) {
                if (results[1]['exercisesList.SzakosztalyId']) {
                    vm.SzakosztalyId = results[1]['exercisesList.SzakosztalyId'];
                    vm.SzakosztalyId = results[1]['exercisesList.SzakosztalyId'];
                }
                if (results[1]['exercisesList.KorosztalyId']) {
                    vm.KorosztalyId = results[1]['exercisesList.KorosztalyId'];
                    vm.KorosztalyId = results[1]['exercisesList.KorosztalyId'];
                }
                if (results[1]['exercisesList.EdzoId']) {
                    vm.EdzoId = results[1]['exercisesList.EdzoId'];
                    vm.EdzoId = results[1]['exercisesList.EdzoId'];
                }
                vm.MODGYAKORLAT = results[2];
                vm.UJGYAKORLAT = results[3];
                getAutoComplete();
            });
        }

        function getSections() {
            return dataservice.sectionDropDownList(0)
                .then(function (data) {
                    if (data.itemsList.length > 1) {
                        data.itemsList.unshift({value: 0, text: gettextCatalog.getString('All')});
                    }
                    vm.sectionList = data.itemsList;
                });
        }

        function sectionDataBound() {
            if (vm.sectionList.length === 1) {
                $('#sectionDropDown').ejDropDownList('selectItemByValue', vm.sectionList[0].value);
            } else {
                $('#sectionDropDown').ejDropDownList('selectItemByValue', vm.SzakosztalyId);
            }
        }

        function sectionSelect(args) {
            vm.SzakosztalyId = args.value;
            if (!vm.KorosztalyId) {
                vm.KorosztalyId = 0;
            }
            if (!vm.EdzoId) {
                vm.EdzoId = 0;
            }
            getAgeGroups(args.value);
            getCoachList();
            paramHelper.setParams([{'exercisesList.SzakosztalyId': args.value}]);
        }

        function getAgeGroups(sectionId) {
            dataservice.ageGroupDropDownList(sectionId)
                .then(function (data) {
                    if (data.itemsList.length > 1) {
                        data.itemsList.unshift({value: 0, text: gettextCatalog.getString('All')});
                    }
                    vm.ageGroupList = data.itemsList;
                });
        }

        function ageGroupDataBound() {
            if (vm.ageGroupList.length === 1) {
                $('#ageGroupDropDown').ejDropDownList('selectItemByValue', vm.ageGroupList[0].value);
            } else {
                $('#ageGroupDropDown').ejDropDownList('selectItemByValue', vm.KorosztalyId);
            }
        }

        function ageGroupSelect(args) {
            vm.KorosztalyId = args.value;
            getCoachList(args.value);
            paramHelper.setParams([{'exercisesList.KorosztalyId': args.value}]);
        }

        function getCoachList(KorosztalyId) {
            return dataservice.coachDropDownList(vm.SzakosztalyId, KorosztalyId, new Date(1754, 1, 1), new Date(3000, 1, 1))
                .then(function (data) {
                    if (data.itemsList.length > 1) {
                        data.itemsList.unshift({value: 0, text: gettextCatalog.getString('All')});
                    }
                    vm.coachList = data.itemsList;
                });
        }

        function coachDataBound() {
            if (vm.coachList.length === 1) {
                $('#coachDropDown').ejDropDownList('selectItemByValue', vm.coachList[0].value);
            } else {
                $('#coachDropDown').ejDropDownList('selectItemByValue', vm.EdzoId);
            }
        }

        function coachSelect(args) {
            vm.EdzoId = args.value;
            paramHelper.setParams([{'exercisesList.EdzoId': args.value}]);
        }

        // function bottom
        function getAutoComplete() {
            dataservice.getTrainingPracticeAutoComplete()
                .then(function (result) {
                    vm.autoComplete = result.data;
                });
        }

        function getDatas() {
            dataservice.getExercises(vm.SzakosztalyId, vm.KorosztalyId, vm.EdzoId, vm.bodyPartValue, vm.TypeValue, vm.individualTeamValue, vm.AssetValue, vm.difficultyValue, vm.necessaryAreaValue, vm.withVideo, vm.withPattern, vm.withPaint, vm.timeValue).then(function (response) {
                grid.dataSource = $filter('addImagePathToObject')(response.itemsList, 'Mintakep', vm.imageRoot);
                $timeout(function () {
                    $('.thumbnail-item').magnificPopup({
                        type: 'image'
                    });
                }, 100);
            });
        }

        function goToExercise(id) {
            if (vm.MODGYAKORLAT) {
                paramHelper.setParams([
                    {'exercises.exerciseId': id},
                    {'exercisesList.SzakosztalyId': vm.SzakosztalyId},
                    {'exercisesList.KorosztalyId': vm.KorosztalyId},
                    {'exercisesList.EdzoId': vm.EdzoId}
                    ]);
                $state.go('administration.exercises.exercisesCreate');
            } else {
                log.permissionError();
            }
        }

        function deleteExercise(id) {
            if (vm.MODGYAKORLAT) {
                swal({
                        title: gettextCatalog.getString('AreYouSureToDelete'),
                        type: 'warning',
                        showCancelButton: true,
                        confirmButtonText: gettextCatalog.getString('Yes'),
                        cancelButtonText: gettextCatalog.getString('No')
                    }).then(function (isConfirm) {
                        if (isConfirm.value) {
                            dataservice.DeleteExercise(id).then(function (response) {
                                if (response.retValue === true) {
                                    getDatas();
                                    log.htmlSuccess(gettextCatalog.getString('ExerciseDeleted'));
                                }
                            });
                        }
                    });
            } else {
                log.permissionError();
            }
        }

        function create() {
            if (vm.UJGYAKORLAT) {
                paramHelper.setParams([
                    {'exercisesList.SzakosztalyId': vm.SzakosztalyId},
                    {'exercisesList.KorosztalyId': vm.KorosztalyId},
                    {'exercisesList.EdzoId': vm.EdzoId}
                ]);
                $state.go('administration.exercises.exercisesCreate');
            } else {
                log.permissionError();
            }
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.administration.exercises.exercisesList')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'administration.exercises.exercisesList',
                config: {
                    url: '/exercisesList',
                    templateUrl: 'app/administration/exercises/exercisesList/exercisesList.html',
                    controller: 'ExercisesListController',
                    controllerAs: 'vm',
                    title: 'ExercisesList',
                    settings: {
                        navId: 2162,
                        level: 2,
                        order: 16,
                        orderTitle_hu: 'Gyakorlat lista',
                        orderTitle_en: 'Exercises List',
                        parentId: 2,
                        content: 'ExercisesList'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.administration.monthlyAttendance')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'administration.monthlyAttendance',
                config: {
                    url: '/monthlyAttendance',
                    templateUrl: 'app/administration/monthlyAttendance/monthlyAttendance.html'
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    MonthlyAttendanceListController.$inject = ["dataservice", "log", "$q", "$state", "gettextCatalog", "paramHelper", "$scope", "authenticationService", "$rootScope", "$timeout"];
    angular
        .module('app.administration.monthlyAttendance.monthlyAttendanceList')
        .controller('MonthlyAttendanceListController', MonthlyAttendanceListController);

    function MonthlyAttendanceListController(dataservice, log, $q, $state, gettextCatalog, paramHelper, $scope, authenticationService, $rootScope, $timeout) {
        var vm = this;
        $rootScope.vm = vm;

        // Page title
        $rootScope.title = gettextCatalog.getString('MonthlyAttendanceList');

        vm.columns = [{
            field: 'Id',
            visible: false,
            isPrimaryKey: true,
            isIdentity: true
        },
            {
                field: 'Link',
                headerText: '',
                textAlign: 'center',
                width: 60,
                allowEditing: false,
                template: '#moatlitemplateDataColumn5'
            },
            {
                field: 'Szakosztaly',
                headerText: gettextCatalog.getString('Section'),
                textAlign: 'center',
                width: 120,
                allowEditing: false
            }, {
                field: 'Korosztaly',
                headerText: gettextCatalog.getString('AgeGroup'),
                textAlign: 'left',
                width: 120,
                allowEditing: false,
                template: '#moatlitemplateDataColumn1'
            }, {
                field: 'Edzo',
                headerText: gettextCatalog.getString('Coach'),
                textAlign: 'center',
                width: 150,
                allowEditing: false,
                template: '#moatlitemplateDataColumn2'

            }, {
                field: 'Datum',
                headerText: gettextCatalog.getString('Date'),
                textAlign: 'center',
                width: 120,
                allowEditing: false
            }, {
                field: 'CsoportLetszam',
                headerText: gettextCatalog.getString('CsoportLetszam'),
                textAlign: 'center',
                width: 120,
                cssClass: 'rotate90degreegridheader2',
                allowEditing: false
            }, {
                field: 'Erkezett',
                headerText: gettextCatalog.getString('Erkezett'),
                textAlign: 'center',
                width: 100,
                cssClass: 'rotate90degreegridheader2',
                allowEditing: false
            }, {
                field: 'Tavozott',
                headerText: gettextCatalog.getString('Tavozott'),
                textAlign: 'center',
                width: 100,
                cssClass: 'rotate90degreegridheader2',
                allowEditing: false
            },
            {
                field: 'EdzoLezarta',
                headerText: gettextCatalog.getString('EdzoLezarta'),
                textAlign: 'center',
                width: 120,
                cssClass: 'rotate90degreegridheader2',
                allowEditing: false,
                type: 'boolean',
                template: '#moatlitemplateDataColumn3'
            }, {
                field: 'SzakvezJovahagyta',
                headerText: gettextCatalog.getString('SzakvezJovahagyta'),
                textAlign: 'center',
                width: 150,
                cssClass: 'rotate90degreegridheader2',
                allowEditing: false,
                type: 'boolean',
                template: '#moatlitemplateDataColumn4'
            }];

        var grid = new ej2.grids.Grid({
            toolbar: $rootScope.toolbarItems,
            allowPaging: true,
            allowExcelExport: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            allowTextWrap: true,
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            beforePrint: $rootScope.beforePrintGrid,
            printComplete: $rootScope.printCompleteGrid,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#Grid'), $scope);
                }
            },
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        function setInitVals() {
            //grid adatai
            vm.coachList = [];
            vm.selectedCoach = 0;
            //Lekérés típusa
            vm.modeList = [
                gettextCatalog.getString('MindenHaviJelenleti'),
                gettextCatalog.getString('CsakLezartHaviJelenletik'),
                gettextCatalog.getString('CsakNemLezartHaviJelenletik')
            ];
            //Kiválasztott lekérés típusa
            vm.selectedMode = gettextCatalog.getString('MindenHaviJelenleti');
            //Évek (2010-től az aktuális évig)
            vm.years = [];
            vm.years.push(gettextCatalog.getString('AllYear'));
            for (var ev = 2010; ev <= new Date().getFullYear(); ev++) {
                vm.years.push(ev);
            }
            //Kiválasztott év (alapból az aktuális)
            vm.selectedYear = new Date().getFullYear();
            //Hónapok
            vm.months = [
                {
                    text: gettextCatalog.getString('AllMonth'),
                    value: -1
                },
                {
                    text: gettextCatalog.getString('January'),
                    value: 0
                }, {
                    text: gettextCatalog.getString('February'),
                    value: 1
                }, {
                    text: gettextCatalog.getString('March'),
                    value: 2
                }, {
                    text: gettextCatalog.getString('April'),
                    value: 3
                }, {
                    text: gettextCatalog.getString('May'),
                    value: 4
                }, {
                    text: gettextCatalog.getString('June'),
                    value: 5
                }, {
                    text: gettextCatalog.getString('July'),
                    value: 6
                }, {
                    text: gettextCatalog.getString('August'),
                    value: 7
                }, {
                    text: gettextCatalog.getString('September'),
                    value: 8
                }, {
                    text: gettextCatalog.getString('October'),
                    value: 9
                }, {
                    text: gettextCatalog.getString('November'),
                    value: 10
                }, {
                    text: gettextCatalog.getString('December'),
                    value: 11
                }];
            //Kiválasztott hónap
            vm.selectedMonth = -1; //new Date().getMonth();
            //A gridben megjelenő adatok
        }

        setInitVals();

        vm.coachChanged = coachChanged;
        vm.createNewAttendance = createNewAttendance;
        vm.refreshData = refreshData;
        vm.goToNewUser = goToNewUser;
        vm.goToNewAgeGroup = goToNewAgeGroup;
        vm.goToMonthlyAttendance = goToMonthlyAttendance;
        vm.yearChanged = yearChanged;

        activate();

        //inicializálás
        function activate() {
            authenticationService.getRight('MEGTHAVIJEL').then(function (res) {
                if (!res) {
                    log.permissionError(true);
                } else {
                    var promises = [
                        getCoaches(),
                        authenticationService.getRight('HJFELVIHET'),
                        authenticationService.getRight('MEGTFELH'),
                        authenticationService.getRight('MEGTKOROKEZ'),
                        authenticationService.getRight('MEGTHAVIJEL'),
                        paramHelper.getParams([], ['monthlyAttendance.coachId', 'monthlyAttendance.year', 'monthlyAttendance.month', 'monthlyAttendance.selectedMode'])
                    ];
                    return $q.all(promises).then(function (results) {
                        vm.HJFELVIHET = results[1];
                        vm.MEGTFELH = results[2];
                        vm.MEGTKOROKEZ = results[3];
                        vm.MEGTHAVIJEL = results[4];
                        $timeout(function () {
                            vm.selectedCoach = results[5]['monthlyAttendance.coachId'];
                            vm.selectedMode = results[5]['monthlyAttendance.selectedMode'];
                            vm.selectedYear = results[5]['monthlyAttendance.year'];
                            vm.selectedMonth = results[5]['monthlyAttendance.month'];
                        }, 100);
                        if (vm.coachList.length === 1) {
                            vm.selectedCoach = vm.coachList[0].value;
                        }
                        //refreshData();
                    });
                }
            });
        }

        //edzők lekérése
        function getCoaches() {
            return dataservice.coachSelect().then(
                function (data) {
                    vm.coachList = data.itemsList;
                    /*
                                        var listObj = new ej.dropdowns.DropDownList({
                                            dataSource: vm.coachList,
                                            // set the index value to select an item based on index at initial rendering
                                            index: vm.selectedCoach,
                                            // set the placeholder to DropDownList input element
                                            placeholder: 'Select a couach',
                                            // bind the change event
                                            change: function (args) { coachChanged(args); }
                                        });
                                        listObj.appendTo('#maEdzo');
                                        */
                    return vm.coachList;
                }
            );
        }

        //edző dropdownlist selectionchanged
        function coachChanged(args) {
            console.log(args);
            /*
            vm.selectedCoach = args.value;
            var item = ej.DataManager(vm.coachList).executeLocal(new ej.Query().where('value', 'equal', vm.selectedCoach))[0];
            vm.allAgeGroupfill = item.HaviJelenletiKorosztalyonkent;
            vm.sectionList = [];
            vm.ageGroupList = [];
            vm.selectedAgeGroup = 0;
            vm.selectedSection = 0;
            */
        }

        function createNewAttendance() {
            goToMonthlyAttendance(-1);
        }

        //Melyik az adott év/hónap utolsó napja?
        function daysInMonth(anyDateInMonth) {
            return new Date(anyDateInMonth.getFullYear(), anyDateInMonth.getMonth() + 1, 0).getDate();
        }

        function refreshData() {
            // a syncfusion direktívák miatt
            $scope.$broadcast('submitted');
            if ($scope.form.$valid === false) {
                log.errorMsg(gettextCatalog.getString('RequiredFieldsError'));
                return;
            }

            saveParameters();
            var tol = new Date();
            var day = 0;
            var ig = 0;
            var year = isNaN(vm.selectedYear) ? 1754 : vm.selectedYear;
            var month = isNaN(vm.selectedMonth) ? 1 : vm.selectedMonth;

            if (vm.selectedMonth == -1) {
                tol = new Date(year, 0, 1, 0, 0, 0);
                day = daysInMonth(new Date(year === 1754 ? 9999 : year, 12, 1));
                ig = new Date(year === 1754 ? 9999 : year, 11, day, 23, 59, 59);
            } else {
                tol = new Date(year, month, 1, 0, 0, 0);
                day = daysInMonth(new Date(year, month, 1));
                ig = new Date(year === 1754 ? 9999 : year, month, day, 23, 59, 59);
            }

            var coach = 0;
            if (vm.selectedCoach) {
                coach = vm.selectedCoach;
            }

            var lezart = 0;
            if (vm.selectedMode === gettextCatalog.getString('CsakLezartHaviJelenletik')) {
                lezart = 1;
            } else if (vm.selectedMode === gettextCatalog.getString('CsakNemLezartHaviJelenletik')) {
                lezart = 2;
            }

            dataservice.getMonthlyAttendanceList(coach, tol, ig, lezart).then(
                function (data) {
                    grid.dataSource = data.itemsList;
                }
            );
        }

        function goToNewUser(edzoId) {
            if (!vm.MEGTFELH) {
                log.permissionError();
                return;
            }
            paramHelper.setParams([{
                'newUser.userId': edzoId
            }]);
            saveParameters();
            $state.go('settings.userManagement.modifyUser');
        }

        function goToNewAgeGroup(ageGroupId) {
            if (!vm.MEGTKOROKEZ) {
                log.permissionError();
                return;
            }
            paramHelper.setParams([{
                'ageGroups.ageGroup': ageGroupId
            }]);
            $state.go('athletes.ageGroups.modifyAgeGroup');
        }

        function saveParameters() {
            paramHelper.setParams([{
                'monthlyAttendance.month': vm.selectedMonth,
                'monthlyAttendance.year': vm.selectedYear,
                'monthlyAttendance.coachId': vm.selectedCoach,
                'monthlyAttendance.selectedMode': vm.selectedMode

            }]);
        }

        function goToMonthlyAttendance(attendanceId) {
            if (!vm.MEGTHAVIJEL) {
                log.permissionError();
                return;
            }
            paramHelper.setParams([{
                'monthlyAttendance.id': attendanceId

            }]);
            saveParameters();
            $state.go('administration.monthlyAttendance.monthlyAttendanceReport');
        }

        function yearChanged(args) {
            if (args.itemId === 0) {
                vm.selectedMonth = -1;
            }
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.administration.monthlyAttendance.monthlyAttendanceList')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'administration.monthlyAttendance.monthlyAttendanceList',
                config: {
                    url: '/monthlyAttendanceList',
                    templateUrl: 'app/administration/monthlyAttendance/monthlyAttendanceList/monthlyAttendanceList.html',
                    controller: 'MonthlyAttendanceListController',
                    controllerAs: 'vm',
                    title: 'MonthlyAttendanceList',
                    settings: {
                        navId: 274,
                        level: 2,
                        order: 7,
                        orderTitle_hu: 'Korábbi havi jelenléti összesítők',
                        orderTitle_en: 'Previous Monthly Attendance Sheet Report',
                        parentId: 4,
                        content: 'MonthlyAttendanceList',
                        activatorPermission: '"MEGTHAVIJEL"'
                    }
                }
            }
        ];
    }
})();

(function () {
    MonthlyAttendanceController.$inject = ["dataservice", "log", "$q", "$state", "$rootScope", "gettextCatalog", "authenticationService", "paramHelper", "$scope", "$compile", "$timeout", "$interval"];
    angular
        .module('app.administration.monthlyAttendance.monthlyAttendanceReport')
        .controller('MonthlyAttendanceReportController', MonthlyAttendanceController);

    function MonthlyAttendanceController(dataservice, log, $q, $state, $rootScope, gettextCatalog, authenticationService, paramHelper, $scope, $compile, $timeout, $interval) {
        var vm = this;
        $rootScope.vm = vm; // jshint ignore: line

        // Page title
        vm.autoSave = undefined;
        vm.readOnlyAttendance = false;
        vm.AthleteUnderEditing = '';
        vm.allowAthleteRefresh = true;
        vm.AthleteUnderEditingText = gettextCatalog.getString('ActualAthlete');
        $rootScope.title = gettextCatalog.getString('MonthlyAttendanceReport');
        vm.openTrainingDiary = openTrainingDiary;
        vm.cellSave = cellSave;
        vm.activePeriods = [];
        var printOpened = false;
        var newAthletesId = -1;
        var prev = '';
        vm.plannedTrainings = undefined;
        vm.SetForAll = SetForAll;
        vm.defaultTeamInformations = false;
        vm.errors = [];
        vm.editedRowId = 0;
        vm.editedColumnName = '';
        vm.selectionMode = ['cell'];
        vm.gridRowSelected = gridRowSelected;
        // Grid's details
        vm.reportParameters = {};
        vm.selectedAthleteName = '';
        vm.yearDataBound = yearDataBound;
        vm.monthDataBound = monthDataBound;
        vm.elem;
        vm.maskObject;
        vm.CopyCellToColumn = CopyCellToColumn;
        var tableEditorTemplate =
            {
                create: function () {
                    var btn = document.createElement('button');
                    btn.setAttribute('type', 'button');
                    btn.textContent = '↕';
                    btn.style.width = '30px';
                    btn.style.minWidth = '30px';
                    btn.style.height = '28px';
                    btn.style.color = 'black';
                    btn.style.marginLeft = '-7px';
                    btn.style.display = 'inline';
                    var txt = document.createElement('input');
                    txt.style.width = '20px';
                    txt.style.float = 'left';
                    //  var elem=document.createElement('div');
                    //  elem.style.display='inline';
                    //  elem.appendChild(txt);
                    //  elem.appendChild(btn);
                    vm.elem = txt;
                    vm.elem.addEventListener('focus', function () {
                        this.select();
                    });
                    return vm.elem;
                },
                read: function () {
                    var res = vm.maskObject.getMaskedValue();
                    return res === '_' ? '' : res;
                },
                destroy: function () {
                    if (vm.maskObject != null) {
                        vm.maskObject.destroy();
                    }
                },
                write: function (args) {
                    vm.allowAthleteRefresh = false;
                    $scope.$apply();
                    var s = args.element.id.toString().replace('GridNew', '');
                    vm.maskObject = new ej2.inputs.MaskedTextBox({
                        minWidth: '20px',
                        mask: '>C',
                        customCharacters: {C: 'bBüÜvVsShH0123-'},
                        value: args.rowData !== angular.isUndefined ? args.rowData[s] : ''.replace(' ', '')
                    });
                    vm.editedRowId = args.rowData['Id'];
                    $compile(args.element[0])($scope);
                    vm.maskObject.appendTo(vm.elem);
                }
            };

        var gridNew;

        function queryCellInfo(args) {
            var element = angular.element(args.cell);
            var sportolo = args.data.IdSportolo;
            if (args.column.field.indexOf('Nap') !== -1) {
                var nap = args.column.field.substring(3);
                var sor = findLine(sportolo);
                if ((args.column.headerText.toString().indexOf(gettextCatalog.getString('MondayAbbr')) !== -1) || (args.column.headerText.toString().indexOf('MondayAbbr') !== -1)) {
                    element.css('background-color', '#d2e4ff');
                }
                if (sor && sor['Nap' + nap] === '0') {
                    element.css('background-color', '#efdcdc');
                }
            }
        }

        //Jelenlét százalék
        vm.presencePercentSum = 0;
        //Jelenlét számolásához kell
        vm.presenceTotalSum = 0;
        vm.presencePlannedTotalSum = 0;
        //Évek (2010-től az aktuális évig)
        vm.years = [];
        for (var ev = 2010; ev <= new Date().getFullYear(); ev++) {
            vm.years.push(ev);
        }
        vm.dayz = {};
        //Kiválasztott év (alapból az aktuális)
        vm.selectedYear = new Date().getFullYear();
        //Hónapok
        vm.months = [
            {
                text: gettextCatalog.getString('January'),
                value: 0
            }, {
                text: gettextCatalog.getString('February'),
                value: 1
            }, {
                text: gettextCatalog.getString('March'),
                value: 2
            }, {
                text: gettextCatalog.getString('April'),
                value: 3
            }, {
                text: gettextCatalog.getString('May'),
                value: 4
            }, {
                text: gettextCatalog.getString('June'),
                value: 5
            }, {
                text: gettextCatalog.getString('July'),
                value: 6
            }, {
                text: gettextCatalog.getString('August'),
                value: 7
            }, {
                text: gettextCatalog.getString('September'),
                value: 8
            }, {
                text: gettextCatalog.getString('October'),
                value: 9
            }, {
                text: gettextCatalog.getString('November'),
                value: 10
            }, {
                text: gettextCatalog.getString('December'),
                value: 11
            }
        ];
        //Kiválasztott hónap
        vm.yearValue = new Date().getFullYear();
        vm.selectedYear = new Date().getFullYear();
        vm.monthValue = new Date().getMonth();
        vm.selectedMonth = new Date().getMonth();
        //Napok nevei (rövidítve)
        vm.days = [
            gettextCatalog.getString('SundayAbbr'),
            gettextCatalog.getString('MondayAbbr'),
            gettextCatalog.getString('TuesdayAbbr'),
            gettextCatalog.getString('WednesdayAbbr'),
            gettextCatalog.getString('ThursdayAbbr'),
            gettextCatalog.getString('FridayAbbr'),
            gettextCatalog.getString('SaturdayAbbr')
        ];
        //Edzők listája, kiválasztott edző
        vm.coachList = [];
        //Szakosztályok listája, kiválasztott szakosztály
        vm.sectionList = [];
        vm.selectedSection = 0;
        //Korcsoportok listája, kiválasztott korcsoport
        vm.ageGroupList = [];
        vm.selectedAgeGroup = 0;
        vm.refreshAthletesButton = false;
        vm.saveButton = false;
        vm.saveButtonEnabled = true;
        vm.closeButton = false;
        vm.acceptButton = false;
        vm.rejectButton = false;
        vm.attendanceOverChangeAthleteNames = '';
        //Havi jelenléti utolsó kitöltött nap
        vm.attendanceLastFilledDay = 0;
        //Minden korcsoportot egyszerre tölt az edző
        vm.allAgeGroupfill = false;
        //A szerkesztés alatt álló havi jelenléti
        vm.editedAttendance = {};
        //Jelenlét hiba volt a mentés során
        vm.hasErrorAtSave = false;
        //Visszautasítás indoka kerül bele
        vm.rejectAttendanceText = '';

        vm.attendanceSelect = attendanceSelect;
        vm.saveAttendance = saveAttendance;
        vm.refreshAthletes = refreshAthletes;
        vm.closeMonthlyAttendance = closeMonthlyAttendance;
        vm.rejectMonthlyAttendance = rejectMonthlyAttendance;
        vm.closerejectingWindow = closerejectingWindow;
        vm.rejectAttendance = rejectAttendance;
        vm.acceptMonthlyAttendance = acceptMonthlyAttendance;
        // coach dropdown
        vm.coachDataBound = coachDataBound;
        vm.coachSelect = coachSelect;
        // section dropdown
        vm.sectionDataBound = sectionDataBound;
        vm.sectionSelect = sectionSelect;
        // ageGroup dropdown
        vm.ageGroupDataBound = ageGroupDataBound;
        vm.ageGroupSelect = ageGroupSelect;
        // year dropdown
        vm.yearSelect = yearSelect;
        // month dropdown
        vm.monthSelect = monthSelect;
        vm.goToNewAthlete = goToNewAthlete;
        vm.goToOlderMonthlyAttendanceReports = goToOlderMonthlyAttendanceReports;
        vm.CopyTimeAndPlaceFromWeeklyPlan = CopyTimeAndPlaceFromWeeklyPlan;
        vm.print = print;
        vm.runOnce = 0;
        vm.openTrainingDiaryAfterSave = false;

        vm.defaultSection = undefined;
        vm.defaultAgeGroup = undefined;
        vm.defaultCoach = undefined;
        vm.yearValue = vm.selectedYear;
        vm.defaultMonth = undefined;
        var JelenletTipus =
        {
            IgazoltHianyzas: 0,
            Serules: 1,
            Verseny: 2,
            Betegseg: 3
        };
        // Default beállítások
        vm.attendanceChecked = [JelenletTipus.IgazoltHianyzas, JelenletTipus.Serules, JelenletTipus.Betegseg];

        activate();

        function openTrainingDiary() {
            vm.openTrainingDiaryAfterSave = true;
            if (!vm.readOnlyAttendance) {
                gridNew.endEdit();
            }
            if (vm.readOnlyAttendance) {
                paramHelper.setParams([{'HaviJelenletiFejId': vm.editedAttendance.fej.Id}]);
                $state.go('administration.trainingDiary');
            } else {
                saveAttendance();
            }
        }

        function findLine(sportolo) {
            for (var i = 0; i < vm.activePeriods.length; i++) {
                if (vm.activePeriods[i].IdSportolo == sportolo) {
                    return vm.activePeriods[i];
                }
            }
        }

        function activate() {
            $q.all([paramHelper.getParams([], ['monthlyAttendance.id', 'monthlyAttendance.sectionId', 'monthlyAttendance.ageGroupId', 'monthlyAttendance.coachId', 'monthlyAttendance.year', 'monthlyAttendance.month', 'monthlyAttendance.autoSave']), authenticationService.getRight('EDZO'), authenticationService.getRight('ADMIN'), authenticationService.getRight('SZAKOSZTVEZ'), authenticationService.getRight('TECHIGAZGATO'), authenticationService.getRight('HJALAIR1'), authenticationService.getRight('HJALAIR2'), authenticationService.getRight('HJFELVIHET'), authenticationService.getRight('MEGTSPORTLIST'), authenticationService.getRight('MEGTHAVIJEL'), getSystemSettingsValue('JELENLETNEKSZAMIT')])
                .then(function (results) {
                    vm.EDZO = results[1];
                    vm.ADMIN = results[2];
                    vm.SZAKOSZTVEZ = results[3];
                    vm.TECHIGAZGATO = results[4];
                    vm.HJALAIR1 = results[5];
                    vm.HJALAIR2 = results[6];
                    vm.HJFELVIHET = results[7];
                    vm.MEGTSPORTLIST = results[8];
                    vm.MEGTHAVIJEL = results[9];
                    if (results[10] && results[10] != null) {
                        vm.attendanceChecked = JSON.parse(results[10]);
                    }
                    if (!vm.MEGTHAVIJEL) {
                        log.permissionError(true);
                        return;
                    }
                    dataservice.getMonthlyAttendanceAutoSave().then(function (autoSave) {
                        if (vm.HJFELVIHET) {
                            vm.autoSave = autoSave.data;
                        } else {
                            vm.autoSave = false;
                        }
                        angular.element('#autoSaveCheckBox').ejCheckBox({checked: autoSave.data});
                    });
                    if (results[0]['monthlyAttendance.sectionId']) {
                        vm.defaultSection = results[0]['monthlyAttendance.sectionId'];
                    }

                    if (results[0]['monthlyAttendance.ageGroupId']) {
                        vm.defaultAgeGroup = results[0]['monthlyAttendance.ageGroupId'];
                    }
                    if (results[0]['monthlyAttendance.coachId']) {
                        vm.defaultCoach = results[0]['monthlyAttendance.coachId'];
                    }
                    if (results[0]['monthlyAttendance.year']) {
                        vm.selectedYear = results[0]['monthlyAttendance.year'];
                    }
                    if (results[0]['monthlyAttendance.month']) {
                        vm.selectedMonth = results[0]['monthlyAttendance.month'];
                    }
                    if (results[0]['monthlyAttendance.id'] && results[0]['monthlyAttendance.id'] !== -1) {
                        dataservice.monthlyAttendanceSelectById(results[0]['monthlyAttendance.id']).then(function (data) {
                            paramHelper.removeParam('monthlyAttendance.id');
                            createGrid(data.columns);
                            if (data.fej) {
                                vm.activePeriods = data.aktiv;
                                //paramHelper.removeParam('monthlyAttendance.id');
                                angular.element('#maEv').ejDropDownList('selectItemByValue', new Date(data.fej.Datum).getFullYear());
                                angular.element('#maHonap').ejDropDownList('selectItemByValue', new Date(data.fej.Datum).getMonth());
                                gridNew.dataSource = data.fej ? data.fej : [];
                                vm.defaultSection = data.fej.IdSzakosztaly ? data.fej.IdSzakosztaly : vm.defaultSection;
                                vm.defaultCoach = data.fej.IdEdzo ? data.fej.IdEdzo : vm.defaultCoach;
                                vm.defaultAgeGroup = data.fej.IdKorcsoport ? data.fej.IdKorcsoport : vm.defaultAgeGroup;
                                getCoaches();
                                viewMonthlyAttendance(data);
                            } else {
                                getCoaches();
                            }
                        });
                    } else {
                        getCoaches();
                    }
                });
        }

        function getSystemSettingsValue(valtozo) {
            return dataservice.getSystemSettingsValue(valtozo).then(function (response) {
                if (response.hasOwnProperty('retValue')) {
                    return response.retValue;
                }
                return null;
            });
        }

        function CopyTimeAndPlaceFromWeeklyPlan() {
            dataservice.CopyTimeAndPlaceFromWeeklyPlan(vm.editedAttendance.fej.Id).then(function (response) {
                if (response.data) {
                    if (response.data.HetfoHely.length > 0) {
                        vm.dayz.HetfoHely = response.data.HetfoHely;
                    }
                    if (response.data.HetfoIdo.length > 0) {
                        vm.dayz.HetfoIdo = response.data.HetfoIdo;
                    }
                    if (response.data.KeddHely.length > 0) {
                        vm.dayz.KeddHely = response.data.KeddHely;
                    }
                    if (response.data.KeddIdo.length > 0) {
                        vm.dayz.KeddIdo = response.data.KeddIdo;
                    }
                    if (response.data.SzerdaHely.length > 0) {
                        vm.dayz.SzerdaHely = response.data.SzerdaHely;
                    }
                    if (response.data.SzerdaIdo.length > 0) {
                        vm.dayz.SzerdaIdo = response.data.SzerdaIdo;
                    }
                    if (response.data.CsutortokHely.length > 0) {
                        vm.dayz.CsutortokHely = response.data.CsutortokHely;
                    }
                    if (response.data.CsutortokIdo.length > 0) {
                        vm.dayz.CsutortokIdo = response.data.CsutortokIdo;
                    }
                    if (response.data.PentekHely.length > 0) {
                        vm.dayz.PentekHely = response.data.PentekHely;
                    }
                    if (response.data.PentekIdo.length > 0) {
                        vm.dayz.PentekIdo = response.data.PentekIdo;
                    }
                    if (response.data.SzombatHely.length > 0) {
                        vm.dayz.SzombatHely = response.data.SzombatHely;
                    }
                    if (response.data.SzombatIdo.length > 0) {
                        vm.dayz.SzombatIdo = response.data.SzombatIdo;
                    }
                    if (response.data.VasarnapHely.length > 0) {
                        vm.dayz.VasarnapHely = response.data.VasarnapHely;
                    }
                    if (response.data.VasarnapIdo.length > 0) {
                        vm.dayz.VasarnapIdo = response.data.VasarnapIdo;
                    }
                } else {
                    log.errorMsg(gettextCatalog.getString('NoPlaceAndTimeDataFoundOnWeeklyTrainingPlan'));
                }
            });
        }

        function SetForAll() {
            //gridNew.editModule.batchSave();
            gridNew.endEdit();
            var names = '';
            var canSet = true;
            for (var i = 0; i < gridNew.dataSource.length; i++) {
                if ((gridNew.dataSource[i].JelenletOsszesen + gridNew.dataSource[i].HianyzasOsszesen) > vm.plannedTrainings) {
                    canSet = false;
                    names += gridNew.dataSource[i].SportoloNev + ', ';
                }
            }
            if (!canSet) {
                names = names.substring(0, names.length - 2);
                log.errorMsg(gettextCatalog.getString('PresencePlusAbsenceIsGreaterThanPlannedMonthlyAttendance') + ':<br><br>' + names);
                return;
            }
            for (var i = 0; i < gridNew.dataSource.length; i++) {
                gridNew.dataSource[i].HaviOsszEdzesszam = vm.plannedTrainings;
            }
        }

        //edzők lekérése
        function getCoaches() {
            return dataservice.coachSelect().then(
                function (data) {
                    vm.coachList = data.itemsList;
                }
            );
        }

        // Run after data bounded
        function coachDataBound() {
            if (vm.coachList.length === 1) {
                angular.element('#maEdzo').ejDropDownList('selectItemByValue', vm.coachList[0].value);
            } else {
                angular.element('#maEdzo').ejDropDownList('selectItemByValue', vm.defaultCoach);
            }
        }

        // Run after selection
        function coachSelect(args) {
            vm.selectedCoach = args.value;
            var item = ej.DataManager(vm.coachList).executeLocal(new ej.Query().where('value', 'equal', vm.selectedCoach))[0];
            vm.allAgeGroupfill = item.HaviJelenletiKorosztalyonkent;
            vm.sectionList = [];
            vm.ageGroupList = [];
            vm.selectedAgeGroup = 0;
            getSections();
        }

        //szakosztályok lekérése
        function getSections() {
            return dataservice.sectionDropDownList(vm.selectedCoach)
                .then(function (data) {
                    vm.sectionList = data.itemsList;
                });
        }

        // Run after data bounded
        function sectionDataBound() {
            if (vm.sectionList.length === 1) {
                angular.element('#maSzakosztaly').ejDropDownList('selectItemByValue', vm.sectionList[0].value);
            } else {
                angular.element('#maSzakosztaly').ejDropDownList('selectItemByValue', vm.defaultSection);
            }
        }

        // Run after selection
        function sectionSelect(args) {
            vm.selectedSection = args.value;
            getAgeGroups();
        }

        //korcsoportok lekérése
        function getAgeGroups() {
            return dataservice.ageGroupSelect(vm.selectedCoach, vm.selectedSection, new Date(vm.selectedYear, vm.selectedMonth, 1, 12, 0, 0))
                .then(function (data) {
                    vm.ageGroupList = data.itemsList;
                });
        }

        // Run after data bounded
        function ageGroupDataBound() {
            if (vm.ageGroupList.length === 1) {
                angular.element('#maKorosztaly').ejDropDownList('selectItemByValue', vm.ageGroupList[0].value);
            } else {
                if (vm.defaultAgeGroup) {
                    angular.element('#maKorosztaly').ejDropDownList('selectItemByValue', vm.defaultAgeGroup);
                } else if (vm.selectedAgeGroup) {
                    angular.element('#maKorosztaly').ejDropDownList('selectItemByValue', vm.selectedAgeGroup);
                }
            }
        }

        // Run after selection
        function ageGroupSelect(args) {
            vm.selectedAgeGroup = args.value;
        }

        // Run after selection
        function monthSelect(args) {
            vm.selectedMonth = args.value;
            getAgeGroups();
        }

        // Run after selection
        function yearSelect(args) {
            vm.selectedYear = args.value;
            getAgeGroups();
        }

        //'Választ' nyomógomb click
        function attendanceSelect() {
            vm.runOnce = 0;
            if (!vm.MEGTHAVIJEL) {
                log.permissionError();
                return;
            }
            // a syncfusion direktívák miatt
            $scope.$broadcast('submitted');
            if ($scope.form.$valid === false) {
                log.errorMsg('FillTheRequiredFields');
                return;
            }
            //gridNew.dataSource = [];
            var kivDatum = new Date(vm.selectedYear, (isNaN(vm.selectedMonth) ? 0 : vm.selectedMonth), 1, 0, 0, 0, 0);
            var dt = new Date(new Date().getFullYear(), new Date().getMonth(), 1, 0, 0, 0, 0);
            dt.setMonth(dt.getMonth() + 1);
            if (kivDatum >= dt) {
                log.errorMsg('WrongDate');
                return;
            }
            dataservice.monthlyAttendanceSelect(vm.selectedCoach, vm.selectedSection, vm.selectedAgeGroup,
                vm.selectedYear, (isNaN(vm.selectedMonth) ? 1 : Number(vm.selectedMonth)) + 1).then(function (data) {
                vm.saveButtonEnabled = true;
                createGrid(data.columns);
                viewMonthlyAttendance(data);
                vm.editedAttendance.aktiv = data.aktiv;
                vm.activePeriods = data.aktiv;
                if (data && data.fej && data.fej.Id) {
                    paramHelper.setParams([
                        {'monthlyAttendance.sectionId': vm.selectedSection},
                        {'monthlyAttendance.ageGroupId': vm.selectedAgeGroup},
                        {'monthlyAttendance.coachId': vm.selectedCoach},
                        {'monthlyAttendance.year': vm.selectedYear},
                        {'monthlyAttendance.month': vm.selectedMonth},
                        {'monthlyAttendance.id': data.fej.Id}
                    ]);
                } else {
                    paramHelper.setParams([
                        {'monthlyAttendance.sectionId': vm.selectedSection},
                        {'monthlyAttendance.ageGroupId': vm.selectedAgeGroup},
                        {'monthlyAttendance.coachId': vm.selectedCoach},
                        {'monthlyAttendance.year': vm.selectedYear},
                        {'monthlyAttendance.month': vm.selectedMonth},
                        {'monthlyAttendance.id': -1}
                    ]);
                }
            });
        }

        vm.rowNumber = 0;
        vm.columnNumber = 0;

        function createGrid(columns) {
            for (var i = 0; i < columns.length; i++) {
                if (columns[i].edit) {
                    columns[i].edit = tableEditorTemplate;
                }
                if (i === (columns.length - 1)) {
                    if (!gridNew) {
                        gridNew = new ej2.grids.Grid({
                            dataSource: [],
                            toolbar: ['ExcelExport'],
                            allowPaging: false,
                            allowExcelExport: true,
                            editSettings: {allowEditing: true, mode: 'Batch', showConfirmDialog: false},
                            //frozenColumns: 4,
                            locale: 'hu-HU',
                            gridLines: 'Both',
                            columns: columns,
                            cellSave: vm.cellSave,
                            queryCellInfo: queryCellInfo,
                            rowDataBound: function (args) {
                                $rootScope.compile(args.row, $scope);
                            },
                            rowSelected: vm.gridRowSelected,
                            actionComplete: function (args) {
                                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                                    $rootScope.compile($('#GridNew'), $scope);
                                }
                            },
                            cellEdit: function (arg) {
                                vm.columnNumber = gridNew.columns.findIndex(function (element) {
                                    return element.field === arg.columnName;
                                });
                                vm.rowNumber = gridNew.dataSource.findIndex(function (element) {
                                    return element.Id === arg.rowData.Id;
                                });
                                if (arg.columnName.indexOf('Nap') !== -1) {
                                    var nap = arg.columnName.substring(3);
                                    var sor = findLine(arg.rowData.IdSportolo);
                                    var property = 'Nap' + nap;
                                    if (sor && sor[property] == '0') {
                                        arg.cancel = true;
                                    }
                                }
                                vm.AthleteUnderEditing = arg.rowData.SportoloNev;
                                vm.editedColumnName = arg.columnName;
                            }
                        });
                        gridNew.appendTo('#GridNew');
                        gridNew.keyConfigs['0'] = '0';
                        gridNew.keyConfigs['1'] = '1';
                        gridNew.keyConfigs['2'] = '2';
                        gridNew.keyConfigs['3'] = '3';
                        gridNew.keyConfigs['B'] = 'B';
                        gridNew.keyConfigs['S'] = 'S';
                        gridNew.keyConfigs['V'] = 'V';
                        gridNew.keyConfigs['H'] = 'H';
                        gridNew.keyConfigs['b'] = 'B';
                        gridNew.keyConfigs['ü'] = '191';
                        gridNew.keyConfigs['Ü'] = '191';
                        gridNew.keyConfigs['s'] = 'S';
                        gridNew.keyConfigs['v'] = 'V';
                        gridNew.keyConfigs['h'] = 'H';
                        gridNew.keyConfigs['numpad 0'] = '96';
                        gridNew.keyConfigs['numpad 1'] = '97';
                        gridNew.keyConfigs['numpad 2'] = '98';
                        gridNew.keyConfigs['numpad 3'] = '99';
                        var oldkeyAction = gridNew.keyboardModule.keyAction;

                        gridNew.keyboardModule.keyAction = function (args) {
                            if (args.key === '0') {
                                vm.editedColumnValue = '0';
                            }
                            if (args.key === '1') {
                                vm.editedColumnValue = '1';
                            }
                            if (args.key === '2') {
                                vm.editedColumnValue = '2';
                            }
                            if (args.key === '3') {
                                vm.editedColumnValue = '3';
                            }
                            if (args.key === 'B' || args.key === 'b') {
                                vm.editedColumnValue = 'B';
                            }
                            if (args.key === 'Ü' || args.key === 'ü') {
                                vm.editedColumnValue = 'Ü';
                            }
                            if (args.key === 'S' || args.key === 's') {
                                vm.editedColumnValue = 'S';
                            }
                            if (args.key === 'V' || args.key === 'v') {
                                vm.editedColumnValue = 'V';
                            }
                            if (args.key === 'H' || args.key === 'h') {
                                vm.editedColumnValue = 'H';
                            }
                            if (args.key === 'Escape') {
                                vm.AthleteUnderEditing = '';
                            }
                            if (args.key === 'Enter') {
                                gridNew.editModule.batchSave();
                                if (args.action === 'enter' && gridNew.dataSource[vm.rowNumber + 1]) {
                                    $timeout(function () {
                                        gridNew.editModule.editCell(vm.rowNumber + 1, gridNew.columns[vm.columnNumber].field);
                                    }, 250);
                                } else if (args.action === 'shiftEnter' && gridNew.dataSource[vm.rowNumber - 1]) {
                                    $timeout(function () {
                                        gridNew.editModule.editCell(vm.rowNumber - 1, gridNew.columns[vm.columnNumber].field);
                                    }, 250);
                                }
                            }
                            if (args.key === 'Tab') {
                                gridNew.editModule.batchSave();
                                if (args.action === 'tab' && gridNew.columns[vm.columnNumber + 1]) {
                                    $timeout(function () {
                                        gridNew.editModule.editCell(vm.rowNumber, gridNew.columns[vm.columnNumber + 1].field);
                                    }, 250);
                                } else if (args.action === 'shiftTab' && gridNew.columns[vm.columnNumber - 1]) {
                                    $timeout(function () {
                                        gridNew.editModule.editCell(vm.rowNumber, gridNew.columns[vm.columnNumber - 1].field);
                                    }, 250);
                                }
                            }
                            $scope.$apply();
                            oldkeyAction(args);
                        };
                        gridNew.toolbarClick = function (args) {
                            if (args.item.id === 'GridNew_excelexport') {
                                gridNew.excelExport();
                            }
                            if (args.item.id === 'GridNew_csvexport') {
                                gridNew.csvExport();
                            }
                            if (args.item.id === 'GridNew_print') {
                                gridNew.print({pageOrientation: 'Landscape'});
                            }
                        };
                    } else {
                        gridNew.columns = columns;
                        gridNew.refreshColumns();
                    }
                }
            }
        }

        function viewMonthlyAttendance(data) {
            vm.noAttendance = false;
            vm.hasAttendance = false;
            vm.hasSignedAttendance = false;
            vm.hasAcceptedAttendance = false;

            vm.editedAttendance.aktiv = data.aktiv;
            vm.editedAttendance.edzesek = data.edzesek;
            vm.editedAttendance.fej = data.fej;
            vm.editedAttendance.tetelek = data.tetelek;
            if (vm.editedAttendance.fej === null) {
                vm.noAttendance = true;
                vm.acceptButton = false;
                vm.rejectButton = false;
                vm.refreshAthletesButton = false;
                if ((vm.ADMIN || vm.SZAKOSZTVEZ) && vm.HJFELVIHET) {
                    //vm.refreshAthletesButton = true;
                    vm.saveButton = true;
                    vm.closeButton = false;
                } else if (vm.EDZO && vm.HJFELVIHET) {
                    //vm.refreshAthletesButton = true;
                    vm.saveButton = true;
                    vm.closeButton = true;
                } else {
                    vm.refreshAthletesButton = false;
                    vm.saveButton = false;
                    vm.closeButton = false;
                }
                createNewAttendance();
            } else {
                if (vm.editedAttendance.fej.EdzoAlairta) {
                    if (vm.editedAttendance.fej.SzakosztalyvezetoAlairta) {
                        vm.hasAcceptedAttendance = true;
                        vm.refreshAthletesButton = false;
                        vm.saveButton = false;
                        vm.closeButton = false;
                        vm.acceptButton = false;
                        vm.rejectButton = false;
                    } else {
                        vm.hasSignedAttendance = true;
                        if (vm.HJFELVIHET) {
                            vm.refreshAthletesButton = false;
                            vm.saveButton = false;
                            vm.closeButton = false;
                        }
                        if ((vm.ADMIN || vm.SZAKOSZTVEZ) && vm.HJALAIR1) {
                            vm.acceptButton = true;
                            vm.rejectButton = true;
                        } else {
                            vm.acceptButton = false;
                            vm.rejectButton = false;
                        }
                    }
                } else {
                    vm.hasAttendance = true;
                    vm.acceptButton = false;
                    vm.rejectButton = false;
                    if ((vm.ADMIN || vm.SZAKOSZTVEZ) && vm.HJFELVIHET) {
                        vm.refreshAthletesButton = true;
                        vm.saveButton = true;
                        vm.closeButton = true;
                    } else if (vm.EDZO && vm.HJFELVIHET) {
                        vm.refreshAthletesButton = true;
                        vm.saveButton = true;
                        vm.closeButton = true;
                    } else {
                        vm.refreshAthletesButton = false;
                        vm.saveButton = false;
                        vm.closeButton = false;
                    }
                }
                gridNew.dataSource = vm.editedAttendance.tetelek;
                vm.dayz = vm.editedAttendance.edzesek;
                // create('existing');
            }
            vm.AthleteUnderEditing = '';
            vm.readOnlyAttendance = !vm.saveButton;
            gridNew.editSettings.allowEditing = !vm.readOnlyAttendance;
            totalPercentageCount();
            athletesCountMonthlyAttendance();
            refreshAthletes();
        }

        //Melyik az adott év/hónap utolsó napja?
        function daysInMonth(anyDateInMonth) {
            return new Date(anyDateInMonth.getFullYear(), anyDateInMonth.getMonth() + 1, 0).getDate();
        }

        //Minden sportoló jelenlét százalék számítása
        function totalPercentageCount() {
            vm.valami = 0;
            vm.presenceTotalSum = 0;
            vm.presencePlannedTotalSum = 0;
            var db = 0;
            if (gridNew && gridNew.dataSource) {
                db = gridNew.dataSource.length;
            }
            for (var rec = 0; rec < db; rec++) {
                var jo = parseFloat(gridNew.dataSource[rec].JelenletOsszesen);
                vm.presenceTotalSum += jo;
                var hoe = parseFloat(gridNew.dataSource[rec].HaviOsszEdzesszam);
                vm.presencePlannedTotalSum += hoe;
                if (hoe === 0) {
                    vm.valami += 1;
                } else {
                    vm.valami += (jo / hoe);
                }
            }
            $timeout(function () {
                if (vm.presencePlannedTotalSum > 0) {
                    vm.presencePercentSum = (vm.valami / db * 100).toFixed(0);
                } else {
                    vm.presencePercentSum = 100;
                }
                $scope.$apply();
            }, 100);
        }

        function cellSave(arg) {
            console.log(arg);
            vm.AthleteUnderEditing = '';
            var propertyChanged = arg.columnName;
            if (!(propertyChanged.indexOf('Nap') == -1 && propertyChanged != 'HaviOsszEdzesszam')) {
                var sor = arg.rowData;
                var change = false;
                var value = '';
                prev = '';
                if (arg.value) {
                    if (propertyChanged != 'HaviOsszEdzesszam') { // ez szám, nem string
                        value = arg.value.trim();
                    } else {
                        value = arg.value;
                    }
                }
                if (arg.previousValue) {
                    if (propertyChanged != 'HaviOsszEdzesszam') {
                        prev = arg.previousValue.trim();
                    } else {
                        prev = arg.previousValue;
                    }
                }
                if (value != prev) {
                    // később frissül, ezért úgy állítom össze a teljes sort, hogy ami éppen megváltozott annak értéket adok, mert a sorban még a régi van
                    sor[propertyChanged] = value;
                    change = true;
                }
                var retObj = attendanceRowCount(sor);
                if (change) {
                    if (retObj.hiba) {
                        arg.value = prev;
                        gridNew.dataSource[sor.RowNumber - 1][propertyChanged] = prev;
                    } else {
                        gridNew.dataSource[sor.RowNumber - 1][propertyChanged] = value;
                        gridNew.dataSource[sor.RowNumber - 1].JelenletOsszesen = retObj.jelenlet;
                        gridNew.dataSource[sor.RowNumber - 1].HianyzasOsszesen = retObj.hianyzas;
                        gridNew.dataSource[sor.RowNumber - 1].JelenletSzazalek = retObj.jelenletSzazalek;
                        gridNew.dataSource[sor.RowNumber - 1].HianyzasSzazalek = retObj.hianyzasSzazalek;
                        gridNew.dataSource[sor.RowNumber - 1].VersenyOsszesen = retObj.verseny;
                        gridNew.dataSource[sor.RowNumber - 1].utolsoKitoltottNap = retObj.utolsoKitoltottNap;
                    }
                }
                if (propertyChanged != 'HaviOsszEdzesszam') {
                    vm.editedColumnValue = gridNew.dataSource[sor.RowNumber - 1][propertyChanged];
                }
            } else {
                gridNew.dataSource[arg.rowData.RowNumber - 1][propertyChanged] = arg.value;
            }

            vm.selectedAthleteName = '';
            $timeout(function () {
                vm.allowAthleteRefresh = true;
                $scope.$apply();
            }, 10);

            totalPercentageCount();
            gridNew.refresh();
        }

        //Adott sportoló jelenlét számítás, túltöltés figyelése
        function attendanceRowCount(record) {
            var ret = {};
            var jelenlet = 0;
            var hianyzas = 0;
            var verseny = 0;
            var utolsoToltott = 0;
            vm.attendanceOverChangeAthleteNames = '';
            for (var i = 1; i < 32; i++) {
                var value = record['Nap' + i] !== null ? record['Nap' + i].trim() : record['Nap' + i];
                if (value) {
                    console.log('___Nap' + i, ' value', value);
                    utolsoToltott = i;
                    if (typeof value === 'string') {
                        value = value.toUpperCase();
                        switch (value) {
                            case '0':
                                hianyzas++;
                                break;
                            case '1':
                                jelenlet += 1;
                                break;
                            case '2':
                                jelenlet += 2;
                                break;
                            case '3':
                                jelenlet += 3;
                                break;
                            case 'H':
                                if (vm.attendanceChecked.indexOf(JelenletTipus.IgazoltHianyzas) !== -1) {
                                    jelenlet++;
                                }
                                break;
                            case 'S':
                                if (vm.attendanceChecked.indexOf(JelenletTipus.Serules) !== -1) {
                                    jelenlet++;
                                }
                                break;
                            case 'V':
                                verseny++;
                                if (vm.attendanceChecked.indexOf(JelenletTipus.Verseny) !== -1) {
                                    jelenlet++;
                                }
                                break;
                            case 'B':
                                if (vm.attendanceChecked.indexOf(JelenletTipus.Betegseg) !== -1) {
                                    jelenlet++;
                                }
                                break;
                            case 'Ü':
                                break;
                        }
                    }
                }
            }
            var dt = vm.editedAttendance.fej.Datum;
            record['utolsoKitoltottNap'] = new Date(new Date(dt).getFullYear(), new Date(dt).getMonth(), utolsoToltott);
            ret.utolsoKitoltottNap = record['utolsoKitoltottNap'];
            record['JelenletOsszesen'] = jelenlet;
            ret.jelenlet = jelenlet;
            record['HianyzasOsszesen'] = hianyzas;
            ret.hianyzas = hianyzas;
            record['VersenyOsszesen'] = verseny;
            ret.verseny = verseny;
            if (record['HaviOsszEdzesszam'] > 0) {
                record['JelenletSzazalek'] = (record['JelenletOsszesen'] / record['HaviOsszEdzesszam'] * 100).toFixed(0);
                record['HianyzasSzazalek'] = (record['HianyzasOsszesen'] / record['HaviOsszEdzesszam'] * 100).toFixed(0);
            } else {
                record['JelenletSzazalek'] = '100';
                record['HianyzasSzazalek'] = '0';
            }
            ret.jelenletSzazalek = record['JelenletSzazalek'];
            ret.hianyzasSzazalek = record['HianyzasSzazalek'];
            if ((record['HianyzasOsszesen'] + record['JelenletOsszesen']) > record['HaviOsszEdzesszam']) {
                vm.attendanceOverChangeAthleteNames += record['SportoloNev'] +
                    '<br>' + gettextCatalog.getString('PlannedMonthlyTrainingsNumbers') + ': ' + record['HaviOsszEdzesszam'] +
                    '<br>' + gettextCatalog.getString('SumPresence') + ': ' + record['JelenletOsszesen'] +
                    '<br>' + gettextCatalog.getString('MissedAttendance') + ': ' + record['HianyzasOsszesen'] +
                    '<br>';
            }
            if (vm.attendanceOverChangeAthleteNames.length > 0) {
                var swalText = gettextCatalog.getString('AttendanceGreaterThanPlanned') + '<br>' +
                    vm.attendanceOverChangeAthleteNames + '<br>' +
                    gettextCatalog.getString('hintOnMonthlyAttendeance_Presence') + '<br><br>' +
                    gettextCatalog.getString('PleaseCorrectTheDatas');
                log.htmlError(swalText);
                ret.hiba = true;
            } else {
                ret.hiba = false;
            }
            totalPercentageCount();
            return ret;
        }

        //Havi jelenléti mentése gomb click
        function saveAttendance(forced) {
            if (!gridNew || (!forced && vm.editedAttendance.fej.EdzoAlairta === true)) {
                return;
            }
            vm.saveButtonEnabled = false;
            $timeout(function () {
                if (gridNew.isEdit === true && gridNew.editModule) {
                    gridNew.editModule.endEdit();
                }
                totalPercentageCount();
                vm.hasErrorAtSave = false;
                vm.editedAttendance.edzesek = vm.dayz;
                dataservice.saveMonthlyAttendance(vm.editedAttendance).then(function (resp) {
                        vm.saveButtonEnabled = true;
                        var haveImputError = [];
                        resp.inputErrors.forEach(function (input) {
                            if (input.error != null) {
                                haveImputError += input.fieldName + '<br>';
                            }
                        });
                        if (haveImputError.length > 0) {
                            log.warningMsg(haveImputError);
                        } else {
                            if (resp && resp.res > 0) {
                                log.successMsg('AttendanceSaved');
                                if (vm.openTrainingDiaryAfterSave) {
                                    paramHelper.setParams([{'HaviJelenletiFejId': resp.res}]);
                                    $state.go('administration.trainingDiary');
                                } else {
                                    paramHelper.setParams([
                                        {'monthlyAttendance.sectionId': vm.selectedSection},
                                        {'monthlyAttendance.ageGroupId': vm.selectedAgeGroup},
                                        {'monthlyAttendance.coachId': vm.selectedCoach},
                                        {'monthlyAttendance.id': resp.res}
                                    ]);
                                    dataservice.monthlyAttendanceSelectById(resp.res).then(function (data) {
                                        viewMonthlyAttendance(data);
                                    });
                                }
                            } else {
                                vm.hasErrorAtSave = true;
                                log.errorMsg('Error Saving Monthly Attendance');
                            }
                        }
                    }, function (err) {
                        console.log('SaveError', err);
                    });
            }, 0);
        }

        //Sportolók frissítése gomb click
        function refreshAthletes() {
            if (!vm.editedAttendance.fej || vm.hasSignedAttendance || vm.hasAcceptedAttendance) {
                return true;
            }
            if (gridNew.isEdit === true && gridNew.editModule) {
                gridNew.editModule.endEdit();
            }
            // JELENLÉTIN LÉVŐ SPORTOLÓ ADATOK FRISSÍTÉSE
            dataservice.monthlyAttendanceRefreshAthleteData(vm.editedAttendance.fej.Id)
                .then(function (refreshData) {
                    for (var r = 0; r < refreshData.tetelek.length; r++) {
                        for (var ea = 0; ea < vm.editedAttendance.tetelek.length; ea++) {
                            if (refreshData.tetelek[r].IdSportolo == vm.editedAttendance.tetelek[ea].IdSportolo) {
                                vm.editedAttendance.tetelek[ea].SportoloNev = refreshData.tetelek[r].SportoloNev;
                                vm.editedAttendance.tetelek[ea].SzuletesiDatum = refreshData.tetelek[r].SzuletesiDatum;
                                //$scope.$apply();
                                //gridNew.editModule.batchSave();
                                break;
                            }
                        }
                    }
                });
            // JELENLÉTIN NEM SZEREPLŐ SPORTOLÓK HOZZÁADÁSA
            dataservice.getNewAthletesInSelectedYearMonth(vm.editedAttendance.fej.Id)
                .then(function (newAthletes) {
                    var maxRowNumber = 0;
                    for (var i = 0; i < newAthletes.tetelek.length; i++) {
                        var duplicate = false;
                        for (var e = 0; e < vm.editedAttendance.tetelek.length; e++) {
                            if (vm.editedAttendance.tetelek[e].RowNumber > maxRowNumber) {
                                maxRowNumber = vm.editedAttendance.tetelek[e].RowNumber;
                            }
                            if (newAthletes.tetelek[i].IdSportolo == vm.editedAttendance.tetelek[e].IdSportolo) {
                                duplicate = true;
                                break;
                            }
                        }
                        if (!duplicate) {
                            var ujTetel = newAthletes.tetelek[i];
                            ujTetel.Id = newAthletesId--;
                            ujTetel.ujsportolo = true;
                            ujTetel.RowNumber = ++maxRowNumber;
                            vm.editedAttendance.tetelek.push(ujTetel);
                        }
                    }
                    athletesCountMonthlyAttendance();
                    log.successMsg('AthletesRefreshingDone');
                    gridNew.refresh();
                });
        }

        //Lekéri a csoport létszámát, érkezők-távozók számát
        function athletesCountMonthlyAttendance() {
            var tol = new Date(vm.selectedYear, (isNaN(vm.selectedMonth) ? 0 : vm.selectedMonth), 1, 0, 0, 0);
            var ig = new Date(vm.selectedYear, (isNaN(vm.selectedMonth) ? 0 : vm.selectedMonth), daysInMonth(tol), 23, 59, 59);
            if (!vm.editedAttendance.fej) {
                return;
            }
            if (!vm.editedAttendance.fej.IdKorcsoport) {
                vm.editedAttendance.fej.IdKorcsoport = 0;
            }
            dataservice.getAthletesCountForMonthlyAttendance(vm.editedAttendance.fej.IdEdzo, vm.editedAttendance.fej.IdSzakosztaly, vm.editedAttendance.fej.IdKorcsoport, tol, ig)
                .then(function (data) {
                    vm.editedAttendance.fej.CsoportLetszam = data.Szam;
                    vm.editedAttendance.fej.Erkezett = data.SzamErkezett;
                    vm.editedAttendance.fej.Tavozott = data.SzamKilepett;
                });
        }

        //Havi jelenléti lezárása gomb click
        function closeMonthlyAttendance() {
            vm.editedAttendance.fej.EdzoAlairta = true;
            vm.editedAttendance.fej.EdzoAlairtaDatum = new Date().toDateString();
            saveAttendance(true);
            $timeout(function () {
                if (!vm.hasErrorAtSave) {
                    vm.readOnlyAttendance = true;
                    gridNew.editSettings.allowEditing = !vm.readOnlyAttendance;
                }
                viewMonthlyAttendance(vm.editedAttendance);
            }, 500);
        }

        //Havi jelenléti visszautasítása gomb click
        function rejectMonthlyAttendance() {
            var dialogObj = angular.element('#rejectAttendanceWindow').data('ejDialog');
            dialogObj.open();
        }

        //Felugró ablak 'Mégsem' gomb click
        function closerejectingWindow() {
            var dialogObj = angular.element('#rejectAttendanceWindow').data('ejDialog');
            dialogObj.close();
        }

        //Felugró ablak 'Rendben' gomb click - visszautasítás elmentése
        function rejectAttendance() {
            if (vm.rejectAttendanceText.length > 0) {
                var dialogObj = angular.element('#rejectAttendanceWindow').data('ejDialog');
                dialogObj.close();
            } else {
                return;
            }
            var uzi = gettextCatalog.getString('SystemMessage') + '\n' + gettextCatalog.getString('The') + ' ' + vm.editedAttendance.fej.SzakosztalyNev;
            if (vm.editedAttendance.fej.KorcsoportNev) {
                uzi += ' - ' + vm.editedAttendance.fej.KorcsoportNev;
            }
            uzi += ' ' + vm.selectedYear + ' ' + vm.months[(isNaN(vm.selectedMonth) ? 0 : vm.selectedMonth)].text + ' ' + gettextCatalog.getString('MonthlyAttendanceReportRejected') + '\n' + gettextCatalog.getString('Cause') + ' ' + vm.rejectAttendanceText;
            vm.editedAttendance.fej.EdzoAlairta = false;
            vm.editedAttendance.fej.EdzoAlairtaDatum = '';
            saveAttendance();
            if (!vm.hasErrorAtSave) {
                vm.readOnlyAttendance = false;
                gridNew.editSettings.allowEditing = !vm.readOnlyAttendance;
                viewMonthlyAttendance(vm.editedAttendance);
                dataservice.messageSave(uzi, [vm.selectedCoach], vm.selectedSection).then(function () {
                });
            }
        }

        //Havi jelenléti szakosztályvezetői elfogadása
        function acceptMonthlyAttendance() {
            dataservice.monthlyAttendanceAcceptByLeader(vm.editedAttendance.fej.Id).then(function (data) {
                vm.editedAttendance.fej.SzakosztalyvezetoAlairta = true;
                vm.editedAttendance.fej.IdSzakosztalyvezetoAlairta = data.res;
                vm.editedAttendance.fej.SzakosztalyvezetoAlairtaDatum = data.date;
                viewMonthlyAttendance(vm.editedAttendance);
                log.successMsg('AttendanceAccepted');
                vm.readOnlyAttendance = true;
                gridNew.editSettings.allowEditing = !vm.readOnlyAttendance;
            });
        }

        //Új havi jelenléti összesítő készítése
        function createNewAttendance() {
            dataservice.getLastMonthlyAttendanceTrainingLocationAndTime(vm.selectedCoach, vm.selectedSection, vm.selectedAgeGroup)
                .then(function (data) {
                    vm.editedAttendance.fej = {};
                    vm.editedAttendance.fej.CsoportLetszam = 0;
                    vm.editedAttendance.fej.Datum = new Date(vm.selectedYear, (isNaN(vm.selectedMonth) ? 0 : vm.selectedMonth), 1, 0, 0, 0);
                    vm.editedAttendance.fej.Erkezett = 0;
                    vm.editedAttendance.fej.Id = -1;
                    vm.editedAttendance.fej.IdEdzo = vm.selectedCoach;
                    vm.editedAttendance.fej.IdKorcsoport = vm.selectedAgeGroup;
                    vm.editedAttendance.fej.IdSzakosztaly = vm.selectedSection;
                    vm.editedAttendance.fej.KorosztalyosToltes = vm.allAgeGroupfill;
                    vm.editedAttendance.fej.Megjegyzes = '';
                    vm.editedAttendance.fej.Tavozott = 0;
                    vm.editedAttendance.fej.EdzoNev = angular.element('#maEdzo').data('ejDropDownList').getSelectedItem()[0].innerText;
                    vm.editedAttendance.fej.SzakosztalyNev = angular.element('#maSzakosztaly').data('ejDropDownList').getSelectedItem()[0].innerText;
                    if (angular.element('#maKorosztaly').data('ejDropDownList') && angular.element('#maKorosztaly').data('ejDropDownList').getSelectedItem().length > 0) {
                        vm.editedAttendance.fej.KorcsoportNev = angular.element('#maKorosztaly').data('ejDropDownList').getSelectedItem()[0].innerText;
                    } else {
                        vm.editedAttendance.fej.KorcsoportNev = 0;
                        vm.selectedAgeGroup = 0;
                    }

                    if (data !== null) {
                        vm.dayz.CsutortokHely = data.CsutortokHely;
                        vm.dayz.CsutortokIdo = data.CsutortokIdo;
                        vm.dayz.HetfoHely = data.HetfoHely;
                        vm.dayz.HetfoIdo = data.HetfoIdo;
                        vm.dayz.IdHaviJelenletiFej = -1;
                        vm.dayz.KeddHely = data.KeddHely;
                        vm.dayz.KeddIdo = data.KeddIdo;
                        vm.dayz.PentekHely = data.PentekHely;
                        vm.dayz.PentekIdo = data.PentekIdo;
                        vm.dayz.SzerdaHely = data.SzerdaHely;
                        vm.dayz.SzerdaIdo = data.SzerdaIdo;
                        vm.dayz.SzombatHely = data.SzombatHely;
                        vm.dayz.SzombatIdo = data.SzombatIdo;
                        vm.dayz.VasarnapHely = data.VasarnapHely;
                        vm.dayz.VasarnapIdo = data.VasarnapIdo;
                    } else {
                        vm.dayz.CsutortokHely = '';
                        vm.dayz.CsutortokIdo = '';
                        vm.dayz.HetfoHely = '';
                        vm.dayz.HetfoIdo = '';
                        vm.dayz.IdHaviJelenletiFej = -1;
                        vm.dayz.KeddHely = '';
                        vm.dayz.KeddIdo = '';
                        vm.dayz.PentekHely = '';
                        vm.dayz.PentekIdo = '';
                        vm.dayz.SzerdaHely = '';
                        vm.dayz.SzerdaIdo = '';
                        vm.dayz.SzombatHely = '';
                        vm.dayz.SzombatIdo = '';
                        vm.dayz.VasarnapHely = '';
                        vm.dayz.VasarnapIdo = '';
                    }
                    vm.editedAttendance.edzesek = vm.dayz;

                    dataservice.getAthletesForMonthlyAttendance(vm.selectedCoach,
                        vm.selectedSection, vm.selectedAgeGroup, vm.editedAttendance.fej.Datum)
                        .then(function (data2) {
                            gridNew.dataSource = data2.tetelek;
                            // create('new');
                            vm.editedAttendance.tetelek = gridNew.dataSource;
                            vm.editedAttendance.aktiv = data2.aktiv;
                            vm.activePeriods = data2.aktiv;
                            athletesCountMonthlyAttendance();
                        });
                });
        }

        function goToNewAthlete(Id) {
            if (vm.MEGTSPORTLIST) {
                swal({
                    title: gettextCatalog.getString('AreYouSureGo'),
                    text: gettextCatalog.getString('AreYouSureYouWantToGoToAthlete'),
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: gettextCatalog.getString('GoToAthlete')
                }).then(function (isConfirmed) {
                    if (isConfirmed.value) {
                        paramHelper.setParams([
                            {'athleteModify.sportoloId': Id}
                        ]);
                        $state.go('athletes.athletesManagement.athleteModify.dataSheet');
                    }
                });
            } else {
                log.permissionError();
            }
        }

        function goToOlderMonthlyAttendanceReports() {
            paramHelper.setParams([{'monthlyAttendance.coachId': vm.selectedCoach}, {'monthlyAttendance.year': vm.selectedYear}, {'monthlyAttendance.month': (isNaN(vm.selectedMonth) ? 0 : vm.selectedMonth)}]);
            $state.go('administration.monthlyAttendance.monthlyAttendanceList');
        }

        function getAccepterCoachById() {
            if (vm.editedAttendance.fej.IdSzakosztalyvezetoAlairta === null) {
                return '';
            } else {
                return $q(function (resolve) {
                    dataservice.getUserData(vm.editedAttendance.fej.IdSzakosztalyvezetoAlairta)
                        .then(function (args) {
                            resolve(args.retValue.name);
                        });
                });
            }
        }

        function print() {
            var max = daysInMonth(new Date(vm.editedAttendance.fej.Datum));
            $q.all([getAccepterCoachById()])
                .then(function (results) {
                    vm.reportParameters = {
                        Szakosztaly: vm.editedAttendance.fej.SzakosztalyNev,
                        EvHonap: (new Date(vm.editedAttendance.fej.Datum).getFullYear() + '. ' + vm.months[moment(vm.editedAttendance.fej.Datum).month()].text),
                        EdzoNeve: vm.editedAttendance.fej.EdzoNev,
                        FejId: vm.editedAttendance.fej.Id,
                        Datum29: max >= 29 ? '29' : ' ',
                        Datum30: max >= 30 ? '30' : ' ',
                        Datum31: max >= 31 ? '31' : ' ',
                        Nap1: 1 + ' ' + vm.days[new Date(new Date(vm.editedAttendance.fej.Datum).getFullYear(), new Date(vm.editedAttendance.fej.Datum).getMonth(), 1, 0, 0, 0).getDay()],
                        Nap2: 2 + ' ' + vm.days[new Date(new Date(vm.editedAttendance.fej.Datum).getFullYear(), new Date(vm.editedAttendance.fej.Datum).getMonth(), 2, 0, 0, 0).getDay()],
                        Nap3: 3 + ' ' + vm.days[new Date(new Date(vm.editedAttendance.fej.Datum).getFullYear(), new Date(vm.editedAttendance.fej.Datum).getMonth(), 3, 0, 0, 0).getDay()],
                        Nap4: 4 + ' ' + vm.days[new Date(new Date(vm.editedAttendance.fej.Datum).getFullYear(), new Date(vm.editedAttendance.fej.Datum).getMonth(), 4, 0, 0, 0).getDay()],
                        Nap5: 5 + ' ' + vm.days[new Date(new Date(vm.editedAttendance.fej.Datum).getFullYear(), new Date(vm.editedAttendance.fej.Datum).getMonth(), 5, 0, 0, 0).getDay()],
                        Nap6: 6 + ' ' + vm.days[new Date(new Date(vm.editedAttendance.fej.Datum).getFullYear(), new Date(vm.editedAttendance.fej.Datum).getMonth(), 6, 0, 0, 0).getDay()],
                        Nap7: 7 + ' ' + vm.days[new Date(new Date(vm.editedAttendance.fej.Datum).getFullYear(), new Date(vm.editedAttendance.fej.Datum).getMonth(), 7, 0, 0, 0).getDay()],
                        Nap8: 8 + ' ' + vm.days[new Date(new Date(vm.editedAttendance.fej.Datum).getFullYear(), new Date(vm.editedAttendance.fej.Datum).getMonth(), 8, 0, 0, 0).getDay()],
                        Nap9: 9 + ' ' + vm.days[new Date(new Date(vm.editedAttendance.fej.Datum).getFullYear(), new Date(vm.editedAttendance.fej.Datum).getMonth(), 9, 0, 0, 0).getDay()],
                        Nap10: 10 + ' ' + vm.days[new Date(new Date(vm.editedAttendance.fej.Datum).getFullYear(), new Date(vm.editedAttendance.fej.Datum).getMonth(), 10, 0, 0, 0).getDay()],
                        Nap11: 11 + ' ' + vm.days[new Date(new Date(vm.editedAttendance.fej.Datum).getFullYear(), new Date(vm.editedAttendance.fej.Datum).getMonth(), 11, 0, 0, 0).getDay()],
                        Nap12: 12 + ' ' + vm.days[new Date(new Date(vm.editedAttendance.fej.Datum).getFullYear(), new Date(vm.editedAttendance.fej.Datum).getMonth(), 12, 0, 0, 0).getDay()],
                        Nap13: 13 + ' ' + vm.days[new Date(new Date(vm.editedAttendance.fej.Datum).getFullYear(), new Date(vm.editedAttendance.fej.Datum).getMonth(), 13, 0, 0, 0).getDay()],
                        Nap14: 14 + ' ' + vm.days[new Date(new Date(vm.editedAttendance.fej.Datum).getFullYear(), new Date(vm.editedAttendance.fej.Datum).getMonth(), 14, 0, 0, 0).getDay()],
                        Nap15: 15 + ' ' + vm.days[new Date(new Date(vm.editedAttendance.fej.Datum).getFullYear(), new Date(vm.editedAttendance.fej.Datum).getMonth(), 15, 0, 0, 0).getDay()],
                        Nap16: 16 + ' ' + vm.days[new Date(new Date(vm.editedAttendance.fej.Datum).getFullYear(), new Date(vm.editedAttendance.fej.Datum).getMonth(), 16, 0, 0, 0).getDay()],
                        Nap17: 17 + ' ' + vm.days[new Date(new Date(vm.editedAttendance.fej.Datum).getFullYear(), new Date(vm.editedAttendance.fej.Datum).getMonth(), 17, 0, 0, 0).getDay()],
                        Nap18: 18 + ' ' + vm.days[new Date(new Date(vm.editedAttendance.fej.Datum).getFullYear(), new Date(vm.editedAttendance.fej.Datum).getMonth(), 18, 0, 0, 0).getDay()],
                        Nap19: 19 + ' ' + vm.days[new Date(new Date(vm.editedAttendance.fej.Datum).getFullYear(), new Date(vm.editedAttendance.fej.Datum).getMonth(), 19, 0, 0, 0).getDay()],
                        Nap20: 20 + ' ' + vm.days[new Date(new Date(vm.editedAttendance.fej.Datum).getFullYear(), new Date(vm.editedAttendance.fej.Datum).getMonth(), 20, 0, 0, 0).getDay()],
                        Nap21: 21 + ' ' + vm.days[new Date(new Date(vm.editedAttendance.fej.Datum).getFullYear(), new Date(vm.editedAttendance.fej.Datum).getMonth(), 21, 0, 0, 0).getDay()],
                        Nap22: 22 + ' ' + vm.days[new Date(new Date(vm.editedAttendance.fej.Datum).getFullYear(), new Date(vm.editedAttendance.fej.Datum).getMonth(), 22, 0, 0, 0).getDay()],
                        Nap23: 23 + ' ' + vm.days[new Date(new Date(vm.editedAttendance.fej.Datum).getFullYear(), new Date(vm.editedAttendance.fej.Datum).getMonth(), 23, 0, 0, 0).getDay()],
                        Nap24: 24 + ' ' + vm.days[new Date(new Date(vm.editedAttendance.fej.Datum).getFullYear(), new Date(vm.editedAttendance.fej.Datum).getMonth(), 24, 0, 0, 0).getDay()],
                        Nap25: 25 + ' ' + vm.days[new Date(new Date(vm.editedAttendance.fej.Datum).getFullYear(), new Date(vm.editedAttendance.fej.Datum).getMonth(), 25, 0, 0, 0).getDay()],
                        Nap26: 26 + ' ' + vm.days[new Date(new Date(vm.editedAttendance.fej.Datum).getFullYear(), new Date(vm.editedAttendance.fej.Datum).getMonth(), 26, 0, 0, 0).getDay()],
                        Nap27: 27 + ' ' + vm.days[new Date(new Date(vm.editedAttendance.fej.Datum).getFullYear(), new Date(vm.editedAttendance.fej.Datum).getMonth(), 27, 0, 0, 0).getDay()],
                        Nap28: 28 + ' ' + vm.days[new Date(new Date(vm.editedAttendance.fej.Datum).getFullYear(), new Date(vm.editedAttendance.fej.Datum).getMonth(), 28, 0, 0, 0).getDay()],
                        Nap29: max >= 29 ? (29 + ' ' + vm.days[new Date(new Date(vm.editedAttendance.fej.Datum).getFullYear(), new Date(vm.editedAttendance.fej.Datum).getMonth(), 29, 0, 0, 0).getDay()]) : ' ',
                        Nap30: max >= 30 ? (30 + ' ' + vm.days[new Date(new Date(vm.editedAttendance.fej.Datum).getFullYear(), new Date(vm.editedAttendance.fej.Datum).getMonth(), 30, 0, 0, 0).getDay()]) : ' ',
                        Nap31: max >= 31 ? (31 + ' ' + vm.days[new Date(new Date(vm.editedAttendance.fej.Datum).getFullYear(), new Date(vm.editedAttendance.fej.Datum).getMonth(), 31, 0, 0, 0).getDay()]) : ' ',
                        OsszJelenletiSzazalek: vm.presencePercentSum + '%',
                        Keszult: vm.editedAttendance.fej.EdzoAlairtaDatum == null ? '' : moment(vm.editedAttendance.fej.EdzoAlairtaDatum).format('YYYY. MM. DD') === 'Invalid date' ? '' : moment(vm.editedAttendance.fej.EdzoAlairtaDatum).format('YYYY. MM. DD'),
                        EdzoNeve2: vm.editedAttendance.fej.EdzoNev,
                        JovahagytaDatum: vm.editedAttendance.fej.SzakosztalyvezetoAlairtaDatum == null ? '' : moment(vm.editedAttendance.fej.SzakosztalyvezetoAlairtaDatum).format('YYYY. MM. DD') === 'Invalid date' ? '' : moment(vm.editedAttendance.fej.SzakosztalyvezetoAlairtaDatum).format('YYYY. MM. DD'),
                        Jovahagyta: results != null ? results[0] : ' ',
                        Korosztaly: vm.editedAttendance.fej.KorcsoportNev === null ? '' : vm.editedAttendance.fej.KorcsoportNev
                    };
                    if (printOpened) {
                        angular.element('#printDialog').ejDialog('open');
                    } else {
                        printOpened = true;
                        angular.element('#printDialog').ejDialog({
                            height: '99%',
                            width: '99%',
                            enablemodal: 'true',
                            'position-x': '0',
                            'position-y': '0',
                            target: '#mainContent',
                            enableresize: 'false'
                        });
                    }
                });
        }

        function gridRowSelected(arg) {
            vm.selectedAthleteName = arg.data.SportoloNev + ' - ' + arg.data.SzuletesiDatum;
            $timeout(function () {
                $scope.$apply();
            }, 10);
        }

        function yearDataBound() {
            angular.element('#maEv').ejDropDownList('selectItemByValue', vm.selectedYear);
        }

        function monthDataBound() {
            angular.element('#maHonap').ejDropDownList('selectItemByValue', vm.selectedMonth);
        }

        function CopyCellToColumn() {
            gridNew.dataSource.forEach(function (element) {
                var retObj = attendanceRowCount(element);
                var sor = findLine(element.IdSportolo);
                if (!(retObj.hiba || (sor && sor[vm.editedColumnName] === '0'))) {
                    var oldValue = element[vm.editedColumnName];
                    element[vm.editedColumnName] = vm.editedColumnValue;
                    //rollback
                    if (attendanceRowCount(element).hiba) {
                        element[vm.editedColumnName] = oldValue;
                        attendanceRowCount(element);
                    } else {
                        element.JelenletOsszesen = retObj.jelenlet;
                        element.HianyzasOsszesen = retObj.hianyzas;
                        element.JelenletSzazalek = retObj.jelenletSzazalek;
                        element.HianyzasSzazalek = retObj.hianyzasSzazalek;
                        element.VersenyOsszesen = retObj.verseny;
                        element.utolsoKitoltottNap = retObj.utolsoKitoltottNap;
                    }
                }
            });
            totalPercentageCount();
            gridNew.refresh();
        }

        vm.autoSaveCheckboxChanged = function (args) {
            dataservice.setMonthlyAttendanceAutoSave(args.value).then(function (result) {
                if (result.retValue) {
                    if (args.value) {
                        log.infoMsg('AutoSaveOn');
                    } else {
                        log.infoMsg('AutoSaveOFF');
                    }
                }
            });
        };

        $rootScope.monthlyAttendanceSaveInterval = $interval(function () {
            if (vm.autoSave) {
                saveAttendance();
            }
        }, 60000);
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.administration.monthlyAttendance.monthlyAttendanceReport')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'administration.monthlyAttendance.monthlyAttendanceReport',
                config: {
                    url: '/monthlyAttendanceReport',
                    templateUrl: 'app/administration/monthlyAttendance/monthlyAttendanceReport/monthlyAttendanceReport.html',
                    controller: 'MonthlyAttendanceReportController',
                    controllerAs: 'vm',
                    title: 'MonthlyAttendanceReport',
                    settings: {
                        navId: 222,
                        level: 2,
                        order: 2,
                        orderTitle_hu: 'Havi jelenléti összesítő',
                        orderTitle_en: 'Monthly Attendance Sheet Report',
                        parentId: 2,
                        content: 'MonthlyAttendanceReport',
                        activatorPermission: '"MEGTHAVIJEL"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.administration.monthlyTrainingPlan')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'administration.monthlyTrainingPlan',
                config: {
                    url: '/monthlyTrainingPlan',
                    templateUrl: 'app/administration/monthlyTrainingPlan/monthlyTrainingPlan.html',
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    MonthlyTrainingPlanListController.$inject = ["log", "dataservice", "$q", "$rootScope", "gettextCatalog", "paramHelper", "authenticationService", "$scope", "$state", "$timeout"];
    angular
        .module('app.administration.monthlyTrainingPlan.monthlyTrainingPlanList')
        .controller('MonthlyTrainingPlanListController', MonthlyTrainingPlanListController);

    function MonthlyTrainingPlanListController(log, dataservice, $q, $rootScope, gettextCatalog, paramHelper, authenticationService, $scope, $state, $timeout) {
        var vm = this;
        $rootScope.vm = vm;

        function setInitVals() {
            $rootScope.title = gettextCatalog.getString('MonthlyTrainingPlanList');
            //grid adatai
            vm.columns = [];

            vm.coachList = [];
            vm.selectedCoach = 0;

            vm.sectionList = [];
            vm.selectedSection = 0;

            vm.ageGroupList = [];
            vm.selectedAgeGroup = 0;

            vm.years = [];
            for (var ev = 2010; ev <= new Date().getFullYear(); ev++) {
                vm.years.push(ev);
            }
            //Kiválasztott év (alapból az aktuális)
            vm.selectedYear = new Date().getFullYear();
            vm.selectedRowId = -1;

            vm.textSearch = '';

            vm.delEnabled = false;
        }

        setInitVals();

        vm.coachChanged = coachChanged;
        vm.coachDataBound = coachDataBound;
        vm.sectionChanged = sectionChanged;
        vm.ageGroupChanged = ageGroupChanged;
        vm.yearChanged = yearChanged;
        vm.sectionDataBound = sectionDataBound;
        vm.ageGroupDataBound = ageGroupDataBound;
        vm.refreshData = refreshData;
        vm.goToNewUser = goToNewUser;
        vm.goToNewAgeGroup = goToNewAgeGroup;
        vm.goToWeeklyTrainingPlan = goToWeeklyTrainingPlan;
        vm.createNewWeeklyTrainingPlan = goToNewWeeklyTrainingPlan;
        vm.rowSelect = rowSelect;
        vm.rowDeselected = rowDeselected;
        vm.deleteWeeklyTrainingPlan = deleteWeeklyTrainingPlan;

        gridColumnsRefresh();

        var grid = new ej2.grids.Grid({
            toolbar: $rootScope.toolbarItems,
            allowPaging: true,
            allowExcelExport: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            allowTextWrap: true,
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            rowSelected: vm.rowSelect,
            rowDeselected: vm.rowDeselected,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#Grid'), $scope);
                }
            },
            beforePrint: $rootScope.beforePrintGrid,
            printComplete: $rootScope.printCompleteGrid
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        activate();

        function activate() {
            var promises = [paramHelper.getParams([], ['monthlyTrainingPlan.edzoId', 'monthlyTrainingPlan.szakosztalyId', 'monthlyTrainingPlan.korosztalyId', 'monthlyTrainingPlan.ev', 'monthlyTrainingPlan.szoveg']),
                authenticationService.getRight('UJHAVIEDZTERV'),
                authenticationService.getRight('MODHAVIEDZTERV'),
                authenticationService.getRight('MEGTHAVIEDZTERV'),
                authenticationService.getRight('MEGTFELH'),
                authenticationService.getRight('MEGTKOROKEZ'),
                authenticationService.getRight('TORLHAVIEDZTERV')];

            return $q.all(promises).then(function (results) {
                angular.element('#maEdzo').ejDropDownList({dataSource: vm.coachList});
                if (vm.coachList.length === 1) {
                    vm.selectedCoach = vm.coachList[0].value;
                }
                vm.UJHAVIEDZTERV = results[1];
                vm.MODHAVIEDZTERV = results[2];
                vm.MEGTHAVIEDZTERV = results[3];
                vm.MEGTFELH = results[4];
                vm.MEGTKOROKEZ = results[5];
                vm.TORLHAVIEDZTERV = results[6];
                if (!vm.MEGTHAVIEDZTERV) {
                    log.permissionError(true);
                    return;
                }
                getCoaches();
                $timeout(function () {
                    if (angular.isDefined(results[0]['monthlyTrainingPlan.edzoId'])) {
                        vm.selectedCoach = parseInt(results[0]['monthlyTrainingPlan.edzoId']);
                    }
                    if (angular.isDefined(results[0]['monthlyTrainingPlan.szakosztalyId'])) {
                        vm.selectedSection = parseInt(results[0]['monthlyTrainingPlan.szakosztalyId']);
                    }
                    if (angular.isDefined(results[0]['monthlyTrainingPlan.korosztalyId'])) {
                        vm.selectedAgeGroup = parseInt(results[0]['monthlyTrainingPlan.korosztalyId']);
                    }
                    if (angular.isDefined(results[0]['monthlyTrainingPlan.szoveg'])) {
                        vm.textSearch = results[0]['monthlyTrainingPlan.szoveg'];
                    }
                    if (results[0]['monthlyTrainingPlan.ev']) {
                        vm.selectedYear = results[0]['monthlyTrainingPlan.ev'];
                    } else {
                        vm.selectedYear = new Date().getFullYear();
                    }
                    angular.element('#maEv').ejDropDownList({value: vm.selectedYear});
                    $scope.$apply();
                }, 0);
            });
        }

        //edzők lekérése
        function getCoaches() {
            return dataservice.coachSelect().then(
                function (data) {
                    vm.coachList = data.itemsList;

                    angular.element('#maEdzo').ejDropDownList({dataSource: vm.coachList});
                    if (vm.coachList.length === 1) {
                        vm.selectedCoach = vm.coachList[0].value;
                    }
                }
            );
        }

        //Grid oszlopainak definíciója
        function gridColumnsRefresh() {
            vm.columns = [
                {
                    field: 'Id', visible: false, isPrimaryKey: true, isIdentity: true
                },
                {
                    field: 'Link',
                    headerText: '',
                    textAlign: 'center',
                    allowEditing: false,
                    width: 60,
                    template: '#motrpllitemplateDataColumn3'
                },
                {
                    field: 'Edzo', headerText: gettextCatalog.getString('Coach'), textAlign: 'left',
                    allowEditing: false,
                    template: '#motrpllitemplateDataColumn1'
                },
                {
                    field: 'Szakosztaly',
                    headerText: gettextCatalog.getString('Section'),
                    textAlign: 'left',
                    allowEditing: false
                },
                {
                    field: 'Korosztaly', headerText: gettextCatalog.getString('AgeGroup'), textAlign: 'left',
                    allowEditing: false,
                    template: '#motrpllitemplateDataColumn2'
                },
                {
                    field: 'Honap',
                    headerText: gettextCatalog.getString('Month'),
                    textAlign: 'left',
                    allowEditing: false
                },
                {
                    field: 'Makrociklus',
                    headerText: gettextCatalog.getString('Makrociklus'),
                    textAlign: 'center',
                    allowEditing: false
                },
                {
                    field: 'Jovahagyott',
                    headerText: gettextCatalog.getString('Approved'),
                    textAlign: 'center',
                    allowEditing: false,
                    template: '#motrpllitemplateDataColumn4'
                }
            ];
        }

        //edző dropdownlist selectionchanged
        function coachChanged(args) {
            vm.selectedCoach = args.value;

            vm.ageGroupList = [];
            getSectionList(args.value);
        }

        function getSectionList(coachId) {
            return dataservice.sectionDropDownList(coachId).then(
                function (data) {
                    vm.sectionList = [];
                    vm.sectionList = data.itemsList;
                }
            );
        }

        function coachDataBound() {
            if (vm.coachList.length === 1) {
                angular.element('#maEdzo').ejDropDownList('selectItemByValue', vm.coachList[0].value);
                vm.selectedCoach = vm.coachList[0].value;
            } else {
                angular.element('#maEdzo').ejDropDownList('selectItemByValue', vm.selectedCoach);
            }
        }// Run after data bounded
        function sectionDataBound() {
            if (vm.sectionList.length === 1) {
                angular.element('#maSzakosztaly').ejDropDownList('selectItemByValue', vm.sectionList[0].value);
                vm.selectedSection = vm.sectionList[0].value;
            } else {
                angular.element('#maSzakosztaly').ejDropDownList('selectItemByValue', vm.selectedSection);
            }
        }

        function sectionChanged(args) {
            if (args.value === vm.selectedSection) {
                vm.selectedSection = args.value;
                return;
            }
            vm.selectedSection = args.value;
            vm.ageGroupList = [];
            dataservice.ageGroupSelectYear(vm.selectedCoach, vm.selectedSection, vm.selectedYear).then(
                function (data) {
                    vm.ageGroupList = data.itemsList;
                });
        }

        function ageGroupChanged(args) {
            if (args.value != null) {
                vm.selectedAgeGroup = args.value;
            }
        }

        // Run after data bounded
        function ageGroupDataBound() {
            if (vm.ageGroupList.length === 1) {
                angular.element('#maKorosztaly').ejDropDownList('selectItemByValue', vm.ageGroupList[0].value);
            } else {
                angular.element('#maKorosztaly').ejDropDownList('selectItemByValue', vm.selectedAgeGroup);
            }
        }

        function yearChanged(args) {
            vm.selectedYear = args.value;
            return dataservice.ageGroupSelectYear(vm.selectedCoach, vm.selectedSection, vm.selectedYear).then(
                function (data) {
                    vm.ageGroupList = data.itemsList;
                }
            );
        }

        function refreshData() {
            $timeout(function () {
                // a syncfusion direktívák miatt
                $scope.$broadcast('submitted');
                if ($scope.form.$valid === false) {
                    log.errorMsg(gettextCatalog.getString('RequiredFieldsError'));
                    return;
                }
                paramHelper.setParams([{'monthlyTrainingPlan.edzoId': vm.selectedCoach}, {'monthlyTrainingPlan.szakosztalyId': vm.selectedSection}, {'monthlyTrainingPlan.korosztalyId': vm.selectedAgeGroup}, {'monthlyTrainingPlan.ev': vm.selectedYear}, {'monthlyTrainingPlan.szoveg': vm.textSearch}]);
                dataservice.getMonthlyTrainingPlanList(vm.selectedCoach, vm.selectedSection, vm.selectedAgeGroup, vm.selectedYear, vm.textSearch).then(
                    function (data) {
                        grid.dataSource = data.itemsList;
                        vm.selectedRowId = -1;
                        vm.delEnabled = false;
                    }
                );
            }, 0);
        }

        function goToNewUser(edzoId) {
            if (!vm.MEGTFELH) {
                log.permissionError();
                return;
            }
            paramHelper.setParams([{'monthlyTrainingPlan.edzoId': vm.selectedCoach}, {'monthlyTrainingPlan.szakosztalyId': vm.selectedSection}, {'monthlyTrainingPlan.korosztalyId': vm.selectedAgeGroup}, {'monthlyTrainingPlan.ev': vm.selectedYear}, {'newUser.userId': edzoId}, {'monthlyTrainingPlan.szoveg': vm.textSearch}]);
            $state.go('settings.userManagement.modifyUser');
        }

        function goToNewAgeGroup(ageGroupId) {
            if (!vm.MEGTKOROKEZ) {
                log.permissionError();
                return;
            }
            paramHelper.setParams([{'monthlyTrainingPlan.edzoId': vm.selectedCoach}, {'monthlyTrainingPlan.szakosztalyId': vm.selectedSection}, {'monthlyTrainingPlan.korosztalyId': vm.selectedAgeGroup}, {'monthlyTrainingPlan.ev': vm.selectedYear}, {'ageGroups.ageGroup': ageGroupId}, {'monthlyTrainingPlan.szoveg': vm.textSearch}]);
            $state.go('athletes.ageGroups.modifyAgeGroup');
        }

        function goToWeeklyTrainingPlan(trainingPlanId) {
            if (!vm.MEGTHAVIEDZTERV) {
                log.permissionError();
                return;
            }
            paramHelper.setParams([{'monthlyTrainingPlan.edzoId': vm.selectedCoach},
                {'monthlyTrainingPlan.szakosztalyId': vm.selectedSection},
                {'monthlyTrainingPlan.korosztalyId': vm.selectedAgeGroup},
                {'monthlyTrainingPlan.ev': vm.selectedYear},
                {'monthlyTrainingPlan.trainingPlanId': trainingPlanId},
                {'monthlyTrainingPlan.edzoNev': getNameByID(vm.coachList, vm.selectedCoach)},
                {'monthlyTrainingPlan.szakosztalyNev': getNameByID(vm.sectionList, vm.selectedSection)},
                {'monthlyTrainingPlan.korosztalyNev': getNameByID(vm.ageGroupList, vm.selectedAgeGroup)},
                {'monthlyTrainingPlan.szoveg': vm.textSearch}
            ]);
            $state.go('administration.monthlyTrainingPlan.monthlyTrainingPlanReport');
        }

        function goToNewWeeklyTrainingPlan() {
            if (!vm.UJHAVIEDZTERV) {
                log.permissionError();
                return;
            }
            if (angular.isUndefined(vm.selectedCoach) || vm.selectedCoach == null || vm.selectedCoach <= 0) {
                log.errorMsg(gettextCatalog.getString('SelectCoach'), gettextCatalog.getString('Error'));
                return;
            }
            if (angular.isUndefined(vm.selectedSection) || vm.selectedSection == null || vm.selectedSection <= 0) {
                log.errorMsg(gettextCatalog.getString('SelectSection'), gettextCatalog.getString('Error'));
                return;
            }
            if (angular.isUndefined(vm.selectedAgeGroup) || vm.selectedAgeGroup == null || vm.selectedAgeGroup <= 0) {
                log.errorMsg(gettextCatalog.getString('SelectAgeGroup'), gettextCatalog.getString('Error'));
                return;
            }
            if (angular.isUndefined(vm.selectedYear) || vm.selectedYear == null || vm.selectedYear <= 0) {
                log.errorMsg(gettextCatalog.getString('SelectCoach'), gettextCatalog.getString('Error'));
                return;
            }
            paramHelper.setParams([{'monthlyTrainingPlan.edzoId': vm.selectedCoach},
                {'monthlyTrainingPlan.szakosztalyId': vm.selectedSection},
                {'monthlyTrainingPlan.korosztalyId': vm.selectedAgeGroup},
                {'monthlyTrainingPlan.ev': vm.selectedYear},
                {'monthlyTrainingPlan.trainingPlanId': -1},
                {'monthlyTrainingPlan.edzoNev': getNameByID(vm.coachList, vm.selectedCoach)},
                {'monthlyTrainingPlan.szakosztalyNev': getNameByID(vm.sectionList, vm.selectedSection)},
                {'monthlyTrainingPlan.korosztalyNev': getNameByID(vm.ageGroupList, vm.selectedAgeGroup)},
                {'monthlyTrainingPlan.szoveg': vm.textSearch}
            ]);
            $state.go('administration.monthlyTrainingPlan.monthlyTrainingPlanReport');
        }

        function getNameByID(arr, id) {
            for (var i = 0; i < arr.length; i++) {
                if (arr[i].value == id) {
                    return arr[i].text;
                }
            }
        }

        function rowSelect(args) {
            vm.selectedRowId = args.data.Id;
            vm.delEnabled = vm.MODHAVIEDZTERV;
            $scope.$apply();
        }

        function rowDeselected() {
            vm.delEnabled = false;
            $scope.$apply();
        }

        function deleteWeeklyTrainingPlan() {
            if (angular.isUndefined(vm.selectedRowId) || vm.selectedRowId <= 0) {
                return;
            }

            dataservice.deleteMonthlyTrainingPlan(vm.selectedRowId).then(
                function (result) {
                    if (result.retValue) {
                        for (var i = 0; i < grid.dataSource.length; i++) {
                            if (grid.dataSource[i].Id === vm.selectedRowId) {
                                grid.dataSource.splice(i, 1);
                                grid.refresh();
                                break;
                            }
                        }
                        log.successMsg(gettextCatalog.getString('PlanDeleted'));
                    } else {
                        log.errorMsg('CantDeleted');
                    }
                });
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.administration.monthlyTrainingPlan.monthlyTrainingPlanList')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'administration.monthlyTrainingPlan.monthlyTrainingPlanList',
                config: {
                    url: '/monthlyTrainingPlanList',
                    templateUrl: 'app/administration/monthlyTrainingPlan/monthlyTrainingPlanList/monthlyTrainingPlanList.html',
                    controller: 'MonthlyTrainingPlanListController',
                    controllerAs: 'vm',
                    title: 'MonthlyTrainingPlanList',
                    settings: {
                        navId: 282,
                        level: 2,
                        order: 8,
                        orderTitle_hu: 'Havi edzésterv',
                        orderTitle_en: 'Monthly Training Plan',
                        parentId: 2,
                        content: 'MonthlyTrainingPlanList',
                        activatorPermission: '"MEGTHAVIEDZTERV"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    MonthlyTrainingPlanReportController.$inject = ["dataservice", "$q", "$rootScope", "gettextCatalog", "paramHelper", "log", "$scope", "authenticationService", "$state", "$timeout"];
    angular
        .module('app.administration.monthlyTrainingPlan.monthlyTrainingPlanReport')
        .controller('MonthlyTrainingPlanReportController', MonthlyTrainingPlanReportController);

    function MonthlyTrainingPlanReportController(dataservice, $q, $rootScope, gettextCatalog, paramHelper, log, $scope, authenticationService, $state, $timeout) {
        var vm = this; $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('Monthly Training Plan');

        var printOpened = false;
        vm.trainingPlanId = -1;

        vm.editedMTP = {};

        vm.editedMTP.Hetfo = undefined;
        vm.copyEnabled = false;

        vm.years = [];
        for (var ev = 2010; ev <= new Date().getFullYear(); ev++) {
            vm.years.push(ev);
        }
        //Hónapok
        vm.months = [{
            text: gettextCatalog.getString('January'),
            value: 0
        }, {
            text: gettextCatalog.getString('February'),
            value: 1
        }, {
            text: gettextCatalog.getString('March'),
            value: 2
        }, {
            text: gettextCatalog.getString('April'),
            value: 3
        }, {
            text: gettextCatalog.getString('May'),
            value: 4
        }, {
            text: gettextCatalog.getString('June'),
            value: 5
        }, {
            text: gettextCatalog.getString('July'),
            value: 6
        }, {
            text: gettextCatalog.getString('August'),
            value: 7
        }, {
            text: gettextCatalog.getString('September'),
            value: 8
        }, {
            text: gettextCatalog.getString('October'),
            value: 9
        }, {
            text: gettextCatalog.getString('November'),
            value: 10
        }, {
            text: gettextCatalog.getString('December'),
            value: 11
        }];

        vm.save = save;
        vm.files = openFiles;
        vm.print = showPrint;
        vm.copyFromOldPlan = copyFromOldPlan;
        vm.columnsPopup = [];
        vm.dataPopup = [];
        vm.selectedRowIndexPopup = -1;
        vm.closeEarlierMonthlyPlanWindow = closeEarlierMonthlyPlanWindow;
        vm.selectEarlierMonthlyPlanWindow = selectEarlierMonthlyPlanWindow;
        vm.SectionLeaderApprove = SectionLeaderApprove;

        vm.columnsPopup = [
            {
                field: 'Id',
                visible: false,
                isPrimaryKey: true,
                isIdentity: true
            },
            {
                field: 'Szakosztaly',
                headerText: gettextCatalog.getString('Section'),
                textAlign: 'center',
                width: 100,
                allowEditing: false
            },
            {
                field: 'Korosztaly',
                headerText: gettextCatalog.getString('AgeGroup'),
                textAlign: 'center',
                width: 100,
                allowEditing: false
            },
            {
                field: 'Makrociklus',
                headerText: gettextCatalog.getString('Makrociklus'),
                textAlign: 'center',
                width: 50,
                allowEditing: false
            },
            {
                field: 'Ev',
                headerText: gettextCatalog.getString('Year'),
                textAlign: 'center',
                width: 50,
                allowEditing: false
            },
            {
                field: 'Honap',
                headerText: gettextCatalog.getString('Month'),
                textAlign: 'center',
                // type: 'date',
                // format: '{0:MMMM}',
                width: 100,
                allowEditing: false
            }
        ];

        var gridPopup = new ej2.grids.Grid({
            dataSource: [],
            editSettings: {allowEditing: false},
            allowTextWrap: true,
            allowScrolling: true,
            allowSorting: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            height: 200,
            columns: vm.columnsPopup,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile(angular.element('#GridPopup'), $scope);
                }
            }
        });
        gridPopup.appendTo('#GridPopup');
        gridPopup.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, gridPopup);
        };

        activate();

        function activate() {
            var promises = [paramHelper.getParams([], ['monthlyTrainingPlan.edzoId', 'monthlyTrainingPlan.szakosztalyId', 'monthlyTrainingPlan.korosztalyId', 'monthlyTrainingPlan.ev', 'monthlyTrainingPlan.trainingPlanId', 'monthlyTrainingPlan.edzoNev', 'monthlyTrainingPlan.szakosztalyNev', 'monthlyTrainingPlan.korosztalyNev']),
                authenticationService.getRight('UJHAVIEDZTERV'),
                authenticationService.getRight('MODHAVIEDZTERV'),
                authenticationService.getRight('MEGTHAVIEDZTERV'),
                getSystemSettings('HAVIEDZTERVJOVAHAGYKOT'),
                authenticationService.getRight('SZAKOSZTVEZ'),
                authenticationService.getRight('ADMIN'),
                authenticationService.getRight('HAVIEDZESTERVJOVAHAGY')
            ];
            $q.all(promises).then(function (results) {
                vm.UJHAVIEDZTERV = results[1];
                vm.MODHAVIEDZTERV = results[2];
                vm.MEGTHAVIEDZTERV = results[3];
                vm.HAVIEDZTERVJOVAHAGYKOT = results[4];
                vm.SZAKOSZTVEZ = results[5];
                vm.ADMIN = results[6];
                vm.HAVIEDZESTERVJOVAHAGY = results[7];
                vm.HAVIEDZTERVJOVAHAGY = vm.HAVIEDZTERVJOVAHAGYKOT && (vm.ADMIN || vm.SZAKOSZTVEZ) && vm.HAVIEDZESTERVJOVAHAGY;
                vm.JOVAHAGYOTT = false;
                if (!vm.MEGTHAVIEDZTERV) {
                    log.permissionError(true);
                    return;
                }
                vm.trainingPlanId = results[0]['monthlyTrainingPlan.trainingPlanId'];
                if (angular.isDefined(vm.trainingPlanId) && vm.trainingPlanId !== -1) {
                    dataservice.monthlyTrainingPlanSelectById(vm.trainingPlanId).then(function (data) {
                        vm.editedMTP = data.retValue;
                        vm.editedMTP.IdSzakosztaly = data.retValue.IdSzakosztaly;
                        vm.JOVAHAGYOTT = vm.editedMTP.Jovahagyott;
                        if (vm.JOVAHAGYOTT) {
                            vm.HAVIEDZTERVJOVAHAGY = false;
                        }
                        vm.editedMTP.EdzoNev = results[0]['monthlyTrainingPlan.edzoNev'];
                        vm.editedMTP.SzakosztalyNev = results[0]['monthlyTrainingPlan.szakosztalyNev'];
                        vm.editedMTP.KorosztalyNev = results[0]['monthlyTrainingPlan.korosztalyNev'];
                        vm.copyEnabled = false;
                    });
                } else {
                    $timeout(function () {
                        vm.editedMTP.EdzoNev = results[0]['monthlyTrainingPlan.edzoNev'];
                        vm.editedMTP.SzakosztalyNev = results[0]['monthlyTrainingPlan.szakosztalyNev'];
                        vm.editedMTP.KorosztalyNev = results[0]['monthlyTrainingPlan.korosztalyNev'];
                        vm.editedMTP.Ev = results[0]['monthlyTrainingPlan.ev'];
                        vm.editedMTP.EdzoId = results[0]['monthlyTrainingPlan.edzoId'];
                        vm.editedMTP.IdSzakosztaly = results[0]['monthlyTrainingPlan.szakosztalyId'];
                        vm.editedMTP.IdKorcsoport = results[0]['monthlyTrainingPlan.korosztalyId'];
                        vm.editedMTP.Tartalom = '';
                        vm.copyEnabled = true;
                    }, 0);
                }
            });
        }

        function save() {
            if ((vm.copyEnabled && vm.UJHAVIEDZTERV) || (vm.MODHAVIEDZTERV && !vm.copyEnabled)) {
                // a syncfusion direktívák miatt
                $scope.$broadcast('submitted');
                if ($scope.form.$valid === false) {
                    log.errorMsg('FillTheRequiredFields');
                } else {
                    dataservice.saveMonthlyTrainingPlan(vm.editedMTP).then(function (data) {
                        dataservice.monthlyTrainingPlanSelectById(data.retValue).then(function (data) {
                            vm.editedMTP = data.retValue;
                            vm.editedMTP.IdSzakosztaly = data.retValue.IdSzakosztaly;
                            vm.JOVAHAGYOTT = vm.editedMTP.Jovahagyott;
                            if (vm.JOVAHAGYOTT) {
                                vm.HAVIEDZTERVJOVAHAGY = false;
                            }
                            vm.editedMTP.EdzoNev = vm.editedMTP.Edzo;
                            vm.editedMTP.SzakosztalyNev = vm.editedMTP.Szakosztaly;
                            vm.editedMTP.KorosztalyNev = vm.editedMTP.Korosztaly;
                            vm.copyEnabled = false;
                        });
                        log.successMsg('SavedSuccessful');
                        // $rootScope.back();
                    });
                }
            } else {
                log.permissionError();
            }
        }

        function openFiles() {
            paramHelper.setParams([{'monthlyTrainingPlan.edzoId': vm.selectedCoach},
                {'monthlyTrainingPlan.szakosztalyId': vm.selectedSection},
                {'monthlyTrainingPlan.korosztalyId': vm.selectedAgeGroup},
                {'monthlyTrainingPlan.ev': vm.selectedYear},
                {'monthlyTrainingPlan.trainingPlanId': vm.editedMTP.Id},
                {'monthlyTrainingPlan.edzoNev': vm.editedMTP.EdzoNev},
                {'monthlyTrainingPlan.szakosztalyNev': vm.editedMTP.SzakosztalyNev},
                {'monthlyTrainingPlan.korosztalyNev': vm.editedMTP.KorosztalyNev},
                {'files.tipus': 'EdzesTervHavi'},
                {'files.tablaId': vm.editedMTP.Id}
            ]);
            $state.go('other.files');
        }

        function showPrint() {
            vm.reportParameters = {
                EvHonap: vm.editedMTP.Ev + '. ' + vm.months[vm.editedMTP.HonapSzama].text,
                Szakosztaly: vm.editedMTP.SzakosztalyNev,
                Korosztaly: vm.editedMTP.KorosztalyNev,
                Edzo: vm.editedMTP.EdzoNev,
                Makrociklus: vm.editedMTP.Makrociklus,
                Tartalom: vm.editedMTP.Tartalom,
                Keszult: moment().format('YYYY. MM. DD'),
                Keszitette: vm.editedMTP.EdzoNev
            };

            if (printOpened) {
                angular.element('#printDialog').ejDialog('open');
            } else {
                printOpened = true;
                angular.element('#printDialog').ejDialog({
                    height: '99%',
                    width: '99%',
                    enablemodal: 'true',
                    'position-x': '0',
                    'position-y': '1',
                    target: '#mainContent',
                    enableresize: 'false'
                });
            }
        }

        function copyFromOldPlan() {
            vm.selectedRowIndexPopup = -1;
            var dialogObj = angular.element('#searchWindow').data('ejDialog');
            dialogObj.open();
            dataservice.getOldMonthlyPlanByUserId(vm.editedMTP.EdzoId, vm.editedMTP.Id).then(function (args) {
                vm.dataPopup = args.itemsList;
                for (var i = 0; i < vm.dataPopup.length; i++) {
                    vm.dataPopup[i].Honap = vm.months[vm.dataPopup[i].HonapSzama].text;
                }
                gridPopup.dataSource = vm.dataPopup;
            });
        }

        function closeEarlierMonthlyPlanWindow() {
            var dialogObj = angular.element('#searchWindow').data('ejDialog');
            dialogObj.close();
        }

        function selectEarlierMonthlyPlanWindow() {
            vm.selectedRowIndexPopup = gridPopup.getSelectedRowIndexes();
            if (vm.selectedRowIndexPopup > -1) {
                var vmi = vm.dataPopup[vm.selectedRowIndexPopup];
                if (vmi) {
                    dataservice.monthlyTrainingPlanSelectById(vmi.Id).then(function (res) {
                        vm.editedMTP.Tartalom = res.retValue.Tartalom;
                        vm.editedMTP.Makrociklus = res.retValue.Makrociklus;
                    });
                    var dialogObj = angular.element('#searchWindow').data('ejDialog');
                    dialogObj.close();
                }
            }
        }

        function getSystemSettings(valtozo) {
            return dataservice.getSystemSettings(valtozo).then(function (response) {
                return response.retValue;
            });
        }

        function SectionLeaderApprove() {
            dataservice.HaviEdzesTervJovahagyas(vm.editedMTP.Id).then(function () {
                log.successMsg(gettextCatalog.getString('MonthlyTraningPlanApproved'));
                vm.HAVIEDZTERVJOVAHAGY = false;
                vm.JOVAHAGYOTT = true;
                $rootScope.back();
            });
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.administration.monthlyTrainingPlan.monthlyTrainingPlanReport')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'administration.monthlyTrainingPlan.monthlyTrainingPlanReport',
                config: {
                    url: '/monthlyTrainingPlanReport',
                    templateUrl: 'app/administration/monthlyTrainingPlan/monthlyTrainingPlanReport/monthlyTrainingPlanReport.html',
                    controller: 'MonthlyTrainingPlanReportController',
                    controllerAs: 'vm'
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    QuickCompetitionResultsController.$inject = ["log", "paramHelper", "dataservice", "$q", "$rootScope", "gettextCatalog", "authenticationService", "$compile", "$scope", "$state"];
    angular
        .module('app.administration.quickCompetitionResults')
        .controller('QuickCompetitionResultsController', QuickCompetitionResultsController);

    function QuickCompetitionResultsController(log, paramHelper, dataservice, $q, $rootScope, gettextCatalog, authenticationService, $compile, $scope, $state) {
        var vm = this;
        $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('QuickCompetitionResults');

        vm.maskObjectTime;
        vm.elem;
        vm.tableTimeEditorTemplate = {
            create: function () {
                var txt = document.createElement('input');
                txt.style.width = '100%';
                txt.style.float = 'left';
                vm.elem = txt;
                vm.elem.addEventListener('focus', function () {
                    this.select();
                });
                return vm.elem;
            },
            read: function () {
                return vm.maskObjectTime.getMaskedValue();
            },
            destroy: function () {
                if (vm.maskObjectTime != null) {
                    vm.maskObjectTime.destroy();
                }
            },
            write: function (args) {
                var s = args.element.id.toString().replace('GridAthletes', '');
                vm.maskObjectTime = new ej2.inputs.MaskedTextBox({
                    minWidth: '100%',
                    mask: '99:99:99.999',
                    value: angular.isDefined(undefined) ? args.rowdata[s] : '',
                    readOnly: !vm.editable
                });
                vm.editedRowId = args.rowData['Id'];
                $compile(args.element[0])($scope);
                vm.maskObjectTime.appendTo(vm.elem);
            }
        };

        vm.maskObject;
        vm.elem;
        vm.dateTimeEditorTemplate =
            {
                create: function () {
                    var txt = document.createElement('input');
                    txt.style.width = '100%';
                    txt.style.float = 'left';
                    vm.elem = txt;
                    vm.elem.addEventListener('focus', function () {
                        this.select();
                    });
                    return vm.elem;
                },
                read: function () {
                    return vm.maskObject.getMaskedValue();
                },
                destroy: function () {
                    if (vm.maskObject != null) {
                        vm.maskObject.destroy();
                    }
                },
                write: function (args) {
                    var s = args.element.id.toString().replace('Grid', '');
                    vm.maskObject = new ej2.inputs.MaskedTextBox({
                        minWidth: '100%',
                        mask: '>0000-00-00',
                        value: args.rowData !== angular.isUndefined ? args.rowData[s] : ''.replace(' ', ''),
                        readOnly: vm.readOnlyAttendance,
                    });
                    vm.editedRowId = args.rowData['Id'];
                    $compile(args.element[0])($scope);
                    vm.maskObject.appendTo(vm.elem);
                }
            };

        vm.maskObject;
        vm.elem;
        vm.ratingEditorTemplate =
            {
                create: function () {
                    var txt = document.createElement('input');
                    txt.style.width = '100%';
                    txt.style.float = 'center';
                    vm.elem = txt;
                    vm.elem.addEventListener('focus', function () {
                        this.select();
                    });
                    return vm.elem;
                },
                read: function () {
                    return vm.maskObject.getMaskedValue();
                },
                destroy: function () {
                    if (vm.maskObject != null) {
                        vm.maskObject.destroy();
                    }
                },
                write: function (args) {
                    var s = args.element.id.toString().replace('Grid', '');
                    vm.maskObject = new ej2.inputs.MaskedTextBox({
                        minWidth: '100%',
                        mask: '>C',
                        customCharacters: {C: '012345'},
                        value: args.rowData !== angular.isUndefined ? args.rowData[s] : ''.replace(' ', ''),
                        readOnly: vm.readOnlyAttendance,
                    });
                    vm.editedRowId = args.rowData['Id'];
                    $compile(args.element[0])($scope);
                    vm.maskObject.appendTo(vm.elem);
                }
            };

        vm.columns = [

            {
                field: 'SportoloId',
                visible: false,
                isPrimaryKey: true,
                isIdentity: true
            },
            {
                field: 'SportoloNev',
                headerText: gettextCatalog.getString('AthleteName'),
                textAlign: 'left',
                width: 150,
                allowEditing: false,
                template: '#qcrname'
            },
            {
                field: 'KorcsoportNeve',
                headerText: gettextCatalog.getString('AgeGroup'),
                textAlign: 'left',
                width: 120,
                allowEditing: false
            },
            {
                field: 'EdzoNeve',
                headerText: gettextCatalog.getString('TrainerName'),
                textAlign: 'left',
                width: 120,
                allowEditing: false,
            },
            {
                field: 'VersenyLeiras',
                headerText: gettextCatalog.getString('CompetitionName'),
                textAlign: 'left',
                width: 150,
                allowEditing: true
            },
            {
                field: 'Versenyszam',
                headerText: gettextCatalog.getString('Versenyszam'),
                textAlign: 'left',
                width: 100,
                editType: 'datetimepicker',
                allowEditing: true
            },
            {
                field: 'DatumTol',
                headerText: gettextCatalog.getString('Date'),
                textAlign: 'left',
                edit: vm.dateTimeEditorTemplate,
                width: 150,
                allowEditing: true
            },
            {
                field: 'Helyszin',
                headerText: gettextCatalog.getString('Helyszin'),
                textAlign: 'left',
                width: 160,
                allowEditing: true
            },
            {
                field: 'Helyezes',
                headerText: gettextCatalog.getString('Helyezes'),
                textAlign: 'left',
                width: 120,
                allowEditing: true
            },
            {
                field: 'EredmenySzoveg',
                headerText: gettextCatalog.getString('EredmenySzoveg'),
                textAlign: 'left',
                width: 160,
                allowEditing: true
            },
            {
                field: 'EredmenyPont',
                headerText: gettextCatalog.getString('EredmenyPontGol'),
                textAlign: 'center',
                editType: 'numericedit',
                width: 160,
                allowEditing: true
            },
            {
                field: 'EredmenyIdo',
                headerText: gettextCatalog.getString('EredmenyIdo'),
                textAlign: 'center',
                edit: vm.tableTimeEditorTemplate,
                width: 160,
                allowEditing: true
            },
            {
                field: 'EredmenyTavolsag',
                headerText: gettextCatalog.getString('EredmenyTavolsag'),
                textAlign: 'center',
                editType: 'numericedit',
                editParams: {decimalPlaces: 2, locale: 'HU-hu'},
                width: 160,
                allowEditing: true
            },
            {
                field: 'EredmenyTavolsagM',
                headerText: gettextCatalog.getString('EredmenyTavolsagM'),
                textAlign: 'center',
                editType: 'numericedit',
                width: 160,
                allowEditing: true
            },
            {
                field: 'Eredmeny',
                headerText: gettextCatalog.getString('Rating'),
                textAlign: 'center',
                editType: 'numericedit',
                edit: {params: {min: 0, max: 5}},
                width: 200,
                allowEditing: true
            }
        ];

        var grid = new ej2.grids.Grid({
            dataSource: [],
            allowPaging: true,
            allowSorting: true,
            allowTextWrap: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            editSettings: {allowEditing: true, mode: 'Batch', showConfirmDialog: false},
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile(grid, $scope);
                }
            },
            rowSelecting: function () {
                grid.clearSelection();
            },
            cellSave: cellSave
        });
        grid.appendTo('#Grid');

        // Public functions
        vm.openAthlete = openAthlete;
        vm.sectionDataBound = sectionDataBound;
        vm.sectionSelect = sectionSelect;
        vm.ageGroupDataBound = ageGroupDataBound;
        vm.ageGroupSelect = ageGroupSelect;
        vm.save = save;

        // Activate page
        activate();

        function activate() {
            var promises = [authenticationService.getRight('UJEERJEL'), getSections(), paramHelper.getParams([], ['qcr.sectionId', 'qcr.ageGroupId'])];
            $q.all(promises).then(function (results) {
                if (!results[0]) {
                    log.permissionError(true);
                }
                vm.sectionId = results[2]['qcr.sectionId'];
                vm.ageGroupId = results[2]['qcr.ageGroupId'];
            });
        }

        function getSections() {
            dataservice.sectionDropDownList(0)
                .then(function (data) {
                    vm.sectionList = data.itemsList;
                });
        }

        function sectionDataBound() {
            if (vm.sectionList.length === 1) {
                vm.sectionId = vm.sectionList[0].value;
            }
            angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.sectionId);
        }

        function sectionSelect(args) {
            vm.sectionId = args.value;
            // getAthletes();
            getAgeGroups();
            paramHelper.setParams([{'qcr.sectionId': vm.sectionId}]);
        }

        function getAgeGroups() {
            dataservice.ageGroupDropDownList(vm.sectionId)
                .then(function (data) {
                    if (data.itemsList.length > 1) {
                        data.itemsList.unshift({value: 0, text: gettextCatalog.getString('All')});
                    }
                    vm.ageGroupList = data.itemsList;
                });
        }

        function ageGroupDataBound() {
            if (vm.ageGroupList.length === 1) {
                vm.ageGroupId = vm.ageGroupList[0].value;
            }
            var index = vm.ageGroupList.map(function (e) {
                return e.value;
            }).indexOf(vm.ageGroupId);
            if (index < 0) {
                index = 0;
            }
            angular.element('#ageGroupDropDown').ejDropDownList('selectItemsByIndices', index);
        }

        function ageGroupSelect(args) {
            vm.ageGroupId = args.value;
            getAthletes();
            paramHelper.setParams([{'qcr.ageGroupId': vm.ageGroupId}]);
        }

        function getAthletes() {
            dataservice.athletesSelect2(vm.sectionId, vm.ageGroupId)
                .then(function (data) {
                    grid.dataSource = data.itemsList;
                });
        }

        function cellSave(args) {
            if (args.columnName === 'EredmenyTavolsag') {
                var item = ej.DataManager(grid.dataSource).executeLocal(new ej.Query().where('SportoloId', 'equal', args.rowData.SportoloId))[0];
                vm.rowIndexUnderEditing = grid.dataSource.indexOf(item);
                grid.dataSource[vm.rowIndexUnderEditing].EredmenyTavolsag = args.value;
                grid.dataSource[vm.rowIndexUnderEditing].EredmenyTavolsagM = (args.value / 100).toFixed(2);
                grid.refresh();
            } else if (args.columnName === 'EredmenyTavolsagM') {
                var item = ej.DataManager(grid.dataSource).executeLocal(new ej.Query().where('SportoloId', 'equal', args.rowData.SportoloId))[0];
                vm.rowIndexUnderEditing = grid.dataSource.indexOf(item);
                grid.dataSource[vm.rowIndexUnderEditing].EredmenyTavolsagM = args.value;
                grid.dataSource[vm.rowIndexUnderEditing].EredmenyTavolsag = Math.round(args.value * 100);
                grid.refresh();
            } else {
                var item = ej.DataManager(grid.dataSource).executeLocal(new ej.Query().where('SportoloId', 'equal', args.rowData.SportoloId))[0];
                vm.rowIndexUnderEditing = grid.dataSource.indexOf(item);
                grid.dataSource[vm.rowIndexUnderEditing][args.columnName] = args.value;
                grid.refresh();
            }
        }

        function save() {
            grid.endEdit();
            grid.editModule.batchSave();
            dataservice.quickCompetitionResult(grid.dataSource).then(function () {
                $rootScope.back();
            });
        }

        function openAthlete(Id) {
            swal({
                title: gettextCatalog.getString('AreYouSureGo'),
                text: gettextCatalog.getString('AreYouSureYouWantToGoToAthlete'),
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: gettextCatalog.getString('GoToAthlete')
            }).then(function (isConfirmed) {
                if (isConfirmed.value) {
                    paramHelper.setParams([
                        {'athleteModify.sportoloId': Id}
                    ]);
                    $state.go('athletes.athletesManagement.athleteModify.dataSheet');
                }
            });
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.administration.quickCompetitionResults')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'administration.quickCompetitionResults',
                config: {
                    url: '/quickCompetitionResults',
                    templateUrl: 'app/administration/quickCompetitionResults/quickCompetitionResults.html',
                    controller: 'QuickCompetitionResultsController',
                    controllerAs: 'vm',
                    title: 'QuickCompetitionResults',
                    settings: {
                        navId: 2112,
                        level: 2,
                        order: 11,
                        orderTitle_hu: 'Eredményjelentő (gyors)',
                        orderTitle_en: 'Result Report (quick)',
                        parentId: 2,
                        content: 'QuickCompetitionResults',
                        activatorPermission: '"UJEERJEL"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    ResultReportAthletesController.$inject = ["$q", "dataservice", "log", "DOMAIN", "paramHelper", "$scope", "authenticationService", "gettextCatalog", "$rootScope", "$timeout"];
    angular
        .module('app.administration.resultReportAthletes')
        .controller('ResultReportAthletesController', ResultReportAthletesController);

    function ResultReportAthletesController($q, dataservice, log, DOMAIN, paramHelper, $scope, authenticationService, gettextCatalog, $rootScope, $timeout) {
        var vm = this;
        $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('ResultReportAthletes');
        vm.deleted = false;
        vm.editedReportResult = {};
        vm.sectionList = [];
        vm.ageGroupList = [];
        vm.athleteList = [];
        vm.athleteListPartner1 = [];
        vm.athleteListPartner2 = [];
        vm.athleteListPartner3 = [];
        vm.noImage = '';
        vm.pageSize = 12;
        vm.defaultSection = -1;
        vm.competitionList = [];
        vm.EredmenyIdo = '';
        vm.noImage = DOMAIN.baseURL + DOMAIN.noImage;
        vm.editedReportResult.Foto = vm.noImage;
        vm.editable = false;
        vm.CanCreateNew = true;
        vm.CanModify = true;
        vm.selectedRowIndexPopup = -1;
        vm.columnsPopup = [];

        // Image cropper variables
        vm.cropper = {};
        vm.cropper.sourceImage = null;
        vm.cropper.croppedImage = null;
        vm.bounds = {};
        vm.bounds.left = 0;
        vm.bounds.right = 0;
        vm.bounds.top = 0;
        vm.bounds.bottom = 0;
        vm.cropDialogTitle = gettextCatalog.getString('ChooseImageTitle');

        vm.openCropDialog = openCropDialog;
        vm.doneCropDialog = doneCropDialog;
        vm.closeCropDialog = closeCropDialog;
        vm.closeEarlierResultReportAthletesWindow = closeEarlierResultReportAthletesWindow;
        vm.selectEarlierResultReportAthletesWindow = selectEarlierResultReportAthletesWindow;

        vm.cmChange = cmChange;
        vm.mChange = mChange;

        function cmChange() {
            var cm = vm.editedReportResult.EredmenyTavolsag;
            if (vm.editedReportResult.EredmenyTavolsagM != cm / 100) {
                vm.editedReportResult.EredmenyTavolsagM = cm / 100;
            }
        }

        function mChange() {
            if (vm.editedReportResult.EredmenyTavolsagM && vm.editedReportResult.EredmenyTavolsagM.length > 0) {
                vm.editedReportResult.EredmenyTavolsagM = vm.editedReportResult.EredmenyTavolsagM.replace(',', '.');
            }
            var m = vm.editedReportResult.EredmenyTavolsagM;
            if (vm.editedReportResult.EredmenyTavolsag != m * 100) {
                vm.editedReportResult.EredmenyTavolsag = Math.round(m * 100);
            }
        }

        vm.columns = [
            {field: 'Id', visible: false, isPrimaryKey: true, isIdentity: true},
            {field: 'Filenev', headerText: gettextCatalog.getString('Filename'), textAlign: 'center', allowEditing: false, template: '#rereattemplateDataColumn1'},
            {field: 'Datum', headerText: gettextCatalog.getString('Date'), textAlign: 'center', allowEditing: false}
        ];

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: ['Delete'],
            allowPaging: true,
            allowSorting: true,
            allowExcelExport: true,
            allowTextWrap: true,
            editSettings: {allowDeleting: false},
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#Grid'), $scope);
                }
                if (args.requestType == 'delete') {
                    return dataservice.deleteFiles(args.data[0].Id).then(function () {
                        log.successMsg(gettextCatalog.getString('FileDeleted'));
                    });
                }
            },
        });
        grid.appendTo('#Grid');

        vm.columnsPopup = [
            {field: 'Id', visible: false, isPrimaryKey: true, isIdentity: true},
            {field: 'VersenyNeve', headerText: gettextCatalog.getString('CompetitionName'), textAlign: 'center', width: 100, allowEditing: false},
            {field: 'Versenyszam', headerText: gettextCatalog.getString('Versenyszam'), textAlign: 'center', width: 100, allowEditing: false},
            {field: 'Szakosztaly', headerText: gettextCatalog.getString('Section'), textAlign: 'center', width: 100, allowEditing: false},
            {field: 'Korosztaly', headerText: gettextCatalog.getString('AgeGroup'), textAlign: 'center', width: 100, allowEditing: false},
            {field: 'SportoloCsapat', headerText: gettextCatalog.getString('Athlete'), textAlign: 'center', width: 100, allowEditing: false},
            {field: 'Datum', headerText: gettextCatalog.getString('Date'), textAlign: 'center', width: 100, allowEditing: false}
        ];

        var gridPopup = new ej2.grids.Grid({
            dataSource: [],
            allowPaging: true,
            allowSorting: true,
            allowTextWrap: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columnsPopup,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            }
        });
        gridPopup.appendTo('#GridPopup');

        vm.sectionDataBound = sectionDataBound;
        vm.sectionSelect = sectionSelect;
        vm.ageGroupDataBound = ageGroupDataBound;
        vm.ageGroupSelect = ageGroupSelect;
        vm.athleteDataBound = athleteDataBound;
        vm.athleteSelect = athleteSelect;
        vm.athleteDataBoundPartner = athleteDataBoundPartner;
        vm.athleteDataBoundPartner2 = athleteDataBoundPartner2;
        vm.athleteDataBoundPartner3 = athleteDataBoundPartner3;
        vm.athleteSelectPartner = athleteSelectPartner;
        vm.athleteSelectPartner2 = athleteSelectPartner2;
        vm.athleteSelectPartner3 = athleteSelectPartner3;
        vm.goToOlderAnnualSeasonPlanReports = goToOlderAnnualSeasonPlanReports;
        vm.openCropDialog = openImgDialog;
        vm.deleteImg = deleteImg;
        vm.deleteFile = deleteFile;
        vm.createResultReport = createResultReport;
        vm.modifyResultReport = modifyResultReport;
        vm.saveResultReport = saveResultReport;
        vm.clearTars1 = clearTars1;
        vm.clearTars2 = clearTars2;
        vm.clearTars3 = clearTars3;

        activate();

        function activate() {
            generateUploadBox();
            $q.all([paramHelper.getParams([], ['resultReportAthletes.Id']),
                    authenticationService.getRight('MODEERJEL'),
                    authenticationService.getRight('UJEERJEL'),
                    authenticationService.getRight('MEGTEERJEL')])
                .then(function (results) {
                    vm.MODEERJEL = results[1];
                    vm.UJEERJEL = results[2];
                    vm.MEGTEERJEL = results[3];

                    if (!vm.MEGTEERJEL) {
                        log.permissionError(true);
                        return;
                    }

                    vm.CanCreateNew = ((!vm.editable) && vm.UJEERJEL);
                    vm.CanModify = ((!vm.editable) && vm.MODEERJEL);
                    //létezőt nyit vissza
                    if (results[0]['resultReportAthletes.Id'] && results[0]['resultReportAthletes.Id'] !== -1) {
                        getReportAthleteById(results[0]['resultReportAthletes.Id']).then(function () {
                            paramHelper.removeParam('resultReportAthletes.Id');
                        });
                    } else {
                        createResultReport();
                        getSections();
                    }
                });
        }

        function getReportAthleteById(Id) {
            return dataservice.resultReportAthletesSelectById(Id)
                .then(function (data) {
                    vm.editedReportResult = data.item;
                    vm.defaultSection = data.item.SzakosztalyId;
                    vm.defaultAgeGroup = data.item.KorcsoportId;
                    vm.defaultAthlete = data.item.SportoloId;
                    vm.defaultAthletePartner = data.item.TarsEredmenySportolo;
                    vm.defaultAthletePartner2 = data.item.TarsEredmenySportolo2;
                    vm.defaultAthletePartner3 = data.item.TarsEredmenySportolo3;
                    if (!data.item.Foto || data.item.Foto == 'noImage.png' || data.item.Foto == 'noImg.jpg') {
                        vm.editedReportResult.Foto = DOMAIN.baseURL + DOMAIN.noImage;
                    } else {
                        vm.editedReportResult.Foto = DOMAIN.baseURL + DOMAIN.resultReportImgBaseUrl + data.item.Foto;
                    }
                    getSections();
                    getFiles(Id);
                });
        }

        function generateUploadBox() {
            angular.element('#UploadDefault').ejUploadbox({
                saveUrl: DOMAIN.baseURL + DOMAIN.webService + 'FileUpload',
                removeUrl: DOMAIN.baseURL + DOMAIN.webService + 'FileRemove',
                uploadName: 'Uploadbox',
                allowDragAndDrop: false,
                autoUpload: true,
                enabled: true,
                buttonText: {
                    browse: gettextCatalog.getString('ChooseFile'),
                    upload: gettextCatalog.getString('UploadFile'),
                    cancel: gettextCatalog.getString('CancelUpload')
                },
                dialogAction: {modal: true, closeOnComplete: true, resize: false, drag: false},
                dialogText: {
                    title: gettextCatalog.getString('UploadedFilesTitle'),
                    name: gettextCatalog.getString('FileName'),
                    size: gettextCatalog.getString('FileSize'),
                    status: gettextCatalog.getString('FileStatus')
                },
                dropAreaText: gettextCatalog.getString('DropFileToUpload'),
                extensionsAllow: '.doc,.docx,.pdf,.xls, .mp4, .avi',
                complete: function (args) {
                    if (args.responseText === 'true') {
                        log.successMsg(gettextCatalog.getString('UploadSuccessed'));
                        getFiles(vm.editedReportResult.Id);
                    } else {
                        log.htmlError(gettextCatalog.getString('UploadError') + '<br>' + args.error);
                    }
                },
                error: function (args) {
                    var err = '';
                    if (args.error === 'Only files with .doc,.docx,.pdf,.xls,.mp4,.avi extensions are allowed.') {
                        err = gettextCatalog.getString('OnlyDocPdfXls');
                    } else if (args.error === '500 Internal Server Error') {
                        err = gettextCatalog.getString('ToLongFile');
                    }
                    log.htmlError(gettextCatalog.getString('UploadError') + '<br>' + err);
                },
                begin: function (args) {
                    args.data = {tipus: 'JelentokEgyeni', tablaId: vm.editedReportResult.Id};
                }
            });
        }

        //szakosztályok lekérése
        function getSections() {
            return dataservice.sectionDropDownList(0)
                .then(function (data) {
                    vm.sectionList = data.itemsList;
                });
        }

        function sectionDataBound() {
            if (vm.sectionList.length === 1) {
                angular.element('#maSzakosztaly').ejDropDownList('selectItemByValue', vm.sectionList[0].value);
            } else {
                angular.element('#maSzakosztaly').ejDropDownList('selectItemByValue', vm.defaultSection);
            }
        }

        // Run after selection
        function sectionSelect(args) {
            vm.editedReportResult.SzakosztalyId = args.value;
            getAgeGroups(args.value);
            getCharacterOfACompetitionList(args.value);
        }

        //korcsoportok lekérése
        function getAgeGroups(szakosztalyId) {
            return dataservice.ageGroupDropDownList(szakosztalyId)
                .then(function (data) {
                    vm.ageGroupList = data.itemsList;
                });
        }

        function getCharacterOfACompetitionList(szakosztalyId) {
            var csapat = false;
            return dataservice.getCharacterOfACompetitionList(csapat, szakosztalyId)
                .then(function (data) {
                    vm.competitionList = data.itemsList;
                });
        }

        function ageGroupDataBound() {
            if (vm.ageGroupList.length === 1) {
                angular.element('#maKorosztaly').ejDropDownList('selectItemByValue', vm.ageGroupList[0].value);
            } else {
                angular.element('#maKorosztaly').ejDropDownList('selectItemByValue', vm.defaultAgeGroup);
            }
        }

        function getAthletes(KorcsoportId) {
            return dataservice.athleteDropDownListSelect(vm.editedReportResult.SzakosztalyId, KorcsoportId, vm.defaultAthlete, vm.defaultAthletePartner)
                .then(function (data) {
                    vm.athleteList = data.itemsList;
                    for (var i = 0; i < vm.athleteList.length; i++) {
                        vm.athleteListPartner1[i] = {value: data.itemsList[i].value, text: data.itemsList[i].text};
                        vm.athleteListPartner2[i] = {value: data.itemsList[i].value, text: data.itemsList[i].text};
                        vm.athleteListPartner3[i] = {value: data.itemsList[i].value, text: data.itemsList[i].text};
                    }
                });
        }

        function ageGroupSelect(args) {
            vm.editedReportResult.KorcsoportId = args.value;
            getAthletes(args.value);
        }

        function athleteDataBound() {
            if (vm.athleteList.length === 1) {
                angular.element('#maSportolo').ejDropDownList('selectItemByValue', vm.athleteList[0].value);
            } else {
                angular.element('#maSportolo').ejDropDownList('selectItemByValue', vm.editedReportResult.SportoloId);
            }
        }

        function excludeFromPartnerList(sportoloid) {
            vm.athleteListPartner1 = vm.athleteListPartner1.filter(function (a) {
                return a.value != sportoloid;
            });
        }

        function athleteDataBoundPartner() {
            angular.element('#maTarsSportolo').ejDropDownList('selectItemByValue', vm.defaultAthletePartner);
        }

        function athleteDataBoundPartner2() {
            angular.element('#maTarsSportolo2').ejDropDownList('selectItemByValue', vm.defaultAthletePartner2);
        }

        function athleteDataBoundPartner3() {
            angular.element('#maTarsSportolo3').ejDropDownList('selectItemByValue', vm.defaultAthletePartner3);
        }

        function athleteSelect(args) {
            vm.editedReportResult.SportoloId = args.value;
            vm.athleteListPartner1 = vm.athleteListPartner1.filter(function (a) {
                return a.value != args.value;
            });
        }

        function athleteSelectPartner(args) {
            vm.editedReportResult.TarsEredmenySportolo = args.value;
            vm.athleteListPartner2 = vm.athleteListPartner1.filter(function (a) {
                return a.value != args.value;
            });
        }

        function athleteSelectPartner2(args) {
            vm.editedReportResult.TarsEredmenySportolo2 = args.value;
            vm.athleteListPartner3 = vm.athleteListPartner2.filter(function (a) {
                return a.value != args.value;
            });
        }

        function athleteSelectPartner3(args) {
            vm.editedReportResult.TarsEredmenySportolo3 = args.value;
        }

        function clearTars1() {
            vm.editedReportResult.TarsEredmenySportolo = undefined;
            $('#maTarsSportolo').ejDropDownList('clearText');
            clearTars2();
            clearTars3();
        }

        function clearTars2() {
            vm.editedReportResult.TarsEredmenySportolo2 = undefined;
            $('#maTarsSportolo2').ejDropDownList('clearText');
            clearTars3();
        }

        function clearTars3() {
            vm.editedReportResult.TarsEredmenySportolo3 = undefined;
            $('#maTarsSportolo3').ejDropDownList('clearText');
        }

        function goToOlderAnnualSeasonPlanReports() {
            vm.deleted = false;

            if (angular.isUndefined(vm.editedReportResult.SzakosztalyId) || vm.editedReportResult.SzakosztalyId === null || vm.editedReportResult.SzakosztalyId === -1) {
                swal({
                    title: gettextCatalog.getString('Error'),
                    text: gettextCatalog.getString('LetHimGrantAtLeastASection'),
                    type: 'error',
                    confirmButtonText: gettextCatalog.getString('Ok')
                });
            } else {
                vm.selectedRowIndexPopup = -1;
                angular.element('#searchWindow').data('ejDialog').open();
                dataservice.resultReportAthletesOlderReports(vm.editedReportResult.SzakosztalyId, vm.editedReportResult.KorcsoportId, true).then(function (args) {
                    gridPopup.dataSource = args.itemsList;
                });
            }
        }

        function openImgDialog() {
            angular.element('#dialogContainer').css('visibility', 'visible');
            angular.element('#cropDialog').ejDialog('open');
        }

        function createResultReport() {
            vm.editedReportResult = {};
            vm.editedReportResult.Id = -1;
            vm.editedReportResult.DatumIg = null;
            vm.editedReportResult.DatumTol = null;
            vm.editedReportResult.EdzoId = null;
            vm.editedReportResult.EdzoNeve = null;
            vm.editedReportResult.Eredmeny = 3;
            vm.editedReportResult.EredmenyIdo = null;
            vm.editedReportResult.EredmenySzoveg = null;
            vm.editedReportResult.EredmenyTavolsag = null;
            vm.editedReportResult.Ertekeles = null;
            vm.editedReportResult.Foto = vm.noImage;
            vm.editedReportResult.Helyezes = null;
            vm.editedReportResult.Helyszin = null;
            vm.editedReportResult.Hivatalos = false;
            vm.editedReportResult.Jellege = null;
            vm.editedReportResult.KorcsoportId = null;
            vm.editedReportResult.KorcsoportNeve = null;
            vm.editedReportResult.SportoloId = null;
            vm.editedReportResult.SportoloNev = null;
            vm.editedReportResult.SzakosztalyId = null;
            vm.editedReportResult.SzakosztalyNeve = null;
            vm.editedReportResult.SzuletesiIdo = null;
            vm.editedReportResult.TarsEredmenySportolo = null;
            vm.editedReportResult.TarsEredmenySportolo2 = null;
            vm.editedReportResult.TarsEredmenySportolo3 = null;
            vm.editedReportResult.VersenyLeiras = null;
            vm.editedReportResult.fileData = null;
            vm.editedReportResult.fileName = null;
            grid.dataSource = [];
            grid.editSettings.allowDeleting = true;

            vm.editedReportResult.SzakosztalyId = 0;
            vm.editedReportResult.KorcsoportId = 0;
            vm.editedReportResult.SportoloId = 0;
            vm.editedReportResult.TarsEredmenySportolo = 0;
            vm.editedReportResult.TarsEredmenySportolo2 = 0;
            vm.editedReportResult.TarsEredmenySportolo3 = 0;
            // angular.element('#maSzakosztaly').ejDropDownList('clearText');
            // angular.element('#maKorosztaly').ejDropDownList('clearText');
            // angular.element('#maSportolo').ejDropDownList('clearText');
            // angular.element('#maTarsSportolo').ejDropDownList('clearText');
            $timeout(function () {
                vm.editable = true;
                vm.CanCreateNew = false;
                vm.CanModify = false;
                $scope.$apply();
            });
        }

        function modifyResultReport() {
            vm.editable = true;
            grid.editSettings.allowDeleting = true;
            angular.element('#UploadDefault').ejUploadbox('enable');
            vm.CanCreateNew = false;
            vm.CanModify = false;
        }

        function saveResultReport() {
            $scope.$broadcast('submitted');
            if ((vm.editedReportResult.EredmenyIdo == null || angular.isUndefined(vm.editedReportResult.EredmenyIdo) || vm.editedReportResult.EredmenyIdo === '__:__:__.___') &&
                (vm.editedReportResult.EredmenySzoveg == null || angular.isUndefined(vm.editedReportResult.EredmenySzoveg) || vm.editedReportResult.EredmenySzoveg === '') &&
                (vm.editedReportResult.EredmenyTavolsag == null || angular.isUndefined(vm.editedReportResult.EredmenyTavolsag) || vm.editedReportResult.EredmenyTavolsag === '') &&
                (vm.editedReportResult.Eredmeny == null || angular.isUndefined(vm.editedReportResult.Eredmeny) || vm.editedReportResult.Eredmeny === '')
            ) {
                log.errorMsg('LegalabbEgyEredmenytAdjonMeg');
                return;
            }
            if ($scope.form.$valid === false) {
                log.errorMsg(gettextCatalog.getString('RequiredFieldsError'));
                return;
            }
            // kép küldése, ha választott
            if (angular.element('#fileName').val() !== '' && vm.cropper.croppedImage !== null) {
                vm.editedReportResult.fileData = vm.cropper.croppedImage;
                vm.editedReportResult.fileName = angular.element('#fileName').val();
            }
            $timeout(function () {
                $scope.$apply();
                dataservice.saveResultReportAthletes(vm.editedReportResult)
                    .then(function (args) {
                        log.successMsg('ResultReportSaved');
                        getReportAthleteById(args.data);
                        vm.editable = false;
                        angular.element('#UploadDefault').ejUploadbox('disable');
                        vm.CanCreateNew = ((!vm.editable) && vm.UJEERJEL);
                        vm.CanModify = ((!vm.editable) && vm.MODEERJEL);
                    });
            }, 100);
        }

        function openCropDialog() {
            angular.element('#dialogContainer').css('visibility', 'visible');
            angular.element('#cropDialog').ejDialog('open');
        }

        function closeCropDialog() {
            angular.element('#dialogContainer').css('visibility', 'hidden');
            angular.element('#cropDialog').ejDialog('close');
        }

        function doneCropDialog() {
            vm.deleted = false;
            vm.editedReportResult.Foto = vm.cropper.croppedImage;
            angular.element('#cropDialog').ejDialog('close');
        }

        function deleteImg() {
            swal({
                title: gettextCatalog.getString('DeleteProfileImg'),
                text: gettextCatalog.getString('AreYouSureYouWantToDeleteTheImage'),
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: gettextCatalog.getString('Yes'),
                cancelButtonText: gettextCatalog.getString('No')
            }).then(function (isConfirm) {
                if (isConfirm.value) {
                    angular.element('#fileName').val('');
                    vm.deleted = true;
                    vm.editedReportResult.Foto = vm.noImage;
                    vm.editedReportResult.fileName = 'oldDeleted';
                    $scope.$apply();
                }
            });
        }

        function getFiles(args) {
            dataservice.getFilesList('JelentokEgyeni', args).then(
                function (data) {
                    grid.dataSource = data.itemsList;
                });
        }

        function deleteFile(args) {
            return dataservice.deleteFiles(args.data.Id).then(function () {
                log.successMsg(gettextCatalog.getString('FileDeleted'));
            });
        }

        function closeEarlierResultReportAthletesWindow() {
            angular.element('#searchWindow').data('ejDialog').close();
        }

        function selectEarlierResultReportAthletesWindow() {
            vm.selectedRowIndexPopup = gridPopup.selectedRowIndex;
            if (vm.selectedRowIndexPopup > -1) {
                var vmi = gridPopup.currentViewData[vm.selectedRowIndexPopup];
                if (vmi) {
                    getReportAthleteById(vmi.Id)
                        .then(function (data) {
                            vm.editedReportResult = data.item;
                            vm.editedReportResult.Id = -1;
                        });
                    angular.element('#searchWindow').data('ejDialog').close();
                }
            }
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.administration.resultReportAthletes')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'administration.resultReportAthletes',
                config: {
                    url: '/resultReportAthletes',
                    templateUrl: 'app/administration/resultReportAthletes/resultReportAthletes.html',
                    controller: 'ResultReportAthletesController',
                    controllerAs: 'vm',
                    title: 'ResultReportAthletes',
                    settings: {
                        navId: 292,
                        level: 2,
                        order: 9,
                        orderTitle_hu: 'Eredményjelentő (egyéni)',
                        orderTitle_en: 'Result Report (individual)',
                        parentId: 2,
                        content: 'ResultReportAthletes',
                        activatorPermission: '"MEGTEERJEL"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    ResultReportTeamController.$inject = ["$q", "dataservice", "log", "DOMAIN", "paramHelper", "$scope", "$compile", "authenticationService", "gettextCatalog", "$rootScope", "$timeout", "$filter"];
    angular
        .module('app.administration.resultReportTeam')
        .controller('ResultReportTeamController', ResultReportTeamController);

    function ResultReportTeamController($q, dataservice, log, DOMAIN, paramHelper, $scope, $compile, authenticationService, gettextCatalog, $rootScope, $timeout, $filter) {
        var vm = this;
        $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('ResultReportTeam');
        vm.editedReportResult = {};
        vm.editedReportId = -1;
        vm.sectionList = [];
        vm.ageGroupList = [];
        vm.teamList = [];
        vm.competitionList = [];
        vm.EredmenyIdo = '';
        vm.noImage = DOMAIN.baseURL + DOMAIN.noImage;
        vm.editedReportResult.Foto = vm.noImage;
        vm.editable = false;
        vm.CanCreateNew = true;
        vm.CanModify = true;
        vm.selectedRowIndexPopup = -1;
        vm.selectedRowIndex = -1;
        vm.AtjatszoAgeGroup = undefined;
        vm.AtjatszoAgeGroupList = [];
        vm.columnsPopup = [];

        // Image cropper variables
        vm.cropper = {};
        vm.cropper.sourceImage = null;
        vm.cropper.croppedImage = null;
        vm.bounds = {};
        vm.bounds.left = 0;
        vm.bounds.right = 0;
        vm.bounds.top = 0;
        vm.bounds.bottom = 0;
        vm.cropDialogTitle = gettextCatalog.getString('ChooseImageTitle');

        vm.addAtjatszok = addAtjatszok;
        vm.doneCropDialog = doneCropDialog;
        vm.closeCropDialog = closeCropDialog;
        vm.closeEarlierResultReportTeamWindow = closeEarlierResultReportTeamWindow;
        vm.selectEarlierResultReportTeamWindow = selectEarlierResultReportTeamWindow;
        vm.goToOlderAnnualSeasonPlanReports = goToOlderAnnualSeasonPlanReports;

        vm.maskObject;
        vm.elem;
        vm.tableTimeEditorTemplate = {
            create: function () {
                var txt = document.createElement('input');
                txt.style.width = '100%';
                txt.style.float = 'left';
                vm.elem = txt;
                vm.elem.addEventListener('focus', function () {
                    this.select();
                });
                return vm.elem;
            },
            read: function () {
                return vm.maskObject.getMaskedValue();
            },
            destroy: function () {
                if (vm.maskObject != null) {
                    vm.maskObject.destroy();
                }
            },
            write: function (args) {
                var s = args.element.id.toString().replace('GridAthletes', '');
                vm.maskObject = new ej2.inputs.MaskedTextBox({
                    minWidth: '100%',
                    mask: '99:99:99.999',
                    value: args.rowdata !== undefined ? args.rowdata[s] : '',
                    readOnly: !vm.editable
                });
                vm.editedRowId = args.rowData['Id'];
                $compile(args.element[0])($scope);
                vm.maskObject.appendTo(vm.elem);
            }
        };

        vm.columns = [
            {
                field: 'Id', visible: false, isPrimaryKey: true, isIdentity: true
            },
            {
                field: 'Filenev',
                headerText: gettextCatalog.getString('Filename'),
                textAlign: 'center',
                allowEditing: false,
                width: 100,
                template: '#reretetemplateDataColumn1'
            },
            {
                field: 'Datum',
                headerText: gettextCatalog.getString('Date'),
                textAlign: 'center',
                width: 100,
                allowEditing: false
            }
        ];

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: ['Delete'],
            allowPaging: true,
            allowSorting: true,
            allowExcelExport: true,
            allowTextWrap: true,
            editSettings: {allowDeleting: false},
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#Grid'), $scope);
                }
                if (args.requestType == 'delete') {
                    return dataservice.deleteFiles(args.data[0].Id).then(function () {
                        log.successMsg(gettextCatalog.getString('FileDeleted'));
                    });
                }
            },
        });
        grid.appendTo('#Grid');

        // Athletes
        vm.columnsAthletes = [
            {
                field: 'Id',
                visible: false,
                isPrimaryKey: true,
                isIdentity: true
            },
            {
                field: 'Nev',
                headerText: gettextCatalog.getString('AthleteName'),
                textAlign: 'center',
                width: 100,
                allowEditing: false
            },
            {
                field: 'KorcsoportNeve',
                headerText: gettextCatalog.getString('AgeGroup'),
                textAlign: 'center',
                width: 50,
                allowEditing: false
            },
            {
                field: 'EdzoNeve',
                headerText: gettextCatalog.getString('TrainerName'),
                textAlign: 'center',
                width: 100,
                allowEditing: false,
            },
            {
                field: 'Atjatszo',
                headerText: gettextCatalog.getString('AtFeljatszo'),
                textAlign: 'center',
                width: 50,
                allowEditing: false,
                type: 'boolean',
                editType: ej.Grid.EditingType.Boolean,
                displayAsCheckBox: true,
            },
            {
                field: 'Kiemelt',
                headerText: gettextCatalog.getString('Kiemelt'),
                textAlign: 'center',
                width: 50,
                type: 'boolean',
                editType: ej.Grid.EditingType.Boolean,
                displayAsCheckBox: true,
            },
            {
                field: 'EredmenySzoveg',
                headerText: gettextCatalog.getString('EredmenySzoveg'),
                textAlign: 'left',
                width: 100,
                allowEditing: true
            },
            {
                field: 'EredmenyPont',
                headerText: gettextCatalog.getString('EredmenyPontGol'),
                textAlign: 'center',
                type: 'numeric',
                editType: ej.Grid.EditingType.Numeric,
                editParams: {decimalPlaces: 2, locale: 'HU-hu'},
                width: 100,
                allowEditing: true
            },
            {
                field: 'EredmenyIdo',
                headerText: gettextCatalog.getString('EredmenyIdo'),
                textAlign: 'center',
                edit: vm.tableTimeEditorTemplate,
                width: 100,
                allowEditing: true
            },
            {
                field: 'EredmenyTavolsag',
                headerText: gettextCatalog.getString('EredmenyTavolsag'),
                textAlign: 'center',
                editType: ej.Grid.EditingType.Numeric,
                format: 'N2',
                params: {decimals: 2},
                width: 100,
                allowEditing: true
            },
            {
                field: 'EredmenyTavolsagM',
                headerText: gettextCatalog.getString('EredmenyTavolsagM'),
                textAlign: 'center',
                editType: ej.Grid.EditingType.Numeric,
                width: 100,
                allowEditing: true
            }
        ];

        var gridAthletes = new ej2.grids.Grid({
            dataSource: [],
            allowPaging: true,
            allowSorting: true,
            allowExcelExport: true,
            allowTextWrap: true,
            editSettings: {allowDeleting: false, allowEditing: false, mode: 'Batch', showConfirmDialog: false},
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columnsAthletes,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#GridAthletes'), $scope);
                }
            },
            cellEdit: function (args) {
                if (!vm.editable) {
                    args.cancel = true;
                } else {
                    if (args.columnName === 'Kiemelt') {
                        var index = gridAthletes.dataSource.findIndex(function (item) {
                            return item.SportolokID === args.rowData.SportolokID;
                        });
                        gridAthletes.dataSource[index]['Kiemelt'] = !gridAthletes.dataSource[index]['Kiemelt'];
                        gridAthletes.endEdit();
                        args.cancel = true;
                    }
                }
            },
            cellSave: function (arg) {
                if (arg.columnName == 'EredmenyTavolsag') {
                    for (var i = 0; i < gridAthletes.dataSource.length; i++) {
                        if (gridAthletes.dataSource[i].SportolokID == arg.rowData.SportolokID) {
                            gridAthletes.dataSource[i].EredmenyTavolsag = arg.value;
                            gridAthletes.dataSource[i].EredmenyTavolsagM = arg.value / 100;
                            gridAthletes.refresh();
                            break;
                        }
                    }
                } else if (arg.columnName == 'EredmenyTavolsagM') {
                    for (var i = 0; i < gridAthletes.dataSource.length; i++) {
                        if (gridAthletes.dataSource[i].SportolokID == arg.rowData.SportolokID) {
                            gridAthletes.dataSource[i].EredmenyTavolsagM = arg.value;
                            gridAthletes.dataSource[i].EredmenyTavolsag = arg.value * 100;
                            gridAthletes.refresh();
                            break;
                        }
                    }
                } else {
                    for (var i = 0; i < gridAthletes.dataSource.length; i++) {
                        if (gridAthletes.dataSource[i].SportolokID == arg.rowData.SportolokID) {
                            gridAthletes.dataSource[i][arg.columnName] = arg.value;
                            gridAthletes.refresh();
                            break;
                        }
                    }
                }
            }
        });
        gridAthletes.appendTo('#GridAthletes');

        vm.atjatszoColumns = [
            {field: 'Id', visible: false, isPrimaryKey: true, isIdentity: true},
            {field: 'SportoloNev', headerText: gettextCatalog.getString('Name'), textAlign: 'center'},
            {field: 'Szuletes', headerText: gettextCatalog.getString('BirthDate'), textAlign: 'center'},
            {field: 'korosztaly', headerText: gettextCatalog.getString('AgeGroup'), textAlign: 'center'},
            {field: 'edzoneve', headerText: gettextCatalog.getString('Coach'), textAlign: 'center'}
        ];

        var gridAtjatszo = new ej2.grids.Grid({
            dataSource: [],
            allowPaging: true,
            allowSorting: true,
            allowExcelExport: true,
            allowTextWrap: true,
            editSettings: {allowDeleting: false},
            locale: 'hu-HU',
            gridLines: 'Both',
            selectionSettings: {type: 'multiple', mode: 'Both'},
            pageSettings: $rootScope.pageSettings,
            columns: vm.atjatszoColumns,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            rowSelecting: function () {
            },
        });
        gridAtjatszo.appendTo('#GridAtjatszo');

        vm.columnsPopup = [
            {
                field: 'Id',
                visible: false,
                isPrimaryKey: true,
                isIdentity: true
            },
            {
                field: 'VersenyNeve',
                headerText: gettextCatalog.getString('CompetitionName'),
                textAlign: 'center',
                width: 100,
                allowEditing: false
            },
            {
                field: 'Versenyszam',
                headerText: gettextCatalog.getString('Versenyszam'),
                textAlign: 'center',
                width: 100,
                allowEditing: false
            },
            {
                field: 'Szakosztaly',
                headerText: gettextCatalog.getString('Section'),
                textAlign: 'center',
                width: 100,
                allowEditing: false
            },
            {
                field: 'Korosztaly',
                headerText: gettextCatalog.getString('AgeGroup'),
                textAlign: 'center',
                width: 100,
                allowEditing: false
            },
            {
                field: 'SportoloCsapat',
                headerText: gettextCatalog.getString('Team'),
                textAlign: 'center',
                width: 100,
                allowEditing: false
            },
            {
                field: 'Datum',
                headerText: gettextCatalog.getString('Date'),
                textAlign: 'center',
                width: 100,
                allowEditing: false
            }
        ];

        var gridPopup = new ej2.grids.Grid({
            dataSource: [],
            allowPaging: true,
            allowSorting: true,
            allowTextWrap: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columnsPopup,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            }
        });
        gridPopup.appendTo('#GridPopup');

        vm.sectionDataBound = sectionDataBound;
        vm.sectionSelect = sectionSelect;
        vm.ageGroupDataBound = ageGroupDataBound;
        vm.ageGroupSelect = ageGroupSelect;
        vm.teamDataBound = teamDataBound;
        vm.teamSelect = teamSelect;
        vm.openCropDialog = openImgDialog;
        vm.deleteImg = deleteImg;
        vm.createResultReport = createResultReport;
        vm.modifyResultReport = modifyResultReport;
        vm.saveResultReport = saveResultReport;
        vm.oldTeamId = 0;
        vm.addAthletesToResultReport = addAthletesToResultReport;
        vm.removeAthletesFromResultReport = removeAthletesFromResultReport;
        vm.atjatszoAgeGroupSelect = atjatszoAgeGroupSelect;

        activate();

        function activate() {
            generateUploadbox();
            $q.all([paramHelper.getParams([], ['resultReportTeam.Id']),
                authenticationService.getRight('MODCSERJEL'),
                authenticationService.getRight('UJCSERJEL'),
                authenticationService.getRight('MEGTCSERJEL')])
                .then(function (results) {
                    vm.MODCSERJEL = results[1];
                    vm.UJCSERJEL = results[2];
                    vm.MEGTCSERJEL = results[3];

                    if (!vm.MEGTCSERJEL) {
                        log.permissionError(true);
                        return;
                    }
                    vm.CanCreateNew = ((!vm.editable) && vm.UJCSERJEL);
                    vm.CanModify = ((!vm.editable) && vm.MODCSERJEL);
                    //létezőt nyit vissza
                    if (results[0]['resultReportTeam.Id'] && results[0]['resultReportTeam.Id'] !== -1) {
                        dataservice.resultReportTeamSelectById(results[0]['resultReportTeam.Id'])
                            .then(function (data) {
                                $timeout(function () {
                                    vm.editedReportId = results[0]['resultReportTeam.Id'];
                                    paramHelper.removeParam('resultReportTeam.Id');
                                    vm.editedReportResult = data.item;
                                    vm.editedReportResult.SzakosztalyId = data.item.SzakosztalyId;
                                    vm.editedReportResult.KorcsoportId = data.item.KorcsoportId;
                                    vm.editedReportResult.CsapatId = data.item.CsapatId;
                                    if (!vm.editedReportResult.Foto || vm.editedReportResult.Foto == 'noImage.png' || vm.editedReportResult.Foto == 'noImg.jpg') {
                                        vm.editedReportResult.Foto = DOMAIN.baseURL + DOMAIN.noImage;
                                    } else {
                                        vm.editedReportResult.Foto = DOMAIN.baseURL + DOMAIN.resultReportTeamImgBaseUrl + vm.editedReportResult.Foto;
                                    }
                                    gridAthletes.dataSource = data.item.Sportolok;
                                }, 0);
                                getSections();
                                getFiles(results[0]['resultReportTeam.Id']);
                            });
                    } else {
                        createResultReport();
                        getSections();
                    }
                });
        }

        function generateUploadbox() {
            angular.element('#UploadDefault').ejUploadbox({
                saveUrl: DOMAIN.baseURL + DOMAIN.webService + 'FileUpload',
                removeUrl: DOMAIN.baseURL + DOMAIN.webService + 'FileRemove',
                uploadName: 'Uploadbox',
                allowDragAndDrop: false,
                autoUpload: true,
                enabled: false,
                buttonText: {
                    browse: gettextCatalog.getString('ChooseFile'),
                    upload: gettextCatalog.getString('UploadFile'),
                    cancel: gettextCatalog.getString('CancelUpload')
                },
                dialogAction: {modal: true, closeOnComplete: true, resize: false, drag: false},
                dialogText: {
                    title: gettextCatalog.getString('UploadedFilesTitle'),
                    name: gettextCatalog.getString('FileName'),
                    size: gettextCatalog.getString('FileSize'),
                    status: gettextCatalog.getString('FileStatus')
                },
                dropAreaText: gettextCatalog.getString('DropFileToUpload'),
                extensionsAllow: '.doc,.docx,.pdf,.xls, .mp4, .avi',
                complete: function (args) {
                    if (args.responseText === 'true') {
                        log.successMsg(gettextCatalog.getString('UploadSuccessed'));
                        getFiles(vm.editedReportResult.Id);
                    } else {
                        log.htmlError(gettextCatalog.getString('UploadError') + '<br>' + args.error);
                    }
                },
                error: function (args) {
                    var err = '';
                    if (args.error === 'Only files with .doc,.docx,.pdf,.xls,.mp4,.avi extensions are allowed.') {
                        err = gettextCatalog.getString('OnlyDocPdfXls');
                    } else if (args.error === '500 Internal Server Error') {
                        err = gettextCatalog.getString('ToLongFile');
                    }
                    log.htmlError(gettextCatalog.getString('UploadError') + '<br>' + err);
                },
                begin: function (args) {
                    args.data = {tipus: 'JelentokCsapat', tablaId: vm.editedReportResult.Id};
                }
            });
        }

        //szakosztályok lekérése
        function getSections() {
            return dataservice.sectionDropDownList(0)
                .then(function (data) {
                    vm.sectionList = data.itemsList;
                });
        }

        function sectionDataBound() {
            if (vm.sectionList.length === 1) {
                angular.element('#maSzakosztaly').ejDropDownList('selectItemByValue', vm.sectionList[0].value);
            } else {
                angular.element('#maSzakosztaly').ejDropDownList('selectItemByValue', vm.editedReportResult.SzakosztalyId);
            }
        }

        // Run after selection
        function sectionSelect(args) {
            vm.editedReportResult.SzakosztalyId = args.value;
            getAgeGroups(args.value);
            getAgeGroupsForAtjatszo(args.value);
            getCharacterOfACompetitionList(args.value);
        }

        //korcsoportok lekérése
        function getAgeGroups(szakosztalyId) {
            return dataservice.ageGroupDropDownList(szakosztalyId)
                .then(function (data) {
                    vm.ageGroupList = data.itemsList;
                });
        }

        function ageGroupDataBound() {
            if (vm.ageGroupList.length === 1) {
                angular.element('#maKorosztaly').ejDropDownList('selectItemByValue', vm.ageGroupList[0].value);
            } else {
                angular.element('#maKorosztaly').ejDropDownList('selectItemByValue', vm.editedReportResult.KorcsoportId);
            }
        }

        function ageGroupSelect(args) {
            vm.editedReportResult.KorcsoportId = args.value;

            // $('#maCsapat').ejDropDownList('clearText');
            vm.oldTeamId = -1;
            getTeams(args.value);
        }

        function getTeams(KorcsoportId) {
            var CsapatId = $('#maKorosztaly').ejDropDownList('getSelectedValue');
            dataservice.teamDropDownListSelect(vm.editedReportResult.SzakosztalyId, KorcsoportId, CsapatId).then(function (data) {
                vm.teamList = data.itemsList;
            });
        }

        function teamDataBound() {
            if (vm.teamList.length === 1) {
                angular.element('#maCsapat').ejDropDownList('selectItemByValue', vm.teamList[0].value);
            } else {
                angular.element('#maCsapat').ejDropDownList('selectItemByValue', vm.editedReportResult.CsapatId);
            }
        }

        function teamSelect(args) {
            if (!vm.editedReportId || vm.editedReportId === -1 || vm.oldTeamId !== -1) {
                if (vm.oldTeamId === args.value) {
                    return;
                }
                vm.oldTeamId = args.value;
                dataservice.teamAthletesListSelect(args.value).then(function (athletesList) {
                    gridAthletes.dataSource = athletesList.itemsList;

                    swal({
                        title: gettextCatalog.getString('AtjatszoSportolok'),
                        text: gettextCatalog.getString('AreYouSureYouWantToAddAtjatszoAthletes'),
                        type: 'question',
                        showCancelButton: true,
                        confirmButtonText: gettextCatalog.getString('Yes'),
                        cancelButtonText: gettextCatalog.getString('No')
                    }).then(function (isConfirm) {
                        if (isConfirm.value) {
                            dataservice.EredmenyJelentoAtjatszoSportoloi(args.value).then(function (args) {
                                for (var i = 0; i < args.itemsList.length; i++) {
                                    gridAthletes.dataSource.push(args.itemsList[i]);
                                }
                                gridAthletes.refresh();
                            });
                        }
                    });
                });
                dataservice.getCoachUsers([vm.editedReportResult.SzakosztalyId]).then(function (args) {
                    vm.atjatszoEdzoList = args.itemsList;
                });
            }
            getAtjatszoSportolok(vm.editedReportResult.SzakosztalyId, 0, 0, args.value);
        }

        function getAgeGroupsForAtjatszo(szakosztalyId) {
            return dataservice.ageGroupDropDownList(szakosztalyId)
                .then(function (data) {
                    vm.AtjatszoAgeGroupList = data.itemsList;
                    vm.AtjatszoAgeGroupList.unshift({value: '0', text: gettextCatalog.getString('All')});
                });
        }

        function atjatszoAgeGroupSelect(arg) {
            getAtjatszoSportolok(vm.editedReportResult.SzakosztalyId, arg.value, 0, vm.editedReportResult.CsapatId);
        }

        function getAtjatszoSportolok(section, agegroup, coach, exceptTeam) {
            dataservice.AtjatszoSportoloLista(section, agegroup, coach, exceptTeam).then(function (response) {
                gridAtjatszo.dataSource = $filter('dateStringFilter')(response.itemsList, 'Szuletes');
            });
        }

        function addAtjatszok() {
            vm.selectedAtjatszok = $rootScope.getSelectedItems(gridAtjatszo);
            if (!vm.selectedAtjatszok || vm.selectedAtjatszok.length == 0) {
                log.errorMsg('PleaseSelectAthlete');
                return;
            }
            vm.selectedAtjatszok.forEach(function (atjatszo) {
                addAthletesToResultReport(atjatszo.SportoloID, atjatszo.edzoneve, atjatszo.edzoid);
            });
            gridAtjatszo.refresh();
        }

        function addAthletesToResultReport(atjatszoSportoloID, edzoNeve, edzoId) {
            if (!atjatszoSportoloID) {
                log.errorMsg('PleaseSelectAthlete');
                return;
            }
            var id = -1;
            for (var i = 0; i < gridAthletes.dataSource.length; i++) {
                if (gridAthletes.dataSource[i].SportolokID == atjatszoSportoloID) {
                    log.errorMsg('AthleteExistsInResultReport');
                    return;
                }
                if (gridAthletes.dataSource[i].Id < id) {
                    id = gridAthletes.dataSource[i].Id;
                }
            }
            dataservice.getTeamResultAthleteData(atjatszoSportoloID).then(function (args) {
                var rec = {};
                rec.SportolokID = args.SportolokID;
                rec.Id = id - 1;
                rec.Nev = args.Nev;
                rec.KorcsoportNeve = args.KorcsoportNeve;
                rec.KorcsoportId = args.Korcsoport;
                rec.EdzoId = edzoId;
                rec.EdzoNeve = edzoNeve;
                rec.SzuletesiIdo = args.SzuletesiIdo;
                rec.SzakosztalyId = args.IdSzakosztaly;
                rec.Atjatszo = true;
                rec.atjatszoCsapatId = vm.editedReportResult.CsapatId;
                rec.Kiemelt = false;
                rec.EredmenySzoveg = '';
                rec.EredmenyPont = '';
                rec.EredmenyIdo = '';
                rec.EredmenyTavolsag = '';
                gridAthletes.dataSource.push(rec);
                gridAthletes.refresh();
            });
        }

        function getCharacterOfACompetitionList(szakosztalyId) {
            var csapat = true;
            return dataservice.getCharacterOfACompetitionList(csapat, szakosztalyId)
                .then(function (data) {
                    vm.competitionList = data.itemsList;
                });
        }

        function goToOlderAnnualSeasonPlanReports() {
            if (!vm.editedReportResult.SzakosztalyId || vm.editedReportResult.SzakosztalyId < 1) {
                log.errorMsg(gettextCatalog.getString('LetHimGrantAtLeastASection'));
                return;
            } else {
                vm.selectedRowIndexPopup = -1;

                angular.element('#searchWindow').data('ejDialog').open();
                var KorcsoportId = angular.element('#maKorosztaly').ejDropDownList('getSelectedValue');
                dataservice.resultReportAthletesOlderReports(vm.editedReportResult.SzakosztalyId,
                    KorcsoportId, false).then(function (args) {
                    gridPopup.dataSource = args.itemsList;
                });
            }
        }

        function selectEarlierResultReportTeamWindow() {
            vm.selectedRowIndexPopup = gridPopup.selectedRowIndex;
            if (vm.selectedRowIndexPopup > -1) {
                var vmi = gridPopup.currentViewData[vm.selectedRowIndexPopup];
                if (vmi) {
                    dataservice.resultReportTeamSelectById(vmi.Id)
                        .then(function (data) {
                            vm.editedReportResult = data.item;
                            vm.editedReportResult.Id = -1;
                            for (var i = 0; i < vm.editedReportResult.Sportolok.length; i++) {
                                vm.editedReportResult.Sportolok[i].Id = -1 * (i + 1);
                            }
                        });
                    angular.element('#searchWindow').data('ejDialog').close();
                }
            }
        }

        function removeAthletesFromResultReport() {
            vm.selectedRowIndex = $rootScope.gridSelectedRowIndex(gridAthletes);
            if (vm.selectedRowIndex === undefined || vm.selectedRowIndex == null || vm.selectedRowIndex.length < 0) {
                log.errorMsg('PleaseSelectAthlete');
                return;
            }
            swal({
                title: gettextCatalog.getString('DeleteAthlete'),
                text: gettextCatalog.getString('AreYouSureYouWantToDeleteSelectedAthlete'),
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: gettextCatalog.getString('Yes'),
                cancelButtonText: gettextCatalog.getString('No')
            }).then(function (isConfirm) {
                if (isConfirm.value) {
                    grid.endEdit();
                    vm.selectedRowIndex.forEach(function () {
                        gridAthletes.dataSource.splice(vm.selectedRowIndex, 1);
                    });
                    gridAthletes.refresh();
                }
            });
        }

        function closeEarlierResultReportTeamWindow() {
            angular.element('#searchWindow').data('ejDialog').close();
        }

        function createResultReport() {
            vm.editedReportResult = {};
            vm.editedReportResult.DatumIg = null;
            vm.editedReportResult.DatumTol = null;
            vm.editedReportResult.EdzoId = null;
            vm.editedReportResult.EdzoNeve = null;
            vm.editedReportResult.Eredmeny = 3;
            vm.editedReportResult.EredmenyIdo = null;
            vm.editedReportResult.EredmenySzoveg = null;
            vm.editedReportResult.EredmenyTavolsag = null;
            vm.editedReportResult.Ertekeles = null;
            vm.editedReportResult.Foto = vm.noImage;
            vm.editedReportResult.Helyezes = null;
            vm.editedReportResult.Helyszin = null;
            vm.editedReportResult.Hivatalos = false;
            vm.editedReportResult.Jellege = null;
            vm.editedReportResult.KorcsoportNeve = null;
            vm.editedReportResult.SportoloId = null;
            vm.editedReportResult.SportoloNev = null;
            vm.editedReportResult.SzakosztalyNeve = null;
            vm.editedReportResult.SzuletesiIdo = null;
            vm.editedReportResult.TarsEredmenySportolo = null;
            vm.editedReportResult.VersenyLeiras = null;
            vm.editedReportResult.fileData = null;
            vm.editedReportResult.fileName = null;
            vm.editedReportResult.Id = -1;
            gridAthletes.dataSource = [];
            grid.dataSource = [];
            grid.editSettings.allowDeleting = true;
            gridAthletes.editSettings.allowDeleting = true;
            gridAthletes.editSettings.allowEditing = true;
            //vm.editable = true;
            angular.element('#UploadDefault').ejUploadbox('enable');
            // angular.element('#maSzakosztaly').ejDropDownList('clearText');
            // angular.element('#maKorosztaly').ejDropDownList('clearText');
            // angular.element('#maSportolo').ejDropDownList('clearText');
            // angular.element('#maTarsSportolo').ejDropDownList('clearText');

            vm.editedReportResult.SzakosztalyId = 0;
            vm.editedReportResult.KorcsoportId = 0;

            vm.editedReportId = -1;
            $timeout(function () {
                vm.editable = true;
                vm.CanCreateNew = false;
                vm.CanModify = false;
                $scope.$apply();
            }, 0);
        }

        function modifyResultReport() {
            dataservice.getCoachUsers(vm.editedReportResult.SzakosztalyId).then(function (args) {
                vm.atjatszoEdzoList = args.itemsList;
                grid.editSettings.allowDeleting = true;
                gridAthletes.editSettings.allowDeleting = true;
                gridAthletes.editSettings.allowEditing = true;
                vm.editable = true;
                angular.element('#UploadDefault').ejUploadbox('enable');
                vm.CanCreateNew = false;
                vm.CanModify = false;
            });
        }

        function saveResultReport() {
            $scope.$broadcast('submitted');
            grid.endEdit();
            //grid.editModule.batchSave();

            gridAthletes.endEdit();
            //gridAthletes.editModule.batchSave();
            if ($scope.form.$valid === false) {
                log.errorMsg(gettextCatalog.getString('RequiredFieldsError'));
                return;
            }
            vm.editedReportResult.Sportolok = gridAthletes.dataSource;
            // kép küldése, ha választott

            if (angular.element('#fileName').val() !== '' && vm.cropper.croppedImage !== null) {
                vm.editedReportResult.fileData = vm.cropper.croppedImage;
                vm.editedReportResult.fileName = angular.element('#fileName').val();
            }
            dataservice.saveResultReportTeams(vm.editedReportResult)
                .then(function (args) {
                    if (args.res > 0) {
                        vm.editedReportId = args.res;
                        log.successMsg('ResultReportSaved');
                        vm.editedReportResult.Id = args.res;
                        angular.element('#UploadDefault').ejUploadbox('disable');
                        vm.CanCreateNew = vm.UJCSERJEL;
                        vm.CanModify = vm.MODCSERJEL;
                        vm.editable = false;
                        // $timeout(function () {
                        //     $scope.$apply();
                        // }, 100);
                    }
                });
        }

        function deleteImg() {
            swal({
                title: gettextCatalog.getString('DeleteProfileImg'),
                text: gettextCatalog.getString('AreYouSureYouWantToDeleteTheImage'),
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: gettextCatalog.getString('Yes'),
                cancelButtonText: gettextCatalog.getString('No')
            }).then(function (isConfirm) {
                if (isConfirm.value) {
                    angular.element('#fileName').val('');
                    vm.editedReportResult.Foto = vm.noImage;
                    vm.editedReportResult.fileName = 'oldDeleted';
                    $scope.$apply();
                }
            });
        }

        function getFiles(args) {
            dataservice.getFilesList('JelentokCsapat', args).then(
                function (data) {
                    grid.dataSource = data.itemsList;
                });
        }

        function openImgDialog() {
            angular.element('#dialogContainer').css('visibility', 'visible');
            angular.element('#cropDialog').ejDialog('open');
        }

        function openCropDialog() {
            angular.element('#dialogContainer').css('visibility', 'visible');
            angular.element('#cropDialog').ejDialog('open');
        }

        function closeCropDialog() {
            angular.element('#dialogContainer').css('visibility', 'hidden');
            angular.element('#cropDialog').ejDialog('close');
        }

        function doneCropDialog() {
            vm.editedReportResult.Foto = vm.cropper.croppedImage;
            angular.element('#cropDialog').ejDialog('close');
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.administration.resultReportTeam')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'administration.resultReportTeam',
                config: {
                    url: '/resultReportTeam',
                    templateUrl: 'app/administration/resultReportTeam/resultReportTeam.html',
                    controller: 'ResultReportTeamController',
                    controllerAs: 'vm',
                    title: 'ResultReportTeam',
                    settings: {
                        navId: 292,
                        level: 2,
                        order: 10,
                        orderTitle_hu: 'Eredményjelentő (csapat)',
                        orderTitle_en: 'Result Report (team)',
                        parentId: 2,
                        content: 'ResultReportTeam',
                        activatorPermission: '"MEGTCSERJEL"'
                    }
                }
            }
        ];
    }
})();

(function() {
    'use strict';

    NewSportSpecificTestController.$inject = ["log", "authenticationService", "dataservice", "$q", "$state", "$rootScope", "gettextCatalog", "paramHelper", "$scope", "$compile", "$timeout"];
    angular
        .module('app.administration.sportSpecificTest.newSportSpecificTest')
        .controller('NewSportSpecificTestController', NewSportSpecificTestController);

    function NewSportSpecificTestController(log, authenticationService, dataservice, $q, $state, $rootScope, gettextCatalog, paramHelper, $scope, $compile, $timeout) {
        var vm = this; $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('NewSportSpecificTest');

        vm.columns = [
            {field: 'SportoloID', headerText: 'Id', textAlign: 'left', isPrimaryKey: true, visible: false},
            {field: 'SportoloNeve', headerText: gettextCatalog.getString('AthleteName'), textAlign: 'left', width: 200, allowEditing: false}
        ];
        vm.testdata = [];
        vm.sectionList = [];
        vm.ageGroupList = [];
        vm.coachList = [];
        vm.sectionId = 0;
        vm.ageGroupId = 0;
        vm.coachId = 0;
        vm.felmeroFejId = -1;
        vm.felmeroElemFejId = -1;
        vm.felmeroElemFejIdValue = undefined;
        vm.newTest = true;
        vm.createButtonEnabled = true;
        vm.editTestTypeButtonEnabled = true;
        vm.edzoertekeles = '';
        vm.querycellinfo = querycellinfo;
        vm.sectionDataBound = sectionDataBound;
        vm.ageGroupDataBound = ageGroupDataBound;
        vm.coachDataBound = coachDataBound;
        vm.felmeroDataBound = felmeroDataBound;
        vm.DeleteTest = DeleteTest;
        vm.SaveTest = SaveTest;
        vm.CreateTest = CreateTest;
        vm.CreateTestType = CreateTestType;
        vm.EditTestType = EditTestType;
        vm.params = [];
        vm.test = [];
        vm.dataFelmeroElem = [];
        vm.dateValue = new Date();
        vm.hints = [];
        vm.cellHint = '';
        vm.openAthlete = openAthlete;
        vm.colorCheckBoxChange = colorCheckBoxChange;
        vm.UJSPFELM = false;
        vm.Highlight = -1;
        vm.colors = true;
        vm.showColors = false;
        var Grid2 = null;

        CreateGrid2();

        activate();

        function activate() {
            authenticationService.getRight('MEGTSPFELM').then(function (results) {
                if (results !== true) {
                    log.permissionError(true);
                } else {
                    var promises = [
                        paramHelper.getParams(['sportSpecificTest.sectionId', 'sportSpecificTest.ageGroupId', 'sportSpecificTest.coachId', 'sportSpecificTest.felmeroFejId', 'sportSpecificTest.felmeroElemFejId', 'sportSpecificTest.highlight']),
                        authenticationService.getRight('UJSPFELM')
                    ];
                    $q.all(promises).then(function (results) {
                        vm.params = results[0];
                        vm.UJSPFELM = results[1];
                        vm.sectionId = vm.params['sportSpecificTest.sectionId'];
                        vm.ageGroupId = vm.params['sportSpecificTest.ageGroupId'];
                        vm.coachId = vm.params['sportSpecificTest.coachId'];
                        vm.felmeroFejId = vm.params['sportSpecificTest.felmeroFejId'];
                        if (vm.params['sportSpecificTest.felmeroElemFejId']) {
                            vm.felmeroElemFejId = vm.params['sportSpecificTest.felmeroElemFejId'];
                            vm.felmeroElemFejIdValue = vm.params['sportSpecificTest.felmeroElemFejId'];
                        }
                        if (vm.params['sportSpecificTest.highlight']) {
                            vm.Highlight = vm.params['sportSpecificTest.highlight'];
                        }
                        vm.sectionIdValue = vm.sectionId;
                        vm.ageGroupIdValue = vm.ageGroupId;
                        vm.coachIdValue = vm.coachId;
                        getSections();
                        getAgeGroups(vm.sectionId);
                        getCoaches();
                        getFelmeroTipusok(vm.sectionId);
                        if (vm.felmeroFejId > 0) {
                            vm.newTest = false;
                            vm.showColors = true;
                            vm.createButtonEnabled = false;
                            LoadTest(vm.felmeroFejId);
                        } else {
                            vm.createButtonEnabled = true;
                            vm.newTest = true;
                        }
                    });
                }
            });
        }

        vm.MMSS_EditorTemplate = {
            create: function () {
                vm.elem = document.createElement('input');
                vm.elem.addEventListener('focus', function () {
                    this.select();
                });
                return vm.elem;
            },
            read: function () {
                return vm.maskObject.getMaskedValue();
            },
            destroy: function () {
                if (vm.maskObject != null) {
                    vm.maskObject.destroy();
                }
            },
            write: function (args) {
                vm.maskObject = new ej2.inputs.MaskedTextBox({
                    minWidth: '100%',
                    mask: '>00:00',
                    value: args.rowData[args.column.field],
                    readOnly: false,
                });
                vm.editedRowId = args.rowData['Id'];
                $compile(args.element[0])($scope);
                vm.maskObject.appendTo(vm.elem);
            }
        };

        vm.HHMMSS_EditorTemplate = {
            create: function () {
                vm.elem = document.createElement('input');
                vm.elem.addEventListener('focus', function () {
                    this.select();
                });
                return vm.elem;
            },
            read: function () {
                return vm.maskObject.getMaskedValue();
            },
            destroy: function () {
                if (vm.maskObject != null) {
                    vm.maskObject.destroy();
                }
            },
            write: function (args) {
                vm.maskObject = new ej2.inputs.MaskedTextBox({
                    minWidth: '100%',
                    mask: '>00:00:00',
                    value: args.rowData[args.column.field],
                    readOnly: false,
                });
                vm.editedRowId = args.rowData['Id'];
                $compile(args.element[0])($scope);
                vm.maskObject.appendTo(vm.elem);
            }
        };

        function CreateGrid2() {
            Grid2 = new ej2.grids.Grid({
                dataSource: vm.test,
                columns: vm.columns,
                allowPaging: false,
                allowSorting: false,
                allowTextWrap: false,
                allowExcelExport: false,
                editSettings: {
                    mode: 'Batch', showConfirmDialog: false, allowEditing: true, allowAdding: false, allowDeleting: false
                },
                locale: 'hu-HU',
                gridLines: 'Both',
                selectionSettings: {type: 'single', mode: 'Cell'},
                cellSelected: function (arg) {
                    vm.cellHint = gettextCatalog.getString('TheSelectedCellIs') + ' ' + vm.hints[arg.cellIndex.cellIndex - 2];
                    if (vm.dataFelmeroElem[arg.cellIndex.cellIndex - 2].ElvartEredmeny) {
                        vm.cellHint += '. ' + gettextCatalog.getString('ExpectedResult') + ': ' + vm.dataFelmeroElem[arg.cellIndex.cellIndex - 2].ElvartEredmeny;
                    }
                    console.log('vm.dataFelmeroElem', vm.dataFelmeroElem[arg.cellIndex.cellIndex - 2].ElvartEredmeny);
                    $scope.$apply();
                },
                queryCellInfo: function (arg) {
                    var cellIndex = -1;
                    if (arg.column.field) {
                        cellIndex = parseInt(arg.column.field.replace('c', ''));
                    }
                    var cell = angular.element(arg.cell);
                    if (vm.Highlight && arg.data.SportoloID == vm.Highlight && arg.column.field == 'SportoloNeve') {
                        cell.css('background-color', '#cdeecd');
                    } else if (vm.colors && vm.testdata && vm.testdata.length > 0 && cellIndex >= 0) {
                        var rowIndex = getRowIndex(arg.data.SportoloID);
                        if (vm.testdata[rowIndex].Colors[cellIndex] && vm.testdata[rowIndex].Colors[cellIndex].length > 0) {
                            cell.css('background-color', vm.testdata[rowIndex].Colors[cellIndex]);
                        }
                    }
                }
            });
            Grid2.appendTo('#Grid2');
        }

        function get1DArrayBelongsToUserInRow(row) {
            var retArray1D = [];
            var SportoloNeve = vm.test[row].SportoloNeve;
            var SportoloID = vm.test[row].SportoloID.toString();
            retArray1D.push(SportoloID);
            retArray1D.push(SportoloNeve);
            var strArr = [];
            for (var i = 0; i < vm.dataFelmeroElem.length; i++) {
                var fieldName = vm.dataFelmeroElem[i].fieldName;
                strArr.push(fieldName);
                retArray1D.push(vm.test[row][strArr[i]]);
                if (vm.test[row][strArr[i]] && vm.test[row][strArr[i]].length > 200) {
                    log.errorMsg(gettextCatalog.getString('Max200CharactersInFields'));
                    return false;
                }
            }
            return retArray1D;
        }

        function resetColumns() {
            vm.columns = [
                {field: 'SportoloID', headerText: 'Id', textAlign: 'left', isPrimaryKey: true, visible: false},
                {field: 'SportoloNeve', headerText: gettextCatalog.getString('AthleteName'), textAlign: 'left', width: 200, allowEditing: false}
            ];
        }

        function setColumns(FEF_ID, newTest, itemsList) {
            if (!FEF_ID) {
                return;
            }
            dataservice.getFelmeroElemList(FEF_ID).then(function (arg) {
                vm.dataFelmeroElem = arg.itemsList;
                for (var i = 0; i < vm.dataFelmeroElem.length; i++) {
                    switch (vm.dataFelmeroElem[i].Tipus){
                        case 1: vm.dataFelmeroElem[i].TipusStr = gettextCatalog.getString('NumberInteger'); break;
                        case 2: vm.dataFelmeroElem[i].TipusStr = gettextCatalog.getString('NumberFraction'); break;
                        case 3: vm.dataFelmeroElem[i].TipusStr = gettextCatalog.getString('Text'); break;
                        case 4: vm.dataFelmeroElem[i].TipusStr = gettextCatalog.getString('TimeHourMinuteSecHundredthOfASec'); break;
                        case 5: vm.dataFelmeroElem[i].TipusStr = gettextCatalog.getString('TimeMinuteSecHundredthOfASec'); break;
                        case 6: vm.dataFelmeroElem[i].TipusStr = gettextCatalog.getString('TimeSecHundredthOfASec'); break;
                        default: vm.dataFelmeroElem[i].TipusStr = 'x';
                    }
                    vm.hints.push(vm.dataFelmeroElem[i].TipusStr);
                }
                if (newTest) {
                    dataservice.FelmeroLetrehozasa(vm.coachId, vm.ageGroupId, parseInt(vm.felmeroElemFejIdValue), vm.dateValue).then(function(data) {
                        vm.test = data.itemsList;
                        Grid2.dataSource = vm.test;
                    }); //  dataservice.FelmeroLetrehozasa
                } else {
                    for (var i = 0; i < itemsList.length; i++) {
                        var line = {};
                        line.SportoloID = itemsList[i].SportoloID;
                        line.SportoloNeve = itemsList[i].SportoloNeve;
                        for (var c = 0; c < vm.dataFelmeroElem.length; c++) {
                            var fieldName = 'c' + c;
                            line[fieldName] = '';
                        }
                        vm.test.push(line);
                    }
                }
                var strArr = [];
                resetColumns();
                for (var i = 0; i < vm.dataFelmeroElem.length; i++) {
                    if (vm.dataFelmeroElem[i].ElvartEredmeny) {
                        vm.dataFelmeroElem[i].Nev += '<br>' + gettextCatalog.getString('ExpectedResult') + ': ' + vm.dataFelmeroElem[i].ElvartEredmeny;
                    }
                    var fieldName = vm.dataFelmeroElem[i].fieldName;
                    strArr.push(fieldName);
                    switch (vm.dataFelmeroElem[i].Tipus){
                        case 1:
                            vm.columns.push({field: vm.dataFelmeroElem[i].fieldName, headerText: vm.dataFelmeroElem[i].Nev, textAlign: 'center', width: 120, isEnabled: true, allowEditing: true});
                            break;
                        case 2:
                            vm.columns.push({field: vm.dataFelmeroElem[i].fieldName, headerText: vm.dataFelmeroElem[i].Nev, textAlign: 'center', width: 120, isEnabled: true, allowEditing: true});
                            break;
                        case 4:
                            vm.columns.push({field: vm.dataFelmeroElem[i].fieldName, headerText: vm.dataFelmeroElem[i].Nev, textAlign: 'center', width: 120, isEnabled: true, allowEditing: true, edit: vm.HHMMSS_EditorTemplate});
                            break;
                        case 5:
                            vm.columns.push({field: vm.dataFelmeroElem[i].fieldName, headerText: vm.dataFelmeroElem[i].Nev, textAlign: 'center', width: 120, isEnabled: true, allowEditing: true, edit: vm.MMSS_EditorTemplate});
                            break;
                        case 6:
                            vm.columns.push({field: vm.dataFelmeroElem[i].fieldName, headerText: vm.dataFelmeroElem[i].Nev, textAlign: 'center', width: 120, isEnabled: true, allowEditing: true});
                            break;
                        default: // 3: text
                            vm.columns.push({field: vm.dataFelmeroElem[i].fieldName, headerText: vm.dataFelmeroElem[i].Nev, textAlign: 'center', width: 400, isEnabled: true, allowEditing: true});
                    }
                    for (var j = 0; !newTest && j < vm.test.length; j++) {
                        vm.test[j][strArr[i]] = itemsList[j].Adatok1D[i];
                    }
                }
                Grid2.dataSource = vm.test;
                Grid2.columns = vm.columns;
                console.log('Grid2.columns', Grid2.columns);
                console.log('Grid2.dataSource', Grid2.dataSource);
                Grid2.refreshColumns();
                Grid2.refresh();
            }); // dataservice.getFelmeroElemList
        }

        function EditTestType() {
            var felmeroTipusIdx = angular.element('#felmeroTipusDropDown').data('ejDropDownList').selectedIndexValue;
            if (felmeroTipusIdx == -1) {
                swal({title: gettextCatalog.getString('ChooseTestTypeFirst'),
                    type: 'warning',
                    confirmButtonColor: '#DD6B55',
                    confirmButtonText: gettextCatalog.getString('Ok'),
                });
                return;
            }
            var felmeroTipus = vm.felmeroElemFejList[felmeroTipusIdx].value;
            paramHelper.setParams([
                {'sectionId': vm.sectionIdValue},
                {'FelmeroElemFej': felmeroTipus}
            ]);
            $state.go('settings.createSportSpecificTest');
        }

        function CreateTest() {
            var felmeroTipusIdx = angular.element('#felmeroTipusDropDown').data('ejDropDownList').selectedIndexValue;
            if (felmeroTipusIdx == -1) {
                swal({title: gettextCatalog.getString('ChooseTestTypeFirst'),
                    type: 'warning',
                    confirmButtonColor: '#DD6B55',
                    confirmButtonText: gettextCatalog.getString('Ok'),
                });
                return;
            }
            var felmeroTipus = vm.felmeroElemFejList[felmeroTipusIdx].value;
            setColumns(felmeroTipus, true, null);
        }

        function LoadTest(ffid) {
            vm.felmeroFejId = ffid;
            resetColumns();
            return dataservice.getFelmeroById(ffid).then(function(data) {
                vm.dateValue = data.date;
                vm.testdata = data.itemsList;
                //console.log('LoadTest'+ ffid + ' vm.testdata', vm.testdata);
                vm.felmeroElemFejIdValue = data.FEFID;
                vm.felmeroElemFejId = data.FEFID;
                setColumns(vm.felmeroElemFejIdValue, false, vm.testdata);
                vm.edzoertekeles = data.EdzoErtekeles;
            });
        }

        function SaveTest() {
            $scope.$broadcast('submitted');
            if ($scope.form.$valid === false) {
                log.errorMsg(gettextCatalog.getString('RequiredFieldsError'));
                return;
            }
            Grid2.endEdit();
            Grid2.editModule.endEdit();
            Grid2.editModule.batchSave();

            $timeout(function () {
                vm.createButtonEnabled = false;
                vm.testSaveTest = {};
                var felmeroTipusIdx = angular.element('#felmeroTipusDropDown').data('ejDropDownList').selectedIndexValue;
                vm.felmeroElemFejIdValue = vm.felmeroElemFejList[felmeroTipusIdx].value;
                vm.testSaveTest.FEF_ID = vm.felmeroElemFejIdValue;
                vm.testSaveTest.data = vm.test;

                var arr2D = [];
                for (var i = 0; i < vm.test.length; i++) {
                    var arr1D = get1DArrayBelongsToUserInRow(i);
                    if (arr1D === false) {
                        return false;
                    }
                    arr2D.push(arr1D);
                }
                return dataservice.FelmeroMentes(arr2D, vm.felmeroFejId, vm.felmeroElemFejIdValue, vm.sectionId, vm.ageGroupId, vm.coachId, vm.edzoertekeles, vm.dateValue).then(function(data) {
                    log.successMsg(gettextCatalog.getString('SaveCompleted'));
                    var lastSaveTestdFFID = data.data;
                    vm.test = [];
                    vm.dataFelmeroElem = [];
                    LoadTest(lastSaveTestdFFID);
                });
            }, 10);
        }

        function DeleteTest() {
            swal({title: gettextCatalog.getString('Are you sure you want to delete the selected test?'),
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: gettextCatalog.getString('Yes, delete this test'),
                cancelButtonText: gettextCatalog.getString('Cancel'),
            }).then(function(isConfirm) {
                if (isConfirm.value) {
                    dataservice.deleteFelmero(vm.felmeroFejId).
                        then(function () {
                            $state.go('administration.sportSpecificTest.newSportSpecificTestList');
                        });
                }
            });
        }

        function getFelmeroTipusok(sectionId) {
            return dataservice.felmeroElemFejDropDownList(sectionId).then(function(data) {
                vm.newTest = false;
                vm.felmeroElemFejList = data.itemsList;
            });
        }

        function getSections() {
            return dataservice.sectionDropDownList().then(function(data) {
                vm.sectionList = data.itemsList;
            });
        }

        function sectionDataBound() {
            if (vm.sectionList.length === 1) {
                vm.sectionId = vm.sectionList[0].value;
                angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.sectionList[0].value);
            } else {
                angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.sectionId);
            }
        }

        function getAgeGroups(sectionId) {
            return dataservice.ageGroupDropDownList(sectionId).then(function(data) {
                vm.ageGroupList = data.itemsList;
            });
        }

        function ageGroupDataBound() {
            if (vm.ageGroupList.length === 1) {
                angular.element('#ageGroupDropDown').ejDropDownList('selectItemByValue', vm.ageGroupList[0].value);
            } else {
                angular.element('#ageGroupDropDown').ejDropDownList('selectItemByValue', vm.ageGroupId);
            }
        }

        function getCoaches() {
            return dataservice.coachDropDownList(vm.sectionId, vm.ageGroupId, vm.dateValue).then(function(data) {
                vm.coachList = data.itemsList;
            });
        }

        function coachDataBound() {
            if (vm.coachList.length === 1) {
                angular.element('#coachDropDown').ejDropDownList('selectItemByValue', vm.coachList[0].value);
            } else {
                angular.element('#coachDropDown').ejDropDownList('selectItemByValue', vm.coachId);
            }
        }

        function felmeroDataBound() {
            if (vm.felmeroElemFejList.length === 1) {
                angular.element('#felmeroTipusDropDown').ejDropDownList('selectItemByValue', vm.felmeroElemFejList[0].value);
            } else {
                angular.element('#felmeroTipusDropDown').ejDropDownList('selectItemByValue', vm.felmeroElemFejId);
            }
        }

        function CreateTestType() {
            paramHelper.setParams([
                {'sectionId': vm.sectionIdValue},
                {'FelmeroElemFej': 0}
            ]);
            $state.go('settings.createSportSpecificTest');
        }

        function openAthlete(Id) {
            swal({
                title: gettextCatalog.getString('AreYouSureGo'),
                text: gettextCatalog.getString('AreYouSureYouWantToGoToAthlete'),
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: gettextCatalog.getString('GoToAthlete'),
                cancelButtonText: gettextCatalog.getString('Cancel')
            }).then(function (isConfirmed) {
                if (isConfirmed.value) {
                    paramHelper.setParams([
                        {'athleteModify.sportoloId': Id}
                    ]);
                    $state.go('athletes.athletesManagement.athleteModify.dataSheet');
                }
            });
        }

        function querycellinfo(arg) {
            var $element = angular.element(arg.cell);
            if (vm.Highlight && arg.data.SportoloID == vm.Highlight && arg.column.field == 'SportoloNeve') {
                $element.css('background-color', '#cdeecd');
            } else if (vm.colors && vm.testdata && vm.testdata.length > 0 && arg.cell.cellIndex >= 2) {
                var rowIndex = getRowIndex(arg.data.SportoloID);
                if (vm.testdata[rowIndex].Colors[arg.cell.cellIndex - 2] && vm.testdata[rowIndex].Colors[arg.cell.cellIndex - 2].length > 0) {
                    $element.css('background-color', vm.testdata[rowIndex].Colors[arg.cell.cellIndex - 2]);
                }
            }
        }

        function getRowIndex(SportoloID) {
            for (var i = 0; i < vm.testdata.length; i++) {
                if (vm.testdata[i].SportoloID == SportoloID) {
                    return i;
                }
            }
            return -1;
        }

        function colorCheckBoxChange(arg) {
            vm.colors = arg.value;
            vm.test = [];
            vm.testdata = [];
            LoadTest(vm.felmeroFejId);
        }
    }
})();


(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.administration.sportSpecificTest.newSportSpecificTest')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'administration.sportSpecificTest.newSportSpecificTest',
                config: {
                    url: '/newSportSpecificTest',
                    templateUrl: 'app/administration/sportSpecificTest/newSportSpecificTest/newSportSpecificTest.html',
                    controller: 'NewSportSpecificTestController',
                    controllerAs: 'vm'
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    NewSportSpecificTestListController.$inject = ["log", "dataservice", "authenticationService", "$q", "$state", "$scope", "$rootScope", "gettextCatalog", "paramHelper", "$filter", "$timeout"];
    angular
        .module('app.administration.sportSpecificTest.newSportSpecificTestList')
        .controller('NewSportSpecificTestListController', NewSportSpecificTestListController);

    function NewSportSpecificTestListController(log, dataservice, authenticationService, $q, $state, $scope, $rootScope, gettextCatalog, paramHelper, $filter, $timeout) {
        var vm = this; $rootScope.vm = vm;

        // Page title
        $rootScope.title = gettextCatalog.getString('NewSportSpecificTestList');

        vm.sectionList = [];
        vm.ageGroupList = [];
        vm.coachList = [];
        vm.sectionId = 0;
        vm.ageGroupId = 0;
        vm.coachId = 0;
        vm.felmeroFejId = 0;
        vm.Highlight = -1;
        vm.dateTo = new Date();
        vm.dateFrom = new Date(vm.dateTo.getFullYear() - 1, vm.dateTo.getMonth(), 1);

        vm.columns = [
            {
                field: 'Id',
                headerText: 'Id',
                textAlign: 'left',
                isPrimaryKey: true,
                visible: false
            },
            {
                field: 'Link',
                headerText: '',
                textAlign: 'center',
                allowEditing: false,
                template: '#sstlOpen',
                width: 60
            },
            {
                field: 'FelmeroNeve',
                headerText: gettextCatalog.getString('TestName'),
                textAlign: 'left',
                allowEditing: false,
                width: 150
            },
            {
                field: 'SzakosztalyNev',
                headerText: gettextCatalog.getString('SectionName'),
                textAlign: 'left',
                allowEditing: false,
                width: 150
            }, {
                field: 'EdzoNev',
                headerText: gettextCatalog.getString('CoachName'),
                textAlign: 'left',
                allowEditing: false,
                width: 150,
                template: '#sstlCoach'
            }, {
                field: 'KorcsoportNev',
                headerText: gettextCatalog.getString('AgeGroup'),
                textAlign: 'left',
                allowEditing: false,
                width: 150,
            }, {
                field: 'Edzoertekeles',
                headerText: gettextCatalog.getString('CoachRating'),
                textAlign: 'left',
                allowEditing: false,
            }, {
                field: 'Datum',
                headerText: gettextCatalog.getString('Datum'),
                textAlign: 'left',
                allowEditing: false,
                width: 150,
                template: '#sstlTest'
            }];

        var grid = new ej2.grids.Grid({
            dataSource: [],
            allowPaging: true,
            allowSorting: true,
            allowExcelExport: true,
            toolbar: $rootScope.toolbarItems,
            allowTextWrap: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#Grid'), $scope);
                }
            },
            beforePrint: $rootScope.beforePrintGrid,
            printComplete: $rootScope.printCompleteGrid
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };
        // Publikus funkciók
        vm.sectionDataBound = sectionDataBound;
        vm.sectionSelect = sectionSelect;
        vm.ageGroupDataBound = ageGroupDataBound;
        vm.ageGroupSelect = ageGroupSelect;
        vm.coachDataBound = coachDataBound;
        vm.coachSelect = coachSelect;
        vm.dateFromChange = dateFromChange;
        vm.dateToChange = dateToChange;
        vm.newTest = newTest;
        vm.goToTest = goToTest;
        vm.goToUser = goToUser;

        activate();

        function activate() {
            authenticationService.getRight('MEGTSPFELM').then(function (results) {
                if (results !== true) {
                    log.permissionError(true);
                } else {
                    $q.all([getSections(),
                        authenticationService.getRight('UJSPFELM'),
                        authenticationService.getRight('MODFELH'),
                        paramHelper.getParams([], [
                            'newSportSpecificTest.sectionId',
                            'newSportSpecificTest.ageGroupId',
                            'newSportSpecificTest.yearId',
                            'newSportSpecificTest.coachId',
                            'newSportSpecificTest.selectedSection'
                        ])
                    ]).then(function (results) {
                        vm.UJSPFELM = results[1];
                        vm.MODFELH = results[2];
                        vm.sectionId = results[3]['newSportSpecificTest.sectionId'];
                        vm.ageGroupId = results[3]['newSportSpecificTest.ageGroupId'];
                        vm.coachId = results[3]['newSportSpecificTest.coachId'];
                    });
                }
            });
        }

        function felmeroFejLista() {
            if (vm.ageGroupId === undefined || vm.ageGroupId === null) {
                vm.ageGroupId = 0;
            }
            if (vm.coachId === undefined || vm.coachId === null) {
                vm.coachId = 0;
            }
            if (vm.testId === undefined || vm.testId === null) {
                vm.testId = 0;
            }
            if (vm.sectionId == 0) {
                vm.Highlight = -1;
            }
            return dataservice.felmeroFejLista(vm.sectionId, vm.ageGroupId, vm.coachId, vm.testId, vm.Highlight, vm.dateFrom, vm.dateTo)
                .then(function (data) {
                    data.itemsList = $filter('dateStringFilter')(data.itemsList, 'Datum');
                    grid.dataSource = data.itemsList;
                });
        }

        function dateFromChange(arg) {
            vm.dateFrom = arg.value;
            felmeroFejLista();
        }

        function dateToChange(arg) {
            vm.dateTo = arg.value;
            felmeroFejLista();
        }

        function getSections() {
            return dataservice.sectionDropDownList().then(function (data) {
                vm.sectionList = data.itemsList;
                vm.sectionList.unshift({value: 0, text: gettextCatalog.getString('All')});
            });
        }

        function sectionDataBound() {
            if (vm.sectionList.length === 1) {
                vm.sectionId = vm.sectionList[0].value;
                angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.sectionList[0].value);
            } else {
                angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.sectionId);
            }
        }

        function sectionSelect(args) {
            vm.sectionId = args.value;
            vm.coachList = [];
            $timeout(function () {
                felmeroFejLista();
            }, 100);
            getAgeGroups();
            getActualCoachesList();
        }

        function getAgeGroups() {
            return dataservice.ageGroupDropDownList(vm.sectionId).then(function (data) {
                vm.ageGroupList = data.itemsList;
            });
        }

        function ageGroupDataBound() {
            if (vm.ageGroupList.length === 1) {
                angular.element('#ageGroupDropDown').ejDropDownList('selectItemByValue', vm.ageGroupList[0].value);
            } else {
                angular.element('#ageGroupDropDown').ejDropDownList('selectItemByValue', vm.ageGroupId);
            }
        }

        function ageGroupSelect(args) {
            vm.ageGroupId = args.value;
            vm.coachList = [];
            getActualCoachesList();
            felmeroFejLista();
        }

        // Section dropDownList function Get coach' list
        function getActualCoachesList() {
            return dataservice.coachDropDownList(vm.sectionId, vm.ageGroupId)
                .then(function (data) {
                    vm.coachList = data.itemsList;
                });
        }

        // Run after data bounded
        function coachDataBound() {
            if (vm.coachList.length === 1) {
                angular.element('#coachDropDown').ejDropDownList('selectItemByValue', vm.coachList[0].value);
            } else {
                angular.element('#coachDropDown').ejDropDownList('selectItemByValue', vm.coachId);
            }
        }

        // Run after age group selected
        function coachSelect(args) {
            vm.coachId = args.value;
            felmeroFejLista();
        }

        function newTest() {
            if (vm.sectionId == 0) {
                log.errorMsg(gettextCatalog.getString('SelectedSectionCannotBeAll'));
                return;
            }
            $scope.$broadcast('submitted');
            if ($scope.form.$valid === false) {
                log.errorMsg(gettextCatalog.getString('RequiredFieldsError'));
                return;
            }
            if (vm.UJSPFELM !== true) {
                log.permissionError();
            } else {
                paramHelper.setParams(
                    [
                        {'sportSpecificTest.sectionId': vm.sectionId},
                        {'newSportSpecificTest.sectionId': vm.sectionId},
                        {'sportSpecificTest.ageGroupId': vm.ageGroupId},
                        {'sportSpecificTest.coachId': vm.coachId},
                        {'sportSpecificTest.felmeroElemFejId': -1},
                        {'sportSpecificTest.felmeroFejId': -1},
                        {'sportSpecificTest.highlight': -1}
                    ]);
                $state.go('administration.sportSpecificTest.newSportSpecificTest');
            }
        }

        function goToTest(SzakosztalyId, KorcsoportId, EdzoId, FelmeroElemFejId, FelmeroFejId) {
            paramHelper.setParams(
                [
                    {'sportSpecificTest.sectionId': SzakosztalyId},
                    {'newSportSpecificTest.sectionId': SzakosztalyId},
                    {'sportSpecificTest.ageGroupId': KorcsoportId},
                    {'sportSpecificTest.coachId': EdzoId},
                    {'sportSpecificTest.felmeroElemFejId': FelmeroElemFejId},
                    {'sportSpecificTest.felmeroFejId': FelmeroFejId},
                    {'sportSpecificTest.highlight': vm.Highlight}
                ]);

            $state.go('administration.sportSpecificTest.newSportSpecificTest');
        }

        function goToUser(EdzoId) {
            if (!vm.MODFELH) {
                log.errorMsg(gettextCatalog.getString('YouHaveNoPermissionToThisFunction'));
                return;
            }
            paramHelper.setParams([{'newUser.userId': EdzoId}]);
            $state.go('settings.userManagement.modifyUser');
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.administration.sportSpecificTest.newSportSpecificTestList')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'administration.sportSpecificTest.newSportSpecificTestList',
                config: {
                    url: '/newSportSpecificTestList',
                    templateUrl: 'app/administration/sportSpecificTest/newSportSpecificTestList/newSportSpecificTestList.html',
                    controller: 'NewSportSpecificTestListController',
                    controllerAs: 'vm',
                    title: 'SportSpecificTestList2',
                    settings: {
                        navId: 242,
                        level: 2,
                        order: 4,
                        orderTitle_hu: 'Sportágspecifikus felmérők',
                        orderTitle_en: 'Sport Specific Tests',
                        parentId: 2,
                        content: 'NewSportSpecificTestList',
                        activatorPermission: '"MEGTSPFELM"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.administration.sportSpecificTest')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'administration.sportSpecificTest',
                config: {
                    url: '/sportSpecificTest',
                    templateUrl: 'app/administration/sportSpecificTest/sportSpecificTest.html'
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    NewTestController.$inject = ["log", "dataservice", "authenticationService", "$q", "$state", "$scope", "$rootScope", "gettextCatalog", "$filter", "paramHelper"];
    angular
        .module('app.administration.test.newTest')
        .controller('NewTestController', NewTestController);

    function NewTestController(log, dataservice, authenticationService, $q, $state, $scope, $rootScope, gettextCatalog, $filter, paramHelper) {
        var vm = this;
        $rootScope.vm = vm;

        // Page title
        $rootScope.title = gettextCatalog.getString('NewTest');

        vm.dataSource = [];
        vm.dateValue = vm.date = new Date();
        vm.getTestAthletesList = getTestAthletesList;

        // Grid's variables
        var columnsize = 40;
        vm.columns = [
            {field: 'FelmerokKozpontiID', headerText: 'Id', textAlign: 'left', isPrimaryKey: true, visible: false},
            {
                field: 'sportoloNeve', headerText: gettextCatalog.getString('AthleteName'),
                textAlign: 'left',
                allowEditing: false,
                width: 135,
                template: '#newtestcolumnTemplate1'
            },
            {
                field: 'szuletesiDatum',
                headerText: gettextCatalog.getString('BirthDate'),
                textAlign: 'center',
                allowEditing: false,
                width: 135
            },
            {
                field: 'szakosztalyNeve',
                headerText: gettextCatalog.getString('Section'),
                textAlign: 'left',
                allowEditing: false,
                width: 135
            },
            {
                field: 'megjelent',
                headerText: gettextCatalog.getString('Appeared'),
                textAlign: 'center',
                width: 135,
                type: 'boolean',
                editType: ej.Grid.EditingType.Boolean,
                displayAsCheckBox: true
            },
            {
                field: 'testmagassag',
                headerText: gettextCatalog.getString('Height'),
                textAlign: 'center',
                editType: 'numericedit',
                width: 135,
                edit: {params: {decimals: 2, min: 0}},
            },
            {
                field: 'testsuly',
                headerText: gettextCatalog.getString('Weight'),
                textAlign: 'center',
                editType: 'numericedit',
                width: 135,
                edit: {params: {decimals: 2, min: 0}},
            },
            {
                field: 'sulypontEmelkedes1',
                headerText: gettextCatalog.getString('VerticalJump') + ' 1',
                textAlign: 'center',
                width: 135,
                editType: 'numericedit',
                edit: {params: {decimals: 2, min: 0}},
            },
            {
                field: 'sulypontEmelkedes2',
                headerText: gettextCatalog.getString('VerticalJump') + ' 2',
                textAlign: 'center',
                width: 135,
                editType: 'numericedit',
                edit: {params: {decimals: 2, min: 0}},
            },
            {
                field: 'sulypontEmelkedes3',
                headerText: gettextCatalog.getString('VerticalJump') + ' 3',
                textAlign: 'center',
                width: 135,
                editType: 'numericedit',
                edit: {params: {decimals: 2, min: 0}},
            },
            {
                field: 'sulypontEmelkedesLegjobb',
                headerText: gettextCatalog.getString('Best') + ' ' + gettextCatalog.getString('VerticalJump'),
                textAlign: 'center',
                allowEditing: false,
                width: 135,
                template: '#maxSelect'
            },
            {
                field: 'f30mSprint1',
                headerText: gettextCatalog.getString('30mSprint') + ' 1',
                textAlign: 'center',
                width: 135,
                editType: 'numericedit',
                edit: {params: {decimals: 2, min: 0}},
            },
            {
                field: 'f30mSprint2',
                headerText: gettextCatalog.getString('30mSprint') + ' 2',
                textAlign: 'center',
                width: 135,
                editType: 'numericedit',
                edit: {params: {decimals: 2, min: 0}},
            },
            {
                field: 'f30mSprint3',
                headerText: gettextCatalog.getString('30mSprint') + ' 3',
                textAlign: 'center',
                width: 135,
                editType: 'numericedit',
                edit: {params: {decimals: 2, min: 0}},
            },
            {
                field: 'f30mSprintLegjobb',
                headerText: gettextCatalog.getString('Best') + ' ' + gettextCatalog.getString('30mSprint'),
                textAlign: 'center',
                allowEditing: false,
                width: 135,
                template: '#minSelect'
            },
            {
                field: 'meterPerMeter',
                headerText: gettextCatalog.getString('2800mRunning'),
                textAlign: 'center',
                editTemplate: {
                    create: function () {
                        return '<input>';
                    },
                    read: function (args) {
                        return args.ejTimePicker()[0].value;
                    },
                    write: function (args) {
                        args.element.ejTimePicker({
                            width: '100%',
                            timeFormat: 'HH:mm:ss',
                            interval: 1,
                            enableStrictMode: false
                        });
                    }
                },
                width: 120
            },
            {field: 'megjegyzes', headerText: gettextCatalog.getString('Comment'), textAlign: 'left', width: 130}
        ];

        // Publikus funkciók
        vm.saveGrid = saveGrid;
        vm.goToAthlete = goToAthlete;

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItems,
            editSettings: {allowEditing: true, mode: 'Batch', showConfirmDialog: false},
            allowPaging: true,
            allowTextWrap: true,
            allowSorting: true,
            allowExcelExport: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#Grid'), $scope);
                }
            },
            cellEdit: cellEdit,
            cellSave: cellSave
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        activate();

        function activate() {
            authenticationService.getRight('MEGTKPFELM').then(function (results) {
                if (results !== true) {
                    log.permissionError(true);
                } else {
                    $q.all([getTestAthletesList()]).then(function () {
                    });
                }
            });
        }

        function getTestAthletesList() {
            dataservice.getTestAthletesList(vm.dateValue).then(function (data) {
                vm.dataSource = $filter('dateStringFilter')(data.itemsList, 'szuletesiDatum');
                grid.dataSource = vm.dataSource;
            });
        }

        function saveGrid() {
            grid.editModule.batchSave();
            return dataservice.saveTest(vm.dataSource, vm.dateValue).then(function () {
                log.successMsg('TestResultsSaved');
                //$state.go('administration.test.testList');
            });
        }

        function goToAthlete(id) {
            $q.all([authenticationService.getRight('MEGTSPORTLIST'), authenticationService.getRight('MEGTSPORTLIST')]).then(function (results) {
                if (results[0] || results[1]) {
                    paramHelper.setParams([{'athleteModify.sportoloId': id}]);
                    $state.go('athletes.athletesManagement.athleteModify.dataSheet');
                } else {
                    log.permissionError();
                }
            });
        }

        function cellSave(args) {
            new ej2.data.DataManager(vm.dataSource).executeQuery(new ej2.data.Query().where('FelmerokKozpontiID', 'equal', args.rowData.FelmerokKozpontiID)).then(function (result) {
                result.result[0][args.columnName] = args.value;
                grid.refresh();
            });
        }

        function cellEdit(args) {
            if (args.columnName === 'megjelent') {
                var index = grid.dataSource.findIndex(function (item) {
                    return item.sportoloId === args.rowData.sportoloId;
                });
                grid.dataSource[index]['megjelent'] = !grid.dataSource[index]['megjelent'];
                grid.endEdit();
                args.cancel = true;
            }
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.administration.test.newTest')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'administration.test.newTest',
                config: {
                    url: '/newTest',
                    templateUrl: 'app/administration/test/newTest/newTest.html',
                    controller: 'NewTestController',
                    controllerAs: 'vm'
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.administration.test')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'administration.test',
                config: {
                    url: '/test',
                    templateUrl: 'app/administration/test/test.html'
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    TestListController.$inject = ["log", "dataservice", "authenticationService", "$q", "$state", "$scope", "$rootScope", "gettextCatalog", "paramHelper"];
    angular
        .module('app.administration.test.testList')
        .controller('TestListController', TestListController);

    function TestListController(log, dataservice, authenticationService, $q, $state, $scope, $rootScope, gettextCatalog, paramHelper) {
        var vm = this; $rootScope.vm = vm;

        // Page title
        $rootScope.title = gettextCatalog.getString('TestList');

        vm.testDates = [];
        vm.testDateValue = 0;

        // Publikus funkciók
        vm.testDatesDataBound = testDatesDataBound;
        vm.testDatesSelect = testDatesSelect;
        vm.newTest = newTest;
        vm.getTest = getTest;

        activate();

        function activate() {
            authenticationService.getRight('MEGTKPFELM').then(function (results) {
                if (results !== true) {
                    log.permissionError(true);
                } else {
                    $q.all([authenticationService.getRight('MODKPFELM'),
                            authenticationService.getRight('UJKPFELM'),
                            authenticationService.getRight('MEGTKPFELM'),
                            paramHelper.getParams([], ['test.testId']), getTestYears()]).then(function(results) {
                        vm.MODKPFELM = results[0];
                        vm.UJKPFELM = results[1];
                        vm.MEGTKPFELM = results[2];
                        vm.testDateValue = results[3]['test.testId'];
                    });
                }
            });
        }

        function getTestYears() {
            dataservice.getTestYears().then(function(data) {
                vm.testDates = data.itemsList;
            });
        }

        // Run after data bounded
        function testDatesDataBound() {
            if (vm.testDates.length === 1) {
                vm.testDateValue = vm.testDates[0].value;
                angular.element('#testDates').ejDropDownList('selectItemByValue', vm.testDates[0].value);
            } else {
                angular.element('#testDates').ejDropDownList('selectItemByValue', vm.testDateValue);
            }
        }

        // Run after section selected
        function testDatesSelect(args) {
            vm.testDateValue = args.value;
        }

        function newTest() {
            if (vm.UJKPFELM !== true) {
                log.permissionError();
            } else {
                // dataservice.canNewTestAthletesList(new Date().toLocaleDateString()).then(function(data) {
                //     if (data.retValue === true) {
                //         $state.go('administration.test.newTest');
                //     }
                // });
                $state.go('administration.test.newTest');
            }
        }

        function getTest() {
            if (vm.MODKPFELM !== true && vm.MEGTKPFELM !== true) {
                log.permissionError();
            } else {
                // a syncfusion direktívák miatt
                $scope.$broadcast('submitted');
                if ($scope.form.$valid === false) {
                    log.errorMsg(gettextCatalog.getString('RequiredFieldsError'));
                } else {
                    paramHelper.setParams([{'test.testId': vm.testDateValue}]);
                    $state.go('administration.test.testResults');
                }
            }
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.administration.test.testList')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'administration.test.testList',
                config: {
                    url: '/testList',
                    templateUrl: 'app/administration/test/testList/testList.html',
                    controller: 'TestListController',
                    controllerAs: 'vm',
                    title: 'TestList',
                    settings: {
                        navId: 232,
                        level: 2,
                        order: 3,
                        orderTitle_hu: 'Központi felmérők',
                        orderTitle_en: 'Center Tests',
                        parentId: 2,
                        content: 'TestList',
                        activatorPermission: '"MEGTKPFELM"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    TestResultsController.$inject = ["log", "dataservice", "authenticationService", "$q", "$state", "$scope", "$rootScope", "gettextCatalog", "paramHelper", "$filter"];
    angular
        .module('app.administration.test.testResults')
        .controller('TestResultsController', TestResultsController);

    function TestResultsController(log, dataservice, authenticationService, $q, $state, $scope, $rootScope, gettextCatalog, paramHelper, $filter) {
        var vm = this;
        $rootScope.vm = vm;

        // Page title
        $rootScope.title = gettextCatalog.getString('TestResults');

        vm.dataSource = [];
        vm.dateValue = new Date();
        vm.enabledDatepicker = false;

        // Grid's variables
        vm.columns = [
            {field: 'FelmerokKozpontiID', headerText: 'Id', textAlign: 'left', isPrimaryKey: true, visible: false},
            {
                field: 'sportoloNeve', headerText: gettextCatalog.getString('AthleteName'),
                textAlign: 'left',
                allowEditing: false,
                width: 135,
                template: '#testresultscolumnTemplate1'
            },
            {
                field: 'szuletesiDatum',
                headerText: gettextCatalog.getString('BirthDate'),
                textAlign: 'center',
                allowEditing: false,
                width: 135
            },
            {
                field: 'szakosztalyNeve',
                headerText: gettextCatalog.getString('Section'),
                textAlign: 'left',
                allowEditing: false,
                width: 135
            },
            {
                field: 'megjelent',
                headerText: gettextCatalog.getString('Appeared'),
                textAlign: 'center',
                width: 135,
                type: 'boolean',
                editType: ej.Grid.EditingType.Boolean,
                displayAsCheckBox: true
            },
            {
                field: 'testmagassag',
                headerText: gettextCatalog.getString('Height'),
                textAlign: 'center',
                editType: 'numericedit',
                width: 135,
                edit: {params: {decimals: 2, min: 0}},
            },
            {
                field: 'testsuly',
                headerText: gettextCatalog.getString('Weight'),
                textAlign: 'center',
                editType: 'numericedit',
                width: 135,
                edit: {params: {decimals: 2, min: 0}},
            },
            {
                field: 'sulypontEmelkedes1',
                headerText: gettextCatalog.getString('VerticalJump') + ' 1',
                textAlign: 'center',
                width: 135,
                editType: 'numericedit',
                edit: {params: {decimals: 2, min: 0}},
            },
            {
                field: 'sulypontEmelkedes2',
                headerText: gettextCatalog.getString('VerticalJump') + ' 2',
                textAlign: 'center',
                width: 135,
                editType: 'numericedit',
                edit: {params: {decimals: 2, min: 0}},
            },
            {
                field: 'sulypontEmelkedes3',
                headerText: gettextCatalog.getString('VerticalJump') + ' 3',
                textAlign: 'center',
                width: 135,
                editType: 'numericedit',
                edit: {params: {decimals: 2, min: 0}},
            },
            {
                field: 'sulypontEmelkedesLegjobb',
                headerText: gettextCatalog.getString('Best') + ' ' + gettextCatalog.getString('VerticalJump'),
                textAlign: 'center',
                allowEditing: false,
                width: 135,
                template: '#maxSelect'
            },
            {
                field: 'f30mSprint1',
                headerText: gettextCatalog.getString('30mSprint') + ' 1',
                textAlign: 'center',
                width: 135,
                editType: 'numericedit',
                edit: {params: {decimals: 2, min: 0}},
            },
            {
                field: 'f30mSprint2',
                headerText: gettextCatalog.getString('30mSprint') + ' 2',
                textAlign: 'center',
                width: 135,
                editType: 'numericedit',
                edit: {params: {decimals: 2, min: 0}},
            },
            {
                field: 'f30mSprint3',
                headerText: gettextCatalog.getString('30mSprint') + ' 3',
                textAlign: 'center',
                width: 135,
                editType: 'numericedit',
                edit: {params: {decimals: 2, min: 0}},
            },
            {
                field: 'f30mSprintLegjobb',
                headerText: gettextCatalog.getString('Best') + ' ' + gettextCatalog.getString('30mSprint'),
                textAlign: 'center',
                allowEditing: false,
                width: 135,
                template: '#minSelect'
            },
            {
                field: 'meterPerMeter',
                headerText: gettextCatalog.getString('2800mRunning'),
                textAlign: 'center',
                editTemplate: {
                    create: function () {
                        return '<input>';
                    },
                    read: function (args) {
                        return args.ejTimePicker()[0].value;
                    },
                    write: function (args) {
                        args.element.ejTimePicker({
                            width: '100%',
                            timeFormat: 'HH:mm:ss',
                            interval: 1,
                            enableStrictMode: false
                        });
                    }
                },
                width: 120
            },
            {field: 'megjegyzes', headerText: gettextCatalog.getString('Comment'), textAlign: 'left', width: 130}
        ];

        var grid = new ej2.grids.Grid({
            dataSource: [],
            allowPaging: true,
            allowSorting: true,
            allowTextWrap: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            editSettings: {allowEditing: true, mode: 'Batch', showConfirmDialog: false},
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile(grid, $scope);
                }
            },
            cellEdit: cellEdit,
            cellSave: cellSave
        });
        grid.appendTo('#Grid');

        vm.lastEditedRow = 0;

        // Publikus funkciók
        vm.calculateBests = calculateBests;
        vm.saveGrid = saveGrid;
        vm.actionBegin = actionBegin;
        vm.goToAthlete = goToAthlete;

        activate();

        function activate() {
            $q.all([authenticationService.getRight('MODKPFELM'),
                paramHelper.getParams([], ['test.testId'])]).then(function (results) {
                vm.MODKPFELM = results[0];
                vm.testId = results[1]['test.testId'];
                getTest(vm.testId);
            });
        }

        function actionBegin(args) {
            if (args.requestType && (args.requestType === 'paging' || args.requestType === 'sorting')) {
                args.cancel = true;
                grid.editModule.batchSave();
            }
        }

        function getTest(datum) {
            dataservice.getTest(datum).then(function (data) {
                vm.dataSource = $filter('dateStringFilter')(data.itemsList, 'szuletesiDatum');
                grid.dataSource = vm.dataSource;
            });
        }

        function calculateBests() {
            grid.editModule.batchSave();
        }

        function saveGrid() {
            if (!vm.MODKPFELM) {
                log.permissionError();
            }
            grid.editModule.batchSave();
            return dataservice.modifyTest(grid.dataSource).then(function () {
                log.successMsg('TestResultsSaved');
            });
        }

        function goToAthlete(id) {
            $q.all([authenticationService.getRight('MEGTSPORTLIST'), authenticationService.getRight('MEGTSPORTLIST')]).then(function (results) {
                if (results[0] || results[1]) {
                    paramHelper.setParams([{'athleteModify.sportoloId': id}]);
                    $state.go('athletes.athletesManagement.athleteModify.dataSheet');
                } else {
                    log.permissionError();
                }
            });
        }

        function cellSave(args) {
            new ej2.data.DataManager(vm.dataSource).executeQuery(new ej2.data.Query().where('FelmerokKozpontiID', 'equal', args.rowData.FelmerokKozpontiID)).then(function (result) {
                result.result[0][args.columnName] = args.value;
                grid.refresh();
            });
        }

        function cellEdit(args) {
            if (args.columnName === 'megjelent') {
                var index = grid.dataSource.findIndex(function (item) {
                    return item.sportoloId === args.rowData.sportoloId;
                });
                grid.dataSource[index]['megjelent'] = !grid.dataSource[index]['megjelent'];
                grid.endEdit();
                args.cancel = true;
            }
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.administration.test.testResults')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'administration.test.testResults',
                config: {
                    url: '/testResults',
                    templateUrl: 'app/administration/test/testResults/testResults.html',
                    controller: 'TestResultsController',
                    controllerAs: 'vm',
                    title: 'TestList'
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    TrainingDiaryController.$inject = ["log", "logger", "DOMAIN", "paramHelper", "$state", "dataservice", "$q", "$rootScope", "gettextCatalog", "authenticationService", "$filter", "$scope", "$timeout"];
    angular
        .module('app.administration.trainingDiary')
        .controller('TrainingDiaryController', TrainingDiaryController);

    function TrainingDiaryController(log, logger, DOMAIN, paramHelper, $state, dataservice, $q, $rootScope, gettextCatalog, authenticationService, $filter, $scope, $timeout) {
        var vm = this;
        $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('trainingDiary');
        vm.coachList = [];
        vm.sectionList = [];
        vm.ageGroupList = [];
        vm.years = [];
        vm.month = [];
        vm.selectedCoach = undefined;
        vm.selectedSection = undefined;
        vm.selectedAgeGroup = undefined;
        vm.yearValue = undefined;
        vm.monthValue = undefined;
        vm.Save = Save;
        vm.addRow = addRow;
        vm.removeRow = removeRow;
        vm.data = [];
        vm.HaviJelenletiFejId = undefined;
        vm.lezart = false;
        vm.addEnabled = false;
        vm.removeEnabled = false;
        vm.selectedRow = selectedRow;
        vm.selectedId = undefined;
        vm.newId = -1;
        vm.querycellinfo = querycellinfo;
        vm.beginEdit = beginEdit;
        vm.print = print;
        vm.keszult = new Date();
        var printOpened = false;

        vm.columns = [
            {field: 'Id', visible: false, isPrimaryKey: true, isIdentity: true},
            {field: 'AktivNap', visible: false, headerText: 'AktivNap', textAlign: 'left', width: 150, allowEditing: false},
            {field: 'Nap', headerText: gettextCatalog.getString('Day'), textAlign: 'left', width: 150, allowEditing: false},
            {field: 'EdzesIdopontja', headerText: gettextCatalog.getString('TrainingTime'), textAlign: 'left', width: 120, allowEditing: true},
            {field: 'TevekenysegHelye', headerText: gettextCatalog.getString('TrainingLocation'), textAlign: 'left', width: 120, allowEditing: true},
            {field: 'EdzesmunkaLeirasa', headerText: gettextCatalog.getString('TrainingDescription'), textAlign: 'left', width: 120, allowEditing: true}
        ];

        vm.months = [
            {text: gettextCatalog.getString('January'), value: 0},
            {text: gettextCatalog.getString('February'), value: 1},
            {text: gettextCatalog.getString('March'), value: 2},
            {text: gettextCatalog.getString('April'), value: 3},
            {text: gettextCatalog.getString('May'), value: 4},
            {text: gettextCatalog.getString('June'), value: 5},
            {text: gettextCatalog.getString('July'), value: 6},
            {text: gettextCatalog.getString('August'), value: 7},
            {text: gettextCatalog.getString('September'), value: 8},
            {text: gettextCatalog.getString('October'), value: 9},
            {text: gettextCatalog.getString('November'), value: 10},
            {text: gettextCatalog.getString('December'), value: 11}
        ];

        var grid = new ej2.grids.Grid({
            dataSource: [],
            editSettings: {allowEditing: true, editMode: 'Batch', showConfirmDialog: false},
            allowTextWrap: true,
            allowSorting: true,
            allowScrolling: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            rowSelected: vm.selectedRow,
            columns: vm.columns,
            querycellinfo: vm.querycellinfo,
            cellEdit: vm.beginEdit,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile(angular.element('#Grid'), $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        activate();

        function activate() {
            var promises = [authenticationService.getRight('HJFELVIHET'), paramHelper.getParams([], ['HaviJelenletiFejId'])];
            $q.all(promises).then(function (results) {
                if (!results[0]) {
                    log.permissionError(true);
                } else if (results[1].HaviJelenletiFejId) {
                    vm.HaviJelenletiFejId = results[1].HaviJelenletiFejId;
                    loadTrainingDiary(results[1].HaviJelenletiFejId);
                }
            });
        }

        function print() {
            vm.reportParameters = {
                FejId: vm.HaviJelenletiFejId,
                'EdzoNeve': angular.element('#edzo').data('ejDropDownList').getSelectedItem()[0].innerText,
                'keszult': vm.keszult
            };
            //     Name : 'name',
            //     TajSzam : 'TajSzam',
            //     SzuletesiIdo : '2012-01-01',
            //     SportoloId : 3422,
            //     Type : 'Type',
            //     Fenykeput : 'Fenykeput'
            // };

            $scope.$apply();

            if (printOpened) {
                angular.element('#printDialog').ejDialog('open');
            } else {
                printOpened = true;
                angular.element('#printDialog').ejDialog({height: '99%', width: '99%', enablemodal: 'true', 'position-x': '0', 'position-y': '0', target: '#mainContent', enableresize: 'false'});
            }
        }

        function querycellinfo(args) {
            var $element = angular.element(args.cell);
            if (!args.data.AktivNap) {
                $element.css('background-color', '#efdcdc');
            }
        }

        function beginEdit(arg) {
            if (!arg.rowData.AktivNap) {
                arg.cancel = true;
            }
        }

        function loadTrainingDiary(HaviJelenletiFejId) {
            dataservice.loadTrainingDiaryByMonthlyAttendanceId(HaviJelenletiFejId).then(function (data) {
                vm.sectionList.push({text: data.szakosztaly, value: data.szakosztalyid});
                vm.ageGroupList.push({text: data.korcsoport, value: data.korcsoportid});
                vm.coachList.push({text: data.edzo, value: data.edzoid});
                vm.selectedCoach = data.edzoid;
                vm.selectedSection = data.szakosztalyid;
                if (data.keszult) {
                    vm.keszult = data.keszult;
                }
                var datum = new Date(data.datum);
                var year = (datum).getFullYear();
                var month = (datum).getMonth();
                vm.yearValue = year;
                vm.monthValue = month;
                vm.years.push({text: year, value: year});
                if (data.lezartJelenleti) {
                    vm.lezart = true;
                    grid.editSettings.allowEditing = false;
                    grid.allowSelection = false;
                }
                vm.data = data.edzesmunka;
                vm.data = $filter('dateStringFilter')(vm.data, 'Nap');
                grid.dataSource = vm.data;
                $timeout(function () {
                    vm.selectedAgeGroup = data.korcsoportid;
                    angular.element('#ev').ejDropDownList('selectItemByValue', vm.years[0].value);
                    angular.element('#edzo').ejDropDownList('selectItemByValue', vm.coachList[0].value);
                    angular.element('#szakosztaly').ejDropDownList('selectItemByValue', vm.sectionList[0].value);
                    if (data.korcsoportid > 0) {
                        angular.element('#korosztaly').ejDropDownList('selectItemByValue', vm.ageGroupList[0].value);
                    }
                    $scope.$apply();
                }, 10);
            });
        }

        function getIndex(id) {
            for (var i = 0; i < vm.data.length; i++) {
                if (vm.data[i].Id == id) {
                    return i;
                }
            }
            return null;
        }

        function addRow() {
            grid.endEdit();
            var idx = getIndex(vm.selectedId);
            var newLine = {};
            newLine.Id = vm.newId--;
            newLine.AktivNap = vm.data[idx].AktivNap;
            newLine.Nap = vm.data[idx].Nap;
            newLine.EdzesIdopontja = '';
            newLine.TevekenysegHelye = '';
            newLine.EdzesmunkaLeirasa = '';
            vm.data.splice(idx + 1, 0, newLine);
            vm.addEnabled = false;
            vm.removeEnabled = false;
            grid.refresh();
        }

        function removeRow() {
            vm.addEnabled = false;
            vm.removeEnabled = false;
            var idx = getIndex(vm.selectedId);
            var entries = entriesForThisDay(idx);
            if (entries > 1) {
                vm.data.splice(idx, 1);
                $scope.$apply();
            }
            grid.dataSource = vm.data;
            grid.refresh();
        }

        function entriesForThisDay(index) {
            var datum = vm.data[index].Nap;
            var counter = 0;
            for (var i = 0; i < vm.data.length; i++) {
                if (vm.data[i].Nap === datum) {
                    counter++;
                }
            }
            return counter;
        }

        function selectedRow(arg) {
            vm.addEnabled = true;
            vm.selectedId = arg.data.Id;
            var idx = getIndex(arg.data.Id);
            var entries = entriesForThisDay(idx);
            vm.removeEnabled = entries > 1;
            $scope.$apply();
        }

        function Save() {
            grid.endEdit();
            dataservice.saveTrainingDiary(vm.data, vm.HaviJelenletiFejId, vm.keszult).then(function (response) {
                log.successMsg('SavedSuccessful');
                loadTrainingDiary(response.data);
            });
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.administration.trainingDiary')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'administration.trainingDiary',
                config: {
                    url: '/trainingDiary',
                    templateUrl: 'app/administration/trainingDiary/trainingDiary.html',
                    controller: 'TrainingDiaryController',
                    controllerAs: 'vm',
                    title: 'trainingDiary'
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.administration.trainingPlan')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'administration.trainingPlan',
                config: {
                    url: '/trainingPlan',
                    templateUrl: 'app/administration/trainingPlan/trainingPlan.html'
                }
            }
        ];
    }
})();

(function () {
        'use strict';

        TrainingPlanCreateController.$inject = ["log", "paramHelper", "dataservice", "DOMAIN", "$filter", "$scope", "$state", "$q", "$rootScope", "gettextCatalog", "authenticationService", "$timeout"];
        angular
            .module('app.administration.trainingPlan.trainingPlanCreate')
            .controller('TrainingPlanCreateController', TrainingPlanCreateController);

        function TrainingPlanCreateController(log, paramHelper, dataservice, DOMAIN, $filter, $scope, $state, $q, $rootScope, gettextCatalog, authenticationService, $timeout) {
            var vm = this;
            $rootScope.vm = vm;
            $rootScope.title = gettextCatalog.getString('TrainingPlanCreate');

            // main datas
            vm.sorIndex = 0; // a gyakorlatok torléséhez kell egy elsödlegeskulcs sorIndex)
            vm.params = null;
            vm.loadPlan = false;
            vm.saveParams = null;
            vm.trainingSectionId = 0;
            vm.trainingSectionList = [];
            vm.trainingName = null;
            vm.trainingDescription = null;
            vm.trainingAgeGroupId = 0;
            vm.trainingAgeGroupList = [];
            vm.gridDataSourceTraining = [];
            vm.imageRoot = DOMAIN.baseURL + DOMAIN.exerciseBaseUrl;
            vm.addNewPermission = false;
            vm.timeLength = 0;

            // filter
            vm.autoComplete = [];
            vm.sectionId = 0;
            vm.sectionList = [];
            vm.ageGroupId = 0;
            vm.ageGroupList = [];
            vm.coachId = 0;
            vm.coachList = [];

            // grid
            vm.selectedRow = [];
            vm.EDZO = false;

            // autoComplete empty string ''
            vm.bodyPartValue = '';
            vm.TypeValue = '';
            vm.individualTeamValue = '';
            vm.AssetValue = '';
            vm.difficultyValue = '';
            vm.necessaryAreaValue = '';
            vm.withVideo = false;
            vm.withPattern = false;
            vm.withPaint = false;

            // button
            vm.addEnabled = false;
            vm.modify = false;
            vm.allowSave = false;

            function sumIdo(args) {
                var res = 0;
                args.result.forEach(function (element) {
                    if (element.Ido) {
                        res += element.Ido * element.IsmSzam;
                    }
                });
                vm.timeLength = res;
                return res;
            }

            vm.summaryRows = [{
                columns: [
                    {
                        type: 'Custom',
                        customAggregate: sumIdo,
                        columnName: 'Ido',
                        footerTemplate: gettextCatalog.getString('Sum') + ': ${Custom}'
                    }
                ]
            }];
            vm.columnsMain = [
                {type: 'checkbox', headerText: '', textAlign: 'center', width: 55},
                {field: 'SorIndex', isPrimaryKey: true, visible: false},
                {field: 'EdzesFejId', visible: false},
                {field: 'GyakorlatId', visible: false},
                {
                    field: 'Nev',
                    headerText: gettextCatalog.getString('Name'),
                    width: 200,
                    textAlign: 'center',
                    template: '#wtpropentemp'
                },
                {field: 'Ido', headerText: gettextCatalog.getString('TimeLength'), width: 150, textAlign: 'center'},
                {
                    field: 'Mintakep',
                    headerText: gettextCatalog.getString('Pattern'),
                    width: 180,
                    textAlign: 'center',
                    template: '#imagetemplateGrid'
                },
                {
                    field: 'Video',
                    headerText: gettextCatalog.getString('Video'),
                    width: 115,
                    type: 'boolean',
                    displayAsCheckBox: true,
                    textAlign: 'center'
                },
                {
                    field: 'GyakorlatKategoria',
                    headerText: gettextCatalog.getString('GyakorlatKategoria'),
                    width: 150,
                    textAlign: 'center'
                },
                {field: 'IsmSzam', headerText: gettextCatalog.getString('IsmSzam'), width: 150, textAlign: 'center'},
                {
                    field: 'GyakorlatTipus',
                    headerText: gettextCatalog.getString('GyakorlatTipus'),
                    width: 150,
                    textAlign: 'center'
                },
                {
                    field: 'Jellege',
                    headerText: gettextCatalog.getString('individualTeam'),
                    width: 150,
                    textAlign: 'center'
                },
                {field: 'Testresz', headerText: gettextCatalog.getString('BodyParts'), width: 150, textAlign: 'center'},
            ];

            var MainGrid = new ej2.grids.Grid({
                dataSource: [],
                toolbar: $rootScope.toolbarItemsWithSearchAndDelete,
                allowPaging: true,
                allowSorting: true,
                allowExcelExport: true,
                locale: 'hu-HU',
                gridLines: 'Both',
                aggregates: vm.summaryRows,
                pageSettings: $rootScope.pageSettings,
                columns: vm.columnsMain,
                rowDataBound: function (args) {
                    $rootScope.compile(args.row, $scope);
                },
                actionComplete: function (args) {
                    if (args.requestType === 'paging' || args.requestType === 'refresh') {
                        $rootScope.compile($('#MainGrid'), $scope);
                    }
                },
                actionBegin: function (args) {
                    if (args.requestType === 'delete') {
                        MainGrid.dataSource = $rootScope.deleteRows(MainGrid);
                        args.cancel = true;
                    }
                }
            });
            MainGrid.appendTo('#MainGrid');
            MainGrid.toolbarClick = function (args) {
                $rootScope.toolbarClick(args, MainGrid);
            };

            vm.trainingColumns = [
                {type: 'checkbox', headerText: '', textAlign: 'center', width: 55},
                {field: 'GyakorlatId', isPrimaryKey: true, visible: false},
                {
                    field: 'Nev',
                    headerText: gettextCatalog.getString('Name'),
                    width: 150,
                    textAlign: 'center',
                    template: '#wtpropentemp'
                },
                {
                    field: 'Mintakep',
                    headerText: gettextCatalog.getString('Pattern'),
                    width: 180,
                    textAlign: 'center',
                    template: '#imagetemplateGrid'
                },
                {
                    field: 'Video',
                    headerText: gettextCatalog.getString('Video'),
                    width: 115,
                    type: 'boolean',
                    displayAsCheckBox: true,
                    textAlign: 'center'
                },
                {
                    field: 'Szakosztaly',
                    headerText: gettextCatalog.getString('Section'),
                    width: 150,
                    textAlign: 'center'
                },
                {field: 'SzakosztalyId', visible: false},
                {
                    field: 'Korosztaly',
                    headerText: gettextCatalog.getString('AgeGroup'),
                    width: 150,
                    textAlign: 'center'
                },
                {field: 'KorosztalyId', visible: false},
                {field: 'Edzo', headerText: gettextCatalog.getString('Coach'), width: 150, textAlign: 'center'},
                {field: 'EdzoId', visible: false},
                {field: 'Ido', headerText: gettextCatalog.getString('TimeLength'), width: 150, textAlign: 'center'},
                {field: 'Testresz', headerText: gettextCatalog.getString('BodyParts'), width: 150, textAlign: 'center'},
                {field: 'Tipus', headerText: gettextCatalog.getString('Type'), width: 150, textAlign: 'center'},
                {
                    field: 'Jellege',
                    headerText: gettextCatalog.getString('individualTeam'),
                    width: 150,
                    textAlign: 'center'
                },
                {
                    field: 'Felszerelesek',
                    headerText: gettextCatalog.getString('Assets'),
                    width: 150,
                    textAlign: 'center'
                },
                {
                    field: 'Publikus',
                    headerText: gettextCatalog.getString('Public'),
                    width: 150,
                    type: 'boolean',
                    displayAsCheckBox: true,
                    textAlign: 'center'
                },
                {field: 'Kifesto', headerText: gettextCatalog.getString('Paint'), width: 150, textAlign: 'center'},
                {
                    field: 'JatekosokSzama',
                    headerText: gettextCatalog.getString('Players'),
                    width: 150,
                    textAlign: 'center'
                },
                {
                    field: 'Nehezseg',
                    headerText: gettextCatalog.getString('Difficulty'),
                    width: 150,
                    textAlign: 'center'
                },
                {
                    field: 'SzuksegesTerulet',
                    headerText: gettextCatalog.getString('Space'),
                    width: 150,
                    textAlign: 'center'
                }
            ];

            var TrainingGrid = new ej2.grids.Grid({
                dataSource: [],
                toolbar: $rootScope.toolbarItemsWithSearch,
                allowPaging: true,
                allowSorting: true,
                allowExcelExport: true,
                locale: 'hu-HU',
                gridLines: 'Both',
                pageSettings: $rootScope.pageSettings,
                columns: vm.trainingColumns,
                selectionSettings: {type: 'Multiple', mode: 'Both'},
                rowDataBound: function (args) {
                    $rootScope.compile(args.row, $scope);
                },
                actionComplete: function (args) {
                    if (args.requestType === 'paging' || args.requestType === 'refresh') {
                        $rootScope.compile($('#TrainingGrid'), $scope);
                    }
                },
                rowSelecting: function () {
                    $timeout(function () {
                        vm.selectedRow = TrainingGrid.getSelectedRecords();
                        if (vm.selectedRow && vm.selectedRow.length > 0) {
                            vm.addEnabled = true && vm.allowSave;
                        }
                    }, 100);
                },
                rowDeselecting: Deselect,
                rowDeselected: Deselect,
            });
            TrainingGrid.appendTo('#TrainingGrid');
            TrainingGrid.toolbarClick = function (args) {
                $rootScope.toolbarClick(args, TrainingGrid);
            };

            function Deselect() {
                if (TrainingGrid.getSelectedRecords().length === 0) {
                    vm.addEnabled = false;
                    $scope.$apply();
                    vm.selectedRow = [];
                }
            }

            // events
            // filter bottom
            vm.sectionSelect = sectionSelect;
            vm.sectionDataBound = sectionDataBound;
            vm.ageGroupSelect = ageGroupSelect;
            vm.coachSelect = coachSelect;
            vm.ageGroupDataBound = ageGroupDataBound;
            vm.coachDataBound = coachDataBound;

            // filter top
            vm.trainingSectionSelect = trainingSectionSelect;
            vm.trainingSectionDataBound = trainingSectionDataBound;
            vm.trainingAgeGroupSelect = trainingAgeGroupSelect;
            vm.trainingAgeGroupDataBound = trainingAgeGroupDataBound;

            // grid
            vm.openTemplate = openTemplate;

            // button
            vm.showExercises = showExercises;
            vm.addRow = addRow;
            vm.save = save;
            activate();

            function activate() {
                $q.all([
                    authenticationService.getRight('UJEDZESSABLON'),
                    authenticationService.getRight('MODEDZESSABLON'),
                    authenticationService.getRight('MEGTEDZESSABLON'),
                    authenticationService.getRight('EDZO'),
                    paramHelper.getParams([],
                        ['trainingPlanCreate.trainingId',
                            'trainingPlanCreate.sectionId',
                            'trainingPlanCreate.ageGroupId'
                        ]),
                    authenticationService.getRight('UJGYAKORLAT')
                ]).then(function (results) {
                        $timeout(function () {
                            vm.UJEDZESSABLON = results[0];
                            vm.MODEDZESSABLON = results[1];
                            vm.MEGTEDZESSABLON = results[2];
                            vm.EDZO = results[3];
                            vm.params = results[4];
                            vm.addNewPermission = results[5];
                            if (!vm.MEGTEDZESSABLON) {
                                log.permissionError(true);
                                return;
                            }
                            if (vm.params && vm.params['trainingPlanCreate.trainingId'] > 0) {
                                vm.trainingId = vm.params['trainingPlanCreate.trainingId'];
                                LoadPlan(vm.params['trainingPlanCreate.trainingId']);
                            }
                            if (vm.params && vm.params['trainingPlanCreate.trainingId'] === 0) {
                                LoadPlan(0);
                            } else {
                                getTrainingSections();
                                getAutoComplete();
                            }

                            if ((vm.UJEDZESSABLON && (vm.trainingId < 1 || !vm.trainingId)) || (vm.MODEDZESSABLON && vm.trainingId > 0)) {
                                vm.allowSave = true;
                                MainGrid.allowSelection = true;
                                TrainingGrid.allowSelection = true;
                                MainGrid.editSettings.allowDeleting = true;
                                MainGrid.refreshHeader();
                                $timeout(function () {
                                    $scope.$apply();
                                }, 100);
                            }
                        }, 0);
                    }
                );
            }

            function LoadPlan(trainingId) {
                vm.loadPlan = true;
                if (trainingId > 0) {
                    dataservice.GetTrainingPlanById(trainingId).then(function (data) {
                        if (data) {
                            vm.trainingSectionId = data.itemsList[0].SzakosztalyId ? data.itemsList[0].SzakosztalyId : vm.trainingSectionId;
                            vm.trainingAgeGroupId = data.itemsList[0].KorosztalyId ? data.itemsList[0].KorosztalyId : vm.trainingAgeGroupId;
                            vm.trainingName = data.itemsList[0].Nev;
                            MainGrid.dataSource = $filter('addImagePathToObject')(data.itemsList[0].Gyakorlatok, 'Mintakep', vm.imageRoot);
                            vm.trainingDescription = data.itemsList[0].Leiras;
                            vm.public = data.itemsList[0].Publikus;
                            $timeout(function () {
                                $('.thumbnail-item').magnificPopup({
                                    type: 'image'
                                });
                            }, 100);
                        }
                    });
                } else {
                    vm.trainingSectionId = vm.params['trainingPlanCreate.sectionId'] ? vm.params['trainingPlanCreate.sectionId'] : vm.trainingSectionId;
                    vm.trainingAgeGroupId = vm.params['trainingPlanCreate.ageGroupId'] ? vm.params['trainingPlanCreate.ageGroupId'] : vm.trainingAgeGroupId;
                }
                getTrainingSections();
                getAutoComplete();
            }

            // function Top
            function getTrainingSections() {
                dataservice.sectionDropDownList(0, false).then(function (data) {
                    if (data.itemsList && data.itemsList.length > 1) {
                        data.itemsList.unshift({value: 0, text: gettextCatalog.getString('All')});
                    }
                    // egyszerre átadom a két szakosztály dropdown adatait
                    vm.sectionList = data.itemsList;
                    vm.trainingSectionList = data.itemsList;
                });
            }

            function trainingSectionDataBound() {
                if (vm.sectionList.length === 1) {
                    angular.element('#trainingSectionDropDown').ejDropDownList('selectItemByValue', vm.sectionList[0].value);
                } else {
                    angular.element('#trainingSectionDropDown').ejDropDownList('selectItemByValue', vm.trainingSectionId);
                }
            }

            function trainingSectionSelect(args) {
                vm.trainingSectionId = args.value;
                getTrainingAgeGroups(args.value);
            }

            function getTrainingAgeGroups(trainingSectionId) {
                return dataservice.ageGroupDropDownList(trainingSectionId).then(function (data) {
                    if (data.itemsList && data.itemsList.length !== 1) {
                        data.itemsList.unshift({text: gettextCatalog.getString('All'), value: 0});
                    }
                    vm.trainingAgeGroupList = data.itemsList;
                });
            }

            function trainingAgeGroupDataBound() {
                if (vm.trainingAgeGroupList.length === 1) {
                    angular.element('#trainingAgeGroupDropDown').ejDropDownList('selectItemByValue', vm.trainingAgeGroupList[0].value);
                } else {
                    angular.element('#trainingAgeGroupDropDown').ejDropDownList('selectItemByValue', vm.trainingAgeGroupId);
                }
            }

            function trainingAgeGroupSelect(args) {
                vm.trainingAgeGroupId = args.value;
            }

            // function bottom
            function getAutoComplete() {
                dataservice.getTrainingPracticeAutoComplete()
                    .then(function (result) {
                        vm.autoComplete = result.data;
                    });
            }

            function sectionDataBound() {
                if (vm.sectionList && vm.sectionList.length === 1) {
                    angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.sectionList[0].value);
                } else {
                    angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.sectionId);
                }
            }

            function sectionSelect(args) {
                getAgeGroups(args.value);
            }

            function getAgeGroups(sectionId) {
                return dataservice.ageGroupDropDownList(sectionId).then(function (data) {
                    if (data.itemsList && data.itemsList.length !== 1) {
                        data.itemsList.unshift({text: gettextCatalog.getString('All'), value: 0});
                    }
                    vm.ageGroupList = data.itemsList;
                });
            }

            function ageGroupDataBound() {
                if (vm.ageGroupList && vm.ageGroupList.length === 1) {
                    angular.element('#ageGroupDropDown').ejDropDownList('selectItemByValue', vm.ageGroupList[0].value);
                } else {
                    angular.element('#ageGroupDropDown').ejDropDownList('selectItemByValue', vm.ageGroupId);
                }
            }

            function ageGroupSelect(args) {
                getCoachesList(args.value);
            }

            function getCoachesList(sectionId) {
                return dataservice.coachDropDownList(sectionId, 0).then(function (data) {
                    if (data.itemsList && data.itemsList.length !== 1) {
                        data.itemsList.unshift({text: gettextCatalog.getString('All'), value: 0});
                    }
                    vm.coachList = data.itemsList;
                });
            }

            function coachDataBound() {
                if (vm.coachList && vm.coachList.length === 1) {
                    angular.element('#coachDropDown').ejDropDownList('selectItemByValue', vm.coachList[0].value);
                } else {
                    angular.element('#coachDropDown').ejDropDownList('selectItemByValue', vm.coachId);
                }
            }

            function coachSelect() {
                //vm.coachId = args.value;
            }

            // grid top events
            function openTemplate(exerciseId) {
                if (vm.allowSave) {
                    swal({
                        title: gettextCatalog.getString('Would you like to save the plan?'),
                        type: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#DD6B55',
                        confirmButtonText: gettextCatalog.getString('Yes'),
                        cancelButtonText: gettextCatalog.getString('No'),
                        closeOnConfirm: false,
                        closeOnCancel: false
                    }).then(function (isConfirm) {
                        if (isConfirm.value) {
                            save().then(function (res) {
                                if (res) {
                                    paramHelper.setParams([{'exercises.exerciseId': exerciseId}]);
                                    $state.go('administration.exercises.exercisesCreate');
                                }
                            });
                        } else if (isConfirm.dismiss === 'cancel') {
                            paramHelper.setParams([{'exercises.exerciseId': exerciseId}]);
                            $state.go('administration.exercises.exercisesCreate');
                        }
                    });
                } else {
                    paramHelper.setParams([{'exercises.exerciseId': exerciseId}]);
                    $state.go('administration.exercises.exercisesCreate');
                }
            }

            // button events
            function showExercises() {
                dataservice.getExercises(vm.sectionId, vm.ageGroupId, vm.coachId, vm.bodyPartValue, vm.TypeValue, vm.individualTeamValue, vm.AssetValue, vm.difficultyValue, vm.necessaryAreaValue, vm.withVideo, vm.withPattern, vm.withPaint, vm.timeValue)
                    .then(function (data) {
                        TrainingGrid.dataSource = $filter('addImagePathToObject')(data.itemsList, 'Mintakep', vm.imageRoot);
                        $timeout(function () {
                            $('.thumbnail-item').magnificPopup({
                                type: 'image'
                            });
                        }, 100);
                    });
            }

            function save() {
                if ((vm.UJEDZESSABLON && (vm.trainingId < 1 || !vm.trainingId)) || (vm.MODEDZESSABLON && vm.trainingId > 0)) {
                    return $q(function (resolve) {
                        $scope.$broadcast('submitted');
                        if ($scope.form.$valid === false) {
                            log.errorMsg('FillTheRequiredFields');
                            resolve(0);
                        } else {
                            vm.saveParam = {
                                TrainingId: vm.trainingId,
                                TrainingName: vm.trainingName,
                                SectionId: vm.trainingSectionId,
                                AgeGroupId: vm.trainingAgeGroupId,
                                Description: vm.trainingDescription,
                                Public: vm.public,
                                Data: MainGrid.dataSource
                            };
                            dataservice.saveTrainingPlan(vm.saveParam).then(function (result) {
                                if (result.retValue !== 0) {
                                    vm.trainingId = result.retValue;
                                    log.successMsg('SaveCompleted');
                                    // $state.go('administration.trainingPlan.trainingPlanList');
                                }
                                resolve(result.retValue);
                            });
                            if (vm.MODEDZESSABLON) {
                                vm.allowSave = true;
                            } else {
                                vm.allowSave = false;
                                TrainingGrid.clearSelection();
                                MainGrid.editSettings.allowDeleting = false;
                            }
                        }
                    });
                } else {
                    log.permissionError();
                }
            }

            function addRow() {
                var gyakorlatKategoria = null;
                var ismSzam = null;
                var HTMLtext = '';
                HTMLtext += '<div style="margin-top: 10px;">';
                HTMLtext += '<label  style="text-align: left; margin-top:7px;  font-weight: bold;">' + gettextCatalog.getString('GyakorlatKategoria') + gettextCatalog.getString(' (e.g. warmingUp)') + '</label><br>';
                HTMLtext += '<input class="col-sm-8" id="AutoCompleteSwalType"  ej-autocomplete></input><br>';
                HTMLtext += '<label style="text-align: left; margin-top:7px; margin-bottom: auto">' + gettextCatalog.getString('NumberOfRepetitions') + '</label><br>';
                HTMLtext += '<input class="col-sm-8" id="SwalIsmetlesSzam" ></input><br>';
                HTMLtext += '</div>';
                if (vm.selectedRow && vm.selectedRow.length > 0) {
                    swal({
                        html: HTMLtext,
                        type: 'info',
                        showCancelButton: true,
                        allowOutsideClick: false,
                        confirmButtonText: gettextCatalog.getString('Add'),
                        cancelButtonText: gettextCatalog.getString('Cancel'),
                        preConfirm: function () {
                            vm.trainingPlanCategory = angular.element('#AutoCompleteSwalType').data('ejAutocomplete').getValue(); // get value
                            return new Promise(function (resolve) {
                                if (!vm.trainingPlanCategory) {
                                    swal.showValidationError(gettextCatalog.getString('ExerciseCategoryRequired'));
                                }
                                resolve();
                            });
                        }
                    }).then(function (isConfirm) {
                        if (isConfirm.value) {
                            var rows = MainGrid.dataSource;
                            MainGrid.dataSource = [];
                            vm.selectedRow.forEach(function (element) {
                                rows.push(
                                    {
                                        SorIndex: vm.sorIndex,
                                        GyakorlatId: element.GyakorlatId,
                                        GyakorlatKategoria: gyakorlatKategoria,
                                        GyakorlatTipus: element.Tipus,
                                        IsmSzam: ismSzam,
                                        Nev: element.Nev,
                                        Ido: element.Ido,
                                        Video: element.Video,
                                        Mintakep: element.Mintakep,
                                        Jellege: element.Jellege,
                                        Testresz: element.Testresz
                                    }
                                );
                                vm.sorIndex++;
                            });
                            MainGrid.dataSource = rows;
                        }
                    }, function () {
                    });

                    // in swal
                    angular.element('#AutoCompleteSwalType').ejAutocomplete({
                        dataSource: vm.autoComplete.EdzesTetelGyakorlatTipus,
                        allowAddNew: true,
                        showPopupButton: true,
                        showEmptyResultText: true,
                        change: function (arg) {
                            gyakorlatKategoria = arg.value;
                        },
                        value: gyakorlatKategoria,
                        width: '100%'
                    });
                    angular.element('#SwalIsmetlesSzam').ejNumericTextbox({
                        change: function changeValue(arg) {
                            ismSzam = arg.value;
                        },
                        width: '100%'
                    });
                }
            }

            vm.createNewTrainingPlan = function () {
                if (vm.addNewPermission !== true) {
                    log.permissionError(true);
                    return;
                }
                if (vm.allowSave) {
                    swal({
                        title: gettextCatalog.getString('Would you like to save the plan?'),
                        type: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#DD6B55',
                        confirmButtonText: gettextCatalog.getString('Yes'),
                        cancelButtonText: gettextCatalog.getString('No'),
                        closeOnConfirm: false,
                        closeOnCancel: false
                    }).then(function (isConfirm) {
                        if (isConfirm.value) {
                            save().then(function (res) {
                                if (res) {
                                    paramHelper.setParams([{'trainingPlanCreate.trainingId': res}]);
                                    paramHelper.setParams([
                                        {'exercisesList.SzakosztalyId': vm.trainingSectionId},
                                        {'exercisesList.KorosztalyId': vm.trainingAgeGroupId},
                                        {'exercisesList.EdzoId': 0}
                                    ]);
                                    $state.go('administration.exercises.exercisesCreate');
                                }
                            });
                        } else if (isConfirm.dismiss === 'cancel') {
                            $state.go('administration.exercises.exercisesCreate');
                        }
                    });
                } else {
                    $state.go('administration.exercises.exercisesCreate');
                }
            };
        }
    }
)
();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.administration.trainingPlan.trainingPlanCreate')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'administration.trainingPlan.trainingPlanCreate',
                config: {
                    url: '/trainingPlanCreate',
                    templateUrl: 'app/administration/trainingPlan/trainingPlanCreate/trainingPlanCreate.html',
                    controller: 'TrainingPlanCreateController',
                    controllerAs: 'vm',
                    title: 'TrainingPlanCreate'
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    TrainingPlanListController.$inject = ["log", "paramHelper", "dataservice", "$timeout", "$q", "$rootScope", "$filter", "DOMAIN", "gettextCatalog", "authenticationService", "$scope", "$state"];
    angular
        .module('app.administration.trainingPlan.trainingPlanList')
        .controller('TrainingPlanListController', TrainingPlanListController);

    function TrainingPlanListController(log, paramHelper, dataservice, $timeout, $q, $rootScope, $filter, DOMAIN, gettextCatalog, authenticationService, $scope, $state) {
        var vm = this; $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('TrainingPlanList');

        vm.imageRoot = DOMAIN.baseURL + DOMAIN.exerciseBaseUrl;
        vm.gridDataSource = [];
        vm.sectionId = 0;
        vm.sectionList = [];
        vm.ageGroupId = 0;
        vm.ageGroupList = [];
        vm.coachId = 0;
        vm.coachList = [];
        vm.openPermission = false;
        vm.addNewPermission = false;
        vm.deletePermission = false;

        //events
        vm.sectionDataBound = sectionDataBound;
        vm.sectionSelect = sectionSelect;
        vm.ageGroupDataBound = ageGroupDataBound;
        vm.ageGroupSelect = ageGroupSelect;
        vm.coachDataBound = coachDataBound;
        vm.coachSelect = coachSelect;
        vm.createNewTrainingPlan = createNewTrainingPlan;
        vm.openTrainingPlan = openTrainingPlan;
        vm.deleteTrainingPlan = deleteTrainingPlan;
        vm.search = search;

        vm.columns = [
            {type: 'checkbox', headerText: '', textAlign: 'center', width: 55},
            {field: 'Link', headerText: '', textAlign: 'center', width: 60, template: '#wtro'},
            {field: 'Nev', headerText: gettextCatalog.getString('Name'), textAlign: 'center', width: 120},
            {field: 'Ido', headerText: gettextCatalog.getString('TrainingTimeLength'), textAlign: 'center', width: 120},
            {field: 'SzakosztalyId', visible: false},
            {field: 'Szakosztaly', headerText: gettextCatalog.getString('Section'), textAlign: 'center', width: 120},
            {field: 'KorosztalyId', visible: false},
            {field: 'Korosztaly', headerText: gettextCatalog.getString('AgeGroup'), textAlign: 'center', width: 120},
            {field: 'EdzoId', visible: false},
            {field: 'Edzo', headerText: gettextCatalog.getString('Coach'), textAlign: 'center', width: 120},
            {field: 'Leiras', headerText: gettextCatalog.getString('Description'), textAlign: 'center', width: 120},
            {field: 'Publikus', headerText: gettextCatalog.getString('Public'), type: 'boolean', displayAsCheckBox: true, textAlign: 'center', width: 120}
        ];

        //gyakorlatok
        vm.childGridColums = [
            {field: 'EdzesFejId', visible: false},
            {field: 'GyakorlatId', isPrimaryKey: true, visible: false},
            {field: 'GyakorlatKategoria', headerText: gettextCatalog.getString('GyakorlatKategoria'), textAlign: 'center', width: 120},
            {field: 'Nehezseg', headerText: gettextCatalog.getString('Nehezseg'), textAlign: 'center', width: 100},
            {field: 'Ido', headerText: gettextCatalog.getString('TimeLength'), textAlign: 'center', width: 120},
            {field: 'IsmSzam', headerText: gettextCatalog.getString('IsmSzam'), textAlign: 'center', width: 120},
            {field: 'Nev', headerText: gettextCatalog.getString('Name'), textAlign: 'center', template: '#wtpropentemp', width: 180},
            {field: 'GyakorlatTipus', headerText: gettextCatalog.getString('GyakorlatTipus'), textAlign: 'center', width: 120},
            {field: 'Mintakep', headerText: gettextCatalog.getString('Pattern'), width: 180, textAlign: 'center', template: '#imagetemplateGrid'},
            {field: 'Video', headerText: gettextCatalog.getString('YouTube'), textAlign: 'center', width: 115, type: 'boolean', displayAsCheckBox: true},
            {field: 'Jellege', headerText: gettextCatalog.getString('individualTeam'), textAlign: 'center'},
            {field: 'Testresz', headerText: gettextCatalog.getString('BodyParts'), textAlign: 'center', width: 120},
        ];

        var Grid = new ej2.grids.Grid({
            dataSource: [],
            allowSorting: true,
            allowExcelExport: true,
            allowTextWrap: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            //allowPaging: true,
            //pageSettings: $rootScope.pageSettings,
            toolbar: ['Print'],
            columns: vm.columns,
            childGrid: {
                dataSource: [],
                queryString: 'EdzesFejId',
                columns: vm.childGridColums,
                allowTextWrap: true,
                allowPaging: true,
                pageSettings: $rootScope.pageSettings,
                rowDataBound: function (args) {
                    $rootScope.compile(args.row, $scope);
                }
            },
            beforePrint: $rootScope.beforePrintGrid,
            printComplete: $rootScope.printCompleteGrid,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#Grid'), $scope);
                }
            },
            rowSelecting: function () {
                Grid.clearSelection();
            },
            checkBoxChange: function (args) {
                $rootScope.checkBoxChangeOnlyOne(args, Grid);
            }
        });

        Grid.appendTo('#Grid');

        activate();
        function activate() {
            $q.all([authenticationService.getRight('MEGTEDZESSABLON'), authenticationService.getRight('MODEDZESSABLON'), authenticationService.getRight('UJEDZESSABLON'), authenticationService.getRight('TOROLEDZESSABLON'), paramHelper.getParams([], ['trainPlanList.SzakosztalyId', 'trainPlanList.KorosztalyId', 'trainPlanList.EdzoId'])]).then(function (results) {
                if (results[0] !== true) {
                    log.permissionError(true);
                } else {
                    $timeout(function () {
                        vm.openPermission = results[0];
                        vm.modifyPermission = results[1];
                        vm.addNewPermission = results[2];
                        vm.deletePermission = results[3];
                        $scope.$apply();
                    }, 1);
                    getSections();
                    getAgeGroups();
                    vm.sectionId = results[4]['trainPlanList.SzakosztalyId'];
                    vm.ageGroupId = results[4]['trainPlanList.KorosztalyId'];
                    vm.coachId = results[4]['trainPlanList.EdzoId'];
                }
            });
        }

        function getSections() {
            dataservice.sectionDropDownList(0, false)
                .then(function (data) {
                    if (data.itemsList && data.itemsList.length > 1) {
                        data.itemsList.unshift({value: 0, text: gettextCatalog.getString('All')});
                    }
                    vm.sectionList = data.itemsList;
                    vm.sectionList = data.itemsList;
                });
        }

        function sectionDataBound() {
            if (vm.sectionList && vm.sectionList.length === 1) {
                vm.sectionId = vm.sectionList[0].value;
            }
            angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.sectionId);
        }

        // Run after section selected
        function sectionSelect(args) {
            vm.sectionId = args.value;
            getAgeGroups();
        }

        // Run after data bounded
        function ageGroupDataBound() {
            if (vm.ageGroupList && vm.ageGroupList.length === 1) {
                angular.element('#ageGroupDropDown').ejDropDownList('selectItemByValue', vm.ageGroupList[0].value);
            } else {
                angular.element('#ageGroupDropDown').ejDropDownList('selectItemByValue', vm.ageGroupId);
            }
        }

        function getAgeGroups() {
            return dataservice.ageGroupDropDownList(vm.sectionId).then(function (data) {
                if (data.itemsList && data.itemsList.length !== 1) {
                    data.itemsList.unshift({text: gettextCatalog.getString('All'), value: 0});
                }
                vm.ageGroupList = data.itemsList;
            });
        }

        // Run after age group selected
        function ageGroupSelect(args) {
            vm.ageGroupId = args.value;
            getActualCoachesList();
        }

        function getActualCoachesList() {
            return dataservice.coachDropDownList(vm.sectionId, 0).then(function (data) {
                if (data.itemsList && data.itemsList.length !== 1) {
                    data.itemsList.unshift({text: gettextCatalog.getString('All'), value: 0});
                }
                vm.coachList = data.itemsList;
            });
        }

        // Run after data bounded
        function coachDataBound() {
            if (vm.coachList && vm.coachList.length === 1) {
                angular.element('#coachDropDown').ejDropDownList('selectItemByValue', vm.coachList[0].value);
            } else {
                angular.element('#coachDropDown').ejDropDownList('selectItemByValue', vm.coachId);
            }
        }

        // Run after age coach selected
        function coachSelect(args) {
            vm.coachId = args.value;
        }

        function openTrainingPlan(Id) {
            if (vm.openPermission !== true) {
                log.permissionError(true);
                return;
            }

            paramHelper.removeParam('trainingPlanCreate.sectionId');
            paramHelper.removeParam('trainingPlanCreate.ageGroupId');
            paramHelper.setParams([{'trainingPlanCreate.trainingId': Id}]);
            $state.go('administration.trainingPlan.trainingPlanCreate');
        }

        function createNewTrainingPlan() {
            if (vm.addNewPermission !== true) {
                log.permissionError(true);
                return;
            }
            paramHelper.setParams([{'trainPlanList.SzakosztalyId': vm.sectionId}]);
            paramHelper.setParams([{'trainPlanList.KorosztalyId': vm.ageGroupId}]);
            paramHelper.setParams([{'trainPlanList.EdzoId': vm.coachId}]);
            paramHelper.setParams([{'trainingPlanCreate.trainingId': 0}, {'trainingPlanCreate.sectionId': vm.sectionId}, {'trainingPlanCreate.ageGroupId': vm.ageGroupId}]);
            $state.go('administration.trainingPlan.trainingPlanCreate');
        }

        function deleteTrainingPlan() {
            var selectedRow = Grid.getSelectedRecords();
            if (!selectedRow || selectedRow.length == 0) {
                log.errorMsg('CantDeleted');
                return;
            }
            if (vm.deletePermission !== true) {
                log.permissionError(true);
                return;
            }
            swal({
                title: gettextCatalog.getString('Are you sure you want to delete the selected training plan?'),
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: gettextCatalog.getString('Yes'),
                cancelButtonText: gettextCatalog.getString('Cancel'),
                closeOnConfirm: false,
                closeOnCancel: false
            }).then(function(isConfirm) {
                if (isConfirm.value) {
                    dataservice.DeleteTrainingPlan(selectedRow[0].EdzesFejId)
                        .then(function (response) {
                            if (response.retValue == true) {
                                log.successMsg('trainingPlanDeleted');
                                search();
                            }
                        }, function () {
                        });
                }
            });
        }

        function search() {
            paramHelper.setParams([{'trainPlanList.SzakosztalyId': vm.sectionId}]);
            paramHelper.setParams([{'trainPlanList.KorosztalyId': vm.ageGroupId}]);
            paramHelper.setParams([{'trainPlanList.EdzoId': vm.coachId}]);
            dataservice.getTrainingPlanList(vm.sectionId, vm.ageGroupId, vm.coachId)
                .then(function (response) {
                    Grid.dataSource = response.itemsList;
                    Grid.childGrid.dataSource = $filter('addImagePathToObject')(response.Gyakorlatok, 'Mintakep', vm.imageRoot);
                    $timeout(function () {
                        $('.thumbnail-item').magnificPopup({
                            type: 'image'
                        });
                    }, 300);
                });
        }

        vm.openTemplate = openTemplate;
        function openTemplate(exerciseId) {
            paramHelper.setParams([{'exercises.exerciseId': exerciseId}]);
            $state.go('administration.exercises.exercisesCreate');
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.administration.trainingPlan.trainingPlanList')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'administration.trainingPlan.trainingPlanList',
                config: {
                    url: '/trainingPlanList',
                    templateUrl: 'app/administration/trainingPlan/trainingPlanList/trainingPlanList.html',
                    controller: 'TrainingPlanListController',
                    controllerAs: 'vm',
                    title: 'TrainingPlanList',
                    settings: {
                        navId: 2142,
                        level: 2,
                        order: 14,
                        orderTitle_hu: 'Edzéssablon lista',
                        orderTitle_en: 'Training Plan List',
                        parentId: 2,
                        content: 'TrainingPlanList',
                        activatorPermission: '"MEGTEDZESSABLON"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    TrainingPlanTemplateController.$inject = ["log", "paramHelper", "dataservice", "$timeout", "$q", "$rootScope", "$filter", "DOMAIN", "gettextCatalog", "authenticationService", "$scope", "$state"];
    angular
        .module('app.administration.trainingPlan.trainingPlanTemplate')
        .controller('TrainingPlanTemplateController', TrainingPlanTemplateController);

    function TrainingPlanTemplateController(log, paramHelper, dataservice, $timeout, $q, $rootScope, $filter, DOMAIN, gettextCatalog, authenticationService, $scope, $state) {
        var vm = this; $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('TrainingPlanTemplate');
        vm.youtubeIcon = DOMAIN.baseURL + DOMAIN.imgBaseUrl + 'youtube.png';
        vm.imageRoot = DOMAIN.baseURL + DOMAIN.exerciseBaseUrl;
        // main datas
        vm.sorIndex = 0; // a gyakorlatok torléséhez kell egy elsödlegeskulcs sorIndex)
        vm.params = null;
        vm.loadPlan = false;
        vm.saveParams = null;
        vm.trainingSectionId = 0;
        vm.trainingSectionList = [];
        vm.trainingName = null;
        vm.trainingDescription = null;
        vm.trainingAgeGroupId = 0;
        vm.trainingAgeGroupList = [];
        function sumIdo(args) {
            var res = 0;
            args.result.forEach(function (element) {
                if (element.Ido) {
                    res += element.Ido * element.IsmSzam;
                }
            });
            vm.timeLength = res;
            return res;
        }

        vm.summaryRows = [{
            columns: [
                {
                    type: 'Custom',
                    customAggregate: sumIdo,
                    columnName: 'Ido',
                    footerTemplate: gettextCatalog.getString('Sum') + ': ${Custom}'
                }
            ]
        }];
        vm.columnsMain = [
            {field: 'SorIndex', isPrimaryKey: true, visible: false},
            {field: 'EdzesFejId', visible: false},
            {field: 'GyakorlatId', visible: false},
            {field: 'Nev', headerText: gettextCatalog.getString('Name'), width: 200, textAlign: 'center', template: '#wtpropentemp'},
            {field: 'Ido', headerText: gettextCatalog.getString('TimeLength'), width: 150, textAlign: 'center'},
            {field: 'Mintakep', headerText: gettextCatalog.getString('Pattern'), width: 180, textAlign: 'center', template: '#imagetemplateGrid'},
            {field: 'Video', headerText: gettextCatalog.getString('Video'), width: 115, type: 'boolean', displayAsCheckBox: true, textAlign: 'center'},
            {field: 'GyakorlatKategoria', headerText: gettextCatalog.getString('GyakorlatKategoria'), width: 150, textAlign: 'center'},
            {field: 'IsmSzam', headerText: gettextCatalog.getString('IsmSzam'), width: 150, textAlign: 'center'},
            {field: 'GyakorlatTipus', headerText: gettextCatalog.getString('GyakorlatTipus'), width: 150, textAlign: 'center'},
            {field: 'Jellege', headerText: gettextCatalog.getString('individualTeam'), width: 150, textAlign: 'center'},
            {field: 'Testresz', headerText: gettextCatalog.getString('BodyParts'), width: 150, textAlign: 'center'},
        ];

        var MainGrid = new ej2.grids.Grid({
            dataSource: [],
            allowPaging: true,
            allowSorting: true,
            locale: 'hu-HU',
            aggregates: vm.summaryRows,
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columnsMain,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#GridTraining'), $scope);
                }
            },
            rowSelecting: function () {
                MainGrid.clearSelection();
            },
            checkBoxChange: function (args) {
                $rootScope.checkBoxChangeOnlyOne(args, MainGrid);
            }
        });
        MainGrid.appendTo('#GridTraining');

        // filter top
        vm.trainingSectionSelect = trainingSectionSelect;
        vm.trainingSectionDataBound = trainingSectionDataBound;
        vm.trainingAgeGroupSelect = trainingAgeGroupSelect;
        vm.trainingAgeGroupDataBound = trainingAgeGroupDataBound;

        // grid
        vm.openTemplate = openTemplate;

        activate();
        function activate() {
            $q.all([authenticationService.getRight('UJEDZESSABLON'), authenticationService.getRight('MODEDZESSABLON'), authenticationService.getRight('MEGTEDZESSABLON'), paramHelper.getParams([], ['trainingPlanCreate.trainingId', 'trainingPlanCreate.sectionId', 'trainingPlanCreate.ageGroupId'])])
                .then(function (results) {
                        var UJEDZESSABLON = results[0];
                        var MODEDZESSABLON = results[1];
                        var MEGTEDZESSABLON = results[2];
                        vm.params = results[3];
                        if (MEGTEDZESSABLON) {
                            if (vm.params && vm.params['trainingPlanCreate.trainingId'] > 0) {
                                LoadPlan(results[3]['trainingPlanCreate.trainingId']);
                                $timeout(function () {
                                    vm.modify = MODEDZESSABLON;
                                    $scope.$apply();
                                });
                            } else if (vm.params && vm.params['trainingPlanCreate.trainingId'] === 0) {
                                $timeout(function () {
                                    vm.modify = UJEDZESSABLON;
                                    $scope.$apply();
                                }, 0);
                            }
                            $timeout(function () {
                                getTrainingSections();
                            }, 0);
                        } else {
                            log.permissionError(true);
                        }
                    }
                );
        }

        function LoadPlan(trainingId) {
            vm.loadPlan = true;
            dataservice.GetTrainingPlanById(trainingId).then(function (data) {
                if (data.itemsList[0].SzakosztalyId) {
                    vm.trainingSectionId = data.itemsList[0].SzakosztalyId;
                }
                if (data.itemsList[0].KorosztalyId) {
                    vm.trainingAgeGroupId = data.itemsList[0].KorosztalyId;
                }
                vm.trainingName = data.itemsList[0].Nev;
                MainGrid.dataSource = $filter('addImagePathToObject')(data.itemsList[0].Gyakorlatok, 'Mintakep', vm.imageRoot);
                vm.trainingDescription = data.itemsList[0].Leiras;
                vm.public = data.itemsList[0].Publikus;
                $timeout(function () {
                    $('.thumbnail-item').magnificPopup({
                        type: 'image'
                    });
                }, 100);
            });
        }

        // function Top
        function getTrainingSections() {
            dataservice.sectionDropDownList(0, false).then(function (data) {
                if (data.itemsList && data.itemsList.length > 1) {
                    data.itemsList.unshift({value: 0, text: gettextCatalog.getString('All')});
                }
                vm.sectionList = data.itemsList;
                vm.trainingSectionList = data.itemsList;
            });
        }

        function trainingSectionDataBound() {
            if (!vm.trainingSectionList) {
                return;
            }
            if (vm.params != null && vm.params['trainingPlanCreate.sectionId'] != null) {
                angular.element('#trainingSectionDropDown').ejDropDownList('selectItemByValue', vm.params['trainingPlanCreate.sectionId']);
                vm.params['trainingPlanCreate.sectionId'] = null;
            } else if (vm.loadPlan === true) {
                angular.element('#trainingSectionDropDown').ejDropDownList('selectItemByValue', vm.trainingSectionId);
            } else {
                vm.trainingSectionId = vm.trainingSectionList[0].value;
                angular.element('#trainingSectionDropDown').ejDropDownList('selectItemByValue', vm.trainingSectionId);
            }
        }

        function trainingSectionSelect(args) {
            vm.trainingSectionId = args.value;
            getTrainingAgeGroups(args.value);
        }

        function getTrainingAgeGroups(trainingSectionId) {
            return dataservice.ageGroupDropDownList(trainingSectionId).then(function (data) {
                if (data.itemsList && data.itemsList.length !== 1) {
                    data.itemsList.unshift({text: gettextCatalog.getString('All'), value: 0});
                }
                vm.trainingAgeGroupList = data.itemsList;
            });
        }

        function trainingAgeGroupDataBound() {
            if (!vm.trainingAgeGroupList) {
                return;
            }
            if (vm.params && vm.params['trainingPlanCreate.ageGroupId'] != null) {
                angular.element('#trainingAgeGroupDropDown').ejDropDownList('selectItemByValue', vm.params['trainingPlanCreate.ageGroupId']);
                vm.params['trainingPlanCreate.ageGroupId'] = null;
            } else if (vm.loadPlan === true) {
                angular.element('#trainingAgeGroupDropDown').ejDropDownList('selectItemByValue', vm.trainingAgeGroupId);
                vm.loadPlan = false;
            } else {
                vm.trainingAgeGroupId = vm.trainingAgeGroupList[0].value;
                angular.element('#trainingAgeGroupDropDown').ejDropDownList('selectItemByValue', vm.trainingAgeGroupId);
            }
        }

        function trainingAgeGroupSelect(args) {
            vm.trainingAgeGroupId = args.value;
        }

        function openTemplate(exerciseId) {
            paramHelper.setParams([{'exercises.exerciseId': exerciseId}]);
            $state.go('administration.exercises.exercisesCreate');
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.administration.trainingPlan.trainingPlanTemplate')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'administration.trainingPlan.trainingPlanTemplate',
                config: {
                    url: '/trainingPlanTemplate',
                    templateUrl: 'app/administration/trainingPlan/trainingPlanTemplate/trainingPlanTemplate.html',
                    controller: 'TrainingPlanTemplateController',
                    controllerAs: 'vm',
                    title: 'TrainingPlanTemplate'
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.administration.weeklyTrainingPlan')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'administration.weeklyTrainingPlan',
                config: {
                    url: '/weeklyTrainingPlan',
                    templateUrl: 'app/administration/weeklyTrainingPlan/weeklyTrainingPlan.html'
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    WeeklyTrainingPlanListController.$inject = ["dataservice", "log", "$q", "$state", "gettextCatalog", "paramHelper", "$scope", "authenticationService", "$rootScope", "$timeout"];
    angular
        .module('app.administration.weeklyTrainingPlan.weeklyTrainingPlanList')
        .controller('WeeklyTrainingPlanListController', WeeklyTrainingPlanListController);

    function WeeklyTrainingPlanListController(dataservice, log, $q, $state, gettextCatalog, paramHelper, $scope, authenticationService, $rootScope, $timeout) {
        var vm = this;
        $rootScope.vm = vm;

        function setInitVals() {
            $rootScope.title = gettextCatalog.getString('WeeklyTrainingPlan');
            //grid adatai
            vm.columns = [];

            vm.coachList = [];
            vm.selectedCoach = 0;

            vm.sectionList = [];
            vm.selectedSection = 0;

            vm.ageGroupList = [];
            vm.selectedAgeGroup = 0;

            vm.years = [];
            var evIg = new Date().getFullYear();
            var december = (new Date().getMonth() === 11);
            if (december) {
                evIg++;
            }
            for (var ev = 2010; ev <= evIg; ev++) {
                vm.years.push(ev);
            }

            //Kiválasztott év (alapból az aktuális)
            vm.selectedYear = new Date().getFullYear();
            vm.selectedRowId = -1;

            vm.textSearch = '';

            vm.delEnabled = false;
        }

        setInitVals();

        vm.coachChanged = coachChanged;
        vm.coachDataBound = coachDataBound;
        vm.sectionChanged = sectionChanged;
        vm.ageGroupChanged = ageGroupChanged;
        vm.yearChanged = yearChanged;
        vm.sectionDataBound = sectionDataBound;
        vm.ageGroupDataBound = ageGroupDataBound;
        vm.refreshData = refreshData;
        vm.goToNewUser = goToNewUser;
        vm.goToNewAgeGroup = goToNewAgeGroup;
        vm.goToWeeklyTrainingPlan = goToWeeklyTrainingPlan;
        vm.createNewWeeklyTrainingPlan = goToNewWeeklyTrainingPlan;
        vm.deleteWeeklyTrainingPlan = deleteWeeklyTrainingPlan;

        activate();

        function activate() {
            var promises = [paramHelper.getParams([], ['weeklyTrainingPlan.edzoId', 'weeklyTrainingPlan.szakosztalyId', 'weeklyTrainingPlan.korosztalyId', 'weeklyTrainingPlan.ev', 'weeklyTrainingPlan.szoveg']),
                authenticationService.getRight('UJHETIEDZTERV'),
                authenticationService.getRight('MODHETIEDZTERV'),
                authenticationService.getRight('MEGTHETIEDZTERV'),
                authenticationService.getRight('MEGTFELH'),
                authenticationService.getRight('MEGTKOROKEZ'),
                authenticationService.getRight('TORLHETIEDZTERV')];

            return $q.all(promises).then(function (results) {
                vm.UJHETIEDZTERV = results[1];
                vm.MODHETIEDZTERV = results[2];
                vm.MEGTHETIEDZTERV = results[3];
                vm.MEGTFELH = results[4];
                vm.MEGTKOROKEZ = results[5];
                vm.TORLHETIEDZTERV = results[6];
                if (!vm.MEGTHETIEDZTERV) {
                    log.permissionError(true);
                    return;
                }
                getCoaches();

                if (results[0]['weeklyTrainingPlan.edzoId'] !== undefined) {
                    vm.selectedCoach = results[0]['weeklyTrainingPlan.edzoId'];
                }
                if (results[0]['weeklyTrainingPlan.szakosztalyId'] !== undefined) {
                    vm.selectedSection = results[0]['weeklyTrainingPlan.szakosztalyId'];
                }
                if (results[0]['weeklyTrainingPlan.korosztalyId'] !== undefined) {
                    vm.selectedAgeGroup = results[0]['weeklyTrainingPlan.korosztalyId'];
                }
                if (results[0]['weeklyTrainingPlan.szoveg'] !== undefined) {
                    vm.textSearch = results[0]['weeklyTrainingPlan.szoveg'];
                }
                if (results[0]['weeklyTrainingPlan.ev']) {
                    vm.selectedYear = results[0]['weeklyTrainingPlan.ev'];
                } else {
                    vm.selectedYear = new Date().getFullYear();
                }
                $timeout(function () {
                    if (vm.selectedCoach > 0 && vm.selectedSection > 0 && vm.selectedAgeGroup > 0 && vm.selectedYear > 0) {
                        refreshData();
                    }
                    angular.element('#maEv').ejDropDownList({value: vm.selectedYear});
                    $scope.$apply();
                }, 500);
            });
        }

        //edzők lekérése
        function getCoaches() {
            return dataservice.coachSelect().then(
                function (data) {
                    vm.coachList = data.itemsList;

                    angular.element('#maEdzo').ejDropDownList({dataSource: vm.coachList});
                    if (vm.coachList.length === 1) {
                        vm.selectedCoach = vm.coachList[0].value;
                    }
                }
            );
        }

        //Grid oszlopainak definíciója
        vm.columns = [
            {
                field: 'Id', visible: false, isPrimaryKey: true, isIdentity: true
            },
            {
                field: 'Link',
                headerText: '',
                textAlign: 'center',
                allowEditing: false,
                template: '#wetrpllitemplateDataColumn3',
                width: 60
            },
            {
                field: 'Edzo', headerText: gettextCatalog.getString('Coach'),
                textAlign: 'center',
                allowEditing: false,
                template: '#wetrpllitemplateDataColumn1',
                width: 150
            },
            {
                field: 'Szakosztaly',
                headerText: gettextCatalog.getString('Section'),
                textAlign: 'center',
                allowEditing: false,
                width: 150
            },
            {
                field: 'Korosztaly', headerText: gettextCatalog.getString('AgeGroup'),
                textAlign: 'center',
                allowEditing: false,
                template: '#wetrpllitemplateDataColumn2',
                width: 150
            },
            {
                field: 'FelkHetSzama',
                headerText: gettextCatalog.getString('FelkHetSzam'),
                textAlign: 'center',
                allowEditing: false,
                width: 150
            },
            {
                field: 'MakrociklusSzama',
                headerText: gettextCatalog.getString('Makrociklus'),
                textAlign: 'center',
                allowEditing: false,
                width: 150
            },
            {
                field: 'Hetfo',
                headerText: gettextCatalog.getString('Monday'),
                textAlign: 'center',
                allowEditing: false,
                width: 120
            },
            {
                field: 'Vasarnap',
                headerText: gettextCatalog.getString('Sunday'),
                textAlign: 'center',
                allowEditing: false,
                width: 120
            },
            {
                field: 'Sportolok',
                headerText: gettextCatalog.getString('Athletes'),
                textAlign: 'center',
                allowEditing: false,
                width: 120
            },
            {
                field: 'Jovahagyott',
                headerText: gettextCatalog.getString('Approved'),
                textAlign: 'center',
                allowEditing: false,
                template: '#wetrpllitemplateDataColumn4',
                width: 150
            }
        ];

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItems,
            allowPaging: true,
            allowTextWrap: true,
            allowSorting: true,
            allowExcelExport: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#Grid'), $scope);
                }
            },
            rowSelected: function (args) {
                vm.selectedRowId = args.data.Id;
                vm.delEnabled = vm.MODHETIEDZTERV;
                $scope.$apply();
            },
            rowDeselected: function () {
                vm.delEnabled = false;
                vm.selectedRowId = -1;
                $scope.$apply();
            },
            beforePrint: $rootScope.beforePrintGrid,
            printComplete: $rootScope.printCompleteGrid
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        //edző dropdownlist selectionchanged
        function coachChanged(args) {
            getSectionList(args.value);
        }

        function getSectionList(coachId) {
            return dataservice.sectionDropDownList(coachId).then(
                function (data) {
                    vm.sectionList = data.itemsList;
                }
            );
        }

        function coachDataBound() {
            if (vm.coachList.length === 1) {
                angular.element('#maEdzo').ejDropDownList('selectItemByValue', vm.coachList[0].value);
            } else {
                angular.element('#maEdzo').ejDropDownList('selectItemByValue', vm.selectedCoach);
            }
        }

        // Run after data bounded
        function sectionDataBound() {
            if (vm.sectionList.length === 1) {
                angular.element('#maSzakosztaly').ejDropDownList('selectItemByValue', vm.sectionList[0].value);
            } else {
                angular.element('#maSzakosztaly').ejDropDownList('selectItemByValue', vm.selectedSection);
            }
        }

        function sectionChanged(arg) {
            dataservice.ageGroupSelectYear(vm.selectedCoach, arg.value, vm.selectedYear).then(
                function (data) {
                    vm.ageGroupList = data.itemsList;
                    if (vm.ageGroupList.length > 1) {
                        vm.ageGroupList.unshift({value: -1, text: gettextCatalog.getString('All')});
                        /*
                            $timeout(function() {
                                angular.element('#maKorosztaly').ejDropDownList('selectItemByValue', -1);
                                $scope.$apply();
                            }, 0);
                        */
                    }
                }
            );
        }

        function ageGroupChanged(args) {
            vm.selectedAgeGroup = args.value;
        }

        // Run after data bounded
        function ageGroupDataBound() {
            if (vm.ageGroupList.length === 1) {
                angular.element('#maKorosztaly').ejDropDownList('selectItemByValue', vm.ageGroupList[0].value);
            } else {
                angular.element('#maKorosztaly').ejDropDownList('selectItemByValue', vm.selectedAgeGroup);
            }
        }

        function yearChanged(args) {
            vm.selectedYear = args.value;
            return dataservice.ageGroupSelectYear(vm.selectedCoach, vm.selectedSection, vm.selectedYear).then(
                function (data) {
                    vm.ageGroupList = data.itemsList;
                    if (vm.ageGroupList.length > 1) {
                        vm.ageGroupList.unshift({value: -1, text: gettextCatalog.getString('All')});
                    }
                }
            );
        }

        function refreshData() {
            dataservice.getWeeklyTrainingPlanList(vm.selectedCoach, vm.selectedSection, vm.selectedAgeGroup, vm.selectedYear, vm.textSearch).then(
                function (data) {
                    grid.dataSource = data.itemsList;
                    vm.delEnabled = false;
                }
            );
            paramHelper.setParams([{'weeklyTrainingPlan.edzoId': vm.selectedCoach},
                {'weeklyTrainingPlan.szakosztalyId': vm.selectedSection},
                {'weeklyTrainingPlan.korosztalyId': vm.selectedAgeGroup},
                {'weeklyTrainingPlan.ev': vm.selectedYear},
                {'weeklyTrainingPlan.szoveg': vm.textSearch}]);
        }

        function goToNewUser(edzoId) {
            if (!vm.MEGTFELH) {
                log.permissionError();
                return;
            }
            paramHelper.setParams([{'weeklyTrainingPlan.edzoId': vm.selectedCoach}, {'weeklyTrainingPlan.szakosztalyId': vm.selectedSection}, {'weeklyTrainingPlan.korosztalyId': vm.selectedAgeGroup}, {'weeklyTrainingPlan.ev': vm.selectedYear}, {'newUser.userId': edzoId}, {'weeklyTrainingPlan.szoveg': vm.textSearch}]);
            $state.go('settings.userManagement.modifyUser');
        }

        function goToNewAgeGroup(ageGroupId) {
            if (!vm.MEGTKOROKEZ) {
                log.permissionError();
                return;
            }
            paramHelper.setParams([{'weeklyTrainingPlan.edzoId': vm.selectedCoach}, {'weeklyTrainingPlan.szakosztalyId': vm.selectedSection}, {'weeklyTrainingPlan.korosztalyId': vm.selectedAgeGroup}, {'weeklyTrainingPlan.ev': vm.selectedYear}, {'ageGroups.ageGroup': ageGroupId}, {'weeklyTrainingPlan.szoveg': vm.textSearch}]);
            $state.go('athletes.ageGroups.modifyAgeGroup');
        }

        function goToWeeklyTrainingPlan(trainingPlanId) {
            if (!vm.MEGTHETIEDZTERV) {
                log.permissionError();
                return;
            }
            paramHelper.setParams([{'weeklyTrainingPlan.edzoId': vm.selectedCoach},
                {'weeklyTrainingPlan.szakosztalyId': vm.selectedSection},
                {'weeklyTrainingPlan.korosztalyId': vm.selectedAgeGroup},
                {'weeklyTrainingPlan.ev': vm.selectedYear},
                {'weeklyTrainingPlan.trainingPlanId': trainingPlanId},
                {'weeklyTrainingPlan.edzoNev': getNameByID(vm.coachList, vm.selectedCoach)},
                {'weeklyTrainingPlan.szakosztalyNev': getNameByID(vm.sectionList, vm.selectedSection)},
                {'weeklyTrainingPlan.korosztalyNev': getNameByID(vm.ageGroupList, vm.selectedAgeGroup)},
                {'weeklyTrainingPlan.szoveg': vm.textSearch}
            ]);
            $state.go('administration.weeklyTrainingPlan.weeklyTrainingPlanReport');
        }

        function goToNewWeeklyTrainingPlan() {
            if (!vm.UJHETIEDZTERV) {
                log.permissionError();
                return;
            }
            if (vm.selectedCoach == undefined || vm.selectedCoach == null || vm.selectedCoach <= 0) {
                log.errorMsg(gettextCatalog.getString('SelectCoach'), gettextCatalog.getString('Error'));
                return;
            }
            if (vm.selectedSection === undefined || vm.selectedSection == null || vm.selectedSection <= 0) {
                log.errorMsg(gettextCatalog.getString('SelectSection'), gettextCatalog.getString('Error'));
                return;
            }
            if (vm.selectedAgeGroup === undefined || vm.selectedAgeGroup == null || vm.selectedAgeGroup <= 0) {
                log.errorMsg(gettextCatalog.getString('SelectAgeGroup'), gettextCatalog.getString('Error'));
                return;
            }
            if (vm.selectedYear == undefined || vm.selectedYear == null || vm.selectedYear <= 0) {
                log.errorMsg(gettextCatalog.getString('SelectYear'), gettextCatalog.getString('Error'));
                return;
            }
            paramHelper.setParams([{'weeklyTrainingPlan.edzoId': vm.selectedCoach},
                {'weeklyTrainingPlan.szakosztalyId': vm.selectedSection},
                {'weeklyTrainingPlan.korosztalyId': vm.selectedAgeGroup},
                {'weeklyTrainingPlan.ev': vm.selectedYear},
                {'weeklyTrainingPlan.trainingPlanId': -1},
                {'weeklyTrainingPlan.edzoNev': getNameByID(vm.coachList, vm.selectedCoach)},
                {'weeklyTrainingPlan.szakosztalyNev': getNameByID(vm.sectionList, vm.selectedSection)},
                {'weeklyTrainingPlan.korosztalyNev': getNameByID(vm.ageGroupList, vm.selectedAgeGroup)},
                {'weeklyTrainingPlan.szoveg': vm.textSearch}
            ]);
            $state.go('administration.weeklyTrainingPlan.weeklyTrainingPlanReport');
        }

        function getNameByID(arr, id) {
            for (var i = 0; i < arr.length; i++) {
                if (arr[i].value == id) {
                    return arr[i].text;
                }
            }
        }

        function deleteWeeklyTrainingPlan() {
            if (vm.selectedRowId === undefined || vm.selectedRowId <= 0 && vm.delEnabled) {
                return;
            }
            swal({
                title: gettextCatalog.getString('Are you sure you want to delete the selected weekly Training Plan?'),
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: gettextCatalog.getString('Yes'),
                cancelButtonText: gettextCatalog.getString('Cancel'),
                closeOnConfirm: true,
                closeOnCancel: true
            }).then(function (isConfirm) {
                if (isConfirm.value) {
                    dataservice.deleteWeeklyTrainingPlan(vm.selectedRowId).then(
                        function (result) {
                            if (result.retValue) {
                                log.successMsg(gettextCatalog.getString('PlanDeleted'));
                                refreshData();
                                $timeout(function () {
                                    vm.delEnabled = false;
                                    $scope.$apply();
                                }, 10);
                            } else {
                                log.errorMsg('CantDeleted');
                            }
                        });
                }
            });
        }
    }
})
();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.administration.weeklyTrainingPlan.weeklyTrainingPlanList')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'administration.weeklyTrainingPlan.weeklyTrainingPlanList',
                config: {
                    url: '/weeklyTrainingPlanList',
                    templateUrl: 'app/administration/weeklyTrainingPlan/weeklyTrainingPlanList/weeklyTrainingPlanList.html',
                    controller: 'WeeklyTrainingPlanListController',
                    controllerAs: 'vm',
                    title: 'WeeklyTrainingPlan',
                    settings: {
                        navId: 272,
                        level: 2,
                        order: 7,
                        orderTitle_hu: 'Heti edzésterv',
                        orderTitle_en: 'Weekly Training Plan',
                        parentId: 2,
                        content: 'WeeklyTrainingPlan',
                        activatorPermission: '"MEGTHETIEDZTERV"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    WeeklyTrainingPlanReportController.$inject = ["dataservice", "$q", "$rootScope", "gettextCatalog", "paramHelper", "log", "$scope", "authenticationService", "$state", "$compile", "$timeout", "$filter", "$sce"];
    angular
        .module('app.administration.weeklyTrainingPlan.weeklyTrainingPlanReport')
        .controller('WeeklyTrainingPlanReportController', WeeklyTrainingPlanReportController);

    function WeeklyTrainingPlanReportController(dataservice, $q, $rootScope, gettextCatalog, paramHelper, log, $scope, authenticationService, $state, $compile, $timeout, $filter, $sce) {
        var vm = this;
        $rootScope.vm = vm;

        $rootScope.title = gettextCatalog.getString('Weekly Training Plan');
        vm.EditText = gettextCatalog.getString('Edit');
        var printOpened = false;
        var printOpened2 = false;
        vm.trainingPlanId = -1;
        vm.editedWTP = {};
        vm.editedWTP.Hetfo = undefined;
        vm.hetfodatum = undefined;
        vm.copyEnabled = false;
        vm.save = save;
        vm.files = openFiles;
        vm.print = showPrint;
        vm.print2 = showPrint2;
        vm.MondayChange = MondayChange;
        vm.copyFromOldPlan = copyFromOldPlan;
        vm.editTraining = editTraining;
        vm.columnsPopup = [];
        vm.selectedRowIndexPopup = -1;
        vm.athleteListHeight = 0;
        vm.selectedRowIndex = -1;
        vm.selectedRow = -1;
        vm.closeEarlierWeeklyPlanWindow = closeEarlierWeeklyPlanWindow;
        vm.selectEarlierWeeklyPlanWindow = selectEarlierWeeklyPlanWindow;
        vm.editDateTemplate = editDateTemplate;
        vm.loadEvents = loadEvents;
        vm.SectionLeaderApprove = SectionLeaderApprove;
        vm.daySelect = daySelect;
        vm.editDay = editDay;
        vm.del = del;
        vm.ok = ok;
        vm.back = back;
        vm.cancel = cancel;
        vm.addNew = addNew;
        vm.addBtnEnabled = true;
        vm.editBtnEnabled = false;
        vm.deleteBtnEnabled = false;
        vm.editEnabled = false;
        vm.checkedItems = [];
        vm.checkedIndices = [];
        vm.athletesChange = athletesChange;
        vm.selectAll = selectAll;
        vm.deleteSelection = deleteSelection;
        vm.chooseTraining = chooseTraining;
        vm.chooseTrainingCancel = chooseTrainingCancel;
        vm.chooseTrainingAccept = chooseTrainingAccept;
        vm.createTrainingTemplate = createTrainingTemplate;
        vm.claimAsset = claimAsset;
        vm.openTemplate = openTemplate;
        vm.reportParametersEszkozIgenyek = [];

        vm.loadEventsEnabled = false;
        vm.caBtnEnabled = false;
        vm.days = [
            {value: 1, text: gettextCatalog.getString('Monday')},
            {value: 2, text: gettextCatalog.getString('Tuesday')},
            {value: 3, text: gettextCatalog.getString('Wednesday')},
            {value: 4, text: gettextCatalog.getString('Thursday')},
            {value: 5, text: gettextCatalog.getString('Friday')},
            {value: 6, text: gettextCatalog.getString('Saturday')},
            {value: 7, text: gettextCatalog.getString('Sunday')},
        ];
        vm.tetelColumns = [
            {field: 'id', visible: false, isPrimaryKey: true, isIdentity: true},
            {
                field: 'Datum',
                headerText: gettextCatalog.getString('Date'),
                textAlign: 'left',
                width: '10%'
            },
            {
                field: 'Nap',
                headerText: gettextCatalog.getString('Day'),
                textAlign: 'left',
                width: '10%'
            },
            {
                field: 'Tol',
                headerText: gettextCatalog.getString('From'),
                textAlign: 'left',
                width: '10%'
            },
            {
                field: 'Ig',
                headerText: gettextCatalog.getString('To'),
                textAlign: 'left',
                width: '10%'
            },
            {
                field: 'Hely',
                headerText: gettextCatalog.getString('Place'),
                textAlign: 'left',
                width: '20%'
            }
        ];

        var grid = new ej2.grids.Grid({
            dataSource: [],
            editSettings: {allowEditing: false},
            allowTextWrap: true,
            allowScrolling: true,
            allowSorting: false,
            locale: 'hu-HU',
            gridLines: 'Both',
            height: 200,
            columns: vm.tetelColumns,
            //rowSelected: vm.daySelect,
            rowSelected: function (args) {
                vm.selectedRowIndex = args.rowIndex;
                daySelect();
            },
            selectedRowIndex: vm.selectedRowIndex,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile(angular.element('#Grid'), $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        vm.columnsPopup = [
            {
                field: 'Id',
                visible: false,
                isPrimaryKey: true,
                isIdentity: true
            },
            {
                field: 'Szakosztaly',
                headerText: gettextCatalog.getString('Section'),
                textAlign: 'center',
                width: 100,
                allowEditing: false
            },
            {
                field: 'Korosztaly',
                headerText: gettextCatalog.getString('AgeGroup'),
                textAlign: 'center',
                width: 100,
                allowEditing: false
            },
            {
                field: 'FelkHetSzama',
                headerText: gettextCatalog.getString('FelkHetSzam'),
                textAlign: 'center',
                width: 50,
                allowEditing: false
            },
            {
                field: 'MakrociklusSzama',
                headerText: gettextCatalog.getString('Makrociklus'),
                textAlign: 'center',
                width: 50,
                allowEditing: false
            },
            {
                field: 'Hetfo',
                headerText: gettextCatalog.getString('Monday'),
                textAlign: 'center',
                type: 'date',
                format: 'yM',
                width: 100,
                allowEditing: false
            },
            {
                field: 'Vasarnap',
                headerText: gettextCatalog.getString('Saturday'),
                textAlign: 'center',
                type: 'date',
                format: 'yM',
                width: 100,
                allowEditing: false
            }
        ];

        var gridPopup = new ej2.grids.Grid({
            dataSource: [],
            editSettings: {allowEditing: false, allowDeleting: false, allowAdding: false},
            allowTextWrap: true,
            allowScrolling: true,
            allowSorting: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            height: 200,
            columns: vm.columnsPopup,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile(angular.element('#GridPopup'), $scope);
                }
            }
        });
        gridPopup.appendTo('#GridPopup');
        gridPopup.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, gridPopup);
        };

        vm.columnsEdzesTetelek = [
            {
                field: 'Id',
                visible: false,
                isPrimaryKey: true,
                isIdentity: true
            },
            {
                field: 'Tipus',
                headerText: gettextCatalog.getString('Tipus'),
                textAlign: 'center',
                width: 75
            },
            {
                field: 'GyakorlatNev',
                headerText: gettextCatalog.getString('GyakorlatNev'),
                textAlign: 'center',
                width: 75
            },
            {
                field: 'Mennyiseg',
                headerText: gettextCatalog.getString('Mennyiseg'),
                textAlign: 'center',
                width: 40
            }
        ];

        var gridEdzesTetelek = new ej2.grids.Grid({
            dataSource: [],
            editSettings: {allowEditing: false, allowDeleting: false, allowAdding: false},
            allowTextWrap: true,
            allowScrolling: true,
            allowSorting: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            height: 200,
            columns: vm.columnsEdzesTetelek,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile(angular.element('#GridEdzesTetelek'), $scope);
                }
            }
        });
        gridEdzesTetelek.appendTo('#GridEdzesTetelek');
        gridEdzesTetelek.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, gridEdzesTetelek);
        };

        vm.Helyek = $sce.trustAsResourceUrl('https://maps.google.it/maps?q=&output=embed');
        vm.TrainingTemplates = [];
        vm.trainingTemplate = undefined;
        vm.TrainingTemplateSelected = TrainingTemplateSelected;

        vm.edit = {};
        vm.edit.idx = -1;
        vm.edit.ac = '';
        vm.edit.Nap = '';
        vm.edit.Datum = '';
        vm.edit.Hely = '';
        vm.edit.Tol = '08:00';
        vm.edit.Ig = '17:00';
        vm.edit.Leiras = '';
        vm.edit.NapSzam = 1;
        vm.edit.Sablon = '';
        vm.edit.EdzesFejId = null;

        vm.dataEdzesTetelek = [];

        vm.tetelek = [];

        activate();

        function activate() {
            var promises = [
                paramHelper.getParams([], [
                    'weeklyTrainingPlan.edzoId',
                    'weeklyTrainingPlan.szakosztalyId',
                    'weeklyTrainingPlan.korosztalyId',
                    'weeklyTrainingPlan.ev',
                    'weeklyTrainingPlan.trainingPlanId',
                    'weeklyTrainingPlan.edzoNev',
                    'weeklyTrainingPlan.szakosztalyNev',
                    'weeklyTrainingPlan.korosztalyNev'
                ]),
                authenticationService.getRight('UJHETIEDZTERV'),
                authenticationService.getRight('MODHETIEDZTERV'),
                authenticationService.getRight('MEGTHETIEDZTERV'),
                getSystemSettings('HETIEDZTERVJOVAHAGYKOT'),
                authenticationService.getRight('SZAKOSZTVEZ'),
                authenticationService.getRight('ADMIN'),
                authenticationService.getRight('HETIEDZESTERVJOVAHAGY'),
                HetiEdzestervLegregebbiHet(),
                authenticationService.getRight('UJEDZESSABLON')
            ];
            $q.all(promises).then(function (results) {
                vm.UJHETIEDZTERV = results[1];
                vm.MODHETIEDZTERV = results[2];
                vm.MEGTHETIEDZTERV = results[3];
                vm.HETIEDZTERVJOVAHAGYKOT = results[4];
                vm.SZAKOSZTVEZ = results[5];
                vm.ADMIN = results[6];
                vm.HETIEDZESTERVJOVAHAGY = results[7];
                vm.HETIEDZTERVJOVAHAGY = vm.HETIEDZTERVJOVAHAGYKOT && (vm.ADMIN || vm.SZAKOSZTVEZ) && vm.HETIEDZESTERVJOVAHAGY;
                vm.JOVAHAGYOTT = false;
                vm.UJEDZESSABLON = results[9];
                if (!vm.MEGTHETIEDZTERV) {
                    log.permissionError(true);
                    return;
                }
                vm.trainingPlanId = results[0]['weeklyTrainingPlan.trainingPlanId'];
                if (angular.isDefined(vm.trainingPlanId) && vm.trainingPlanId !== -1) { // VAN EDZÉS TERV
                    dataservice.weeklyTrainingPlanSelectByIdNew(vm.trainingPlanId).then(function (data) {
                        vm.editedWTP = data.retValue;
                        vm.JOVAHAGYOTT = vm.editedWTP.Jovahagyott;
                        if (vm.JOVAHAGYOTT) {
                            vm.HETIEDZTERVJOVAHAGY = false;
                        }
                        vm.editedWTP.Keszult = $filter('dateStringFilter')(vm.editedWTP.Keszult);
                        vm.tetelek = data.retValue.gridData;
                        vm.tetelek = $filter('dateStringFilter')(vm.tetelek, 'Datum');
                        grid.dataSource = vm.tetelek;
                        vm.copyEnabled = false;
                        vm.loadEventsEnabled = true;
                        vm.athletes = data.retValue.checkedItems;
                        vm.athleteListHeight = vm.athletes.length * 15;
                        $timeout(function () {
                            vm.Helyek = $sce.trustAsResourceUrl('https://maps.google.it/maps?q=&output=embed');
                            vm.edit.Hely = $sce.trustAsResourceUrl('https://maps.google.it/maps?q=&output=embed');
                            $scope.$apply();
                            vm.edit.Hely = '';
                        }, 10);
                        $timeout(function () {
                            grid.refresh();
                            if (data.retValue.mindenki === false) {
                                data.retValue.checkedIndices.forEach(function (chk) {
                                    var index = $filter('getIndex')(data.retValue.checkedItems, 'value', chk);
                                    $('#athletesList').ejListBox('checkItemByIndex', index);
                                });
                            } else {
                                selectAll();
                            }
                        }, 1000);
                    });
                } else { // NINCS EDZÉS TERV
                    vm.editedWTP.EdzoNev = results[0]['weeklyTrainingPlan.edzoNev'];
                    vm.editedWTP.SzakosztalyNev = results[0]['weeklyTrainingPlan.szakosztalyNev'];
                    vm.editedWTP.KorosztalyNev = results[0]['weeklyTrainingPlan.korosztalyNev'];
                    vm.editedWTP.Keszult = $filter('dateStringFilter')(new Date());
                    vm.editedWTP.IdEdzo = results[0]['weeklyTrainingPlan.edzoId'];
                    vm.editedWTP.IdSzakosztaly = results[0]['weeklyTrainingPlan.szakosztalyId'];
                    vm.editedWTP.IdKorosztaly = results[0]['weeklyTrainingPlan.korosztalyId'];
                    dataservice.getAthletesForWeeklyTrainingPlan(vm.editedWTP.IdEdzo, vm.editedWTP.IdKorosztaly).then(function (data) {
                        vm.athletes = data.itemsList;
                        vm.athleteListHeight = vm.athletes.length * 15;
                        $timeout(function () {
                            angular.element('#deHetfo').ejDatePicker({minDate: results[8].data});
                            selectAll();
                        }, 1000);
                    });
                }
            });
        }

        function daySelect() {
            var changed = false;
            if (vm.selectedRow >= 0 && vm.edit && vm.tetelek[vm.selectedRow] &&
                (
                    vm.edit.EdzesFejId !== vm.tetelek[vm.selectedRow].EdzesFejId ||
                    vm.edit.Datum !== vm.tetelek[vm.selectedRow].Datum ||
                    vm.edit.Hely !== vm.tetelek[vm.selectedRow].Hely ||
                    vm.edit.Ig !== vm.tetelek[vm.selectedRow].Ig ||
                    vm.edit.Tol !== vm.tetelek[vm.selectedRow].Tol ||
                    vm.edit.Leiras !== vm.tetelek[vm.selectedRow].Leiras ||
                    vm.edit.Nap !== vm.tetelek[vm.selectedRow].Nap ||
                    vm.edit.NapSzam != vm.tetelek[vm.selectedRow].NapSzam
                )
            ) {
                changed = true;
            }
            // Éppen szerkesztés közben kattint el
            if (vm.editEnabled && changed) {
                swal({
                    title: gettextCatalog.getString('DoYouWantToSaveChanges?'),
                    type: 'question',
                    showCancelButton: true,
                    confirmButtonColor: '#DD6B55',
                    confirmButtonText: gettextCatalog.getString('Yes'),
                    cancelButtonText: gettextCatalog.getString('No')
                }).then(function (isConfirm) {
                    if (isConfirm.value) {
                        ok();
                        vm.selectedRow = vm.selectedRowIndex;
                        $timeout(function () {
                            vm.editBtnEnabled = true;
                            vm.deleteBtnEnabled = vm.JOVAHAGYOTT === false;
                            editDay();
                            $scope.$apply();
                        }, 300);
                    } else {
                        cancel();
                        vm.selectedRow = vm.selectedRowIndex;
                        $timeout(function () {
                            vm.editBtnEnabled = true;
                            vm.deleteBtnEnabled = vm.JOVAHAGYOTT === false;
                            editDay();
                            $scope.$apply();
                        }, 300);
                    }
                });
            } else {
                $timeout(function () {
                    vm.editBtnEnabled = true;
                    vm.deleteBtnEnabled = vm.JOVAHAGYOTT === false;
                    vm.selectedRow = vm.selectedRowIndex;
                    editDay();
                    $scope.$apply();
                }, 0);
            }
        }

        function addNew() {
            if (!vm.editedWTP.Hetfo) {
                log.errorMsg(gettextCatalog.getString('ChooseMondayFirst'));
                return;
            }
            vm.edit = {};
            vm.edit.idx = -1;
            vm.edit.Helyek = [];
            vm.edit.Nap = '';
            vm.edit.Datum = '';
            vm.edit.Hely = '';
            vm.edit.Tol = '08:00';
            vm.edit.Ig = '17:00';
            vm.edit.Leiras = '';
            vm.edit.NapSzam = 1;
            vm.edit.Sablon = '';
            vm.editEnabled = true;
        }

        function editTraining(idx) {
            vm.editEnabled = true;
            vm.edit.idx = idx;
            vm.edit.Nap = vm.tetelek[idx].Nap;
            vm.edit.Datum = vm.tetelek[idx].Datum;
            vm.edit.Hely = vm.tetelek[idx].Hely;
            vm.edit.Tol = vm.tetelek[idx].Tol;
            vm.edit.Ig = vm.tetelek[idx].Ig;
            vm.edit.Leiras = vm.tetelek[idx].Leiras;
            vm.edit.NapSzam = vm.tetelek[idx].NapSzam;
            vm.edit.EdzesFejId = vm.tetelek[idx].EdzesFejId;
            vm.edit.Sablon = vm.tetelek[idx].Sablon;
            vm.edit.ac = vm.tetelek[idx].ac;
            if (vm.edit.Hely) {
                vm.Helyek = $sce.trustAsResourceUrl('https://maps.google.it/maps?q=' + vm.edit.Hely + '&output=embed');
            }
            vm.caBtnEnabled = vm.edit.EdzesFejId > 0;
            if (vm.edit.EdzesFejId > 0) {
                angular.element('#ct').ejButton({text: gettextCatalog.getString('ChangeTemplate')});
            } else {
                angular.element('#ct').ejButton({text: gettextCatalog.getString('ChooseTemplate')});
            }
        }

        function editDay() {
            $timeout(function () {
                vm.editEnabled = false;
                editTraining(vm.selectedRow);
                $scope.$apply();
            }, 0);
        }

        function del() {
            swal({
                title: gettextCatalog.getString('AreYouSureYouWantToDeleteRecord?'),
                type: 'question',
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: gettextCatalog.getString('Yes'),
                cancelButtonText: gettextCatalog.getString('No')
            }).then(function (isConfirm) {
                if (isConfirm.value) {
                    vm.editBtnEnabled = false;
                    vm.deleteBtnEnabled = false;
                    vm.editEnabled = false;
                    vm.tetelek.splice(vm.selectedRow, 1);
                    for (var i = 0; i < vm.tetelek.length; i++) {
                        vm.tetelek[i].id = i;
                    }
                    grid.dataSource = vm.tetelek;
                    cancel();
                }
            }, function () {
            });
        }

        function cancel() {
            $timeout(function () {
                vm.editEnabled = false;
                vm.deleteBtnEnabled = false;
                grid.refresh();
                $scope.$apply();
            }, 10);
        }

        function ok() {
            vm.edit.Hely = $('#Hely').val();
            var Datum = $filter('addDays')(vm.editedWTP.Hetfo, vm.edit.NapSzam - 1);
            $timeout(function () {
                if (vm.edit.idx >= 0) {
                    vm.tetelek[vm.edit.idx].Sablon = vm.edit.Sablon;
                    vm.tetelek[vm.edit.idx].EdzesFejId = vm.edit.EdzesFejId;
                    vm.tetelek[vm.edit.idx].Hely = vm.edit.Hely;
                    vm.tetelek[vm.edit.idx].Tol = vm.edit.Tol;
                    vm.tetelek[vm.edit.idx].Ig = vm.edit.Ig;
                    vm.tetelek[vm.edit.idx].Leiras = vm.edit.Leiras;
                    vm.tetelek[vm.edit.idx].NapSzam = vm.edit.NapSzam;
                    vm.tetelek[vm.edit.idx].Nap = NumberOfDayToWeekDay(vm.edit.NapSzam);
                    vm.tetelek[vm.edit.idx].Datum = $filter('addDays')(vm.editedWTP.Hetfo, vm.edit.NapSzam - 1);
                } else {
                    var id = -1;
                    for (var i = 0; i < vm.tetelek.length; i++) {
                        if (vm.tetelek[i].id > id) {
                            id = vm.tetelek[i].id;
                        }
                    }
                    vm.tetelek.push(
                        {
                            Nap: NumberOfDayToWeekDay(vm.edit.NapSzam),
                            Datum: $filter('addDays')(vm.editedWTP.Hetfo, vm.edit.NapSzam - 1),
                            Hely: vm.edit.Hely,
                            Tol: vm.edit.Tol,
                            Ig: vm.edit.Ig,
                            Leiras: vm.edit.Leiras,
                            NapSzam: vm.edit.NapSzam,
                            EdzesFejId: vm.edit.EdzesFejId,
                            Sablon: vm.edit.Sablon,
                            id: ++id
                        }
                    );
                }
                grid.dataSource = vm.tetelek;
                vm.editEnabled = false;
                vm.deleteBtnEnabled = false;
                grid.refresh();
                $scope.$apply();
            }, 10);
        }

        function chooseTrainingCancel() {
            angular.element('#ChooseTrainingWindow').data('ejDialog').close();
            gridEdzesTetelek.dataSource = [];
        }

        function chooseTrainingAccept(arg) {
            angular.element('#ChooseTrainingWindow').data('ejDialog').close();
            vm.edit.EdzesFejId = vm.SelectedEdzesFejId;
            vm.edit.Sablon = vm.EdzesSablonNev;
            vm.edit.ac = vm.EdzesSablonHosszuNev;
            switch (arg) {
                case 'copy':
                    if (vm.EdzesTetelLeiras) {
                        if (vm.edit.Leiras && vm.edit.Leiras.length > 0) {
                            swal({
                                title: gettextCatalog.getString('AreYouSureYouWantToReplaceTrainingDescription?'),
                                type: 'question',
                                showCancelButton: true,
                                confirmButtonColor: '#DD6B55',
                                confirmButtonText: gettextCatalog.getString('Yes'),
                                cancelButtonText: gettextCatalog.getString('No')
                            }).then(function (isConfirm) {
                                if (isConfirm.value) {
                                    $timeout(function () {
                                        vm.edit.Leiras = vm.EdzesTetelLeiras;
                                    }, 10);
                                }
                            }, function () {
                            });
                        } else {
                            vm.edit.Leiras = vm.EdzesTetelLeiras;
                        }
                    }
                    break;
                case 'append':
                    if (vm.EdzesTetelLeiras) {
                        vm.edit.Leiras = vm.edit.Leiras + ', ' + vm.EdzesTetelLeiras;
                    }
                    break;
            }
        }

        function chooseTraining() {
            vm.EdzesTetelLeiras = '';
            vm.TrainingTemplates = [];
            vm.dataEdzesTetelek = [];
            dataservice.EdzesFejLista(vm.editedWTP.IdSzakosztaly, vm.editedWTP.IdKorosztaly).then(function (response) {
                vm.TrainingTemplates = response.itemsList;
                vm.trainingTemplate = '';
                if (vm.edit.ac && vm.edit.ac.length > 0) {
                    vm.trainingTemplate = vm.edit.ac;
                    TrainingTemplateSelected(vm.edit.ac, vm.edit.EdzesFejId);
                }
                angular.element('#TrainingTemplate').ejAutocomplete({
                    dataSource: vm.TrainingTemplates,
                    fields: {key: 'value', text: 'text'},
                    multiSelectMode: 'none',
                    multiColumnSettings: {
                        enable: true,
                        showHeader: true,
                        columns: [
                            {field: 'text', headerText: 'EdzesFejNeve', key: 'value'},
                            {field: 'szakosztaly', headerText: 'Szakosztaly', key: 'value'},
                            {field: 'korosztaly', headerText: 'Korosztaly', key: 'value'}
                        ]
                    },
                    showPopupButton: true,
                    showEmptyResultText: true,
                    select: function (arg) {
                        vm.dataEdzesTetelek = [];
                        TrainingTemplateSelected(arg.value, arg.item.value);
                        arg.cancel = true;
                    },
                    value: vm.trainingTemplate,
                    width: '100%'
                });
                angular.element('#ChooseTrainingWindow').data('ejDialog').open();
            });
            gridEdzesTetelek.dataSource = [];
        }

        function TrainingTemplateSelected(name, EdzesFejId) {
            vm.EdzesTetelLeiras = '';
            vm.EdzesSablonNev = '';
            vm.EdzesSablonHosszuNev = '';
            if (!(EdzesFejId > 0)) {
                return;
            }
            dataservice.EdzesSablon(EdzesFejId).then(function (response) {
                if (response.data && response.data.found) {
                    vm.SelectedEdzesFejId = response.data.EdzesFejId;
                    vm.EdzesTetelLeiras = response.data.Leiras;
                    vm.dataEdzesTetelek = response.data.Tetelek;
                    vm.EdzesSablonNev = response.data.Nev;
                    vm.EdzesSablonHosszuNev = name;
                    gridEdzesTetelek.dataSource = vm.dataEdzesTetelek;
                }
            });
        }

        function createTrainingTemplate() {
            if (!vm.UJEDZESSABLON) {
                log.permissionError();
                return;
            }
            angular.element('#ChooseTrainingWindow').data('ejDialog').close();
            swal({
                title: gettextCatalog.getString('DoYouWantToSaveChanges?'),
                type: 'question',
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: gettextCatalog.getString('Yes'),
                cancelButtonText: gettextCatalog.getString('No')
            }).then(function (isConfirm) {
                if (isConfirm.value) {
                    save(true, false);
                }
                $timeout(function () {
                    paramHelper.setParams([{'trainingPlanCreate.trainingId': -1}]);
                    $state.go('administration.trainingPlan.trainingPlanCreate');
                }, 700);
            }, function () { });
        }

        function NumberOfDayToWeekDay(napSzam) {
            // return vm.days[parseInt(napSzam)];
            switch (napSzam) {
                case 1:
                case '1':
                    return gettextCatalog.getString('Monday');
                    break;
                case 2:
                case '2':
                    return gettextCatalog.getString('Tuesday');
                    break;
                case 3:
                case '3':
                    return gettextCatalog.getString('Wednesday');
                    break;
                case 4:
                case '4':
                    return gettextCatalog.getString('Thursday');
                    break;
                case 5:
                case '5':
                    return gettextCatalog.getString('Friday');
                    break;
                case 6:
                case '6':
                    return gettextCatalog.getString('Saturday');
                    break;
                case 7:
                case '7':
                    return gettextCatalog.getString('Sunday');
                    break;
            }
        }

        function getRowIndexForDate(date) {
            for (var i = 0; i < vm.data.length; i++) {
                if (vm.data[i].Datum == date) {
                    return i;
                }
            }
            return -1;
        }

        function loadEvents() {
            if (!vm.loadEventsEnabled) {
                return;
            }
            dataservice.EsemenyekAttolteseHetiEdzestervre(vm.editedWTP.IdEdzo, vm.editedWTP.IdKorosztaly, vm.editedWTP.Hetfo).then(function () {
                grid.refresh();
            });
        }

        function save(createEvents, navigateBack) {
            createEvents = true;
            if (vm.editEnabled) {
                ok();
            }
            if (vm.UJHETIEDZTERV || vm.MODHETIEDZTERV) {
                $timeout(function () {
                    $scope.$broadcast('submitted');
                    grid.refresh();
                    if ($scope.form.$valid === false) {
                        log.errorMsg('FillTheRequiredFields');
                    } else {
                        var temp = $('#athletesList').ejListBox('getCheckedItems');
                        console.log('temp', temp);
                        vm.checkedItems = [];
                        temp.forEach(function (t) {
                            vm.checkedItems.push(t.data);
                        });
                        var mindenki = temp.length === vm.athletes.length;
                        dataservice.saveWeeklyTrainingPlanNew(vm.editedWTP, vm.tetelek, createEvents, mindenki, vm.checkedItems).then(function () {
                            log.successMsg('SavedSuccessful');
                            if (navigateBack !== false) {
                                back();
                            }
                        });
                    }
                }, 400);
            }
        }

        function openFiles() {
            paramHelper.setParams([
                {'weeklyTrainingPlan.edzoId': vm.editedWTP.IdEdzo},
                {'weeklyTrainingPlan.szakosztalyId': vm.editedWTP.IdSzakosztaly},
                {'weeklyTrainingPlan.korosztalyId': vm.editedWTP.IdKorosztaly},
                {'weeklyTrainingPlan.ev': vm.selectedYear},
                {'weeklyTrainingPlan.trainingPlanId': vm.editedWTP.Id},
                {'weeklyTrainingPlan.edzoNev': vm.editedWTP.EdzoNev},
                {'weeklyTrainingPlan.szakosztalyNev': vm.editedWTP.SzakosztalyNev},
                {'weeklyTrainingPlan.korosztalyNev': vm.editedWTP.KorosztalyNev},
                {'files.tipus': 'EdzesTervHeti'},
                {'files.tablaId': vm.editedWTP.Id}
            ]);
            $state.go('other.files');
        }

        function showPrint() {
            var tetelek = $.extend(true, [], vm.tetelek);
            vm.reportParameters = {
                id: vm.editedWTP.Id,
                szakosztaly: vm.editedWTP.SzakosztalyNev,
                korosztaly: vm.editedWTP.KorosztalyNev,
                edzo: vm.editedWTP.EdzoNev,
                keszult: vm.editedWTP.Keszult,
                makrociklus: vm.editedWTP.Makrociklus,
                hetfo: vm.editedWTP.Hetfo,
                vasarnap: vm.editedWTP.Vasarnap,
                felkhet: vm.editedWTP.HetSzama,
                tetelek: tetelek
            };
            $timeout(function () {
                if (printOpened) {
                    angular.element('#printDialog').ejDialog('open');
                } else {
                    printOpened = true;
                    angular.element('#printDialog').ejDialog({
                        height: '99%',
                        width: '99%',
                        enablemodal: 'true',
                        'position-x': '0',
                        'position-y': '1',
                        target: '#mainContent',
                        enableresize: 'false'
                    });
                }
            }, 500);
        }

        function MondayChange() {
            var sDate = angular.element('#deHetfo').data('ejDatePicker').getValue();
            var sMonday = $filter('startOfWeek')(sDate);
            var sSunday = $filter('endOfWeek')(sDate);
            angular.element('#deHetfo').ejDatePicker({value: sMonday});
            vm.editedWTP.Hetfo = sMonday;
            vm.editedWTP.Vasarnap = sSunday;
            vm.loadEventsEnabled = true;
            if (vm.editedWTP.HetSzama === undefined || vm.editedWTP.HetSzama == null || vm.editedWTP.HetSzama === '' || vm.editedWTP.HetSzama == 0 || vm.editedWTP.HetSzama == '0') {
                vm.editedWTP.HetSzama = $filter('stringToMoment')(sDate).week();
            }
            $timeout(function () {
                for (var i = 0; i < vm.tetelek.length; i++) {
                    vm.tetelek[i].Datum = $filter('addDays')(sMonday, vm.tetelek[i].NapSzam - 1);
                }
                grid.refresh();
                $scope.$apply();
                grid.dataSource = vm.tetelek;
            }, 100);
            if (vm.trainingPlanId == -1) {
                vm.copyEnabled = true;
            }
        }

        function copyFromOldPlan() {
            if (vm.trainingPlanId > 0) {
                log.infoMsg(gettextCatalog.getString('FormerWeeklyTrainingPlanCanOnlyBeCopiedToNewPlans'));
                return;
            }
            if (!vm.copyEnabled) {
                log.infoMsg(gettextCatalog.getString('ChooseMondayFirst'));
                return;
            }
            vm.selectedRowIndexPopup = -1;
            var dialogObj = angular.element('#searchWindow').data('ejDialog');
            dialogObj.open();
            dataservice.getOldWeeklyPlanByUserId(vm.editedWTP.IdEdzo, vm.editedWTP.Id).then(function (args) {
                gridPopup.dataSource = args.itemsList;
            });
        }

        function closeEarlierWeeklyPlanWindow() {
            var dialogObj = angular.element('#searchWindow').data('ejDialog');
            dialogObj.close();
        }

        function selectEarlierWeeklyPlanWindow() {
            var oldPlan = $rootScope.getSelectedItems(gridPopup)[0];
            if (oldPlan) {
                dataservice.weeklyTrainingPlanSelectByIdNew(oldPlan.Id).then(function (data) {
                    vm.tetelek = [];
                    for (var i = 0; i < data.retValue.gridData.length; i++) {
                        var NapSzam = 1;
                        switch (data.retValue.gridData[i].Nap) {
                            case gettextCatalog.getString('Monday'):
                                NapSzam = 1;
                                break;
                            case gettextCatalog.getString('Tuesday'):
                                NapSzam = 2;
                                break;
                            case gettextCatalog.getString('Wednesday'):
                                NapSzam = 3;
                                break;
                            case gettextCatalog.getString('Thursday'):
                                NapSzam = 4;
                                break;
                            case gettextCatalog.getString('Friday'):
                                NapSzam = 5;
                                break;
                            case gettextCatalog.getString('Saturday'):
                                NapSzam = 6;
                                break;
                            case gettextCatalog.getString('Sunday'):
                                NapSzam = 7;
                                break;
                        }
                        data.retValue.gridData[i].Datum = $filter('addDays')(vm.editedWTP.Hetfo, NapSzam - 1);
                        vm.tetelek.push(data.retValue.gridData[i]);
                    }
                    grid.dataSource = vm.tetelek;
                });
                var dialogObj = angular.element('#searchWindow').data('ejDialog');
                dialogObj.close();
            }
        }

        function editDateTemplate() {
            return {
                create: function () {
                    return '<input type="text">';
                },
                read: function (args) {
                    return args[0].value;
                },
                write: function (args) {
                    var s = args.element[0].id.toString().replace('Grid', '');
                    var q = args.element.ejTimePicker({
                        value: args.rowdata !== undefined ? args.rowdata[s] : '',
                        cssClass: 'gridEditTemplateTextAndButton',
                        timeFormat: 'HH:mm'
                    });
                    vm.editedRowId = args.rowdata['Id'];
                    $compile(args.element.context[1])($scope);
                    return q;
                }
            };
        }

        function athletesChange(args) {
            if (vm.JOVAHAGYOTT) {
                args.cancel = true;
                return;
            }
            if (args.isChecked) {
                vm.checkedItems.push({value: args.value, text: args.text});
            } else {
                vm.checkedItems.splice(vm.checkedItems.indexOf({value: args.value, text: args.text}), 1);
            }
        }

        function selectAll() {
            $('#athletesList').ejListBox('checkAll');
            vm.checkedItems = $.extend(true, [], vm.athletes);
        }

        function deleteSelection() {
            $('#athletesList').ejListBox('uncheckAll');
            vm.checkedItems = [];
        }

        function getSystemSettings(valtozo) {
            return dataservice.getSystemSettings(valtozo).then(function (response) {
                return response.retValue;
            });
        }

        function SectionLeaderApprove() {
            dataservice.HetiEdzesTervJovahagyas(vm.editedWTP.Id).then(function () {
                log.successMsg(gettextCatalog.getString('WeeklyTraningPlanApproved'));
                vm.HETIEDZTERVJOVAHAGY = false;
                vm.JOVAHAGYOTT = true;
                $rootScope.back();
            });
        }

        function claimAsset() {
            dataservice.EszkozIgenyLista(vm.edit.EdzesFejId).then(function (response) {
                var neededAssets = [];
                for (var i = 0; i < response.data.length; i++) {
                    neededAssets.push({id: 'asset' + i, text: response.data[i], value: 1});
                }
                var HTMLtext = createHtmlSwalContent(neededAssets);
                swal({
                    title: gettextCatalog.getString('PrintAssetClaim'),
                    html: HTMLtext,
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonColor: '#DD6B55',
                    confirmButtonText: gettextCatalog.getString('Ok'),
                    cancelButtonText: gettextCatalog.getString('Cancel'),
                }).then(function (isConfirm) {
                    if (isConfirm.value) {
                        var neededAssetParams = [];
                        for (var i = 0; i < response.data.length; i++) {
                            var val = document.getElementById('asset' + i).value;
                            if (val) {
                                neededAssetParams.push({name: response.data[i], value: val});
                            }
                        }
                        showPrint2(neededAssetParams);
                    }
                }, function () {
                });
            });
        }

        function showPrint2(arg) {
            var items = $.extend(true, [], arg);
            vm.reportParameters2 = {
                edzo: vm.editedWTP.EdzoNev,
                szakosztaly: vm.editedWTP.SzakosztalyNev,
                korosztaly: vm.editedWTP.KorosztalyNev,
                datum: vm.edit.Datum,
                elemek: items
            };
            $timeout(function () {
                if (printOpened2) {
                    angular.element('#printDialog2').ejDialog('open');
                } else {
                    printOpened2 = true;
                    angular.element('#printDialog2').ejDialog({
                        height: '99%',
                        width: '99%',
                        enablemodal: 'true',
                        'position-x': '0',
                        'position-y': '1',
                        target: '#mainContent',
                        enableresize: 'false'
                    });
                }
            }, 500);
        }

        function createHtmlSwalContent(arr) {
            var HTMLtext = '<div style="margin-top: 10px;" >';
            arr.forEach(function (item) {
                HTMLtext += '<div class="row">';
                if (item.hasOwnProperty('cb')) {
                    HTMLtext += '<label class="col-lg-6" style="text-align: left; margin-top:7px;">' + item.text + '</label>';
                    HTMLtext += '<div style="float:left;">';
                    HTMLtext += '<div class="col-lg-6"><input id="' + item.id + '" ej-checkbox></input></div><br>';
                    HTMLtext += '</div>';
                } else if (item.hasOwnProperty('cp')) {
                    HTMLtext += '<label class="col-lg-6" style="text-align: left; margin-top:7px;">' + item.text + '</label>';
                    HTMLtext += '<div class="col-lg-6"><input id="' + item.id + '" ej-colorpicker></input></div><br>';
                } else if (item.hasOwnProperty('ac')) {
                    HTMLtext += '<label class="col-lg-6" style="text-align: left; margin-top:7px;">' + item.text + '</label>';
                    HTMLtext += '<div class="col-lg-6"><input id="AutoCompleteSwal" ej-autocomplete></input></div><br>';
                } else if (item.hasOwnProperty('dd')) {
                    HTMLtext += '<br>';
                    HTMLtext += '<label class="col-lg-6" style="text-align: left; margin-top:7px;">' + item.text + '</label>';
                    HTMLtext += '<div class="col-lg-6"><input id="' + item.id + '" ej-dropdownlist e-width="100%"></input></div><br>';
                } else {
                    HTMLtext += '<label class="col-lg-6" style="text-align: left; margin-top:7px;">' + item.text + '</label>';
                    if (item.value && item.value.length > 0) {
                        HTMLtext += '<div class="col-lg-6"><input type="text" value="' + item.value + '" id="' + item.id + '"></input></div><br>';
                    } else {
                        HTMLtext += '<div class="col-lg-6"><input type="text" value="" id="' + item.id + '"></input></div><br>';
                    }
                }
                HTMLtext += '</div>';
            });
            HTMLtext += '</div>';
            return HTMLtext;
        }

        function openTemplate() {
            paramHelper.setParams([
                {'trainingPlanCreate.trainingId': vm.edit.EdzesFejId}
            ]);
            $state.go('administration.trainingPlan.trainingPlanTemplate');
        }

        function back() {
            $rootScope.back();
        }

        function HetiEdzestervLegregebbiHet() {
            return dataservice.HetiEdzestervLegregebbiHet().then(function (response) {
                return response;
            });
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.administration.weeklyTrainingPlan.weeklyTrainingPlanReport')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'administration.weeklyTrainingPlan.weeklyTrainingPlanReport',
                config: {
                    url: '/weeklyTrainingPlanReport',
                    templateUrl: 'app/administration/weeklyTrainingPlan/weeklyTrainingPlanReport/weeklyTrainingPlanReport.html',
                    controller: 'WeeklyTrainingPlanReportController',
                    controllerAs: 'vm'
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    AthleteDashboardController.$inject = ["log", "dataservice", "$q", "$rootScope", "gettextCatalog"];
    angular
        .module('app.athleteDashboard')
        .controller('AthleteDashboardController', AthleteDashboardController);

    function AthleteDashboardController(log, dataservice, $q, $rootScope, gettextCatalog) {
        $rootScope.vm = this;
        $rootScope.title = gettextCatalog.getString('AthleteDashboard');

        // Create variables

        // Public functions

        // Activate page
        activate();

        function activate() {
            var promises = [];
            $q.all(promises).then(function () {})
                .catch(function () {
                    log.permissionError();
                });
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.athleteDashboard')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'athleteDashboard',
                config: {
                    url: '/athleteDashboard',
                    templateUrl: 'app/athleteDashboard/athleteDashboard.html',
                    controller: 'AthleteDashboardController',
                    controllerAs: 'vm',
                    title: 'AthleteDashboard',
                    settings: {
                        navId: 13,
                        level: 1,
                        order: 9,
                        parentId: 0,
                        content: 'AthleteDashboard',
                        permission: ['6']
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    AddAgeGroupController.$inject = ["log", "$state", "dataservice", "authenticationService", "$q", "gettextCatalog", "$rootScope", "paramHelper", "$window", "$scope"];
    angular
        .module('app.athletes.ageGroups.addAgeGroup')
        .controller('AddAgeGroupController', AddAgeGroupController);

    function AddAgeGroupController(log, $state, dataservice, authenticationService, $q, gettextCatalog, $rootScope, paramHelper, $window, $scope) {
        var vm = this; $rootScope.vm = vm;
        vm.params = [];

        // Page title
        $rootScope.title = gettextCatalog.getString('AddAgeGroup');

        // Dropdownlist's sources
        vm.sectionList = [];
        var date = new Date().getFullYear();
        vm.yearList = dataservice.range(date + 5, 1900);
        vm.yearListTo = dataservice.range(date + 10, 1900);

        vm.formData = {
            Color: '#000000',
            ActiveAgeGroup: true,
            SelectedYearFrom: undefined,
            SelectedYearTo: undefined,
            Comment: undefined,
            AgeGroupName: undefined,
            SectionId: undefined
        };

        vm.clearDropdown = clearDropdown;
        vm.sectionSelect = sectionSelect;
        vm.saveAgeGroup = saveAgeGroup;
        vm.yearFromDropDownChanged = yearFromDropDownChanged;
        vm.yearToDropDownChanged = yearToDropDownChanged;
        vm.sectionDataBound = sectionDataBound;
        vm.colorChanged = colorChanged;
        vm.activeCheckboxChanged = activeCheckboxChanged;

        activate();

        function activate() {
            $q.all([authenticationService.getRight('UJKOROKEZ')]).then(function (results) {
                if (results[0] !== true) {
                    log.permissionError(true);
                } else {
                    $q.all([paramHelper.getParams([], ['ageGroups.section'])]).then(function (results) {
                        vm.UJKOROKEZ = true;
                        vm.formData.SectionId = results[0]['ageGroups.section'];
                        angular.element('#activeCheckBox').ejCheckBox({checked: vm.formData.ActiveAgeGroup});
                        getSections();
                    });
                }
            });
        }

        function clearDropdown() {
            vm.formData.SelectedYearTo = null;
        }

        function getSections() {
            return dataservice.sectionDropDownList(0).then(function (data) {
                vm.sectionList = data.itemsList;
            });
        }

        function sectionDataBound() {
            if (vm.sectionList.length === 1) {
                angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.sectionList[0].value);
                vm.formData.SectionId = vm.sectionList[0].value;
            } else {
                angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.formData.SectionId);
            }
        }

        function sectionSelect(args) {
            vm.formData.SectionId = args.value;
        }

        function yearFromDropDownChanged(args) {
            vm.formData.SelectedYearFrom = args.value;
        }

        function yearToDropDownChanged(args) {
            vm.formData.SelectedYearTo = args.value;
        }

        function colorChanged(args) {
            vm.formData.Color = args.value;
        }

        function activeCheckboxChanged(args) {
            vm.formData.ActiveAgeGroup = args.value;
        }

        function saveAgeGroup() {
            if (vm.UJKOROKEZ) {
                // a syncfusion direktívák miatt
                $scope.$broadcast('submitted');
                if ($scope.form.$valid === false) {
                    log.errorMsg('FillTheRequiredFields');
                } else {
                    dataservice.saveAgeGroup(vm.formData)
                        .then(function () {
                        log.successMsg('AgeGroupAdded');
                        paramHelper.setParams([{'ageGroups.section': vm.formData.SectionId}]);
                        $state.go('athletes.ageGroups.ageGroupsList');
                    }, function () {
                    });
                }
            } else {
                log.permissionError();
            }
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.athletes.ageGroups.addAgeGroup')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'athletes.ageGroups.addAgeGroup',
                config: {
                    url: '/addAgeGroup',
                    templateUrl: 'app/athletes/ageGroups/addAgeGroup/addAgeGroup.html',
                    controller: 'AddAgeGroupController',
                    controllerAs: 'vm'
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    AgeGroupMembersList.$inject = ["log", "$state", "dataservice", "authenticationService", "$q", "$window", "$filter", "$scope", "gettextCatalog", "paramHelper", "$rootScope"];
    angular
        .module('app.athletes.ageGroups.ageGroupMembersList')
        .controller('AgeGroupMembersListController', AgeGroupMembersList);

    function AgeGroupMembersList(log, $state, dataservice, authenticationService, $q, $window, $filter, $scope, gettextCatalog, paramHelper, $rootScope) {
        var vm = this;
        $rootScope.vm = vm;

        // Page title
        $rootScope.title = gettextCatalog.getString('AgeGroupMembersList');

        // Dropdownlist's sources
        vm.ageGroupList = [];
        vm.ageGroupMembersList = [];

        vm.columns = [
            {field: 'Nev', headerText: gettextCatalog.getString('Name'), textAlign: 'left', template: '#aggrmelitemplateDataColumn1', width: 150},
            {field: 'SzuletesiIdo', headerText: gettextCatalog.getString('BirthDate'), textAlign: 'left', width: 100},
            {field: 'EdzoNeve', headerText: gettextCatalog.getString('CoachsName'), textAlign: 'left', template: '#aggrmelitemplateDataColumn2', width: 150},
            {field: 'SzakosztalyNeve', headerText: gettextCatalog.getString('Section'), textAlign: 'left', width: 100},
            {field: 'Tagdij', headerText: gettextCatalog.getString('PayedSportServiceFee'), textAlign: 'center', width: 75},
            {field: 'Oktatasidij', headerText: gettextCatalog.getString('PayedEducationalFee'), textAlign: 'center', width: 75},
            {field: 'Megjegyzes', headerText: gettextCatalog.getString('Comment'), textAlign: 'center', width: 75}
        ];

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItems,
            allowPaging: true,
            allowSorting: true,
            allowSelection: false,
            allowExcelExport: true,
            allowTextWrap: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#Grid'), $scope);
                }
            },
            rowSelecting: function () {
                grid.clearSelection();
            },
            checkBoxChange: function (args) {
                $rootScope.checkBoxChangeOnlyOne(args, grid);
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        // Publikus funkciók
        vm.goToAgeGroupChange = goToAgeGroupChange;
        vm.goToNewAthlete = goToNewAthlete;
        vm.goToNewUser = goToNewUser;

        activate();

        function activate() {
            $q.all([authenticationService.getRight('MEGTKOROKEZ'), authenticationService.getRight('MODKOROKEZ')]).then(function (results) {
                if (results[0] !== true) {
                    log.permissionError(true);
                } else {
                    vm.MODKOROKEZ = results[1];
                    $q.all([paramHelper.getParams(['ageGroups.section', 'ageGroups.ageGroup']), authenticationService.getRight('MEGTSPORTLIST')]).then(function (results) {
                        vm.korosztaly = results[0]['ageGroups.ageGroup'];
                        vm.szakosztaly = results[0]['ageGroups.section'];
                        vm.MEGTSPORTLIST = results[1];
                        getAgeGroupMembersList();
                    });
                }
            });
        }

        function getAgeGroupMembersList() {
            return dataservice.getAgeGroupMembersList(vm.szakosztaly, vm.korosztaly)
                .then(function (data) {
                    grid.dataSource = $filter('dateStringFilter')(data.itemsList, 'SzuletesiIdo');
                });
        }

        function goToAgeGroupChange() {
            authenticationService.getRight('MEGTKORVALT').then(function (results) {
                if (results) {
                    $state.go('settings.ageGroupChange');
                } else {
                    log.permissionError();
                }
            });
        }

        function goToNewUser(edzoId) {
            paramHelper.setParams([{'newUser.userId': edzoId}]);
            $state.go('settings.userManagement.modifyUser');
        }

        function goToNewAthlete(Id) {
            if (vm.MEGTSPORTLIST) {
                paramHelper.setParams([{'athleteModify.sportoloId': Id}, {'athleteNew.selectedSectionId': vm.szakosztaly}, {'athleteNew.selectedAgeGroupId': vm.korosztaly}]);
                $state.go('athletes.athletesManagement.athleteModify.dataSheet');
            } else {
                log.permissionError();
            }
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.athletes.ageGroups.ageGroupMembersList')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'athletes.ageGroups.ageGroupMembersList',
                config: {
                    url: '/ageGroupMembersList',
                    templateUrl: 'app/athletes/ageGroups/ageGroupMembersList/ageGroupMembersList.html',
                    controller: 'AgeGroupMembersListController',
                    controllerAs: 'vm'
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.athletes.ageGroups')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'athletes.ageGroups',
                config: {
                    url: '/ageGroups',
                    templateUrl: 'app/athletes/ageGroups/ageGroups.html'
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    TeamsCtrl.$inject = ["log", "dataservice", "authenticationService", "$q", "$state", "$scope", "gettextCatalog", "paramHelper", "$rootScope"];
    angular
        .module('app.athletes.ageGroups.ageGroupsList')
        .controller('AgeGroupsListController', TeamsCtrl);

    function TeamsCtrl(log, dataservice, authenticationService, $q, $state, $scope, gettextCatalog, paramHelper, $rootScope) {
        var vm = this; $rootScope.vm = vm;

        // Page title
        $rootScope.title = gettextCatalog.getString('AgeGroups');

        // Dropdownlist's sources
        vm.sectionList = [];
        vm.sectionListCopyTo = [];
        vm.ageGroupList = [];
        // checkbox

        vm.columns = [
            {type: 'checkbox', textAlign: 'center', width: 35},
            {
                field: 'nev',
                headerText: gettextCatalog.getString('Name'),
                textAlign: 'left',
                width: 150,
                template: '#templateData'
            },
            {
                field: 'megjegyzes',
                headerText: gettextCatalog.getString('Comment'),
                textAlign: 'left',
                width: 150
            },
            {
                field: 'aktiv',
                headerText: gettextCatalog.getString('Active'),
                textAlign: 'left',
                width: 50,
                displayAsCheckBox: true
            }
        ];

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItems,
            allowPaging: true,
            allowSorting: true,
            allowExcelExport: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#Grid'), $scope);
                }
            },
            rowSelecting: function () {
                grid.clearSelection();
            },
            checkBoxChange: function (args) {
                $rootScope.checkBoxChangeOnlyOne(args, grid);
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        // Publikus funkciók
        vm.sectionSelect = sectionSelect;
        vm.sectionDestinationDropDownChanged = sectionDestinationDropDownChanged;
        vm.copyAllAgeGroup = copyAllAgeGroup;
        vm.goToAddAgeGroup = goToAddAgeGroup;
        vm.goToModifyAgeGroup = goToModifyAgeGroup;
        vm.goToModifyAgeGroupButton = goToModifyAgeGroupButton;
        vm.goToAgeGroupMembersList = goToAgeGroupMembersList;
        vm.sectionDataBound = sectionDataBound;

        activate();

        function activate() {
            $q.all([authenticationService.getRight('MEGTKOROKEZ')]).then(function (result) {
                if (result[0] !== true) {
                    log.permissionError(true);
                } else {
                    vm.MEGTKOROKEZ = result[0];
                    $q.all([authenticationService.getRight('UJKOROKEZ'), authenticationService.getRight('MODKOROKEZ'), paramHelper.getParams([], ['ageGroups.section'])]).then(function (results) {
                        vm.UJKOROKEZ = results[0];
                        vm.MODKOROKEZ = results[1];
                        vm.sectionId = results[2]['ageGroups.section'];
                        getSections();
                    });
                }
            });
        }

        function getSections() {
            return dataservice.sectionDropDownList(0).then(function (data) {
                vm.sectionList = data.itemsList;
            });
        }

        // Run after data bounded
        function sectionDataBound() {
            if (vm.sectionList.length === 1) {
                vm.sectionId = vm.sectionList[0].value;
                angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.sectionList[0].value);
            } else {
                angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.sectionId);
            }
        }

        function sectionSelect(args) {
            vm.sectionId = args.value;
            getAgeGroups();
            paramHelper.setParams([{'ageGroups.section': vm.sectionId}]);
            vm.sectionListCopyTo = [];
            vm.sectionList.forEach(s => {
                if (s.value != vm.sectionId) {
                    vm.sectionListCopyTo.push(s);
                }
            });
        }

        // in modal window
        function sectionDestinationDropDownChanged(args) {
            vm.selectedDestinationSection = args.value;
            angular.element('.sa-error-container').removeClass('show');
            angular.element('.sa-input-error').removeClass('show');
        }

        function getAgeGroups(sectionId) {
            if (!sectionId) {
                sectionId = vm.sectionId;
            }
            return dataservice.ageGroupList(sectionId).then(function (data) {
                grid.dataSource = data.itemsList;
            });
        }

        function copyAllAgeGroup() {
            if (vm.UJKOROKEZ && vm.MODKOROKEZ) {
                if (angular.isDefined(vm.sectionId)) {
                    swal({
                        title: gettextCatalog.getString('CopyAllAgeGroup'),
                        html: '<label>' + gettextCatalog.getString('DestinationSection') + '</label><input id="sectionDropDown3" ej-dropdownlist placeholder="' + gettextCatalog.getString('PleaseChoose') + '" style="margin-bottom: 10px;">',
                        showCancelButton: true,
                        confirmButtonText: gettextCatalog.getString('Yes'),
                        cancelButtonText: gettextCatalog.getString('No'),
                        closeOnConfirm: false,
                        preConfirm: function () {
                            return new Promise(function (resolve, reject) {
                                if (!vm.selectedDestinationSection) {
                                    swal.showValidationError(gettextCatalog.getString('PleaseChooseSection'));
                                    reject(gettextCatalog.getString('PleaseChooseSection'));
                                } else {
                                    resolve();
                                }
                            });
                        }
                    }).then(function (isConfirmed) {
                        if (isConfirmed.value) {
                            dataservice.copyAllAgeGroup(vm.sectionId, vm.selectedDestinationSection).then(function () {
                                getAgeGroups();
                                log.successMsg('AllAgeGroupCopied');
                                swal.close();
                            }, function () {
                            });
                        }
                    });
                    angular.element('#sectionDropDown3').ejDropDownList({
                        dataSource: vm.sectionListCopyTo,
                        change: sectionDestinationDropDownChanged,
                        value: vm.selectedDestinationSection,
                        width: '100%'
                    });
                    getAgeGroups();
                } else {
                    log.errorMsg('YouHaveToSelectTeam');
                }
            } else {
                log.permissionError();
            }
        }

        function goToAddAgeGroup() {
            if (vm.UJKOROKEZ) {
                paramHelper.setParams([{'ageGroups.section': vm.sectionId}]);
                $state.go('athletes.ageGroups.addAgeGroup');
            } else {
                log.permissionError();
            }
        }

        function goToModifyAgeGroupButton() {
            if (vm.MODKOROKEZ || vm.MEGTKOROKEZ) {
                if ($rootScope.checkRowSelection(grid, true)) {
                    var selectedRecords = $rootScope.getSelectedItems(grid);
                    paramHelper.setParams([{'ageGroups.ageGroup': selectedRecords[0].id}, {'ageGroups.section': vm.sectionId}]);
                    $state.go('athletes.ageGroups.modifyAgeGroup');
                }
            } else {
                log.permissionError();
            }
        }

        function goToModifyAgeGroup(id) {
            if (vm.MODKOROKEZ || vm.MEGTKOROKEZ) {
                if (id) {
                    console.log(id);
                    paramHelper.setParams([{'ageGroups.ageGroup': id}]);
                    $state.go('athletes.ageGroups.modifyAgeGroup');
                }
            } else {
                log.permissionError();
            }
        }

        function goToAgeGroupMembersList() {
            if (vm.MEGTKOROKEZ) {
                if ($rootScope.checkRowSelection(grid, true)) {
                    var selectedRecords = $rootScope.getSelectedItems(grid);
                    paramHelper.setParams([{'ageGroups.ageGroup': selectedRecords[0].id}, {'ageGroups.section': vm.sectionId}]);
                    $state.go('athletes.ageGroups.ageGroupMembersList');
                }
            } else {
                log.permissionError();
            }
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.athletes.ageGroups.ageGroupsList')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'athletes.ageGroups.ageGroupsList',
                config: {
                    url: '/ageGroupsList',
                    templateUrl: 'app/athletes/ageGroups/ageGroupsList/ageGroupsList.html',
                    controller: 'AgeGroupsListController',
                    controllerAs: 'vm',
                    title: 'AgeGroups',
                    settings: {
                        navId: 231,
                        level: 2,
                        order: 3,
                        orderTitle_hu: 'Korosztályok',
                        orderTitle_en: 'Age Groups',
                        parentId: 1,
                        content: 'AgeGroups',
                        activatorPermission: '"MEGTKOROKEZ"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    ModifyAgeGroupController.$inject = ["log", "$state", "dataservice", "authenticationService", "$q", "gettextCatalog", "paramHelper", "$window", "$rootScope", "$scope"];
    angular
        .module('app.athletes.ageGroups.modifyAgeGroup')
        .controller('ModifyAgeGroupController', ModifyAgeGroupController);

    function ModifyAgeGroupController(log, $state, dataservice, authenticationService, $q, gettextCatalog, paramHelper, $window, $rootScope, $scope) {
        var vm = this; $rootScope.vm = vm;

        // Page title
        $rootScope.title = gettextCatalog.getString('ModifyAgeGroup');

        // Dropdownlist's sources
        vm.sectionList = [];
        var date = new Date().getFullYear();
        vm.yearList = dataservice.range(date + 5, 1900);
        vm.yearListTo = dataservice.range(date + 10, 1900);
        vm.colorValue = '#000000';
        vm.activeValue = true;

        vm.formData = {
            color: '#000000',
            activeAgeGroup: true,
            selectedYearFrom: undefined,
            selectedYearTo: undefined,
            comment: undefined,
            ageGroupName: undefined,
            sectionId: undefined,
            id: undefined
        };

        vm.clearDropdown = clearDropdown;
        vm.sectionSelect = sectionSelect;
        vm.modifyAgeGroup = modifyAgeGroup;
        vm.yearFromDropDownChanged = yearFromDropDownChanged;
        vm.yearToDropDownChanged = yearToDropDownChanged;
        vm.sectionDataBound = sectionDataBound;
        vm.colorChanged = colorChanged;
        vm.activeCheckboxChanged = activeCheckboxChanged;

        activate();

        function activate() {
            $q.all([authenticationService.getRight('MODKOROKEZ'), authenticationService.getRight('MEGTKOROKEZ')]).then(function (results) {
                if (results[0] !== true && results[1] !== true) {
                    log.permissionError(true);
                } else {
                    vm.MODKOROKEZ = results[0];
                    $q.all([paramHelper.getParams(['ageGroups.ageGroup'])]).then(function (results) {
                        vm.ageGroupId = results[0]['ageGroups.ageGroup'];
                        getAgeGroup().then(function () {
                            getSections();
                        });
                    });
                }
            });
        }

        function clearDropdown() {
            vm.formData.selectedYearTo = null;
        }

        function getAgeGroup() {
            return dataservice.getAgeGroup(vm.ageGroupId).then(function (data) {
                vm.formData.ageGroupName = data.ageGroupName;
                vm.formData.comment = data.comment;
                vm.formData.selectedYearFrom = data.selectedYearFrom;
                vm.formData.selectedYearTo = data.selectedYearTo;
                vm.formData.color = data.color;
                vm.formData.activeAgeGroup = data.activeAgeGroup;
                vm.formData.id = data.id;
                vm.formData.sectionId = data.sectionId;
            });
        }

        function getSections() {
            return dataservice.sectionDropDownList(0).then(function (data) {
                vm.sectionList = data.itemsList;
            });
        }

        function sectionDataBound() {
            angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.formData.sectionId);
        }

        function sectionSelect(selectedSection) {
            vm.formData.sectionId = selectedSection.value;
        }

        function yearFromDropDownChanged(args) {
            vm.formData.selectedYearFrom = args.value;
        }

        function yearToDropDownChanged(args) {
            vm.formData.selectedYearTo = args.value;
        }

        function colorChanged(args) {
            vm.formData.color = args.value;
        }

        function activeCheckboxChanged(args) {
            vm.formData.activeAgeGroup = args.value;
        }

        function modifyAgeGroup() {
            if (vm.MODKOROKEZ) {
                // a syncfusion direktívák miatt
                $scope.$broadcast('submitted');
                if ($scope.form.$valid === false) {
                    log.errorMsg('RequiredFieldsError');
                } else {
                    dataservice.modifyAgeGroup(vm.formData).then(function () {
                        log.successMsg('AgeGroupModified');
                        paramHelper.setParams([{'ageGroups.section': vm.formData.sectionId}]);
                        $state.go('athletes.ageGroups.ageGroupsList');
                    });
                }
            } else {
                log.permissionError();
            }
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.athletes.ageGroups.modifyAgeGroup')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'athletes.ageGroups.modifyAgeGroup',
                config: {
                    url: '/modifyAgeGroup',
                    templateUrl: 'app/athletes/ageGroups/modifyAgeGroup/modifyAgeGroup.html',
                    controller: 'ModifyAgeGroupController',
                    controllerAs: 'vm'
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.athletes')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'athletes',
                config: {
                    title: 'Athletes',
                    url: '/athletes',
                    templateUrl: 'app/athletes/athletes.html',
                    settings: {
                        navId: 1,
                        level: 1,
                        order: 1,
                        parentId: 0,
                        content: 'Athletes',
                        activatorPermission: ['"MEGTKOROKEZ"', '"MEGTSPORTLIST"', '"MEGTCSOPORT"', '"SZAKOSZTALY"', '"MEGTSPORTLIST"']
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    AnthropometryController.$inject = ["log", "dataservice", "$q", "$rootScope", "gettextCatalog", "paramHelper", "authenticationService", "$filter", "$scope", "DOMAIN", "$timeout"];
    angular
        .module('app.athletes.athletesManagement.athleteModify.anthropometry')
        .controller('AnthropometryController', AnthropometryController);

    function AnthropometryController(log, dataservice, $q, $rootScope, gettextCatalog, paramHelper, authenticationService, $filter, $scope, DOMAIN, $timeout) {
        var vm = this;
        $rootScope.vm = vm;

        // Create variables
        vm.felmeresId = 0;
        vm.noImg = DOMAIN.baseURL + DOMAIN.userImage;
        vm.REGIFELMERES = false;
        vm.fileName = null;
        vm.oldAnthropometryTestTitle = gettextCatalog.getString('OldAnthropometryTests');
        vm.formData = {
            athletesName: '',
            athletesAddress: '',
            birthDate: '',
            endOfPuberty: '',
            chosenSports: '',
            TM: '',
            TS: '',
            HUS: '',
            DS: '',
            VAS: '',
            MKS: '',
            MMG: '',
            CRS: '',
            MKK: '',
            FFK: '',
            FK: '',
            AKK: '',
            CUK: '',
            KZK: '',
            COK: '',
            ASK: '',
            BOK: '',
            BR: '',
            HR: '',
            R: '',
            COR: '',
            LR: '',
            MSR: '',
            CSR: '',
            Felmeres: '',
            Csoport: '',
            MeresDatuma: '',
            VizsgalatotKeroNeveCime: ''
        };
        vm.selectedRowIndexPopup = -1;
        vm.columnsPopup = [{
            field: 'Id',
            visible: false,
            isPrimaryKey: true,
            isIdentity: true
        },
            {
                field: 'Felmeres',
                headerText: gettextCatalog.getString('Felmeres'),
                textAlign: 'center',
                width: 100,
                allowEditing: false
            },
            {
                field: 'Csoport',
                headerText: gettextCatalog.getString('Csoport'),
                textAlign: 'center',
                width: 100,
                allowEditing: false
            },
            {
                field: 'MeresDatuma',
                headerText: gettextCatalog.getString('MeresDatuma'),
                textAlign: 'center',
                width: 100,
                allowEditing: false
            }
        ];

        // Image cropper variables
        vm.cropper = {};
        vm.cropper.sourceImage = null;
        vm.cropper.croppedImage = null;
        vm.bounds = {};
        vm.bounds.left = 0;
        vm.bounds.right = 0;
        vm.bounds.top = 0;
        vm.bounds.bottom = 0;
        vm.cropDialogTitle = gettextCatalog.getString('ChooseImageTitle');

        vm.reportParameters = {};
        var printOpenedE = false;

        // Public functions
        vm.openCropDialog = openCropDialog;
        vm.doneCropDialog = doneCropDialog;
        vm.closeCropDialog = closeCropDialog;
        vm.saveForm = saveForm;
        vm.deleteImg = deleteImg;
        vm.newAnthropometryTest = newAnthropometryTest;
        vm.oldAnthropometryTest = oldAnthropometryTest;
        vm.closeWindow = closeWindow;
        vm.selectTest = selectTest;
        vm.print = print;
        vm.focusOut = focusOut;

        var grid = new ej2.grids.Grid({
            dataSource: [],
            allowTextWrap: true,
            allowSorting: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            columns: vm.columnsPopup,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#Grid'), $scope);
                }
            }
        });
        grid.appendTo('#GridPopup');

        // Activate page
        activate();

        function activate() {
            initKeyEvents();
            var promises = [authenticationService.getRight('MEGTANTFELM'), authenticationService.getRight('MODANTFELM'), authenticationService.getRight('ANTRKIERT')];
            $q.all(promises).then(function (results) {
                if (results[0] !== true) {
                    log.permissionError(true);
                } else {
                    vm.MODANTFELM = results[1];
                    vm.ANTRKIERT = results[2];
                    $q.all([paramHelper.getParams(['athleteModify.sportoloId', 'athleteModify.sportoloNev'])]).then(function (data) {
                        vm.sportoloId = data[0]['athleteModify.sportoloId'];
                        vm.sportoloNev = data[0]['athleteModify.sportoloNev'];
                        $rootScope.title = vm.sportoloNev + ' - ' + gettextCatalog.getString('Anthropometry');
                        getAthleteForAnthropometry(vm.sportoloId);
                    });
                }
            });
        }

        function getAthleteForAnthropometry(sportolo, felmeresId) {
            if (felmeresId === undefined) {
                felmeresId = 0;
            }
            dataservice.getAthleteForAnthropometry(sportolo, felmeresId).then(function (data) {
                data.ant.SzuletesiIdo = $filter('datetimeFilter')(data.ant.SzuletesiIdo);
                data.ant.MeresDatuma = $filter('datetimeFilter')(data.ant.MeresDatuma);
                data.ant.PubertaskorVege = $filter('datetimeFilter')(data.ant.PubertaskorVege);
                vm.formData = data.ant;
                vm.formData.IdSportolo = vm.sportoloId;
                vm.felmeresId = vm.formData.Id;
                if (vm.formData.Id !== 0 && vm.formData.Id !== '0') {
                    vm.REGIFELMERES = true;
                }
                if (data.ant.LogoEleresiUt && data.ant.LogoEleresiUt != 'noImg.jpg') {
                    vm.photoUrl = DOMAIN.baseURL + DOMAIN.anthropometryPhotosUrl + data.ant.LogoEleresiUt;
                } else {
                    vm.photoUrl = vm.noImg;
                }
            });
        }

        function saveForm() {
            if (!vm.MODANTFELM) {
                log.permissionError();
                return;
            }
            // a syncfusion direktívák miatt
            $scope.$broadcast('submitted');
            if ($scope.form.$valid === false) {
                log.errorMsg('RequiredFieldsError');
                $scope.$apply();
            } else {
                if (angular.element('#fileName').val() !== '' && vm.cropper.croppedImage !== null) {
                    vm.fileData = vm.cropper.croppedImage;
                    vm.fileName = angular.element('#fileName').val();
                } else if (vm.photoUrl === undefined) {
                    vm.fileName = 'noImg.jpg';
                }
                dataservice.saveAnthropometry(vm.formData, vm.fileData, vm.fileName).then(function (response) {
                    getAthleteForAnthropometry(response.data.sportoloId, response.data.Id);
                    if (response.data.sikeresSzinkron) {
                        log.successMsg(response.data.hibauzenet);
                    } else if (response.data.hibauzenet && response.data.hibauzenet.length > 0) {
                        log.warningMsg(response.data.hibauzenet, true);
                    }
                    log.successMsg('Saved');
                });
            }
        }

        function openCropDialog() {
            angular.element('#dialogContainer').css('visibility', 'visible');
            angular.element('#cropDialog').ejDialog('open');
        }

        function closeCropDialog() {
            angular.element('#dialogContainer').css('visibility', 'hidden');
            angular.element('#cropDialog').ejDialog('close');
        }

        function doneCropDialog() {
            vm.photoUrl = vm.cropper.croppedImage;
            angular.element('#cropDialog').ejDialog('close');
        }

        function deleteImg() {
            angular.element('#fileName').val('');
            vm.fileName = 'oldDeleted';
            vm.photoUrl = vm.noImg;
        }

        function newAnthropometryTest() {
            vm.formData.Id = 0;
            vm.formData.Felmeres = '';
            vm.formData.Csoport = '';
            vm.formData.MeresDatuma = null;
            vm.formData.TTM = '';
            vm.formData.TTS = '';
            vm.formData.HUS = '';
            vm.formData.TDS = '';
            vm.formData.VAS = '';
            vm.formData.MKS = '';
            vm.formData.MMG = '';
            vm.formData.CRS = '';
            vm.formData.MKK = '';
            vm.formData.FFK = '';
            vm.formData.FK = '';
            vm.formData.AKK = '';
            vm.formData.CUK = '';
            vm.formData.KZK = '';
            vm.formData.COK = '';
            vm.formData.ASK = '';
            vm.formData.BOK = '';
            vm.formData.BR = '';
            vm.formData.HR = '';
            vm.formData.TR = '';
            vm.formData.COR = '';
            vm.formData.LR = '';
            vm.formData.MSR = '';
            vm.formData.CSR = '';
            vm.formData.Endomorfia = '';
            vm.formData.Mezomorfia = '';
            vm.formData.Ektomorfia = '';
            vm.formData.MetrikusConradIndex = '';
            vm.formData.PlasztikusConradIndex = '';
            vm.formData.DFDC = '';
            vm.formData.DFTZSSzazalek = '';
            vm.formData.DFTTS = '';
            vm.formData.DFDelta = '';
            vm.formData.DFBZS = '';
            vm.formData.DFBCS = '';
            vm.formData.DFBI = '';
            vm.formData.DFBZSR = '';
            vm.formData.DFBF = '';
            vm.formData.DFDCBF = '';
            vm.formData.DFVTM = '';
            vm.formData.DFBTTS = '';
            vm.formData.DFDELTASzazalek = '';
            vm.formData.DFBZSSzazalek = '';
            vm.formData.DFBCSSzazalek = '';
            vm.formData.DFBISzazalek = '';
            vm.formData.DFBZSRSzazalek = '';
            vm.formData.Testalkat = '';
            vm.formData.Sulyfelesleg = '';
            vm.formData.Erosithetoseg = '';
            vm.formData.VarhatoTestmagassag = '';
            vm.formData.SzakertoiVelemeny = '';
            vm.formData.AjanlottSportagak = '';
            $scope.$apply();
        }

        // Grid popup
        function oldAnthropometryTest() {
            vm.selectedRowIndexPopup = -1;
            angular.element('#dialogContainer').css('visibility', 'visible');
            var dialogObj = angular.element('#oldAnthropometryTestsWindow').data('ejDialog');
            dialogObj.open();

            dataservice.getOldAnthropometryTest(vm.sportoloId).then(function (data) {
                grid.dataSource = $filter('dateStringFilter')(data.itemsList, 'MeresDatuma');
            });
        }

        function closeWindow() {
            angular.element('#dialogContainer').css('visibility', 'hidden');
            var dialogObj = angular.element('#oldAnthropometryTestsWindow').data('ejDialog');
            dialogObj.close();
        }

        function selectTest() {
            var row = grid.getSelectedRecords()[0];
            if (!row) {
                vm.selectedRowIndexPopup = -1;
            } else {
                vm.selectedRowIndexPopup = row.Id;
            }
            getAthleteForAnthropometry(vm.sportoloId, vm.selectedRowIndexPopup);
            closeWindow();
        }

        function print() {
            $timeout(function () {
                vm.reportParameters = {
                    'Tomeges': vm.felmeresId + ',' + vm.sportoloId,
                    'SportoloId': 0,
                    'AntropometriaId': 0,
                    'SportiskolaLogo': vm.photoUrl
                };

                if (printOpenedE) {
                    angular.element('#printDialoganthtest2').ejDialog('open');
                } else {
                    printOpenedE = true;
                    angular.element('#printDialoganthtest2').ejDialog({
                        height: '95%',
                        width: '95%',
                        enablemodal: 'true',
                        'position-x': '0',
                        'position-y': '0',
                        target: '#mainContent',
                        enableresize: 'false'
                    });
                }

                //angular.element('#printDialoganthtest2').ejDialog('open');
            }, 0);
        }

        var tizedesvesszo = false;
        var voltLostFocus = false;

        function initKeyEvents() {
            angular.element('body').on('keyup', 'button', function () {
                $(this).submit();
            });

            angular.element('body').on('keyup', 'select, textarea, input', function (e) {
                var form = $(this).parents('form:eq(0)');
                var focusable;
                var next;
                if (e.keyCode == 13) {
                    var tab = $((this)).attr('tabIndex');
                    tab++;
                    $('[tabindex=\'' + tab + '\']').focus();

                    return false;
                }
            });

            $('body').on('keyup', 'input', function (e) {
                var form = $(this).parents('form:eq(0)');
                var focusable;
                var next;
                var keyCode = e.keyCode;
                //volt már tizedesvessző, és számot adott meg, következő mezőre lépés
                if (tizedesvesszo === true && ((keyCode >= 48 && keyCode <= 57) || (keyCode >= 96 && keyCode <= 105))) {
                    tizedesvesszo = false;
                    var tab = $(this).attr('tabindex');
                    tab++;
                    $('[tabindex=\'' + tab + '\']').focus();

                    return false;
                }
                //ha még nem volt tizedesvessző, és .-ot, vagy ,-t nyomott le
                if (!tizedesvesszo && (keyCode === 110 || keyCode === 188)) {
                    tizedesvesszo = true;
                }
                //ha volt tizedesvessző, de BackSpace-t nyom le
                if (tizedesvesszo && keyCode === 8) {
                    tizedesvesszo = false;
                }
            });
        }

        function focusOut(args) {
            if (voltLostFocus || args.value == null) {
                return;
            }
            if (!validate(args.model.minValue, args.model.maxValue, args.value)) {
                voltLostFocus = true;
                var audio2 = new Audio('/sounds/error.mp3');
                audio2.play();
                args.cancel = true;
                document.getElementsByName(args.model.name)[0].children[1].children[0].children[0].children[0].focus();
                voltLostFocus = false;
                return true;
            } else {
                if (args.model.name === 'MSR') {
                    var audio = new Audio('/sounds/save.mp3');
                    audio.play();
                } else {
                    var audio = new Audio('/sounds/focusout.mp3');
                    audio.play();
                }
            }
        }

        function validate(min, max, value) {
            return value >= min && value <= max;
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.athletes.athletesManagement.athleteModify.anthropometry')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'athletes.athletesManagement.athleteModify.anthropometry',
                config: {
                    url: '/anthropometry',
                    templateUrl: 'app/athletes/athletesManagement/athleteModify/anthropometry/anthropometry.html',
                    controller: 'AnthropometryController',
                    controllerAs: 'vm'
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    AthleteFeesController.$inject = ["log", "dataservice", "$q", "$rootScope", "gettextCatalog", "paramHelper", "$scope", "authenticationService", "$state"];
    angular
        .module('app.athletes.athletesManagement.athleteModify.athleteFees')
        .controller('AthleteFeesController', AthleteFeesController);

    function AthleteFeesController(log, dataservice, $q, $rootScope, gettextCatalog, paramHelper, $scope, authenticationService, $state) {
        var vm = this;
        $rootScope.vm = vm;

        // Create variables
        // Dropdownlist's sources
        vm.sectionList = [];
        vm.coachList = [];
        vm.yearList = dataservice.range(new Date().getFullYear() - 4, new Date().getFullYear() + 1);
        vm.priceType = [{text: 'NK', value: 'NK'}, {text: 'K', value: 'K'}, {text: 'B', value: 'B'}, {
            text: 'EP',
            value: 'EP'
        }, {text: 'MT', value: 'MT'}];

        vm.selectedCoach = vm.coachId = 0;
        vm.selectedSection = 0;

        // Grid's variables
        vm.columns = [
            {field: 'Id', isPrimaryKey: true, visible: false},
            {
                headerText: gettextCatalog.getString('General'),
                columns: [
                    {field: 'Ev', headerText: gettextCatalog.getString('Year'), width: 70},
                    {field: 'SzakosztalyNeve', headerText: gettextCatalog.getString('Section'), width: 150},
                    {
                        field: 'EdzoNeve',
                        headerText: gettextCatalog.getString('CoachName'), textAlign: 'left', width: 150,
                        template: '#feearrearscolumnTemplate2'
                    },
                    {
                        field: 'VersenyzoNeve',
                        headerText: gettextCatalog.getString('Name'), textAlign: 'left', width: 150,
                        template: '#feearrearscolumnTemplate1'
                    },
                    {
                        field: 'Dsi_Igazolas',
                        headerText: gettextCatalog.getString('Regisztracios'),
                        textAlign: 'left',
                        width: 100
                    }
                ],
                textAlign: 'center'
            },
            {
                field: 'OsszesHatralek',
                headerText: gettextCatalog.getString('Sum'),
                textAlign: 'left',
                width: 150
            },
            {
                headerText: gettextCatalog.getString('Month'),
                columns: [
                    {field: 'Honap_1', headerText: gettextCatalog.getString('January'), textAlign: 'left', width: 100},
                    {field: 'Honap_2', headerText: gettextCatalog.getString('February'), textAlign: 'left', width: 100},
                    {field: 'Honap_3', headerText: gettextCatalog.getString('March'), textAlign: 'left', width: 100},
                    {field: 'Honap_4', headerText: gettextCatalog.getString('April'), textAlign: 'left', width: 100},
                    {field: 'Honap_5', headerText: gettextCatalog.getString('May'), textAlign: 'left', width: 100},
                    {field: 'Honap_6', headerText: gettextCatalog.getString('June'), textAlign: 'left', width: 100},
                    {field: 'Honap_7', headerText: gettextCatalog.getString('July'), textAlign: 'left', width: 100},
                    {field: 'Honap_8', headerText: gettextCatalog.getString('August'), textAlign: 'left', width: 100},
                    {field: 'Honap_9', headerText: gettextCatalog.getString('September'), textAlign: 'left', width: 100},
                    {field: 'Honap_10', headerText: gettextCatalog.getString('October'), textAlign: 'left', width: 100},
                    {field: 'Honap_11', headerText: gettextCatalog.getString('November'), textAlign: 'left', width: 100},
                    {field: 'Honap_12', headerText: gettextCatalog.getString('December'), textAlign: 'left', width: 100}
                ],
                textAlign: 'center'
            }
    ]
        ;
        vm.rowIndexUnderEditing = -1;

        // Public functions
        vm.getAthletes = getFees;
        vm.goToAthlete = goToAthlete;
        vm.openCoach = openCoach;

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItemsWithSearch,
            allowPaging: true,
            allowTextWrap: true,
            allowSorting: true,
            allowExcelExport: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#Grid'), $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        // Activate page
        activate();

        function activate() {
            var promises = [paramHelper.getParams(['athleteModify.sportoloId', 'athleteModify.sportoloNev'], [])];
            $q.all(promises).then(function (results) {
                vm.sportoloId = results[0]['athleteModify.sportoloId'];
                vm.sportoloNev = results[0]['athleteModify.sportoloNev'];
                $rootScope.title = vm.sportoloNev + ' - ' + gettextCatalog.getString('AthleteFees');
                getFees();
            });
        }

        function getFees() {
            return dataservice.getAthleteFees(vm.sportoloId).then(function (data) {
                grid.dataSource = data.itemsList;
            });
        }

        function goToAthlete(id) {
            $q.all([authenticationService.getRight('MEGTSPORTLIST')]).then(function (results) {
                if (results[0]) {
                    paramHelper.setParams([{'athleteModify.sportoloId': id}]);
                    $state.go('athletes.athletesManagement.athleteModify.dataSheet');
                } else {
                    log.permissionError();
                }
            });
        }

        function openCoach(edzoId) {
            $q.all([authenticationService.getRight('MODFELH'), authenticationService.getRight('MEGTFELH')]).then(function (results) {
                if (results[0] || results[1]) {
                    paramHelper.setParams([{'newUser.userId': edzoId}]);
                    $state.go('settings.userManagement.modifyUser');
                } else {
                    log.permissionError();
                }
            });
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.athletes.athletesManagement.athleteModify.athleteFees')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'athletes.athletesManagement.athleteModify.athleteFees',
                config: {
                    url: '/athleteFees',
                    templateUrl: 'app/athletes/athletesManagement/athleteModify/athleteFees/athleteFees.html',
                    controller: 'AthleteFeesController',
                    controllerAs: 'vm',
                    title: 'AthleteFees'
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    AthleteLogController.$inject = ["dataservice", "log", "authenticationService", "$q", "$rootScope", "gettextCatalog", "paramHelper", "$filter", "$scope"];
    angular
        .module('app.athletes.athletesManagement.athleteModify.athleteLog')
        .controller('AthleteLogController', AthleteLogController);

    function AthleteLogController(dataservice, log, authenticationService, $q, $rootScope, gettextCatalog, paramHelper, $filter, $scope) {
        var vm = this; $rootScope.vm = vm;

        vm.sportoloId = null;
        vm.sportoloNev = null;
        vm.logAll = [];
        vm.dateList = [];

        vm.dateFrom = new Date();
        vm.dateFrom.setMonth(vm.dateFrom.getMonth() - 1);
        vm.dateTo = new Date();
        vm.dateFromChanged = dateFromChanged;
        vm.dateToChanged = dateToChanged;

        vm.columns = [
            {field: 'strtimestamp', headerText: gettextCatalog.getString('TimeStamp'), headerTextAlign: 'center', textAlign: 'left', width: '100'},
            {field: 'field', headerText: gettextCatalog.getString('Field'), headerTextAlign: 'center', width: '100'},
            {field: 'oldvalue', headerText: gettextCatalog.getString('OldValue'), textAlign: 'center', width: '150'},
            {field: 'newvalue', headerText: gettextCatalog.getString('NewValue'), textAlign: 'center', width: '150'}
        ];

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItemsWithSearch,
            allowPaging: true,
            allowTextWrap: true,
            allowSorting: true,
            allowExcelExport: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#Grid'), $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        activate();

        function activate() {
            var promises = [authenticationService.getRight('LOG')];
            $q.all(promises).then(function (res) {
                if (!res[0]) {
                    log.permissionError(true);
                } else {
                    $q.all([paramHelper.getParams(['athleteModify.sportoloId', 'athleteModify.sportoloNev'], [])]).then(function (results) {
                        vm.sportoloId = results[0]['athleteModify.sportoloId'];
                        vm.sportoloNev = results[0]['athleteModify.sportoloNev'];
                        $rootScope.title = vm.sportoloNev + ' - ' + gettextCatalog.getString('AthleteLog');
                        getLog(vm.sportoloId, vm.dateFrom, vm.dateTo);
                    });
                }
            })
            .catch(function () {
                log.permissionError(true);
            });
        }

        function getLog(sportoloid, from, to) {
            dataservice.getLog('Sportolok', sportoloid, from, to).then(function (response) {
                grid.dataSource = response.data.List;
                vm.logAll = response.data.List;
                vm.dateList = response.data.DatesStr;
                vm.dateList.unshift({value: '0', text: gettextCatalog.getString('All')});
                setTimeout(function() {
                    angular.element('#date').ejDropDownList('selectItemByValue', '0');
                    $scope.$apply();
                }, 10);
            });
        }

        function dateFromChanged(arg) {
            getLog(vm.sportoloId, arg.value, vm.dateTo);
        }

        function dateToChanged(arg) {
            getLog(vm.sportoloId, vm.dateFrom, arg.value);
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.athletes.athletesManagement.athleteModify.athleteLog')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'athletes.athletesManagement.athleteModify.athleteLog',
                config: {
                    url: '/athleteLog',
                    templateUrl: 'app/athletes/athletesManagement/athleteModify/athleteLog/athleteLog.html',
                    controller: 'AthleteLogController',
                    controllerAs: 'vm',
                    title: 'AthleteLog'
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    AthleteModifyController.$inject = ["log", "logger", "dataservice", "$q", "DOMAIN", "$rootScope", "gettextCatalog", "paramHelper", "authenticationService", "$state", "$timeout", "$scope"];
    angular
        .module('app.athletes.athletesManagement.athleteModify')
        .controller('AthleteModifyController', AthleteModifyController);

    function AthleteModifyController(log, logger, dataservice, $q, DOMAIN, $rootScope, gettextCatalog, paramHelper, authenticationService, $state, $timeout, $scope) {
        var vm = this;
        $rootScope.vm = vm;

        vm.athleteMenuOpened = false;
        vm.printMenuOpened = false;

        $rootScope.title = gettextCatalog.getString('AthleteModify');

        vm.athleteMenuItems = [];

        vm.printMenuItems = [];

        var printOpened = false;
        vm.reportParameters = {};
        var printOpenedSchoolRequesting = false;
        vm.reportParametersSchoolRequesting = {};
        var printOpenedTaj = false;
        vm.reportParametersEgeszsegProfil = {};

        // Activate page
        activate();

        function activate() {
            $q.all([paramHelper.getParams(['athleteModify.sportoloId'], ['athleteModify.sportoloNev', 'selectedSectionId', 'selectedAgeGroupId', 'selectedActiveOrInactive', 'selectedPage', 'selectedRow']),
                authenticationService.getRight('ADMIN'),
                authenticationService.getRight('UJEDZVALT'),
                authenticationService.getRight('MODFELH'),
                authenticationService.getRight('SPORTKILEP'),
                authenticationService.getRight('ModFizetesMod'),
                authenticationService.getRight('MODSPORTOLO'),
                authenticationService.getRight('SPORTOLO'),
                authenticationService.getRight('SZULO'),
                authenticationService.getRight('EGESZSMEGT'),
                authenticationService.getRight('KMVERSEREDM'),
                authenticationService.getRight('MEGTHAVIJEL'),
                authenticationService.getRight('MODTAGDBEALL'),
                authenticationService.getRight('MEGTANTFELM'),
                authenticationService.getRight('MEGTKPFELM'),
                authenticationService.getRight('MEGTSPFELM'),
                authenticationService.getRight('PSYCHO'),
                authenticationService.getRight('KIKERONYOMT'),
                authenticationService.getRight('TESTMERET'),
                authenticationService.getRight('MEGTSPORTBEF'),
                authenticationService.getRight('MODKOROKEZ'),
                authenticationService.getRight('LOG'),
                authenticationService.getRight('DOKLIST'),
                authenticationService.getRight('ESZKNYILVMEGT'),
                authenticationService.getRight('SPORTKILEPVEGLEGES')

            ]).then(function (results) {
                vm.sportoloId = results[0]['athleteModify.sportoloId'];

                vm.ADMIN = results[1];
                vm.UJEDZVALT = results[2];
                vm.MODFELH = results[3];
                vm.SPORTKILEP = results[4];
                vm.ModFizetesMod = results[5];
                vm.MODSPORTOLO = results[6];
                vm.SPORTOLO = results[7];
                vm.SZULO = results[8];
                vm.EGESZSMEGT = results[9];
                vm.KMVERSEREDM = results[10];
                vm.MEGTHAVIJEL = results[11];
                vm.MODTAGDBEALL = results[12];
                vm.MEGTANTFELM = results[13];
                vm.MEGTKPFELM = results[14];
                vm.MEGTSPFELM = results[15];
                vm.PSYCHO = results[16];
                vm.KIKERONYOMT = results[17];
                vm.TESTMERET = results[18];
                vm.MEGTSPORTBEF = results[19];
                vm.MODKOROKEZ = results[20];
                vm.LOG = results[21];
                vm.DOKLIST = results[22];
                vm.ESZKNYILVMEGT = results[23];
                vm.SPORTKILEPVEGLEGES = results[24];

                dataservice.getAthleteDataMin(vm.sportoloId).then(function (data) {
                    vm.SportoloNev = data.Nev;
                    vm.Taj = data.Taj;
                    vm.SzuletesiIdo = data.SzuletesiIdo;
                    vm.Aktiv = data.Aktiv;
                    vm.JelenlegiEdzo = data.JelenlegiEdzo;

                    if (vm.Aktiv) {
                        vm.SPORTBELEPTET = false;
                    } else {
                        vm.SPORTBELEPTET = vm.MODSPORTOLO;
                        vm.SPORTKILEP = false;
                    }

                    vm.athleteMenuItems.push({
                        name: gettextCatalog.getString('DataSheet'),
                        state: 'DataSheet',
                        enabled: true
                    });
                    vm.printMenuItems.push({
                        name: gettextCatalog.getString('DatasheetPrint'),
                        state: 'DatasheetPrint',
                        enabled: true
                    });
                    if (!vm.SPORTOLO && !vm.SZULO) {
                        vm.athleteMenuItems.push({
                            name: gettextCatalog.getString('RaceResultsReport'),
                            state: 'RaceResultsReport',
                            enabled: vm.KMVERSEREDM
                        });
                        vm.athleteMenuItems.push({
                            name: gettextCatalog.getString('TrainingVisit'),
                            state: 'TrainingVisit',
                            enabled: vm.MEGTHAVIJEL
                        });
                        vm.athleteMenuItems.push({
                            name: gettextCatalog.getString('Anthropometry'),
                            state: 'Anthropometry',
                            enabled: vm.MEGTANTFELM
                        });
                        vm.athleteMenuItems.push({
                            name: gettextCatalog.getString('CentralAssessors'),
                            state: 'CentralAssessors',
                            enabled: vm.MEGTKPFELM
                        });
                        vm.athleteMenuItems.push({
                            name: gettextCatalog.getString('NewSportSpecificTestList'),
                            state: 'NewSportSpecificTestList',
                            enabled: vm.MEGTSPFELM
                        });
                        vm.athleteMenuItems.push({
                            name: gettextCatalog.getString('goneAthlete'),
                            state: 'goneAthlete',
                            enabled: vm.SPORTKILEP
                        });
                        vm.athleteMenuItems.push({
                            name: gettextCatalog.getString('EnteringAthlete'),
                            state: 'EnteringAthlete',
                            enabled: vm.SPORTBELEPTET
                        });
                        vm.athleteMenuItems.push({
                            name: gettextCatalog.getString('Psychology'),
                            state: 'Psychology',
                            enabled: vm.PSYCHO
                        });
                        vm.printMenuItems.push({
                            name: gettextCatalog.getString('SchoolRequesting'),
                            state: 'SchoolRequesting',
                            enabled: vm.KIKERONYOMT
                        });
                        vm.athleteMenuItems.push({
                            name: gettextCatalog.getString('HealthModul'),
                            state: 'HealthModul',
                            enabled: vm.EGESZSMEGT
                        });
                        vm.printMenuItems.push({
                            name: gettextCatalog.getString('PrintHealth'),
                            state: 'PrintHealth',
                            enabled: vm.EGESZSMEGT
                        });
                    }

                    vm.athleteMenuItems.push({
                        name: gettextCatalog.getString('CompetitionResultsChart'),
                        state: 'CompetitionResultsChart',
                        enabled: vm.KMVERSEREDM
                    });
                    vm.athleteMenuItems.push({
                        name: gettextCatalog.getString('BodyStat'),
                        state: 'BodyStat',
                        enabled: vm.TESTMERET
                    });
                    vm.athleteMenuItems.push({
                        name: gettextCatalog.getString('AthleteFees'),
                        state: 'AthleteFees',
                        enabled: vm.MEGTSPORTBEF
                    });
                    vm.athleteMenuItems.push({
                        name: gettextCatalog.getString('Log'),
                        state: 'Log',
                        enabled: vm.LOG
                    });
                    vm.athleteMenuItems.push({
                        name: gettextCatalog.getString('Contracts'),
                        state: 'Contracts',
                        enabled: vm.DOKLIST && vm.MODSPORTOLO
                    });

                    vm.athleteMenuItems.push({
                        name: gettextCatalog.getString('AthletesAssets'),
                        state: 'AthletesAssets',
                        enabled: (vm.ESZKNYILVMEGT && vm.Aktiv)
                    });
                    vm.athleteMenuItems.push({
                        name: gettextCatalog.getString('GDPRExitAthlete'),
                        state: 'GDPRExitAthlete',
                        enabled: vm.SPORTKILEPVEGLEGES
                    });

                    vm.athleteMenuItems.sort(function (item1, item2) {
                        return item1.name.localeCompare(item2.name);
                    });
                    vm.printMenuItems.sort(function (item1, item2) {
                        return item1.name.localeCompare(item2.name);
                    });

                    paramHelper.setParams([
                        {'athleteModify.sportoloNev': vm.SportoloNev},
                        {'athleteModify.sportoloTaj': vm.Taj},
                        {'athleteModify.sportoloSzuletesiIdo': vm.SzuletesiIdo},
                        {'athleteModify.aktivSportolo': vm.Aktiv}
                    ]);
                });
            });
        }

        vm.openAthleteMenu = function () {
            vm.athleteMenuOpened = !vm.athleteMenuOpened;
            if (vm.athleteMenuOpened) {
                $('#AthleteMenuButton').addClass('is-active');
            } else {
                $('#AthleteMenuButton').removeClass('is-active');
            }

            if (vm.athleteMenuOpened === true) {
                $('#AthletePrintButton').removeClass('is-active');
                vm.printMenuOpened = false;
            }
        };

        vm.openPrintMenu = function () {
            vm.printMenuOpened = !vm.printMenuOpened;
            if (vm.printMenuOpened) {
                $('#AthletePrintButton').addClass('is-active');
            } else {
                $('#AthletePrintButton').removeClass('is-active');
            }

            if (vm.printMenuOpened === true) {
                $('#AthleteMenuButton').removeClass('is-active');
                vm.athleteMenuOpened = false;
            }
        };

        vm.openAthletePage = function (item) {
            if (item.enabled === false) {
                // log.permissionError();
                return;
            }
            vm.openAthleteMenu();
            switch (item.state) {
                case 'DataSheet':
                    $state.go('athletes.athletesManagement.athleteModify.dataSheet');
                    break;
                case 'RaceResultsReport':
                    $state.go('athletes.athletesManagement.athleteModify.raceResultsReport');
                    break;
                case 'TrainingVisit':
                    $state.go('athletes.athletesManagement.athleteModify.trainingVisitReport');
                    break;
                case 'Anthropometry':
                    $state.go('athletes.athletesManagement.athleteModify.anthropometry');
                    break;
                case 'CentralAssessors':
                    $state.go('athletes.athletesManagement.athleteModify.centralReportOfAthlete');
                    break;
                case 'NewSportSpecificTestList':
                    $state.go('athletes.athletesManagement.athleteModify.athletesSportSpecificTestList');
                    break;
                case 'goneAthlete':
                    goToGoneAthleteAllowed();
                    break;
                case 'EnteringAthlete':
                    getSectionsSwal();
                    break;
                case 'Contracts':
                    paramHelper.setParams([{'files.tipus': 'Sportolok'}, {'files.tablaId': vm.sportoloId}]);
                    $state.go('athletes.athletesManagement.athleteModify.files');
                    break;
                case 'Psychology':
                    $state.go('athletes.athletesManagement.athleteModify.psychology.summary');
                    break;
                case 'BodyStat':
                    $state.go('athletes.athletesManagement.athleteModify.athletesBodyStat');
                    break;
                case 'HealthModul':
                    $state.go('athletes.athletesManagement.athleteModify.health.healthList');
                    break;
                case 'CompetitionResultsChart':
                    $state.go('athletes.athletesManagement.athleteModify.competitionResultsChart');
                    break;
                case 'AthleteFees':
                    $state.go('athletes.athletesManagement.athleteModify.athleteFees');
                    break;
                case 'Log':
                    $state.go('athletes.athletesManagement.athleteModify.athleteLog');
                    break;
                case 'AthletesAssets':
                    $state.go('athletes.athletesManagement.athleteModify.athletesAssets');
                    break;
                case 'GDPRExitAthlete':
                    GDPRExitAthlete();
                    break;
            }
        };

        vm.printPage = function (item) {
            if (item.enabled === false) {
                return;
            }
            vm.openPrintMenu();
            switch (item.state) {
                case 'DatasheetPrint':
                    datasheetPrint();
                    break;
                case 'SchoolRequesting':
                    schoolRequestingOk();
                    break;
                case 'PrintHealth':
                    testClick();
                    break;
            }
        };

        function goToGoneAthleteAllowed() {
            var TitleString = gettextCatalog.getString(vm.SportoloNev + ' ' + gettextCatalog.getString('ExitAthleteTitlePart'));
            var enteringExitingText = gettextCatalog.getString('SelectDategoneAthlete'); // Válaszd ki a kiléptetés dátumát!
            var reasonEnteringExitingText = gettextCatalog.getString('ExitedAthletesText'); // A kiléptetés indoka
            var confirmButtonText = gettextCatalog.getString('Exiting');

            var HTMLarr = [];

            HTMLarr[0] = '<div style="margin-bottom: 10px; width: 95%;" ><label>';
            HTMLarr[1] = enteringExitingText; // Válaszd ki a kiléptetés vagy visszaléptetés dátumát!
            HTMLarr[2] = '<br></label></div><div style="margin-left: 30%;"><input id="datepick" required type="text"></div>';
            HTMLarr[3] = '<br><label>';
            HTMLarr[4] = reasonEnteringExitingText; // A kiléptetés vagy visszaléptetés indoka
            HTMLarr[5] = '</label><br>';
            HTMLarr[6] = '<textarea id="noteTextArea" rows="4" cols="55"  required style="width: 95%; resize: none; padding: 5px;"></textarea>';

            var HTMLtext = HTMLarr.join('');

            swal({
                title: TitleString,
                html: HTMLtext,
                type: 'warning',
                showCancelButton: true,
                allowOutsideClick: false,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: confirmButtonText,
                cancelButtonText: gettextCatalog.getString('Cancel'),
                closeOnConfirm: false,
                preConfirm: function () {
                    var preConfOk = true;
                    vm.selectedExitDate = angular.element('#datepick').data('ejDatePicker').getValue();
                    vm.noteExitText = angular.element('#noteTextArea').val();
                    checkExitDate(vm.selectedExitDate);
                    return new Promise(function (resolve) {
                        if (!vm.selectedExitDate || !vm.exitAthleteDateOk) {
                            preConfOk = false;
                            swal.showValidationError(gettextCatalog.getString('SelectExitDate'));
                        }
                        if (vm.noteExitText == null || vm.noteExitText === '') {
                            preConfOk = false;
                            swal.showValidationError(gettextCatalog.getString('SetNoteText'));
                        }
                        resolve();
                    });
                }
            }).then(function (isConfirm) {
                if (isConfirm.value) {
                    saveExitAthletes(true);
                    swal.close();
                }
            });

            // Set DatePicker
            angular.element('#datepick').ejDatePicker({
                dateFormat: 'yyyy-MM-dd',
                value: new Date(),
                change: function (args) {
                    checkExitDate(args.value);
                }
            });
        }

        function checkExitDate(args) {
            var currentDate = new Date();
            vm.selectedExitDate = new Date(args);
            vm.exitAthleteDateOk = (vm.selectedExitDate <= currentDate);
        }

        function saveExitAthletes(firstSection) {
            vm.datas = {};
            vm.datas.athletesId = [vm.sportoloId];
            vm.datas.selectedExitDate = vm.selectedExitDate;
            if (!vm.noteExitText) {
                vm.noteExitText = '----';
            }
            vm.datas.noteExitText = vm.noteExitText;
            vm.datas.firstSection = firstSection;
            dataservice.saveExitAthletes(vm.datas).then(function (answer) {
                if (answer.retValue) {
                    swal(gettextCatalog.getString('SuccesfulExitAthleteResult'), '', 'success');
                    $rootScope.back();
                } else {
                    swal(gettextCatalog.getString('FailedExitAthleteResult'), '', 'error');
                }
            });
        }

        function GDPRExitAthlete() {
            dataservice.getAthleteData(vm.sportoloId).then(function (data) {
                if (data.Egyenleg < 0 || data.Egyenleg2 < 0) {
                    log.errorMsg(gettextCatalog.getString('AthleteHasArrear'));
                } else {
                    swal({
                        title: gettextCatalog.getString('FinallyExitAthlete'),
                        text: gettextCatalog.getString('AreYouSureYouWantToFinallyExitSelectedAthlete'),
                        type: 'error',
                        showCancelButton: true,
                        confirmButtonColor: '#e50000',
                        cancelButtonText: gettextCatalog.getString('No'),
                        confirmButtonText: gettextCatalog.getString('Yes')
                    }).then(function (isConfirmed) {
                        if (isConfirmed.value) {
                            dataservice.GDPRExitAthlete(vm.sportoloId).then(function () {
                                $state.go('athletes.athletesManagement.athletesList');
                            });
                        }
                    });
                }
            });
        }

        function getSectionsSwal() {
            dataservice.sectionDropDownList(0).then(function (data) {
                vm.sectionListSwal = data.itemsList;
                reEnteringAthlete();
            });
        }

        function reEnteringAthlete() {
            var showAgeGroupSwal = false;
            var TitleString = gettextCatalog.getString(vm.SportoloNev + ' ' + gettextCatalog.getString('EnteringAthlete'));
            var enteringExitingText = gettextCatalog.getString('SelectDateEnteringAthlete'); // Válaszd ki a visszaléptetés dátumát!
            var confirmButtonText = gettextCatalog.getString('Entering');

            var HTMLarr = [];
            HTMLarr[0] = '<label>';
            HTMLarr[1] = enteringExitingText; // Válaszd ki a visszaléptetés dátumát!
            HTMLarr[2] = '<br></label></div><div style="margin-left: 30%;"><input id="datepick" type="text"></div>';
            HTMLarr[3] = '<br>';
            HTMLarr[4] = '<div style="margin-top: 10px;" ><div class="row"><label class="col-lg-6" style="text-align: left; margin-top:5px;">' + gettextCatalog.getString('ReEnteringSection') +
                '</label><div class="col-lg-6"><input id="sectionDropDownSwal" ej-dropdownlist></div></div></div>';
            HTMLarr[5] = '<div style="margin-top: 10px;" ><div class="row"><label class="col-lg-6" style="text-align: left; margin-top:5px;">' + gettextCatalog.getString('ReEnteringAgeGroup') +
                '</label><div class="col-lg-6"><input id="ageGroupDropDownSwal" ej-dropdownlist datasource="vm.ageGroupListSwal"></div></div></div>';
            HTMLarr[6] = '<div style="margin-top: 10px;" ><div class="row"><label class="col-lg-6" style="text-align: left; margin-top:5px;">' + gettextCatalog.getString('ReEnteringCoach') +
                '</label><div class="col-lg-6"><input id="coachDropDownSwal" ej-dropdownlist datasource="vm.coachListSwal"></div></div></div>';
            HTMLarr[7] = '<div ng-show="vm.display" class="ng-hide" id="secondSectionDropDownSwalDiv" style="margin-top: 10px; clear: both;" ><div class="row"><label class="col-lg-6" style="text-align: left; margin-top:5px;">' + gettextCatalog.getString('ReEnteringSecondSection') +
                '</label><div class="col-lg-6"><input id="secondSectionDropDownSwal" ej-dropdownlist></div></div></div>';
            HTMLarr[8] = '<div ng-show="vm.display" class="ng-hide" id="secondAgeGroupDropDownSwalDiv" style="margin-top: 10px; clear: both;" ><div class="row"><label class="col-lg-6" style="text-align: left; margin-top:5px;">' + gettextCatalog.getString('ReEnteringSecondAgeGroup') +
                '</label><div class="col-lg-6"><input id="secondAgeGroupDropDownSwal" ej-dropdownlist datasource="vm.secondAgeGroupListSwal"></div></div></div>';
            HTMLarr[9] = '<div ng-show="vm.display" class="ng-hide" id="secondCoachDropDownSwalDiv"  style="margin-top: 10px; clear: both;" ><div class="row"><label class="col-lg-6" style="text-align: left; margin-top:5px;">' + gettextCatalog.getString('ReEnteringSecondCoach') +
                '</label><div class="col-lg-6"><input id="secondCoachDropDownSwal" ej-dropdownlist datasource="vm.secondCoachListSwal"></div></div></div><div class="col-lg-12"></div>';

            var HTMLtext = HTMLarr.join('');

            swal({
                title: TitleString,
                html: HTMLtext,
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: confirmButtonText,
                cancelButtonText: gettextCatalog.getString('Cancel'),
                preConfirm: function () {
                    vm.selectedExitDate = angular.element('#datepick').data('ejDatePicker').getValue(); // get value

                    vm.exitAthleteDateOk = (new Date(vm.selectedExitDate).getTime()) <= new Date().getTime();

                    return new Promise(function (resolve) {
                        if (!vm.selectedExitDate || !vm.exitAthleteDateOk) {
                            swal.showValidationError(gettextCatalog.getString('SelectEnteringDate'));
                        }
                        resolve();
                    });
                }
            }).then(function (isConfirm) {
                if (isConfirm.value) {
                    saveReEnteringAthletes();
                }
            }, function () {
                swal(gettextCatalog.getString('Cancelled'), gettextCatalog.getString('notEnteringAthlete'), 'error');
            });

            // Set DatePicker
            angular.element('#datepick').ejDatePicker({
                dateFormat: 'yyyy-MM-dd',
                value: new Date(),
                change: function (args) {
                    // Get current date
                    vm.selectedExitDate = new Date(args.value);
                    vm.exitAthleteDateOk = vm.selectedExitDate.getDate() === 1;
                }
            });
            // Section swal
            angular.element('#sectionDropDownSwal').ejDropDownList({
                dataSource: vm.sectionListSwal,
                select: selectSectionDropDownSwal,
                value: vm.athleteDataSwalSzakosztaly,
                databound: sectionSwalDatabound,
                width: '100%'
            });

            function sectionSwalDatabound() {
                if (vm.sectionList.length === 1) {
                    angular.element('#sectionDropDownSwal').ejDropDownList('selectItemByValue', vm.sectionList[0].value);
                } else {
                    angular.element('#sectionDropDownSwal').ejDropDownList('selectItemByValue', vm.athleteDataSwalSzakosztaly);
                }
            }

            function selectSectionDropDownSwal(arg) {
                vm.athleteDataSwalSzakosztaly = arg.value;
                showAgeGroupSwal = true; // show ageGroup dropdown
                // Clear
                vm.coachListSwal = [];
                angular.element('#secondSectionDropDownSwalDiv').addClass('ng-hide');
                angular.element('#secondAgeGroupDropDownSwalDiv').addClass('ng-hide');
                angular.element('#secondCoachDropDownSwalDiv').addClass('ng-hide');

                angular.element('#coachDropDownSwal').ejDropDownList({
                    dataSource: vm.coachListSwal,
                });
                getSecondSectionsSwal();
                getAgeGroupsSwal();
            }

            // AgeGroup swal
            angular.element('#ageGroupDropDownSwal').ejDropDownList({
                dataSource: vm.ageGroupListSwal,
                select: ageGroupDropDownSwal,
                value: vm.athleteDataSwalKorcsoport,
                databound: ageGroupSwalDataBound,
                width: '100%'
            });

            function getAgeGroupsSwal() {
                dataservice.ageGroupDropDownList(vm.athleteDataSwalSzakosztaly)
                    .then(function (data) {
                        vm.ageGroupListSwal = data.itemsList;
                        // reFresh
                        angular.element('#ageGroupDropDownSwal').ejDropDownList({
                            dataSource: vm.ageGroupListSwal,
                        });
                    });
            }

            function ageGroupSwalDataBound() {
                if (vm.ageGroupList.length === 1) {
                    angular.element('#ageGroupDropDownSwal').ejDropDownList('selectItemByValue', vm.ageGroupListSwal[0].value);
                } else {
                    angular.element('#ageGroupDropDownSwal').ejDropDownList('selectItemByValue', vm.athleteDataSwalKorcsoport);
                }
            }

            function ageGroupDropDownSwal(arg) {
                vm.athleteDataSwalKorcsoport = arg.value;
                getCoachesSwal();
            }

            // Coach swal
            angular.element('#coachDropDownSwal').ejDropDownList({
                dataSource: vm.coachListSwal,
                select: coachDropDownSwalSelect,
                value: vm.athleteDataSwalEdzo,
                databound: coachSwalDataBound,
                width: '100%'
            });

            function getCoachesSwal() {
                return dataservice.coachDropDownList(vm.athleteDataSwalSzakosztaly, vm.athleteDataSwalKorcsoport) // Kell a section id (szakosztály)
                    .then(function (data) {
                        vm.coachListSwal = data.itemsList;
                        angular.element('#coachDropDownSwal').ejDropDownList({
                            dataSource: vm.coachListSwal,
                        });
                    });
            }

            function coachSwalDataBound() {
                if (vm.ageGroupList.length === 1) {
                    angular.element('#coachDropDownSwal').ejDropDownList('selectItemByValue', vm.coachListSwal[0].value);
                } else {
                    angular.element('#coachDropDownSwal').ejDropDownList('selectItemByValue', vm.athleteDataSwalEdzo);
                }
            }

            function coachDropDownSwalSelect(arg) {
                vm.athleteDataSwalEdzo = arg.value;
                angular.element('#secondSectionDropDownSwalDiv').removeClass('ng-hide');
                angular.element('#secondAgeGroupDropDownSwalDiv').removeClass('ng-hide');
                angular.element('#secondCoachDropDownSwalDiv').removeClass('ng-hide');
            }

            // Second Section swal
            angular.element('#secondSectionDropDownSwal').ejDropDownList({
                dataSource: vm.secondSectionListSwal,
                select: selectSecondSectionDropDownSwal,
                value: vm.secondAthleteDataSwalSzakosztaly,
                databound: sectionSwalDatabound,
                width: '100%'
            });

            function selectSecondSectionDropDownSwal(arg) {
                vm.secondAthleteDataSwalSzakosztaly = arg.value;
                // Clear
                vm.secondCoachListSwal = [];
                angular.element('#secondCoachDropDownSwal').ejDropDownList({
                    dataSource: vm.secondCoachListSwal,
                });

                getsecondAgeGroupsSwal();
            }

            function getSecondSectionsSwal() {
                dataservice.sectionDropDownList(0)
                    .then(function (data) {
                        // itt ki kell venni a listából az elsődleges section-t (vm.athleteDataSwalSzakosztaly)
                        for (var i = 0; i < data.itemsList.length; i++) {
                            if (data.itemsList[i].value === vm.athleteDataSwalSzakosztaly) {
                                data.itemsList.splice(i, 1);
                            }
                        }
                        vm.secondSectionListSwal = data.itemsList;
                        angular.element('#secondSectionDropDownSwal').ejDropDownList({
                            dataSource: vm.secondSectionListSwal,
                        });
                    });
            }

            // second AgeGroup swal
            angular.element('#secondAgeGroupDropDownSwal').ejDropDownList({
                dataSource: vm.secondAgeGroupListSwal,
                select: secondAgeGroupDropDownSwal,
                value: vm.secondAthleteDataSwalKorcsoport,
                databound: secondAgeGroupSwalDataBound,
                width: '100%'
            });

            function getsecondAgeGroupsSwal() {
                dataservice.ageGroupDropDownList(vm.secondAthleteDataSwalSzakosztaly)
                    .then(function (data) {
                        vm.secondAgeGroupListSwal = data.itemsList;
                        // reFresh
                        angular.element('#secondAgeGroupDropDownSwal').ejDropDownList({
                            dataSource: vm.secondAgeGroupListSwal,
                        });
                    });
            }

            function secondAgeGroupSwalDataBound() {
                if (vm.secondAgeGroupList.length === 1) {
                    angular.element('#secondAgeGroupDropDownSwal').ejDropDownList('selectItemByValue', vm.secondAgeGroupListSwal[0].value);
                } else {
                    angular.element('#secondAgeGroupDropDownSwal').ejDropDownList('selectItemByValue', vm.secondAthleteDataSwalKorcsoport);
                }
            }

            function secondAgeGroupDropDownSwal(arg) {
                vm.secondAthleteDataSwalKorcsoport = arg.value;
                getsecondCoachesSwal();
            }

            // Coach swal
            angular.element('#secondCoachDropDownSwal').ejDropDownList({
                dataSource: vm.secondCoachListSwal,
                select: selectSecondCoachDropDownSwal,
                value: vm.secondAthleteDataSwalEdzo,
                databound: secondCoachSwalDataBound,
                width: '100%'
            });

            function selectSecondCoachDropDownSwal(arg) {
                vm.secondAthleteDataSwalEdzo = arg.value;
            }

            function getsecondCoachesSwal() {
                return dataservice.coachDropDownList(vm.secondAthleteDataSwalSzakosztaly, vm.secondAthleteDataSwalKorcsoport) // Kell a section id (szakosztály)
                    .then(function (data) {
                        vm.secondCoachListSwal = data.itemsList;
                        angular.element('#secondCoachDropDownSwal').ejDropDownList({
                            dataSource: vm.secondCoachListSwal,
                        });
                    });
            }

            function secondCoachSwalDataBound() {
                if (vm.secondAgeGroupList.length === 1) {
                    angular.element('#secondCoachDropDownSwal').ejDropDownList('selectItemByValue', vm.secondCoachListSwal[0].value);
                } else {
                    angular.element('#secondCoachDropDownSwal').ejDropDownList('selectItemByValue', vm.secondAthleteDataSwalEdzo);
                }
            }
        }

        function saveReEnteringAthletes() {
            vm.athleteData = {};
            vm.athleteData.IdSzakosztaly = vm.athleteDataSwalSzakosztaly;
            vm.SzakosztalyNev = '';
            vm.athleteData.Korcsoport = vm.athleteDataSwalKorcsoport;
            vm.athleteData.KorcsoportNeve = '';
            vm.athleteData.JelenlegiEdzo = vm.athleteDataSwalEdzo;
            vm.athleteData.JelenlegiEdzoNev = '';
            vm.athleteData.MasodlagosSzakosztaly = vm.secondAthleteDataSwalSzakosztaly;
            vm.athleteData.MasodlagosKorcsoport = vm.secondAthleteDataSwalKorcsoport;
            vm.athleteData.MasodlagosSzakosztalyEdzoId = vm.secondAthleteDataSwalEdzo;
            vm.athleteData.KilepesDatuma = '';
            vm.athleteData.KilepesIndoka = '';

            vm.sendAthleteDatas = {};
            vm.sendAthleteDatas.athletesId = vm.sportoloId;
            vm.sendAthleteDatas.selectedReEnteringDate = vm.selectedExitDate;
            vm.sendAthleteDatas.szakosztalyId = vm.athleteData.IdSzakosztaly;
            vm.sendAthleteDatas.korcsoportId = vm.athleteData.Korcsoport;
            vm.sendAthleteDatas.edzoId = vm.athleteData.JelenlegiEdzo;
            vm.sendAthleteDatas.masodlagosSzakosztalyId = vm.secondAthleteDataSwalSzakosztaly;
            vm.sendAthleteDatas.masodlagosKorcsoportId = vm.secondAthleteDataSwalKorcsoport;
            vm.sendAthleteDatas.masodlagosEdzoId = vm.secondAthleteDataSwalEdzo;

            return dataservice.saveReEnteringAthletes(vm.sendAthleteDatas).then(function () {
                $rootScope.back();
            });
        }

        function datasheetPrint() {
            $timeout(function () {
                vm.reportParameters = {
                    'Szak': '',
                    'Kor': '',
                    'Edzo': vm.JelenlegiEdzo,
                    'SzulHely': '',
                    'Lakcim': '',
                    'IskolaCim': '',
                    'Id': vm.sportoloId,
                    'fenykeput': '',
                    'UgyesebbLab': '',
                    'UgyesebbKez': '',
                    'Neme': '',
                    'Aktiv': vm.Aktiv === true ? gettextCatalog.getString('Yes') : gettextCatalog.getString('No')
                };
            }, 0);
            if (printOpened) {
                angular.element('#printDialogDatasheet').ejDialog('open');
            } else {
                printOpened = true;
                angular.element('#printDialogDatasheet').ejDialog({
                    height: '99%',
                    width: '99%',
                    enablemodal: 'true',
                    'position-x': '0',
                    'position-y': '0',
                    target: '#mainContent',
                    enableresize: 'false'
                });
            }
        }

        function schoolRequestingOk() {
            var HTMLarr = [];

            HTMLarr[0] = '<label><b>' + '</b></label><br><br>';
            HTMLarr[1] = '<label>' + gettextCatalog.getString('PleaseGiveSchoolRequestingDatas') + '</label>';
            HTMLarr[2] = '</label><br></p><div style="margin-bottom: 10px; width: 95%;" ><label>';
            HTMLarr[3] = gettextCatalog.getString('DateInterval');
            HTMLarr[4] = '<br></label></div><div><input id="dateInterval" type="text"></div><br><label>';
            HTMLarr[5] = gettextCatalog.getString('Justification');
            HTMLarr[6] = '<br></label></div><div><input id="justification" type="text"></div>';
            var HTMLtext = HTMLarr.join('');

            $q.all([paramHelper.getParams([], ['schoolRequesting.dateInterval', 'schoolRequesting.justification'])])
                .then(function (results) {
                    if (results[0] != null) {
                        angular.element('#dateInterval').val(results[0]['schoolRequesting.dateInterval']);
                        angular.element('#justification').val(results[0]['schoolRequesting.justification']);
                    }
                });

            swal({
                title: gettextCatalog.getString('SchoolRequesting'),
                html: HTMLtext,
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: gettextCatalog.getString('Print'),
                cancelButtonText: gettextCatalog.getString('Cancel'),
                closeOnConfirm: false,
                preConfirm: function () {
                    var preConfOk = false;
                    vm.dateInterval = angular.element('#dateInterval').val(); // get value
                    vm.justification = angular.element('#justification').val();
                    return new Promise(function (resolve, reject) {
                        if (vm.dateInterval === null || vm.dateInterval === '') {
                            preConfOk = false;
                            reject(gettextCatalog.getString('FillDateInterval'));
                        } else {
                            preConfOk = true;
                        }
                        if (vm.justification === null || vm.justification === '') {
                            preConfOk = false;
                            reject(gettextCatalog.getString('FillJustification'));
                        } else {
                            preConfOk = true;
                        }
                        if (preConfOk) {
                            resolve();
                        }
                    });
                },
                closeOnCancel: false
            }).then(function (confirmed) {
                if (confirmed.value) {
                    vm.reportParametersSchoolRequesting = {
                        'Logo': ' ',
                        'Fejlec': ' ',
                        'SportoloNeve': vm.SportoloNev,
                        'SportoloSzuletesiHelye': '',
                        'SportoloSzuletesiIdeje': '',
                        'SportoloAnyjaNeve': '',
                        'EgyesuletNeve': ' ',
                        'VarosDatum': '',
                        'Idopont': vm.dateInterval,
                        'Indok': vm.justification,
                        'Szoveg': '',
                        'Alairo': '',
                        'SportoloId': vm.sportoloId,
                        'EdzoId': authenticationService.getAuthData().id
                    };
                    $timeout(function () {
                        $scope.$apply();
                    }, 0);
                    paramHelper.setParams([{
                        'schoolRequesting.dateInterval': vm.dateInterval,
                        'schoolRequesting.justification': vm.justification
                    }]);
                    if (printOpenedSchoolRequesting) {
                        angular.element('#printDialogSchoolRequesting').ejDialog('open');
                    } else {
                        printOpenedSchoolRequesting = true;
                        angular.element('#printDialogSchoolRequesting').ejDialog({
                            height: '99%',
                            width: '99%',
                            enablemodal: 'true',
                            'position-x': '0',
                            'position-y': '1',
                            target: '#mainContent',
                            enableresize: 'false'
                        });
                    }
                    swal.close();
                    return true;
                }
            }).then(function () {
            });
        }

        function testClick() {
            swal({
                title: gettextCatalog.getString('HealthPrintQuestion'),
                input: 'select',
                inputOptions: {
                    '1': gettextCatalog.getString('AllHealth'),
                    '2': gettextCatalog.getString('ActualHealth')
                },
                showCancelButton: true,
                confirmButtonText: gettextCatalog.getString('OK'),
                cancelButtonText: gettextCatalog.getString('Cancel'),
                inputValidator: function (value) {
                    return new Promise(function (resolve) {
                        vm.healtType = value;
                        resolve();
                    });
                }
            }).then(function (isConfirm) {
                if (isConfirm.value) {
                    vm.reportParametersEgeszsegProfil = {
                        'SportoloId': vm.sportoloId,
                        'Name': vm.SportoloNev,
                        'SzuletesiIdo': '',
                        'TajSzam': '',
                        'Type': vm.healtType,
                        'Fenykeput': ''
                    };
                    $scope.$apply();

                    if (printOpenedTaj) {
                        angular.element('#printDialogHealth').ejDialog('open');
                    } else {
                        printOpenedTaj = true;
                        angular.element('#printDialogHealth').ejDialog({
                            height: '99%',
                            width: '99%',
                            enablemodal: 'true',
                            'position-x': '0',
                            'position-y': '1',
                            target: '#mainContent',
                            enableresize: 'false'
                        });
                    }
                }
            });
        }
    }
})
();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.athletes.athletesManagement.athleteModify')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'athletes.athletesManagement.athleteModify',
                config: {
                    url: '/athleteModify',
                    templateUrl: 'app/athletes/athletesManagement/athleteModify/athleteModify.html',
                    controller: 'AthleteModifyController',
                    controllerAs: 'vm',
                    title: 'AthleteModify'
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    AthletesAssetsController.$inject = ["log", "logger", "dataservice", "$q", "$rootScope", "gettextCatalog", "paramHelper", "authenticationService", "$scope"];
    angular
        .module('app.athletes.athletesManagement.athleteModify.athletesAssets')
        .controller('AthletesAssetsController', AthletesAssetsController);

    function AthletesAssetsController(log, logger, dataservice, $q, $rootScope, gettextCatalog, paramHelper, authenticationService, $scope) {
        var vm = this;
        $rootScope.vm = vm;

        vm.assetColumns = [
            {field: 'EszkozId', visible: false, isPrimaryKey: true},
            {field: 'Megnevezes', headerText: gettextCatalog.getString('Megnevezes'), width: 70},
            {field: 'Leiras', headerText: gettextCatalog.getString('Leiras'), width: 50},
            {field: 'Azonosito', headerText: gettextCatalog.getString('Azonosito'), width: 50},
            {field: 'Meret', headerText: gettextCatalog.getString('Meret'), width: 30},
            {field: 'Ar', headerText: gettextCatalog.getString('Ar'), width: 30}
        ];
        vm.types = [];
        vm.newAsset = {};
        vm.selectedAssets = [];
        vm.Issue = Issue;
        vm.IssueAsset = IssueAsset;
        vm.IssueNewAsset = IssueNewAsset;
        vm.TakeBack = TakeBack;
        vm.takebackEnabled = false;
        vm.chooseEnabled = false;
        vm.ESZKMOZG = false;
        vm.TakeBackComment = '';
        vm.IssueComment = '';

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItems,
            allowPaging: true,
            allowTextWrap: true,
            allowSorting: true,
            allowExcelExport: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.assetColumns,
            selectionSettings: {type: 'multiple'},
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#AthletesAssetGrid'), $scope);
                }
            }
        });
        grid.appendTo('#AthletesAssetGrid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        var gridPopUp = new ej2.grids.Grid({
            dataSource: [],
            allowTextWrap: true,
            allowSorting: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            columns: vm.assetColumns,
            selectionSettings: {type: 'multiple'},
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#AssetGrid'), $scope);
                }
            }
        });
        gridPopUp.appendTo('#AssetGrid');

        activate();

        function activate() {
            $q.all([
                authenticationService.getRight('ESZKNYILVMEGT'),
                authenticationService.getRight('ESZKMOZG'),
                paramHelper.getParams(['athleteModify.sportoloId', 'athleteModify.sportoloNev'], [])
            ]).then(function (results) {
                if (!results[0]) {
                    log.permissionError(true);
                } else {
                    vm.ESZKMOZG = results[1];
                    vm.sportoloId = results[2]['athleteModify.sportoloId'];
                    vm.sportoloNev = results[2]['athleteModify.sportoloNev'];
                    $rootScope.title = vm.sportoloNev + ' - ' + gettextCatalog.getString('AthletesAssets');
                    IssuedAssets();
                }
            });
        }

        function IssuedAssets() {
            dataservice.IssuedAssets(vm.sportoloId, 0).then(function (response) {
                grid.dataSource = response.data;
            });
        }

        function getSelectedAssetIds(targetGrid) {
            var selectedAssets = targetGrid.getSelectedRecords();
            var assetIds = [];
            selectedAssets.forEach(function (asset) {
                assetIds.push(asset.EszkozId);
            });
            return assetIds;
        }

        function IssueAsset() {
            if (vm.ESZKMOZG) {
                angular.element('#issueDialog').data('ejDialog').open();
                dataservice.AssetsByType(0, 'issuable').then(function (data) {
                    gridPopUp.dataSource = data.data;
                });
                dataservice.assetTypeList().then(function (data) {
                    vm.types = data.itemsList;
                    vm.types.forEach(function (item) {
                        item.value = item.TipusId;
                        item.text = item.TipusNev;
                    });
                });
            } else {
                log.permissionError();
            }
        }

        function Issue() {
            vm.chooseEnabled = false;
            vm.IssueComment = '';
            angular.element('#issueDialog').data('ejDialog').close();
            dataservice.AssetIssue(getSelectedAssetIds(gridPopUp), 0, vm.sportoloId, vm.IssueComment).then(function () {
                log.successMsg('IssuedSuccessfully');
                IssuedAssets();
            });
        }

        function TakeBack() {
            vm.takebackEnabled = false;
            dataservice.AssetTakeBack(getSelectedAssetIds(grid), vm.TakeBackComment).then(function () {
                vm.TakeBackComment = '';
                log.successMsg('TakenBackSuccessfully');
                IssuedAssets();
            });
        }

        function IssueNewAsset() {
            angular.element('#issueDialog').data('ejDialog').close();
            vm.chooseEnabled = false;
            var HTMLtext = createHtmlSwalContent([
                {id: 'Megnevezes', text: gettextCatalog.getString('Megnevezes'), value: ''},
                {id: 'Leiras', text: gettextCatalog.getString('Leiras'), value: ''},
                {id: 'Azonosito', text: gettextCatalog.getString('Azonosito'), value: ''},
                {id: 'Meret', text: gettextCatalog.getString('Meret'), value: ''},
                {id: 'Ar', text: gettextCatalog.getString('Ar'), value: ''},
                {id: 'darab', text: gettextCatalog.getString('NumberMassAdd'), value: ''},
                {id: 'AssetType', text: gettextCatalog.getString('AssetType'), value: '', ac: true}
            ]);
            swal({
                title: gettextCatalog.getString('CreateAsset'),
                html: HTMLtext,
                type: 'info',
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: gettextCatalog.getString('Ok'),
                cancelButtonText: gettextCatalog.getString('Cancel'),
            }).then(function (isConfirm) {
                if (isConfirm.value) {
                    vm.newAsset.EszkozId = -1;
                    vm.newAsset.TipusId = 0;
                    vm.newAsset.TipusNev = '';
                    vm.newAsset.Megnevezes = document.getElementById('Megnevezes').value;
                    vm.newAsset.Leiras = document.getElementById('Leiras').value;
                    vm.newAsset.Azonosito = document.getElementById('Azonosito').value;
                    vm.newAsset.Meret = document.getElementById('Meret').value;
                    vm.newAsset.Ar = document.getElementById('Ar').value;
                    vm.newAsset.darab = document.getElementById('darab').value;
                    vm.newAsset.TipusNev = document.getElementById('AutoCompleteSwal').value;
                    console.log('vm.newAsset', vm.newAsset);
                    if (!vm.newAsset.Megnevezes || vm.newAsset.Megnevezes.length == 0) {
                        log.errorMsg(gettextCatalog.getString('AssetNameMustNotBeEmpty'));
                        return;
                    }
                    if (vm.newAsset.TipusId == 0 && (!vm.newAsset.TipusNev || vm.newAsset.TipusNev.length == 0)) {
                        log.errorMsg(gettextCatalog.getString('AssetTypeNameMustNotBeEmpty'));
                        return;
                    }
                    dataservice.AssetManager(vm.newAsset).then(function (response) {
                        dataservice.AssetIssue(response.data.EszkozIdk, 0, vm.sportoloId, vm.IssueComment).then(function () {
                            vm.IssueComment = '';
                            log.successMsg('IssuedSuccessfully');
                            IssuedAssets();
                        });
                    });
                }
            });
            angular.element('#AutoCompleteSwal').ejAutocomplete({
                dataSource: vm.types,
                change: function (arg) {
                    vm.newAsset.TipusId = 0;
                    vm.newAsset.TipusNev = arg.value;
                },
                value: vm.newAsset.TipusId,
                width: '100%'
            });
        }

        function createHtmlSwalContent(arr) {
            var HTMLtext = '<div style="margin-top: 10px;" >';
            arr.forEach(function (item) {
                HTMLtext += '<div class="row">';
                HTMLtext += '<label class="col-lg-6" style="text-align: left; margin-top:5px;">' + item.text + '</label>';
                if (item.hasOwnProperty('ac')) {
                    HTMLtext += '<input class="col-lg-6 col-lg-offset-6" id="AutoCompleteSwal" ej-autocomplete></input><br>';
                    // HTMLtext += '<cts-auto-complete name="ac" label="'+item.text+'" value="" change="vm.AutoCompleteChange" validation-rules="{required: true}" datasource="vm.types" style="width: 100%"></cts-auto-complete>'
                } else if (item.hasOwnProperty('dd')) {
                    HTMLtext += '<input class="col-lg-6 col-lg-offset-6" id="DropDownSwal" ej-dropdownlist></input><br>';
                } else {
                    if (item.value && item.value.length > 0) {
                        HTMLtext += '<input type="text" value="' + item.value + '" id="' + item.id + '"></input><br>';
                    } else {
                        HTMLtext += '<input type="text" value="" id="' + item.id + '"></input><br>';
                    }
                }
                HTMLtext += '</div>';
            });
            HTMLtext += '</div><br>';
            return HTMLtext;
        }
    }
})();


(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.athletes.athletesManagement.athleteModify.athletesAssets')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'athletes.athletesManagement.athleteModify.athletesAssets',
                config: {
                    url: '/AthletesAssets',
                    templateUrl: 'app/athletes/athletesManagement/athleteModify/athletesAssets/athletesAssets.html',
                    controller: 'AthletesAssetsController',
                    controllerAs: 'vm',
                    title: 'AthletesAssets'
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    AthletesBodyStatController.$inject = ["log", "logger", "dataservice", "$q", "$rootScope", "gettextCatalog", "authenticationService", "paramHelper", "$filter"];
    angular
        .module('app.athletes.athletesManagement.athleteModify.athletesBodyStat')
        .controller('AthletesBodyStatController', AthletesBodyStatController);

    function AthletesBodyStatController(log, logger, dataservice, $q, $rootScope, gettextCatalog, authenticationService, paramHelper, $filter) {
        var vm = this; $rootScope.vm = vm;

        vm.BodyStatText = gettextCatalog.getString('BodyStat');
        vm.cm = gettextCatalog.getString('Cm');
        vm.kg = gettextCatalog.getString('Kg');
        vm.bmi = gettextCatalog.getString('Bmi');
        vm.sportoloNev = '';
        vm.data = [];

        activate();

        function activate() {
            authenticationService.getRight('TESTMERET').then(function (results) {
                if (results !== true) {
                    log.permissionError(true);
                } else {
                    $q.all([paramHelper.getParams(['athleteModify.sportoloId', 'athleteModify.sportoloNev'], [])]).then(function (results) {
                        vm.sportoloId = results[0]['athleteModify.sportoloId'];
                        vm.sportoloNev = results[0]['athleteModify.sportoloNev'];
                        $rootScope.title = vm.sportoloNev + ' - ' + gettextCatalog.getString('athletesBodyStat');
                        getAthletesBodyStat(vm.sportoloId);
                    });
                }
            });
        }

        function getAthletesBodyStat(sportoloid) {
            vm.data = [];
            dataservice.getAthletesBodyStat(sportoloid)
                .then(function (data) {
                    if (data.itemsList.length == 0) {
                        log.errorMsg(gettextCatalog.getString('NoBodyStatFoundOnMonthlyAttendanceReports'));
                        $rootScope.back();
                    }
                    vm.data = data.itemsList;
                    vm.data = $filter('dateStringFilter')(vm.data, 'datum');
                });
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.athletes.athletesManagement.athleteModify.athletesBodyStat')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'athletes.athletesManagement.athleteModify.athletesBodyStat',
                config: {
                    url: '/athletesBodyStat',
                    templateUrl: 'app/athletes/athletesManagement/athleteModify/athletesBodyStat/athletesBodyStat.html',
                    controller: 'AthletesBodyStatController',
                    controllerAs: 'vm',
                    title: 'AthletesBodyStat',
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    AthletesSportSpecificTestListController.$inject = ["log", "dataservice", "authenticationService", "$q", "$state", "$scope", "$rootScope", "gettextCatalog", "paramHelper", "$filter"];
    angular
        .module('app.athletes.athletesManagement.athleteModify.athletesSportSpecificTestList')
        .controller('AthletesSportSpecificTestListController', AthletesSportSpecificTestListController);

    function AthletesSportSpecificTestListController(log, dataservice, authenticationService, $q, $state, $scope, $rootScope, gettextCatalog, paramHelper, $filter) {
        var vm = this; $rootScope.vm = vm;

        vm.sectionId = 0;
        vm.ageGroupId = 0;
        vm.coachId = 0;
        vm.felmeroFejId = 0;
        vm.sportoloId = -1;
        vm.dateTo = new Date();
        vm.dateFrom = new Date(vm.dateTo.getFullYear() - 1, vm.dateTo.getMonth(), 1);

        // Grid's variables
        vm.pageSize = 20;

        vm.columns = [
            {
                field: 'Id',
                headerText: 'Id',
                textAlign: 'left',
                isPrimaryKey: true,
                visible: false
            },
            {
                field: 'FelmeroNeve',
                headerText: gettextCatalog.getString('TestName'),
                textAlign: 'left',
                allowEditing: false,
                width: 150
            },
            {
                field: 'SzakosztalyNev',
                headerText: gettextCatalog.getString('SectionName'),
                textAlign: 'left',
                allowEditing: false,
                width: 150
            }, {
                field: 'EdzoNev',
                headerText: gettextCatalog.getString('CoachName'),
                textAlign: 'left',
                allowEditing: false,
                width: 150,
                template: '#sstlCoach'
            }, {
                field: 'KorcsoportNev',
                headerText: gettextCatalog.getString('AgeGroup'),
                textAlign: 'left',
                allowEditing: false,
                width: 150
            }, {
                field: 'Edzoertekeles',
                headerText: gettextCatalog.getString('CoachRating'),
                textAlign: 'left',
                allowEditing: false,
                width: 150
            }, {
                field: 'Datum',
                headerText: gettextCatalog.getString('Datum'),
                textAlign: 'left',
                allowEditing: false,
                width: 150
            }, {
                headerText: '',
                textAlign: 'center',
                allowEditing: false,
                template: '#sstlOpen'
            }];

        vm.dateFromChange = dateFromChange;
        vm.dateToChange = dateToChange;
        vm.goToTest = goToTest;
        vm.goToUser = goToUser;

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItems,
            allowPaging: true,
            allowTextWrap: true,
            allowSorting: true,
            allowExcelExport: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#Grid'), $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        activate();

        function activate() {
            authenticationService.getRight('MEGTSPFELM').then(function (results) {
                if (results !== true) {
                    log.permissionError(true);
                } else {
                    $q.all([
                        authenticationService.getRight('UJSPFELM'),
                        authenticationService.getRight('MODFELH'),
                        paramHelper.getParams(['athleteModify.sportoloId', 'athleteModify.sportoloNev'], [])
                    ]).then(function (results) {
                        vm.sportoloId = results[2]['athleteModify.sportoloId'];
                        vm.sportoloNev = results[2]['athleteModify.sportoloNev'];
                        $rootScope.title = vm.sportoloNev + ' - ' + gettextCatalog.getString('AthletesSportSpecificTestList');
                        felmeroFejLista();
                        vm.UJSPFELM = results[0];
                        vm.MODFELH = results[1];
                    });
                }
            });
        }

        function felmeroFejLista() {
            return dataservice.felmeroFejLista(0, 0, 0, 0, vm.sportoloId, vm.dateFrom, vm.dateTo)
                .then(function (data) {
                    data.itemsList = $filter('dateStringFilter')(data.itemsList, 'Datum');
                    grid.dataSource = data.itemsList;
                });
        }

        function dateFromChange(arg) {
            vm.dateFrom = arg.value;
            felmeroFejLista();
        }

        function dateToChange(arg) {
            vm.dateTo = arg.value;
            felmeroFejLista();
        }

        function goToTest(SzakosztalyId, KorcsoportId, EdzoId, FelmeroElemFejId, FelmeroFejId) {
            paramHelper.setParams(
                [
                    {'sportSpecificTest.sectionId': SzakosztalyId},
                    {'newSportSpecificTest.sectionId': SzakosztalyId},
                    {'sportSpecificTest.ageGroupId': KorcsoportId},
                    {'sportSpecificTest.coachId': EdzoId},
                    {'sportSpecificTest.felmeroElemFejId': FelmeroElemFejId},
                    {'sportSpecificTest.felmeroFejId': FelmeroFejId},
                    {'sportSpecificTest.highlight': vm.sportoloId}
                ]);

            $state.go('administration.sportSpecificTest.newSportSpecificTest');
        }

        function goToUser(EdzoId) {
            if (!vm.MODFELH) {
                log.errorMsg(gettextCatalog.getString('YouHaveNoPermissionToThisFunction'));
                return;
            }
            paramHelper.setParams([{'newUser.userId': EdzoId}]);
            $state.go('settings.userManagement.modifyUser');
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.athletes.athletesManagement.athleteModify.athletesSportSpecificTestList')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'athletes.athletesManagement.athleteModify.athletesSportSpecificTestList',
                config: {
                    url: '/athletesSportSpecificTestList',
                    templateUrl: 'app/athletes/athletesManagement/athleteModify/athletesSportSpecificTestList/athletesSportSpecificTestList.html',
                    controller: 'AthletesSportSpecificTestListController',
                    controllerAs: 'vm',
                    title: 'athletesSportSpecificTestList'
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    CentralReportOfAthleteController.$inject = ["dataservice", "$q", "$rootScope", "gettextCatalog", "paramHelper", "$scope"];
    angular
        .module('app.athletes.athletesManagement.athleteModify.centralReportOfAthlete')
        .controller('CentralReportOfAthleteController', CentralReportOfAthleteController);

    function CentralReportOfAthleteController(dataservice, $q, $rootScope, gettextCatalog, paramHelper, $scope) {
        var vm = this; $rootScope.vm = vm;

        vm.columns = [{
            field: 'Felmero',
            headerText: gettextCatalog.getString('CentralAssessors')
        }, {
            field: 'SulypontLegjobb',
            headerText: gettextCatalog.getString('VerticalJump')
        }, {
            field: 'SulypontValtozas',
            headerText: gettextCatalog.getString('VerticalJumpChange')
        }, {
            field: 'SprintLegjobb',
            headerText: gettextCatalog.getString('Sprint')
        }, {
            field: 'SprintValtozas',
            headerText: gettextCatalog.getString('SprintChange')
        }, {
            field: 'MeterLegjobbStr',
            headerText: gettextCatalog.getString('m2800')
        }, {
            field: 'MeterValtozasStr',
            headerText: gettextCatalog.getString('m2800Change')
        }];

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItemsWithSearch,
            allowPaging: true,
            allowTextWrap: true,
            allowSorting: true,
            allowExcelExport: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#Grid'), $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        activate();

        function activate() {
            $q.all([paramHelper.getParams(['athleteModify.sportoloId', 'athleteModify.sportoloNev'], [])])
                .then(function (results) {
                    vm.sportoloId = results[0]['athleteModify.sportoloId'];
                    vm.sportoloNev = results[0]['athleteModify.sportoloNev'];
                    $rootScope.title = vm.sportoloNev + ' - ' + gettextCatalog.getString('CentralReportOfAthlete');
                    getData(vm.sportoloId, vm.sportoloNev);
                });
        }

        function getData(id, name) {
            $rootScope.title = name + ' - ' + gettextCatalog.getString('CentralReportOfAthlete');
            return dataservice.centralReportOfAthlete(id)
                .then(function (data) {
                    grid.dataSource = data.itemsList;
                });
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.athletes.athletesManagement.athleteModify.centralReportOfAthlete')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'athletes.athletesManagement.athleteModify.centralReportOfAthlete',
                config: {
                    url: '/centralReportOfAthlete',
                    templateUrl: 'app/athletes/athletesManagement/athleteModify/centralReportOfAthlete/centralReportOfAthlete.html',
                    controller: 'CentralReportOfAthleteController',
                    controllerAs: 'vm',
                    title: 'CentralReportOfAthlete'
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    CompetitionResultsChartController.$inject = ["dataservice", "log", "authenticationService", "$q", "$rootScope", "gettextCatalog", "paramHelper", "$filter"];
    angular
        .module('app.athletes.athletesManagement.athleteModify.competitionResultsChart')
        .controller('CompetitionResultsChartController', CompetitionResultsChartController);

    function CompetitionResultsChartController(dataservice, log, authenticationService, $q, $rootScope, gettextCatalog, paramHelper, $filter) {
        var vm = this; $rootScope.vm = vm;

        // Create variables
        vm.sectionId = 0;
        vm.ageGroupId = 0;
        vm.discipline = '0';
        vm.selectdateFrom = '';
        vm.selectdateTo = new Date();

        vm.data1 = [];
        vm.data2 = [];
        vm.data3 = [];
        vm.data4 = [];

        // Public functions
        vm.sectionDataBound = sectionDataBound;
        vm.sectionSelect = sectionSelect;
        vm.ageGroupDataBound = ageGroupDataBound;
        vm.ageGroupSelect = ageGroupSelect;
        vm.disciplineDataBound = disciplineDataBound;
        vm.disciplineSelect = disciplineSelect;
        vm.filter = filter;
        vm.selectdateFromChange = selectdateFromChange;
        vm.selectdateToChange = selectdateToChange;

        // Activate page
        activate();

        function activate() {
            var promises = [authenticationService.getRight('KMVERSEREDM')];
            $q.all(promises).then(function (res) {
                if (!res[0]) {
                    log.permissionError(true);
                } else {
                    loadResults();
                }
            })
            .catch(function () {
                log.permissionError(true);
            });
        }

        function loadResults() {
            var promises = [paramHelper.getParams([], ['athleteModify.sportoloId', 'athleteModify.sportoloNev'])];
            $q.all(promises).then(function (results) {
                vm.sportoloId = results[0]['athleteModify.sportoloId'];
                vm.sportoloNev = results[0]['athleteModify.sportoloNev'];
                $rootScope.title = vm.sportoloNev + ' - ' + gettextCatalog.getString('CompetitionResultsChart');
                getSections();

                angular.element('#Chart1').ejChart({
                        primaryXAxis: {
                            title: {text: 'Verseny'}
                        },
                        primaryYAxis: {
                            title: {text: 'Értékelés'}
                        },
                        commonSeriesOptions: {
                            tooltip: {
                                visible: true
                            }
                        },
                        series: [
                            {
                                points: vm.data1,
                                name: 'Sales',
                                type: 'line',
                                fill: '#358fcc',
                                enableAnimation: true,
                                marker: {
                                    shape: 'circle',
                                    size: {
                                        height: 10, width: 10
                                    },
                                    visible: true
                                },
                                border: {width: 3},
                                tooltip: {format: 'Verseny: #point.VersenyLeiras#<br/> Értékelés : #point.y#'}
                            }
                        ],
                        isResponsive: true,
                        load: loadChart1,
                        title: {text: 'Értékelés'},
                        size: {height: '400'},
                        legend: {visible: false}
                    });

                angular.element('#Chart2').ejChart({
                        primaryXAxis: {
                            title: {text: 'Verseny'}
                        },
                        primaryYAxis: {
                            title: {text: 'Pont'}
                        },
                        commonSeriesOptions: {
                            tooltip: {
                                visible: true
                            }
                        },
                        series: [
                            {
                                points: vm.data2,
                                name: 'Sales',
                                type: 'line',
                                fill: '#628a00',
                                enableAnimation: true,
                                marker: {
                                    shape: 'circle',
                                    size: {
                                        height: 10, width: 10
                                    },
                                    visible: true
                                },
                                border: {width: 3},
                                tooltip: {format: 'Verseny: #point.VersenyLeiras#<br/> Pont : #point.y#'}
                            }
                        ],
                        isResponsive: true,
                        load: loadChart2,
                        title: {text: 'Pont'},
                        size: {height: '400'},
                        legend: {visible: false}
                    });

                angular.element('#Chart3').ejChart({
                        //Initializing Primary X Axis
                        primaryXAxis: {
                            title: {text: 'Verseny'}
                        },

                        //Initializing Primary Y Axis
                        primaryYAxis: {
                            title: {text: 'Távolság'}
                        },

                        //Initializing Common Properties for all the series
                        commonSeriesOptions: {
                            tooltip: {
                                visible: true
                            }
                        },

                        //Initializing Series
                        series: [
                            {
                                points: vm.data3,
                                name: 'Sales',
                                type: 'line',
                                fill: '#dc6f00',
                                enableAnimation: true,
                                marker: {
                                    shape: 'circle',
                                    size: {
                                        height: 10, width: 10
                                    },
                                    visible: true
                                },
                                border: {width: 3},
                                tooltip: {format: 'Verseny: #point.VersenyLeiras#<br/> Távolság : #point.y#'}
                            }
                        ],
                        isResponsive: true,
                        load: loadChart3,
                        title: {text: 'Távolság'},
                        size: {height: '400'},
                        legend: {visible: false}
                    });

                angular.element('#Chart4').ejChart({
                        //Initializing Primary X Axis
                        primaryXAxis: {
                            title: {text: 'Eredmény'},
                            labelFormat: 'mm:ss',
                            valueType: 'datetime'
                        },

                        //Initializing Primary Y Axis
                        primaryYAxis: {
                            title: {text: 'Verseny'},
                            rangePadding: 'additional'
                        },

                        //Initializing Common Properties for all the series
                        commonSeriesOptions: {
                            tooltip: {
                                visible: true
                            }
                        },

                        //Initializing Series
                        series: [
                            {
                                points: vm.data4,
                                name: 'Sales',
                                type: 'line',
                                isTransposed: true,
                                fill: '#b81309',
                                enableAnimation: true,
                                marker: {
                                    shape: 'circle',
                                    size: {
                                        height: 10, width: 10
                                    },
                                    visible: true
                                },
                                border: {width: 3},
                                tooltip: {format: 'Verseny: #point.VersenyLeiras#<br/> Eredmény : #point.x#'}
                            }
                        ],
                        isResponsive: true,
                        load: loadChart4,
                        title: {text: 'Idő'},
                        size: {height: '400'},
                        legend: {visible: false}
                    });
            });
        }

        function getSections() {
            dataservice.resultChartSectionDropDown(vm.sportoloId, vm.ageGroupId, vm.discipline).then(function (data) {
                data.itemsList.unshift({value: '0', text: gettextCatalog.getString('All')});
                vm.sectionList = data.itemsList;
            });
        }

        function sectionDataBound() {
            angular.element('#section').ejDropDownList('selectItemByValue', 0);
            vm.sectionId = 0;
        }

        function sectionSelect(args) {
            vm.sectionId = args.value;
            getAgeGroups();
        }

        function getAgeGroups() {
            dataservice.resultChartAgeGroupDropDown(vm.sportoloId, vm.sectionId, vm.discipline).then(function (data) {
                data.itemsList.unshift({value: '0', text: gettextCatalog.getString('All')});
                vm.ageGroupList = data.itemsList;
            });
        }

        function ageGroupDataBound() {
            angular.element('#ageGroup').ejDropDownList('selectItemByValue', 0);
            vm.ageGroupId = 0;
        }

        function ageGroupSelect(args) {
            vm.ageGroupId = args.value;
            getDiscipline();
        }

        function getDiscipline() {
            dataservice.resultChartVersenyszamDropDown(vm.sportoloId, vm.sectionId, vm.ageGroupId).then(function (data) {
                data.itemsList.unshift({value: '0', text: gettextCatalog.getString('All')});
                vm.disciplineList = data.itemsList;
            });
        }

        function disciplineDataBound() {
            angular.element('#discipline').ejDropDownList('selectItemByValue', '0');
            vm.discipline = '0';
        }

        function disciplineSelect(args) {
            vm.discipline = args.value;
        }

        function selectdateFromChange(args) {
            vm.selectdateFrom = args.value;
        }

        function selectdateToChange(args) {
            vm.selectdateTo = args.value;
        }

        function loadChart1() {
            vm.chart1 = this;
        }

        function loadChart2() {
            vm.chart2 = this;
        }

        function loadChart3() {
            vm.chart3 = this;
        }

        function loadChart4() {
            vm.chart4 = this;
        }

        function filter() {
            dataservice.resultChart1(vm.sportoloId, vm.discipline, vm.selectdateFrom, vm.selectdateTo, vm.sectionId, vm.ageGroupId).then(function (data) {
                vm.data1 = data.itemsList;
                vm.chart1.model.series[0].points = vm.data1;
                if (vm.data1.length === 0) {
                    vm.chart1.model.series[0].marker.visible = false;
                }
                vm.chart1.redraw();
            });
            dataservice.resultChart2(vm.sportoloId, vm.discipline, vm.selectdateFrom, vm.selectdateTo, vm.sectionId, vm.ageGroupId).then(function (data) {
                vm.data2 = data.itemsList;
                vm.chart2.model.series[0].points = vm.data2;
                if (vm.data2.length === 0) {
                    vm.chart2.model.series[0].marker.visible = false;
                }
                vm.chart2.redraw();
            });
            dataservice.resultChart3(vm.sportoloId, vm.discipline, vm.selectdateFrom, vm.selectdateTo, vm.sectionId, vm.ageGroupId).then(function (data) {
                vm.data3 = data.itemsList;
                vm.chart3.model.series[0].points = vm.data3;
                if (vm.data3.length === 0) {
                    vm.chart3.model.series[0].marker.visible = false;
                }
                vm.chart3.redraw();
            });
            dataservice.resultDateChart(vm.sportoloId, vm.discipline, vm.selectdateFrom, vm.selectdateTo, vm.sectionId, vm.ageGroupId).then(function (data) {
                vm.data4 = $filter('dateStringFilter2')(data.itemsList, 'x');
                vm.chart4.model.series[0].points = vm.data4;
                if (vm.data4.length === 0) {
                    vm.chart4.model.series[0].marker.visible = false;
                }
                vm.chart4.redraw();
            });
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.athletes.athletesManagement.athleteModify.competitionResultsChart')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'athletes.athletesManagement.athleteModify.competitionResultsChart',
                config: {
                    url: '/competitionResultsChart',
                    templateUrl: 'app/athletes/athletesManagement/athleteModify/competitionResultsChart/competitionResultsChart.html',
                    controller: 'CompetitionResultsChartController',
                    controllerAs: 'vm',
                    title: 'CompetitionResultsChart'
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    AthleteModifyDataSheetController.$inject = ["log", "logger", "dataservice", "$q", "DOMAIN", "$rootScope", "gettextCatalog", "paramHelper", "authenticationService", "$filter", "$scope", "VIEW_DATA", "$state", "$timeout"];
    angular
        .module('app.athletes.athletesManagement.athleteModify.dataSheet')
        .controller('AthleteModifyDataSheetController', AthleteModifyDataSheetController);

    function AthleteModifyDataSheetController(log, logger, dataservice, $q, DOMAIN, $rootScope, gettextCatalog, paramHelper, authenticationService, $filter, $scope, VIEW_DATA, $state, $timeout) {
        var vm = this;
        $rootScope.vm = vm;
        vm.display = false;

        vm.noImgUrl = DOMAIN.baseURL + DOMAIN.userImage;
        vm.photoUrl = vm.noImgUrl;
        vm.selectedItems = [0, 1];
        vm.sexNum = 0;
        vm.sexList = [
            {text: gettextCatalog.getString('Man'), value: 1},
            {text: gettextCatalog.getString('Woman'), value: -1}
        ];
        vm.betterHandList = [
            {text: gettextCatalog.getString('Left'), value: 1},
            {text: gettextCatalog.getString('Right'), value: 2},
            {text: gettextCatalog.getString('Both'), value: 3}
        ];
        vm.betterFootList = [
            {text: gettextCatalog.getString('Left'), value: 1},
            {text: gettextCatalog.getString('Right'), value: 2},
            {text: gettextCatalog.getString('Both'), value: 3}
        ];
        vm.feeOfEducationList = [
            {text: gettextCatalog.getString('EducationFee'), value: -1},
            {text: gettextCatalog.getString('SportServiceFee'), value: 1}
        ];

        vm.parentList = [];

        vm.FatherMotherList = [
            {value: 'mother', text: gettextCatalog.getString('Mother')},
            {value: 'father', text: gettextCatalog.getString('Father')},
        ];

        // Oktatási díj = 0 - Sportszolgáltatási díj = Tagdíj = 1;
        vm.feeOfEducationValue = gettextCatalog.getString('SportServiceFee'); // Sportszolgáltatási díjas
        vm.countyList = VIEW_DATA.dropDownList.counties;
        vm.courseList = VIEW_DATA.dropDownList.course;
        vm.classList = VIEW_DATA.dropDownList.class;
        vm.emptyResultText = gettextCatalog.getString('emptyResultText');
        vm.fatherNames = [];
        vm.motherNames = [];
        vm.feeOfEducationDataStart = undefined; // String
        vm.feeOfEducationDateOk = false;
        vm.sectionList = []; // recived section list
        vm.ageGroupList = []; // recived age group list
        vm.coachList = []; // for reentering
        vm.sectionListSwal = []; // recived section list
        vm.ageGroupListSwal = []; // recived age group list
        vm.coachListSwal = []; // for reentering
        vm.athleteDataSwalSzakosztaly = undefined;
        vm.athleteDataSwalKorcsoport = undefined;
        vm.athleteDataSwalEdzo = undefined;
        vm.secondAthleteDataSwalSzakosztaly = undefined;
        vm.secondAthleteDataSwalKorcsoport = undefined;
        vm.secondAthleteDataSwalEdzo = undefined;
        vm.allowEdit = true;

        vm.isSecondCoach = false;
        vm.isSecondCoachChange = false;
        vm.secondAgeGroupList = [];
        vm.secondSectionList = [];
        vm.secondCoachList = [];
        vm.secondAgeGroupListSwal = [];
        vm.secondSectionListSwal = [];
        vm.secondCoachListSwal = [];
        vm.selectedExitDate = undefined;
        vm.exitAthleteDateOk = false;
        // Athlete parameters
        vm.selectedAgeGroupText = undefined; // selected age group name
        vm.selectedAthlete = [];
        vm.athleteData = {
            Id: undefined,
            AdoSzam: undefined, // String
            Aktiv: undefined, // Boolean
            AktTestmagassag: undefined, // Int32?
            AktTestsuly: undefined, // Int32?
            Allampolgarsag: undefined, // String
            AnyjaLeanykoriNeve: undefined, // String
            AnyjaNeve: undefined, // String
            AnyjaTestmagassaga: undefined, // Int32?
            ApjaTestmagassaga: undefined, // Int32
            BefOktdij: undefined, // Decimal
            BefTagdij: undefined, // Decimal
            DSITagsagKezdete: undefined, // DateTime
            EddigiEdzoi: undefined, // String
            EddigiSpEgyesuletei: undefined, // String
            EdzesreJarasKezdete: undefined, // DateTime
            Egyenleg: undefined, // Decimal
            Elerhetoseg: undefined, // String
            EmailCim: undefined, // String
            EvzarasOsszege: undefined, // Decimal?
            FajiEredet: undefined, // String
            Fenykep: undefined, // Byte[]
            FenykepUt: undefined, // String
            fileData: null,
            FurdokopenyDb: undefined, // String
            FurdokopenyErtek: undefined, // String
            FurdokopenyMerete: undefined, // String
            GyermekkoriSport: undefined, // String
            IdSzakosztaly: undefined, // Int32
            IskolaEvfolyam: undefined, // String
            IskolaHazszam: undefined, // String
            IskolaIgazgatoNeve: undefined, // String
            IskolaIrSzam: undefined, // String
            IskolaNeve: undefined, // String
            IskolaOsztaly: undefined, // String
            IskolaUtca: undefined, // String
            IskolaVaros: undefined, // String
            JelenlegiEdzo: undefined, // int
            KabatDb: undefined, // String
            KabatErtek: undefined, // String
            KabatMerete: undefined, // String
            KilepesDatuma: undefined, // DateTime
            KilepesIndoka: undefined, // String
            Korcsoport: undefined, // Int32
            LakcimHazszam: undefined, // String
            LakcimIrSzam: undefined, // String
            LakcimMegye: undefined, // String
            LakcimUtca: undefined, // String
            LakcimVaros: undefined, // String
            LeanykoriNev: undefined, // String
            MasodlagosSzakosztaly: undefined, // Int32?
            MasodlagosSzakosztalyEdzoId: undefined,
            MasodlagosKorcsoport: undefined,
            Megjegyzes: undefined, // String
            MelegitoDb: undefined, // String
            MelegitoErtek: undefined, // String
            MelegitoMerete: undefined, // String
            Neme: undefined, // String
            Nev: undefined, // String
            OsztalyFonokNeve: undefined, // String
            PancelNadragDb: undefined, // String
            PancelNadragErtek: undefined, // String
            PancelNadragMerete: undefined, // StringCipo
            UszoNadragMerete: undefined, // StringCipo
            PapucsDb: undefined, // String
            PapucsErte: undefined, // String
            PapucsMerete: undefined, // String
            CipoDb: undefined, // String
            CipoErtek: undefined, // String
            CipoMerete: undefined, // String
            PoloDb: undefined, // String
            PoloErtek: undefined, // String
            PoloMerete: undefined, // String
            PubertasVege: undefined, // DateTime
            RegisztraciosSzam: undefined, // String
            SortDb: undefined, // String
            SortErtek: undefined, // String
            SortMerete: undefined, // String
            SportoloiMultAnya: undefined, // String
            SportoloiMultApa: undefined, // String
            SportolokID: undefined, // Int32
            SzakosztalyNev: undefined, // String
            SzemIgSzam: undefined, // String
            SzuletesiHelyOrszag: undefined,
            SzuletesiHelyVaros: undefined, // String
            SzuletesiIdo: undefined, // DateTime
            Szulo1Elerhetosege: undefined, // String
            Szulo2Elerhetosege: undefined, // String
            SzulokFoglalkozasa: undefined, // String
            SzuloNeve: undefined, // String
            SzunideiElfoglaltsag: undefined, // String
            Tagdijas: undefined, // Boolean
            TAJSzam: undefined, // String
            Testmagassag: undefined, // Int32?
            TestneveloElerhetosege: undefined, // String
            TestneveloNeve: undefined, // String
            Testsuly: undefined, // Int32?
            UgyesebbKez: undefined, // String
            UgyesebbLabT: undefined, // String
            UtlevelSzam: undefined, // String
            UtolsoFrissites: undefined, // DateTime
            ValasztottSportagak: undefined, // String
            VersSportKezd: undefined, // DateTime
            VisszalepesDatuma: undefined, // DateTime?
        };
        vm.sportoloId = -1; // for sql quetion
        // This value show when start the new Fee of education mode
        vm.feeOfEducationDate = undefined;
        // Current coach name in text by Id
        vm.currentCoachNameInText = undefined;
        // Grid's details
        vm.schoolGridSelectedRowData = {};

        vm.columnsUsersOfAthlete = [
            {field: 'UserName', headerText: gettextCatalog.getString('UserName')},
            {
                field: 'UserTeljesNev',
                headerText: gettextCatalog.getString('UserFullName'),
                textAlign: 'left',
                template: '#atmotemplateDataColumn4'
            },
            {field: 'szerep', headerText: gettextCatalog.getString('Role')},
            {
                headerText: gettextCatalog.getString('unlinkUserFromAthlete'),
                textAlign: 'left',
                template: '#atmotemplateDataColumn5'
            }
        ];

        vm.columnsSchool = [
            {field: 'IskolaNeve', headerText: gettextCatalog.getString('SchoolName')},
            {field: 'IskolaIrSzam', headerText: gettextCatalog.getString('SchoolZipCode')},
            {field: 'IskolaVaros', headerText: gettextCatalog.getString('SchoolCity')},
            {field: 'IskolaUtca', headerText: gettextCatalog.getString('SchoolStreet')},
            {field: 'IskolaHazszam', headerText: gettextCatalog.getString('SchoolNumber')},
            {field: 'IskolaIgazgatoNeve', headerText: gettextCatalog.getString('SchoolDirectorName')}
        ];
        // Grid columnsAthleteMoveStory

        vm.columnsAthleteMoveStory = [
            {
                field: 'Edzo',
                headerText: gettextCatalog.getString('CoachName'),
                width: 100,
                template: '#atmotemplateDataColumn1'
            },
            {field: 'Szakosztaly', headerText: gettextCatalog.getString('Section'), width: 100},
            {field: 'Korcsoport', headerText: gettextCatalog.getString('AgeGroup'), width: 100},
            {field: 'Felvitel', headerText: gettextCatalog.getString('StartTime'), width: 100},
            {field: 'IdoszakVege', headerText: gettextCatalog.getString('EndTime'), width: 100},
            {
                field: 'Belepes',
                headerText: gettextCatalog.getString('Enter'),
                textAlign: 'center',
                width: 70,
                type: 'boolean',
                displayAsCheckBox: true
            },
            {
                field: 'Kilepes',
                headerText: gettextCatalog.getString('GoOut'),
                textAlign: 'center',
                width: 70,
                type: 'boolean',
                displayAsCheckBox: true
            }
        ];
        // Public functions
        // AthleteModify functions
        // Drop Down List function
        vm.sectionDataBound = sectionDataBound;
        vm.sectionSelect = sectionSelect;
        vm.getSections = getSections;

        // Second
        vm.secondSectionSelect = secondSectionSelect;
        vm.secondAgeGroupSelect = secondAgeGroupSelect;
        vm.secondAgeGroupDataBound = secondAgeGroupDataBound;
        vm.changeSecondAgeGroup = changeSecondAgeGroup;
        vm.secondCoachDropDownListDataBound = secondCoachDropDownListDataBound;
        vm.selectSecondCoachBtn = selectSecondCoachBtn;
        vm.exitingSecondSectionBtn = exitingSecondSectionBtn;
        vm.coachDropDownListDataBound = coachDropDownListDataBound;
        vm.ageGroupDataBound = ageGroupDataBound;
        vm.ageGroupSelect = ageGroupSelect;
        // Top menu buttons functions
        vm.anthropometry = anthropometry; // Public
        //vm.enteringAthlete = enteringAthlete; // public
        vm.generateRegNum = generateRegNum;

        // Image cropper variables
        vm.deleteImg = deleteImg; // Public, delete the photo from user profile 999 Hofi

        vm.save = save;
        vm.cropper = {}; // Ricsi
        vm.cropper.sourceImage = null; // Ricsi
        vm.cropper.croppedImage = null; // Ricsi
        vm.bounds = {}; // Ricsi
        vm.bounds.left = 0; // Ricsi
        vm.bounds.right = 0; // Ricsi
        vm.bounds.top = 0; // Ricsi
        vm.bounds.bottom = 0; // Ricsi
        vm.cropDialogTitle = gettextCatalog.getString('ChooseImageTitle'); // Ricsi

        vm.openCropDialog = openCropDialog; // Ricsi
        vm.doneCropDialog = doneCropDialog; // Ricsi
        vm.closeCropDialog = closeCropDialog; // Ricsi
        // Change Age Group
        vm.changeAgeGroup = changeAgeGroup;
        // sex (gende) dropdown public function
        vm.sexSelect = sexSelect;
        // Height dropdown public function
        vm.changeHeight = changeHeight;
        // Weight dropdown public function
        vm.changeWeight = changeWeight;
        // better Hand dropdown public function
        vm.betterHandSelect = betterHandSelect;
        // better Foot dropdown public function
        vm.betterFootSelect = betterFootSelect;
        // Social security number required
        vm.socialSecurityNumberRequiredValue = false;
        vm.athleteRegistrationNumberRequiredValue = false;
        //
        vm.changeFeeOfEducationBtn = changeFeeOfEducationBtn;
        // select coach
        vm.selectCoachBtn = selectCoachBtn;
        // Select Schools
        vm.selectSchools = selectSchools;
        // Grid selcted row
        vm.schoolGridSelectedRow = schoolGridSelectedRow;
        vm.coachList = [];
        vm.clearSecondSection = clearSecondSection;
        vm.clearSecondAgeGroup = clearSecondAgeGroup;
        vm.clearSecondCoach = clearSecondCoach;
        vm.openCoach = openCoach;
        vm.createLoginForAthlete = createLoginForAthlete;
        vm.createLoginForParents = createLoginForParents;
        vm.createLoginForExistingParent = createLoginForExistingParent;

        vm.photoUrl = vm.noImgUrl;
        vm.unlinkUserFromAthlete = unlinkUserFromAthlete;

        // School Grid datasource initial
        vm.displayButtons = true;
        vm.coachListGridData = [];
        vm.tajkeres = true;
        vm.ADMIN = false;
        vm.UJEDZVALT = false;
        vm.MODFELH = false;
        vm.SPORTKILEP = false;
        vm.SPORTKILEPTET = false;
        vm.SPORTBELEPTET = false;
        vm.ModFizetesMod = false;
        vm.SPORTOLO = false;
        vm.SZULO = false;
        vm.EGESZSMEGT = false;
        vm.aktiv = true;
        vm.RUHA = {
            CIPO: false,
            PAPUCS: false,
            MELEGITO: false,
            FURDOKOPENY: false,
            KABAT: false,
            PANCELNADRAG: false,
            POLO: false,
            SORT: false,
            USZONADRAG: false
        };

        vm.reportParametersSchoolRequesting = {};
        vm.SportoloCsoportok = [];
        vm.SzuloCsoportok = [];

        vm.gymTeacherDatasource = [];
        vm.classMasterDatasource = [];
        vm.schoolNameChanged = schoolNameChanged;

        var grid = new ej2.grids.Grid({
            dataSource: [],
            allowPaging: true,
            allowTextWrap: true,
            allowSorting: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columnsSchool,
            rowSelected: schoolGridSelectedRow,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#Grid'), $scope);
                }
            }
        });
        grid.appendTo('#Grid');

        var gridUsersOfAthlete = new ej2.grids.Grid({
            dataSource: [],
            allowTextWrap: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            columns: vm.columnsUsersOfAthlete,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            }
        });
        gridUsersOfAthlete.appendTo('#GridUsersOfAthlete');

        var grid123 = new ej2.grids.Grid({
            dataSource: [],
            allowPaging: true,
            allowTextWrap: true,
            allowSorting: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columnsAthleteMoveStory,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#Grid'), $scope);
                }
            }
        });
        grid123.appendTo('#Grid123');

        // Activate page
        activate();
        $scope.$on('$viewContentLoaded', function () {
            // Set checkbox
            if (vm.sportoloId <= 0) {
                angular.element('#active').ejCheckBox({checked: true});
            }
        });

        function generateRegNum() {
            dataservice.GenerateRegNum().then(function (data) {
                vm.athleteData.RegisztraciosSzam = data.data;
            });
        }

        function getParentUserGroups() {
            return dataservice.SzuloCsoportokDropDownList().then(function (data) {
                vm.SzuloCsoportok = data.itemsList;
            });
        }

        function getAthleteUserGroups() {
            return dataservice.SportoloCsoportokDropDownList().then(function (data) {
                vm.SportoloCsoportok = data.itemsList;
            });
        }

        function activate() {
            $q.all([paramHelper.getParams(['athleteModify.sportoloId'], ['athleteModify.sportoloNev', 'selectedSectionId', 'selectedAgeGroupId', 'selectedActiveOrInactive', 'selectedPage', 'selectedRow']),
                authenticationService.getRight('ADMIN'),
                authenticationService.getRight('UJEDZVALT'),
                authenticationService.getRight('MODFELH'),
                authenticationService.getRight('SPORTKILEP'),
                authenticationService.getRight('ModFizetesMod'),
                authenticationService.getRight('MODSPORTOLO'),
                authenticationService.getRight('SPORTOLO'),
                authenticationService.getRight('SZULO'),
                authenticationService.getRight('EGESZSMEGT'),
                authenticationService.getRight('KMVERSEREDM'),
                authenticationService.getRight('MEGTHAVIJEL'),
                authenticationService.getRight('MODTAGDBEALL'),
                authenticationService.getRight('MEGTANTFELM'),
                authenticationService.getRight('MEGTKPFELM'),
                authenticationService.getRight('MEGTSPFELM'),
                authenticationService.getRight('PSYCHO'),
                authenticationService.getRight('KIKERONYOMT'),
                authenticationService.getRight('TESTMERET'),
                authenticationService.getRight('MEGTSPORTBEF'),
                authenticationService.getRight('MODKOROKEZ'),
                authenticationService.getRight('LOG'),
                authenticationService.getRight('DOKLIST'),
                authenticationService.getRight('UJFELH'),
                getSystemSettings('NINCSOKTDIJ')
            ]).then(function (results) {
                vm.ADMIN = results[1];
                vm.UJEDZVALT = results[2];
                vm.MODFELH = results[3];
                vm.SPORTKILEP = results[4];
                vm.ModFizetesMod = results[5];
                vm.MODSPORTOLO = results[6];
                vm.SPORTOLO = results[7];
                vm.SZULO = results[8];
                vm.EGESZSMEGT = results[9];
                vm.KMVERSEREDM = results[10];
                vm.MEGTHAVIJEL = results[11];
                vm.MODTAGDBEALL = results[12];
                vm.MEGTANTFELM = results[13];
                vm.MEGTKPFELM = results[14];
                vm.MEGTSPFELM = results[15];
                vm.PSYCHO = results[16];
                vm.KIKERONYOMT = results[17];
                vm.TESTMERET = results[18];
                vm.MEGTSPORTBEF = results[19];
                vm.MODKOROKEZ = results[20];
                vm.LOG = results[21];
                vm.DOKLIST = results[22];
                vm.NINCSOKTDIJ = results[23];
                vm.UJFELH = results[24];
                vm.photoUrl = vm.noImgUrl;

                vm.sportoloId = results[0]['athleteModify.sportoloId'];

                var promises = [getSystemSettings('TAJKOTELEZO'), getSystemSettings('SNYSZKOTELEZO'), getSystemSettings('SPORTMINKOTELEZO')];
                $q.all(promises).then(function (results) {
                    vm.socialSecurityNumberRequiredValue = results[0];
                    vm.athleteRegistrationNumberRequiredValue = results[1];
                    vm.athleteRequiredMinimumDatas = results[2];
                });

                dataservice.getAthleteData(vm.sportoloId).then(function (data) {
                    vm.athleteData = data;
                    RefreshClothes();
                    vm.sportoloNev = vm.athleteData.Nev;
                    $rootScope.title = vm.sportoloNev + ' - ' + gettextCatalog.getString('DataSheet');
                    init();
                });
            });
        }

        function RefreshClothes() {
            $timeout(function () {
                dataservice.SzakosztalyRuhai(vm.athleteData.IdSzakosztaly, vm.athleteData.MasodlagosSzakosztaly).then(function (ruhaResponse) {
                    vm.RUHA = ruhaResponse.data;
                });
            }, 100);
        }

        function init() {
            initAthleteDatas();
            getParentUserGroups();
            getAthleteUserGroups();
            getParentsList();
            getUsersBelongingToAthlete(vm.athleteData.SportolokID);
            getParentNames();
            getAthleteMoveStory(vm.athleteData.SportolokID);
        }

        function unlinkUserFromAthlete(userid, sportoloid, szerep) {
            var promises = [authenticationService.getRight('MODFELH')];
            $q.all(promises).then(function (res) {
                if (!res[0]) {
                    log.permissionError();
                } else {
                    if (szerep == 0) {
                        swal({
                            title: gettextCatalog.getString('Are you sure you want to unlink and delete the selected user?'),
                            type: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: '#DD6B55',
                            confirmButtonText: gettextCatalog.getString('Yes'),
                            cancelButtonText: gettextCatalog.getString('Cancel')
                        }).then(function (isConfirm) {
                            if (isConfirm.value) {
                                return dataservice.unlinkUserFromAthlete(userid, sportoloid).then(function () {
                                    log.successMsg(gettextCatalog.getString('UserUnlinkedAndDeleted'));
                                    activate();
                                });
                            }
                        });
                    } else {
                        swal({
                            title: gettextCatalog.getString('Are you sure you want to unlink the selected user?'),
                            type: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: '#DD6B55',
                            confirmButtonText: gettextCatalog.getString('Yes'),
                            cancelButtonText: gettextCatalog.getString('Cancel'),
                        }).then(function (isConfirm) {
                            if (isConfirm.value) {
                                return dataservice.unlinkUserFromAthlete(userid, sportoloid).then(function () {
                                    log.successMsg(gettextCatalog.getString('UserUnlinked'));
                                    activate();
                                });
                            }
                        });
                    }
                }
            })
                .catch(function () {
                    log.permissionError();
                });
        }

        function getParentsList() {
            dataservice.athleteAndParentDropDownList('parent')
                .then(function (data) {
                    vm.parentList = data.itemsList;
                });
        }

        vm.parentDataSwal = undefined;

        function parentSwalDatabound() {
            if (vm.parentList.length === 1) {
                angular.element('#parentDropDownSwal').ejDropDownList('selectItemByValue', vm.parentList[0].value);
            } else {
                angular.element('#parentDropDownSwal').ejDropDownList('selectItemByValue', vm.parentDataSwal);
            }
        }

        function selectParentDropDownSwal(arg) {
            vm.parentDataSwal = arg.value;
        }

        function createLoginForExistingParent() {
            var promises = [authenticationService.getRight('UJFELH')];
            $q.all(promises).then(function (res) {
                if (!res[0]) {
                    log.permissionError();
                } else {
                    var HTMLtext = '<div style="margin-top: 10px;" >' +
                        '<label class="col-lg-6" style="text-align: left; margin-top:5px;">' + gettextCatalog.getString('SelectParentForAthlete') + '</label>' +
                        '<input class="col-lg-6 col-lg-offset-6" id="parentDropDownSwal" ej-dropdownlist></div><br><br>';
                    swal({
                        title: gettextCatalog.getString('CreateLoginForExistingParent'),
                        html: HTMLtext,
                        type: 'question',
                        showCancelButton: true,
                        confirmButtonColor: '#DD6B55',
                        confirmButtonText: gettextCatalog.getString('Ok'),
                        cancelButtonText: gettextCatalog.getString('Cancel'),
                    }).then(function (isConfirm) {
                        if (isConfirm.value) {
                            dataservice.assignAthleteToParentUser(vm.parentDataSwal, vm.athleteData.SportolokID, vm.selectedSzuloCsoport).then(function (arg) {
                                if (arg.data > 0) {
                                    log.successMsg(gettextCatalog.getString('AthleteAssignedToUserSuccessfully'));
                                    activate();
                                }
                            });
                        }
                    });
                    angular.element('#parentDropDownSwal').ejDropDownList({
                        dataSource: vm.parentList,
                        select: selectParentDropDownSwal,
                        value: vm.parentDataSwal,
                        databound: parentSwalDatabound,
                        width: '100%'
                    });
                }
            })
                .catch(function () {
                    log.permissionError();
                });
        }

        vm.fathermotherDataSwal = undefined;

        function fatherMotherSwalDatabound() {
            if (vm.FatherMotherList.length === 1) {
                angular.element('#fatherMotherDropDownSwal').ejDropDownList('selectItemByValue', vm.FatherMotherList[0].value);
            } else {
                angular.element('#fatherMotherDropDownSwal').ejDropDownList('selectItemByValue', vm.fathermotherDataSwal);
            }
        }

        function selectFatherMotherDropDownSwal(arg) {
            vm.fathermotherDataSwal = arg.value;
        }

        vm.selectedSzuloCsoport = undefined;

        function selectParentGroupDropDownSwal(arg) {
            vm.selectedSzuloCsoport = arg.value;
        }

        function createLoginForParents() {
            var promises = [authenticationService.getRight('UJFELH')];
            $q.all(promises).then(function (res) {
                if (!res[0]) {
                    log.permissionError();
                } else {
                    var HTMLtext = '<div class="row" style="margin-top: 10px;" ><div class="col-lg-6" style="text-align: left; margin-top:5px;"><label>' + gettextCatalog.getString('WhichParent') +
                        '</label></div><div class="col-lg-6"><input id="fatherMotherDropDownSwal" ej-dropdownlist></div></div><br><br>' +
                        '<div class="row" style="margin-top: 10px;"><div class="col-lg-6" style="text-align: left; margin-top:5px;"><label>' + gettextCatalog.getString('SelectParentGroup') + '</label></div>' +
                        '<div class="col-lg-6"><input id="parentGroupsDropDownSwal" ej-dropdownlist></div></div><br><br>' +
                        '<div class="row" style="margin-top: 10px;"><div class="col-lg-6" style="text-align: left; margin-top:5px;"><label>' + gettextCatalog.getString('Username') +
                        '</label></div><div class="col-lg-6"><input id="parentUserName" name="parentUserName" maxlength="30"></div></div>' +
                        '<div class="row" style="margin-top: 10px;"><div class="col-lg-6" style="text-align: left; margin-top:5px;"><label>' + gettextCatalog.getString('Password') +
                        '</label></div><div class="col-lg-6"><input type="password" id="parentPassword" name="parentPassword" maxlength="10"></div></div>' +
                        '<div class="row" style="margin-top: 10px;"><div class="col-lg-6" style="text-align: left; margin-top:5px;"><label>' + gettextCatalog.getString('PassordAgain') +
                        '</label></div><div class="col-lg-6"><input type="password" id="parentPasswordAgain" name="parentPasswordAgain" maxlength="10"></div></div>';
                    swal({
                        title: gettextCatalog.getString('CreateLoginForParents'),
                        html: HTMLtext,
                        type: 'question',
                        showCancelButton: true,
                        confirmButtonColor: '#DD6B55',
                        confirmButtonText: gettextCatalog.getString('Ok'),
                        cancelButtonText: gettextCatalog.getString('Cancel'),
                        preConfirm: function () {
                            return new Promise(function (resolve) {
                                var parentUserName = document.getElementById('parentUserName').value;
                                var parentPassword = document.getElementById('parentPassword').value;
                                var parentPasswordAgain = document.getElementById('parentPasswordAgain').value;
                                if (!(vm.fathermotherDataSwal == 'mother' || vm.fathermotherDataSwal == 'father')) {
                                    swal.showValidationError(gettextCatalog.getString('ChooseWhichParentRegisters'));
                                }
                                if (!parentPassword || parentPassword.length < 5) {
                                    swal.showValidationError(gettextCatalog.getString('PasswordMustBeAtLeast5CharactersLong'));
                                }
                                if (parentPassword.length > 10) {
                                    swal.showValidationError(gettextCatalog.getString('PasswordMustBeAtMost10CharactersLong'));
                                }
                                if (parentPassword !== parentPasswordAgain) {
                                    swal.showValidationError(gettextCatalog.getString('PasswordFieldsMustMatch'));
                                }
                                if (!parentUserName || parentUserName.length < 5) {
                                    swal.showValidationError(gettextCatalog.getString('UsernameMustBeAtLeast5CharactersLong'));
                                }
                                if (parentUserName.length > 30) {
                                    swal.showValidationError(gettextCatalog.getString('UsernameMustBeAtMost10CharactersLong'));
                                }
                                if (!(vm.selectedSzuloCsoport > 0)) {
                                    swal.showValidationError(gettextCatalog.getString('SelectParentUserGroup'));
                                }
                                resolve();
                            });
                        }
                    }).then(function (confirmed) {
                        if (confirmed.value) {
                            var parentUserName = document.getElementById('parentUserName').value;
                            var parentPassword = document.getElementById('parentPassword').value;
                            dataservice.createLoginForParent(parentUserName, parentPassword, vm.fathermotherDataSwal, vm.athleteData.SportolokID, vm.selectedSzuloCsoport).then(function (arg) {
                                if (arg.data > 0) {
                                    log.successMsg(gettextCatalog.getString('UserCreatedSuccessfully'));
                                    activate();
                                }
                            });
                        }
                    });
                    angular.element('#parentGroupsDropDownSwal').ejDropDownList({
                        dataSource: vm.SzuloCsoportok,
                        value: vm.selectedSzuloCsoport,
                        select: selectParentGroupDropDownSwal,
                        width: '100%'
                    });
                    angular.element('#fatherMotherDropDownSwal').ejDropDownList({
                        dataSource: vm.FatherMotherList,
                        select: selectFatherMotherDropDownSwal,
                        value: vm.fathermotherDataSwal,
                        databound: fatherMotherSwalDatabound,
                        width: '100%'
                    });
                }
            })
                .catch(function () {
                    log.permissionError();
                });
        }

        vm.selectedSportoloCsoport = undefined;

        function selectAthleteGroupDropDownSwal(arg) {
            vm.selectedSportoloCsoport = arg.value;
        }

        function createLoginForAthlete() {
            var promises = [authenticationService.getRight('UJFELH')];
            $q.all(promises).then(function (res) {
                if (!res[0]) {
                    log.permissionError();
                } else {
                    var HTMLtext =
                        '<div class="row" style="margin-top: 10px;"><div class="col-lg-6"><label>' + gettextCatalog.getString('Username') +
                        '</label></div><div class="col-lg-6"><input id="athleteUserName" name="athleteUserName" minlength="2" maxlength="30" style="width: 100%"></div></div>' +
                        '<div class="row" style="margin-top: 10px;"><div class="col-lg-6"><label>' + gettextCatalog.getString('Password') +
                        '</label></div><div class="col-lg-6"><input type="password" id="athletePassword" name="athletePassword" maxlength="10" style="width: 100%"></div></div>' +
                        '<div class="row" style="margin-top: 10px;"><div class="col-lg-6"><label>' + gettextCatalog.getString('PassordAgain') +
                        '</label></div><div class="col-lg-6"><input type="password" id="athletePasswordAgain" name="athletePasswordAgain" minlength="5" maxlength="10" style="width: 100%"></div></div>' +
                        '<div class="row" style="margin-top: 10px;"><div class="col-lg-6"><label>' + gettextCatalog.getString('SelectAthleteGroup') + '</label></div>' +
                        '<div class="col-lg-6"><input id="athleteGroupsDropDownSwal" ej-dropdownlist></div></div>';
                    swal({
                        title: gettextCatalog.getString('CreateLoginForAthlete'),
                        html: HTMLtext,
                        type: 'question',
                        showCancelButton: true,
                        allowOutsideClick: false,
                        confirmButtonColor: '#DD6B55',
                        confirmButtonText: gettextCatalog.getString('Ok'),
                        cancelButtonText: gettextCatalog.getString('Cancel'),
                        preConfirm: function () {
                            var athleteUserName = document.getElementById('athleteUserName').value;
                            var athletePassword = document.getElementById('athletePassword').value;
                            var athletePasswordAgain = document.getElementById('athletePasswordAgain').value;
                            var preConfOk = true;
                            return new Promise(function (resolve) {
                                if (!athletePassword || athletePassword.length < 5) {
                                    swal.showValidationError(gettextCatalog.getString('PasswordMustBeAtLeast5CharactersLong'));
                                    preConfOk = false;
                                }
                                if (athletePassword.length > 10) {
                                    swal.showValidationError(gettextCatalog.getString('PasswordMustBeAtMost10CharactersLong'));
                                    preConfOk = false;
                                }
                                if (athletePassword != athletePasswordAgain) {
                                    swal.showValidationError(gettextCatalog.getString('PasswordFieldsMustMatch'));
                                    preConfOk = false;
                                }
                                if (!athleteUserName || athleteUserName.length < 5) {
                                    swal.showValidationError(gettextCatalog.getString('UsernameMustBeAtLeast5CharactersLong'));
                                    preConfOk = false;
                                }
                                if (athleteUserName.length > 30) {
                                    swal.showValidationError(gettextCatalog.getString('UsernameMustBeAtMost10CharactersLong'));
                                    preConfOk = false;
                                }
                                if (!vm.selectedSportoloCsoport) {
                                    swal.showValidationError(gettextCatalog.getString('SelectAthleteUserGroup'));
                                    preConfOk = false;
                                }
                                resolve();
                            });
                        }
                    }).then(function (isConfirmed) {
                        if (isConfirmed.value) {
                            var athleteUserName = document.getElementById('athleteUserName').value;
                            var athletePassword = document.getElementById('athletePassword').value;
                            dataservice.createLoginForAthlete(athleteUserName, athletePassword, vm.athleteData.SportolokID, vm.selectedSportoloCsoport).then(function (arg) {
                                if (arg.data > 0) {
                                    log.successMsg(gettextCatalog.getString('UserCreatedSuccessfully'));
                                    activate();
                                }
                            });
                        }
                    });
                    angular.element('#athleteGroupsDropDownSwal').ejDropDownList({
                        dataSource: vm.SportoloCsoportok,
                        value: vm.selectedSportoloCsoport,
                        select: selectAthleteGroupDropDownSwal,
                        width: '100%'
                    });
                }
            })
                .catch(function () {
                    log.permissionError();
                });
        }

        vm.sexDatabound = function () {
            $timeout(function () {
                $('#gender').ejDropDownList('selectItemByValue', vm.sexNum);
            }, 100);
        };

        function initAthleteDatas() {
            if (!vm.athleteData.currentUserCanModifyAthlete) {
                vm.allowEdit = false;
                log.successMsg(gettextCatalog.getString('AthleteDatasheetIsReadyOnly'));
            } else {
                vm.allowEdit = true;
            }
            if (vm.athleteData.Aktiv) {
                vm.SPORTBELEPTET = false;
                vm.SPORTKILEPTET = true;
                vm.displayButtons = true;
            } else {
                vm.SPORTBELEPTET = true;
                vm.SPORTKILEPTET = false;
                vm.displayButtons = false;
            }

            // Oktatási díj = 0 - Sportszolgáltatási díj = 1;
            if (vm.athleteData.Tagdijas) {
                vm.feeOfEducationValue = gettextCatalog.getString('SportServiceFee');
            } else {
                vm.feeOfEducationValue = gettextCatalog.getString('EducationFee');
            }

            if (vm.athleteData.FerfiB) {
                vm.sexNum = 1;
            } else {
                vm.sexNum = -1;
            }
            //angular.element('#feeOfEducation').ejDropDownList('selectItemByValue', vm.feeOfEducationValue);
            $timeout(function () {
                if (vm.athleteData.MasodlagosSzakosztalyEdzoId > 0) {
                    vm.isSecondCoach = true;
                    if (vm.UJEDZVALT) {
                        vm.isSecondCoachChange = true;
                    }
                } else {
                    vm.isSecondCoach = false;
                    vm.isSecondCoachChange = false;
                    getSecondSections(); // show dropDown and get datas
                }
                if (vm.athleteData.FenykepUt === 'avatar_2x.png') {
                    vm.photoUrl = vm.noImgUrl;
                } else {
                    vm.photoUrl = DOMAIN.baseURL + DOMAIN.profileImgBaseUrl + vm.athleteData.FenykepUt;
                }
                $scope.$apply();
            }, 0);
        }

        function save() {
            if (!(vm.MODSPORTOLO || vm.SPORTOLO || vm.SZULO)) {
                log.permissionError();
                return;
            }
            vm.athleteData.UgyesebbLab = vm.athleteData.UgyesebbLabT;
            vm.athleteData.UgyesebbKez = vm.athleteData.UgyesebbKezT;
            $scope.$broadcast('submitted');
            if ($scope.form.$valid === false) {
                angular.element('#accordion').ejAccordion('expandAll');
                log.errorMsg(gettextCatalog.getString('RequiredFieldsError'));
            } else {
                vm.athleteData.TAJSzam = angular.element('#socialSecurityNumber').ejMaskEdit('get_StrippedValue');
                modifyAthlete();
            }
        }

        function modifyAthlete() {
            var parameters = {
                naptol: vm.feeOfEducationDataStart,
                kivSportolo: vm.athleteData.SportolokID,
                csakUjak: 0,
                fizModValtas: 1
            };

            if (!(vm.MODSPORTOLO || vm.SPORTOLO || vm.SZULO)) {
                log.permissionError();
                return;
            }
            if (angular.element('#fileName').val() !== '' && vm.cropper.croppedImage !== null) {
                vm.athleteData.FenykepUt = angular.element('#fileName').val();
                vm.athleteData.Fenykep = vm.cropper.croppedImage;
            } else if (vm.photoUrl === vm.noImg) {
                vm.athleteData.fileName = 'avatar_2x.png';
                vm.athleteData.Fenykep = null;
            } else {
                vm.fileName = vm.athleteData.FenykepUt;
            }

            var dsiTime = new Date(vm.athleteData.DSITagsagKezdete);

            if (dsiTime.getTime() > new Date()) {
                swal({
                    title: gettextCatalog.getString('DateError'),
                    text: gettextCatalog.getString('TheMemberOfDSIDateLateThenNow'),
                    type: 'warning',
                    confirmButtonText: gettextCatalog.getString('Ok')
                });
            } else {
                if (vm.athleteData.MasodlagosSzakosztaly > 0) {
                    if (vm.athleteData.MasodlagosKorcsoport > 0) {
                        if (!(vm.athleteData.MasodlagosSzakosztalyEdzoId > 0)) {
                            log.errorMsg(gettextCatalog.getString('SecondSectionDetailsAreNotComplete'));
                            return;
                        }
                    } else {
                        log.errorMsg(gettextCatalog.getString('SecondSectionDetailsAreNotComplete'));
                        return;
                    }
                }
                dataservice.modifyAthlete(vm.athleteData)
                    .then(function (retval) {
                        if (retval.retValue) {
                            if (parameters.naptol) {
                                dataservice.meteOutFee(parameters).then(function () {
                                    log.successMsg('MeteOutFeeOK');
                                });
                            }
                            swal({
                                title: gettextCatalog.getString('SaveAthlete'),
                                text: gettextCatalog.getString('SaveAthleteSuccess'),
                                type: 'success',
                                confirmButtonColor: '#DD6B55',
                                confirmButtonText: gettextCatalog.getString('OK'),
                                closeOnConfirm: true
                            }).then(
                                function (isConfirm) {
                                    if (isConfirm.value) {
                                        if (!(vm.SPORTOLO || vm.SZULO)) {
                                            paramHelper.setParams([
                                                {'athleteList.selectedSectionId': vm.athleteData.IdSzakosztaly},
                                                {'athleteList.selectedAgeGroupId': vm.athleteData.Korcsoport}
                                            ]);
                                            $rootScope.back();
                                        }
                                    }
                                });
                        } else {
                            var message = gettextCatalog.getString(retval.message) + ' ' + gettextCatalog.getString(retval.error);
                            swal({
                                title: gettextCatalog.getString('SaveAthlete'),
                                text: message,
                                type: 'error',
                                confirmButtonColor: '#DD6B55',
                                confirmButtonText: gettextCatalog.getString('OK'),
                                closeOnConfirm: true
                            }).then(
                                function (isConfirm) {
                                    if (isConfirm.value) {
                                        paramHelper.setParams([
                                            {'athleteList.selectedSectionId': vm.athleteData.IdSzakosztaly},
                                            {'athleteList.selectedAgeGroupId': vm.athleteData.Korcsoport}
                                        ]);
                                        $rootScope.back();
                                    }
                                });
                        }
                    });
            }
        }

        function openCropDialog() {
            if (!(vm.MODSPORTOLO || vm.SPORTOLO)) {
                log.permissionError();
                return;
            }
            angular.element('#dialogContainer').css('visibility', 'visible');
            angular.element('#cropDialog').ejDialog('open');
        }

        function closeCropDialog() {
            angular.element('#dialogContainer').css('visibility', 'hidden');
            angular.element('#cropDialog').ejDialog('close');
        }

        function doneCropDialog() {
            vm.photoUrl = vm.cropper.croppedImage;
            angular.element('#cropDialog').ejDialog('close');
        }

        function deleteImg() {
            if (!(vm.MODSPORTOLO || vm.SPORTOLO)) {
                log.permissionError();
                return;
            }

            swal({
                title: gettextCatalog.getString('DeleteProfileImg'),
                text: gettextCatalog.getString('AreYouSureYouWantToDeleteTheProfileImg'),
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: gettextCatalog.getString('Yes'),
                cancelButtonText: gettextCatalog.getString('No')
            }).then(function (isConfirm) {
                if (isConfirm.value) {
                    angular.element('#fileName').val('');
                    var nem = vm.athleteData.Neme == 'Férfi' ? 'male' : 'female';
                    vm.athleteData.fileName = null;
                    vm.fileName = null;
                    vm.athleteData.FenykepUt = 'ath_' + nem + '_' + Math.ceil(Math.random() * (8 - 1) + 1) + '.png';
                    vm.photoUrl = DOMAIN.baseURL + DOMAIN.profileImgBaseUrl + vm.athleteData.FenykepUt;
                    dataservice.DeleteAthleteAvatar(vm.sportoloId, vm.athleteData.FenykepUt);
                    $scope.$apply();
                }
            });
        }

        function getSections() {
            dataservice.sectionDropDownList(vm.athleteData.JelenlegiEdzo)
                .then(function (data) {
                    vm.sectionList = data.itemsList;
                });
        }

        function sectionDataBound() {
            if (vm.sectionList.length === 1) {
                angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.sectionList[0].value);
            } else {
                angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.athleteData.IdSzakosztaly);
            }
        }

        function sectionSelect() {
            getAgeGroups();
        }

        function getSecondSections() {
            dataservice.sectionDropDownList(0)
                .then(function (data) {
                    // for (var i = 0; i < data.itemsList.length; i++) {
                    //     if (data.itemsList[i].value === vm.athleteData.IdSzakosztaly) {
                    //         data.itemsList.splice(i, 1);
                    //     }
                    //
                    // }
                    vm.secondSectionList = data.itemsList;
                });
        }

        function secondSectionSelect(selectedSection) {
            vm.athleteData.MasodlagosSzakosztaly = selectedSection.value;
            getSecondAgeGroups();
            RefreshClothes();
        }

        function getSecondCoacheList() {
            return dataservice.coachDropDownList(vm.athleteData.MasodlagosSzakosztaly, vm.athleteData.MasodlagosKorcsoport) // Kell a section id (szakosztály)
                .then(function (data) {
                    vm.secondCoachList = data.itemsList;
                });
        }

        function secondCoachDropDownListDataBound() {
            if (vm.coachList.length === 1) {
                angular.element('#secondCoachName').ejDropDownList('selectItemByValue', vm.coachList[0].value);
                vm.athleteData.MasodlagosSzakosztalyEdzoId = vm.coachList[0].value;
            } else {
                angular.element('#secondCoachName').ejDropDownList('selectItemByValue', vm.athleteData.MasodlagosSzakosztalyEdzoId);
            }
        }

        function selectSecondCoachBtn() {
            vm.athleteData.ModifyCoach = 2;
            paramHelper.setParams([
                {'athleteTransfer.athleteData': vm.athleteData},
                {'previousState': 'athletes.athletesManagement.athleteModify.dataSheet'}
            ]);
            $state.go('settings.athleteTransfer');
        }

        function changeSecondAgeGroup() {
            paramHelper.setParams([{
                'ageGroupChange.athleteData': vm.athleteData,
                'ageGroupChange.which': 2
            }]);
            $state.go('settings.ageGroupChange');
        }

        function getSecondAgeGroups() {
            dataservice.ageGroupDropDownList(vm.athleteData.MasodlagosSzakosztaly)
                .then(function (data) {
                    vm.secondAgeGroupList = data.itemsList;
                });
        }

        function secondAgeGroupDataBound() {
            if (vm.ageGroupList.length === 1) {
                angular.element('#secondAgeGroupDropDown').ejDropDownList('selectItemByValue', vm.ageGroupList[0].value);
            } else {
                angular.element('#secondAgeGroupDropDown').ejDropDownList('selectItemByValue', vm.athleteData.MasodlagosKorcsoport);
            }
        }

        function secondAgeGroupSelect(args) {
            vm.athleteData.MasodlagosKorcsoport = args.value;
            getSecondCoacheList();
        }

        function changeAgeGroup() {
            paramHelper.setParams([{
                'ageGroupChange.athleteData': vm.athleteData,
                'ageGroupChange.which': 1,
                'ageGroupChange.backPath': 'athletesManagement.athleteModify'
            }]);
            $state.go('settings.ageGroupChange');
        }

        function getAgeGroups() {
            dataservice.ageGroupDropDownList(vm.athleteData.IdSzakosztaly)
                .then(function (data) {
                    vm.ageGroupList = data.itemsList;
                });
        }

        function ageGroupDataBound() {
            if (vm.ageGroupList.length === 1) {
                angular.element('#ageGroupDropDown').ejDropDownList('selectItemByValue', vm.ageGroupList[0].value);
            } else {
                angular.element('#ageGroupDropDown').ejDropDownList('selectItemByValue', vm.athleteData.Korcsoport);
            }
        }

        function ageGroupSelect(args) {
            vm.selectedAgeGroupId = args.value;
        }

        function getActualCoachesList() {
            return dataservice.coachDropDownList(vm.athleteData.IdSzakosztaly) // Kell a section id (szakosztály)
                .then(function (data) {
                    vm.coachList = data.itemsList;
                });
        }

        function coachDropDownListDataBound() {
            angular.element('#coachName').ejDropDownList('selectItemByValue', vm.athleteData.JelenlegiEdzo);
        }

        function selectCoachBtn() {
            vm.athleteData.ModifyCoach = 1;
            paramHelper.setParams([
                {'athleteTransfer.athleteData': vm.athleteData},
                {'previousState': 'athletes.athletesManagement.athleteModify.dataSheet'}
            ]);
            $state.go('settings.athleteTransfer');
        }

        function sexSelect(arg) {
            vm.athleteData.FerfiB = arg.value === 1;
            if (vm.athleteData.FerfiB) {
                vm.athleteData.Neme = 'Férfi';
            } else {
                vm.athleteData.Neme = 'Nő';
            }
        }

        function changeHeight(args) {
            vm.athleteData.Testmagassag = args.value;
        }

        function changeWeight(args) {
            vm.athleteData.Testsuly = args.value;
        }

        function betterHandSelect(arg) {
            vm.athleteData.UgyesebbKezT = arg.value;
            vm.athleteData.UgyesebbKez = arg.selectedText;
        }

        function betterFootSelect(arg) {
            vm.athleteData.UgyesebbLabT = arg.value;
            vm.athleteData.UgyesebbLab = arg.selectedText;
        }

        function changeFeeOfEducationBtn() {
            if (!vm.ModFizetesMod) {
                log.permissionError();
                return;
            }
            if (vm.NINCSOKTDIJ && vm.athleteData.Tagdijas) {
                log.errorMsg(gettextCatalog.getString('CannotChangeFromSportServiceFeeToEducationFee'));
                return;
            }
            vm.visible = false; // Not need use this for angularJs, because the swa enable appear Error message
            var HTMLarr = [];
            HTMLarr[1] = '<p id="datepickValidText" style="color: #a94442;" class="ng-hide" ng-show="vm.visible"><label>'; // It is working with Angular
            HTMLarr[2] = gettextCatalog.getString('PleasGiveTheStartMonth'); // Kérlek a sportszolgáltatási díj kezdő hónapját add meg!
            HTMLarr[3] = '</label><br></p><div class="control"><label>';
            HTMLarr[4] = gettextCatalog.getString('SelectDate'); // Válaszd ki a szolgáltatás kezdő dátumát!
            HTMLarr[5] = ' ';
            HTMLarr[6] = gettextCatalog.getString('ThechangeWillStartInTheNextMonth'); // A változtatás csak a jövő hónaptól lesz érvényes;
            HTMLarr[7] = '<br></label></div><div  style="padding-left:30%"><input class="form-group cts-form-group" id="datepick" type="text" style="margin-bottom: 1em"></div>';
            var HTMLtext = HTMLarr.join('');
            swal({
                title: gettextCatalog.getString('ReallyDoYouchangeThefeeMode'),
                html: HTMLtext,
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: gettextCatalog.getString('Change'),
                cancelButtonText: gettextCatalog.getString('Cancel'),
                closeOnConfirm: false,
                preConfirm: function preConfirm() {
                    vm.feeOfEducationDataStart = angular.element('#datepick').data('ejDatePicker').getValue();
                    if (!vm.feeOfEducationDateOk) {
                        swal.showValidationError(gettextCatalog.getString('SelectDateError'));
                        return false;
                    }
                    return true;
                }
            }).then(function (isConfirm) {
                if (isConfirm.value) {
                    // Oktatási díj = 0 - Sportszolgáltatási díj = 1;
                    if (vm.athleteData.Tagdijas) { // Ha Tagdijas másnéven Sportszolg dijas
                        vm.athleteData.Tagdijas = false;
                        vm.feeOfEducationValue = gettextCatalog.getString('EducationFee'); // Csere Okt díjasra
                    } else { // sportoszolg díjas
                        vm.athleteData.Tagdijas = true;
                        vm.feeOfEducationValue = gettextCatalog.getString('SportServiceFee'); // csere Tagdijasra, Sportszolg dijasasra
                    }
                    $scope.$apply();
                    // The date value modified to valid value, soh info about it
                    return true; // bind to swal 'Modified'
                } else {
                    swal(gettextCatalog.getString('notChangedPayMode') + ' ' + getTagDijText());
                }
            }, function () {
            });
            // Set DatePicker
            var now = new Date();
            var current;
            if (now.getMonth() == 11) {
                current = new Date(now.getFullYear() + 1, 0, 1);
            } else {
                current = new Date(now.getFullYear(), now.getMonth() + 1, 1);
            }
            vm.feeOfEducationDateOk = true;
            angular.element('#datepick').ejDatePicker({
                // set date format
                dateFormat: 'yyyy-MM-dd',
                change: function (args) {
                    // Get current date
                    var currentDate = new Date();
                    var selectedDate = new Date(args.value);
                    if (selectedDate.getFullYear() < currentDate.getFullYear()) {
                        // Error, no correct date
                        vm.feeOfEducationDateOk = false;
                    } else if (selectedDate.getMonth() <= currentDate.getMonth()) {
                        // Error, no correct date
                        vm.feeOfEducationDateOk = false;
                    } else if (selectedDate.getDate() > currentDate.getDate()) {
                        // Error, no correct date
                        vm.feeOfEducationDateOk = false;
                    } else {
                        // Ok, the date is correct
                        vm.feeOfEducationDateOk = true;
                        vm.feeOfEducationDate = new Date(args.value);
                        vm.feeOfEducationDate = vm.feeOfEducationDate.toLocaleDateString().replace(/\s/g, '').replace(/\./g, '-').slice(0, -1);
                    }
                },
                value: current
            });

            // Get the current selected text
            function getTagDijText() {
                // Oktatási díj = 0 - Sportszolgáltatási díj = 1;
                // Oktatási díj = 0 - Sportszolgáltatási díj = 1;
                if (vm.athleteData.Tagdijas) {
                    return gettextCatalog.getString('SportServiceFee');
                } else {
                    return gettextCatalog.getString('EducationFee');
                }
            }
        }

        function selectSchools() {
            if (vm.visibleSchooSelectlGrid) {
                angular.element('#hidedContent').css('height', '0px');
            } else {
                dataservice.selectSchools()
                    .then(function (data) {
                        // swal dropdownList select shool and fill fields with datas
                        angular.element('#hidedContent').css('height', '100%');
                        grid.dataSource = data.itemsList;
                    });
            }
            vm.visibleSchooSelectlGrid = !vm.visibleSchooSelectlGrid;
        }

        function schoolGridSelectedRow(args) {
            vm.schoolGridSelectedRowData = args.data;
            vm.athleteData.IskolaEvfolyam = vm.schoolGridSelectedRowData.IskolaEvfolyam; // String
            vm.athleteData.IskolaNeve = vm.schoolGridSelectedRowData.IskolaNeve; // String
            vm.athleteData.IskolaIrSzam = vm.schoolGridSelectedRowData.IskolaIrSzam; // String
            vm.athleteData.IskolaIrSzam = vm.schoolGridSelectedRowData.IskolaIrSzam; // String
            vm.athleteData.IskolaVaros = vm.schoolGridSelectedRowData.IskolaVaros; // String
            vm.athleteData.IskolaUtca = vm.schoolGridSelectedRowData.IskolaUtca; // String
            vm.athleteData.IskolaHazszam = vm.schoolGridSelectedRowData.IskolaHazszam; // String
            vm.athleteData.IskolaOsztaly = vm.schoolGridSelectedRowData.IskolaOsztaly; // String
            vm.athleteData.IskolaIgazgatoNeve = vm.schoolGridSelectedRowData.IskolaIgazgatoNeve; // String
            vm.athleteData.TestneveloNeve = '';
            vm.athleteData.TestneveloElerhetosege = '';
            vm.athleteData.TestneveloEmail = '';
            vm.athleteData.OsztalyFonokNeve = '';
            vm.athleteData.OfTel = '';
            vm.athleteData.OfEmail = '';
            $scope.$apply();
            // swal dropdownList select shool and fill fields with datas
            angular.element('#hidedContent').css('height', '0px');
            vm.visibleSchooSelectlGrid = !vm.visibleSchooSelectlGrid;
        }

        function anthropometry() {
            if (!vm.MEGTANTFELM) {
                log.permissionError();
            } else {
                paramHelper.setParams([{'anthropometry.sportoloId': vm.athleteData.SportolokID}]);
                $state.go('athletes.athletesManagement.anthropometry');
            }
        }

        function saveExitAthletes(firstSection) {
            vm.datas = {};
            vm.athletesId = [];
            vm.athletesId.push(vm.athleteData.SportolokID);
            vm.datas.athletesId = vm.athletesId;
            vm.datas.selectedExitDate = vm.selectedExitDate;
            if (angular.isUndefined(vm.noteExitText)) {
                vm.noteExitText = '----';
            }
            vm.datas.noteExitText = vm.noteExitText;
            vm.datas.firstSection = firstSection;
            dataservice.saveExitAthletes(vm.datas)
                .then(function (answer) {
                    // swal() kiírni az eredményt
                    if (answer.value) {
                        swal(gettextCatalog.getString('SuccesfulExitAthleteResult'), gettextCatalog.getString('SuccesfulExitAthlete'), 'success');
                        paramHelper.setParams([
                            {'athleteList.selectedSectionId': vm.athleteData.IdSzakosztaly},
                            {'athleteList.selectedAgeGroupId': vm.athleteData.Korcsoport}
                        ]);
                        $state.go('athletes.athletesManagement.athletesList');
                    } else {
                        swal({
                            title: gettextCatalog.getString('SuccesfulExitAthleteResult'),
                            text: gettextCatalog.getString('FinallyExitAthlete') + ': ' + answer.message,
                            type: 'warning',
                            confirmButtonText: 'Ok'
                        });
                    }
                    $state.reload();
                });
        }

        function getSystemSettings(arg) {
            return dataservice.getSystemSettings(arg).then(function (response) {
                return response.retValue;
            });
        }

        function getUsersBelongingToAthlete(sportoloid) {
            return dataservice.getUsersBelongingToAthlete(sportoloid).then(function (response) {
                gridUsersOfAthlete.dataSource = response.itemsList;
                gridUsersOfAthlete.refresh();
            });
        }

        function getAthleteMoveStory(id) {
            return dataservice.getAthleteMoveStory(id).then(function (response) {
                vm.coachListGridData = response.itemsList;
                vm.coachListGridData = $filter('dateStringFilter')(vm.coachListGridData, 'Felvitel');
                vm.coachListGridData = $filter('dateStringFilter')(vm.coachListGridData, 'IdoszakVege');
                grid123.dataSource = vm.coachListGridData;
            });
        }

        function clearSecondSection() {
            vm.athleteData.MasodlagosSzakosztaly = undefined;
            vm.athleteData.MasodlagosKorcsoport = undefined;
            vm.secondAgeGroupList = [];
            vm.athleteData.MasodlagosSzakosztalyEdzoNev = undefined;
            vm.secondCoachList = [];
            $('#secondSectionDropDown').ejDropDownList('clearText');
        }

        function clearSecondAgeGroup() {
            vm.athleteData.MasodlagosKorcsoport = undefined;
            vm.athleteData.MasodlagosSzakosztalyEdzoNev = undefined;
            vm.secondCoachList = [];
            $('#secondAgeGroupDropDown').ejDropDownList('clearText');
        }

        function clearSecondCoach() {
            vm.athleteData.MasodlagosSzakosztalyEdzoNev = undefined;
            $('#secondCoachNameDropDown').ejDropDownList('clearText');
        }

        function exitingSecondSectionBtn() {
            if (!vm.allowEdit) {
                swal({
                    title: gettextCatalog.getString('AthleteDatasheetIsReadyOnly'),
                    type: 'warning',
                    showCancelButton: false,
                    confirmButtonColor: '#DD6B55',
                    confirmButtonText: gettextCatalog.getString('Ok'),
                    closeOnConfirm: false,
                    closeOnCancel: false
                });
                return;
            }
            vm.visible = false; // Not need use this for angularJs, because the swa enable appear Error message
            var HTMLarr = [];

            HTMLarr[0] = '<p id="datepickValidText" style="color: #a94442;" class="ng-hide" ng-show="vm.visible"><label>'; // It is working with Angular
            HTMLarr[1] = gettextCatalog.getString('PleasGiveTheStartMonthgoneAthlete'); // Kérlek a sportszolgáltatási díj kezdő hónapját add meg!
            HTMLarr[2] = '</label><br></p><div style="margin-bottom: 10px; width: 95%;" ><label>';
            HTMLarr[3] = gettextCatalog.getString('SelectDategoneAthlete'); // Válaszd ki a kiléptetés dátumát!
            HTMLarr[4] = '<br></label></div><div style="margin-left: 30%;"><input id="datepick" type="text"></div>';
            var HTMLtext = HTMLarr.join('');

            swal({
                title: gettextCatalog.getString(vm.athleteData.Nev + ' ' + gettextCatalog.getString('ExitAthleteSecondSection')),
                html: HTMLtext,
                type: 'warning',
                showCancelButton: true,
                allowOutsideClick: false,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: gettextCatalog.getString('Exiting'),
                cancelButtonText: gettextCatalog.getString('Cancel'),
                closeOnConfirm: false,
                preConfirm: function (Exiting) {
                    if (Exiting.value) {
                        var preConfOk = false;
                        vm.selectedExitDate = angular.element('#datepick').data('ejDatePicker').getValue(); // get value
                        vm.noteExitText = angular.element('#noteTextArea').val();
                        checkExitDate(vm.selectedExitDate).then(function () {
                            return new Promise(function (resolve) {
                                if (vm.selectedExitDate === null || !vm.exitAthleteDateOk) {
                                    // Must show the error message!
                                    preConfOk = false;
                                    swal.showValidationError(gettextCatalog.getString('SelectExitDate'));
                                } else {
                                    preConfOk = true;
                                }
                                if (vm.noteExitText === null || vm.noteExitText === '') {
                                    // Must show the error message!
                                    preConfOk = false;
                                    swal.showValidationError(gettextCatalog.getString('SetNoteText'));
                                } else {
                                    preConfOk = true;
                                }
                                resolve();
                            });
                        });
                    }
                },
                closeOnCancel: false
            }).then(function (confirmed) {
                if (confirmed.value) {
                    saveExitAthletes(false);
                    swal.close();
                    return true;
                } else {
                    swal(gettextCatalog.getString('Cancelled'), gettextCatalog.getString('notExitAthlete'), 'error');
                }
            });
            // Set DatePicker
            angular.element('#datepick').ejDatePicker({
                // set date format
                dateFormat: 'yyyy-MM-dd',
                change: function (args) {
                    checkDade(args.value);
                }
            });
        }

        function checkExitDate(args) {
            return $q(function () {
                var currentDate = new Date();
                vm.selectedExitDate = new Date(args);
                vm.exitAthleteDateOk = (vm.selectedExitDate <= currentDate);
            });
        }

        function checkDade(args) {
            var currentDate = new Date();
            vm.selectedExitDate = new Date(args);
            vm.exitAthleteDateOk = (vm.selectedExitDate <= currentDate);
        }

        function openCoach(coachId) {
            $q.all([authenticationService.getRight('MODFELH'), authenticationService.getRight('MEGTFELH')]).then(function (results) {
                if (results[0] || results[1]) {
                    paramHelper.setParams([{'newUser.userId': coachId}]);
                    $state.go('settings.userManagement.modifyUser');
                } else {
                    log.permissionError();
                }
            });
        }

        function schoolNameChanged() {
            if (vm.athleteData.IskolaNeve && vm.athleteData.IskolaNeve.length > 0) {
                dataservice.getGymTeachers(vm.athleteData.IskolaNeve).then(function (data) {
                    vm.gymTeacherDatasource = data.itemsList;
                });
                dataservice.getClassMasters(vm.athleteData.IskolaNeve).then(function (data) {
                    vm.classMasterDatasource = data.itemsList;
                });
            } else {
                vm.gymTeacherDatasource = [];
                vm.classMasterDatasource = [];
            }
        }

        vm.selectOf = selectOf;

        function selectOf(arg) {
            for (var i = 0; i < vm.classMasterDatasource.length; i++) {
                if (arg.value == vm.classMasterDatasource[i].value) {
                    dataservice.getClassMasterContact(arg.value).then(function (data) {
                        if (data.data.tel) {
                            vm.athleteData.OfTel = data.data.tel;
                        }
                        if (data.data.email) {
                            vm.athleteData.OfEmail = data.data.email;
                        }
                    });
                }
            }
        }

        vm.selectTesiTanar = selectTesiTanar;

        function selectTesiTanar(arg) {
            for (var i = 0; i < vm.gymTeacherDatasource.length; i++) {
                if (arg.value == vm.gymTeacherDatasource[i].value) {
                    dataservice.getGymTeacherContact(arg.value).then(function (data) {
                        if (data.data.tel) {
                            vm.athleteData.TestneveloElerhetosege = data.data.tel;
                        }
                        if (data.data.email) {
                            vm.athleteData.TestneveloEmail = data.data.email;
                        }
                    });
                }
            }
        }

        function getParentNames() {
            dataservice.getParentNames().then(function (data) {
                for (var i = 0; i < data.data.father.length; i++) {
                    vm.fatherNames.push({value: data.data.father[i], text: data.data.father[i]});
                }
                for (var i = 0; i < data.data.mother.length; i++) {
                    vm.motherNames.push({value: data.data.mother[i], text: data.data.mother[i]});
                }
            });
        }

        vm.selectMother = selectMother;

        function selectMother(arg) {
            if (arg && arg.value.length > 0) {
                var closeidx = arg.value.indexOf(')');
                // if (arg.value.length-1 > closeidx){return;}
                var idx = arg.value.indexOf('(');
                if (idx != -1 && !(arg.value.length - 1 > closeidx)) {
                    getParentData('mother', arg.value, arg.value.substring(0, idx - 1));
                    // vm.athleteData.AnyjaNeve = arg.value.substring(0, idx - 1);
                }
            }
        }

        vm.selectFather = selectFather;

        function selectFather(arg) {
            if (arg && arg.value.length > 0) {
                var closeidx = arg.value.indexOf(')');
                // if (arg.value.length-1 > closeidx){return;}
                var idx = arg.value.indexOf('(');
                if (idx != -1 && !(arg.value.length - 1 > closeidx)) {
                    getParentData('father', arg.value, arg.value.substring(0, idx - 1));
                    // vm.athleteData.SzuloNeve = arg.value.substring(0, idx - 1);
                }
            }
        }

        function getParentData(parent, arg, szuloNeve) {
            dataservice.getParentDataPOST(parent, arg).then(function (data) {
                // Szülő kiválasztásakor felajánljuk hogy csatolhatja már meglévő szülő userhez a sportolót
                if (data.data.userid > 0) {
                    swal({
                        title: gettextCatalog.getString('Do you want to assign the athlete to the selected parent user?'),
                        type: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#DD6B55',
                        confirmButtonText: gettextCatalog.getString('Yes'),
                        cancelButtonText: gettextCatalog.getString('Cancel'),
                    }).then(function (isConfirm) {
                        if (isConfirm.value) {
                            dataservice.assignAthleteToParentUser(data.data.userid, vm.athleteData.SportolokID).then(function (arg) {
                                if (arg.data > 0) {
                                    log.successMsg(gettextCatalog.getString('AthleteAssignedToUserSuccessfully'));
                                }
                            });
                        }
                    });
                }
                if (parent == 'father') {
                    $('#fatherName').ejAutocomplete('clearText');
                    $('#fatherName').ejAutocomplete({multiSelectMode: ej.MultiSelectMode.None, value: szuloNeve});
                    if (data.data) {
                        vm.athleteData.Szulo2Elerhetosege = '';
                        vm.athleteData.ApaEmail = '';
                        vm.athleteData.ApjaTestmagassaga = '';
                        vm.athleteData.ApjaFoglalkozasa = '';
                        vm.athleteData.ApaMunkahely = '';
                        vm.athleteData.SportoloiMultApa = '';
                        if (data.data.tel && data.data.tel.length > 0) {
                            vm.athleteData.Szulo2Elerhetosege = data.data.tel;
                        }
                        if (data.data.email && data.data.email.length > 0) {
                            vm.athleteData.ApaEmail = data.data.email;
                        }
                        if (data.data.height && data.data.height.length > 0) {
                            vm.athleteData.ApjaTestmagassaga = data.data.height;
                        }
                        if (data.data.job && data.data.job.length > 0) {
                            vm.athleteData.ApjaFoglalkozasa = data.data.job;
                        }
                        if (data.data.workplace && data.data.workplace.length > 0) {
                            vm.athleteData.ApaMunkahely = data.data.workplace;
                        }
                        if (data.data.sportpast && data.data.sportpast.length > 0) {
                            vm.athleteData.SportoloiMultApa = data.data.sportpast;
                        }
                    }
                } else if (parent == 'mother') {
                    $('#motherName').ejAutocomplete('clearText');
                    $('#motherName').ejAutocomplete({multiSelectMode: ej.MultiSelectMode.None, value: szuloNeve});
                    if (data.data) {
                        vm.athleteData.Szulo1Elerhetosege = '';
                        vm.athleteData.AnyaEmail = '';
                        vm.athleteData.AnyjaTestmagassaga = '';
                        vm.athleteData.AnyjaFoglalkozasa = '';
                        vm.athleteData.AnyaMunkahely = '';
                        vm.athleteData.SportoloiMultAnya = '';
                        if (data.data.tel && data.data.tel.length > 0) {
                            vm.athleteData.Szulo1Elerhetosege = data.data.tel;
                        }
                        if (data.data.email && data.data.email.length > 0) {
                            vm.athleteData.AnyaEmail = data.data.email;
                        }
                        if (data.data.height && data.data.height.length > 0) {
                            vm.athleteData.AnyjaTestmagassaga = data.data.height;
                        }
                        if (data.data.job && data.data.job.length > 0) {
                            vm.athleteData.AnyjaFoglalkozasa = data.data.job;
                        }
                        if (data.data.workplace && data.data.workplace.length > 0) {
                            vm.athleteData.AnyaMunkahely = data.data.workplace;
                        }
                        if (data.data.sportpast && data.data.sportpast.length > 0) {
                            vm.athleteData.SportoloiMultAnya = data.data.sportpast;
                        }
                    }
                }
            });
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.athletes.athletesManagement.athleteModify.dataSheet')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'athletes.athletesManagement.athleteModify.dataSheet',
                config: {
                    url: '/dataSheet',
                    templateUrl: 'app/athletes/athletesManagement/athleteModify/dataSheet/dataSheet.html',
                    controller: 'AthleteModifyDataSheetController',
                    controllerAs: 'vm',
                    title: 'AthleteModifyDataSheet'
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    Files2Controller.$inject = ["log", "dataservice", "$q", "$rootScope", "gettextCatalog", "$scope", "paramHelper", "DOMAIN"];
    angular
        .module('app.athletes.athletesManagement.athleteModify.files')
        .controller('Files2Controller', Files2Controller);

    function Files2Controller(log, dataservice, $q, $rootScope, gettextCatalog, $scope, paramHelper, DOMAIN) {
        var vm = this;
        $rootScope.vm = vm;

        $rootScope.title = $rootScope.title + gettextCatalog.getString('Contracts');
        vm.title = gettextCatalog.getString('Contracts');

        //grid adatai
        vm.data = [];
        vm.columns = [
            {
                field: 'Id',
                visible: false,
                isPrimaryKey: true,
                isIdentity: true
            },
            {
                field: 'Filenev',
                headerText: gettextCatalog.getString('Filename'),
                textAlign: 'center',
                allowEditing: false,
                template: '#fitemplateDataColumn1'
            },
            {
                field: 'Datum',
                headerText: gettextCatalog.getString('Date'),
                textAlign: 'center'
            }
        ];

        vm.selectedRow = -1;
        vm.deleteFile = deleteFile;

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItems,
            allowTextWrap: true,
            allowSorting: true,
            allowExcelExport: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            columns: vm.columns,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#Grid'), $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        activate();

        function activate() {
            angular.element('#UploadDefault').ejUploadbox({
                saveUrl: DOMAIN.baseURL + DOMAIN.webService + 'FileUpload',
                removeUrl: DOMAIN.baseURL + DOMAIN.webService + 'FileRemove',
                uploadName: 'Uploadbox',
                allowDragAndDrop: false,
                autoUpload: true,
                buttonText: {browse: gettextCatalog.getString('ChooseFile'), upload: gettextCatalog.getString('UploadFile'), cancel: gettextCatalog.getString('CancelUpload')},
                dialogAction: {modal: true, closeOnComplete: true, resize: false, drag: false},
                dialogText: {title: gettextCatalog.getString('UploadedFilesTitle'), name: gettextCatalog.getString('FileName'), size: gettextCatalog.getString('FileSize'), status: gettextCatalog.getString('FileStatus')},
                dropAreaText: gettextCatalog.getString('DropFileToUpload'),
                extensionsAllow: '.doc,.docx,.pdf,.xls,.mp4,.avi',
                complete: function () {
                    log.successMsg(gettextCatalog.getString('UploadSuccessed'));
                    getFiles();
                },
                error: function (args) {
                    var err = '';
                    if (args.error === 'Only files with .doc, .docx, .pdf, .xls, .mp4, .avi extensions are allowed.') {
                        err = gettextCatalog.getString('OnlyDocPdfXls');
                    } else if (args.error === '500 Internal Server Error') {
                        err = gettextCatalog.getString('ToLongFile');
                    }
                    log.htmlError(gettextCatalog.getString('UploadError') + '<br>' + err);
                },
                begin: function (args) {
                    args.data = {tipus: vm.tipus, tablaId: vm.tablaId};
                }
            });

            var promises = [paramHelper.getParams([], ['files.tipus', 'files.tablaId', 'weeklyTrainingPlan.edzoId', 'weeklyTrainingPlan.szakosztalyId', 'weeklyTrainingPlan.korosztalyId', 'weeklyTrainingPlan.ev', 'weeklyTrainingPlan.trainingPlanId', 'weeklyTrainingPlan.edzoNev', 'weeklyTrainingPlan.szakosztalyNev', 'weeklyTrainingPlan.korosztalyNev'])];

            return $q.all(promises).then(function (results) {
                if (results[0]['files.tipus'] !== undefined) {
                    vm.tipus = results[0]['files.tipus'];
                }
                if (results[0]['files.tablaId'] !== undefined) {
                    vm.tablaId = results[0]['files.tablaId'];
                }
                if (results[0]['weeklyTrainingPlan.edzoId'] !== undefined) {
                    vm.selectedCoach = results[0]['weeklyTrainingPlan.edzoId'];
                }
                if (results[0]['weeklyTrainingPlan.edzoNev'] !== undefined) {
                    vm.coachName = results[0]['weeklyTrainingPlan.edzoNev'];
                }
                if (results[0]['weeklyTrainingPlan.szakosztalyId'] !== undefined) {
                    vm.selectedSection = results[0]['weeklyTrainingPlan.szakosztalyId'];
                }
                if (results[0]['weeklyTrainingPlan.szakosztalyNev'] !== undefined) {
                    vm.sectionName = results[0]['weeklyTrainingPlan.szakosztalyNev'];
                }
                if (results[0]['weeklyTrainingPlan.korosztalyId'] !== undefined) {
                    vm.selectedAgeGroup = results[0]['weeklyTrainingPlan.korosztalyId'];
                }
                if (results[0]['weeklyTrainingPlan.korosztalyNev'] !== undefined) {
                    vm.ageGroupName = results[0]['weeklyTrainingPlan.korosztalyNev'];
                }
                if (results[0]['weeklyTrainingPlan.ev'] !== undefined) {
                    vm.selectedYear = results[0]['weeklyTrainingPlan.ev'];
                }
                getFiles();
            });
        }

        function getFiles() {
            dataservice.getFilesList(vm.tipus, vm.tablaId).then(
                function (data) {
                    grid.dataSource = data.itemsList;
                    vm.data = data.itemsList;
                });
        }

        function deleteFile() {
            var row = grid.getSelectedRecords()[0];
            if (!row) {
                vm.selectedRow = -1;
            } else {
                vm.selectedRow = row.Id;
            }
            if (vm.selectedRow < 0) {
                log.errorMsg('SelectFile');
                return;
            }

            swal({
                title: gettextCatalog.getString('Are you sure you want to delete the selected file?'),
                text: gettextCatalog.getString('You will not be able to recover it!'),
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: gettextCatalog.getString('Yes, delete this file'),
                cancelButtonText: gettextCatalog.getString('Cancel'),
                closeOnConfirm: false,
                closeOnCancel: false
            }).then(function (isConfirm) {
                if (isConfirm.value) {
                    return dataservice.deleteFiles(vm.selectedRow).then(
                        function () {
                            log.successMsg(gettextCatalog.getString('FileDeleted'));
                            getFiles();
                        }
                    );
                }
            });
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.athletes.athletesManagement.athleteModify.files')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'athletes.athletesManagement.athleteModify.files',
                config: {
                    url: '/files',
                    templateUrl: 'app/athletes/athletesManagement/athleteModify/files/files.html',
                    controller: 'Files2Controller',
                    controllerAs: 'vm'
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.athletes.athletesManagement.athleteModify.health')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'athletes.athletesManagement.athleteModify.health',
                config: {
                    title: 'Health',
                    url: '/health',
                    templateUrl: 'app/athletes/athletesManagement/athleteModify/health/health.html',
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    HealthListController.$inject = ["log", "$state", "dataservice", "$q", "$rootScope", "gettextCatalog", "paramHelper", "authenticationService", "$filter", "$scope", "$timeout"];
    angular
        .module('app.athletes.athletesManagement.athleteModify.health.healthList')
        .controller('HealthListController', HealthListController);

    function HealthListController(log, $state, dataservice, $q, $rootScope, gettextCatalog, paramHelper, authenticationService, $filter, $scope, $timeout) {
        var vm = this;
        $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('HealthList');

        // Create variables
        vm.Id = null;
        vm.selectedGridRow = {};
        vm.dateFrom = new Date('1900-01-01');
        vm.dateTo = new Date();
        vm.beginedit = false;
        vm.dataTmp = '';
        vm.athleteName = '';
        vm.athleteId = '';
        vm.athleteSocialSecurity = '';
        vm.athleteBirthDate = '';
        vm.pageSize = 12;
        vm.gridHealthDatas = [];
        vm.allowAddNew = false;

        vm.columns = [
            {
                field: 'Id',
                isPrimaryKey: true,
                isIdentity: true,
                visible: false
            },
            {
                field: 'Mettol',
                headerText: gettextCatalog.getString('From'),
                width: 90
            },
            {
                field: 'Meddig',
                headerText: gettextCatalog.getString('To'),
                width: 90
            },
            {
                field: 'Tipus',
                headerText: gettextCatalog.getString('Type'),
                //databound: typeDataBound,
                width: 100
            },
            {
                field: 'AlTipus',
                headerText: gettextCatalog.getString('SubType'),
                width: 100
            },
            {
                field: 'Leiras',
                headerText: gettextCatalog.getString('Description'),
                width: 125
            },
            {
                field: 'Kezeles',
                headerText: gettextCatalog.getString('Therapy')
            },
            {
                field: 'Letrehozas',
                headerText: gettextCatalog.getString('CreatedDate'),
                width: 90
            },
            {
                field: 'Modositas',
                headerText: gettextCatalog.getString('ModifiedDate'),
                width: 90
            },
            {
                field: 'Szerkesztes',
                headerText: gettextCatalog.getString('Edit'),
                template: '#healteditcolumnTemplate',
            }
        ];
        vm.editText = gettextCatalog.getString('Edit');
        vm.EGESZSMEGT = false;
        vm.EGESZSMOD = false;

        // Public functions
        vm.getHealthDatas = getHealthDatas;
        vm.goToNewHealthEvent = goToNewHealthEvent;
        vm.goToModifyHealthEvent = goToModifyHealthEvent;
        vm.dateFromChange = dateFromChange;
        vm.dateToChange = dateToChange;
        vm.backToDatasheet = backToDatasheet;

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItems,
            allowPaging: true,
            allowTextWrap: true,
            allowSorting: true,
            allowExcelExport: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#Grid'), $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        // Activate page
        activate();

        function activate() {
            $q.all([paramHelper.getParams([], ['athleteModify.sportoloNev', 'athleteModify.sportoloId', 'athleteModify.sportoloTaj', 'athleteModify.sportoloSzuletesiIdo', 'athleteModify.aktivSportolo']),
                authenticationService.getRight('EGESZSMEGT'),
                authenticationService.getRight('EGESZSMOD')])
                .then(function (results) {
                    vm.EGESZSMEGT = results[1];
                    vm.EGESZSMOD = results[2];

                    if (!vm.EGESZSMEGT) {
                        log.permissionError();
                        $rootScope.back();
                    }

                    $timeout(function () {
                        vm.athleteId = results[0]['athleteModify.sportoloId'];
                        vm.athleteName = results[0]['athleteModify.sportoloNev'];
                        vm.athleteSocialSecurity = results[0]['athleteModify.sportoloTaj'];
                        vm.allowAddNew = results[0]['athleteModify.aktivSportolo'];
                        vm.athleteBirthDate = results[0]['athleteModify.sportoloSzuletesiIdo'];
                        vm.athleteBirthDate = $filter('dateStringFilter')(vm.athleteBirthDate);
                        getHealthDatas();
                    }, 0);
                });
        }

        function getHealthDatas(from, to) {
            if (from) {
                vm.dateFrom = from;
            }
            if (to) {
                vm.dateTo = to;
            }
            if (vm.dateFrom === null) {
                vm.dateFrom = Date();
            }
            if (vm.dateTo === null) {
                vm.dateTo = Date();
            }

            dataservice.GetHealth(vm.athleteId, vm.dateFrom, vm.dateTo).then(function (data) {
                vm.dataTmp = data.itemsList;
                vm.dataTmp = $filter('dateStringFilter')(vm.dataTmp, 'Letrehozas');
                vm.dataTmp = $filter('dateStringFilter')(vm.dataTmp, 'Meddig');
                vm.dataTmp = $filter('dateStringFilter')(vm.dataTmp, 'Mettol');
                vm.dataTmp = $filter('dateStringFilter')(vm.dataTmp, 'Modositas');

                vm.dataTmp.forEach(function (element) {
                    element.Tipus = element.Tipus;
                });

                vm.gridHealthDatas = vm.dataTmp;
                grid.dataSource = vm.dataTmp;
            });
        }

        function dateToChange(args) {
            getHealthDatas(vm.dateFrom, args.value);
        }

        function dateFromChange(args) {
            getHealthDatas(args.value, vm.dateTo);
        }

        function goToNewHealthEvent() {
            paramHelper.setParams([{
                'newHealthAthleteId': vm.athleteId,
                'newHealthAthleteName': vm.athleteName,
                'newHealthAthleteSocialSecurity': vm.athleteSocialSecurity,
                'newHealthAthleteBirthDate': vm.athleteBirthDate,
            }]);
            $state.go('athletes.athletesManagement.athleteModify.health.newHealthEvent');
        }

        function goToModifyHealthEvent(id) {
            if (!vm.allowAddNew) {
                return;
            }
            vm.selectedGridRow = ej.DataManager(vm.gridHealthDatas).executeLocal(new ej.Query().where('Id', 'equal', id))[0];
            paramHelper.setParams([{
                'mofifyHealthAthleteId': vm.athleteId,
                'mofifyHealthAthleteName': vm.athleteName,
                'mofifyHealthAthleteSocialSecurity': vm.athleteSocialSecurity,
                'mofifyHealthAthleteBirthDate': vm.athleteBirthDate,
                'mofifyHealthId': vm.selectedGridRow.Id,
                'mofifyHealthKezeles': vm.selectedGridRow.Kezeles,
                'mofifyHealthLeiras': vm.selectedGridRow.Leiras,
                'mofifyHealthLetrehozas': vm.selectedGridRow.Letrehozas,
                'mofifyHealthMettol': vm.selectedGridRow.Mettol,
                'mofifyHealthMeddig': vm.selectedGridRow.Meddig,
                'mofifyHealthTipus': vm.selectedGridRow.Tipus,
                'mofifyHealthAlTipus': vm.selectedGridRow.AlTipus,
                'fromState': 'healthList',
            }]);
            $state.go('athletes.athletesManagement.athleteModify.health.modifyHealthEvent');
        }

        function backToDatasheet() {
            paramHelper.setParams([{'athleteModify.sportoloId': vm.athleteId}]);
            $state.go('athletes.athletesManagement.athleteModify.dataSheet');
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.athletes.athletesManagement.athleteModify.health.healthList')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'athletes.athletesManagement.athleteModify.health.healthList',
                config: {
                    url: '/healthList',
                    templateUrl: 'app/athletes/athletesManagement/athleteModify/health/healthList/healthList.html',
                    controller: 'HealthListController',
                    controllerAs: 'vm',
                    title: 'HealthList'
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    ModifyHealthEventController.$inject = ["log", "logger", "$state", "dataservice", "$q", "$rootScope", "gettextCatalog", "paramHelper", "authenticationService", "$filter", "$timeout", "$scope"];
    angular
        .module('app.athletes.athletesManagement.athleteModify.health.modifyHealthEvent')
        .controller('modifyHealthEventController', ModifyHealthEventController);

    function ModifyHealthEventController(log, logger, $state, dataservice, $q, $rootScope, gettextCatalog, paramHelper, authenticationService, $filter, $timeout, $scope) {
        var vm = this; $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('ModifyHealthEvent');
        // Create variables
        vm.EGESZSMEGT = false;
        vm.EGESZSMOD = false;
        vm.documents = '';
        vm.params = {
            Id: null,
            SportoloId: null,
            Mettol: null,
            Meddig: null,
            Tipus: null,
            AlTipus: null,
            Leiras: null,
            Kezeles: null
        };

        vm.healthMainType = [];
        vm.healthSubType = [];
        vm.SubType = [];

        // Public functions
        vm.saveDatas = saveDatas;
        vm.fileUpload = fileUpload;
        vm.MainTypeSelected = MainTypeSelected;

        function MainTypeSelected(arg) {
            var mainId = 0;
            vm.SubType = [];
            for (var i = 0; i < vm.healthMainType.length; i++) {
                if (vm.healthMainType[i].text === arg.value) {
                    mainId = vm.healthMainType[i].value;
                }
            }
            dataservice.healthSubTypesList()
                .then(function (response) {
                    for (var i = 0; i < response.itemsList.length; i++) {
                        if (response.itemsList[i].FotipusId === mainId) {
                            vm.SubType.push({
                                text: response.itemsList[i].AltipusNev,
                                value: response.itemsList[i].FotipusId,
                            });
                        }
                    }
                });
        }

        // Activate page
        activate();
        function activate() {
            $q.all([paramHelper.getParams([],
                [
                    'mofifyHealthId',
                    'mofifyHealthAthleteId',
                    'mofifyHealthAthleteName',
                    'mofifyHealthAthleteSocialSecurity',
                    'mofifyHealthAthleteBirthDate',
                    'mofifyHealthKezeles',
                    'mofifyHealthLeiras',
                    'mofifyHealthLetrehozas',
                    'mofifyHealthMettol',
                    'mofifyHealthMeddig',
                    'mofifyHealthTipus',
                    'mofifyHealthAlTipus'
                ]),

                authenticationService.getRight('EGESZSMEGT'),
                authenticationService.getRight('EGESZSMOD')])
                .then(function (results) {
                    $timeout(function () {
                        vm.params.Id = results[0]['mofifyHealthId'];
                        vm.params.SportoloId = results[0]['mofifyHealthAthleteId'];
                        vm.athleteName = results[0]['mofifyHealthAthleteName'];
                        vm.athleteSocialSecurity = results[0]['mofifyHealthAthleteSocialSecurity'];
                        vm.athleteBirthDate = results[0]['mofifyHealthAthleteBirthDate'];
                        vm.params.Kezeles = results[0]['mofifyHealthKezeles'];
                        vm.params.Leiras = results[0]['mofifyHealthLeiras'];
                        vm.params.Mettol = results[0]['mofifyHealthMettol'];
                        vm.params.Meddig = results[0]['mofifyHealthMeddig'];
                        $('#MainType').ejAutocomplete({
                            value: results[0]['mofifyHealthTipus']
                        });
                        vm.params.AlTipus = results[0]['mofifyHealthAlTipus'];
                    }, 1);
                    vm.EGESZSMEGT = results[1];
                    vm.EGESZSMOD = results[2];
                    if (!vm.EGESZSMEGT) {
                        log.permissionError();
                        $rootScope.back();
                    }
                });
        }

        function fileUpload() {
            //TablaId = szerkSportolo.SportolokID, TablaNev = "Sportolok"
            paramHelper.setParams([{'files.tipus': 'HealthEvent'}, {'files.tablaId': vm.params.SportoloId}]);
            $state.go('other.files');
        }

        function saveDatas() {
            // a syncfusion direktívák miatt
            $scope.$broadcast('submitted');
            if ($scope.form.$valid === false) {
                log.errorMsg(gettextCatalog.getString('RequiredFieldsError'));
            } else {
                dataservice.modifyHealthData(vm.params)
                        .then(function () {
                            if (vm.params.Meddig) {
                                var from = new Date(vm.params.Mettol);
                                var to = new Date(vm.params.Meddig);
                                if (from > to) {
                                    log.errorMsg(gettextCatalog.getString('DateToMustNotBeBeforeDateFrom'));
                                    return;
                                }
                            }
                            $rootScope.back();
                        });
            }
        }

        // meglévő adatlekérés
        getHealthMainTypes();
        function getHealthMainTypes() {
            dataservice.healthMainTypesList()
                .then(function (response) {
                    for (var i = 0; i < response.itemsList.length; i++) {
                        vm.healthMainType.push({
                            text: response.itemsList[i].Nev,
                            value: response.itemsList[i].Id
                        });
                    }
                    MainTypeSelected({value: vm.params.Tipus});
                });
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.athletes.athletesManagement.athleteModify.health.modifyHealthEvent')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'athletes.athletesManagement.athleteModify.health.modifyHealthEvent',
                config: {
                    url: '/modifyHealthEvent',
                    templateUrl: 'app/athletes/athletesManagement/athleteModify/health/modifyHealthEvent/modifyHealthEvent.html',
                    controller: 'modifyHealthEventController',
                    controllerAs: 'vm',
                    title: 'ModifyHealthEventController'
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    NewHealthEventController.$inject = ["log", "logger", "$state", "dataservice", "$q", "$rootScope", "gettextCatalog", "paramHelper", "authenticationService", "$timeout", "$scope"];
    angular
        .module('app.athletes.athletesManagement.athleteModify.health.newHealthEvent')
        .controller('newHealthEventController', NewHealthEventController);

    function NewHealthEventController(log, logger, $state, dataservice, $q, $rootScope, gettextCatalog, paramHelper, authenticationService, $timeout, $scope) {
        var vm = this; $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('newHealthEvent');

        // Create variables
        vm.EGESZSMEGT = false;
        vm.EGESZSMOD = false;
        vm.documents = '';
        vm.params = {
            SportoloId: null,
            Mettol: null,
            Meddig: null,
            Tipus: null,
            AlTipus: null,
            Leiras: null,
            Kezeles: null
        };

        vm.healthMainType = [];
        vm.healthSubType = [];
        vm.SubType = [];
        // Public functions
        vm.saveDatas = saveDatas;
        vm.fileUpload = fileUpload;
        vm.MainTypeSelected = MainTypeSelected;

        function MainTypeSelected(arg) {
            var mainId = 0;
            vm.SubType = [];
            for (var i = 0; i < vm.healthMainType.length; i++) {
                if (vm.healthMainType[i].text === arg.value) {
                    mainId = vm.healthMainType[i].value;
                }
            }
            for (var i = 0; i < vm.healthSubType.length; i++) {
                if (vm.healthSubType[i].value === mainId) {
                    vm.SubType.push(vm.healthSubType[i]);
                    vm.params.AlTipus = null;
                }
            }
        }

        // Activate page
        activate();

        function activate() {
            $q.all([paramHelper.getParams([], ['newHealthAthleteId', 'newHealthAthleteName', 'newHealthAthleteSocialSecurity', 'newHealthAthleteBirthDate']),
                authenticationService.getRight('EGESZSMEGT'),
                authenticationService.getRight('EGESZSMOD')])
                .then(function (results) {
                    $timeout(function () {
                        vm.params.SportoloId = results[0]['newHealthAthleteId'];
                        vm.athleteName = results[0]['newHealthAthleteName'];
                        vm.athleteSocialSecurity = results[0]['newHealthAthleteSocialSecurity'];
                        vm.athleteBirthDate = results[0]['newHealthAthleteBirthDate'];
                    }, 0);
                    vm.EGESZSMEGT = results[1];
                    vm.EGESZSMOD = results[2];

                    if (!vm.EGESZSMEGT) {
                        log.permissionError();
                        $rootScope.back();
                    }
                });
        }

        function fileUpload() {
            paramHelper.setParams([{'files.tipus': 'HealthEvent'}, {'files.tablaId': vm.params.SportoloId}]);
            $state.go('other.files');
        }

        getHealthMainTypes();
        function getHealthMainTypes() {
            dataservice.healthMainTypesList()
                .then(function (response) {
                    for (var i = 0; i < response.itemsList.length; i++) {
                        vm.healthMainType.push({
                            text: response.itemsList[i].Nev,
                            value: response.itemsList[i].Id
                        });
                    }
                });
        }

        getHealthSubTypes();
        function getHealthSubTypes() {
            dataservice.healthSubTypesList()
                .then(function (response) {
                    for (var i = 0; i < response.itemsList.length; i++) {
                        vm.healthSubType.push({
                            text: response.itemsList[i].AltipusNev,
                            value: response.itemsList[i].FotipusId,
                        });
                    }
                });
        }

        function saveDatas() {
            // a syncfusion direktívák miatt
            $scope.$broadcast('submitted');
            if ($scope.form.$valid === false) {
                log.errorMsg(gettextCatalog.getString('RequiredFieldsError'));
            } else {
                console.log('vm.params', vm.params);
                if (vm.params.Meddig) {
                    var from = new Date(vm.params.Mettol);
                    var to = new Date(vm.params.Meddig);
                    if (from > to) {
                        log.errorMsg(gettextCatalog.getString('DateToMustNotBeBeforeDateFrom'));
                    } else {
                        dataservice.saveHealthData(vm.params)
                            .then(function () {
                                $rootScope.back();
                            });
                    }
                } else {
                    dataservice.saveHealthData(vm.params)
                        .then(function () {
                            $rootScope.back();
                        });
                }
            }
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.athletes.athletesManagement.athleteModify.health.newHealthEvent')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'athletes.athletesManagement.athleteModify.health.newHealthEvent',
                config: {
                    url: '/newHealthEvent',
                    templateUrl: 'app/athletes/athletesManagement/athleteModify/health/newHealthEvent/newHealthEvent.html',
                    controller: 'newHealthEventController',
                    controllerAs: 'vm',
                    title: 'newHealthEventController'
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    PerformanceMotivationTestController.$inject = ["$q", "gettextCatalog", "dataservice", "paramHelper", "log", "$state", "$rootScope", "authenticationService"];
    angular
        .module('app.athletes.athletesManagement.athleteModify.psychology.performanceMotivationTest')
        .controller('PerformanceMotivationTestController', PerformanceMotivationTestController);

    function PerformanceMotivationTestController($q, gettextCatalog, dataservice, paramHelper, log, $state, $rootScope, authenticationService) {
        var vm = this; $rootScope.vm = vm;

        vm.questions = [
            gettextCatalog.getString('PerformanceMotivationTestQ1'),
            gettextCatalog.getString('PerformanceMotivationTestQ2'),
            gettextCatalog.getString('PerformanceMotivationTestQ3'),
            gettextCatalog.getString('PerformanceMotivationTestQ4'),
            gettextCatalog.getString('PerformanceMotivationTestQ5'),
            gettextCatalog.getString('PerformanceMotivationTestQ6'),
            gettextCatalog.getString('PerformanceMotivationTestQ7'),
            gettextCatalog.getString('PerformanceMotivationTestQ8'),
            gettextCatalog.getString('PerformanceMotivationTestQ9'),
            gettextCatalog.getString('PerformanceMotivationTestQ10'),
            gettextCatalog.getString('PerformanceMotivationTestQ11'),
            gettextCatalog.getString('PerformanceMotivationTestQ12'),
            gettextCatalog.getString('PerformanceMotivationTestQ13'),
            gettextCatalog.getString('PerformanceMotivationTestQ14'),
            gettextCatalog.getString('PerformanceMotivationTestQ15'),
            gettextCatalog.getString('PerformanceMotivationTestQ16'),
            gettextCatalog.getString('PerformanceMotivationTestQ17'),
            gettextCatalog.getString('PerformanceMotivationTestQ18'),
            gettextCatalog.getString('PerformanceMotivationTestQ19'),
            gettextCatalog.getString('PerformanceMotivationTestQ20'),
            gettextCatalog.getString('PerformanceMotivationTestQ21'),
            gettextCatalog.getString('PerformanceMotivationTestQ22'),
            gettextCatalog.getString('PerformanceMotivationTestQ23'),
            gettextCatalog.getString('PerformanceMotivationTestQ24'),
            gettextCatalog.getString('PerformanceMotivationTestQ25'),
            gettextCatalog.getString('PerformanceMotivationTestQ26'),
            gettextCatalog.getString('PerformanceMotivationTestQ27'),
            gettextCatalog.getString('PerformanceMotivationTestQ28'),
            gettextCatalog.getString('PerformanceMotivationTestQ29'),
            gettextCatalog.getString('PerformanceMotivationTestQ30'),
            gettextCatalog.getString('PerformanceMotivationTestQ31'),
            gettextCatalog.getString('PerformanceMotivationTestQ32'),
            gettextCatalog.getString('PerformanceMotivationTestQ33'),
            gettextCatalog.getString('PerformanceMotivationTestQ34'),
            gettextCatalog.getString('PerformanceMotivationTestQ35'),
            gettextCatalog.getString('PerformanceMotivationTestQ36'),
            gettextCatalog.getString('PerformanceMotivationTestQ37'),
            gettextCatalog.getString('PerformanceMotivationTestQ38'),
            gettextCatalog.getString('PerformanceMotivationTestQ39'),
            gettextCatalog.getString('PerformanceMotivationTestQ40'),
            gettextCatalog.getString('PerformanceMotivationTestQ41')
        ];
        vm.answers = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

        // Public functions
        vm.saveSurvey = saveSurvey;

        activate();

        function activate() {
            $q.all([paramHelper.getParams(['athleteModify.sportoloId', 'athleteModify.sportoloNev']), authenticationService.getRight('PSYCHO')])
                .then(function (results) {
                    if (results[1] !== true) {
                        log.permissionError(true);
                    } else {
                        vm.sportoloId = results[0]['athleteModify.sportoloId'];
                        vm.sportoloNev = results[0]['athleteModify.sportoloNev'];
                        $rootScope.title = vm.sportoloNev + ' - ' + gettextCatalog.getString('Psychology') + ' - ' + gettextCatalog.getString('PerformanceMotivationTest');
                    }
                });
        }

        function saveSurvey() {
            var hiba = false;
            if (vm.sportoloId) {
                angular.forEach(vm.answers, function (value, key) {
                    if (value === 0) {
                        vm.answers[key] = -1;
                        hiba = true;
                    }
                });
            } else {
                hiba = true;
            }
            if (hiba) {
                log.errorMsg('SurveyNotFilled');
            } else {
                dataservice.savePerformanceMotivationSurvey(vm.sportoloId, vm.answers)
                    .then(function () {
                        log.successMsg('TestSaved');
                        $state.go('athletes.athletesManagement.athleteModify.psychology.summary');
                    });
            }
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.athletes.athletesManagement.athleteModify.psychology.performanceMotivationTest')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'athletes.athletesManagement.athleteModify.psychology.performanceMotivationTest',
                config: {
                    url: '/performanceMotivationTest',
                    templateUrl: 'app/athletes/athletesManagement/athleteModify/psychology/performanceMotivationTest/performanceMotivationTest.html',
                    controller: 'PerformanceMotivationTestController',
                    controllerAs: 'vm',
                    title: 'PerformanceMotivationTest'
                }
            }
        ];
    }
})();

/* global Aes */

(function () {
    'use strict';

    PerformanceMotivationTestEvaluationController.$inject = ["$q", "gettextCatalog", "dataservice", "paramHelper", "log", "$rootScope", "authenticationService"];
    angular
        .module('app.athletes.athletesManagement.athleteModify.psychology.performanceMotivationTestEvaluation')
        .controller('PerformanceMotivationTestEvaluationController', PerformanceMotivationTestEvaluationController);

    function PerformanceMotivationTestEvaluationController($q, gettextCatalog, dataservice, paramHelper, log, $rootScope, authenticationService) {
        var vm = this; $rootScope.vm = vm;

        vm.questions = [
            gettextCatalog.getString('PerformanceMotivationTestQ1'),
            gettextCatalog.getString('PerformanceMotivationTestQ2'),
            gettextCatalog.getString('PerformanceMotivationTestQ3'),
            gettextCatalog.getString('PerformanceMotivationTestQ4'),
            gettextCatalog.getString('PerformanceMotivationTestQ5'),
            gettextCatalog.getString('PerformanceMotivationTestQ6'),
            gettextCatalog.getString('PerformanceMotivationTestQ7'),
            gettextCatalog.getString('PerformanceMotivationTestQ8'),
            gettextCatalog.getString('PerformanceMotivationTestQ9'),
            gettextCatalog.getString('PerformanceMotivationTestQ10'),
            gettextCatalog.getString('PerformanceMotivationTestQ11'),
            gettextCatalog.getString('PerformanceMotivationTestQ12'),
            gettextCatalog.getString('PerformanceMotivationTestQ13'),
            gettextCatalog.getString('PerformanceMotivationTestQ14'),
            gettextCatalog.getString('PerformanceMotivationTestQ15'),
            gettextCatalog.getString('PerformanceMotivationTestQ16'),
            gettextCatalog.getString('PerformanceMotivationTestQ17'),
            gettextCatalog.getString('PerformanceMotivationTestQ18'),
            gettextCatalog.getString('PerformanceMotivationTestQ19'),
            gettextCatalog.getString('PerformanceMotivationTestQ20'),
            gettextCatalog.getString('PerformanceMotivationTestQ21'),
            gettextCatalog.getString('PerformanceMotivationTestQ22'),
            gettextCatalog.getString('PerformanceMotivationTestQ23'),
            gettextCatalog.getString('PerformanceMotivationTestQ24'),
            gettextCatalog.getString('PerformanceMotivationTestQ25'),
            gettextCatalog.getString('PerformanceMotivationTestQ26'),
            gettextCatalog.getString('PerformanceMotivationTestQ27'),
            gettextCatalog.getString('PerformanceMotivationTestQ28'),
            gettextCatalog.getString('PerformanceMotivationTestQ29'),
            gettextCatalog.getString('PerformanceMotivationTestQ30'),
            gettextCatalog.getString('PerformanceMotivationTestQ31'),
            gettextCatalog.getString('PerformanceMotivationTestQ32'),
            gettextCatalog.getString('PerformanceMotivationTestQ33'),
            gettextCatalog.getString('PerformanceMotivationTestQ34'),
            gettextCatalog.getString('PerformanceMotivationTestQ35'),
            gettextCatalog.getString('PerformanceMotivationTestQ36'),
            gettextCatalog.getString('PerformanceMotivationTestQ37'),
            gettextCatalog.getString('PerformanceMotivationTestQ38'),
            gettextCatalog.getString('PerformanceMotivationTestQ39'),
            gettextCatalog.getString('PerformanceMotivationTestQ40'),
            gettextCatalog.getString('PerformanceMotivationTestQ41')
        ];
        vm.answers = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

        // Public functions
        vm.saveEval = saveEval;

        activate();

        function activate() {
            $q.all([paramHelper.getParams(['psychology.surveyId', 'psychology.mode', 'athleteModify.sportoloNev'], ['psychology.surveyPassword']), authenticationService.getRight('PSYCHO')])
                .then(function (results) {
                    if (results[1] !== true) {
                        log.permissionError(true);
                    } else {
                        vm.surveyId = results[0]['psychology.surveyId'];
                        vm.password = results[0]['psychology.surveyPassword'];
                        vm.sportoloNev = results[0]['athleteModify.sportoloNev'];
                        $rootScope.title = vm.sportoloNev + ' - ' + gettextCatalog.getString('Psychology') + ' - ' + gettextCatalog.getString('PerformanceMotivationTestEvaluation');
                        vm.edit = results[0]['psychology.mode'] === 'edit';
                        if (vm.edit) {
                            getSurveyProtected();
                        } else {
                            getSurvey();
                        }
                    }
                });
        }

        function getSurvey() {
            return dataservice.getPerformanceMotivationSurvey(vm.surveyId, true)
                .then(function (data) {
                    vm.answers = data.kitoltottKerdoiv;
                    vm.sportolo = {};
                    vm.sportolo.nev = data.sportoloNeve;
                    vm.sportolo.szuletesiDatum = data.sportoloSzuletesiDatuma;
                    vm.sportolo.anyjaNeve = data.sportoloAnyjaNeve;
                    vm.kitoltesDatuma = data.kitoltesDatuma;
                    vm.kiertekelesSzam = data.kiertekelesSzam;
                    vm.kiertekelesSzoveg = data.kiertekelesSzoveg;
                    angular.element('#rteSample').ejRTE({value: vm.kiertekelesSzoveg});
                });
        }

        function getSurveyProtected() {
            swal({
                title: gettextCatalog.getString('Password'),
                text: gettextCatalog.getString('SelectPasswordForTheTest'),
                //type: 'input',
                input: 'password',
                animation: 'slide-from-top',
                allowOutsideClick: false,
                allowEscapeKey: false,
                inputValue: vm.password,
                closeOnConfirm: false

            }).then(function (inputValue) {
                    if (!inputValue || !inputValue.value || inputValue.dismiss === 'cancel' || inputValue.dismiss === 'esc') {
                        return false;
                    } else {
                        vm.password = inputValue.value;
                        return dataservice.getPerformanceMotivationSurvey(vm.surveyId, false)
                            .then(function (data) {
                                vm.answers = data.kitoltottKerdoiv;
                                vm.sportolo = {};
                                vm.sportolo.nev = data.sportoloNeve;
                                vm.sportolo.szuletesiDatum = data.sportoloSzuletesiDatuma;
                                vm.sportolo.anyjaNeve = data.sportoloAnyjaNeve;
                                vm.kitoltesDatuma = data.kitoltesDatuma;
                                vm.kiertekelesDatuma = data.kiertekelesDatuma;
                                vm.kiertekelesSzam = data.kiertekelesSzam;
                                vm.kiertekelesSzoveg = data.kiertekelesSzoveg;
                                if (vm.kiertekelesDatuma !== '') {
                                    vm.kiertekelesSzoveg = Aes.Ctr.decrypt(vm.kiertekelesSzoveg, inputValue.value, 256);
                                }
                                angular.element('#rteSample').ejRTE({value: vm.kiertekelesSzoveg});
                                swal.close();
                            });
                    }
                });
        }

        function saveEval() {
            swal({
                title: gettextCatalog.getString('Password'),
                text: gettextCatalog.getString('SelectPasswordForTheTest'),
                //type: 'input',
                input: 'password',
                inputValue: vm.password,
                allowOutsideClick: false,
                allowEscapeKey: false,
            }).then(
                function (inputValue) {
                    if (!inputValue || !inputValue.value || inputValue.dismiss === 'cancel' || inputValue.dismiss === 'esc') {
                        return false;
                    } else {
                        vm.password = inputValue.value;
                        paramHelper.setParams([{'psychology.surveyPassword': inputValue.value}]);
                        vm.encryptedHtml = Aes.Ctr.encrypt(angular.element('#rteSample').ejRTE('getHtml'), inputValue.value, 256);
                        dataservice.savePerformanceMotivationSurveyEval(vm.surveyId, vm.encryptedHtml)
                            .then(function () {
                                log.successMsg('TestSaved');
                                $rootScope.back();
                            });
                    }
                });
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.athletes.athletesManagement.athleteModify.psychology.performanceMotivationTestEvaluation')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'athletes.athletesManagement.athleteModify.psychology.performanceMotivationTestEvaluation',
                config: {
                    url: '/performanceMotivationTestEvaluation',
                    templateUrl: 'app/athletes/athletesManagement/athleteModify/psychology/performanceMotivationTestEvaluation/performanceMotivationTestEvaluation.html',
                    controller: 'PerformanceMotivationTestEvaluationController',
                    controllerAs: 'vm',
                    title: 'performanceMotivationTestEvaluation'
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    PieronTestController.$inject = ["$q", "gettextCatalog", "dataservice", "paramHelper", "log", "$state", "$interval", "$rootScope", "$scope", "authenticationService"];
    angular
        .module('app.athletes.athletesManagement.athleteModify.psychology.pieronTest')
        .controller('PieronTestController', PieronTestController);

    function PieronTestController($q, gettextCatalog, dataservice, paramHelper, log, $state, $interval, $rootScope, $scope, authenticationService) {
        var vm = this; $rootScope.vm = vm;

        vm.time = 10;
        vm.timeLeftMinutes = 10;
        vm.timeLeftSeconds = 0;
        vm.lastClicked = {index1: -1, index2: -1, time: Date.Now};
        vm.started = false;
        vm.finished = false;
        vm.questions = [
            [
                {url: 'images/pieron1.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron5.png'}
            ],
            [
                {url: 'images/pieron7.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron4.png'}
            ],
            [
                {url: 'images/pieron1.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron6.png'}
            ],
            [
                {url: 'images/pieron3.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron8.png'}
            ],
            [
                {url: 'images/pieron2.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron5.png'}
            ],
            [// 6
                {url: 'images/pieron3.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron3.png'}
            ],
            [// 7
                {url: 'images/pieron3.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron6.png'}
            ],
            [// 8
                {url: 'images/pieron8.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron5.png'}
            ],
            [// 9
                {url: 'images/pieron7.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron4.png'}
            ],
            [// 10
                {url: 'images/pieron5.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron8.png'}
            ],
            [// 11
                {url: 'images/pieron8.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron4.png'}
            ],
            [// 12
                {url: 'images/pieron7.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron2.png'}
            ],
            [// 13
                {url: 'images/pieron8.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron2.png'}
            ],
            [// 14
                {url: 'images/pieron3.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron6.png'}
            ],
            [// 15
                {url: 'images/pieron6.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron5.png'}
            ],
            [// 16
                {url: 'images/pieron7.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron8.png'}
            ],
            [// 17
                {url: 'images/pieron8.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron5.png'}
            ],
            [// 18
                {url: 'images/pieron7.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron4.png'}
            ],
            [// 19
                {url: 'images/pieron1.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron5.png'}
            ],
            [// 20
                {url: 'images/pieron7.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron8.png'}
            ]
        ];

        vm.answers = [
            [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        ];

        vm.goodAnswers = [
            [1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 1, 0, 1, 0, 0, 1, 0, 0, 1, 1],
            [1, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 1, 0, 1, 0, 0, 1, 0, 0, 1],
            [1, 1, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 1, 0, 1, 0, 0, 1, 0, 0],
            [0, 1, 1, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 1, 0, 1, 0, 0, 1, 0],
            [0, 0, 1, 1, 1, 0, 1, 0, 1, 0, 1, 0, 0, 1, 1, 0, 1, 0, 0, 1],
            [0, 1, 0, 1, 0, 1, 0, 1, 1, 0, 0, 1, 0, 1, 1, 0, 1, 1, 0, 0],
            [0, 0, 1, 0, 1, 0, 1, 0, 1, 1, 0, 0, 1, 0, 1, 1, 0, 1, 1, 0],
            [0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 1, 0, 0, 1, 0, 1, 1, 0, 1, 1],
            [1, 0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 1, 0, 0, 1, 0, 1, 1, 0, 1],
            [1, 1, 0, 0, 0, 1, 0, 1, 0, 1, 0, 1, 1, 0, 0, 1, 0, 1, 1, 0],
            [0, 1, 1, 1, 0, 1, 1, 0, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 0, 1],
            [1, 0, 1, 1, 1, 0, 1, 1, 0, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 0],
            [0, 1, 0, 1, 1, 1, 0, 1, 1, 0, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0],
            [0, 0, 1, 0, 1, 1, 1, 0, 1, 1, 0, 0, 0, 1, 1, 0, 0, 1, 1, 0],
            [0, 0, 0, 1, 0, 1, 1, 1, 0, 1, 1, 0, 0, 0, 1, 1, 0, 0, 1, 1],
            [1, 0, 0, 0, 1, 0, 0, 1, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 1, 0],
            [0, 1, 0, 0, 0, 1, 0, 0, 1, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1, 1],
            [1, 0, 1, 0, 0, 0, 1, 0, 0, 1, 1, 1, 0, 0, 1, 1, 0, 0, 1, 1],
            [1, 1, 0, 1, 0, 0, 0, 1, 0, 0, 1, 1, 1, 0, 0, 1, 1, 0, 0, 1],
            [1, 1, 1, 0, 1, 0, 0, 0, 1, 0, 0, 1, 1, 1, 0, 0, 1, 1, 0, 0]
        ];
        vm.answersByMinutes = [];

        vm.stopInterval = stopInterval;
        vm.startInterval = startInterval;
        vm.clicked = clicked;
        vm.timeChanged = timeChanged;
        vm.saveSurvey = saveSurvey;

        activate();

        function activate() {
            $q.all([paramHelper.getParams(['athleteModify.sportoloId', 'athleteModify.sportoloNev']), authenticationService.getRight('PSYCHO')])
                .then(function (results) {
                if (results[1] !== true) {
                    log.permissionError(true);
                } else {
                    vm.sportoloId = results[0]['athleteModify.sportoloId'];
                    vm.sportoloNev = results[0]['athleteModify.sportoloNev'];
                    $rootScope.title = vm.sportoloNev + ' - ' + gettextCatalog.getString('Psychology') + ' - ' + gettextCatalog.getString('PieronTest');
                }
            });
        }

        function saveSurvey() {
            dataservice.savePieronTest(vm.sportoloId, vm.answers, vm.seen, vm.tNumber, vm.wrongAnswersNumber)
                .then(function () {
                    log.successMsg('TestSaved');
                    $state.go('athletes.athletesManagement.athleteModify.psychology.summary');
                });
        }

        function startInterval() {
            angular.element('#testTime').ejNumericTextbox('disable');
            vm.started = true;
            $scope.$apply();
            vm.startTime = Date.now();
            vm.stopPromise = $interval(function () {
                var temp = new Date(vm.time * 60000 - Date.now() + vm.startTime);
                if (vm.time * 60000 - Date.now() + vm.startTime < 0) {
                    vm.stopInterval();
                } else {
                    vm.timeLeftMinutes = temp.getMinutes();
                    vm.timeLeftSeconds = temp.getSeconds();
                }
            }, 1000);
            vm.minuteTimer = $interval(function () {
                if (vm.time * 60000 - Date.now() + vm.startTime < 0) {
                    stopMinuteTimer();
                } else {
                    vm.answersByMinutes.push({index1: vm.lastClicked.index1, index2: vm.lastClicked.index2});
                }
            }, 60000);
        }

        function stopMinuteTimer() {
            $interval.cancel(vm.minuteTimer);
        }

        function stopInterval() {
            vm.finished = true;
            $scope.$apply();
            vm.finishTime = Date.now();
            $interval.cancel(vm.stopPromise);
            vm.wrongAnswersNumber = 0;
            vm.answersByMinutes.push(vm.lastClicked);
            vm.seen = vm.lastClicked.index1 * 20 + vm.lastClicked.index2 + 1;
            for (var i = 0; i < 20; i++) {
                for (var j = 0; j < 20; j++) {
                    if (vm.lastClicked.index1 > i || vm.lastClicked.index1 === i && vm.lastClicked.index2 >= j) {
                        if (vm.answers[i][j] === 1 && vm.goodAnswers[i][j] === 1) {
                            vm.answers[i][j] = 2;
                        } else if (vm.answers[i][j] === 0 && vm.goodAnswers[i][j] === 1 || vm.answers[i][j] === 1 && vm.goodAnswers[i][j] === 0) {
                            vm.answers[i][j] = -1;
                            vm.wrongAnswersNumber++;
                        }
                    }
                }
            }
            // 3 jó, 4 rossz, 5 semmi
            angular.forEach(vm.answersByMinutes, function (value) {
                if (vm.answers[value.index1][value.index2] === 2) {
                    vm.answers[value.index1][value.index2] = 3;
                } else if (vm.answers[value.index1][value.index2] === -1) {
                    vm.answers[value.index1][value.index2] = 4;
                } else {
                    vm.answers[value.index1][value.index2] = 5;
                }
            });
            vm.tNumber = (vm.seen - vm.wrongAnswersNumber) / vm.seen * 100;
        }

        function clicked(index1, index2) {
            if ((vm.lastClicked.index1 < index1 || vm.lastClicked.index1 === index1 && vm.lastClicked.index2 < index2) && vm.finished === false && vm.started === true) {
                vm.answers[index1][index2] = 1;
                vm.lastClicked.index1 = index1;
                vm.lastClicked.index2 = index2;
            }
        }

        function timeChanged() {
            if (vm.started === false) {
                vm.timeLeftMinutes = vm.time;
            }
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.athletes.athletesManagement.athleteModify.psychology.pieronTest')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'athletes.athletesManagement.athleteModify.psychology.pieronTest',
                config: {
                    url: '/pieronTest',
                    templateUrl: 'app/athletes/athletesManagement/athleteModify/psychology/pieronTest/pieronTest.html',
                    controller: 'PieronTestController',
                    controllerAs: 'vm',
                    title: 'PieronTest'
                }
            }
        ];
    }
})();

/* global Aes */

(function () {
    'use strict';

    PieronTestEvaluation.$inject = ["$q", "gettextCatalog", "dataservice", "paramHelper", "log", "$state", "$rootScope", "authenticationService"];
    angular
        .module('app.athletes.athletesManagement.athleteModify.psychology.pieronTestEvaluation')
        .controller('PieronTestEvaluation', PieronTestEvaluation);

    function PieronTestEvaluation($q, gettextCatalog, dataservice, paramHelper, log, $state, $rootScope, authenticationService) {
        var vm = this; $rootScope.vm = vm;

        vm.questions = [
            [
                {url: 'images/pieron1.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron5.png'}
            ],
            [
                {url: 'images/pieron7.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron3.png'},

                {url: 'images/pieron2.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron4.png'}
            ],
            [
                {url: 'images/pieron1.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron6.png'}
            ],
            [
                {url: 'images/pieron3.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron8.png'}
            ],
            [
                {url: 'images/pieron2.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron5.png'}
            ],
            [// 6
                {url: 'images/pieron3.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron3.png'}
            ],
            [// 7
                {url: 'images/pieron3.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron6.png'}
            ],
            [// 8
                {url: 'images/pieron8.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron5.png'}
            ],
            [// 9
                {url: 'images/pieron7.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron4.png'}
            ],
            [// 10
                {url: 'images/pieron5.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron8.png'}
            ],
            [// 11
                {url: 'images/pieron8.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron4.png'}
            ],
            [// 12
                {url: 'images/pieron7.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron2.png'}
            ],
            [// 13
                {url: 'images/pieron8.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron2.png'}
            ],
            [// 14
                {url: 'images/pieron3.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron6.png'}
            ],
            [// 15
                {url: 'images/pieron6.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron5.png'}
            ],
            [// 16
                {url: 'images/pieron7.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron8.png'}
            ],
            [// 17
                {url: 'images/pieron8.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron5.png'}
            ],
            [// 18
                {url: 'images/pieron7.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron4.png'}
            ],
            [// 19
                {url: 'images/pieron1.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron5.png'}
            ],
            [// 20
                {url: 'images/pieron7.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron2.png'},
                {url: 'images/pieron3.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron4.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron5.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron6.png'},
                {url: 'images/pieron1.png'},
                {url: 'images/pieron7.png'},
                {url: 'images/pieron8.png'},
                {url: 'images/pieron8.png'}
            ]
        ];

        vm.answers = [
            [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        ];

        vm.saveEval = saveEval;

        activate();

        function activate() {
            $q.all([paramHelper.getParams(['psychology.surveyId', 'psychology.mode', 'athleteModify.sportoloNev'], ['psychology.surveyPassword']), authenticationService.getRight('PSYCHO')])
                .then(function (results) {
                if (results[1] !== true) {
                    log.permissionError(true);
                } else {
                    vm.surveyId = results[0]['psychology.surveyId'];
                    vm.password = results[0]['psychology.surveyPassword'];
                    vm.sportoloNev = results[0]['athleteModify.sportoloNev'];
                    $rootScope.title = vm.sportoloNev + ' - ' + gettextCatalog.getString('Psychology') + ' - ' + gettextCatalog.getString('PieronTestEvaluation');
                    vm.edit = results[0]['psychology.mode'] === 'edit';
                    if (vm.edit) {
                        getSurveyProtected();
                    } else {
                        getSurvey();
                    }
                }
            });
        }

        function getSurvey() {
            dataservice.getPieronTest(vm.surveyId, true)
                .then(function (data) {
                vm.answers = data.kitoltottKerdoiv;
                vm.sportolo = {};
                vm.sportolo.nev = data.sportoloNeve;
                vm.sportolo.szuletesiDatum = data.sportoloSzuletesiDatuma;
                vm.sportolo.anyjaNeve = data.sportoloAnyjaNeve;
                vm.kiertekelesSzam = data.kiertekelesSzam;
                vm.seen = data.kiertekelesSzam[1];
                vm.age = data.kiertekelesSzam[2];
                vm.tNumber = data.kiertekelesSzam[0];
                vm.wrongAnswersNumber = data.kiertekelesSzam[3];
                if (vm.wrongAnswersNumber === undefined) {
                    vm.wrongAnswersNumber = 0;
                    angular.forEach(vm.answers, function (value) {
                        angular.forEach(value, function (value2) {
                            if (value2 === -1) {
                                vm.wrongAnswersNumber++;
                            }
                        });
                    });
                }
                vm.ertek = [];
                if (vm.age < 15) {
                    if (vm.seen < 159) {
                        vm.ertek.push('Nagyon rossz');
                    } else if (vm.seen < 201) {
                        vm.ertek.push('Átlag alatti');
                    } else if (vm.seen < 296) {
                        vm.ertek.push('Átlagos');
                    } else if (vm.seen < 376) {
                        vm.ertek.push('Átlag feletti');
                    } else if (vm.seen >= 376) {
                        vm.ertek.push('Kiváló');
                    }

                    if (vm.tNumber <= 90.3) {
                        vm.ertek.push('Nagyon rossz');
                    } else if (vm.tNumber <= 95.7) {
                        vm.ertek.push('Átlag alatti');
                    } else if (vm.tNumber <= 98.5) {
                        vm.ertek.push('Átlagos');
                    } else if (vm.tNumber <= 99.4) {
                        vm.ertek.push('Átlag feletti');
                    } else if (vm.tNumber > 99.4) {
                        vm.ertek.push('Kiváló');
                    }
                } else if (vm.age > 14 && vm.age < 19) {
                    if (vm.seen < 201) {
                        vm.ertek.push('Nagyon rossz');
                    } else if (vm.seen < 256) {
                        vm.ertek.push('Átlag alatti');
                    } else if (vm.seen < 345) {
                        vm.ertek.push('Átlagos');
                    } else if (vm.seen < 396) {
                        vm.ertek.push('Átlag feletti');
                    } else if (vm.seen > 395) {
                        vm.ertek.push('Kiváló');
                    }

                    if (vm.tNumber <= 93.3) {
                        vm.ertek.push('Nagyon rossz');
                    } else if (vm.tNumber <= 97.0) {
                        vm.ertek.push('Átlag alatti');
                    } else if (vm.tNumber <= 98.8) {
                        vm.ertek.push('Átlagos');
                    } else if (vm.tNumber <= 99.6) {
                        vm.ertek.push('Átlag feletti');
                    } else if (vm.tNumber > 99.6) {
                        vm.ertek.push('Kiváló');
                    }
                } else if (vm.age > 18) {
                    if (vm.seen < 178) {
                        vm.ertek.push('Nagyon rossz');
                    } else if (vm.seen < 214) {
                        vm.ertek.push('Átlag alatti');
                    } else if (vm.seen < 261) {
                        vm.ertek.push('Átlagos');
                    } else if (vm.seen < 323) {
                        vm.ertek.push('Átlag feletti');
                    } else if (vm.seen > 322) {
                        vm.ertek.push('Kiváló');
                    }

                    if (vm.tNumber <= 88.2) {
                        vm.ertek.push('Nagyon rossz');
                    } else if (vm.tNumber <= 93.7) {
                        vm.ertek.push('Átlag alatti');
                    } else if (vm.tNumber <= 96.2) {
                        vm.ertek.push('Átlagos');
                    } else if (vm.tNumber <= 97.7) {
                        vm.ertek.push('Átlag feletti');
                    } else if (vm.tNumber > 99.7) {
                        vm.ertek.push('Kiváló');
                    }
                }

                vm.kitoltesDatuma = data.kitoltesDatuma;
            });
        }

        function getSurveyProtected() {
            swal({
                title: gettextCatalog.getString('Password'),
                text: gettextCatalog.getString('SelectPasswordForTheTest'),
                //type: 'input',
                input: 'password',
                animation: 'slide-from-top',
                inputValue: vm.password,
                closeOnConfirm: false,
                allowEscapeKey: false
            }).then(function (inputValue) {
                if (!inputValue || !inputValue.value || inputValue.dismiss === 'cancel' || inputValue.dismiss === 'esc') {
                    return false;
                } else {
                    vm.password = inputValue.value;
                    dataservice.getPieronTest(vm.surveyId, false)
                        .then(function (data) {
                        vm.answers = data.kitoltottKerdoiv;
                        vm.sportolo = {};
                        vm.sportolo.nev = data.sportoloNeve;
                        vm.sportolo.szuletesiDatum = data.sportoloSzuletesiDatuma;
                        vm.sportolo.anyjaNeve = data.sportoloAnyjaNeve;
                        vm.kitoltesDatuma = data.kitoltesDatuma;
                        vm.kiertekelesDatuma = data.kiertekelesDatuma;
                        vm.kiertekelesSzam = data.kiertekelesSzam;
                        vm.kiertekelesSzoveg = data.kiertekelesSzoveg;
                        vm.seen = data.kiertekelesSzam[1];
                        vm.age = data.kiertekelesSzam[2];
                        vm.tNumber = data.kiertekelesSzam[0];
                        vm.wrongAnswersNumber = data.kiertekelesSzam[3];
                        vm.ertek = [];
                        if (vm.age < 15) {
                            if (vm.seen < 159) {
                                vm.ertek.push('Nagyon rossz');
                            } else if (vm.seen < 201) {
                                vm.ertek.push('Átlag alatti');
                            } else if (vm.seen < 296) {
                                vm.ertek.push('Átlagos');
                            } else if (vm.seen < 376) {
                                vm.ertek.push('Átlag feletti');
                            } else if (vm.seen >= 376) {
                                vm.ertek.push('Kiváló');
                            }

                            if (vm.tNumber <= 90.3) {
                                vm.ertek.push('Nagyon rossz');
                            } else if (vm.tNumber <= 95.7) {
                                vm.ertek.push('Átlag alatti');
                            } else if (vm.tNumber <= 98.5) {
                                vm.ertek.push('Átlagos');
                            } else if (vm.tNumber <= 99.4) {
                                vm.ertek.push('Átlag feletti');
                            } else if (vm.tNumber > 99.4) {
                                vm.ertek.push('Kiváló');
                            }
                        } else if (vm.age > 14 && vm.age < 19) {
                            if (vm.seen < 201) {
                                vm.ertek.push('Nagyon rossz');
                            } else if (vm.seen < 256) {
                                vm.ertek.push('Átlag alatti');
                            } else if (vm.seen < 345) {
                                vm.ertek.push('Átlagos');
                            } else if (vm.seen < 396) {
                                vm.ertek.push('Átlag feletti');
                            } else if (vm.seen > 395) {
                                vm.ertek.push('Kiváló');
                            }

                            if (vm.tNumber <= 93.3) {
                                vm.ertek.push('Nagyon rossz');
                            } else if (vm.tNumber <= 97.0) {
                                vm.ertek.push('Átlag alatti');
                            } else if (vm.tNumber <= 98.8) {
                                vm.ertek.push('Átlagos');
                            } else if (vm.tNumber <= 99.6) {
                                vm.ertek.push('Átlag feletti');
                            } else if (vm.tNumber > 99.6) {
                                vm.ertek.push('Kiváló');
                            }
                        } else if (vm.age > 18) {
                            if (vm.seen < 178) {
                                vm.ertek.push('Nagyon rossz');
                            } else if (vm.seen < 214) {
                                vm.ertek.push('Átlag alatti');
                            } else if (vm.seen < 261) {
                                vm.ertek.push('Átlagos');
                            } else if (vm.seen < 323) {
                                vm.ertek.push('Átlag feletti');
                            } else if (vm.seen > 322) {
                                vm.ertek.push('Kiváló');
                            }

                            if (vm.tNumber <= 88.2) {
                                vm.ertek.push('Nagyon rossz');
                            } else if (vm.tNumber <= 93.7) {
                                vm.ertek.push('Átlag alatti');
                            } else if (vm.tNumber <= 96.2) {
                                vm.ertek.push('Átlagos');
                            } else if (vm.tNumber <= 97.7) {
                                vm.ertek.push('Átlag feletti');
                            } else if (vm.tNumber > 99.7) {
                                vm.ertek.push('Kiváló');
                            }
                        }

                        if (vm.kiertekelesDatuma !== '') {
                            vm.kiertekelesSzoveg = Aes.Ctr.decrypt(vm.kiertekelesSzoveg, inputValue.value, 256);
                        }
                        angular.element('#rteSample').ejRTE({value: vm.kiertekelesSzoveg});
                        swal.close();
                    });
                }
            });
        }

        function saveEval() {
            swal({
                title: gettextCatalog.getString('Password'),
                text: gettextCatalog.getString('SelectPasswordForTheTest'),
                //type: 'input',
                input: 'password',
                animation: 'slide-from-top',
                inputValue: vm.password,
                allowEscapeKey: false
            }).then(function (inputValue) {
                if (!inputValue || !inputValue.value || inputValue.dismiss === 'cancel' || inputValue.dismiss === 'esc') {
                    return false;
                } else {
                    vm.password = inputValue.value;
                    paramHelper.setParams([{'psychology.surveyPassword': inputValue.value}]);
                    vm.encryptedHtml = Aes.Ctr.encrypt(angular.element('#rteSample').ejRTE('getHtml'), inputValue.value, 256);
                    dataservice.savePerformanceMotivationSurveyEval(vm.surveyId, vm.encryptedHtml)
                        .then(function () {
                            log.successMsg('TestSaved');
                            $state.go('athletes.athletesManagement.athleteModify.psychology.summary');
                        });
                }
            });
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.athletes.athletesManagement.athleteModify.psychology.pieronTestEvaluation')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'athletes.athletesManagement.athleteModify.psychology.pieronTestEvaluation',
                config: {
                    url: '/pieronTestEvaluation',
                    templateUrl: 'app/athletes/athletesManagement/athleteModify/psychology/pieronTestEvaluation/pieronTestEvaluation.html',
                    controller: 'PieronTestEvaluation',
                    controllerAs: 'vm',
                    title: 'PieronTestEvaluation'
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.athletes.athletesManagement.athleteModify.psychology')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'athletes.athletesManagement.athleteModify.psychology',
                config: {
                    url: '/psychology',
                    templateUrl: 'app/athletes/athletesManagement/athleteModify/psychology/psychology.html'
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    SummaryController.$inject = ["$q", "log", "paramHelper", "$state", "dataservice", "$scope", "PSYCHOLOGY", "DOMAIN", "gettextCatalog", "$rootScope", "authenticationService"];
    angular
        .module('app.athletes.athletesManagement.athleteModify.psychology.summary')
        .controller('SummaryController', SummaryController);

    function SummaryController($q, log, paramHelper, $state, dataservice, $scope, PSYCHOLOGY, DOMAIN, gettextCatalog, $rootScope, authenticationService) {
        var vm = this;
        $rootScope.vm = vm;

        vm.warteggUrl = DOMAIN.baseURL + DOMAIN.psychologyDocUrl + '/wartegg.png';
        vm.columns = [
            {field: 'Id', visible: false, isPrimaryKey: true},
            {field: 'typeId', visible: false},
            {field: 'type', headerText: gettextCatalog.getString('TestsType'), textAlign: 'left'},
            {field: 'dateOfSurvey', headerText: gettextCatalog.getString('TestsDate'), textAlign: 'left'},
            {
                field: 'documentOfSurvey',
                headerText: gettextCatalog.getString('Test'),
                textAlign: 'left',
                template: '#sutemplateDataColumn1'
            },
            {
                field: 'dateOfAssessment',
                headerText: gettextCatalog.getString('EvaluationsDate'),
                textAlign: 'left',
                template: '#sutemplateDataColumn2'
            },
            {
                field: 'documentOfAssessment',
                headerText: gettextCatalog.getString('Evaluation'),
                textAlign: 'left',
                template: '#sutemplateDataColumn3'
            }
        ];
        vm.open = gettextCatalog.getString('Open');
        vm.noEvaluationForThisTest = gettextCatalog.getString('NoEvaluationForThisTest');

        // Public functions
        vm.goToPerformanceMotivation = goToPerformanceMotivation;
        vm.goToPieron = goToPieron;
        vm.goToTenessee = goToTenessee;
        vm.goToShowFilledTest = goToShowFilledTest;
        vm.addWartegTest = addWartegTest;

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItemsWithSearch,
            allowPaging: true,
            allowTextWrap: true,
            allowSorting: true,
            allowExcelExport: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#Grid'), $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        activate();

        function activate() {
            var promises = [paramHelper.getParams([], [
                'athleteModify.sportoloId',
                'athleteModify.sportoloNev',
                'athleteModify.aktivSportolo']), authenticationService.getRight('PSYCHO')];
            return $q.all(promises).then(function (results) {
                if (results[1] !== true) {
                    log.permissionError(true);
                } else {
                    vm.aktiv = results[0]['athleteModify.aktivSportolo'];
                    if (!vm.aktiv) {
                        $('#dropdownMenu').addClass('disabled');
                    }
                    vm.sportoloId = results[0]['athleteModify.sportoloId'];
                    vm.sportoloNev = results[0]['athleteModify.sportoloNev'];
                    $rootScope.title = vm.sportoloNev + ' - ' + gettextCatalog.getString('Psychology');
                    getPsychologyTests();
                }
            });
        }

        function getPsychologyTests() {
            return dataservice.getPsychologyTests(vm.sportoloId).then(function (data) {
                grid.dataSource = data.itemsList;
            });
        }

        function goToShowFilledTest(id, testType, password, documentOfAssessmentBool) {
            if (documentOfAssessmentBool) {
                return;
            }
            if (password) {
                password = 'edit';
            } else {
                password = 'open';
            }
            switch (testType) {
                case PSYCHOLOGY.Wartegg:
                    paramHelper.setParams([{'psychology.psychologyId': id}]);
                    $state.go('athletes.athletesManagement.athleteModify.psychology.wartegg');
                    break;
                case PSYCHOLOGY.PerformanceMotivation:
                    paramHelper.setParams([{'psychology.surveyId': id}, {'psychology.mode': password}]);
                    $state.go('athletes.athletesManagement.athleteModify.psychology.performanceMotivationTestEvaluation');
                    break;
                case PSYCHOLOGY.Pieron:
                    paramHelper.setParams([{'psychology.surveyId': id}, {'psychology.mode': password}]);
                    $state.go('athletes.athletesManagement.athleteModify.psychology.pieronTestEvaluation');
                    break;
                case PSYCHOLOGY.Tenessee:
                    paramHelper.setParams([{'psychology.surveyId': id}]);
                    $state.go('athletes.athletesManagement.athleteModify.psychology.tenesseeSelfImageScaleEvaluation');
                    break;
                default:
                    break;
            }
        }

        function goToPerformanceMotivation() {
            if (!vm.aktiv) {
                paramHelper.setParams([{'psychology.sportoloId': vm.sportoloId}]);
                $state.go('athletes.athletesManagement.athleteModify.psychology.performanceMotivationTest');
            }
        }

        function goToPieron() {
            if (!vm.aktiv) {
                paramHelper.setParams([{'psychology.sportoloId': vm.sportoloId}]);
                $state.go('athletes.athletesManagement.athleteModify.psychology.pieronTest');
            }
        }

        function goToTenessee() {
            if (!vm.aktiv) {
                paramHelper.setParams([{'psychology.sportoloId': vm.sportoloId}]);
                $state.go('athletes.athletesManagement.athleteModify.psychology.tenesseeSelfImageScale');
            }
        }

        function addWartegTest() {
            if (!vm.aktiv) {
                return dataservice.saveWartegg(vm.sportoloId).then(function (data) {
                    if (!data) {
                        log.errorMsg(gettextCatalog.getString('ErrorOccurredWhileCreatingTheTest'));
                    } else {
                        getPsychologyTests();
                    }
                });
            }
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.athletes.athletesManagement.athleteModify.psychology.summary')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'athletes.athletesManagement.athleteModify.psychology.summary',
                config: {
                    url: '/summary',
                    templateUrl: 'app/athletes/athletesManagement/athleteModify/psychology/summary/summary.html',
                    controller: 'SummaryController',
                    controllerAs: 'vm',
                    title: 'Summary'
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    TenesseeSelfImageScaleController.$inject = ["$q", "gettextCatalog", "dataservice", "paramHelper", "log", "$state", "$rootScope", "authenticationService"];
    angular
        .module('app.athletes.athletesManagement.athleteModify.psychology.tenesseeSelfImageScale')
        .controller('TenesseeSelfImageScaleController', TenesseeSelfImageScaleController);

    function TenesseeSelfImageScaleController($q, gettextCatalog, dataservice, paramHelper, log, $state, $rootScope, authenticationService) {
        var vm = this; $rootScope.vm = vm;

        vm.questions = [
            gettextCatalog.getString('TenesseeSelfImageScaleQ1'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ2'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ3'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ4'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ5'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ6'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ7'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ8'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ9'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ10'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ11'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ12'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ13'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ14'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ15'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ16'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ17'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ18'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ19'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ20'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ21'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ22'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ23'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ24'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ25'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ26'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ27'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ28'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ29'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ30'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ31'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ32'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ33'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ34'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ35'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ36'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ37'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ38'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ39'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ40'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ41'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ42'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ43'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ44'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ45'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ46'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ47'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ48'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ49'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ50'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ51'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ52'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ53'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ54'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ55'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ56'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ57'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ58'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ59'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ60'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ61'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ62'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ63'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ64'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ65'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ66'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ67'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ68'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ69'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ70'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ71'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ72'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ73'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ74'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ75'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ76'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ77'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ78'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ79'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ80'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ81'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ82'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ83'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ84'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ85'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ86'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ87'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ88'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ89'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ90'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ91'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ92'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ93'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ94'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ95'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ96'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ97'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ98'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ99'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ100')
        ];
        vm.answers = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        vm.sportoloId = 0;

        // Public functions
        vm.saveSurvey = saveSurvey;

        activate();

        function activate() {
            $q.all([paramHelper.getParams(['athleteModify.sportoloId', 'athleteModify.sportoloNev']), authenticationService.getRight('PSYCHO')])
                .then(function (results) {
                    if (results[1] !== true) {
                        log.permissionError(true);
                    } else {
                        vm.sportoloId = results[0]['athleteModify.sportoloId'];
                        vm.sportoloNev = results[0]['athleteModify.sportoloNev'];
                        $rootScope.title = vm.sportoloNev + ' - ' + gettextCatalog.getString('Psychology') + ' - ' + gettextCatalog.getString('TenesseeSelfImageScale');
                    }
                })

            ;
        }

        function saveSurvey() {
            var hiba = false;
            if (vm.sportoloId) {
                angular.forEach(vm.answers, function (value, key) {
                    if (value === 0) {
                        vm.answers[key] = -1;
                        hiba = true;
                    }
                });
            } else {
                hiba = true;
            }
            if (hiba) {
                log.errorMsg('PleaseAnswerAllQuestion');
            } else {
                dataservice.saveTenesseeSelfImageScale(vm.sportoloId, vm.answers)
                    .then(function () {
                        log.successMsg('TestSaved');
                        $state.go('psychology.summary');
                    });
            }
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.athletes.athletesManagement.athleteModify.psychology.tenesseeSelfImageScale')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'athletes.athletesManagement.athleteModify.psychology.tenesseeSelfImageScale',
                config: {
                    url: '/tenesseeSelfImageScale',
                    templateUrl: 'app/athletes/athletesManagement/athleteModify/psychology/tenesseeSelfImageScale/tenesseeSelfImageScale.html',
                    controller: 'TenesseeSelfImageScaleController',
                    controllerAs: 'vm',
                    title: 'tenesseeSelfImageScale'
                }
            }
        ];
    }
})();

/* global Aes */

(function () {
    'use strict';

    TenesseeSelfImageScaleEvaluationController.$inject = ["$q", "gettextCatalog", "dataservice", "paramHelper", "$rootScope", "authenticationService", "log"];
    angular
        .module('app.athletes.athletesManagement.athleteModify.psychology.tenesseeSelfImageScaleEvaluation')
        .controller('TenesseeSelfImageScaleEvaluationController', TenesseeSelfImageScaleEvaluationController);

    function TenesseeSelfImageScaleEvaluationController($q, gettextCatalog, dataservice, paramHelper, $rootScope, authenticationService, log) {
        var vm = this; $rootScope.vm = vm;

        vm.questions = [
            gettextCatalog.getString('TenesseeSelfImageScaleQ1'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ2'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ3'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ4'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ5'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ6'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ7'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ8'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ9'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ10'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ11'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ12'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ13'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ14'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ15'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ16'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ17'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ18'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ19'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ20'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ21'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ22'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ23'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ24'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ25'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ26'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ27'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ28'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ29'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ30'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ31'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ32'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ33'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ34'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ35'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ36'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ37'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ38'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ39'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ40'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ41'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ42'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ43'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ44'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ45'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ46'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ47'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ48'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ49'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ50'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ51'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ52'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ53'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ54'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ55'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ56'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ57'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ58'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ59'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ60'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ61'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ62'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ63'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ64'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ65'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ66'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ67'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ68'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ69'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ70'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ71'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ72'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ73'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ74'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ75'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ76'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ77'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ78'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ79'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ80'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ81'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ82'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ83'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ84'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ85'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ86'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ87'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ88'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ89'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ90'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ91'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ92'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ93'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ94'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ95'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ96'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ97'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ98'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ99'),
            gettextCatalog.getString('TenesseeSelfImageScaleQ100')
        ];
        vm.answers = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

        // Public functions
        vm.saveEval = saveEval;

        activate();

        function activate() {
            $q.all([paramHelper.getParams(['psychology.surveyId'], ['psychology.surveyPassword', 'athleteModify.sportoloNev']), authenticationService.getRight('PSYCHO')])
                .then(function (results) {
                    if (results[1] !== true) {
                        log.permissionError(true);
                    } else {
                        vm.surveyId = results[0]['psychology.surveyId'];
                        vm.password = results[0]['psychology.surveyPassword'];
                        vm.sportoloNev = results[0]['athleteModify.sportoloNev'];
                        $rootScope.title = vm.sportoloNev + ' - ' + gettextCatalog.getString('Psychology') + ' - ' + gettextCatalog.getString('TenesseeSelfImageScaleEvaluation');
                        getTSFIS();
                    }
                });
        }

        function getTSFIS() {
            swal({
                title: gettextCatalog.getString('Password'),
                text: gettextCatalog.getString('SelectPasswordForTheTest'),
                //type: 'input',
                input: 'password',
                animation: 'slide-from-top',
                inputValue: vm.password,
                closeOnConfirm: false,
                allowEscapeKey: false
            }).then(
                function (inputValue) {
                    if (!inputValue || !inputValue.value || inputValue.dismiss === 'cancel' || inputValue.dismiss === 'esc') {
                        return false;
                    } else {
                        vm.password = inputValue.value;
                        dataservice.getTenesseeSelfImageScaleById(vm.surveyId).then(function (data) {
                            if (data.error === '') {
                                vm.answers = data.kitoltottKerdoiv;
                                vm.sportolo = {};
                                vm.sportolo.nev = data.sportoloNeve;
                                vm.sportolo.szuletesiDatum = data.sportoloSzuletesiDatuma;
                                vm.sportolo.anyjaNeve = data.sportoloAnyjaNeve;
                                vm.kitoltesDatuma = data.kitoltesDatuma;
                                vm.kiertekelesDatuma = data.kiertekelesDatuma;
                                vm.kiertekelesSzam = data.kiertekelesSzam;
                                vm.kiertekelesSzoveg = data.kiertekelesSzoveg;
                                vm.kiertekelesSzamMagyarazat = data.kiertekelesSzamMagyarazat;
                                if (vm.kiertekelesDatuma !== '') {
                                    vm.kiertekelesSzoveg = Aes.Ctr.decrypt(vm.kiertekelesSzoveg, inputValue.value, 256);
                                    angular.element('#rteSample').ejRTE({value: vm.kiertekelesSzoveg});
                                }
                                swal.close();
                            }
                        });
                    }
                });
        }

        function saveEval() {
            swal({
                title: gettextCatalog.getString('Password'),
                text: gettextCatalog.getString('SelectPasswordForTheTest'),
                //type: 'input',
                input: 'password',
                animation: 'slide-from-top',
                inputValue: vm.password,
                closeOnConfirm: false,
                allowEscapeKey: false
            }).then(function (inputValue) {
                if (!inputValue || !inputValue.value || inputValue.dismiss === 'cancel' || inputValue.dismiss === 'esc') {
                    return false;
                } else {
                    vm.password = inputValue.value;
                    paramHelper.setParams([{'psychology.surveyPassword': inputValue.value}]);
                    var hiba = false;
                    angular.forEach(vm.answers, function (value, key) {
                        if (value === 0) {
                            vm.answers[key] = -1;
                            hiba = true;
                        }
                    });
                    if (hiba) {
                        log.errorMsg('SurveyNotFilled');
                    } else {
                        vm.encryptedHtml = Aes.Ctr.encrypt(angular.element('#rteSample').ejRTE('getHtml'), inputValue.value, 256);
                        dataservice.saveTenesseeSelfImageScaleEval(vm.surveyId, vm.encryptedHtml)
                            .then(function () {
                                log.successMsg('TestSaved');
                                $rootScope.back();
                            });
                    }
                }
            });
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.athletes.athletesManagement.athleteModify.psychology.tenesseeSelfImageScaleEvaluation')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'athletes.athletesManagement.athleteModify.psychology.tenesseeSelfImageScaleEvaluation',
                config: {
                    url: '/tenesseeSelfImageScaleEvaluation',
                    templateUrl: 'app/athletes/athletesManagement/athleteModify/psychology/tenesseeSelfImageScaleEvaluation/tenesseeSelfImageScaleEvaluation.html',
                    controller: 'TenesseeSelfImageScaleEvaluationController',
                    controllerAs: 'vm',
                    title: 'TenesseeSelfImageScaleEvaluation'
                }
            }
        ];
    }
})();

/* global Aes */

(function () {
    'use strict';

    WarteggController.$inject = ["$q", "gettextCatalog", "dataservice", "paramHelper", "$state", "$rootScope", "authenticationService", "log", "$scope", "$timeout"];
    angular
        .module('app.athletes.athletesManagement.athleteModify.psychology.wartegg')
        .controller('WarteggController', WarteggController);

    function WarteggController($q, gettextCatalog, dataservice, paramHelper, $state, $rootScope, authenticationService, log, $scope, $timeout) {
        var vm = this;
        $rootScope.vm = vm;

        vm.sportoloId = 0;
        vm.psychologyId = 0;
        vm.kiertekelt = false;
        vm.allowEdit = false;

        // Public functions
        vm.upload = upload;

        activate();

        function activate() {
            var promises = [paramHelper.getParams(['athleteModify.sportoloId', 'psychology.psychologyId', 'athleteModify.sportoloNev'], ['psychology.surveyPassword', 'athleteModify.aktivSportolo']), authenticationService.getRight('PSYCHO')];
            return $q.all(promises).then(function (data) {
                if (data[1] !== true) {
                    log.permissionError(true);
                } else {
                    $timeout(function () {
                        vm.allowEdit = data[0]['athleteModify.aktivSportolo'];
                        $scope.$apply();
                    });
                    vm.psychologyId = data[0]['psychology.psychologyId'];
                    vm.password = data[0]['psychology.surveyPassword'];
                    vm.sportoloId = data[0]['athleteModify.sportoloId'];
                    vm.sportoloNev = data[0]['athleteModify.sportoloNev'];
                    $rootScope.title = vm.sportoloNev + ' - ' + gettextCatalog.getString('Psychology') + ' - ' + gettextCatalog.getString('WarteggTest');
                    swal({
                        title: gettextCatalog.getString('Password'),
                        text: gettextCatalog.getString('SelectPasswordForTheTest'),
                        //type: 'input',
                        input: 'password',
                        animation: 'slide-from-top',
                        inputValue: vm.password,
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then(
                        function (inputValue) {
                            if (!inputValue || !inputValue.value || inputValue.dismiss === 'cancel' || inputValue.dismiss === 'esc') {
                                return false;
                            } else {
                                vm.password = inputValue.value;
                                dataservice.getWarteggTestById(vm.psychologyId)
                                    .then(function (response) {
                                        vm.kiertekelt = response.kiertekelesDatuma !== '';
                                        vm.kepfajl = response.kitoltottKerdoiv;
                                        vm.kiertekelesSzoveg = response.kiertekelesSzoveg;
                                        if (vm.kiertekelesSzoveg !== '') {
                                            vm.kiertekelesSzoveg = Aes.Ctr.decrypt(vm.kiertekelesSzoveg, inputValue.value, 256);
                                            angular.element('#rteSample').ejRTE({value: vm.kiertekelesSzoveg});
                                        }
                                        swal.close();
                                    });
                            }
                        });
                }
            });
        }

        function upload() {
            if (!vm.allowEdit) {
                return;
            }
            swal({
                title: gettextCatalog.getString('Password'),
                text: gettextCatalog.getString('SelectPasswordForTheTest'),
                //type: 'input',
                input: 'password',
                animation: 'slide-from-top',
                inputValue: vm.password,
                allowOutsideClick: false,
                allowEscapeKey: false
            }).then(
                function (inputValue) {
                    if (!inputValue || !inputValue.value || inputValue.dismiss === 'cancel' || inputValue.dismiss === 'esc') {
                        return false;
                    } else {
                        vm.password = inputValue.value;
                        var file = document.getElementById('file').files[0];
                        var szoveg = angular.element('#rteSample').ejRTE('getHtml');
                        if (file) {
                            var r = new FileReader();
                            if (szoveg !== '') {
                                szoveg = Aes.Ctr.encrypt(szoveg, inputValue.value, 256);
                            }

                            r.onloadend = function (e) {
                                var data = {
                                    psychologyId: vm.psychologyId,
                                    fileName: file.name,
                                    fileData: e.target.result,
                                    sportoloId: vm.sportoloId,
                                    psychologySurvey: szoveg
                                };
                                dataservice.uploadWartegg(data)
                                    .then(function () {
                                        swal.close();
                                        $state.go('athletes.athletesManagement.athleteModify.psychology.summary');
                                    });
                            };
                            r.readAsDataURL(file);
                        } else {
                            if (szoveg !== '') {
                                szoveg = Aes.Ctr.encrypt(szoveg, inputValue.value, 256);
                            }
                            var data = {
                                psychologyId: vm.psychologyId,
                                fileName: '',
                                fileData: null,
                                sportoloId: vm.sportoloId,
                                psychologySurvey: szoveg
                            };
                            dataservice.uploadWartegg(data)
                                .then(function () {
                                    swal.close();
                                    $state.go('athletes.athletesManagement.athleteModify.psychology.summary');
                                });
                        }
                    }
                });
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.athletes.athletesManagement.athleteModify.psychology.wartegg')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'athletes.athletesManagement.athleteModify.psychology.wartegg',
                config: {
                    url: '/wartegg',
                    templateUrl: 'app/athletes/athletesManagement/athleteModify/psychology/wartegg/wartegg.html',
                    controller: 'WarteggController',
                    controllerAs: 'vm',
                    title: 'Wartegg',
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    RaceResultsReport2Controller.$inject = ["log", "logger", "dataservice", "$q", "$rootScope", "gettextCatalog", "paramHelper", "authenticationService", "$scope", "$filter", "$state"];
    angular
        .module('app.athletes.athletesManagement.athleteModify.raceResultsReport')
        .controller('RaceResultsReport2Controller', RaceResultsReport2Controller);

    function RaceResultsReport2Controller(log, logger, dataservice, $q, $rootScope, gettextCatalog, paramHelper, authenticationService, $scope, $filter, $state) {
        var vm = this;
        $rootScope.vm = vm;
        vm.params = [];

        // For print
        vm.reportParameters = {};

        // GRID
        vm.schoolGridSelectedRowData = {};
        vm.columnsAthlete = [
            {
                field: 'SportoloNev',
                headerText: gettextCatalog.getString('AthleteName'),
                headerTextAlign: 'center',
                textAlign: 'left',
                width: '150',
                template: '#rareretemplateDataColumn1'
            },
            {
                field: 'EredmenySzoveg',
                headerText: gettextCatalog.getString('ResultText'),
                textAlign: 'left',
                width: '350'
            },
            {
                field: 'EredmenyPont',
                headerText: gettextCatalog.getString('ResultScore'),
                headerTextAlign: 'center',
                width: '150'
            },
            {
                field: 'EredmenyIdo',
                headerText: gettextCatalog.getString('ResultTime'),
                headerTextAlign: 'center',
                width: '150'
            },
            {
                field: 'EredmenyTavolsag',
                headerText: gettextCatalog.getString('ResultDistance'),
                headerTextAlign: 'center',
                width: '150'
            },
            {
                field: 'SzakosztalyNeve',
                headerText: gettextCatalog.getString('Section'),
                headerTextAlign: 'center',
                width: '100'
            },
            {
                field: 'KorcsoportNeve',
                headerText: gettextCatalog.getString('AgeGroup'),
                headerTextAlign: 'center',
                width: '100'
            },
            {
                field: 'DatumTol',
                headerText: gettextCatalog.getString('DateFrom'),
                headerTextAlign: 'center',
                width: '90'
            },
            {field: 'DatumIg', headerText: gettextCatalog.getString('DateTo'), headerTextAlign: 'center', width: '90'},
            {
                field: 'Helyszin',
                headerText: gettextCatalog.getString('Location'),
                headerTextAlign: 'center',
                width: '140'
            },
            {
                field: 'Helyezes',
                headerText: gettextCatalog.getString('Helyezes'),
                headerTextAlign: 'center',
                width: '120'
            },
            {field: 'VersenyLeiras', headerText: gettextCatalog.getString('VersenyLeiras'), width: '250'},
            {
                field: 'Ertekeles',
                headerText: gettextCatalog.getString('CoachRating'),
                headerTextAlign: 'center',
                width: '400'
            },
            {
                field: 'Jellege',
                headerText: gettextCatalog.getString('Jellege'),
                headerTextAlign: 'center',
                width: '250'
            },
            {field: 'Eredmeny', headerText: gettextCatalog.getString('Result'), headerTextAlign: 'center', width: '90'}, //int Edzői értékelés (Eredmeny = -2 => 1;Eredmeny =2=> 5 )
            {
                field: 'Versenyszam',
                headerText: gettextCatalog.getString('Versenyszam'),
                headerTextAlign: 'center',
                width: '200'
            },
            {
                field: 'EdzoNeve',
                headerText: gettextCatalog.getString('Coach'),
                headerTextAlign: 'center',
                width: '110',
                template: '#rareretemplateDataColumn2'
            },
            {
                headerText: gettextCatalog.getString('OpenIt'),
                headerTextAlign: 'center',
                width: '100',
                template: '#rareretemplateDataColumn3'
            },
            {
                headerText: gettextCatalog.getString('Print'),
                headerTextAlign: 'center',
                width: '100',
                template: '#rareretemplateDataColumn4'
            }
        ];
        vm.teamsLists = [];
        vm.columnsTeam = [
            {
                field: 'CsapatNev',
                headerText: gettextCatalog.getString('TeamName'),
                width: '150',
                template: '#rareretemplateDataColumn5'
            },
            {field: 'EredmenySzoveg', headerText: gettextCatalog.getString('ResultText'), width: '350'},
            {field: 'SzakosztalyNeve', headerText: gettextCatalog.getString('Section'), width: '100'},
            {field: 'KorcsoportNeve', headerText: gettextCatalog.getString('AgeGroup'), width: '100'},
            {field: 'DatumTol', headerText: gettextCatalog.getString('DateFrom'), width: '90'},
            {field: 'DatumIg', headerText: gettextCatalog.getString('DateTo'), width: '90'},
            {field: 'Helyszin', headerText: gettextCatalog.getString('Location'), width: '140'},
            {field: 'Helyezes', headerText: gettextCatalog.getString('AthleteRanking'), width: '120'},
            {field: 'VersenyLeiras', headerText: gettextCatalog.getString('VersenyLeiras'), width: '250'},
            {field: 'Ertekeles', headerText: gettextCatalog.getString('CoachRating'), width: '400'},
            {field: 'Jellege', headerText: gettextCatalog.getString('Jellege'), width: '250'},
            {field: 'Eredmeny', headerText: gettextCatalog.getString('Result'), headerTextAlign: 'center', width: '90'}, //int Edzői értékelés (Eredmeny = -2 => 1;Eredmeny =2=> 5 )
            {
                field: 'Versenyszam',
                headerText: gettextCatalog.getString('Versenyszam'),
                headerTextAlign: 'center',
                width: '200'
            },
            {
                field: 'EdzoNeve',
                headerText: gettextCatalog.getString('Coach'),
                width: '110',
                template: '#rareretemplateDataColumn6'
            },
            {
                headerText: gettextCatalog.getString('OpenIt'),
                width: '100',
                template: '#rareretemplateDataColumn7'
            },
            {
                headerText: gettextCatalog.getString('Print'),
                width: '100',
                template: '#rareretemplateDataColumn8'
            }
        ];

        // Public functions
        vm.openCoach = openCoach;
        vm.openAthlete = openAthlete;
        vm.openTeam = openTeam;

        vm.openResultReportAthletes = openResultReportAthletes;
        vm.openResultReportTeam = openResultReportTeam;

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItems,
            allowPaging: true,
            allowTextWrap: true,
            allowSorting: true,
            allowExcelExport: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columnsAthlete,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#Grid'), $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        var grid2 = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItems,
            allowPaging: true,
            allowTextWrap: true,
            allowSorting: true,
            allowExcelExport: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columnsTeam,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#Grid2'), $scope);
                }
            }
        });
        grid2.appendTo('#Grid2');
        grid2.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid2);
        };

        activate();

        function activate() {
            $q.all([
                authenticationService.getRight('KMVERSEREDM'),
                paramHelper.getParams(['athleteModify.sportoloId', 'athleteModify.sportoloNev'], [])
            ]).then(function (results) {
                if (!results[0]) {
                    log.permissionError(true);
                } else {
                    vm.sportoloId = results[1]['athleteModify.sportoloId'];
                    vm.sportoloNev = results[1]['athleteModify.sportoloNev'];
                    searchAthlete(vm.sportoloId, vm.sportoloNev);
                    $rootScope.title = vm.sportoloNev + ' - ' + gettextCatalog.getString('RaceResultsReport');
                }
            });
        }

        function searchAthlete(id, nev) {
            dataservice.getResultsReportsAthlete({
                    SportoloId: id,
                    SportoloNev: nev
                })
                .then(function (data) {
                    vm.athletesLists = data.itemsList;
                    vm.athletesLists = $filter('dateStringFilter')(vm.athletesLists, 'SzuletesiIdo');
                    vm.athletesLists = $filter('dateStringFilter')(vm.athletesLists, 'DatumTol');
                    vm.athletesLists = $filter('dateStringFilter')(vm.athletesLists, 'DatumIg');
                    vm.athletesLists = $filter('valueChangeFromObject')(vm.athletesLists, 'Eredmeny');
                    grid.dataSource = vm.athletesLists;

                    vm.teamsLists = data.itemsList2;
                    vm.teamsLists = $filter('dateStringFilter')(vm.teamsLists, 'DatumTol');
                    vm.teamsLists = $filter('dateStringFilter')(vm.teamsLists, 'DatumIg');
                    vm.teamsLists = $filter('valueChangeFromObject')(vm.teamsLists, 'Eredmeny');
                    grid2.dataSource = vm.teamsLists;
                });
        }

        function openAthlete(id) {
            $q.all([authenticationService.getRight('MEGTSPORTLIST')]).then(function (results) {
                if (results[0]) {
                    paramHelper.setParams([{'athleteModify.sportoloId': id}]);
                    $state.go('athletes.athletesManagement.athleteModify.dataSheet');
                } else {
                    log.permissionError();
                }
            });
        }

        function openCoach(edzoId) {
            $q.all([authenticationService.getRight('MODFELH'), authenticationService.getRight('MEGTFELH')]).then(function (results) {
                if (results[0] || results[1]) {
                    paramHelper.setParams([{'newUser.userId': edzoId}]);
                    $state.go('settings.userManagement.modifyUser');
                } else {
                    log.permissionError();
                }
            });
        }

        function openTeam(id) {
            $q.all([authenticationService.getRight('MEGTCSOPORT')]).then(function (results) {
                if (results[0]) {
                    paramHelper.setParams([
                        {'teams.sectionId': '0'},
                        {'teams.ageGroupId': '0'},
                        {'teams.team': id}
                    ]);
                    $state.go('athletes.teams.teamMembersList');
                } else {
                    log.permissionError();
                }
            });
        }

        function openResultReportAthletes(id) {
            $q.all([authenticationService.getRight('MEGTEERJEL')]).then(function (results) {
                if (results[0]) {
                    paramHelper.setParams([{'resultReportAthletes.Id': id}]);
                    $state.go('administration.resultReportAthletes');
                } else {
                    log.permissionError();
                }
            });
        }

        function openResultReportTeam(id) {
            $q.all([authenticationService.getRight('MEGTCSERJEL')]).then(function (results) {
                if (results[0]) {
                    paramHelper.setParams([{'resultReportTeam.Id': id}]);
                    $state.go('administration.resultReportTeam');
                } else {
                    log.permissionError();
                }
            });
        }
    }
})();


(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.athletes.athletesManagement.athleteModify.raceResultsReport')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'athletes.athletesManagement.athleteModify.raceResultsReport',
                config: {
                    url: '/raceResultsReport',
                    templateUrl: 'app/athletes/athletesManagement/athleteModify/raceResultsReport/raceResultsReport.html',
                    controller: 'RaceResultsReport2Controller',
                    controllerAs: 'vm',
                    title: 'RaceResultsReport'
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    TrainingVisitReportController.$inject = ["log", "dataservice", "$q", "$rootScope", "gettextCatalog", "$scope", "paramHelper", "$state"];
    angular
        .module('app.athletes.athletesManagement.athleteModify.trainingVisitReport')
        .controller('TrainingVisitReportController', TrainingVisitReportController);

    function TrainingVisitReportController(log, dataservice, $q, $rootScope, gettextCatalog, $scope, paramHelper, $state) {
        var vm = this;
        $rootScope.vm = vm;

        //Évek (2010-től az aktuális évig)
        vm.years = [];
        for (var ev = 2010; ev <= new Date().getFullYear(); ev++) {
            vm.years.push(ev + ' / ' + (ev + 1));
        }
        //Kiválasztott év (alapból az aktuális)
        vm.selectedYear = new Date().getFullYear() + ' / ' + (new Date().getFullYear() + 1);
        vm.stackedHeaderRows = [];

        vm.sportoloId = undefined;
        vm.korcsoportId = undefined;
        vm.szakosztalyId = undefined;
        vm.columns = [];

        vm.columns = [
            {
                field: 'Sorszam',
                headerText: gettextCatalog.getString('RowNumber'),
                textAlign: 'center',
                width: 80,
                allowEditing: false
            }, {
                field: 'VersenyzoNeve',
                headerText: gettextCatalog.getString('Name'),
                textAlign: 'left',
                width: 250,
                template: '#AthleteColumnTemplate',
                allowEditing: false
            },
            {
                field: 'SzulEv',
                headerText: gettextCatalog.getString('BirthYear'),
                textAlign: 'center',
                width: 90,
                allowEditing: false
            },
            {
                headerText: gettextCatalog.getString('August'), columns:
                    [
                        {
                            field: 'AugEdzes',
                            headerText: gettextCatalog.getString('Sum'),
                            textAlign: 'center',
                            width: 80,
                            allowEditing: false
                        },
                        {
                            field: 'AugJelen',
                            headerText: gettextCatalog.getString('Attendance'),
                            textAlign: 'center',
                            width: 100,
                            allowEditing: false
                        },
                        {
                            field: 'AugHianyzik',
                            headerText: gettextCatalog.getString('Miss'),
                            textAlign: 'center',
                            width: 80,
                            allowEditing: false
                        },
                        {
                            field: 'AugSzazalek',
                            headerText: gettextCatalog.getString('AttendancePercent'),
                            textAlign: 'center',
                            width: 90,
                            allowEditing: false
                        }
                    ],
                textAlign: 'center'
            },
            {
                headerText: gettextCatalog.getString('September'), columns:
                    [
                        {
                            field: 'SzeptEdzes',
                            headerText: gettextCatalog.getString('Sum'),
                            textAlign: 'center',
                            width: 80,
                            allowEditing: false
                        },
                        {
                            field: 'SzeptJelen',
                            headerText: gettextCatalog.getString('Attendance'),
                            textAlign: 'center',
                            width: 100,
                            allowEditing: false
                        },
                        {
                            field: 'SzeptHianyzik',
                            headerText: gettextCatalog.getString('Miss'),
                            textAlign: 'center',
                            width: 80,
                            allowEditing: false
                        },
                        {
                            field: 'SzeptSzazalek',
                            headerText: gettextCatalog.getString('AttendancePercent'),
                            textAlign: 'center',
                            width: 90,
                            allowEditing: false
                        }
                    ],
                textAlign: 'center'
            },
            {
                headerText: gettextCatalog.getString('October'), columns:
                    [
                        {
                            field: 'OktEdzes',
                            headerText: gettextCatalog.getString('Sum'),
                            textAlign: 'center',
                            width: 80,
                            allowEditing: false
                        },
                        {
                            field: 'OktJelen',
                            headerText: gettextCatalog.getString('Attendance'),
                            textAlign: 'center',
                            width: 100,
                            allowEditing: false
                        },
                        {
                            field: 'OktHianyzik',
                            headerText: gettextCatalog.getString('Miss'),
                            textAlign: 'center',
                            width: 80,
                            allowEditing: false
                        },
                        {
                            field: 'OktSzazalek',
                            headerText: gettextCatalog.getString('AttendancePercent'),
                            textAlign: 'center',
                            width: 90,
                            allowEditing: false
                        }
                    ],
                textAlign: 'center'
            },
            {
                headerText: gettextCatalog.getString('November'), columns:
                    [
                        {
                            field: 'NovEdzes',
                            headerText: gettextCatalog.getString('Sum'),
                            textAlign: 'center',
                            width: 80,
                            allowEditing: false
                        },
                        {
                            field: 'NovJelen',
                            headerText: gettextCatalog.getString('Attendance'),
                            textAlign: 'center',
                            width: 100,
                            allowEditing: false
                        },
                        {
                            field: 'NovHianyzik',
                            headerText: gettextCatalog.getString('Miss'),
                            textAlign: 'center',
                            width: 80,
                            allowEditing: false
                        },
                        {
                            field: 'NovSzazalek',
                            headerText: gettextCatalog.getString('AttendancePercent'),
                            textAlign: 'center',
                            width: 90,
                            allowEditing: false
                        }
                    ],
                textAlign: 'center'
            },
            {
                headerText: gettextCatalog.getString('December'), columns:
                    [
                        {
                            field: 'DecEdzes',
                            headerText: gettextCatalog.getString('Sum'),
                            textAlign: 'center',
                            width: 80,
                            allowEditing: false
                        },
                        {
                            field: 'DecJelen',
                            headerText: gettextCatalog.getString('Attendance'),
                            textAlign: 'center',
                            width: 100,
                            allowEditing: false
                        },
                        {
                            field: 'DecHianyzik',
                            headerText: gettextCatalog.getString('Miss'),
                            textAlign: 'center',
                            width: 80,
                            allowEditing: false
                        },
                        {
                            field: 'DecSzazalek',
                            headerText: gettextCatalog.getString('AttendancePercent'),
                            textAlign: 'center',
                            width: 90,
                            allowEditing: false
                        }
                    ],
                textAlign: 'center'
            },
            {
                headerText: gettextCatalog.getString('January'), columns:
                    [
                        {
                            field: 'JanEdzes',
                            headerText: gettextCatalog.getString('Sum'),
                            textAlign: 'center',
                            width: 80,
                            allowEditing: false
                        },
                        {
                            field: 'JanJelen',
                            headerText: gettextCatalog.getString('Attendance'),
                            textAlign: 'center',
                            width: 100,
                            allowEditing: false
                        },
                        {
                            field: 'JanHianyzik',
                            headerText: gettextCatalog.getString('Miss'),
                            textAlign: 'center',
                            width: 80,
                            allowEditing: false
                        },
                        {
                            field: 'JanSzazalek',
                            headerText: gettextCatalog.getString('AttendancePercent'),
                            textAlign: 'center',
                            width: 90,
                            allowEditing: false
                        }
                    ],
                textAlign: 'center'
            },
            {
                headerText: gettextCatalog.getString('February'), columns:
                    [
                        {
                            field: 'FebEdzes',
                            headerText: gettextCatalog.getString('Sum'),
                            textAlign: 'center',
                            width: 80,
                            allowEditing: false
                        },
                        {
                            field: 'FebJelen',
                            headerText: gettextCatalog.getString('Attendance'),
                            textAlign: 'center',
                            width: 100,
                            allowEditing: false
                        },
                        {
                            field: 'FebHianyzik',
                            headerText: gettextCatalog.getString('Miss'),
                            textAlign: 'center',
                            width: 80,
                            allowEditing: false
                        },
                        {
                            field: 'FebSzazalek',
                            headerText: gettextCatalog.getString('AttendancePercent'),
                            textAlign: 'center',
                            width: 90,
                            allowEditing: false
                        }
                    ],
                textAlign: 'center'
            },
            {
                headerText: gettextCatalog.getString('March'), columns:
                    [
                        {
                            field: 'MarcEdzes',
                            headerText: gettextCatalog.getString('Sum'),
                            textAlign: 'center',
                            width: 80,
                            allowEditing: false
                        },
                        {
                            field: 'MarcJelen',
                            headerText: gettextCatalog.getString('Attendance'),
                            textAlign: 'center',
                            width: 100,
                            allowEditing: false
                        },
                        {
                            field: 'MarcHianyzik',
                            headerText: gettextCatalog.getString('Miss'),
                            textAlign: 'center',
                            width: 80,
                            allowEditing: false
                        },
                        {
                            field: 'MarcSzazalek',
                            headerText: gettextCatalog.getString('AttendancePercent'),
                            textAlign: 'center',
                            width: 90,
                            allowEditing: false
                        }
                    ],
                textAlign: 'center'
            },
            {
                headerText: gettextCatalog.getString('April'), columns:
                    [
                        {
                            field: 'AprEdzes',
                            headerText: gettextCatalog.getString('Sum'),
                            textAlign: 'center',
                            width: 80,
                            allowEditing: false
                        },
                        {
                            field: 'AprJelen',
                            headerText: gettextCatalog.getString('Attendance'),
                            textAlign: 'center',
                            width: 100,
                            allowEditing: false
                        },
                        {
                            field: 'AprHianyzik',
                            headerText: gettextCatalog.getString('Miss'),
                            textAlign: 'center',
                            width: 80,
                            allowEditing: false
                        },
                        {
                            field: 'AprSzazalek',
                            headerText: gettextCatalog.getString('AttendancePercent'),
                            textAlign: 'center',
                            width: 90,
                            allowEditing: false
                        }
                    ],
                textAlign: 'center'
            },
            {
                headerText: gettextCatalog.getString('May'), columns:
                    [
                        {
                            field: 'MajEdzes',
                            headerText: gettextCatalog.getString('Sum'),
                            textAlign: 'center',
                            width: 80,
                            allowEditing: false
                        },
                        {
                            field: 'MajJelen',
                            headerText: gettextCatalog.getString('Attendance'),
                            textAlign: 'center',
                            width: 100,
                            allowEditing: false
                        },
                        {
                            field: 'MajHianyzik',
                            headerText: gettextCatalog.getString('Miss'),
                            textAlign: 'center',
                            width: 80,
                            allowEditing: false
                        },
                        {
                            field: 'MajSzazalek',
                            headerText: gettextCatalog.getString('AttendancePercent'),
                            textAlign: 'center',
                            width: 90,
                            allowEditing: false
                        }
                    ],
                textAlign: 'center'
            },
            {
                headerText: gettextCatalog.getString('June'), columns:
                    [
                        {
                            field: 'JunEdzes',
                            headerText: gettextCatalog.getString('Sum'),
                            textAlign: 'center',
                            width: 80,
                            allowEditing: false
                        },
                        {
                            field: 'JunJelen',
                            headerText: gettextCatalog.getString('Attendance'),
                            textAlign: 'center',
                            width: 100,
                            allowEditing: false
                        },
                        {
                            field: 'JunHianyzik',
                            headerText: gettextCatalog.getString('Miss'),
                            textAlign: 'center',
                            width: 80,
                            allowEditing: false
                        },
                        {
                            field: 'JunSzazalek',
                            headerText: gettextCatalog.getString('AttendancePercent'),
                            textAlign: 'center',
                            width: 90,
                            allowEditing: false
                        }
                    ],
                textAlign: 'center'
            },
            {
                headerText: gettextCatalog.getString('July'), columns:
                    [
                        {
                            field: 'JulEdzes',
                            headerText: gettextCatalog.getString('Sum'),
                            textAlign: 'center',
                            width: 80,
                            allowEditing: false
                        },
                        {
                            field: 'JulJelen',
                            headerText: gettextCatalog.getString('Attendance'),
                            textAlign: 'center',
                            width: 100,
                            allowEditing: false
                        },
                        {
                            field: 'JulHianyzik',
                            headerText: gettextCatalog.getString('Miss'),
                            textAlign: 'center',
                            width: 80,
                            allowEditing: false
                        },
                        {
                            field: 'JulSzazalek',
                            headerText: gettextCatalog.getString('AttendancePercent'),
                            textAlign: 'center',
                            width: 90,
                            allowEditing: false
                        }
                    ],
                textAlign: 'center'
            },
            {
                headerText: gettextCatalog.getString('12month'), columns:
                    [
                        {
                            field: 'OsszEdzes',
                            headerText: gettextCatalog.getString('Sum'),
                            textAlign: 'center',
                            width: 80,
                            allowEditing: false
                        },
                        {
                            field: 'OsszJelen',
                            headerText: gettextCatalog.getString('Attendance'),
                            textAlign: 'center',
                            width: 100,
                            allowEditing: false
                        },
                        {
                            field: 'OsszJelen',
                            headerText: gettextCatalog.getString('Miss'),
                            textAlign: 'center',
                            width: 80,
                            allowEditing: false
                        },
                        {
                            field: 'OsszSzazalek',
                            headerText: gettextCatalog.getString('AttendancePercent'),
                            textAlign: 'center',
                            width: 90,
                            allowEditing: false
                        }
                    ],
                textAlign: 'center'
            }
        ];

        // Create variables

        // Public functions
        vm.reportSelect = reportSelect;
        vm.modifyAthletes = modifyAthletes;

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItemsWithSearch,
            allowPaging: true,
            allowTextWrap: true,
            allowSorting: true,
            allowExcelExport: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#Grid'), $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        // Activate page
        activate();

        function activate() {
            $q.all([paramHelper.getParams(['athleteModify.sportoloId', 'athleteModify.sportoloNev'], [])]).then(function (results) {
                vm.sportoloId = results[0]['athleteModify.sportoloId'];
                vm.sportoloNev = results[0]['athleteModify.sportoloNev'];
                $rootScope.title = vm.sportoloNev + ' - ' + gettextCatalog.getString('trainingVisitReport');
            });
        }

        function reportSelect() {
            dataservice.getTrainingVisitReport(vm.selectedYear.split('/')[0], vm.sportoloId)
                .then(function (data) {
                    grid.dataSource = data.itemsList;
                });
        }

        /**
         * Public modifyAthletes(SportolokId)
         */
        function modifyAthletes(VersenyzoId, SzakosztalyId, KorosztalyId) {
            console.log('Versenyzo: ', VersenyzoId, ', SzakosztalyId: ', SzakosztalyId);
            //if (vm.MODSPORTOLO || vm.MEGTSPORTLIST) { // check permission
            paramHelper.setParams([
                {'athleteList.selectedSectionId': SzakosztalyId},
                {'athleteList.selectedAgeGroupId': KorosztalyId},
                {'athleteModify.sportoloId': VersenyzoId}
            ]);
            $state.go('athletes.athletesManagement.athleteModify.dataSheet');
            /*} else {
                log.errorMsg(gettextCatalog.getString('PermissionDenied'));
            }*/
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.athletes.athletesManagement.athleteModify.trainingVisitReport')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'athletes.athletesManagement.athleteModify.trainingVisitReport',
                config: {
                    url: '/trainingVisitReport',
                    templateUrl: 'app/athletes/athletesManagement/athleteModify/trainingVisitReport/trainingVisitReport.html',
                    controller: 'TrainingVisitReportController',
                    controllerAs: 'vm',
                    title: 'TrainingVisitReport'
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    AthleteNewController.$inject = ["log", "dataservice", "$q", "DOMAIN", "$rootScope", "gettextCatalog", "paramHelper", "authenticationService", "$scope", "VIEW_DATA", "$state", "$timeout"];
    angular
        .module('app.athletes.athletesManagement.athleteNew')
        .controller('AthleteNewController', AthleteNewController);

    function AthleteNewController(log, dataservice, $q, DOMAIN, $rootScope, gettextCatalog, paramHelper, authenticationService, $scope, VIEW_DATA, $state, $timeout) {
        var vm = this;
        $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('AthleteNew');
        // Create variables
        // Default values
        vm.noImgUrl = DOMAIN.baseURL + DOMAIN.userImage; // default image
        vm.photoUrl = vm.noImgUrl; // User image

        // Opened fields in Accordion
        vm.selectedItems = [0, 1];
        //Not used at the moment vm.section = ''; // section (szakosztály)
        //not used at the moment vm.secondSection = ''; // Second section
        vm.thereIsSelectedAthlete = false;
        vm.noSelectedAthlete = true;

        vm.sexList = [{
            text: gettextCatalog.getString('Man'),
            value: 1
        },
            {
                text: gettextCatalog.getString('Woman'),
                value: 0
            }
        ];
        vm.fatherNames = [];
        vm.motherNames = [];
        getParentNames();
        //gettextCatalog.getString('RequiredFieldsError')
        vm.betterHandList = [{
            text: gettextCatalog.getString('Left'),
            value: 1
        },
            {
                text: gettextCatalog.getString('Right'),
                value: 2
            },
            {
                text: gettextCatalog.getString('Both'),
                value: 3
            }
        ];
        vm.betterFootList = [{
            text: gettextCatalog.getString('Left'),
            value: 1
        },
            {
                text: gettextCatalog.getString('Right'),
                value: 2
            },
            {
                text: gettextCatalog.getString('Both'),
                value: 3
            }
        ];
        vm.feeOfEducationList = [
            {text: gettextCatalog.getString('EducationFee'), value: 0},
            {text: gettextCatalog.getString('SportServiceFee'), value: 1}
        ];
        vm.countyList = VIEW_DATA.dropDownList.counties;
        vm.courseList = VIEW_DATA.dropDownList.course;
        vm.classList = VIEW_DATA.dropDownList.class;

        // If changed the fee of education, show that the date is correct or not
        vm.feeOfEducationDateOk = false;
        vm.ageGroupList = []; // recived age group list
        vm.secondAgeGroupList = [];
        vm.sectionList = []; // recived section list
        vm.secondSectionList = [];
        vm.selectedAgeGroupId = '';

        // Athlete parameters
        vm.selectedAgeGroupText = undefined; // selected age group name
        vm.athleteData = {
            Id: undefined,
            AdoSzam: undefined, // String
            Aktiv: undefined, // Boolean
            AktTestmagassag: undefined, // Int32?
            AktTestsuly: undefined, // Int32?
            Allampolgarsag: undefined, // String
            AnyjaLeanykoriNeve: undefined, // String
            AnyjaNeve: undefined, // String
            AnyjaTestmagassaga: undefined, // Int32?
            ApjaTestmagassaga: undefined, // Int32
            BefOktdij: undefined, // Decimal
            BefTagdij: undefined, // Decimal
            DSITagsagKezdete: undefined, // DateTime
            EddigiEdzoi: undefined, // String
            EddigiSpEgyesuletei: undefined, // String
            EdzesreJarasKezdete: undefined, // DateTime
            Egyenleg: undefined, // Decimal
            Elerhetoseg: undefined, // String
            EmailCim: undefined, // String
            EvzarasOsszege: undefined, // Decimal?
            FajiEredet: undefined, // String
            Fenykep: undefined, // Byte[]
            FenykepUt: undefined, // String
            fileData: null,
            FurdokopenyDb: undefined, // String
            FurdokopenyErtek: undefined, // String
            FurdokopenyMerete: undefined, // String
            GyermekkoriSport: undefined, // String
            IdSzakosztaly: undefined, // Int32
            IskolaEvfolyam: undefined, // String
            IskolaHazszam: undefined, // String
            IskolaIgazgatoNeve: undefined, // String
            IskolaIrSzam: undefined, // String
            IskolaNeve: undefined, // String
            IskolaOsztaly: undefined, // String
            IskolaUtca: undefined, // String
            IskolaVaros: undefined, // String
            JelenlegiEdzo: undefined, // int
            KabatDb: undefined, // String
            KabatErtek: undefined, // String
            KabatMerete: undefined, // String
            KilepesDatuma: undefined, // DateTime
            KilepesIndoka: undefined, // String
            Korcsoport: undefined, // Int32
            LakcimHazszam: undefined, // String
            LakcimIrSzam: undefined, // String
            LakcimMegye: undefined, // String
            LakcimUtca: undefined, // String
            LakcimVaros: undefined, // String
            LeanykoriNev: undefined, // String
            MasodlagosSzakosztalyId: undefined, // Int32?
            MasodlagosKorcsoport: undefined,
            MasodlagosSzakosztalyEdzoId: undefined,
            Megjegyzes: undefined, // String
            MelegitoDb: undefined, // String
            MelegitoErtek: undefined, // String
            MelegitoMerete: undefined, // String
            Neme: undefined, // String
            Nev: undefined, // String
            OsztalyFonokNeve: undefined, // String
            PancelNadragDb: undefined, // String
            PancelNadragErtek: undefined, // String
            PancelNadragMerete: undefined, // String
            UszoNadragMerete: undefined, // String
            PapucsDb: undefined, // String
            PapucsErtek: undefined, // String
            PapucsMerete: undefined, // String
            PoloDb: undefined, // String
            PoloErtek: undefined, // String
            PoloMerete: undefined, // String
            PubertasVege: undefined, // DateTime
            RegisztraciosSzam: undefined, // String
            SortDb: undefined, // String
            SortErtek: undefined, // String
            SortMerete: undefined, // String
            SportoloiMultAnya: undefined, // String
            SportoloiMultApa: undefined, // String
            SportolokID: undefined, // Int32
            SzakosztalyNev: undefined, // String
            SzemIgSzam: undefined, // String
            SzuletesiHelyOrszag: undefined,
            SzuletesiHelyVaros: undefined, // String
            SzuletesiIdo: undefined, // DateTime
            Szulo1Elerhetosege: undefined, // String
            Szulo2Elerhetosege: undefined, // String
            AnyjaFoglalkozasa: undefined, // String
            ApjaFoglalkozasa: undefined,
            SzuloNeve: undefined, // String
            SzunideiElfoglaltsag: undefined, // String
            Tagdijas: undefined, // Boolean
            TAJSzam: undefined, // String
            Testmagassag: undefined, // Int32?
            TestneveloElerhetosege: undefined, // String
            TestneveloNeve: undefined, // String
            Testsuly: undefined, // Int32?
            UgyesebbKez: undefined, // String
            UgyesebbLab: undefined, // String
            UtlevelSzam: undefined, // String
            UtolsoFrissites: undefined, // DateTime
            ValasztottSportagak: undefined, // String
            VersSportKezd: undefined, // DateTime
            VisszalepesDatuma: undefined, // DateTime?
            dddd: undefined,
            JatekEngedelySzama: undefined
        };

        vm.RUHA = {
            CIPO: false,
            PAPUCS: false,
            MELEGITO: false,
            FURDOKOPENY: false,
            KABAT: false,
            PANCELNADRAG: false,
            POLO: false,
            SORT: false,
            USZONADRAG: false
        };

        vm.athleteId = -1; // for sql quetion
        // This value show when start the new Fee of education mode
        vm.feeOfEducationDate = undefined;
        // Current coach name in text by Id
        vm.currentCoachNameInText = undefined;

        // Grid's details
        vm.schoolGridSelectedRowData = {};
        // Grid columnsSchool

        vm.columnsSchool = [
            {field: 'IskolaNeve', headerText: gettextCatalog.getString('SchoolName'), textAlign: 'left'},
            {field: 'IskolaIrSzam', headerText: gettextCatalog.getString('SchoolZipCode'), textAlign: 'left'},
            {field: 'IskolaVaros', headerText: gettextCatalog.getString('SchoolCity'), textAlign: 'left'},
            {field: 'IskolaUtca', headerText: gettextCatalog.getString('SchoolStreet'), textAlign: 'left'},
            {field: 'IskolaHazszam', headerText: gettextCatalog.getString('SchoolNumber'), textAlign: 'left'},
            {field: 'IskolaIgazgatoNeve', headerText: gettextCatalog.getString('SchoolDirectorName'), textAlign: 'left'}
        ];

        vm.visibleSchooSelectlGrid = false;

        // Grid columnsAthleteMoveStory
        vm.columnsAthleteMoveStory = [
            {field: 'EdzoNeve', headerText: gettextCatalog.getString('CoachName'), textAlign: 'left'},
            {field: 'KorcsoportNeve', headerText: gettextCatalog.getString('AgeGroup'), textAlign: 'left'},
            {field: 'DatumTol', headerText: gettextCatalog.getString('StartTime'), textAlign: 'left'},
            {field: 'DatumIg', headerText: gettextCatalog.getString('EndTime'), textAlign: 'left'},
            {field: 'Belepes', headerText: gettextCatalog.getString('Enter'), textAlign: 'left'},
            {field: 'Kilepes', headerText: gettextCatalog.getString('GoOut'), textAlign: 'left'}
        ];

        // Public functions
        // AthleteNew functions
        // Drop Down List function
        vm.sectionDataBound = sectionDataBound;
        vm.sectionSelect = sectionSelect;
        vm.getSections = getSections;

        vm.secondSectionDataBound = secondSectionDataBound;
        vm.secondSectionSelect = secondSectionSelect;
        vm.secondCoachSelect = secondCoachSelect;

        vm.coachDropDownListDataBound = coachDropDownListDataBound;
        vm.secondCoachDropDownListDataBound = secondCoachDropDownListDataBound;

        vm.ageGroupDataBound = ageGroupDataBound;
        vm.seconAgeGroupDataBound = secondAgeGroupDataBound;
        vm.ageGroupSelect = ageGroupSelect;
        vm.secondAgeGroupSelect = secondAgeGroupSelect;

        // Top menu buttons functions
        vm.goToAthleteResults = goToAthleteResults; // Public Athlete's results

        // Image cropper variables
        vm.deleteImg = deleteImg; // Public, delete the photo from user profile 999 Hofi

        vm.save = save;
        vm.cropper = {}; // Ricsi
        vm.cropper.sourceImage = null; // Ricsi
        vm.cropper.croppedImage = null; // Ricsi
        vm.bounds = {}; // Ricsi
        vm.bounds.left = 0; // Ricsi
        vm.bounds.right = 0; // Ricsi
        vm.bounds.top = 0; // Ricsi
        vm.bounds.bottom = 0; // Ricsi
        vm.cropDialogTitle = gettextCatalog.getString('ChooseImageTitle'); // Ricsi

        vm.openCropDialog = openCropDialog; // Ricsi
        vm.doneCropDialog = doneCropDialog; // Ricsi
        vm.closeCropDialog = closeCropDialog; // Ricsi
        // Change Age Group
        vm.changeAgeGroup = changeAgeGroup;
        // sex (gende) dropdown public function
        vm.sexSelect = sexSelect;
        // Height dropdown public function
        vm.changeHeight = changeHeight;
        // Weight dropdown public function
        vm.changeWeight = changeWeight;
        // better Hand dropdown public function
        vm.betterHandDataBound = betterHandDataBound;
        vm.betterHandSelect = betterHandSelect;
        // better Foot dropdown public function
        vm.betterFootSelect = betterFootSelect;
        vm.feeOfEducationBound = feeOfEducationBound;
        // Social security number required
        vm.socialSecurityNumberRequiredValue = false;
        vm.athleteRegistrationNumberRequiredValue = false;

        // select coach
        //vm.selectCoachBtn = selectCoachBtn;
        // Select Schools
        vm.selectSchools = selectSchools;
        // Public functions for grid databound
        vm.schoolList = [];
        // Grid selcted row
        vm.schoolGridSelectedRow = schoolGridSelectedRow;
        // Selected coach
        vm.coachSelect = coachSelect;
        vm.coachList = [];
        vm.secondCoachList = [];

        vm.clearSecondSection = clearSecondSection;
        vm.clearSecondAgeGroup = clearSecondAgeGroup;
        vm.clearSecondCoach = clearSecondCoach;

        // Active
        vm.activeChange = activeChange;

        // School Grid datasource initial
        vm.coachListGridData = [];

        vm.ADMIN = false;
        vm.TORLCSOPORT = false;
        vm.MODCSOPORT = false;

        vm.tajkeres = true;

        vm.gymTeacherDatasource = [];
        vm.classMasterDatasource = [];
        vm.schoolNameChanged = schoolNameChanged;
        vm.generateRegNum = generateRegNum;

        vm.generateAvatar = generateAvatar;

        var grid = new ej2.grids.Grid({
            dataSource: [],
            allowPaging: true,
            allowTextWrap: true,
            allowSorting: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columnsSchool,
            rowSelected: schoolGridSelectedRow,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#Grid'), $scope);
                }
            }
        });
        grid.appendTo('#Grid');

        // Activate page
        activate();
        $scope.$on('$viewContentLoaded', function () {
            // Set checkbox
            angular.element('#active').ejCheckBox({checked: true});
        });

        function activate() {
            // need paramHelper params (e.g. athleteId)
            $q.all([paramHelper.getParams([], ['athleteNew.sportolokId', 'athleteNew.ageGroupList', 'athleteNew.selectedSectionId', 'athleteNew.selectedSectionName', 'athleteNew.selectedAgeGroupName', 'athleteNew.selectedAgeGroupId', 'athleteNew.sectionList']), authenticationService.getRight('ADMIN'), authenticationService.getRight('TORLCSOPORT'), authenticationService.getRight('MODCSOPORT'), getSystemSettings('TAJKOTELEZO'), getSystemSettings('SNYSZKOTELEZO'), getSystemSettings('SPORTMINKOTELEZO'), getSystemSettings('NINCSOKTDIJ')]).then(function (results) {
                vm.ADMIN = results[1];
                vm.TORLCSOPORT = results[2];
                vm.MODCSOPORT = results[3];
                vm.NINCSOKTDIJ = results[7];
                if (vm.NINCSOKTDIJ) {
                    vm.feeOfEducationList = [
                        {text: gettextCatalog.getString('SportServiceFee'), value: 1}
                    ];
                }
                vm.athleteId = results[0]['athleteNew.sportolokId'];
                vm.athleteData.IdSzakosztaly = results[0]['athleteNew.selectedSectionId'];
                vm.athleteData.SzakosztalyNev = results[0]['athleteNew.selectedSectionName'];
                vm.athleteData.Korcsoport = results[0]['athleteNew.selectedAgeGroupId'];
                vm.selectedAgeGroupText = results[0]['athleteNew.selectedAgeGroupName'];
                vm.athleteData.KorcsoportName = results[0]['athleteNew.selectedAgeGroupName'];

                vm.photoUrl = DOMAIN.baseURL + DOMAIN.userImage; // User image
                vm.displayPhoto = DOMAIN.baseURL + DOMAIN.userImage;
                vm.athleteData.Aktiv = true;

                // Get Coach list for dropDown
                vm.socialSecurityNumberRequiredValue = results[4];
                vm.athleteRegistrationNumberRequiredValue = results[5];
                vm.athleteRequiredMinimumDatas = results[6];

                RefreshClothes();
                // This functions runs after thel all datas arrived
                // Get section list
                getSecondSections();
                // set feeOfEducation dropDownList selected value
                feeOfEducationSetSelectedValue();
                // get schools
                //selectSchools();
                $timeout(function () {
                    var t = {
                        text: results[0]['athleteNew.selectedSectionName'],
                        value: results[0]['athleteNew.selectedSectionId']
                    };
                    vm.sectionList = results[0]['athleteNew.sectionList'];

                    vm.ageGroupList = results[0]['athleteNew.ageGroupList'];

                    if (vm.ageGroupList != null && vm.ageGroupList.length > 0 && vm.ageGroupList[0].value === 0) {
                        vm.ageGroupList.splice(0, 1);
                    }
                    $scope.$apply();
                }, 0);
            });
        }

        function generateAvatar(nem) {
            var ava = 'ath_' + nem + '_' + Math.ceil(Math.random() * (8 - 1) + 1) + '.png';
            if (ava == vm.photoUrl) {
                generateAvatar(nem);
            }
            return ava;
        }

        function RefreshClothes() {
            $timeout(function () {
                dataservice.SzakosztalyRuhai(vm.athleteData.IdSzakosztaly, vm.athleteData.MasodlagosSzakosztaly).then(function (ruhaResponse) {
                    vm.RUHA = ruhaResponse.data;
                });
            }, 100);
        }

        function saveAnyway() {
            var value = $('#feeOfEducation').ejDropDownList('getSelectedValue');
            switch (value) {
                case 0:
                case '0':
                    vm.athleteData.Tagdijas = false; // Oktatási díjas
                    break;
                case 1:
                case '1':
                default:
                    vm.athleteData.Tagdijas = true;
                    break;
            }
            vm.athleteData.TAJSzam = angular.element('#socialSecurityNumber').ejMaskEdit('get_StrippedValue');

            // kép küldése, ha választott
            vm.athleteData.FenykepUt = vm.photoUrl;
            if (angular.element('#fileName').val() !== '' && vm.cropper.croppedImage !== null) {
                vm.athleteData.FenykepUt = angular.element('#fileName').val();
                vm.athleteData.Fenykep = vm.cropper.croppedImage;
            }

            if (vm.photoUrl === vm.noImg) {
                vm.athleteData.fileName = 'avatar_2x.png';
                vm.athleteData.Fenykep = null;
            }
            var dsiTime = new Date(vm.athleteData.DSITagsagKezdete);

            if (dsiTime.getTime() > new Date()) {
                swal({
                    title: gettextCatalog.getString('DateError'),
                    text: gettextCatalog.getString('TheMemberOfDSIDateLateThenNow'),
                    type: 'warning',
                    confirmButtonText: gettextCatalog.getString('Ok')
                });
            } else {
                if (vm.athleteData.MasodlagosSzakosztaly > 0) {
                    if (vm.athleteData.MasodlagosKorcsoport > 0) {
                        if (!(vm.athleteData.MasodlagosSzakosztalyEdzoId > 0)) {
                            log.errorMsg(gettextCatalog.getString('SecondSectionDetailsAreNotComplete'));
                            return;
                        }
                    } else {
                        log.errorMsg(gettextCatalog.getString('SecondSectionDetailsAreNotComplete'));
                        return;
                    }
                }
                dataservice.saveNewAthlete(vm.athleteData)
                    .then(
                        function () {
                            swal({
                                title: gettextCatalog.getString('SaveAthlete'),
                                text: gettextCatalog.getString('SaveAthleteSuccess'),
                                type: 'success',
                                confirmButtonColor: '#DD6B55',
                                confirmButtonText: gettextCatalog.getString('OK'),
                                closeOnConfirm: false,
                                allowOutsideClick: false
                            }).then(
                                function () {
                                    paramHelper.setParams([
                                        {'athleteList.selectedSectionId': vm.athleteData.IdSzakosztaly},
                                        {'athleteList.selectedAgeGroupId': vm.athleteData.Korcsoport},
                                        {'athleteList.inactiveTeams': false}
                                    ]);
                                    $state.go('athletes.athletesManagement.athletesList');
                                });
                        });
            }
        }

        function save() {
            // a syncfusion direktívák miatt
            $scope.$broadcast('submitted');
            if ($scope.form.$valid === false) {
                log.errorMsg(gettextCatalog.getString('RequiredFieldsError'));
                angular.element('#accordion').ejAccordion('expandAll');
            } else {
                dataservice.SimilarAthleteExist({
                    nev: vm.athleteData.Nev,
                    datum: vm.athleteData.SzuletesiIdo
                }).then(function (response) {
                    if (response.retValue) {
                        swal({
                            title: gettextCatalog.getString('SimilarAthlete'),
                            text: gettextCatalog.getString('WeFoundASimilarAthleteContinueText'),
                            type: 'warning',
                            showCancelButton: true,
                            confirmButtonText: gettextCatalog.getString('Yes'),
                            cancelButtonText: gettextCatalog.getString('No')
                        }).then(function (isConfirm) {
                            if (isConfirm.value) {
                                saveAnyway();
                            }
                        });
                    } else {
                        saveAnyway();
                    }
                });
            }
        }

        function generateRegNum() {
            dataservice.GenerateRegNum().then(function (data) {
                vm.athleteData.RegisztraciosSzam = data.data;
            });
        }

        function openCropDialog() {
            angular.element('#dialogContainer').css('visibility', 'visible');
            angular.element('#cropDialog').ejDialog('open');
        }

        function closeCropDialog() {
            angular.element('#dialogContainer').css('visibility', 'hidden');
            angular.element('#cropDialog').ejDialog('close');
        }

        function doneCropDialog() {
            vm.photoUrl = vm.cropper.croppedImage;
            vm.displayPhoto = vm.photoUrl;
            angular.element('#cropDialog').ejDialog('close');
        }

        function deleteImg() {
            swal({
                title: gettextCatalog.getString('DeleteProfileImg'),
                text: gettextCatalog.getString('AreYouSureYouWantToDeleteTheProfileImg'),
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: gettextCatalog.getString('Yes'),
                cancelButtonText: gettextCatalog.getString('No')
            }).then(function (isConfirm) {
                if (isConfirm.value) {
                    angular.element('#fileName').val('');
                    if (vm.athleteData.FerfiB != null) {
                        var nem = vm.athleteData.FerfiB ? 'male' : 'female';
                        vm.cropper.sourceImage = null;
                        vm.photoUrl = generateAvatar(nem);
                        vm.displayPhoto = DOMAIN.baseURL + DOMAIN.profileImgBaseUrl + vm.photoUrl;
                    } else {
                        vm.cropper.sourceImage = null;
                        vm.photoUrl = vm.noImgUrl;
                        vm.displayPhoto = vm.photoUrl;
                    }
                    $scope.$apply();
                }
            });
        }

        function getSections() {
            dataservice.sectionDropDownList(vm.athleteData.JelenlegiEdzo)
                .then(function (data) {
                    vm.sectionList = data.itemsList;
                });
            getAgeGroups();
        }

        function sectionDataBound() {
            if (vm.sectionList.length === 1) {
                angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.sectionList[0].value);
            } else {
                angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.athleteData.IdSzakosztaly);
            }
        }

        function sectionSelect(args) {
            vm.athleteData.IdSzakosztaly = args.value;
            getAgeGroups();
        }

        function getSecondSections() {
            dataservice.sectionDropDownList(0)
                .then(function (data) {
                    // itt ki kell venni a listából az elsődleges section-t (vm.athleteData.IdSzakosztaly)
                    // for (var i = 0; i < data.itemsList.length; i++) {
                    //     if ((data.itemsList[i].value + '') === vm.athleteData.IdSzakosztaly) {
                    //         data.itemsList.splice(i, 1);
                    //     }
                    // }
                    vm.secondSectionList = data.itemsList;
                });
        }

        function secondSectionDataBound() {
            if (vm.sectionList.length === 1) {
                angular.element('#secondSectionDropDown').ejDropDownList('selectItemByValue', vm.sectionList[0].value);
            } else {
                angular.element('#secondSectionDropDown').ejDropDownList('selectItemByValue', vm.athleteData.MasodlagosSzakosztaly);
            }
        }

        function secondSectionSelect(selectedSection) {
            if (selectedSection.value > -1) {
                vm.athleteData.MasodlagosSzakosztalyId = selectedSection.value;
                getSecondAgeGroups();
                RefreshClothes();
            } else {
                vm.athleteData.MasodlagosSzakosztalyId = undefined;
                vm.athleteData.MasodlagosKorcsoport = undefined; // clear list until not selected agegroup
                vm.athleteData.MasodlagosSzakosztalyEdzoId = undefined; // clear list until not selected agegroup
                vm.secondAgeGroupList = [];
                vm.secondCoachList = []; // clear list until not selected agegroup
            }
        }

        function getSecondAgeGroups() {
            dataservice.ageGroupDropDownList(vm.athleteData.MasodlagosSzakosztalyId)
                .then(function (data) {
                    vm.secondAgeGroupList = data.itemsList;
                });
        }

        function secondAgeGroupDataBound() {
            if (vm.secondAgeGroupList.length === 1) {
                angular.element('#secondAgeGroupDropDown').ejDropDownList('selectItemByValue', vm.secondAgeGroupList[0].value);
            } else {
                angular.element('#secondAgeGroupDropDown').ejDropDownList('selectItemByValue', vm.athleteData.MasodlagosKorcsoport);
            }
        }

        function secondAgeGroupSelect(args) {
            if (args.value > -1) {
                vm.athleteData.MasodlagosKorcsoport = args.value;
                getSecondCoachesList();
            } else {
                vm.athleteData.MasodlagosKorcsoport = undefined, // clear list until not selected agegroup
                    vm.athleteData.MasodlagosSzakosztalyEdzoId = undefined, // clear list until not selected agegroup
                    vm.secondCoachList = []; // clear list until not selected agegroup
            }
        }

        function getSecondCoachesList() {
            return dataservice.coachDropDownList(vm.athleteData.MasodlagosSzakosztaly, vm.athleteData.MasodlagosKorcsoport) // Kell a section id (szakosztály)
                .then(function (data) {
                    vm.secondCoachList = data.itemsList;
                });
        }

        function secondCoachDropDownListDataBound() {
            if (vm.coachList.length === 1) {
                angular.element('#secondCoachName').ejDropDownList('selectItemByValue', vm.coachList[0].value);
                //vm.selectedCoach = vm.coachList[0].value;
                vm.athleteData.MasodlagosSzakosztalyEdzoId = vm.coachList[0].value;
            } else {
                angular.element('#secondCoachName').ejDropDownList('selectItemByValue', vm.athleteData.JelenlegiEdzo);
            }
        }

        function secondCoachSelect(args) {
            //vm.selectedCoach = args.value;
            if (args.value > -1) {
                vm.athleteData.MasodlagosSzakosztalyEdzoId = args.value;
            } else {
                vm.athleteData.MasodlagosSzakosztalyEdzoId = undefined; // clear list until not selected agegroup
            }
        }

        function changeAgeGroup() {
            paramHelper.setParams([{'ageGroupChange.athleteData': vm.athleteData}]);
            $state.go('settings.ageGroupChange');
        }

        function getAgeGroups() {
            dataservice.ageGroupDropDownList(vm.athleteData.IdSzakosztaly)
                .then(function (data) {
                    vm.ageGroupList = data.itemsList;
                    //getActualCoachesList();
                    // itt kérjük le az edzőt
                });
        }

        function ageGroupDataBound() {
            if (vm.ageGroupList.length === 1) {
                angular.element('#ageGroupDropDown').ejDropDownList('selectItemByValue', vm.ageGroupList[0].value);
            } else {
                angular.element('#ageGroupDropDown').ejDropDownList('selectItemByValue', vm.athleteData.Korcsoport);
            }
        }

        function ageGroupSelect(args) {
            vm.athleteData.Korcsoport = args.value;
            getActualCoachesList();
        }

        function getActualCoachesList() {
            return dataservice.coachDropDownList(vm.athleteData.IdSzakosztaly, vm.athleteData.Korcsoport) // Kell a section id (szakosztály)
                .then(function (data) {
                    vm.coachList = data.itemsList;
                });
        }

        function coachDropDownListDataBound() {
            if (vm.coachList.length === 1) {
                angular.element('#coachName').ejDropDownList('selectItemByValue', vm.coachList[0].value);
                //vm.selectedCoach = vm.coachList[0].value;
                vm.athleteData.JelenlegiEdzo = vm.coachList[0].value;
            } else {
                angular.element('#coachName').ejDropDownList('selectItemByValue', vm.athleteData.JelenlegiEdzo);
            }
        }

        function coachSelect(args) {
            vm.athleteData.JelenlegiEdzo = args.value;
        }

        function sexSelect(arg) {
            //vm.sexNum
            if (vm.cropper.sourceImage == null || vm.photoUrl == vm.noImgUrl) {
                var nem = arg.value ? 'male' : 'female';
                vm.photoUrl = generateAvatar(nem);
                vm.displayPhoto = DOMAIN.baseURL + DOMAIN.profileImgBaseUrl + vm.photoUrl;
            }
            vm.athleteData.FerfiB = arg.value === 1;
        }

        function changeHeight(args) {
            vm.athleteData.Testmagassag = args.value;
        }

        function changeWeight(args) {
            vm.athleteData.Testsuly = args.value;
        }

        function betterHandDataBound() {
            angular.element('#betterHandDropDown').ejDropDownList('selectItemByText', vm.athleteData.UgyesebbKez);
        }

        function betterHandSelect(arg) {
            vm.athleteData.UgyesebbKezT = arg.value;
            vm.athleteData.UgyesebbKez = arg.selectedText;
        }

        function betterFootSelect(arg) {
            vm.athleteData.UgyesebbLabT = arg.value;
            vm.athleteData.UgyesebbLab = arg.selectedText;
        }

        function feeOfEducationBound() {
            angular.element('#feeOfEducation').ejDropDownList('selectItemByValue', 1);
        }

        function feeOfEducationSetSelectedValue() {
            angular.element('#feeOfEducation').ejDropDownList('selectItemByValue', 'Sportszolgáltatási díjas');
        }

        function selectSchools() {
            if (vm.visibleSchooSelectlGrid) {
                angular.element('#hidedContent').css('height', '0px');
            } else {
                dataservice.selectSchools()
                    .then(function (data) {
                        // swal dropdownList select shool and fill fields with datas
                        angular.element('#hidedContent').css('height', '100%');
                        grid.dataSource = data.itemsList;
                    });
            }
            vm.visibleSchooSelectlGrid = !vm.visibleSchooSelectlGrid;
        }

        function schoolGridSelectedRow(args) {
            // Ha megvan a kiválasztott sor, el kell tüntetni a Gridet
            vm.schoolGridSelectedRowData = args.data;
            vm.athleteData.IskolaEvfolyam = vm.schoolGridSelectedRowData.IskolaEvfolyam; // String
            vm.athleteData.IskolaNeve = vm.schoolGridSelectedRowData.IskolaNeve; // String
            vm.athleteData.IskolaIrSzam = vm.schoolGridSelectedRowData.IskolaIrSzam; // String
            vm.athleteData.IskolaIrSzam = vm.schoolGridSelectedRowData.IskolaIrSzam; // String
            vm.athleteData.IskolaVaros = vm.schoolGridSelectedRowData.IskolaVaros; // String
            vm.athleteData.IskolaUtca = vm.schoolGridSelectedRowData.IskolaUtca; // String
            vm.athleteData.IskolaHazszam = vm.schoolGridSelectedRowData.IskolaHazszam; // String
            vm.athleteData.IskolaOsztaly = vm.schoolGridSelectedRowData.IskolaOsztaly; // String
            vm.athleteData.IskolaIgazgatoNeve = vm.schoolGridSelectedRowData.IskolaIgazgatoNeve; // String
            $scope.$apply();
            // swal dropdownList select shool and fill fields with datas
            angular.element('#hidedContent').css('height', '0px');
            vm.visibleSchooSelectlGrid = !vm.visibleSchooSelectlGrid;
        }

        function activeChange(args) {
            vm.athleteData.Aktiv = args.value;
        }

        function goToAthleteResults() {
            var coachItem = angular.element('#coachName').data('ejDropDownList').getSelectedItem()[0];
            if (angular.isDefined(coachItem)) {
                vm.athleteData.EdzoNev = angular.element('#coachName').data('ejDropDownList').getSelectedItem()[0].innerText;
            } else {
                vm.athleteData.EdzoNev = '';
            }
            vm.athleteData.KorcsoportNev = vm.selectedAgeGroupText;
            paramHelper.setParams([{'raceResultsReport.athleteData': vm.athleteData}]);
            $state.go('reports.raceResultsReport');
        }

        function getSystemSettings(arg) {
            return dataservice.getSystemSettings(arg).then(function (response) {
                return response.retValue;
            });
        }

        function clearSecondSection() {
            vm.athleteData.MasodlagosSzakosztaly = undefined;
            vm.athleteData.MasodlagosKorcsoport = undefined;
            vm.secondAgeGroupList = [];
            vm.athleteData.MasodlagosSzakosztalyEdzoNev = undefined;
            vm.secondCoachList = [];
            $('#secondSectionDropDown').ejDropDownList('clearText');
        }

        function clearSecondAgeGroup() {
            vm.athleteData.MasodlagosKorcsoport = undefined;
            vm.athleteData.MasodlagosSzakosztalyEdzoNev = undefined;
            vm.secondCoachList = [];
            $('#secondAgeGroupDropDown').ejDropDownList('clearText');
        }

        function clearSecondCoach() {
            vm.athleteData.MasodlagosSzakosztalyEdzoNev = undefined;
            $('#secondCoachNameDropDown').ejDropDownList('clearText');
        }

        vm.emptyResultText = gettextCatalog.getString('emptyResultText');

        function schoolNameChanged() {
            if (vm.athleteData.IskolaNeve && vm.athleteData.IskolaNeve.length > 0) {
                dataservice.getGymTeachers(vm.athleteData.IskolaNeve).then(function (data) {
                    vm.gymTeacherDatasource = data.itemsList;
                });
                dataservice.getClassMasters(vm.athleteData.IskolaNeve).then(function (data) {
                    vm.classMasterDatasource = data.itemsList;
                });
            } else {
                vm.gymTeacherDatasource = [];
                vm.classMasterDatasource = [];
            }
        }

        vm.selectOf = selectOf;

        function selectOf(arg) {
            for (var i = 0; i < vm.classMasterDatasource.length; i++) {
                if (arg.value == vm.classMasterDatasource[i].value) {
                    dataservice.getClassMasterContact(arg.value).then(function (data) {
                        if (data.data.tel) {
                            vm.athleteData.OfTel = data.data.tel;
                        }
                        if (data.data.email) {
                            vm.athleteData.OfEmail = data.data.email;
                        }
                    });
                }
            }
        }

        vm.selectTesiTanar = selectTesiTanar;

        function selectTesiTanar(arg) {
            for (var i = 0; i < vm.gymTeacherDatasource.length; i++) {
                if (arg.value == vm.gymTeacherDatasource[i].value) {
                    dataservice.getGymTeacherContact(arg.value).then(function (data) {
                        if (data.data.tel) {
                            vm.athleteData.TestneveloElerhetosege = data.data.tel;
                        }
                        if (data.data.email) {
                            vm.athleteData.TestneveloEmail = data.data.email;
                        }
                    });
                }
            }
        }

        function getParentNames() {
            dataservice.getParentNames().then(function (data) {
                for (var i = 0; i < data.data.father.length; i++) {
                    vm.fatherNames.push({value: data.data.father[i], text: data.data.father[i]});
                }
                for (var i = 0; i < data.data.mother.length; i++) {
                    vm.motherNames.push({value: data.data.mother[i], text: data.data.mother[i]});
                }
            });
        }

        vm.selectMother = selectMother;

        function selectMother(arg) {
            if (arg && arg.value.length > 0) {
                vm.athleteData.Szulo1Elerhetosege = '';
                vm.athleteData.AnyaEmail = '';
                vm.athleteData.AnyjaTestmagassaga = '';
                vm.athleteData.AnyjaFoglalkozasa = '';
                vm.athleteData.AnyaMunkahely = '';
                vm.athleteData.SportoloiMultAnya = '';
                var idx = arg.value.indexOf('(');
                if (idx != -1) {
                    getParentData('mother', arg.value);
                    vm.athleteData.AnyjaNeve = arg.value.substring(0, idx - 1);
                }
            }
        }

        vm.selectFather = selectFather;

        function selectFather(arg) {
            if (arg && arg.value.length > 0) {
                vm.athleteData.Szulo2Elerhetosege = '';
                vm.athleteData.ApaEmail = '';
                vm.athleteData.ApjaTestmagassaga = '';
                vm.athleteData.ApjaFoglalkozasa = '';
                vm.athleteData.ApaMunkahely = '';
                vm.athleteData.SportoloiMultApa = '';
                var idx = arg.value.indexOf('(');
                if (idx != -1) {
                    getParentData('father', arg.value);
                    vm.athleteData.SzuloNeve = arg.value.substring(0, idx - 1);
                }
            }
        }

        function getParentData(parent, arg) {
            dataservice.getParentDataPOST(parent, arg).then(function (data) {
                if (parent == 'father') {
                    if (data.data) {
                        if (data.data.tel && data.data.tel.length > 0) {
                            vm.athleteData.Szulo2Elerhetosege = data.data.tel;
                        }
                        if (data.data.email && data.data.email.length > 0) {
                            vm.athleteData.ApaEmail = data.data.email;
                        }
                        if (data.data.height && data.data.height.length > 0) {
                            vm.athleteData.ApjaTestmagassaga = data.data.height;
                        }
                        if (data.data.job && data.data.job.length > 0) {
                            vm.athleteData.ApjaFoglalkozasa = data.data.job;
                        }
                        if (data.data.workplace && data.data.workplace.length > 0) {
                            vm.athleteData.ApaMunkahely = data.data.workplace;
                        }
                        if (data.data.sportpast && data.data.sportpast.length > 0) {
                            vm.athleteData.SportoloiMultApa = data.data.sportpast;
                        }
                    }
                } else if (parent == 'mother') {
                    if (data.data) {
                        if (data.data.tel && data.data.tel.length > 0) {
                            vm.athleteData.Szulo1Elerhetosege = data.data.tel;
                        }
                        if (data.data.email && data.data.email.length > 0) {
                            vm.athleteData.AnyaEmail = data.data.email;
                        }
                        if (data.data.height && data.data.height.length > 0) {
                            vm.athleteData.AnyjaTestmagassaga = data.data.height;
                        }
                        if (data.data.job && data.data.job.length > 0) {
                            vm.athleteData.AnyjaFoglalkozasa = data.data.job;
                        }
                        if (data.data.workplace && data.data.workplace.length > 0) {
                            vm.athleteData.AnyaMunkahely = data.data.workplace;
                        }
                        if (data.data.sportpast && data.data.sportpast.length > 0) {
                            vm.athleteData.SportoloiMultAnya = data.data.sportpast;
                        }
                    }
                }
            });
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.athletes.athletesManagement.athleteNew')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'athletes.athletesManagement.athleteNew',
                config: {
                    url: '/athleteNew',
                    templateUrl: 'app/athletes/athletesManagement/athleteNew/athleteNew.html',
                    controller: 'AthleteNewController',
                    controllerAs: 'vm',
                    title: 'AthleteNew',
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    athletesListController.$inject = ["log", "dataservice", "$q", "$state", "gettextCatalog", "$scope", "paramHelper", "authenticationService", "$filter", "$rootScope", "$timeout"];
    angular
        .module('app.athletes.athletesManagement.athletesList')
        .controller('AthletesListController', athletesListController);

    function athletesListController(log, dataservice, $q, $state, gettextCatalog, $scope, paramHelper, authenticationService, $filter, $rootScope, $timeout) {
        let vm = this;
        $rootScope.vm = vm; // jshint ignore: line
        this.params = []; // for parameters sending

        $rootScope.title = gettextCatalog.getString('AthletesList');

        // Permissions
        this.MEGTSPORTLIST = false;
        this.MEGTCSOPORT = false;
        this.MEGTKOROSZT = false;
        this.MODSPORTOLO = false;
        this.UJSPORTOLO = false;
        this.MEGTSPORTLIST = false;
        this.SPORTKILEP = false;
        this.MODFELH = false;
        this.KMVERSEREDM = false;
        this.athleteResultsBtnEnabled = false;
        // Dropdownlist's sources
        this.sectionList = [];
        this.ageGroupList = [];
        this.athleteList = [];
        // Dropdown values
        this.selectedSectionId = '';
        this.selectedAgeGroupId = '';
        this.selectedAgeGroupName = '';
        this.sportoliId = -1;
        // Checkbox variables
        this.checkboxEnabled = false;
        // Grid's details
        this.selectedAthleteExitDate = '';
        this.exitAthleteDateOk = false;
        this.selectedExitDate = undefined;
        this.athleteCompetitionResult = false;
        // Grid columns
        this.columns = [
            {type: 'checkbox', textAlign: 'center', width: 35},
            {
                field: 'Nev',
                headerText: gettextCatalog.getString('Athletes'),
                textAlign: 'left',
                template: '#templateDataRow1',
                width: 150
            },
            {field: 'SzuletesiIdo', headerText: gettextCatalog.getString('BirthDate'), textAlign: 'left', width: 100},
            {field: 'KorcsoportNeve', headerText: gettextCatalog.getString('AgeGroup'), textAlign: 'left', width: 100},
            {
                field: 'EdzoNeve',
                headerText: gettextCatalog.getString('Coach'),
                textAlign: 'left',
                template: '#templateDataRow2',
                width: 150
            },
            {
                field: 'Tagdij',
                headerText: gettextCatalog.getString('PayedSportServiceFee'),
                textAlign: 'left',
                width: 100
            },
            {
                field: 'Oktatasidij',
                headerText: gettextCatalog.getString('PayedEducationalFee'),
                textAlign: 'left',
                width: 100
            },
            {field: 'Egyenleg', headerText: gettextCatalog.getString('Balance'), textAlign: 'left', width: 100}
        ];

        let grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItemsWithSearch,
            allowPaging: true,
            allowTextWrap: true,
            allowSorting: true,
            allowExcelExport: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: this.columns,
            rowDataBound: (args) => {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: (args) => {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#Grid'), $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = (args) => {
            $rootScope.toolbarClick(args, grid);
        };

        let activate = () => {
            if (!authenticationService.isAuthenticated()) {
                $rootScope.login();
                return;
            }
            Promise.all([paramHelper.getParams([],
                [
                    'athleteList.selectedSectionId',
                    'athleteList.selectedAgeGroupId',
                    'athleteList.inactiveAthletes'
                ]),
                authenticationService.getRight('MEGTSPORTLIST'),
                authenticationService.getRight('MEGTCSOPORT'),
                authenticationService.getRight('MEGTKOROSZT'),
                authenticationService.getRight('MODSPORTOLO'),
                authenticationService.getRight('UJSPORTOLO'),
                authenticationService.getRight('SPORTKILEP'),
                authenticationService.getRight('MODFELH'),
                authenticationService.getRight('KMVERSEREDM')
            ]).then((results) => {
                // Nem épül fel a DOM Three, mire érték adódik
                $timeout(() => {
                    this.MEGTSPORTLIST = results[1];
                    this.MEGTCSOPORT = results[2];
                    this.MEGTKOROSZT = results[3];
                    this.MODSPORTOLO = results[4];
                    this.UJSPORTOLO = results[5];
                    this.SPORTKILEP = results[6];
                    this.MODFELH = results[7];
                    this.KMVERSEREDM = results[8];

                    if (!(this.MEGTSPORTLIST)) {
                        log.permissionError(true);
                        return;
                    }

                    // set selected values for dropDownLists
                    this.params.sectionId = results[0]['athleteList.selectedSectionId'];
                    this.params.selectedAgeGroupId = results[0]['athleteList.selectedAgeGroupId'];
                    // set selected values for checkBox
                    this.params.inactiveAthletes = results[0]['athleteList.inactiveAthletes'];
                    // Permission for delete
                    this.TORLCSOPORT = results[1];
                    // Permission for modify
                    this.MODCSOPORT = results[2];
                    // Set params for checkBox
                    // if (!this.params.inactiveAthletes) {
                    // this.inactiveAthletes = false;
                    // } else {
                    // this.inactiveAthletes = true;
                    // }
                    angular.element('#active').ejCheckBox({checked: this.params.inactiveAthletes});
                    // Get section list
                    getSections();
                }, 0);
            });
        };

        let getSections = () => {
            dataservice.sectionDropDownList(0)
                .then((data) => {
                    this.sectionList = data.itemsList;
                });
        };

        this.sectionDataBound = () => {
            this.selectedSectionId = this.sectionList.length === 1 ? this.sectionList[0].value : this.params.sectionId;
        };

        this.sectionSelect = (args) => {
            this.selectedSectionId = args.value;
            this.checkboxEnabled = true;
            if (angular.isUndefined(this.params.ageGroupId)) {
                //getTeams();
                getAthletes();
            }
            getAgeGroups();
            paramHelper.setParams([{'athleteList.selectedSectionId': this.selectedSectionId}]);
        };

        let getAgeGroups = () => {
            dataservice.ageGroupDropDownList(this.selectedSectionId)
                .then((data) => {
                    if (data.itemsList.length > 1) {
                        data.itemsList.unshift({value: 0, text: gettextCatalog.getString('All')});
                    }
                    this.ageGroupList = data.itemsList;
                    if (this.ageGroupList.length == 1) {
                        $timeout(() => {
                            this.ageGroupId = this.ageGroupList[0].value;
                        }, 0);
                    }
                });
        };

        this.ageGroupDataBound = () => {
            if (this.ageGroupList.length === 1) {
                this.selectedAgeGroupId = this.ageGroupList[0].value;
            } else {
                if (this.params.sectionId && this.params.selectedAgeGroupId && parseInt(this.params.sectionId) === parseInt(this.selectedSectionId)) {
                    this.selectedAgeGroupId = this.params.selectedAgeGroupId;
                } else {
                    this.selectedAgeGroupId = 0;
                }
            }
        };

        this.ageGroupSelect = (args) => {
            this.selectedAgeGroupId = args.value;
            //getTeams();
            getAthletes();
            paramHelper.setParams([{'athleteList.selectedAgeGroupId': this.selectedAgeGroupId}]);
        };

        let getAthletes = () => {
            dataservice.athletesSelect(this.selectedSectionId, this.selectedAgeGroupId, this.inactiveAthletes)
                .then((data) => {
                    this.athleteResultsBtnEnabled = false;
                    grid.dataSource = $filter('dateStringFilter')(data.itemsList, 'SzuletesiIdo');
                });
        };

        this.inactiveChange = (args) => {
            this.inactiveAthletes = args.value;
            getAthletes();
            paramHelper.setParams([{'athleteList.inactiveAthletes': this.inactiveAthletes}]);
        };

        this.goToUser = (EdzoId) => {
            if (!this.MODFELH) {
                log.errorMsg(gettextCatalog.getString('YouHaveNoPermissionToThisFunction'));
                return;
            }
            paramHelper.setParams([{'newUser.userId': EdzoId}]);
            $state.go('settings.userManagement.modifyUser');
        };

        this.goToNewAthlete = () => {
            if (this.selectedSectionId > 0) {
                // Save data for restore
                this.selectedSectionName = angular.element('#sectionDropDown').data('ejDropDownList').selectedTextValue;
                this.selectedAgeGroupName = angular.element('#ageGroupDropDown').data('ejDropDownList').selectedTextValue;

                paramHelper.setParams([
                    {'athleteNew.sportolokId': -1},
                    {'athleteNew.sectionList': this.sectionList},
                    {'athleteNew.selectedSectionId': this.selectedSectionId},
                    {'athleteNew.selectedSectionName': this.selectedSectionName},
                    {'athleteNew.ageGroupList': this.ageGroupList},
                    {'athleteNew.selectedAgeGroupId': this.selectedAgeGroupId},
                    {'athleteNew.selectedAgeGroupName': this.selectedAgeGroupName},
                    {'athleteList.selectedAgeGroupName': this.selectedAgeGroupName}]);
                $state.go('athletes.athletesManagement.athleteNew');
            } else {
                log.errorMsg(gettextCatalog.getString('RequiredSection'));
            }
        };

        this.modifyAthletes = (id) => {
            if (this.MODSPORTOLO || this.MEGTSPORTLIST) {
                this.selectedAgeGroupName = angular.element('#ageGroupDropDown').data('ejDropDownList').selectedTextValue;
                paramHelper.setParams([
                    {'athleteModify.sportoloId': id},
                    {'athleteList.selectedAgeGroupName': this.selectedAgeGroupName}]);
                $state.go('athletes.athletesManagement.athleteModify.dataSheet');
            } else {
                log.errorMsg(gettextCatalog.getString('PermissionDenied'));
            }
        };

        this.modifyAthletesButton = () => {
            if (this.MODSPORTOLO || this.MEGTSPORTLIST) {
                if ($rootScope.checkRowSelection(grid, true)) {
                    this.selectedAgeGroupName = angular.element('#ageGroupDropDown').data('ejDropDownList').selectedTextValue;
                    let selectedAthletes = $rootScope.getSelectedItems(grid);
                    paramHelper.setParams([
                        {'athleteModify.sportoloId': selectedAthletes[0].SportolokId},
                        {'athleteModify.sportoloNev': selectedAthletes[0].Nev},
                        {'athleteList.selectedAgeGroupName': this.selectedAgeGroupName}]);
                    $state.go('athletes.athletesManagement.athleteModify.dataSheet');
                }
            } else {
                log.errorMsg(gettextCatalog.getString('PermissionDenied'));
            }
        };

        let saveExitAthletes = () => {
            let data = {};
            this.athletesId = [];
            let selectedAthletes = $rootScope.getSelectedItems(grid);
            for (let i = 0; i < selectedAthletes.length; i++) {
                this.athletesId.push(selectedAthletes[i].SportolokId);
            }
            data.athletesId = this.athletesId;
            data.selectedExitDate = this.selectedExitDate;
            data.noteExitText = this.noteExitText;
            data.firstSection = true;
            dataservice.saveExitAthletes(data)
                .then((answer) => {
                    // swal() kiírni az eredményt
                    if (answer.retValue) {
                        log.successMsg('SuccesfulExitAthlete');
                        getAthletes();
                    } else {
                        swal({
                            title: gettextCatalog.getString('SuccesfulExitAthleteResult'),
                            text: gettextCatalog.getString('FailedExitAthleteResult'),
                            type: 'warning',
                            confirmButtonClass: 'btn-danger',
                            confirmButtonText: 'Ok'
                        });
                    }
                });
        };

        this.goneAthletesBtn = () => {
            if ($rootScope.checkRowSelection(grid)) {
                let selectedAthletes = $rootScope.getSelectedItems(grid);
                let exitAthletesNames = '';
                for (let i = 0; i < selectedAthletes.length; i++) {
                    exitAthletesNames += selectedAthletes[i].Nev + '; ';
                }

                this.visible = false; // Not need use this for angularJs, because the swa enable appear Error message

                let HTMLtext = `<p id="datepickValidText" style="color: #a94442;" class="ng-hide" ng-show="this.visible">
                                <label>${gettextCatalog.getString('PleasGiveTheStartMonthgoneAthlete')}</label><br></p>
                                <div style="margin-bottom: 10px; width: 95%;" >
                                <label>${gettextCatalog.getString('SelectDategoneAthlete')}<br></label></div>
                                <div style="margin-left: 30%;"><input id="datepick" type="text"></div>
                                <br><label>${gettextCatalog.getString('ExitedAthletesNamesText')}</label><br>
                                <textarea id="exitAthleteNamesTextArea" rows="2" cols="55" style="width: 95%; resize: none; padding: 5px;">${exitAthletesNames}</textarea><br>
                                <br><label>${gettextCatalog.getString('ExitedAthletesText')}</label><br>
                                <textarea id="noteTextArea" rows="4" cols="55" style="width: 95%; resize: none; padding: 5px;"></textarea>`;

                swal({
                    title: gettextCatalog.getString('ExitAthlete'),
                    html: HTMLtext,
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#DD6B55',
                    confirmButtonText: gettextCatalog.getString('Exiting'),
                    cancelButtonText: gettextCatalog.getString('Cancel'),
                    preConfirm: () => {
                        let preConfOk = false;
                        this.selectedExitDate = angular.element('#datepick').data('ejDatePicker').getValue(); // get value
                        this.noteExitText = angular.element('#noteTextArea').val();
                        return new Promise((resolve, reject) => {
                            if (this.selectedExitDate === null || !this.exitAthleteDateOk) {
                                // Must show the error message!
                                preConfOk = false;
                                swal.showValidationError(gettextCatalog.getString('SelectExitDate')); // Válaszd ki a kiléptetés dátumát!
                                reject(gettextCatalog.getString('SelectExitDate'));
                            } else {
                                preConfOk = true;
                            }
                            if (this.noteExitText === null || this.noteExitText === '') {
                                // Must show the error message!
                                preConfOk = false;
                                swal.showValidationError(gettextCatalog.getString('SetNoteText')); // Írd be a kiléptetés indokát!
                                reject(gettextCatalog.getString('SetNoteText'));
                            } else {
                                preConfOk = true;
                            }
                            if (preConfOk) {
                                resolve();
                            }
                        });
                    }
                    //                closeOnCancel: false
                }).then((confirmed) => {
                    if (confirmed.value) {
                        saveExitAthletes();
                        swal.close();
                        return true;
                    } else {
                        swal(gettextCatalog.getString('Cancelled'), gettextCatalog.getString('notExitAthlete'), 'error');
                    }
                });
                // Set DatePicker
                angular.element('#datepick').ejDatePicker({
                    // set date format
                    dateFormat: 'yyyy-MM-dd',
                    change: (args) => {
                        // Get current date
                        let currentDate = new Date();
                        this.selectedExitDate = new Date(args.value);
                        if (this.selectedExitDate.getFullYear() > currentDate.getFullYear()) {
                            // Error, no correct date
                            this.exitAthleteDateOk = false;
                        } else if (this.selectedExitDate.getMonth() > currentDate.getMonth()) {
                            // Error, no correct date
                            this.exitAthleteDateOk = false;
                        } else {
                            this.exitAthleteDateOk = this.selectedExitDate.getDate() === getMonthLastDay(args.value);
                        }

                        function getMonthLastDay(selectDate) {
                            let date = new Date(selectDate);
                            let y = date.getFullYear();
                            let m = date.getMonth();
                            let lastDay = new Date(y, m + 1, 0).getDate();
                            return date.getDate();
                        }
                    }
                });
            }
        };

        this.competitionResult = () => {
            if ($rootScope.checkRowSelection(grid, true)) {
                this.selectedAgeGroupName = angular.element('#ageGroupDropDown').data('ejDropDownList').selectedTextValue;
                let selectedAthletes = $rootScope.getSelectedItems(grid);
                paramHelper.setParams([{'raceResultsReport.athleteData': selectedAthletes[0]}]);
                $state.go('reports.raceResultsReport');
            }
        };

        // Activate page
        activate();
    }
})();


(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.athletes.athletesManagement.athletesList')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'athletes.athletesManagement.athletesList',
                config: {
                    url: '/athletesList',
                    templateUrl: 'app/athletes/athletesManagement/athletesList/athletesList.html',
                    controller: 'AthletesListController',
                    controllerAs: 'vm',
                    title: 'AthletesList',
                    settings: {
                        navId: 211,
                        level: 2,
                        order: 1,
                        orderTitle_hu: 'Tagnyilvántartás',
                        orderTitle_en: 'Member register',
                        parentId: 1,
                        content: 'AthletesList',
                        activatorPermission: '"MEGTSPORTLIST"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.athletes.athletesManagement')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'athletes.athletesManagement',
                config: {
                    url: '/athletesManagement',
                    templateUrl: 'app/athletes/athletesManagement/athletesManagement.html'
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    SectionsController.$inject = ["logger", "log", "dataservice", "$q", "$rootScope", "gettextCatalog", "authenticationService", "$scope", "paramHelper", "$state"];
    angular
        .module('app.athletes.sections')
        .controller('SectionsController', SectionsController);

    function SectionsController(logger, log, dataservice, $q, $rootScope, gettextCatalog, authenticationService, $scope, paramHelper, $state) {
        $rootScope.title = gettextCatalog.getString('Sections');
        var vm = this; $rootScope.vm = vm;

        vm.editEnabled = false;
        vm.editEnabledPerm = false;

        vm.EditSection = EditSection;
        vm.AddSection = AddSection;

        activate();

        vm.columns = [
            {type: 'checkbox', textAlign: 'center', width: '35px'},
            {field: 'SzakosztalyNeve', headerText: gettextCatalog.getString('Section'), textAlign: 'left', width: 150},
            {
                field: 'SzakosztalyVezeto1',
                headerText: gettextCatalog.getString('PrimarySectionLeader'),
                textAlign: 'left',
                width: 150
            },
            {
                field: 'SzakosztalyVezeto2',
                headerText: gettextCatalog.getString('SecondarySectionLeader'),
                textAlign: 'left',
                width: 150
            },
            {
                field: 'Egyeni', headerText: gettextCatalog.getString('IndividualSport'), textAlign: 'center',
                type: 'boolean',
                displayAsCheckBox: true,
                width: 75
            },
            {
                field: 'Csapat', headerText: gettextCatalog.getString('TeamSport'), textAlign: 'center',
                type: 'boolean',
                displayAsCheckBox: true,
                width: 75
            },
            {
                field: 'Aktiv', headerText: gettextCatalog.getString('Aktiv'), textAlign: 'center',
                type: 'boolean',
                displayAsCheckBox: true,
                width: 75
            }
        ];

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItems,
            allowSorting: true,
            allowExcelExport: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            queryCellInfo: querycellinfo,
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#Grid'), $scope);
                }
            },
            rowSelecting: function () {
                grid.clearSelection();
            },
            checkBoxChange: function (args) {
                $rootScope.checkBoxChangeOnlyOne(args, grid);
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        function activate() {
            $q.all([authenticationService.getRight('SZAKOSZTALY')]).then(function (result) {
                if (result[0] !== true) {
                    log.permissionError(true);
                } else {
                    vm.userId = authenticationService.getAuthData().id;
                    vm.editEnabledPerm = result[0];
                    getSectionData();
                }
            });
        }

        function getSectionData() {
            dataservice.getSectionData(0).then(function (response) {
                grid.dataSource = response.itemsList;
            });
        }

        function querycellinfo(arg) {
            if (arg.column.field == 'SzakosztalyNeve') {
                var cell = angular.element(arg.cell);
                cell.css('background-color', arg.data.Szin);
                cell.css('color', arg.data.SzovegSzin);
            }
        }

        function AddSection() {
            paramHelper.setParams([{'editSection.SectionId': -1}]);
            $state.go('settings.editSection');
        }

        function EditSection() {
            if ($rootScope.checkRowSelection(grid, true)) {
                var selectedRecords = $rootScope.getSelectedItems(grid);
                vm.editSection = selectedRecords[0];
                paramHelper.setParams([{'editSection.SectionId': vm.editSection.SzakosztalyID}]);
                $state.go('settings.editSection');
            }
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.athletes.sections')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'athletes.sections',
                config: {
                    url: '/sections',
                    templateUrl: 'app/athletes/sections/sections.html',
                    controller: 'SectionsController',
                    controllerAs: 'vm',
                    title: 'Sections',
                    settings: {
                        navId: 142,
                        level: 2,
                        order: 4,
                        orderTitle_hu: 'Szakosztályok',
                        orderTitle_en: 'Sections',
                        parentId: 1,
                        content: 'Sections',
                        activatorPermission: '"SZAKOSZTALY"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    AddTeamController.$inject = ["log", "$state", "dataservice", "$q", "DOMAIN", "gettextCatalog", "$scope", "paramHelper", "authenticationService", "$rootScope", "validatorHelper", "$timeout"];
    angular
        .module('app.athletes.teams.addTeam')
        .controller('AddTeamController', AddTeamController);

    function AddTeamController(log, $state, dataservice, $q, DOMAIN, gettextCatalog, $scope, paramHelper, authenticationService, $rootScope, validatorHelper, $timeout) {
        var vm = this; $rootScope.vm = vm;

        // Page title
        $rootScope.title = gettextCatalog.getString('AddTeam');

        vm.MEGTCSOPORT = false;
        // Dropdownlist's sources
        vm.sectionList = [];
        vm.ageGroupList = [];
        vm.coachList = [];
        // Default values
        vm.noImg = DOMAIN.baseURL + DOMAIN.userImage;
        vm.photoUrl = vm.noImg;
        vm.formData = {
            FileData: null,
            FileName: DOMAIN.userImage,
            TeamName: undefined,
            Comment: undefined,
            SectionId: undefined,
            AgeGroupId: undefined,
            CoachId: undefined,
            ActiveTeam: true
        };

        // Image cropper variables
        vm.cropper = {};
        vm.cropper.sourceImage = null;
        vm.cropper.croppedImage = null;
        vm.bounds = {};
        vm.bounds.left = 0;
        vm.bounds.right = 0;
        vm.bounds.top = 0;
        vm.bounds.bottom = 0;
        vm.cropDialogTitle = gettextCatalog.getString('ChooseImageTitle');

        // Public functions
        vm.saveTeam = saveTeam;
        vm.saveTeamAndAddMembers = saveTeamAndAddMembers;
        vm.openCropDialog = openCropDialog;
        vm.doneCropDialog = doneCropDialog;
        vm.closeCropDialog = closeCropDialog;
        vm.deleteImg = deleteImg;
        vm.sectionDataBound = sectionDataBound;
        vm.sectionSelect = sectionSelect;
        vm.ageGroupDataBound = ageGroupDataBound;
        vm.ageGroupSelect = ageGroupSelect;
        vm.coachDataBound = coachDataBound;
        vm.coachSelect = coachSelect;
        vm.simpleSave = simpleSave;

        activate();

        function activate() {
            authenticationService.getRight('UJCSOPORT').then(function (result) {
                if (result !== true) {
                    log.permissionError(true);
                } else {
                    $q.all([paramHelper.getParams([], ['teams.sectionId', 'teams.ageGroupId']), authenticationService.getRight('MEGTCSOPORT')]).then(function (results) {
                        vm.formData.SectionId = results[0]['teams.sectionId'];
                        vm.formData.AgeGroupId = results[0]['teams.ageGroupId'];
                        $timeout(function () {
                            vm.MEGTCSOPORT = results[1];
                        }, 0);
                        angular.element('#ActiveTeam').ejCheckBox({checked: vm.formData.ActiveTeam});
                        getSections();
                    });
                }
            });
        }

        function getSections() {
            return dataservice.sectionDropDownList(0).then(function (data) {
                vm.sectionList = data.itemsList;
            });
        }

        function sectionDataBound() {
            if (vm.sectionList.length === 1) {
                angular.element('#SectionId').ejDropDownList('selectItemByValue', vm.sectionList[0].value);
                vm.formData.SectionId = vm.sectionList[0].value;
            } else {
                angular.element('#SectionId').ejDropDownList('selectItemByValue', vm.formData.SectionId);
            }
        }

        function sectionSelect(args) {
            vm.formData.SectionId = args.value;
            getAgeGroups();
        }

        function getAgeGroups() {
            return dataservice.ageGroupDropDownList(vm.formData.SectionId)
                .then(function (data) {
                    vm.formData.CoachId = undefined;
                    vm.coachList = [];
                    vm.ageGroupList = data.itemsList;
                });
        }

        function ageGroupDataBound() {
            if (vm.ageGroupList.length === 1) {
                angular.element('#AgeGroupId').ejDropDownList('selectItemByValue', vm.ageGroupList[0].value);
                vm.formData.AgeGroupId = vm.ageGroupList[0].value;
            } else {
                angular.element('#AgeGroupId').ejDropDownList('selectItemByValue', vm.formData.AgeGroupId);
            }
        }

        function ageGroupSelect(args) {
            vm.formData.AgeGroupId = args.value;
            getCoaches();
        }

        function getCoaches() {
            return dataservice.coachDropDownList(vm.formData.SectionId, vm.formData.AgeGroupId)
                .then(function (data) {
                    vm.coachList = data.itemsList;
                });
        }

        function coachDataBound() {
            if (vm.coachList.length === 1) {
                angular.element('#CoachId').ejDropDownList('selectItemByValue', vm.coachList[0].value);
                vm.formData.CoachId = vm.coachList[0].value;
            }
        }

        function coachSelect(args) {
            vm.formData.CoachId = args.value;
        }

        function saveTeam(simpleSave) {
            if (angular.element('#FileName').val() !== '' && vm.cropper.croppedImage !== null) {
                vm.formData.FileData = vm.cropper.croppedImage;
                vm.formData.FileName = angular.element('#FileName').val();
            }
            // a syncfusion direktívák miatt
            $scope.$broadcast('submitted');
            if ($scope.form.$valid === false) {
                log.errorMsg('RequiredFieldsError');
            } else {
                dataservice.saveTeam(vm.formData)
                    .then(function (data) {
                        log.successMsg('TeamSaved');
                        paramHelper.setParams([{'teams.sectionId': vm.formData.SectionId}, {'teams.ageGroupId': vm.formData.AgeGroupId}]);
                        if (simpleSave) {
                            $state.go('athletes.teams.teamList');
                        } else {
                            paramHelper.setParams([{'teams.team': data.res}]);
                            $state.go('athletes.teams.teamMembersList');
                        }
                    }, function (response) {
                        validatorHelper.validate(response, $scope.form);
                    });
            }
        }

        function simpleSave() {
            saveTeam(true);
        }

        function saveTeamAndAddMembers() {
            saveTeam(false);
        }

        function openCropDialog() {
            angular.element('#dialogContainer').css('visibility', 'visible');
            angular.element('#cropDialog').ejDialog('open');
        }

        function closeCropDialog() {
            angular.element('#dialogContainer').css('visibility', 'hidden');
            angular.element('#cropDialog').ejDialog('close');
        }

        function doneCropDialog() {
            vm.photoUrl = vm.cropper.croppedImage;
            angular.element('#dialogContainer').css('visibility', 'hidden');
            angular.element('#cropDialog').ejDialog('close');
        }

        function deleteImg() {
            swal({
                title: gettextCatalog.getString('DeleteTeamImg'),
                text: gettextCatalog.getString('AreYouSureYouWantToDeleteTheTeamImg'),
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: gettextCatalog.getString('Yes'),
                cancelButtonText: gettextCatalog.getString('No')
            }).then(function (isConfirm) {
                if (isConfirm.value) {
                    angular.element('#FileName').val('');
                    vm.photoUrl = vm.noImg;
                    $scope.$apply();
                }
            });
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.athletes.teams.addTeam')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'athletes.teams.addTeam',
                config: {
                    url: '/addTeam',
                    templateUrl: 'app/athletes/teams/addTeam/addTeam.html',
                    controller: 'AddTeamController',
                    controllerAs: 'vm',
                    title: 'AddTeams'
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    AddTeamMember.$inject = ["log", "$state", "dataservice", "$q", "gettextCatalog", "paramHelper", "$scope", "authenticationService", "$rootScope", "$filter"];
    angular
        .module('app.athletes.teams.addTeamMember')
        .controller('AddTeamMemberController', AddTeamMember);

    function AddTeamMember(log, $state, dataservice, $q, gettextCatalog, paramHelper, $scope, authenticationService, $rootScope, $filter) {
        var vm = this; $rootScope.vm = vm;

        // Page title
        $rootScope.title = gettextCatalog.getString('AddTeamMember');

        vm.columns = [
            {type: 'checkbox', textAlign: 'center', width: 35},
            {
                field: 'Name',
                headerText: gettextCatalog.getString('Name'),
                template: '#adtemetemplateDataColumn1',
                width: 150
            },
            {field: 'BirthDate', headerText: gettextCatalog.getString('BirthDate'), width: 100}
        ];

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItems,
            allowPaging: true,
            allowSorting: true,
            allowExcelExport: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            width: '100%',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#Grid'), $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        // Public functions
        vm.addTeamMemberToTeam = addTeamMemberToTeam;
        vm.goToNewAthlete = goToNewAthlete;

        activate();

        function activate() {
            authenticationService.getRight('MODCSOPORT').then(function (result) {
                if (result !== true) {
                    log.permissionError(true);
                } else {
                    $q.all([paramHelper.getParams(['teams.sectionId', 'teams.ageGroupId', 'teams.team']), authenticationService.getRight('MEGTSPORTLIST')]).then(function (results) {
                        vm.csapat = results[0]['teams.team'];
                        vm.korosztaly = results[0]['teams.ageGroupId'];
                        vm.szakosztaly = results[0]['teams.sectionId'];
                        vm.MEGTSPORTLIST = results[1];
                        getPossibleTeamMembersList();
                    });
                }
            });
        }

        function getPossibleTeamMembersList() {
            return dataservice.getPossibleTeamMembersList(vm.csapat, vm.szakosztaly, vm.korosztaly)
                .then(function (data) {
                    grid.dataSource = $filter('dateStringFilter')(data.itemsList, 'BirthDate');
                });
        }

        function addTeamMemberToTeam() {
            var selectedRows = $rootScope.getSelectedItems(grid);
            if (selectedRows.length !== 0) {
                var out = [];
                for (var i = 0; i < selectedRows.length && selectedRows[i]; i++) {
                    out.push(selectedRows[i].Id);
                }
                dataservice.addTeamMemberToTeam(out, vm.csapat).then(function (data) {
                    data = data.retValue;
                    if (data === true) {
                        getPossibleTeamMembersList();
                        log.successMsg('TeamMemberAddedToTeam');
                    }
                });
            } else {
                log.errorMsg('YouHaveToSelectLeastAthlete');
            }
        }

        function goToNewAthlete(Id) {
            if (vm.MEGTSPORTLIST) {
                paramHelper.setParams([{'athleteModify.sportoloId': Id}, {'athleteModify.selectedSectionId': vm.szakosztaly}, {'athleteModify.selectedAgeGroupId': vm.korosztaly}]);
                $state.go('athletes.athletesManagement.athleteModify.dataSheet');
            } else {
                log.permissionError();
            }
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.athletes.teams.addTeamMember')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'athletes.teams.addTeamMember',
                config: {
                    url: '/addTeamMember',
                    templateUrl: 'app/athletes/teams/addTeamMember/addTeamMember.html',
                    controller: 'AddTeamMemberController',
                    controllerAs: 'vm',
                    title: 'AddTeamMember'
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    ModifyTeamController.$inject = ["log", "$state", "dataservice", "$q", "DOMAIN", "gettextCatalog", "$scope", "paramHelper", "authenticationService", "$rootScope", "$timeout"];
    angular
        .module('app.athletes.teams.modifyTeam')
        .controller('ModifyTeamController', ModifyTeamController);

    function ModifyTeamController(log, $state, dataservice, $q, DOMAIN, gettextCatalog, $scope, paramHelper, authenticationService, $rootScope, $timeout) {
        var vm = this; $rootScope.vm = vm;

        // Page title
        $rootScope.title = gettextCatalog.getString('ModifyTeam');

        // Dropdownlist's sources
        vm.sectionList = [];
        vm.ageGroupList = [];
        vm.coachList = [];
        // Default values
        vm.noImg = DOMAIN.baseURL + DOMAIN.userImage;
        vm.photoUrl = vm.noImg;
        vm.formData = {
            TeamId: 0,
            FileData: null,
            FileName: 'avatar_2x.png',
            TeamName: undefined,
            Comment: undefined,
            SectionId: undefined,
            AgeGroupId: undefined,
            CoachId: undefined,
            ActiveTeam: true
        };

        // Image cropper variables
        vm.cropper = {};
        vm.cropper.sourceImage = null;
        vm.cropper.croppedImage = null;
        vm.bounds = {};
        vm.bounds.left = 0;
        vm.bounds.right = 0;
        vm.bounds.top = 0;
        vm.bounds.bottom = 0;
        vm.cropDialogTitle = gettextCatalog.getString('ChooseImageTitle');

        // Public functions
        vm.modifyTeam = modifyTeam;
        vm.modifyTeamAndAddMembers = modifyTeamAndAddMembers;
        vm.openCropDialog = openCropDialog;
        vm.doneCropDialog = doneCropDialog;
        vm.closeCropDialog = closeCropDialog;
        vm.deleteImg = deleteImg;
        vm.sectionDataBound = sectionDataBound;
        vm.sectionSelect = sectionSelect;
        vm.ageGroupDataBound = ageGroupDataBound;
        vm.ageGroupSelect = ageGroupSelect;
        vm.coachDataBound = coachDataBound;
        vm.coachSelect = coachSelect;
        vm.simpleModifyTeam = simpleModifyTeam;
        vm.activeCheckboxChanged = activeCheckboxChanged;
        vm.modifyTeamAndAddMembersButtonEnabled = false;

        activate();

        function activate() {
            $q.all([authenticationService.getRight('MODCSOPORT'), authenticationService.getRight('MEGTCSOPORT')]).then(function (results) {
                if (results[0] !== true && results[1] !== true) {
                    log.permissionError(true);
                } else {
                    $timeout(function () {
                        vm.MODCSOPORT = results[0];
                    });
                    paramHelper.getParams(['teams.team']).then(function (results) {
                        vm.formData.TeamId = results['teams.team'];
                        getTeam().then(function () {
                            getSections();
                        }, function () {
                            log.errorMsg('CantGetTeam');
                        });
                    });
                }
            });
        }

        function getTeam() {
            return $q(function (resolve) {
                dataservice.getTeam(vm.formData.TeamId).then(function (data) {
                    vm.team = data;
                    vm.formData.TeamName = data.csapatNev;
                    vm.formData.Comment = data.megjegyzes;
                    vm.formData.SectionId = data.szakosztalyId;
                    vm.formData.AgeGroupId = data.korosztalyId;
                    vm.formData.CoachId = data.edzoId;
                    angular.element('#activeCheckBox').ejCheckBox({checked: data.aktiv});
                    vm.formData.ActiveTeam = data.aktiv;
                    if (!data.kep || data.kep == 'avatar_2x.png') {
                        vm.photoUrl = DOMAIN.baseURL + DOMAIN.userImage;
                    } else {
                        vm.photoUrl = DOMAIN.baseURL + DOMAIN.teamPhotosUrl + data.kep;
                    }

                    vm.formData.FileName = data.kep;
                    resolve();
                });
            });
        }

        function getSections() {
            return dataservice.sectionDropDownList(0).then(function (data) {
                vm.sectionList = data.itemsList;
            });
        }

        // Run after data bounded
        function sectionDataBound() {
            if (vm.sectionList.length === 1) {
                angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.sectionList[0].value);
                vm.formData.SectionId = vm.sectionList[0].value;
            } else {
                angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.formData.SectionId);
            }
        }

        // Run after section selected
        function sectionSelect(args) {
            vm.formData.SectionId = args.value;
            getAgeGroups();
        }

        function getAgeGroups() {
            return dataservice.ageGroupDropDownList(vm.formData.SectionId)
                .then(function (data) {
                    vm.coachList = [];
                    vm.ageGroupList = data.itemsList;
                });
        }

        // Run after data bounded
        function ageGroupDataBound() {
            if (vm.ageGroupList.length === 1) {
                angular.element('#ageGroupDropDown').ejDropDownList('selectItemByValue', vm.ageGroupList[0].value);
                vm.formData.AgeGroupId = vm.ageGroupList[0].value;
            } else {
                angular.element('#ageGroupDropDown').ejDropDownList('selectItemByValue', vm.formData.AgeGroupId);
            }
        }

        // Run after age group selected
        function ageGroupSelect(args) {
            vm.formData.AgeGroupId = args.value;
            getCoaches();
        }

        function getCoaches() {
            return dataservice.coachDropDownList(vm.formData.SectionId, vm.formData.AgeGroupId)
                .then(function (data) {
                    vm.coachList = data.itemsList;
                });
        }

        function coachDataBound() {
            if (vm.coachList.length === 1) {
                angular.element('#coachDropDown').ejDropDownList('selectItemByValue', vm.coachList[0].value);
                vm.formData.CoachId = vm.coachList[0].value;
            } else {
                angular.element('#coachDropDown').ejDropDownList('selectItemByValue', vm.formData.CoachId);
            }
        }

        /**
         * Edző kiválasztásakor fut le és lekéri a korosztály edzőit
         * @author Richard Keki
         */
        function coachSelect(args) {
            vm.formData.CoachId = args.value;
        }

        function activeCheckboxChanged(args) {
            vm.modifyTeamAndAddMembersButtonEnabled = args.value;
            $timeout(function () {
                $scope.$apply();
            }, 0);
            vm.formData.ActiveTeam = args.value;
        }

        function modifyTeam(simpleSave) {
            // a syncfusion direktívák miatt
            $scope.$broadcast('submitted');
            if ($scope.form.$valid === false) {
                log.errorMsg('RequiredFieldsError');
            } else {
                if (angular.element('#FileName').val() !== '' && vm.cropper.croppedImage !== null) {
                    vm.formData.FileData = vm.cropper.croppedImage;
                    vm.formData.FileName = angular.element('#FileName').val();
                }
                dataservice.modifyTeam(vm.formData)
                    .then(function () {
                        log.successMsg('TeamModified');
                        paramHelper.setParams([{'teams.sectionId': vm.formData.SectionId}, {'teams.ageGroupId': vm.formData.AgeGroupId}]);
                        if (simpleSave) {
                            $state.go('athletes.teams.teamList');
                        } else {
                            $state.go('athletes.teams.teamMembersList');
                        }
                    });
            }
        }

        function simpleModifyTeam() {
            modifyTeam(true);
        }

        function modifyTeamAndAddMembers() {
            modifyTeam(false);
        }

        function openCropDialog() {
            angular.element('#dialogContainer').css('visibility', 'visible');
            angular.element('#cropDialog').ejDialog('open');
        }

        function closeCropDialog() {
            angular.element('#dialogContainer').css('visibility', 'hidden');
            angular.element('#cropDialog').ejDialog('close');
        }

        function doneCropDialog() {
            vm.photoUrl = vm.cropper.croppedImage;
            angular.element('#cropDialog').ejDialog('close');
        }

        function deleteImg() {
            swal({
                title: gettextCatalog.getString('DeleteTeamImg'),
                text: gettextCatalog.getString('AreYouSureYouWantToDeleteTheTeamImg'),
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: gettextCatalog.getString('Yes'),
                cancelButtonText: gettextCatalog.getString('No')
            }).then(function (isConfirm) {
                if (isConfirm.value) {
                    angular.element('#FileName').val('');
                    vm.photoUrl = vm.noImg;
                    vm.formData.FileName = 'oldDeleted';
                    $scope.$apply();
                }
            });
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.athletes.teams.modifyTeam')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'athletes.teams.modifyTeam',
                config: {
                    url: '/modifyTeam',
                    templateUrl: 'app/athletes/teams/modifyTeam/modifyTeam.html',
                    controller: 'ModifyTeamController',
                    controllerAs: 'vm',
                    title: 'ModifyTeams'
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    TeamsCtrl.$inject = ["dataservice", "$q", "$state", "$rootScope", "gettextCatalog", "$scope", "paramHelper", "authenticationService", "log", "$timeout"];
    angular
        .module('app.athletes.teams.teamList')
        .controller('TeamListController', TeamsCtrl);

    function TeamsCtrl(dataservice, $q, $state, $rootScope, gettextCatalog, $scope, paramHelper, authenticationService, log, $timeout) {
        var vm = this;
        $rootScope.vm = this;
        // Page title
        $rootScope.title = gettextCatalog.getString('TeamList');

        // Dropdownlist's sources
        vm.sectionList = [];
        vm.ageGroupList = [];
        // Checkbox variables
        vm.inactiveTeams = false;
        vm.checkboxEnabled = false;
        // Grid's details
        vm.columns = [
            {type: 'checkbox', textAlign: 'center', width: 35},
            {
                field: 'csapatNev',
                headerText: gettextCatalog.getString('TeamName'),
                textAlign: 'left',
                width: 100,
                template: '#teamlistcolumnTemplate1'
            },
            {
                field: 'edzoNeve',
                headerText: gettextCatalog.getString('Coach'),
                textAlign: 'left',
                width: 150,
                template: '#teamlistcolumnTemplate2'
            },
            {
                field: 'aktiv',
                headerText: gettextCatalog.getString('Active'),
                textAlign: 'center',
                width: 75,
                type: 'boolean',
                displayAsCheckBox: true
            },
            {field: 'versenyzo', headerText: gettextCatalog.getString('Athletes'), textAlign: 'center', width: 75},
            {field: 'versenyzoFiu', headerText: gettextCatalog.getString('Man'), textAlign: 'center', width: 75},
            {field: 'versenyzoLany', headerText: gettextCatalog.getString('Woman'), textAlign: 'center', width: 75},
            {field: 'megjegyzes', headerText: gettextCatalog.getString('Comment'), textAlign: 'left', width: 200}
        ];

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItems,
            allowPaging: true,
            allowSorting: true,
            allowTextWrap: true,
            allowExcelExport: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#Grid'), $scope);
                }
            },
            rowSelecting: function () {
                grid.clearSelection();
            },
            checkBoxChange: function (args) {
                $rootScope.checkBoxChangeOnlyOne(args, grid);
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };
        grid.dataBound = function () {
            if (grid.dataSource.length === 1) {
                grid.selectRow(0);
            }
        };

        // Public functions
        vm.inactiveChange = inactiveChange;
        vm.deleteTeam = deleteTeam;
        vm.goToAddTeam = goToAddTeam;
        vm.goToModifyTeam = goToModifyTeam;
        vm.goToTeamMembersList = goToTeamMembersList;
        vm.openCoach = openCoach;
        vm.sectionChange = sectionChange;
        vm.ageGroupChange = ageGroupChange;
        vm.openTeamResults = openTeamResults;

        // Activate page
        activate();

        function activate() {
            authenticationService.getRight('MEGTCSOPORT').then(function (result) {
                if (result !== true) {
                    log.permissionError(true);
                } else {
                    vm.MEGTCSOPORT = result;
                    $q.all([paramHelper.getParams([], ['teams.sectionId', 'teams.ageGroupId', 'teams.inactiveTeams']), authenticationService.getRight('TORLCSOPORT'), authenticationService.getRight('MODCSOPORT'), authenticationService.getRight('UJCSOPORT'), authenticationService.getRight('MEGTCSERJEL')]).then(function (results) {
                        vm.defaultSection = results[0]['teams.sectionId'];
                        vm.defaultAgeGroup = results[0]['teams.ageGroupId'];
                        vm.inactiveTeams = results[0]['teams.inactiveTeams'];
                        vm.TORLCSOPORT = results[1];
                        vm.MODCSOPORT = results[2];
                        vm.UJCSOPORT = results[3];
                        vm.MEGTCSERJEL = results[4];
                        if (!vm.inactiveTeams) {
                            vm.inactiveTeams = false;
                        }
                        angular.element('#active').ejCheckBox({checked: vm.inactiveTeams});
                        getSections();
                    });
                }
            });
        }

        function openTeamResults() {
            if (vm.MEGTCSERJEL) {
                if ($rootScope.checkRowSelection(grid, true)) {
                    var selectedRecords = $rootScope.getSelectedItems(grid);
                    paramHelper.setParams([{'teamID': selectedRecords[0].csapatId}]);
                    $state.go('reports.raceResultsReport');
                }
            } else {
                log.permissionError();
            }
        }

        // Get sections' list
        function getSections() {
            return dataservice.sectionDropDownList().then(function (data) {
                vm.sectionList = data.itemsList;
                if (vm.sectionList.length === 1) {
                    $timeout(function () {
                        vm.sectionId = vm.sectionList[0].value;
                    }, 0);
                } else {
                    $timeout(function () {
                        vm.sectionId = vm.defaultSection;
                    }, 0);
                }
            });
        }

        // Run after section selected
        function sectionChange(args) {
            vm.checkboxEnabled = true;
            if (!vm.ageGroupId && !vm.defaultAgeGroup) {
                getTeams(args.value, 0, vm.inactiveTeams);
            }
            getAgeGroups(args.value);
            paramHelper.setParams([{'teams.sectionId': args.value}]);
        }

        // Get age groups' list
        function getAgeGroups(sectionId) {
            return dataservice.ageGroupDropDownList(sectionId).then(function (data) {
                if (data.itemsList.length > 1) {
                    data.itemsList.unshift({value: '0', text: gettextCatalog.getString('All')});
                }
                vm.ageGroupList = data.itemsList;
                if (vm.ageGroupList.length === 1) {
                    $timeout(function () {
                        vm.ageGroupId = vm.ageGroupList[0].value;
                    }, 0);
                } else {
                    if (vm.sectionId == vm.defaultSection) {
                        $timeout(function () {
                            vm.ageGroupId = vm.defaultAgeGroup;
                        }, 0);
                    } else {
                        $timeout(function () {
                            vm.ageGroupId = 0;
                        }, 0);
                    }
                }
            });
        }

        // Run after age group selected
        function ageGroupChange(args) {
            getTeams(vm.sectionId, args.value, vm.inactiveTeams);
            paramHelper.setParams([{'teams.ageGroupId': args.value}]);
        }

        // Get teams' list
        function getTeams(sectionId, ageGroupId, active) {
            return dataservice.teamList(sectionId, ageGroupId, active).then(function (data) {
                grid.dataSource = data.itemsList;
            });
        }

        // when click inactives checkbox
        function inactiveChange(args) {
            vm.inactiveTeams = args.value;
            paramHelper.setParams([{'teams.inactiveTeams': args.value}]);
            if (vm.sectionId) {
                getTeams(vm.sectionId, vm.ageGroupId, args.value);
            }
        }

        function deleteTeam() {
            if (vm.TORLCSOPORT) {
                if ($rootScope.checkRowSelection(grid, true)) {
                    var selectedRecords = $rootScope.getSelectedItems(grid);
                    if (selectedRecords[0].versenyzo > 0) {
                        swal({
                            title: gettextCatalog.getString('AreYouSureYouWantToDeleteTheTeamWithMembers'),
                            text: gettextCatalog.getString('TeamHasMembers'),
                            type: 'warning',
                            showCancelButton: true,
                            confirmButtonText: gettextCatalog.getString('Delete'),
                            cancelButtonText: gettextCatalog.getString('Cancel')
                        }).then(function (isConfirm) {
                            if (isConfirm.value) {
                                deleteTeamById(selectedRecords[0].csapatId);
                            }
                        });
                    } else if (selectedRecords[0].aktiv === true) {
                        swal({
                            title: gettextCatalog.getString('AreYouSureYouWantToDeleteTheTeam'),
                            text: gettextCatalog.getString('MakesTeamPassive'),
                            type: 'warning',
                            showCancelButton: true,
                            confirmButtonText: gettextCatalog.getString('Delete'),
                            cancelButtonText: gettextCatalog.getString('Cancel')
                        }).then(function (isConfirm) {
                            if (isConfirm.value) {
                                deleteTeamById(selectedRecords[0].csapatId);
                            }
                        });
                    } else {
                        log.errorMsg('YouCantDeleteInactiveTeam');
                    }
                }
            } else {
                log.permissionError();
            }
        }

        function deletePlayersFromTeam(id) {
            return dataservice.deleteTeamsPlayers(id)
                .then(function (data) {
                    if (data.retValue !== true) {
                        log.errorMsg('CantDeleted');
                    } else {
                        getTeams(vm.sectionId, vm.ageGroupId, vm.inactiveTeams);
                    }
                });
        }

        function deleteTeamById(id) {
            return dataservice.deleteTeam(id).then(function (data) {
                if (data.retValue === true) {
                    deletePlayersFromTeam(id);
                } else {
                    log.errorMsg('TeamDeletedError', 'CantDeleted');
                }
            });
        }

        function goToAddTeam() {
            if (vm.UJCSOPORT) {
                paramHelper.setParams([{'teams.sectionId': vm.sectionId}, {'teams.ageGroupId': vm.ageGroupId}, {'teams.inactiveTeams': vm.inactiveTeams}]);
                $state.go('athletes.teams.addTeam');
            } else {
                log.permissionError();
            }
        }

        function goToModifyTeam() {
            if (vm.MODCSOPORT || vm.MEGTCSOPORT) {
                if ($rootScope.checkRowSelection(grid, true)) {
                    var selectedRecords = $rootScope.getSelectedItems(grid);
                    paramHelper.setParams([{'teams.sectionId': vm.sectionId}, {'teams.ageGroupId': vm.ageGroupId}, {'teams.inactiveTeams': vm.inactiveTeams}, {'teams.team': selectedRecords[0].csapatId}]);
                    $state.go('athletes.teams.modifyTeam');
                }
            } else {
                log.permissionError();
            }
        }

        function goToTeamMembersList(szakosztaly, korosztaly, csapat, inaktiv) {
            if (vm.MODCSOPORT) {
                if (szakosztaly && korosztaly && csapat && angular.isDefined(inaktiv)) {
                    paramHelper.setParams([{'teams.sectionId': szakosztaly}, {'teams.ageGroupId': korosztaly}, {'teams.inactiveTeams': vm.inactiveTeams}, {'teams.team': csapat}]);
                    $state.go('athletes.teams.teamMembersList');
                } else {
                    if ($rootScope.checkRowSelection(grid, true)) {
                        var selectedRecords = $rootScope.getSelectedItems(grid);
                        if (selectedRecords[0].aktiv !== false) {
                            paramHelper.setParams([{'teams.sectionId': selectedRecords[0].szakosztalyId}, {'teams.ageGroupId': selectedRecords[0].korosztalyId}, {'teams.inactiveTeams': vm.inactiveTeams}, {'teams.team': selectedRecords[0].csapatId}]);
                            $state.go('athletes.teams.teamMembersList');
                        } else {
                            log.errorMsg('YouCantViewInactiveTeamsMembers');
                        }
                    }
                }
            } else {
                log.permissionError();
            }
        }

        function openCoach(edzoId) {
            $q.all([authenticationService.getRight('MODFELH'), authenticationService.getRight('MEGTFELH')]).then(function (results) {
                if (results[0] || results[1]) {
                    paramHelper.setParams([{'newUser.userId': edzoId}]);
                    $state.go('settings.userManagement.modifyUser');
                } else {
                    log.permissionError();
                }
            });
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.athletes.teams.teamList')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'athletes.teams.teamList',
                config: {
                    url: '/teamList',
                    templateUrl: 'app/athletes/teams/teamList/teamList.html',
                    controller: 'TeamListController',
                    controllerAs: 'vm',
                    title: 'TeamList',
                    settings: {
                        navId: 221,
                        level: 2,
                        order: 2,
                        orderTitle_hu: 'Csapatok',
                        orderTitle_en: 'Team list',
                        parentId: 1,
                        content: 'TeamList',
                        activatorPermission: '"MEGTCSOPORT"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    TeamMembersList.$inject = ["log", "$state", "dataservice", "$q", "$filter", "gettextCatalog", "paramHelper", "authenticationService", "$scope", "$rootScope"];
    angular
        .module('app.athletes.teams.teamMembersList')
        .controller('TeamMembersListController', TeamMembersList);

    function TeamMembersList(log, $state, dataservice, $q, $filter, gettextCatalog, paramHelper, authenticationService, $scope, $rootScope) {
        var vm = this; $rootScope.vm = vm;

        // Page title
        $rootScope.title = gettextCatalog.getString('TeamMembersTitle');

        vm.now = new Date();
        vm.dateValue = vm.now;
        // Grid's variable
        vm.columns = [
            {type: 'checkbox', textAlign: 'center', width: 35},
            {
                field: 'Name',
                headerText: gettextCatalog.getString('Name'),
                template: '#temelitemplateDataColumn1',
                width: 150
            },
            {field: 'BirthDate', headerText: gettextCatalog.getString('BirthDate'), width: 100}
        ];

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItems,
            allowPaging: true,
            allowSorting: true,
            allowExcelExport: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            width: '100%',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#Grid'), $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        // Public functions
        vm.dateChange = dateChange;
        vm.deleteTeamMember = deleteTeamMember;
        vm.goToAddTeamMember = goToAddTeamMember;
        vm.goToNewAthlete = goToNewAthlete;

        activate();

        function activate() {
            authenticationService.getRight('MEGTCSOPORT').then(function (result) {
                if (result !== true) {
                    log.permissionError(true);
                } else {
                    $q.all([paramHelper.getParams(['teams.sectionId', 'teams.ageGroupId', 'teams.team'], ['teams.date']),
                        authenticationService.getRight('MEGTSPORTLIST')
                    ]).then(function (results) {
                        vm.csapat = results[0]['teams.team'];
                        vm.korosztaly = results[0]['teams.ageGroupId'];
                        vm.szakosztaly = results[0]['teams.sectionId'];
                        if (results[0]['teams.date'] != null) {
                            vm.dateValue = results[0]['teams.date'];
                        }
                        vm.MEGTSPORTLIST = results[1];
                        getTeamMembersList();
                    });
                }
            });
        }

        function getTeamMembersList() {
            dataservice.getTeamMembersList(vm.csapat, vm.dateValue).then(function (data) {
                grid.dataSource = $filter('dateStringFilter')(data.itemsList, 'BirthDate');
            });
        }

        function dateChange(args) {
            if (args.value !== null) {
                vm.dateValue = args.value;
                getTeamMembersList();
                paramHelper.setParams([{'teams.date': vm.dateValue}]);
            }
        }

        function deleteTeamMember() {
            var selectedRows = $rootScope.getSelectedItems(grid);
            if (selectedRows.length !== 0) {
                var out = [];
                for (var i = 0; i < selectedRows.length; i++) {
                    out.push(selectedRows[i].Id);
                }
                swal({
                    title: gettextCatalog.getString('DeleteTeamMembers'),
                    text: gettextCatalog.getString('AreYouSureYouWantToDeleteTheTeamMembers'),
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: gettextCatalog.getString('Yes'),
                    cancelButtonText: gettextCatalog.getString('No')
                }).then(function (isConfirm) {
                    if (isConfirm.value) {
                        dataservice.deleteTeamMember(vm.csapat, out)
                            .then(function () {
                                getTeamMembersList();
                                log.successMsg('TeamMemberDeletedSuccess');
                            });
                    }
                });
            } else {
                log.errorMsg('YouHaveToSelectLeastAthlete');
            }
        }

        function goToAddTeamMember() {
            $state.go('athletes.teams.addTeamMember');
        }

        function goToNewAthlete(Id) {
            if (vm.MEGTSPORTLIST) {
                paramHelper.setParams([{'athleteModify.sportoloId': Id}, {'athleteNew.selectedSectionId': vm.szakosztaly}, {'athleteNew.selectedAgeGroupId': vm.korosztaly}]);
                $state.go('athletes.athletesManagement.athleteModify.dataSheet');
            } else {
                log.permissionError();
            }
        }
    }
})
();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.athletes.teams.teamMembersList')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'athletes.teams.teamMembersList',
                config: {
                    url: '/teamMembersList',
                    templateUrl: 'app/athletes/teams/teamMembersList/teamMembersList.html',
                    controller: 'TeamMembersListController',
                    controllerAs: 'vm',
                    title: 'TeamMembersList'
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.athletes.teams')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'athletes.teams',
                config: {
                    url: '/teams',
                    templateUrl: 'app/athletes/teams/teams.html'
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    config.$inject = ["$provide"];
    extendExceptionHandler.$inject = ["$delegate", "exceptionHandler", "logger", "$injector"];
    angular
        .module('blocks.exception')
        .provider('exceptionHandler', exceptionHandlerProvider)
        .config(config);

    /**
     * Must configure the exception handling
     */
    function exceptionHandlerProvider() {
        /* jshint validthis:true */
        this.config = {
            environment: undefined
        };

        this.configure = function (environment) {
            this.config.environment = environment;
        };

        this.$get = function () {
            return {config: this.config};
        };
    }

    function config($provide) {
        $provide.decorator('$exceptionHandler', extendExceptionHandler);
    }

    function extendExceptionHandler($delegate, exceptionHandler, logger, $injector) {
        return function (exception) {
            if (!(exception && typeof exception === 'object')) {
                return;
            }
            var object = {
                vm: null,
                stateList: null,
                actualState: null,
                localStorage: null,
                ClientSideException: null,
                title: null
            };
            var rootScope = $injector.get('$rootScope');
            var LS = $injector.get('localStorageService');
            var keys = LS.keys();
            var LSItems = [];
            keys.forEach(function (element) {
                LSItems.push(element + ': ' + LS.get(element));
            });

            var ClientSideException = {Message: '', stack: ''};
            if (exception.__proto__.hasOwnProperty('toString')) {
                ClientSideException.Message = exception.toString();
            }
            if (exception.hasOwnProperty('stack')) {
                ClientSideException.stack = exception.stack.toString();
            }
            object.localStorage = LSItems;
            object.actualState = rootScope.actualState;
            object.stateList = rootScope.stateList;
            object.title = rootScope.htmlTitle;
            object.ClientSideException = ClientSideException;
            var cloneVM = $.extend(true, {}, rootScope.vm);
            var cloneVMkeys = Object.keys(cloneVM);
            cloneVMkeys.forEach(function (vmKey) {
                try {
                    JSON.stringify(cloneVM[vmKey]);
                }
                catch (err) {
                    cloneVM[vmKey] = null;
                }
            });
            object.vm = cloneVM;

            if ((ClientSideException.Message.indexOf('LogClientSideException') != -1) || (ClientSideException.stack.indexOf('LogClientSideException') != -1)) {
                return;
            }

            var jsonObject = JSON.stringify(object);

            if (exceptionHandler.config.environment !== 'development') {
                var dataService = $injector.get('dataservice');
                dataService.sendLocalException(jsonObject).then(function () {});
            }

            if (exceptionHandler.config.environment === 'development') {
                //logger.error(exception);
                $delegate(exception);
            }
        };
    }
})();

(function () {
    'use strict';

    loggers.$inject = ["$log", "toastr"];
    angular
        .module('blocks.logger')
        .factory('logger', loggers)
        .provider('log', log);

    function loggers($log, toastr) {
        return {
            error: error,
            info: info,
            success: success,
            warning: warning
        };
        /////////////////////

        /**
         * Logging erros to console and sweetalert and toastr
         * @author Richard Keki
         * @param {string}   message
         * @param {string}   title
         * @param {string}   data
         */
        function error(message, title, data) {
            toastr.error(message);
            $log.error('Error: ', message, data);
            if (angular.isUndefined(title)) {
                title = 'Error';
            }
            swal({title: title, html: message, type: 'error'});
        }

        function info(message) {
            toastr.info(message);
            $log.info('Info: ', message);
        }

        function success(message) {
            toastr.success(message);
            $log.info('Success: ', message);
        }

        function warning(message) {
            toastr.warning(message);
            $log.warn('Warning: ', message);
        }
    }

    function log() {
        this.environment = ''; // jshint ignore: line

        this.setEnvironment = function (env) { // jshint ignore: line
            this.environment = env;
        };

        this.$get = ["$injector", function ($injector) { // jshint ignore: line
            var gettextCatalog = $injector.get('gettextCatalog');
            var $log = $injector.get('$log');
            var toastr = $injector.get('toastr');
            var env = this.environment;
            var $rootScope = $injector.get('$rootScope');
            return {
                permissionError: function (back) {
                    var message = gettextCatalog.getString('YouHaveNoPermissionToThisFunction');
                    var title = gettextCatalog.getString('PermissionDenied');
                    swal({title: title, html: message, type: 'error'});
                    if (env === 'development') {
                        $log.error(title + ': ', message);
                        toastr.error(message);
                    }
                    if (back === true) {
                        $rootScope.fromBack = true;
                        $rootScope.back();
                    }
                },

                errorMsg: function (message, data) {
                    message = gettextCatalog.getString(message);
                    var title = gettextCatalog.getString('Error');
                    if (env === 'development') {
                        toastr.error(message);
                        $log.error(title + ': ', message, data);
                    }
                    swal({title: title, html: message, type: 'error'});
                },

                htmlError: function (htmlMessage) {
                    var title = gettextCatalog.getString('Error');
                    if (env === 'development') {
                        toastr.error(htmlMessage);
                        $log.error(title + ': ' + htmlMessage);
                    }
                    swal({title: title, html: htmlMessage, type: 'error'});
                },

                infoMsg: function (message) {
                    message = gettextCatalog.getString(message);
                    var title = gettextCatalog.getString('Info');
                    toastr.info(message);
                    if (env === 'development') {
                        $log.info(title + ': ', message);
                    }
                },

                helpMsg: function (message) {
                    var title = '';
                    //var title = gettextCatalog.getString('Help');
                    swal({title: title, html: gettextCatalog.getString(message), type: 'info'});
                    if (env === 'development') {
                        $log.info(title + ': ', message);
                    }
                },

                helpMsgSmall: function (message) {
                    var title = '';
                    //var title = gettextCatalog.getString('Help');
                    swal({title: title, html: '<div style="font-size: 0.9em;">' + gettextCatalog.getString(message) + '</div>', type: 'info'});
                    if (env === 'development') {
                        $log.info(title + ': ', message);
                    }
                },

                successMsg: function (message) {
                    message = gettextCatalog.getString(message);
                    var title = gettextCatalog.getString('Success');
                    toastr.success(message);
                    if (env === 'development') {
                        $log.info(title + ': ', message);
                    }
                },

                htmlSuccess: function (htmlMessage) {
                    // = gettextCatalog.getString(message);
                    var title = gettextCatalog.getString('Success');
                    toastr.success(htmlMessage);
                    if (env === 'development') {
                        $log.info(title + ': ', htmlMessage);
                    }
                },

                warningMsg: function (message, hideSwal) {
                    message = gettextCatalog.getString(message);
                    var title = gettextCatalog.getString('Warning');
                    toastr.warning(message);
                    if (env === 'development') {
                        $log.warn(title + ': ', message);
                    }
                    if (!(hideSwal === true)) {
                        swal({title: title, html: message, type: 'warning'});
                    }
                },

                htmlWarning: function (message) {
                    //message = gettextCatalog.getString(message);
                    var title = gettextCatalog.getString('Warning');
                    toastr.warning(message);
                    if (env === 'development') {
                        $log.warn(title + ': ', message);
                    }
                    swal({title: title, html: message, type: 'warning'});
                }
            };
        }];
    }
}());

/* Help configure the state-base ui.router */
(function () {
    'use strict';

    routerHelperProvider.$inject = ["$locationProvider", "$stateProvider", "$urlRouterProvider"];
    angular
        .module('blocks.router')
        .provider('routerHelper', routerHelperProvider);

    function routerHelperProvider($locationProvider, $stateProvider, $urlRouterProvider) {
        /* jshint validthis:true */
        RouterHelper.$inject = ["$location", "$rootScope", "$state", "logger", "authenticationService"];
        var config = {
            docTitle: undefined,
            resolveAlways: {}
        };

        $locationProvider.html5Mode(false);

        this.configure = function (cfg) {
            angular.extend(config, cfg);
        };

        this.$get = RouterHelper;
        function RouterHelper($location, $rootScope, $state, logger, authenticationService) {
            var handlingStateChangeError = false;
            var hasOtherwise = false;
            var stateCounts = {
                errors: 0,
                changes: 0
            };

            var service = {
                configureStates: configureStates,
                getStates: getStates,
                stateCounts: stateCounts
            };

            init();

            return service;

            ///////////////

            function configureStates(states, otherwisePath) {
                states.forEach(function (state) {
                    state.config.resolve =
                        angular.extend(state.config.resolve || {}, config.resolveAlways);
                    $stateProvider.state(state.state, state.config);
                });
                if (otherwisePath && !hasOtherwise) {
                    hasOtherwise = true;
                    $urlRouterProvider.otherwise(otherwisePath);
                }
            }

            function handleRoutingErrors() {
                // Route cancellation:
                // On routing error, go to the dashboard.
                // Provide an exit clause if it tries to do it twice.
                $rootScope.$on('$stateChangeError',
                               function (event, toState, toParams, fromState, fromParams, error) {
                    if (handlingStateChangeError) {
                        return;
                    }
                    stateCounts.errors++;
                    handlingStateChangeError = true;
                    var destination = toState && (toState.title || toState.name || toState.loadedTemplateUrl) || 'unknown target';
                    var msg = 'Error routing to ' + destination + '. ' +
                        (error.data || '') + '. <br/>' + (error.statusText || '') +
                        ': ' + (error.status || '');
                    logger.warning(msg, [toState]);
                    $location.path('/');
                }
                              );
            }

            function init() {
                handleRoutingErrors();
                updateDocTitle();
            }

            function getStates() {
                return $state.get();
            }

            function updateDocTitle() {
                $rootScope.$on('$stateChangeSuccess',
                               function () { // paraméterek: event, toState, toParams, fromState, fromParams
                    if (!authenticationService.isAuthenticated()) {
                        $state.go('login');
                        return;
                    }
                    stateCounts.changes++;
                    handlingStateChangeError = false;
                    //var title = config.docTitle + ' ';
                    //$rootScope.title = title; // data bind to <title>
                }
                              );
            }
        }
    }
})();

(function () {
    'use strict';

    AnnualEducationalFeeByAthletesController.$inject = ["log", "dataservice", "$q", "$rootScope", "gettextCatalog", "authenticationService", "$scope", "$state", "paramHelper"];
    angular
        .module('app.business.annualEducationalFeeByAthletes')
        .controller('AnnualEducationalFeeByAthletesController', AnnualEducationalFeeByAthletesController);

    function AnnualEducationalFeeByAthletesController(log, dataservice, $q, $rootScope, gettextCatalog, authenticationService, $scope, $state, paramHelper) {
        var vm = this; $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('AnnualEducationalFeeByAthletes');

        // Create variables
        vm.data = [];
        vm.yearList = dataservice.range(2000, new Date().getFullYear());
        vm.year = new Date().getFullYear();

        vm.summaryRows = [{
            columns: [
                {
                    type: 'Sum',
                    field: 'Elvart',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'Tenyleges',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                }
            ]
        }];
        vm.columns = [
            {field: 'Id', isPrimaryKey: true, visible: false},
            {
                field: 'SportoloNeve', headerText: gettextCatalog.getString('Athlete'), width: 100,
                template: '#annualeducationalfeebyathletecolumnTemplate1'
            },
            {
                field: 'EdzoNeve', headerText: gettextCatalog.getString('Coach'), width: 100,
                template: '#annualeducationalfeebyathletecolumnTemplate2'
            },
            {field: 'SzakosztalyNeve', headerText: gettextCatalog.getString('Section'), width: 100},
            {
                field: 'Elvart',
                headerText: gettextCatalog.getString('Elvart'),
                textAlign: 'left',
                width: 100,
                format: 'N0'
            },
            {
                field: 'Tenyleges',
                headerText: gettextCatalog.getString('Tenyleges'),
                textAlign: 'left',
                width: 100,
                format: 'N0'
            }
        ];

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItemsWithSearch,
            allowPaging: true,
            editSettings: {allowEditing: true, mode: 'Batch', showConfirmDialog: false},
            allowTextWrap: true,
            allowSorting: true,
            allowExcelExport: true,
            allowDeleting: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            aggregates: vm.summaryRows,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#Grid'), $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        // Public functions
        vm.getDatas = getDatas;
        vm.goToAthlete = goToAthlete;
        vm.openCoach = openCoach;

        // Activate page
        activate();

        function activate() {
            var promises = [authenticationService.getRight('OKTOSSZSP')];
            $q.all(promises).then(function (result) {
                if (result[0] !== true) {
                    log.permissionError(true);
                } else {
                    getDatas();
                }
            });
        }

        function getDatas() {
            dataservice.getAnnualEducationalFeeByAthletes(vm.year).then(function (data) {
                vm.data = data.itemsList;
                grid.dataSource = vm.data;
            });
        }

        function goToAthlete(id) {
            $q.all([authenticationService.getRight('MEGTSPORTLIST')]).then(function (results) {
                if (results[0]) {
                    paramHelper.setParams([{'athleteModify.sportoloId': id}]);
                    $state.go('athletes.athletesManagement.athleteModify.dataSheet');
                } else {
                    log.permissionError();
                }
            });
        }

        function openCoach(edzoId) {
            $q.all([authenticationService.getRight('MODFELH'), authenticationService.getRight('MEGTFELH')]).then(function (results) {
                if (results[0] || results[1]) {
                    paramHelper.setParams([{'newUser.userId': edzoId}]);
                    $state.go('settings.userManagement.modifyUser');
                } else {
                    log.permissionError();
                }
            });
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.business.annualEducationalFeeByAthletes')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'business.annualEducationalFeeByAthletes',
                config: {
                    url: '/annualEducationalFeeByAthletes',
                    templateUrl: 'app/business/annualEducationalFeeByAthletes/annualEducationalFeeByAthletes.html',
                    controller: 'AnnualEducationalFeeByAthletesController',
                    controllerAs: 'vm',
                    title: 'AnnualEducationalFeeByAthletes',
                    settings: {
                        navId: 2163,
                        level: 2,
                        order: 16,
                        orderTitle_hu: 'Oktatási díj összesítés sportolónként',
                        orderTitle_en: 'Annual Educational Fee by Coach',
                        parentId: 3,
                        content: 'AnnualEducationalFeeByAthletes',
                        permission: ['7'],
                        activatorPermission: '"OKTOSSZSP"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    AnnualEducationalFeeByCoachController.$inject = ["log", "dataservice", "$q", "$rootScope", "gettextCatalog", "authenticationService", "$scope", "$state", "paramHelper"];
    angular
        .module('app.business.annualEducationalFeeByCoach')
        .controller('AnnualEducationalFeeByCoachController', AnnualEducationalFeeByCoachController);

    function AnnualEducationalFeeByCoachController(log, dataservice, $q, $rootScope, gettextCatalog, authenticationService, $scope, $state, paramHelper) {
        var vm = this; $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('AnnualEducationalFeeByCoach');

        // Create variables
        vm.data = [];
        vm.yearList = dataservice.range(2000, new Date().getFullYear());
        vm.year = new Date().getFullYear();

        vm.summaryRows = [{
            columns: [
                {
                    type: 'Sum',
                    field: 'Elvart',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'Tenyleges',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'E1',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'T1',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'E2',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'T2',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'E3',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'T3',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'E4',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'T4',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'E5',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'T5',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'E6',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'T6',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'E7',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'T7',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'E8',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'T8',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'E9',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'T9',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'E10',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'T10',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'E11',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'T11',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'E12',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'T12',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                }
            ]
        }];

        vm.columns = [
            {field: 'Id', isPrimaryKey: true, visible: false},
            {field: 'EdzoNeve', headerText: gettextCatalog.getString('Coach'), width: 150,
                template: '#annualeducationalfeebycoachcolumnTemplate'},
            {field: 'SzakosztalyNeve', headerText: gettextCatalog.getString('Section'), width: 130},
            {field: 'Elvart', headerText: gettextCatalog.getString('Elvart'), textAlign: 'left', width: 100, format: 'N0'},
            {field: 'Tenyleges', headerText: gettextCatalog.getString('Tenyleges'), textAlign: 'left', width: 120, format: 'N0'},
            {field: 'E1', headerText: gettextCatalog.getString('January') + ' E1', textAlign: 'center', width: 100, format: 'N0'},
            {field: 'T1', headerText: gettextCatalog.getString('January') + ' T1', textAlign: 'center', width: 100, format: 'N0'},
            {field: 'E2', headerText: gettextCatalog.getString('February') + ' E2', textAlign: 'center', width: 100, format: 'N0'},
            {field: 'T2', headerText: gettextCatalog.getString('February') + ' T2', textAlign: 'center', width: 100, format: 'N0'},
            {field: 'E3', headerText: gettextCatalog.getString('March') + ' E3', textAlign: 'center', width: 100, format: 'N0'},
            {field: 'T3', headerText: gettextCatalog.getString('March') + ' T3', textAlign: 'center', width: 100, format: 'N0'},
            {field: 'E4', headerText: gettextCatalog.getString('April') + ' E4', textAlign: 'center', width: 100, format: 'N0'},
            {field: 'T4', headerText: gettextCatalog.getString('April') + ' T4', textAlign: 'center', width: 100, format: 'N0'},
            {field: 'E5', headerText: gettextCatalog.getString('May') + ' E5', textAlign: 'center', width: 100, format: 'N0'},
            {field: 'T5', headerText: gettextCatalog.getString('May') + ' T5', textAlign: 'center', width: 100, format: 'N0'},
            {field: 'E6', headerText: gettextCatalog.getString('June') + ' E6', textAlign: 'center', width: 100, format: 'N0'},
            {field: 'T6', headerText: gettextCatalog.getString('June') + ' T6', textAlign: 'center', width: 100, format: 'N0'},
            {field: 'E7', headerText: gettextCatalog.getString('July') + ' E7', textAlign: 'center', width: 100, format: 'N0'},
            {field: 'T7', headerText: gettextCatalog.getString('July') + ' T7', textAlign: 'center', width: 100, format: 'N0'},
            {field: 'E8', headerText: gettextCatalog.getString('August') + ' E8', textAlign: 'center', width: 100, format: 'N0'},
            {field: 'T8', headerText: gettextCatalog.getString('August') + ' T8', textAlign: 'center', width: 100, format: 'N0'},
            {field: 'E9', headerText: gettextCatalog.getString('September') + ' E9', textAlign: 'center', width: 100, format: 'N0'},
            {field: 'T9', headerText: gettextCatalog.getString('September') + ' T9', textAlign: 'center', width: 100, format: 'N0'},
            {field: 'E10', headerText: gettextCatalog.getString('October') + ' E10', textAlign: 'center', width: 100, format: 'N0'},
            {field: 'T10', headerText: gettextCatalog.getString('October') + ' T10', textAlign: 'center', width: 100, format: 'N0'},
            {field: 'E11', headerText: gettextCatalog.getString('November') + ' E11', textAlign: 'center', width: 100, format: 'N0'},
            {field: 'T11', headerText: gettextCatalog.getString('November') + ' T11', textAlign: 'center', width: 100, format: 'N0'},
            {field: 'E12', headerText: gettextCatalog.getString('December') + ' E12', textAlign: 'center', width: 100, format: 'N0'},
            {field: 'T12', headerText: gettextCatalog.getString('December') + ' T12', textAlign: 'center', width: 100, format: 'N0'}
        ];

        // Public functions
        vm.getDatas = getDatas;
        vm.openCoach = openCoach;

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItemsWithSearch,
            allowPaging: true,
            editSettings: {allowEditing: true, mode: 'Batch', showConfirmDialog: false},
            allowTextWrap: true,
            allowSorting: true,
            allowExcelExport: true,
            allowDeleting: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            aggregates: vm.summaryRows,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile(angular.element('#Grid'), $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };
        // Activate page
        activate();

        function activate() {
            var promises = [authenticationService.getRight('OKTOSSZEDZO')];
            $q.all(promises).then(function (result) {
                if (result[0] !== true) {
                    log.permissionError(true);
                } else {
                    getDatas();
                }
            });
        }

        function getDatas() {
            dataservice.getAnnualEducationalFeeByCoach(vm.year).then(function(data) {
                vm.data = data.itemsList;
                grid.dataSource = vm.data;
            });
        }

        function openCoach(edzoId) {
            $q.all([authenticationService.getRight('MODFELH'), authenticationService.getRight('MEGTFELH')]).then(function (results) {
                if (results[0] || results[1]) {
                    paramHelper.setParams([{'newUser.userId': edzoId}]);
                    $state.go('settings.userManagement.modifyUser');
                } else {
                    log.permissionError();
                }
            });
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.business.annualEducationalFeeByCoach')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'business.annualEducationalFeeByCoach',
                config: {
                    url: '/annualEducationalFeeByCoach',
                    templateUrl: 'app/business/annualEducationalFeeByCoach/annualEducationalFeeByCoach.html',
                    controller: 'AnnualEducationalFeeByCoachController',
                    controllerAs: 'vm',
                    title: 'AnnualEducationalFeeByCoach',
                    settings: {
                        navId: 2153,
                        level: 2,
                        order: 15,
                        orderTitle_hu: 'Oktatási díj összesítés edzőnként',
                        orderTitle_en: 'Annual Educational Fee by Coach',
                        parentId: 3,
                        content: 'AnnualEducationalFeeByCoach',
                        permission: ['7'],
                        activatorPermission: '"OKTOSSZEDZO"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    AnnualEducationalFeeByOneSectionController.$inject = ["log", "dataservice", "$q", "$rootScope", "gettextCatalog", "authenticationService", "$scope", "$state", "paramHelper"];
    angular
        .module('app.business.annualEducationalFeeByOneSection')
        .controller('AnnualEducationalFeeByOneSectionController', AnnualEducationalFeeByOneSectionController);

    function AnnualEducationalFeeByOneSectionController(log, dataservice, $q, $rootScope, gettextCatalog, authenticationService, $scope, $state, paramHelper) {
        var vm = this;
        $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('AnnualEducationalFeeByOneSection');

        vm.summaryRows = [{
            columns: [
                {
                    type: 'Sum',
                    field: 'EdzoNeve',
                    groupFooterTemplate: gettextCatalog.getString('Sum')
                },
                {
                    type: 'Sum',
                    field: 'Elvart',
                    groupFooterTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'Tenyleges',
                    groupFooterTemplate: '${Sum}',
                    format: 'N0'
                }
            ]
        }];

        vm.columns = [
            {field: 'Id', isPrimaryKey: true, visible: false},
            {
                field: 'EdzoNeve',
                headerText: gettextCatalog.getString('Coach'),
                width: 100,
                template: '#annualeducationalfeebyonesectioncolumnTemplate'
            },
            {
                field: 'Elvart',
                headerText: gettextCatalog.getString('Elvart'),
                textAlign: 'left',
                width: 100,
                groupFooterTemplate: 'Total freight: ${Sum}',
                format: 'N0'
            },
            {
                field: 'Tenyleges',
                headerText: gettextCatalog.getString('Tenyleges'),
                textAlign: 'left',
                width: 100,
                format: 'N0'
            },
            {field: 'Year', headerText: gettextCatalog.getString('Year'), visible: false}
        ];

        var grid = new ej2.grids.Grid({
            dataSource: [],
            allowExcelExport: true,
            allowTextWrap: true,
            allowPaging: true,
            allowSorting: true,
            allowGrouping: true,
            toolbar: $rootScope.toolbarItems,
            groupSettings: {showDropArea: false, columns: ['Year']},
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            locale: 'hu-HU',
            aggregates: vm.summaryRows,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'searching' || args.requestType === 'refresh') {
                    $rootScope.compile(grid, $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        // Public functions
        vm.getDatas = getDatas;
        vm.sectionSelect = sectionSelect;
        vm.openCoach = openCoach;

        // Activate page
        activate();

        function activate() {
            var promises = [authenticationService.getRight('SZAKOKTDIJBEF')];
            $q.all(promises).then(function (result) {
                if (result[0] !== true) {
                    log.permissionError(true);
                } else {
                    getSections();
                }
            });
        }

        // Get sections' list
        function getSections() {
            return dataservice.sectionDropDownList().then(function (data) {
                vm.sectionList = data.itemsList;
            });
        }

        // Run after section selected
        function sectionSelect(args) {
            vm.sectionId = args.value;
            getDatas();
        }

        function getDatas() {
            dataservice.getAnnualEducationalFeeByOneSection(vm.sectionId).then(function (data) {
                grid.dataSource = data.itemsList;
            });
        }

        function openCoach(edzoId) {
            $q.all([authenticationService.getRight('MODFELH'), authenticationService.getRight('MEGTFELH')]).then(function (results) {
                if (results[0] || results[1]) {
                    paramHelper.setParams([{'newUser.userId': edzoId}]);
                    $state.go('settings.userManagement.modifyUser');
                } else {
                    log.permissionError();
                }
            });
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.business.annualEducationalFeeByOneSection')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'business.annualEducationalFeeByOneSection',
                config: {
                    url: '/annualEducationalFeeByOneSection',
                    templateUrl: 'app/business/annualEducationalFeeByOneSection/annualEducationalFeeByOneSection.html',
                    controller: 'AnnualEducationalFeeByOneSectionController',
                    controllerAs: 'vm',
                    title: 'AnnualEducationalFeeByOneSection',
                    settings: {
                        navId: 2173,
                        level: 2,
                        order: 17,
                        orderTitle_hu: 'Szakosztályonkénti oktatási díj befizetések',
                        orderTitle_en: 'Annual Educational Fee by One Section',
                        parentId: 3,
                        content: 'AnnualEducationalFeeByOneSection',
                        activatorPermission: '"SZAKOKTDIJBEF"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    AnnualEducationalFeeBySectionController.$inject = ["log", "dataservice", "$q", "$rootScope", "gettextCatalog", "authenticationService", "$scope"];
    angular
        .module('app.business.annualEducationalFeeBySection')
        .controller('AnnualEducationalFeeBySectionController', AnnualEducationalFeeBySectionController);

    function AnnualEducationalFeeBySectionController(log, dataservice, $q, $rootScope, gettextCatalog, authenticationService, $scope) {
        var vm = this;
        $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('AnnualEducationalFeeBySection');

        // Create variables
        vm.yearList = dataservice.range(2000, new Date().getFullYear());
        vm.year = new Date().getFullYear();

        vm.summaryRows = [{
            columns: [
                {
                    type: 'Sum',
                    field: 'SzakosztalyNeve',
                    footerTemplate: gettextCatalog.getString('Sum')
                },
                {
                    type: 'Sum',
                    field: 'Elvart',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'Tenyleges',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'E1',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'T1',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'E2',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'T2',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'E3',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'T3',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'E4',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'T4',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'E5',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'T5',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'E6',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'T6',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'E7',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'T7',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'E8',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'T8',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'E9',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'T9',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'E10',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'E11',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'E11',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'T11',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'E12',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'T12',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                }
            ]
        }];
        vm.columns = [
            {field: 'Id', isPrimaryKey: true, visible: false},
            {field: 'SzakosztalyNeve', headerText: gettextCatalog.getString('Section'), width: 140},
            {
                field: 'Elvart',
                headerText: gettextCatalog.getString('ElvartOssz'),
                textAlign: 'center',
                width: 140,
                format: 'N0'
            },
            {
                field: 'Tenyleges',
                headerText: gettextCatalog.getString('TenylegesOssz'),
                textAlign: 'center',
                width: 140,
                format: 'N0'
            },
            {
                field: 'E1',
                headerText: gettextCatalog.getString('January') + ' E1',
                textAlign: 'center',
                width: 140,
                format: 'N0'
            },
            {
                field: 'T1',
                headerText: gettextCatalog.getString('January') + ' T1',
                textAlign: 'center',
                width: 140,
                format: 'N0'
            },
            {
                field: 'E2',
                headerText: gettextCatalog.getString('February') + ' E2',
                textAlign: 'center',
                width: 140,
                format: 'N0'
            },
            {
                field: 'T2',
                headerText: gettextCatalog.getString('February') + ' T2',
                textAlign: 'center',
                width: 140,
                format: 'N0'
            },
            {
                field: 'E3',
                headerText: gettextCatalog.getString('March') + ' E3',
                textAlign: 'center',
                width: 140,
                format: 'N0'
            },
            {
                field: 'T3',
                headerText: gettextCatalog.getString('March') + ' T3',
                textAlign: 'center',
                width: 140,
                format: 'N0'
            },
            {
                field: 'E4',
                headerText: gettextCatalog.getString('April') + ' E4',
                textAlign: 'center',
                width: 140,
                format: 'N0'
            },
            {
                field: 'T4',
                headerText: gettextCatalog.getString('April') + ' T4',
                textAlign: 'center',
                width: 140,
                format: 'N0'
            },
            {
                field: 'E5',
                headerText: gettextCatalog.getString('May') + ' E5',
                textAlign: 'center',
                width: 140,
                format: 'N0'
            },
            {
                field: 'T5',
                headerText: gettextCatalog.getString('May') + ' T5',
                textAlign: 'center',
                width: 140,
                format: 'N0'
            },
            {
                field: 'E6',
                headerText: gettextCatalog.getString('June') + ' E6',
                textAlign: 'center',
                width: 140,
                format: 'N0'
            },
            {
                field: 'T6',
                headerText: gettextCatalog.getString('June') + ' T6',
                textAlign: 'center',
                width: 140,
                format: 'N0'
            },
            {
                field: 'E7',
                headerText: gettextCatalog.getString('July') + ' E7',
                textAlign: 'center',
                width: 140,
                format: 'N0'
            },
            {
                field: 'T7',
                headerText: gettextCatalog.getString('July') + ' T7',
                textAlign: 'center',
                width: 140,
                format: 'N0'
            },
            {
                field: 'E8',
                headerText: gettextCatalog.getString('August') + ' E8',
                textAlign: 'center',
                width: 140,
                format: 'N0'
            },
            {
                field: 'T8',
                headerText: gettextCatalog.getString('August') + ' T8',
                textAlign: 'center',
                width: 140,
                format: 'N0'
            },
            {
                field: 'E9',
                headerText: gettextCatalog.getString('September') + ' E9',
                textAlign: 'center',
                width: 140,
                format: 'N0'
            },
            {
                field: 'T9',
                headerText: gettextCatalog.getString('September') + ' T9',
                textAlign: 'center',
                width: 140,
                format: 'N0'
            },
            {
                field: 'E10',
                headerText: gettextCatalog.getString('October') + ' E10',
                textAlign: 'center',
                width: 140,
                format: 'N0'
            },
            {
                field: 'T10',
                headerText: gettextCatalog.getString('October') + ' T10',
                textAlign: 'center',
                width: 140,
                format: 'N0'
            },
            {
                field: 'E11',
                headerText: gettextCatalog.getString('November') + ' E11',
                textAlign: 'center',
                width: 140,
                format: 'N0'
            },
            {
                field: 'T11',
                headerText: gettextCatalog.getString('November') + ' T11',
                textAlign: 'center',
                width: 140,
                format: 'N0'
            },
            {
                field: 'E12',
                headerText: gettextCatalog.getString('December') + ' E12',
                textAlign: 'center',
                width: 140,
                format: 'N0'
            },
            {
                field: 'T12',
                headerText: gettextCatalog.getString('December') + ' T12',
                textAlign: 'center',
                width: 140,
                format: 'N0'
            }
        ];

        var grid = new ej2.grids.Grid({
            columns: vm.columns,
            dataSource: [],
            allowTextWrap: true,
            allowPaging: true,
            allowSorting: true,
            toolbar: $rootScope.toolbarItemsWithSearch,
            pageSettings: $rootScope.pageSettings,
            allowExcelExport: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            aggregates: vm.summaryRows,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'searching' || args.requestType === 'refresh') {
                    $rootScope.compile(grid, $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            console.log('args', args);
            console.log('grid', grid);
            $rootScope.toolbarClick(args, grid);
        };

        // Public functions
        vm.getDatas = getDatas;

        // Activate page
        activate();

        function activate() {
            var promises = [authenticationService.getRight('OKTOSSZSZAKO')];
            $q.all(promises).then(function (result) {
                if (result[0] !== true) {
                    log.permissionError(true);
                } else {
                    getDatas();
                }
            });
        }

        function getDatas() {
            dataservice.getAnnualEducationalFeeBySection(vm.year).then(function (data) {
                grid.dataSource = data.itemsList;
            });
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.business.annualEducationalFeeBySection')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'business.annualEducationalFeeBySection',
                config: {
                    url: '/annualEducationalFeeBySection',
                    templateUrl: 'app/business/annualEducationalFeeBySection/annualEducationalFeeBySection.html',
                    controller: 'AnnualEducationalFeeBySectionController',
                    controllerAs: 'vm',
                    title: 'AnnualEducationalFeeBySection',
                    settings: {
                        navId: 2143,
                        level: 2,
                        order: 14,
                        orderTitle_hu: 'Oktatási díj összesítés szakosztályonként',
                        orderTitle_en: 'Annual Educational Fee by Section',
                        parentId: 3,
                        content: 'AnnualEducationalFeeBySection',
                        permission: ['7'],
                        activatorPermission: '"OKTOSSZSZAKO"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    AnnualSportServiceFeeByAthletesController.$inject = ["log", "dataservice", "$q", "$rootScope", "gettextCatalog", "authenticationService", "$scope", "$state", "paramHelper"];
    angular
        .module('app.business.annualSportServiceFeeByAthletes')
        .controller('AnnualSportServiceFeeByAthletesController', AnnualSportServiceFeeByAthletesController);

    function AnnualSportServiceFeeByAthletesController(log, dataservice, $q, $rootScope, gettextCatalog, authenticationService, $scope, $state, paramHelper) {
        var vm = this; $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('AnnualSportServiceFeeByAthletes');

        // Create variables
        vm.yearList = dataservice.range(2000, new Date().getFullYear());
        vm.year = new Date().getFullYear();

        vm.summaryRows = [{
            columns: [
                {
                    type: 'Sum',
                    field: 'Elvart',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'Tenyleges',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                }
            ]
        }];
        vm.columns = [
            {field: 'Id', isPrimaryKey: true, visible: false},
            {field: 'SportoloNeve', headerText: gettextCatalog.getString('Athlete'), width: 100,
            template: '#annualsportservicefeebyathletecolumnTemplate1'},
            {field: 'EdzoNeve', headerText: gettextCatalog.getString('Coach'), width: 100,
            template: '#annualsportservicefeebyathletecolumnTemplate2'},
            {field: 'SzakosztalyNeve', headerText: gettextCatalog.getString('Section'), width: 100},
            {field: 'Elvart', headerText: gettextCatalog.getString('Elvart'), textAlign: 'left', width: 100, format: 'N0'},
            {field: 'Tenyleges', headerText: gettextCatalog.getString('Tenyleges'), textAlign: 'left', width: 100, format: 'N0'}
        ];

        // Public functions
        vm.getDatas = getDatas;
        vm.goToAthlete = goToAthlete;
        vm.openCoach = openCoach;

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItemsWithSearch,
            allowPaging: true,
            editSettings: {allowEditing: true, mode: 'Batch', showConfirmDialog: false},
            allowTextWrap: true,
            allowSorting: true,
            allowExcelExport: true,
            allowDeleting: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            aggregates: vm.summaryRows,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#Grid'), $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        // Activate page
        activate();

        function activate() {
            var promises = [authenticationService.getRight('MEGTTAGDOSP')];
            $q.all(promises).then(function (result) {
                if (result[0] !== true) {
                    log.permissionError(true);
                } else {
                    getDatas();
                }
            });
        }

        function getDatas() {
            dataservice.getAnnualSportServiceFeeByAthletes(vm.year).then(function(data) {
                grid.dataSource = data.itemsList;
            });
        }

        function goToAthlete(id) {
            $q.all([authenticationService.getRight('MEGTSPORTLIST')]).then(function (results) {
                if (results[0]) {
                    paramHelper.setParams([{'athleteModify.sportoloId': id}]);
                    $state.go('athletes.athletesManagement.athleteModify.dataSheet');
                } else {
                    log.permissionError();
                }
            });
        }

        function openCoach(edzoId) {
            $q.all([authenticationService.getRight('MODFELH'), authenticationService.getRight('MEGTFELH')]).then(function (results) {
                if (results[0] || results[1]) {
                    paramHelper.setParams([{'newUser.userId': edzoId}]);
                    $state.go('settings.userManagement.modifyUser');
                } else {
                    log.permissionError();
                }
            });
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.business.annualSportServiceFeeByAthletes')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'business.annualSportServiceFeeByAthletes',
                config: {
                    url: '/annualSportServiceFeeByAthletes',
                    templateUrl: 'app/business/annualSportServiceFeeByAthletes/annualSportServiceFeeByAthletes.html',
                    controller: 'AnnualSportServiceFeeByAthletesController',
                    controllerAs: 'vm',
                    title: 'AnnualSportServiceFeeByAthletes',
                    settings: {
                        navId: 2123,
                        level: 2,
                        order: 12,
                        orderTitle_hu: 'Sportszolgáltatási díj összesítés sportolónként',
                        orderTitle_en: 'Annual Sport Service Fee by Athlets',
                        parentId: 3,
                        content: 'AnnualSportServiceFeeByAthletes',
                        activatorPermission: '"MEGTTAGDOSP"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    AnnualSportServiceFeeByCoachController.$inject = ["log", "dataservice", "$q", "$rootScope", "gettextCatalog", "authenticationService", "$scope", "$state", "paramHelper"];
    angular
        .module('app.business.annualSportServiceFeeByCoach')
        .controller('AnnualSportServiceFeeByCoachController', AnnualSportServiceFeeByCoachController);

    function AnnualSportServiceFeeByCoachController(log, dataservice, $q, $rootScope, gettextCatalog, authenticationService, $scope, $state, paramHelper) {
        var vm = this; $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('AnnualSportServiceFeeByCoach');

        // Create variables
        vm.data = [];
        vm.yearList = dataservice.range(2000, new Date().getFullYear());
        vm.year = new Date().getFullYear();

        vm.summaryRows = [{
            columns: [
                {
                    type: 'Sum',
                    field: 'Elvart',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'Tenyleges',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'E1',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'T1',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'E2',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'T2',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'E3',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'T3',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'E4',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'T4',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'E5',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'T5',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'E6',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'T6',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'E7',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'T7',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'E8',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'T8',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'E9',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'T9',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'E10',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'T10',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'E11',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'T11',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'E12',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'T12',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                }
            ]
        }];

        vm.columns = [
            {field: 'Id', isPrimaryKey: true, visible: false},
            {field: 'EdzoNeve', headerText: gettextCatalog.getString('Coach'), width: 150,
                template: '#annualsportservicefeebycoachcolumnTemplate'},
            {field: 'SzakosztalyNeve', headerText: gettextCatalog.getString('Section'), width: 130},
            {field: 'Elvart', headerText: gettextCatalog.getString('ElvartOssz'), textAlign: 'left', width: 120, format: 'N0'},
            {field: 'Tenyleges', headerText: gettextCatalog.getString('TenylegesOssz'), textAlign: 'left', width: 120, format: 'N0'},
            {field: 'E1', headerText: gettextCatalog.getString('January') + ' E1', textAlign: 'center', width: 100, format: 'N0'},
            {field: 'T1', headerText: gettextCatalog.getString('January') + ' T1', textAlign: 'center', width: 100, format: 'N0'},
            {field: 'E2', headerText: gettextCatalog.getString('February') + ' E2', textAlign: 'center', width: 100, format: 'N0'},
            {field: 'T2', headerText: gettextCatalog.getString('February') + ' T2', textAlign: 'center', width: 100, format: 'N0'},
            {field: 'E3', headerText: gettextCatalog.getString('March') + ' E3', textAlign: 'center', width: 100, format: 'N0'},
            {field: 'T3', headerText: gettextCatalog.getString('March') + ' T3', textAlign: 'center', width: 100, format: 'N0'},
            {field: 'E4', headerText: gettextCatalog.getString('April') + ' E4', textAlign: 'center', width: 100, format: 'N0'},
            {field: 'T4', headerText: gettextCatalog.getString('April') + ' T4', textAlign: 'center', width: 100, format: 'N0'},
            {field: 'E5', headerText: gettextCatalog.getString('May') + ' E5', textAlign: 'center', width: 100, format: 'N0'},
            {field: 'T5', headerText: gettextCatalog.getString('May') + ' T5', textAlign: 'center', width: 100, format: 'N0'},
            {field: 'E6', headerText: gettextCatalog.getString('June') + ' E6', textAlign: 'center', width: 100, format: 'N0'},
            {field: 'T6', headerText: gettextCatalog.getString('June') + ' T6', textAlign: 'center', width: 100, format: 'N0'},
            {field: 'E7', headerText: gettextCatalog.getString('July') + ' E7', textAlign: 'center', width: 100, format: 'N0'},
            {field: 'T7', headerText: gettextCatalog.getString('July') + ' T7', textAlign: 'center', width: 100, format: 'N0'},
            {field: 'E8', headerText: gettextCatalog.getString('August') + ' E8', textAlign: 'center', width: 100, format: 'N0'},
            {field: 'T8', headerText: gettextCatalog.getString('August') + ' T8', textAlign: 'center', width: 100, format: 'N0'},
            {field: 'E9', headerText: gettextCatalog.getString('September') + ' E9', textAlign: 'center', width: 100, format: 'N0'},
            {field: 'T9', headerText: gettextCatalog.getString('September') + ' T9', textAlign: 'center', width: 100, format: 'N0'},
            {field: 'E10', headerText: gettextCatalog.getString('October') + ' E10', textAlign: 'center', width: 100, format: 'N0'},
            {field: 'T10', headerText: gettextCatalog.getString('October') + ' T10', textAlign: 'center', width: 100, format: 'N0'},
            {field: 'E11', headerText: gettextCatalog.getString('November') + ' E11', textAlign: 'center', width: 100, format: 'N0'},
            {field: 'T11', headerText: gettextCatalog.getString('November') + ' T11', textAlign: 'center', width: 100, format: 'N0'},
            {field: 'E12', headerText: gettextCatalog.getString('December') + ' E12', textAlign: 'center', width: 100, format: 'N0'},
            {field: 'T12', headerText: gettextCatalog.getString('December') + ' T12', textAlign: 'center', width: 100, format: 'N0'}
        ];

        // Public functions
        vm.getDatas = getDatas;
        vm.openCoach = openCoach;

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItemsWithSearch,
            allowPaging: true,
            editSettings: {allowEditing: true, mode: 'Batch', showConfirmDialog: false},
            allowTextWrap: true,
            allowSorting: true,
            allowExcelExport: true,
            allowDeleting: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            aggregates: vm.summaryRows,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile(angular.element('#Grid'), $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        // Activate page
        activate();

        function activate() {
            var promises = [authenticationService.getRight('MEGTTAGDOED')];
            $q.all(promises).then(function (result) {
                if (result[0] !== true) {
                    log.permissionError(true);
                } else {
                    getDatas();
                }
            });
        }

        function getDatas() {
            dataservice.getAnnualSportServiceFeeByCoach(vm.year).then(function(data) {
                vm.data = data.itemsList;
                grid.dataSource = vm.data;
            });
        }

        function openCoach(edzoId) {
            $q.all([authenticationService.getRight('MODFELH'), authenticationService.getRight('MEGTFELH')]).then(function (results) {
                if (results[0] || results[1]) {
                    paramHelper.setParams([{'newUser.userId': edzoId}]);
                    $state.go('settings.userManagement.modifyUser');
                } else {
                    log.permissionError();
                }
            });
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.business.annualSportServiceFeeByCoach')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'business.annualSportServiceFeeByCoach',
                config: {
                    url: '/annualSportServiceFeeByCoach',
                    templateUrl: 'app/business/annualSportServiceFeeByCoach/annualSportServiceFeeByCoach.html',
                    controller: 'AnnualSportServiceFeeByCoachController',
                    controllerAs: 'vm',
                    title: 'AnnualSportServiceFeeByCoach',
                    settings: {
                        navId: 2113,
                        level: 2,
                        order: 11,
                        orderTitle_hu: 'Sportszoláltatási díj összesítés edzőnként',
                        orderTitle_en: 'Annual Sport Service Fee by Coach',
                        parentId: 3,
                        content: 'AnnualSportServiceFeeByCoach',
                        activatorPermission: '"MEGTTAGDOED"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    AnnualSportServiceFeeByOneSectionController.$inject = ["log", "dataservice", "$q", "$rootScope", "gettextCatalog", "authenticationService", "$scope", "$state", "paramHelper"];
    angular
        .module('app.business.annualSportServiceFeeByOneSection')
        .controller('AnnualSportServiceFeeByOneSectionController', AnnualSportServiceFeeByOneSectionController);

    function AnnualSportServiceFeeByOneSectionController(log, dataservice, $q, $rootScope, gettextCatalog, authenticationService, $scope, $state, paramHelper) {
        var vm = this;
        $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('AnnualSportServiceFeeByOneSection');

        vm.summaryRows = [{
            columns: [
                {
                    type: 'Sum',
                    field: 'Elvart',
                    groupFooterTemplate: gettextCatalog.getString('Sum') + ': ${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'Tenyleges',
                    groupFooterTemplate: gettextCatalog.getString('Sum') + ': ${Sum}',
                    format: 'N0'
                }
            ]
        }];
        vm.columns = [
            {field: 'Id', isPrimaryKey: true, visible: false},
            {
                field: 'EdzoNeve',
                headerText: gettextCatalog.getString('Coach'),
                width: 100,
                template: '#annualsportservicefeebyonesectioncolumnTemplate'
            },
            {
                field: 'Elvart',
                headerText: gettextCatalog.getString('Elvart'),
                textAlign: 'left',
                width: 100,
                groupFooterTemplate: 'Total freight: ${Sum}',
                format: 'N0'
            },
            {
                field: 'Tenyleges',
                headerText: gettextCatalog.getString('Tenyleges'),
                textAlign: 'left',
                width: 100,
                format: 'N0'
            },
            {field: 'Year', headerText: gettextCatalog.getString('Year'), visible: false}
        ];

        var grid = new ej2.grids.Grid({
            dataSource: [],
            allowExcelExport: true,
            allowTextWrap: true,
            allowPaging: true,
            allowSorting: true,
            allowGrouping: true,
            toolbar: $rootScope.toolbarItems,
            groupSettings: {showDropArea: false, columns: ['Year']},
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            locale: 'hu-HU',
            aggregates: vm.summaryRows,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'searching' || args.requestType === 'refresh') {
                    $rootScope.compile(grid, $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        // Public functions
        vm.sectionSelect = sectionSelect;
        vm.openCoach = openCoach;

        // Activate page
        activate();

        function activate() {
            var promises = [authenticationService.getRight('SZAKOSPDIJBEF')];
            $q.all(promises).then(function (result) {
                if (result[0] !== true) {
                    log.permissionError(true);
                } else {
                    getSections();
                }
            });
        }

        // Get sections' list
        function getSections() {
            return dataservice.sectionDropDownList(0, true).then(function (data) {
                vm.sectionList = data.itemsList;
            });
        }

        // Run after section selected
        function sectionSelect(args) {
            vm.sectionId = args.value;
            getDatas(args.value);
        }

        function getDatas(sectionId) {
            dataservice.getAnnualSportServiceFeeByOneSection(sectionId).then(function (data) {
                console.log('data.itemsList: ' + data.itemsList.length);
                grid.dataSource = data.itemsList;
            });
        }

        function openCoach(edzoId) {
            $q.all([authenticationService.getRight('MODFELH'), authenticationService.getRight('MEGTFELH')]).then(function (results) {
                if (results[0] || results[1]) {
                    paramHelper.setParams([{'newUser.userId': edzoId}]);
                    $state.go('settings.userManagement.modifyUser');
                } else {
                    log.permissionError();
                }
            });
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.business.annualSportServiceFeeByOneSection')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'business.annualSportServiceFeeByOneSection',
                config: {
                    url: '/annualSportServiceFeeByOneSection',
                    templateUrl: 'app/business/annualSportServiceFeeByOneSection/annualSportServiceFeeByOneSection.html',
                    controller: 'AnnualSportServiceFeeByOneSectionController',
                    controllerAs: 'vm',
                    title: 'AnnualSportServiceFeeByOneSection',
                    settings: {
                        navId: 2133,
                        level: 2,
                        order: 13,
                        orderTitle_hu: 'Szakosztályonkénti sportszolgáltatási díj összesítés',
                        orderTitle_en: 'Annual Sport Service Fee by One Section',
                        parentId: 3,
                        content: 'AnnualSportServiceFeeByOneSection',
                        activatorPermission: '"SZAKOSPDIJBEF"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    AnnualSportServiceFeeBySectionController.$inject = ["log", "dataservice", "$q", "$rootScope", "gettextCatalog", "authenticationService", "$scope"];
    angular
        .module('app.business.annualSportServiceFeeBySection')
        .controller('AnnualSportServiceFeeBySectionController', AnnualSportServiceFeeBySectionController);

    function AnnualSportServiceFeeBySectionController(log, dataservice, $q, $rootScope, gettextCatalog, authenticationService, $scope) {
        var vm = this;
        $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('AnnualSportServiceFeeBySection');

        // Create variables
        vm.data = [];
        vm.yearList = dataservice.range(2000, new Date().getFullYear());
        vm.year = new Date().getFullYear();

        vm.summaryRows = [{
            columns: [{
                type: 'Sum',
                field: 'SzakosztalyNeve',
                footerTemplate: gettextCatalog.getString('Sum')
            },
            {
                type: 'Sum',
                field: 'Elvart',
                footerTemplate: '${Sum}',
                format: 'N0'
            },
            {
                type: 'Sum',
                field: 'Tenyleges',
                footerTemplate: '${Sum}',
                format: 'N0'
            },
            {
                type: 'Sum',
                field: 'E1',
                footerTemplate: '${Sum}',
                format: 'N0'
            },
            {
                type: 'Sum',
                field: 'T1',
                footerTemplate: '${Sum}',
                format: 'N0'
            },
            {
                type: 'Sum',
                field: 'E2',
                footerTemplate: '${Sum}',
                format: 'N0'
            },
            {
                type: 'Sum',
                field: 'T2',
                footerTemplate: '${Sum}',
                format: 'N0'
            },
            {
                type: 'Sum',
                field: 'E3',
                footerTemplate: '${Sum}',
                format: 'N0'
            },
            {
                type: 'Sum',
                field: 'T3',
                footerTemplate: '${Sum}',
                format: 'N0'
            },
            {
                type: 'Sum',
                field: 'E4',
                footerTemplate: '${Sum}',
                format: 'N0'
            },
            {
                type: 'Sum',
                field: 'T4',
                footerTemplate: '${Sum}',
                format: 'N0'
            },
            {
                type: 'Sum',
                field: 'E5',
                footerTemplate: '${Sum}',
                format: 'N0'
            },
            {
                type: 'Sum',
                field: 'T5',
                footerTemplate: '${Sum}',
                format: 'N0'
            },
            {
                type: 'Sum',
                field: 'E6',
                footerTemplate: '${Sum}',
                format: 'N0'
            },
            {
                type: 'Sum',
                field: 'T6',
                footerTemplate: '${Sum}',
                format: 'N0'
            },
            {
                type: 'Sum',
                field: 'E7',
                footerTemplate: '${Sum}',
                format: 'N0'
            },
            {
                type: 'Sum',
                field: 'T7',
                footerTemplate: '${Sum}',
                format: 'N0'
            },
            {
                type: 'Sum',
                field: 'E8',
                footerTemplate: '${Sum}',
                format: 'N0'
            },
            {
                type: 'Sum',
                field: 'T8',
                footerTemplate: '${Sum}',
                format: 'N0'
            },
            {
                type: 'Sum',
                field: 'E9',
                footerTemplate: '${Sum}',
                format: 'N0'
            },
            {
                type: 'Sum',
                field: 'T9',
                footerTemplate: '${Sum}',
                format: 'N0'
            },
            {
                type: 'Sum',
                field: 'E10',
                footerTemplate: '${Sum}',
                format: 'N0'
            },
            {
                type: 'Sum',
                field: 'T10',
                footerTemplate: '${Sum}',
                format: 'N0'
            },
            {
                type: 'Sum',
                field: 'E11',
                footerTemplate: '${Sum}',
                format: 'N0'
            },
            {
                type: 'Sum',
                field: 'T11',
                footerTemplate: '${Sum}',
                format: 'N0'
            },
            {
                type: 'Sum',
                field: 'E12',
                footerTemplate: '${Sum}',
                format: 'N0'
            },
            {
                type: 'Sum',
                field: 'T12',
                footerTemplate: '${Sum}',
                format: 'N0'
            }]
        }];
        vm.columns = [
            {field: 'Id', isPrimaryKey: true, visible: false},
            {
                field: 'SzakosztalyNeve',
                headerText: gettextCatalog.getString('Section'),
                textAlign: 'center',
                width: 140
            },
            {
                field: 'Elvart',
                headerText: gettextCatalog.getString('Elvart'),
                textAlign: 'center',
                width: 140,
                format: 'N0'
            },
            {
                field: 'Tenyleges',
                headerText: gettextCatalog.getString('Tenyleges'),
                textAlign: 'center',
                width: 140,
                format: 'N0'
            },
            {
                field: 'E1',
                headerText: gettextCatalog.getString('January') + ' E1',
                textAlign: 'center',
                width: 140,
                format: 'N0'
            },
            {
                field: 'T1',
                headerText: gettextCatalog.getString('January') + ' T1',
                textAlign: 'center',
                width: 140,
                format: 'N0'
            },
            {
                field: 'E2',
                headerText: gettextCatalog.getString('February') + ' E2',
                textAlign: 'center',
                width: 140,
                format: 'N0'
            },
            {
                field: 'T2',
                headerText: gettextCatalog.getString('February') + ' T2',
                textAlign: 'center',
                width: 140,
                format: 'N0'
            },
            {
                field: 'E3',
                headerText: gettextCatalog.getString('March') + ' E3',
                textAlign: 'center',
                width: 140,
                format: 'N0'
            },
            {
                field: 'T3',
                headerText: gettextCatalog.getString('March') + ' T3',
                textAlign: 'center',
                width: 140,
                format: 'N0'
            },
            {
                field: 'E4',
                headerText: gettextCatalog.getString('April') + ' E4',
                textAlign: 'center',
                width: 140,
                format: 'N0'
            },
            {
                field: 'T4',
                headerText: gettextCatalog.getString('April') + ' T4',
                textAlign: 'center',
                width: 140,
                format: 'N0'
            },
            {
                field: 'E5',
                headerText: gettextCatalog.getString('May') + ' E5',
                textAlign: 'center',
                width: 140,
                format: 'N0'
            },
            {
                field: 'T5',
                headerText: gettextCatalog.getString('May') + ' T5',
                textAlign: 'center',
                width: 140,
                format: 'N0'
            },
            {
                field: 'E6',
                headerText: gettextCatalog.getString('June') + ' E6',
                textAlign: 'center',
                width: 140,
                format: 'N0'
            },
            {
                field: 'T6',
                headerText: gettextCatalog.getString('June') + ' T6',
                textAlign: 'center',
                width: 140,
                format: 'N0'
            },
            {
                field: 'E7',
                headerText: gettextCatalog.getString('July') + ' E7',
                textAlign: 'center',
                width: 140,
                format: 'N0'
            },
            {
                field: 'T7',
                headerText: gettextCatalog.getString('July') + ' T7',
                textAlign: 'center',
                width: 140,
                format: 'N0'
            },
            {
                field: 'E8',
                headerText: gettextCatalog.getString('August') + ' E8',
                textAlign: 'center',
                width: 140,
                format: 'N0'
            },
            {
                field: 'T8',
                headerText: gettextCatalog.getString('August') + ' T8',
                textAlign: 'center',
                width: 140,
                format: 'N0'
            },
            {
                field: 'E9',
                headerText: gettextCatalog.getString('September') + ' E9',
                textAlign: 'center',
                width: 140,
                format: 'N0'
            },
            {
                field: 'T9',
                headerText: gettextCatalog.getString('September') + ' T9',
                textAlign: 'center',
                width: 140,
                format: 'N0'
            },
            {
                field: 'E10',
                headerText: gettextCatalog.getString('October') + ' E10',
                textAlign: 'center',
                width: 140,
                format: 'N0'
            },
            {
                field: 'T10',
                headerText: gettextCatalog.getString('October') + ' T10',
                textAlign: 'center',
                width: 140,
                format: 'N0'
            },
            {
                field: 'E11',
                headerText: gettextCatalog.getString('November') + ' E11',
                textAlign: 'center',
                width: 140,
                format: 'N0'
            },
            {
                field: 'T11',
                headerText: gettextCatalog.getString('November') + ' T11',
                textAlign: 'center',
                width: 140,
                format: 'N0'
            },
            {
                field: 'E12',
                headerText: gettextCatalog.getString('December') + ' E12',
                textAlign: 'center',
                width: 140,
                format: 'N0'
            },
            {
                field: 'T12',
                headerText: gettextCatalog.getString('December') + ' T12',
                textAlign: 'center',
                width: 140,
                format: 'N0'
            }
        ];

        var grid = new ej2.grids.Grid({
            columns: vm.columns,
            dataSource: [],
            allowTextWrap: true,
            allowPaging: true,
            allowSorting: true,
            toolbar: $rootScope.toolbarItemsWithSearch,
            pageSettings: $rootScope.pageSettings,
            editSettings: {allowEditing: true, mode: 'Batch', showConfirmDialog: false, showDeleteConfirmDialog: false},
            allowExcelExport: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            aggregates: vm.summaryRows,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'searching' || args.requestType === 'refresh') {
                    $rootScope.compile($('#Grid'), $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        // Public functions
        vm.getDatas = getDatas;

        // Activate page
        activate();

        function activate() {
            var promises = [authenticationService.getRight('MEGTTAGDSZO')];
            $q.all(promises).then(function (result) {
                if (result[0] !== true) {
                    log.permissionError(true);
                } else {
                    getDatas();
                }
            });
        }

        function getDatas() {
            dataservice.getAnnualSportServiceFeeBySection(vm.year).then(function (data) {
                grid.dataSource = data.itemsList;
            });
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.business.annualSportServiceFeeBySection')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'business.annualSportServiceFeeBySection',
                config: {
                    url: '/annualSportServiceFeeBySection',
                    templateUrl: 'app/business/annualSportServiceFeeBySection/annualSportServiceFeeBySection.html',
                    controller: 'AnnualSportServiceFeeBySectionController',
                    controllerAs: 'vm',
                    title: 'AnnualSportServiceFeeBySection',
                    settings: {
                        navId: 2103,
                        level: 2,
                        order: 10,
                        orderTitle_hu: 'Sportszolgáltatási díj összesítés szakosztályonként',
                        orderTitle_en: 'Annual Sport Service Fee by Section',
                        parentId: 3,
                        content: 'AnnualSportServiceFeeBySection',
                        activatorPermission: '"MEGTTAGDSZO"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.business')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'business',
                config: {
                    title: 'Business',
                    url: '/business',
                    templateUrl: 'app/business/business.html',
                    settings: {
                        navId: 3,
                        level: 1,
                        order: 3,
                        parentId: 0,
                        content: 'Business',
                        activatorPermission: ['"OKTOSSZSP"', '"OKTOSSZEDZO"', '"SZAKOKTDIJBEF"', '"OKTOSSZSZAKO"', '"MEGTTAGDOSP"', '"MEGTTAGDOED"', '"SZAKOSPDIJBEF"',
                                              '"MEGTTAGDSZO"', '"CSEKKEXPORT"', '"CSV"', '"MEGTNAPIOKTD"', '"MEGTNAPITAGD"', '"MEGTTAGDNYILV"', '"MEGTTAGDBEALL"',
                                              '"MEGTHAVIJELLEM"', '"MEGTTAGDHATR"', '"MEGTTAGDNYILV"']
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    CheckPaymentController.$inject = ["log", "dataservice", "$q", "$rootScope", "gettextCatalog", "paramHelper", "authenticationService", "$filter", "$scope"];
    angular
        .module('app.business.checkPayment')
        .controller('CheckPaymentController', CheckPaymentController);

    function CheckPaymentController(log, dataservice, $q, $rootScope, gettextCatalog, paramHelper, authenticationService, $filter, $scope) {
        var vm = this; $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('CheckPayment');

        // Create variables

        vm.data = [];
        vm.dataId = [];
        vm.payment = '0';
        vm.checkNumber = '';
        vm.hasCheck = false;
        vm.selectedRecords = {};

        // Grid's variables
        vm.summaryRows = [{
            columns: [
                {
                    type: 'Sum',
                    field: 'Osszeg',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                }
            ]
        }];
        vm.columns = [
            {field: 'Id', isPrimaryKey: true, visible: false},
            {field: 'Versenyzo', headerText: gettextCatalog.getString('Name'), textAlign: 'left', width: 100},
            {field: 'Edzo', headerText: gettextCatalog.getString('Coach'), width: 100},
            {field: 'Szakosztaly', headerText: gettextCatalog.getString('Section'), width: 100},
            {field: 'Osszeg', headerText: gettextCatalog.getString('PaidAmount'), textAlign: 'center', width: 100, format: 'N0'}
        ];

        // Public functions
        vm.getCheck = getCheck;
        vm.pay = pay;
        vm.save = save;
        vm.removePayment = removePayment;

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItemsWithSearch,
            allowPaging: true,
            allowTextWrap: true,
            allowSorting: true,
            allowExcelExport: true,
            allowDeleting: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            aggregates: vm.summaryRows,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#Grid'), $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        grid.dataSource = vm.data;

        // Activate page
        activate();

        function activate() {
            var promises = [authenticationService.getRight('CSEKKEXPORT')];
            $q.all(promises).then(function (results) {
                if (!results[0]) {
                    log.permissionError(true);
                }
            });
        }

        function getCheck() {
            // a syncfusion direktívák miatt
            $scope.$broadcast('submitted');
            if ($scope.form.$valid === false) {
                log.errorMsg(gettextCatalog.getString('RequiredFieldsError'));
                return;
            }
            dataservice.getCheck(vm.checkNumber).then(function(data) {
                vm.hasCheck = true;
                vm.actualPayment = data;
                vm.actualPayment.Osszeg = vm.payment;
            });
        }

        function pay() {
            if (vm.dataId.indexOf(vm.actualPayment.Id) === -1) {
                vm.data.push(vm.actualPayment);
                vm.dataId.push(vm.actualPayment.Id);
                grid.refresh();
            }
        }

        function removePayment() {
            var id = grid.getSelectedRecords()[0].Id;
            grid.dataSource = $rootScope.deleteRows(grid);
            var i = vm.dataId.indexOf(id);
            if (i !== -1) {
                vm.dataId.splice(i, 1);
            }
        }

        function save() {
            dataservice.checkPaymentsSave(vm.data).then(function() {
                log.successMsg('Saved');
                vm.data = [];
                vm.dataId = [];
                vm.actualPayment = {};
                vm.hasCheck = false;
            });
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.business.checkPayment')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'business.checkPayment',
                config: {
                    url: '/checkPayment',
                    templateUrl: 'app/business/checkPayment/checkPayment.html',
                    controller: 'CheckPaymentController',
                    controllerAs: 'vm',
                    title: 'CheckPayment',
                    settings: {
                        navId: 2193,
                        level: 2,
                        order: 19,
                        orderTitle_hu: 'Csekkes befizetés',
                        orderTitle_en: 'Check Payment',
                        parentId: 3,
                        content: 'CheckPayment',
                        activatorPermission: '"CSEKKEXPORT"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    CheckPrintingExportController.$inject = ["log", "dataservice", "$q", "$rootScope", "gettextCatalog", "paramHelper", "authenticationService", "$scope", "$state"];
    angular
        .module('app.business.checkPrintingExport')
        .controller('CheckPrintingExportController', CheckPrintingExportController);

    function CheckPrintingExportController(log, dataservice, $q, $rootScope, gettextCatalog, paramHelper, authenticationService, $scope, $state) {
        var vm = this;
        $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('CheckPrintingExport');

        // Create variables
        // Dropdownlist's sources
        vm.sectionList = [];
        vm.coachList = [];

        var date = new Date();
        var y = date.getFullYear();
        var m = date.getMonth();
        vm.dateFromValue = new Date(y, m, 1);
        vm.dateToValue = new Date(y, m + 1, 0);

        vm.data = [];
        vm.selectedCoach = vm.coachId = 0;
        vm.selectedSection = 0;

        // Grid's variables
        vm.columns = [
            {
                field: 'SportoloNeve',
                headerText: gettextCatalog.getString('Name'), width: 100,
                template: '#checkprintingexportcolumnTemplate1'
            },
            {
                field: 'NyilvantartasiSzama',
                headerText: gettextCatalog.getString('RegistrationNumber'),
                textAlign: 'center',
                width: 100
            },
            {field: 'CimeIrSzam', headerText: gettextCatalog.getString('ZipCode'), textAlign: 'center', width: 50},
            {field: 'CimeVaros', headerText: gettextCatalog.getString('City'), width: 100},
            {field: 'CimeUtca', headerText: gettextCatalog.getString('Street'), textAlign: 'left', width: 100},
            {
                field: 'BefizetoAzonosito',
                headerText: gettextCatalog.getString('BefizetoAzonosito'),
                textAlign: 'center',
                width: 100
            },
            {field: 'Szakosztaly', headerText: gettextCatalog.getString('Section'), textAlign: 'left', width: 100},
            {
                field: 'Edzo', headerText: gettextCatalog.getString('Coach'), textAlign: 'left', width: 100,
                template: '#checkprintingexportcolumnTemplate2'
            },
            {
                field: 'FizetendoOsszeg',
                headerText: gettextCatalog.getString('FizetendoOsszeg'),
                textAlign: 'left',
                width: 100
            }
        ];

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItemsWithSearch,
            allowPaging: true,
            allowTextWrap: true,
            allowSorting: true,
            allowExcelExport: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#Grid'), $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        // Public functions
        vm.sectionDataBound = sectionDataBound;
        vm.sectionSelect = sectionSelect;
        vm.coachDataBound = coachDataBound;
        vm.coachSelect = coachSelect;
        vm.getDatas = getDatas;
        vm.goToAthlete = goToAthlete;
        vm.openCoach = openCoach;

        // Activate page
        activate();

        function activate() {
            var promises = [paramHelper.getParams([], ['checkPrintingExport.sectionId',
                'checkPrintingExport.dateFrom',
                'checkPrintingExport.coachId',
                'checkPrintingExport.dateTo']), authenticationService.getRight('CSEKKEXPORT')];
            $q.all(promises).then(function (results) {
                if (results[1] !== true) {
                    log.permissionError(true);
                } else {
                    vm.defaultsectionId = results[0]['checkPrintingExport.sectionId'];
                    vm.defaultCoachId = results[0]['checkPrintingExport.coachId'];
                    vm.dateFromValue = results[0]['checkPrintingExport.dateFrom'];
                    vm.dateToValue = results[0]['checkPrintingExport.dateTo'];
                    getSections();
                }
            });
        }

        /**
         * Betölti az edzőket
         * @author Richard Keki
         * @returns {promise} A http promisszal tér vissza
         */
        function getcoaches() {
            return dataservice.coachDropDownList(vm.sectionId).then(function (data) {
                data.itemsList.unshift({value: '0', text: gettextCatalog.getString('All')});
                vm.coachList = data.itemsList;
            });
        }

        /**
         * Edzők betöltése után beállítja az alapértelmezett edzőt
         * @author Richard Keki
         */
        function coachDataBound() {
            if (vm.coachList.length === 1) {
                angular.element('#coachDropDown').ejDropDownList('selectItemByValue', vm.coachList[0].value);
                vm.coachId = vm.coachList[0].value;
            } else {
                angular.element('#coachDropDown').ejDropDownList('selectItemByValue', vm.defaultCoachId);
                vm.coachId = vm.defaultCoachId;
            }
        }

        function coachSelect(args) {
            vm.coachId = args.value;
        }

        //szakosztályok lekérése
        function getSections() {
            return dataservice.sectionDropDownList(0).then(function (data) {
                data.itemsList.unshift({value: '0', text: gettextCatalog.getString('All')});
                vm.sectionList = data.itemsList;
            });
        }

        // Run after data bounded
        function sectionDataBound() {
            if (vm.sectionList.length === 1) {
                angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.sectionList[0].value);
                vm.sectionId = vm.sectionList[0].value;
            } else {
                angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.defaultsectionId);
                vm.sectionId = vm.defaultsectionId;
            }
        }

        // Run after selection
        function sectionSelect(args) {
            vm.sectionId = args.value;
            getcoaches();
        }

        function getDatas() {
            // a syncfusion direktívák miatt
            $scope.$broadcast('submitted');
            if ($scope.form.$valid === false) {
                log.errorMsg(gettextCatalog.getString('RequiredFieldsError'));
                return;
            }
            paramHelper.setParams([
                {'checkPrintingExport.sectionId': vm.sectionId},
                {'checkPrintingExport.coachId': vm.coachId},
                {'checkPrintingExport.dateFrom': vm.dateFromValue},
                {'checkPrintingExport.dateTo': vm.dateToValue}
            ]);
            return dataservice.getCheckExportPrintList(vm.sectionId, vm.coachId, vm.dateFromValue, vm.dateToValue).then(function (data) {
                vm.athletesList = data.itemsList;
                grid.dataSource = vm.athletesList;
            });
        }

        function goToAthlete(id) {
            $q.all([authenticationService.getRight('MEGTSPORTLIST'), authenticationService.getRight('MEGTSPORTLIST')]).then(function (results) {
                if (results[0] || results[1]) {
                    paramHelper.setParams([{'athleteModify.sportoloId': id}]);
                    $state.go('athletes.athletesManagement.athleteModify.dataSheet');
                } else {
                    log.permissionError();
                }
            });
        }

        function openCoach(edzoId) {
            $q.all([authenticationService.getRight('MODFELH'), authenticationService.getRight('MEGTFELH')]).then(function (results) {
                if (results[0] || results[1]) {
                    paramHelper.setParams([{'newUser.userId': edzoId}]);
                    $state.go('settings.userManagement.modifyUser');
                } else {
                    log.permissionError();
                }
            });
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.business.checkPrintingExport')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'business.checkPrintingExport',
                config: {
                    url: '/checkPrintingExport',
                    templateUrl: 'app/business/checkPrintingExport/checkPrintingExport.html',
                    controller: 'CheckPrintingExportController',
                    controllerAs: 'vm',
                    title: 'CheckPrintingExport',
                    settings: {
                        navId: 2183,
                        level: 2,
                        order: 18,
                        orderTitle_hu: 'Exportálás csekknyomtatáshoz',
                        orderTitle_en: 'Export for Check Printing',
                        parentId: 3,
                        content: 'CheckPrintingExport',
                        activatorPermission: '"CSEKKEXPORT"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    CsvPaymentController.$inject = ["log", "dataservice", "$q", "$rootScope", "gettextCatalog", "paramHelper", "authenticationService", "$filter", "$scope", "DOMAIN", "$timeout", "$state"];
    angular
        .module('app.business.csvPayment')
        .controller('CsvPaymentController', CsvPaymentController);

    function CsvPaymentController(log, dataservice, $q, $rootScope, gettextCatalog, paramHelper, authenticationService, $filter, $scope, DOMAIN, $timeout, $state) {
        console.log('CsvPaymentController');
        var vm = this;
        $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('CsvPayment');
        var grid = null;
        var WGrid2 = null;
        var WGrid3 = null;
        var validSelections = [];

        activate();

        function activate() {
            reset();
            validSelections = [];
            vm.settings.CsvPresetLoaded = false;
            vm.step = 0;
            vm.selModeArr = ['cell'];
            vm.columns = [
                {field: 'row', isPrimaryKey: true, visible: false},
                {
                    field: 'date',
                    headerText: gettextCatalog.getString('Date'),
                    textAlign: 'left',
                    width: 40
                },
                {
                    field: 'name',
                    headerText: gettextCatalog.getString('Name'),
                    textAlign: 'left',
                    width: 120
                },
                {
                    field: 'comment',
                    headerText: gettextCatalog.getString('PaymentComment'),
                    textAlign: 'left',
                    width: 120
                },
                {
                    field: 'amount',
                    headerText: gettextCatalog.getString('amount'),
                    textAlign: 'left',
                    width: 40
                },
                {
                    field: 'payments',
                    headerText: gettextCatalog.getString('payments'),
                    textAlign: 'left',
                    width: 90
                },
                {
                    field: 'depositor',
                    headerText: gettextCatalog.getString('depositor'),
                    textAlign: 'left',
                    width: 70
                },
                {
                    field: 'accept',
                    type: 'checkbox',
                    //type: 'boolean',
                    headerText: gettextCatalog.getString('Accept'),
                    textAlign: 'left',
                    width: 40,
                    displayAsCheckBox: true,
                    allowEditing: false,
                    visible: true
                }
            ];
            vm.csvAll = [];
            vm.csv = [];
            var promises = [authenticationService.getRight('CSV'), getSystemSettingsValue('CSVSETTINGS')];
            $q.all(promises).then(function (results) {
                if (!results[0]) {
                    log.permissionError(true);
                } else {
                    vm.step = 1;
                    $('#step1').show();
                    console.log('results', results);
                    delete vm.settings.filename;
                    delete vm.settings.mode;
                    delete vm.settings.AmountColumn;
                    delete vm.settings.CommentColumn;
                    delete vm.settings.DateColumn;
                    delete vm.settings.DepositorColumn;
                    delete vm.settings.headerRow;
                    delete vm.settings.encRow;
                    if (results[1]) {
                        var savedSettings = JSON.parse(results[1]);
                        console.log('activate() vm.settings', vm.settings);
                        if (savedSettings && savedSettings.hasOwnProperty('AmountColumn')) {
                            console.log('savedSettings', savedSettings);
                            vm.settings.AmountColumn = savedSettings.AmountColumn;
                            vm.settings.CommentColumn = savedSettings.CommentColumn;
                            vm.settings.DateColumn = savedSettings.DateColumn;
                            vm.settings.DepositorColumn = savedSettings.DepositorColumn;
                            vm.settings.headerRow = savedSettings.headerRow;
                            vm.settings.CsvPresetLoaded = true;
                        }
                    }
                    vm.data = [];
                    vm.alldata = [];
                    vm.acceptedRows = [];
                    vm.printEnabled = false;
                    vm.saveEnabled = false;
                    vm.firstLineIsHeader = true;
                    //angular.element('#csvuploadform').show();
                    createUploadButton();
                    CreateGrid();
                    CreateWGrid3();
                    CreateWGrid2();
                }
            });
        }

        function reset() {
            grid = null;
            WGrid2 = null;
            WGrid3 = null;
            validSelections = [];
            vm.processModes = [
                {modeName: gettextCatalog.getString('CSV_JustOneLine'), mode: 'JUSTONELINE'},
                {modeName: gettextCatalog.getString('CSV_Merge'), mode: 'MERGE'}
            ];
            vm.wcolumns = [
                {field: 'id', isPrimaryKey: true, visible: false},
                {field: 'enc', visible: false}
            ];
            vm.data = [];
            vm.alldata = [];
            vm.acceptedRows = [];
            vm.header = [
                {row: 'elso'},
                {row: 'masodik'}
            ];
            vm.header2 = [];
            vm.querycellinfo = querycellinfo;
            vm.FilterFailedTransactions = FilterFailedTransactions;
            vm.noHeader = noHeader;
            vm.noDepositor = noDepositor;
            vm.headerSelected = headerSelected;
            vm.columnSelected = columnSelected;
            vm.StartAgain = StartAgain;
            vm.Continue = Continue;
            vm.SaveSettings = SaveSettings;
            vm.modeSelect = modeSelect;
            vm.cellSelected = cellSelected;
            vm.save = save;
            vm.cancel = activate;
            vm.printEnabled = false;
            vm.saveEnabled = false;
            vm.firstLineIsHeader = true;
            vm.red = '#eecdcd';
            vm.yellow = '#eeeecd';
            vm.green = '#cdeecd';
            vm.settings = {};
        }

        function CreateWGrid2() {
            WGrid2 = new ej2.grids.Grid({
                dataSource: vm.csv,
                columns: vm.wcolumns,
                toolbar: $rootScope.toolbarItems,
                allowPaging: false,
                allowSorting: false,
                allowTextWrap: false,
                allowExcelExport: false,
                editSettings: {
                    allowEditing: false, allowAdding: false, allowDeleting: false
                },
                locale: 'hu-HU',
                gridLines: 'Both',
                selectionSettings: {type: 'Single', mode: 'Row'},
                rowSelected: function (arg) {
                    console.log('WGrid2 rowSelected', arg);
                    headerSelected(arg);
                }
            });
        }

        function CreateWGrid3() {
            WGrid3 = new ej2.grids.Grid({
                dataSource: vm.csv,
                columns: vm.wcolumns,
                toolbar: $rootScope.toolbarItems,
                allowPaging: false,
                allowSorting: false,
                allowTextWrap: false,
                allowExcelExport: false,
                editSettings: {
                    allowEditing: false, allowAdding: false, allowDeleting: false
                },
                locale: 'hu-HU',
                gridLines: 'Both',
                selectionSettings: {type: 'Single', mode: 'Cell'},
                cellSelected: function (arg) {
                    console.log('WGrid3 __ cellSelected', arg);
                    cellSelected(arg);
                }
            });
        }

        function CreateGrid() {
            grid = new ej2.grids.Grid({
                dataSource: vm.data,
                columns: vm.columns,
                queryCellInfo: querycellinfo,
                toolbar: $rootScope.toolbarItems,
                allowPaging: false,
                allowSorting: false,
                allowTextWrap: false,
                allowExcelExport: false,
                editSettings: {
                    allowEditing: false, allowAdding: false, allowDeleting: false
                },
                locale: 'hu-HU',
                gridLines: 'Both',
                selectionSettings: {type: 'Multiple', mode: 'Row'},
                rowDataBound: function (args) {
                    $rootScope.compile(args.row, $scope);
                },
                rowSelected: function (arg) {
                    RowSelect(arg.rowIndex, true);
                },
                rowDeselected: function (arg) {
                    if (arg.rowIndex.length == 1) {
                        RowSelect(arg.rowIndex[0], false);
                    } else {
                        RowSelect(-1, false);
                    }
                },
                toolbarClick: function (args) {
                    $rootScope.toolbarClick(args, grid);
                }
            });
        }

        function RowSelect(idx, select) {
            //console.log('RowSelect idx=', idx, ' select=', select);
            if (select && idx >= 0) {
                //console.log('RowSelect IF vm.data[' + idx + ']', vm.data[idx]);
                if (vm.data[idx].amountParse == -1) {
                    grid.clearSelection();
                    grid.selectRows(validSelections);
                } else if (validSelections.indexOf(idx) == -1) {
                    validSelections.push(idx);
                }
            } else { // Deselect
                var IdxOfDeselected = validSelections.indexOf(idx);
                if (IdxOfDeselected != -1) {
                    //console.log('Deselect idx=', idx, ' IdxOfDeselected=', IdxOfDeselected);
                    validSelections.splice(IdxOfDeselected, 1);
                    //console.log('Deselect validSelections', validSelections);
                }
            }
        }

        function modeSelect(arg) {
            console.log('modeSelect', arg);
            vm.settings.mode = arg.data.mode;
            CSVSettings(vm.settings);
            vm.step = 10;
        }

        function SetCsvGrid(data) {
            console.log('SetCsvGrid() data', data);
            if (data.warning.length > 0) {
                log.errorMsg(data.warning, gettextCatalog.getString('Warning'));
            }
            vm.settings.filename = data.filename;
            vm.csvAll = [];
            vm.csv = [];
            for (var c = 0; c <= data.numberOfColumns; c++) {
                if (data.columnWidth[c] == 0) {
                    vm.wcolumns.push({field: 'c' + c, headerText: '', visible: false});
                } else {
                    vm.wcolumns.push({field: 'c' + c, headerText: '', textAlign: 'center', width: 120});
                }
            }
            vm.csvAll = data.itemsList;
            vm.csv = data.itemsList;

            var node = document.getElementById('WGrid2');
            while (node && node.hasChildNodes()) {
                node.removeChild(node.lastChild);
            }
            WGrid2.dataSource = vm.csv;
            WGrid2.columns = vm.wcolumns;
            WGrid2.appendTo('#WGrid2');
            $scope.$apply();
        }

        function cellSelected(arg) {
            console.log('cellSelected_STEP=' + vm.step, arg);
            if (vm.step >= 4) {
                columnChoosen(arg.cellIndex.cellIndex - 2);
            }
            if (vm.step == 3) {
                log.infoMsg(gettextCatalog.getString('CSV_CharacterEncodingSelected'));
                console.log('STEP3 - ENCODING', arg.selectedRowCellIndex[0].rowIndex);
                dataservice.CSVPreprocessSelectHeader(vm.settings.filename, vm.settings.headerRow, arg.data.enc).then(function (response) {
                    console.log('CSVPreprocessSelectHeader again', response);
                    setHeadersAndWidth(response.headerTexts, response.columnWidth);
                    vm.csv = response.itemsList;
                    $timeout(function () {
                        WGrid3.dataSource = vm.csv;
                        WGrid3.clearSelection();
                        WGrid3.refresh();
                        vm.step = 4;
                    }, 700);
                });
            }
        }

        function columnSelected(arg) {
            console.log('columnSelected', arg.columnIndex - 2);
            if (vm.step >= 4) {
                columnChoosen(arg.columnIndex - 2);
            }
        }

        function noDepositor() {
            columnChoosen(-1);
        }

        function columnChoosen(columnIndex) {
            console.log('step=' + vm.step, '  columnSelected', columnIndex);
            $timeout(function () {
                switch (vm.step) {
                    case 4:
                        log.infoMsg(gettextCatalog.getString('CSV_PaymentCommentSelected') + ': ' + vm.wcolumns[columnIndex + 2].headerText);
                        vm.settings.CommentColumn = columnIndex;
                        vm.step++;
                        break;
                    case 5:
                        log.infoMsg(gettextCatalog.getString('CSV_PaymentDateSelected') + ': ' + vm.wcolumns[columnIndex + 2].headerText);
                        vm.settings.DateColumn = columnIndex;
                        vm.step++;
                        break;
                    case 6:
                        log.infoMsg(gettextCatalog.getString('CSV_PaymentDepositorSelected') + ': ' + vm.wcolumns[columnIndex + 2].headerText);
                        vm.settings.DepositorColumn = columnIndex;
                        vm.step++;
                        break;
                    case 7:
                        log.infoMsg(gettextCatalog.getString('CSV_PaymentAmountSelected') + ': ' + vm.wcolumns[columnIndex + 2].headerText);
                        vm.settings.AmountColumn = columnIndex;
                        vm.step++;
                        break;
                }
                WGrid3.clearSelection();
            }, 700);
        }

        function CSVSettings(settings) {
            console.log('CSVSettings', settings);
            if (!(settings.hasOwnProperty('AmountColumn') && settings.hasOwnProperty('CommentColumn') && settings.hasOwnProperty('DateColumn') && settings.hasOwnProperty('DepositorColumn'))) {
                return;
            }
            dataservice.CSVSettings(settings).then(function (response) {
                console.log('CSVSettings response', response);
                vm.data = response.data.data;
                vm.data = $filter('dateStringFilter')(vm.data, 'date');
                var node = document.getElementById('GridFinal');
                while (node && node.hasChildNodes()) {
                    node.removeChild(node.lastChild);
                }
                grid.columns = vm.columns;
                grid.dataSource = vm.data;
                validSelections = [];
                vm.data.forEach(function (row) {
                    if (row.amountParse > 0) {
                        validSelections.push(row.row);
                    }
                });
                grid.appendTo('#GridFinal');
                var upperrChkBox = angular.element('.e-checkbox-wrapper');
                upperrChkBox[0].innerHTML = '';
            }, function (reject) {
                console.log('CSVSettings reject', reject);
                StartAgain();
            });
        }

        function noHeader() {
            headerSelected({rowIndex: -1});
            vm.settings.headerRow = -1;
        }

        function headerSelected(header) {
            console.log('headerSelected', header);
            if (header.rowIndex >= 0) {
                log.infoMsg(gettextCatalog.getString('CSV_HeaderSelected'));
            } else {
                log.infoMsg(gettextCatalog.getString('CSV_HeaderSelectedNoHeader'));
            }
            vm.step = 3;
            vm.settings.headerRow = header.rowIndex;
            dataservice.CSVPreprocessSelectHeader(vm.settings.filename, vm.settings.headerRow, 'HEADERSELECT').then(function (response) {
                console.log('CSVPreprocessSelectHeader', response);
                if (header.rowIndex >= 0) {
                    setHeadersAndWidth(vm.csvAll[header.rowIndex], response.columnWidth);
                }
                $timeout(function () {
                    vm.csv = [];
                    var rowCntr = 0;
                    response.itemsList.forEach(function (row) {
                        if (rowCntr++ >= header.rowIndex) {
                            vm.csv.push(row);
                        }
                    });
                    var node = document.getElementById('WGrid3');
                    while (node && node.hasChildNodes()) {
                        node.removeChild(node.lastChild);
                    }
                    WGrid3.dataSource = vm.csv;
                    WGrid3.appendTo('#WGrid3');
                    $scope.$apply();
                }, 50);
            });
        }

        function setHeadersAndWidth(headerRow, columnWidth) {
            console.log('SET HEADERS', headerRow, columnWidth);
            var colCntr = 0;
            vm.wcolumns.forEach(function (column) {
                if (colCntr++ > 1) {
                    column.headerText = headerRow['c' + (colCntr - 3)];
                    column.width = columnWidth[colCntr - 3] * 10.5;
                }
            });
        }

        function getSystemSettingsValue(valtozo) {
            return dataservice.getSystemSettingsValue(valtozo).then(function (response) {
                return response.retValue;
            });
        }

        function createUploadButton() {
            angular.element('#UploadButton').ejUploadbox({
                saveUrl: DOMAIN.baseURL + DOMAIN.webService + 'CSVPreprocessSelectHeader',
                uploadName: 'Uploadbox',
                allowDragAndDrop: false,
                autoUpload: true,
                buttonText: {
                    browse: gettextCatalog.getString('ChooseFile'),
                    upload: gettextCatalog.getString('UploadFile'),
                    cancel: gettextCatalog.getString('CancelUpload')
                },
                dialogAction: {
                    modal: true,
                    closeOnComplete: true,
                    resize: false,
                    drag: false
                },
                dialogText: {
                    title: gettextCatalog.getString('UploadingAndProcessingCSV'),
                    name: gettextCatalog.getString('FileName'),
                    size: gettextCatalog.getString('FileSize'),
                    status: gettextCatalog.getString('FileStatus')
                },
                dropAreaText: gettextCatalog.getString('DropFileToUpload'),
                extensionsAllow: '.csv',
                complete: function (args) {
                    vm.printEnabled = false;
                    vm.saveEnabled = true;
                    vm.data = [];
                    var idx = args.responseText.indexOf('ExceptionMessage":');
                    if (idx > 0) {
                        idx += 19;
                        var last = args.responseText.indexOf(',', idx) - 1;
                        log.htmlError(args.responseText.substring(idx, last));
                    } else {
                        $('#step1').hide();
                        console.log('vm.settings...', vm.settings);
                        if (vm.settings.CsvPresetLoaded) {
                            vm.step = 8;
                        } else {
                            vm.step = 2;
                        }
                        log.infoMsg(gettextCatalog.getString('UploadSuccessed'));
                        var response = JSON.parse(args.responseText);
                        SetCsvGrid(response);
                    }
                },
                error: function () {
                    log.htmlError(gettextCatalog.getString('UploadError'));
                },
                beforeSend: function () {
                },
                begin: function (args) {
                    args.data = {file: '', headerRow: 0};
                }
            });
        }

        function FilterFailedTransactions() {
            vm.alldata = vm.data;
            vm.data = [];
            $timeout(function () {
                vm.alldata.forEach(function (row) {
                    if (!row.accept) {
                        vm.data.push(row);
                    }
                });
                grid.dataSource = vm.data;
                grid.allowSelection = false;
                //grid.selectionSettings = {type: 'None', mode: 'None'};
                vm.columns[7].visible = false;
                grid.refreshColumns();
                grid.refreshHeader();
                $scope.$apply();
            }, 100);
        }

        function save() {
            var selectedRecords = grid.getSelectedRecords();
            console.log('save selectedRecords', selectedRecords);
            vm.data.forEach(function (r) {
                r.accept = false;
            });
            selectedRecords.forEach(function (r) {
                vm.data[r.row].accept = true;
            });
            console.log('save vm.data', vm.data);
            vm.saveEnabled = false;
            var param = {};
            param.NemElfogadottLista = [];
            param.ElfogadottLista = [];
            vm.data.forEach(function (row) {
                if (row.accept) {
                    param.ElfogadottLista.push(row);
                } else {
                    param.NemElfogadottLista.push(row);
                }
            });
            vm.step++;
            swal({
                title: gettextCatalog.getString('MailWillBeSentToYouContainingUnprocessedAndProcessedCSVLines'),
                type: 'question',
                showCancelButton: false,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: gettextCatalog.getString('Ok')
            }).then(function () {
                AcceptCSVPayment(param);
            }, function () {
                AcceptCSVPayment(param);
            });
        }

        function AcceptCSVPayment(param) {
            param.filename = vm.settings.filename;
            console.log('AcceptCSVPayment', param);
            dataservice.AcceptCSVPayment(param).then(function () {
                console.log('AcceptCSVPayment OK');
                vm.printEnabled = true;
                FilterFailedTransactions();
            }, function (arg) {
                vm.printEnabled = false;
                vm.saveEnabled = true;
                vm.step--;
                console.log('AcceptCSVPayment ERR', arg);
            });
        }

        function SaveSettings() {
            var fileNameTemp = vm.settings.filename;
            delete vm.settings.filename;
            delete vm.settings.mode;
            delete vm.settings.CsvPresetLoaded;
            var SettingsJSON = JSON.stringify(vm.settings);
            console.log('saveSystemSettingsValue', vm.settings, SettingsJSON);
            dataservice.saveSystemSettingsValue('CSVSETTINGS', SettingsJSON).then(function () {
                log.successMsg(gettextCatalog.getString('CSVSettingsSavedSuccessed'));
            });
            vm.settings.filename = fileNameTemp;
        }

        function Continue() {
            vm.step++;
        }

        function StartAgain() {
            dataservice.saveSystemSettingsValue('CSVSETTINGS', '{}').then(function () {
                log.successMsg(gettextCatalog.getString('CSVSettingsSavedSuccessed'));
                $state.reload();
            });
        }

        function querycellinfo(arg) {
            var cell = angular.element(arg.cell);
            switch (arg.column.field) {
                case 'date':
                case 'comment':
                case 'name':
                    switch (arg.data.sportoloParse) {
                        case -2:
                        case -1:
                            cell.css('background-color', vm.red);
                            break;
                        case 0:
                            cell.css('background-color', vm.yellow);
                            break;
                        case 1:
                            cell.css('background-color', vm.green);
                            break;
                    }
                    break;
                case 'depositor':
                case 'amount':
                case 'payments':
                    switch (arg.data.amountParse) {
                        case -1:
                            cell.css('background-color', vm.red);
                            break;
                        case 0:
                            cell.css('background-color', vm.yellow);
                            break;
                        case 1:
                            cell.css('background-color', vm.green);
                            break;
                    }
                    break;
                case 'accept':
                    if (arg.data.sportoloParse == 1 && arg.data.amountParse == 1) {
                        cell.css('background-color', vm.green);
                    }
                    if (arg.data.sportoloParse == 0 || arg.data.amountParse == 0) {
                        cell.css('background-color', vm.yellow);
                    }
                    if (arg.data.sportoloParse == -1 || arg.data.amountParse == -1) {
                        cell.css('background-color', vm.red);
                    }
                    break;
            }
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.business.csvPayment')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'business.csvPayment',
                config: {
                    url: '/csvPayment',
                    templateUrl: 'app/business/csvPayment/csvPayment.html',
                    controller: 'CsvPaymentController',
                    controllerAs: 'vm',
                    title: 'CsvPayment',
                    settings: {
                        navId: 2203,
                        level: 2,
                        order: 20,
                        orderTitle_hu: 'Átutalások importálása',
                        orderTitle_en: 'Paid Fee',
                        parentId: 3,
                        content: 'CsvPayment',
                        activatorPermission: '"CSV"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    DailyEducationalFeePaymentsController.$inject = ["log", "dataservice", "$q", "$rootScope", "gettextCatalog", "paramHelper", "authenticationService", "$scope", "$state"];
    angular
        .module('app.business.dailyEducationalFeePayments')
        .controller('DailyEducationalFeePaymentsController', DailyEducationalFeePaymentsController);

    function DailyEducationalFeePaymentsController(log, dataservice, $q, $rootScope, gettextCatalog, paramHelper, authenticationService, $scope, $state) {
        var vm = this;
        $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('DailyEducationalFeePayments');

        var printOpened = false;

        // Create variables
        // Dropdownlist's sources
        vm.sectionList = [];
        vm.coachList = [];
        vm.numberList = [];
        vm.dateValue = new Date();
        vm.atletesList = [];
        vm.selectedCoach = vm.coachId = 0;
        vm.selectedSection = 0;
        vm.showAddNumber = false;
        vm.dateEnabled = false;

        vm.rowIndexUnderEditing = -1;
        vm.columns = [
            {field: 'Id', isPrimaryKey: true, visible: false},
            {field: 'AdottNapiSorszamok', headerText: gettextCatalog.getString('Number'), width: 70},
            {field: 'Versenyzo_Nev', headerText: gettextCatalog.getString('Name'), textAlign: 'left', width: 150, template: true, templateID: '#dailyeducationalfeepaymentscolumnTemplate1'},
            {field: 'EdzoNeve', headerText: gettextCatalog.getString('CoachName'), textAlign: 'left', width: 150, template: true, templateID: '#dailyeducationalfeepaymentscolumnTemplate2'},
            {field: 'AdottNapiAtveteliElismervenyek', headerText: gettextCatalog.getString('AtveteliElismervenyek'), width: 150},
            {field: 'AdottNapiTemaszamok', headerText: gettextCatalog.getString('Temaszam'), textAlign: 'left', width: 100},
            {field: 'AdottNapiKoltseghelyek', headerText: gettextCatalog.getString('Koltseghelyek'), textAlign: 'left', width: 150},
            {field: 'AdottNapiBefizetesHonapok', headerText: gettextCatalog.getString('BefizetesekHonap'), textAlign: 'left', width: 100},
            {field: 'AdottNapiBefizdatumok', headerText: gettextCatalog.getString('Date'), textAlign: 'left', width: 100},
            {field: 'osszesFizetett', headerText: gettextCatalog.getString('Fizetett'), textAlign: 'left', width: 100, format: 'N0'}
        ];

        // Public functions
        vm.sectionDataBound = sectionDataBound;
        vm.sectionSelect = sectionSelect;
        vm.coachDataBound = coachDataBound;
        vm.coachSelect = coachSelect;
        vm.getAthletes = getAthletes;
        vm.numberDataBound = numberDataBound;
        vm.numberSelect = numberSelect;
        vm.addNumbers = addNumbers;
        vm.goToAthlete = goToAthlete;
        vm.openCoach = openCoach;
        vm.print = print;

        vm.summaryRows = [{
            columns: [
                {
                    type: 'Sum',
                    field: 'osszesFizetett',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                }
            ]
        }];

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItemsWithSearch,
            allowPaging: true,
            allowTextWrap: true,
            allowSorting: true,
            allowExcelExport: true,
            allowDeleting: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            aggregates: vm.summaryRows,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#Grid'), $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        // Activate page
        activate();

        function activate() {
            var promises = [paramHelper.getParams([], ['dailyEducationalFeePayments.sectionId', 'dailyEducationalFeePayments.number', 'dailyEducationalFeePayments.coachId', 'dailyEducationalFeePayments.date']), authenticationService.getRight('MEGTNAPIOKTD')];
            $q.all(promises).then(function (results) {
                if (results[1] !== true) {
                    log.permissionError(true);
                } else {
                    vm.defaultsectionId = results[0]['dailyEducationalFeePayments.sectionId'];
                    // angular.element('#number').ejDropDownList('selectItemByValue', results[0]['dailyEducationalFeePayments.number']);
                    vm.defaultNumber = results[0]['dailyEducationalFeePayments.number'] !== null ? results[0]['dailyEducationalFeePayments.number'] : 0;
                    vm.defaultCoachId = results[0]['dailyEducationalFeePayments.coachId'] !== null ? results[0]['dailyEducationalFeePayments.coachId'] : 0;
                    getcoaches();
                }
            });
        }

        /**
         * Betölti az edzőket
         * @author Richard Keki
         * @returns {promise} A http promisszal tér vissza
         */
        function getcoaches() {
            return dataservice.coachSelect(vm.sectionId).then(function (data) {
                data.itemsList.unshift({value: '0', text: gettextCatalog.getString('All')});
                vm.coachList = data.itemsList;
            });
        }

        /**
         * Edzők betöltése után beállítja az alapértelmezett edzőt
         * @author Richard Keki
         */
        function coachDataBound() {
            if (vm.coachList.length === 1) {
                angular.element('#coachDropDown').ejDropDownList('selectItemByValue', vm.coachList[0].value);
                vm.coachId = vm.coachList[0].value;
            } else {
                angular.element('#coachDropDown').ejDropDownList('selectItemByValue', vm.defaultCoachId);
                vm.coachId = vm.defaultCoachId;
            }
        }

        function coachSelect(args) {
            vm.coachId = args.value;
            getSections();
        }

        //szakosztályok lekérése
        function getSections() {
            return dataservice.sectionDropDownList(vm.coachId).then(function (data) {
                data.itemsList.unshift({value: '0', text: gettextCatalog.getString('All')});
                vm.sectionList = data.itemsList;
            });
        }

        // Run after data bounded
        function sectionDataBound() {
            if (vm.sectionList.length === 1) {
                angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.sectionList[0].value);
                vm.sectionId = vm.sectionList[0].value;
            } else {
                angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.defaultsectionId);
                vm.sectionId = vm.defaultsectionId;
            }
        }

        // Run after selection
        function sectionSelect(args) {
            vm.sectionId = args.value;
            getServiceFeePaymentsNumbers(args.value);
        }

        function getServiceFeePaymentsNumbers(sectionId) {
            return dataservice.getEducationalFeePaymentsNumbers(sectionId, vm.dateValue).then(function (data) {
                data.itemsList.unshift({value: '0', text: gettextCatalog.getString('All')});
                vm.numberList = data.itemsList;
            });
        }

        // Run after data bounded
        function numberDataBound() {
            if (vm.sectionList.length === 1) {
                angular.element('#number').ejDropDownList('selectItemByValue', vm.numberList[0].value);
                vm.selectedNumber = vm.numberList[0].value;
            } else {
                angular.element('#number').ejDropDownList('selectItemByValue', vm.defaultNumber);
                vm.selectedNumber = vm.defaultNumber;
            }
        }

        function numberSelect(args) {
            vm.selectedNumber = args.value;
            vm.dateEnabled = !(args.value !== 0 && args.value !== '0');
        }

        function getAthletes() {
            // a syncfusion direktívák miatt
            $scope.$broadcast('submitted');
            if ($scope.form.$valid === false) {
                log.errorMsg(gettextCatalog.getString('RequiredFieldsError'));
                return;
            }
            paramHelper.setParams([{'dailyEducationalFeePayments.sectionId': vm.sectionId}, {'dailyEducationalFeePayments.number': vm.selectedNumber}, {'dailyEducationalFeePayments.coachId': vm.coachId}]);
            dataservice.getAthletesForDailyPayments2(vm.sectionId, vm.coachId, vm.dateValue, vm.selectedNumber).then(function (data) {
                vm.atletesList = data.itemsList;
                grid.dataSource = vm.atletesList;
                grid.refresh();
                vm.showAddNumber = vm.selectedNumber === '-1';
            });
        }

        function addNumbers() {
            return dataservice.updateOktatasiDijfizetesek(vm.atletesList, true).then(function () {
                log.successMsg('Saved');
                getServiceFeePaymentsNumbers(vm.sectionId);
                getAthletes();
                return true;
            });
        }

        function goToAthlete(id) {
            $q.all([authenticationService.getRight('MEGTSPORTLIST')]).then(function (results) {
                if (results[0]) {
                    paramHelper.setParams([{'athleteModify.sportoloId': id}]);
                    $state.go('athletes.athletesManagement.athleteModify.dataSheet');
                } else {
                    log.permissionError();
                }
            });
        }

        function openCoach(edzoId) {
            $q.all([authenticationService.getRight('MODFELH'), authenticationService.getRight('MEGTFELH')]).then(function (results) {
                if (results[0] || results[1]) {
                    paramHelper.setParams([{'newUser.userId': edzoId}]);
                    $state.go('settings.userManagement.modifyUser');
                } else {
                    log.permissionError();
                }
            });
        }

        function print() {
            vm.reportParameters = {
                'edzoId': vm.coachId,
                'szakosztalyId': vm.sectionId,
                'datum': vm.dateValue,
                'sorszam': vm.selectedNumber,
                'cimszoveg': gettextCatalog.getString('DailyEducationalFeePayments'),
                'fejlec': '',
                'edzokapja': false,
                'sportszolg': false
            };
            $scope.$apply();

            if (printOpened) {
                angular.element('#printDialog').ejDialog('open');
            } else {
                printOpened = true;
                angular.element('#printDialog').ejDialog({height: '99%', width: '99%', enablemodal: 'true', 'position-x': '0', 'position-y': '1', target: '#mainContent', enableresize: 'false'});
            }
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.business.dailyEducationalFeePayments')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'business.dailyEducationalFeePayments',
                config: {
                    url: '/dailyEducationalFeePayments',
                    templateUrl: 'app/business/dailyEducationalFeePayments/dailyEducationalFeePayments.html',
                    controller: 'DailyEducationalFeePaymentsController',
                    controllerAs: 'vm',
                    title: 'DailyEducationalFeePayments',
                    settings: {
                        navId: 263,
                        level: 2,
                        order: 6,
                        orderTitle_hu: 'Napi oktatási díj befizetések',
                        orderTitle_en: 'Daily Educational Fee Payments',
                        parentId: 3,
                        content: 'DailyEducationalFeePayments',
                        permission: ['7'],
                        activatorPermission: '"MEGTNAPIOKTD"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    modFeesCtrl.$inject = ["log", "$rootScope", "gettextCatalog", "dataservice", "authenticationService", "$q", "$scope", "$filter", "paramHelper"];
    angular
        .module('app.business.dailyEducationalFeesPerCoach')
        .controller('DailyEducationalFeesPerCoachController', modFeesCtrl);

    function modFeesCtrl(log, $rootScope, gettextCatalog, dataservice, authenticationService, $q, $scope, $filter, paramHelper) {
        var vm = this;
        $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('DailyEducationalFeesPerCoach');
        vm.coachList = '';
        vm.selectedCoach = '';
        vm.datumIg = new Date();
        vm.datumTol = new Date(new Date().setMonth(new Date().getMonth() - 1));
        vm.coachDataBound = coachDataBound;

        // Grid's details
        vm.data = [];
        vm.columns = [{
            field: 'Datum',
            headerText: gettextCatalog.getString('Date'),
            textAlign: 'center',
            width: 40,
            allowEditing: false
        }, {
            field: 'osszesFizetett',
            headerText: gettextCatalog.getString('PaidAmount'),
            textAlign: 'center',
            width: 40,
            allowEditing: false
        }, {
            field: 'AtveteliElismervenySorszam',
            headerText: gettextCatalog.getString('AcknowledgmentOfReceipt'),
            textAlign: 'center',
            width: 60,
        }
        ];
        vm.summaryRows = [{
            columns: [
                {
                    type: 'Sum',
                    field: 'osszesFizetett',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                }
            ]
        }];

        // Public functions
        vm.getFeeDatas = getFeeDatas;
        vm.selectCoach = selectCoach;

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItemsWithSearch,
            allowPaging: true,
            editSettings: {allowEditing: true, mode: 'Batch', showConfirmDialog: false},
            allowTextWrap: true,
            allowSorting: true,
            allowExcelExport: true,
            allowDeleting: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            aggregates: vm.summaryRows,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#Grid'), $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        activate();

        function activate() {
            $q.all([authenticationService.getRight('MEGTNAPIOKTD')]).then(function (results) {
                if (results[0] !== true) {
                    log.permissionError(true);
                } else {
                    getCoaches();
                    setDropDowns();
                }
            });
        }

        function setDropDowns() {
            var promises = [paramHelper.getParams([], [
                'defpc.coach',
                'defpc.from',
                'defpc.to'
            ])
            ];
            $q.all(promises).then(function (results) {
                vm.datumTol = results[0]['defpc.from'];
                vm.datumIg = results[0]['defpc.to'];
                vm.selectedCoach = results[0]['defpc.coach'];
                vm.coachIdValue = results[0]['defpc.coach'];
                vm.defaultCoachId = results[0]['defpc.coach'];
            });
        }

        //edzők lekérése
        function getCoaches() {
            return dataservice.coachSelect().then(
                function (data) {
                    vm.coachList = data.itemsList;
                }
            );
        }

        function getFeeDatas() {
            // a syncfusion direktívák miatt
            $scope.$broadcast('submitted');
            if ($scope.form.$valid === false) {
                log.errorMsg('RequiredFieldsError');
            } else {
                paramHelper.setParams([
                    {'defpc.coach': vm.selectedCoach},
                    {'defpc.from': vm.datumTol},
                    {'defpc.to': vm.datumIg}
                ]);
                return dataservice.dailyEducationalFeesPerCoach(vm.selectedCoach, vm.datumTol, vm.datumIg).then(
                    function (data) {
                        vm.data = $filter('dateStringFilter')(data.itemsList, 'Datum');
                        grid.dataSource = vm.data;
                    }
                );
            }
        }

        function coachDataBound() {
            if (vm.coachList.length === 1) {
                angular.element('#coachDropDown').ejDropDownList('selectItemByValue', vm.coachList[0].value);
                vm.coachId = vm.coachList[0].value;
            } else {
                angular.element('#coachDropDown').ejDropDownList('selectItemByValue', vm.defaultCoachId);
                vm.coachId = vm.defaultCoachId;
            }
        }

        function selectCoach(arg) {
            vm.selectedCoach = arg.value;
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.business.dailyEducationalFeesPerCoach')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'business.dailyEducationalFeesPerCoach',
                config: {
                    url: '/dailyEducationalFeesPerCoach',
                    templateUrl: 'app/business/dailyEducationalFeesPerCoach/dailyEducationalFeesPerCoach.html',
                    controller: 'DailyEducationalFeesPerCoachController',
                    controllerAs: 'vm',
                    title: 'DailyEducationalFeesPerCoach',
                    settings: {
                        navId: 283,
                        level: 2,
                        order: 8,
                        orderTitle_hu: 'Napi oktatási díj befizetések edzőnként',
                        orderTitle_en: 'Daily Educational Fee Payments Per Coach',
                        parentId: 3,
                        content: 'DailyEducationalFeesPerCoach',
                        permission: ['7'],
                        activatorPermission: '"MEGTNAPIOKTD"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    DailySportServiceFeePaymentsController.$inject = ["log", "dataservice", "$q", "$rootScope", "gettextCatalog", "paramHelper", "authenticationService", "$scope", "$state"];
    angular
        .module('app.business.dailySportServiceFeePayments')
        .controller('DailySportServiceFeePaymentsController', DailySportServiceFeePaymentsController);

    function DailySportServiceFeePaymentsController(log, dataservice, $q, $rootScope, gettextCatalog, paramHelper, authenticationService, $scope, $state) {
        var vm = this;
        $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('DailySportServiceFeePayments');

        var printOpened = false;
        // Create variables
        // Dropdownlist's sources
        vm.sectionList = [];
        vm.coachList = [];
        vm.numberList = [];
        vm.dateValue = new Date();
        vm.atletesList = [];
        vm.selectedCoach = vm.coachId = 0;
        vm.selectedSection = 0;
        vm.showAddNumber = false;
        vm.reportParameters = {};
        vm.dateEnabled = false;

        vm.rowIndexUnderEditing = -1;
        vm.columns = [
            {field: 'Id', isPrimaryKey: true, visible: false},
            {field: 'AdottNapiSorszamok', headerText: gettextCatalog.getString('Number'), width: 70},
            {
                headerText: gettextCatalog.getString('Name'), textAlign: 'left', width: 150,
                template: '#dailysportservicefeepaymentscolumnTemplate1'
            },
            {
                headerText: gettextCatalog.getString('CoachName'), textAlign: 'left', width: 150,
                template: '#dailysportservicefeepaymentscolumnTemplate2'
            },
            {field: 'AdottNapiAtveteliElismervenyek', headerText: gettextCatalog.getString('AtveteliElismervenyek'), width: 150},
            {field: 'AdottNapiTemaszamok', headerText: gettextCatalog.getString('Temaszam'), textAlign: 'left', width: 100},
            {field: 'AdottNapiKoltseghelyek', headerText: gettextCatalog.getString('Koltseghelyek'), textAlign: 'left', width: 150},
            {field: 'AdottNapiBefizetesHonapok', headerText: gettextCatalog.getString('BefizetesekHonap'), textAlign: 'left', width: 100},
            {field: 'AdottNapiBefizdatumok', headerText: gettextCatalog.getString('Date'), textAlign: 'left', width: 100},
            {field: 'osszesFizetett', headerText: gettextCatalog.getString('Fizetett'), textAlign: 'right', width: 100, format: 'N0'}
        ];

        // Public functions
        vm.sectionDataBound = sectionDataBound;
        vm.sectionSelect = sectionSelect;
        vm.coachDataBound = coachDataBound;
        vm.coachSelect = coachSelect;
        vm.getAthletes = getAthletes;
        vm.numberDataBound = numberDataBound;
        vm.numberSelect = numberSelect;
        vm.addNumbers = addNumbers;
        vm.print = print;
        vm.goToAthlete = goToAthlete;
        vm.openCoach = openCoach;

        vm.summaryRows = [{
            columns: [
                {
                    type: 'Sum',
                    field: 'osszesFizetett',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                }
            ]
        }];

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItemsWithSearch,
            allowPaging: true,
            allowTextWrap: true,
            allowSorting: true,
            allowExcelExport: true,
            allowDeleting: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            aggregates: vm.summaryRows,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#Grid'), $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        // Activate page
        activate();

        function activate() {
            var promises = [paramHelper.getParams([], ['dailySportServiceFeePayments.sectionId', 'dailySportServiceFeePayments.number', 'dailySportServiceFeePayments.coachId', 'dailySportServiceFeePayments.date']), authenticationService.getRight('MEGTNAPITAGD')];
            $q.all(promises).then(function (results) {
                if (results[1] !== true) {
                    log.permissionError(true);
                } else {
                    vm.defaultsectionId = results[0]['dailySportServiceFeePayments.sectionId'];
                    // angular.element('#number').ejDropDownList('selectItemByValue', results[0]['dailySportServiceFeePayments.number']);
                    vm.defaultNumber = results[0]['dailySportServiceFeePayments.number'] !== null ? results[0]['dailySportServiceFeePayments.number'] : 0;
                    vm.defaultCoachId = results[0]['dailySportServiceFeePayments.coachId'] !== null ? results[0]['dailySportServiceFeePayments.coachId'] : 0;
                    getcoaches();
                }
            });
        }

        /**
         * Betölti az edzőket
         * @author Richard Keki
         * @returns {promise} A http promisszal tér vissza
         */
        function getcoaches() {
            return dataservice.coachSelect(vm.sectionId).then(function (data) {
                data.itemsList.unshift({value: '0', text: gettextCatalog.getString('All')});
                vm.coachList = data.itemsList;
            });
        }

        /**
         * Edzők betöltése után beállítja az alapértelmezett edzőt
         * @author Richard Keki
         */
        function coachDataBound() {
            if (vm.coachList.length === 1) {
                angular.element('#coachDropDown').ejDropDownList('selectItemByValue', vm.coachList[0].value);
                vm.coachId = vm.coachList[0].value;
            } else {
                angular.element('#coachDropDown').ejDropDownList('selectItemByValue', vm.defaultCoachId);
                vm.coachId = vm.defaultCoachId;
            }
        }

        function coachSelect(args) {
            vm.coachId = args.value;
            getSections();
        }

        //szakosztályok lekérése
        function getSections() {
            dataservice.sectionDropDownList(vm.coachId).then(function (data) {
                data.itemsList.unshift({value: '0', text: gettextCatalog.getString('All')});
                vm.sectionList = data.itemsList;
            });
        }

        // Run after data bounded
        function sectionDataBound() {
            if (vm.sectionList.length === 1) {
                angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.sectionList[0].value);
                vm.sectionId = vm.sectionList[0].value;
            } else {
                angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.defaultsectionId);
                vm.sectionId = vm.defaultsectionId;
            }
        }

        // Run after selection
        function sectionSelect(args) {
            vm.sectionId = args.value;
            getServiceFeePaymentsNumbers(args.value);
        }

        function getServiceFeePaymentsNumbers(sectionId) {
            return dataservice.getServiceFeePaymentsNumbers(sectionId, vm.dateValue).then(function (data) {
                vm.numberList = data.itemsList;
                vm.numberList.unshift({value: '0', text: gettextCatalog.getString('All')});
            });
        }

        // Run after data bounded
        function numberDataBound() {
            if (vm.numberList.length === 1) {
                angular.element('#number').ejDropDownList('selectItemByValue', vm.numberList[0].value);
                vm.selectedNumber = vm.numberList[0].value;
            } else {
                angular.element('#number').ejDropDownList('selectItemByValue', vm.defaultNumber);
                vm.selectedNumber = vm.defaultNumber;
            }
        }

        function numberSelect(args) {
            vm.selectedNumber = args.value;
            vm.dateEnabled = !(args.value !== 0 && args.value !== '0');
        }

        function getAthletes() {
            // a syncfusion direktívák miatt
            $scope.$broadcast('submitted');
            if ($scope.form.$valid === false) {
                log.errorMsg(gettextCatalog.getString('RequiredFieldsError'));
                return;
            }
            paramHelper.setParams([{'dailySportServiceFeePayments.sectionId': vm.sectionId}, {'dailySportServiceFeePayments.number': vm.selectedNumber}, {'dailySportServiceFeePayments.coachId': vm.coachId}]);
            dataservice.getAthletesForDailyPayments(vm.sectionId, vm.coachId, vm.dateValue, vm.selectedNumber).then(function (data) {
                vm.atletesList = data.itemsList;
                grid.dataSource = vm.atletesList;
                grid.refresh();
                vm.showAddNumber = vm.selectedNumber === '-1';
            });
        }

        function addNumbers() {
            return dataservice.updateTagdijfizetesek(vm.atletesList, true).then(function () {
                log.successMsg('Saved');
                getServiceFeePaymentsNumbers(vm.sectionId, true);
                getAthletes();
                return true;
            });
        }

        function print() {
            vm.reportParameters = {
                'edzoId': vm.coachId,
                'szakosztalyId': vm.sectionId,
                'datum': vm.dateValue,
                'sorszam': vm.selectedNumber,
                'cimszoveg': gettextCatalog.getString('DailySportServiceFeePayments'),
                'fejlec': '',
                'edzokapja': false,
                'sportszolg': true
            };
            $scope.$apply();
            if (printOpened) {
                angular.element('#printDialog').ejDialog('open');
            } else {
                printOpened = true;
                angular.element('#printDialog').ejDialog({height: '99%', width: '99%', enablemodal: 'true', 'position-x': '0', 'position-y': '1', target: '#mainContent', enableresize: 'false'});
            }
        }

        function goToAthlete(id) {
            $q.all([authenticationService.getRight('MEGTSPORTLIST')]).then(function (results) {
                if (results[0]) {
                    paramHelper.setParams([{'athleteModify.sportoloId': id}]);
                    $state.go('athletes.athletesManagement.athleteModify.dataSheet');
                } else {
                    log.permissionError();
                }
            });
        }

        function openCoach(edzoId) {
            $q.all([authenticationService.getRight('MODFELH'), authenticationService.getRight('MEGTFELH')]).then(function (results) {
                if (results[0] || results[1]) {
                    paramHelper.setParams([{'newUser.userId': edzoId}]);
                    $state.go('settings.userManagement.modifyUser');
                } else {
                    log.permissionError();
                }
            });
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.business.dailySportServiceFeePayments')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'business.dailySportServiceFeePayments',
                config: {
                    url: '/dailySportServiceFeePayments',
                    templateUrl: 'app/business/dailySportServiceFeePayments/dailySportServiceFeePayments.html',
                    controller: 'DailySportServiceFeePaymentsController',
                    controllerAs: 'vm',
                    title: 'DailySportServiceFeePayments',
                    settings: {
                        navId: 253,
                        level: 2,
                        order: 5,
                        orderTitle_hu: 'Napi sportszolgáltatási díj befizetések',
                        orderTitle_en: 'Daily Sport Service Fee Payments',
                        parentId: 3,
                        content: 'DailySportServiceFeePayments',
                        activatorPermission: '"MEGTNAPITAGD"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    modFeesCtrl.$inject = ["log", "$rootScope", "gettextCatalog", "dataservice", "authenticationService", "$q", "$scope", "$filter", "paramHelper"];
    angular
        .module('app.business.dailySportServiceFeesPerCoach')
        .controller('DailySportServiceFeesPerCoachController', modFeesCtrl);

    function modFeesCtrl(log, $rootScope, gettextCatalog, dataservice, authenticationService, $q, $scope, $filter, paramHelper) {
        var vm = this;
        $rootScope.vm = vm;
        vm.coachDataBound = coachDataBound;
        $rootScope.title = gettextCatalog.getString('DailySportServiceFeesPerCoach');

        vm.coachList = '';
        vm.selectedCoach = '';
        vm.maskObject = {};

        vm.datumIg = new Date();
        vm.datumTol = new Date(new Date().setMonth(new Date().getMonth() - 1));

        // Grid's details
        vm.data = [];
        vm.nonClosedYears = [];
        vm.selectedYear = 0;
        vm.columns = [{
            field: 'Datum',
            headerText: gettextCatalog.getString('Date'),
            textAlign: 'center',
            width: 40,
            allowEditing: false
        }, {
            field: 'osszesFizetett',
            headerText: gettextCatalog.getString('PaidAmount'),
            textAlign: 'center',
            width: 40,
            allowEditing: false,
            format: 'N0'
        }, {
            field: 'AtveteliElismervenySorszam',
            headerText: gettextCatalog.getString('AcknowledgmentOfReceipt'),
            textAlign: 'center',
            width: 60,
            allowEditing: false
        }
        ];
        vm.summaryRows = [{
            columns: [
                {
                    type: 'Sum',
                    field: 'osszesFizetett',
                    footerTemplate: '${Sum}',
                    format: 'N0'
                }
            ]
        }];

        // Public functions
        vm.getFeeDatas = getFeeDatas;
        vm.selectCoach = selectCoach;

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItemsWithSearch,
            allowPaging: true,
            editSettings: {allowEditing: true, mode: 'Batch', showConfirmDialog: false},
            allowTextWrap: true,
            allowSorting: true,
            allowExcelExport: true,
            allowDeleting: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            aggregates: vm.summaryRows,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#Grid'), $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        activate();

        function activate() {
            $q.all([authenticationService.getRight('MEGTNAPITAGD')]).then(function (results) {
                if (results[0] !== true) {
                    log.permissionError(true);
                } else {
                    getCoaches();
                    setDropDowns();
                }
            });
        }

        function setDropDowns() {
            var promises = [paramHelper.getParams([], [
                'dssfpc.coach',
                'dssfpc.from',
                'dssfpc.to'
            ])
            ];
            $q.all(promises).then(function (results) {
                vm.datumTol = results[0]['dssfpc.from'];
                vm.datumIg = results[0]['dssfpc.to'];
                vm.selectedCoach = results[0]['dssfpc.coach'];
                vm.coachIdValue = results[0]['dssfpc.coach'];
                vm.defaultCoachId = results[0]['dssfpc.coach'];
            });
        }

        function coachDataBound() {
            if (vm.coachList.length === 1) {
                angular.element('#coachDropDown').ejDropDownList('selectItemByValue', vm.coachList[0].value);
                vm.coachId = vm.coachList[0].value;
            } else {
                angular.element('#coachDropDown').ejDropDownList('selectItemByValue', vm.defaultCoachId);
                vm.coachId = vm.defaultCoachId;
            }
        }

        //edzők lekérése
        function getCoaches() {
            return dataservice.coachSelect().then(
                function (data) {
                    vm.coachList = data.itemsList;
                }
            );
        }

        function getFeeDatas() {
            // a syncfusion direktívák miatt
            $scope.$broadcast('submitted');
            if ($scope.form.$valid === false) {
                log.errorMsg('RequiredFieldsError');
            } else {
                paramHelper.setParams([
                    {'dssfpc.coach': vm.selectedCoach},
                    {'dssfpc.from': vm.datumTol},
                    {'dssfpc.to': vm.datumIg}
                ]);
                return dataservice.dailySportServiceFeesPerCoach(vm.selectedCoach, vm.datumTol, vm.datumIg).then(
                    function (data) {
                        vm.data = $filter('dateStringFilter')(data.itemsList, 'Datum');
                        grid.dataSource = vm.data;
                    }
                );
            }
        }

        function selectCoach(arg) {
            vm.selectedCoach = arg.value;
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.business.dailySportServiceFeesPerCoach')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'business.dailySportServiceFeesPerCoach',
                config: {
                    url: '/dailySportServiceFeesPerCoach',
                    templateUrl: 'app/business/dailySportServiceFeesPerCoach/dailySportServiceFeesPerCoach.html',
                    controller: 'DailySportServiceFeesPerCoachController',
                    controllerAs: 'vm',
                    title: 'DailySportServiceFeesPerCoach',
                    settings: {
                        navId: 273,
                        level: 2,
                        order: 7,
                        orderTitle_hu: 'Napi sportszolgáltatási díj befizetések edzőnként',
                        orderTitle_en: 'Daily Sport Service Fee Payments Per Coach',
                        parentId: 3,
                        content: 'DailySportServiceFeesPerCoach',
                        activatorPermission: '"MEGTNAPITAGD"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    EducationalFeeRegisterController.$inject = ["log", "dataservice", "$q", "$rootScope", "gettextCatalog", "paramHelper", "authenticationService", "$scope", "$state", "$compile", "$timeout", "$filter"];
    angular
        .module('app.business.educationalFeeRegister')
        .controller('EducationalFeeRegisterController', EducationalFeeRegisterController);

    function EducationalFeeRegisterController(log, dataservice, $q, $rootScope, gettextCatalog, paramHelper, authenticationService, $scope, $state, $compile, $timeout, $filter) {
        var vm = this;
        $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('EducationalFeeRegister');

        // Create variables
        // Dropdownlist's sources
        vm.AthleteUnderEditing = '';
        vm.AthleteUnderEditingText = gettextCatalog.getString('ActualAthlete');
        vm.kedvezmenyNevek = [];
        vm.sectionList = [];
        vm.coachList = [];
        vm.yearList = dataservice.range(new Date().getFullYear() - 4, new Date().getFullYear() + 1);
        vm.rowUnderEditing = [];
        vm.priceType = [{text: 'NK', value: 'NK'}, {text: 'B', value: 'B'}, {text: 'EP', value: 'EP'}];
        vm.year = new Date().getFullYear();
        vm.modifiedRows = [];

        vm.maskObject;
        vm.elem;

        vm.dateTimeEditorTemplate =
            {
                create: function () {
                    var txt = document.createElement('input');
                    txt.style.width = '100%';
                    txt.style.float = 'left';
                    vm.elem = txt;
                    vm.elem.addEventListener('focus', function () {
                        this.select();
                    });
                    return vm.elem;
                },
                read: function () {
                    return vm.maskObject.getMaskedValue();
                },
                destroy: function () {
                    if (vm.maskObject != null) {
                        vm.maskObject.destroy();
                    }
                },
                write: function (args) {
                    var s = args.element.id.toString().replace('Grid', '');
                    vm.maskObject = new ej2.inputs.MaskedTextBox({
                        minWidth: '100%',
                        mask: '>0000-00-00',
                        value: args.rowData !== angular.isUndefined ? args.rowData[s] : ''.replace(' ', ''),
                        readOnly: vm.readOnlyAttendance,
                    });
                    vm.editedRowId = args.rowData['Id'];
                    $compile(args.element[0])($scope);
                    vm.maskObject.appendTo(vm.elem);
                }
            };

        vm.dropDownListEditorTemplate =
            {
                create: function () {
                    vm.elem = document.createElement('input');
                    return vm.elem;
                },
                read: function () {
                    var text = '';
                    switch (vm.maskObject.value) {
                        case 'NK':
                            text = 'NK';
                            vm.rowUnderEditing['Honap_' + vm.monthUnderEditing + '_kedvezmenyes'] = 'NK';
                            vm.rowUnderEditing['Honap_' + vm.monthUnderEditing] = vm.rowUnderEditing['KirottTeljesAr' + vm.monthUnderEditing];
                            vm.rowUnderEditing['Honap_' + vm.monthUnderEditing + '_fizetendo'] = vm.rowUnderEditing['KirottTeljesAr' + vm.monthUnderEditing];
                            vm.rowUnderEditing['Kedvezmenyes' + vm.monthUnderEditing] = false;
                            break;
                        case 'K1':
                            text = vm.priceType.find(function (value) {
                                return value.value === 'K1';
                            }).text;
                            vm.rowUnderEditing['Honap_' + vm.monthUnderEditing + '_kedvezmenyes'] = 'K1';
                            vm.rowUnderEditing['Honap_' + vm.monthUnderEditing] = vm.sectionFees[0].KedvezmenyesOD;
                            vm.rowUnderEditing['Honap_' + vm.monthUnderEditing + '_fizetendo'] = vm.sectionFees[0].KedvezmenyesOD;
                            vm.rowUnderEditing['Kedvezmenyes' + vm.monthUnderEditing] = true;
                            vm.rowUnderEditing['KedvezmenyTipus' + vm.monthUnderEditing] = 'K1';
                            break;
                        case 'K2':
                            text = vm.priceType.find(function (value) {
                                return value.value === 'K2';
                            }).text;
                            vm.rowUnderEditing['Honap_' + vm.monthUnderEditing + '_kedvezmenyes'] = 'K2';
                            vm.rowUnderEditing['Honap_' + vm.monthUnderEditing] = vm.sectionFees[0].KedvezmenyesOD2;
                            vm.rowUnderEditing['Honap_' + vm.monthUnderEditing + '_fizetendo'] = vm.sectionFees[0].KedvezmenyesOD2;
                            vm.rowUnderEditing['Kedvezmenyes' + vm.monthUnderEditing] = true;
                            vm.rowUnderEditing['KedvezmenyTipus' + vm.monthUnderEditing] = 'K2';
                            break;
                        case 'K3':
                            text = vm.priceType.find(function (value) {
                                return value.value === 'K3';
                            }).text;
                            vm.rowUnderEditing['Honap_' + vm.monthUnderEditing + '_kedvezmenyes'] = 'K3';
                            vm.rowUnderEditing['Honap_' + vm.monthUnderEditing] = vm.sectionFees[0].KedvezmenyesOD3;
                            vm.rowUnderEditing['Honap_' + vm.monthUnderEditing + '_fizetendo'] = vm.sectionFees[0].KedvezmenyesOD3;
                            vm.rowUnderEditing['Kedvezmenyes' + vm.monthUnderEditing] = true;
                            vm.rowUnderEditing['KedvezmenyTipus' + vm.monthUnderEditing] = 'K3';
                            break;
                        case 'K4':
                            text = vm.priceType.find(function (value) {
                                return value.value === 'K4';
                            }).text;
                            vm.rowUnderEditing['Honap_' + vm.monthUnderEditing + '_kedvezmenyes'] = 'K4';
                            vm.rowUnderEditing['Honap_' + vm.monthUnderEditing] = vm.sectionFees[0].KedvezmenyesOD4;
                            vm.rowUnderEditing['Honap_' + vm.monthUnderEditing + '_fizetendo'] = vm.sectionFees[0].KedvezmenyesOD4;
                            vm.rowUnderEditing['Kedvezmenyes' + vm.monthUnderEditing] = true;
                            vm.rowUnderEditing['KedvezmenyTipus' + vm.monthUnderEditing] = 'K4';
                            break;
                        case 'K5':
                            text = vm.priceType.find(function (value) {
                                return value.value === 'K5';
                            }).text;
                            vm.rowUnderEditing['Honap_' + vm.monthUnderEditing + '_kedvezmenyes'] = 'K5';
                            vm.rowUnderEditing['Honap_' + vm.monthUnderEditing] = vm.sectionFees[0].KedvezmenyesOD5;
                            vm.rowUnderEditing['Honap_' + vm.monthUnderEditing + '_fizetendo'] = vm.sectionFees[0].KedvezmenyesOD5;
                            vm.rowUnderEditing['Kedvezmenyes' + vm.monthUnderEditing] = true;
                            vm.rowUnderEditing['KedvezmenyTipus' + vm.monthUnderEditing] = 'K5';
                            break;
                        case 'B':
                            text = 'B';
                            vm.rowUnderEditing['Honap_' + vm.monthUnderEditing + '_kedvezmenyes'] = 'B';
                            vm.rowUnderEditing['Honap_' + vm.monthUnderEditing] = 0;
                            vm.rowUnderEditing['Honap_' + vm.monthUnderEditing + '_fizetendo'] = 0;
                            break;
                        case 'EP':
                            text = 'EP';
                            vm.rowUnderEditing['Honap_' + vm.monthUnderEditing + '_kedvezmenyes'] = 'EP';
                            vm.rowUnderEditing['Honap_' + vm.monthUnderEditing] = 0;
                            vm.rowUnderEditing['Honap_' + vm.monthUnderEditing + '_fizetendo'] = 0;
                            break;
                        case 'ODM':
                            text = 'ODM';
                            vm.rowUnderEditing['Honap_' + vm.monthUnderEditing] = 0;
                            vm.rowUnderEditing['Honap_' + vm.monthUnderEditing + '_fizetendo'] = 0;
                            vm.rowUnderEditing['Honap_' + vm.monthUnderEditing + '_kedvezmenyes'] = 'ODM';
                            break;
                    }
                    // grid.refresh();
                    return text;
                },
                destroy: function () {
                    vm.maskObject.destroy();
                },
                write: function (args) {
                    vm.monthUnderEditing = args.column.field[6] + (args.column.field[7] && args.column.field[7] !== '_' ? args.column.field[7] : '');
                    new ej2.data.DataManager(vm.data).executeQuery(new ej2.data.Query().where('Id', 'equal', args.rowData.Id)).then(function (result) {
                        vm.rowUnderEditing = result.result[0];
                    });

                    var arr = vm.priceType.slice(0);
                    if (args.rowData.mentessegAdhato === true) {
                        arr.push({text: 'ODM', value: 'ODM'});
                    }
                    vm.maskObject = new ej2.dropdowns.DropDownList({
                        value: args.rowData[args.column.field.slice(0, -5)],
                        dataSource: arr,
                        popupWidth: 150,
                        fields: {
                            value: 'value',
                            text: 'text'
                        }
                    });
                    vm.maskObject.appendTo(vm.elem);
                }
            };

        vm.monthList =
            [{text: gettextCatalog.getString('All'), value: -1},
                {text: gettextCatalog.getString('January'), value: 0},
                {text: gettextCatalog.getString('February'), value: 1},
                {text: gettextCatalog.getString('March'), value: 2},
                {text: gettextCatalog.getString('April'), value: 3},
                {text: gettextCatalog.getString('May'), value: 4},
                {text: gettextCatalog.getString('June'), value: 5},
                {text: gettextCatalog.getString('July'), value: 6},
                {text: gettextCatalog.getString('August'), value: 7},
                {text: gettextCatalog.getString('September'), value: 8},
                {text: gettextCatalog.getString('October'), value: 9},
                {text: gettextCatalog.getString('November'), value: 10},
                {text: gettextCatalog.getString('December'), value: 11}];

        // Grid's variables
        vm.osszesFizetendo = function (args) {
            return ej.sum(args, 'osszesFizetendo');
        };
        vm.osszesFizetett = function (args) {
            return ej.sum(args, 'osszesFizetett');
        };

        vm.summaryRows = [{
            columns: [
                {
                    type: 'Sum',
                    field: 'Honap_1',
                    footerTemplate: gettextCatalog.getString('Sum') + ': ${Sum}'
                },
                {
                    type: 'Sum',
                    field: 'Honap_2',
                    footerTemplate: gettextCatalog.getString('Sum') + ': ${Sum}'
                },
                {
                    type: 'Sum',
                    field: 'Honap_3',
                    footerTemplate: gettextCatalog.getString('Sum') + ': ${Sum}'
                },
                {
                    type: 'Sum',
                    field: 'Honap_4',
                    footerTemplate: gettextCatalog.getString('Sum') + ': ${Sum}'
                },
                {
                    type: 'Sum',
                    field: 'Honap_5',
                    footerTemplate: gettextCatalog.getString('Sum') + ': ${Sum}'
                },
                {
                    type: 'Sum',
                    field: 'Honap_6',
                    footerTemplate: gettextCatalog.getString('Sum') + ': ${Sum}'
                },
                {
                    type: 'Sum',
                    field: 'Honap_7',
                    footerTemplate: gettextCatalog.getString('Sum') + ': ${Sum}'
                },
                {
                    type: 'Sum',
                    field: 'Honap_8',
                    footerTemplate: gettextCatalog.getString('Sum') + ': ${Sum}'
                },
                {
                    type: 'Sum',
                    field: 'Honap_9',
                    footerTemplate: gettextCatalog.getString('Sum') + ': ${Sum}'
                },
                {
                    type: 'Sum',
                    field: 'Honap_10',
                    footerTemplate: gettextCatalog.getString('Sum') + ': ${Sum}'
                },
                {
                    type: 'Sum',
                    field: 'Honap_11',
                    footerTemplate: gettextCatalog.getString('Sum') + ': ${Sum}'
                },
                {
                    type: 'Sum',
                    field: 'Honap_12',
                    footerTemplate: gettextCatalog.getString('Sum') + ': ${Sum}'
                },
                {
                    type: 'Custom',
                    customAggregate: vm.osszesFizetendo,
                    columnName: 'osszesFizetendo',
                    footerTemplate: gettextCatalog.getString('Sum') + ': ${Custom}'
                },
                {
                    type: 'Custom',
                    customAggregate: vm.osszesFizetett,
                    columnName: 'osszesFizetett',
                    footerTemplate: gettextCatalog.getString('Sum') + ': ${Custom}'
                }
            ]
        }];

        vm.rowIndexUnderEditing = -1;
        vm.fizetveWidth = 80;
        vm.columns = [
            {
                headerText: gettextCatalog.getString('General'),
                columns: [
                    {field: 'Id', isPrimaryKey: true, visible: false},
                    {
                        allowEditing: false,
                        headerText: gettextCatalog.getString('Name'),
                        textAlign: 'left',
                        template: '#educationalfeeregistercolumnTemplate1',
                        field: 'Versenyzo_Nev',
                        width: 175
                    },
                    {
                        field: 'SzuletesiIdo',
                        allowEditing: false,
                        headerText: gettextCatalog.getString('BirthDate'),
                        textAlign: 'center',
                        width: 100
                    }
                ],
                textAlign: 'center'
            },
            {
                headerText: gettextCatalog.getString('General'),
                columns: [
                    {
                        field: 'SzakosztalyNeve',
                        allowEditing: false,
                        headerText: gettextCatalog.getString('Section'),
                        textAlign: 'left',
                        width: 100
                    },
                    {
                        allowEditing: false,
                        headerText: gettextCatalog.getString('CoachName'),
                        textAlign: 'left',
                        template: '#educationalfeeregistercolumnTemplate2',
                        field: 'EdzoNeve',
                        width: 150
                    }
                ],
                textAlign: 'center'
            },
            {
                headerText: gettextCatalog.getString('January'),
                columns: [
                    {
                        field: 'Honap_1_kedvezmenyes_Text',
                        headerText: gettextCatalog.getString('NeedPay1'),
                        textAlign: 'left',
                        width: 90,
                        edit: vm.dropDownListEditorTemplate
                        /*
                        editType: 'dropdownedit',
                        edit: { params: { fields: {value: 'value', text: 'text'},
                                dataSource: vm.priceType,
                                query : new ej.data.Query()
                               }
                         */
                    },
                    {
                        field: 'Honap_1',
                        headerText: gettextCatalog.getString('Payed1'),
                        textAlign: 'left',
                        // editType: 'numericedit',
                        // edit: { params: { showSpinButton: false } },
                        type: 'number',
                        width: vm.fizetveWidth
                    },
                    {
                        field: 'Honap_1_kozlemeny',
                        headerText: gettextCatalog.getString('ReceiptNumber1'),
                        textAlign: 'left',
                        width: 90
                    },
                    {
                        field: 'Honap_1_FizDatum',
                        headerText: gettextCatalog.getString('PaymentDate1'),
                        textAlign: 'center',
                        editType: ej.Grid.EditingType.Date,
                        allowEditing: true,
                        edit: vm.dateTimeEditorTemplate,
                        width: 90
                    }
                ],
                textAlign: 'center'
            },
            {
                headerText: gettextCatalog.getString('February'),
                columns: [
                    {
                        field: 'Honap_2_kedvezmenyes_Text',
                        headerText: gettextCatalog.getString('NeedPay2'),
                        textAlign: 'left',
                        width: 90,
                        edit: vm.dropDownListEditorTemplate
                    },
                    {
                        field: 'Honap_2',
                        headerText: gettextCatalog.getString('Payed2'),
                        textAlign: 'left',
                        type: 'number',
                        width: vm.fizetveWidth
                    },
                    {
                        field: 'Honap_2_kozlemeny',
                        headerText: gettextCatalog.getString('ReceiptNumber2'),
                        textAlign: 'left',
                        width: 90
                    },
                    {
                        field: 'Honap_2_FizDatum',
                        headerText: gettextCatalog.getString('PaymentDate2'),
                        textAlign: 'center',
                        editType: ej.Grid.EditingType.Date,
                        allowEditing: true,
                        edit: vm.dateTimeEditorTemplate,
                        width: 90
                    }
                ],
                textAlign: 'center'
            },
            {
                headerText: gettextCatalog.getString('March'),
                columns: [
                    {
                        field: 'Honap_3_kedvezmenyes_Text',
                        headerText: gettextCatalog.getString('NeedPay3'),
                        textAlign: 'left',
                        width: 90,
                        edit: vm.dropDownListEditorTemplate
                    },
                    {
                        field: 'Honap_3',
                        headerText: gettextCatalog.getString('Payed3'),
                        textAlign: 'left',
                        type: 'number',
                        width: vm.fizetveWidth
                    },
                    {
                        field: 'Honap_3_kozlemeny',
                        headerText: gettextCatalog.getString('ReceiptNumber3'),
                        textAlign: 'left',
                        width: 90
                    },
                    {
                        field: 'Honap_3_FizDatum',
                        headerText: gettextCatalog.getString('PaymentDate3'),
                        textAlign: 'center',
                        editType: ej.Grid.EditingType.Date,
                        allowEditing: true,
                        edit: vm.dateTimeEditorTemplate,
                        width: 90
                    }
                ],
                textAlign: 'center'
            },
            {
                headerText: gettextCatalog.getString('April'),
                columns: [
                    {
                        field: 'Honap_4_kedvezmenyes_Text',
                        headerText: gettextCatalog.getString('NeedPay4'),
                        textAlign: 'left',
                        width: 90,
                        edit: vm.dropDownListEditorTemplate
                    },
                    {
                        field: 'Honap_4',
                        headerText: gettextCatalog.getString('Payed4'),
                        textAlign: 'left',
                        type: 'number',
                        width: vm.fizetveWidth
                    },
                    {
                        field: 'Honap_4_kozlemeny',
                        headerText: gettextCatalog.getString('ReceiptNumber4'),
                        textAlign: 'left',
                        width: 90
                    },
                    {
                        field: 'Honap_4_FizDatum',
                        headerText: gettextCatalog.getString('PaymentDate4'),
                        textAlign: 'center',
                        editType: ej.Grid.EditingType.Date,
                        allowEditing: true,
                        edit: vm.dateTimeEditorTemplate,
                        width: 90
                    }
                ],
                textAlign: 'center'
            },
            {
                headerText: gettextCatalog.getString('May'),
                columns: [
                    {
                        field: 'Honap_5_kedvezmenyes_Text',
                        headerText: gettextCatalog.getString('NeedPay5'),
                        textAlign: 'left',
                        width: 90,
                        edit: vm.dropDownListEditorTemplate
                    },
                    {
                        field: 'Honap_5',
                        headerText: gettextCatalog.getString('Payed5'),
                        textAlign: 'left',
                        type: 'number',
                        width: vm.fizetveWidth
                    },
                    {
                        field: 'Honap_5_kozlemeny',
                        headerText: gettextCatalog.getString('ReceiptNumber5'),
                        textAlign: 'left',
                        width: 90
                    },
                    {
                        field: 'Honap_5_FizDatum',
                        headerText: gettextCatalog.getString('PaymentDate5'),
                        textAlign: 'center',
                        editType: ej.Grid.EditingType.Date,
                        allowEditing: true,
                        edit: vm.dateTimeEditorTemplate,
                        width: 90
                    }
                ],
                textAlign: 'center'
            },
            {
                headerText: gettextCatalog.getString('June'),
                columns: [
                    {
                        field: 'Honap_6_kedvezmenyes_Text',
                        headerText: gettextCatalog.getString('NeedPay6'),
                        textAlign: 'left',
                        width: 90,
                        edit: vm.dropDownListEditorTemplate
                    },
                    {
                        field: 'Honap_6',
                        headerText: gettextCatalog.getString('Payed6'),
                        textAlign: 'left',
                        type: 'number',
                        width: vm.fizetveWidth
                    },
                    {
                        field: 'Honap_6_kozlemeny',
                        headerText: gettextCatalog.getString('ReceiptNumber6'),
                        textAlign: 'left',
                        width: 90
                    },
                    {
                        field: 'Honap_6_FizDatum',
                        headerText: gettextCatalog.getString('PaymentDate6'),
                        textAlign: 'center',
                        editType: ej.Grid.EditingType.Date,
                        allowEditing: true,
                        edit: vm.dateTimeEditorTemplate,
                        width: 90
                    }
                ],
                textAlign: 'center'
            },
            {
                headerText: gettextCatalog.getString('July'),
                columns: [
                    {
                        field: 'Honap_7_kedvezmenyes_Text',
                        headerText: gettextCatalog.getString('NeedPay7'),
                        textAlign: 'left',
                        width: 90,
                        edit: vm.dropDownListEditorTemplate
                    },
                    {
                        field: 'Honap_7',
                        headerText: gettextCatalog.getString('Payed7'),
                        textAlign: 'left',
                        type: 'number',
                        width: vm.fizetveWidth
                    },
                    {
                        field: 'Honap_7_kozlemeny',
                        headerText: gettextCatalog.getString('ReceiptNumber7'),
                        textAlign: 'left',
                        width: 90
                    },
                    {
                        field: 'Honap_7_FizDatum',
                        headerText: gettextCatalog.getString('PaymentDate7'),
                        textAlign: 'center',
                        editType: ej.Grid.EditingType.Date,
                        allowEditing: true,
                        edit: vm.dateTimeEditorTemplate,
                        width: 90
                    }
                ],
                textAlign: 'center'
            },
            {
                headerText: gettextCatalog.getString('August'),
                columns: [
                    {
                        field: 'Honap_8_kedvezmenyes_Text',
                        headerText: gettextCatalog.getString('NeedPay8'),
                        textAlign: 'left',
                        width: 90,
                        edit: vm.dropDownListEditorTemplate
                    },
                    {
                        field: 'Honap_8',
                        headerText: gettextCatalog.getString('Payed8'),
                        textAlign: 'left',
                        type: 'number',
                        width: vm.fizetveWidth
                    },
                    {
                        field: 'Honap_8_kozlemeny',
                        headerText: gettextCatalog.getString('ReceiptNumber8'),
                        textAlign: 'left',
                        width: 90
                    },
                    {
                        field: 'Honap_8_FizDatum',
                        headerText: gettextCatalog.getString('PaymentDate8'),
                        textAlign: 'center',
                        editType: ej.Grid.EditingType.Date,
                        allowEditing: true,
                        edit: vm.dateTimeEditorTemplate,
                        width: 90
                    }
                ],
                textAlign: 'center'
            },
            {
                headerText: gettextCatalog.getString('September'),
                columns: [
                    {
                        field: 'Honap_9_kedvezmenyes_Text',
                        headerText: gettextCatalog.getString('NeedPay9'),
                        textAlign: 'left',
                        width: 90,
                        edit: vm.dropDownListEditorTemplate
                    },
                    {
                        field: 'Honap_9',
                        headerText: gettextCatalog.getString('Payed9'),
                        textAlign: 'left',
                        type: 'number',
                        width: vm.fizetveWidth
                    },
                    {
                        field: 'Honap_9_kozlemeny',
                        headerText: gettextCatalog.getString('ReceiptNumber9'),
                        textAlign: 'left',
                        width: 90
                    },
                    {
                        field: 'Honap_9_FizDatum',
                        headerText: gettextCatalog.getString('PaymentDate9'),
                        textAlign: 'center',
                        editType: ej.Grid.EditingType.Date,
                        allowEditing: true,
                        edit: vm.dateTimeEditorTemplate,
                        width: 90
                    }
                ],
                textAlign: 'center'
            },
            {
                headerText: gettextCatalog.getString('October'),
                columns: [
                    {
                        field: 'Honap_10_kedvezmenyes_Text',
                        headerText: gettextCatalog.getString('NeedPay10'),
                        textAlign: 'left',
                        width: 90,
                        edit: vm.dropDownListEditorTemplate
                    },
                    {
                        field: 'Honap_10',
                        headerText: gettextCatalog.getString('Payed10'),
                        textAlign: 'left',
                        type: 'number',
                        width: vm.fizetveWidth
                    },
                    {
                        field: 'Honap_10_kozlemeny',
                        headerText: gettextCatalog.getString('ReceiptNumber10'),
                        textAlign: 'left',
                        width: 90
                    },
                    {
                        field: 'Honap_10_FizDatum',
                        headerText: gettextCatalog.getString('PaymentDate10'),
                        textAlign: 'center',
                        editType: ej.Grid.EditingType.Date,
                        allowEditing: true,
                        edit: vm.dateTimeEditorTemplate,
                        width: 90
                    }
                ],
                textAlign: 'center'
            },
            {
                headerText: gettextCatalog.getString('November'),
                columns: [
                    {
                        field: 'Honap_11_kedvezmenyes_Text',
                        headerText: gettextCatalog.getString('NeedPay11'),
                        textAlign: 'left',
                        width: 90,
                        edit: vm.dropDownListEditorTemplate
                    },
                    {
                        field: 'Honap_11',
                        headerText: gettextCatalog.getString('Payed11'),
                        textAlign: 'left',
                        type: 'number',
                        width: vm.fizetveWidth
                    },
                    {
                        field: 'Honap_11_kozlemeny',
                        headerText: gettextCatalog.getString('ReceiptNumber11'),
                        textAlign: 'left',
                        width: 90
                    },
                    {
                        field: 'Honap_11_FizDatum',
                        headerText: gettextCatalog.getString('PaymentDate11'),
                        textAlign: 'center',
                        editType: ej.Grid.EditingType.Date,
                        allowEditing: true,
                        edit: vm.dateTimeEditorTemplate,
                        width: 90
                    }
                ],
                textAlign: 'center'
            },
            {
                headerText: gettextCatalog.getString('December'),
                columns: [
                    {
                        field: 'Honap_12_kedvezmenyes_Text',
                        headerText: gettextCatalog.getString('NeedPay12'),
                        textAlign: 'left',
                        width: 90,
                        edit: vm.dropDownListEditorTemplate
                    },
                    {
                        field: 'Honap_12',
                        headerText: gettextCatalog.getString('Payed12'),
                        textAlign: 'left',
                        type: 'number',
                        width: vm.fizetveWidth
                    },
                    {
                        field: 'Honap_12_kozlemeny',
                        headerText: gettextCatalog.getString('ReceiptNumber12'),
                        textAlign: 'left',
                        width: 90
                    },
                    {
                        field: 'Honap_12_FizDatum',
                        headerText: gettextCatalog.getString('PaymentDate12'),
                        textAlign: 'center',
                        editType: ej.Grid.EditingType.Date,
                        allowEditing: true,
                        edit: vm.dateTimeEditorTemplate,
                        width: 90
                    }
                ],
                textAlign: 'center'
            },
            {
                headerText: gettextCatalog.getString('Summaries'),
                columns: [
                    {
                        field: 'osszesFizetendo',
                        headerText: gettextCatalog.getString('SumNeedPay'),
                        textAlign: 'center',
                        allowEditing: false,
                        width: 90
                    },
                    {
                        field: 'osszesFizetett',
                        headerText: gettextCatalog.getString('SumPayed'),
                        textAlign: 'center',
                        allowEditing: false,
                        width: 90
                    }
                ],
                textAlign: 'center'
            }
        ];

        function dataBound() {
            setTimeout(function () {
                var grid = document.getElementById('Grid').ej2_instances[0];
                var el = grid.element.querySelector('.e-frozencontent');
                if (el !== null) {
                    el.style.height = grid.element.querySelector('.e-movablecontent').getBoundingClientRect().height + 'px';
                }
            }, 100);
        }

        var grid = new ej2.grids.Grid({
            dataSource: [],
            // allowTextWrap: true,
            toolbar: $rootScope.toolbarItemsWithSearch,
            allowPaging: true,
            // frozenColumns: 3,
            pageSettings: $rootScope.pageSettings,
            editSettings: {allowEditing: true, mode: 'Batch', showConfirmDialog: false, showDeleteConfirmDialog: false},
            allowExcelExport: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            columns: vm.columns,
            aggregates: vm.summaryRows,
            // dataBound: dataBound,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'searching' || args.requestType === 'refresh') {
                    $rootScope.compile($('#Grid'), $scope);
                }
            },
            queryCellInfo: querycellinfo,
            cellEdit: cellEdit,
            cellSave: cellSave
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        var fut = false;
        $('#monthDropDownList').ejDropDownList({
            dataSource: vm.monthList,
            fields: {text: 'text'},
            showCheckbox: true,
            width: '100%',
            checkChange: function (args) {
                var DropDownListObj = $('#monthDropDownList').data('ejDropDownList');
                if (fut) {
                    return;
                }
                fut = true;
                if (args.selectedValue < 0) {
                    $('#monthDropDownList').ejDropDownList('unselectItemsByIndices', '1,2,3,4,5,6,7,8,9,10,11,12,13');
                    $('#monthDropDownList').ejDropDownList('selectItemByValue', -1);
                } else {
                    $('#monthDropDownList').ejDropDownList('unselectItemsByIndices', 0);
                    $('#monthDropDownList').ejDropDownList((args.isChecked ? 'selectItemByValue' : 'unselectItemByValue'), args.selectedValue);
                }
                fut = false;
            },
            create: function () {
                $('#monthDropDownList').ejDropDownList('selectItemByValue', -1);
            },
            multiSelectMode: ej.MultiSelectMode.Delimiter,
        });

        // Public functions
        vm.sectionDataBound = sectionDataBound;
        vm.sectionSelect = sectionSelect;
        vm.coachDataBound = coachDataBound;
        vm.coachSelect = coachSelect;
        vm.getAthletes = getAthletesClick;
        vm.yearDataBound = yearDataBound;
        vm.monthDataBound = monthDataBound;
        vm.yearSelect = yearSelect;
        vm.saveWithNumbers = saveWithNumbers;
        vm.saveWithoutNumbers = saveWithoutNumbers;
        vm.goToDailyPayments = goToDailyPayments;
        vm.goToAthlete = goToAthlete;
        vm.openCoach = openCoach;
        vm.getReducedPriceTypes = getReducedPriceTypes;

        // Activate page
        activate();

        function activate() {
            var promises = [authenticationService.getRight('MEGTTAGDNYILV'), authenticationService.getRight('MEGTOKTDNYILV'), paramHelper.getParams([], ['educationalFeeRegister.sectionId', 'educationalFeeRegister.year', 'educationalFeeRegister.coachId', 'educationalFeeRegister.ageGroupId']), authenticationService.getRight('UJOKTDNYILV'), authenticationService.getRight('UJOKTDNYILV')];
            $q.all(promises).then(function (results) {
                if (results[0] !== true || results[1] !== true) {
                    log.permissionError(true);
                } else {
                    $q.all([getcoaches(), getSections(), getReducedPriceTypes()]).then(function () {
                        if (results[2]['educationalFeeRegister.sectionId'] && results[2]['educationalFeeRegister.coachId'] && results[2]['educationalFeeRegister.year']) {
                            $timeout(function () {
                                if (results[2]['educationalFeeRegister.ageGroupId']) {
                                    var DropDownListObj = $('#monthDropDownList').data('ejDropDownList');
                                    DropDownListObj.selectItemByValue(JSON.parse(results[2]['educationalFeeRegister.ageGroupId']));
                                }
                                showHideColumns();
                                getAthletes(results[2]['educationalFeeRegister.sectionId'], results[2]['educationalFeeRegister.coachId'], results[2]['educationalFeeRegister.year']);
                            }, 0);
                        }
                    });

                    vm.UJOKTDNYILV = results[3];
                    vm.UJOKTDNYILV = results[4];
                }
            });
        }

        function getReducedPriceTypes() {
            return dataservice.getReducedEducationalFeeTypes(authenticationService.getLanguage()).then(function (data) {
                vm.priceType = vm.priceType.concat(data.itemsList);
                for (var i = 0; i < data.itemsList.length; i++) {
                    vm.kedvezmenyNevek.push(data.itemsList[i].text);
                }
            });
        }

        function getFeeDatas() {
            return dataservice.getFeeDatas(vm.sectionId).then(function (data) {
                vm.sectionFees = data.itemsList;
            });
        }

        function getcoaches() {
            return dataservice.coachSelect(vm.sectionId).then(function (data) {
                data.itemsList.unshift({value: '0', text: gettextCatalog.getString('All')});
                vm.coachList = data.itemsList;
            });
        }

        function coachDataBound() {
            if (vm.coachList.length === 1) {
                angular.element('#coachDropDown').ejDropDownList('selectItemByValue', vm.coachList[0].value);
                vm.coachId = vm.coachList[0].value;
            } else {
                angular.element('#coachDropDown').ejDropDownList('selectItemByValue', vm.coachId);
            }
        }

        function coachSelect(args) {
            vm.coachId = args.value;
            getSections();
        }

        //szakosztályok lekérése
        function getSections() {
            return dataservice.sectionDropDownListWithFees(vm.coachId).then(function (data) {
                data.itemsList.unshift({value: '0', text: gettextCatalog.getString('All')});
                vm.sectionList = data.itemsList;
            });
        }

        // Run after data bounded
        function sectionDataBound() {
            if (vm.sectionList.length === 1) {
                angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.sectionList[0].value);
                vm.sectionId = vm.sectionList[0].value;
            } else {
                angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.sectionId);
            }
        }

        // Run after selection
        function sectionSelect(args) {
            vm.EducationalFee = vm.sectionList[args.itemId].OktatasiDij !== null ? vm.sectionList[args.itemId].OktatasiDij : 0;
            vm.ReducedEducationalFee = vm.sectionList[args.itemId].KedvezmenyesOktatasiDij !== null ? vm.sectionList[args.itemId].KedvezmenyesOktatasiDij : 0;
            vm.sectionId = args.value;
        }

        function yearDataBound() {
            if (vm.yearList.length === 1) {
                angular.element('#yearDropDownList').ejDropDownList('selectItemByValue', vm.yearList[0].value);
                vm.year = vm.yearList[0].value;
            }
        }

        function monthDataBound() {
            if (vm.monthList.length === 1) {
                angular.element('#monthDropDownList').ejDropDownList('selectItemByValue', vm.monthList[0].value);
                vm.year = vm.yearList[0].value;
            }
        }

        function yearSelect(args) {
            vm.year = args.value;
        }

        function getAthletesClick() {
            showHideColumns();
            getAthletes();
        }

        function showHideColumns() {
            $timeout(function () {
                var DropDownListObj = $('#monthDropDownList').data('ejDropDownList');
                var vmi = DropDownListObj.getSelectedValue();
                if (vmi.includes(-1)) {
                    grid.frozenColumns = 3;
                } else {
                    grid.frozenColumns = null;
                }
                for (var m = 2; m < 14; m++) {
                    if (vmi.includes(m - 2) || vmi.includes(-1)) {
                        for (var j = 0; j < 4; j++) {
                            vm.columns[m].columns[j].visible = true;
                        }
                    } else {
                        for (var j = 0; j < 4; j++) {
                            vm.columns[m].columns[j].visible = false;
                        }
                    }
                }
                grid.refreshColumns();
                $scope.$apply();
            }, 0);
        }

        function getAthletes(sectionId, coachId, year) {
            if (sectionId !== undefined) {
                vm.sectionId = sectionId;
                vm.coachId = coachId;
                vm.year = year;
            } else {
                // a syncfusion direktívák miatt
                $scope.$broadcast('submitted');
                if ($scope.form.$valid === false) {
                    log.errorMsg(gettextCatalog.getString('RequiredFieldsError'));
                    return;
                }
            }
            getFeeDatas();
            paramHelper.setParams([{'educationalFeeRegister.sectionId': vm.sectionId}, {'educationalFeeRegister.year': vm.year}, {'educationalFeeRegister.coachId': vm.coachId}, {'educationalFeeRegister.ageGroupId': JSON.stringify($('#monthDropDownList').data('ejDropDownList').getSelectedValue())}]);
            var DropDownListObj = $('#monthDropDownList').data('ejDropDownList');
            var months = DropDownListObj.getSelectedValue();
            dataservice.getAthletesForEducationalFeeRegister(vm.sectionId, vm.coachId, vm.year, months).then(function (data) {
                $filter('dateStringFilterPromise')(data.itemsList, 'SzuletesiIdo').then(function (result) {
                    $filter('dateStringFilterPromise')(result, 'Honap_1_FizDatum').then(function (result1) {
                        $filter('dateStringFilterPromise')(result1, 'Honap_2_FizDatum').then(function (result2) {
                            $filter('dateStringFilterPromise')(result2, 'Honap_3_FizDatum').then(function (result3) {
                                $filter('dateStringFilterPromise')(result3, 'Honap_4_FizDatum').then(function (result4) {
                                    $filter('dateStringFilterPromise')(result4, 'Honap_5_FizDatum').then(function (result5) {
                                        $filter('dateStringFilterPromise')(result5, 'Honap_6_FizDatum').then(function (result6) {
                                            $filter('dateStringFilterPromise')(result6, 'Honap_7_FizDatum').then(function (result7) {
                                                $filter('dateStringFilterPromise')(result7, 'Honap_8_FizDatum').then(function (result8) {
                                                    $filter('dateStringFilterPromise')(result8, 'Honap_9_FizDatum').then(function (result9) {
                                                        $filter('dateStringFilterPromise')(result9, 'Honap_10_FizDatum').then(function (result10) {
                                                            $filter('dateStringFilterPromise')(result10, 'Honap_11_FizDatum').then(function (result11) {
                                                                $filter('dateStringFilterPromise')(result11, 'Honap_12_FizDatum').then(function (result12) {
                                                                    vm.data = result12;
                                                                    $timeout(function () {
                                                                        vm.AthleteUnderEditing = '';
                                                                        $scope.$apply();
                                                                        grid.dataSource = vm.data;
                                                                    }, 500);
                                                                });
                                                            });
                                                        });
                                                    });
                                                });
                                            });
                                        });
                                    });
                                });
                            });
                        });
                    });
                });
            });
        }

        // cellák színezése és utolsó két oszlopban az összesítés
        function querycellinfo(args) {
            var element = angular.element(args.cell);
            if (args.column.field.indexOf('Honap_') !== -1) {
                switch (args.data['Honap_' + args.column.field[6] + (args.column.field[7] && args.column.field[7] !== '_' ? args.column.field[7] : '') + '_ReadOnly']) {
                    case 'MT':
                        element.css('background-color', '#efdcdc');
                        break;
                    case 'O':
                        element.css('background-color', '#c0c0c0');
                        break;
                    case 'P':
                        element.css('background-color', '#CCC4FF');
                        break;
                }
            }
            if (args.column.field === 'osszesFizetendo') {
                args.data['osszesFizetendo'] = args.data['Honap_1_fizetendo'] + args.data['Honap_2_fizetendo'] + args.data['Honap_3_fizetendo'] + args.data['Honap_4_fizetendo'] + args.data['Honap_5_fizetendo'] + args.data['Honap_6_fizetendo'] + args.data['Honap_7_fizetendo'] + args.data['Honap_8_fizetendo'] + args.data['Honap_9_fizetendo'] + args.data['Honap_10_fizetendo'] + args.data['Honap_11_fizetendo'] + args.data['Honap_12_fizetendo']; //set the datasource value
                element.html(args.data['osszesFizetendo']); //set the element values
            }
            if (args.column.field === 'osszesFizetett') {
                args.data['osszesFizetett'] = (args.data['Honap_1'] !== 'null' ? args.data['Honap_1'] * 1 : 0) + (args.data['Honap_2'] !== 'null' ? args.data['Honap_2'] * 1 : 0) + (args.data['Honap_3'] !== 'null' ? args.data['Honap_3'] * 1 : 0) + (args.data['Honap_4'] !== 'null' ? args.data['Honap_4'] * 1 : 0) + (args.data['Honap_5'] !== 'null' ? args.data['Honap_5'] * 1 : 0) + (args.data['Honap_6'] !== 'null' ? args.data['Honap_6'] * 1 : 0) + (args.data['Honap_7'] !== 'null' ? args.data['Honap_7'] * 1 : 0) + (args.data['Honap_8'] !== 'null' ? args.data['Honap_8'] * 1 : 0) + (args.data['Honap_9'] !== 'null' ? args.data['Honap_9'] * 1 : 0) + (args.data['Honap_10'] !== 'null' ? args.data['Honap_10'] * 1 : 0) + (args.data['Honap_11'] !== 'null' ? args.data['Honap_11'] * 1 : 0) + (args.data['Honap_12'] !== 'null' ? args.data['Honap_12'] * 1 : 0);
                //set the datasource value
                element.html(args.data['osszesFizetett']); //set the element values
            }
        }

        // szerkesztés letiltása cellánként
        function cellEdit(args) {
            if (
                (args.rowData.Honap_1_kedvezmenyes_Text === 'B' || args.rowData.Honap_1_kedvezmenyes_Text === 'EP') && (args.columnName === 'Honap_1' || args.columnName === 'Honap_1_kozlemeny' || args.columnName === 'Honap_1_FizDatum') ||
                (args.rowData.Honap_2_kedvezmenyes_Text === 'B' || args.rowData.Honap_2_kedvezmenyes_Text === 'EP') && (args.columnName === 'Honap_2' || args.columnName === 'Honap_2_kozlemeny' || args.columnName === 'Honap_2_FizDatum') ||
                (args.rowData.Honap_3_kedvezmenyes_Text === 'B' || args.rowData.Honap_3_kedvezmenyes_Text === 'EP') && (args.columnName === 'Honap_3' || args.columnName === 'Honap_3_kozlemeny' || args.columnName === 'Honap_3_FizDatum') ||
                (args.rowData.Honap_4_kedvezmenyes_Text === 'B' || args.rowData.Honap_4_kedvezmenyes_Text === 'EP') && (args.columnName === 'Honap_4' || args.columnName === 'Honap_4_kozlemeny' || args.columnName === 'Honap_4_FizDatum') ||
                (args.rowData.Honap_5_kedvezmenyes_Text === 'B' || args.rowData.Honap_5_kedvezmenyes_Text === 'EP') && (args.columnName === 'Honap_5' || args.columnName === 'Honap_5_kozlemeny' || args.columnName === 'Honap_5_FizDatum') ||
                (args.rowData.Honap_6_kedvezmenyes_Text === 'B' || args.rowData.Honap_6_kedvezmenyes_Text === 'EP') && (args.columnName === 'Honap_6' || args.columnName === 'Honap_6_kozlemeny' || args.columnName === 'Honap_6_FizDatum') ||
                (args.rowData.Honap_7_kedvezmenyes_Text === 'B' || args.rowData.Honap_7_kedvezmenyes_Text === 'EP') && (args.columnName === 'Honap_7' || args.columnName === 'Honap_7_kozlemeny' || args.columnName === 'Honap_7_FizDatum') ||
                (args.rowData.Honap_8_kedvezmenyes_Text === 'B' || args.rowData.Honap_8_kedvezmenyes_Text === 'EP') && (args.columnName === 'Honap_8' || args.columnName === 'Honap_8_kozlemeny' || args.columnName === 'Honap_8_FizDatum') ||
                (args.rowData.Honap_9_kedvezmenyes_Text === 'B' || args.rowData.Honap_9_kedvezmenyes_Text === 'EP') && (args.columnName === 'Honap_9' || args.columnName === 'Honap_9_kozlemeny' || args.columnName === 'Honap_9_FizDatum') ||
                (args.rowData.Honap_10_kedvezmenyes_Text === 'B' || args.rowData.Honap_10_kedvezmenyes_Text === 'EP') && (args.columnName === 'Honap_10' || args.columnName === 'Honap_10_kozlemeny' || args.columnName === 'Honap_10_FizDatum') ||
                (args.rowData.Honap_11_kedvezmenyes_Text === 'B' || args.rowData.Honap_11_kedvezmenyes_Text === 'EP') && (args.columnName === 'Honap_11' || args.columnName === 'Honap_11_kozlemeny' || args.columnName === 'Honap_11_FizDatum') ||
                (args.rowData.Honap_12_kedvezmenyes_Text === 'B' || args.rowData.Honap_12_kedvezmenyes_Text === 'EP') && (args.columnName === 'Honap_12' || args.columnName === 'Honap_12_kozlemeny' || args.columnName === 'Honap_12_FizDatum') ||

                args.columnName === 'Honap_1_kedvezmenyes_Text' && (args.rowData.Honap_1_ReadOnly !== 'A' || args.rowData.Tagdijas_1 === true) ||
                args.columnName === 'Honap_2_kedvezmenyes_Text' && (args.rowData.Honap_2_ReadOnly !== 'A' || args.rowData.Tagdijas_2 === true) ||
                args.columnName === 'Honap_3_kedvezmenyes_Text' && (args.rowData.Honap_3_ReadOnly !== 'A' || args.rowData.Tagdijas_3 === true) ||
                args.columnName === 'Honap_4_kedvezmenyes_Text' && (args.rowData.Honap_4_ReadOnly !== 'A' || args.rowData.Tagdijas_4 === true) ||
                args.columnName === 'Honap_5_kedvezmenyes_Text' && (args.rowData.Honap_5_ReadOnly !== 'A' || args.rowData.Tagdijas_5 === true) ||
                args.columnName === 'Honap_6_kedvezmenyes_Text' && (args.rowData.Honap_6_ReadOnly !== 'A' || args.rowData.Tagdijas_6 === true) ||
                args.columnName === 'Honap_7_kedvezmenyes_Text' && (args.rowData.Honap_7_ReadOnly !== 'A' || args.rowData.Tagdijas_7 === true) ||
                args.columnName === 'Honap_8_kedvezmenyes_Text' && (args.rowData.Honap_8_ReadOnly !== 'A' || args.rowData.Tagdijas_8 === true) ||
                args.columnName === 'Honap_9_kedvezmenyes_Text' && (args.rowData.Honap_9_ReadOnly !== 'A' || args.rowData.Tagdijas_9 === true) ||
                args.columnName === 'Honap_10_kedvezmenyes_Text' && (args.rowData.Honap_10_ReadOnly !== 'A' || args.rowData.Tagdijas_10 === true) ||
                args.columnName === 'Honap_11_kedvezmenyes_Text' && (args.rowData.Honap_11_ReadOnly !== 'A' || args.rowData.Tagdijas_11 === true) ||
                args.columnName === 'Honap_12_kedvezmenyes_Text' && (args.rowData.Honap_12_ReadOnly !== 'A' || args.rowData.Tagdijas_12 === true) ||

                // Kérésre nem szerkeszthető, ha nem nulla vagy null van benne
                args.columnName === 'Honap_1_kedvezmenyes_Text' && (args.rowData.Honap_1 !== 0 && args.rowData.Honap_1 !== null) ||
                args.columnName === 'Honap_2_kedvezmenyes_Text' && (args.rowData.Honap_2 !== 0 && args.rowData.Honap_2 !== null) ||
                args.columnName === 'Honap_3_kedvezmenyes_Text' && (args.rowData.Honap_3 !== 0 && args.rowData.Honap_3 !== null) ||
                args.columnName === 'Honap_4_kedvezmenyes_Text' && (args.rowData.Honap_4 !== 0 && args.rowData.Honap_4 !== null) ||
                args.columnName === 'Honap_5_kedvezmenyes_Text' && (args.rowData.Honap_5 !== 0 && args.rowData.Honap_5 !== null) ||
                args.columnName === 'Honap_6_kedvezmenyes_Text' && (args.rowData.Honap_6 !== 0 && args.rowData.Honap_6 !== null) ||
                args.columnName === 'Honap_7_kedvezmenyes_Text' && (args.rowData.Honap_7 !== 0 && args.rowData.Honap_7 !== null) ||
                args.columnName === 'Honap_8_kedvezmenyes_Text' && (args.rowData.Honap_8 !== 0 && args.rowData.Honap_8 !== null) ||
                args.columnName === 'Honap_9_kedvezmenyes_Text' && (args.rowData.Honap_9 !== 0 && args.rowData.Honap_9 !== null) ||
                args.columnName === 'Honap_10_kedvezmenyes_Text' && (args.rowData.Honap_10 !== 0 && args.rowData.Honap_10 !== null) ||
                args.columnName === 'Honap_11_kedvezmenyes_Text' && (args.rowData.Honap_11 !== 0 && args.rowData.Honap_11 !== null) ||
                args.columnName === 'Honap_12_kedvezmenyes_Text' && (args.rowData.Honap_12 !== 0 && args.rowData.Honap_12 !== null) ||

                args.columnName === 'Honap_1' && (args.rowData.Honap_1_ReadOnly !== 'A' || args.rowData.Tagdijas_1 === true) ||
                args.columnName === 'Honap_2' && (args.rowData.Honap_2_ReadOnly !== 'A' || args.rowData.Tagdijas_2 === true) ||
                args.columnName === 'Honap_3' && (args.rowData.Honap_3_ReadOnly !== 'A' || args.rowData.Tagdijas_3 === true) ||
                args.columnName === 'Honap_4' && (args.rowData.Honap_4_ReadOnly !== 'A' || args.rowData.Tagdijas_4 === true) ||
                args.columnName === 'Honap_5' && (args.rowData.Honap_5_ReadOnly !== 'A' || args.rowData.Tagdijas_5 === true) ||
                args.columnName === 'Honap_6' && (args.rowData.Honap_6_ReadOnly !== 'A' || args.rowData.Tagdijas_6 === true) ||
                args.columnName === 'Honap_7' && (args.rowData.Honap_7_ReadOnly !== 'A' || args.rowData.Tagdijas_7 === true) ||
                args.columnName === 'Honap_8' && (args.rowData.Honap_8_ReadOnly !== 'A' || args.rowData.Tagdijas_8 === true) ||
                args.columnName === 'Honap_9' && (args.rowData.Honap_9_ReadOnly !== 'A' || args.rowData.Tagdijas_9 === true) ||
                args.columnName === 'Honap_10' && (args.rowData.Honap_10_ReadOnly !== 'A' || args.rowData.Tagdijas_10 === true) ||
                args.columnName === 'Honap_11' && (args.rowData.Honap_11_ReadOnly !== 'A' || args.rowData.Tagdijas_11 === true) ||
                args.columnName === 'Honap_12' && (args.rowData.Honap_12_ReadOnly !== 'A' || args.rowData.Tagdijas_12 === true) ||

                args.columnName === 'Honap_1_kozlemeny' && (args.rowData.Honap_1_ReadOnly !== 'A' || args.rowData.Tagdijas_1 === true) ||
                args.columnName === 'Honap_2_kozlemeny' && (args.rowData.Honap_2_ReadOnly !== 'A' || args.rowData.Tagdijas_2 === true) ||
                args.columnName === 'Honap_3_kozlemeny' && (args.rowData.Honap_3_ReadOnly !== 'A' || args.rowData.Tagdijas_3 === true) ||
                args.columnName === 'Honap_4_kozlemeny' && (args.rowData.Honap_4_ReadOnly !== 'A' || args.rowData.Tagdijas_4 === true) ||
                args.columnName === 'Honap_5_kozlemeny' && (args.rowData.Honap_5_ReadOnly !== 'A' || args.rowData.Tagdijas_5 === true) ||
                args.columnName === 'Honap_6_kozlemeny' && (args.rowData.Honap_6_ReadOnly !== 'A' || args.rowData.Tagdijas_6 === true) ||
                args.columnName === 'Honap_7_kozlemeny' && (args.rowData.Honap_7_ReadOnly !== 'A' || args.rowData.Tagdijas_7 === true) ||
                args.columnName === 'Honap_8_kozlemeny' && (args.rowData.Honap_8_ReadOnly !== 'A' || args.rowData.Tagdijas_8 === true) ||
                args.columnName === 'Honap_9_kozlemeny' && (args.rowData.Honap_9_ReadOnly !== 'A' || args.rowData.Tagdijas_9 === true) ||
                args.columnName === 'Honap_10_kozlemeny' && (args.rowData.Honap_10_ReadOnly !== 'A' || args.rowData.Tagdijas_10 === true) ||
                args.columnName === 'Honap_11_kozlemeny' && (args.rowData.Honap_11_ReadOnly !== 'A' || args.rowData.Tagdijas_11 === true) ||
                args.columnName === 'Honap_12_kozlemeny' && (args.rowData.Honap_12_ReadOnly !== 'A' || args.rowData.Tagdijas_12 === true) ||

                args.columnName === 'Honap_1_FizDatum' && (args.rowData.Honap_1_ReadOnly !== 'A' || args.rowData.Tagdijas_1 === true) ||
                args.columnName === 'Honap_2_FizDatum' && (args.rowData.Honap_2_ReadOnly !== 'A' || args.rowData.Tagdijas_2 === true) ||
                args.columnName === 'Honap_3_FizDatum' && (args.rowData.Honap_3_ReadOnly !== 'A' || args.rowData.Tagdijas_3 === true) ||
                args.columnName === 'Honap_4_FizDatum' && (args.rowData.Honap_4_ReadOnly !== 'A' || args.rowData.Tagdijas_4 === true) ||
                args.columnName === 'Honap_5_FizDatum' && (args.rowData.Honap_5_ReadOnly !== 'A' || args.rowData.Tagdijas_5 === true) ||
                args.columnName === 'Honap_6_FizDatum' && (args.rowData.Honap_6_ReadOnly !== 'A' || args.rowData.Tagdijas_6 === true) ||
                args.columnName === 'Honap_7_FizDatum' && (args.rowData.Honap_7_ReadOnly !== 'A' || args.rowData.Tagdijas_7 === true) ||
                args.columnName === 'Honap_8_FizDatum' && (args.rowData.Honap_8_ReadOnly !== 'A' || args.rowData.Tagdijas_8 === true) ||
                args.columnName === 'Honap_9_FizDatum' && (args.rowData.Honap_9_ReadOnly !== 'A' || args.rowData.Tagdijas_9 === true) ||
                args.columnName === 'Honap_10_FizDatum' && (args.rowData.Honap_10_ReadOnly !== 'A' || args.rowData.Tagdijas_10 === true) ||
                args.columnName === 'Honap_11_FizDatum' && (args.rowData.Honap_11_ReadOnly !== 'A' || args.rowData.Tagdijas_11 === true) ||
                args.columnName === 'Honap_12_FizDatum' && (args.rowData.Honap_12_ReadOnly !== 'A' || args.rowData.Tagdijas_12 === true)
            ) {
                args.cancel = true;
            } else {
                $timeout(function () {
                    new ej2.data.DataManager(vm.data).executeQuery(new ej2.data.Query().where('Id', 'equal', args.rowData.Id)).then(function (result) {
                        vm.rowUnderEditing = result.result[0];
                    });
                    vm.AthleteUnderEditing = args.rowData.Versenyzo_Nev;
                    $scope.$apply();
                }, 0);
            }
        }

        function saveWithoutNumbers() {
            return save(false);
        }

        function saveWithNumbers() {
            return save(true);
        }

        function save(withNumbers) {
            if (vm.UJOKTDNYILV || vm.UJOKTDNYILV) {
                // batchSave();
                return dataservice.updateOktatasiDijfizetesek(vm.modifiedRows, withNumbers).then(function () {
                    log.successMsg('Saved');
                    vm.modifiedRows = [];
                    return true;
                });
            } else {
                log.permissionError();
            }
        }

        function batchSave() {
            grid.editModule.batchSave();
        }

        function goToDailyPayments() {
            paramHelper.setParams([{'dailyEducationalFeePayments.sectionId': vm.sectionId}, {'dailyEducationalFeePayments.coachId': vm.coachId}, {'dailyEducationalFeePayments.year': vm.year}]);
            saveWithoutNumbers().then(function () {
                $state.go('business.dailyEducationalFeePayments');
            });
        }

        function goToAthlete(id) {
            $q.all([authenticationService.getRight('MEGTSPORTLIST'), authenticationService.getRight('MEGTSPORTLIST')]).then(function (results) {
                if (results[0] || results[1]) {
                    paramHelper.setParams([{'athleteModify.sportoloId': id}]);
                    $state.go('athletes.athletesManagement.athleteModify.dataSheet');
                } else {
                    log.permissionError();
                }
            });
        }

        function openCoach(edzoId) {
            $q.all([authenticationService.getRight('MODFELH'), authenticationService.getRight('MEGTFELH')]).then(function (results) {
                if (results[0] || results[1]) {
                    paramHelper.setParams([{'newUser.userId': edzoId}]);
                    $state.go('settings.userManagement.modifyUser');
                } else {
                    log.permissionError();
                }
            });
        }

        function cellSave(args) {
            if (args.value != null && args.value !== vm.rowUnderEditing[args.columnName]) {
                $timeout(function () {
                    vm.modifiedRows.push(vm.rowUnderEditing);
                    $scope.$apply();
                }, 500);
            }
            vm.AthleteUnderEditing = '';
            new ej2.data.DataManager(vm.data).executeQuery(new ej2.data.Query().where('Id', 'equal', args.rowData.Id)).then(function (result) {
                result.result[0][args.columnName] = args.value;
                grid.refresh();
            });
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.business.educationalFeeRegister')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'business.educationalFeeRegister',
                config: {
                    url: '/educationalFeeRegister',
                    templateUrl: 'app/business/educationalFeeRegister/educationalFeeRegister.html',
                    controller: 'EducationalFeeRegisterController',
                    controllerAs: 'vm',
                    title: 'EducationalFeeRegister',
                    settings: {
                        navId: 233,
                        level: 2,
                        order: 3,
                        orderTitle_hu: 'Oktatási díj nyilvántartás',
                        orderTitle_en: 'Educational Fee Register',
                        parentId: 3,
                        content: 'EducationalFeeRegister',
                        permission: ['7'],
                        activatorPermission: '"MEGTTAGDNYILV"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    modFeesCtrl.$inject = ["log", "$rootScope", "gettextCatalog", "dataservice", "authenticationService", "$q", "$scope"];
    angular
        .module('app.business.modifyFees')
        .controller('modifyFeesController', modFeesCtrl);

    function modFeesCtrl(log, $rootScope, gettextCatalog, dataservice, authenticationService, $q, $scope) {
        var vm = this;
        $rootScope.vm = vm;

        $rootScope.title = gettextCatalog.getString('ModifyFees');

        var elem;
        var checkBoxObj;
        var checkBoxEditorTemplate =
            {
                create: function () {
                    elem = document.createElement('input');
                    return elem;
                },
                read: function () {
                    return checkBoxObj.checked.toString();
                },
                destroy: function () {
                    if (checkBoxObj != null) {
                        checkBoxObj.destroy();
                    }
                },
                write: function (args) {
                    var s = args.element.id.toString().replace('Grid', '');
                    checkBoxObj = new ej2.buttons.CheckBox({
                        checked: args.rowData[s],
                        value: args.rowData[s]
                    });
                    checkBoxObj.appendTo(elem);
                }
            };

        // Grid's details
        vm.toleranceDays = 10;
        vm.ddlYearValue = 0;
        vm.fromDate = new Date((new Date()).getFullYear(), 0, 1);
        vm.onlyNew = false;
        vm.saveData = saveData;
        vm.closeYear = closeYear;
        vm.meteOut = meteOut;
        vm.nonClosedYears = [];
        vm.selectedYear = 0;
        vm.closeYearEnabled = false;
        vm.yearclosed = false;
        vm.yearSelect = yearSelect;

        vm.columns = [{
            field: 'Id',
            visible: false,
            isPrimaryKey: true,
            isIdentity: true
        }, {
            field: 'Nev',
            headerText: gettextCatalog.getString('SectionName'),
            textAlign: 'center',
            width: 200,
            allowEditing: false
        }, {
            field: 'Tagdij',
            headerText: gettextCatalog.getString('Fee'),
            textAlign: 'center',
            width: 100,
            editTemplate: vm.tableNumericEditorTemplate,
            allowEditing: true
        }, {
            field: 'KedvezmenyesTD',
            headerText: gettextCatalog.getString('ReducedFee'),
            textAlign: 'center',
            width: 140,
            editTemplate: vm.tableNumericEditorTemplate,
            allowEditing: true
        }, {
            field: 'KedvezmenyesTD2',
            headerText: gettextCatalog.getString('ReducedFee') + ' 2',
            textAlign: 'center',
            width: 140,
            editTemplate: vm.tableNumericEditorTemplate,
            allowEditing: true
        }, {
            field: 'KedvezmenyesTD3',
            headerText: gettextCatalog.getString('ReducedFee') + ' 3',
            textAlign: 'center',
            width: 140,
            editTemplate: vm.tableNumericEditorTemplate,
            allowEditing: true
        }, {
            field: 'KedvezmenyesTD4',
            headerText: gettextCatalog.getString('ReducedFee') + ' 4',
            textAlign: 'center',
            width: 140,
            editTemplate: vm.tableNumericEditorTemplate,
            allowEditing: true
        }, {
            field: 'KedvezmenyesTD5',
            headerText: gettextCatalog.getString('ReducedFee') + ' 5',
            textAlign: 'center',
            width: 140,
            editTemplate: vm.tableNumericEditorTemplate,
            allowEditing: true
        }, {
            field: 'TDMentessegAdhato',
            headerText: gettextCatalog.getString('FeeFree'),
            textAlign: 'center',
            width: 140,
            type: 'boolean',
            edit: checkBoxEditorTemplate,
            displayAsCheckBox: true,
            allowEditing: true
        }, {
            field: 'Oktatasidij',
            headerText: gettextCatalog.getString('EducationalFee'),
            textAlign: 'center',
            width: 140,
            editTemplate: vm.tableNumericEditorTemplate,
            allowEditing: true
        }, {
            field: 'KedvezmenyesOD',
            headerText: gettextCatalog.getString('ReducedEducationalFee'),
            textAlign: 'center',
            width: 140,
            editTemplate: vm.tableNumericEditorTemplate,
            allowEditing: true
        }, {
            field: 'KedvezmenyesOD2',
            headerText: gettextCatalog.getString('ReducedEducationalFee') + ' 2',
            textAlign: 'center',
            width: 140,
            editTemplate: vm.tableNumericEditorTemplate,
            allowEditing: true
        }, {
            field: 'KedvezmenyesOD3',
            headerText: gettextCatalog.getString('ReducedEducationalFee') + ' 3',
            textAlign: 'center',
            width: 140,
            editTemplate: vm.tableNumericEditorTemplate,
            allowEditing: true
        }, {
            field: 'KedvezmenyesOD4',
            headerText: gettextCatalog.getString('ReducedEducationalFee') + ' 4',
            textAlign: 'center',
            width: 140,
            editTemplate: vm.tableNumericEditorTemplate,
            allowEditing: true
        }, {
            field: 'KedvezmenyesOD5',
            headerText: gettextCatalog.getString('ReducedEducationalFee') + ' 5',
            textAlign: 'center',
            width: 140,
            editTemplate: vm.tableNumericEditorTemplate,
            allowEditing: true
        }, {
            field: 'ODMentessegAdhato',
            headerText: gettextCatalog.getString('EducationalFeeFree'),
            textAlign: 'center',
            width: 140,
            type: 'boolean',
            displayAsCheckBox: true,
            edit: checkBoxEditorTemplate,
            allowEditing: true
        }, {
            field: 'Temaszam',
            headerText: gettextCatalog.getString('ThemeNumber'),
            textAlign: 'center',
            width: 140,
            allowEditing: true
        }, {
            field: 'KoltsegHely',
            headerText: gettextCatalog.getString('FeePlace'),
            textAlign: 'center',
            width: 140,
            allowEditing: true
        }];

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItems,
            allowPaging: true,
            allowSorting: true,
            allowExcelExport: true,
            allowTextWrap: true,
            frozenColumns: 2,
            editSettings: {allowEditing: true, mode: 'Batch', showConfirmDialog: false},
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#Grid'), $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        vm.tableNumericEditorTemplate = {
            create: function () {
                return '<input>';
            },
            read: function (args) {
                return args.ejMaskEdit('get_StrippedValue');
            },
            write: function (args) {
                var s = args.element[0].id.toString().replace('Grid', '');
                args.element.ejMaskEdit({
                    width: '100%',
                    maskFormat: 'NNN',
                    //customCharacter: 'bBvVsS0123-',
                    value: args.rowdata !== undefined ? args.rowdata[s] : '',
                    readOnly: vm.readOnlyAttendance
                });
            }
        };

        activate();

        function activate() {
            $q.all([authenticationService.getRight('MODTAGDBEALL'), authenticationService.getRight('MEGTTAGDBEALL')]).then(function (results) {
                if (results[1] !== true) {
                    log.permissionError(true);
                } else {
                    vm.MODTAGDBEALL = results[1];
                    getFeeDatas();
                    getLastClosedYear();
                    getReducedEducationalFeeTypes();
                    getReducedSportServiceFeeTypes();
                }
            });
        }

        function getReducedEducationalFeeTypes() {
            return dataservice.getReducedEducationalFeeTypes(authenticationService.getLanguage()).then(function (data) {
                if (data.itemsList.length >= 5) {
                    vm.columns[10].headerText = data.itemsList[0].text;
                    vm.columns[11].headerText = data.itemsList[1].text;
                    vm.columns[12].headerText = data.itemsList[2].text;
                    vm.columns[13].headerText = data.itemsList[3].text;
                    vm.columns[14].headerText = data.itemsList[4].text;
                    grid.refreshColumns();
                }
            });
        }

        function getReducedSportServiceFeeTypes() {
            return dataservice.getReducedSportServiceFeeTypes(authenticationService.getLanguage()).then(function (data) {
                if (data.itemsList.length >= 5) {
                    vm.columns[3].headerText = data.itemsList[0].text;
                    vm.columns[4].headerText = data.itemsList[1].text;
                    vm.columns[5].headerText = data.itemsList[2].text;
                    vm.columns[6].headerText = data.itemsList[3].text;
                    vm.columns[7].headerText = data.itemsList[4].text;
                    grid.refreshColumns();
                }
            });
        }

        function yearSelect(arg) {
            if (arg.value) {
                vm.closeYearEnabled = true;
            }
        }

        function getFeeDatas() {
            return dataservice.getFeeDatas()
                .then(function (data) {
                    grid.dataSource = data.itemsList;
                    vm.toleranceDays = data.TurelmiIdo;
                });
        }

        function getLastClosedYear() {
            return dataservice.getLastClosedYear().then(function (data) {
                if (data.retValue === 0 || data.retValue === '0') {
                    data.retValue = new Date().getFullYear() - 1;
                }
                var maxYear = new Date().getFullYear() + 1;
                for (var i = data.retValue + 1; i < maxYear; i++) {
                    vm.nonClosedYears.push(i);
                }
                vm.yearclosed = vm.nonClosedYears.length == 0;
            });
        }

        function saveDataReal() {
            if (!vm.MODTAGDBEALL) {
                log.permissionError();
            }
            grid.editModule.batchSave();
            // itt kell mindent elmenteni
            var functionData = {
                itemsList: grid.dataSource,
                TurelmiIdo: vm.toleranceDays
            };
            return dataservice.saveFeeDatas(functionData);
        }

        function saveData() {
            if (!vm.MODTAGDBEALL) {
                log.permissionError();
            } else {
                saveDataReal().then(function () {
                    log.successMsg('SaveFeeDataOK');
                });
            }
        }

        function closeYear() {
            if (!vm.MODTAGDBEALL) {
                log.permissionError();
            } else {
                var functionData = {
                    datum: vm.selectedYear,
                };
                dataservice.closeYear(functionData).then(function () {
                    getLastClosedYear();
                });
            }
        }

        function meteOut() {
            if (!vm.MODTAGDBEALL) {
                log.permissionError();
            } else {
                // ment és kiró
                if (vm.onlyNew) {
                    // csak új sportolóknak
                    dataservice.getAthletesForMeteOut(vm.fromDate).then(function (athletes) {
                        var athleteNames = '';
                        for (var i = 0; i < athletes.itemsList.length; i++) {
                            athleteNames += athletes.itemsList[i] + '<br>';
                        }

                        var HTMLarr = [];
                        HTMLarr[0] = gettextCatalog.getString('');
                        HTMLarr[1] = '<br><label>';
                        HTMLarr[2] = gettextCatalog.getString('AthletesAffectedByMeteOut');
                        HTMLarr[3] = '</label><br>';
                        HTMLarr[4] = '<p style="text-align: left;">';
                        HTMLarr[5] = athleteNames;
                        HTMLarr[6] = '</p><br>';
                        var HTMLtext = HTMLarr.join('');

                        swal({
                            title: gettextCatalog.getString('MeteOutOnlyNewAthletesTitle'),
                            html: HTMLtext,
                            type: 'warning',
                            showCancelButton: true,
                            confirmButtonText: gettextCatalog.getString('Yes'),
                            cancelButtonText: gettextCatalog.getString('No')
                        }).then(function (confirmed) {
                            if (confirmed.value) {
                                saveDataReal().then(function () {
                                    var parameters = {
                                        naptol: vm.fromDate,
                                        kivSportolo: '',
                                        csakUjak: 1,
                                        fizModValtas: 0
                                    };
                                    dataservice.meteOutFee(parameters).then(function () {
                                        log.successMsg('MeteOutFeeOK');
                                    });
                                });
                            }
                        });
                    });
                } else {
                    // mindenkinek
                    swal({
                        title: gettextCatalog.getString('MeteOutAllAthletesTitle'),
                        text: gettextCatalog.getString('MeteOutAllAthletesText'),
                        type: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#DD6B55',
                        confirmButtonText: gettextCatalog.getString('Yes'),
                        cancelButtonText: gettextCatalog.getString('No')
                    }).then(function (confirmed) {
                        if (confirmed.value) {
                            saveDataReal().then(function () {
                                var parameters = {
                                    naptol: vm.fromDate,
                                    kivSportolo: '',
                                    csakUjak: 0,
                                    fizModValtas: 0
                                };
                                dataservice.meteOutFee(parameters).then(function () {
                                    log.successMsg('MeteOutFeeOK');
                                });
                            });
                        }
                    }, function () {
                    });
                }
            }
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.business.modifyFees')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'business.modifyFees',
                config: {
                    url: '/modifyFees',
                    templateUrl: 'app/business/modifyFees/modifyFees.html',
                    controller: 'modifyFeesController',
                    controllerAs: 'vm',
                    title: 'ModifyFees',
                    settings: {
                        navId: 213,
                        level: 2,
                        order: 1,
                        orderTitle_hu: 'Díjak beállítása',
                        orderTitle_en: 'Set Fees',
                        parentId: 3,
                        content: 'ModifyFees',
                        activatorPermission: '"MEGTTAGDBEALL"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    MonthlyAttendanceArrearsController.$inject = ["log", "dataservice", "$q", "$rootScope", "gettextCatalog", "authenticationService", "$filter", "$state", "$scope", "paramHelper"];
    angular
        .module('app.business.monthlyAttendanceArrears')
        .controller('MonthlyAttendanceArrearsController', MonthlyAttendanceArrearsController);

    function MonthlyAttendanceArrearsController(log, dataservice, $q, $rootScope, gettextCatalog, authenticationService, $filter, $state, $scope, paramHelper) {
        var vm = this; $rootScope.vm = vm;

        $rootScope.title = gettextCatalog.getString('MonthlyAttendanceReportArrears');

        // Grid's variables
        vm.columns = [
            {field: 'Id', isPrimaryKey: true, visible: false},
            {field: 'SzakosztalyNeve', headerText: gettextCatalog.getString('Section'), width: 100},
            {field: 'EdzoNeve', headerText: gettextCatalog.getString('CoachName'), textAlign: 'center', width: 150, template: '#monthlyattendancearrearscolumnTemplate'},
            {field: 'Datum2', headerText: gettextCatalog.getString('Date'), textAlign: 'center', width: 130},
            {field: 'CsoportLetszam', headerText: gettextCatalog.getString('groupStaffNumbers'), textAlign: 'center', width: 120},
            {field: 'Erkezett', headerText: gettextCatalog.getString('Arrived'), textAlign: 'center', width: 60},
            {field: 'Tavozott', headerText: gettextCatalog.getString('Departed'), textAlign: 'center', width: 60},
            {field: 'Megjegyzes', headerText: gettextCatalog.getString('Comment'), textAlign: 'left', width: 200},
            {field: 'Edzo_Alairta', headerText: gettextCatalog.getString('CoachSigned'), textAlign: 'center', width: 100, type: 'boolean', displayAsCheckBox: true},
            {field: 'Szakosztalyvezeto_Alairta', headerText: gettextCatalog.getString('SectionLeaderSigned'), textAlign: 'center', width: 130, type: 'boolean', displayAsCheckBox: true},
            {field: 'utolsoKitoltottDatum', headerText: gettextCatalog.getString('ModifiedDate'), textAlign: 'center', width: 100}
        ];

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItemsWithSearch,
            allowPaging: true,
            allowTextWrap: true,
            allowSorting: true,
            allowExcelExport: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#Grid'), $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        vm.openCoach = openCoach;
        // Activate page
        activate();

        function activate() {
            var promises = [authenticationService.getRight('MEGTHAVIJELLEM')];
            $q.all(promises).then(function (results) {
                if (results[0] !== true) {
                    log.permissionError(true);
                } else {
                    getDatas();
                }
            });
        }

        function getDatas() {
            dataservice.getAnnualSeasonPlanArrears().then(function(data) {
                data.itemsList = $filter('dateYearMonthStringFilter')(data.itemsList, 'Datum2');
                grid.dataSource = data.itemsList;
            });
        }

        function openCoach(edzoId) {
            $q.all([authenticationService.getRight('MODFELH'), authenticationService.getRight('MEGTFELH')]).then(function (results) {
                if (results[0] || results[1]) {
                    paramHelper.setParams([{'newUser.userId': edzoId}]);
                    $state.go('settings.userManagement.modifyUser');
                } else {
                    log.permissionError();
                }
            });
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.business.monthlyAttendanceArrears')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'business.monthlyAttendanceArrears',
                config: {
                    url: '/monthlyAttendanceArrears',
                    templateUrl: 'app/business/monthlyAttendanceArrears/monthlyAttendanceArrears.html',
                    controller: 'MonthlyAttendanceArrearsController',
                    controllerAs: 'vm',
                    title: 'MonthlyAttendanceReportArrears',
                    settings: {
                        navId: 293,
                        level: 2,
                        order: 9,
                        orderTitle_hu: 'Havi jelenléti összesítő lemaradások',
                        orderTitle_en: 'Monthly Attendance Report Arrears',
                        parentId: 3,
                        content: 'MonthlyAttendanceReportArrears',
                        activatorPermission: '"MEGTHAVIJELLEM"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    SportServiceFeeArrearsController.$inject = ["log", "dataservice", "$q", "$rootScope", "gettextCatalog", "paramHelper", "$scope", "authenticationService", "$state", "$timeout"];
    angular
        .module('app.business.sportServiceFeeArrears')
        .controller('SportServiceFeeArrearsController', SportServiceFeeArrearsController);

    function SportServiceFeeArrearsController(log, dataservice, $q, $rootScope, gettextCatalog, paramHelper, $scope, authenticationService, $state, $timeout) {
        var vm = this;
        $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('FeeArrears');

        // Create variables
        // Dropdownlist's sources
        vm.sectionList = [];
        vm.coachList = [];
        vm.yearList = dataservice.range(2000, new Date().getFullYear());
        vm.priceType = [{text: 'NK', value: 'NK'}, {text: 'K', value: 'K'}, {text: 'B', value: 'B'}, {
            text: 'EP',
            value: 'EP'
        }, {text: 'MT', value: 'MT'}];

        vm.selectedCoach = vm.coachId = 0;
        vm.selectedSection = 0;

        vm.summaryRows = [{
            columns: [
                {
                    type: 'Sum',
                    field: 'OsszesHatralek',
                    groupCaptionTemplate: gettextCatalog.getString('Sum') + ': ${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'Honap_1',
                    groupCaptionTemplate: gettextCatalog.getString('Sum') + ': ${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'Honap_2',
                    groupCaptionTemplate: gettextCatalog.getString('Sum') + ': ${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'Honap_3',
                    groupCaptionTemplate: gettextCatalog.getString('Sum') + ': ${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'Honap_4',
                    groupCaptionTemplate: gettextCatalog.getString('Sum') + ': ${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'Honap_5',
                    groupCaptionTemplate: gettextCatalog.getString('Sum') + ': ${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'Honap_6',
                    groupCaptionTemplate: gettextCatalog.getString('Sum') + ': ${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'Honap_7',
                    groupCaptionTemplate: gettextCatalog.getString('Sum') + ': ${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'Honap_8',
                    groupCaptionTemplate: gettextCatalog.getString('Sum') + ': ${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'Honap_9',
                    groupCaptionTemplate: gettextCatalog.getString('Sum') + ': ${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'Honap_10',
                    groupCaptionTemplate: gettextCatalog.getString('Sum') + ': ${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'Honap_11',
                    groupCaptionTemplate: gettextCatalog.getString('Sum') + ': ${Sum}',
                    format: 'N0'
                },
                {
                    type: 'Sum',
                    field: 'Honap_12',
                    groupCaptionTemplate: gettextCatalog.getString('Sum') + ': ${Sum}',
                    format: 'N0'
                }
            ]
        }];

        vm.rowIndexUnderEditing = -1;
        vm.columns = [
            {field: 'Id', isPrimaryKey: true, visible: false},
            {
                headerText: gettextCatalog.getString('General'), columns: [
                    {field: 'Ev', headerText: gettextCatalog.getString('Year'), width: 80},
                    {field: 'SzakosztalyNeve', headerText: gettextCatalog.getString('Section'), width: 150},
                    {
                        field: 'EdzoNeve',
                        headerText: gettextCatalog.getString('CoachName'),
                        textAlign: 'left',
                        width: 150,
                        template: '#feearrearscolumnTemplate2'
                    },
                    {
                        field: 'VersenyzoNeve',
                        headerText: gettextCatalog.getString('Name'),
                        textAlign: 'left',
                        width: 150,
                        template: '#feearrearscolumnTemplate1'
                    },
                    {
                        field: 'Dsi_Igazolas',
                        headerText: gettextCatalog.getString('Regisztracios'),
                        textAlign: 'left',
                        width: 165
                    },
                ], textAlign: 'center'
            },
            {
                headerText: gettextCatalog.getString('Summary'), columns: [
                    {
                        field: 'OsszesHatralek',
                        headerText: gettextCatalog.getString('SumArrears'),
                        textAlign: 'left',
                        width: 150,
                        format: 'N0'
                    },
                ], textAlign: 'center'
            },
            {
                headerText: gettextCatalog.getString('Month'), columns: [
                    {field: 'Honap_1', headerText: gettextCatalog.getString('January'), textAlign: 'left', width: 125, format: 'N0'},
                    {field: 'Honap_2', headerText: gettextCatalog.getString('February'), textAlign: 'left', width: 125, format: 'N0'},
                    {field: 'Honap_3', headerText: gettextCatalog.getString('March'), textAlign: 'left', width: 125, format: 'N0'},
                    {field: 'Honap_4', headerText: gettextCatalog.getString('April'), textAlign: 'left', width: 125, format: 'N0'},
                    {field: 'Honap_5', headerText: gettextCatalog.getString('May'), textAlign: 'left', width: 125, format: 'N0'},
                    {field: 'Honap_6', headerText: gettextCatalog.getString('June'), textAlign: 'left', width: 125, format: 'N0'},
                    {field: 'Honap_7', headerText: gettextCatalog.getString('July'), textAlign: 'left', width: 125, format: 'N0'},
                    {field: 'Honap_8', headerText: gettextCatalog.getString('August'), textAlign: 'left', width: 125, format: 'N0'},
                    {field: 'Honap_9', headerText: gettextCatalog.getString('September'), textAlign: 'left', width: 125, format: 'N0'},
                    {field: 'Honap_10', headerText: gettextCatalog.getString('October'), textAlign: 'left', width: 125, format: 'N0'},
                    {field: 'Honap_11', headerText: gettextCatalog.getString('November'), textAlign: 'left', width: 125, format: 'N0'},
                    {field: 'Honap_12', headerText: gettextCatalog.getString('December'), textAlign: 'left', width: 125, format: 'N0'}
                ], textAlign: 'center'
            }
        ];
        var grid = new ej2.grids.Grid({
            columns: vm.columns,
            dataSource: [],
            allowTextWrap: true,
            allowPaging: true,
            allowSorting: true,
            allowGrouping: true,
            groupSettings: {columns: ['SzakosztalyNeve', 'EdzoNeve']},
            toolbar: $rootScope.toolbarItemsWithSearch,
            pageSettings: {pageCount: 5, pageSize: 2000, pageSizes: [4, 8, 20, 100, 2000]},
            editSettings: {allowEditing: false},
            allowExcelExport: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            aggregates: vm.summaryRows,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'searching' || args.requestType === 'refresh') {
                    $rootScope.compile($('#Grid'), $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        // Public functions
        vm.sectionDataBound = sectionDataBound;
        vm.sectionSelect = sectionSelect;
        vm.coachDataBound = coachDataBound;
        vm.coachSelect = coachSelect;
        vm.getAthletes = getAthletes;
        vm.yearDataBound = yearDataBound;
        vm.yearSelect = yearSelect;
        vm.goToAthlete = goToAthlete;
        vm.openCoach = openCoach;

        // Activate page
        activate();

        function activate() {
            var promises = [paramHelper.getParams([], ['sportServiceFeeArrears.sectionId', 'sportServiceFeeArrears.year', 'sportServiceFeeArrears.coachId']), authenticationService.getRight('MEGTTAGDHATR')];
            $q.all(promises).then(function (results) {
                if (results[1] !== true) {
                    log.permissionError(true);
                } else {
                    vm.defaultsectionId = results[0]['sportServiceFeeArrears.sectionId'];
                    vm.defaultYear = results[0]['sportServiceFeeArrears.year'];
                    // angular.element('#yearDropDownList').ejDropDownList('selectItemByValue', results[0]['sportServiceFeeArrears.year']);
                    vm.year = vm.selectedYear = results[0]['sportServiceFeeArrears.year'];
                    vm.defaultCoachId = results[0]['sportServiceFeeArrears.coachId'];
                    if (vm.defaultsectionId != null && vm.defaultCoachId != null && vm.year != null) {
                        $timeout(function () {
                            getAthletes(results[0]['sportServiceFeeArrears.sectionId'], results[0]['sportServiceFeeArrears.coachId'], results[0]['sportServiceFeeArrears.year']);
                        }, 100);
                    }
                    getcoaches();
                    getSections();
                }
            });
        }

        /**
         * Betölti az edzőket
         * @author Richard Keki
         * @returns {promise} A http promisszal tér vissza
         */
        function getcoaches() {
            return dataservice.coachSelect(vm.sectionId).then(function (data) {
                data.itemsList.unshift({value: '0', text: gettextCatalog.getString('All')});
                vm.coachList = data.itemsList;
            });
        }

        /**
         * Edzők betöltése után beállítja az alapértelmezett edzőt
         * @author Richard Keki
         */
        function coachDataBound() {
            if (vm.coachList.length === 1) {
                angular.element('#coachDropDown').ejDropDownList('selectItemByValue', vm.coachList[0].value);
                vm.coachId = vm.coachList[0].value;
            } else {
                angular.element('#coachDropDown').ejDropDownList('selectItemByValue', vm.defaultCoachId);
                vm.coachId = vm.defaultCoachId;
            }
        }

        function coachSelect(args) {
            vm.coachId = args.value;
            getSections();
        }

        //szakosztályok lekérése
        function getSections() {
            return dataservice.sectionDropDownList(vm.coachId, true).then(function (data) {
                data.itemsList.unshift({value: '0', text: gettextCatalog.getString('All')});
                vm.sectionList = data.itemsList;
            });
        }

        // Run after data bounded
        function sectionDataBound() {
            if (vm.sectionList.length === 1) {
                angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.sectionList[0].value);
                vm.selectedSection = vm.sectionList[0].value;
            } else {
                angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.defaultsectionId);
                vm.selectedSection = vm.defaultsectionId;
            }
        }

        // Run after selection
        function sectionSelect(args) {
            vm.ReducedSportServiceFee = vm.sectionList[args.itemId].Tagdij !== null ? vm.sectionList[args.itemId].Tagdij : 0;
            vm.SportServiceFee = vm.sectionList[args.itemId].KedvezmenyesTagdij !== null ? vm.sectionList[args.itemId].KedvezmenyesTagdij : 0;
            vm.sectionId = args.value;
        }

        function yearDataBound() {
            if (vm.yearList.length === 1) {
                angular.element('#yearDropDownList').ejDropDownList('selectItemByValue', vm.yearList[0].value);
                vm.year = vm.yearList[0].value;
            }
            vm.year = new Date().getFullYear();
        }

        function yearSelect(args) {
            vm.year = args.value;
        }

        function getAthletes(sectionId, coachId, year) {
            if (arguments.length == 3) {
                vm.sectionId = sectionId;
                vm.coachId = coachId;
                vm.year = year;
            } else {
                // a syncfusion direktívák miatt
                $scope.$broadcast('submitted');
                if ($scope.form.$valid === false) {
                    log.errorMsg(gettextCatalog.getString('RequiredFieldsError'));
                    return;
                }
            }
            paramHelper.setParams([{'sportServiceFeeArrears.sectionId': vm.sectionId}, {'sportServiceFeeArrears.year': vm.year}, {'sportServiceFeeArrears.coachId': vm.coachId}]);
            dataservice.getAthletesForFeeArrears(vm.sectionId, vm.coachId, vm.year).then(function (data) {
                grid.dataSource = data.itemsList;
            });
        }

        function goToAthlete(id) {
            $q.all([authenticationService.getRight('MEGTSPORTLIST')]).then(function (results) {
                if (results[0]) {
                    paramHelper.setParams([{'athleteModify.sportoloId': id}]);
                    $state.go('athletes.athletesManagement.athleteModify.dataSheet');
                } else {
                    log.permissionError();
                }
            });
        }

        function openCoach(edzoId) {
            $q.all([authenticationService.getRight('MODFELH'), authenticationService.getRight('MEGTFELH')]).then(function (results) {
                if (results[0] || results[1]) {
                    paramHelper.setParams([{'newUser.userId': edzoId}]);
                    $state.go('settings.userManagement.modifyUser');
                } else {
                    log.permissionError();
                }
            });
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.business.sportServiceFeeArrears')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'business.sportServiceFeeArrears',
                config: {
                    url: '/sportServiceFeeArrears',
                    templateUrl: 'app/business/sportServiceFeeArrears/sportServiceFeeArrears.html',
                    controller: 'SportServiceFeeArrearsController',
                    controllerAs: 'vm',
                    title: 'FeeArrears',
                    settings: {
                        navId: 243,
                        level: 2,
                        order: 4,
                        orderTitle_hu: 'Díj hátralékosok',
                        orderTitle_en: 'Fee Arrears',
                        parentId: 3,
                        content: 'FeeArrears',
                        activatorPermission: '"MEGTTAGDHATR"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    SportServiceFeeRegisterController.$inject = ["log", "dataservice", "$q", "$rootScope", "gettextCatalog", "paramHelper", "authenticationService", "$scope", "$state", "$compile", "$timeout", "$filter"];
    angular
        .module('app.business.sportServiceFeeRegister')
        .controller('SportServiceFeeRegisterController', SportServiceFeeRegisterController);

    function SportServiceFeeRegisterController(log, dataservice, $q, $rootScope, gettextCatalog, paramHelper, authenticationService, $scope, $state, $compile, $timeout, $filter) {
        var vm = this;
        $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('SportServiceFeeRegister');

        // Create variables
        // Dropdownlist's sources
        vm.AthleteUnderEditing = '';
        vm.AthleteUnderEditingText = gettextCatalog.getString('ActualAthlete');
        vm.kedvezmenyNevek = [];
        vm.sectionList = [];
        vm.coachList = [];
        vm.yearList = dataservice.range(new Date().getFullYear() - 4, new Date().getFullYear() + 1);
        vm.rowUnderEditing = [];
        vm.priceType = [{text: 'NK', value: 'NK'}, {text: 'B', value: 'B'}, {text: 'EP', value: 'EP'}];
        vm.year = new Date().getFullYear();
        vm.modifiedRows = [];

        vm.maskObject;
        vm.elem;

        vm.dateTimeEditorTemplate =
            {
                create: function () {
                    var txt = document.createElement('input');
                    txt.style.width = '100%';
                    txt.style.float = 'left';
                    vm.elem = txt;
                    vm.elem.addEventListener('focus', function () {
                        this.select();
                    });
                    return vm.elem;
                },
                read: function () {
                    return vm.maskObject.getMaskedValue();
                },
                destroy: function () {
                    if (vm.maskObject != null) {
                        vm.maskObject.destroy();
                    }
                },
                write: function (args) {
                    var s = args.element.id.toString().replace('Grid', '');
                    vm.maskObject = new ej2.inputs.MaskedTextBox({
                        minWidth: '100%',
                        mask: '>0000-00-00',
                        value: args.rowData !== angular.isUndefined ? args.rowData[s] : ''.replace(' ', ''),
                        readOnly: vm.readOnlyAttendance,
                    });
                    vm.editedRowId = args.rowData['Id'];
                    $compile(args.element[0])($scope);
                    vm.maskObject.appendTo(vm.elem);
                }
            };

        vm.dropDownListEditorTemplate =
            {
                create: function () {
                    vm.elem = document.createElement('input');
                    return vm.elem;
                },
                read: function () {
                    var text = '';
                    switch (vm.maskObject.value) {
                        case 'NK':
                            text = 'NK';
                            vm.rowUnderEditing['Honap_' + vm.monthUnderEditing + '_kedvezmenyes'] = 'NK';
                            vm.rowUnderEditing['Honap_' + vm.monthUnderEditing] = vm.rowUnderEditing['KirottTeljesAr' + vm.monthUnderEditing];
                            vm.rowUnderEditing['Honap_' + vm.monthUnderEditing + '_fizetendo'] = vm.rowUnderEditing['KirottTeljesAr' + vm.monthUnderEditing];
                            vm.rowUnderEditing['Kedvezmenyes' + vm.monthUnderEditing] = false;
                            break;
                        case 'K1':
                            text = vm.priceType.find(function (value) {
                                return value.value === 'K1';
                            }).text;
                            vm.rowUnderEditing['Honap_' + vm.monthUnderEditing + '_kedvezmenyes'] = 'K1';
                            vm.rowUnderEditing['Honap_' + vm.monthUnderEditing] = vm.sectionFees[0].KedvezmenyesTD;
                            vm.rowUnderEditing['Honap_' + vm.monthUnderEditing + '_fizetendo'] = vm.sectionFees[0].KedvezmenyesTD;
                            vm.rowUnderEditing['Kedvezmenyes' + vm.monthUnderEditing] = true;
                            vm.rowUnderEditing['KedvezmenyTipus' + vm.monthUnderEditing] = 'K1';
                            break;
                        case 'K2':
                            text = vm.priceType.find(function (value) {
                                return value.value === 'K2';
                            }).text;
                            vm.rowUnderEditing['Honap_' + vm.monthUnderEditing + '_kedvezmenyes'] = 'K2';
                            vm.rowUnderEditing['Honap_' + vm.monthUnderEditing] = vm.sectionFees[0].KedvezmenyesTD2;
                            vm.rowUnderEditing['Honap_' + vm.monthUnderEditing + '_fizetendo'] = vm.sectionFees[0].KedvezmenyesTD2;
                            vm.rowUnderEditing['Kedvezmenyes' + vm.monthUnderEditing] = true;
                            vm.rowUnderEditing['KedvezmenyTipus' + vm.monthUnderEditing] = 'K2';
                            break;
                        case 'K3':
                            text = vm.priceType.find(function (value) {
                                return value.value === 'K3';
                            }).text;
                            vm.rowUnderEditing['Honap_' + vm.monthUnderEditing + '_kedvezmenyes'] = 'K3';
                            vm.rowUnderEditing['Honap_' + vm.monthUnderEditing] = vm.sectionFees[0].KedvezmenyesTD3;
                            vm.rowUnderEditing['Honap_' + vm.monthUnderEditing + '_fizetendo'] = vm.sectionFees[0].KedvezmenyesTD3;
                            vm.rowUnderEditing['Kedvezmenyes' + vm.monthUnderEditing] = true;
                            vm.rowUnderEditing['KedvezmenyTipus' + vm.monthUnderEditing] = 'K3';
                            break;
                        case 'K4':
                            text = vm.priceType.find(function (value) {
                                return value.value === 'K4';
                            }).text;
                            vm.rowUnderEditing['Honap_' + vm.monthUnderEditing + '_kedvezmenyes'] = 'K4';
                            vm.rowUnderEditing['Honap_' + vm.monthUnderEditing] = vm.sectionFees[0].KedvezmenyesTD4;
                            vm.rowUnderEditing['Honap_' + vm.monthUnderEditing + '_fizetendo'] = vm.sectionFees[0].KedvezmenyesTD4;
                            vm.rowUnderEditing['Kedvezmenyes' + vm.monthUnderEditing] = true;
                            vm.rowUnderEditing['KedvezmenyTipus' + vm.monthUnderEditing] = 'K4';
                            break;
                        case 'K5':
                            text = vm.priceType.find(function (value) {
                                return value.value === 'K5';
                            }).text;
                            vm.rowUnderEditing['Honap_' + vm.monthUnderEditing + '_kedvezmenyes'] = 'K5';
                            vm.rowUnderEditing['Honap_' + vm.monthUnderEditing] = vm.sectionFees[0].KedvezmenyesTD5;
                            vm.rowUnderEditing['Honap_' + vm.monthUnderEditing + '_fizetendo'] = vm.sectionFees[0].KedvezmenyesTD5;
                            vm.rowUnderEditing['Kedvezmenyes' + vm.monthUnderEditing] = true;
                            vm.rowUnderEditing['KedvezmenyTipus' + vm.monthUnderEditing] = 'K5';
                            break;
                        case 'B':
                            text = 'B';
                            vm.rowUnderEditing['Honap_' + vm.monthUnderEditing + '_kedvezmenyes'] = 'B';
                            vm.rowUnderEditing['Honap_' + vm.monthUnderEditing] = 0;
                            vm.rowUnderEditing['Honap_' + vm.monthUnderEditing + '_fizetendo'] = 0;
                            break;
                        case 'EP':
                            text = 'EP';
                            vm.rowUnderEditing['Honap_' + vm.monthUnderEditing + '_kedvezmenyes'] = 'EP';
                            vm.rowUnderEditing['Honap_' + vm.monthUnderEditing] = 0;
                            vm.rowUnderEditing['Honap_' + vm.monthUnderEditing + '_fizetendo'] = 0;
                            break;
                        case 'SDM':
                            text = 'SDM';
                            vm.rowUnderEditing['Honap_' + vm.monthUnderEditing] = 0;
                            vm.rowUnderEditing['Honap_' + vm.monthUnderEditing + '_fizetendo'] = 0;
                            vm.rowUnderEditing['Honap_' + vm.monthUnderEditing + '_kedvezmenyes'] = 'SDM';
                            break;
                    }

                    return text;
                },

                destroy: function () {
                    vm.maskObject.destroy();
                },
                write: function (args) {
                    vm.monthUnderEditing = args.column.field[6] + (args.column.field[7] && args.column.field[7] !== '_' ? args.column.field[7] : '');
                    new ej2.data.DataManager(vm.data).executeQuery(new ej2.data.Query().where('Id', 'equal', args.rowData.Id)).then(function (result) {
                        vm.rowUnderEditing = result.result[0];
                    });

                    var arr = vm.priceType.slice(0);
                    if (args.rowData.mentessegAdhato === true) {
                        arr.push({text: 'SDM', value: 'SDM'});
                    }
                    vm.maskObject = new ej2.dropdowns.DropDownList({
                        value: args.rowData[args.column.field.slice(0, -5)],
                        popupWidth: 150,
                        dataSource: arr,
                        fields: {
                            value: 'value',
                            text: 'text'
                        }
                    });
                    vm.maskObject.appendTo(vm.elem);
                }
            };

        vm.monthList =
            [{text: gettextCatalog.getString('All'), value: -1},
                {text: gettextCatalog.getString('January'), value: 0},
                {text: gettextCatalog.getString('February'), value: 1},
                {text: gettextCatalog.getString('March'), value: 2},
                {text: gettextCatalog.getString('April'), value: 3},
                {text: gettextCatalog.getString('May'), value: 4},
                {text: gettextCatalog.getString('June'), value: 5},
                {text: gettextCatalog.getString('July'), value: 6},
                {text: gettextCatalog.getString('August'), value: 7},
                {text: gettextCatalog.getString('September'), value: 8},
                {text: gettextCatalog.getString('October'), value: 9},
                {text: gettextCatalog.getString('November'), value: 10},
                {text: gettextCatalog.getString('December'), value: 11}];

        // Grid's variables
        vm.osszesFizetendo = function (args) {
            return ej.sum(args, 'osszesFizetendo');
        };
        vm.osszesFizetett = function (args) {
            return ej.sum(args, 'osszesFizetett');
        };

        vm.summaryRows = [{
            columns: [
                {
                    type: 'Sum',
                    field: 'Honap_1',
                    footerTemplate: gettextCatalog.getString('Sum') + ': ${Sum}'
                },
                {
                    type: 'Sum',
                    field: 'Honap_2',
                    footerTemplate: gettextCatalog.getString('Sum') + ': ${Sum}'
                },
                {
                    type: 'Sum',
                    field: 'Honap_3',
                    footerTemplate: gettextCatalog.getString('Sum') + ': ${Sum}'
                },
                {
                    type: 'Sum',
                    field: 'Honap_4',
                    footerTemplate: gettextCatalog.getString('Sum') + ': ${Sum}'
                },
                {
                    type: 'Sum',
                    field: 'Honap_5',
                    footerTemplate: gettextCatalog.getString('Sum') + ': ${Sum}'
                },
                {
                    type: 'Sum',
                    field: 'Honap_6',
                    footerTemplate: gettextCatalog.getString('Sum') + ': ${Sum}'
                },
                {
                    type: 'Sum',
                    field: 'Honap_7',
                    footerTemplate: gettextCatalog.getString('Sum') + ': ${Sum}'
                },
                {
                    type: 'Sum',
                    field: 'Honap_8',
                    footerTemplate: gettextCatalog.getString('Sum') + ': ${Sum}'
                },
                {
                    type: 'Sum',
                    field: 'Honap_9',
                    footerTemplate: gettextCatalog.getString('Sum') + ': ${Sum}'
                },
                {
                    type: 'Sum',
                    field: 'Honap_10',
                    footerTemplate: gettextCatalog.getString('Sum') + ': ${Sum}'
                },
                {
                    type: 'Sum',
                    field: 'Honap_11',
                    footerTemplate: gettextCatalog.getString('Sum') + ': ${Sum}'
                },
                {
                    type: 'Sum',
                    field: 'Honap_12',
                    footerTemplate: gettextCatalog.getString('Sum') + ': ${Sum}'
                },
                {
                    type: 'Custom',
                    customAggregate: vm.osszesFizetendo,
                    columnName: 'osszesFizetendo',
                    footerTemplate: gettextCatalog.getString('Sum') + ': ${Custom}'
                },
                {
                    type: 'Custom',
                    customAggregate: vm.osszesFizetett,
                    columnName: 'osszesFizetett',
                    footerTemplate: gettextCatalog.getString('Sum') + ': ${Custom}'
                }
            ]
        }];

        vm.rowIndexUnderEditing = -1;
        vm.fizetveWidth = 80;
        vm.columns = [
            {
                headerText: gettextCatalog.getString('General'),
                columns: [
                    {field: 'Id', isPrimaryKey: true, visible: false},
                    {
                        allowEditing: false,
                        headerText: gettextCatalog.getString('Name'),
                        textAlign: 'left',
                        template: '#sportservicefeeregistercolumnTemplate1',
                        field: 'Versenyzo_Nev',
                        width: 175
                    },
                    {
                        field: 'SzuletesiIdo',
                        allowEditing: false,
                        headerText: gettextCatalog.getString('BirthDate'),
                        textAlign: 'center',
                        width: 100
                    }
                ],
                textAlign: 'center'
            },
            {
                headerText: gettextCatalog.getString('General'),
                columns: [
                    {
                        field: 'SzakosztalyNeve',
                        allowEditing: false,
                        headerText: gettextCatalog.getString('Section'),
                        textAlign: 'left',
                        width: 100,
                        visible: true
                    },
                    {
                        field: 'EdzoNeve',
                        allowEditing: false,
                        headerText: gettextCatalog.getString('CoachName'),
                        textAlign: 'left',
                        template: '#sportservicefeeregistercolumnTemplate2',
                        width: 150,
                        visible: true
                    }
                ],
                textAlign: 'center'
            },
            {
                headerText: gettextCatalog.getString('January'),
                columns: [
                    {
                        field: 'Honap_1_kedvezmenyes_Text',
                        headerText: gettextCatalog.getString('NeedPay1'),
                        textAlign: 'left',
                        width: 90,
                        edit: vm.dropDownListEditorTemplate
                        /*
                        editType: 'dropdownedit',
                        edit: { params: { fields: {value: 'value', text: 'text'},
                                dataSource: vm.priceType,
                                query : new ej.data.Query()
                               }
                         */
                    },
                    {
                        field: 'Honap_1',
                        headerText: gettextCatalog.getString('Payed1'),
                        textAlign: 'left',
                        // editType: 'numericedit',
                        // edit: { params: { showSpinButton: false } },
                        type: 'number',
                        width: vm.fizetveWidth
                    },
                    {
                        field: 'Honap_1_kozlemeny',
                        headerText: gettextCatalog.getString('ReceiptNumber1'),
                        textAlign: 'left',
                        width: 90
                    },
                    {
                        field: 'Honap_1_FizDatum',
                        headerText: gettextCatalog.getString('PaymentDate1'),
                        textAlign: 'center',
                        editType: ej.Grid.EditingType.Date,
                        allowEditing: true,
                        edit: vm.dateTimeEditorTemplate,
                        width: 90
                    }
                ],
                textAlign: 'center'
            },
            {
                headerText: gettextCatalog.getString('February'),
                columns: [
                    {
                        field: 'Honap_2_kedvezmenyes_Text',
                        headerText: gettextCatalog.getString('NeedPay2'),
                        textAlign: 'left',
                        width: 90,
                        edit: vm.dropDownListEditorTemplate
                    },
                    {
                        field: 'Honap_2',
                        headerText: gettextCatalog.getString('Payed2'),
                        textAlign: 'left',
                        type: 'number',
                        width: vm.fizetveWidth
                    },
                    {
                        field: 'Honap_2_kozlemeny',
                        headerText: gettextCatalog.getString('ReceiptNumber2'),
                        textAlign: 'left',
                        width: 90
                    },
                    {
                        field: 'Honap_2_FizDatum',
                        headerText: gettextCatalog.getString('PaymentDate2'),
                        textAlign: 'center',
                        editType: ej.Grid.EditingType.Date,
                        allowEditing: true,
                        edit: vm.dateTimeEditorTemplate,
                        width: 90
                    }
                ],
                textAlign: 'center'
            },
            {
                headerText: gettextCatalog.getString('March'),
                columns: [
                    {
                        field: 'Honap_3_kedvezmenyes_Text',
                        headerText: gettextCatalog.getString('NeedPay3'),
                        textAlign: 'left',
                        width: 90,
                        edit: vm.dropDownListEditorTemplate
                    },
                    {
                        field: 'Honap_3',
                        headerText: gettextCatalog.getString('Payed3'),
                        textAlign: 'left',
                        type: 'number',
                        width: vm.fizetveWidth
                    },
                    {
                        field: 'Honap_3_kozlemeny',
                        headerText: gettextCatalog.getString('ReceiptNumber3'),
                        textAlign: 'left',
                        width: 90
                    },
                    {
                        field: 'Honap_3_FizDatum',
                        headerText: gettextCatalog.getString('PaymentDate3'),
                        textAlign: 'center',
                        editType: ej.Grid.EditingType.Date,
                        allowEditing: true,
                        edit: vm.dateTimeEditorTemplate,
                        width: 90
                    }
                ],
                textAlign: 'center'
            },
            {
                headerText: gettextCatalog.getString('April'),
                columns: [
                    {
                        field: 'Honap_4_kedvezmenyes_Text',
                        headerText: gettextCatalog.getString('NeedPay4'),
                        textAlign: 'left',
                        width: 90,
                        edit: vm.dropDownListEditorTemplate
                    },
                    {
                        field: 'Honap_4',
                        headerText: gettextCatalog.getString('Payed4'),
                        textAlign: 'left',
                        type: 'number',
                        width: vm.fizetveWidth
                    },
                    {
                        field: 'Honap_4_kozlemeny',
                        headerText: gettextCatalog.getString('ReceiptNumber4'),
                        textAlign: 'left',
                        width: 90
                    },
                    {
                        field: 'Honap_4_FizDatum',
                        headerText: gettextCatalog.getString('PaymentDate4'),
                        textAlign: 'center',
                        editType: ej.Grid.EditingType.Date,
                        allowEditing: true,
                        edit: vm.dateTimeEditorTemplate,
                        width: 90
                    }
                ],
                textAlign: 'center'
            },
            {
                headerText: gettextCatalog.getString('May'),
                columns: [
                    {
                        field: 'Honap_5_kedvezmenyes_Text',
                        headerText: gettextCatalog.getString('NeedPay5'),
                        textAlign: 'left',
                        width: 90,
                        edit: vm.dropDownListEditorTemplate
                    },
                    {
                        field: 'Honap_5',
                        headerText: gettextCatalog.getString('Payed5'),
                        textAlign: 'left',
                        type: 'number',
                        width: vm.fizetveWidth
                    },
                    {
                        field: 'Honap_5_kozlemeny',
                        headerText: gettextCatalog.getString('ReceiptNumber5'),
                        textAlign: 'left',
                        width: 90
                    },
                    {
                        field: 'Honap_5_FizDatum',
                        headerText: gettextCatalog.getString('PaymentDate5'),
                        textAlign: 'center',
                        editType: ej.Grid.EditingType.Date,
                        allowEditing: true,
                        edit: vm.dateTimeEditorTemplate,
                        width: 90
                    }
                ],
                textAlign: 'center'
            },
            {
                headerText: gettextCatalog.getString('June'),
                columns: [
                    {
                        field: 'Honap_6_kedvezmenyes_Text',
                        headerText: gettextCatalog.getString('NeedPay6'),
                        textAlign: 'left',
                        width: 90,
                        edit: vm.dropDownListEditorTemplate
                    },
                    {
                        field: 'Honap_6',
                        headerText: gettextCatalog.getString('Payed6'),
                        textAlign: 'left',
                        type: 'number',
                        width: vm.fizetveWidth
                    },
                    {
                        field: 'Honap_6_kozlemeny',
                        headerText: gettextCatalog.getString('ReceiptNumber6'),
                        textAlign: 'left',
                        width: 90
                    },
                    {
                        field: 'Honap_6_FizDatum',
                        headerText: gettextCatalog.getString('PaymentDate6'),
                        textAlign: 'center',
                        editType: ej.Grid.EditingType.Date,
                        allowEditing: true,
                        edit: vm.dateTimeEditorTemplate,
                        width: 90
                    }
                ],
                textAlign: 'center'
            },
            {
                headerText: gettextCatalog.getString('July'),
                columns: [
                    {
                        field: 'Honap_7_kedvezmenyes_Text',
                        headerText: gettextCatalog.getString('NeedPay7'),
                        textAlign: 'left',
                        width: 90,
                        edit: vm.dropDownListEditorTemplate
                    },
                    {
                        field: 'Honap_7',
                        headerText: gettextCatalog.getString('Payed7'),
                        textAlign: 'left',
                        type: 'number',
                        width: vm.fizetveWidth
                    },
                    {
                        field: 'Honap_7_kozlemeny',
                        headerText: gettextCatalog.getString('ReceiptNumber7'),
                        textAlign: 'left',
                        width: 90
                    },
                    {
                        field: 'Honap_7_FizDatum',
                        headerText: gettextCatalog.getString('PaymentDate7'),
                        textAlign: 'center',
                        editType: ej.Grid.EditingType.Date,
                        allowEditing: true,
                        edit: vm.dateTimeEditorTemplate,
                        width: 90
                    }
                ],
                textAlign: 'center'
            },
            {
                headerText: gettextCatalog.getString('August'),
                columns: [
                    {
                        field: 'Honap_8_kedvezmenyes_Text',
                        headerText: gettextCatalog.getString('NeedPay8'),
                        textAlign: 'left',
                        width: 90,
                        edit: vm.dropDownListEditorTemplate
                    },
                    {
                        field: 'Honap_8',
                        headerText: gettextCatalog.getString('Payed8'),
                        textAlign: 'left',
                        type: 'number',
                        width: vm.fizetveWidth
                    },
                    {
                        field: 'Honap_8_kozlemeny',
                        headerText: gettextCatalog.getString('ReceiptNumber8'),
                        textAlign: 'left',
                        width: 90
                    },
                    {
                        field: 'Honap_8_FizDatum',
                        headerText: gettextCatalog.getString('PaymentDate8'),
                        textAlign: 'center',
                        editType: ej.Grid.EditingType.Date,
                        allowEditing: true,
                        edit: vm.dateTimeEditorTemplate,
                        width: 90
                    }
                ],
                textAlign: 'center'
            },
            {
                headerText: gettextCatalog.getString('September'),
                columns: [
                    {
                        field: 'Honap_9_kedvezmenyes_Text',
                        headerText: gettextCatalog.getString('NeedPay9'),
                        textAlign: 'left',
                        width: 90,
                        edit: vm.dropDownListEditorTemplate
                    },
                    {
                        field: 'Honap_9',
                        headerText: gettextCatalog.getString('Payed9'),
                        textAlign: 'left',
                        type: 'number',
                        width: vm.fizetveWidth
                    },
                    {
                        field: 'Honap_9_kozlemeny',
                        headerText: gettextCatalog.getString('ReceiptNumber9'),
                        textAlign: 'left',
                        width: 90
                    },
                    {
                        field: 'Honap_9_FizDatum',
                        headerText: gettextCatalog.getString('PaymentDate9'),
                        textAlign: 'center',
                        editType: ej.Grid.EditingType.Date,
                        allowEditing: true,
                        edit: vm.dateTimeEditorTemplate,
                        width: 90
                    }
                ],
                textAlign: 'center'
            },
            {
                headerText: gettextCatalog.getString('October'),
                columns: [
                    {
                        field: 'Honap_10_kedvezmenyes_Text',
                        headerText: gettextCatalog.getString('NeedPay10'),
                        textAlign: 'left',
                        width: 90,
                        edit: vm.dropDownListEditorTemplate
                    },
                    {
                        field: 'Honap_10',
                        headerText: gettextCatalog.getString('Payed10'),
                        textAlign: 'left',
                        type: 'number',
                        width: vm.fizetveWidth
                    },
                    {
                        field: 'Honap_10_kozlemeny',
                        headerText: gettextCatalog.getString('ReceiptNumber10'),
                        textAlign: 'left',
                        width: 90
                    },
                    {
                        field: 'Honap_10_FizDatum',
                        headerText: gettextCatalog.getString('PaymentDate10'),
                        textAlign: 'center',
                        editType: ej.Grid.EditingType.Date,
                        allowEditing: true,
                        edit: vm.dateTimeEditorTemplate,
                        width: 90
                    }
                ],
                textAlign: 'center'
            },
            {
                headerText: gettextCatalog.getString('November'),
                columns: [
                    {
                        field: 'Honap_11_kedvezmenyes_Text',
                        headerText: gettextCatalog.getString('NeedPay11'),
                        textAlign: 'left',
                        width: 90,
                        edit: vm.dropDownListEditorTemplate
                    },
                    {
                        field: 'Honap_11',
                        headerText: gettextCatalog.getString('Payed11'),
                        textAlign: 'left',
                        type: 'number',
                        width: vm.fizetveWidth
                    },
                    {
                        field: 'Honap_11_kozlemeny',
                        headerText: gettextCatalog.getString('ReceiptNumber11'),
                        textAlign: 'left',
                        width: 90
                    },
                    {
                        field: 'Honap_11_FizDatum',
                        headerText: gettextCatalog.getString('PaymentDate11'),
                        textAlign: 'center',
                        editType: ej.Grid.EditingType.Date,
                        allowEditing: true,
                        edit: vm.dateTimeEditorTemplate,
                        width: 90
                    }
                ],
                textAlign: 'center'
            },
            {
                headerText: gettextCatalog.getString('December'),
                columns: [
                    {
                        field: 'Honap_12_kedvezmenyes_Text',
                        headerText: gettextCatalog.getString('NeedPay12'),
                        textAlign: 'left',
                        width: 90,
                        edit: vm.dropDownListEditorTemplate
                    },
                    {
                        field: 'Honap_12',
                        headerText: gettextCatalog.getString('Payed12'),
                        textAlign: 'left',
                        type: 'number',
                        width: vm.fizetveWidth
                    },
                    {
                        field: 'Honap_12_kozlemeny',
                        headerText: gettextCatalog.getString('ReceiptNumber12'),
                        textAlign: 'left',
                        width: 90
                    },
                    {
                        field: 'Honap_12_FizDatum',
                        headerText: gettextCatalog.getString('PaymentDate12'),
                        textAlign: 'center',
                        editType: ej.Grid.EditingType.Date,
                        allowEditing: true,
                        edit: vm.dateTimeEditorTemplate,
                        width: 90
                    }
                ],
                textAlign: 'center'
            },
            {
                headerText: gettextCatalog.getString('Summaries'),
                columns: [
                    {
                        field: 'osszesFizetendo',
                        headerText: gettextCatalog.getString('SumNeedPay'),
                        textAlign: 'center',
                        allowEditing: false,
                        width: 90
                    },
                    {
                        field: 'osszesFizetett',
                        headerText: gettextCatalog.getString('SumPayed'),
                        textAlign: 'center',
                        allowEditing: false,
                        width: 90
                    }
                ],
                textAlign: 'center'
            }
        ];

        function dataBound() {
            setTimeout(function () {
                var grid = document.getElementById('Grid').ej2_instances[0];
                var el = grid.element.querySelector('.e-frozencontent');
                if (el !== null) {
                    el.style.height = grid.element.querySelector('.e-movablecontent').getBoundingClientRect().height + 'px';
                }
            }, 100);
        }

        var grid = new ej2.grids.Grid({
            dataSource: [],
            // allowTextWrap: true,
            toolbar: $rootScope.toolbarItemsWithSearch,
            allowPaging: true,
            pageSettings: $rootScope.pageSettings,
            editSettings: {allowEditing: true, mode: 'Batch', showConfirmDialog: false, showDeleteConfirmDialog: false},
            allowExcelExport: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            columns: vm.columns,
            aggregates: vm.summaryRows,
            // dataBound: dataBound,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'searching' || args.requestType === 'refresh') {
                    $rootScope.compile($('#Grid'), $scope);
                }
            },
            queryCellInfo: querycellinfo,
            cellEdit: cellEdit,
            cellSave: cellSave
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        var fut = false;
        $('#monthDropDownList').ejDropDownList({
            dataSource: vm.monthList,
            fields: {text: 'text'},
            showCheckbox: true,
            width: '100%',
            checkChange: function (args) {
                var DropDownListObj = $('#monthDropDownList').data('ejDropDownList');
                if (fut) {
                    return;
                }
                fut = true;
                if (args.selectedValue < 0) {
                    $('#monthDropDownList').ejDropDownList('unselectItemsByIndices', '1,2,3,4,5,6,7,8,9,10,11,12,13');
                    $('#monthDropDownList').ejDropDownList('selectItemByValue', -1);
                } else {
                    $('#monthDropDownList').ejDropDownList('unselectItemsByIndices', 0);
                    $('#monthDropDownList').ejDropDownList((args.isChecked ? 'selectItemByValue' : 'unselectItemByValue'), args.selectedValue);
                }
                fut = false;
            },
            create: function () {
                $('#monthDropDownList').ejDropDownList('selectItemByValue', -1);
            },
            multiSelectMode: ej.MultiSelectMode.Delimiter,
        });

        // Public functions
        vm.sectionDataBound = sectionDataBound;
        vm.sectionSelect = sectionSelect;
        vm.coachDataBound = coachDataBound;
        vm.coachSelect = coachSelect;
        vm.getAthletes = getAthletesClick;
        vm.yearDataBound = yearDataBound;
        vm.monthDataBound = monthDataBound;
        vm.yearSelect = yearSelect;
        vm.saveWithNumbers = saveWithNumbers;
        vm.saveWithoutNumbers = saveWithoutNumbers;
        vm.goToDailyPayments = goToDailyPayments;
        vm.goToAthlete = goToAthlete;
        vm.openCoach = openCoach;
        vm.getReducedPriceTypes = getReducedPriceTypes;

        // Activate page
        activate();

        function activate() {
            var promises = [authenticationService.getRight('MODTAGDBEALL'),
                authenticationService.getRight('UJTAGDNYILV'),
                paramHelper.getParams([], ['sportServiceFeeRegister.sectionId', 'sportServiceFeeRegister.year', 'sportServiceFeeRegister.coachId', 'sportServiceFeeRegister.ageGroupId']),
                authenticationService.getRight('MEGTTAGDNYILV'),
                authenticationService.getRight('MEGTOKTDNYILV')];
            $q.all(promises).then(function (results) {
                if (results[3] !== true || results[4] !== true) {
                    log.permissionError(true);
                } else {
                    $q.all([getcoaches(), getSections(), getReducedPriceTypes()]).then(function () {
                        if (results[2]['sportServiceFeeRegister.sectionId'] && results[2]['sportServiceFeeRegister.coachId'] && results[2]['sportServiceFeeRegister.year']) {
                            $timeout(function () {
                                if (results[2]['sportServiceFeeRegister.ageGroupId']) {
                                    var DropDownListObj = $('#monthDropDownList').data('ejDropDownList');
                                    DropDownListObj.selectItemByValue(JSON.parse(results[2]['sportServiceFeeRegister.ageGroupId']));
                                }
                                showHideColumns();
                                getAthletes(results[2]['sportServiceFeeRegister.sectionId'], results[2]['sportServiceFeeRegister.coachId'], results[2]['sportServiceFeeRegister.year']);
                            }, 0);
                        }
                    });
                    vm.MODTAGDBEALL = results[0];
                    vm.UJTAGDNYILV = results[1];
                }
            });
        }

        function getReducedPriceTypes() {
            return dataservice.getReducedSportServiceFeeTypes(authenticationService.getLanguage()).then(function (data) {
                vm.priceType = vm.priceType.concat(data.itemsList);
                for (var i = 0; i < data.itemsList.length; i++) {
                    vm.kedvezmenyNevek.push(data.itemsList[i].text);
                }
            });
        }

        function getFeeDatas() {
            return dataservice.getFeeDatas(vm.sectionId).then(function (data) {
                vm.sectionFees = data.itemsList;
            });
        }

        function getcoaches() {
            return dataservice.coachSelect(vm.sectionId).then(function (data) {
                data.itemsList.unshift({value: '0', text: gettextCatalog.getString('All')});
                vm.coachList = data.itemsList;
            });
        }

        function coachDataBound() {
            if (vm.coachList.length === 1) {
                angular.element('#coachDropDown').ejDropDownList('selectItemByValue', vm.coachList[0].value);
                vm.coachId = vm.coachList[0].value;
            } else {
                angular.element('#coachDropDown').ejDropDownList('selectItemByValue', vm.coachId);
            }
        }

        function coachSelect(args) {
            vm.coachId = args.value;
            getSections();
        }

        //szakosztályok lekérése
        function getSections() {
            return dataservice.sectionDropDownListWithFees(vm.coachId).then(function (data) {
                data.itemsList.unshift({value: '0', text: gettextCatalog.getString('All')});
                vm.sectionList = data.itemsList;
            });
        }

        // Run after data bounded
        function sectionDataBound() {
            if (vm.sectionList.length === 1) {
                angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.sectionList[0].value);
                vm.sectionId = vm.sectionList[0].value;
            } else {
                angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.sectionId);
            }
        }

        // Run after selection
        function sectionSelect(args) {
            vm.SportServiceFee = vm.sectionList[args.itemId].Tagdij !== null ? vm.sectionList[args.itemId].Tagdij : 0;
            vm.ReducedSportServiceFee = vm.sectionList[args.itemId].KedvezmenyesTagdij !== null ? vm.sectionList[args.itemId].KedvezmenyesTagdij : 0;
            vm.sectionId = args.value;
        }

        function yearDataBound() {
            if (vm.yearList.length === 1) {
                angular.element('#yearDropDownList').ejDropDownList('selectItemByValue', vm.yearList[0].value);
                vm.year = vm.yearList[0].value;
            }
        }

        function monthDataBound() {
            if (vm.monthList.length === 1) {
                angular.element('#monthDropDownList').ejDropDownList('selectItemByValue', vm.monthList[0].value);
                vm.year = vm.yearList[0].value;
            }
        }

        function yearSelect(args) {
            vm.year = args.value;
        }

        function getAthletesClick() {
            showHideColumns();
            getAthletes();
        }

        function showHideColumns() {
            $timeout(function () {
                var DropDownListObj = $('#monthDropDownList').data('ejDropDownList');
                var vmi = DropDownListObj.getSelectedValue();
                if (vmi.includes(-1)) {
                    grid.frozenColumns = 3;
                } else {
                    grid.frozenColumns = null;
                }
                for (var m = 2; m < 14; m++) {
                    if (vmi.includes(m - 2) || vmi.includes(-1)) {
                        for (var j = 0; j < 4; j++) {
                            vm.columns[m].columns[j].visible = true;
                        }
                    } else {
                        for (var j = 0; j < 4; j++) {
                            vm.columns[m].columns[j].visible = false;
                        }
                    }
                }
                grid.refreshColumns();
                $scope.$apply();
            }, 0);
        }

        function getAthletes(sectionId, coachId, year) {
            if (sectionId) {
                vm.sectionId = sectionId;
                vm.coachId = coachId;
                vm.year = year;
            } else {
                // a syncfusion direktívák miatt
                $scope.$broadcast('submitted');
                if ($scope.form.$valid === false) {
                    log.errorMsg(gettextCatalog.getString('RequiredFieldsError'));
                    return;
                }
            }
            getFeeDatas();
            paramHelper.setParams([{'sportServiceFeeRegister.sectionId': vm.sectionId}, {'sportServiceFeeRegister.year': vm.year}, {'sportServiceFeeRegister.coachId': vm.coachId}, {'sportServiceFeeRegister.ageGroupId': JSON.stringify($('#monthDropDownList').data('ejDropDownList').getSelectedValue())}]);

            var DropDownListObj = $('#monthDropDownList').data('ejDropDownList');
            var months = DropDownListObj.getSelectedValue();
            dataservice.getAthletesFromFeeRegister(vm.sectionId, vm.coachId, vm.year, months).then(function (data) {
                $filter('dateStringFilterPromise')(data.itemsList, 'SzuletesiIdo').then(function (result) {
                    $filter('dateStringFilterPromise')(result, 'Honap_1_FizDatum').then(function (result1) {
                        $filter('dateStringFilterPromise')(result1, 'Honap_2_FizDatum').then(function (result2) {
                            $filter('dateStringFilterPromise')(result2, 'Honap_3_FizDatum').then(function (result3) {
                                $filter('dateStringFilterPromise')(result3, 'Honap_4_FizDatum').then(function (result4) {
                                    $filter('dateStringFilterPromise')(result4, 'Honap_5_FizDatum').then(function (result5) {
                                        $filter('dateStringFilterPromise')(result5, 'Honap_6_FizDatum').then(function (result6) {
                                            $filter('dateStringFilterPromise')(result6, 'Honap_7_FizDatum').then(function (result7) {
                                                $filter('dateStringFilterPromise')(result7, 'Honap_8_FizDatum').then(function (result8) {
                                                    $filter('dateStringFilterPromise')(result8, 'Honap_9_FizDatum').then(function (result9) {
                                                        $filter('dateStringFilterPromise')(result9, 'Honap_10_FizDatum').then(function (result10) {
                                                            $filter('dateStringFilterPromise')(result10, 'Honap_11_FizDatum').then(function (result11) {
                                                                $filter('dateStringFilterPromise')(result11, 'Honap_12_FizDatum').then(function (result12) {
                                                                    vm.data = result12;
                                                                    $timeout(function () {
                                                                        vm.AthleteUnderEditing = '';
                                                                        $scope.$apply();
                                                                        grid.dataSource = vm.data;
                                                                    }, 500);
                                                                });
                                                            });
                                                        });
                                                    });
                                                });
                                            });
                                        });
                                    });
                                });
                            });
                        });
                    });
                });
            });
        }

        // cellák színezése és utolsó két oszlopban az összesítés
        function querycellinfo(args) {
            var element = angular.element(args.cell);
            if (args.column.field.indexOf('Honap_') !== -1) {
                switch (args.data['Honap_' + args.column.field[6] + (args.column.field[7] && args.column.field[7] !== '_' ? args.column.field[7] : '') + '_ReadOnly']) {
                    case 'MT':
                        element.css('background-color', '#efdcdc');
                        break;
                    case 'O':
                        element.css('background-color', '#c0c0c0');
                        break;
                    case 'P':
                        element.css('background-color', '#CCC4FF');
                        break;
                }
            }
            if (args.column.field === 'osszesFizetendo') {
                args.data['osszesFizetendo'] = args.data['Honap_1_fizetendo'] + args.data['Honap_2_fizetendo'] + args.data['Honap_3_fizetendo'] + args.data['Honap_4_fizetendo'] + args.data['Honap_5_fizetendo'] + args.data['Honap_6_fizetendo'] + args.data['Honap_7_fizetendo'] + args.data['Honap_8_fizetendo'] + args.data['Honap_9_fizetendo'] + args.data['Honap_10_fizetendo'] + args.data['Honap_11_fizetendo'] + args.data['Honap_12_fizetendo']; //set the datasource value
                element.html(args.data['osszesFizetendo']); //set the element values
            }
            if (args.column.field === 'osszesFizetett') {
                args.data['osszesFizetett'] = (args.data['Honap_1'] !== 'null' ? args.data['Honap_1'] * 1 : 0) + (args.data['Honap_2'] !== 'null' ? args.data['Honap_2'] * 1 : 0) + (args.data['Honap_3'] !== 'null' ? args.data['Honap_3'] * 1 : 0) + (args.data['Honap_4'] !== 'null' ? args.data['Honap_4'] * 1 : 0) + (args.data['Honap_5'] !== 'null' ? args.data['Honap_5'] * 1 : 0) + (args.data['Honap_6'] !== 'null' ? args.data['Honap_6'] * 1 : 0) + (args.data['Honap_7'] !== 'null' ? args.data['Honap_7'] * 1 : 0) + (args.data['Honap_8'] !== 'null' ? args.data['Honap_8'] * 1 : 0) + (args.data['Honap_9'] !== 'null' ? args.data['Honap_9'] * 1 : 0) + (args.data['Honap_10'] !== 'null' ? args.data['Honap_10'] * 1 : 0) + (args.data['Honap_11'] !== 'null' ? args.data['Honap_11'] * 1 : 0) + (args.data['Honap_12'] !== 'null' ? args.data['Honap_12'] * 1 : 0);
                //set the datasource value
                element.html(args.data['osszesFizetett']); //set the element values
            }
        }

        // szerkesztés letiltása cellánként
        function cellEdit(args) {
            if (
                (args.rowData.Honap_1_kedvezmenyes_Text === 'B' || args.rowData.Honap_1_kedvezmenyes_Text === 'EP') && (args.columnName === 'Honap_1' || args.columnName === 'Honap_1_kozlemeny' || args.columnName === 'Honap_1_FizDatum') ||
                (args.rowData.Honap_2_kedvezmenyes_Text === 'B' || args.rowData.Honap_2_kedvezmenyes_Text === 'EP') && (args.columnName === 'Honap_2' || args.columnName === 'Honap_2_kozlemeny' || args.columnName === 'Honap_2_FizDatum') ||
                (args.rowData.Honap_3_kedvezmenyes_Text === 'B' || args.rowData.Honap_3_kedvezmenyes_Text === 'EP') && (args.columnName === 'Honap_3' || args.columnName === 'Honap_3_kozlemeny' || args.columnName === 'Honap_3_FizDatum') ||
                (args.rowData.Honap_4_kedvezmenyes_Text === 'B' || args.rowData.Honap_4_kedvezmenyes_Text === 'EP') && (args.columnName === 'Honap_4' || args.columnName === 'Honap_4_kozlemeny' || args.columnName === 'Honap_4_FizDatum') ||
                (args.rowData.Honap_5_kedvezmenyes_Text === 'B' || args.rowData.Honap_5_kedvezmenyes_Text === 'EP') && (args.columnName === 'Honap_5' || args.columnName === 'Honap_5_kozlemeny' || args.columnName === 'Honap_5_FizDatum') ||
                (args.rowData.Honap_6_kedvezmenyes_Text === 'B' || args.rowData.Honap_6_kedvezmenyes_Text === 'EP') && (args.columnName === 'Honap_6' || args.columnName === 'Honap_6_kozlemeny' || args.columnName === 'Honap_6_FizDatum') ||
                (args.rowData.Honap_7_kedvezmenyes_Text === 'B' || args.rowData.Honap_7_kedvezmenyes_Text === 'EP') && (args.columnName === 'Honap_7' || args.columnName === 'Honap_7_kozlemeny' || args.columnName === 'Honap_7_FizDatum') ||
                (args.rowData.Honap_8_kedvezmenyes_Text === 'B' || args.rowData.Honap_8_kedvezmenyes_Text === 'EP') && (args.columnName === 'Honap_8' || args.columnName === 'Honap_8_kozlemeny' || args.columnName === 'Honap_8_FizDatum') ||
                (args.rowData.Honap_9_kedvezmenyes_Text === 'B' || args.rowData.Honap_9_kedvezmenyes_Text === 'EP') && (args.columnName === 'Honap_9' || args.columnName === 'Honap_9_kozlemeny' || args.columnName === 'Honap_9_FizDatum') ||
                (args.rowData.Honap_10_kedvezmenyes_Text === 'B' || args.rowData.Honap_10_kedvezmenyes_Text === 'EP') && (args.columnName === 'Honap_10' || args.columnName === 'Honap_10_kozlemeny' || args.columnName === 'Honap_10_FizDatum') ||
                (args.rowData.Honap_11_kedvezmenyes_Text === 'B' || args.rowData.Honap_11_kedvezmenyes_Text === 'EP') && (args.columnName === 'Honap_11' || args.columnName === 'Honap_11_kozlemeny' || args.columnName === 'Honap_11_FizDatum') ||
                (args.rowData.Honap_12_kedvezmenyes_Text === 'B' || args.rowData.Honap_12_kedvezmenyes_Text === 'EP') && (args.columnName === 'Honap_12' || args.columnName === 'Honap_12_kozlemeny' || args.columnName === 'Honap_12_FizDatum') ||

                args.columnName === 'Honap_1_kedvezmenyes_Text' && (args.rowData.Honap_1_ReadOnly !== 'A' || args.rowData.Tagdijas_1 === false) ||
                args.columnName === 'Honap_2_kedvezmenyes_Text' && (args.rowData.Honap_2_ReadOnly !== 'A' || args.rowData.Tagdijas_2 === false) ||
                args.columnName === 'Honap_3_kedvezmenyes_Text' && (args.rowData.Honap_3_ReadOnly !== 'A' || args.rowData.Tagdijas_3 === false) ||
                args.columnName === 'Honap_4_kedvezmenyes_Text' && (args.rowData.Honap_4_ReadOnly !== 'A' || args.rowData.Tagdijas_4 === false) ||
                args.columnName === 'Honap_5_kedvezmenyes_Text' && (args.rowData.Honap_5_ReadOnly !== 'A' || args.rowData.Tagdijas_5 === false) ||
                args.columnName === 'Honap_6_kedvezmenyes_Text' && (args.rowData.Honap_6_ReadOnly !== 'A' || args.rowData.Tagdijas_6 === false) ||
                args.columnName === 'Honap_7_kedvezmenyes_Text' && (args.rowData.Honap_7_ReadOnly !== 'A' || args.rowData.Tagdijas_7 === false) ||
                args.columnName === 'Honap_8_kedvezmenyes_Text' && (args.rowData.Honap_8_ReadOnly !== 'A' || args.rowData.Tagdijas_8 === false) ||
                args.columnName === 'Honap_9_kedvezmenyes_Text' && (args.rowData.Honap_9_ReadOnly !== 'A' || args.rowData.Tagdijas_9 === false) ||
                args.columnName === 'Honap_10_kedvezmenyes_Text' && (args.rowData.Honap_10_ReadOnly !== 'A' || args.rowData.Tagdijas_10 === false) ||
                args.columnName === 'Honap_11_kedvezmenyes_Text' && (args.rowData.Honap_11_ReadOnly !== 'A' || args.rowData.Tagdijas_11 === false) ||
                args.columnName === 'Honap_12_kedvezmenyes_Text' && (args.rowData.Honap_12_ReadOnly !== 'A' || args.rowData.Tagdijas_12 === false) ||

                // Kérésre nem szerkeszthető, ha nem nulla vagy null van benne
                args.columnName === 'Honap_1_kedvezmenyes_Text' && (args.rowData.Honap_1 !== 0 && args.rowData.Honap_1 !== null) ||
                args.columnName === 'Honap_2_kedvezmenyes_Text' && (args.rowData.Honap_2 !== 0 && args.rowData.Honap_2 !== null) ||
                args.columnName === 'Honap_3_kedvezmenyes_Text' && (args.rowData.Honap_3 !== 0 && args.rowData.Honap_3 !== null) ||
                args.columnName === 'Honap_4_kedvezmenyes_Text' && (args.rowData.Honap_4 !== 0 && args.rowData.Honap_4 !== null) ||
                args.columnName === 'Honap_5_kedvezmenyes_Text' && (args.rowData.Honap_5 !== 0 && args.rowData.Honap_5 !== null) ||
                args.columnName === 'Honap_6_kedvezmenyes_Text' && (args.rowData.Honap_6 !== 0 && args.rowData.Honap_6 !== null) ||
                args.columnName === 'Honap_7_kedvezmenyes_Text' && (args.rowData.Honap_7 !== 0 && args.rowData.Honap_7 !== null) ||
                args.columnName === 'Honap_8_kedvezmenyes_Text' && (args.rowData.Honap_8 !== 0 && args.rowData.Honap_8 !== null) ||
                args.columnName === 'Honap_9_kedvezmenyes_Text' && (args.rowData.Honap_9 !== 0 && args.rowData.Honap_9 !== null) ||
                args.columnName === 'Honap_10_kedvezmenyes_Text' && (args.rowData.Honap_10 !== 0 && args.rowData.Honap_10 !== null) ||
                args.columnName === 'Honap_11_kedvezmenyes_Text' && (args.rowData.Honap_11 !== 0 && args.rowData.Honap_11 !== null) ||
                args.columnName === 'Honap_12_kedvezmenyes_Text' && (args.rowData.Honap_12 !== 0 && args.rowData.Honap_12 !== null) ||

                args.columnName === 'Honap_1' && (args.rowData.Honap_1_ReadOnly !== 'A' || args.rowData.Tagdijas_1 === false) ||
                args.columnName === 'Honap_2' && (args.rowData.Honap_2_ReadOnly !== 'A' || args.rowData.Tagdijas_2 === false) ||
                args.columnName === 'Honap_3' && (args.rowData.Honap_3_ReadOnly !== 'A' || args.rowData.Tagdijas_3 === false) ||
                args.columnName === 'Honap_4' && (args.rowData.Honap_4_ReadOnly !== 'A' || args.rowData.Tagdijas_4 === false) ||
                args.columnName === 'Honap_5' && (args.rowData.Honap_5_ReadOnly !== 'A' || args.rowData.Tagdijas_5 === false) ||
                args.columnName === 'Honap_6' && (args.rowData.Honap_6_ReadOnly !== 'A' || args.rowData.Tagdijas_6 === false) ||
                args.columnName === 'Honap_7' && (args.rowData.Honap_7_ReadOnly !== 'A' || args.rowData.Tagdijas_7 === false) ||
                args.columnName === 'Honap_8' && (args.rowData.Honap_8_ReadOnly !== 'A' || args.rowData.Tagdijas_8 === false) ||
                args.columnName === 'Honap_9' && (args.rowData.Honap_9_ReadOnly !== 'A' || args.rowData.Tagdijas_9 === false) ||
                args.columnName === 'Honap_10' && (args.rowData.Honap_10_ReadOnly !== 'A' || args.rowData.Tagdijas_10 === false) ||
                args.columnName === 'Honap_11' && (args.rowData.Honap_11_ReadOnly !== 'A' || args.rowData.Tagdijas_11 === false) ||
                args.columnName === 'Honap_12' && (args.rowData.Honap_12_ReadOnly !== 'A' || args.rowData.Tagdijas_12 === false) ||

                args.columnName === 'Honap_1_kozlemeny' && (args.rowData.Honap_1_ReadOnly !== 'A' || args.rowData.Tagdijas_1 === false) ||
                args.columnName === 'Honap_2_kozlemeny' && (args.rowData.Honap_2_ReadOnly !== 'A' || args.rowData.Tagdijas_2 === false) ||
                args.columnName === 'Honap_3_kozlemeny' && (args.rowData.Honap_3_ReadOnly !== 'A' || args.rowData.Tagdijas_3 === false) ||
                args.columnName === 'Honap_4_kozlemeny' && (args.rowData.Honap_4_ReadOnly !== 'A' || args.rowData.Tagdijas_4 === false) ||
                args.columnName === 'Honap_5_kozlemeny' && (args.rowData.Honap_5_ReadOnly !== 'A' || args.rowData.Tagdijas_5 === false) ||
                args.columnName === 'Honap_6_kozlemeny' && (args.rowData.Honap_6_ReadOnly !== 'A' || args.rowData.Tagdijas_6 === false) ||
                args.columnName === 'Honap_7_kozlemeny' && (args.rowData.Honap_7_ReadOnly !== 'A' || args.rowData.Tagdijas_7 === false) ||
                args.columnName === 'Honap_8_kozlemeny' && (args.rowData.Honap_8_ReadOnly !== 'A' || args.rowData.Tagdijas_8 === false) ||
                args.columnName === 'Honap_9_kozlemeny' && (args.rowData.Honap_9_ReadOnly !== 'A' || args.rowData.Tagdijas_9 === false) ||
                args.columnName === 'Honap_10_kozlemeny' && (args.rowData.Honap_10_ReadOnly !== 'A' || args.rowData.Tagdijas_10 === false) ||
                args.columnName === 'Honap_11_kozlemeny' && (args.rowData.Honap_11_ReadOnly !== 'A' || args.rowData.Tagdijas_11 === false) ||
                args.columnName === 'Honap_12_kozlemeny' && (args.rowData.Honap_12_ReadOnly !== 'A' || args.rowData.Tagdijas_12 === false) ||

                args.columnName === 'Honap_1_FizDatum' && (args.rowData.Honap_1_ReadOnly !== 'A' || args.rowData.Tagdijas_1 === false) ||
                args.columnName === 'Honap_2_FizDatum' && (args.rowData.Honap_2_ReadOnly !== 'A' || args.rowData.Tagdijas_2 === false) ||
                args.columnName === 'Honap_3_FizDatum' && (args.rowData.Honap_3_ReadOnly !== 'A' || args.rowData.Tagdijas_3 === false) ||
                args.columnName === 'Honap_4_FizDatum' && (args.rowData.Honap_4_ReadOnly !== 'A' || args.rowData.Tagdijas_4 === false) ||
                args.columnName === 'Honap_5_FizDatum' && (args.rowData.Honap_5_ReadOnly !== 'A' || args.rowData.Tagdijas_5 === false) ||
                args.columnName === 'Honap_6_FizDatum' && (args.rowData.Honap_6_ReadOnly !== 'A' || args.rowData.Tagdijas_6 === false) ||
                args.columnName === 'Honap_7_FizDatum' && (args.rowData.Honap_7_ReadOnly !== 'A' || args.rowData.Tagdijas_7 === false) ||
                args.columnName === 'Honap_8_FizDatum' && (args.rowData.Honap_8_ReadOnly !== 'A' || args.rowData.Tagdijas_8 === false) ||
                args.columnName === 'Honap_9_FizDatum' && (args.rowData.Honap_9_ReadOnly !== 'A' || args.rowData.Tagdijas_9 === false) ||
                args.columnName === 'Honap_10_FizDatum' && (args.rowData.Honap_10_ReadOnly !== 'A' || args.rowData.Tagdijas_10 === false) ||
                args.columnName === 'Honap_11_FizDatum' && (args.rowData.Honap_11_ReadOnly !== 'A' || args.rowData.Tagdijas_11 === false) ||
                args.columnName === 'Honap_12_FizDatum' && (args.rowData.Honap_12_ReadOnly !== 'A' || args.rowData.Tagdijas_12 === false)
            ) {
                args.cancel = true;
            } else {
                $timeout(function () {
                    new ej2.data.DataManager(vm.data).executeQuery(new ej2.data.Query().where('Id', 'equal', args.rowData.Id)).then(function (result) {
                        vm.rowUnderEditing = result.result[0];
                    });
                    vm.AthleteUnderEditing = args.rowData.Versenyzo_Nev;
                    $scope.$apply();
                }, 0);
            }
        }

        function saveWithoutNumbers() {
            return save(false);
        }

        function saveWithNumbers() {
            return save(true);
        }

        function save(withNumbers) {
            if (vm.MODTAGDBEALL || vm.UJTAGDNYILV) {
                // batchSave();
                return dataservice.updateTagdijfizetesek(vm.modifiedRows, withNumbers).then(function () {
                    log.successMsg('Saved');
                    vm.modifiedRows = [];
                    return true;
                });
            } else {
                log.permissionError();
            }
        }

        function batchSave() {
            grid.editModule.batchSave();
        }

        function goToDailyPayments() {
            paramHelper.setParams([{'dailySportServiceFeePayments.sectionId': vm.sectionId}, {'dailySportServiceFeePayments.coachId': vm.coachId}, {'dailySportServiceFeePayments.year': vm.year}]);
            saveWithoutNumbers().then(function () {
                $state.go('business.dailySportServiceFeePayments');
            });
        }

        function goToAthlete(id) {
            $q.all([authenticationService.getRight('MEGTSPORTLIST'), authenticationService.getRight('MEGTSPORTLIST')]).then(function (results) {
                if (results[0] || results[1]) {
                    paramHelper.setParams([{'athleteModify.sportoloId': id}]);
                    $state.go('athletes.athletesManagement.athleteModify.dataSheet');
                } else {
                    log.permissionError();
                }
            });
        }

        function openCoach(edzoId) {
            $q.all([authenticationService.getRight('MODFELH'), authenticationService.getRight('MEGTFELH')]).then(function (results) {
                if (results[0] || results[1]) {
                    paramHelper.setParams([{'newUser.userId': edzoId}]);
                    $state.go('settings.userManagement.modifyUser');
                } else {
                    log.permissionError();
                }
            });
        }

        function cellSave(args) {
            if (args.value != null && args.value !== vm.rowUnderEditing[args.columnName]) {
                $timeout(function () {
                    $scope.$apply();
                    vm.modifiedRows.push(vm.rowUnderEditing);
                }, 500);
            }
            vm.AthleteUnderEditing = '';
            new ej2.data.DataManager(vm.data).executeQuery(new ej2.data.Query().where('Id', 'equal', args.rowData.Id)).then(function (result) {
                result.result[0][args.columnName] = args.value;
                grid.refresh();
            });
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.business.sportServiceFeeRegister')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'business.sportServiceFeeRegister',
                config: {
                    url: '/sportServiceFeeRegister',
                    templateUrl: 'app/business/sportServiceFeeRegister/sportServiceFeeRegister.html',
                    controller: 'SportServiceFeeRegisterController',
                    controllerAs: 'vm',
                    title: 'SportServiceFeeRegister',
                    settings: {
                        navId: 223,
                        level: 2,
                        order: 2,
                        orderTitle_hu: 'Sportszolgáltatási díj nyilvántartás',
                        orderTitle_en: 'Sport Service Fee Register',
                        parentId: 3,
                        content: 'SportServiceFeeRegister',
                        activatorPermission: '"MEGTTAGDNYILV"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    authenticationService.$inject = ["localStorageService", "moment", "dataservice", "$rootScope", "AUTH_EVENTS", "$q"];
    angular
        .module('app.core')
        .factory('authenticationService', authenticationService);

    function authenticationService(localStorageService, moment, dataservice, $rootScope, AUTH_EVENTS, $q) {
        return {
            isAuthenticated: isAuthenticated,
            getPermission: getPermission,
            noEducationalFee: noEducationalFee,
            getAuthData: getAuthData,
            logout: logout,
            login: login,
            setSessionTimeOut: setSessionTimeOut,
            isSessionTimeOut: isSessionTimeOut,
            getSessionData: getSessionData,
            getLanguage: getLanguage,
            getRights: getRights,
            getRight: getRight,
            getAccessToken: getAccessToken
        };

        function isAuthenticated() {
            var authData = localStorageService.get('_authData');
            return !authData ? false : true;
        }

        function getAccessToken() {
            return localStorageService.get('_authData').access_token;
        }

        function getPermission() {
            if (localStorageService.get('_authData') && localStorageService.get('_authData').permission) {
                return localStorageService.get('_authData').permission;
            } else {
                return -1;
            }
        }

        function getRights(data) {
            return $q(function (resolve) {
                var accessRights = [];
                for (var i = 0; i < data.length; i++) {
                    accessRights.push({RightName: data[i], Allowed: false});
                }
                if (isAuthenticated()) {
                    for (var r = 0; r < accessRights.length; r++) {
                        for (var j = 0; j < getAuthData().accessRights.length; j++) {
                            if (data[r].indexOf(getAuthData().accessRights[j]) >= 0 && isAuthenticated()) {
                                accessRights[r].Allowed = true;
                            }
                        }
                    }
                }
                resolve(accessRights);
            });
        }

        function noEducationalFee() {
            dataservice.noEducationalFee().then(function (result) {
                localStorageService.set('noEducationalFee', result.retValue);
            });
        }

        function getRight(data) {
            return $q(function (resolve) {
                if (!isAuthenticated()) {
                    resolve(false);
                } else {
                    data = '"' + data + '"';
                    if (getAuthData().accessRights && getAuthData().accessRights.indexOf(data) >= 0) {
                        resolve(true);
                    }
                    resolve(false);
                }
            });
        }

        function getLanguage() {
            if (isAuthenticated()) {
                return localStorageService.get('_authData').language;
            } else if (isSessionTimeOut()) {
                return localStorageService.get('_sessionData').language;
            } else {
                return navigator.language || navigator.userLanguage;
            }
        }

        function pSetAuthData(user) {
            if (!user) {
                return false;
            }
            // át kell írni a szervert, hogy adja vissza ezeket is
            // valamint az access_token-t is menteni kell
            return localStorageService.set('_authData', {
                id: user.id,
                loginName: user.loginName,
                userFullName: user.userFullName,
                picture: user.picture,
                language: user.language,
                gridRecordPerPage: user.gridRecordPerPage,
                pwdExpiration: moment.utc(user.expiration).format(),
                accessRights: user.accessRights,
                permission: user.permission,
                access_token: user.access_token
            });
        }

        function login(loginName, password, language) {
            return dataservice.login(loginName, password, language)
                .then(function (data) {
                    var subscribeToTopic = data.data.school;
                    switch (data.data.szerepkor){
                        case '-1':
                            subscribeToTopic += 'coach';
                            break;
                        case '0':
                            subscribeToTopic += 'athlete';
                            break;
                        case '1':
                        case '2':
                            subscribeToTopic += 'parent';
                            break;
                    }
                    subscribeToTopic += data.data.id;
                    localStorageService.set('sikertopic', subscribeToTopic);
                    if (angular.isDefined(data.data.access_token)) {
                        data.data.loginName = loginName;
                        data.data.language = language;
                        localStorageService.set(data.data.id + '.' + 'gridRecordPerPage', data.data.gridRecordPerPage);
                        if (pSetAuthData(data.data)) {
                            if (isSessionTimeOut() && loginName === getSessionData().loginName) {
                                $rootScope.$broadcast(AUTH_EVENTS.login, getSessionData().url, data.data.permission);
                            } else {
                                $rootScope.$broadcast(AUTH_EVENTS.login, '', data.data.permission);
                            }
                            pClearSessionData();
                            return true;
                        }
                    }
                    return false;
                }).catch(function () {
                    return false;
                });
        }

        function logout() {
            return dataservice.logout().then(function (data) {
                    if (angular.isDefined(data) && data.retValue) {
                        pClearAuthData();
                        $rootScope.$broadcast(AUTH_EVENTS.logout);
                        return true;
                    }
                    return false;
                }
            ).catch(function () {
                return false;
            });
        }

        function setSessionTimeOut(url) {
            if (isAuthenticated()) {
                var userInfo = getAuthData();
                localStorageService.set('_sessionData', {
                    loginName: userInfo.loginName,
                    picture: userInfo.picture,
                    language: userInfo.language,
                    url: url
                });
                logout();
            }
        }

        function isSessionTimeOut() {
            var sessionData = localStorageService.get('_sessionData');
            return !sessionData ? false : true;
        }

        function getSessionData() {
            return localStorageService.get('_sessionData');
        }

        function getAuthData() {
            return localStorageService.get('_authData');
        }

        function pClearSessionData() {
            return localStorageService.remove('_sessionData');
        }

        function pClearAuthData() {
            return localStorageService.remove('_authData', 'marMegnezte');
        }
    }
})();

(function () {
    'use strict';

    toastrConfig.$inject = ["toastr"];
    configure.$inject = ["routerHelperProvider", "exceptionHandlerProvider", "$httpProvider", "logProvider"];
    var core = angular.module('app.core');

    core.config(toastrConfig);

    function toastrConfig(toastr) {
        toastr.options.timeOut = 4000;
        toastr.options.positionClass = 'toast-bottom-right';
    }

    var config = {
        appTitle: 'Siker2',
        environment: 'development', // 'development' vagy 'production'
        partnerLogo: 'images/partnerlogo2.png'
    };

    core.value('config', config);

    core.config(configure);

    function configure(routerHelperProvider, exceptionHandlerProvider, $httpProvider, logProvider) {
        if (config.environment) {
            logProvider.setEnvironment(config.environment);
        }
        //      $compileProvider.debugInfoEnabled(false);
        // $httpProvider.defaults.withCredentials = true;
        exceptionHandlerProvider.configure(config.environment);
        routerHelperProvider.configure({docTitle: config.appTitle + ': '});
        $httpProvider.interceptors.push('httpInterceptor');
    }
})();

/* global toastr:false, moment:false */
(function () {
    'use strict';

    angular
        .module('app.core')
        .constant('toastr', toastr)
        .constant('moment', moment)
        .constant('DOMAIN', {
                baseURL: clientConfig.url,
                //baseURL: 'http://deac.sikerszoftver.hu/',
                //baseURL: 'http://egrivizilabda.sikerszoftver.hu/',
                imgBaseUrl: 'api/Photos/',
                webService: 'api/',
                noImage: 'api/Photos/noImg.jpg',
                userImage: 'api/Photos/avatar_2x.png',
                profileImgBaseUrl: 'api/Photos/Profile/',
                psychologyDocUrl: 'api/PsychologyDocuments/',
                resultReportImgBaseUrl: 'api/Photos/Versenyeredmeny/',
                resultReportTeamImgBaseUrl: 'api/Photos/VersenyeredmenyCsapat/',
                anthropometryPhotosUrl: 'api/Photos/Antropometria/',
                youtubeIcon: 'api/Photos/youtube.png',
                teamPhotosUrl: 'api/Photos/Csapat/',
                exerciseBaseUrl: 'api/Photos/Gyakorlatok/',
                messageImagesUrl: 'api/MessageImages/',
                justPsycho: 0
            }
            /*
             .constant('DOMAIN', {
             webService: 'http://pszicho.unideb.cts.hu/app/api/',
             noImage: 'http://pszicho.unideb.cts.hu/Photos/noImage.jpg',
             userImage: 'http://pszicho.unideb.cts.hu/Photos/avatar_2x.png',
             imgBaseUrl: 'http://pszicho.unideb.cts.hu/app/api/Photos/',
             profileImgBaseUrl: 'http://pszicho.unideb.cts.hu/app/api/Photos/Profile/',
             psychologyDocUrl: 'http://pszicho.unideb.cts.hu/app/api/PsychologyDocuments/',
             justPsycho: 1
             }*/
        )
        .constant('timeout', 20000) // Http request timeout 20 seconds
        .constant('keepalive', 7200000) // Session time keepalive 2 hours
        .constant('AUTH_EVENTS', {
            login: 'auth-login',
            logout: 'auth-logout',
            sessionTimeout: 'auth-session-timeout',
            notAuthorized: 'auth-not-authorized',
            refreshProfilePic: 'refresh-profile-picture'
        })
        .constant('LANG_EVENTS', {
            changeLanguage: 'change-language'
        })
        .constant('PSYCHOLOGY', {
            Wartegg: 1,
            PerformanceMotivation: 2,
            Pieron: 3,
            Tenessee: 4
        })
        .constant('VIEW_DATA', {
            dropDownList: {
                weight: {
                    downThreshold: 20,
                    upThreshold: 150
                },
                centimetre: {
                    downThreshold: 100,
                    upThreshold: 250
                },
                sex: ['Nő', 'Férfi'],
                hand: ['Jobb', 'Bal'],
                foot: ['Jobb', 'Bal'],
                feeOfEducation: ['Oktatási díjas', 'Sportszolgáltatási díjas'],
                counties: ['Bács-Kiskun', 'Baranya', 'Békés', 'Borsod-Abaúj-Zemplén', 'Csongrád', 'Fejér', 'Győr-Moson-Sopron', 'Hajdú-Bihar', 'Heves', 'Jász-Nagykun-Szolnok', 'Komárom-Esztergom', 'Nógrád', 'Pest', 'Somogy', 'Szabolcs-Szatmár-Bereg', 'Tolna', 'Vas', 'Veszprém', 'Zala', 'Budapest'],
                course: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15'],
                class: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'R', 'S', 'T', 'U', 'V', 'X', 'Y', 'Z']

            }
        })
        .constant('LAYOUT_EVENTS', {
            passwordChange: 'layout-password-change'
        });
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.core')
        .run(appRun);

    /* @ngInject */
    function appRun(routerHelper) {
        // var otherwise = '/404';
        var otherwise = '/';
        routerHelper.configureStates(getStates(), otherwise);
    }

    function getStates() {
        return [
            {
                state: '404',
                config: {
                    url: '/404',
                    templateUrl: 'app/core/404.html',
                    title: '404'
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    dataservice.$inject = ["$http", "DOMAIN"];
    angular
        .module('app.core').config(function (/*$httpProvider*/) {
            // delete $httpProvider.defaults.headers.common['X-Requested-With'];
        })
        .factory('dataservice', dataservice);

    function dataservice($http, DOMAIN) {
        var service = {
            range: range,
            getURL: getURL,
            changePassword: changePassword,
            login: login,
            getHaveToPay: getHaveToPay,
            logout: logout,
            parentsAthletes: parentsAthletes,
            quickCompetitionResult: quickCompetitionResult,
            getPieronTest: getPieronTest,
            getAvailableLanguages: getAvailableLanguages,
            sectionDropDownList: sectionDropDownList,
            ageGroupDropDownList: ageGroupDropDownList,
            teamsDropDownList: teamsDropDownList,
            getAthletesForEducationalFeeRegister: getAthletesForEducationalFeeRegister,
            teamList: teamList,
            savePieronTest: savePieronTest,
            getUserGroupList: getUserGroupList,
            updateTagdijfizetesek: updateTagdijfizetesek,
            ageGroupDropDownListForSearch: ageGroupDropDownListForSearch,
            getTestAthletesList: getTestAthletesList,
            modifyEvent: modifyEvent,
            getTest: getTest,
            usersListSelect: usersListSelect,
            getCheck: getCheck,
            coachDropDownList: coachDropDownList,
            getCheckExportPrintList: getCheckExportPrintList,
            KoltsegtervOsszesitoExcelExport: KoltsegtervOsszesitoExcelExport,
            addUserGroup: addUserGroup,
            getUpAndDownPlayers: getUpAndDownPlayers,
            HealthReport: HealthReport,
            getAthletesFromFeeRegister: getAthletesFromFeeRegister,
            saveTest: saveTest,
            getAnnualSportServiceFeeByCoach: getAnnualSportServiceFeeByCoach,
            getOldCompetitivePlanByUserId: getOldCompetitivePlanByUserId,
            athletesSelect2: athletesSelect2,
            getDuplicatedAthletes: getDuplicatedAthletes,
            deleteMonthlyTrainingPlan: deleteMonthlyTrainingPlan,
            saveAnthropometry: saveAnthropometry,
            getAthletesForFeeArrears: getAthletesForFeeArrears,
            checkPaymentsSave: checkPaymentsSave,
            deleteHealthMainType: deleteHealthMainType,
            deleteHealthSubType: deleteHealthSubType,
            HealthMainTypeManager: HealthMainTypeManager,
            HealthSubTypeManager: HealthSubTypeManager,
            healthMainTypesList: healthMainTypesList,
            healthSubTypesList: healthSubTypesList,
            sectionDropDownListAll: sectionDropDownListAll,
            getSectionLeaderListBox: getSectionLeaderListBox,
            getEducationalFeePaymentsNumbers: getEducationalFeePaymentsNumbers,
            sectionDropDownListWithFees: sectionDropDownListWithFees,
            sectionDropDownListWithGroupStatus: sectionDropDownListWithGroupStatus,
            getAgeGroupTreeView: getAgeGroupTreeView,
            getAnnualSeasonPlanArrears: getAnnualSeasonPlanArrears,
            removeEvent: removeEvent,
            savePerformanceMotivationSurveyEval: savePerformanceMotivationSurveyEval,
            editUserGroup: editUserGroup,
            getOldAnthropometryTest: getOldAnthropometryTest,
            saveTeam: saveTeam,
            getAthletesEV: getAthletesEV,
            updateOktatasiDijfizetesek: updateOktatasiDijfizetesek,
            savePerformanceMotivationSurvey: savePerformanceMotivationSurvey,
            getPerformanceMotivationSurvey: getPerformanceMotivationSurvey,
            selectSchools: selectSchools,
            getOldWeeklyPlanByUserId: getOldWeeklyPlanByUserId,
            getWeeklyTrainingPlans: getWeeklyTrainingPlans,
            getAnnualCompetitiveReports: getAnnualCompetitiveReports,
            getClassMasters: getClassMasters,
            getClassMasterContact: getClassMasterContact,
            getMonthlyAttendanceReports: getMonthlyAttendanceReports,
            getTrainingAttendances: getTrainingAttendances,
            getMonthlyCompetitivePlans: getMonthlyCompetitivePlans,
            parentsAthleteAttendanceList: parentsAthleteAttendanceList,
            getGymTeachers: getGymTeachers,
            getGymTeacherContact: getGymTeacherContact,
            getMonthlyTrainingPlanList: getMonthlyTrainingPlanList,
            addSchool: addSchool,
            getSectionResources: getSectionResources,
            getAnnualSportServiceFeeByOneSection: getAnnualSportServiceFeeByOneSection,
            getAgeGroupResources: getAgeGroupResources,
            editSchool: editSchool,
            getAnnualEducationalFeeBySection: getAnnualEducationalFeeBySection,
            getAnnualEducationalFeeByOneSection: getAnnualEducationalFeeByOneSection,
            searchAthlete: searchAthlete,
            searchUser: searchUser,
            deleteSchool: deleteSchool,
            addUser: addUser,
            getAthleteForAnthropometry: getAthleteForAnthropometry,
            saveEvent: saveEvent,
            modifyUser: modifyUser,
            modifyUserMin: modifyUserMin,
            getTeamMembersList: getTeamMembersList,
            modifyTeam: modifyTeam,
            getPossibleTeamMembersList: getPossibleTeamMembersList,
            addTeamMemberToTeam: addTeamMemberToTeam,
            getUserGroupDropDownList: getUserGroupDropDownList,
            getFullUserGroupList: getFullUserGroupList,
            deleteTeamMember: deleteTeamMember,
            getTestYears: getTestYears,
            getAnnualSportServiceFeeBySection: getAnnualSportServiceFeeBySection,
            getAnnualEducationalFeeByCoach: getAnnualEducationalFeeByCoach,
            deleteTeam: deleteTeam,
            deleteTeamsPlayers: deleteTeamsPlayers,
            getTeam: getTeam,
            getAnnualEducationalFeeByAthletes: getAnnualEducationalFeeByAthletes,
            ageGroupList: ageGroupList,
            saveDailyAttendance: saveDailyAttendance,
            sendLocalException: sendLocalException,
            getResultsReportsAthlete: getResultsReportsAthlete,
            DeleteExercise: DeleteExercise,
            SimilarAthleteExist: SimilarAthleteExist,
            getExerciseList: getExerciseList,
            getExercise: getExercise,
            HetiEdzesTervJovahagyas: HetiEdzesTervJovahagyas,
            GetPaints: GetPaints,
            HaviEdzesTervJovahagyas: HaviEdzesTervJovahagyas,
            getServiceFeePaymentsNumbers: getServiceFeePaymentsNumbers,
            getAgeGroupMembersList: getAgeGroupMembersList,
            getAwayBudgetPlanList: getAwayBudgetPlanList,
            KoltsegtervOsszesitoKimutatas: KoltsegtervOsszesitoKimutatas,
            getAgeGroup: getAgeGroup,
            modifyTest: modifyTest,
            saveExercise: saveExercise,
            saveAgeGroup: saveAgeGroup,
            modifyAgeGroup: modifyAgeGroup,
            modifyPaint: modifyPaint,
            copyAllAgeGroup: copyAllAgeGroup,
            athletesSelect: athletesSelect,
            parentsAthleteAttendance: parentsAthleteAttendance,
            savePaint: savePaint,
            getPaint: getPaint,
            getAthletesForDailyPayments2: getAthletesForDailyPayments2,
            getUserData: getUserData,
            getUserDataMin: getUserDataMin,
            coachSelect: coachSelect,
            ageGroupSelect: ageGroupSelect,
            monthlyAttendanceSelect: monthlyAttendanceSelect,
            getAccessRights: getAccessRights,
            saveMonthlyAttendance: saveMonthlyAttendance,
            getNewAthletesInSelectedYearMonth: getNewAthletesInSelectedYearMonth,
            messageSave: messageSave,
            getUserGroupTypes: getUserGroupTypes,
            monthlyAttendanceAcceptByLeader: monthlyAttendanceAcceptByLeader,
            getAthleteData: getAthleteData,
            getAthleteDataMin: getAthleteDataMin,
            getAthletesForDailyPayments: getAthletesForDailyPayments,
            transferAthletes: transferAthletes,
            getEvents: getEvents,
            getAnnualSportServiceFeeByAthletes: getAnnualSportServiceFeeByAthletes,
            getLastMonthlyAttendanceTrainingLocationAndTime: getLastMonthlyAttendanceTrainingLocationAndTime,
            getAthletesForMonthlyAttendance: getAthletesForMonthlyAttendance,
            monthlyAttendanceSelectById: monthlyAttendanceSelectById,
            getAthletesCountForMonthlyAttendance: getAthletesCountForMonthlyAttendance,
            getMonthlyAttendanceList: getMonthlyAttendanceList,
            getUserUnreadedMessages: getUserUnreadedMessages,
            unreadedMessagesViewed: unreadedMessagesViewed,
            messageDelete: messageDelete,
            messageDeleteSent: messageDeleteSent,
            getUnAcceptedMonthlyAttendance: getUnAcceptedMonthlyAttendance,
            getUnAcceptedMonthlyCompetitionPlan: getUnAcceptedMonthlyCompetitionPlan,
            getUnAcceptedWeeklyCompetitionPlan: getUnAcceptedWeeklyCompetitionPlan,
            getUnAcceptedYearlyCompetitionPlan: getUnAcceptedYearlyCompetitionPlan,
            saveTenesseeSelfImageScale: saveTenesseeSelfImageScale,
            getPsychologyTests: getPsychologyTests,
            uploadWartegg: uploadWartegg,
            saveWartegg: saveWartegg,
            getTenesseeSelfImageScaleById: getTenesseeSelfImageScaleById,
            saveTenesseeSelfImageScaleEval: saveTenesseeSelfImageScaleEval,
            getMonthlyCompetitiveReports: getMonthlyCompetitiveReports,
            getWarteggTestById: getWarteggTestById,
            getWeeklyTrainingPlanList: getWeeklyTrainingPlanList,
            SaveAwayBudgetPlan: SaveAwayBudgetPlan,
            getIdegenbeliKoltsegvetesiTervEdzoList: getIdegenbeliKoltsegvetesiTervEdzoList,
            getIdegenbeliKoltsegvetesiTervSportoloList: getIdegenbeliKoltsegvetesiTervSportoloList,
            getWeeklyTravelList: getWeeklyTravelList,
            getWeeklyTrainingList: getWeeklyTrainingList,
            getAthletes: getAthletes,
            saveExitAthletes: saveExitAthletes,
            saveNewAthlete: saveNewAthlete,
            getAnthropometryListForPrinting: getAnthropometryListForPrinting,
            modifyAthlete: modifyAthlete,
            getSystemSettings: getSystemSettings,
            saveSystemSettings: saveSystemSettings,
            getUserGroupRights: getUserGroupRights,
            setUserGroupRight: setUserGroupRight,
            weeklyTrainingPlanSelectByIdNew: weeklyTrainingPlanSelectByIdNew,
            saveWeeklyTrainingPlanNew: saveWeeklyTrainingPlanNew,
            getFilesList: getFilesList,
            getResultsReports: getResultsReports,
            deleteFiles: deleteFiles,
            getCompetitiveMonthlyPlanList: getCompetitiveMonthlyPlanList,
            monthlyPlanSelectById: monthlyPlanSelectById,
            saveMonthlyCompetitionPlan: saveMonthlyCompetitionPlan,
            monthlyCompetitionPlanAcceptByLeader: monthlyCompetitionPlanAcceptByLeader,
            getCompetitiveMonthlyPlanItems: getCompetitiveMonthlyPlanItems,
            sectionIndividualOrTeam: sectionIndividualOrTeam,
            getFeeDatas: getFeeDatas,
            saveFeeDatas: saveFeeDatas,
            getAthletesForMeteOut: getAthletesForMeteOut,
            meteOutFee: meteOutFee,
            closeYear: closeYear,
            getLastClosedYear: getLastClosedYear,
            getLinks: getLinks,
            saveLink: saveLink,
            deleteLink: deleteLink,
            athletesBySection: athletesBySection,
            getUnPaidFees: getUnPaidFees,
            getUnPaidFeesTrainer: getUnPaidFeesTrainer,
            getMessages: getMessages,
            GetMessageGroups: GetMessageGroups,
            messageReaded: messageReaded,
            sendMessage: sendMessage,
            SikerMobileFreeSendNewMessage: SikerMobileFreeSendNewMessage,
            SikerMobileFreeSendMessage: SikerMobileFreeSendMessage,
            annualSeasonPlanReportSelectById: annualSeasonPlanReportSelectById,
            annualSeasonPlanReportSelect: annualSeasonPlanReportSelect,
            getTrainerEmailContact: getTrainerEmailContact,
            annualSeasonPlanReportMembersDataByIdSelect: annualSeasonPlanReportMembersDataByIdSelect,
            coachAthletesByAgeGroupForAnnualSeasonPlan: coachAthletesByAgeGroupForAnnualSeasonPlan,
            annualSeasonPlanDeleteMembers: annualSeasonPlanDeleteMembers,
            saveAnnualSeasonPlanMembers: saveAnnualSeasonPlanMembers,
            saveAnnualSeasonPlanHead: saveAnnualSeasonPlanHead,
            annualSeasonPlanReportMembersPastSelect: annualSeasonPlanReportMembersPastSelect,
            annualSeasonPlanReportMembersPastDelete: annualSeasonPlanReportMembersPastDelete,
            annualSeasonPlanReportMembersPastRefresh: annualSeasonPlanReportMembersPastRefresh,
            saveAnnualSeasonPlanMembersPast: saveAnnualSeasonPlanMembersPast,
            annualSeasonPlanReportBestResultsList: annualSeasonPlanReportBestResultsList,
            saveAnnualSeasonPlanBestResults: saveAnnualSeasonPlanBestResults,
            annualSeasonPlanReportBestResultsSelect: annualSeasonPlanReportBestResultsSelect,
            annualSeasonPlanReportObjectivesSelect: annualSeasonPlanReportObjectivesSelect,
            saveAnnualSeasonPlanCapitalObjectives: saveAnnualSeasonPlanCapitalObjectives,
            deleteFileAnnualSeasonPlan: deleteFileAnnualSeasonPlan,
            getAnnualSeasonPlanListByTrainer: getAnnualSeasonPlanListByTrainer,
            annualSeasonPlanCompetitionPlansAndObjectivesSelect: annualSeasonPlanCompetitionPlansAndObjectivesSelect,
            saveAnnualSeasonPlanCompetitionPlansAndObjectives: saveAnnualSeasonPlanCompetitionPlansAndObjectives,
            deleteAnnualSeasonPlanCompetitionPlansAndObjectives: deleteAnnualSeasonPlanCompetitionPlansAndObjectives,
            deleteAnnualSeasonPlanCompetitionPlansAndObjective: deleteAnnualSeasonPlanCompetitionPlansAndObjective,
            annualSeasonPlanList: annualSeasonPlanList,
            dailyEducationalFeesPerCoach: dailyEducationalFeesPerCoach,
            dailySportServiceFeesPerCoach: dailySportServiceFeesPerCoach,
            annualSeasponPlanTableListSelect: annualSeasponPlanTableListSelect,
            annualSeasponPlanTableListSelect2: annualSeasponPlanTableListSelect2,
            saveAnnualSeasonPlanTable: saveAnnualSeasonPlanTable,
            getAthleteTransferList: getAthleteTransferList,
            getCentralReportAllIn: getCentralReportAllIn,
            getFelmerokDatumaiDropDownList: getFelmerokDatumaiDropDownList,
            leavingAthletesBySection: leavingAthletesBySection,
            joinedAthletesBySection: joinedAthletesBySection,
            listAthletes: listAthletes,
            athletesByCoach: athletesByCoach,
            leavingAthletesByCoach: leavingAthletesByCoach,
            joinedAthletesByCoach: joinedAthletesByCoach,
            activeAthletesByAge: activeAthletesByAge,
            activeAthletesBornAtSpecificYear: activeAthletesBornAtSpecificYear,
            activeAthletesByMonth: activeAthletesByMonth,
            activeAthletesInSectionByMonth: activeAthletesInSectionByMonth,
            athletesNotPresentOnMonthlyAttendance: athletesNotPresentOnMonthlyAttendance,
            ActiveAthletesInASpecificMonth: ActiveAthletesInASpecificMonth,
            LeavingAthletesInASpecificMonth: LeavingAthletesInASpecificMonth,
            JoinedAthletesInASpecificMonth: JoinedAthletesInASpecificMonth,
            leavingAthletesFromASpecificCoach: leavingAthletesFromASpecificCoach,
            joinedAthletesToASpecificCoach: joinedAthletesToASpecificCoach,
            getFelmerokDatumai2DropDownList: getFelmerokDatumai2DropDownList,
            getAnnualPresenceReportByTrainersReport: getAnnualPresenceReportByTrainersReport,
            getAnnualPresenceReportBySectionsReport: getAnnualPresenceReportBySectionsReport,
            getAnnualPresenceReportBySportSchoolReport: getAnnualPresenceReportBySportSchoolReport,
            activeAthletesByCoach: activeAthletesByCoach,
            deleteWeeklyTrainingPlan: deleteWeeklyTrainingPlan,
            getAthleteMoveStory: getAthleteMoveStory,
            athleteDropDownListSelect: athleteDropDownListSelect,
            getCharacterOfACompetitionList: getCharacterOfACompetitionList,
            saveResultReportAthletes: saveResultReportAthletes,
            resultReportAthletesSelectById: resultReportAthletesSelectById,
            deleteResultsReport: deleteResultsReport,
            searchMemberList: searchMemberList,
            resultReportAthletesOlderReports: resultReportAthletesOlderReports,
            teamDropDownListSelect: teamDropDownListSelect,
            teamAthletesListSelect: teamAthletesListSelect,
            getCoachUsers: getCoachUsers,
            getEdzoKorcsoportjai: getEdzoKorcsoportjai,
            getTeamResultAthleteData: getTeamResultAthleteData,
            EredmenyJelentoAtjatszoSportoloi: EredmenyJelentoAtjatszoSportoloi,
            saveResultReportTeams: saveResultReportTeams,
            resultReportTeamSelectById: resultReportTeamSelectById,
            saveNewLink: saveNewLink,
            activeAthletesByBirthYear: activeAthletesByBirthYear,
            VersenyTervHaviDeleteById: VersenyTervHaviDeleteById,
            monthlyPlanSelectByDate: monthlyPlanSelectByDate,
            ujHaviVersenyeztetesiTerv: ujHaviVersenyeztetesiTerv,
            saveReEnteringAthletes: saveReEnteringAthletes,
            getAthletesForWeeklyTrainingPlan: getAthletesForWeeklyTrainingPlan,
            centralReportByRating: centralReportByRating,
            GetAwayBudgetPlan: GetAwayBudgetPlan,
            centralReportOfAthlete: centralReportOfAthlete,
            deleteUserGroup: deleteUserGroup,
            userGroupList: userGroupList,
            getTrainingVisitReport: getTrainingVisitReport,
            getSentMessages: getSentMessages,
            getExpiringDocuments: getExpiringDocuments,
            getAbsenceReport: getAbsenceReport,
            saveFelmeroElemFej: saveFelmeroElemFej,
            saveFelmeroElem: saveFelmeroElem,
            getSystemSettingsValue: getSystemSettingsValue,
            getFelmeroElemFejList: getFelmeroElemFejList,
            getFelmeroElemList: getFelmeroElemList,
            felmeroElemFejDropDownList: felmeroElemFejDropDownList,
            felmeroFejLista: felmeroFejLista,
            FelmeroMentes: FelmeroMentes,
            FelmeroLetrehozasa: FelmeroLetrehozasa,
            getFelmeroById: getFelmeroById,
            getSportagSpecReport: getSportagSpecReport,
            deleteFelmeroElemFej: deleteFelmeroElemFej,
            deleteFelmero: deleteFelmero,
            FelmeroTipusMasolas: FelmeroTipusMasolas,
            getSectionHasSectionLeaderRight: getSectionHasSectionLeaderRight,
            getSectionHasCoachRight: getSectionHasCoachRight,
            getOldMonthlyPlanByUserId: getOldMonthlyPlanByUserId,
            monthlyTrainingPlanSelectById: monthlyTrainingPlanSelectById,
            createLoginForAthlete: createLoginForAthlete,
            createLoginForParent: createLoginForParent,
            getAthleteidBelongsToAthleteUser: getAthleteidBelongsToAthleteUser,
            getUsersBelongingToAthlete: getUsersBelongingToAthlete,
            athleteAndParentDropDownList: athleteAndParentDropDownList,
            assignAthleteToParentUser: assignAthleteToParentUser,
            unlinkUserFromAthlete: unlinkUserFromAthlete,
            getParentAndAthleteUsers: getParentAndAthleteUsers,
            UsersUserGroup: UsersUserGroup,
            getUserIdsOfGroup: getUserIdsOfGroup,
            getUserId: getUserId,
            getAthletesBodyStat: getAthletesBodyStat,
            getAthletesOfUser: getAthletesOfUser,
            saveMonthlyTrainingPlan: saveMonthlyTrainingPlan,
            saveHealthData: saveHealthData,
            GetHealth: GetHealth,
            resultChartSectionDropDown: resultChartSectionDropDown,
            resultChartAgeGroupDropDown: resultChartAgeGroupDropDown,
            resultChartVersenyszamDropDown: resultChartVersenyszamDropDown,
            resultDateChart: resultDateChart,
            resultChart1: resultChart1,
            resultChart2: resultChart2,
            resultChart3: resultChart3,
            SzuloCsoportokDropDownList: SzuloCsoportokDropDownList,
            SportoloCsoportokDropDownList: SportoloCsoportokDropDownList,
            getNamesByIds: getNamesByIds,
            Cimjegyzek: Cimjegyzek,
            CimjegyzekMobil: CimjegyzekMobil,
            KedvezmenyNevek: KedvezmenyNevek,
            OktatasiKedvezmenyNevek: OktatasiKedvezmenyNevek,
            KedvezmenyNevekMentes: KedvezmenyNevekMentes,
            modifyHealthData: modifyHealthData,
            getReducedSportServiceFeeTypes: getReducedSportServiceFeeTypes,
            getReducedEducationalFeeTypes: getReducedEducationalFeeTypes,
            getAthleteFees: getAthleteFees,
            getParentNames: getParentNames,
            loadTrainingDiaryByMonthlyAttendanceId: loadTrainingDiaryByMonthlyAttendanceId,
            saveTrainingDiary: saveTrainingDiary,
            getTrainingDiaryReports: getTrainingDiaryReports,
            monthlyAttendanceRefreshAthleteData: monthlyAttendanceRefreshAthleteData,
            getLog: getLog,
            getImageOfUser: getImageOfUser,
            canNewTestAthletesList: canNewTestAthletesList,
            saveSystemSettingsValue: saveSystemSettingsValue,
            EsemenyekAttolteseHetiEdzestervre: EsemenyekAttolteseHetiEdzestervre,
            AtjatszoSportoloLista: AtjatszoSportoloLista,
            GetPaintList: GetPaintList,
            getParentNotifications: getParentNotifications,
            getParentNotifications2: getParentNotifications2,
            ErtesitestLatta: ErtesitestLatta,
            AcceptCSVPayment: AcceptCSVPayment,
            KoltesegvetesiTervExcelExport: KoltesegvetesiTervExcelExport,
            KoltesegvetesiTervVeglegesites: KoltesegvetesiTervVeglegesites,
            KoltesegvetesiTervLezaras: KoltesegvetesiTervLezaras,
            KoltesegvetesiTervJovahagyas: KoltesegvetesiTervJovahagyas,
            WeeklyTrainingPlaces: WeeklyTrainingPlaces,
            GenerateRegNum: GenerateRegNum,
            assetTypeList: assetTypeList,
            AssetManager: AssetManager,
            AssetsByType: AssetsByType,
            assetInventoryByType: assetInventoryByType,
            assetInventoryByPerson: assetInventoryByPerson,
            DeleteUndeleteAssets: DeleteUndeleteAssets,
            AthletesInSection: AthletesInSection,
            UsersInGroup: UsersInGroup,
            AssetIssue: AssetIssue,
            AssetTakeBack: AssetTakeBack,
            IssuedAssets: IssuedAssets,
            getSectionData: getSectionData,
            editSection: editSection,
            getSectionLeaders: getSectionLeaders,
            CSVSettings: CSVSettings,
            CSVPreprocessSelectHeader: CSVPreprocessSelectHeader,
            EdzesFejLista: EdzesFejLista,
            EdzesSablon: EdzesSablon,
            ExpiringDocuments: ExpiringDocuments,
            getTrainingPracticeAutoComplete: getTrainingPracticeAutoComplete,
            getExercises: getExercises,
            IdegenKoltsegTervBuszTulaj: IdegenKoltsegTervBuszTulaj,
            IdegenKoltsegTervBusz: IdegenKoltsegTervBusz,
            saveTrainingPlan: saveTrainingPlan,
            getParentDataPOST: getParentDataPOST,
            getTrainingPlanList: getTrainingPlanList,
            EszkozIgenyLista: EszkozIgenyLista,
            GetTrainingPlanById: GetTrainingPlanById,
            ageGroupSelectYear: ageGroupSelectYear,
            ageGroupSelectBetweenDates: ageGroupSelectBetweenDates,
            getCoachContant: getCoachContant,
            deleteAwayBudgetPlan: deleteAwayBudgetPlan,
            SzakosztalyRuhai: SzakosztalyRuhai,
            DeleteTrainingPlan: DeleteTrainingPlan,
            noEducationalFee: noEducationalFee,
            getMonthlyAttendanceAutoSave: getMonthlyAttendanceAutoSave,
            setMonthlyAttendanceAutoSave: setMonthlyAttendanceAutoSave,
            CopyTimeAndPlaceFromWeeklyPlan: CopyTimeAndPlaceFromWeeklyPlan,
            SetPushNotificationSettings: SetPushNotificationSettings,
            HetiEdzestervLegregebbiHet: HetiEdzestervLegregebbiHet,
            getCompetitionPlaces: getCompetitionPlaces,
            GDPRExitAthlete: GDPRExitAthlete,
            DeleteAthleteAvatar: DeleteAthleteAvatar,
            DeleteUserAvatar: DeleteUserAvatar,
            GetUnreadMessageCount: GetUnreadMessageCount,
            FirebaseSubscribeToTopic: FirebaseSubscribeToTopic,
            SikerMobileFreeDeleteMessages: SikerMobileFreeDeleteMessages
        };

        var ds = this; // jshint ignore: line

        return service;

        function FirebaseSubscribeToTopic(data) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'FirebaseSubscribeToTopic',
                data: data
            };
            return $http(ds.req);
        }

        function GetUnreadMessageCount() {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'GetUnreadMessageCount'
            };
            return $http(ds.req);
        }

        function DeleteAthleteAvatar(id, fenykepUt) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'DeleteAthleteAvatar',
                params: {
                    id: id,
                    fenykepUt: fenykepUt
                }
            };
            return $http(ds.req);
        }

        function DeleteUserAvatar(id, fenykepUt) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'DeleteUserAvatar',
                params: {
                    id: id,
                    fenykepUt: fenykepUt
                }
            };
            return $http(ds.req);
        }

        function GDPRExitAthlete(sportoloId) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'GDPRExitAthlete',
                params: {
                    sportoloId: sportoloId
                }
            };
            return $http(ds.req);
        }

        function HetiEdzestervLegregebbiHet() {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'HetiEdzestervLegregebbiHet'
            };
            return $http(ds.req);
        }

        function SetPushNotificationSettings(data) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'SetPushNotificationSettings',
                data: data
            };
            return $http(ds.req);
        }

        function CopyTimeAndPlaceFromWeeklyPlan(id) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'CopyTimeAndPlaceFromWeeklyPlan',
                params: {
                    id: id
                }
            };
            return $http(ds.req);
        }

        function deleteAwayBudgetPlan(id) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'deleteAwayBudgetPlan',
                params: {
                    id: id
                }
            };
            return $http(ds.req);
        }

        function getCoachContant(edzoid) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'getCoachContant',
                params: {
                    edzoid: edzoid
                }
            };
            return $http(ds.req);
        }

        function noEducationalFee() {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'NoEducationalFee'
            };
            return $http(ds.req);
        }

        function EszkozIgenyLista(EdzesFejId) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'EszkozIgenyLista',
                params: {
                    EdzesFejId: EdzesFejId
                }
            };
            return $http(ds.req);
        }

        function getParentDataPOST(parent, arg) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'SzuloAdatok',
                data: {
                    parent: parent,
                    arg: arg
                }
            };
            return $http(ds.req);
        }

        function IdegenKoltsegTervBuszTulaj() {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'IdegenKoltsegTervBuszTulaj'
            };
            return $http(ds.req);
        }

        function IdegenKoltsegTervBusz() {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'IdegenKoltsegTervBusz'
            };
            return $http(ds.req);
        }

        function EdzesSablon(EdzesFejId) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'EdzesSablon',
                params: {
                    EdzesFejId: EdzesFejId
                }
            };
            return $http(ds.req);
        }

        function EdzesFejLista(szakosztaly, korosztaly) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'EdzesFejLista',
                params: {
                    szakosztaly: szakosztaly,
                    korosztaly: korosztaly
                }
            };
            return $http(ds.req);
        }

        function CSVPreprocessSelectHeader(file, headerRow, enc) {
            if (!enc) {
                enc = 'NULL';
            }
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'CSVPreprocessSelectHeader',
                params: {
                    file: file,
                    headerRow: headerRow,
                    enc: enc
                }
            };
            return $http(ds.req);
        }

        function CSVSettings(data) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'CSVSettings',
                data: data
            };
            return $http(ds.req);
        }

        function getSectionLeaders() {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'getSectionLeaders'
            };
            return $http(ds.req);
        }

        function editSection(data) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'editSection',
                data: data
            };
            return $http(ds.req);
        }

        function getSectionData(id) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'getSectionData',
                params: {
                    id: id
                }
            };
            return $http(ds.req);
        }

        function IssuedAssets(sportolo, edzo) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'IssuedAssets',
                params: {
                    sportolo: sportolo,
                    edzo: edzo
                }
            };
            return $http(ds.req);
        }

        function AssetTakeBack(assets, megjegyzes) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'AssetTakeBack',
                data: {
                    assets: assets,
                    megjegyzes: megjegyzes
                }
            };
            return $http(ds.req);
        }

        function AssetIssue(assets, edzo, sportolo, megjegyzes) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'AssetIssue',
                data: {
                    assets: assets,
                    edzo: edzo,
                    sportolo: sportolo,
                    megjegyzes: megjegyzes
                }
            };
            return $http(ds.req);
        }

        function AthletesInSection(section) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'AthletesInSection',
                params: {
                    section: section
                }
            };
            return $http(ds.req);
        }

        function UsersInGroup(usergroup) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'UsersInGroup',
                params: {
                    usergroup: usergroup
                }
            };
            return $http(ds.req);
        }

        function AssetsByType(assetType, filter) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'AssetsByType',
                params: {
                    assetType: assetType,
                    filter: filter
                }
            };
            return $http(ds.req);
        }

        function DeleteUndeleteAssets(data) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'DeleteUndeleteAssets',
                data: data
            };
            return $http(ds.req);
        }

        function AssetManager(data) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'AssetManager',
                data: data
            };
            return $http(ds.req);
        }

        function assetTypeList() {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'assetTypeList'
            };
            return $http(ds.req);
        }

        function GenerateRegNum() {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'GenerateRegNum'
            };
            return $http(ds.req);
        }

        function WeeklyTrainingPlaces() {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'WeeklyTrainingPlaces'
            };
            return $http(ds.req);
        }

        function KoltesegvetesiTervLezaras(tervid, close) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'KoltesegvetesiTervLezaras',
                params: {
                    tervid: tervid,
                    close: close
                }
            };
            return $http(ds.req);
        }

        function KoltesegvetesiTervVeglegesites(tervid) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'KoltesegvetesiTervVeglegesites',
                params: {
                    tervid: tervid
                }
            };
            return $http(ds.req);
        }

        function KoltesegvetesiTervJovahagyas(tervid, szint) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'KoltesegvetesiTervJovahagyas',
                params: {
                    tervid: tervid,
                    szint: szint
                }
            };
            return $http(ds.req);
        }

        function KoltesegvetesiTervExcelExport(tervid) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'KoltesegvetesiTervExcelExport',
                params: {
                    tervid: tervid
                }
            };
            return $http(ds.req);
        }

        function KoltsegtervOsszesitoExcelExport(szakosztalyId, korosztalyId, edzoId, dateFrom, dateTo, onlyStartDate) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'KoltsegtervOsszesitoExcelExport',
                params: {
                    szakosztalyId: szakosztalyId,
                    korosztalyId: korosztalyId,
                    edzoId: edzoId,
                    dateFrom: dateFrom,
                    dateTo: dateTo,
                    onlyStartDate: onlyStartDate,
                }
            };
            return $http(ds.req);
        }

        function AcceptCSVPayment(data) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'AcceptCSVPayment',
                data: data
            };
            return $http(ds.req);
        }

        function SaveAwayBudgetPlan(data) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'SaveAwayBudgetPlan',
                data: data
            };
            return $http(ds.req);
        }

        function ErtesitestLatta(ertesitesid) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'ErtesitestLatta',
                params: {
                    ertesitesid: ertesitesid
                }
            };
            return $http(ds.req);
        }

        function GetAwayBudgetPlan(tervId) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'GetAwayBudgetPlan',
                params: {
                    tervId: tervId
                }
            };
            return $http(ds.req);
        }

        function getParentNotifications(fromDate, toDate, currentListSize, moreNewer, moreOlder, load, size) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'getParentNotifications',
                params: {
                    fromDate: fromDate,
                    toDate: toDate,
                    currentListSize: currentListSize,
                    moreNewer: moreNewer,
                    moreOlder: moreOlder,
                    load: load,
                    size: size
                }
            };
            return $http(ds.req);
        }

        function getParentNotifications2(fromDate, toDate, currentListSize, moreNewer, moreOlder, load, size) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'getParentNotifications2',
                params: {
                    fromDate: fromDate,
                    toDate: toDate,
                    currentListSize: currentListSize,
                    moreNewer: moreNewer,
                    moreOlder: moreOlder,
                    load: load,
                    size: size
                }
            };
            return $http(ds.req);
        }

        function GetPaintList(section) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'GetPaintList',
                params: {
                    section: section
                }
            };
            return $http(ds.req);
        }

        function GetPaints(sectionId, ageGroupId, coachId) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'GetPaints',
                params: {
                    sectionId: sectionId,
                    ageGroupId: ageGroupId,
                    coachId: coachId
                }
            };
            return $http(ds.req);
        }

        function getImageOfUser(userid) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'getImageOfUser',
                params: {
                    userid: userid
                }
            };
            return $http(ds.req);
        }

        function getLog(table, pk, tol, ig) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'getLog',
                params: {
                    table: table,
                    pk: pk,
                    tol: tol,
                    ig: ig
                }
            };
            return $http(ds.req);
        }

        function loadTrainingDiaryByMonthlyAttendanceId(id) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'KepzesiNaploBetoltesIdAlapjan',
                params: {'id': id}
            };
            return $http(ds.req);
        }

        function EsemenyekAttolteseHetiEdzestervre(edzo, korosztaly, hetfo) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'EsemenyekAttolteseHetiEdzestervre',
                params: {
                    edzo: edzo,
                    korosztaly: korosztaly,
                    hetfo: hetfo
                }
            };
            return $http(ds.req);
        }

        function getParentNames() {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'SzuloNevek',
            };
            return $http(ds.req);
        }

        function KedvezmenyNevekMentes(language, k1, k2, k3, k4, k5, ok1, ok2, ok3, ok4, ok5) {
            if (!k1) {
                k1 = '';
            }
            if (!k2) {
                k2 = '';
            }
            if (!k3) {
                k3 = '';
            }
            if (!k4) {
                k4 = '';
            }
            if (!k5) {
                k5 = '';
            }
            if (!ok1) {
                ok1 = '';
            }
            if (!ok2) {
                ok2 = '';
            }
            if (!ok3) {
                ok3 = '';
            }
            if (!ok4) {
                ok4 = '';
            }
            if (!ok5) {
                ok5 = '';
            }
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'KedvezmenyNevekMentes',
                params: {
                    language: language,
                    k1: k1,
                    k2: k2,
                    k3: k3,
                    k4: k4,
                    k5: k5,
                    ok1: ok1,
                    ok2: ok2,
                    ok3: ok3,
                    ok4: ok4,
                    ok5: ok5
                }
            };
            return $http(ds.req);
        }

        function OktatasiKedvezmenyNevek(language) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'OktatasiKedvezmenyNevek',
                params: {
                    language: language
                }
            };
            return $http(ds.req);
        }

        function getReducedSportServiceFeeTypes(language) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'GetReducedSportServiceFeeTypes',
                params: {
                    language: language
                }
            };
            return $http(ds.req);
        }

        function getReducedEducationalFeeTypes(language) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'GetReducedEducationalFeeTypes',
                params: {
                    language: language
                }
            };
            return $http(ds.req);
        }

        function KedvezmenyNevek(language) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'KedvezmenyNevek',
                params: {
                    language: language
                }
            };
            return $http(ds.req);
        }

        function SportoloCsoportokDropDownList() {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'SportoloCsoportokDropDownList',
            };
            return $http(ds.req);
        }

        function SzuloCsoportokDropDownList() {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'SzuloCsoportokDropDownList',
            };
            return $http(ds.req);
        }

        function resultChart3(sportolo, versenyszam, mettol, meddig, szakosztaly, korosztaly) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'ResultChart3',
                params: {
                    sportolo: sportolo,
                    versenyszam: versenyszam,
                    mettol: mettol,
                    meddig: meddig,
                    szakosztaly: szakosztaly,
                    korosztaly: korosztaly
                }
            };
            return $http(ds.req);
        }

        function resultChart2(sportolo, versenyszam, mettol, meddig, szakosztaly, korosztaly) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'ResultChart2',
                params: {
                    sportolo: sportolo,
                    versenyszam: versenyszam,
                    mettol: mettol,
                    meddig: meddig,
                    szakosztaly: szakosztaly,
                    korosztaly: korosztaly
                }
            };
            return $http(ds.req);
        }

        function resultChart1(sportolo, versenyszam, mettol, meddig, szakosztaly, korosztaly) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'ResultChart1',
                params: {
                    sportolo: sportolo,
                    versenyszam: versenyszam,
                    mettol: mettol,
                    meddig: meddig,
                    szakosztaly: szakosztaly,
                    korosztaly: korosztaly
                }
            };
            return $http(ds.req);
        }

        function resultDateChart(sportolo, versenyszam, mettol, meddig, szakosztaly, korosztaly) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'ResultDateChart',
                params: {
                    sportolo: sportolo,
                    versenyszam: versenyszam,
                    mettol: mettol,
                    meddig: meddig,
                    szakosztaly: szakosztaly,
                    korosztaly: korosztaly
                }
            };
            return $http(ds.req);
        }

        function resultChartVersenyszamDropDown(sportolo, szakosztaly, korosztaly) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'ResultChartVersenyszamDropDownList',
                params: {
                    sportolo: sportolo,
                    szakosztaly: szakosztaly,
                    korosztaly: korosztaly
                }
            };
            return $http(ds.req);
        }

        function resultChartAgeGroupDropDown(sportolo, szakosztaly, versenyszam) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'ResultChartAgeGroupDropDownList',
                params: {
                    sportolo: sportolo,
                    szakosztaly: szakosztaly,
                    versenyszam: versenyszam
                }
            };
            return $http(ds.req);
        }

        function resultChartSectionDropDown(sportolo, korosztaly, versenyszam) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'ResultChartSectionDropDownList',
                params: {
                    sportolo: sportolo,
                    korosztaly: korosztaly,
                    versenyszam: versenyszam
                }
            };
            return $http(ds.req);
        }

        function getAthletesBodyStat(sportoloid) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'SportoloTestmeretStatisztika',
                params: {sportoloid: sportoloid}
            };
            return $http(ds.req);
        }

        function getUserId() {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'getUserId',
            };
            return $http(ds.req);
        }

        function UsersUserGroup(userid) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'FelhasznaloCsoportTagja',
                params: {userid: userid}
            };
            return $http(ds.req);
        }

        function getParentAndAthleteUsers(section, agegroup) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'SportolokhozKapcsolodoFelhasznalokOsszes',
                params: {
                    section: section,
                    agegroup: agegroup
                }
            };
            return $http(ds.req);
        }

        function unlinkUserFromAthlete(userid, sportoloid) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'UnlinkUserFromAthlete',
                params: {
                    userid: userid,
                    sportoloid: sportoloid
                }
            };
            return $http(ds.req);
        }

        function athleteAndParentDropDownList(role) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'SzuloEsSportoloUserDropDownList',
                params: {role: role}
            };
            return $http(ds.req);
        }

        function getUsersBelongingToAthlete(sportoloid) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'SportolohozKapcsolodoFelhasznalok',
                params: {sportoloid: sportoloid}
            };
            return $http(ds.req);
        }

        function getAthletesOfUser() {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'getAthletesOfUser'
            };
            return $http(ds.req);
        }

        function getAthleteidBelongsToAthleteUser() {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'getAthleteidBelongsToAthleteUser'
            };
            return $http(ds.req);
        }

        function assignAthleteToParentUser(parentuserid, sportoloid) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'AssignAthleteToParentUser',
                params: {
                    parentuserid: parentuserid,
                    sportoloid: sportoloid
                }
            };
            return $http(ds.req);
        }

        function createLoginForParent(parentUserName, parentPassword, parent, athleteId, group) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'CreateLoginForParent',
                params: {
                    parentUserName: parentUserName,
                    parentPassword: parentPassword,
                    parent: parent,
                    athleteId: athleteId,
                    group: group
                }
            };
            return $http(ds.req);
        }

        function createLoginForAthlete(athleteUserName, athletePassword, athleteId, group) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'CreateLoginForAthlete',
                params: {
                    athleteUserName: athleteUserName,
                    athletePassword: athletePassword,
                    athleteId: athleteId,
                    group: group
                }
            };
            return $http(ds.req);
        }

        function FelmeroTipusMasolas(fefid, targetsection, name) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'FelmeroTipusMasolas',
                params: {
                    fefid: fefid,
                    targetsection: targetsection,
                    name: name
                }
            };
            return $http(ds.req);
        }

        function FelmeroMentes(arr, ffid, fefid, section, agegroup, coach, edzoertekeles, date) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'FelmeroMentes',
                data: {
                    'data': arr,
                    'ffid': ffid,
                    'fefid': fefid,
                    'section': section,
                    'agegroup': agegroup,
                    'coach': coach,
                    'edzoertekeles': edzoertekeles,
                    'date': date
                }
            };
            return $http(ds.req);
        }

        function FelmeroLetrehozasa(coach, agegroup, fefid, date) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'FelmeroLetrehozasa',
                params: {
                    coach: coach,
                    agegroup: agegroup,
                    fefid: fefid,
                    date: date
                }
            };
            return $http(ds.req);
        }

        function getSportagSpecReport(fefid, agegroup, section, fromdate, todate) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'SportagSpecReport',
                params: {
                    fefid: fefid,
                    agegroup: agegroup,
                    section: section,
                    fromdate: fromdate,
                    todate: todate
                }
            };
            return $http(ds.req);
        }

        function getFelmeroById(FFID) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'FelmeroBetoltese',
                params: {
                    FFID: FFID
                }
            };
            return $http(ds.req);
        }

        function deleteFelmeroElemFej(fefid) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'FelmeroElemFejTorles',
                params: {
                    fefid: fefid
                }
            };
            return $http(ds.req);
        }

        function deleteFelmero(ffid) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'FelmeroTorles',
                params: {
                    ffid: ffid
                }
            };
            return $http(ds.req);
        }

        function saveFelmeroElemFej(data) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'FelmeroElemFejLetrehozasa',
                data: data
            };
            return $http(ds.req);
        }

        function getFelmeroElemFejList(section) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'FelmeroElemFejLista',
                params: {
                    section: section
                }
            };
            return $http(ds.req);
        }

        function saveFelmeroElem(data) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'FelmeroElemLetrehozasa',
                data: data
            };
            return $http(ds.req);
        }

        function getFelmeroElemList(fefid) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'FelmeroElemLista',
                params: {
                    fefid: fefid
                }
            };
            return $http(ds.req);
        }

        function getAbsenceReport(section, agegroup, coach, tol, ig) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'Hianyzasok',
                params: {
                    section: section,
                    agegroup: agegroup,
                    coach: coach,
                    tol: tol,
                    ig: ig
                }
            };
            return $http(ds.req);
        }

        function getExpiringDocuments(section, agegroup, coach, to, spc, pp, pid) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'LejaroDokumentumok',
                params: {
                    section: section,
                    agegroup: agegroup,
                    coach: coach,
                    to: to,
                    spc: spc,
                    pp: pp,
                    pid: pid,
                    sportoloid: 0
                }
            };
            return $http(ds.req);
        }

        function userGroupList() {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'FelhasznaloCsoportokDropDown',
            };
            return $http(ds.req);
        }

        function deleteUserGroup(userGroupId) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'FelhasznaloCsoportTorlese',
                params: {
                    userGroupId: userGroupId
                }
            };
            return $http(ds.req);
        }

        function centralReportOfAthlete(sportoloID) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'SportoloKozpontiFelmeroiKimutatas',
                params: {
                    sportoloID: sportoloID
                }
            };
            return $http(ds.req);
        }

        function centralReportByRating(section, agegroup, coach, gender, date) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'KozpontiFelmerokRanglistaKimutatas',
                params: {
                    section: section,
                    agegroup: agegroup,
                    coach: coach,
                    gender: gender,
                    date: date
                }
            };
            return $http(ds.req);
        }

        function monthlyPlanSelectByDate(dateyear, datemonth, szakosztalyId, edzoId, newplan, egyeni) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'VersenyTervHaviByDate',
                params: {
                    dateyear: dateyear,
                    datemonth: datemonth,
                    szakosztalyId: szakosztalyId,
                    edzoId: edzoId,
                    newplan: newplan, // Ha uj tervet akarok létrehozni akkor nem dob hibaüzenetet ha az adott hónapra nincs még versenyterv
                    egyeni: egyeni
                }
            };
            return $http(ds.req);
        }

        function ujHaviVersenyeztetesiTerv(date, szakosztalyId, edzoId, egyeni) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'UjHaviVersenyeztetesiTerv',
                params: {
                    date: date,
                    szakosztalyId: szakosztalyId,
                    edzoId: edzoId,
                    egyeni: egyeni
                }
            };
            return $http(ds.req);
        }

        function activeAthletesByBirthYear(sectionId, year, gender) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'AktivSportolokSzuletesievEsSzakosztalySzerint',
                params: {
                    'sectionId': sectionId,
                    'year': year,
                    'gender': gender
                }
            };
            return $http(ds.req);
        }

        function getAthleteMoveStory(SportoloId) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'SportoloMozgasa',
                params: {
                    'SportoloId': SportoloId
                }
            };
            return $http(ds.req);
        }

        function VersenyTervHaviDeleteById(id, SzakosztalyId, egyeni) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'VersenyTervHaviDeleteById',
                params: {
                    'id': id,
                    'SzakosztalyId': SzakosztalyId,
                    'egyeni': egyeni
                }
            };
            return $http(ds.req);
        }

        function activeAthletesByCoach(coachId, sectionId, dateFrom, gender) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'EdzoAktivakSzama_Sportolok',
                params: {
                    'edzoId': coachId,
                    'szakosztalyId': sectionId,
                    'datumTol': dateFrom,
                    'neme': gender
                }
            };
            return $http(ds.req);
        }

        function joinedAthletesToASpecificCoach(edzoId, datumTol, datumIg, gender) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'EdzoBelepokSzama_Sportolok',
                params: {
                    'edzoId': edzoId,
                    'datumTol': datumTol,
                    'datumIg': datumIg,
                    'neme': gender
                }
            };
            return $http(ds.req);
        }

        function leavingAthletesFromASpecificCoach(edzoId, datumTol, datumIg, gender) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'EdzoKilepokSzama_Sportolok',
                params: {
                    'edzoId': edzoId,
                    'datumTol': datumTol,
                    'datumIg': datumIg,
                    'neme': gender
                }
            };
            return $http(ds.req);
        }

        function JoinedAthletesInASpecificMonth(honap) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'SportolokSzamanakAlakulasa_BelepettSportolok',
                params: {
                    'honap': honap
                }
            };
            return $http(ds.req);
        }

        function LeavingAthletesInASpecificMonth(honap) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'SportolokSzamanakAlakulasa_KilepettSportolok',
                params: {
                    'honap': honap
                }
            };
            return $http(ds.req);
        }

        function ActiveAthletesInASpecificMonth(honap, datumig, szakosztalyId, neme) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'SportolokSzamanakAlakulasaSzakosztalyonkent_sportolok',
                params: {
                    'honap': honap,
                    'datumig': datumig,
                    'szakosztalyId': szakosztalyId,
                    'gender': neme
                }
            };
            return $http(ds.req);
        }

        function athletesNotPresentOnMonthlyAttendance(datumTol, datumIg, sectionId) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'HaviJelenletinNemSzereploSportolok',
                params: {
                    'szakosztalyId': sectionId,
                    'tol': datumTol,
                    'ig': datumIg
                }
            };
            return $http(ds.req);
        }

        function activeAthletesInSectionByMonth(datumTol, datumIg, SzakosztalyNeve, sectionId) {
            if (!sectionId) {
                sectionId = -1;
            }
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'SportolokSzamanakAlakulasaSzakosztalyonkent',
                params: {
                    'datumTol': datumTol,
                    'datumIg': datumIg,
                    'sectionId': sectionId
                }
            };
            return $http(ds.req);
        }

        function activeAthletesByMonth(datumTol, datumIg) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'SportolokSzamanakAlakulasa',
                params: {
                    'datumTol': datumTol,
                    'datumIg': datumIg
                }
            };
            return $http(ds.req);
        }

        function activeAthletesBornAtSpecificYear(year, sectionId) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'SportolokEvszamSzerint',
                params: {
                    'ev': year,
                    'szakosztalyId': sectionId
                }
            };
            return $http(ds.req);
        }

        function activeAthletesByAge(date, sectionId) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'SportolokSzuletesiIdoAlapjan',
                params: {
                    'datum': date,
                    'szakosztaly': sectionId
                }
            };
            return $http(ds.req);
        }

        function joinedAthletesByCoach(dateFrom, dateTo) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'BelepoSportolokSzamaEdzonkent',
                params: {
                    'dateFrom': dateFrom,
                    'dateTo': dateTo
                }
            };
            return $http(ds.req);
        }

        function leavingAthletesByCoach(dateFrom, dateTo) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'KilepoSportolokSzamaEdzonkent',
                params: {
                    'dateFrom': dateFrom,
                    'dateTo': dateTo
                }
            };
            return $http(ds.req);
        }

        function athletesByCoach(date) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'SportolokSzamaEdzonkent',
                params: {
                    'datum': date
                }
            };
            return $http(ds.req);
        }

        function listAthletes(dateFrom, dateTo, state, sectionId, gender) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'SportolokListaSzakosztalyonkent',
                params: {
                    'dateFrom': dateFrom,
                    'dateTo': dateTo,
                    'state': state,
                    'sectionId': sectionId,
                    'gender': gender
                }
            };
            return $http(ds.req);
        }

        function leavingAthletesBySection(queryDateFrom, queryDateTo) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'SzakosztalyKilepokSzama',
                params: {
                    'datum': queryDateFrom,
                    'datum2': queryDateTo,
                }
            };
            return $http(ds.req);
        }

        function joinedAthletesBySection(queryDateFrom, queryDateTo) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'SzakosztalyBelepokSzama',
                params: {
                    'datum': queryDateFrom,
                    'datum2': queryDateTo,
                }
            };
            return $http(ds.req);
        }

        function range(start, stop, step) {
            if (stop == null) {
                stop = start || 0;
                start = 0;
            }
            step = step || 1;

            if (start <= stop) {
                var length = Math.max(Math.ceil((stop - start) / step), 0);
                var range = Array(length);

                for (var idx = 0; idx <= length; idx++, start += step) {
                    range[idx] = start;
                }
            } else {
                var length = Math.max(Math.ceil((start - stop) / step), 0);
                var range = Array(length);

                for (var idx = 0; idx <= length; idx++, start -= step) {
                    range[idx] = start;
                }
            }

            return range;
        }

        function getURL() {
            return DOMAIN.baseURL + DOMAIN.webService;
        }

        function changePassword(oldPwd, newPwd) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'ChangePassword',
                data: {
                    'oldPassword': oldPwd,
                    'newPassword': newPwd
                }
            };
            return $http(ds.req);
        }

        function login(loginName, password, language) {
            ds.req = {
                type: 'apiTOKEN',
                url: DOMAIN.baseURL + 'Token',
                data: $.param({
                    grant_type: 'password',
                    username: loginName,
                    password: password,
                    language: language,
                })
            };
            return $http(ds.req);
        }

        function logout() {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'Logout'
            };
            return $http(ds.req);
        }

        function getHaveToPay() {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'HaveToPay'
            };
            return $http(ds.req);
        }

        function getAvailableLanguages() {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'AvailableLanguages'
            };
            return $http(ds.req);
        }

        function getTestYears() {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'FelmerokKozpontiEveiSelect'
            };
            return $http(ds.req);
        }

        function sectionDropDownList(edzoId, osszesSzakosztaly) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'SzakosztalyokDropDownList',
                params: {edzoId: edzoId, osszesSzakosztaly: osszesSzakosztaly}
            };
            return $http(ds.req);
        }

        function sectionDropDownListWithGroupStatus(edzoId, osszesSzakosztaly) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'SzakosztalyokDropDownListWithGroupStatus',
                params: {edzoId: edzoId, osszesSzakosztaly: osszesSzakosztaly}
            };
            return $http(ds.req);
        }

        function sectionDropDownListAll() {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'SzakosztalyokDropDownListAll'
            };
            return $http(ds.req);
        }

        function sectionDropDownListWithFees(edzoId) {
            if (!edzoId) {
                edzoId = 0;
            }
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'SzakosztalyokDijDropDownLista',
                params: {edzoId: edzoId}
            };
            return $http(ds.req);
        }

        function getDuplicatedAthletes(inactivesToo) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'DuplikaltFelhasznalokSelect',
                params: {inactivesToo: inactivesToo}
            };
            return $http(ds.req);
        }

        function getAthletesFromFeeRegister(sectionId, coachId, year, months) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'GetAthletesForFeeRegister',
                params: {sectionId: sectionId, year: year, coachId: coachId, months: months}
            };
            return $http(ds.req);
        }

        function getAthletesForEducationalFeeRegister(sectionId, coachId, year, months) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'GetAthletesForEducationalFeeRegister',
                params: {sectionId: sectionId, year: year, coachId: coachId, months: months}
            };
            return $http(ds.req);
        }

        function ageGroupDropDownList(szakosztalyId) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'KorosztalyokDropDownList',
                params: {'szakosztalyId': szakosztalyId}
            };
            return $http(ds.req);
        }

        function getIdegenbeliKoltsegvetesiTervEdzoList(szakosztalyId, korosztalyId) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'GetIdegenbeliKoltsegvetesiTervEdzoList',
                params: {szakosztalyId: szakosztalyId, korosztalyId: korosztalyId}
            };
            return $http(ds.req);
        }

        function getAwayBudgetPlanList(szakosztalyId, korosztalyId, edzoId, dateFrom, dateTo, onlyStartDate, type, versenyHely) {
            if (!onlyStartDate) {
                onlyStartDate = false;
            }
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'IdegenbeliKoltsegvetesiTervLista',
                params: {
                    szakosztalyId: szakosztalyId,
                    korosztalyId: korosztalyId,
                    edzoId: edzoId,
                    dateFrom: dateFrom,
                    dateTo: dateTo,
                    onlyStartDate: onlyStartDate,
                    type: type,
                    versenyHely: versenyHely
                }
            };
            return $http(ds.req);
        }

        function ageGroupDropDownListForSearch(sectionId) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'KorosztalyokDropDownListForSearch',
                params: {'sectionId': sectionId}
            };
            return $http(ds.req);
        }

        function HealthReport(dateFrom, dateTo, szakosztalyId, korcsoportId, edzoId, fotipus, altipus) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'HealthReport',
                params: {
                    'fotipus': fotipus,
                    'altipus': altipus,
                    'dateFrom': dateFrom,
                    'dateTo': dateTo,
                    'szakosztalyId': szakosztalyId,
                    'korcsoportId': korcsoportId,
                    'edzoId': edzoId
                }
            };
            return $http(ds.req);
        }

        function getUpAndDownPlayers(szakosztalyId, korcsoportId, edzoId) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'AtjatszoSportolokSelect',
                params: {'szakosztalyId': szakosztalyId, 'korcsoportId': korcsoportId, 'edzoId': edzoId}
            };
            return $http(ds.req);
        }

        function getMonthlyCompetitivePlans(tol, ig, szakosztalyId, edzoId) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'HaviVersenyeztetesiTervLeadasokSelect',
                params: {'szakosztalyId': szakosztalyId, 'tol': tol, 'edzoId': edzoId, 'ig': ig}
            };
            return $http(ds.req);
        }

        function getMonthlyAttendanceReports(tol, ig, szakosztalyId, edzoId) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'VezetoiHaviJelenletikSelect',
                params: {'szakosztalyId': szakosztalyId, 'tol': tol, 'edzoId': edzoId, 'ig': ig}
            };
            return $http(ds.req);
        }

        function getTrainingDiaryReports(tol, ig, szakosztalyId, edzoId, korosztalyId) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'HaviKepzesiNaplokSelect',
                params: {
                    'tol': tol,
                    'ig': ig,
                    'szakosztalyId': szakosztalyId,
                    'edzoId': edzoId,
                    'korosztalyId': korosztalyId
                }
            };
            return $http(ds.req);
        }

        function getAnnualCompetitiveReports(tol, ig, szakosztalyId, edzoId) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'VezetoiEvesVersenyeztetesiTervekSelect',
                params: {'szakosztalyId': szakosztalyId, 'tol': tol, 'edzoId': edzoId, 'ig': ig}
            };
            return $http(ds.req);
        }

        function getMonthlyCompetitiveReports(tol, ig, szakosztalyId, edzoId) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'VezetoiHaviVersenyeztetesiTervekSelect',
                params: {'szakosztalyId': szakosztalyId, 'tol': tol, 'edzoId': edzoId, 'ig': ig}
            };
            return $http(ds.req);
        }

        function getWeeklyTrainingPlans(tol, ig, szakosztalyId, edzoId) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'VezetoiHetiEdzestervekSelect',
                params: {'szakosztalyId': szakosztalyId, 'tol': tol, 'edzoId': edzoId, 'ig': ig}
            };
            return $http(ds.req);
        }

        function getTrainingAttendances(tol, ig, edzoId) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'EdzeslatogatasListaSelect',
                params: {'tol': tol, 'edzoId': edzoId, 'ig': ig}
            };
            return $http(ds.req);
        }

        function getUserGroupTypes() {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'GetUserGroupTypes'
            };
            return $http(ds.req);
        }

        function teamsDropDownList(sectionId, ageGroupId, coachId) {
            if (sectionId === undefined) {
                sectionId = 0;
            }
            if (ageGroupId === undefined) {
                ageGroupId = 0;
            }
            if (coachId === undefined) {
                coachId = 0;
            }
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'TeamsDropDownList',
                params: {
                    'sectionId': sectionId,
                    'ageGroupId': ageGroupId,
                    'coachId': coachId
                }
            };
            return $http(ds.req);
        }

        function deleteTeamImg(csapatId) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'DeleteTeamImg',
                params: {'csapatId': csapatId}
            };
            return $http(ds.req);
        }

        function ageGroupList(szakosztalyId) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'KorosztalyokList',
                params: {'szakosztalyId': szakosztalyId}
            };
            return $http(ds.req);
        }

        function getAgeGroupMembersList(szakosztaly, korcsoport) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'KorosztalySportoloi',
                params: {
                    'szakosztaly': szakosztaly,
                    'korcsoport': korcsoport
                }
            };
            return $http(ds.req);
        }

        function getServiceFeePaymentsNumbers(szakosztalyId, datum) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'NapiTagdijfizetesekSorszamok',
                params: {
                    'szakosztalyId': szakosztalyId,
                    'datum': datum
                }
            };
            return $http(ds.req);
        }

        function getEducationalFeePaymentsNumbers(szakosztalyId, datum) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'NapiOktatasiDijFizetesekSorszamok',
                params: {
                    'szakosztalyId': szakosztalyId,
                    'datum': datum
                }
            };
            return $http(ds.req);
        }

        function getTestAthletesList(date, athleteId) {
            if (athleteId === undefined) {
                athleteId = 0;
            }
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'SportolokSelectKozpontiFelmero',
                params: {
                    'sportoloId': athleteId,
                    'datum': date
                }
            };
            return $http(ds.req);
        }

        function canNewTestAthletesList(date) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'SportolokSelectKozpontiFelmeroVanEKetto',
                params: {
                    'datum': date
                }
            };
            return $http(ds.req);
        }

        function getCheck(checkNumber) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'CsekkBefizetesBetolt',
                params: {'azonosito': checkNumber}
            };
            return $http(ds.req);
        }

        function getCheckExportPrintList(sectionId, coachId, dateFromValue, dateToValue) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'CsekkNyomtatasLista',
                params: {
                    'SzakosztalyId': sectionId,
                    'EdzoId': coachId,
                    'datumTol': dateFromValue,
                    'datumIg': dateToValue
                }
            };
            return $http(ds.req);
        }

        function getAgeGroup(korcsoport) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'KorosztalyLekerese',
                params: {'id': korcsoport}
            };
            return $http(ds.req);
        }

        function coachDropDownList(szakosztalyId, korosztalyId, datumtol, datumig) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'EdzoDropDownList',
                params: {
                    'szakosztalyId': szakosztalyId,
                    'korcsoportId': korosztalyId,
                    datumtol: datumtol,
                    datumig: datumig
                }
            };
            return $http(ds.req);
        }

        function getAnthropometryListForPrinting(from, to) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'TomegesAntropometriaNyomtatas',
                params: {
                    'from': from,
                    'to': to
                }
            };
            return $http(ds.req);
        }

        function teamList(szakosztalyId, korosztalyId, inactive) {
            if (angular.isUndefined(korosztalyId) || korosztalyId === '') {
                korosztalyId = 0;
            }
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'CsapatList',
                params: {'szakosztalyId': szakosztalyId, 'korosztalyId': korosztalyId, 'inactive': inactive}
            };
            return $http(ds.req);
        }

        function getUserGroupList() {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'FelhasznaloCsoportokSelect'
            };
            return $http(ds.req);
        }

        function saveTeam(formData) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'SaveTeam',
                data: formData
            };
            return $http(ds.req);
        }

        function getIdegenbeliKoltsegvetesiTervSportoloList(szakosztalyId, AgeGroups) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'GetIdegenbeliKoltsegvetesiTervSportoloList',
                data: {szakosztalyId: szakosztalyId, AgeGroups: AgeGroups}
            };
            return $http(ds.req);
        }

        function saveExercise(formData) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'SaveExercise',
                data: formData
            };
            return $http(ds.req);
        }

        function saveAgeGroup(formData) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'KorcsoportMentes',
                data: formData
            };
            return $http(ds.req);
        }

        function saveAnthropometry(ant, fileData, fileName) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'AntropometriaMentes',
                data: {
                    ant: ant,
                    fileData: fileData,
                    fileName: fileName
                }
            };
            return $http(ds.req);
        }

        function savePerformanceMotivationSurvey(athleteId, answers) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'SavePerformanceMotivationSurvey',
                data: {
                    answers: answers,
                    sportoloId: athleteId
                }
            };
            return $http(ds.req);
        }

        function savePieronTest(sportoloId, answers, seen, tNumber, wrongAnswersNumber) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'SavePieronTest',
                data: {
                    sportoloId: sportoloId,
                    answers: answers,
                    n: seen,
                    tNumber: tNumber,
                    wrongAnswersNumber: wrongAnswersNumber
                }
            };
            return $http(ds.req);
        }

        function savePerformanceMotivationSurveyEval(surveyId, szoveg) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'SavePerformanceMotivationSurveyEval',
                data: {
                    surveyId: surveyId,
                    szoveg: szoveg
                }
            };
            return $http(ds.req);
        }

        function getPerformanceMotivationSurvey(surveyId, noText) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'GetPerformanceMotivationSurvey',
                params: {surveyId: surveyId, noText: noText}
            };
            return $http(ds.req);
        }

        function getPieronTest(surveyId, noText) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'GetPieronTest',
                params: {surveyId: surveyId, noText: noText}
            };
            return $http(ds.req);
        }

        function getAthletesForDailyPayments(szakosztalyId, edzoId, datum, sorszam) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'NapiTagdijFizetok',
                params: {datum: datum, szakosztalyId: szakosztalyId, edzoId: edzoId, sorszam: sorszam}
            };
            return $http(ds.req);
        }

        function getAthletesForDailyPayments2(szakosztalyId, edzoId, datum, sorszam) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'NapiOktatasiDijFizetok',
                params: {szakosztalyId: szakosztalyId, datum: datum, edzoId: edzoId, sorszam: sorszam}
            };
            return $http(ds.req);
        }

        function modifyAgeGroup(formData) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'KorcsoportModositasa',
                data: formData
            };
            return $http(ds.req);
        }

        function addUser(formData) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'FelhasznaloMentes',
                data: formData
            };
            return $http(ds.req);
        }

        function searchAthlete(formData) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'SportoloKereses/Kereses',
                data: formData
            };
            return $http(ds.req);
        }

        function searchUser(formData) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'FelhasznaloKereses',
                data: formData
            };
            return $http(ds.req);
        }

        function searchMemberList(formData) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'TaglistaKereses',
                data: formData
            };
            return $http(ds.req);
        }

        function modifyUser(formData) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'FelhasznaloModositas',
                data: formData
            };
            return $http(ds.req);
        }

        function modifyUserMin(formData) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'FelhasznaloModositasMin',
                data: formData
            };
            return $http(ds.req);
        }

        function getAgeGroupTreeView() {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'SzakosztalyokKorosztalyokTreeViewLekeres'
            };
            return $http(ds.req);
        }

        function getSystemSettings(valtozo) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'GetSystemSettings',
                params: {valtozo: valtozo}
            };
            return $http(ds.req);
        }

        function getSystemSettingsValue(valtozo) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'GetSystemSettingsValue',
                params: {valtozo: valtozo}
            };
            return $http(ds.req);
        }

        function SzakosztalyRuhai(section, section2) {
            if (!section2) {
                section2 = 0;
            }
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'SzakosztalyRuhai',
                params: {section: section, section2: section2}
            };
            return $http(ds.req);
        }

        function saveSystemSettings(valtozo, ertek) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'SaveSystemSettings',
                data: {valtozo: valtozo, ertek: ertek}
            };
            return $http(ds.req);
        }

        function saveSystemSettingsValue(valtozo, ertek) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'SaveSystemSettingsValue',
                data: {valtozo: valtozo, ertek: ertek}
            };
            return $http(ds.req);
        }

        function getSectionLeaderListBox() {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'SzakosztalyokVezetovelLekeres'
            };
            return $http(ds.req);
        }

        function copyAllAgeGroup(forrasSzakosztalyId, celSzakosztalyId) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'KorcsoportMasolas',
                params: {'forrasSzakosztalyId': forrasSzakosztalyId, 'celSzakosztalyId': celSzakosztalyId}
            };
            return $http(ds.req);
        }

        function getAnnualSportServiceFeeBySection(year) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'TagdijBySzakosztalySelect',
                params: {'year': year}
            };
            return $http(ds.req);
        }

        function getAnnualEducationalFeeBySection(year) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'OktatasiDijBySzakosztalySelect',
                params: {'year': year}
            };
            return $http(ds.req);
        }

        function getAnnualSportServiceFeeByOneSection(szakosztalyId) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'TagdijByEgySzakosztaly',
                params: {'szakosztaly': szakosztalyId}
            };
            return $http(ds.req);
        }

        function getAnnualEducationalFeeByOneSection(szakosztalyId) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'OktatasiDijByEgySzakosztaly',
                params: {'szakosztaly': szakosztalyId}
            };
            return $http(ds.req);
        }

        function getAnnualSportServiceFeeByCoach(year) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'TagdijByEdzoSelect',
                params: {'year': year}
            };
            return $http(ds.req);
        }

        function getAnnualEducationalFeeByCoach(year) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'OktatasiDijByEdzoSelect',
                params: {'year': year}
            };
            return $http(ds.req);
        }

        function getAnnualSportServiceFeeByAthletes(year) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'TagdijBySportoloSelect',
                params: {'year': year}
            };
            return $http(ds.req);
        }

        function getAnnualEducationalFeeByAthletes(year) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'OktatasiDijBySportoloSelect',
                params: {'year': year}
            };
            return $http(ds.req);
        }

        function modifyTeam(formData) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'ModifyTeam',
                data: formData
            };
            return $http(ds.req);
        }

        function getUserGroupDropDownList() {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'FelhasznaloCsoportokDropDownList'
            };
            return $http(ds.req);
        }

        function getFullUserGroupList(group) {
            if (!group) {
                group = 'all';
            }
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'FelhasznaloCsoportokList',
                params: {'group': group}
            };
            return $http(ds.req);
        }

        function getTeamMembersList(teamId, date) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'CsapatSportoloi',
                params: {csapatId: teamId, date: date}
            };
            return $http(ds.req);
        }

        function getPossibleTeamMembersList(teamId, szakosztalyId, korosztalyId) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'csapatLehetsegesSportoloi',
                params: {csapatId: teamId, korcsoportId: korosztalyId, szakosztalyId: szakosztalyId}
            };
            return $http(ds.req);
        }

        function addTeamMemberToTeam(sportoloId, csapatId) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'CsapatSportoloOsszerendeles',
                data: {
                    CsapatId: csapatId,
                    SportoloId: sportoloId
                }
            };
            return $http(ds.req);
        }

        function deleteTeamMember(teamId, sportoloIds) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'CsapatSportoloTorles',
                data: {
                    CsapatId: teamId,
                    SportoloIdk: sportoloIds
                }
            };
            return $http(ds.req);
        }

        function deleteTeam(teamId) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'CsoportTorlese',
                params: {Id: teamId}
            };
            return $http(ds.req);
        }

        function deleteTeamsPlayers(teamId) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'CsapatOsszesSportoloTorles',
                params: {csapatId: teamId}
            };
            return $http(ds.req);
        }

        function getTest(datum) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'FelmerokKozpontiSelect',
                params: {datum: datum}
            };
            return $http(ds.req);
        }

        function modifyTest(tabla) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'FelmerokKozpontiModositas',
                data: {
                    tabla: tabla
                }
            };
            return $http(ds.req);
        }

        function saveTest(tabla, date) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'FelmerokKozpontiMentes',
                data: {
                    tabla: tabla,
                    date: date
                }
            };
            return $http(ds.req);
        }

        function getTeam(teamId) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'CsapatLekerese',
                params: {csapatId: teamId}
            };
            return $http(ds.req);
        }

        function usersListSelect() {
            ds.req = {
                type: 'apiGET',
                withCredentials: true,
                url: DOMAIN.baseURL + DOMAIN.webService + 'felhasznalokListaSelect',
                data: {}
            };
            return $http(ds.req);
        }

        function addUserGroup(csoport) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'FelhasznaloCsoportHozzaadas',
                data: csoport
            };
            return $http(ds.req);
        }

        function editUserGroup(csoport) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'FelhasznaloCsoportModositas',
                data: csoport
            };
            return $http(ds.req);
        }

        function selectSchools() {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'IskolakSelect'
            };
            return $http(ds.req);
        }

        function getAthletes(szakosztalyId, edzoId, sportoloId) {
            if (sportoloId === null || sportoloId === undefined) {
                sportoloId = 0;
            }
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'getAthletes',
                params: {szakosztalyId: szakosztalyId, edzoId: edzoId, sportoloId: sportoloId}
            };
            return $http(ds.req);
        }

        function getAthletesEV(szakosztalyId, edzoId, sportoloId, csakAktiv) {
            if (sportoloId === null || sportoloId === undefined) {
                sportoloId = 0;
            }
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'getAthletes',
                params: {szakosztalyId: szakosztalyId, edzoId: edzoId, sportoloId: sportoloId, csakAktiv: csakAktiv}
            };
            return $http(ds.req);
        }

        function athletesSelect(szakosztalyId, korcsoportId, onlyInactives) {
            if (!szakosztalyId) {
                szakosztalyId = 0;
            }
            if (!korcsoportId || korcsoportId == 'Összes') {
                korcsoportId = 0;
            }
            onlyInactives = (onlyInactives === true);
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'szakosztalySportoloi2',
                dataFilter: function (data) {
                    return data.replace(/"\\\/(Date\([0-9-]+\))\\\/"/gi, 'new $1');
                },
                params: {'szakosztaly': szakosztalyId, 'inactive': onlyInactives, 'korcsoport': korcsoportId}
            };
            return $http(ds.req);
        }

        function athletesSelect2(szakosztalyId, korcsoportId) {
            if (!korcsoportId || korcsoportId == 'Összes') {
                korcsoportId = 0;
            }
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'GyorsEredmenyjelentoSportoloSelect',
                params: {'szakosztaly': szakosztalyId, 'korcsoport': korcsoportId}
            };
            return $http(ds.req);
        }

        function addSchool(school) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'IskolaHozzaadas',
                data: school
            };
            return $http(ds.req);
        }

        function editSchool(newSchool) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'IskolaModositas',
                data: newSchool
            };
            return $http(ds.req);
        }

        function transferAthletes(sportolok, edzoId, szakosztalyId, korosztalyId, datum, korcsoportValtasKell) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'TransferAthletes',
                data: {
                    sportolok: sportolok,
                    edzoId: edzoId,
                    szakosztalyId: szakosztalyId,
                    korosztalyId: korosztalyId,
                    datum: datum,
                    korcsoportValtasKell: korcsoportValtasKell
                }
            };
            return $http(ds.req);
        }

        function quickCompetitionResult(sportolok) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'GyorsEredmenyjelentoSportoloMentes',
                data: {
                    sportolok: sportolok
                }
            };
            return $http(ds.req);
        }

        function deleteSchool(id) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'IskolaTorles',
                params: {id: id}
            };
            return $http(ds.req);
        }

        function getUserData(id) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'FelhasznaloSelect',
                params: {userId: id}
            };
            return $http(ds.req);
        }

        function getUserDataMin(id) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'FelhasznaloSelectMin',
                params: {userId: id}
            };
            return $http(ds.req);
        }

        function getAthleteForAnthropometry(id, felmeres) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'getAthleteForAnthropometry',
                params: {id: id, felmeres: felmeres}
            };
            return $http(ds.req);
        }

        function getOldCompetitivePlanByUserId(edzoId, vtId) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'EdzoKorabbiHaviVersTervei',
                params: {
                    'edzoId': edzoId,
                    'vtId': vtId
                }
            };
            return $http(ds.req);
        }

        function getOldAnthropometryTest(sportoloId) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'RegiAntropometriaFelmeresekSelect',
                params: {sportoloId: sportoloId}
            };
            return $http(ds.req);
        }

        function coachSelect() {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'EdzoFelhasznalokDropDownSelect',
                data: {}
            };
            return $http(ds.req);
        }

        function ageGroupSelect(edzoId, szakosztalyId, datum) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'KorcsoportokEdzoSzakosztalyDropDownSelect',
                params: {'szakId': szakosztalyId, 'edzoId': edzoId, 'dt': datum}
            };
            return $http(ds.req);
        }

        function ageGroupSelectYear(edzoId, szakosztalyId, year) {
            if (!szakosztalyId) {
                szakosztalyId = 0;
            }
            if (!edzoId) {
                edzoId = 0;
            }
            if (!year) {
                year = moment().year;
            }
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'KorcsoportokEdzoSzakosztalyDropDownSelectYear',
                params: {'szakId': szakosztalyId, 'edzoId': edzoId, 'year': year}
            };
            return $http(ds.req);
        }

        function ageGroupSelectBetweenDates(edzoId, szakosztalyId, from, to) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'KorcsoportokEdzoSzakosztalyDropDownSelectBetweenDates',
                params: {'szakId': szakosztalyId, 'edzoId': edzoId, 'from': from, 'to': to}
            };
            return $http(ds.req);
        }

        function getAthleteFees(sportoloId) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'GetAthleteFees',
                params: {'sportoloId': sportoloId}
            };
            return $http(ds.req);
        }

        function getAthletesForFeeArrears(szakosztalyId, edzoId, ev) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'GetAthletesForFeeArrears',
                params: {'year': ev, 'sectionId': szakosztalyId, 'coachId': edzoId}
            };
            return $http(ds.req);
        }

        function monthlyAttendanceSelect(edzoId, szakosztalyId, korosztalyId, ev, honap) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'HaviJelenletiLekeres',
                params: {
                    'kivEdzo': edzoId,
                    'kivSzakosztaly': szakosztalyId,
                    'kivKorcsoport': korosztalyId,
                    'kivEv': ev,
                    'kivHonap': honap
                }

            };
            return $http(ds.req);
        }

        function getGymTeachers(IskolaNeve) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'TestneveloAutoComple',
                params: {'IskolaNeve': IskolaNeve}
            };
            return $http(ds.req);
        }

        function getGymTeacherContact(testnevelo) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'TestneveloElerhetosege',
                params: {'testnevelo': testnevelo}
            };
            return $http(ds.req);
        }

        function getClassMasters(IskolaNeve) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'OsztalyfonokAutoComplete',
                params: {'IskolaNeve': IskolaNeve}
            };
            return $http(ds.req);
        }

        function getClassMasterContact(classmaster) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'OsztalyfonokElerhetosege',
                params: {'classmaster': classmaster}
            };
            return $http(ds.req);
        }

        function monthlyAttendanceSelectById(id) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'HaviJelenletiLekeresById',
                params: {'id': id}
            };
            return $http(ds.req);
        }

        function saveDailyAttendance(attendance) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'NapiJelenletiMentes',
                data: attendance
            };
            return $http(ds.req);
        }

        function saveMonthlyAttendance(attendance) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'HaviJelenletiMentes',
                data: attendance
            };
            return $http(ds.req);
        }

        function saveTrainingDiary(tetelek, jelenletiid, keszult) {
            var data = {};
            data.edzesmunka = tetelek;
            data.JelenletiFejId = jelenletiid;
            data.keszult = keszult;
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'KepzesiNaploMentes',
                data: data
            };
            return $http(ds.req);
        }

        function getAthleteData(athleteId) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'sportoloSelect',
                params: {'sportoloId': athleteId}
            };
            return $http(ds.req);
        }

        function getAthleteDataMin(athleteId) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'SportoloSelectMin',
                params: {'sportoloId': athleteId}
            };
            return $http(ds.req);
        }

        function monthlyAttendanceRefreshAthleteData(fejid) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'HaviJelenletiSportoloAdatokFrissites',
                params: {'fejid': fejid}
            };
            return $http(ds.req);
        }

        function getNewAthletesInSelectedYearMonth(hj) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'UjJatekosokKivHonapbanSelect',
                data: hj
            };
            return $http(ds.req);
        }

        function monthlyAttendanceAcceptByLeader(idMA) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'haviJelenletiJovahagyas',
                data: idMA
            };
            return $http(ds.req);
        }

        function HaviEdzesTervJovahagyas(id) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'HaviEdzesTervJovahagyas',
                data: id
            };
            return $http(ds.req);
        }

        function HetiEdzesTervJovahagyas(id) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'HetiEdzesTervJovahagyas',
                data: id
            };
            return $http(ds.req);
        }

        function messageSave(uzenet, cimzettekId, sectionId) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'UzenetMentes',
                data: {
                    uzenet: uzenet,
                    cimzettekId: cimzettekId,
                    sectionId: sectionId
                }
            };
            return $http(ds.req);
        }

        function getAnnualSeasonPlanArrears() {
            //Datum=JSON.stringify(Datum);
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'HaviJelenletiLemaradasok'
            };
            return $http(ds.req);
        }

        function getLastMonthlyAttendanceTrainingLocationAndTime(edzoId, kivSzakosztaly, kivKorcsoport) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'HaviJelenletiUtolsoEdzesAdatok',
                params: {'edzoId': edzoId, 'kivSzakosztaly': kivSzakosztaly, 'kivKorcsoport': kivKorcsoport}
            };
            return $http(ds.req);
        }

        function getAthletesForMonthlyAttendance(edzoId, kivSzakosztaly, kivKorcsoport, kivHonap) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'HaviJelenletiEdzoJatekosaiKivHonapban',
                params: {
                    'edzoId': edzoId,
                    'kivSzakosztaly': kivSzakosztaly,
                    'kivKorosztaly': kivKorcsoport,
                    'kivHonap': kivHonap
                }
            };
            return $http(ds.req);
        }

        function getAthletesCountForMonthlyAttendance(edzoId, szakosztalyId, korcsoportId, tol, ig) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'HaviJelenletiSzakosztalySportoloi',
                params: {
                    'edzoId': edzoId,
                    'szakosztalyId': szakosztalyId,
                    'korcsoportId': korcsoportId,
                    'tol': tol,
                    'ig': ig
                }
            };
            return $http(ds.req);
        }

        function getMonthlyAttendanceList(edzoId, tol, ig, lezart) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'HaviJelenletikLista',
                params: {'kivEdzo': edzoId, 'tol': tol, 'ig': ig, 'lezart': lezart}
            };
            return $http(ds.req);
        }

        function getUserUnreadedMessages() {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'felhasznaloOlvasatlanUzenetei'
            };
            return $http(ds.req);
        }

        function unreadedMessagesViewed(id) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'UzenetOlvasottaTesz',
                params: {'uzenetId': id}
            };
            return $http(ds.req);
        }

        function messageDelete(id) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'UzenetTorlese',
                params: {'uzenetId': id}
            };
            return $http(ds.req);
        }

        function messageDeleteSent(id) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'UzenetTorleseElkuldottekbol',
                params: {'uzenetId': id}
            };
            return $http(ds.req);
        }

        function getUnAcceptedMonthlyAttendance() {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'HaviJelenletiSzakvezAlairni'
            };
            return $http(ds.req);
        }

        function getUnAcceptedMonthlyCompetitionPlan() {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'VersenyTervHaviAlairni'
            };
            return $http(ds.req);
        }

        function getUnAcceptedWeeklyCompetitionPlan() {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'VersenyTervHetiAlairni'
            };
            return $http(ds.req);
        }

        function getUnAcceptedYearlyCompetitionPlan() {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'VersenyTervEvesAlairni'
            };
            return $http(ds.req);
        }

        function getLinks() {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'HasznosLinkek'
            };
            return $http(ds.req);
        }

        function saveLink(data) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'HasznosLinkekMentes',
                data: data
            };
            return $http(ds.req);
        }

        function saveNewLink(data) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'HasznosLinkekUj',
                data: data
            };
            return $http(ds.req);
        }

        function deleteLink(data) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'HasznosLinkTorles',
                data: data
            };
            return $http(ds.req);
        }

        function getEvents(datum, nezet, sectionId, training, ageGroupId) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'GetEvents',
                params: {training: training, datum: datum, nezet: nezet, sectionId: sectionId, ageGroupId: ageGroupId}
            };
            return $http(ds.req);
        }

        function saveEvent(appointment) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'SaveEvent',
                data: appointment
            };
            return $http(ds.req);
        }

        function modifyEvent(appointment) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'ModifyEvent',
                data: appointment
            };
            return $http(ds.req);
        }

        function removeEvent(Id, year, month, day) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'RemoveEvent',
                data: {
                    Id: Id,
                    year: year,
                    month: month,
                    day: day
                }
            };
            return $http(ds.req);
        }

        function getSectionResources() {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'GetSectionResources'
            };
            return $http(ds.req);
        }

        function getAgeGroupResources() {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'GetAgeGroupResources'
            };
            return $http(ds.req);
        }

        function saveTenesseeSelfImageScale(athleteId, answers) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'SaveTenesseeSelfImageScale',
                data: {
                    answers: answers,
                    sportoloId: athleteId
                }
            };
            return $http(ds.req);
        }

        function getTenesseeSelfImageScaleById(surveyId) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'getTenesseeSelfImageScaleById',
                params: {surveyId: surveyId}
            };
            return $http(ds.req);
        }

        function saveTenesseeSelfImageScaleEval(surveyId, szoveg) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'SaveTenesseeSelfImageScaleEval',
                data: {surveyId: surveyId, szoveg: szoveg}
            };
            return $http(ds.req);
        }

        function saveWartegg(sportoloId) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'SaveWartegg',
                params: {sportoloId: sportoloId}
            };
            return $http(ds.req);
        }

        function uploadWartegg(data) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'UploadWartegg',
                data: data
            };
            return $http(ds.req);
        }

        function getPsychologyTests(sportoloId) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'getPsychologyTests',
                params: {sportoloId: sportoloId}
            };
            return $http(ds.req);
        }

        function getWarteggTestById(testId) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'getWarteggTestById',
                params: {surveyId: testId}
            };
            return $http(ds.req);
        }

        function getWeeklyTrainingPlanList(edzoId, szakosztalyId, korosztalyId, ev, text) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'HetiEdzestervekLista',
                params: {
                    'edzoId': edzoId,
                    'szakId': szakosztalyId,
                    'korosztalyId': korosztalyId,
                    'ev': ev,
                    'text': text
                }
            };
            return $http(ds.req);
        }

        function getMonthlyTrainingPlanList(edzoId, szakosztalyId, korosztalyId, ev, text) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'HaviEdzestervekLista',
                params: {
                    'edzoId': edzoId,
                    'szakId': szakosztalyId,
                    'korosztalyId': korosztalyId,
                    'ev': ev,
                    'text': text
                }
            };
            return $http(ds.req);
        }

        function saveExitAthletes(datas) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'SaveExitAthletes',
                data: datas
            };
            return $http(ds.req);
        }

        function saveNewAthlete(datas) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'SaveNewAthlete',
                data: datas
            };
            return $http(ds.req);
        }

        function modifyAthlete(datas) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'ModifyAthlete',
                data: datas
            };
            return $http(ds.req);
        }

        function getAccessRights() {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'JogosultsagokSelect'
            };
            return $http(ds.req);
        }

        function getAthletesForWeeklyTrainingPlan(edzoId, korosztalyId) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'GetAthletesForWeeklyTrainingPlan',
                params: {edzoId: edzoId, korosztalyId: korosztalyId}
            };
            return $http(ds.req);
        }

        function getUserGroupRights(groupId) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'CsoportJogosultsagokSelect',
                params: {'csoportId': groupId}
            };
            return $http(ds.req);
        }

        function setUserGroupRight(groupId, rightId, value) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'CsoportJogosultsagokSelect',
                data: {
                    csoportId: groupId,
                    jogId: rightId,
                    ertek: value
                }
            };
            return $http(ds.req);
        }

        function weeklyTrainingPlanSelectByIdNew(id) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'getHetiEdzestervByIdNew',
                params: {'id': id}
            };
            return $http(ds.req);
        }

        function saveWeeklyTrainingPlanNew(formData, gridData, createEvents, mindenki, checkedItems) {
            formData.gridData = gridData;
            formData.createEvents = createEvents;
            formData.mindenki = mindenki;
            formData.checkedItems = checkedItems;
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'HetiEdzestervMentesNew',
                data: formData
            };
            return $http(ds.req);
        }

        function getFilesList(table, tableId) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'getFilesList',
                params: {
                    table: table,
                    tableId: tableId
                }
            };
            return $http(ds.req);
        }

        function deleteFiles(id) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'FileRemove',
                params: {
                    id: id
                }
            };
            return $http(ds.req);
        }

        function getCompetitiveMonthlyPlanList(coachId, sectionId, selectedYear) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'VersenyTervHaviLista',
                params: {
                    edzoId: coachId,
                    szakosztalyId: sectionId,
                    ev: selectedYear
                }
            };
            return $http(ds.req);
        }

        function monthlyPlanSelectById(id, szakosztalyId, egyeni) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'VersenyTervHaviById',
                params: {
                    id: id,
                    szakosztalyId: szakosztalyId,
                    egyeni: egyeni
                }
            };
            return $http(ds.req);
        }

        function saveMonthlyCompetitionPlan(cplan) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'VersenyTervHaviMentes',
                data: cplan
            };
            return $http(ds.req);
        }

        function updateTagdijfizetesek(tabla, sorszamadassal) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'UpdateTagdijfizetesek',
                data: {tabla: tabla, sorszamadassal: sorszamadassal}
            };
            return $http(ds.req);
        }

        function checkPaymentsSave(tabla) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'CsekkBefizetesMentes',
                data: {tabla: tabla}
            };
            return $http(ds.req);
        }

        function updateOktatasiDijfizetesek(tabla, sorszamadassal) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'UpdateOktatasiDijfizetesek',
                data: {tabla: tabla, sorszamadassal: sorszamadassal}
            };
            return $http(ds.req);
        }

        function monthlyCompetitionPlanAcceptByLeader(id, idSzakosztaly, tipus) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'VersenyTervHaviJovahagyas',
                params: {
                    idVt: id,
                    idSzakosztaly: idSzakosztaly,
                    tipus: tipus
                }
            };
            return $http(ds.req);
        }

        function getCompetitiveMonthlyPlanItems(coachId, sectionId, date, egyeni) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'VersenyTervHaviTetelekLista',
                params: {
                    edzoId: coachId,
                    szakosztalyId: sectionId,
                    datum: date,
                    tipus: egyeni
                }
            };
            return $http(ds.req);
        }

        function getResultsReports(data) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'EredmenyJelentokLista',
                data: data
            };
            return $http(ds.req);
        }

        function getResultsReportsAthlete(data) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'EredmenyJelentokListaAthlete',
                data: data
            };
            return $http(ds.req);
        }

        function savePaint(data) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'SavePaint',
                data: data
            };
            return $http(ds.req);
        }

        function modifyPaint(data) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'ModifyPaint',
                data: data
            };
            return $http(ds.req);
        }

        function getPaint(data) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'GetPaint',
                params: data
            };
            return $http(ds.req);
        }

        function deleteResultsReport(resultReportID, csapatEredmeny) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'VersenyEredmenyTorlese',
                params: {
                    'Id': resultReportID,
                    'csapatEredmeny': csapatEredmeny
                }
            };
            return $http(ds.req);
        }

        function sectionIndividualOrTeam(id) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'SzakosztalyEgyeniVagyCsapat',
                params: {
                    szakosztalyId: id
                }
            };
            return $http(ds.req);
        }

        function getFeeDatas(sectionId) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'SzakosztalyokDijak',
                params: {sectionId: sectionId}
            };
            return $http(ds.req);
        }

        function saveFeeDatas(formData) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'SzakosztalyokDijak/Save',
                data: formData
            };
            return $http(ds.req);
        }

        function meteOutFee(formData) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'TagdijKiszabas',
                data: formData,
                timeout: 1800000
            };
            return $http(ds.req);
        }

        function getAthletesForMeteOut(fromDate) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'TagdijUjSportolok',
                params: {
                    'naptol': fromDate
                }
            };
            return $http(ds.req);
        }

        function closeYear(formData) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'Evzaras',
                data: formData
            };
            return $http(ds.req);
        }

        function getLastClosedYear() {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'getUtolsoEvzaras'
            };
            return $http(ds.req);
        }

        function athletesBySection(queryDate) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'SzakosztalySportolokSzama',
                params: {
                    'datum': queryDate
                }
            };
            return $http(ds.req);
        }

        function getUnPaidFees() {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'getSzakosztalyEdzoHatralekosai'
            };
            return $http(ds.req);
        }

        function getUnPaidFeesTrainer() {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'getEdzoTagdijHatralekosai'
            };
            return $http(ds.req);
        }

        function getMessages(subjectId, pageNumber, itemsPerPage) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'SikerMobileFreeGetMessages',
                params: {
                    subjectId: subjectId,
                    pageNumber: pageNumber,
                    itemsPerPage: itemsPerPage
                }
            };
            return $http(ds.req);
        }

        function getSentMessages() {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'getFelhasznaloElkuldottUzenetei'
            };
            return $http(ds.req);
        }

        function GetMessageGroups(pageNumber, itemsPerPage, onlyUnread) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'SikerMobileFreeGetMessageGroups',
                params: {
                    pageNumber: pageNumber,
                    itemsPerPage: itemsPerPage,
                    onlyUnread: onlyUnread
                }
            };
            return $http(ds.req);
        }

        function messageReaded(id) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'UzenetOlvasottaTesz',
                params: {
                    uzenetId: id
                }
            };
            return $http(ds.req);
        }

        function sendMessage(obj) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'UzenetKuldes',
                data: obj
            };
            return $http(ds.req);
        }

        function SikerMobileFreeSendMessage(obj) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'SikerMobileFreeSendMessage',
                data: obj
            };
            return $http(ds.req);
        }

        function SikerMobileFreeSendNewMessage(obj) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'SikerMobileFreeSendNewMessageDesktop',
                data: obj
            };
            return $http(ds.req);
        }

        function getNamesByIds(obj) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'CimzettLista',
                data: obj
            };
            return $http(ds.req);
        }

        function parentsAthletes() {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'SzuloSportoloiSelect'
            };
            return $http(ds.req);
        }

        function parentsAthleteAttendance(sportoloId, date) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'HianyzasIgazolasa',
                params: {
                    sportoloId: sportoloId,
                    date: date
                }
            };
            return $http(ds.req);
        }

        function parentsAthleteAttendanceList() {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'HianyzasokSzulo'
            };
            return $http(ds.req);
        }

        function annualSeasonPlanReportSelectById(id) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'VersenyeztetesiTervFejSelectById',
                params: {'id': id}
            };
            return $http(ds.req);
        }

        function annualSeasonPlanReportSelect(szakosztalyId, korosztalyId, edzoId, ev, egyeni) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'VersenyeztetesiTervFejSelect',
                params: {
                    'szakosztalyId': szakosztalyId,
                    'korosztalyId': korosztalyId,
                    'edzoId': edzoId,
                    'ev': ev,
                    'egyeni': egyeni
                }
            };
            return $http(ds.req);
        }

        function getTrainerEmailContact(edzo) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'FelhasznaloElerhetosegeiSelect',
                params: {userId: edzo}
            };
            return $http(ds.req);
        }

        function annualSeasonPlanReportMembersDataByIdSelect(fejId) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'VersenyeztetesiTervFejTagokAdataiById',
                params: {
                    'fejId': fejId
                }
            };
            return $http(ds.req);
        }

        function coachAthletesByAgeGroupForAnnualSeasonPlan(edzoId, szakosztalyId, korcsoportId, versenyeztetesiTervFejId) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'EdzoSportoloiKorcsoportSelect',
                params: {
                    'edzoId': edzoId,
                    'szakosztalyId': szakosztalyId,
                    'korcsoportId': korcsoportId,
                    'versenyeztetesiTervFejId': versenyeztetesiTervFejId
                }
            };
            return $http(ds.req);
        }

        function annualSeasonPlanDeleteMembers(versenyeztetesiTervFejId) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'VersenyeztetesiTagokTorles',
                params: {
                    'fejId': versenyeztetesiTervFejId
                }
            };
            return $http(ds.req);
        }

        function saveAnnualSeasonPlanMembers(obj) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'VersenyeztetesiTervTagokAdataiMentes',
                data: obj
            };
            return $http(ds.req);
        }

        function saveAnnualSeasonPlanHead(obj) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'VersenyeztetesiTervFejMentes',
                data: obj
            };
            return $http(ds.req);
        }

        function annualSeasonPlanReportMembersPastSelect(id) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'VersenyeztetesiTervTagokMultjaSelectById',
                params: {
                    'fejId': id
                }
            };
            return $http(ds.req);
        }

        function annualSeasonPlanReportMembersPastDelete(id) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'VersenyeztetesiTagokMultTorles',
                params: {
                    'fejId': id
                }
            };
            return $http(ds.req);
        }

        function annualSeasonPlanReportMembersPastRefresh(id, szakosztalyId, korcsoportId, edzoId) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'VersenyeztetesiTagokMultLekeres',
                params: {
                    'fejId': id,
                    'szakosztalyId': szakosztalyId,
                    'korcsoportId': korcsoportId,
                    'edzoId': edzoId
                }
            };
            return $http(ds.req);
        }

        function saveAnnualSeasonPlanMembersPast(data) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'VersenyeztetesiTervTagokMultjaMentes',
                data: data
            };
            return $http(ds.req);
        }

        function annualSeasonPlanReportBestResultsList(id) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'VersenyeztetesiTervErdemenyekSelect',
                params: {
                    'fejId': id
                }
            };
            return $http(ds.req);
        }

        function saveAnnualSeasonPlanBestResults(obj) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'VersenyeztetesiTervKiemelkedoEredmenyekMentes',
                data: obj
            };
            return $http(ds.req);
        }

        function annualSeasonPlanReportBestResultsSelect(id) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'KiemelkEredmSelect',
                params: {
                    'versFejId': id
                }
            };
            return $http(ds.req);
        }

        function dailyEducationalFeesPerCoach(edzoId, datumTol, datumIg) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'NapiOktDijBefizetesekEdzonkent',
                params: {
                    'edzoId': edzoId,
                    'datumTol': datumTol,
                    'datumIg': datumIg
                }
            };
            return $http(ds.req);
        }

        function dailySportServiceFeesPerCoach(edzoId, datumTol, datumIg) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'NapiSportSzolgDijBefizetesekEdzonkent',
                params: {
                    'edzoId': edzoId,
                    'datumTol': datumTol,
                    'datumIg': datumIg
                }
            };
            return $http(ds.req);
        }

        function annualSeasonPlanReportObjectivesSelect(id) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'VersenyeztetesiTervCelkituzesek',
                params: {
                    'fejId': id
                }
            };
            return $http(ds.req);
        }

        function saveAnnualSeasonPlanCapitalObjectives(obj) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'VersenyeztetesiTervCelkituzesekMentes',
                data: obj
            };
            return $http(ds.req);
        }

        function deleteFileAnnualSeasonPlan(file, host) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'VersenyeztetesiTervCsatoltFileTorles',
                params: {
                    'file': file,
                    'host': host
                }
            };
            return $http(ds.req);
        }

        function getAnnualSeasonPlanListByTrainer(edzoId, vtId) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'EdzoKorabbiEvesVersenyeztetesiTervei',
                params: {
                    'edzoId': edzoId,
                    'vtId': vtId
                }
            };
            return $http(ds.req);
        }

        function annualSeasonPlanCompetitionPlansAndObjectivesSelect(id) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'VersenyeztetesiTervVersTervekSelect',
                params: {
                    'fejId': id
                }
            };
            return $http(ds.req);
        }

        function saveAnnualSeasonPlanCompetitionPlansAndObjectives(obj) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'VersenyeztetesiTervVersTervekMentes',
                data: obj
            };
            return $http(ds.req);
        }

        function deleteAnnualSeasonPlanCompetitionPlansAndObjectives(fejId) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'VersenyeztetesiTervVersTervekTorles',
                params: {
                    'fejId': fejId
                }
            };
            return $http(ds.req);
        }

        function deleteAnnualSeasonPlanCompetitionPlansAndObjective(id) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'VersenyeztetesiTervVersenyTervTorles',
                params: {
                    'id': id
                }
            };
            return $http(ds.req);
        }

        function annualSeasonPlanList(ev) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'VersenyeztetesiTervListSelect',
                params: {
                    'ev': ev
                }
            };
            return $http(ds.req);
        }

        function annualSeasponPlanTableListSelect(fejId) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'VersenyeztetesiTervTablazatSelect',
                params: {
                    'fejId': fejId
                }
            };
            return $http(ds.req);
        }

        function annualSeasponPlanTableListSelect2(edzo, korcsoport, honap) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'VersenyeztetesiTervTablazatSelect2',
                params: {
                    'edzo': edzo,
                    'korcsoport': korcsoport,
                    'honap': honap
                }
            };
            return $http(ds.req);
        }

        function saveAnnualSeasonPlanTable(obj) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'VersenyeztetesiTervTablazatMentes',
                data: obj
            };
            return $http(ds.req);
        }

        function getAthleteTransferList(szakosztalyId, edzoId) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'KimutatasAtigazolasLista',
                params: {
                    'szakosztalyId': szakosztalyId,
                    'edzoId': edzoId
                }
            };
            return $http(ds.req);
        }

        function getCentralReportAllIn(szakId, korId, edzoId, szulEv, neme) {
            if (!szakId) {
                szakId = 0;
            }
            if (!korId) {
                korId = 0;
            }
            if (!edzoId) {
                edzoId = 0;
            }
            if (!szulEv) {
                szulEv = 0;
            }
            if (!neme) {
                neme = '';
            }
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'KEredmenyFelmerokOsszesitett',
                params: {
                    'szakId': szakId,
                    'korId': korId,
                    'edzoId': edzoId,
                    'szulEv': szulEv,
                    'neme': neme
                }
            };
            return $http(ds.req);
        }

        function getFelmerokDatumaiDropDownList() {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'FelmerokDatumaiDropDownList'
            };
            return $http(ds.req);
        }

        function getFelmerokDatumai2DropDownList() {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'FelmerokDatumai2DropDownList'
            };
            return $http(ds.req);
        }

        function getAnnualPresenceReportByTrainersReport(ev, honap, szakosztalyId, korosztalyId, korosztalyNev, edzoId) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'JelenletiEvesKimutatasEdzonkent',
                params: {
                    'ev': ev,
                    honap: honap,
                    'szakosztalyId': szakosztalyId,
                    'korosztalyId': korosztalyId,
                    'korosztalyNev': korosztalyNev,
                    'edzoId': edzoId
                }
            };
            return $http(ds.req);
        }

        function getAnnualPresenceReportBySectionsReport(ev, honap, szakosztalyId) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'JelenletiEvesKimutatasSzakosztalyonkent',
                params: {
                    'ev': ev,
                    honap: honap,
                    'szakosztalyId': szakosztalyId
                }
            };
            return $http(ds.req);
        }

        function getAnnualPresenceReportBySportSchoolReport(ev, honap) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'JelenletiEvesKimutatasSportiskolankent',
                params: {
                    ev: ev,
                    honap: honap
                }
            };
            return $http(ds.req);
        }

        function deleteWeeklyTrainingPlan(id) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'HetiEdzestervTorles',
                params: {
                    'id': id
                }
            };
            return $http(ds.req);
        }

        function deleteMonthlyTrainingPlan(id) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'HaviEdzestervTorles',
                params: {
                    'id': id
                }
            };
            return $http(ds.req);
        }

        function athleteDropDownListSelect(szakosztalyId, korosztalyId, sportolo1, sportolo2) {
            if (sportolo1 === undefined) {
                sportolo1 = 0;
            }
            if (sportolo2 === undefined) {
                sportolo2 = 0;
            }

            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'SportoloDropDownList',
                params: {
                    'szakosztaly': szakosztalyId,
                    'korcsoport': korosztalyId,
                    'sportoloId1': sportolo1,
                    'sportoloId2': sportolo2
                }
            };
            return $http(ds.req);
        }

        function getCharacterOfACompetitionList(csapat, szakosztalyId) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'EredmenyJelentokJellegeiList',
                params: {
                    'csapat': csapat,
                    'szakosztalyId': szakosztalyId
                }
            };
            return $http(ds.req);
        }

        function saveResultReportAthletes(obj) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'SportoloEredmenyJelentoMentes',
                data: obj
            };
            return $http(ds.req);
        }

        function resultReportAthletesSelectById(id) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'SportoloEredmenyJelentoById',
                params: {
                    'eredmenyId': id
                }
            };
            return $http(ds.req);
        }

        function resultReportAthletesOlderReports(szakosztalyId, korcsoportId, egyeni) {
            if (!szakosztalyId) {
                return;
            }
            if (!korcsoportId) {
                korcsoportId = -1;
            }

            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'KorabbiEredmenyJelentok',
                params: {
                    'szakosztalyId': szakosztalyId,
                    'korcsoportId': korcsoportId,
                    'egyeni': egyeni
                }
            };
            return $http(ds.req);
        }

        function teamDropDownListSelect(szakosztalyId, korosztalyId, csapat) {
            if (!csapat) {
                csapat = 0;
            }
            if (!korosztalyId) {
                korosztalyId = 0;
            }
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'CsapatDropDownList',
                params: {
                    'szakosztaly': szakosztalyId,
                    'korcsoport': korosztalyId,
                    'csapat': csapat
                }
            };
            return $http(ds.req);
        }

        function getTrainingVisitReport(year, sportoloId) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'KSportoloEdzeslatogatas',
                params: {
                    'ev': year,
                    'sportoloId': sportoloId
                }
            };
            return $http(ds.req);
        }

        function teamAthletesListSelect(csapatId) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'csapatSportoloiLista',
                params: {
                    'csapatId': csapatId
                }
            };
            return $http(ds.req);
        }

        function getCoachUsers(szakosztalyIdk) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'FelhasznaloEdzok',
                params: {
                    'szakId': szakosztalyIdk
                }
            };
            return $http(ds.req);
        }

        function getEdzoKorcsoportjai(edzoId) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'EdzoKorcsoportjaiDropDownSelect',
                params: {
                    'edzoId': edzoId
                }
            };
            return $http(ds.req);
        }

        function AtjatszoSportoloLista(szakosztalyId, korcsoportId, edzoId, exceptTeam) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'AtjatszoSportoloLista',
                params: {
                    'szakosztalyId': szakosztalyId,
                    'korcsoportId': korcsoportId,
                    'edzoId': edzoId,
                    'exceptTeam': exceptTeam
                }
            };
            return $http(ds.req);
        }

        function getTeamResultAthleteData(sportoloId) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'CsapatEredmenySportoloAdatai',
                params: {
                    'sportoloId': sportoloId
                }
            };
            return $http(ds.req);
        }

        function EredmenyJelentoAtjatszoSportoloi(csapatId, userId) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'EredmenyJelentoAtjatszoSportoloi',
                params: {
                    'csapatId': csapatId,
                    'userId': userId
                }
            };
            return $http(ds.req);
        }

        function saveResultReportTeams(obj) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'CsapatEredmenyJelentoMentes',
                data: obj
            };
            return $http(ds.req);
        }

        function resultReportTeamSelectById(id) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'CsapatEredmenyJelentoById',
                params: {
                    'eredmenyId': id
                }
            };
            return $http(ds.req);
        }

        function saveReEnteringAthletes(sportolo) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'SaveReEnteringAthletes',
                data: sportolo
            };
            return $http(ds.req);
        }

        function felmeroElemFejDropDownList(szakosztalyId) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'FelmeroElemFejDropDownList',
                params: {
                    'szakosztalyId': szakosztalyId,
                }
            };
            return $http(ds.req);
        }

        function felmeroFejLista(szakosztalyId, korosztalyId, edzoId, felmeroId, sportoloid, datefrom, dateto) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'FelmeroFejLista',
                params: {
                    'section': szakosztalyId,
                    'ageGroup': korosztalyId,
                    'coach': edzoId,
                    'test': felmeroId,
                    'sportoloid': sportoloid,
                    'datefrom': datefrom,
                    'dateto': dateto
                }
            };
            return $http(ds.req);
        }

        function getSectionHasSectionLeaderRight(id) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'FelhasznaloCsoportSzakosztalyVezetoe',
                params: {
                    'felhCsopId': id
                }
            };
            return $http(ds.req);
        }

        function getSectionHasCoachRight(id) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'FelhasznaloCsoportEdzoje',
                params: {
                    'felhCsopId': id
                }
            };
            return $http(ds.req);
        }

        function getOldWeeklyPlanByUserId(idEdzo, id) {
            if (id == undefined) {
                id = -1;
            }
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'getOldWeeklyPlanByUserId',
                params: {
                    'IdEdzo': idEdzo,
                    'Id': id
                }
            };
            return $http(ds.req);
        }

        function getOldMonthlyPlanByUserId(idEdzo, id) {
            if (id == undefined) {
                id = -1;
            }
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'getOldMonthlyPlanByUserId',
                params: {
                    'IdEdzo': idEdzo,
                    'Id': id
                }
            };
            return $http(ds.req);
        }

        function monthlyTrainingPlanSelectById(id) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'getHaviEdzestervById',
                params: {'id': id}
            };
            return $http(ds.req);
        }

        function saveMonthlyTrainingPlan(formData) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'HaviEdzestervMentes',
                data: formData
            };
            return $http(ds.req);
        }

        function Cimjegyzek(usersof) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'Cimjegyzek',
                params: {
                    'usersof': usersof
                }
            };
            return $http(ds.req);
        }

        function CimjegyzekMobil() {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'CimjegyzekMobil'
            };
            return $http(ds.req);
        }

        function getUserIdsOfGroup(usersof, ids) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'getUserIdsOfGroup',
                data: {
                    'usersof': usersof,
                    'ids': ids
                }
            };
            return $http(ds.req);
        }

        function GetHealth(id, dateFrom, dateTo) {
            if (dateFrom === null || dateFrom === '' || dateFrom === undefined) {
                dateFrom = '1900-01-01';
            }
            if (dateTo === null || dateTo === '' || dateTo === undefined) {
                dateTo = '1900-01-01';
            }

            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'GetHealth',
                params: {
                    'athleteId': id,
                    'dateFrom': dateFrom,
                    'dateTo': dateTo
                }
            };
            return $http(ds.req);
        }

        function saveHealthData(datas) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'SaveHealthData',
                data: datas
            };
            return $http(ds.req);
        }

        function deleteHealthMainType(datas) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'DeleteHealthTypes',
                params: {
                    'mainTypeId': datas.mainTypeId,
                    'subTypeId': null
                }
            };
            return $http(ds.req);
        }

        function deleteHealthSubType(datas) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'DeleteHealthTypes',
                params: {
                    'mainTypeId': null,
                    'subTypeId': datas.subTypeId
                }
            };
            return $http(ds.req);
        }

        function SimilarAthleteExist(data) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'SimilarAthleteExist',
                params: data
            };
            return $http(ds.req);
        }

        function HealthMainTypeManager(datas) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'HealthTypeManager',
                data: {
                    'foTipusId': datas.Id,
                    'foTipus': datas.Nev
                }
            };
            return $http(ds.req);
        }

        function HealthSubTypeManager(datas) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'HealthTypeManager',
                data: {
                    'foTipusId': datas.FotipusId,
                    'alTipusId': datas.Id,
                    'alTipus': datas.AltipusNev
                }
            };
            return $http(ds.req);
        }

        function modifyHealthData(datas) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'ModifyHealthData',
                data: datas
            };
            return $http(ds.req);
        }

        function healthMainTypesList() {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'HealthMainTypes'
            };
            return $http(ds.req);
        }

        function healthSubTypesList() {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'HealthSubTypes'
            };
            return $http(ds.req);
        }

        function monthlyAttendanceActualDaySelect(szakosztalyId, korosztalyId) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'HaviJelenletiLekeresAktualisNap',
                params: {
                    'szakosztalyId': szakosztalyId,
                    'korosztalyId': korosztalyId
                }

            };
            return $http(ds.req);
        }

        function ExpiringDocuments() {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'ExpiringDocuments'
            };
            return $http(ds.req);
        }

        function ExpiringDocuments() {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'ExpiringDocuments'
            };
            return $http(ds.req);
        }

        function DeleteExercise(id) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'DeleteExercise',
                params: {
                    id: id
                }
            };
            return $http(ds.req);
        }

        function getWeeklyTravelList(szakosztalyId, korosztalyId, edzoId, dateFrom, dateTo, onlyStartDate, showOrder, busOwner) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'WeeklyTravelList',
                params: {
                    'szakosztalyId': szakosztalyId,
                    'korosztalyId': korosztalyId,
                    'edzoId': edzoId,
                    'dateFrom': dateFrom,
                    'dateTo': dateTo,
                    'onlyStartDate': onlyStartDate,
                    'showOrder': showOrder,
                    'busOwner': busOwner
                }
            };
            return $http(ds.req);
        }

        function getWeeklyTrainingList(szakosztalyId, korosztalyId, edzoId, dateFrom, dateTo, showWeeks, helyszin) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'WeeklyTrainingList',
                params: {
                    'szakosztalyId': szakosztalyId,
                    'korosztalyId': korosztalyId,
                    'edzoId': edzoId,
                    'dateFrom': dateFrom,
                    'dateTo': dateTo,
                    'showWeeks': showWeeks,
                    'helyszin': helyszin
                }
            };
            return $http(ds.req);
        }

        function KoltsegtervOsszesitoKimutatas(szakosztalyId, korosztalyId, edzoId, dateFrom, dateTo, onlyStartDate) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'KoltsegtervOsszesitoKimutatas',
                params: {
                    'szakosztalyId': szakosztalyId,
                    'korosztalyId': korosztalyId,
                    'edzoId': edzoId,
                    'dateFrom': dateFrom,
                    'dateTo': dateTo,
                    'onlyStartDate': onlyStartDate
                }
            };
            return $http(ds.req);
        }

        function assetInventoryByType(eszkTipusId, szabad, aktiv, osszes) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'EszkozNyilvantartas',
                params: {
                    'eszkTipusId': eszkTipusId,
                    'szabad': szabad,
                    'aktiv': aktiv,
                    'all': osszes
                }
            };
            return $http(ds.req);
        }

        function assetInventoryByPerson(user, athlete, sectionsId, ageGropu) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'EszkozNyilvantartasSzemely',
                params: {
                    'felhasznalo': user,
                    'sportolo': athlete,
                    'szakosztalyId': sectionsId,
                    'korosztalyId': ageGropu
                }
            };
            return $http(ds.req);
        }

        function getTrainingPracticeAutoComplete() {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'TrainingPracticeAutoComplete',
            };
            return $http(ds.req);
        }

        function getExercise(id) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'GetExercise',
                params: {
                    id: id
                }
            };
            return $http(ds.req);
        }

        function getExerciseList(data) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'GetExerciseList',
                params: data
            };
            return $http(ds.req);
        }

        function getExercises(sectionId, ageGroupId, coachId, bodyPart, exercisesType, nature, outfit, difficulty, necessaryArea, video, pattern, designer, time) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'getExercises',
                params: {
                    'szakosztalyId': sectionId,
                    'korosztalyId': ageGroupId,
                    'edzoId': coachId,
                    'testresz': bodyPart,
                    'tipus': exercisesType,
                    'jellege': nature,
                    'felszereles': outfit,
                    'nehezseg': difficulty,
                    'szuksegesTerulet': necessaryArea,
                    'video': video,
                    'mintaKep': pattern,
                    'kifesto': designer,
                    'time': time
                }

            };
            return $http(ds.req);
        }

        function saveTrainingPlan(obj) {
            //CoachId, TrainingName, SectionId, AgeGroupId, Location, Public, Data
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'saveTrainingPlan',
                data: obj
            };
            return $http(ds.req);
        }

        function getTrainingPlanList(sectionId, ageGroupId, coachId) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'getTrainingPlanList',
                params: {
                    'szakosztalyId': sectionId,
                    'korosztalyId': ageGroupId,
                    'edzoId': coachId
                }
            };
            return $http(ds.req);
        }

        function GetTrainingPlanById(Id) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'GetTrainingPlanById',
                params: {
                    'Id': Id
                }
            };
            return $http(ds.req);
        }

        function DeleteTrainingPlan(EdzesFejId) {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'DeleteTrainingPlan',
                params: {
                    'EdzesFejId': EdzesFejId
                }
            };
            return $http(ds.req);
        }

        function sendLocalException(error) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'LogClientSideException',
                data: {
                    error: error
                }
            };
            return $http(ds.req);
        }

        function getMonthlyAttendanceAutoSave() {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'MonthlyAttendanceAutoSave'
            };
            return $http(ds.req);
        }

        function setMonthlyAttendanceAutoSave(autoSave) {
            ds.req = {
                type: 'apiPOST',
                url: DOMAIN.baseURL + DOMAIN.webService + 'MonthlyAttendanceAutoSave',
                data: autoSave
            };
            return $http(ds.req);
        }

        function getCompetitionPlaces() {
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'GetCompetitionPlaces'
            };
            return $http(ds.req);
        }

        function SikerMobileFreeDeleteMessages(targyId) {
            console.log('targyId', targyId);
            ds.req = {
                type: 'apiGET',
                url: DOMAIN.baseURL + DOMAIN.webService + 'SikerMobileFreeDeleteMessages',
                params: {
                    'targyId': targyId
                }
            };
            return $http(ds.req);
        }
    }
})();

/* global XRegExp */
(function () {
    'use strict';

    ctsDropdownList.$inject = ["gettextCatalog"];
    ctsAutoComplete.$inject = ["$timeout"];
    report.$inject = ["localStorageService", "DOMAIN"];
    fileDropzone.$inject = ["fileReader", "log", "gettextCatalog"];
    ngFileSelect.$inject = ["fileReader"];
    htWidgetHeader.$inject = ["log", "gettextCatalog"];
    angular
        .module('app.core')
        .directive('ctsDropdownList', ctsDropdownList)
        .directive('ctsAutoComplete', ctsAutoComplete)
        .directive('ctsColorPicker', ctsColorPicker)
        .directive('ctsDatePicker', ctsDatePicker)
        .directive('ctsDateTimePicker', ctsDateTimePicker)
        .directive('ctsMaskBox', ctsMaskBox)
        .directive('ctsCheckBox', ctsCheckBox)
        .directive('ctsHorizontalCheckBox', ctsHorizontalCheckBox)
        .directive('ctsTextBox', ctsTextBox)
        .directive('ctsTextBoxTajSzam', ctsTextBoxTajSzam)
        .directive('ctsTextArea', ctsTextArea)
        .directive('ctsTextBoxPhoneNumber', ctsTextBoxPhoneNumber)
        .directive('ctsTextBoxEmail', ctsTextBoxEmail)
        .directive('ctsTextBoxTaxId', ctsTextBoxTaxId)
        .directive('ctsTextBoxPassportNumber', ctsTextBoxPassportNumber)
        .directive('ctsListBox', ctsListBox)
        .directive('ctsNumericTextBox', ctsNumericTextBox)
        .directive('ctsRating', ctsRating)
        .directive('report', report)
        .directive('preventEnterSubmit', preventEnterSubmit)
        .directive('fileDropzone', fileDropzone)
        .directive('ngFileSelect', ngFileSelect)
        .directive('htWidgetHeader', htWidgetHeader);

    function htWidgetHeader(log, gettextCatalog) {
        //Usage:
        //<div ht-widget-header title="vm.map.title"></div>
        // Creates:
        // <div ht-widget-header=""
        //      title="Movie"
        //      allow-collapse="true" </div>
        function link($scope) {
            $scope.helpText = gettextCatalog.getString('Help');
            $scope.openHelp = function () {
                log.helpMsgSmall($scope.textId);
            };
        }

        return {
            link: link,
            scope: {
                'title': '@',
                'textId': '@'
            },
            template: '<div class="widget-head">' +
            '<h2 class="page-title">{{title|translate}}' +
            '<a class="pull-right helpText" ng-click="openHelp()"> <span class="glyphicon glyphicon-info-sign"></span> </a>' +
            '</h2></div>',
            restrict: 'EA'
        };
    }

    function ctsDropdownList(gettextCatalog) {
        controller.$inject = ["$scope"];
        function controller($scope) {
            if ($scope.create() !== undefined) {
                $scope.create2 = function (data) {
                    $scope.create()({value: data.value});
                };
            }
            if ($scope.change() !== undefined) {
                $scope.change2 = function (data) {
                    $scope.change()({value: data.value});
                };
            }
            if ($scope.clear() !== undefined) {
                $scope.clear2 = function () {
                    $scope.clear()();
                };
            } else if ($scope.open() !== undefined) {
                $scope.open2 = function () {
                    $scope.open()();
                };
            }
            if ($scope.databound() !== undefined) {
                $scope.databound2 = function (data) {
                    $scope.databound()(data);
                };
            }
            if ($scope.select() !== undefined) {
                $scope.select2 = function (data) {
                    $scope.select()(data);
                };
            }
            //if ($scope.ctsPlaceholder === undefined) {
            $scope.ctsPlaceholder = 'PleaseChoose';
        }

        var link = {
            pre: function ($scope, element) {
                element[0].querySelector('.addId').id = $scope.name;
                $scope.locale = $scope.$root.language;
                if ($scope.locale === 'hu') {
                    $scope.locale = 'hu-HU';
                } else if ($scope.locale === 'en') {
                    $scope.locale = 'en-GB';
                }
                if ($scope.enabled === undefined) {
                    $scope.enabled = true;
                } else {
                    $scope.$watch(function () {
                        return $scope.enabled;
                    }, function (newValue) {
                        angular.element('#' + $scope.name).ejDropDownList({
                            enabled: newValue,
                            locale: $scope.locale,
                            fields: {
                                text: $scope.fieldText,
                                value: $scope.fieldValue
                            },
                            value: $scope.value,
                            dataSource: $scope.datasource,
                            width: '100%',
                            watermarkText: gettextCatalog.getString($scope.ctsPlaceholder),
                            create: $scope.create2,
                            change: $scope.change2,
                            dataBound: $scope.databound2,
                            select: $scope.select2,
                            selectedIndex: $scope.selectedindex
                        });
                    });
                }
                if (!$scope.fieldValue) {
                    $scope.fieldValue = 'value';
                }
                if (!$scope.fieldText) {
                    $scope.fieldText = 'text';
                }
            },
            post: function ($scope) {
                $scope.form = $scope.$parent.form;
                if ($scope.validationRules !== undefined) {
                    $scope.classes = '';
                    if ($scope.validationRules.required === true) {
                        $scope.classes += ' required';
                        $scope.$watch(function () {
                            return $scope.value;
                        }, function (newValue, oldValue) {
                            if (newValue !== oldValue) {
                                $scope.form[$scope.name].$dirty = true;
                                if (newValue === '') {
                                    $scope.form[$scope.name].$setValidity('required', false);
                                } else {
                                    $scope.form[$scope.name].$setValidity('required', true);
                                }
                            }
                        });
                        $scope.$on('submitted', function () {
                            if (!$scope.value) {
                                $scope.form[$scope.name].$setValidity('required', false);
                            } else {
                                $scope.form[$scope.name].$setValidity('required', true);
                            }
                            //$scope.$apply();
                        });
                    }
                } else {
                    $scope.required = false;
                }
            }
        };
        return {
            restrict: 'E',
            replace: true,
            controller: controller,
            scope: {
                change: '&',
                create: '&',
                clear: '&',
                open: '&',
                databound: '&',
                datasource: '=',
                enabled: '=?',
                label: '@',
                name: '@',
                postfix: '@',
                select: '&',
                validationRules: '=?',
                value: '=?',
                selectedindex: '=?',
                fieldValue: '@?',
                fieldText: '@?'
            },
            template: '<div class="form-group cts-form-group {{classes}}" data-ng-class="{error: form[name].$invalid}">' +
            '<label for="{{name}}">{{label|translate}}</label>' +
            '<div class="input-group">' +
            '<input class="addId" name="{{name}}" ej-dropdownlist e-locale="locale" e-fields-value="fieldValue" e-fields-text="fieldText" e-value="value" e-datasource="datasource" e-width="100%" e-watermarktext="{{ctsPlaceholder|translate}}" e-create="create2" e-change="change2" e-enabled="enabled" e-dataBound="databound2" e-select="select2" e-selectedIndex="selectedindex">' +
            '<span data-ng-if="clear2 !== undefined" class="input-group-addon" data-ng-click="clear2()"><i class="glyphicon glyphicon-trash"></i></span>' +
            '<span data-ng-if="open2 !== undefined" class="input-group-addon" data-ng-click="open2()"><i' +
            ' class="glyphicon glyphicon-eye-open"></i></span>' +
            '<span data-ng-if="postfix !== undefined" class="input-group-addon">{{postfix}}</span>' +
            //'<div class="validation-messages">' +
            //'<span class="error">{{\'NotValid\'|translate}}</span>' +
            //'</div>' +
            '<div class="validation-messages">' +
            '<span data-ng-if="form[name].$error.required === true" class="error">{{\'Required\'|translate}}</span>' +
            '</div>' +
            '<div class="validation-messages">' +
            '<span data-ng-if="form[name].$error.maxlength === true" class="error">{{\'Maxlength\'|translate}}</span>' +
            '</div>' +
            '<div class="validation-messages">' +
            '<span data-ng-if="form[name].$error.minlength === true" class="error">{{\'Minlength\'|translate}}</span>' +
            '</div>' +
            '</div>' +
            '</div>',
            link: link
        };
    }

    function autocompleteWatch($timeout, newValue, oldValue, required, maxlength, $scope) {
        if (angular.isDefined(newValue)) {
            if (newValue !== oldValue) {
                $scope.form[$scope.name].$dirty = true;
                if (required) {
                    if (newValue === '') {
                        $timeout(function () {
                            $scope.form[$scope.name].$setValidity('required', false);
                            $scope.$apply();
                        }, 100);
                    } else {
                        $timeout(function () {
                            $scope.form[$scope.name].$setValidity('required', true);
                            $scope.$apply();
                        }, 100);
                    }
                }
                if (maxlength && newValue) {
                    if (newValue.length < maxlength) {
                        $scope.form[$scope.name].$setValidity('maxlength', true);
                    } else {
                        $scope.form[$scope.name].$setValidity('maxlength', false);
                    }
                }
            }
        }
    }

    function ctsAutoComplete($timeout) {
        controller.$inject = ["$scope"];
        function controller($scope) {
            if ($scope.ctsPlaceholder === undefined) {
                $scope.ctsPlaceholder = $scope.label;
            }
            if (!$scope.showPopupButton) {
                $scope.showPopupButton = false;
            }
            if (!$scope.delaySuggestionTimeout) {
                $scope.delaySuggestionTimeout = '0';
            }
            if ($scope.change() !== undefined) {
                $scope.change2 = function (data) {
                    $scope.change()({value: data.value});
                };
            }
            if ($scope.multiSelect === 'true') {
                $scope.multiSelectMode = ej.MultiSelectMode.VisualMode;
            } else {
                $scope.multiSelect = false;
                $scope.multiSelectMode = ej.MultiSelectMode.None;
            }
            if (!$scope.allowAddNew) {
                $scope.allowAddNew = false;
            } else {
                $scope.allowAddNew = true;
            }
        }

        var link = {
            pre: function ($scope, element) {
                element[0].querySelector('.addId').id = $scope.name;
                $scope.locale = $scope.$root.language;
                if ($scope.owndisabled === undefined) {
                    $scope.owndisabled = false;
                }
                if ($scope.locale === 'hu') {
                    $scope.locale = 'hu-HU';
                } else if ($scope.locale === 'en') {
                    $scope.locale = 'en-GB';
                }
                if ($scope.enabled === undefined) {
                    $scope.enabled = true;
                } else {
                    $scope.$watch(function () {
                        return $scope.enabled;
                    }, function (newValue) {
                        angular.element('#' + $scope.name).ejAutocomplete({enabled: newValue});
                    });
                }
            },
            post: function ($scope) {
                $scope.form = $scope.$parent.form;
                if ($scope.validationRules !== undefined) {
                    $scope.classes = '';
                    $scope.$watch(function () {
                        return $scope.value;
                    }, function (newValue, oldValue) {
                        autocompleteWatch($timeout, newValue, oldValue, $scope.validationRules.required, $scope.validationRules.maxlength, $scope);
                    });
                    $scope.$on('submitted', function () {
                        $scope.value = angular.element('#' + $scope.name).ejAutocomplete('getValue');
                        autocompleteWatch($scope.value, undefined, $scope.validationRules.required, $scope.validationRules.maxlength, $scope);
                        // $scope.$apply();
                    });

                    if ($scope.validationRules.required === true) {
                        $scope.classes += ' required';
                    }
                } else {
                    $scope.required = false;
                }
            }
        };
        return {
            restrict: 'E',
            replace: true,
            controller: controller,
            scope: {
                change: '&',
                clear: '&',
                datasource: '=',
                enabled: '=?',
                label: '@',
                name: '@',
                ctsPlaceholder: '@',
                emptyResultText: '@?',
                postfix: '@',
                select: '&',
                validationRules: '=?',
                value: '=?',
                addnewtext: '=?',
                showPopupButton: '=?',
                delaySuggestionTimeout: '@',
                multiSelect: '@?',
                allowAddNew: '=?',
                owndisabled: '=?',
            },
            template: '<div class="form-group cts-form-group {{classes}}" data-ng-class="{error: form[name].$invalid}">' +
            '<label for="{{name}}">{{label|translate}}</label>' +
            '<div class="input-group">' +
            '<input class="addId" type="text" name="{{name}}" ej-autocomplete e-delaySuggestionTimeout="delaySuggestionTimeout" e-emptyResultText="{{\'emptyResultText\'|translate}}" e-change="change2" e-locale="locale" e-showPopupButton="showPopupButton" e-addnewtext="addnewtext" e-value="value" e-datasource="datasource" e-width="100%" e-watermarktext="{{ctsPlaceholder|translate}}" e-enabled="enabled" data-ng-disabled="owndisabled" e-multiSelectMode="multiSelectMode" e-allowAddNew="true" e-enableDistinct="true" data-ng-required="required"' +
            ' e-autoFocus="true" >' +
            '<span data-ng-if="clear() !== undefined" class="input-group-addon" data-ng-click="clear()()"><i class="glyphicon glyphicon-trash"></i></span>' +
            '<span data-ng-if="postfix !== undefined" class="input-group-addon">{{postfix}}</span>' +
            //'<div class="validation-messages">' +
            //'<span class="error">{{\'NotValid\'|translate}}</span>' +
            //'</div>' +
            '<div class="validation-messages">' +
            '<span data-ng-if="form[name].$error.required === true" class="error">{{\'Required\'|translate}}</span>' +
            '</div>' +
            '<div class="validation-messages">' +
            '<span data-ng-if="form[name].$error.maxlength === true" class="error">{{\'Maxlength\'|translate}}</span>' +
            '</div>' +
            '<div class="validation-messages">' +
            '<span data-ng-if="form[name].$error.minlength === true" class="error">{{\'Minlength\'|translate}}</span>' +
            '</div>' +
            '</div>' +
            '</div>',
            link: link
        };
    }

    function ctsColorPicker() {
        controller.$inject = ["$scope"];
        function controller($scope) {
            if ($scope.change() !== undefined) {
                $scope.change2 = function (data) {
                    $scope.change()({value: data.value});
                };
            }
            if ($scope.select() !== undefined) {
                $scope.select2 = function (data) {
                    $scope.select()({value: data.value});
                };
            }
            if ($scope.ctsPlaceholder === undefined) {
                $scope.ctsPlaceholder = $scope.label;
            }
        }

        var link = {
            pre: function ($scope, element) {
                element[0].querySelector('.addId').id = $scope.name;
                $scope.locale = $scope.$root.language;
                if ($scope.locale === 'hu') {
                    $scope.locale = 'hu-HU';
                } else if ($scope.locale === 'en') {
                    $scope.locale = 'en-GB';
                }
                if ($scope.enabled === undefined) {
                    $scope.enabled = true;
                } else {
                    $scope.$watch(function () {
                        return $scope.enabled;
                    }, function (newValue) {
                        angular.element('#' + $scope.name).ejDropDownList({enabled: newValue});
                    });
                }
            },
            post: function ($scope) {
                $scope.form = $scope.$parent.form;
                if ($scope.validationRules !== undefined) {
                    $scope.classes = '';
                    if ($scope.validationRules.required === true) {
                        $scope.classes += ' required';
                        $scope.$watch(function () {
                            return $scope.value;
                        }, function (newValue, oldValue) {
                            if (newValue !== oldValue) {
                                $scope.form[$scope.name].$dirty = true;
                                if (newValue === '') {
                                    $scope.form[$scope.name].$setValidity('required', false);
                                } else {
                                    $scope.form[$scope.name].$setValidity('required', true);
                                }
                            }
                        });
                        $scope.$on('submitted', function () {
                            if (!$scope.value) {
                                $scope.form[$scope.name].$setValidity('required', false);
                            } else {
                                $scope.form[$scope.name].$setValidity('required', true);
                            }
                            //$scope.$apply();
                        });
                    }
                } else {
                    $scope.required = false;
                }
            }
        };
        return {
            restrict: 'E',
            replace: true,
            controller: controller,
            scope: {
                change: '&',
                select: '&',
                label: '@',
                enabled: '=?',
                name: '@',
                ctsPlaceholder: '@',
                validationRules: '=?',
                value: '=?'
            },
            template: '<div class="form-group cts-form-group {{classes}}" data-ng-class="{error: form[name].$invalid, }">' +
            '<label for="{{name}}">{{label|translate}}</label>' +
            '<div>' +
            '<input class="addId" name="{{name}}" ej-ColorPicker e-locale="locale" e-value="value" e-width="100%" placeholder="{{ctsPlaceholder|translate}}" e-select="select2" e-change="change2" e-enabled="enabled">' +
            '<div class="validation-messages">' +
            '<span data-ng-if="form[name].$error.required === true" class="error">{{\'Required\'|translate}}</span>' +
            '</div>' +
            '<div class="validation-messages">' +
            '<span data-ng-if="form[name].$error.maxlength === true" class="error">{{\'Maxlength\'|translate}}</span>' +
            '</div>' +
            '<div class="validation-messages">' +
            '<span data-ng-if="form[name].$error.minlength === true" class="error">{{\'Minlength\'|translate}}</span>' +
            '</div>' +
            '</div>' +
            '</div>',
            link: link
        };
    }

    function ctsDatePicker() {
        controller.$inject = ["$scope"];
        function controller($scope) {
            if ($scope.change() !== undefined) {
                $scope.change2 = function (data) {
                    $scope.change()({value: data.value});
                };
            }
            if ($scope.ctsPlaceholder === undefined) {
                $scope.ctsPlaceholder = $scope.label;
            }
            if ($scope.clear() !== undefined) {
                $scope.clear2 = function () {
                    $scope.clear()();
                };
            }
            $scope.refresh = function(data) {
                $scope.value = data.value;
            };
        }

        var link = {
            pre: function ($scope, element) {
                element[0].querySelector('.addId').id = $scope.name;
                $scope.locale = $scope.$root.language;
                if ($scope.locale === 'hu') {
                    $scope.locale = 'hu-HU';
                } else if ($scope.locale === 'en') {
                    $scope.locale = 'en-GB';
                }
                if ($scope.enabled === undefined) {
                    $scope.enabled = true;
                } else {
                    $scope.$watch(function () {
                        return $scope.enabled;
                    }, function (newValue) {
                        angular.element('#' + $scope.name).ejDatePicker({enabled: newValue});
                    });
                }
            },
            post: function ($scope) {
                $scope.form = $scope.$parent.form;
                if ($scope.validationRules !== undefined) {
                    $scope.classes = '';
                    if ($scope.validationRules.required === true) {
                        $scope.classes += ' required';
                        $scope.$watch(function () {
                            return $scope.value;
                        }, function (newValue, oldValue) {
                            if (newValue !== oldValue && newValue != '') {
                                $scope.form[$scope.name].$dirty = true;
                                if (newValue === '') {
                                    $scope.form[$scope.name].$setValidity('required', false);
                                } else {
                                    $scope.form[$scope.name].$setValidity('required', true);
                                }
                            }
                        });
                        $scope.$on('submitted', function () {
                            if (!$scope.value) {
                                $scope.form[$scope.name].$setValidity('required', false);
                            } else {
                                $scope.form[$scope.name].$setValidity('required', true);
                            }
                            // $scope.$apply();
                        });
                    }
                } else {
                    $scope.required = false;
                }
            }

        };

        return {
            restrict: 'E',
            replace: true,
            controller: controller,
            scope: {
                enabled: '=?',
                change: '&',
                clear: '&',
                label: '@',
                name: '@',
                ctsPlaceholder: '@',
                validationRules: '=?',
                value: '=?',
                locale: '=?'
            },
            template: '<div class="form-group cts-form-group {{classes}}" data-ng-class="{error: form[name].$invalid}">' +
            '<label for="{{name}}">{{label|translate}}</label>' +
            '<div class="input-group">' +
            '<input class="addId" name="{{name}}" ej-DatePicker e-enableStrictMode="true" e-startDay="1" e-value="value" e-locale="locale" e-width="100%" e-showtooltip="true" e-change="change2" e-focusOut="refresh" e-enabled="enabled">' +
            '<span data-ng-if="clear() !== undefined" class="input-group-addon" data-ng-click="clear()()"><i class="glyphicon glyphicon-trash"></i></span>' +
            '<span data-ng-if="postfix !== undefined" class="input-group-addon">{{postfix}}</span>' +
            '<div class="validation-messages">' +
            '<span data-ng-if="form[name].$error.required === true" class="error">{{\'Required\'|translate}}</span>' +
            '</div>' +
            '<div class="validation-messages">' +
            '<span data-ng-if="form[name].$error.maxlength === true" class="error">{{\'Maxlength\'|translate}}</span>' +
            '</div>' +
            '<div class="validation-messages">' +
            '<span data-ng-if="form[name].$error.minlength === true" class="error">{{\'Minlength\'|translate}}</span>' +
            '</div>' +
            '</div>' +
            '</div>',
            link: link
        };
    }

    function ctsDateTimePicker() {
        controller.$inject = ["$scope"];
        function controller($scope) {
            if ($scope.change() !== undefined) {
                $scope.change2 = function (data) {
                    $scope.change()({value: data.value});
                };
            }
            if ($scope.ctsPlaceholder === undefined) {
                $scope.ctsPlaceholder = $scope.label;
            }
            if ($scope.clear() !== undefined) {
                $scope.clear2 = function () {
                    $scope.clear()();
                };
            }
            $scope.refresh = function(data) {
                $scope.value = data.value;
            };
        }

        function link($scope, element) {
            $scope.form = $scope.$parent.form;
            element[0].querySelector('.addId').id = $scope.name;
            $scope.locale = $scope.$root.language;
            if ($scope.locale === 'hu') {
                $scope.locale = 'hu-HU';
            } else if ($scope.locale === 'en') {
                $scope.locale = 'en-GB';
            }
            if ($scope.enabled === undefined) {
                $scope.enabled = true;
            }
            $scope.$watch(function () {
                return $scope.enabled;
            }, function (newValue) {
                angular.element('#' + $scope.name).ejDateTimePicker({enabled: newValue});
            });
            if ($scope.validationRules !== undefined) {
                $scope.classes = '';
                if ($scope.validationRules.required === true) {
                    $scope.classes += ' required';
                    $scope.$watch(function () {
                        return $scope.value;
                    }, function (newValue, oldValue) {
                        if (newValue !== oldValue && newValue != '') {
                            $scope.form[$scope.name].$dirty = true;
                            if (newValue === '') {
                                $scope.form[$scope.name].$setValidity('required', false);
                            } else {
                                $scope.form[$scope.name].$setValidity('required', true);
                            }
                        }
                    });
                    $scope.$on('submitted', function () {
                        if (!$scope.value) {
                            $scope.form[$scope.name].$setValidity('required', false);
                        } else {
                            $scope.form[$scope.name].$setValidity('required', true);
                        }
                        $scope.$apply();
                    });
                }
            } else {
                $scope.required = false;
            }
        }

        return {
            restrict: 'E',
            replace: true,
            controller: controller,
            scope: {
                enabled: '=?',
                change: '&',
                clear: '&',
                label: '@',
                name: '@',
                interval: '=',
                ctsPlaceholder: '@',
                validationRules: '=?',
                value: '=?'
            },
            template: '<div class="form-group cts-form-group {{classes}}" data-ng-class="{error: form[name].$invalid}">' +
            '<label for="{{name}}">{{label|translate}}</label>' +
            '<div class="input-group">' +
            '<input class="addId" name="{{name}}" ej-DateTimePicker e-value="value" e-locale="locale" e-width="100%" e-datetimeformat="yyyy-MM-dd HH:mm" e-watermarktext="éééé-hh-nn hh:mm" e-change="change2" e-focusOut="refresh" e-enabled="enabled" e-interval="interval">' +
            '<span data-ng-if="clear() !== undefined" class="input-group-addon" data-ng-click="clear()()"><i class="glyphicon glyphicon-trash"></i></span>' +
            '<span data-ng-if="postfix !== undefined" class="input-group-addon">{{postfix}}</span>' +
            '<div class="validation-messages">' +
            '<span data-ng-if="form[name].$error.required === true" class="error">{{\'Required\'|translate}}</span>' +
            '</div>' +
            '<div class="validation-messages">' +
            '<span data-ng-if="form[name].$error.maxlength === true" class="error">{{\'Maxlength\'|translate}}</span>' +
            '</div>' +
            '<div class="validation-messages">' +
            '<span data-ng-if="form[name].$error.minlength === true" class="error">{{\'Minlength\'|translate}}</span>' +
            '</div>' +
            '</div>' +
            '</div>',
            link: link
        };
    }

    function ctsMaskBox() {
        controller.$inject = ["$scope"];
        function controller($scope) {
            if ($scope.change() !== undefined) {
                $scope.change2 = function (data) {
                    $scope.change()({value: data.value});
                };
            }
            if ($scope.ctsPlaceholder === undefined) {
                $scope.ctsPlaceholder = $scope.label;
            }
        }

        function link($scope, element) {
            $scope.form = $scope.$parent.form;
            element[0].querySelector('.addId').id = $scope.name;
            $scope.locale = $scope.$root.language;
            if ($scope.locale === 'hu') {
                $scope.locale = 'hu-HU';
            } else if ($scope.locale === 'en') {
                $scope.locale = 'en-GB';
            }
            if ($scope.enabled === undefined) {
                $scope.enabled = true;
            }
            if ($scope.validationRules !== undefined) {
                $scope.classes = '';
                if ($scope.validationRules.required === true) {
                    $scope.classes += ' required';
                    $scope.$watch(function () {
                        return $scope.value;
                    }, function (newValue, oldValue) {
                        if (newValue !== oldValue) {
                            $scope.form[$scope.name].$dirty = true;
                            if (newValue === '') {
                                $scope.form[$scope.name].$setValidity('required', false);
                            } else {
                                $scope.form[$scope.name].$setValidity('required', true);
                            }
                        }
                    });
                    $scope.$on('submitted', function () {
                        if (!$scope.value) {
                            $scope.form[$scope.name].$setValidity('required', false);
                        } else {
                            $scope.form[$scope.name].$setValidity('required', true);
                        }
                        //$scope.$apply();
                    });
                }
            } else {
                $scope.required = false;
            }
        }

        return {
            restrict: 'E',
            replace: true,
            controller: controller,
            scope: {
                enabled: '=?',
                change: '&',
                label: '@',
                name: '@',
                maskFormat: '@',
                ctsPlaceholder: '@',
                validationRules: '=?',
                value: '=?'
            },
            template: '<div class="form-group cts-form-group {{classes}}" data-ng-class="{error: form[name].$invalid}">' +
            '<label for="{{name}}">{{label|translate}}</label>' +
            '<div>' +
            '<input class="addId" name="{{name}}" ej-MaskEdit e-value="value" e-locale="locale" e-maskFormat="maskFormat" e-width="100%" placeholder="{{ctsPlaceholder|translate}}" e-change="change2" e-enabled="enabled">' +
            '<div class="validation-messages">' +
            '<span data-ng-if="form[name].$error.required === true" class="error">{{\'Required\'|translate}}</span>' +
            '</div>' +
            '<div class="validation-messages">' +
            '<span data-ng-if="form[name].$error.maxlength === true" class="error">{{\'Maxlength\'|translate}}</span>' +
            '</div>' +
            '<div class="validation-messages">' +
            '<span data-ng-if="form[name].$error.minlength === true" class="error">{{\'Minlength\'|translate}}</span>' +
            '</div>' +
            '</div>' +
            '</div>',
            link: link
        };
    }

    function ctsTextBox() {
        var link = {
            pre: function ($scope, element) {
                $scope.form = $scope.$parent.form;
                element[0].querySelector('.addId').id = $scope.name;
                $scope.locale = $scope.$root.language;
                if ($scope.locale === 'hu') {
                    $scope.locale = 'hu-HU';
                } else if ($scope.locale === 'en') {
                    $scope.locale = 'en-GB';
                }
                $scope.classes = '';
                if ($scope.owndisabled === undefined) {
                    $scope.owndisabled = false;
                }
                if ($scope.inputonly === true) {
                    $scope.classes += ' inputonly';
                }
                if ($scope.validationRules !== undefined) {
                    $scope.required = $scope.validationRules.required === true;
                    $scope.classes += $scope.validationRules.required === true ? ' required' : '';
                    if ($scope.validationRules.minlength !== undefined) {
                        $scope.minlength = $scope.validationRules.minlength;
                    } else {
                        $scope.minlength = 0;
                    }
                    if ($scope.validationRules.maxlength !== undefined) {
                        $scope.maxlength = $scope.validationRules.maxlength;
                    } else {
                        $scope.maxlength = 128;
                    }
                    if ($scope.type === undefined) {
                        $scope.type = 'text';
                    }
                } else {
                    $scope.required = false;
                }
                if ($scope.ctsPlaceholder === undefined) {
                    $scope.ctsPlaceholder = $scope.label;
                }
            },
            post: function ($scope) {
                if ($scope.change() !== undefined) {
                    $scope.$watch(function () {
                        return $scope.ngModel;
                    }, function (newValue, oldValue) {
                        if (newValue !== oldValue) {
                            $scope.change()();
                        }
                    });
                }
            }
        };
        return {
            restrict: 'E',
            replace: true,
            scope: {
                change: '&', //
                //clear: '&',     //
                //enabled: '=?',  //
                owndisabled: '=?',
                inputonly: '=?',
                label: '@',
                name: '@',
                ngModel: '=',
                ctsPlaceholder: '@',
                type: '@',
                validationRules: '=?'
            },
            template: '<div class="form-group cts-form-group {{classes}}" data-ng-class="{error: form[name].$invalid && (form[name].$dirty || form.$submitted)}">' +
            '<label for="{{name}}">{{label|translate}}</label>' +
            '<div>' +
            //'<input class="form-control addId" name="{{name}}" type="{{type}}" placeholder="{{ctsPlaceholder|translate}}" data-ng-model="ngModel" data-ng-required="required" data-ng-minlength="minlength" data-ng-maxlength="maxlength" data-ng-disabled="disabled">' +
            '<input class="form-control addId" name="{{name}}" type="{{type}}" placeholder="{{ctsPlaceholder|translate}}" data-ng-model="ngModel" data-ng-required="required" data-ng-minlength="minlength" data-ng-maxlength="maxlength" data-ng-disabled="owndisabled">' +
            //'<div class="validation-messages">' +
            //'<span class="error">{{\'NotValid\'|translate}}</span>' +
            //'</div>' +
            '<div class="validation-messages">' +
            '<span data-ng-if="form[name].$error.required === true" class="error">{{\'Required\'|translate}}</span>' +
            '</div>' +
            '<div class="validation-messages">' +
            '<span data-ng-if="form[name].$error.maxlength === true" class="error">{{\'Maxlength\'|translate}}</span>' +
            '</div>' +
            '<div class="validation-messages">' +
            '<span data-ng-if="form[name].$error.minlength === true" class="error">{{\'Minlength\'|translate}}</span>' +
            '</div>' +
            '</div>' +
            '</div>',
            link: link
        };
    }

    function ctsTextBoxTajSzam() {
        function link($scope, element) {
            $scope.form = $scope.$parent.form;
            element[0].querySelector('.addId').id = $scope.name;
            $scope.locale = $scope.$root.language;
            if ($scope.locale === 'hu') {
                $scope.locale = 'hu-HU';
            } else if ($scope.locale === 'en') {
                $scope.locale = 'en-GB';
            }
            if ($scope.validationRules !== undefined) {
                $scope.classes = '';

                if ($scope.validationRules.required === true) {
                    $scope.required = $scope.validationRules.required === true;
                    $scope.classes += $scope.validationRules.required === true ? ' required' : '';
                    $scope.$watch(function () {
                        return $scope.ngModel;
                    }, function (newValue, oldValue) {
                        if (newValue !== oldValue) {
                            $scope.form[$scope.name].$dirty = true;
                            if (XRegExp('([0-9]{3}-?){3}').test($scope.ngModel) === true) {
                                $scope.form[$scope.name].$setValidity('required', true);
                            } else {
                                $scope.form[$scope.name].$setValidity('required', false);
                            }
                        }
                    });
                    $scope.$on('submitted', function () {
                        if (!$scope.ngModel || XRegExp('([0-9]{3}-?){3}').test($scope.ngModel) === false) {
                            $scope.form[$scope.name].$setValidity('required', false);
                        } else {
                            $scope.form[$scope.name].$setValidity('required', true);
                        }
                        //$scope.$apply();
                    });
                }
            } else {
                $scope.required = false;
            }
            if (angular.isUndefined($scope.ctsPlaceholder)) {
                $scope.ctsPlaceholder = $scope.label;
            }
        }

        return {
            restrict: 'E',
            replace: true,
            scope: {
                label: '@',
                name: '@',
                ngModel: '=',
                ctsPlaceholder: '@',
                validationRules: '=?'
            },
            template: '<div class="form-group cts-form-group {{classes}}" data-ng-class="{error: form[name].$invalid && (form[name].$dirty || form.$submitted)}">' +
            '<label for="{{name}}">{{label|translate}}</label>' +
            '<div>' +
            '<input class="form-control addId" name="{{name}}" type="text" placeholder="{{ctsPlaceholder|translate}}" e-value="ngModel" data-ng-required="required" ej-MaskEdit e-maskFormat="999-999-999" e-width="100%" e-locale="locale">' +
            '<div class="validation-messages">' +
            '<span data-ng-if="form[name].$error.required === true" class="error">{{\'Required\'|translate}}</span>' +
            '</div>' +
            '<div class="validation-messages">' +
            '<span data-ng-if="form[name].$error.maxlength === true" class="error">{{\'Maxlength\'|translate}}</span>' +
            '</div>' +
            '<div class="validation-messages">' +
            '<span data-ng-if="form[name].$error.minlength === true" class="error">{{\'Minlength\'|translate}}</span>' +
            '</div>' +
            '</div>' +
            '</div>',
            link: link
        };
    }

    function ctsTextArea() {
        function link($scope) {
            $scope.form = $scope.$parent.form;
            $scope.classes = '';
            if ($scope.inputonly === true) {
                $scope.classes += ' inputonly';
            }
            if (angular.isDefined($scope.validationRules)) {
                $scope.required = $scope.validationRules.required === true;
                $scope.classes += $scope.validationRules.required === true ? ' required' : '';
                if (angular.isDefined($scope.validationRules.minlength)) {
                    $scope.minlength = $scope.validationRules.minlength;
                } else {
                    $scope.minlength = 0;
                }
                if (angular.isDefined($scope.validationRules.maxlength)) {
                    $scope.maxlength = $scope.validationRules.maxlength;
                } else {
                    $scope.maxlength = 128;
                }
            } else {
                $scope.required = false;
            }
            if (angular.isUndefined($scope.type)) {
                $scope.type = 'text';
            }
            if ($scope.ctsPlaceholder === undefined) {
                $scope.ctsPlaceholder = $scope.label;
            }
            if ($scope.owndisabled === undefined) {
                $scope.owndisabled = false;
            }
            if ($scope.css === undefined) {
                $scope.css = '';
            }
            if ($scope.rows === undefined) {
                $scope.rows = 5;
            }

            angular.element('.test').attr('id', $scope.name);
        }

        return {
            restrict: 'E',
            replace: true,
            scope: {
                css: '@',
                owndisabled: '=?',
                inputonly: '=?',
                label: '@',
                name: '@',
                ngModel: '=',
                ctsPlaceholder: '@',
                validationRules: '=?',
                rows: '@'
            },
            template: '<div class="form-group cts-form-group {{classes}}" data-ng-class="{error: form[name].$invalid && (form[name].$dirty || form.$submitted)}" style="{{css}}">' +
            '<label for="{{name}}">{{label|translate}}</label>' +
            '<div>' +
            '<textarea rows="{{rows}}" style="resize:none" class="form-control addId textarea" name="{{name}}" placeholder="{{ctsPlaceholder|translate}}" data-ng-model="ngModel" data-ng-required="required" data-ng-minlength="minlength" data-ng-maxlength="maxlength" data-ng-disabled="owndisabled"> </textarea>' +
            '<div class="validation-messages">' +
            '<span data-ng-if="form[name].$error.required === true" class="error">{{\'Required\'|translate}}</span>' +
            '</div>' +
            '<div class="validation-messages">' +
            '<span data-ng-if="form[name].$error.maxlength === true" class="error">{{\'Maxlength\'|translate}}</span>' +
            '</div>' +
            '<div class="validation-messages">' +
            '<span data-ng-if="form[name].$error.minlength === true" class="error">{{\'Minlength\'|translate}}</span>' +
            '</div>' +
            '</div>' +
            '</div>',
            link: link
        };
    }

    function ctsHorizontalCheckBox() {
        controller.$inject = ["$scope"];
        function controller($scope) {
            if ($scope.change() !== undefined) {
                $scope.change2 = function (data) {
                    $scope.change()({value: data.isChecked});
                };
            }
        }

        var link = {
            pre: function ($scope, element) {
                if ($scope.enabled === undefined) {
                    $scope.enabled = true;
                }
                element[0].querySelector('.addId').id = $scope.name;

                $scope.locale = $scope.$root.language;
                if ($scope.locale === 'hu') {
                    $scope.locale = 'hu-HU';
                } else if ($scope.locale === 'en') {
                    $scope.locale = 'en-GB';
                }
            }
        };
        return {
            restrict: 'E',
            replace: true,
            controller: controller,
            scope: {
                change: '&',
                checked: '=?',
                enabled: '=?',
                label: '@',
                name: '@'
            },
            template: '<div class="form-group cts-form-group chkbox">' +
            '<form action="">' +
            '<input class="addId" ej-checkBox e-locale="locale" e-checked="checked" e-enabled="enabled" e-change="change2">&nbsp&nbsp{{label|translate}}<br></form>' +
            '</div>',

            link: link
        };
    }

    function ctsCheckBox() {
        controller.$inject = ["$scope"];
        function controller($scope) {
            if ($scope.change() !== undefined) {
                $scope.change2 = function (data) {
                    $scope.change()({value: data.isChecked});
                };
            }
            if ($scope.enabled === undefined) {
                $scope.enabled = true;
            } else {
                $scope.$watch(function () {
                    return $scope.enabled;
                }, function (newValue) {
                    if (newValue) {
                        angular.element('#' + $scope.name).ejCheckBox('enable');
                    } else {
                        angular.element('#' + $scope.name).ejCheckBox('disable');
                    }
                });
            }
        }

        var link = {
            pre: function ($scope, element) {
                if ($scope.enabled === undefined) {
                    $scope.enabled = true;
                }
                element[0].querySelector('.addId').id = $scope.name;
                $scope.locale = $scope.$root.language;
                if ($scope.locale === 'hu') {
                    $scope.locale = 'hu-HU';
                } else if ($scope.locale === 'en') {
                    $scope.locale = 'en-GB';
                }
            }
        };
        return {
            restrict: 'E',
            replace: true,
            controller: controller,
            scope: {
                change: '&',
                checked: '=?',
                enabled: '=?',
                label: '@',
                name: '@'
            },
            template: '<div class="form-group cts-form-group chkbox">' +
            '<label for="{{name}}">{{label|translate}}</label>' +
            '<div>' +
            '<input class="addId" ej-checkBox e-locale="locale" e-checked="checked" e-enabled="enabled" e-change="change2">' +
            '</div>' +
            '</div>',
            link: link
        };
    }

    function ctsTextBoxPhoneNumber() {
        function link($scope, element) {
            $scope.form = $scope.$parent.form;
            element[0].querySelector('.addId').id = $scope.name;
            $scope.locale = $scope.$root.language;
            if ($scope.locale === 'hu') {
                $scope.locale = 'hu-HU';
            } else if ($scope.locale === 'en') {
                $scope.locale = 'en-GB';
            }
            if ($scope.validationRules !== undefined) {
                $scope.classes = '';
                $scope.required = $scope.validationRules.required === true;
                $scope.classes += $scope.validationRules.required === true ? ' required' : '';
            } else {
                $scope.required = false;
            }
            if ($scope.ctsPlaceholder === undefined) {
                $scope.ctsPlaceholder = $scope.label;
            }
        }

        return {
            restrict: 'E',
            replace: true,
            scope: {
                label: '@',
                name: '@',
                ngModel: '=',
                ctsPlaceholder: '@',
                validationRules: '=?'
            },
            template: '<div class="form-group cts-form-group {{classes}}" data-ng-class="{error: form[name].$invalid && (form[name].$dirty || form.$submitted)}">' +
            '<label for="{{name}}">{{label|translate}}</label>' +
            '<div>' +
            '<input class="form-control addId" name="{{name}}" type="text" placeholder="{{ctsPlaceholder|translate}}" data-ng-model="ngModel" data-ng-required="required" ej-MaskEdit e-locale="locale" e-maskFormat="99-999-9999" e-width="100%">' +
            '<div class="validation-messages">' +
            '<span data-ng-if="form[name].$error.required === true" class="error">{{\'Required\'|translate}}</span>' +
            '</div>' +
            '<div class="validation-messages">' +
            '<span data-ng-if="form[name].$error.maxlength === true" class="error">{{\'Maxlength\'|translate}}</span>' +
            '</div>' +
            '<div class="validation-messages">' +
            '<span data-ng-if="form[name].$error.minlength === true" class="error">{{\'Minlength\'|translate}}</span>' +
            '</div>' +
            '</div>' +
            '</div>',
            link: link
        };
    }

    function ctsTextBoxEmail() {
        function link($scope, element) {
            $scope.form = $scope.$parent.form;
            element[0].querySelector('.addId').id = $scope.name;
            $scope.locale = $scope.$root.language;
            if ($scope.locale === 'hu') {
                $scope.locale = 'hu-HU';
            } else if ($scope.locale === 'en') {
                $scope.locale = 'en-GB';
            }
            if ($scope.validationRules !== undefined) {
                $scope.classes = '';
                $scope.required = $scope.validationRules.required === true;
                $scope.classes += $scope.validationRules.required === true ? ' required' : '';
                if ($scope.validationRules.minlength !== undefined) {
                    $scope.minlength = $scope.validationRules.minlength;
                } else {
                    $scope.minlength = 0;
                }
                if ($scope.validationRules.maxlength !== undefined) {
                    $scope.maxlength = $scope.validationRules.maxlength;
                } else {
                    $scope.maxlength = 128;
                }
                if ($scope.type === undefined) {
                    $scope.type = 'text';
                }
            } else {
                $scope.required = false;
            }
            if ($scope.ctsPlaceholder === undefined) {
                $scope.ctsPlaceholder = $scope.label;
            }
            if ($scope.enabled === undefined) {
                $scope.enabled = true;
            }
        }

        return {
            restrict: 'E',
            replace: true,
            scope: {
                label: '@',
                name: '@',
                ngModel: '=',
                ctsPlaceholder: '@',
                type: '@',
                enabled: '=?',
                validationRules: '=?'
            },
            template: '<div class="form-group cts-form-group {{classes}}" data-ng-class="{error: form[name].$invalid && (form[name].$dirty || form.$submitted)}">' +
            '<label for="{{name}}">{{label|translate}}</label>' +
            '<div>' +
            '<input class="form-control addId" name="{{name}}" type="text" data-ng-disabled="!enabled" placeholder="{{ctsPlaceholder|translate}}" data-ng-model="ngModel" data-ng-required="required">' +
            '<div class="validation-messages">' +
            '<span data-ng-if="form[name].$error.required === true" class="error">{{\'Required\'|translate}}</span>' +
            '</div>' +
            '<div class="validation-messages">' +
            '<span data-ng-if="form[name].$error.maxlength === true" class="error">{{\'Maxlength\'|translate}}</span>' +
            '</div>' +
            '<div class="validation-messages">' +
            '<span data-ng-if="form[name].$error.minlength === true" class="error">{{\'Minlength\'|translate}}</span>' +
            '</div>' +
            '</div>' +
            '</div>',
            link: link
        };
    }

    function ctsTextBoxTaxId() {
        function link($scope, element) {
            $scope.form = $scope.$parent.form;
            element[0].querySelector('.addId').id = $scope.name;
            if ($scope.validationRules !== undefined) {
                $scope.classes = '';
                $scope.required = $scope.validationRules.required === true;
                $scope.classes += $scope.validationRules.required === true ? ' required' : '';
            } else {
                $scope.required = false;
            }
            if ($scope.ctsPlaceholder === undefined) {
                $scope.ctsPlaceholder = $scope.label;
            }
        }

        return {
            restrict: 'E',
            replace: true,
            scope: {
                label: '@',
                name: '@',
                ngModel: '=',
                ctsPlaceholder: '@',
                validationRules: '=?'
            },
            template: '<div class="form-group cts-form-group {{classes}}" data-ng-class="{error: form[name].$invalid && (form[name].$dirty || form.$submitted)}">' +
            '<label for="{{name}}">{{label|translate}}</label>' +
            '<div>' +
            '<input class="form-control addId" name="{{name}}" type="text" placeholder="{{ctsPlaceholder|translate}}" data-ng-model="ngModel" data-ng-required="required" e-width="100%">' +
            '<div class="validation-messages">' +
            '<span data-ng-if="form[name].$error.required === true" class="error">{{\'Required\'|translate}}</span>' +
            '</div>' +
            '<div class="validation-messages">' +
            '<span data-ng-if="form[name].$error.maxlength === true" class="error">{{\'Maxlength\'|translate}}</span>' +
            '</div>' +
            '<div class="validation-messages">' +
            '<span data-ng-if="form[name].$error.minlength === true" class="error">{{\'Minlength\'|translate}}</span>' +
            '</div>' +
            '</div>' +
            '</div>',
            link: link
        };
    }

    function ctsTextBoxPassportNumber() {
        function link($scope, element) {
            $scope.form = $scope.$parent.form;
            element[0].querySelector('.addId').id = $scope.name;
            $scope.locale = $scope.$root.language;
            if ($scope.locale === 'hu') {
                $scope.locale = 'hu-HU';
            } else if ($scope.locale === 'en') {
                $scope.locale = 'en-GB';
            }
            if ($scope.validationRules !== undefined) {
                $scope.classes = '';
                $scope.required = $scope.validationRules.required === true;
                $scope.classes += $scope.validationRules.required === true ? ' required' : '';
            } else {
                $scope.required = false;
            }
            if ($scope.ctsPlaceholder === undefined) {
                $scope.ctsPlaceholder = $scope.label;
            }
        }

        return {
            restrict: 'E',
            replace: true,
            scope: {
                label: '@',
                name: '@',
                ngModel: '=',
                ctsPlaceholder: '@',
                validationRules: '=?'
            },
            template: '<div class="form-group cts-form-group {{classes}}" data-ng-class="{error: form[name].$invalid && (form[name].$dirty || form.$submitted)}">' +
            '<label for="{{name}}">{{label|translate}}</label>' +
            '<div>' +
            '<input class="form-control addId" name="{{name}}" type="text" placeholder="{{ctsPlaceholder|translate}}" data-ng-model="ngModel" data-ng-required="required" ej-MaskEdit e-locale="locale" e-width="100%">' +
            '<div class="validation-messages">' +
            '<span data-ng-if="form[name].$error.required === true" class="error">{{\'Required\'|translate}}</span>' +
            '</div>' +
            '<div class="validation-messages">' +
            '<span data-ng-if="form[name].$error.maxlength === true" class="error">{{\'Maxlength\'|translate}}</span>' +
            '</div>' +
            '<div class="validation-messages">' +
            '<span data-ng-if="form[name].$error.minlength === true" class="error">{{\'Minlength\'|translate}}</span>' +
            '</div>' +
            '</div>' +
            '</div>',
            link: link
        };
    }

    function ctsListBox() {
        controller.$inject = ["$scope"];
        function controller($scope) {
            if ($scope.checkChange() !== undefined) {
                $scope.checkChange2 = function (data) {
                    $scope.checkChange()(data);
                };
            }
        }

        var link = {
            pre: function ($scope, element) {
                if ($scope.enabled === undefined) {
                    $scope.enabled = true;
                }
                if ($scope.ctsPlaceholder === undefined) {
                    $scope.ctsPlaceholder = $scope.label;
                }
                if ($scope.cssClass === undefined) {
                    $scope.cssClass = '';
                }
                $scope.showCheckbox = $scope.showCheckbox === 'true' || $scope.showCheckbox === true;
                if ($scope.height === undefined) {
                    $scope.height = 300;
                }
                element[0].querySelector('.addId').id = $scope.name;
                $scope.locale = $scope.$root.language;
                if ($scope.locale === 'hu') {
                    $scope.locale = 'hu-HU';
                } else if ($scope.locale === 'en') {
                    $scope.locale = 'en-GB';
                }
            }

        };
        return {
            restrict: 'E',
            replace: true,
            controller: controller,
            scope: {
                checkChange: '&',
                cssClass: '@',
                datasource: '=',
                enabled: '=?',
                height: '@',
                label: '@',
                name: '@',
                checkedIndices: '=',
                ctsPlaceholder: '@',
                showCheckbox: '@'
            },
            template: '<div class="form-group cts-form-group">' +
            '<label for="{{name}}">{{label|translate}}</label>' +
            '<div class="input-group">' +
            '<ul class="addId" name="{{name}}" ej-listbox e-locale="locale" e-cssClass="cssClass" e-checkedIndices="checkedIndices" e-datasource="datasource" e-showCheckbox="showCheckbox" e-width="100%" e-height="height" placeholder="{{ctsPlaceholder|translate}}" e-enabled="enabled" e-checkChange="checkChange2" e-enableIncrementalSearch="true"></ul>' +
            '</div>' +
            '</div>',
            link: link
        };
    }

    function ctsNumericTextBox() {
        controller.$inject = ["$scope"];
        function controller($scope) {
            if ($scope.change() !== undefined) {
                $scope.change2 = function (data) {
                    $scope.change()(data);
                };
            }
            if ($scope.focusout() !== undefined) {
                $scope.focusout2 = function (data) {
                    $scope.focusout()(data);
                };
            }
        }

        var link = {
            pre: function ($scope, element) {
                $scope.form = $scope.$parent.form;
                element[0].querySelector('.addId').id = $scope.name;
                $scope.locale = $scope.$root.language;
                if ($scope.locale === 'hu') {
                    $scope.locale = 'hu-HU';
                } else if ($scope.locale === 'en') {
                    $scope.locale = 'en-GB';
                }
                $scope.classes = '';
                if ($scope.enabled === undefined) {
                    $scope.enabled = true;
                }
                if ($scope.inputonly === true) {
                    $scope.classes += ' inputonly';
                }
                if (!$scope.decimalplaces) {
                    $scope.decimalplaces = 0;
                } else {
                    $scope.decimalplaces = parseInt($scope.decimalplaces);
                }
                if ($scope.validationRules !== undefined) {
                    if ($scope.validationRules.required === true) {
                        $scope.classes += ' required';
                        $scope.$watch(function () {
                            return $scope.value;
                        }, function (newValue, oldValue) {
                            if (oldValue !== undefined && newValue !== oldValue) {
                                if (newValue === '') {
                                    $scope.form[$scope.name].$setValidity('required', false);
                                } else {
                                    $scope.form[$scope.name].$setValidity('required', true);
                                }
                            }
                        });
                        $scope.$on('submitted', function () {
                            if (!$scope.value && $scope.value !== 0) {
                                $scope.form[$scope.name].$setValidity('required', false);
                            } else {
                                $scope.form[$scope.name].$setValidity('required', true);
                            }
                            //$scope.$apply();
                        });
                    }
                    if ($scope.validationRules.minlength !== undefined) {
                        $scope.minlength = $scope.validationRules.minlength;
                    } else {
                        $scope.minlength = 0;
                    }
                    if ($scope.validationRules.maxlength !== undefined) {
                        $scope.maxlength = $scope.validationRules.maxlength;
                    } else {
                        $scope.maxlength = 1000000;
                    }
                } else {
                    $scope.required = false;
                    $scope.minlength = 0;
                    $scope.maxlength = Number.MAX_VALUE;
                }
                if ($scope.ctsPlaceholder === undefined) {
                    $scope.ctsPlaceholder = $scope.label;
                }
            }
        };
        return {
            restrict: 'E',
            replace: true,
            controller: controller,
            scope: {
                change: '&',
                focusout: '&',
                decimalplaces: '=?',
                enabled: '=?',
                label: '@',
                inputonly: '=?',
                name: '@',
                value: '=?',
                ctsPlaceholder: '@',
                validationRules: '=?',
                tabIndex: '@'
            },
            template: '<div class="form-group cts-form-group {{classes}}" data-ng-class="{error: form[name].$invalid}">' +
            '<label for="{{name}}">{{label|translate}}</label>' +
            '<div>' +
            '<input class="form-control addId" name="{{name}}" ej-numerictextbox e-locale="locale" e-enableStrictMode="true"  e-watermarkText="{{ctsPlaceholder|translate}}" min="{{minlength}}" max="{{maxlength}}" e-value="value" e-minValue="minlength" e-maxValue="maxlength" e-enabled="enabled" e-width="100%" e-decimalPlaces="decimalplaces" placeholder="{{ctsPlaceholder|translate}}" e-change="change2" e-focusout="focusout2" tabIndex="{{tabIndex}}">' +
            '<div class="validation-messages">' +
            '<span data-ng-if="form[name].$error.required === true" class="error">{{\'Required\'|translate}}</span>' +
            '</div>' +
            '<div class="validation-messages">' +
            '<span data-ng-if="form[name].$error.maxlength === true" class="error">{{\'Maxlength\'|translate}}</span>' +
            '</div>' +
            '<div class="validation-messages">' +
            '<span data-ng-if="form[name].$error.minlength === true" class="error">{{\'Minlength\'|translate}}</span>' +
            '</div>' +
            '</div>' +
            '</div>',
            link: link
        };
    }

    function ctsRating() {
        controller.$inject = ["$scope"];
        function controller($scope) {
            if ($scope.change() !== undefined) {
                $scope.change2 = function (data) {
                    $scope.change()(data);
                };
            }
        }

        var link = {
            pre: function ($scope, element) {
                $scope.form = $scope.$parent.form;
                element[0].querySelector('.addId').id = $scope.name;
                $scope.locale = $scope.$root.language;
                if ($scope.locale === 'hu') {
                    $scope.locale = 'hu-HU';
                } else if ($scope.locale === 'en') {
                    $scope.locale = 'en-GB';
                }
                if ($scope.enabled === undefined) {
                    $scope.enabled = true;
                }
                if ($scope.validationRules !== undefined) {
                    $scope.classes = '';
                    if ($scope.validationRules.required === true) {
                        $scope.classes += ' required';
                        $scope.$watch(function () {
                            return $scope.value;
                        }, function (newValue, oldValue) {
                            if (oldValue !== undefined && newValue !== oldValue) {
                                if (newValue === '') {
                                    $scope.form[$scope.name].$setValidity('required', false);
                                } else {
                                    $scope.form[$scope.name].$setValidity('required', true);
                                }
                            }
                        });
                        $scope.$on('submitted', function () {
                            if (!$scope.value) {
                                $scope.form[$scope.name].$setValidity('required', false);
                            } else {
                                $scope.form[$scope.name].$setValidity('required', true);
                            }
                            //$scope.$apply();
                        });
                    }
                    if ($scope.validationRules.minlength !== undefined) {
                        $scope.minlength = $scope.validationRules.minlength;
                    } else {
                        $scope.minlength = 0;
                    }
                    if ($scope.validationRules.maxlength !== undefined) {
                        $scope.maxlength = $scope.validationRules.maxlength;
                    } else {
                        $scope.maxlength = 1000000;
                    }
                } else {
                    $scope.required = false;
                    $scope.minlength = 0;
                    $scope.maxlength = Number.MAX_VALUE;
                }
            }
        };
        return {
            restrict: 'E',
            replace: true,
            controller: controller,
            scope: {
                change: '&',
                enabled: '=?',
                label: '@',
                name: '@',
                value: '=?',
                validationRules: '=?'
            },
            template: '<div class="form-group cts-form-group {{classes}}" data-ng-class="{error: form[name].$invalid}">' +
            '<label for="{{name}}">{{label|translate}}</label>' +
            '<div>' +
            '<div class="form-control addId" name="{{name}}" ej-rating e-locale="locale" e-value="value" e-minValue="0" e-maxValue="5" e-enabled="enabled" e-change="change2"></div>' +
            '<div class="validation-messages">' +
            '<span data-ng-if="form[name].$error.required === true" class="error">{{\'Required\'|translate}}</span>' +
            '</div>' +
            '<div class="validation-messages">' +
            '<span data-ng-if="form[name].$error.maxlength === true" class="error">{{\'Maxlength\'|translate}}</span>' +
            '</div>' +
            '<div class="validation-messages">' +
            '<span data-ng-if="form[name].$error.minlength === true" class="error">{{\'Minlength\'|translate}}</span>' +
            '</div>' +
            '</div>' +
            '</div>',
            link: link
        };
    }

    function report(localStorageService, DOMAIN) {
        function Link(scope, element) {
            var report = null;

            function createReportOptions() {
                var authData = localStorageService.get('_authData');
                var authToken = '';
                if (authData) {
                    authToken = authData.access_token;
                }
                return {
                    reportSource: {
                        report: 'Siker2MVC.' + scope.reportName + ', Siker2MVC',
                        parameters: scope.reportParameters
                    },
                    serviceUrl: DOMAIN.baseURL + 'api/reports/',
                    persistSession: true,
                    authenticationToken: authToken,
                    ready: function () {
                        this.refreshReport();
                    }
                };
            }

            function createReport() {
                report = element.telerik_ReportViewer(createReportOptions()).data('telerik_ReportViewer');
            }

            //createReport();

            //var reportNameWatcher = scope.$watch("reportName", updateReport);
            var reportParametersWatcher = scope.$watch('reportParameters', updateReport);

            function updateReport(newVal, oldVal) {
                if (newVal !== oldVal) {
                    createReport();
                    report.reportSource({
                        report: 'Siker2MVC.' + scope.reportName + ', Siker2MVC',
                        parameters: scope.reportParameters
                    });
                    report.refreshReport();
                }
            }

            element.on('$destroy', function () {
                reportParametersWatcher();
            });
        }

        return {
            restrict: 'E',
            scope: {
                reportName: '@',
                reportParameters: '='
            },
            link: Link
        };
    }

    function preventEnterSubmit() {
        return function (scope, el) {
            el.bind('keydown', function (event) {
                if (13 == event.which) {
                    event.preventDefault(); // Doesn't work at all
                    window.stop(); // Works in all browsers but IE...
                    document.execCommand('Stop'); // Works in IE
                    return false; // Don't even know why it's here. Does nothing.
                }
            });
        };
    }

    function ngFileSelect(fileReader) {
        return {
            link: function ($scope, el) {
                $scope.getFile = function (file) {
                    $scope.progress = 0;
                    fileReader.readAsDataURL(file, $scope).then(function (result) {
                        $scope.$parent.$$childHead.imageDatas.push(result);
                    });
                };

                el.bind('change', function (e) {
                    var items = (e.srcElement || e.target).files;
                    angular.forEach(items, function (file) {
                        $scope.$parent.$$childHead.files.push(file);
                        $scope.getFile(file);
                    });
                });
            }

        };
    }

    function fileDropzone(fileReader, log, gettextCatalog) {
        return {
            restrict: 'A',
            link: function (scope, element) {
                function processDragOverOrEnter(event) {
                    if (event != null) {
                        event.preventDefault();
                    }
                    if (event.originalEvent.dataTransfer) {
                        event.originalEvent.dataTransfer.effectAllowed = 'copy';
                    }
                    return false;
                }

                element.bind('dragover', processDragOverOrEnter);
                element.bind('dragenter', processDragOverOrEnter);

                scope.getFile = function (file) {
                    $scope.progress = 0;
                    fileReader.readAsDataURL(file, $scope).then(function (result) {
                        $scope.$parent.$$childHead.imageDatas.push(result);
                    });
                };

                return element.bind('drop', function (event) {
                    if (event) {
                        event.preventDefault();
                    }

                    if (event.originalEvent.dataTransfer) {
                        var items = event.originalEvent.dataTransfer.files;
                        var largeError = '';
                        var typeError = '';
                        angular.forEach(items, function (file) {
                            if (file.size <= 4194304) {
                                if (file.type === 'image/png' || file.type === 'image/jpeg' || file.type === 'image/bmp' || file.type === 'image/gif') {
                                    scope.$parent.$$childHead.files.push(file);
                                    scope.getFile(file);
                                } else {
                                    typeError += file.name + '<br>';
                                }
                            } else {
                                largeError += file.name + '<br>';
                            }
                        });
                        if (largeError) {
                            log.errorMsg(gettextCatalog.getString('FileTooLarge') + '<br><br>' + largeError);
                        }
                        if (typeError) {
                            log.errorMsg(gettextCatalog.getString('FileTypeError') + '<br><br>' + typeError);
                        }
                    }

                    return false;
                });
            }
        };
    }
})();

(function () {
    'use strict';

    fileReader.$inject = ["$q"];
    angular
        .module('app.core')
        .factory('fileReader', fileReader);

    function fileReader($q) {
        return {
            onLoad: onLoad,
            onError: onError,
            onProgress: onProgress,
            readAsDataURL: readAsDataURL,
            getReader: getReader
        };

        function onLoad(reader, deferred, scope) {
            return function () {
                scope.$apply(function () {
                    deferred.resolve(reader.result);
                });
            };
        }

        function onError(reader, deferred, scope) {
            return function () {
                scope.$apply(function () {
                    deferred.reject(reader.result);
                });
            };
        }

        function onProgress(reader, scope) {
            return function (event) {
                scope.$broadcast('fileProgress',
                    {
                        total: event.total,
                        loaded: event.loaded
                    });
            };
        }

        function getReader(deferred, scope) {
            var reader = new FileReader();
            reader.onload = onLoad(reader, deferred, scope);
            reader.onerror = onError(reader, deferred, scope);
            reader.onprogress = onProgress(reader, scope);
            return reader;
        }

        function readAsDataURL(file, scope) {
            var deferred = $q.defer();

            var reader = getReader(deferred, scope);
            reader.readAsDataURL(file);

            return deferred.promise;
        }
    }
})();

(function () {
    'use strict';

    startOfWeek.$inject = ["authenticationService"];
    endOfWeek.$inject = ["authenticationService"];
    addDays.$inject = ["authenticationService"];
    stringToMoment.$inject = ["authenticationService"];
    dateStringFilter.$inject = ["authenticationService"];
    dateStringFilterPromise.$inject = ["authenticationService", "$q"];
    dateYearMonthStringFilter.$inject = ["authenticationService"];
    dateTimeStringFilter.$inject = ["authenticationService"];
    datetimeFilter.$inject = ["authenticationService"];
    dateYearMonthLongStrFilter.$inject = ["gettextCatalog"];
    angular
        .module('app.core')
        .filter('getIndex', getIndex)
        .filter('startOfWeek', startOfWeek)
        .filter('endOfWeek', endOfWeek)
        .filter('addDays', addDays)
        .filter('stringToMoment', stringToMoment)
        .filter('momentToString', momentToString)
        .filter('dateStringFilter', dateStringFilter)
        .filter('dateStringFilterPromise', dateStringFilterPromise)
        .filter('dateStringFilter2', dateStringFilter2)
        .filter('dateYearMonthStringFilter', dateYearMonthStringFilter)
        .filter('dateTimeStringFilter', dateTimeStringFilter)
        .filter('dateEventFilter', dateEventFilter)
        .filter('datetimeFilter', datetimeFilter)
        .filter('textByValueFromObjFilter', textByValueFromObjFilter)
        .filter('valueChangeFromObject', valueChangeFromObject)
        .filter('dateYearMonthFilter', dateYearMonthFilter)
        .filter('dateYearFilter', dateYearFilter)
        .filter('dateMonthFilter', dateMonthFilter)
        .filter('dateYearMonthLongStrFilter', dateYearMonthLongStrFilter)
        .filter('dateToISOFilter', dateToISOFilter)
        .filter('addImagePathToObject', addImagePathToObject);

    function addDays(authenticationService) {
        return function (sDate, addDays) {
            var lang = authenticationService.getAuthData().language;
            var mDate = null;
            if (!lang) {
                lang = 'hu';
            }
            if (lang == 'hu') {
                var mDate = moment(sDate, 'YYYY.MM.DD.');
            } else if (lang == 'en') {
                var mDate = moment(sDate, 'MM/DD/YYYY');
            }
            if (mDate && mDate['_isValid'] && mDate['_isAMomentObject']) {
                var mOffset = mDate.add(addDays, 'days');
                return mOffset.format('L');
            } else {
                return false;
            }
        };
    }

    function startOfWeek(authenticationService) {
        return function (sDate) {
            var lang = authenticationService.getAuthData().language;
            if (!lang) {
                lang = 'hu';
            }
            var mDate = null;
            if (lang == 'hu') {
                var mDate = moment(sDate, 'YYYY.MM.DD.');
            } else if (lang == 'en') {
                var mDate = moment(sDate, 'MM/DD/YYYY');
            }
            if (mDate && mDate['_isValid'] && mDate['_isAMomentObject']) {
                var mMonday = moment(mDate.startOf('isoweek'));
                return mMonday.format('L');
            } else {
                return false;
            }
        };
    }

    function endOfWeek(authenticationService) {
        return function (sDate) {
            var lang = authenticationService.getAuthData().language;
            if (!lang) {
                lang = 'hu';
            }
            var mDate = null;
            if (lang == 'hu') {
                var mDate = moment(sDate, 'YYYY.MM.DD.');
            } else if (lang == 'en') {
                var mDate = moment(sDate, 'MM/DD/YYYY');
            }
            if (mDate && mDate['_isValid'] && mDate['_isAMomentObject']) {
                var mMonday = moment(mDate.endOf('isoweek'));
                return mMonday.format('L');
            } else {
                return false;
            }
        };
    }

    function stringToMoment(authenticationService) {
        return function (sDate) {
            var lang = authenticationService.getAuthData().language;
            if (!lang) {
                lang = 'hu';
            }
            var mDate = null;
            if (lang == 'hu') {
                var mDate = moment(sDate, 'YYYY.MM.DD.');
            } else if (lang == 'en') {
                var mDate = moment(sDate, 'MM/DD/YYYY');
            }
            if (mDate && mDate['_isValid'] && mDate['_isAMomentObject']) {
                return mDate;
            } else {
                return false;
            }
        };
    }

    function momentToString() {
        return function (mDate) {
            if (mDate && mDate['_isValid'] && mDate['_isAMomentObject']) {
                return mDate.format('L');
            } else {
                return false;
            }
        };
    }

    function getIndex() {
        return function (list, property, findThis) {
            for (var i = 0; i < list.length; i++) {
                if (list[i][property] == findThis) {
                    return i;
                }
            }
            return false;
        };
    }

    function dateStringFilterPromise(authenticationService, $q) {
        return function (input, propertyTime) {
            return $q(function (resolve) {
                var lang = authenticationService.getAuthData().language;
                moment.locale(lang);
                if (arguments.length == 1) {
                    if (input) {
                        return moment(input).format('L');
                    } else {
                        resolve('');
                    }
                } else {
                    angular.forEach(input, function (value, key) {
                        if (!input[key][propertyTime]) {
                            input[key][propertyTime] = '';
                        } else {
                            input[key][propertyTime] = moment(input[key][propertyTime].slice(0, -(input[key][propertyTime].length - 10))).format('L');
                        }
                    });
                    resolve(input);
                }
            });
        };
    }

    function dateStringFilter(authenticationService) {
        return function (input, propertyTime) {
            var lang = authenticationService.getAuthData().language;
            moment.locale(lang);
            if (arguments.length == 1) {
                if (input) {
                    return moment(input).format('L');
                } else {
                    return '';
                }
            } else {
                angular.forEach(input, function (value, key) {
                    if (!input[key][propertyTime]) {
                        input[key][propertyTime] = '';
                    } else {
                        input[key][propertyTime] = moment(input[key][propertyTime].slice(0, -(input[key][propertyTime].length - 10))).format('L');
                    }
                });
                return input;
            }
        };
    }

    function dateYearMonthStringFilter(authenticationService) {
        return function (input, propertyTime) {
            var lang = authenticationService.getAuthData().language;
            moment.locale(lang);
            if (arguments.length == 1) {
                if (input) {
                    return moment(input).format('L');
                } else {
                    return '';
                }
            } else {
                angular.forEach(input, function (value, key) {
                    if (!input[key][propertyTime]) {
                        input[key][propertyTime] = '';
                    } else {
                        input[key][propertyTime] = moment(input[key][propertyTime].slice(0, -(input[key][propertyTime].length - 10))).format('YYYY. MMMM');
                    }
                });
                return input;
            }
        };
    }

    function dateTimeStringFilter(authenticationService) {
        return function (input, propertyTime) {
            var lang = authenticationService.getAuthData().language;
            moment.locale(lang);
            if (arguments.length == 1) {
                if (input) {
                    return moment(input).format('LLL');
                } else {
                    return '';
                }
            } else {
                angular.forEach(input, function (value, key) {
                    if (!input[key][propertyTime]) {
                        input[key][propertyTime] = '';
                    } else {
                        input[key][propertyTime] = moment(input[key][propertyTime]).format('LLL');
                    }
                });
                return input;
            }
        };
    }

    function dateStringFilter2() {
        return function (input, propertyTime) {
            angular.forEach(input, function (value, key) {
                var temp = moment(input[key][propertyTime]);
                if (temp.isValid()) {
                    input[key][propertyTime] = new Date(temp.format('YYYY'), temp.format('M') - 1, temp.format('D'), temp.format('h'), temp.format('m'), temp.format('s'));
                } else {
                    input[key][propertyTime] = '';
                }
            });
            return input;
        };
    }

    function dateEventFilter() {
        return function (input) {
            angular.forEach(input, function (value, key) {
                if (input[key]['Recurrence'] === 'False' || input[key]['Recurrence'] === 'false') {
                    input[key]['Recurrence'] = false;
                } else if (input[key]['Recurrence'] === 'True' || input[key]['Recurrence'] === 'true') {
                    input[key]['Recurrence'] = true;
                } else if (input[key]['Recurrence'] === '1') {
                    input[key]['Recurrence'] = 1;
                }
                if (!input[key]['StartTime']) {
                    input[key]['StartTime'] = '';
                } else {
                    input[key]['StartTime'] = new Date(moment(input[key]['StartTimeString']).format('YYYY'), moment(input[key]['StartTimeString']).format('M') - 1, moment(input[key]['StartTimeString']).format('D'), moment(input[key]['StartTimeString']).format('H'), moment(input[key]['StartTimeString']).format('m'));
                }
                if (!input[key]['EndTime']) {
                    input[key]['EndTime'] = '';
                } else {
                    input[key]['EndTime'] = new Date(moment(input[key]['EndTimeString']).format('YYYY'), moment(input[key]['EndTimeString']).format('M') - 1, moment(input[key]['EndTimeString']).format('D'), moment(input[key]['EndTimeString']).format('H'), moment(input[key]['EndTimeString']).format('m'));
                }
            });
            return input;
        };
    }

    function datetimeFilter(authenticationService) {
        return function (input) {
            var lang = authenticationService.getAuthData().language;
            moment.locale(lang);
            if (input) {
                input = moment(input.slice(0, -9)).format('L');
            }
            return input;
        };
    }

    /**
     * textByValueFromObjFilter()
     *
     * This function find first objet if object's value equal the input value
     * and return the object's text value
     */
    function textByValueFromObjFilter() {
        return function (input, input2) {
            var result = '';
            angular.forEach(input, function (value) {
                if (value.value === input2) {
                    result = value.text;
                }
            });
            return result;
        };
    }

    /**
     * Sportolo result modify
     * Comment
     */
    function valueChangeFromObject() {
        return function (input, input2) {
            var output = [];
            angular.forEach(input, function (value, key) {
                input[key] [input2] = input[key] [input2] + 3;
                output.push(input[key]);
            });
            return output;
        };
    }

    function addImagePathToObject() {
        return function (input, input2, input3) {
            var output = [];
            angular.forEach(input, function (value, key) {
                if (input[key] [input2] != null) {
                    input[key] [input2] = input3 + input[key] [input2];
                }
                output.push(input[key]);
            });
            return output;
        };
    }

    function dateYearMonthFilter() {
        return function (input, propertyTime) {
            angular.forEach(input, function (value, key) {
                if (!input[key][propertyTime]) {
                    input[key][propertyTime] = '';
                } else {
                    input[key][propertyTime] = moment(input[key][propertyTime].slice(0, -9)).format('YYYY-MM');
                }
            });
            return input;
        };
    }

    function dateYearFilter() {
        return function (input, propertyTime) {
            angular.forEach(input, function (value, key) {
                if (!input[key][propertyTime]) {
                    input[key][propertyTime] = '';
                } else {
                    input[key][propertyTime] = moment(input[key][propertyTime].slice(0, -9)).format('YYYY');
                }
            });
            return input;
        };
    }

    function dateMonthFilter() {
        return function (input, propertyTime) {
            angular.forEach(input, function (value, key) {
                if (!input[key][propertyTime]) {
                    input[key][propertyTime] = '';
                } else {
                    input[key][propertyTime] = moment(input[key][propertyTime].slice(0, -9)).format('MM');
                }
            });
            return input;
        };
    }

    function dateYearMonthLongStrFilter(gettextCatalog) {
        return function (input) {
            if (arguments.length == 1) { // TODO new Date v moment
                var d = moment(input);
                var year = d.format('YYYY');
                var month = d.format('M');
                var monthStr = '';
                switch (month) {
                    case '1':
                        monthStr = gettextCatalog.getString('January');
                        break;
                    case '2':
                        monthStr = gettextCatalog.getString('February');
                        break;
                    case '3':
                        monthStr = gettextCatalog.getString('March');
                        break;
                    case '4':
                        monthStr = gettextCatalog.getString('April');
                        break;
                    case '5':
                        monthStr = gettextCatalog.getString('May');
                        break;
                    case '6':
                        monthStr = gettextCatalog.getString('June');
                        break;
                    case '7':
                        monthStr = gettextCatalog.getString('July');
                        break;
                    case '8':
                        monthStr = gettextCatalog.getString('August');
                        break;
                    case '9':
                        monthStr = gettextCatalog.getString('September');
                        break;
                    case '10':
                        monthStr = gettextCatalog.getString('October');
                        break;
                    case '11':
                        monthStr = gettextCatalog.getString('November');
                        break;
                    case '12':
                        monthStr = gettextCatalog.getString('December');
                        break;
                    default:
                        monthStr = '';
                        break;
                }
                input = year + ' ' + monthStr;
                return input;
            }
            return input;
        };
    }

    function dateToISOFilter() {
        return function (input) {
            return moment(input, ['YYYY.MM.DD.', 'MM/DD/YYYY']).format('YYYY-MM-DD');
        };
    }
})();


(function () {
    'use strict';

    httpInterceptor.$inject = ["logger", "$q", "$rootScope", "AUTH_EVENTS", "DOMAIN", "idleService", "loader", "localStorageService", "$injector"];
    angular
        .module('app.core')
        .factory('httpInterceptor', httpInterceptor);

    function httpInterceptor(logger, $q, $rootScope, AUTH_EVENTS, DOMAIN, idleService, loader, localStorageService, $injector) {
        function Check(r, type) {
            // console.log('Check',r,type);
            switch (type){
                case 'request':
                    if (r && r.url && r.url.indexOf('LogClientSideException') === -1) {
                        return true;
                    }
                    break;
                case 'response':
                    return true;
                    break;
                case 'responseError':
                    return true;
                    break;
            }
            return false;
        }

        // Szerver oldali hibánál elküldi a kliens oldalon lévő adatokat is
        function LogServerSideException(ServerSideException, $injector) {
            if (!ServerSideException || ServerSideException == null || (ServerSideException && ServerSideException.toString().indexOf('LogClientSideException') !== -1)) {
                return;
            }
            var object = {
                ServerSideException: ServerSideException,
                vm: null,
                stateList: null,
                actualState: null,
                localStorage: null,
                title: null
            };
            var rootScope = $injector.get('$rootScope');
            var LS = $injector.get('localStorageService');
            var keys = LS.keys();
            var LSItems = [];
            keys.forEach(function (element) {
                LSItems.push(element + ': ' + LS.get(element));
            });
            object.localStorage = LSItems;
            object.actualState = rootScope.actualState;
            object.stateList = rootScope.stateList;
            object.title = rootScope.htmlTitle;
            object.ClientSideException = false;
            var cloneVM = $.extend(true, {}, rootScope.vm);
            var cloneVMkeys = Object.keys(cloneVM);
            cloneVMkeys.forEach(function (vmKey) {
                try {
                    JSON.stringify(cloneVM[vmKey]);
                }
                catch (err) {
                    cloneVM[vmKey] = null;
                }
            });
            object.vm = cloneVM;
            var jsonObject = JSON.stringify(object);
            var dataService = $injector.get('dataservice');
            dataService.sendLocalException(jsonObject).then(function () {});
        }

        function processRequest() {
            loader.delayedStart();
        }

        function processResponse() {
            loader.end();
        }

        return {
            request: function (config) {
                if (Check(config, 'request')) {
                    processRequest();
                }
                if (config.type === 'apiGET') {
                    config.method = 'GET';
                    config.headers['Content-Type'] = 'application/json; charset-utf-8';
                    var authData = localStorageService.get('_authData');
                    if (authData) {
                        config.headers.Authorization = 'Bearer ' + authData.access_token;
                    }
                    //config.timeout = 20000;
                } else if (config.type === 'apiPOST') {
                    config.method = 'POST';
                    config.headers['Content-Type'] = 'application/json; charset-utf-8';
                    var authData = localStorageService.get('_authData');
                    if (authData) {
                        config.headers.Authorization = 'Bearer ' + authData.access_token;
                    }
                    //config.timeout = 20000;
                } else if (config.type === 'apiTOKEN') {
                    config.method = 'POST';
                    config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                    //config.timeout = 20000;
                }
                if (config.timeout === 'undefined') {
                    config.timeout = 20000;
                }
                return config;
            },
            requestError: function () {
                processResponse();
            },
            response: function (response) {
                // console.log('=== response response ===',response);
                if (response.config.url.indexOf(DOMAIN.webService) >= 0) {
                    idleService.resetTimer();
                }
                if (response.data && response.data.error !== undefined) {
                    if (response.data.message) {
                        logger.info(response.data.message);
                    }
                    if (response.data.validationErrors) {
                        if (Check(response, 'response')) {
                            processResponse();
                        }
                        return $q.reject(response);
                        // return $q.resolve(response);
                    }
                    if (response.data.error !== '') {
                        if (response.data.error) {
                            response.data.error = response.data.error === '' ? 'Unexpected error occurred. Please try again, later.' : response.data.error;
                            logger.error(response.data.error, 'Error', response);
                        } else {
                            logger.error('Unexpected error occurred. Please try again, later.', 'Error', response);
                        }
                        if (Check(response, 'response')) {
                            processResponse();
                        }
                        return $q.reject(response);
                        // return $q.resolve(response);
                    } else {
                        if (Check(response, 'response')) {
                            processResponse();
                        }
                        return $q.resolve(response.data);
                    }
                }
                if (Check(response, 'response')) {
                    processResponse();
                }
                return response || $q.when(response);
            },
            responseError: function (rejection) {
                // console.log('=== responseError rejection ===',rejection);
                if (rejection.config && rejection.config.url.indexOf(DOMAIN.webService) >= 0) {
                    idleService.resetTimer();
                }
                if (rejection.status === 401) {
                    $rootScope.$broadcast(AUTH_EVENTS.notAuthorized);
                } else if (rejection.status === 404) {
                    $rootScope.$broadcast();
                } else if (rejection.data) {
                    if (rejection.data.error) {
                        rejection.data.error = rejection.data.error === '' ? 'Unexpected error occurred. Please try again, later.' : rejection.data.error;
                        logger.error(rejection.data.error, 'Error', rejection);
                    } else if (rejection.data.ExceptionMessage) {
                        logger.error(angular.isDefined(rejection.data.ExceptionMessage) ? rejection.data.ExceptionMessage : '', 'Error', rejection);
                    } else if (rejection.data.Message) {
                        logger.error((angular.isDefined(rejection.data.Message) ? rejection.data.Message : '') + ' ' + (angular.isDefined(rejection.data.MessageDetail) ? rejection.data.MessageDetail : ''), 'Error', rejection);
                    } else {
                        logger.error('Unexpected error occurred. Please try again, later.', 'Error', rejection);
                    }
                } else {
                    logger.error('Unexpected error occurred. Please try again, later.', 'Error', rejection);
                }

                if (Check(rejection, 'responseError')) {
                    processResponse();
                }

                if (rejection.status != -1 && (rejection && rejection.data && rejection.data.ExceptionType != 'System.Exception')) {
                    LogServerSideException(rejection.data.ExceptionMessage, $injector);
                }

                return $q.reject(rejection);
                // return $q.resolve(rejection); // Angular > 1.5.8
            }
        };
    }
})();

(function () {
    'use strict';

    idleService.$inject = ["$rootScope", "$timeout", "keepalive", "AUTH_EVENTS"];
    angular
        .module('app.core')
        .factory('idleService', idleService);

    function idleService($rootScope, $timeout, keepalive, AUTH_EVENTS) {
        var idleTimer = null;

        function stopTimer() {
            if (idleTimer) {
                $timeout.cancel(idleTimer);
            }
        }

        function timerExpiring() {
            stopTimer();
            $rootScope.$broadcast(AUTH_EVENTS.sessionTimeout);
        }

        function startTimer() {
            idleTimer = $timeout(timerExpiring, keepalive);
        }

        function resetTimer() {
            stopTimer();
            startTimer();
        }

        startTimer();
        return {
            startTimer: startTimer,
            stopTimer: stopTimer,
            resetTimer: resetTimer
        };
    }
})();

(function () {
    'use strict';

    loader.$inject = ["$timeout", "$rootScope"];
    angular
        .module('app.core')
        .factory('loader', loader);

    function loader($timeout, $rootScope) {
        var delayIn = 500;
        var delayOut = 250;
        var queue = [];
        var timerPromise = null;
        var timerPromiseHide = null;

        return {
            delayedStart: function () {
                queue.push({});
                if (queue.length === 1) {
                    timerPromise = $timeout(function () {
                        if (queue.length) {
                            showLoader();
                        }
                    }, delayIn);
                }
            },
            start: function () {
                queue.push({});
                if (queue.length === 1) {
                    showLoader();
                }
            },
            end: function () {
                queue.pop();
                if (queue.length === 0) {
                    timerPromiseHide = $timeout(function () {
                        if (queue.length === 0) {
                            hideLoader();
                            if (timerPromiseHide) {
                                $timeout.cancel(timerPromiseHide);
                            }
                        }
                    }, delayOut);
                }
            }
        };

        function showLoader() {
            $rootScope.loader = true;
        }

        function hideLoader() {
            if (timerPromise) {
                $timeout.cancel(timerPromise);
            }
            $rootScope.loader = false;
        }
    }
})();

(function () {
    'use strict';

    paramHelper.$inject = ["$q", "localStorageService", "log", "gettextCatalog", "authenticationService"];
    angular
        .module('app.core')
        .factory('paramHelper', paramHelper);

    function paramHelper($q, localStorageService, log, gettextCatalog, authenticationService) {
        return {
            setParams: setParams,
            getParams: getParams,
            removeParam: removeParam,
            removeAll: removeAll,
            setUserNameParams: setUserNameParams,
            getUserNameParams: getUserNameParams
        };

        // [{key: value}, {key: value}, ...]
        function setParams(params) {
            return $q(function (resolve) {
                angular.forEach(params, function (value) {
                    angular.forEach(value, function (value, key) {
                        //console.log(key + ': ' + value);
                        localStorageService.set(authenticationService.getAuthData().id + '.' + key, value);
                    });
                });
                resolve(true);
            });
        }

        // [{key: value}, {key: value}, ...]
        function setUserNameParams(userName, params) {
            return $q(function (resolve) {
                angular.forEach(params, function (value) {
                    angular.forEach(value, function (value, key) {
                        localStorageService.set(userName + '.' + key, value);
                    });
                });
                resolve(true);
            });
        }

        // [key, key, ...]
        function getUserNameParams(userName, params, optionalParams) {
            return $q(function (resolve, reject) {
                var result = [];
                angular.forEach(params, function (value) {
                    var temp = localStorageService.get(userName + '.' + value);
                    if (!temp) {
                        var noParam = gettextCatalog.getString('NoParam');
                        log.htmlError(noParam + ': ' + value);
                        reject();
                    } else {
                        result[value] = temp;
                    }
                });
                angular.forEach(optionalParams, function (value) {
                    result[value] = localStorageService.get(userName + '.' + value);
                });
                resolve(result);
            });
        }

        // [key, key, ...]
        function getParams(params, optionalParams) {
            return $q(function (resolve, reject) {
                var result = [];
                if (authenticationService.getAuthData() && authenticationService.getAuthData().id) {
                    angular.forEach(params, function (value) {
                        var temp = localStorageService.get(authenticationService.getAuthData().id + '.' + value);
                        if (!temp) {
                            var noParam = gettextCatalog.getString('NoParam');
                            log.htmlError(noParam + ': ' + value);
                            reject();
                        } else {
                            result[value] = temp;
                            //removeParam(value)
                        }
                    });
                    angular.forEach(optionalParams, function (value) {
                        result[value] = localStorageService.get(authenticationService.getAuthData().id + '.' + value);
                        //removeParam(value);
                    });
                }
                resolve(result);
            });
        }

        function removeParam(param) {
            localStorageService.remove(authenticationService.getAuthData().id + '.' + param);
        }

        function removeAll() {
            return localStorageService.clearAll();
        }
    }
})();

(function () {
    'use strict';

    validatorHelper.$inject = ["$q"];
    angular
        .module('app.core')
        .factory('validatorHelper', validatorHelper);

    function validatorHelper($q) {
        return {
            validate: validate
        };

        function validate(response, form) {
            return $q(function (resolve) {
                if (response.data.validationErrors) {
                    angular.forEach(response.data.validationErrors, function (value, key) {
                        var fieldName = key.substring(key.indexOf('.') + 1, key.length + 1);
                        if (form[fieldName]) {
                            if (value['_errors'][0]['<ErrorMessage>k__BackingField'] === 'required') {
                                form[fieldName].$setValidity('required', false);
                            }
                            if (value['_errors'][0]['<ErrorMessage>k__BackingField'] === 'maxlength') {
                                form[fieldName].$setValidity('maxlength', false);
                            }
                            if (value['_errors'][0]['<ErrorMessage>k__BackingField'] === 'minlength') {
                                form[fieldName].$setValidity('minlength', false);
                            }
                        }
                    });
                    return $q.reject(response);
                }
                resolve(true);
            });
        }
    }
})();

(function () {
    'use strict';

    DashboardController.$inject = ["$q", "dataservice", "log", "DOMAIN", "$location", "localStorageService", "paramHelper", "$state", "$scope", "authenticationService", "gettextCatalog", "$rootScope", "$filter", "$timeout"];
    angular
        .module('app.dashboard')
        .controller('DashboardController', DashboardController);

    function DashboardController($q, dataservice, log, DOMAIN, $location, localStorageService, paramHelper, $state, $scope, authenticationService, gettextCatalog, $rootScope, $filter, $timeout) {
        var vm = this;
        $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('MainPage');

        var printOpened = false;

        vm.messageCount = 0;
        vm.printDashboard = printDashboard;
        vm.clearLastViewedLinks = clearLastViewedLinks;
        //Grid nyomtatás, exportálás nyomógomb
        vm.datagridExpiringDocuments = [];
        vm.dataMonthlyAttendance = [];
        vm.columnsMonthlyAttendance = [];
        vm.dataMonthlyCompetitionPlan = [];
        vm.dataWeeklyCompetitionPlan = [];
        vm.columnsMonthlyCompetitionPlan = [];
        vm.dataYearlyCompetitionPlan = [];
        vm.columnsYearlyCompetitionPlan = [];
        vm.dataGridLinks = [];
        vm.columnsGridLinks = [];
        vm.dataUnpaidFees = [];
        vm.columnsUnpaidFees = [];
        vm.dataUnpaidFeesTrainer = [];
        vm.columnsUnpaidFeesTrainer = [];

        vm.goToNewUser = goToNewUser;
        vm.goToNewAthletes = goToNewAthletes;
        vm.goToNewAgeGroup = goToNewAgeGroup;
        vm.goToMonthlyAttendance = goToMonthlyAttendance;
        vm.goToMonthlyCompetitonPlan = goToMonthlyCompetitonPlan;
        vm.goToAnnualSeasonPlan = goToAnnualSeasonPlan;
        vm.openSportServiceFeeRegister = openSportServiceFeeRegister;
        vm.openSportServiceFeeArrears = openSportServiceFeeArrears;
        vm.openWeeklyPlan = openWeeklyPlan;
        vm.addNewLink = addNewLink;

        vm.editLink = editLink;
        vm.editLinkSave = editLinkSave;
        vm.deleteLink = deleteLink;
        vm.closeeditLinksWindow = closeeditLinksWindow;
        vm.closenewLinksWindow = closenewLinksWindow;
        vm.newLinkSave = newLinkSave;

        vm.MessageSeen = gettextCatalog.getString('MessageSeen');
        vm.ReadMessage = gettextCatalog.getString('ReadMessage');
        vm.MessageDelete = gettextCatalog.getString('MessageDelete');
        vm.LinkData = gettextCatalog.getString('LinkData');
        //Kell, mert script-ből nem veszi fel a fordítást
        vm.Edit = gettextCatalog.getString('Edit');
        vm.PayIn = gettextCatalog.getString('PayIn');

        vm.printing = false;

        vm.reportParameters = [];
        vm.printOptions = {
            messages: false,
            mthAttendance: false,
            mthCmptPlan: false,
            yrCmptPlan: false,
            unpayedFee: false,
            stat: false,
        };

        if (DOMAIN.justPsycho === 1) {
            $location.path('/athletesManagement/athletesList');
        }

        // gridek generálása
        // 1.
        vm.columnsgridExpiringDocuments = [];
        vm.columnsgridExpiringDocuments = [
            {
                field: 'EdzoNeve',
                headerText: gettextCatalog.getString('Coach'),
                textAlign: 'center',
                width: 120,
                template: '#datemplateDataColumn1'
            },
            {
                field: 'SzakosztalyNeve',
                headerText: gettextCatalog.getString('Section'),
                textAlign: 'center',
                width: 120
            },
            {
                field: 'KorosztalyNeve',
                headerText: gettextCatalog.getString('AgeGroup'),
                textAlign: 'center',
                width: 120
            },
            {
                field: 'SportoloNeve',
                headerText: gettextCatalog.getString('Athlete'),
                textAlign: 'center',
                width: 120,
                template: '#datemplateDataColumn2'
            },
            {
                field: 'Datum',
                headerText: gettextCatalog.getString('Date'),
                textAlign: 'center',
                width: 150
            },
            {
                field: 'Tipus',
                headerText: gettextCatalog.getString('Type'),
                textAlign: 'center',
                width: 150
            }
        ];
        var gridExpiringDocuments = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItems,
            allowTextWrap: true,
            allowPaging: true,
            allowSorting: true,
            allowExcelExport: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columnsgridExpiringDocuments,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#gridExpiringDocuments'), $scope);
                }
            }
        });

        gridExpiringDocuments.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, gridExpiringDocuments);
        };

        // 2.
        vm.columnsMonthlyAttendance = [];
        vm.columnsMonthlyAttendance = [
            {field: 'Id', visible: false, isPrimaryKey: true, isIdentity: true},
            {
                field: 'Link',
                headerText: '',
                textAlign: 'center',
                width: 60,
                template: '#datemplateDataColumn4'
            },
            {
                field: 'Edzo',
                headerText: gettextCatalog.getString('Coach'),
                textAlign: 'center',
                template: '#datemplateDataColumn3'
            },
            {
                field: 'Szakosztaly',
                headerText: gettextCatalog.getString('Section'),
                textAlign: 'center'
            },
            {
                field: 'Datum',
                headerText: gettextCatalog.getString('Date'),
                textAlign: 'center'
            },
            {
                field: 'CsoportLetszam',
                headerText: gettextCatalog.getString('groupStaffNumbers'),
                textAlign: 'center'
            },
            {
                field: 'Erkezett',
                headerText: gettextCatalog.getString('Arrived'),
                textAlign: 'center'
            },
            {
                field: 'Tavozott',
                headerText: gettextCatalog.getString('Departed'),
                textAlign: 'center'
            },
            {
                field: 'Megjegyzes',
                headerText: gettextCatalog.getString('Comment'),
                textAlign: 'center'
            }
        ];

        var gridMonthlyAttendance = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItems,
            allowTextWrap: true,
            allowPaging: true,
            allowSorting: true,
            allowExcelExport: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columnsMonthlyAttendance,
            beforePrint: $rootScope.beforePrintGrid,
            printComplete: $rootScope.printCompleteGrid,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#gridMonthlyAttendance'), $scope);
                }
            }
        });

        gridMonthlyAttendance.appendTo('#gridExpiringDocuments');
        gridMonthlyAttendance.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, gridMonthlyAttendance);
        };

        //3.
        vm.columnsMonthlyCompetitionPlan = [];
        vm.columnsMonthlyCompetitionPlan = [
            {field: 'Id', visible: false, isPrimaryKey: true, isIdentity: true},
            {
                field: 'Link',
                headerText: '',
                textAlign: 'center',
                width: 60,
                allowEditing: false,
                template: '#datemplateDataColumn6'
            },
            {
                field: 'Edzo',
                headerText: gettextCatalog.getString('Coach'),
                textAlign: 'center',
                allowEditing: false,
                template: '#datemplateDataColumn5'
            },
            {
                field: 'Szakosztaly',
                headerText: gettextCatalog.getString('Section'),
                textAlign: 'center',
                allowEditing: false
            },
            {
                field: 'Datum',
                headerText: gettextCatalog.getString('Date'),
                textAlign: 'center',
                allowEditing: false
            },
            {
                field: 'Megjegyzes',
                headerText: gettextCatalog.getString('Comment'),
                textAlign: 'center',
                allowEditing: false
            }
        ];
        vm.selectedRow = [];
        var gridMonthlyMonthlyCompetitionPlan = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItems,
            allowTextWrap: true,
            allowPaging: true,
            allowSorting: true,
            allowExcelExport: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columnsMonthlyCompetitionPlan,
            beforePrint: $rootScope.beforePrintGrid,
            printComplete: $rootScope.printCompleteGrid,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#gridMonthlyMonthlyCompetitionPlan'), $scope);
                }
            }
        });

        gridMonthlyMonthlyCompetitionPlan.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, gridMonthlyMonthlyCompetitionPlan);
        };

        //4.

        vm.columnsWeeklyCompetitionPlan = [];
        vm.columnsWeeklyCompetitionPlan = [
            {field: 'tervid', visible: false, isPrimaryKey: true, isIdentity: true},
            {
                field: 'Link',
                headerText: '',
                textAlign: 'center', width: 60, allowEditing: false,
                template: '#templateColumnETHetiLink'
            },
            {
                field: 'szakosztaly',
                headerText: gettextCatalog.getString('Section'),
                textAlign: 'center',
                allowEditing: false
            },
            {
                field: 'korcsoport',
                headerText: gettextCatalog.getString('AgeGroup'),
                textAlign: 'center',
                allowEditing: false
            },
            {
                field: 'edzo',
                headerText: gettextCatalog.getString('Coach'),
                textAlign: 'center',
                allowEditing: false,
                template: '#templateColumnETHetiEdzo'
            },
            {
                field: 'hetfo',
                headerText: gettextCatalog.getString('Monday'),
                textAlign: 'center',
                allowEditing: false
            },
            {
                field: 'vasarnap',
                headerText: gettextCatalog.getString('Sunday'),
                textAlign: 'center',
                allowEditing: false
            }
        ];

        var gridWeeklyCompetitionPlan = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItems,
            allowTextWrap: true,
            allowPaging: true,
            allowSorting: true,
            allowExcelExport: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columnsWeeklyCompetitionPlan,
            beforePrint: $rootScope.beforePrintGrid,
            printComplete: $rootScope.printCompleteGrid,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#gridWeeklyCompetitionPlan'), $scope);
                }
            }
        });

        gridWeeklyCompetitionPlan.appendTo('#gridWeeklyCompetitionPlan');
        gridWeeklyCompetitionPlan.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, gridWeeklyCompetitionPlan);
        };

        //5.

        vm.columnsYearlyCompetitionPlan = [];
        vm.columnsYearlyCompetitionPlan = [
            {field: 'Id', visible: false, isPrimaryKey: true, isIdentity: true},
            {
                field: 'Link',
                headerText: '',
                textAlign: 'center',
                width: 60,
                allowEditing: false,
                template: '#datemplateDataColumn8'
            },
            {
                field: 'Edzo',
                headerText: gettextCatalog.getString('Coach'),
                textAlign: 'center',
                allowEditing: false,
                template: '#datemplateDataColumn7'
            },
            {
                field: 'Szakosztaly',
                headerText: gettextCatalog.getString('Section'),
                textAlign: 'center',
                allowEditing: false
            },
            {
                field: 'Korosztaly',
                headerText: gettextCatalog.getString('AgeGroup'),
                textAlign: 'center',
                allowEditing: false
            }
        ];

        var gridYearlyCompetitionPlan = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItems,
            allowTextWrap: true,
            allowPaging: true,
            allowSorting: true,
            allowExcelExport: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columnsYearlyCompetitionPlan,
            beforePrint: $rootScope.beforePrintGrid,
            printComplete: $rootScope.printCompleteGrid,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#gridYearlyCompetitionPlan'), $scope);
                }
            }
        });

        gridYearlyCompetitionPlan.appendTo('#gridYearlyCompetitionPlan');
        gridYearlyCompetitionPlan.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, gridYearlyCompetitionPlan);
        };

        //6.
        vm.columnsUnpaidFees = [];
        vm.columnsUnpaidFees = [
            {
                field: 'Link',
                headerText: '',
                textAlign: 'center',
                width: 60,
                allowEditing: false,
                template: '#datemplateDataColumn11'
            },
            {
                field: 'EdzoNeve',
                headerText: gettextCatalog.getString('Coach'),
                textAlign: 'center',
                allowEditing: false,
                template: '#datemplateDataColumn9'
            },
            {
                field: 'SzakosztalyNeve',
                headerText: gettextCatalog.getString('Section'),
                textAlign: 'center',
                allowEditing: false
            },
            {
                field: 'Egyenleg',
                headerText: gettextCatalog.getString('Balance'),
                textAlign: 'center',
                allowEditing: false
            },
            {
                field: 'Link1',
                headerText: gettextCatalog.getString('PayIn'),
                textAlign: 'center',
                allowEditing: false,
                template: '#datemplateDataColumn10'
            }
        ];

        var gridUnpaidFees = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItems,
            allowTextWrap: true,
            allowPaging: true,
            allowSorting: true,
            allowExcelExport: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columnsUnpaidFees,
            beforePrint: function (args) {
                $rootScope.beforePrintGrid(args, ['Link', 'Link1']);
            },
            printComplete: function (args) {
                $rootScope.printCompleteGrid(args, ['Link', 'Link1']);
            },
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#gridUnpaidFees'), $scope);
                }
            }
        });

        gridUnpaidFees.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, gridUnpaidFees);
        };

        //6.1.

        vm.columnsUnpaidFeesTrainer = [];
        vm.columnsUnpaidFeesTrainer = [
            {
                field: 'SportoloNeve',
                headerText: gettextCatalog.getString('Athlete'),
                textAlign: 'center',
                width: 120,
                allowEditing: false,
                template: '#datemplateDataColumn12'
            },
            {
                field: 'SzuletesiIdo',
                headerText: gettextCatalog.getString('BirthDate'),
                textAlign: 'center',
                width: 120,
                allowEditing: false
            },
            {
                field: 'Aktiv',
                headerText: gettextCatalog.getString('Active'),
                textAlign: 'center',
                width: 120,
                allowEditing: false,
                template: '#datemplateDataColumn13'
            },
            {
                field: 'Evfolyam',
                headerText: gettextCatalog.getString('SchoolYear'),
                textAlign: 'center',
                width: 120,
                allowEditing: false
            },
            {
                field: 'Befizetett',
                headerText: gettextCatalog.getString('PayIn'),
                textAlign: 'center',
                width: 120,
                allowEditing: false
            },
            {
                field: 'OktDijak',
                headerText: gettextCatalog.getString('EducationalFee'),
                textAlign: 'center',
                width: 120,
                allowEditing: false
            },
            {
                field: 'Egyenleg',
                headerText: gettextCatalog.getString('Balance'),
                textAlign: 'center',
                width: 120,
                allowEditing: false
            }
        ];

        var gridUnpaidFeesTrainer = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItems,
            allowTextWrap: true,
            allowPaging: true,
            allowSorting: true,
            allowExcelExport: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columnsUnpaidFeesTrainer,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#gridUnpaidFeesTrainer'), $scope);
                }
            }
        });

        gridUnpaidFeesTrainer.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, gridUnpaidFeesTrainer);
        };

        //7.
        vm.columnsGridLinks = [];
        vm.columnsGridLinks = [
            {field: 'Id', visible: false, isPrimaryKey: true, isIdentity: true},
            {
                field: 'Hivatkozas',
                headerText: gettextCatalog.getString('Link'),
                textAlign: 'center',
                width: 120,
                allowEditing: false,
                template: '#datemplateDataColumn14'
            },
            {
                field: 'Megjegyzes',
                headerText: gettextCatalog.getString('Comment'),
                textAlign: 'center',
                width: 120,
                allowEditing: false
            },
            {
                field: 'Link',
                headerText: gettextCatalog.getString('LinkDesc'),
                textAlign: 'center',
                width: 120,
                allowEditing: false
            },
            {
                headerText: gettextCatalog.getString('Edit'), textAlign: 'center', width: 120, allowEditing: false,
                template: '#datemplateDataColumn15'
            }
        ];

        var gridLinks = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItems,
            allowTextWrap: true,
            allowPaging: true,
            allowSorting: true,
            allowExcelExport: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columnsGridLinks,
            beforePrint: $rootScope.beforePrintGrid,
            printComplete: $rootScope.printCompleteGrid,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#gridLinks'), $scope);
                }
            }
        });
        gridLinks.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, gridLinks);
        };

        activate();

        function activate() {
            if (!localStorageService.get('_authData')) {
                return;
            }

            $q.all([
                authenticationService.getRight('EDZO'),
                authenticationService.getRight('ADMIN'),
                authenticationService.getRight('SZAKOSZTVEZ'),
                authenticationService.getRight('TECHIGAZGATO'),
                authenticationService.getRight('HJALAIR1'),
                authenticationService.getRight('HAVIVERSTALAIR1'),
                authenticationService.getRight('EVVERSTALAIR1'),
                authenticationService.getRight('MEGTFELH'),
                authenticationService.getRight('MODSPORTOLO'),
                authenticationService.getRight('MODKOROKEZ'),
                authenticationService.getRight('MEGTHAVIJEL'),
                authenticationService.getRight('MEGTHAVIVERST'),
                authenticationService.getRight('MEGTEVVERST'),
                authenticationService.getRight('MODSPORTOLO'),
                authenticationService.getRight('FOLAPLINKEK'),
                getSystemSettings('FOLAPOLVASATLANOK'),
                getSystemSettings('FOLAPNYOMTATAS'),
                getSystemSettings('FOLAPELFOGADASRAVAROJELENLETIK'),
                getSystemSettings('FOLAPELFOGADASRAVAROHAVITERVEK'),
                getSystemSettings('FOLAPELFOGADASRAVAROEVESTERVEK'),
                getSystemSettings('FOLAPKIFIZETETLENTAGDIJAK'),
                getSystemSettings('FOLAPLINKEK'),
                getSystemSettings('FOLAPLEJARO'),
                getSystemSettings('FOLAPELFOGADASRAVAROHETITERV'),
                authenticationService.getRight('UZENETMEGT')
            ]).then(function (results) {
                vm.EDZO = results[0];
                vm.ADMIN = results[1];
                vm.SZAKOSZTVEZ = results[2];
                vm.TECHIGAZGATO = results[3];
                vm.HJALAIR1 = results[4];
                vm.HAVIVERSTALAIR1 = results[5];
                vm.EVVERSTALAIR1 = results[6];
                vm.MEGTFELH = results[7];
                vm.MODSPORTOLO = results[8];
                vm.MODKOROKEZ = results[9];
                vm.MEGTHAVIJEL = results[10];
                vm.MEGTHAVIVERST = results[11];
                vm.MEGTEVVERST = results[12];
                vm.MODSPORTOLO = results[13];
                vm.FOLAPLINKEK = results[14];
                vm.FOLAPOLVASATLANOK = results[15];
                vm.FOLAPNYOMTATAS = results[16];
                vm.FOLAPELFOGADASRAVAROJELENLETIK = results[17];
                vm.FOLAPELFOGADASRAVAROHAVITERVEK = results[18];
                vm.FOLAPELFOGADASRAVAROEVESTERVEK = results[19];
                vm.FOLAPKIFIZETETLENTAGDIJAK = results[20];
                //vm.FOLAPLINKEK = results[21];
                vm.FOLAPLEJARO = results[22];
                vm.FOLAPELFOGADASRAVAROHETITERV = results[23];
                vm.UZENETMEGT = results[24];

                dataservice.getUnAcceptedMonthlyAttendance().then(function (data) {
                    vm.dataMonthlyAttendance = data.itemsList;
                    gridMonthlyAttendance.dataSource = data.itemsList;
                    $timeout(function () {
                        gridMonthlyAttendance.appendTo('#gridMonthlyAttendance');
                    }, 100);
                });
                dataservice.getUnAcceptedMonthlyCompetitionPlan().then(function (data) {
                    vm.dataMonthlyCompetitionPlan = data.itemsList;
                    gridMonthlyMonthlyCompetitionPlan.dataSource = vm.dataMonthlyCompetitionPlan;
                    $timeout(function () {
                        gridMonthlyMonthlyCompetitionPlan.appendTo('#gridMonthlyMonthlyCompetitionPlan');
                    }, 100);
                });
                if (vm.FOLAPELFOGADASRAVAROHETITERV) {
                    dataservice.getUnAcceptedWeeklyCompetitionPlan().then(function (data) {
                        vm.FOLAPELFOGADASRAVAROHETITERV = data.isAdmin || data.isSectionLeader;
                        var dataList = data.itemsList;
                        dataList = $filter('dateStringFilter')(dataList, 'hetfo');
                        dataList = $filter('dateStringFilter')(dataList, 'vasarnap');
                        gridWeeklyCompetitionPlan.dataSource = dataList;
                        vm.dataWeeklyCompetitionPlan = dataList;
                        $timeout(function () {
                            gridWeeklyCompetitionPlan.appendTo('#gridWeeklyCompetitionPlan');
                        }, 100);
                    });
                }
                dataservice.getUnAcceptedYearlyCompetitionPlan().then(function (data) {
                    vm.dataYearlyCompetitionPlan = data.itemsList;
                    gridYearlyCompetitionPlan.dataSource = data.itemsList;
                    $timeout(function () {
                        gridYearlyCompetitionPlan.appendTo('#gridYearlyCompetitionPlan');
                    }, 100);
                });
                if (vm.FOLAPLINKEK) {
                    $timeout(function () {
                        gridLinks.appendTo('#gridLinks');
                        getLinks();
                    }, 100);
                }
                if (vm.ADMIN || vm.SZAKOSZTVEZ || vm.TECHIGAZGATO) {
                    dataservice.getUnPaidFees().then(function (data) {
                        vm.dataUnpaidFees = data.itemsList;
                        gridUnpaidFees.dataSource = data.itemsList;
                        $timeout(function () {
                            gridUnpaidFees.appendTo('#gridUnpaidFees');
                        }, 100);
                    });
                } else {
                    dataservice.getUnPaidFeesTrainer().then(function (data) {
                        vm.dataUnpaidFeesTrainer = data.itemsList;
                        gridUnpaidFeesTrainer.dataSource = data.itemsList;
                        $timeout(function () {
                            gridUnpaidFeesTrainer.appendTo('#gridUnpaidFeesTrainer');
                        }, 100);
                    });
                }

                dataservice.ExpiringDocuments().then(function (data) {
                    data.itemsList = $filter('dateStringFilter')(data.itemsList, 'Datum');
                    gridExpiringDocuments.dataSource = data.itemsList;
                    vm.datagridExpiringDocuments = data.itemsList;
                    //generálás csak a div létrehozása után lehet ami csak az ng-if után futhat le
                    $timeout(function () {
                        gridExpiringDocuments.appendTo('#gridExpiringDocuments');
                    }, 100);
                });
            });
        }

        function getSystemSettings(valtozo) {
            return dataservice.getSystemSettings(valtozo).then(function (response) {
                return response.retValue;
            });
        }

        function openSportServiceFeeRegister(sectionId, coachId) {
            var currentYear = new Date().getFullYear();
            paramHelper.setParams([
                {'sportServiceFeeRegister.sectionId': sectionId},
                {'sportServiceFeeRegister.coachId': coachId},
                {'sportServiceFeeRegister.year': currentYear}
            ]);
            $state.go('business.sportServiceFeeRegister');
        }

        function openSportServiceFeeArrears(sectionId, coachId) {
            var currentYear = new Date().getFullYear();
            paramHelper.setParams([
                {'sportServiceFeeArrears.sectionId': sectionId},
                {'sportServiceFeeArrears.coachId': coachId},
                {'sportServiceFeeArrears.year': currentYear}
            ]);
            $state.go('business.sportServiceFeeArrears');
        }

        function openWeeklyPlan(tervid) {
            paramHelper.setParams([
                {'weeklyTrainingPlan.trainingPlanId': tervid}
            ]);
            $state.go('administration.weeklyTrainingPlan.weeklyTrainingPlanReport');
        }

        function goToNewUser(edzoId) {
            if (!vm.MEGTFELH) {
                log.permissionError();
                return;
            }
            paramHelper.setParams([{'newUser.userId': edzoId}]);
            $state.go('settings.userManagement.modifyUser');
        }

        function goToNewAgeGroup(ageGroupId) {
            if (!vm.MODKOROKEZ) {
                log.permissionError();
                return;
            }
            paramHelper.setParams([{'ageGroups.ageGroup': ageGroupId}]);
            $state.go('athletes.ageGroups.modifyAgeGroup');
        }

        function goToNewAthletes(athleteId) {
            if (!vm.MODSPORTOLO) {
                log.permissionError();
                return;
            }
            paramHelper.setParams([{'athleteModify.sportoloId': athleteId}]);
            $state.go('athletes.athletesManagement.athleteModify.dataSheet');
        }

        function goToMonthlyAttendance(maId) {
            if (!vm.MEGTHAVIJEL) {
                log.permissionError();
                return;
            }
            paramHelper.setParams([{'monthlyAttendance.id': maId}]);
            $state.go('administration.monthlyAttendance.monthlyAttendanceReport');
        }

        function goToAnnualSeasonPlan(asId) {
            if (!vm.MEGTEVVERST) {
                log.permissionError();
                return;
            }
            paramHelper.setParams([{'AnnualSeasonPlanReport.Id': asId}]);
            $state.go('administration.annualSeasonPlan.annualSeasonPlanReportPage1');
        }

        function goToMonthlyCompetitonPlan(mcpId, edzoId, szakosztalyId) {
            if (!vm.MEGTHAVIVERST) {
                log.permissionError();
                return;
            }
            var result = gridMonthlyMonthlyCompetitionPlan.dataSource.filter(function (v) {
                if (v.Id === mcpId) {
                    return v;
                }
            });
            paramHelper.setParams([{'competitiveMonthlyPlan.edzoId': edzoId},
                {'competitiveMonthlyPlan.edzoNev': result[0].Edzo},
                {'competitiveMonthlyPlan.szakosztalyNev': result[0].Szakosztaly},
                {'competitiveMonthlyPlan.szakosztalyId': szakosztalyId}, {'competitiveMonthlyPlan.competitivePlanId': mcpId}
            ]);
            $state.go('administration.competitiveMonthlyPlan.competitiveMonthlyPlanReport');
        }

        function printDashboard() {
            var existChecked = false;
            angular.forEach(vm.printOptions, function (value) {
                if (value) {
                    existChecked = true;
                }
            });

            if (existChecked === false) {
                log.errorMsg(gettextCatalog.getString('NoSelectedItemToPrint'));
                return;
            }
            vm.reportParameters = {
                'evesVers': vm.printOptions.yrCmptPlan,
                'felhasznalo': authenticationService.getAuthData().userFullName,
                'FelhasznaloId': authenticationService.getAuthData().id,
                'havijel': vm.printOptions.mthAttendance,
                'haviVers': vm.printOptions.mthCmptPlan,
                'nemBefTd': vm.printOptions.unpayedFee,
                'statisztika': vm.printOptions.stat,
                'szakosztTd': 'false',
                'uzenet': vm.printOptions.messages
            };
            $scope.$apply();

            if (printOpened) {
                angular.element('#printDialog').ejDialog('open');
            } else {
                printOpened = true;
                angular.element('#printDialog').ejDialog({
                    height: '99%',
                    width: '99%',
                    enablemodal: 'true',
                    'position-x': '0',
                    'position-y': '1',
                    target: '#mainContent',
                    enableresize: 'false'
                });
            }
        }

        function clearLastViewedLinks() {
            // Todo: isolated storage-be rakni a linket/onnan visszatölteni/törölni
        }

        function addNewLink() {
            if (!vm.FOLAPLINKEK) {
                log.permissionError();
                return;
            }
            var dialogObj = angular.element('#newlink').data('ejDialog');
            dialogObj.open();
        }

        function closenewLinksWindow() {
            var dialogObj = angular.element('#newlink').data('ejDialog');
            dialogObj.close();
        }

        function newLinkSave() {
            if (!vm.FOLAPLINKEK) {
                log.permissionError();
                return;
            }
            var dialogObj = angular.element('#newlink').data('ejDialog');
            dialogObj.close();
            if (vm.newLink && vm.newLink.Hivatkozas && vm.newLink.Hivatkozas.length > 0) {
                dataservice.saveNewLink(vm.newLink).then(function () {
                    getLinks();
                    log.successMsg('NewLinkSaved');
                    vm.newLink.Hivatkozas = '';
                    vm.newLink.Link = '';
                    vm.newLink.Megjegyzes = '';
                });
            } else {
                log.errorMsg(gettextCatalog.getString('EmptyLinkAddressCannotBeSaved'));
            }
        }

        function editLink(args) {
            if (!vm.FOLAPLINKEK) {
                log.permissionError();
                return;
            }
            var db = gridLinks.dataSource.length;

            for (var rec = 0; rec < db; rec++) {
                if (gridLinks.dataSource[rec].Id === args) {
                    vm.editedLink = gridLinks.dataSource[rec];
                    break;
                }
            }
            var dialogObj = angular.element('#editLinks').data('ejDialog');
            dialogObj.open();
        }

        function editLinkSave() {
            if (!vm.FOLAPLINKEK) {
                log.permissionError();
                return;
            }
            dataservice.saveLink(vm.editedLink).then(function () {
                getLinks();
                // var db = gridLinks.dataSource.length;
                // for (var rec = 0; rec < db; rec++) {
                //     if (gridLinks.dataSource[rec].Id === vm.editedLink.Id) {
                //         gridLinks.dataSource[rec] = vm.editedLink;
                //         vm.dataGridLinks[rec] = vm.editedLink;
                //
                //             console.log('save', gridLinks.dataSource);
                //             gridLinks.appendTo('#gridLinks');
                //     }
                // }
                closeeditLinksWindow();
                log.successMsg('LinkSaved');
            });
        }

        function deleteLink(arg) {
            if (!vm.FOLAPLINKEK) {
                log.permissionError();
                return;
            }
            swal({
                title: gettextCatalog.getString('Are you sure you want to delete the selected link?'),
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: gettextCatalog.getString('Yes, delete this link'),
                cancelButtonText: gettextCatalog.getString('Cancel'),
                closeOnConfirm: false,
                closeOnCancel: false
            }).then(function (isConfirm) {
                if (isConfirm.value) {
                    var p = {};
                    p.Id = arg;
                    dataservice.deleteLink(p).then(function () {
                        log.successMsg('LinkDeleted');
                        getLinks();
                    });
                }
            });
        }

        //Felugró ablak 'Mégsem' gomb click
        function closeeditLinksWindow() {
            var dialogObj = angular.element('#editLinks').data('ejDialog');
            dialogObj.close();
        }

        function getLinks() {
            dataservice.getLinks().then(function (data) {
                gridLinks.dataSource = data.itemsList;
            });
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.dashboard')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'dashboard',
                config: {
                    url: '/',
                    templateUrl: 'app/dashboard/dashboard.html',
                    controller: 'DashboardController',
                    controllerAs: 'vm',
                    title: 'Dashboard',
                    settings: {
                        navId: 8,
                        level: 1,
                        order: 8,
                        parentId: 0,
                        content: 'Dashboard'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    angular
        .module('app.layout')
        .directive('htSidebar', htSidebar);

    /* @ngInject */
    function htSidebar() {
        // Opens and closes the sidebar menu.
        // Usage:
        //  <div ht-sidebar">
        //  <div ht-sidebar whenDoneAnimating="vm.sidebarReady()">
        // Creates:
        //  <div ht-sidebar class="sidebar">
        return {
            link: link,
            restrict: 'EA',
            scope: {
                whenDoneAnimating: '&?'
            }
        };

        function link(scope, element) {
            var dropClass = 'dropy';
            var openMobile = 'open';
            var $sidebarInner = element.find('.sidebar-inner');
            var $dropdownElement = element.find('.sidebar-dropdown a');

            element.addClass('sidebar');
            $dropdownElement.click(dropdown);
            scope.$on('autoCloseSideBar', closeSideBar);

            function openSideBar() {
                $('.sidebar').css({'height': '460px'});
                $sidebarInner.addClass(openMobile);
                $sidebarInner.slideDown(350, scope.whenDoneAnimating);
                $dropdownElement.addClass(dropClass);
            }

            function closeSideBar() {
                $sidebarInner.removeClass(openMobile);
                $sidebarInner.slideUp(350, scope.whenDoneAnimating);
                $('.sidebar').css({'height': 'auto'});
                $dropdownElement.removeClass(dropClass);
            }

            function dropdown(e) {
                e.preventDefault();
                if (!$dropdownElement.hasClass(dropClass)) {
                    openSideBar();
                } else if ($dropdownElement.hasClass(dropClass)) {
                    closeSideBar();
                }
            }
        }
    }
})();

(function () {
    'use strict';

    ShellController.$inject = ["$rootScope", "$q", "config", "logger", "authenticationService", "$state", "AUTH_EVENTS", "LAYOUT_EVENTS", "gettextCatalog", "LANG_EVENTS", "$scope", "routerHelper", "DOMAIN", "loader", "$compile", "$window", "paramHelper", "dataservice", "$timeout", "localStorageService", "log", "$interval"];
    angular
        .module('app.layout')
        .run(["$trace", "$transitions", "authenticationService", "localStorageService", "$q", "$rootScope", "gettextCatalog", "routerHelper", "DOMAIN", function ($trace, $transitions, authenticationService, localStorageService, $q, $rootScope, gettextCatalog, routerHelper, DOMAIN) {
            $rootScope.availableLanguages = ['hu', 'en', 'ro', 'fr'];
            $transitions.onBefore({}, function () {
                return $q(function (resolve) {
                    var states = routerHelper.getStates();

                    function getNavRoutes() {
                        return $q(function (resolve) {
                            var authData = authenticationService.getAuthData();

                            var lang = $rootScope.availableLanguages[0];
                            if (authData) {
                                lang = authenticationService.getAuthData().language;
                            }

                            $rootScope.navRoutes = states.filter(function (r) {
                                if (DOMAIN.justPsycho === 1) {
                                    return r.settings && r.settings.level && r.settings.level === 1 && !r.settings.parentId && r.settings.navId && r.settings.navId === 1;
                                } else {
                                    return r.settings && r.settings.level && r.settings.level === 1 && !r.settings.parentId && r.settings.navId;
                                }
                            }).sort(function (r1, r2) {
                                return r1.settings.order - r2.settings.order;
                            });
                            angular.forEach($rootScope.navRoutes, function (value) {
                                if (value.settings) {
                                    value.settings.childRoutes = states.filter(function (r) {
                                        if (DOMAIN.justPsycho === 1) {
                                            return r.settings && r.settings.level && r.settings.level === 2 && r.settings.parentId && r.settings.parentId === value.settings.navId && r.settings.navId && r.settings.navId === 24;
                                        } else {
                                            return r.settings && r.settings.level && r.settings.level === 2 && r.settings.parentId && r.settings.parentId === value.settings.navId && r.settings.navId;
                                        }
                                    }).sort(function (r1, r2) {
                                        if (r1.settings['orderTitle_' + lang]) {
                                            return r1.settings['orderTitle_' + lang].localeCompare(r2.settings['orderTitle_' + lang]);
                                        } else {
                                            return r1.settings.order - r2.settings.order;
                                        }
                                    });
                                    angular.forEach(value.settings.childRoutes, function (value) {
                                        if (value.settings) {
                                            value.settings.childRoutes = states.filter(function (r) {
                                                if (DOMAIN.justPsycho === 1) {
                                                    return r.settings && r.settings.level && r.settings.level === 3 && r.settings.parentId && r.settings.parentId === value.settings.navId && r.settings.navId && r.settings.navId === 24;
                                                } else {
                                                    return r.settings && r.settings.level && r.settings.level === 3 && r.settings.parentId && r.settings.parentId === value.settings.navId && r.settings.navId;
                                                }
                                            }).sort(function (r1, r2) {
                                                if (r1.settings['orderTitle_' + lang]) {
                                                    return r1.settings['orderTitle_' + lang].localeCompare(r2.settings['orderTitle_' + lang]);
                                                } else {
                                                    return r1.settings.order - r2.settings.order;
                                                }
                                            });
                                        }
                                    });
                                }
                            });
                            resolve();
                        });
                    }

                    $rootScope.setLanguage = function setLanguage(language) {
                        return $q(function (resolve) {
                            var defaultLang = true;
                            for (var i = 0; i < $rootScope.availableLanguages.length; i++) {
                                if (language.toLowerCase().indexOf($rootScope.availableLanguages[i]) >= 0) {
                                    language = $rootScope.availableLanguages[i];
                                    defaultLang = false;
                                }
                            }

                            if (defaultLang) {
                                language = $rootScope.availableLanguages[0];
                            }

                            if (language.value) {
                                language = language.value;
                            }
                            $rootScope.language = language;

                            var a1 = gettextCatalog.getString('Item');
                            var a2 = gettextCatalog.getString('Items');

                            gettextCatalog.loadRemote('/languages/' + language + '.json').then(function () {
                                gettextCatalog.setCurrentLanguage(language);

                                ej2.base.L10n.load({
                                    'hu-HU': {
                                        'grid': {
                                            // 'EmptyRecord': 'Nincs megjeleníthető adat!',
                                            EmptyRecord: gettextCatalog.getString('EmptyRecord'),
                                            BatchSaveConfirm: gettextCatalog.getString('BatchSaveConfirm'),
                                            SaveButton: gettextCatalog.getString('Save'),
                                            OkButton: 'Rendben',
                                            CancelButton: gettextCatalog.getString('Cancel'),
                                            ConfirmDelete: gettextCatalog.getString('ChangesAutomaticallySaved'),
                                            BatchSaveLostChanges: gettextCatalog.getString('Unsaved changes will be lost. Are you sure you want to continue?'),
                                            Item: gettextCatalog.getString('Item'),
                                            Items: gettextCatalog.getString('Item'),
                                            GroupDropArea: gettextCatalog.getString('GroupDropArea'),
                                            Print: gettextCatalog.getString('Print'),
                                            Delete: gettextCatalog.getString('Delete'),
                                            ExcelExport: 'Excel Export',
                                            Search: gettextCatalog.getString('Search'),
                                            DatePickerWaterMark: gettextCatalog.getString('SelectTheDate'),
                                        },
                                        'pager': {
                                            currentPageInfo: '{0}. ' + gettextCatalog.getString('gridPage') + ': {1} ' + gettextCatalog.getString('gridPages'),
                                            totalItemsInfo: '(' + gettextCatalog.getString('allItems') + ': {0})',
                                            pagerDropDown: gettextCatalog.getString('RecordPerPage'),
                                            pagerInfo: gettextCatalog.getString('pagerInfo'), // "{0} {1} lapok ({2} elem)",
                                            firstPageTooltip: gettextCatalog.getString('firstPageTooltip'), //  "Ugrás az első oldalra",
                                            lastPageTooltip: gettextCatalog.getString('lastPageTooltip'), //"Ugrás az utolsó oldalra",
                                            nextPageTooltip: gettextCatalog.getString('nextPageTooltip'), //"Ugrás a következő oldalra",
                                            previousPageTooltip: gettextCatalog.getString('previousPageTooltip'), //"Ugrás az előző oldalra",
                                            nextPagerTooltip: gettextCatalog.getString('nextPagerTooltip'), //"Ugrás a következő oldalra",
                                            previousPagerTooltip: gettextCatalog.getString('previousPagerTooltip'), //"Ugrás az előző oldalra"
                                        }
                                    }
                                });

                                ej.Pager.Locale['hu-HU'] = {
                                    pagerInfo: '{0}/{1} ' + gettextCatalog.getString('Page') + ' (' + gettextCatalog.getString('ResultsNumber') + ': {2})'
                                };
                                ej.DatePicker.Locale['hu-HU'] = {
                                    watermarkText: gettextCatalog.getString('ChooseDate'),
                                    buttonText: gettextCatalog.getString('Today')
                                };
                                ej.Autocomplete.Locale['hu-HU'] = {
                                    addNewText: gettextCatalog.getString('addNewText'),// "Új hozzáadása",
                                    emptyResultText: gettextCatalog.getString('emptyResultText') // "Nincs javaslat",
                                };
                                ej.CurrencyTextbox.Locale['hu-HU'] = {
                                    watermarkText: gettextCatalog.getString('currencyTextboxWatermarkText') // "Írja be az értéket",
                                };
                                ej.DatePicker.Locale['hu-HU'] = {
                                    watermarkText: gettextCatalog.getString('datePickerWatermarkText'), //"Válassza ki a dátumot",
                                    buttonText: 'Ma',
                                };
                                ej.DateTimePicker.Locale['hu-HU'] = {
                                    watermarkText: gettextCatalog.getString('dateTimePickerWatermarkText'),// "Válassza ki a dátumot és időt",
                                    buttonText: {
                                        today: gettextCatalog.getString('today'), // "Ma",
                                        timeNow: gettextCatalog.getString('timeNow'),// "Most",
                                        done: gettextCatalog.getString('done'),//"Kész",
                                        timeTitle: gettextCatalog.getString('timeTitle')//"Idő"
                                    },
                                };
                                ej.Dialog.Locale['hu-HU'] = {
                                    tooltip: {
                                        close: gettextCatalog.getString('close'), //"Bezárás",
                                        collapse: gettextCatalog.getString('collapse'), //"Összecsuk",
                                        restore: gettextCatalog.getString('restore'), // "Kinyit",
                                        maximize: gettextCatalog.getString('maximize'), // "Teljes méret",
                                        minimize: gettextCatalog.getString('minimize'), //"Kis méret",
                                        expand: gettextCatalog.getString('expand'), //"Kinagyít",
                                    },
                                    closeIconTooltip: gettextCatalog.getString('closeIconTooltip'), //"Bezárás",
                                };
                                ej.DropDownList.Locale['hu-HU'] = {
                                    emptyResultText: gettextCatalog.getString('emptyResultText'), //"Nincsenek elemek",
                                    watermarkText: ' ',
                                };
                                ej.NumericTextbox.Locale['hu-HU'] = {
                                    watermarkText: gettextCatalog.getString('currencyTextboxWatermarkText'),
                                };
                                ej.Pager.Locale['hu-HU'] = {
                                    pagerInfo: gettextCatalog.getString('pagerInfo'), // "{0} {1} lapok ({2} elem)",
                                    firstPageTooltip: gettextCatalog.getString('firstPageTooltip'), //  "Ugrás az első oldalra",
                                    lastPageTooltip: gettextCatalog.getString('lastPageTooltip'), //"Ugrás az utolsó oldalra",
                                    nextPageTooltip: gettextCatalog.getString('nextPageTooltip'), //"Ugrás a következő oldalra",
                                    previousPageTooltip: gettextCatalog.getString('previousPageTooltip'), //"Ugrás az előző oldalra",
                                    nextPagerTooltip: gettextCatalog.getString('nextPagerTooltip'), //"Ugrás a következő oldalra",
                                    previousPagerTooltip: gettextCatalog.getString('previousPagerTooltip'), //"Ugrás az előző oldalra",
                                };
                                ej.PercentageTextbox.Locale['hu-HU'] = {
                                    watermarkText: gettextCatalog.getString('currencyTextboxWatermarkText') //  "Írja be az értéket",
                                };
                                ej.Schedule.Locale['hu'] = {
                                    Priority: gettextCatalog.getString('AlertUsers'), // 'Felhasználók értesítése'
                                    CreateAppointmentTitle: gettextCatalog.getString('CreateAppointmentTitle'), //  'Esemény létrehozása',
                                    RecurrenceEditTitle: gettextCatalog.getString('RecurrenceEditTitle'), // 'Ismétlődő esemény szerkesztése',
                                    RecurrenceEditMessage: gettextCatalog.getString('RecurrenceEditMessage'), //'Hogyan szeretné módosítani az eseményt?',
                                    RecurrenceEditOnly: gettextCatalog.getString('RecurrenceEditOnly'), //'Ezt az egyet',
                                    RecurrenceEditSeries: gettextCatalog.getString('RecurrenceEditSeries'), //'Összeset',
                                    PreviousAppointment: gettextCatalog.getString('PreviousAppointment'), //'Előző esemény',
                                    NextAppointment: gettextCatalog.getString('NextAppointment'), //'Következő esemény',
                                    AppointmentSubject: gettextCatalog.getString('AppointmentSubject'), //'Esemény neve',
                                    StartTime: gettextCatalog.getString('StartTime'), //'Esemény kezdete',
                                    EndTime: gettextCatalog.getString('EndTime'), //'Esemény vége',
                                    AllDay: gettextCatalog.getString('AllDay'), //'Egész napos',
                                    Today: gettextCatalog.getString('Today'), //'Mai nap',
                                    Recurrence: gettextCatalog.getString('Recurrence'), //'Ismétlődés gyakorisága',
                                    Done: gettextCatalog.getString('Done'), //'Kész',
                                    Cancel: gettextCatalog.getString('Cancel'), //'Mégse',
                                    Ok: gettextCatalog.getString('Ok'), //'Ok',
                                    RepeatBy: gettextCatalog.getString('RepeatBy'), //'Ismétlés',
                                    RepeatEvery: gettextCatalog.getString('RepeatEvery'), //'Ismétlés gyakorisága',
                                    Repeat: gettextCatalog.getString('Repeat'), //'Ismétlés',
                                    RepeatOn: gettextCatalog.getString('RepeatOn'), //'Ismétlés ezeken a napokon',
                                    StartsOn: gettextCatalog.getString('StartsOn'), //'Ismétlődés ettől',
                                    Ends: gettextCatalog.getString('Ends'), //'Ismétlődés vége',
                                    Summary: gettextCatalog.getString('Summary'), //'Ismétlődés',
                                    Daily: gettextCatalog.getString('Daily'), //'Naponta',
                                    Weekly: gettextCatalog.getString('Weekly'), //'Hetente',
                                    Monthly: gettextCatalog.getString('Monthly'), //'Havonta',
                                    Yearly: gettextCatalog.getString('Yearly'), //'Évente',
                                    Every: gettextCatalog.getString('Every'), //'Minden',
                                    EveryWeekDay: gettextCatalog.getString('EveryWeekDay'), //'Munkanapokon',
                                    Never: gettextCatalog.getString('Never'), //'Soha',
                                    After: gettextCatalog.getString('After'), //'A(z)',
                                    Occurrence: gettextCatalog.getString('Occurrence'), //'alkalom után',
                                    On: gettextCatalog.getString('On'), //'A következő napig',
                                    Edit: gettextCatalog.getString('Edit'), //'Módosítás',
                                    RecurrenceDay: gettextCatalog.getString('RecurrenceDay'), //'napon',
                                    RecurrenceWeek: gettextCatalog.getString('RecurrenceWeek'), //'héten',
                                    RecurrenceMonth: gettextCatalog.getString('RecurrenceMonth'), //'hónapban',
                                    RecurrenceYear: gettextCatalog.getString('RecurrenceYear'), //'évben',
                                    The: '',
                                    OfEvery: '',
                                    First: gettextCatalog.getString('First'), //'első',
                                    Second: gettextCatalog.getString('Second'), //'második',
                                    Third: gettextCatalog.getString('Third'), //'harmadik',
                                    Fourth: gettextCatalog.getString('Fourth'), //'negyedik',
                                    Last: gettextCatalog.getString('Last'), //'utolsó',
                                    WeekDay: gettextCatalog.getString('WeekDay'), //'munkanap',
                                    Subject: gettextCatalog.getString('Subject'), //'Tárgy',
                                    Categorize: gettextCatalog.getString('Categorize'), //'Kategória',
                                    OpenItem: gettextCatalog.getString('OpenItem'), //'Megtekintés',
                                    Day: gettextCatalog.getString('Day'), //'Napi',
                                    Week: gettextCatalog.getString('Week'), //'Heti',
                                    WorkWeek: gettextCatalog.getString('WorkWeek'), //'Munkahét',
                                    Month: gettextCatalog.getString('Month'), //'Havi',
                                    AddEvent: gettextCatalog.getString('AddEvent'), //'Esemény hozzáadása',
                                    Agenda: gettextCatalog.getString('Agenda'), //'Lista',
                                    Detailed: gettextCatalog.getString('Detailed'), //'Részletek',
                                    EventBeginsin: gettextCatalog.getString('EventBeginsin'), //'Az esemény kezdete',
                                    Editevent: gettextCatalog.getString('Editevent'), //'Esemény szerkesztése',
                                    Editseries: gettextCatalog.getString('Editseries'), //'Sorozat szerkesztése',
                                    Times: gettextCatalog.getString('Times'), //'alkalom',
                                    Until: gettextCatalog.getString('Until'), //'Eddig',
                                    Hours: gettextCatalog.getString('Hours'), //'óra',
                                    Minutes: gettextCatalog.getString('Minutes'), //'perc',
                                    Overdue: gettextCatalog.getString('Overdue'), //'Lejárt',
                                    Days: gettextCatalog.getString('Days'), //'nap',
                                    Event: gettextCatalog.getString('Event'), //'Esemény',
                                    Select: gettextCatalog.getString('Select'), //'Kiválaszt',
                                    Previous: gettextCatalog.getString('Previous'), //'Előző',
                                    Next: gettextCatalog.getString('Next'), //'Következő',
                                    Close: gettextCatalog.getString('Close'), //'Bezár',
                                    Delete: gettextCatalog.getString('Delete'), //'Törlés',
                                    Date: gettextCatalog.getString('Date'), //'Dátum',
                                    Gotodate: gettextCatalog.getString('Gotodate'), //'Dátumra ugrás',
                                    RecurrenceDeleteTitle: gettextCatalog.getString('RecurrenceDeleteTitle'), //'Esemény törlése',
                                    Location: gettextCatalog.getString('Location'), //'Helyszín',
                                    CreateError: gettextCatalog.getString('CreateError'), // 'Az esemény hossza nem lehet nagyobb, mint az ismétlődés gyakorisága. Állítsd rövidebbre az eseményt idejét vagy változtasd meg az ismétlődést.',
                                    StartEndError: gettextCatalog.getString('StartEndError'), //'A kezdés ideje hamarabb kell legyen, mint a befejezésé.',
                                    MouseOverDeleteTitle: gettextCatalog.getString('MouseOverDeleteTitle'), //'Esemény törlése',
                                    DeleteConfirmation: gettextCatalog.getString('DeleteConfirmation'), //'Biztosan törli az eseményt?',
                                    Time: gettextCatalog.getString('Time'), //'Időpont',
                                    NoTitle: gettextCatalog.getString('NoTitle'), //'Névtelen esemény',
                                    OverFlowAppCount: gettextCatalog.getString('OverFlowAppCount'), //'további esemény',
                                    EmptyResultText: gettextCatalog.getString('EmptyResultText'), //'Nincs ilyen a listában'
                                };
                                ej.Uploadbox.Locale['hu-HU'] = {
                                    buttonText: {
                                        upload: gettextCatalog.getString('upload'), //"Feltöltés",
                                        browse: gettextCatalog.getString('browse'), //"Tallózás",
                                        cancel: gettextCatalog.getString('cancel'), //"Törlés",
                                        close: gettextCatalog.getString('close'), //"Bezárás"
                                    },
                                    dialogText: {
                                        title: gettextCatalog.getString('title'), //"Feltöltés",
                                        name: gettextCatalog.getString('name'), //"Név",
                                        size: gettextCatalog.getString('size'), //"Méret",
                                        status: gettextCatalog.getString('status'), //"Állapot"
                                    },
                                    dropAreaText: gettextCatalog.getString('dropAreaText'), //"Dobja ide a fájlokat vagy kattintson a feltöltéshez!",
                                    filedetail: gettextCatalog.getString('filedetail'), //"A kiválasztott fájl mérete túl ndoneagy. Kérjük, válasszon kisebb méretű fájlt.",
                                    denyError: gettextCatalog.getString('denyError'), //"Fájlok #Extension kiterjesztésekkel nem megengedettek.",
                                    allowError: gettextCatalog.getString('allowError'), //"Csak #Extension kiterjesztésű fájlok  engedélyezettek.",
                                    cancelToolTip: gettextCatalog.getString('cancelToolTip'), //"Mégsem",
                                    removeToolTip: gettextCatalog.getString('removeToolTip'), //"Törlés",
                                    retryToolTip: gettextCatalog.getString('retryToolTip'), //"Próbálja újra",
                                    completedToolTip: gettextCatalog.getString('completedToolTip'), //"Befejezés",
                                    failedToolTip: gettextCatalog.getString('failedToolTip'), //"nem sikerült",
                                    closeToolTip: gettextCatalog.getString('closeToolTip'), //"Bezárás",
                                };

                                $rootScope.navSubTitles = {
                                    'Athletes': gettextCatalog.getString('Athletes')
                                };
                                $rootScope.validationTranslate = {
                                    required: gettextCatalog.getString('Required'),
                                    minlength: gettextCatalog.getString('Minlength'),
                                    maxlength: gettextCatalog.getString('Maxlength')
                                };
                                $rootScope.headTitles = {
                                    'AddAgeGroup': gettextCatalog.getString('AddAgeGroup'),
                                    'AddTeamMember': gettextCatalog.getString('AddTeamMember'),
                                    'AddTeams': gettextCatalog.getString('AddTeams'),
                                    'Administration': gettextCatalog.getString('Administration'),
                                    'AgeGroupMembersList': gettextCatalog.getString('AgeGroupMembersList'),
                                    'AgeGroupsList': gettextCatalog.getString('AgeGroupsList'),
                                    'Athletes': gettextCatalog.getString('Athletes'),
                                    'AthletesList': gettextCatalog.getString('AthletesList'),
                                    'AthletesManagement': gettextCatalog.getString('AthletesManagement'),
                                    'Business': gettextCatalog.getString('Business'),
                                    'CentralReport': gettextCatalog.getString('CentralReport'),
                                    'CentralReportAllIn': gettextCatalog.getString('CentralReportAllIn'),
                                    'CentralReportByRating': gettextCatalog.getString('CentralReportByRating'),
                                    'Dashboard': gettextCatalog.getString('Dashboard'),
                                    'DuplicatedAthletes': gettextCatalog.getString('DuplicatedAthletes'),
                                    'EditHealthType': gettextCatalog.getString('EditHealthType'),
                                    'LogIn': gettextCatalog.getString('LogIn'),
                                    'ModifyAgeGroup': gettextCatalog.getString('ModifyAgeGroup'),
                                    'ModifyTeams': gettextCatalog.getString('ModifyTeams'),
                                    'MonthlyAttendance': gettextCatalog.getString('MonthlyAttendance'),
                                    'MonthlyAttendanceList': gettextCatalog.getString('MonthlyAttendanceList'),
                                    'NewAthlete': gettextCatalog.getString('NewAthlete'),
                                    'NewUser': gettextCatalog.getString('NewUser'),
                                    'Reports': gettextCatalog.getString('Reports'),
                                    'SchoolManagement': gettextCatalog.getString('SchoolManagement'),
                                    'Search': gettextCatalog.getString('Search'),
                                    'Settings': gettextCatalog.getString('Settings'),
                                    'SportSpecificReportLists': gettextCatalog.getString('SportSpecificReportLists'),
                                    'SportSpecificTestList': gettextCatalog.getString('SportSpecificTestList'),
                                    'StatisticalReports': gettextCatalog.getString('StatisticalReports'),
                                    'TeamList': gettextCatalog.getString('TeamList'),
                                    'TeamMembersList': gettextCatalog.getString('TeamMembersList'),
                                    'TestResultsFootball': gettextCatalog.getString('TestResultsFootball'),
                                    'TestResultsHockey': gettextCatalog.getString('TestResultsHockey'),
                                    'UserGroupsManagement': gettextCatalog.getString('UserGroupsManagement'),
                                    'UserManagement': gettextCatalog.getString('UserManagement'),
                                    'AgeGroupManagement': gettextCatalog.getString('AgeGroupManagement'),
                                    'AnnualPresenceReports': gettextCatalog.getString('AnnualPresenceReports'),
                                    'EventsCalendar': gettextCatalog.getString('EventsCalendar'),
                                    'ManagementReports': gettextCatalog.getString('ManagementReports'),
                                    'SearchType': gettextCatalog.getString('SearchType'),
                                    'MessageCenter': gettextCatalog.getString('MessageCenter')
                                };

                                $rootScope.busyMessage = gettextCatalog.getString('Loading');
                                getNavRoutes().then(function () {
                                    if (!$rootScope.$$phase) {
                                        $rootScope.$apply();
                                    }
                                    resolve();
                                });
                            });
                        });
                    };
                    var lang = null;
                    if (authenticationService.isAuthenticated()) {
                        lang = localStorageService.get('_authData').language;
                    } else if (authenticationService.isSessionTimeOut()) {
                        lang = localStorageService.get('_sessionData').language;
                    } else {
                        lang = navigator.language || navigator.userLanguage;
                    }
                    $rootScope.setLanguage(lang).then(function () {
                        resolve();
                    });
                });
            });
        }])
        .controller('ShellController', ShellController);

    function ShellController($rootScope, $q, config, logger, authenticationService, $state, AUTH_EVENTS, LAYOUT_EVENTS, gettextCatalog, LANG_EVENTS, $scope, routerHelper, DOMAIN, loader, $compile, $window, paramHelper, dataservice, $timeout, localStorageService, log, $interval) {
        // Declaration variables
        var vm = this;
        vm.intId = -1;
        vm.busyMessage = 'Please wait...';
        vm.isBusy = true;
        vm.password = {oldPassword: '', newPassword: '', confirmPassword: '', expiried: false};
        vm.expiresLabel = '';
        vm.authData = {};
        vm.isAuthenticated = false;
        vm.pictureBasePath = DOMAIN.baseURL + DOMAIN.profileImgBaseUrl + '/';
        vm.userPermission = authenticationService.getPermission();
        vm.logout = logout;
        vm.openPasswordDialog = openPasswordDialog2;
        vm.goToProfile = goToProfile;
        vm.goToDashboard = goToDashboard;
        vm.athleteidOfAthleteUser = -1;
        vm.partnerLogo = '';
        $rootScope.sideMenuOpened = true;
        $rootScope.gridPage = 5;
        $rootScope.gridPageSizes = [4, 8, 20, 100];

        // SYNCFUSION 2 SETTINGS
        $rootScope.toolbarItems = ['ExcelExport', /*'pdfexport',*/ 'Print'];
        $rootScope.toolbarItemsWithDelete = ['ExcelExport', /*'pdfexport',*/ 'Print', 'Delete'];
        $rootScope.toolbarItemsWithSearch = ['ExcelExport', /*'pdfexport',*/ 'Print', 'Search'];
        $rootScope.toolbarItemsWithSearchAndDelete = ['ExcelExport', /*'pdfexport',*/ 'Print', 'Delete', 'Search'];
        $rootScope.toolbarClick = function (args, grid) {
            if (args.item.id === (grid.element.id + '_excelexport')) {
                var origColumns = $.extend(true, [], grid.properties.columns);
                grid.properties.columns.forEach(function (c) {
                    c.headerText = c.headerText.replace('<br>', ' ');
                });
                if (grid.columns[0].type === 'checkbox') {
                    grid.columns[0].visible = false;
                    grid.excelExport().then(function () {
                        grid.columns[0].visible = true;
                    });
                } else {
                    grid.excelExport();
                }
                grid.properties.columns = $.extend(true, [], origColumns);
            }
            // if (args.item.id === (grid.element.id + '_pdfexport')) {
            //     grid.pdfExport();
            // }
            if (args.item.id === (grid.element.id + '_print')) {
                grid.print({pageOrientation: 'Landscape'});
            }
        };
        $rootScope.compile = function compile(args, scope) {
            $timeout(function () {
                $compile(args)(scope);
            }, 100);
        };
        // checkBoxChange event
        $rootScope.checkBoxChangeOnlyOne = function (args, grid) {
            if (args.selectedRowIndexes.length > 1) {
                var el = $(grid.element).find('.e-checkselectall').next();
                el.addClass('e-uncheck');
                el.removeClass('e-check');
                grid.clearSelection();
                log.errorMsg('YouHaveToSelectOnlyOneRow');
            }
        };
        $rootScope.getSelectedItems = function (grid) {
            var selectedRowIndexes = grid.getSelectedRowIndexes();
            var items = [];
            selectedRowIndexes.forEach(function (element) {
                items.push(grid.selectionModule.contentRenderer.rows[element].data);
            });
            return items;
        };

        $rootScope.deleteRows = function (grid) {
            var selectedRowIndexes = grid.getSelectedRowIndexes();
            var indexes = selectedRowIndexes.sort(function (a, b) {
                return b - a;
            });
            indexes.forEach(function (i) {
                grid.dataSource.splice(i, 1);
            });
            grid.refresh();
            return grid.dataSource;
        };

        $rootScope.gridSelectedRowIndex = function (grid) {
            var indexes = [];
            var selectedIndexes = grid.getSelectedRowIndexes();
            selectedIndexes.forEach(function (indexId) {
                indexes.push((grid.pageSettings.currentPage - 1) * grid.pageSettings.pageSize + indexId);
            });
            return indexes;
        };
        $rootScope.checkRowSelection = function (grid, onlyOne) {
            var selectedRows = $rootScope.getSelectedItems(grid);
            if (selectedRows.length === 0) {
                log.errorMsg('NoSelectedRow');
                return false;
            }
            if (onlyOne && selectedRows.length > 1) {
                log.errorMsg('YouHaveToSelectOnlyOneRow');
                return false;
            }
            return true;
        };

        $rootScope.beforePrintGrid = function (args, gridColumns) {
            var gridObj = args.element.ej2_instances[0]; // instance for printing Grid
            if (gridColumns) {
                gridObj.hideColumns(gridColumns, 'field');
                gridObj.refresh();
            } else {
                gridObj.hideColumns('Link', 'field');
                gridObj.refresh();
            }
        };
        $rootScope.printCompleteGrid = function (args, gridColumns) {
            var gridObj = args.element.ej2_instances[0]; // instance for printing Grid
            if (gridColumns) {
                gridObj.showColumns(gridColumns, 'field');
                gridObj.refresh();
            } else {
                gridObj.showColumn('Link', 'field');
                gridObj.refresh();
            }
        };
        // VÉGE

        $rootScope.sideMenuOpen = function () {
            $rootScope.sideMenuOpened = true;
        };

        $rootScope.sideMenuClose = function () {
            $rootScope.sideMenuOpened = false;
        };

        activate();

        function activate() {
            vm.intId = setInterval(TryRefreshToken, 1000);
            return $q(function (resolve) {
                vm.partnerLogoSmall = clientConfig.partnerLogoSmall;
                vm.partnerLogo = config.partnerLogo;
                logger.success(config.appTitle + ' loaded!', null);
                if (authenticationService.isAuthenticated()) {
                    if (localStorageService.get('_authData').gridRecordPerPage) {
                        $rootScope.gridPage = parseInt(localStorageService.get('gridRecordPerPage') || 10);
                        $timeout(function () {
                            $scope.$apply();
                        }, 0);
                    }

                    pageSettings();
                    haveToPay();
                    resolve(true);
                } else {
                    resolve(false);
                }
            });
        }

        function TryRefreshToken() {
            if (!authenticationService.isAuthenticated()) {
                return;
            }
            var sikertopic = localStorageService.get('sikertopic');
            var firebasetoken = localStorage.getItem('firebasetoken');
            var lang = authenticationService.getAuthData().language;
            if (authenticationService.isAuthenticated() && sikertopic && firebasetoken && sikertopic.length > 0 && firebasetoken.length > 0) {
                console.log('TOPIC:', sikertopic);
                console.log('TOKEN:', firebasetoken);
                console.log('LANG:', lang);
                dataservice.FirebaseSubscribeToTopic({topic: sikertopic, token: firebasetoken, lang: lang}).then(function (resp) {
                    console.log('FirebaseSubscribeToTopic', resp);
                });
                clearInterval(vm.intId);
            }
        }

        var pageSize = 4;

        function pageSettings() {
            paramHelper.getParams([], ['gridRecordPerPage']).then(function (result) {
                if (result['gridRecordPerPage']) {
                    pageSize = parseInt(result['gridRecordPerPage']);
                }
                $rootScope.pageSettings = {pageCount: 5, pageSize: pageSize, pageSizes: $rootScope.gridPageSizes};
            });
        }

        $scope.$watch('title', function () {
            $rootScope.htmlTitle = 'Siker 2.0 b201810171440 - ' + $rootScope.title;
        });

        $scope.previousState;

        $scope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams, options) {
            pageSettings();
            if ($rootScope.monthlyAttendanceSaveInterval) {
                $interval.cancel($rootScope.monthlyAttendanceSaveInterval);
                $rootScope.monthlyAttendanceSaveInterval = undefined;
            }
            if (options.location === false && (fromState.url === '/eventsCalendar' || fromState.url === '/schedule')) {
                event.preventDefault();
            }
            $rootScope.actualState = toState;
            /*
            else {
                 loader.start();
            }*/
        });

        $rootScope.stateList = [];

        $rootScope.fromBack = false;
        $scope.$on('$stateChangeSuccess', function (ev, to, toParams, from) {
            if (!$rootScope.fromBack) {
                $rootScope.stateList.push(from.name);
            }
            $scope.actual = to.name;
            //$log.log($rootScope.stateList);
            $rootScope.fromBack = false;
            // loader.end();
        });
        $scope.$on('$stateNotFound', function () {
            // loader.end();
        });
        $scope.$on('stateChangeError', function () {
            // loader.end();
        });

        $rootScope.back = function () {
            $rootScope.fromBack = true;
            var state = $rootScope.stateList.pop();
            if (state === angular.isUndefined || state === '') {
                state = 'dashboard';
            }
            $state.go(state);
        };

        $rootScope.home = function () {
            $state.go('dashboard');
        };

        $rootScope.login = function () {
            $state.go('login');
            loader.end();
        };

        // //
        // $rootScope.$watch(function () {
        //     return authenticationService.isAuthenticated();
        // }, function (value) {
        //     vm.isAuthenticated = value;
        //     vm.authData = authenticationService.getAuthData();
        // });

        //Refres profile image broadcast handler
        $rootScope.$on(AUTH_EVENTS.refreshProfilePic, function (events, args) {
            vm.authData.picture = args;
        });

        function logout() {
            $rootScope.title = '';
            authenticationService.logout().then(function (result) {
                if (!result) {
                    logger.error(gettextCatalog.getString('SignOutWasUnsucessful'));
                }
            });
        }

        function openPasswordDialog2() {
            $rootScope.$broadcast(LAYOUT_EVENTS.passwordChange);
        }

        // Watching variables change
        $rootScope.$watch(function () {
            return authenticationService.isAuthenticated();
        }, function (value) {
            vm.isAuthenticated = value;
            vm.authData = authenticationService.getAuthData();
            passwordDialogConf();
        });

        //
        function haveToPay() {
            dataservice.getHaveToPay().then(function (haveToPayResult) {
                if (haveToPayResult.retValue == true) {
                    if (!localStorageService.get('marMegnezte')) {
                        swal({
                            title: gettextCatalog.getString('Message'),
                            text: gettextCatalog.getString('AttenzioneDebitBalance'),
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            confirmButtonColor: '#DD6B55',
                            confirmButtonText: gettextCatalog.getString('Ok'),
                            onOpen: function () {
                                swal.showLoading();
                                $timeout(function () {
                                    swal.hideLoading();
                                    swal.enableButtons();
                                }, 3000);
                            }
                        }).then(function () {
                            localStorageService.set('marMegnezte', {
                                value: true,
                            });
                        });
                    }
                }
            });
        }

        // Boradcast or emitt handlers
        $rootScope.$on(AUTH_EVENTS.login, function (events, args, permission) {
            haveToPay();
            if (args === '' || args === 'login') {
                switch (permission) {
                    case '5':
                        $state.go('parentDashboard');
                        break;
                    case '6':
                        $state.go('athleteDashboard');
                        break;
                    default:
                        $state.go('dashboard');
                        break;
                }
            } else {
                $state.go(args);
            }
        });

        $rootScope.$on(AUTH_EVENTS.logout, function () {
            $state.go('login');
        });

        $rootScope.$on(AUTH_EVENTS.notAuthorized, function () {
            authenticationService.logout();
        });

        $rootScope.$on(LAYOUT_EVENTS.passwordChange, function () {
            passwordDialogConf();
            openPasswordDialog();
        });

        $rootScope.$on(LANG_EVENTS.changeLanguage, function (events, args) {
            $rootScope.setLanguage(args);
        });

        $rootScope.$on(AUTH_EVENTS.sessionTimeout, function () {
            if (!vm.isAuthenticated) {
                return;
            }
            authenticationService.setSessionTimeOut($state.current.name);
        });
        $(document).click(function(e) {
            if ($(e.target).is('#mainContent *') && window.innerWidth < 768) {
                $rootScope.$broadcast('autoCloseSideBar');
            }
        });

        function passwordDialogConf() {
            if (vm.authData) {
                var today = new Date();
                today.setHours(0, 0, 0, 0);
                var expiration = new Date(moment(vm.authData.pwdExpiration));
                expiration.setHours(0, 0, 0, 0);
                var diffDays = moment(vm.authData.pwdExpiration).diff(today, 'days');

                if (diffDays === 1) {
                    var message = gettextCatalog.getString('YourPasswordIsAboutToExpire1') + ' ' + moment(vm.authData.pwdExpiration).format('YYYY-MM-DD');
                    logger.info(message);
                    vm.expiresLabel = message;
                    openPasswordDialog();
                } else if (expiration <= today) {
                    vm.password.expiried = true;
                    var message = gettextCatalog.getString('YourPasswordExpired');
                    vm.expiresLabel = message;
                    openPasswordDialog();
                }
            }
        }

        function openPasswordDialog() {
            swal({
                title: gettextCatalog.getString('ChangePassword'),
                html: '<div id="passwordChangeModal"><p ng-show="vm.expiresLabel.length !== 0" style="color: red;" id="expiresLabel">{{vm.expiresLabel}}</p>' +
                '<form method="post">' +
                '<div class="form-group">' +
                '<input class="form-control" placeholder="Régi jelszó" name="oldPassword" id="oldPassword" autofocus data-ng-model="vm.password.oldPassword" type="password" required tabindex="1">' +
                '</div>' +
                '<div class="form-group">' +
                '<input class="form-control" placeholder="Új jelszó" name="newPassword" id="newPassword" data-ng-model="vm.password.newPassword" type="password" tabindex="2">' +
                '</div>' +
                '<div class="form-group">' +
                '<input class="form-control" placeholder="Új jelszó mégegyszer" name="confirmPassword" id="confirmPassword" data-ng-model="vm.password.confirmPassword" type="password" tabindex="3">' +
                '</div>' +
                '</form>' +
                '</div>',
                preConfirm: function () {
                    return new Promise(function (resolve) {
                        vm.password.newPassword = document.getElementById('newPassword').value;
                        vm.password.oldPassword = document.getElementById('oldPassword').value;
                        vm.password.confirmPassword = document.getElementById('confirmPassword').value;

                        if (!vm.password.newPassword || vm.password.newPassword.length < 4 || vm.password.newPassword.length > 10) {
                            swal.showValidationError(gettextCatalog.getString('PasswordMustBeAtLeast5CharactersLong'));
                        }
                        if (vm.password.oldPassword.length === 0 || vm.password.newPassword.length === 0 || vm.password.confirmPassword.length === 0) {
                            swal.showValidationError(gettextCatalog.getString('FellInAllElement'));
                        }
                        if (vm.password.newPassword !== vm.password.confirmPassword) {
                            swal.showValidationError(gettextCatalog.getString('PasswordsDontMatch'));
                        }
                        resolve();
                    });
                },
                showCancelButton: !vm.password.expiried,
                allowEscapeKey: false,
                allowOutsideClick: false,
                confirmButtonText: gettextCatalog.getString('OK'),
                cancelButtonText: gettextCatalog.getString('Cancel')
            }).then(function (confirmed) {
                if (confirmed.value) {
                    $window.onkeydown = null;
                    $window.onfocus = null;
                    if (confirmed) {
                        vm.error = '';
                        dataservice.changePassword(vm.password.oldPassword, vm.password.newPassword)
                            .then(function (data) {
                                if (data.retValue === true && data.error.length === 0) {
                                    var expiration = new Date();
                                    vm.authData.expiration = expiration.setFullYear(expiration.getFullYear() + 1);
                                    logger.success(gettextCatalog.getString('PasswordChanged'));
                                    vm.password = {
                                        oldPassword: '',
                                        newPassword: '',
                                        confirmPassword: '',
                                        expiried: false
                                    };
                                    vm.expiresLabel = '';
                                    swal.close();
                                    logout();
                                }
                            }).catch(function () {
                            logger.error(gettextCatalog.getString('SaveUnsuccessful'));
                            openPasswordDialog();
                        });
                    } else {
                        vm.password = {oldPassword: '', newPassword: '', confirmPassword: '', expiried: false};
                        vm.expiresLabel = '';
                    }
                }
            });

            $compile(angular.element('#passwordChangeModal'))($scope);
            angular.element('.confirm').removeAttr('tabindex');
            angular.element('#oldPassword').attr('tabindex', 1);
            angular.element('#newPassword').attr('tabindex', 2);
            angular.element('#confirmPassword').attr('tabindex', 3);
        }

        function openAthleteModify() {
            dataservice.getAthleteidBelongsToAthleteUser()
                .then(function (data) {
                    vm.athleteidOfAthleteUser = data.data;
                    paramHelper.setParams([
                        {'athleteModify.sportoloId': vm.athleteidOfAthleteUser},
                        {'athleteModify.sportoloNev': vm.authData.loginName}
                    ]);
                    $state.go('athletes.athletesManagement.athleteModify.dataSheet');
                });
        }

        function goToProfile() {
            $q.all([authenticationService.getRight('SPORTOLO')])
                .then(() => {
                    $state.go('settings.userManagement.userSettings');
                });
        }

        function goToDashboard() {
            var permission = authenticationService.getPermission();
            switch (permission) {
                case '5':
                    $state.go('parentDashboard');
                    break;
                case '6':
                    $state.go('athleteDashboard');
                    break;
                default:
                    $state.go('dashboard');
                    break;
            }
        }

        loader.end();
    }
})();

(function () {
    'use strict';

    SidebarController.$inject = ["$state", "authenticationService", "localStorageService", "dataservice", "$rootScope", "$scope"];
    angular
        .module('app.layout')
        .controller('SidebarController', SidebarController);

    function SidebarController($state, authenticationService, localStorageService, dataservice, $rootScope, $scope) {
        var vm = this;
        vm.isCurrent = isCurrent;
        vm.noEducationalFee = localStorageService.get('noEducationalFee');
        vm.isAuthenticated = authenticationService.isAuthenticated();
        vm.permission = authenticationService.getPermission();
        vm.authenticated = authenticationService.isAuthenticated();
        vm.rights = authenticationService.getAuthData().accessRights;
        vm.checkPermissionGroup = checkPermissionGroup;
        $rootScope.INAKTIVMENUREJTES = true;
        function getSystemSettings(valtozo) {
            return dataservice.getSystemSettings(valtozo).then(function (response) {
                return response.retValue;
            });
        }
        $scope.$on('msgRead', getUnreadMessageCount);
        getSystemSettings('INAKTIVMENUREJTES').then(function (res) {
            $rootScope.INAKTIVMENUREJTES = res;
        });
        vm.menuItemClicked = menuItemClicked;
        vm.messageCount = 0;
        getUnreadMessageCount();
        function checkPermissionGroup(activators) {
            for (var i = 0; i < activators.length; i++) {
                if (vm.rights.indexOf(activators[i]) !== -1) {
                    return true;
                }
            }
            return false;
        }

        function getUnreadMessageCount() {
            dataservice.GetUnreadMessageCount().then(function(data) {
                vm.messageCount = data.res;
            });
        };

        function menuItemClicked(nav, level) {
            if (nav.settings.childRoutes === undefined || nav.settings.childRoutes.length === 0) {
                if (level === 1) {
                    vm.level1Open = 0;
                    vm.level2Open = 0;
                }
                if (window.innerWidth < 768) {
                    $rootScope.$broadcast('autoCloseSideBar');
                }
                $state.go(nav.name);
            } else {
                switch (level) {
                    case 1:
                        if (nav.settings.navId === vm.level1Open) {
                            vm.level1Open = 0;
                        } else {
                            vm.level1Open = nav.settings.navId;
                            vm.level2Open = 0;
                        }
                        break;
                    case 2:
                        if (nav.settings.navId === vm.level2Open) {
                            vm.level2Open = 0;
                        } else {
                            vm.level2Open = nav.settings.navId;
                        }
                        break;
                    default:
                        break;
                }
            }
        }

        function isCurrent(route) {
            if (!route.title || !$state.current || !$state.current.title) {
                return '';
            }
            var menuName = route.title;
            return $state.current.title === menuName ? 'current' : '';
        }
    }
})();

(function () {
    'use strict';

    LoginController.$inject = ["$q", "dataservice", "logger", "authenticationService", "$state", "$rootScope", "LANG_EVENTS", "DOMAIN", "paramHelper"];
    angular
        .module('app.login')
        .controller('LoginController', LoginController);

    function LoginController($q, dataservice, logger, authenticationService, $state, $rootScope, LANG_EVENTS, DOMAIN, paramHelper) {
        var vm = this; $rootScope.vm = vm;
        vm.title = 'Bejelentkezés';
        vm.loginName = '';
        vm.password = '';
        vm.defaultLang = '';
        vm.image = DOMAIN.baseURL + DOMAIN.userImage;
        vm.isAuthenticated = authenticationService.isAuthenticated();
        vm.sessionTimeout = false;
        vm.unknownUser = false;
        vm.languageTemplate = '<img src=\"${icon}\" alt=\"lang\" height=\"20px\" width=\"20px\"/>' +
            '<span style=\"padding-left: 10px; vertical-align: middle\">${text}</span>';

        // Events
        vm.changeLanguage = changeLanguage;
        vm.changeLoginName = changeLoginName;
        vm.login = login;
        vm.loginFocusOut = loginFocusOut;

        activate();

        function activate() {
            if (authenticationService.isAuthenticated()) {
                $state.go('dashboard');
                return;
            }
            var promises = [getAvailableLanguages(), loadSessionData()];
            $q.all(promises).then(function () {
                angular.element('#availableLang').ejDropDownList({dataSource: vm.availableLanguages});
                if (!authenticationService.isSessionTimeOut()) {
                    angular.element('#availableLang').ejDropDownList('setSelectedValue', vm.defaultLang);
                } else {
                    angular.element('#availableLang').ejDropDownList('setSelectedValue', authenticationService.getLanguage());
                }
            });
        }

        function getAvailableLanguages() {
            var browserLang = navigator.language || navigator.userLanguage;
            authenticationService.noEducationalFee();
            return dataservice.getAvailableLanguages().then(function (data) {
                data = data.itemsList;
                vm.availableLanguages = data;
                for (var i = 0; i < vm.availableLanguages.length; i++) {
                    if (browserLang.toLowerCase().indexOf(vm.availableLanguages[i].value.toLowerCase()) >= 0) {
                        vm.defaultLang = vm.availableLanguages[i].value;
                    }
                }
                if (vm.defaultLang === '') {
                    vm.defaultLang = data.d.defLanguage;
                }
                return vm.availableLanguages;
            });
        }

        function loadSessionData() {
            if (!authenticationService.isSessionTimeOut()) {
                return;
            }
            var user = authenticationService.getSessionData();
            vm.image = user.picture;
            vm.sessionTimeout = true;
            vm.loginName = user.loginName;
        }

        function login() {
            paramHelper.setUserNameParams(vm.loginName, [{'Login.Language': angular.element('#availableLang').ejDropDownList('getSelectedValue')}]);
            authenticationService.login(vm.loginName, vm.password, angular.element('#availableLang').ejDropDownList('getSelectedValue')).then(function (result) {
                if (!result) {
                    angular.element('#wrongUnameOrPwd').fadeIn('medium');
                    angular.element('#loginName').addClass('error');
                    angular.element('#password').addClass('error');
                    vm.unknownUser = true;
                }
            });
        }

        function changeLanguage(args) {
            paramHelper.setUserNameParams(vm.loginName, [{'Login.Language': angular.element('#availableLang').ejDropDownList('getSelectedValue')}]);
            $rootScope.$broadcast(LANG_EVENTS.changeLanguage, args.value);
            vm.frmLogin.$setPristine();
        }

        function changeLoginName() {
            if (vm.unknownUser) {
                angular.element('#wrongUnameOrPwd').css('display', 'none');
                angular.element('#loginName').removeClass('error');
                angular.element('#password').removeClass('error');
                vm.unknownUser = false;
            }
            if (authenticationService.isSessionTimeOut() && vm.loginName !== authenticationService.getSessionData().loginName) {
                vm.image = DOMAIN.baseURL + DOMAIN.userImage;
                vm.sessionTimeout = false;
            } else if (authenticationService.isSessionTimeOut() && vm.loginName === authenticationService.getSessionData().loginName) {
                vm.image = authenticationService.getSessionData().picture;
                vm.sessionTimeout = true;
            }
        }

        function loginFocusOut() {
            paramHelper.getUserNameParams(vm.loginName, [], ['Login.Language']).then(function(args) {
                if (args['Login.Language']) {
                    vm.defaultLang = args['Login.Language'];
                    angular.element('#availableLang').ejDropDownList('setSelectedValue', vm.defaultLang);
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.login')
        .directive('ngEnter', ngEnter);

    /* @ngInject */
    function ngEnter() {
        return {
            link: link,
            restrict: 'EA'
        };

        function link(scope, element, attrs) {
            element.bind('keydown keypress', function (event) {
                if (event.which === 13) {
                    scope.$apply(function () {
                        scope.$eval(attrs.ngEnter, {'event': event});
                    });
                    event.preventDefault();
                }
            });
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.login')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'login',
                config: {
                    url: '/login',
                    templateUrl: 'app/login/login.html',
                    controller: 'LoginController',
                    controllerAs: 'vm',
                    title: 'LogIn'
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.messageCenter')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'messageCenter',
                config: {
                    title: 'MessageCenter',
                    url: '/messageCenter',
                    templateUrl: 'app/messageCenter/messageCenter.html',
                }
            }
        ];
    }
})();

(function () {
        'use strict';

        MessageCenterController.$inject = ["$q", "$rootScope", "gettextCatalog", "dataservice", "$scope", "log", "authenticationService", "paramHelper", "$state", "$timeout", "DOMAIN"];
        angular
            .module('app.messageCenter')
            .controller('MessageCenterController', MessageCenterController);

        function MessageCenterController($q, $rootScope, gettextCatalog, dataservice, $scope, log, authenticationService, paramHelper, $state, $timeout, DOMAIN) {
            var vm = this;
            $rootScope.vm = vm;
            $rootScope.title = gettextCatalog.getString('MessageCenterRecievedMessages');
            //Grid nyomtatás, exportálás nyomógomb
            vm.isBusy = false;
            vm.listPageNumber = 1;
            vm.itemsPerMessage = 24;
            vm.messagePageNumber = 1;
            vm.listItemsPerPage = 24;
            vm.SelectedMessage = {};
            vm.openedMessageTargyId = null;
            vm.SelectedMessageIndex = null;
            vm.SelectedMessageDateSource = null;
            vm.toolbarClick = toolbarClick;
            vm.loadMessageId = -1;
            vm.profileImgBaseUrl = DOMAIN.baseURL + DOMAIN.profileImgBaseUrl;
            vm.messageImagesUrl = DOMAIN.baseURL + DOMAIN.messageImagesUrl;
            vm.imageSet = imageSet;

            activate();

            vm.EditMessageText = gettextCatalog.getString('Directory');
            vm.Uzenet = gettextCatalog.getString('Message'); // cts-textarea-hoz kell, onnan nem veszi fel a fordítást...

            function activate() {
                setInterval(WaitForPushNotifications, 500);
                vm.toolbarItems = [
                    {
                        empid: 1,
                        tooltiptext: gettextCatalog.getString('msgSendNew'),
                        spriteCss: 'msgtools newmsg',
                        group: '1'
                    },
                    {
                        empid: 4,
                        tooltiptext: gettextCatalog.getString('Remove'),
                        spriteCss: 'msgtools msgdelete',
                        group: '2'
                    },
                    {
                        empid: 5,
                        tooltiptext: gettextCatalog.getString('Print'),
                        spriteCss: 'msgtools msgprint',
                        group: '3'
                    },
                    {
                        empid: 6,
                        tooltiptext: gettextCatalog.getString('Refresh'),
                        spriteCss: 'msgtools msgrefresh',
                        group: '3'
                    }
                    // , {
                    //     empid: 7,
                    //     tooltiptext: gettextCatalog.getString('Sent'),
                    //     spriteCss: 'msgtools msgsent',
                    //     group: '3'
                    // }
                ];
                vm.dataMessages = [];

                $q.all([paramHelper.getParams([], ['messageTargyId']), authenticationService.getRight('MEGTFELH'), authenticationService.getRight('UZENETMEGT'), authenticationService.getRight('UZENETTORLES')]).then(function (results) {
                    vm.MEGTFELH = results[1];
                    vm.UZENETMEGT = results[2];
                    vm.UZENETTORLES = results[3];
                    if (results[0].messageTargyId) {
                        vm.openedMessageTargyId = results[0].messageTargyId;
                        paramHelper.removeParam('messageTargyId');
                    }
                    if (!vm.UZENETMEGT) {
                        log.permissionError(true);
                        return;
                    }
                    refreshList();
                    angular.element(document.querySelector('#message-list')).bind('scroll', function () {
                        var objDiv = jQuery($('#message-list'));
                        if (objDiv[0].scrollTop == objDiv[0].scrollHeight - objDiv[0].clientHeight) {
                            vm.listPageNumber += 1;
                            loadMoreListItem();
                        }
                    });
                    angular.element(document.querySelector('#text')).bind('keypress', function (e) {
                        if ((e.which === 10 || e.which === 13) && e.shiftKey === false) {
                            vm.messageSend();
                        }
                    });
                    $timeout(function () {
                        if (vm.openedMessageTargyId > 0) {
                            getMessages(vm.openedMessageTargyId);
                        }
                    }, 100);
                });
            }

            function WaitForPushNotifications() {
                var pushnotification = localStorage.getItem('pushnotification');
                if (pushnotification && pushnotification.length > 0) {
                    localStorage.removeItem('pushnotification');
                    var payload = JSON.parse(pushnotification);
                    if (payload.data.page == 'messages') {
                        refreshList();
                        if (parseInt(payload.data.contentid) == parseInt(vm.openedMessageTargyId)) {
                            getMessages(vm.openedMessageTargyId);
                        }
                    }
                }
            }

            function toolbarClick(params) {
                switch (params.currentTarget.id) {
                    case '1':
                        paramHelper.setParams([{
                            'newMessage.Message': '',
                            'newMessage.OriginalSenderId': 0,
                            'newMessage.OriginalSenderName': ''
                        }
                        ]);
                        $state.go('messageCenter.newMessage');
                        break;
                    case '4':
                        if (!vm.openedMessageTargyId) {
                            log.errorMsg('Válasszon ki egy üzenetet!');
                            return;
                        }
                        swal({
                            title: gettextCatalog.getString('DoYouWantDelete'),
                            type: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: '#DD6B55',
                            confirmButtonText: gettextCatalog.getString('YesIWantDelete'),
                            cancelButtonText: gettextCatalog.getString('Cancel'),
                        }).then(function (isConfirm) {
                            if (!vm.UZENETTORLES) {
                                log.errorMsg('Nincs joga az üzenetet törléséhez!');
                                return;
                            }
                            if (isConfirm.value) {
                                dataservice.SikerMobileFreeDeleteMessages(vm.openedMessageTargyId).then(function () {
                                    log.infoMsg('MessageMarkAsDeleted');
                                    refreshList();
                                    vm.openedMessageTargyId = null;
                                    vm.SelectedMessageDateSource = null;
                                    $timeout(function () {
                                        $scope.$apply();
                                    }, 10);
                                    vm.SelectedMessage = {};
                                });
                            }
                        });
                        break;
                    case '5':
                        if (!vm.SelectedMessage.Id) {
                            log.errorMsg('Válasszon ki egy üzenetet!');
                            return;
                        }
                        var newWindow = window.open();
                        var x = document.getElementById('printDiv').innerHTML;

                        var w = '<head><title>Test</title><link rel=\"stylesheet\" href=\"/.tmp/style.css\">' + x + '</head><body>';
                        newWindow.document.write(w);
                        // newWindow.print();
                        newWindow.print();
                        $timeout(function () {
                            newWindow.close();
                        }, 100);
                        break;
                    case '6':
                        vm.SelectedMessage.Id = null;
                        vm.SelectedMessage.Uzenet = '';
                        vm.SelectedMessage.FeladoNev = '';
                        vm.SelectedMessage.Datum = '';
                        refreshList();
                        getMessages(vm.openedMessageTargyId);
                        break;
                    case '7':
                        if (!vm.SelectedMessage.TargyId) {
                            log.errorMsg('Válasszon ki egy üzenetet!');
                            return;
                        } else {
                            vm.messageSend();
                        }
                }
            }

            function refreshList() {
                var pageNumber = vm.listPageNumber * vm.listItemsPerPage;
                dataservice.GetMessageGroups(1, pageNumber).then(function (data) {
                    vm.dataMessages = [];
                    vm.dataMessages = data.itemsList;
                    for (var i = 0; i < vm.dataMessages.length; i++) {
                        if (vm.dataMessages[i]['TargyId'] == vm.openedMessageTargyId) {
                            vm.recipients = vm.dataMessages[i]['Kikkel'];
                            break;
                        }
                    }
                });
            }

            vm.messageClicked = function (index) {
                vm.isBusy = false;
                vm.messagePageNumber = 1;
                vm.SelectedMessage = vm.dataMessages[index];
                vm.openedMessageTargyId = vm.SelectedMessage.TargyId;
                vm.selectedMessageIndex = index;
                vm.recipients = vm.dataMessages[index].Kikkel;

                paramHelper.setParams([{
                    'messageTargyId': vm.openedMessageTargyId
                }]);
                if (!vm.SelectedMessage.Olvasott) {
                    dataservice.messageReaded(vm.SelectedMessage.Id).then(function () {
                        vm.SelectedMessage.Olvasott = true;
                        $rootScope.$broadcast('msgRead');
                    });
                } else {
                    setTimeout(function () {
                        $scope.$apply();
                    }, 10);
                }
                getMessages(vm.openedMessageTargyId);
            };

            function getMessages(targyId) {
                dataservice.getMessages(targyId).then(function (result) {
                    vm.SelectedMessageDateSource = result.itemsList;
                    imageSet(vm.SelectedMessageDateSource);
                    angular.element(document.querySelector('#message-detail')).bind('scroll', function () {
                        var objDiv = jQuery($('#message-detail'));
                        if (objDiv[0].scrollTop === 0 && vm.isBusy === false) {
                            vm.messagePageNumber += 1;
                            vm.isBusy = true;
                            loadMoreMessage();
                        }
                    });
                });
            }

            vm.messageOpen = function (id) {
                vm.messageViewed(id);
                paramHelper.setParams([{'messageId': id}]);
                $state.go('messageCenter.messageCenter');
            };

            vm.messageViewed = function (id) {
                dataservice.unreadedMessagesViewed(id).then(function () {
                    log.infoMsg('MessageMarkedAsRead');
                });
            };

            vm.messageSend = function () {
                if (!vm.openedMessageTargyId) {
                    log.errorMsg('Válasszon ki egy üzenetet!');
                } else {
                    if (!vm.Message) {
                        return;
                    }
                    var parameters = {SubjectId: vm.openedMessageTargyId, Message: vm.Message};
                    vm.Message = null;
                    dataservice.SikerMobileFreeSendMessage(parameters).then(function (response) {
                        if (response.retValue) {
                            log.successMsg(gettextCatalog.getString('SendSuccessful'));
                            getMessages(vm.openedMessageTargyId);
                            vm.selectedMessageIndex = 0;
                            refreshList();
                        }
                    });
                }
            };

            vm.finished = function () {
                var objDiv = $('#message-detail');
                // ne kerülön vissza a
                if (vm.messagePageNumber === 1) {
                    objDiv[0].scrollTop = objDiv[0].scrollHeight;
                }
            };

            function loadMoreListItem() {
                dataservice.GetMessageGroups(vm.listPageNumber).then(function (resp) {
                    if (resp.itemsList.length === 0) {
                        vm.listPageNumber -= 1;
                        angular.element(document.querySelector('#message-list')).unbind('scroll');
                        return;
                    }
                    resp.itemsList.forEach(function (item) {
                        vm.dataMessages.push(item);
                    });
                    $timeout(function () {
                        $scope.$apply();
                    }, 0);
                });
            };

            function loadMoreMessage() {
                dataservice.getMessages(vm.openedMessageTargyId, vm.messagePageNumber, vm.itemsPerMessage).then(function (resp) {
                    if (resp.itemsList.length === 0) {
                        vm.listPageNumber += 1;
                        angular.element(document.querySelector('#message-detail')).unbind('scroll');
                        return;
                    }
                    var objDivBefore = $('#message-detail');
                    var rowSizeBeforeLoadMore = objDivBefore[0].scrollHeight - objDivBefore[0].clientHeight;
                    resp.itemsList.reverse().forEach(function (item) {
                        vm.SelectedMessageDateSource.unshift(item);
                    });

                    $timeout(function () {
                        vm.isBusy = false;
                        var objDivAfter = $('#message-detail');
                        var rowSizeAfterLoadMore = objDivAfter[0].scrollHeight - objDivAfter[0].clientHeight;
                        objDivAfter[0].scrollTop = rowSizeAfterLoadMore - rowSizeBeforeLoadMore;
                        $scope.$apply();
                    }, 0);
                    imageSet(vm.SelectedMessageDateSource);
                });
            };

            function imageSet(array) {
                for (var i = 0; i < array.length; i++) {
                    if (array[i]['images'] != null) {
                        for (var j = 0; j < array[i]['images'].length; j++) {
                            array[i]['images'][j] = array[i]['images'][j].replace('_thumb', '');
                        }
                    }
                }
                $timeout(function() {
                    $('.message-wrapper').each(function() {
                        $(this).magnificPopup({
                            delegate: 'a',
                            type: 'image',
                            gallery: {
                                enabled: true
                            }
                        });
                    });
                }, 100);
            }
        }
    }

)();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.messageCenter.messageCenter')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'messageCenter.messageCenter',
                config: {
                    url: '/messageCenter',
                    templateUrl: 'app/messageCenter/messageCenter/messageCenter.html',
                    controller: 'MessageCenterController',
                    controllerAs: 'vm',
                    title: 'MessageCenter',
                    settings: {
                        navId: 9,
                        level: 1,
                        order: 9,
                        parentId: 0,
                        content: 'MessageCenter',
                        permission: ['0', '1', '2', '3', '4', '5', '6'],
                        activatorPermission: '"UZENETMEGT"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    NewMessageController.$inject = ["$q", "logger", "$rootScope", "gettextCatalog", "log", "$state", "dataservice", "$scope", "paramHelper", "$timeout", "authenticationService"];
    angular
        .module('app.messageCenter.newMessage')
        .controller('NewMessageController', NewMessageController);

    function NewMessageController($q, logger, $rootScope, gettextCatalog, log, $state, dataservice, $scope, paramHelper, $timeout, authenticationService) {
        var vm = this;
        $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('NewMessage');

        vm.toolbarClick = toolbarClick;
        vm.Message = '';
        vm.LIMITEDUSER = false;
        vm.SPORTOLOUSER = false;
        vm.SZULOUSER = false;

        vm.getUsersUserGroup = getUsersUserGroup;

        vm.RecipientsIds = [];
        vm.RecipientsNames = '';
        vm.RecipientsNamesArr = [];
        vm.recipientsText = gettextCatalog.getString('recipients');
        vm.clearText = gettextCatalog.getString('clear');
        vm.showRecipientsText = gettextCatalog.getString('showRecipients');

        vm.usersList = [];
        vm.athletesList = [];
        vm.parentsList = [];
        vm.usersGroupList = [];
        vm.sectionsList = [];
        vm.teamsAthletesList = [];
        vm.teamParentsList = [];
        vm.ageGroupsList = [];
        vm.ageGroupsParentsList = [];

        vm.usersListAll = [];
        vm.athletesListAll = [];
        vm.parentsListAll = [];
        vm.usersGroupListAll = [];
        vm.sectionsListAll = [];
        vm.teamsAthletesListAll = [];
        vm.teamParentsListAll = [];
        vm.ageGroupsListAll = [];
        vm.ageGroupsParentsListAll = [];

        activate();

        let recipientsList = [];
        let recipients = new Set();
        let MultiSelect = new ej2.dropdowns.MultiSelect({
            dataSource: vm.recipientsList,
            fields: {groupBy: 'group', value: 'usersof', text: 'text'},
            mode: 'CheckBox',
            placeholder: gettextCatalog.getString('recipients'),
            showDropDownIcon: true,
            filterBarPlaceholder: gettextCatalog.getString('Search')
        });
        MultiSelect.appendTo('#recipients');

        function toolbarClick(params) {
            switch (params.currentTarget.id) {
                case '1':
                    SendMessage();
                    break;
                case '2':
                    $state.go('messageCenter.messageCenter');
                    break;
            }
        }

        function SendMessage() {
            recipients = MultiSelect.checkBoxSelectionModule.activeLi;

            var hiba = '';
            if (recipients.length === 0) {
                hiba += 'Legalább egy címzettet adjon meg!';
            }
            if (vm.Message.length === 0) {
                hiba += '<br>Adjon meg üzenetet!';
            }
            if (hiba.length > 0) {
                log.errorMsg(hiba);
                return;
            }
            vm.Obj = {};
            vm.Obj.Ids = [];
            recipients.forEach((element) => {
                vm.Obj.Ids.push(element.dataset.value);
            });
            vm.Obj.Message = vm.Message;

            dataservice.SikerMobileFreeSendNewMessage(vm.Obj).then(function () {
                log.successMsg('SendSuccessful');
                $state.go('messageCenter.messageCenter');
            });
        }

        function getUserId() {
            getUsersUserGroup(authenticationService.getAuthData().id);
        }

        function getUsersUserGroup(userid) {
            dataservice.UsersUserGroup(userid)
                .then(function (data) {
                    vm.LIMITEDUSER = false;
                    for (var i = 0; i < data.data.length; i++) {
                        switch (data.data[i]) {
                            case 'SZULO':
                                vm.SZULOUSER = true;
                                vm.LIMITEDUSER = true;
                                break;
                            case 'SPORTOLO':
                                vm.SPORTOLOUSER = true;
                                vm.LIMITEDUSER = true;
                                break;
                        }
                    }
                    return data.data;
                });
        }

        let UsersListView = new ej2.lists.ListView({
            dataSource: vm.usersList,
            showCheckBox: true,
            fields: {text: 'text', id: 'value'}
        });
        let AthletesListView = new ej2.lists.ListView({
            dataSource: vm.athletesList,
            showCheckBox: true,
            fields: {text: 'text', id: 'value'}
        });
        let ParentsListView = new ej2.lists.ListView({
            dataSource: vm.athletesList,
            showCheckBox: true,
            fields: {text: 'text', id: 'value'}
        });
        let UserGroupsListView = new ej2.lists.ListView({
            dataSource: vm.athletesList,
            showCheckBox: true,
            fields: {text: 'text', id: 'value'}
        });
        let SectionsCoachesListView = new ej2.lists.ListView({
            dataSource: vm.athletesList,
            showCheckBox: true,
            fields: {text: 'text', id: 'value'}
        });
        let TeamsAthletesListView = new ej2.lists.ListView({
            dataSource: vm.athletesList,
            showCheckBox: true,
            fields: {text: 'text', id: 'value'}
        });
        let TeamsAthletesParentsListView = new ej2.lists.ListView({
            dataSource: vm.athletesList,
            showCheckBox: true,
            fields: {text: 'text', id: 'value'}
        });
        let AgegroupsAthletesListView = new ej2.lists.ListView({
            dataSource: vm.athletesList,
            showCheckBox: true,
            fields: {text: 'text', id: 'value'}
        });
        let AgegroupsAthletesParentsListView = new ej2.lists.ListView({
            dataSource: vm.athletesList,
            showCheckBox: true,
            fields: {text: 'text', id: 'value'}
        });

        let Tabs = new ej2.navigations.Tab({
            items: [
                {
                    header: {text: gettextCatalog.getString('Users')},
                    content: '<div id="ListUsers"></div>'
                },
                {
                    header: {text: gettextCatalog.getString('Athletes')},
                    content: '<div id="ListAthletes"></div>'
                },
                {
                    header: {text: gettextCatalog.getString('Parents')},
                    content: '<div id="ListParents"></div>'
                },
                {
                    header: {text: gettextCatalog.getString('UserGroups')},
                    content: '<div id="ListUserGroups"></div>'
                },
                {
                    header: {text: gettextCatalog.getString('SectionsCoaches')},
                    content: '<div id="ListSectionsCoaches"></div>'
                },
                {
                    header: {text: gettextCatalog.getString('Team\'s athletes')},
                    content: '<div id="ListTeamsAthletes"></div>'
                },
                {
                    header: {text: gettextCatalog.getString('Team\'s athletes parents')},
                    content: '<div id="ListTeamsAthletesParents"></div>'
                },
                {
                    header: {text: gettextCatalog.getString('Agegroup\'s athletes')},
                    content: '<div id="ListAgegroupsAthletes"></div>'
                },
                {
                    header: {text: gettextCatalog.getString('Agegroup\'s athletes parents')},
                    content: '<div id="ListAgegroupsAthletesParents"></div>'
                }
            ],
            overflowMode: 'Scrollable',
            heightAdjustMode: 'Auto',
        });
        Tabs.appendTo('#Tabs');
        UsersListView.appendTo('#ListUsers');
        AthletesListView.appendTo('#ListAthletes');
        ParentsListView.appendTo('#ListParents');
        UserGroupsListView.appendTo('#ListUserGroups');
        SectionsCoachesListView.appendTo('#ListSectionsCoaches');
        TeamsAthletesListView.appendTo('#ListTeamsAthletes');
        TeamsAthletesParentsListView.appendTo('#ListTeamsAthletesParents');
        AgegroupsAthletesListView.appendTo('#ListAgegroupsAthletes');
        AgegroupsAthletesParentsListView.appendTo('#ListAgegroupsAthletesParents');

        function activate() {
            $q.all([authenticationService.getRight('UZENETIR')]).then(function (results) {
                vm.UZENETIR = results[0];
                if (!vm.UZENETIR) {
                    log.permissionError(true);
                }
            });

            getUserId();
            vm.toolbarItems = [
                {empid: 1, tooltiptext: gettextCatalog.getString('msgSend'), spriteCss: 'msgtools newSend'},
                {empid: 2, tooltiptext: gettextCatalog.getString('msgRecieved'), spriteCss: 'msgtools msgrcvd'},
            ];

            vm.toolbarPopupItems = [
                {empid: 1, tooltiptext: gettextCatalog.getString('msgOk'), spriteCss: 'msgtools Accept'},
                {empid: 2, tooltiptext: gettextCatalog.getString('msgCancel'), spriteCss: 'msgtools Back'}
            ];
            // ÖSSZES
            dataservice.Cimjegyzek().then(function (data) {
                MultiSelect.dataSource = data.itemsList;
            });
            $q.all([paramHelper.getParams([], ['newMessage.Message', 'newMessage.OriginalSenderId', 'newMessage.OriginalSenderName'])]).then(function (result) {
                vm.Message = result[0]['newMessage.Message'];
                vm.RecipientsIds = [];
                vm.RecipientsNames = '';
                vm.RecipientsNamesArr = [];
                if (result[0]['newMessage.OriginalSenderId'] > 0) {
                    vm.RecipientsIds.push(result[0]['newMessage.OriginalSenderId']);
                }
                vm.RecipientsNames = result[0]['newMessage.OriginalSenderName'];
            });
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.messageCenter.newMessage')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'messageCenter.newMessage',
                config: {
                    url: '/newMessage',
                    templateUrl: 'app/messageCenter/newMessage/newMessage.html',
                    controller: 'NewMessageController',
                    controllerAs: 'vm',
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    SentMessagesController.$inject = ["$q", "$rootScope", "gettextCatalog", "dataservice", "$scope", "log", "authenticationService", "paramHelper", "$state", "$timeout"];
    angular
        .module('app.messageCenter.sentMessages')
        .controller('SentMessagesController', SentMessagesController);

    function SentMessagesController($q, $rootScope, gettextCatalog, dataservice, $scope, log, authenticationService, paramHelper, $state, $timeout) {
        var vm = this; $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('MessageCenterSentMessages');
        //Grid nyomtatás, exportálás nyomógomb
        vm.goToUser = goToUser;
        vm.gridRowSelected = gridRowSelected;
        vm.SelectedMessage = {};
        vm.toolbarClick = toolbarClick;
        vm.loadMessageId = -1;
        vm.columnsMessages = [];

        initGrid();

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItemsWithSearch,
            allowPaging: true,
            allowTextWrap: true,
            allowSorting: true,
            allowExcelExport: true,
            allowDeleting: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columnsMessages,
            rowSelected: vm.gridRowSelected,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile(angular.element('#Grid'), $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        vm.EditMessageText = gettextCatalog.getString('Directory');
        vm.Uzenet = gettextCatalog.getString('Message');

        activate();

        function activate() {
            vm.toolbarItems = [
                {empid: 1, tooltiptext: gettextCatalog.getString('msgSendNew'), spriteCss: 'msgtools newmsg', group: '1'},
                {empid: 3, tooltiptext: gettextCatalog.getString('msgForward'), spriteCss: 'msgtools msgforward', group: '2'},
                {empid: 5, tooltiptext: gettextCatalog.getString('Print'), spriteCss: 'msgtools msgprint', group: '3'},
                {empid: 8, tooltiptext: gettextCatalog.getString('Delete'), spriteCss: 'msgtools msgdelete', group: '4'},
                {empid: 7, tooltiptext: gettextCatalog.getString('msgRecieved'), spriteCss: 'msgtools msgrcvd', group: '5'}
            ];
            vm.dataMessages = [];

            var selectThisRow = -1;
            var selectThisPage = 0;
            var pageSize = 5;
            var elem = {};
            $q.all([paramHelper.getParams([], ['messageId']),
                authenticationService.getRight('MEGTFELH')]).then(function (results) {
                vm.MEGTFELH = results[1];
                vm.loadMessageId = results[0].messageId;
                paramHelper.removeParam('messageId');
                initGrid();
                paramHelper.removeParam('messageId');
                dataservice.getSentMessages().then(function (data) {
                    vm.dataMessages = data.itemsList;
                    for (var i = 0; i < vm.dataMessages.length; i++) {
                        vm.dataMessages[i].index = i;
                        vm.dataMessages[i].clicked = 0;
                    }
                    grid.dataSource = vm.dataMessages;
                    $timeout(function () {
                        if (vm.loadMessageId !== -1 || vm.loadMessageId !== null) {
                            elem = vm.dataMessages.filter(function (a) {
                                return a.Id === vm.loadMessageId;
                            });
                            if (vm.loadMessageId > 0) {
                                for (var i = 0; i < vm.dataMessages.length; i++) {
                                    if (elem[0].Id === vm.dataMessages[i].Id) {
                                        break;
                                    }
                                }
                                selectThisRow = i;
                                selectThisPage = parseInt((selectThisRow / pageSize));
                                selectThisRow = selectThisRow - selectThisPage * pageSize;
                                selectThisPage++;
                                grid.dataSource = vm.dataMessages;
                                grid.allowPaging = true;
                                grid.pageSettings.pageSize = pageSize;
                                if (selectThisRow !== -1) {
                                    grid.getPager().goToPage(selectThisPage);
                                    vm.selectThisRow = selectThisRow;
                                    selectRow(selectThisRow);
                                }
                            }
                        }
                    }, 0);
                });
            });
        }

        function goToUser(edzoId) {
            if (!vm.MEGTFELH) {
                log.permissionError();
                return;
            }
            paramHelper.setParams([{'newUser.userId': edzoId}]);
            $state.go('settings.userManagement.modifyUser');
        }

        function initGrid() {
            vm.columnsMessages = [];
            vm.columnsMessages = [
                {field: 'Id', visible: false, isPrimaryKey: true, isIdentity: true},
                {
                    field: 'Olvasott',
                    headerText: '',
                    textAlign: 'center',
                    width: '40px',
                    allowEditing: false,
                    type: 'string',
                    template: '#mecetemplateDataColumn1'
                },
                {
                    field: 'CimzettNev',
                    headerText: gettextCatalog.getString('Addressee'),
                    textAlign: 'center',
                    width: '150px',
                },
                {
                    field: 'Datum',
                    headerText: gettextCatalog.getString('Date'),
                    textAlign: 'center',
                    width: '100px',
                },
            ];
        }

        function gridRowSelected(params) {
            vm.SelectedMessage = params.data;
            vm.selectThisRow = params.rowIndex; // A gridben hanyadik elem
            var msgIndex = params.data.index; // hanyadik levele a usernek
            if (!params.data.Viewed) {
                vm.SelectedMessage.Viewed = true;
                grid.refresh();
                grid.selectedRowIndex = params.rowIndex;
            }
            setTimeout(function () {
                $scope.$apply();
            }, 10);
        }

        function selectRow() {
            grid.selectRows = vm.selectThisRow;
        }

        function toolbarClick(params) {
            switch (params.currentTarget.id) {
                case '1':
                    paramHelper.setParams([{
                        'newMessage.Message': '',
                        'newMessage.OriginalSenderId': 0,
                        'newMessage.OriginalSenderName': ''
                    }
                    ]);
                    $state.go('messageCenter.newMessage');
                    break;
                case '3':
                    if (!vm.SelectedMessage.Id) {
                        log.errorMsg('Válasszon ki egy üzenetet!');
                        return;
                    }
                    paramHelper.setParams([{
                        'newMessage.Message': '\r\n\r\n--- ' + gettextCatalog.getString('OriginalMessage') + ' ---\r\n' +
                         gettextCatalog.getString('Sender') + ': ' + vm.SelectedMessage.FeladoNev + '\r\n' +
                         gettextCatalog.getString('Addressee') + ': ' + vm.SelectedMessage.CimzettNev + '\r\n' +
                         gettextCatalog.getString('Time') + ': ' + vm.SelectedMessage.Datum + '\r\n\r\n\r\n' +
                         vm.SelectedMessage.Uzenet,
                        'newMessage.OriginalSenderId': 0,
                        'newMessage.OriginalSenderName': '',
                    }]);
                    $state.go('messageCenter.newMessage');
                    break;
                case '5':
                    if (!vm.SelectedMessage.Id) {
                        log.errorMsg('Válasszon ki egy üzenetet!');
                    } else {
                        var newWindow = window.open();
                        var x = document.getElementById('printDiv').innerHTML;
                        newWindow.document.write(x);
                        newWindow.print();
                        newWindow.close();
                    }
                    break;
                case '7':
                    $state.go('messageCenter.messageCenter');
                    break;
                case '8':
                    if (!vm.SelectedMessage.Id) {
                        log.errorMsg('Válasszon ki egy üzenetet!');
                        return;
                    }
                    swal({title: gettextCatalog.getString('DoYouWantDelete'),
                        type: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#DD6B55',
                        confirmButtonText: gettextCatalog.getString('YesIWantDelete'),
                        cancelButtonText: gettextCatalog.getString('Cancel'),
                    }).then(function(isConfirm) {
                        if (isConfirm.value) {
                            dataservice.messageDeleteSent(vm.SelectedMessage.Id).then(function () {
                                log.infoMsg('MessageMarkAsDeleted');
                                refreshList();
                                setTimeout(function() {
                                    $scope.$apply();
                                }, 10);
                                vm.SelectedMessage = {};
                            });
                        }
                    });
                    break;
            }
        }

        function refreshList() {
            dataservice.getSentMessages().then(function (data) {
                vm.dataMessages = [];
                vm.dataMessages = data.itemsList;
            });
            initGrid();
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.messageCenter.sentMessages')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'messageCenter.sentMessages',
                config: {
                    url: '/sentMessages',
                    templateUrl: 'app/messageCenter/sentMessages/sentMessages.html',
                    controller: 'SentMessagesController',
                    controllerAs: 'vm',
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    FilesController.$inject = ["log", "dataservice", "$q", "$rootScope", "gettextCatalog", "$scope", "paramHelper", "DOMAIN"];
    angular
        .module('app.other.files')
        .controller('FilesController', FilesController);

    function FilesController(log, dataservice, $q, $rootScope, gettextCatalog, $scope, paramHelper, DOMAIN) {
        var vm = this; $rootScope.vm = vm;
        $rootScope.title = $rootScope.title + gettextCatalog.getString('Contracts');
        vm.title = gettextCatalog.getString('Contracts');

        //grid adatai
        vm.data = [];
        vm.columns = [{
                field: 'Id',
                visible: false,
                isPrimaryKey: true,
                isIdentity: true
            },
            {
                field: 'Filenev',
                headerText: gettextCatalog.getString('Filename'),
                textAlign: 'center',
                allowEditing: false,
                template: '#fitemplateDataColumn1'
            },
            {
                field: 'Datum',
                headerText: gettextCatalog.getString('Date'),
                textAlign: 'center',
                allowEditing: false
            }
        ];

        vm.selectedRow = -1;
        vm.deleteFile = deleteFile;

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItemsWithSearch,
            allowPaging: true,
            allowTextWrap: true,
            allowSorting: true,
            allowExcelExport: true,
            allowDeleting: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            selectedRowIndex: vm.selectedRow,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile(angular.element('#Grid'), $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        activate();

        function activate() {
            angular.element('#UploadDefault').ejUploadbox({
                saveUrl: DOMAIN.baseURL + DOMAIN.webService + 'FileUpload',
                removeUrl: DOMAIN.baseURL + DOMAIN.webService + 'FileRemove',
                uploadName: 'Uploadbox',
                allowDragAndDrop: false,
                autoUpload: true,
                buttonText: {browse: gettextCatalog.getString('ChooseFile'), upload: gettextCatalog.getString('UploadFile'), cancel: gettextCatalog.getString('CancelUpload')},
                dialogAction: {modal: true, closeOnComplete: true, resize: false, drag: false},
                dialogText: {title: gettextCatalog.getString('UploadedFilesTitle'), name: gettextCatalog.getString('FileName'), size: gettextCatalog.getString('FileSize'), status: gettextCatalog.getString('FileStatus')},
                dropAreaText: gettextCatalog.getString('DropFileToUpload'),
                extensionsAllow: '.doc,.docx,.pdf,.xls,.mp4,.avi',
                complete: function () {
                    log.successMsg(gettextCatalog.getString('UploadSuccessed'));
                    getFiles();
                },
                error: function (args) {
                    var err = '';
                    if (args.error === 'Only files with .doc, .docx, .pdf, .xls, .mp4, .avi extensions are allowed.') {
                        err = gettextCatalog.getString('OnlyDocPdfXls');
                    } else if (args.error === '500 Internal Server Error') {
                        err = gettextCatalog.getString('ToLongFile');
                    }
                    log.htmlError(gettextCatalog.getString('UploadError') + '<br>' + err);
                },
                begin: function (args) {
                    args.data = {tipus: vm.tipus, tablaId: vm.tablaId};
                }
            });

            var promises = [paramHelper.getParams([], ['files.tipus', 'files.tablaId', 'weeklyTrainingPlan.edzoId', 'weeklyTrainingPlan.szakosztalyId', 'weeklyTrainingPlan.korosztalyId', 'weeklyTrainingPlan.ev', 'weeklyTrainingPlan.trainingPlanId', 'weeklyTrainingPlan.edzoNev', 'weeklyTrainingPlan.szakosztalyNev', 'weeklyTrainingPlan.korosztalyNev'])];

            return $q.all(promises).then(function (results) {
                if (angular.isDefined(results[0]['files.tipus'])) {
                    vm.tipus = results[0]['files.tipus'];
                }
                if (angular.isDefined(results[0]['files.tablaId'])) {
                    vm.tablaId = results[0]['files.tablaId'];
                }
                if (angular.isDefined(results[0]['weeklyTrainingPlan.edzoId'])) {
                    vm.selectedCoach = results[0]['weeklyTrainingPlan.edzoId'];
                }
                if (angular.isDefined(results[0]['weeklyTrainingPlan.edzoNev'])) {
                    vm.coachName = results[0]['weeklyTrainingPlan.edzoNev'];
                }
                if (angular.isDefined(results[0]['weeklyTrainingPlan.szakosztalyId'])) {
                    vm.selectedSection = results[0]['weeklyTrainingPlan.szakosztalyId'];
                }
                if (angular.isDefined(results[0]['weeklyTrainingPlan.szakosztalyNev'])) {
                    vm.sectionName = results[0]['weeklyTrainingPlan.szakosztalyNev'];
                }
                if (angular.isDefined(results[0]['weeklyTrainingPlan.korosztalyId'])) {
                    vm.selectedAgeGroup = results[0]['weeklyTrainingPlan.korosztalyId'];
                }
                if (angular.isDefined(results[0]['weeklyTrainingPlan.korosztalyNev'])) {
                    vm.ageGroupName = results[0]['weeklyTrainingPlan.korosztalyNev'];
                }
                if (angular.isDefined(results[0]['weeklyTrainingPlan.ev'])) {
                    vm.selectedYear = results[0]['weeklyTrainingPlan.ev'];
                }
                getFiles();
            });
        }

        function getFiles() {
            dataservice.getFilesList(vm.tipus, vm.tablaId).then(
                function (data) {
                    vm.data = data.itemsList;
                    grid.dataSource = vm.data;
                });
        }

        function deleteFile() {
            if (grid.getSelectedRowIndexes().size === 0) {
                log.errorMsg('SelectFile');
                return;
            }

            swal({title: gettextCatalog.getString('Are you sure you want to delete the selected file?'),
                text: gettextCatalog.getString('You will not be able to recover it!'),
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: gettextCatalog.getString('Yes, delete this file'),
                cancelButtonText: gettextCatalog.getString('Cancel'),
                closeOnConfirm: false,
                closeOnCancel: false
            }).then(function(isConfirm) {
                if (isConfirm.value) {
                    return dataservice.deleteFiles(vm.data[grid.getSelectedRowIndexes()[0]].Id).then(
                            function() {
                                log.successMsg(gettextCatalog.getString('FileDeleted'));
                                getFiles();
                            }
                        );
                }
            });
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.other.files')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'other.files',
                config: {
                    url: '/files',
                    templateUrl: 'app/other/files/files.html',
                    controller: 'FilesController',
                    controllerAs: 'vm'
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.other')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'other',
                config: {
                    title: 'Other',
                    url: '/other',
                    templateUrl: 'app/other/other.html'
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    DashboardController.$inject = ["$q", "dataservice", "log", "DOMAIN", "$location", "paramHelper", "$state", "$scope", "authenticationService", "gettextCatalog", "$rootScope", "$timeout"];
    angular
        .module('app.paint')
        .controller('PaintController', DashboardController);

    function DashboardController($q, dataservice, log, DOMAIN, $location, paramHelper, $state, $scope, authenticationService, gettextCatalog, $rootScope, $timeout) {
        var vm = this;
        $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('Paint');

        vm.enabledResizeRotate = false;
        var canvas;
        var ctx;
        var interval = null;

        var WIDTH = $('#canvasWrapper').width() - 17;
        var HEIGHT = WIDTH / 594 * 319;

        var scaleWidth = 1;
        var scaleHeight = 1;
        /*
        Modes:
            0 - Pen
            1 - Select
            2 - Resize
            3 - Rotate
         */
        vm.activeMode = 1;

        var paintId = null;
        vm.public = false;
        vm.sectionDropDownEnabled = true;
        vm.checkBoxEnabled = false;
        vm.deleteEnabled = false;

        vm.clickedElement = null;
        var clickedElementIndex = -1;

        var maxUndoStates = 10;
        var lineSize = 3;
        vm.background = 6;
        var arrowPointRadius = 15;
        var lineId = 0;
        var color = '#000000';
        var textColor = '#ffffff';
        var fontSize = 18;
        var font = fontSize + 'pt Arial';
        vm.label = '';
        var objectCounter = 0;

        var imageWidth = WIDTH;
        var imageHeight = HEIGHT;
        var imageObj = null;

        // Visszavonáshoz
        var stateLast = true;
        vm.stateId = -1;
        var states = [];

        // Animációhoz
        var selectedAnimationId = -1;
        vm.animationStates = [];

        // Mentés és betöltés
        vm.paintName = '';
        vm.sectionId = null;
        vm.agegroupId = null;
        vm.agegroupValue = null;
        vm.ageGroupList = [];

        var lines = [];
        var objects = [];

        function saveState() {
            if (stateLast === false) {
                for (var i = maxUndoStates; i > vm.stateId; i--) {
                    states.splice(i, 1);
                }
                stateLast = true;
            }
            var stateTemp = {lines: $.extend(true, [], lines), objects: $.extend(true, [], objects), lineId: lineId};
            stateTemp.objects.forEach(function (element) {
                element.clicked = false;
            });
            if (vm.stateId < maxUndoStates) {
                states.push(stateTemp);
                vm.stateId++;
            } else {
                states.shift();
                states.push(stateTemp);
            }
            vm.redoEnable = false;
            scopeApply();
        }

        function getSections() {
            return dataservice.sectionDropDownList(0).then(function (data) {
                vm.sectionList = data.itemsList;
            });
        }

        function getAgeGroups() {
            return dataservice.ageGroupSelect(0, vm.sectionId).then(function (data) {
                data.itemsList.unshift({text: gettextCatalog.getString('All'), value: 0});
                vm.ageGroupList = data.itemsList;
                $timeout(function () {
                    if (vm.agegroupValue) {
                        angular.element('#agegroupDropDown').ejDropDownList('selectItemByValue', vm.agegroupValue);
                        vm.selectedAgeGroup = vm.agegroupValue;
                    }
                    $scope.$apply();
                }, 100);
            });
        }

        // Run after data bounded
        vm.sectionDataBound = function sectionDataBound() {
            if (vm.sectionList.length === 1) {
                vm.sectionId = vm.sectionList[0].value;
                angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.sectionList[0].value);
            } else {
                angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.sectionId);
            }
        };

        vm.ageGroupDataBound = function ageGroupDataBound() {
            if (vm.ageGroupList.length === 1) {
                angular.element('#agegroupDropDown').ejDropDownList('selectItemByValue', vm.ageGroupList[0].value);
                vm.selectedAgeGroup = vm.ageGroupList[0].value;
            } else {
                angular.element('#agegroupDropDown').ejDropDownList('selectItemByValue', vm.selectedAgeGroup);
            }
        };

        vm.sectionSelect = function sectionSelect(args) {
            vm.sectionId = args.value;
            getAgeGroups();
        };

        vm.agegroupSelect = function agegroupSelect(args) {
            vm.agegroupId = args.value;
        };

        vm.undo = function undo() {
            if (vm.stateId > 0) {
                stateLast = false;
                vm.stateId--;
                lines = $.extend(true, [], states[vm.stateId].lines);
                objects = $.extend(true, [], states[vm.stateId].objects);
                lineId = states[vm.stateId].lineId;
            }
            vm.redoEnable = true;
        };

        vm.redo = function redo() {
            if (stateLast === false && vm.stateId + 1 < states.length) {
                vm.stateId++;
                lines = $.extend(true, [], states[vm.stateId].lines);
                objects = $.extend(true, [], states[vm.stateId].objects);
                lineId = states[vm.stateId].lineId;
            }
            if (stateLast === false && vm.stateId + 1 < states.length) {
                vm.redoEnable = true;
            } else {
                vm.redoEnable = false;
            }
        };

        var backgrounds = [{
            text: gettextCatalog.getString('FootballPitch'),
            src: '/images/football_pitch.png',
            value: 1
        },
            {text: gettextCatalog.getString('Grass'), src: '/images/green_background.png', value: 2},
            {text: gettextCatalog.getString('BasketballCourt'), src: '/images/basketball_court.png', value: 3},
            {text: gettextCatalog.getString('HandballCourt'), src: '/images/handball_court.png', value: 4},
            {text: gettextCatalog.getString('HockeyRink'), src: '/images/hockey_rink.jpeg', value: 5},
            {text: gettextCatalog.getString('NoBackground'), src: '/images/none.png', value: 6}];

        function init() {
            getSections();
            // Háttér választó
            $('#Background').ejDropDownList({
                dataSource: backgrounds,
                value: vm.background,
                template: '<div><img src="${src}" style="height: 30px;margin-right: 1em;"/>${text}</div>',
                change: backgroundChanged,
                enabled: vm.checkBoxEnabled,
                width: 250
            });

            // Vonal vastagság választó
            $('#LineSize').ejDropDownList({
                dataSource: [{text: gettextCatalog.getString('LineSize1'), src: '/images/line_size_1.png', value: 1},
                    {text: gettextCatalog.getString('LineSize2'), src: '/images/line_size_3.png', value: 3},
                    {text: gettextCatalog.getString('LineSize3'), src: '/images/line_size_5.png', value: 5}],
                value: lineSize,
                template: '<div><img src="${src}"/></div>',
                change: penWidthChanged,
                enabled: vm.checkBoxEnabled,
                width: 200
            });

            // Háttérszínválasztó
            $('#Color').ejColorPicker({
                value: color,
                enableOpacity: false,
                change: colorChanged,
                enabled: vm.checkBoxEnabled,
                modelType: 'Palette'
            });

            // Szövegszínválasztó
            $('#TextColor').ejColorPicker({
                value: textColor,
                enableOpacity: false,
                change: textColorChanged,
                enabled: vm.checkBoxEnabled,
                modelType: 'Palette'
            });

            // Canvas létrehozása
            canvas = document.getElementById('canvas');
            // Szélesség a maximális szélesség
            canvas.width = WIDTH;
            // Magasság alapértelmezett
            canvas.height = WIDTH / 594 * 319;
            // Context mentése
            ctx = canvas.getContext('2d');
            // Vonalvastagás, betűtípus, betűméret beállítása
            ctx.lineSize = lineSize;
            ctx.font = '16px Arial';
            // Click esemény beállítása
            canvas.onmousedown = canvasClicked;

            //paramHelper.setParams([{'Paint.id': 3}]);
            paramHelper.getParams([], ['Paint.id']).then(function (result) {
                paintId = result['Paint.id'];
                // paintId = 3;
                paramHelper.removeParam('Paint.id');
                if (paintId) {
                    dataservice.getPaint({id: paintId}).then(function (res) {
                        vm.authData = authenticationService.getAuthData();
                        vm.sectionDropDownEnabled = false;
                        var response = res.retValue;
                        if (response.userId === parseInt(vm.authData.id)) {
                            vm.checkBoxEnabled = true;
                            vm.deleteEnabled = true;
                            $('#Background').ejDropDownList('enable');
                            $('#LineSize').ejDropDownList('enable');
                            $('#Color').ejColorPicker('enable');
                        }
                        var data = JSON.parse(response.data);
                        vm.paintName = response.paintName;
                        vm.sectionId = response.sectionId;
                        vm.sectionSelect({value: vm.sectionId});
                        vm.agegroupId = response.agegroupId;
                        vm.agegroupValue = response.agegroupId;
                        vm.selectedAgeGroup = response.agegroupId;
                        lineId = data.lineId;
                        objectCounter = data.objectCounter;
                        ctx.scale(WIDTH / data.imageWidth, HEIGHT / data.imageHeight);
                        scaleWidth = WIDTH / data.imageWidth;
                        scaleHeight = HEIGHT / data.imageHeight;
                        imageWidth = data.imageWidth;
                        imageHeight = data.imageHeight;
                        $('#Background').ejDropDownList('selectItemByValue', data.background);
                        vm.public = response.publikus;
                        data.animationStates.forEach(function (el) {
                            el.objects.forEach(function (el2) {
                                if (el2.type === 'ball') {
                                    var tmp = el2.image;
                                    el2.image = new Image();
                                    el2.image.src = tmp;
                                }
                            });
                        });
                        vm.animationStates = data.animationStates;
                        lines = data.lines;
                        data.objects.forEach(function (el) {
                            if (el.type === 'ball') {
                                var tmp = el.image;
                                el.image = new Image();
                                el.image.src = tmp;
                            }
                        });
                        objects = data.objects;
                    });
                }

                // Kirajzolás intervalból hivása
                saveState();
                interval = setInterval(draw, 10);
            });
        }

        // Rajzoló metódusok
        // Kör
        function circle(x, y, r) {
            ctx.beginPath();
            ctx.arc(x, y, r, 0, 2 * Math.PI, false);
            ctx.fill();
            ctx.stroke();
        }

        // Téglalap
        function rect(x, y, w, h) {
            ctx.beginPath();
            ctx.rect(x, y, w, h);
            ctx.stroke();
            ctx.fill();
            ctx.closePath();
        }

        function triangle(x, y, w, h) {
            ctx.beginPath();
            ctx.setLineDash([0, 0]);
            ctx.moveTo(x, y + h);
            ctx.lineTo(x + w, y + h);
            ctx.lineTo(x + w / 2, y);
            ctx.lineTo(x, y + h);
            ctx.lineTo(x + w, y + h);
            ctx.stroke();
            ctx.fill();
            ctx.closePath();
        }

        function pentagon(x, y, w) {
            ctx.beginPath();
            ctx.setLineDash([0, 0]);

            var numberOfSides = 5;
            var size = w * 0.6;
            var Xcenter = x;
            var Ycenter = y;

            ctx.beginPath();
            ctx.moveTo(Xcenter + size * Math.cos(0), Ycenter + size * Math.sin(0));

            for (var i = 1; i <= numberOfSides; i += 1) {
                ctx.lineTo(Xcenter + size * Math.cos(i * 2 * Math.PI / numberOfSides), Ycenter + size * Math.sin(i * 2 * Math.PI / numberOfSides));
            }

            ctx.stroke();
            ctx.fill();
            ctx.closePath();
        }

        // Vonal
        function line(x1, y1, x2, y2) {
            ctx.beginPath();
            ctx.setLineDash([0, 0]);
            ctx.moveTo(x1, y1);
            ctx.lineTo(x2, y2);
            ctx.stroke();
            ctx.fill();
            ctx.closePath();
        }

        // Szaggatott vonal
        function dashedLine(fromx, fromy, tox, toy) {
            //variables to be used when creating the arrow
            var headlen = 10;

            var angle = Math.atan2(toy - fromy, tox - fromx);

            //starting path of the arrow from the start square to the end square and drawing the stroke
            ctx.beginPath();
            ctx.setLineDash([5, 5]);
            ctx.moveTo(fromx, fromy);
            ctx.lineTo(tox, toy);
            ctx.stroke();
            ctx.fill();
            ctx.closePath();
            ctx.beginPath();
            ctx.setLineDash([0, 0]);

            //starting a new path from the head of the arrow to one of the sides of the point
            ctx.moveTo(tox, toy);
            ctx.lineTo(tox - headlen * Math.cos(angle - Math.PI / 7), toy - headlen * Math.sin(angle - Math.PI / 7));

            //path from the side point of the arrow, to the other side point
            ctx.lineTo(tox - headlen * Math.cos(angle + Math.PI / 7), toy - headlen * Math.sin(angle + Math.PI / 7));

            //path from the side point back to the tip of the arrow, and then again to the opposite side point
            ctx.lineTo(tox, toy);
            ctx.lineTo(tox - headlen * Math.cos(angle - Math.PI / 7), toy - headlen * Math.sin(angle - Math.PI / 7));

            //draws the paths created above
            ctx.stroke();
            ctx.fill();
            ctx.closePath();
        }

        // Szaggatott vonal
        function dashedLine2(fromx, fromy, tox, toy) {
            //variables to be used when creating the arrow
            var headlen = 10;

            var angle = Math.atan2(toy - fromy, tox - fromx);

            //starting path of the arrow from the start square to the end square and drawing the stroke
            ctx.beginPath();
            ctx.setLineDash([10, 5]);
            ctx.moveTo(fromx, fromy);
            ctx.lineTo(tox, toy);
            ctx.stroke();
            ctx.fill();
            ctx.closePath();
            ctx.beginPath();
            ctx.setLineDash([0, 0]);

            //starting a new path from the head of the arrow to one of the sides of the point
            ctx.moveTo(tox, toy);
            ctx.lineTo(tox - headlen * Math.cos(angle - Math.PI / 7), toy - headlen * Math.sin(angle - Math.PI / 7));

            //path from the side point of the arrow, to the other side point
            ctx.lineTo(tox - headlen * Math.cos(angle + Math.PI / 7), toy - headlen * Math.sin(angle + Math.PI / 7));

            //path from the side point back to the tip of the arrow, and then again to the opposite side point
            ctx.lineTo(tox, toy);
            ctx.lineTo(tox - headlen * Math.cos(angle - Math.PI / 7), toy - headlen * Math.sin(angle - Math.PI / 7));

            //draws the paths created above
            ctx.stroke();
            ctx.fill();
            ctx.closePath();
        }

        // Nyíl
        function arrow(fromx, fromy, tox, toy) {
            //variables to be used when creating the arrow
            var headlen = 10;

            var angle = Math.atan2(toy - fromy, tox - fromx);

            //starting path of the arrow from the start square to the end square and drawing the stroke
            ctx.beginPath();
            ctx.setLineDash([0, 0]);
            ctx.moveTo(fromx, fromy);
            ctx.lineTo(tox, toy);

            //starting a new path from the head of the arrow to one of the sides of the point
            ctx.moveTo(tox, toy);
            ctx.lineTo(tox - headlen * Math.cos(angle - Math.PI / 7), toy - headlen * Math.sin(angle - Math.PI / 7));

            //path from the side point of the arrow, to the other side point
            ctx.lineTo(tox - headlen * Math.cos(angle + Math.PI / 7), toy - headlen * Math.sin(angle + Math.PI / 7));

            //path from the side point back to the tip of the arrow, and then again to the opposite side point
            ctx.lineTo(tox, toy);
            ctx.lineTo(tox - headlen * Math.cos(angle - Math.PI / 7), toy - headlen * Math.sin(angle - Math.PI / 7));

            //draws the paths created above
            ctx.stroke();
            ctx.fill();
            ctx.closePath();
        }

        function sine(fromx, fromy, tox, toy) {
            //variables to be used when creating the arrow

            var oFromx = fromx;
            var oFromy = fromy;

            tox = tox - fromx;
            fromx = 0;
            toy = toy - fromy;
            fromy = 0;

            var headlen = 10;

            var angle = Math.atan2(toy - fromy, tox - fromx);

            //starting path of the arrow from the start square to the end square and drawing the stroke
            ctx.beginPath();
            ctx.setLineDash([0, 0]);
            ctx.lineJoin = 'round';

            var unit = 3;
            var x = fromx;
            var y = Math.sin(x);

            var cosalfa = Math.cos(angle);
            var sinalfa = Math.sin(angle);

            var length = Math.sqrt(Math.pow(tox - fromx, 2) + Math.pow(toy - fromy, 2));

            ctx.moveTo(fromx + oFromx, unit * y + fromy + oFromy);

            var newX;
            var newY;

            // Loop to draw segments
            for (var i = 0; i <= length; i += 1) {
                x = i / unit;
                y = Math.sin(x);

                var oldX = fromx + i;
                var oldY = unit * y + fromy;

                newX = oldX * cosalfa - oldY * sinalfa;
                newY = oldX * sinalfa + oldY * cosalfa;

                ctx.lineTo(newX + oFromx, newY + oFromy);
            }

            ctx.stroke();
            ctx.closePath();
            ctx.beginPath();

            x = newX + oFromx - headlen / 2 * Math.cos(angle + Math.PI / 2);
            y = newY + oFromy - headlen / 2 * Math.sin(angle + Math.PI / 2);

            //starting a new path from the head of the arrow to one of the sides of the point
            ctx.moveTo(x, y);
            ctx.lineTo(x + headlen * Math.cos(angle + Math.PI / 2), y + headlen * Math.sin(angle + Math.PI / 2));

            //path from the side point of the arrow, to the other side point
            ctx.lineTo(x + headlen * Math.cos(angle + Math.PI / 7), y + headlen * Math.sin(angle + Math.PI / 7));

            //path from the side point back to the tip of the arrow, and then again to the opposite side point
            ctx.lineTo(x, y);
            ctx.lineTo(x + headlen * Math.cos(angle + Math.PI / 2), y + headlen * Math.sin(angle + Math.PI / 2));

            //draws the paths created above
            ctx.stroke();
            ctx.fill();
            ctx.closePath();
        }

        // Canvas törlése
        function clear() {
            ctx.clearRect(0, 0, WIDTH, HEIGHT);
        }

        // Vonalvastagság változik
        function penWidthChanged(args) {
            lineSize = args.value;
        }

        // Szín változik
        function colorChanged(args) {
            color = args.value;
        }

        // Szín változik
        function textColorChanged(args) {
            textColor = args.value;
        }

        // Klikk esemény
        function canvasClicked(e) {
            if (!vm.checkBoxEnabled) {
                return;
            }
            // Ha kijelölő mód aktív
            if (vm.activeMode !== 0) {
                // x, y koordináta meghatározása
                var x = (e.pageX - canvas.offsetLeft) / scaleWidth;
                var y = (e.pageY - canvas.offsetTop) / scaleHeight;
                // előző kijelölés törlése
                clearClicked();
                // kijelölt elem megkeresése
                objects.forEach(function (element, index) {
                    if (element.type === 'rect' || element.type === 'triangle' || element.type === 'pentagon') {
                        if (x < element.x + (element.width / 2) && x > element.x - (element.width / 2) &&
                            y < element.y + (element.height / 2) && y > element.y - (element.height / 2)) {
                            clearClicked();
                            vm.clickedElement = element;
                            clickedElementIndex = index;
                            vm.clickedElement.clicked = true;
                            vm.label = element.label;
                            canvas.onmousemove = moveObject;
                            canvas.onmouseup = moveEnd;
                        } else {
                            element.clicked = false;
                        }
                    } else if (element.type === 'circle') {
                        if (Math.pow(x - element.x, 2) + Math.pow(y - element.y, 2) < Math.pow(element.r, 2)) {
                            clearClicked();
                            vm.clickedElement = element;
                            clickedElementIndex = index;
                            vm.clickedElement.clicked = true;
                            vm.label = element.label;
                            canvas.onmousemove = moveObject;
                            canvas.onmouseup = moveEnd;
                        } else {
                            element.clicked = false;
                        }
                    } else if (element.type === 'arrow' || element.type === 'line' || element.type === 'dline' || element.type === 'dline2' || element.type === 'sine') {
                        if (x < element.x1 + arrowPointRadius && x > element.x1 - arrowPointRadius &&
                            y < element.y1 + arrowPointRadius && y > element.y1 - arrowPointRadius) {
                            clearClicked();
                            vm.clickedElement = element;
                            clickedElementIndex = index;
                            vm.clickedElement.clicked = true;
                            vm.label = element.label;
                            canvas.onmousemove = moveArrowStart;
                            canvas.onmouseup = moveEnd;
                        } else if ((x < element.x2 + arrowPointRadius && x > element.x2 - arrowPointRadius &&
                                y < element.y2 + arrowPointRadius && y > element.y2 - arrowPointRadius)) {
                            clearClicked();
                            vm.clickedElement = element;
                            clickedElementIndex = index;
                            vm.clickedElement.clicked = true;
                            vm.label = element.label;
                            canvas.onmousemove = moveArrorEnd;
                            canvas.onmouseup = moveEnd;
                        } else if (isPointOnSection({x: element.x1, y: element.y1}, {
                                x: element.x2,
                                y: element.y2
                            }, {x: x, y: y})) {
                            clearClicked();
                            vm.clickedElement = element;
                            clickedElementIndex = index;
                            vm.clickedElement.clicked = true;
                            vm.label = element.label;
                            old.x = x;
                            old.y = y;
                            canvas.onmousemove = moveArrow;
                            canvas.onmouseup = moveEnd;
                        } else {
                            element.clicked = false;
                        }
                    } else if (element.type === 'ball') {
                        var w = element.width / 2;
                        var h = element.height / 2;

                        var originX = element.x - w;
                        var originY = element.y - h;

                        var x1 = rotate(originX, originY, element.x - w, element.y + h, element.rotate);
                        var x2 = rotate(originX, originY, element.x + w, element.y + h, element.rotate);
                        var x3 = rotate(originX, originY, element.x + w, element.y - h, element.rotate);
                        var x4 = rotate(originX, originY, element.x - w, element.y - h, element.rotate);

                        // objects.push({
                        //     id: objectCounter++,
                        //     type: 'rect',
                        //     x: x1[0],
                        //     y: x1[1],
                        //     width: 4,
                        //     height: 4,
                        //     color: 'red',
                        //     textColor: textColor,
                        //     clicked: false,
                        //     lineSize: lineSize
                        // });
                        // objects.push({
                        //     id: objectCounter++,
                        //     type: 'rect',
                        //     x: x2[0],
                        //     y: x2[1],
                        //     width: 4,
                        //     height: 4,
                        //     color: 'yellow',
                        //     textColor: textColor,
                        //     clicked: false,
                        //     lineSize: lineSize
                        // });
                        // objects.push({
                        //     id: objectCounter++,
                        //     type: 'rect',
                        //     x: x3[0],
                        //     y: x3[1],
                        //     width: 4,
                        //     height: 4,
                        //     color: 'orange',
                        //     textColor: textColor,
                        //     clicked: false,
                        //     lineSize: lineSize
                        // });
                        // objects.push({
                        //     id: objectCounter++,
                        //     type: 'rect',
                        //     x: x4[0],
                        //     y: x4[1],
                        //     width: 4,
                        //     height: 4,
                        //     color: 'brown',
                        //     textColor: textColor,
                        //     clicked: false,
                        //     lineSize: lineSize
                        // });

                        var maxX = Math.max(x1[0], x2[0], x3[0], x4[0]);
                        var maxY = Math.max(x1[1], x2[1], x3[1], x4[1]);
                        var minX = Math.min(x1[0], x2[0], x3[0], x4[0]);
                        var minY = Math.min(x1[1], x2[1], x3[1], x4[1]);

                        if (x > minX && x < maxX && y > minY && y < maxY) {
                            clearClicked();
                            vm.clickedElement = element;
                            clickedElementIndex = index;
                            vm.clickedElement.clicked = true;
                            vm.label = element.label;
                            if (vm.clickedElement.canResizeRotate) {
                                vm.enabledResizeRotate = true;
                            }
                            if (vm.activeMode === 1) {
                                canvas.onmousemove = moveObject;
                                canvas.onmouseup = moveEnd;
                            } else if (vm.activeMode === 2) {
                                oldResizeX = x;
                                canvas.onmousemove = resizeObject;
                                canvas.onmouseup = moveEnd;
                            } else if (vm.activeMode === 3) {
                                oldRotateX = x;
                                canvas.onmousemove = rotateObject;
                                canvas.onmouseup = moveEnd;
                            }
                        } else {
                            element.clicked = false;
                        }
                    }
                });
                // Ha rajz mód aktív
            } else if (vm.activeMode === 0) {
                lines[lineId] = {points: [], lineSize: lineSize, color: color};
                canvas.onmousemove = drawPen;
                canvas.onmouseup = stopDrawPen;
            }
            $scope.$apply();
        }

        function rotate(cx, cy, x, y, angle) {
            var radians = (Math.PI / 180) * angle;
            var cos = Math.cos(radians);
            var sin = Math.sin(radians);
            var nx = (cos * (x - cx)) - (sin * (y - cy)) + cx;
            var ny = (sin * (x - cx)) + (cos * (y - cy)) + cy;
            return [nx, ny];
        }

        function draw() {
            clear();
            if (imageObj) {
                ctx.drawImage(imageObj, 0, 0, imageWidth, imageHeight);
            }
            var oldFont = ctx.font;
            objects.forEach(function (element) {
                ctx.lineWidth = element.lineSize;
                if (element.clicked === false) {
                    ctx.fillStyle = element.color;
                    ctx.strokeStyle = element.color;
                } else {
                    ctx.fillStyle = element.color;
                    ctx.strokeStyle = '#991111';
                }
                if (element.type === 'rect') {
                    rect(element.x - (element.width / 2), element.y - (element.height / 2), element.width, element.height);
                    if (element.label) {
                        ctx.font = font;
                        ctx.fillStyle = element.textColor;
                        ctx.textAlign = 'center';
                        ctx.fillText(element.label, element.x, element.y + (element.height / 2) - fontSize / 2);
                        ctx.font = oldFont;
                    }
                } else if (element.type === 'pentagon') {
                    pentagon(element.x, element.y, element.width, element.height);
                    if (element.label) {
                        ctx.font = font;
                        ctx.fillStyle = element.textColor;
                        ctx.textAlign = 'center';
                        ctx.fillText(element.label, element.x, element.y + (element.height / 2) - fontSize / 2);
                        ctx.font = oldFont;
                    }
                } else if (element.type === 'triangle') {
                    triangle(element.x - (element.width / 2), element.y - (element.height / 2), element.width, element.height);
                    if (element.label) {
                        ctx.font = font;
                        ctx.fillStyle = element.textColor;
                        ctx.textAlign = 'center';
                        ctx.fillText(element.label, element.x, element.y + (element.height / 2) - 3);
                        ctx.font = oldFont;
                    }
                } else if (element.type === 'line') {
                    line(element.x1, element.y1, element.x2, element.y2);
                    if (element.label) {
                        if (element.label) {
                            if (element.y2 < element.y1) {
                                ctx.fillText(element.label, element.x1, element.y1 + 16);
                            } else {
                                ctx.fillText(element.label, element.x1, element.y1 - 5);
                            }
                        }
                    }
                } else if (element.type === 'sine') {
                    sine(element.x1, element.y1, element.x2, element.y2);
                    if (element.label) {
                        if (element.label) {
                            if (element.y2 < element.y1) {
                                ctx.fillText(element.label, element.x1, element.y1 + 16);
                            } else {
                                ctx.fillText(element.label, element.x1, element.y1 - 5);
                            }
                        }
                    }
                } else if (element.type === 'dline') {
                    dashedLine(element.x1, element.y1, element.x2, element.y2);
                    if (element.label) {
                        if (element.y2 < element.y1) {
                            ctx.fillText(element.label, element.x1, element.y1 + 16);
                        } else {
                            ctx.fillText(element.label, element.x1, element.y1 - 5);
                        }
                    }
                } else if (element.type === 'dline2') {
                    dashedLine2(element.x1, element.y1, element.x2, element.y2);
                    if (element.label) {
                        if (element.y2 < element.y1) {
                            ctx.fillText(element.label, element.x1, element.y1 + 16);
                        } else {
                            ctx.fillText(element.label, element.x1, element.y1 - 5);
                        }
                    }
                } else if (element.type === 'arrow') {
                    arrow(element.x1, element.y1, element.x2, element.y2);
                    if (element.label) {
                        if (element.label) {
                            if (element.y2 < element.y1) {
                                ctx.fillText(element.label, element.x1, element.y1 + 16);
                            } else {
                                ctx.fillText(element.label, element.x1, element.y1 - 5);
                            }
                        }
                    }
                } else if (element.type === 'circle') {
                    circle(element.x, element.y, element.r);
                    if (element.label) {
                        ctx.font = font;
                        ctx.fillStyle = element.textColor;
                        ctx.textAlign = 'center';
                        ctx.fillText(element.label, element.x, element.y + 10);
                        ctx.font = oldFont;
                    }
                } else if (element.type === 'ball') {
                    var x = element.x - (element.width / 2);
                    var y = element.y - (element.height / 2);

                    ctx.translate(x, y);
                    ctx.rotate(element.rotate * (Math.PI / 180));
                    ctx.drawImage(element.image, 0, 0, element.width, element.height);

                    if (element.clicked) {
                        ctx.lineWidth = 2;
                        ctx.strokeRect(0, 0, element.width, element.height);
                        ctx.lineWidth = lineSize;
                    }
                    if (element.label) {
                        ctx.fillText(element.label, 0, -5);
                    }
                    ctx.rotate(-element.rotate * (Math.PI / 180));
                    ctx.translate(-x, -y);
                }
            });

            for (var i = 0; i < lines.length; i++) {
                for (var j = 0; j + 1 < lines[i].points.length; j++) {
                    ctx.lineWidth = lines[i].lineSize;
                    ctx.fillStyle = lines[i].color;
                    ctx.strokeStyle = lines[i].color;
                    line(lines[i].points[j].x, lines[i].points[j].y, lines[i].points[j + 1].x, lines[i].points[j + 1].y);
                }
            }
        }

        function drawThis(obs) {
            clear();
            if (imageObj) {
                ctx.drawImage(imageObj, 0, 0, imageWidth, imageHeight);
            }
            obs.objects.forEach(function (element) {
                ctx.lineWidth = element.lineSize;
                if (element.clicked === false) {
                    ctx.fillStyle = element.color;
                    ctx.strokeStyle = element.color;
                } else {
                    ctx.fillStyle = element.color;
                    ctx.strokeStyle = '#991111';
                }
                if (element.type === 'rect') {
                    rect(element.x - (element.width / 2), element.y - (element.height / 2), element.width, element.height);
                    if (element.label) {
                        ctx.font = font;
                        ctx.fillStyle = element.textColor;
                        ctx.textAlign = 'center';
                        ctx.fillText(element.label, element.x - (element.width / 2), element.y - (element.height / 2) - fontSize / 2);
                    }
                    element.x += element.deltaX;
                    element.y += element.deltaY;
                } else if (element.type === 'triangle') {
                    triangle(element.x - (element.width / 2), element.y - (element.height / 2), element.width, element.height);
                    if (element.label) {
                        ctx.font = font;
                        ctx.fillStyle = element.textColor;
                        ctx.textAlign = 'center';
                        ctx.fillText(element.label, element.x, element.y + (element.height / 2) - 3);
                    }
                    element.x += element.deltaX;
                    element.y += element.deltaY;
                } else if (element.type === 'line') {
                    line(element.x1, element.y1, element.x2, element.y2);
                    if (element.label) {
                        if (element.label) {
                            if (element.y2 < element.y1) {
                                ctx.fillText(element.label, element.x1, element.y1 + 16);
                            } else {
                                ctx.fillText(element.label, element.x1, element.y1 - 5);
                            }
                        }
                    }
                    element.x1 += element.deltaX1;
                    element.y1 += element.deltaY1;
                    element.x2 += element.deltaX2;
                    element.y2 += element.deltaY2;
                } else if (element.type === 'dline') {
                    dashedLine(element.x1, element.y1, element.x2, element.y2);
                    if (element.label) {
                        if (element.y2 < element.y1) {
                            ctx.fillText(element.label, element.x1, element.y1 + 16);
                        } else {
                            ctx.fillText(element.label, element.x1, element.y1 - 5);
                        }
                    }
                    element.x1 += element.deltaX1;
                    element.y1 += element.deltaY1;
                    element.x2 += element.deltaX2;
                    element.y2 += element.deltaY2;
                } else if (element.type === 'dline2') {
                    dashedLine2(element.x1, element.y1, element.x2, element.y2);
                    if (element.label) {
                        if (element.y2 < element.y1) {
                            ctx.fillText(element.label, element.x1, element.y1 + 16);
                        } else {
                            ctx.fillText(element.label, element.x1, element.y1 - 5);
                        }
                    }
                    element.x1 += element.deltaX1;
                    element.y1 += element.deltaY1;
                    element.x2 += element.deltaX2;
                    element.y2 += element.deltaY2;
                } else if (element.type === 'arrow') {
                    arrow(element.x1, element.y1, element.x2, element.y2);
                    if (element.label) {
                        if (element.label) {
                            if (element.y2 < element.y1) {
                                ctx.fillText(element.label, element.x1, element.y1 + 16);
                            } else {
                                ctx.fillText(element.label, element.x1, element.y1 - 5);
                            }
                        }
                    }
                    element.x1 += element.deltaX1;
                    element.y1 += element.deltaY1;
                    element.x2 += element.deltaX2;
                    element.y2 += element.deltaY2;
                } else if (element.type === 'sine') {
                    sine(element.x1, element.y1, element.x2, element.y2);
                    if (element.label) {
                        if (element.label) {
                            if (element.y2 < element.y1) {
                                ctx.fillText(element.label, element.x1, element.y1 + 16);
                            } else {
                                ctx.fillText(element.label, element.x1, element.y1 - 5);
                            }
                        }
                    }
                    element.x1 += element.deltaX1;
                    element.y1 += element.deltaY1;
                    element.x2 += element.deltaX2;
                    element.y2 += element.deltaY2;
                } else if (element.type === 'circle') {
                    circle(element.x, element.y, element.r);
                    if (element.label) {
                        ctx.font = font;
                        ctx.fillStyle = element.textColor;
                        ctx.textAlign = 'center';
                        ctx.fillText(element.label, element.x - (element.r / 2), element.y - element.r - 5);
                    }
                    element.x += element.deltaX;
                    element.y += element.deltaY;
                } else if (element.type === 'ball') {
                    var x = element.x - (element.width / 2);
                    var y = element.y - (element.height / 2);

                    ctx.translate(x, y);
                    ctx.rotate(element.rotate * (Math.PI / 180));
                    // ctx.drawImage(element.image, element.x - (element.width / 2), element.y - (element.height / 2), element.width, element.height);
                    ctx.drawImage(element.image, 0, 0, element.width, element.height);

                    if (element.clicked) {
                        ctx.lineWidth = 2;
                        ctx.strokeRect(0, 0, element.width, element.height);
                        ctx.lineWidth = lineSize;
                    }
                    if (element.label) {
                        ctx.fillText(element.label, 0, -5);
                    }
                    ctx.rotate(-element.rotate * (Math.PI / 180));
                    ctx.translate(-x, -y);
                    element.x += element.deltaX;
                    element.y += element.deltaY;
                }
            });

            for (var i = 0; i < obs.lines.length; i++) {
                for (var j = 0; j + 1 < obs.lines[i].points.length; j++) {
                    ctx.lineWidth = obs.lines[i].lineSize;
                    ctx.fillStyle = obs.lines[i].color;
                    ctx.strokeStyle = obs.lines[i].color;
                    line(obs.lines[i].points[j].x, obs.lines[i].points[j].y, obs.lines[i].points[j + 1].x, obs.lines[i].points[j + 1].y);
                }
            }
        }

        // Kijelölés törlése
        function clearClicked() {
            vm.enabledResizeRotate = false;
            vm.label = '';
            vm.clickedElement = null;
            clickedElementIndex = -1;
            objects.forEach(function (element) {
                element.clicked = false;
            });
        }

        var oldResizeX = 0;

        function resizeObject(e) {
            var x = (e.pageX - canvas.offsetLeft) / scaleWidth;

            var resizeScale = vm.clickedElement.height / vm.clickedElement.width;
            vm.clickedElement.width += x - oldResizeX;
            vm.clickedElement.height += (x - oldResizeX) * resizeScale;
            oldResizeX = x;
        }

        var oldRotateX = 0;

        function rotateObject(e) {
            var x = (e.pageX - canvas.offsetLeft) / scaleWidth;
            vm.clickedElement.rotate += (x - oldRotateX) * 2;
            oldRotateX = x;
        }

        // Mozgatások
        function moveObject(e) {
            if (vm.clickedElement.rotate) {
                vm.clickedElement.x = (e.pageX - canvas.offsetLeft) / scaleWidth;
                vm.clickedElement.y = (e.pageY - canvas.offsetTop) / scaleHeight;
            } else {
                vm.clickedElement.x = (e.pageX - canvas.offsetLeft) / scaleWidth;
                vm.clickedElement.y = (e.pageY - canvas.offsetTop) / scaleHeight;
            }
        }

        function moveArrowStart(e) {
            vm.clickedElement.x1 = (e.pageX - canvas.offsetLeft) / scaleWidth;
            vm.clickedElement.y1 = (e.pageY - canvas.offsetTop) / scaleWidth;
        }

        function moveArrorEnd(e) {
            vm.clickedElement.x2 = (e.pageX - canvas.offsetLeft) / scaleWidth;
            vm.clickedElement.y2 = (e.pageY - canvas.offsetTop) / scaleWidth;
        }

        var old = {x: 0, y: 0};

        function moveArrow(e) {
            var x = (e.pageX - canvas.offsetLeft) / scaleWidth;
            var y = (e.pageY - canvas.offsetTop) / scaleWidth;
            vm.clickedElement.x1 += x - old.x;
            vm.clickedElement.y1 += y - old.y;
            vm.clickedElement.x2 += x - old.x;
            vm.clickedElement.y2 += y - old.y;
            old.x = x;
            old.y = y;
        }

        // Vonal új pontjának mentése
        function drawPen(e) {
            var x = e.pageX - canvas.offsetLeft;
            var y = e.pageY - canvas.offsetTop;
            lines[lineId].points.push({x: x, y: y});
        }

        // Aktuális vonal vége
        function stopDrawPen() {
            lineId++;
            canvas.onmousemove = null;
            canvas.onmouseup = null;
            saveState();
        }

        // Mozgatás vége
        function moveEnd() {
            canvas.onmousemove = null;
            canvas.onmouseup = null;
            saveState();
        }

        // Rajzoló mód aktiválása
        vm.pen = function () {
            vm.activeMode = 0;
            clearClicked();
        };

        // Kiválasztó mód aktiválása
        vm.select = function () {
            vm.activeMode = 1;
            clearClicked();
        };

        // Kijelölt elem törlése
        vm.deleteObject = function () {
            if (clickedElementIndex !== -1) {
                clearClicked();
                objects.splice(clickedElementIndex, 1);
                saveState();
            }
        };

        // Hozzáadások
        vm.addRect = function () {
            objects.push({
                id: objectCounter++,
                type: 'rect',
                x: 500,
                y: 100,
                width: 40,
                height: 40,
                color: color,
                textColor: textColor,
                clicked: false,
                lineSize: lineSize
            });
            saveState();
        };

        vm.addTriangle = function () {
            objects.push({
                id: objectCounter++,
                type: 'triangle',
                x: 500,
                y: 100,
                width: 40,
                height: 40,
                color: color,
                textColor: textColor,
                clicked: false,
                lineSize: lineSize
            });
            saveState();
        };

        vm.addPentagon = function () {
            objects.push({
                id: objectCounter++,
                type: 'pentagon',
                x: 500,
                y: 100,
                width: 40,
                height: 40,
                color: color,
                textColor: textColor,
                clicked: false,
                lineSize: lineSize
            });
            saveState();
        };

        vm.addCircle = function () {
            objects.push({
                id: objectCounter++,
                type: 'circle',
                x: 500,
                y: 125,
                r: 20,
                color: color,
                textColor: textColor,
                clicked: false,
                lineSize: lineSize
            });
            saveState();
        };

        vm.addLine = function () {
            objects.push({
                id: objectCounter++,
                type: 'line',
                x1: 500,
                y1: 100,
                x2: 600,
                y2: 100,
                color: color,
                textColor: textColor,
                clicked: false,
                lineSize: lineSize
            });
            saveState();
        };

        vm.addDashedLine = function () {
            objects.push({
                id: objectCounter++,
                type: 'dline',
                x1: 500,
                y1: 100,
                x2: 600,
                y2: 100,
                color: color,
                textColor: textColor,
                clicked: false,
                lineSize: lineSize
            });
            saveState();
        };

        vm.addDashedLine2 = function () {
            objects.push({
                id: objectCounter++,
                type: 'dline2',
                x1: 500,
                y1: 100,
                x2: 600,
                y2: 100,
                color: color,
                textColor: textColor,
                clicked: false,
                lineSize: lineSize
            });
            saveState();
        };

        vm.addArrow = function () {
            objects.push({
                id: objectCounter++,
                type: 'arrow',
                x1: 500,
                y1: 100,
                x2: 600,
                y2: 100,
                color: color,
                textColor: textColor,
                clicked: false,
                lineSize: lineSize
            });
            saveState();
        };

        vm.addSine = function () {
            objects.push({
                id: objectCounter++,
                type: 'sine',
                x1: 500,
                y1: 100,
                x2: 600,
                y2: 100,
                color: color,
                textColor: textColor,
                clicked: false,
                lineSize: lineSize
            });
            saveState();
        };

        vm.addFootball = function () {
            var ball = {
                id: objectCounter++,
                type: 'ball',
                image: new Image(),
                x: 500,
                y: 100,
                width: 30,
                height: 30,
                rotate: 0,
                canResizeRotate: true
            };
            ball.image.src = '/images/football_ball.png';
            objects.push(ball);
            saveState();
        };

        vm.addBasketball = function () {
            var ball = {
                id: objectCounter++,
                type: 'ball',
                image: new Image(),
                x: 500,
                y: 100,
                width: 30,
                height: 30,
                rotate: 0,
                canResizeRotate: true
            };
            ball.image.src = '/images/basketball_ball.png';
            objects.push(ball);
            saveState();
        };

        vm.addHandball = function () {
            var ball = {
                id: objectCounter++,
                type: 'ball',
                image: new Image(),
                x: 500,
                y: 100,
                width: 30,
                height: 30,
                rotate: 0,
                canResizeRotate: true
            };
            ball.image.src = '/images/handball_ball.png';
            objects.push(ball);
            saveState();
        };

        vm.addCone = function () {
            var ball = {
                id: objectCounter++,
                type: 'ball',
                image: new Image(),
                x: 500,
                y: 100,
                width: 30,
                height: 30,
                rotate: 0,
                canResizeRotate: true
            };
            ball.image.src = '/images/cone.png';
            objects.push(ball);
            saveState();
        };

        vm.addHockeyPuck = function () {
            var ball = {
                id: objectCounter++,
                type: 'ball',
                image: new Image(),
                x: 500,
                y: 100,
                width: 20,
                height: 20,
                rotate: 0,
                canResizeRotate: true
            };
            ball.image.src = '/images/hockey_puck.png';
            objects.push(ball);
            saveState();
        };

        vm.addGoal1 = function () {
            var ball = {
                id: objectCounter++,
                type: 'ball',
                image: new Image(),
                x: 500,
                y: 100,
                width: 50,
                height: 100,
                rotate: 0,
                canResizeRotate: true
            };
            ball.image.src = '/images/goal1.png';
            objects.push(ball);
            saveState();
        };

        // Pont és pont távolsága
        function pointPointDistance(p1, p2) {
            return Math.sqrt(Math.pow(p1.x - p2.x, 2) + Math.pow(p1.y - p2.y, 2));
        }

        // Pitagorasz (hiányzó befogó hossza)
        function pitagorasz(atfogo, befogo) {
            return Math.sqrt(Math.pow(atfogo, 2) - Math.pow(befogo, 2));
        }

        // Pont a vonalon van?
        function isPointOnSection(p1, p2, p0) {
            // Vonaltól való távolság, amire még megfogható
            var diff = 10;
            // Számításból eredő hiba tűrés
            var errorDiff = 3;
            var sectionDistance = pointPointDistance(p1, p2);
            var d = Math.abs((p2.x - p1.x) * (p1.y - p0.y) - (p1.x - p0.x) * (p2.y - p1.y)) / Math.sqrt(Math.pow(p2.x - p1.x, 2) + Math.pow(p1.y - p2.y, 2));
            var sectionP1 = pitagorasz(pointPointDistance(p1, p0), d);
            var sectionP2 = pitagorasz(pointPointDistance(p2, p0), d);

            if ((sectionP1 + sectionP2 < (sectionDistance + errorDiff)) && (sectionP1 + sectionP2 > (sectionDistance - errorDiff))) {
                return d < diff;
            }
            return false;
        }

        //
        function backgroundChanged(args) {
            vm.background = args.value;
            if (args.value === 6) {
                imageObj = null;
            } else {
                imageObj = new Image();
                imageObj.src = backgrounds[args.value - 1].src;
            }
        }

        // Minden objektum törlése
        vm.deleteAll = function () {
            imageWidth = WIDTH;
            imageHeight = HEIGHT;
            scaleHeight = 1;
            scaleWidth = 1;
            objects = [];
            lines = [];
            vm.animationStates = [];
            states = [];
            paintId = null;
            vm.sectionDropDownEnabled = true;
            clearClicked();
            stateLast = true;
            vm.stateId = -1;
            selectedAnimationId = -1;
            lineId = 0;
            vm.label = '';
            color = '#000000';
            vm.checkBoxEnabled = true;
            $('#Background').ejDropDownList('enable');
            $('#LineSize').ejDropDownList('enable');
            $('#Color').ejColorPicker('enable');
            $('#TextColor').ejColorPicker('enable');
            vm.deleteEnabled = false;
            scopeApply();
            saveState();
        };

        // Szín beállítása
        vm.getColor = function () {
            if (vm.clickedElement) {
                color = vm.clickedElement.color;
                $('#Color').ejColorPicker({
                    value: vm.clickedElement.color,
                    enableOpacity: false,
                    change: colorChanged,
                    modelType: 'Palette'
                });
            }
        };

        vm.changedLabel = function () {
            vm.clickedElement.label = vm.label;
            saveState();
        };

        vm.addAnimation = function () {
            clearClicked();
            selectedAnimationId++;
            var stateTemp = {lines: $.extend(true, [], lines), objects: $.extend(true, [], objects), lineId: lineId};
            stateTemp.objects.forEach(function (element) {
                element.clicked = false;
            });
            vm.animationStates.push(stateTemp);
        };

        vm.saveAnimation = function () {
            if (selectedAnimationId >= 0) {
                vm.animationStates[selectedAnimationId].lines = $.extend(true, [], lines);
                vm.animationStates[selectedAnimationId].objects = $.extend(true, [], objects);
                vm.animationStates[selectedAnimationId].lineId = lineId;
            }
        };

        function scopeApply() {
            $timeout(function () {
                $scope.$apply();
            }, 0);
        }

        vm.deleteAnimation = function () {
            clearClicked();
            if (selectedAnimationId > -1) {
                vm.animationStates.splice(selectedAnimationId, 1);
                vm.selectAnimation(vm.animationStates.length - 1);
                scopeApply();
            }
        };

        vm.selectAnimation = function (index) {
            clearClicked();
            if (index > -1) {
                selectedAnimationId = index;
                lines = $.extend(true, [], vm.animationStates[index].lines);
                objects = $.extend(true, [], vm.animationStates[index].objects);
                lineId = vm.animationStates[index].lineId;
            }
        };

        var fps = 60;
        var drawTime = 1000 / fps;
        var intervalTimes = 0;
        var timePerState = 2;
        var animationList = [];
        var stateId = 0;
        vm.play = function (speed) {
            clearClicked();
            timePerState = speed;
            intervalTimes = 0;
            animationList = [];
            stateId = 0;
            // Csak akkor van animáció, amikor legalább két állapot van
            var statesLength = vm.animationStates.length;
            if (statesLength > 1) {
                for (var i = 0; i < (statesLength - 1); i++) {
                    animationList.push({objects: [], lines: []});
                    vm.animationStates[i].objects.forEach(function (element) {
                        // Ha kell animálni
                        var nextElement = vm.animationStates[i + 1].objects.find(function (nextElement) {
                            return element.id === nextElement.id;
                        });
                        if (nextElement !== undefined) {
                            // deltaX és deltaY kiszámolása
                            if (element.type === 'rect' || element.type === 'circle' || element.type === 'ball') {
                                var tmp = $.extend(true, [], element);
                                tmp.deltaX = (nextElement.x - element.x) / (timePerState * fps);
                                tmp.deltaY = (nextElement.y - element.y) / (timePerState * fps);
                                animationList[i].objects.push(tmp);
                            } else if (element.type === 'line' || element.type === 'dline' || element.type === 'dline2' || element.type === 'arrow' || element.type === 'sine') {
                                var tmp = $.extend(true, [], element);
                                tmp.deltaX1 = (nextElement.x1 - element.x1) / (timePerState * fps);
                                tmp.deltaY1 = (nextElement.y1 - element.y1) / (timePerState * fps);
                                tmp.deltaX2 = (nextElement.x2 - element.x2) / (timePerState * fps);
                                tmp.deltaY2 = (nextElement.y2 - element.y2) / (timePerState * fps);
                                animationList[i].objects.push(tmp);
                            }
                            animationList[i].lines = $.extend(true, [], vm.animationStates[i].lines);
                        }
                    });
                }
                clearInterval(interval);
                interval = setInterval(drawAnimation, drawTime);
                stateId = 0;
                intervalTimes = 0;
            }
        };

        function drawAnimation() {
            if (intervalTimes >= (vm.animationStates.length - 1) * timePerState * fps) {
                clearInterval(interval);
                interval = setInterval(draw, 10);
                vm.selectAnimation(vm.animationStates.length - 1);
            } else {
                if (intervalTimes % (timePerState * fps) === 0) {
                    stateId++;
                }
                intervalTimes++;
                drawThis(animationList[stateId - 1]);
            }
        }

        vm.save = function () {
            $timeout(function () {
                // a syncfusion direktívák miatt
                $scope.$broadcast('submitted');
                if ($scope.form.$valid === false) {
                    log.errorMsg('RequiredFieldsError');
                } else {
                    var data = {
                        lineId: lineId,
                        objectCounter: objectCounter,
                        background: vm.background,
                        imageWidth: imageWidth,
                        imageHeight: imageHeight,
                        animationStates: $.extend(true, [], vm.animationStates),
                        lines: lines,
                        objects: $.extend(true, [], objects)
                    };
                    data.objects.forEach(function (el) {
                        if (el.type === 'ball') {
                            el.image = el.image.src;
                        }
                    });
                    data.animationStates.forEach(function (el) {
                        el.objects.forEach(function (el2) {
                            if (el2.type === 'ball') {
                                el2.image = el2.image.src;
                            }
                        });
                    });
                    if (paintId) {
                        dataservice.modifyPaint({
                            paintId: paintId,
                            publikus: vm.public,
                            data: JSON.stringify(data)
                        }).then(function () {
                            vm.sectionDropDownEnabled = false;
                            log.successMsg('PaintModified');
                        });
                    } else {
                        dataservice.savePaint({
                            paintName: vm.paintName,
                            sectionId: vm.sectionId,
                            agegroupId: vm.agegroupId,
                            data: JSON.stringify(data)
                        }).then(function (data) {
                            paintId = data.res;
                            vm.deleteEnabled = true;
                            vm.sectionDropDownEnabled = false;
                            log.successMsg('PaintSaved');
                        });
                    }
                }
            }, 0);
        };

        vm.publicCheckboxChanged = function (args) {
            vm.public = args.value;
        };

        vm.deletePaint = function () {
            swal({
                title: gettextCatalog.getString('DoYouWantDelete'),
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: gettextCatalog.getString('YesIWantDelete'),
                cancelButtonText: gettextCatalog.getString('Cancel'),
            }).then(function (isConfirm) {
                if (isConfirm.value) {
                    dataservice.deletePaint({
                        id: paintId
                    }).then(function () {
                        vm.deleteAll();
                        log.successMsg('PaintDeleted');
                    });
                }
            });
        };

        vm.resizeObject = function () {
            vm.activeMode = 2;
        };

        vm.rotateObject = function () {
            vm.activeMode = 3;
        };

        interval = init();
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.paint')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'paint',
                config: {
                    url: '/paint/',
                    templateUrl: 'app/paint/paint.html',
                    controller: 'PaintController',
                    controllerAs: 'vm',
                    title: 'Paint',
                    /*
                    settings: {
                        navId: 2162,
                        level: 2,
                        order: 16,
                        parentId: 2,
                        orderTitle_hu: 'Gyakorlat ábra tervező',
                        orderTitle_en: 'Exercise Figure Creator',
                        content: 'Paint'
                    }
                    */
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    ParentDashboardController.$inject = ["log", "dataservice", "$q", "$rootScope", "gettextCatalog", "paramHelper", "authenticationService", "$state"];
    angular
        .module('app.parentDashboard')
        .controller('ParentDashboardController', ParentDashboardController);

    function ParentDashboardController(log, dataservice, $q, $rootScope, gettextCatalog, paramHelper, authenticationService, $state) {
        var vm = this; $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('ParentDashboard');

        vm.athletesofuser = [];
        vm.selectedAthlete = undefined;
        vm.modifyAthleteData = modifyAthleteData;
        vm.athleteidOfAthleteUser = -1;
        vm.SPORTOLO = false;
        vm.SZULO = false;

        activate();

        function activate() {
            $q.all([
                authenticationService.getRight('SPORTOLO'),
                authenticationService.getRight('SZULO')])
                .then(function (results) {
                    if (results[0] || results[1]) {
                        vm.SPORTOLO = results[0];
                        vm.SZULO = results[1];
                        getAthletesOfUser();
                        getAthleteIDofUser();
                        // getParentNotifications(new Date(), new Date(), 0, true, true, 'all', 9999);
                    } else {
                        log.permissionError(true);
                    }
                });
        }

        function modifyAthleteData() {
            if (vm.SZULO) {
                paramHelper.setParams([{'athleteModify.sportoloId': vm.selectedAthlete}]);
                $state.go('athletes.athletesManagement.athleteModify.dataSheet');
            } else {
                paramHelper.setParams([{'athleteModify.sportoloId': vm.athleteidOfAthleteUser}]);
                $state.go('athletes.athletesManagement.athleteModify.dataSheet');
            }
        }

        function getAthletesOfUser() {
            dataservice.getAthletesOfUser()
                .then(function (data) {
                    vm.athletesofuser = data.itemsList;
                });
        }

        function getAthleteIDofUser() {
            dataservice.getAthleteidBelongsToAthleteUser()
                .then(function (data) {
                    vm.athleteidOfAthleteUser = data.data;
                });
        }

        function getParentNotifications(fromDate, toDate, currentListSize, moreNewer, moreOlder, load, size) {
            dataservice.getParentNotifications2(fromDate, toDate, currentListSize, moreNewer, moreOlder, load, size).then(function (data) {
                console.log('getParentNotifications', data);
            });
            dataservice.ErtesitestLatta(-1).then(function (data) {
                console.log('ErtesitestLatta', data);
            });
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.parentDashboard')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'parentDashboard',
                config: {
                    url: '/parentDashboard',
                    templateUrl: 'app/parentDashboard/parentDashboard.html',
                    controller: 'ParentDashboardController',
                    controllerAs: 'vm',
                    title: 'ParentDashboard',
                    settings: {
                        navId: 12,
                        level: 1,
                        order: 11,
                        parentId: 0,
                        content: 'ParentDashboard',
                        permission: ['5']
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    ParentMonthlyAttendanceController.$inject = ["log", "dataservice", "$q", "$rootScope", "gettextCatalog", "$scope", "$filter"];
    angular
        .module('app.parentMonthlyAttendance')
        .controller('ParentMonthlyAttendanceController', ParentMonthlyAttendanceController);

    function ParentMonthlyAttendanceController(log, dataservice, $q, $rootScope, gettextCatalog, $scope, $filter) {
        var vm = this; $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('parentMonthlyAttendance');

        // Create variables
        vm.dateValue = new Date();
        vm.athleteList = [];
        vm.athleteId = '';
        vm.columns = [
            {
                field: 'SportoloNeve',
                headerText: gettextCatalog.getString('Athlete'),
                textAlign: 'left'
            },
            {
                field: 'Nap',
                headerText: gettextCatalog.getString('Day'),
                textAlign: 'left'
            },
            {
                field: 'Igazolt',
                headerText: gettextCatalog.getString('Igazolt'),
                textAlign: 'center',
                type: 'boolean',
                displayAsCheckBox: true
            }
        ];

        // Public functions
        vm.saveDate = saveDate;
        vm.athleteDataBound = athleteDataBound;

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItemsWithSearch,
            allowPaging: true,
            allowTextWrap: true,
            allowSorting: true,
            allowExcelExport: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            rowSelected: vm.gridRowSelected,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile(angular.element('#Grid'), $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        // Activate page
        activate();

        function activate() {
            var promises = [];
            $q.all(promises)
                .then(function () {
                    getAthletes();
                    parentsAthleteAttendanceList();
                })
                .catch(function () {
                    log.permissionError();
                });
        }

        // Get sections' list
        function getAthletes() {
            return dataservice.parentsAthletes().then(function (data) {
                vm.athleteList = data.itemsList;
            });
        }

        function athleteDataBound() {
            if (vm.athleteList.length === 1) {
                angular.element('#sectionId').ejDropDownList('selectItemByValue', vm.athleteList[0].value);
                vm.athleteId = vm.athleteList[0].value;
            }
        }

        function parentsAthleteAttendanceList() {
            return dataservice.parentsAthleteAttendanceList().then(function (data) {
                grid.dataSource = $filter('dateStringFilter')(data.itemsList, 'Nap');
            });
        }

        function saveDate() {
            // a syncfusion direktívák miatt
            $scope.$broadcast('submitted');
            if ($scope.form.$valid === false) {
                log.errorMsg(gettextCatalog.getString('RequiredFieldsError'));
                return;
            }
            return dataservice.parentsAthleteAttendance(vm.athleteId, vm.dateValue).then(function () {
                log.successMsg('HianyzasBejelentve');
                parentsAthleteAttendanceList();
            });
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.parentMonthlyAttendance')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'parentMonthlyAttendance',
                config: {
                    url: '/parentMonthlyAttendance',
                    templateUrl: 'app/parentMonthlyAttendance/parentMonthlyAttendance.html',
                    controller: 'ParentMonthlyAttendanceController',
                    controllerAs: 'vm',
                    title: 'parentMonthlyAttendance',
                    settings: {
                        navId: 1200,
                        level: 1,
                        order: 20,
                        parentId: 0,
                        content: 'parentMonthlyAttendance',
                        permission: ['5']
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    AbsenceReportController.$inject = ["log", "dataservice", "$q", "$rootScope", "gettextCatalog", "paramHelper", "authenticationService", "$scope", "$state", "$timeout"];
    angular
        .module('app.reports.absenceReport')
        .controller('AbsenceReportController', AbsenceReportController);

    function AbsenceReportController(log, dataservice, $q, $rootScope, gettextCatalog, paramHelper, authenticationService, $scope, $state, $timeout) {
        var vm = this;
        $rootScope.vm = vm;
        vm.params = [];
        $rootScope.title = gettextCatalog.getString('AbsenceReport');
        vm.searchSPC = true;
        vm.searchPP = true;
        vm.sectionList = [];
        vm.coachList = [];
        vm.search = search;
        vm.openCoach = openCoach;
        vm.openAthlete = openAthlete;
        vm.sectionDataBound = sectionDataBound;
        vm.sectionSelect = sectionSelect;
        vm.coachDropDownListDataBound = coachDropDownListDataBound;
        vm.coachSelect = coachSelect;
        vm.selectdateFrom = new Date(new Date().getFullYear(), new Date().getMonth() - 1, new Date().getDate());
        vm.selectdateTo = new Date();
        vm.fromDateSelect = fromDateSelect;
        vm.toDateSelect = toDateSelect;
        vm.SelectedSectionID = -1;
        vm.SelectedCoachID = -1;

        vm.columns = [
            {
                field: 'SportoloNeve',
                headerText: gettextCatalog.getString('Athlete'),
                headerTextAlign: 'center',
                textAlign: 'left',
                width: '120',
                template: '#abretemplateDataColumn1'
            },
            {
                field: 'EdzoNeve',
                headerText: gettextCatalog.getString('Coach'),
                headerTextAlign: 'center',
                textAlign: 'left',
                width: '120',
                template: '#abretemplateDataColumn2'
            },
            {
                field: 'OsszEdzesekSzama',
                headerText: '*' + gettextCatalog.getString('SumNumberOfTrainings'),
                headerTextAlign: 'center',
                textAlign: 'center',
                width: '150'
            },
            {
                field: 'JelenletSzazalek',
                headerText: '*' + gettextCatalog.getString('AttendancePercent'),
                headerTextAlign: 'center',
                textAlign: 'center',
                width: '130'
            },
            {
                field: 'EdzesekSzama',
                headerText: gettextCatalog.getString('NumberOfTrainings'),
                headerTextAlign: 'center',
                textAlign: 'center',
                width: '105'
            },
            {
                field: 'HianyzasokSzama',
                headerText: gettextCatalog.getString('NumberOfAbsence'),
                headerTextAlign: 'center',
                textAlign: 'center',
                width: '130'
            },
            {
                field: 'IgazoltHianyzasokSzama',
                headerText: gettextCatalog.getString('ProvenNumberOfAbsence'),
                headerTextAlign: 'center',
                textAlign: 'center',
                width: '150'
            },
            {
                field: 'BetegsegekSzama',
                headerText: gettextCatalog.getString('NumberOfSickness'),
                headerTextAlign: 'center',
                textAlign: 'center',
                width: '140'
            },
            {
                field: 'SerulesekSzama',
                headerText: gettextCatalog.getString('NumberOfInjuries'),
                headerTextAlign: 'center',
                textAlign: 'center',
                width: '120'
            },
            {
                field: 'VersenyekSzama',
                headerText: gettextCatalog.getString('NumberOfCompetition'),
                headerTextAlign: 'center',
                textAlign: 'center',
                width: '125'
            }
        ];
        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItems,
            allowPaging: true,
            allowTextWrap: true,
            allowSorting: true,
            allowExcelExport: true,
            locale: 'hu-HU',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile(grid, $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        activate();

        function activate() {
            $timeout(function () {
                vm.selectdateFrom = new Date(new Date().getFullYear(), new Date().getMonth() - 1, new Date().getDate());
                vm.selectdateTo = new Date();
                $scope.$apply();
            });
            var promises = [authenticationService.getRight('HIANYZASMEGT')];
            $q.all(promises).then(function (res) {
                if (!res[0]) {
                    log.permissionError(true);
                } else {
                    getSections();
                    setDropDowns();
                }
            })
                .catch(function () {
                    log.permissionError(true);
                });
        }

        function setDropDowns() {
            var promises = [paramHelper.getParams([], [
                'absenceReport.sectionId',
                'absenceReport.coachId',
                'absenceReport.selectdateFrom',
                'absenceReport.selectdateTo',
            ])
            ];
            $q.all(promises).then(function (results) {
                vm.SelectedSectionID = results[0]['absenceReport.sectionId'] ? results[0]['absenceReport.sectionId'] : vm.SelectedSectionID;
                vm.SelectedCoachID = results[0]['absenceReport.coachId'] ? results[0]['absenceReport.coachId'] : vm.SelectedCoachID;
                vm.selectdateFrom = results[0]['absenceReport.selectdateFrom'] ? results[0]['absenceReport.selectdateFrom'] : vm.selectdateFrom;
                vm.selectdateTo = results[0]['absenceReport.selectdateTo'] ? results[0]['absenceReport.selectdateTo'] : vm.selectdateTo;
            });
        }

        function search() {
            $scope.$broadcast('submitted');
            if ($scope.form.$valid === false) {
                log.errorMsg('FillTheRequiredFields');
                return;
            }
            paramHelper.setParams([
                {'absenceReport.sectionId': vm.SelectedSectionID},
                {'absenceReport.coachId': vm.SelectedCoachID},
                {'absenceReport.selectdateFrom': vm.selectdateFrom},
                {'absenceReport.selectdateTo': vm.selectdateTo},
            ]);
            dataservice.getAbsenceReport(vm.SelectedSectionID, 0, vm.SelectedCoachID, vm.selectdateFrom, vm.selectdateTo)
                .then(function (data) {
                    grid.dataSource = data.itemsList;
                });
        }

        function sectionSelect(args) {
            getActualCoachesList(args.value);
            vm.showDelButton = false;
        }

        function coachSelect(args) {
            vm.SelectedCoachID = args.value;
            if (args.value == -1) {
                vm.SelectedCoachID = 0;
            }
            vm.showDelButton = false;
        }

        function getSections() {
            dataservice.sectionDropDownList(0)
                .then(function (data) {
                    vm.sectionList = data.itemsList;
                    if (data.itemsList.length > 1) {
                        var all = {value: -1, text: gettextCatalog.getString('All')};
                        vm.sectionList.splice(0, 0, all);
                    }
                });
        }

        function getActualCoachesList(SelectedSectionID) {
            return dataservice.coachDropDownList(SelectedSectionID, 0, vm.selectdateFrom, vm.selectdateTo)
                .then(function (data) {
                    vm.coachList = data.itemsList;
                    if (data.itemsList.length > 1) {
                        var all = {value: -1, text: gettextCatalog.getString('All')};
                        vm.coachList.splice(0, 0, all);
                    }
                });
        }

        function openAthlete(id) {
            $q.all([authenticationService.getRight('MEGTSPORTLIST'), authenticationService.getRight('MEGTSPORTLIST')]).then(function (results) {
                if (results[0] || results[1]) {
                    paramHelper.setParams([{'athleteModify.sportoloId': id}]);
                    $state.go('athletes.athletesManagement.athleteModify.dataSheet');
                } else {
                    log.permissionError();
                }
            });
        }

        function openCoach(edzoId) {
            $q.all([authenticationService.getRight('MODFELH'), authenticationService.getRight('MEGTFELH')]).then(function (results) {
                if (results[0] || results[1]) {
                    paramHelper.setParams([{'newUser.userId': edzoId}]);
                    $state.go('settings.userManagement.modifyUser');
                } else {
                    log.permissionError();
                }
            });
        }

        function coachDropDownListDataBound() {
            if (vm.coachList.length === 1) {
                angular.element('#coach').ejDropDownList('selectItemByValue', vm.coachList[0].value);
            } else {
                angular.element('#coach').ejDropDownList('selectItemByValue', vm.SelectedCoachID);
            }
        }

        function sectionDataBound() {
            if (vm.sectionList.length === 1) {
                angular.element('#section').ejDropDownList('selectItemByValue', vm.sectionList[0].value);
            } else {
                angular.element('#section').ejDropDownList('selectItemByValue', vm.SelectedSectionID);
            }
        }

        function fromDateSelect() {
            getActualCoachesList(vm.SelectedSectionID);
        }

        function toDateSelect() {
            getActualCoachesList(vm.SelectedSectionID);
        }
    }
})();


(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.reports.absenceReport')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'reports.absenceReport',
                config: {
                    url: '/absenceReport',
                    templateUrl: 'app/reports/absenceReport/absenceReport.html',
                    controller: 'AbsenceReportController',
                    controllerAs: 'vm',
                    title: 'AbsenceReport',
                    settings: {
                        navId: 2154,
                        level: 2,
                        order: 15,
                        orderTitle_hu: 'Hiányzások',
                        orderTitle_en: 'Absence',
                        parentId: 4,
                        content: 'AbsenceReport',
                        activatorPermission: '"HIANYZASMEGT"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.reports.annualPresenceReports')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'reports.annualPresenceReports',
                config: {
                    url: '/annualPresenceReports',
                    templateUrl: 'app/reports/annualPresenceReports/annualPresenceReports.html',
                    title: 'AnnualPresenceReports',
                    settings: {
                        navId: 224,
                        level: 2,
                        order: 2,
                        orderTitle_hu: 'Éves jelenléti kimutatások',
                        orderTitle_en: 'Annual Attendance Reports',
                        parentId: 4,
                        content: 'AnnualPresenceReports',
                        activatorPermission: ['"KMEVESJELEDZO"', '"KMEVESJELSZO"', '"KMEVESJELSP"']
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    AnnualPresenceReportsBySectionsController.$inject = ["log", "dataservice", "$q", "$rootScope", "gettextCatalog", "$scope", "authenticationService", "paramHelper", "$state", "$timeout"];
    angular
        .module('app.reports.annualPresenceReports.annualPresenceReportsBySections')
        .controller('AnnualPresenceReportsBySectionsController', AnnualPresenceReportsBySectionsController);

    function AnnualPresenceReportsBySectionsController(log, dataservice, $q, $rootScope, gettextCatalog, $scope, authenticationService, paramHelper, $state, $timeout) {
        var vm = this;
        $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('AnnualPresenceReportsBySections');

        //Évek (2010-től az aktuális évig)
        vm.years = [];
        for (var ev = 2010; ev <= new Date().getFullYear(); ev++) {
            vm.years.push(ev);
        }
        //Kiválasztott év (alapból az aktuális)
        vm.selectedYear = new Date().getFullYear();
        vm.selectedMonth = 0;

        //Hónapok
        vm.months = [
            {text: gettextCatalog.getString('January'), value: 0},
            {text: gettextCatalog.getString('February'), value: 1},
            {text: gettextCatalog.getString('March'), value: 2},
            {text: gettextCatalog.getString('April'), value: 3},
            {text: gettextCatalog.getString('May'), value: 4},
            {text: gettextCatalog.getString('June'), value: 5},
            {text: gettextCatalog.getString('July'), value: 6},
            {text: gettextCatalog.getString('August'), value: 7},
            {text: gettextCatalog.getString('September'), value: 8},
            {text: gettextCatalog.getString('October'), value: 9},
            {text: gettextCatalog.getString('November'), value: 10},
            {text: gettextCatalog.getString('December'), value: 11}
        ];

        vm.selectedSection = {};
        vm.sectionDataBound = [];
        vm.stackedHeaderRows = [];
        vm.summaryRows = [];
        vm.columns = [
            {field: 'Id', visible: false, isPrimaryKey: true, isIdentity: true},
            {field: 'Sorszam', headerText: gettextCatalog.getString('RowNumber'), textAlign: 'center', width: 120},
            {
                field: 'VersenyzoNeve',
                headerText: gettextCatalog.getString('Name'),
                textAlign: 'center',
                width: 250,
                template: '#columnTemplate'
            },
            {
                headerText: gettextCatalog.getString('January'), textAlign: 'center', columns: [
                    // column: 'JanEdzes, JanJelen, JanHianyzik,JanSzazalek',
                    {
                        field: 'JanEdzes',
                        headerText: gettextCatalog.getString('Sum'),
                        textAlign: 'center',
                        width: 120
                    },
                    {
                        field: 'JanJelen',
                        headerText: gettextCatalog.getString('Present'),
                        textAlign: 'center',
                        width: 100
                    },
                    {
                        field: 'JanHianyzik',
                        headerText: gettextCatalog.getString('NonPresent'),
                        textAlign: 'center',
                        width: 100
                    },
                    {
                        field: 'JanSzazalek',
                        headerText: gettextCatalog.getString('JelenSzazalek'),
                        textAlign: 'center',
                        width: 120
                    }
                ]
            },
            {
                headerText: gettextCatalog.getString('February'), textAlign: 'center', columns: [
                    // column: 'FebEdzes, FebJelen, FebHianyzik,FebSzazalek',
                    {
                        field: 'FebEdzes',
                        headerText: gettextCatalog.getString('Sum'),
                        textAlign: 'center',
                        width: 120
                    },
                    {
                        field: 'FebJelen',
                        headerText: gettextCatalog.getString('Present'),
                        textAlign: 'center',
                        width: 100
                    },
                    {
                        field: 'FebHianyzik',
                        headerText: gettextCatalog.getString('NonPresent'),
                        textAlign: 'center',
                        width: 100
                    },
                    {
                        field: 'FebSzazalek',
                        headerText: gettextCatalog.getString('JelenSzazalek'),
                        textAlign: 'center',
                        width: 120
                    }
                ]
            },
            {
                headerText: gettextCatalog.getString('March'), textAlign: 'center', columns: [
                    // column: 'MarcEdzes, MarcJelen, MarcHianyzik,MarcSzazalek',
                    {
                        field: 'MarcEdzes',
                        headerText: gettextCatalog.getString('Sum'),
                        textAlign: 'center',
                        width: 120
                    },
                    {
                        field: 'MarcJelen',
                        headerText: gettextCatalog.getString('Present'),
                        textAlign: 'center',
                        width: 100
                    },
                    {
                        field: 'MarcHianyzik',
                        headerText: gettextCatalog.getString('NonPresent'),
                        textAlign: 'center',
                        width: 100
                    },
                    {
                        field: 'MarcSzazalek',
                        headerText: gettextCatalog.getString('JelenSzazalek'),
                        textAlign: 'center',
                        width: 120
                    }
                ]
            },
            {
                headerText: gettextCatalog.getString('April'), textAlign: 'center', columns: [
                    // column: 'AprEdzes, AprJelen, AprHianyzik,AprSzazalek',
                    {
                        field: 'AprEdzes',
                        headerText: gettextCatalog.getString('Sum'),
                        textAlign: 'center',
                        width: 120
                    },
                    {
                        field: 'AprJelen',
                        headerText: gettextCatalog.getString('Present'),
                        textAlign: 'center',
                        width: 100
                    },
                    {
                        field: 'AprHianyzik',
                        headerText: gettextCatalog.getString('NonPresent'),
                        textAlign: 'center',
                        width: 100
                    },
                    {
                        field: 'AprSzazalek',
                        headerText: gettextCatalog.getString('JelenSzazalek'),
                        textAlign: 'center',
                        width: 120
                    }
                ]
            },
            {
                headerText: gettextCatalog.getString('May'), textAlign: 'center', columns: [
                    // column: 'MajEdzes, MajJelen, MajHianyzik,MajSzazalek',

                    {
                        field: 'MajEdzes',
                        headerText: gettextCatalog.getString('Sum'),
                        textAlign: 'center',
                        width: 120
                    },
                    {
                        field: 'MajJelen',
                        headerText: gettextCatalog.getString('Present'),
                        textAlign: 'center',
                        width: 100
                    },
                    {
                        field: 'MajHianyzik',
                        headerText: gettextCatalog.getString('NonPresent'),
                        textAlign: 'center',
                        width: 100
                    },
                    {
                        field: 'MajSzazalek',
                        headerText: gettextCatalog.getString('JelenSzazalek'),
                        textAlign: 'center',
                        width: 120
                    },
                ]
            },
            {
                headerText: gettextCatalog.getString('June'), textAlign: 'center', columns: [
                    // column: 'JunEdzes, JunJelen, JunHianyzik,JunSzazalek',
                    {
                        field: 'JunEdzes',
                        headerText: gettextCatalog.getString('Sum'),
                        textAlign: 'center',
                        width: 120
                    },
                    {
                        field: 'JunJelen',
                        headerText: gettextCatalog.getString('Present'),
                        textAlign: 'center',
                        width: 100
                    },
                    {
                        field: 'JunHianyzik',
                        headerText: gettextCatalog.getString('NonPresent'),
                        textAlign: 'center',
                        width: 100
                    },
                    {
                        field: 'JunSzazalek',
                        headerText: gettextCatalog.getString('JelenSzazalek'),
                        textAlign: 'center',
                        width: 120
                    }
                ]
            },
            {
                headerText: gettextCatalog.getString('July'), textAlign: 'center', columns: [
                    // column: 'JulEdzes, JulJelen, JulHianyzik,JulSzazalek',
                    {
                        field: 'JulEdzes',
                        headerText: gettextCatalog.getString('Sum'),
                        textAlign: 'center',
                        width: 120
                    },
                    {
                        field: 'JulJelen',
                        headerText: gettextCatalog.getString('Present'),
                        textAlign: 'center',
                        width: 100
                    },
                    {
                        field: 'JulHianyzik',
                        headerText: gettextCatalog.getString('NonPresent'),
                        textAlign: 'center',
                        width: 100
                    },
                    {
                        field: 'JulSzazalek',
                        headerText: gettextCatalog.getString('JelenSzazalek'),
                        textAlign: 'center',
                        width: 120
                    },
                ]
            },
            {
                headerText: gettextCatalog.getString('August'), textAlign: 'center', columns: [
                    //column: 'AugEdzes, AugJelen, AugHianyzik,AugSzazalek',
                    {field: 'AugEdzes', headerText: gettextCatalog.getString('Sum'), textAlign: 'center', width: 120},
                    {
                        field: 'AugJelen',
                        headerText: gettextCatalog.getString('Present'),
                        textAlign: 'center',
                        width: 100
                    },
                    {
                        field: 'AugHianyzik',
                        headerText: gettextCatalog.getString('NonPresent'),
                        textAlign: 'center',
                        width: 100
                    },
                    {
                        field: 'AugSzazalek',
                        headerText: gettextCatalog.getString('JelenSzazalek'),
                        textAlign: 'center',
                        width: 120
                    }
                ]
            },
            {
                headerText: gettextCatalog.getString('September'), textAlign: 'center', columns: [
                    // column: 'SzeptEdzes, SzeptJelen, SzeptHianyzik,SzeptSzazalek',
                    {field: 'SzeptEdzes', headerText: gettextCatalog.getString('Sum'), textAlign: 'center', width: 120},
                    {
                        field: 'SzeptJelen',
                        headerText: gettextCatalog.getString('Present'),
                        textAlign: 'center',
                        width: 100
                    },
                    {
                        field: 'SzeptHianyzik',
                        headerText: gettextCatalog.getString('NonPresent'),
                        textAlign: 'center',
                        width: 100
                    },
                    {
                        field: 'SzeptSzazalek',
                        headerText: gettextCatalog.getString('JelenSzazalek'),
                        textAlign: 'center',
                        width: 120
                    }
                ]
            },
            {
                headerText: gettextCatalog.getString('October'), textAlign: 'center', columns: [
                    // column: 'OktEdzes, OktJelen, OktHianyzik,OktSzazalek',
                    {field: 'OktEdzes', headerText: gettextCatalog.getString('Sum'), textAlign: 'center', width: 120},
                    {
                        field: 'OktJelen',
                        headerText: gettextCatalog.getString('Present'),
                        textAlign: 'center',
                        width: 100
                    },
                    {
                        field: 'OktHianyzik',
                        headerText: gettextCatalog.getString('NonPresent'),
                        textAlign: 'center',
                        width: 100
                    },
                    {
                        field: 'OktSzazalek',
                        headerText: gettextCatalog.getString('JelenSzazalek'),
                        textAlign: 'center',
                        width: 120
                    }
                ]
            },
            {
                headerText: gettextCatalog.getString('November'), textAlign: 'center', columns: [
                    // column: 'NovEdzes, NovJelen, NovHianyzik,NovSzazalek',
                    {field: 'NovEdzes', headerText: gettextCatalog.getString('Sum'), textAlign: 'center', width: 120},
                    {
                        field: 'NovJelen',
                        headerText: gettextCatalog.getString('Present'),
                        textAlign: 'center',
                        width: 100
                    },
                    {
                        field: 'NovHianyzik',
                        headerText: gettextCatalog.getString('NonPresent'),
                        textAlign: 'center',
                        width: 100
                    },
                    {
                        field: 'NovSzazalek',
                        headerText: gettextCatalog.getString('JelenSzazalek'),
                        textAlign: 'center',
                        width: 120
                    }
                ]
            },
            {
                headerText: gettextCatalog.getString('December'), textAlign: 'center', columns: [
                    // column: 'DecEdzes, DecJelen, DecHianyzik,DecSzazalek',
                    {field: 'DecEdzes', headerText: gettextCatalog.getString('Sum'), textAlign: 'center', width: 120},
                    {
                        field: 'DecJelen',
                        headerText: gettextCatalog.getString('Present'),
                        textAlign: 'center',
                        width: 100
                    },
                    {
                        field: 'DecHianyzik',
                        headerText: gettextCatalog.getString('NonPresent'),
                        textAlign: 'center',
                        width: 100
                    },
                    {
                        field: 'DecSzazalek',
                        headerText: gettextCatalog.getString('JelenSzazalek'),
                        textAlign: 'center',
                        width: 120
                    }
                ]
            },
            {
                headerText: gettextCatalog.getString('12month'), textAlign: 'center', columns: [
                    // column: 'OsszEdzes, OsszJelen, OsszHianyzik,OsszSzazalek',
                    {
                        field: 'OsszEdzes',
                        headerText: gettextCatalog.getString('Sum'),
                        textAlign: 'center',
                        width: 120
                    },
                    {
                        field: 'OsszJelen',
                        headerText: gettextCatalog.getString('Present'),
                        textAlign: 'center',
                        width: 100
                    },
                    {
                        field: 'OsszHianyzik',
                        headerText: gettextCatalog.getString('NonPresent'),
                        textAlign: 'center',
                        width: 100
                    },
                    {
                        field: 'OsszSzazalek',
                        headerText: gettextCatalog.getString('JelenSzazalek'),
                        textAlign: 'center',
                        width: 120
                    }
                ]
            },
        ];

        var grid = new ej2.grids.Grid({
            dataSource: [],
            allowPaging: true,
            allowExcelExport: true,
            //frozenColumns: 3,
            locale: 'hu-HU',
            gridLines: 'Both',
            toolbar: $rootScope.toolbarItemsWithSearch,
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile(grid, $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        vm.sectionSelect = sectionSelect;
        vm.goToNewCoach = goToNewCoach;
        vm.reportSelect = reportSelect;
        vm.sectionDataBound = sectionDataBound;

        activate();

        function activate() {
            var promises = [authenticationService.getRight('KMEVESJELEDZO')];
            $q.all(promises).then(function (res) {
                vm.KMEVESJELEDZO = res[0];
                if (!vm.KMEVESJELEDZO) {
                    log.permissionError(true);
                } else {
                    getSections();
                    setDropDowns();
                }
            });
        }

        function setDropDowns() {
            var promises = [paramHelper.getParams([], [
                'aprbs.selectedSection',
                'annualPresenceReports.year',
                'annualPresenceReports.month'
            ])
            ];
            $q.all(promises).then(function (results) {
                if (results[0]['annualPresenceReports.year']) {
                    vm.selectedYear = results[0]['annualPresenceReports.year'];
                }
                if (results[0]['annualPresenceReports.month']) {
                    vm.selectedMonth = results[0]['annualPresenceReports.month'];
                }
                if (results[0]['aprbs.selectedSection']) {
                    vm.selectedSection = results[0]['aprbs.selectedSection'];
                }
            });
        }

        function sectionDataBound() {
            if (vm.selectedSection > 0) {
                angular.element('#maSzakosztaly').ejDropDownList('selectItemByValue', vm.selectedSection);
            } else {
                if (vm.sectionList.length === 1) {
                    angular.element('#maSzakosztaly').ejDropDownList('selectItemByValue', vm.sectionList[0].value);
                    vm.selectedSection = vm.sectionList[0].value;
                } else {
                    angular.element('#maSzakosztaly').ejDropDownList('selectItemByValue', vm.selectedSection);
                }
            }
        }

        function getSections() {
            return dataservice.sectionDropDownList(0, true)
                .then(function (data) {
                    vm.sectionList = data.itemsList;
                    $timeout(function () {
                        if (!(vm.selectedSection > 0)) {
                            vm.selectedSection = vm.sectionList[0].value;
                        }
                    }, 0);
                });
        }

        function sectionSelect(args) {
            vm.selectedSection = args.value;
        }

        function goToNewCoach(coachId) {
            if (coachId && coachId === 0 && !vm.MEGTHAVIJEL) {
                log.permissionError();
                return;
            }
            paramHelper.setParams([{'newUser.userId': coachId}]);
            $state.go('settings.userManagement.modifyUser');
        }

        function reportSelect() {
            // a syncfusion direktívák miatt
            $scope.$broadcast('submitted');
            if ($scope.form.$valid === false) {
                log.errorMsg('FillTheRequiredFields');
                return;
            }
            if (vm.selectedSection && vm.selectedYear && vm.selectedMonth) {
                paramHelper.setParams([
                    {'aprbs.selectedSection': vm.selectedSection},
                    {'annualPresenceReports.year': vm.selectedYear},
                    {'annualPresenceReports.month': vm.selectedMonth}
                ]);
            }
            dataservice.getAnnualPresenceReportBySectionsReport(vm.selectedYear, vm.selectedMonth, vm.selectedSection)
                .then(function (data) {
                    vm.columns2 = [];
                    vm.columns2.push(vm.columns[0]);
                    vm.columns2.push(vm.columns[1]);
                    vm.columns2.push(vm.columns[2]);
                    var j = (parseInt(vm.selectedMonth) + 3);
                    for (var i = 0; i < 12; i++) {
                        vm.columns2.push(vm.columns[j++]);
                        j = j === 12 + 3 ? 3 : j;
                    }
                    vm.columns2.push(vm.columns[15]);
                    grid.columns = vm.columns2;
                    grid.refreshColumns();
                    grid.dataSource = data.itemsList;
                });
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.reports.annualPresenceReports.annualPresenceReportsBySections')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'reports.annualPresenceReports.annualPresenceReportsBySections',
                config: {
                    url: '/annualPresenceReportsBySections',
                    templateUrl: 'app/reports/annualPresenceReports/annualPresenceReportsBySections/annualPresenceReportsBySections.html',
                    controller: 'AnnualPresenceReportsBySectionsController',
                    controllerAs: 'vm',
                    title: 'AnnualPresenceReportsBySections',
                    settings: {
                        navId: 33234,
                        level: 3,
                        order: 3,
                        orderTitle_hu: 'Éves jelenléti kimutatás szakosztályonként',
                        orderTitle_en: 'Annual Attendance Reports by Sections',
                        parentId: 224,
                        content: 'AnnualPresenceReportsBySections',
                        activatorPermission: '"KMEVESJELEDZO"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    AnnualPresenceReportsBySportSchoolController.$inject = ["dataservice", "$q", "log", "authenticationService", "$rootScope", "gettextCatalog", "$scope", "paramHelper", "$timeout"];
    angular
        .module('app.reports.annualPresenceReports.annualPresenceReportsBySportSchool')
        .controller('AnnualPresenceReportsBySportSchoolController', AnnualPresenceReportsBySportSchoolController);

    function AnnualPresenceReportsBySportSchoolController(dataservice, $q, log, authenticationService, $rootScope, gettextCatalog, $scope, paramHelper, $timeout) {
        var vm = this;
        $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('AnnualPresenceReportsBySportSchool');

        //Évek (2010-től az aktuális évig)
        vm.years = [];
        for (var ev = 2010; ev <= new Date().getFullYear(); ev++) {
            vm.years.push(ev);
        }
        //Kiválasztott év (alapból az aktuális)
        vm.selectedYear = new Date().getFullYear();
        vm.selectedMonth = 0;

        //Hónapok
        vm.months = [
            {text: gettextCatalog.getString('January'), value: 0},
            {text: gettextCatalog.getString('February'), value: 1},
            {text: gettextCatalog.getString('March'), value: 2},
            {text: gettextCatalog.getString('April'), value: 3},
            {text: gettextCatalog.getString('May'), value: 4},
            {text: gettextCatalog.getString('June'), value: 5},
            {text: gettextCatalog.getString('July'), value: 6},
            {text: gettextCatalog.getString('August'), value: 7},
            {text: gettextCatalog.getString('September'), value: 8},
            {text: gettextCatalog.getString('October'), value: 9},
            {text: gettextCatalog.getString('November'), value: 10},
            {text: gettextCatalog.getString('December'), value: 11}
        ];

        vm.reportSelect = reportSelect;
        vm.columns = [
            {field: 'Id', visible: false, isPrimaryKey: true, isIdentity: true},
            {field: 'Sorszam', headerText: gettextCatalog.getString('RowNumber'), textAlign: 'center', width: 120},
            {field: 'VersenyzoNeve', headerText: gettextCatalog.getString('Name'), textAlign: 'center', width: 250},

            {
                headerText: gettextCatalog.getString('January'), textAlign: 'center', columns: [
                    // column: 'JanEdzes, JanJelen, JanHianyzik,JanSzazalek',
                    {
                        field: 'JanEdzes',
                        headerText: gettextCatalog.getString('Sum'),
                        textAlign: 'center',
                        width: 120
                    },
                    {
                        field: 'JanJelen',
                        headerText: gettextCatalog.getString('Present'),
                        textAlign: 'center',
                        width: 100
                    },
                    {
                        field: 'JanHianyzik',
                        headerText: gettextCatalog.getString('NonPresent'),
                        textAlign: 'center',
                        width: 100
                    },
                    {
                        field: 'JanSzazalek',
                        headerText: gettextCatalog.getString('JelenSzazalek'),
                        textAlign: 'center',
                        width: 120
                    }
                ]
            },
            {
                headerText: gettextCatalog.getString('February'), textAlign: 'center', columns: [
                    // column: 'FebEdzes, FebJelen, FebHianyzik,FebSzazalek',
                    {
                        field: 'FebEdzes',
                        headerText: gettextCatalog.getString('Sum'),
                        textAlign: 'center',
                        width: 120
                    },
                    {
                        field: 'FebJelen',
                        headerText: gettextCatalog.getString('Present'),
                        textAlign: 'center',
                        width: 100
                    },
                    {
                        field: 'FebHianyzik',
                        headerText: gettextCatalog.getString('NonPresent'),
                        textAlign: 'center',
                        width: 100
                    },
                    {
                        field: 'FebSzazalek',
                        headerText: gettextCatalog.getString('JelenSzazalek'),
                        textAlign: 'center',
                        width: 120
                    }
                ]
            },
            {
                headerText: gettextCatalog.getString('March'), textAlign: 'center', columns: [
                    // column: 'MarcEdzes, MarcJelen, MarcHianyzik,MarcSzazalek',
                    {
                        field: 'MarcEdzes',
                        headerText: gettextCatalog.getString('Sum'),
                        textAlign: 'center',
                        width: 120
                    },
                    {
                        field: 'MarcJelen',
                        headerText: gettextCatalog.getString('Present'),
                        textAlign: 'center',
                        width: 100
                    },
                    {
                        field: 'MarcHianyzik',
                        headerText: gettextCatalog.getString('NonPresent'),
                        textAlign: 'center',
                        width: 100
                    },
                    {
                        field: 'MarcSzazalek',
                        headerText: gettextCatalog.getString('JelenSzazalek'),
                        textAlign: 'center',
                        width: 120
                    }
                ]
            },
            {
                headerText: gettextCatalog.getString('April'), textAlign: 'center', columns: [
                    // column: 'AprEdzes, AprJelen, AprHianyzik,AprSzazalek',
                    {
                        field: 'AprEdzes',
                        headerText: gettextCatalog.getString('Sum'),
                        textAlign: 'center',
                        width: 120
                    },
                    {
                        field: 'AprJelen',
                        headerText: gettextCatalog.getString('Present'),
                        textAlign: 'center',
                        width: 100
                    },
                    {
                        field: 'AprHianyzik',
                        headerText: gettextCatalog.getString('NonPresent'),
                        textAlign: 'center',
                        width: 100
                    },
                    {
                        field: 'AprSzazalek',
                        headerText: gettextCatalog.getString('JelenSzazalek'),
                        textAlign: 'center',
                        width: 120
                    }
                ]
            },
            {
                headerText: gettextCatalog.getString('May'), textAlign: 'center', columns: [
                    // column: 'MajEdzes, MajJelen, MajHianyzik,MajSzazalek',

                    {
                        field: 'MajEdzes',
                        headerText: gettextCatalog.getString('Sum'),
                        textAlign: 'center',
                        width: 120
                    },
                    {
                        field: 'MajJelen',
                        headerText: gettextCatalog.getString('Present'),
                        textAlign: 'center',
                        width: 100
                    },
                    {
                        field: 'MajHianyzik',
                        headerText: gettextCatalog.getString('NonPresent'),
                        textAlign: 'center',
                        width: 100
                    },
                    {
                        field: 'MajSzazalek',
                        headerText: gettextCatalog.getString('JelenSzazalek'),
                        textAlign: 'center',
                        width: 120
                    }
                ]
            },
            {
                headerText: gettextCatalog.getString('June'), textAlign: 'center', columns: [
                    // column: 'JunEdzes, JunJelen, JunHianyzik,JunSzazalek',
                    {
                        field: 'JunEdzes',
                        headerText: gettextCatalog.getString('Sum'),
                        textAlign: 'center',
                        width: 120
                    },
                    {
                        field: 'JunJelen',
                        headerText: gettextCatalog.getString('Present'),
                        textAlign: 'center',
                        width: 100
                    },
                    {
                        field: 'JunHianyzik',
                        headerText: gettextCatalog.getString('NonPresent'),
                        textAlign: 'center',
                        width: 100
                    },
                    {
                        field: 'JunSzazalek',
                        headerText: gettextCatalog.getString('JelenSzazalek'),
                        textAlign: 'center',
                        width: 120
                    }
                ]
            },
            {
                headerText: gettextCatalog.getString('July'), textAlign: 'center', columns: [
                    // column: 'JulEdzes, JulJelen, JulHianyzik,JulSzazalek',
                    {
                        field: 'JulEdzes',
                        headerText: gettextCatalog.getString('Sum'),
                        textAlign: 'center',
                        width: 120
                    },
                    {
                        field: 'JulJelen',
                        headerText: gettextCatalog.getString('Present'),
                        textAlign: 'center',
                        width: 100
                    },
                    {
                        field: 'JulHianyzik',
                        headerText: gettextCatalog.getString('NonPresent'),
                        textAlign: 'center',
                        width: 100
                    },
                    {
                        field: 'JulSzazalek',
                        headerText: gettextCatalog.getString('JelenSzazalek'),
                        textAlign: 'center',
                        width: 120
                    }
                ]
            },
            {
                headerText: gettextCatalog.getString('August'), textAlign: 'center', columns: [
                    //column: 'AugEdzes, AugJelen, AugHianyzik,AugSzazalek',
                    {field: 'AugEdzes', headerText: gettextCatalog.getString('Sum'), textAlign: 'center', width: 120},
                    {field: 'AugJelen', headerText: gettextCatalog.getString('Present'), textAlign: 'center', width: 100},
                    {field: 'AugHianyzik', headerText: gettextCatalog.getString('NonPresent'), textAlign: 'center', width: 100},
                    {
                        field: 'AugSzazalek',
                        headerText: gettextCatalog.getString('JelenSzazalek'),
                        textAlign: 'center',
                        width: 120
                    }
                ]
            },
            {
                headerText: gettextCatalog.getString('September'), textAlign: 'center', columns: [
                    // column: 'SzeptEdzes, SzeptJelen, SzeptHianyzik,SzeptSzazalek',
                    {field: 'SzeptEdzes', headerText: gettextCatalog.getString('Sum'), textAlign: 'center', width: 120},
                    {field: 'SzeptJelen', headerText: gettextCatalog.getString('Present'), textAlign: 'center', width: 100},
                    {
                        field: 'SzeptHianyzik',
                        headerText: gettextCatalog.getString('NonPresent'),
                        textAlign: 'center',
                        width: 100
                    },
                    {
                        field: 'SzeptSzazalek',
                        headerText: gettextCatalog.getString('JelenSzazalek'),
                        textAlign: 'center',
                        width: 120
                    }
                ]
            },
            {
                headerText: gettextCatalog.getString('October'), textAlign: 'center', columns: [
                    // column: 'OktEdzes, OktJelen, OktHianyzik,OktSzazalek',
                    {field: 'OktEdzes', headerText: gettextCatalog.getString('Sum'), textAlign: 'center', width: 120},
                    {field: 'OktJelen', headerText: gettextCatalog.getString('Present'), textAlign: 'center', width: 100},
                    {field: 'OktHianyzik', headerText: gettextCatalog.getString('NonPresent'), textAlign: 'center', width: 100},
                    {
                        field: 'OktSzazalek',
                        headerText: gettextCatalog.getString('JelenSzazalek'),
                        textAlign: 'center',
                        width: 120
                    }
                ]
            },
            {
                headerText: gettextCatalog.getString('November'), textAlign: 'center', columns: [
                    // column: 'NovEdzes, NovJelen, NovHianyzik,NovSzazalek',
                    {field: 'NovEdzes', headerText: gettextCatalog.getString('Sum'), textAlign: 'center', width: 120},
                    {field: 'NovJelen', headerText: gettextCatalog.getString('Present'), textAlign: 'center', width: 100},
                    {field: 'NovHianyzik', headerText: gettextCatalog.getString('NonPresent'), textAlign: 'center', width: 100},
                    {
                        field: 'NovSzazalek',
                        headerText: gettextCatalog.getString('JelenSzazalek'),
                        textAlign: 'center',
                        width: 120
                    }
                ]
            },
            {
                headerText: gettextCatalog.getString('December'), textAlign: 'center', columns: [
                    // column: 'DecEdzes, DecJelen, DecHianyzik,DecSzazalek',
                    {field: 'DecEdzes', headerText: gettextCatalog.getString('Sum'), textAlign: 'center', width: 120},
                    {field: 'DecJelen', headerText: gettextCatalog.getString('Present'), textAlign: 'center', width: 100},
                    {field: 'DecHianyzik', headerText: gettextCatalog.getString('NonPresent'), textAlign: 'center', width: 100},
                    {
                        field: 'DecSzazalek',
                        headerText: gettextCatalog.getString('JelenSzazalek'),
                        textAlign: 'center',
                        width: 120
                    }
                ]
            },
            {
                headerText: gettextCatalog.getString('12month'), textAlign: 'center', columns: [
                    // column: 'OsszEdzes, OsszJelen, OsszHianyzik,OsszSzazalek',
                    {
                        field: 'OsszEdzes',
                        headerText: gettextCatalog.getString('Sum'),
                        textAlign: 'center',
                        width: 120
                    },
                    {
                        field: 'OsszJelen',
                        headerText: gettextCatalog.getString('Present'),
                        textAlign: 'center',
                        width: 100
                    },
                    {
                        field: 'OsszHianyzik',
                        headerText: gettextCatalog.getString('NonPresent'),
                        textAlign: 'center',
                        width: 100
                    },
                    {
                        field: 'OsszSzazalek',
                        headerText: gettextCatalog.getString('JelenSzazalek'),
                        textAlign: 'center',
                        width: 120
                    }
                ]
            }
        ];

        var grid = new ej2.grids.Grid({
            dataSource: [],
            allowPaging: true,
            allowExcelExport: true,
            //frozenColumns: 3,
            locale: 'hu-HU',
            gridLines: 'Both',
            toolbar: $rootScope.toolbarItemsWithSearch,
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile(grid, $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        activate();

        function activate() {
            var promises = [authenticationService.getRight('KMEVESJELSZO')];
            $q.all(promises).then(function (res) {
                if (!res[0]) {
                    log.permissionError(true);
                }
                paramHelper.getParams([], ['annualPresenceReports.year', 'annualPresenceReports.month']).then(function (result) {
                    $timeout(function () {
                        if (result['annualPresenceReports.year']) {
                            vm.selectedYear = result['annualPresenceReports.year'];
                        }
                        if (result['annualPresenceReports.month']) {
                            vm.selectedMonth = result['annualPresenceReports.month'];
                        }
                        reportSelect();
                    }, 0);
                });
            });
        }

        function reportSelect() {
            // a syncfusion direktívák miatt
            $scope.$broadcast('submitted');
            if ($scope.form.$valid === false) {
                log.errorMsg('FillTheRequiredFields');
                return;
            }
            if (vm.selectedYear && vm.selectedMonth) {
                paramHelper.setParams([
                    {'annualPresenceReports.year': vm.selectedYear},
                    {'annualPresenceReports.month': vm.selectedMonth}
                ]);
            }
            dataservice.getAnnualPresenceReportBySportSchoolReport(vm.selectedYear, vm.selectedMonth)
                .then(function (data) {
                    vm.columns2 = [];
                    vm.columns2.push(vm.columns[0]);
                    vm.columns2.push(vm.columns[1]);
                    vm.columns2.push(vm.columns[2]);
                    var j = (parseInt(vm.selectedMonth) + 3);
                    for (var i = 0; i < 12; i++) {
                        vm.columns2.push(vm.columns[j++]);
                        j = j === 12 + 3 ? 3 : j;
                    }
                    vm.columns2.push(vm.columns[15]);
                    grid.columns = vm.columns2;
                    grid.refreshColumns();
                    grid.dataSource = data.itemsList;
                });
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.reports.annualPresenceReports.annualPresenceReportsBySportSchool')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'reports.annualPresenceReports.annualPresenceReportsBySportSchool',
                config: {
                    url: '/annualPresenceReportsBySportSchool',
                    templateUrl: 'app/reports/annualPresenceReports/annualPresenceReportsBySportSchool/annualPresenceReportsBySportSchool.html',
                    controller: 'AnnualPresenceReportsBySportSchoolController',
                    controllerAs: 'vm',
                    title: 'AnnualPresenceReportsBySportSchool',
                    settings: {
                        navId: 32234,
                        level: 3,
                        order: 2,
                        orderTitle_hu: 'Éves jelenléti kimutatás edzőnként',
                        orderTitle_en: 'Annual Attendance Reports by Coaches',
                        parentId: 224,
                        content: 'AnnualPresenceReportsBySportSchool',
                        activatorPermission: '"KMEVESJELSZO"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    AnnualPresenceReportsByTrainersController.$inject = ["log", "dataservice", "$q", "$rootScope", "gettextCatalog", "$scope", "authenticationService", "paramHelper", "$state"];
    angular
        .module('app.reports.annualPresenceReports.annualPresenceReportsByTrainers')
        .controller('AnnualPresenceReportsByTrainersController', AnnualPresenceReportsByTrainersController);

    function AnnualPresenceReportsByTrainersController(log, dataservice, $q, $rootScope, gettextCatalog, $scope, authenticationService, paramHelper, $state) {
        var vm = this;
        $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('AnnualPresenceReportsByTrainers');

        //Évek (2010-től az aktuális évig)
        vm.years = [];
        for (var ev = 2010; ev <= new Date().getFullYear(); ev++) {
            vm.years.push(ev);
        }
        //Kiválasztott év (alapból az aktuális)
        vm.selectedYear = new Date().getFullYear();
        vm.selectedMonth = 0;

        //Hónapok
        vm.months = [
            {text: gettextCatalog.getString('January'), value: 0},
            {text: gettextCatalog.getString('February'), value: 1},
            {text: gettextCatalog.getString('March'), value: 2},
            {text: gettextCatalog.getString('April'), value: 3},
            {text: gettextCatalog.getString('May'), value: 4},
            {text: gettextCatalog.getString('June'), value: 5},
            {text: gettextCatalog.getString('July'), value: 6},
            {text: gettextCatalog.getString('August'), value: 7},
            {text: gettextCatalog.getString('September'), value: 8},
            {text: gettextCatalog.getString('October'), value: 9},
            {text: gettextCatalog.getString('November'), value: 10},
            {text: gettextCatalog.getString('December'), value: 11}
        ];

        //Kiválasztott év (alapból az aktuális)
        vm.selectedCoach = {};
        vm.coachList = [];
        vm.selectedSection = 0;
        vm.sectionDataBound = [];
        vm.selectedAgeGroup = 0;
        vm.ageGroupList = [];
        vm.columns = [
            {field: 'Id', visible: false, isPrimaryKey: true, isIdentity: true},
            {field: 'Sorszam', headerText: gettextCatalog.getString('RowNumber'), textAlign: 'center', width: 120},
            {field: 'VersenyzoNeve', headerText: gettextCatalog.getString('Name'), textAlign: 'center', width: 250},
            {
                headerText: gettextCatalog.getString('January'), textAlign: 'center', columns: [
                    // column: 'JanEdzes, JanJelen, JanHianyzik,JanSzazalek',
                    {
                        field: 'JanEdzes',
                        headerText: gettextCatalog.getString('Sum'),
                        textAlign: 'center',
                        width: 120
                    },
                    {
                        field: 'JanJelen',
                        headerText: gettextCatalog.getString('Present'),
                        textAlign: 'center',
                        width: 100
                    },
                    {
                        field: 'JanHianyzik',
                        headerText: gettextCatalog.getString('NonPresent'),
                        textAlign: 'center',
                        width: 100
                    },
                    {
                        field: 'JanSzazalek',
                        headerText: gettextCatalog.getString('JelenSzazalek'),
                        textAlign: 'center',
                        width: 120
                    }
                ]
            },
            {
                headerText: gettextCatalog.getString('February'), textAlign: 'center', columns: [
                    // column: 'FebEdzes, FebJelen, FebHianyzik,FebSzazalek',
                    {
                        field: 'FebEdzes',
                        headerText: gettextCatalog.getString('Sum'),
                        textAlign: 'center',
                        width: 120
                    },
                    {
                        field: 'FebJelen',
                        headerText: gettextCatalog.getString('Present'),
                        textAlign: 'center',
                        width: 100
                    },
                    {
                        field: 'FebHianyzik',
                        headerText: gettextCatalog.getString('NonPresent'),
                        textAlign: 'center',
                        width: 100
                    },
                    {
                        field: 'FebSzazalek',
                        headerText: gettextCatalog.getString('JelenSzazalek'),
                        textAlign: 'center',
                        width: 120
                    }
                ]
            },
            {
                headerText: gettextCatalog.getString('March'), textAlign: 'center', columns: [
                    // column: 'MarcEdzes, MarcJelen, MarcHianyzik,MarcSzazalek',
                    {
                        field: 'MarcEdzes',
                        headerText: gettextCatalog.getString('Sum'),
                        textAlign: 'center',
                        width: 120
                    },
                    {
                        field: 'MarcJelen',
                        headerText: gettextCatalog.getString('Present'),
                        textAlign: 'center',
                        width: 100
                    },
                    {
                        field: 'MarcHianyzik',
                        headerText: gettextCatalog.getString('NonPresent'),
                        textAlign: 'center',
                        width: 100
                    },
                    {
                        field: 'MarcSzazalek',
                        headerText: gettextCatalog.getString('JelenSzazalek'),
                        textAlign: 'center',
                        width: 120
                    }
                ]
            },
            {
                headerText: gettextCatalog.getString('April'), textAlign: 'center', columns: [
                    // column: 'AprEdzes, AprJelen, AprHianyzik,AprSzazalek',
                    {
                        field: 'AprEdzes',
                        headerText: gettextCatalog.getString('Sum'),
                        textAlign: 'center',
                        width: 120
                    },
                    {
                        field: 'AprJelen',
                        headerText: gettextCatalog.getString('Present'),
                        textAlign: 'center',
                        width: 100
                    },
                    {
                        field: 'AprHianyzik',
                        headerText: gettextCatalog.getString('NonPresent'),
                        textAlign: 'center',
                        width: 100
                    },
                    {
                        field: 'AprSzazalek',
                        headerText: gettextCatalog.getString('JelenSzazalek'),
                        textAlign: 'center',
                        width: 120
                    }
                ]
            },
            {
                headerText: gettextCatalog.getString('May'), textAlign: 'center', columns: [
                    // column: 'MajEdzes, MajJelen, MajHianyzik,MajSzazalek',

                    {
                        field: 'MajEdzes',
                        headerText: gettextCatalog.getString('Sum'),
                        textAlign: 'center',
                        width: 120
                    },
                    {
                        field: 'MajJelen',
                        headerText: gettextCatalog.getString('Present'),
                        textAlign: 'center',
                        width: 100
                    },
                    {
                        field: 'MajHianyzik',
                        headerText: gettextCatalog.getString('NonPresent'),
                        textAlign: 'center',
                        width: 100
                    },
                    {
                        field: 'MajSzazalek',
                        headerText: gettextCatalog.getString('JelenSzazalek'),
                        textAlign: 'center',
                        width: 120
                    }
                ]
            },
            {
                headerText: gettextCatalog.getString('June'), textAlign: 'center', columns: [
                    // column: 'JunEdzes, JunJelen, JunHianyzik,JunSzazalek',
                    {
                        field: 'JunEdzes',
                        headerText: gettextCatalog.getString('Sum'),
                        textAlign: 'center',
                        width: 120
                    },
                    {
                        field: 'JunJelen',
                        headerText: gettextCatalog.getString('Present'),
                        textAlign: 'center',
                        width: 100
                    },
                    {
                        field: 'JunHianyzik',
                        headerText: gettextCatalog.getString('NonPresent'),
                        textAlign: 'center',
                        width: 100
                    },
                    {
                        field: 'JunSzazalek',
                        headerText: gettextCatalog.getString('JelenSzazalek'),
                        textAlign: 'center',
                        width: 120
                    }
                ]
            },
            {
                headerText: gettextCatalog.getString('July'), textAlign: 'center', columns: [
                    // column: 'JulEdzes, JulJelen, JulHianyzik,JulSzazalek',
                    {
                        field: 'JulEdzes',
                        headerText: gettextCatalog.getString('Sum'),
                        textAlign: 'center',
                        width: 120
                    },
                    {
                        field: 'JulJelen',
                        headerText: gettextCatalog.getString('Present'),
                        textAlign: 'center',
                        width: 100
                    },
                    {
                        field: 'JulHianyzik',
                        headerText: gettextCatalog.getString('NonPresent'),
                        textAlign: 'center',
                        width: 100
                    },
                    {
                        field: 'JulSzazalek',
                        headerText: gettextCatalog.getString('JelenSzazalek'),
                        textAlign: 'center',
                        width: 120
                    }
                ]
            },
            {
                headerText: gettextCatalog.getString('August'), textAlign: 'center', columns: [
                    //column: 'AugFlo, AugJelen, AugHianyzik,AugSzazalek',
                    {
                        field: 'AugEdzes',
                        headerText: gettextCatalog.getString('EdzesSzam'),
                        textAlign: 'center',
                        width: 120
                    },
                    {
                        field: 'AugJelen',
                        headerText: gettextCatalog.getString('Present'),
                        textAlign: 'center',
                        width: 100
                    },
                    {
                        field: 'AugHianyzik',
                        headerText: gettextCatalog.getString('NonPresent'),
                        textAlign: 'center',
                        width: 100
                    },
                    {
                        field: 'AugSzazalek',
                        headerText: gettextCatalog.getString('JelenSzazalek'),
                        textAlign: 'center',
                        width: 120
                    }
                ]
            },
            {
                headerText: gettextCatalog.getString('September'), textAlign: 'center', columns: [
                    // column: 'SzeptFlo, SzeptJelen, SzeptHianyzik,SzeptSzazalek',
                    {field: 'SzeptEdzes', headerText: gettextCatalog.getString('Sum'), textAlign: 'center', width: 120},
                    {
                        field: 'SzeptJelen',
                        headerText: gettextCatalog.getString('Present'),
                        textAlign: 'center',
                        width: 100
                    },
                    {
                        field: 'SzeptHianyzik',
                        headerText: gettextCatalog.getString('NonPresent'),
                        textAlign: 'center',
                        width: 100
                    },
                    {
                        field: 'SzeptSzazalek',
                        headerText: gettextCatalog.getString('JelenSzazalek'),
                        textAlign: 'center',
                        width: 120
                    }
                ]
            },
            {
                headerText: gettextCatalog.getString('October'), textAlign: 'center', columns: [
                    // column: 'OktEdzes, OktJelen, OktHianyzik,OktSzazalek',
                    {field: 'OktEdzes', headerText: gettextCatalog.getString('Sum'), textAlign: 'center', width: 120},
                    {
                        field: 'OktJelen',
                        headerText: gettextCatalog.getString('Present'),
                        textAlign: 'center',
                        width: 100
                    },
                    {
                        field: 'OktHianyzik',
                        headerText: gettextCatalog.getString('NonPresent'),
                        textAlign: 'center',
                        width: 100
                    },
                    {
                        field: 'OktSzazalek',
                        headerText: gettextCatalog.getString('JelenSzazalek'),
                        textAlign: 'center',
                        width: 120
                    }
                ]
            },
            {
                headerText: gettextCatalog.getString('November'), textAlign: 'center', columns: [
                    // column: 'NovEdzes, NovJelen, NovHianyzik,NovSzazalek',
                    {field: 'NovEdzes', headerText: gettextCatalog.getString('Sum'), textAlign: 'center', width: 120},
                    {
                        field: 'NovJelen',
                        headerText: gettextCatalog.getString('Present'),
                        textAlign: 'center',
                        width: 100
                    },
                    {
                        field: 'NovHianyzik',
                        headerText: gettextCatalog.getString('NonPresent'),
                        textAlign: 'center',
                        width: 100
                    },
                    {
                        field: 'NovSzazalek',
                        headerText: gettextCatalog.getString('JelenSzazalek'),
                        textAlign: 'center',
                        width: 120
                    }
                ]
            },
            {
                headerText: gettextCatalog.getString('December'), textAlign: 'center', columns: [
                    // column: 'DecEdzes, DecJelen, DecHianyzik,DecSzazalek',
                    {field: 'DecEdzes', headerText: gettextCatalog.getString('Sum'), textAlign: 'center', width: 120},
                    {
                        field: 'DecJelen',
                        headerText: gettextCatalog.getString('Present'),
                        textAlign: 'center',
                        width: 100
                    },
                    {
                        field: 'DecHianyzik',
                        headerText: gettextCatalog.getString('NonPresent'),
                        textAlign: 'center',
                        width: 100
                    },
                    {
                        field: 'DecSzazalek',
                        headerText: gettextCatalog.getString('JelenSzazalek'),
                        textAlign: 'center',
                        width: 120
                    }
                ]
            },
            {
                headerText: gettextCatalog.getString('12month'), textAlign: 'center', columns: [
                    // column: 'OsszEdzes, OsszJelen, OsszHianyzik,OsszSzazalek',
                    {
                        field: 'OsszEdzes',
                        headerText: gettextCatalog.getString('Sum'),
                        textAlign: 'center',
                        width: 120
                    },
                    {
                        field: 'OsszJelen',
                        headerText: gettextCatalog.getString('Present'),
                        textAlign: 'center',
                        width: 100
                    },
                    {
                        field: 'OsszHianyzik',
                        headerText: gettextCatalog.getString('NonPresent'),
                        textAlign: 'center',
                        width: 100
                    },
                    {
                        field: 'OsszSzazalek',
                        headerText: gettextCatalog.getString('JelenSzazalek'),
                        textAlign: 'center',
                        width: 120
                    }
                ]
            }
        ];

        // Public functions
        vm.coachSelect = coachSelect;
        vm.sectionSelect = sectionSelect;
        vm.ageGroupSelect = ageGroupSelect;

        vm.goToNewAthlete = goToNewAthlete;
        vm.reportSelect = reportSelect;

        vm.sectionDataBound = sectionDataBound;
        vm.ageGroupDataBound = ageGroupDataBound;
        vm.coachDataBound = coachDataBound;

        var grid = new ej2.grids.Grid({
            dataSource: [],
            allowPaging: true,
            allowExcelExport: true,
            //frozenColumns: 3,
            locale: 'hu-HU',
            gridLines: 'Both',
            toolbar: $rootScope.toolbarItemsWithSearch,
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile(grid, $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        activate();

        function activate() {
            var promises = [authenticationService.getRight('KMEVESJELSP')];
            $q.all(promises).then(function (res) {
                if (!res[0]) {
                    log.permissionError(true);
                } else {
                    getSections();
                    setDropDowns();
                }
            });
        }

        function setDropDowns() {
            var promises = [paramHelper.getParams([], [
                'aprbt.selectedSection',
                'aprbt.selectedAgeGroup',
                'aprbt.selectedCoach',
                'annualPresenceReports.year',
                'annualPresenceReports.month'
            ])];
            $q.all(promises).then(function (results) {
                if (results[0]['aprbt.selectedSection']) {
                    vm.selectedSection = results[0]['aprbt.selectedSection'];
                }
                if (results[0]['aprbt.selectedAgeGroup']) {
                    vm.selectedAgeGroup = results[0]['aprbt.selectedAgeGroup'];
                }
                if (results[0]['aprbt.selectedCoach']) {
                    vm.selectedCoach = results[0]['aprbt.selectedCoach'];
                }
                if (results[0]['annualPresenceReports.year']) {
                    vm.selectedYear = results[0]['annualPresenceReports.year'];
                }
                if (results[0]['annualPresenceReports.month']) {
                    vm.selectedMonth = results[0]['annualPresenceReports.month'];
                }
            });
        }

        function getCoaches() {
            return dataservice.coachDropDownList(vm.selectedSection, vm.selectedAgeGroup, new Date(vm.selectedYear, vm.selectedMonth, 1)).then(
                function (data) {
                    data.itemsList.unshift({text: gettextCatalog.getString('All'), value: 0});
                    vm.coachList = data.itemsList;
                }
            );
        }

        function coachSelect(args) {
            vm.selectedCoach = args.value;
        }

        function getSections() {
            return dataservice.sectionDropDownList(0, true)
                .then(function (data) {
                    data.itemsList.unshift({text: gettextCatalog.getString('All'), value: 0});
                    vm.sectionList = data.itemsList;
                });
        }

        function sectionSelect(args) {
            vm.selectedSection = args.value;
            getAgeGroups();
            getCoaches();
        }

        function getAgeGroups() {
            return dataservice.ageGroupSelectYear(0, vm.selectedSection, vm.selectedYear)
                .then(function (data) {
                    data.itemsList.unshift({text: gettextCatalog.getString('All'), value: 0});
                    vm.ageGroupList = data.itemsList;
                });
        }

        function ageGroupSelect(args) {
            vm.selectedAgeGroup = args.value;
            getCoaches();
        }

        function goToNewAthlete(athleteId) {
            if (athleteId == 0) {
                return;
            }
            if (!vm.MODSPORTOLO) {
                log.permissionError();
                return;
            }
            paramHelper.setParams([{'athleteModify.Id': athleteId}]);
            $state.go('athletes.athletesManagement.athleteModify.dataSheet');
        }

        function reportSelect() {
            // a syncfusion direktívák miatt
            $scope.$broadcast('submitted');
            if ($scope.form.$valid === false) {
                log.errorMsg('FillTheRequiredFields');
                return;
            }
            if (vm.selectedYear && vm.selectedMonth && vm.selectedSection && vm.selectedAgeGroup && vm.selectedCoach) {
                paramHelper.setParams([
                    {'annualPresenceReports.year': vm.selectedYear},
                    {'annualPresenceReports.month': vm.selectedMonth},
                    {'aprbt.selectedSection': vm.selectedSection},
                    {'aprbt.selectedAgeGroup': vm.selectedAgeGroup},
                    {'aprbt.selectedCoach': vm.selectedCoach}
                ]);
            }
            dataservice.getAnnualPresenceReportByTrainersReport(vm.selectedYear, vm.selectedMonth, vm.selectedSection, vm.selectedAgeGroup, '', vm.selectedCoach)
                .then(function (data) {
                    vm.columns2 = [];
                    vm.columns2.push(vm.columns[0]);
                    vm.columns2.push(vm.columns[1]);
                    vm.columns2.push(vm.columns[2]);
                    var j = (parseInt(vm.selectedMonth) + 3);
                    for (var i = 0; i < 12; i++) {
                        vm.columns2.push(vm.columns[j++]);
                        j = j === 12 + 3 ? 3 : j;
                    }
                    vm.columns2.push(vm.columns[15]);
                    grid.columns = vm.columns2;
                    grid.refreshColumns();
                    grid.dataSource = data.itemsList;
                });
        }

        function sectionDataBound() {
            if (vm.selectedSection > 0) {
                angular.element('#maSzakosztaly').ejDropDownList('selectItemByValue', vm.selectedSection);
            } else {
                if (vm.sectionList.length === 1) {
                    angular.element('#maSzakosztaly').ejDropDownList('selectItemByValue', vm.sectionList[0].value);
                    vm.selectedSection = vm.sectionList[0].value;
                } else {
                    angular.element('#maSzakosztaly').ejDropDownList('selectItemByValue', vm.selectedSection);
                }
            }
        }

        function ageGroupDataBound() {
            if (vm.selectedAgeGroup > 0) {
                angular.element('#maKorosztaly').ejDropDownList('selectItemByValue', vm.selectedAgeGroup);
            } else {
                if (vm.ageGroupList.length === 1) {
                    angular.element('#maKorosztaly').ejDropDownList('selectItemByValue', vm.ageGroupList[0].value);
                    vm.selectedAgeGroup = vm.ageGroupList[0].value;
                } else {
                    angular.element('#maKorosztaly').ejDropDownList('selectItemByValue', vm.selectedAgeGroup);
                }
            }
        }

        function coachDataBound() {
            if (vm.selectedCoach > 0) {
                angular.element('#maEdzo').ejDropDownList('selectItemByValue', vm.selectedCoach);
            } else {
                if (vm.coachList.length === 1) {
                    angular.element('#maEdzo').ejDropDownList('selectItemByValue', vm.coachList[0].value);
                    vm.selectedCoach = vm.coachList[0].value;
                } else {
                    angular.element('#maEdzo').ejDropDownList('selectItemByValue', vm.selectedCoach);
                }
            }
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.reports.annualPresenceReports.annualPresenceReportsByTrainers')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'reports.annualPresenceReports.annualPresenceReportsByTrainers',
                config: {
                    url: '/annualPresenceReportsByTrainers',
                    templateUrl: 'app/reports/annualPresenceReports/annualPresenceReportsByTrainers/annualPresenceReportsByTrainers.html',
                    controller: 'AnnualPresenceReportsByTrainersController',
                    controllerAs: 'vm',
                    title: 'AnnualPresenceReportsByTrainers',
                    settings: {
                        navId: 31234,
                        level: 3,
                        order: 1,
                        orderTitle_hu: 'Éves jelenléti kimutatás sportolónként',
                        orderTitle_en: 'Annual Attendance Reports By Athletes',
                        parentId: 224,
                        content: 'AnnualPresenceReportsByTrainers',
                        activatorPermission: '"KMEVESJELSP"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    AnthropometryTestPrintingController.$inject = ["log", "dataservice", "$rootScope", "gettextCatalog", "authenticationService", "$filter", "$scope", "$state", "paramHelper", "DOMAIN", "$q", "$timeout"];
    angular
        .module('app.reports.anthropometryTestPrinting')
        .controller('AnthropometryTestPrintingController', AnthropometryTestPrintingController);

    function AnthropometryTestPrintingController(log, dataservice, $rootScope, gettextCatalog, authenticationService, $filter, $scope, $state, paramHelper, DOMAIN, $q, $timeout) {
        var vm = this;
        $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('AnthropometryTestPrinting');

        // Create variables
        vm.dateToValue = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
        vm.dateFromValue = new Date(new Date().getFullYear(), new Date().getMonth() - 1, new Date().getDate());
        vm.printEnabled = false;
        // Grid's variables
        vm.columns = [
            {type: 'checkbox', headerText: '', textAlign: 'center', width: 55},
            {field: 'SportoloId', isPrimaryKey: true, visible: false},
            {
                field: 'SportoloNeve',
                headerText: gettextCatalog.getString('Name'),
                textAlign: 'left',
                template: '#anthropometryTestPrintingcolumnTemplate'
            },
            {field: 'SportoloLakcim', headerText: gettextCatalog.getString('Address'), textAlign: 'left'},
            {field: 'Felmeres', headerText: gettextCatalog.getString('Test'), textAlign: 'left'},
            {field: 'Csoport', headerText: gettextCatalog.getString('Group'), textAlign: 'left'},
            {field: 'MeresDatuma', headerText: gettextCatalog.getString('Date'), textAlign: 'left'}
        ];
        vm.reportParameters = {};

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItems,
            allowPaging: true,
            allowSorting: true,
            allowExcelExport: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            selectionSettings: {type: 'multiple', mode: 'Both'},
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile(grid, $scope);
                }
            },
            rowSelecting: function () {
                $timeout(function () {
                    var selectedRow = grid.getSelectedRecords();
                    if (selectedRow && selectedRow.length > 0) {
                        vm.printEnabled = true;
                    }
                    $scope.$apply();
                }, 100);
            },
            rowDeselected: Deselect,
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        function Deselect() {
            if (grid.getSelectedRecords().length === 0) {
                vm.printEnabled = false;
                $scope.$apply();
            }
        }

        // Public functions
        vm.search = search;
        vm.printSelection = printSelection;
        vm.goToAthlete = goToAthlete;

        // Activate page
        activate();

        function activate() {
            authenticationService.getRight('TomAntr').then(function (result) {
                if (result !== true) {
                    log.permissionError(true);
                } else {
                    search();
                }
            });
        }

        function search() {
            dataservice.getAnthropometryListForPrinting(vm.dateFromValue, vm.dateToValue).then(function (data) {
                grid.dataSource = $filter('dateStringFilter')(data.itemsList, 'MeresDatuma');
            });
        }

        function printSelection() {
            var selectedAthletes = $rootScope.getSelectedItems(grid);
            var Tomeges = '';
            if (selectedAthletes.length == 0) {
                log.errorMsg('NoSelectedAthlete');
                return;
            }
            angular.forEach(selectedAthletes, function (value) {
                if (Tomeges.length > 0) {
                    Tomeges += ';';
                }
                Tomeges += value.Id + ',' + value.SportoloId;
            });
            vm.reportParameters = {
                'Tomeges': Tomeges,
                'SportoloId': 0,
                'AntropometriaId': 0,
                'SportiskolaLogo': (grid.dataSource[0] && grid.dataSource[0].SportiskolaLogo) ? DOMAIN.baseURL + DOMAIN.anthropometryPhotosUrl + grid.dataSource[0].SportiskolaLogo : undefined
            };
            if (Tomeges !== '') {
                angular.element('#printDialoganthtest').ejDialog({
                    'height': '95%',
                    'width': '95%',
                    'showoninit': 'false',
                    'enablemodal': 'true',
                    'position-x': '0',
                    'position-y': '0',
                    'target': '#mainContent',
                    'enableresize': 'false'
                });
                angular.element('#printDialoganthtest').ejDialog('open');
            }
        }

        function goToAthlete(id) {
            $q.all([authenticationService.getRight('MEGTSPORTLIST')]).then(function (results) {
                if (results[0]) {
                    paramHelper.setParams([{'athleteModify.sportoloId': id}]);
                    $state.go('athletes.athletesManagement.athleteModify.dataSheet');
                } else {
                    log.permissionError();
                }
            });
        }
    }
})
();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.reports.anthropometryTestPrinting')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'reports.anthropometryTestPrinting',
                config: {
                    url: '/anthropometryTestPrinting',
                    templateUrl: 'app/reports/anthropometryTestPrinting/anthropometryTestPrinting.html',
                    controller: 'AnthropometryTestPrintingController',
                    controllerAs: 'vm',
                    title: 'AnthropometryTestPrinting',
                    settings: {
                        navId: 2124,
                        level: 2,
                        order: 12,
                        orderTitle_hu: 'Antropometria tömeges nyomtatás',
                        orderTitle_en: 'Anthropometry Bulk Printing',
                        parentId: 4,
                        content: 'AnthropometryTestPrinting',
                        activatorPermission: '"TomAntr"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    AssetInventoryReportByType.$inject = ["logger", "dataservice", "$q", "$rootScope", "gettextCatalog", "authenticationService", "$scope", "log", "$filter", "paramHelper"];
    angular
        .module('app.reports.assetInventoryReportByType')
        .controller('AssetInventoryReportByTypeController', AssetInventoryReportByType);

    function AssetInventoryReportByType (logger, dataservice, $q, $rootScope, gettextCatalog, authenticationService, $scope, log, $filter, paramHelper) {
        var vm = this; $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('AssetInventoryReportByType');

        vm.active = false;
        vm.all = true;
        vm.assetTypeId = undefined;
        vm.assetTypeList = [];
        vm.checkboxEnabled = false;
        vm.datasource = [];
        vm.expend = false;
        vm.mainGrid = [];
        vm.childGrid = [];
        vm.selectAll = selectAll;
        vm.AssetTypeDataBound = AssetTypeDataBound;
        vm.show = show;

        activate();
        vm.columns = [
            {field: 'EszkozId', visible: false},
            {field: 'EszkozMegnevezes', headerText: gettextCatalog.getString('Megnevezes'), textAlign: 'center', width: 150},
            {field: 'EszkozTipusa', headerText: gettextCatalog.getString('AssetType'), textAlign: 'center', width: 150},
            {field: 'Aktiv', headerText: gettextCatalog.getString('ItemActive'), textAlign: 'center', type: 'boolean', displayAsCheckBox: true, width: 140},
            {field: 'Szabad', headerText: gettextCatalog.getString('Issuable'), textAlign: 'center', type: 'boolean', displayAsCheckBox: true, width: 160},
            {field: 'EszkozLeiras', headerText: gettextCatalog.getString('Leiras'), textAlign: 'center', width: 150},
            {field: 'Azonosito', headerText: gettextCatalog.getString('Azonosito'), textAlign: 'center', width: 150},
            {field: 'Meret', headerText: gettextCatalog.getString('Meret'), textAlign: 'center', width: 150},
            {field: 'Kinel', headerText: gettextCatalog.getString('Kinel'), textAlign: 'center', width: 150},
            {field: 'Ar', headerText: gettextCatalog.getString('Ar'), textAlign: 'center', width: 150}
        ];

        vm.childGridColumns = [
            {field: 'MozgasId', isPrimaryKey: 'true', visible: false},
            {field: 'Kiadva', headerText: gettextCatalog.getString('Kiadva'), textAlign: 'center', width: 150},
            {field: 'Visszaveve', headerText: gettextCatalog.getString('Visszaveve'), textAlign: 'center', width: 150},
            {field: 'Sportolo', headerText: gettextCatalog.getString('Sportolo'), textAlign: 'center', width: 150},
            {field: 'Felhasznalo', headerText: gettextCatalog.getString('Felhasznalo'), textAlign: 'center', width: 150},
            {field: 'MegjegyzesKiadaskor', headerText: gettextCatalog.getString('MegjegyzesKiadaskor'), textAlign: 'center', width: 150},
            {field: 'MegjegyzesVisszavetelkor', headerText: gettextCatalog.getString('MegjegyzesVisszavetelkor'), textAlign: 'center', width: 150},
        ];

        var grid = new ej2.grids.Grid({
            dataSource: [],
            allowSorting: true,
            columns: vm.columns,
            //allowPaging: true,
            //pageSettings: $rootScope.pageSettings,
            toolbar: ['Print', 'Search'],
            childGrid: {
                dataSource: [],
                queryString: 'EszkozId',
                allowPaging: true,
                allowSorting: true,
                pageSettings: $rootScope.pageSettings,
                columns: vm.childGridColumns
            },
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        function activate() {
            $q.all([authenticationService.getRight('ESZKNYILVMEGT')]).then(function (data) {
                vm.ESZKNYILVMEGT = data[0];
                if (vm.ESZKNYILVMEGT) {
                    getAssetType();
                    setDropDowns();
                } else {
                    log.permissionError(true);
                }
            });
        }

        function setDropDowns() {
            var promises = [paramHelper.getParams([], [
                    'airbt.type',
                    'airbt.active',
                    'airbt.expend',
                    'airbt.all'
                ])
            ];
            $q.all(promises).then(function (results) {
                if (results[0]['airbt.type'] != null) {
                    vm.assetTypeId = results[0]['airbt.type'];
                    // vm.active = results[0]['airbt.active'];
                    // vm.expend = results[0]['airbt.expend'];
                    // vm.all = results[0]['airbt.all'];
                    // angular.element("#Active").ejCheckBox ({ enabled: vm.active });
                    // angular.element("#Expend").ejCheckBox ({ enabled: vm.expend });
                    // angular.element("#All").ejCheckBox ({ enabled: vm.all });
                }
            });
        }

        function getAssetType() {
            dataservice.assetTypeList().then(function (data) {
                if (data.itemsList.length > 1) {
                    data.itemsList.unshift({TipusId: 0, TipusNev: gettextCatalog.getString('All')});
                }
                vm.assetTypeList = data.itemsList;
            });
        }

        function selectAll() {
            vm.checkboxEnabled = vm.all ? true : false;
        }

        // Run after data bounded
        function AssetTypeDataBound() {
            if (vm.assetTypeId > 0) {
                angular.element('#AssetTypeDropDown').ejDropDownList('selectItemByValue', vm.assetTypeId);
            } else {
                if (vm.assetTypeList.length === 1) {
                    vm.assetTypeId = vm.assetTypeList[0].TipusId;
                    angular.element('#AssetTypeDropDown').ejDropDownList('selectItemByValue', vm.assetTypeId[0].value);
                } else {
                    vm.assetTypeId = 0;
                    angular.element('#AssetTypeDropDown').ejDropDownList('selectItemByValue', vm.assetTypeId);
                }
            }
        }

        function show() {
            $scope.$broadcast('submitted');
            if ($scope.form.$valid === false) {
                log.errorMsg(gettextCatalog.getString('RequiredFieldsError'));
                return;
            }
            paramHelper.setParams([
                {'airbt.type': vm.assetTypeId},
                {'airbt.active': vm.active},
                {'airbt.expend': vm.expend},
                {'airbt.all': vm.all}
            ]);
            dataservice.assetInventoryByType(vm.assetTypeId, vm.expend, vm.active, vm.all).then(function (data) {
                grid.dataSource = data.itemsList[0].EszkozAdatok;
                var childGrid = data.itemsList[0].EszkozMozgasa;
                childGrid = $filter('dateTimeStringFilter')(childGrid, 'Kiadva');
                grid.childGrid.dataSource = $filter('dateTimeStringFilter')(childGrid, 'Visszaveve');
            });
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.reports.assetInventoryReportByType')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'reports.assetInventoryReportByType',
                config: {
                    url: '/assetInventoryReportByType',
                    templateUrl: 'app/reports/assetInventoryReportByType/AssetInventoryReportByType.html',
                    controller: 'AssetInventoryReportByTypeController',
                    controllerAs: 'vm',
                    title: 'AssetInventoryReportByType',
                    settings: {
                        navId: 322224,
                        level: 3,
                        order: 2,
                        orderTitle_hu: 'Eszköz nyilvántartó (Típus)',
                        orderTitle_en: 'Asset Inventory (Type)',
                        parentId: 2224,
                        content: 'AssetInventoryReportByType',
                        activatorPermission: '"ESZKNYILVMEGT"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    AssetInventoryReportByUsers.$inject = ["logger", "dataservice", "$q", "$rootScope", "gettextCatalog", "authenticationService", "$scope", "log", "$filter", "paramHelper"];
    angular
        .module('app.reports.assetInventoryReportByUsers')
        .controller('AssetInventoryReportByUsersController', AssetInventoryReportByUsers);

    function AssetInventoryReportByUsers(logger, dataservice, $q, $rootScope, gettextCatalog, authenticationService, $scope, log, $filter, paramHelper) {
        var vm = this;
        $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('AssetInventoryReportByUsers');

        vm.sectionId = 0;
        vm.ageGroupId = 0;
        vm.searchTypeAthlete = false;
        vm.enableAgeGropu = false;
        vm.ageGroupList = [];
        vm.sectionList = [];
        vm.athletecoachList = [
            {value: 'athlete', text: gettextCatalog.getString('Athlete')},
            {value: 'users', text: gettextCatalog.getString('Users')}
        ];
        vm.columns = [
            {field: 'KiadvaId', visible: false},
            {field: 'Nev', headerText: gettextCatalog.getString('Name'), textAlign: 'center'},
            {field: 'Email', headerText: gettextCatalog.getString('Email'), textAlign: 'center'},
            {field: 'Lakcim', headerText: gettextCatalog.getString('Location'), textAlign: 'center'},
            {field: 'Elerhetosege', headerText: gettextCatalog.getString('Elerhetosege'), textAlign: 'center'},
        ];
        vm.childGridColums = [
            {field: 'EszkozId', visible: false},
            {field: 'KiadvaId', visible: false},
            {field: 'EszkozMegnevezes', headerText: gettextCatalog.getString('Megnevezes'), textAlign: 'center'},
            {field: 'EszkozTipusa', headerText: gettextCatalog.getString('AssetType'), textAlign: 'center'},
            {field: 'EszkozLeiras', headerText: gettextCatalog.getString('Leiras'), textAlign: 'center'},
            {field: 'Azonosito', headerText: gettextCatalog.getString('Azonosito'), textAlign: 'center'},
            {field: 'Meret', headerText: gettextCatalog.getString('Meret'), textAlign: 'center'},
            {field: 'Ar', headerText: gettextCatalog.getString('Ar'), textAlign: 'center'}
        ];

        var grid = new ej2.grids.Grid({
            dataSource: [],
            allowSorting: true,
            columns: vm.columns,
            //pageSettings: $rootScope.pageSettings,
            toolbar: ['Print', 'Search'],
            childGrid: {
                dataSource: [],
                queryString: 'KiadvaId',
                allowPaging: true,
                columns: vm.childGridColums
            },
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        vm.ageGroupDataBound = ageGroupDataBound;
        vm.ageGroupSelect = ageGroupSelect;
        vm.searchTypeSelect = searchTypeSelect;
        vm.sectionDataBound = sectionDataBound;
        vm.searchTypeDateBound = searchTypeDateBound;
        vm.sectionSelect = sectionSelect;
        vm.show = show;

        activate();

        function activate() {
            $q.all([authenticationService.getRight('ESZKNYILVMEGT')]).then(function (data) {
                vm.ESZKNYILVMEGT = data[0];
                if (!vm.ESZKNYILVMEGT) {
                    log.permissionError(true);
                    return;
                }
                getSections();
                setDropDowns();
            });
        }

        function setDropDowns() {
            var promises = [paramHelper.getParams([], [
                'airbu.typeuser',
                'airbu.section',
                'airbu.agegroup'
            ])
            ];
            $q.all(promises).then(function (results) {
                vm.searchTypeUser = (results[0]['airbu.typeuser'] === true);
                vm.searchTypeAthlete = (results[0]['airbu.typeuser'] === false);
                vm.sectionId = results[0]['airbu.section'];
                vm.ageGroupId = results[0]['airbu.agegroup'];
            });
        }

        function searchTypeSelect(arg) {
            vm.chooseEnabled = false;
            switch (arg.value) {
                case 'athlete':
                    vm.searchTypeAthlete = true;
                    vm.searchTypeUser = false;
                    vm.dropdownlabel = gettextCatalog.getString('Section');
                    break;
                case 'users':
                    vm.searchTypeAthlete = false;
                    vm.searchTypeUser = true;
                    vm.dropdownlabel = gettextCatalog.getString('UserGroup');
                    break;
            }
        }

        function searchTypeDateBound() {
            if (vm.searchTypeUser) {
                angular.element('#searchType').ejDropDownList('selectItemByValue', vm.athletecoachList[1].value);
                vm.searchTypeAthlete = false;
                vm.searchTypeUser = true;
            } else {
                angular.element('#searchType').ejDropDownList('selectItemByValue', vm.athletecoachList[0].value);
                vm.searchTypeAthlete = true;
                vm.searchTypeUser = false;
            }
        }

        function getSections() {
            dataservice.sectionDropDownList(0, true)
                .then(function (data) {
                    if (data.itemsList && data.itemsList.length > 1) {
                        data.itemsList.unshift({value: 0, text: gettextCatalog.getString('All')});
                    }
                    vm.sectionList = data.itemsList;
                });
        }

        function sectionSelect(arg) {
            vm.sectionId = arg.value;
            vm.enableAgeGropu = true;
            getAgeGroups();
        }

        function getAgeGroups() {
            return dataservice.ageGroupDropDownList(vm.sectionId).then(function (data) {
                if (data.itemsList && data.itemsList.length > 1) {
                    data.itemsList.unshift({value: 0, text: gettextCatalog.getString('All')});
                }
                vm.ageGroupList = data.itemsList;
            });
        }

        function ageGroupDataBound() {
            if (vm.ageGroupId > 0) {
                angular.element('#ageGroupDropDown').ejDropDownList('selectItemByValue', vm.ageGroupId);
            } else {
                if (vm.ageGroupList && vm.ageGroupList.length === 1) {
                    vm.ageGroupId = vm.sectionList[0].value;
                    angular.element('#ageGroupDropDown').ejDropDownList('selectItemByValue', vm.ageGroupList[0].value);
                } else {
                    vm.ageGroupId = 0;
                    angular.element('#ageGroupDropDown').ejDropDownList('selectItemByValue', vm.ageGroupId);
                }
            }
        }

        function ageGroupSelect(args) {
            vm.ageGroupId = args.value;
        }

        function sectionDataBound() {
            if (vm.sectionId > 0) {
                angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.sectionId);
            } else {
                if (vm.sectionList && vm.sectionList.length === 1) {
                    vm.sectionId = vm.sectionList[0].value;
                    angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.sectionList[0].value);
                } else {
                    vm.sectionId = 0;
                    angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.sectionId);
                }
            }
        }

        function show() {
            paramHelper.setParams([
                {'airbu.typeuser': (vm.searchTypeUser == true)},
                {'airbu.section': vm.sectionId},
                {'airbu.agegroup': vm.ageGroupId},
            ]);
            dataservice.assetInventoryByPerson(vm.searchTypeUser, vm.searchTypeAthlete, vm.sectionId, vm.ageGroupId).then(function (data) {
                grid.dataSource = data.itemsList[0].Kiknel;
                var childdataSource = data.itemsList[0].EszkozAdatok;
                childdataSource = $filter('dateTimeStringFilter')(childdataSource, 'Kiadva');
                grid.childGrid.dataSource = $filter('dateTimeStringFilter')(childdataSource, 'Visszaveve');
            });
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.reports.assetInventoryReportByUsers')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'reports.assetInventoryReportByUsers',
                config: {
                    url: '/assetInventoryReportByUsers',
                    templateUrl: 'app/reports/assetInventoryReportByUsers/assetInventoryReportByUsers.html',
                    controller: 'AssetInventoryReportByUsersController',
                    controllerAs: 'vm',
                    title: 'AssetInventoryReportByUsers',
                    settings: {
                        navId: 312224,
                        level: 3,
                        order: 1,
                        orderTitle_hu: 'Eszköz nyilvántartó (Személy)',
                        orderTitle_en: 'Asset Inventory (Person)',
                        parentId: 2224,
                        content: 'AssetInventoryReportByUsers',
                        activatorPermission: '"ESZKNYILVMEGT"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.reports.assetInventoryReports')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'reports.assetInventoryReports',
                config: {
                    url: '/assetInventoryReports',
                    templateUrl: 'app/reports/assetInventoryReports/assetInventoryReports.html',
                    title: 'AssetInventoryReports',
                    settings: {
                        navId: 2224,
                        level: 2,
                        order: 22,
                        orderTitle_hu: 'Eszköz nyilvántartó',
                        orderTitle_en: 'Asset Inventory',
                        parentId: 4,
                        content: 'AssetManagement',
                        activatorPermission: ['"ESZKNYILVMEGT"']
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    AthleteTransferController.$inject = ["log", "dataservice", "$q", "$rootScope", "gettextCatalog", "paramHelper", "authenticationService", "$state", "$scope", "$filter"];
    angular
        .module('app.reports.athleteTransfer')
        .controller('AthleteTransferController2', AthleteTransferController);

    function AthleteTransferController(log, dataservice, $q, $rootScope, gettextCatalog, paramHelper, authenticationService, $state, $scope, $filter) {
        var vm = this; $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('AthleteTransfer');

        // Create variables
        vm.coachList = [];
        vm.sectionList = [];
        vm.dateToValue = new Date();
        vm.dateFromValue = new Date(new Date().setMonth(new Date().getMonth() - 6));
        // Grid's variables
        vm.columns = [
            {field: 'EdzoNeve', headerText: gettextCatalog.getString('Coach'), textAlign: 'left', width: 150, template: '#attrcolumnTemplate1'},
            {field: 'SportoloNeve', headerText: gettextCatalog.getString('Athlete'), textAlign: 'left', width: 150, template: '#columnTemplate2'},
            {field: 'Kerveny_Datum', headerText: gettextCatalog.getString('Kervenyezve'), textAlign: 'center', width: 150},
            {field: 'Elfogadva', type: 'boolean', displayAsCheckBox: true, headerText: gettextCatalog.getString('Accepted'), textAlign: 'center', width: 150},
            {field: 'Lezarva', type: 'boolean', displayAsCheckBox: true, headerText: gettextCatalog.getString('Closed'), textAlign: 'center', width: 150},
            {field: 'Lezarva_datum', headerText: gettextCatalog.getString('ClosedDate'), textAlign: 'center', width: 150},
            {field: 'KorcsoportValtas', type: 'boolean', displayAsCheckBox: true, headerText: gettextCatalog.getString('KorcsoportValtas'), textAlign: 'center', width: 150},
            {field: 'KerelmezoNeve', headerText: gettextCatalog.getString('Kervenyezo'), textAlign: 'center', width: 150},
        ];

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItems,
            allowPaging: true,
            allowSorting: true,
            allowTextWrap: true,
            allowExcelExport: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile(grid, $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        // Public functions
        vm.sectionSelect = sectionSelect;
        vm.sectionDataBound = sectionDataBound;
        vm.coachDataBound = coachDataBound;
        vm.search = search;
        vm.goToNewUser = goToNewUser;
        vm.goToNewAthlete = goToNewAthlete;

        // Activate page
        activate();

        function activate() {
            var promises = [authenticationService.getRight('KMEDZOVALTAS')];
            $q.all(promises).then(function (res) {
                if (!res[0]) {
                    log.permissionError(true);
                } else {
                    $q.all([authenticationService.getRight('KMEDZOVALTAS'), paramHelper.getParams([], ['athleteTransferList.coachId', 'athleteTransferList.szakosztalyId'])]).then(function (results) {
                        vm.KMEDZOVALTAS = results[0];
                        vm.sectionId = results[1]['athleteTransferList.szakosztalyId'] === null ? -1 : results[1]['athleteTransferList.szakosztalyId'];
                        vm.coachId = results[1]['athleteTransferList.coachId'] === null ? -1 : results[1]['athleteTransferList.coachId'];
                    });
                    getSections();
                    setDropDowns();
                }
            })
            .catch(function () {
                log.permissionError(true);
            });
        }

        function setDropDowns() {
            var promises = [paramHelper.getParams([], [
            'at.section',
            'at.coach'
            ])
            ];
            $q.all(promises).then(function (results) {
                vm.sectionId = results[0]['at.section'];
                vm.coachId = results[0]['at.coach'];
            });
        }

        // Get sections' list
        function getSections() {
            return dataservice.sectionDropDownList().then(function (data) {
                if (data.itemsList.length !== 1) {
                    data.itemsList.unshift({text: gettextCatalog.getString('All'), value: -1});
                }
                vm.sectionList = data.itemsList;
            });
        }

        // Run after data bounded
        function sectionDataBound() {
            if (vm.sectionList.length === 1) {
                angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.sectionList[0].value);
            } else {
                angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.sectionId);
            }
        }

        // Run after section selected
        function sectionSelect(args) {
            getActualCoachesList(args.value);
        }

        function getActualCoachesList(sectionId) {
            return dataservice.coachDropDownList(sectionId, 0).then(function (data) {
                if (data.itemsList.length !== 1) {
                    data.itemsList.unshift({text: gettextCatalog.getString('All'), value: -1});
                }
                vm.coachList = data.itemsList;
            });
        }

        // Run after data bounded
        function coachDataBound() {
            if (vm.coachList.length === 1) {
                angular.element('#coachDropDown').ejDropDownList('selectItemByValue', vm.coachList[0].value);
            } else {
                angular.element('#coachDropDown').ejDropDownList('selectItemByValue', vm.coachId);
            }
        }

        function search() {
            $scope.$broadcast('submitted');
            if ($scope.form.$valid === false) {
                log.errorMsg(gettextCatalog.getString('RequiredFieldsError'));
                return;
            }
            paramHelper.setParams([
            {'at.section': vm.sectionId},
            {'at.coach': vm.coachId}
            ]);
            dataservice.getAthleteTransferList(vm.sectionId, vm.coachId).then(function (data) {
                data.itemsList = $filter('dateStringFilter')(data.itemsList, 'EdzoLezartaDatum');
                data.itemsList = $filter('dateStringFilter')(data.itemsList, 'SzakosztalyVezetoJovahagyva');
                grid.dataSource = $filter('dateStringFilter')(data.itemsList, 'KeszitesDatum');
            });
        }

        function goToNewUser(edzoId) {
            paramHelper.setParams([{'newUser.userId': edzoId}]);
            $state.go('settings.userManagement.modifyUser');
        }

        function goToNewAthlete(id) {
            $q.all([authenticationService.getRight('MEGTSPORTLIST')]).then(function (results) {
                if (results[0]) {
                    paramHelper.setParams([{'athleteModify.sportoloId': id}]);
                    $state.go('athletes.athletesManagement.athleteModify.dataSheet');
                } else {
                    log.permissionError();
                }
            });
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.reports.athleteTransfer')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'reports.athleteTransfer',
                config: {
                    url: '/athleteTransfer',
                    templateUrl: 'app/reports/athleteTransfer/athleteTransfer.html',
                    controller: 'AthleteTransferController2',
                    controllerAs: 'vm',
                    title: 'AthleteTransfer',
                    settings: {
                        navId: 2124,
                        level: 2,
                        order: 12,
                        orderTitle_hu: 'Edzőváltás',
                        orderTitle_en: 'Change Coach',
                        parentId: 4,
                        content: 'AthleteTransfer',
                        activatorPermission: ['"KMEDZOVALTAS"']
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    AwayBudgetPlanSummary.$inject = ["log", "dataservice", "$q", "$rootScope", "gettextCatalog", "authenticationService", "$scope", "$filter", "paramHelper", "$state", "$timeout"];
    angular
        .module('app.reports.awayBudgetPlanSummary')
        .controller('AwayBudgetPlanSummaryController', AwayBudgetPlanSummary);

    function AwayBudgetPlanSummary(log, dataservice, $q, $rootScope, gettextCatalog, authenticationService, $scope, $filter, paramHelper, $state, $timeout) {
        var vm = this;
        $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('AwayBudgetPlanSummary');

        vm.sectionList = [];
        vm.sectionId = undefined;
        vm.ageGroupList = [];
        vm.ageGroupId = undefined;
        vm.coachList = [];
        vm.coachId = undefined;
        vm.colIndex = undefined;
        vm.rowindex = undefined;
        vm.toRange = undefined;
        vm.newRange = undefined;
        vm.fromRange = undefined;
        vm.onlyStartDate = false;
        vm.g = [];
        vm.selectdateFrom = getMonday(new Date(), 0);
        vm.selectdateTo = getMonday(new Date(), 6);
        vm.sectionDataBound = sectionDataBound;
        vm.sectionSelect = sectionSelect;
        vm.ageGroupDataBound = ageGroupDataBound;
        vm.ageGroupSelect = ageGroupSelect;
        vm.onlyStartDateChanged = onlyStartDateChanged;
        vm.coachDataBound = coachDataBound;
        vm.coachSelect = coachSelect;
        vm.openAthlete = openAthlete;
        vm.openCoach = openCoach;
        vm.show = show;

        vm.columns = [
            {
                visible: false
            },
            {
                field: 'VersenySorszam',
                headerText: gettextCatalog.getString('TervSorszam'),
                width: 90,
                textAlign: 'center'
            },
            {
                field: 'Szakosztaly',
                headerText: gettextCatalog.getString('Section'),
                width: 125,
                textAlign: 'center'
            },
            {
                field: 'NevHelyCsopRsz',
                headerText: gettextCatalog.getString('NevHelyCsopRsz'),
                width: 135,
                textAlign: 'center'
            },
            {
                field: 'VersenyKezdesIdopont',
                headerText: gettextCatalog.getString('RaceStartTime'),
                width: 150,
                textAlign: 'center'
            },
            {
                field: 'VersenyBefejezesIdopont',
                headerText: gettextCatalog.getString('RaceEndTime'),
                width: 150,
                textAlign: 'center'
            },
            {
                field: 'Megnevezes',
                headerText: gettextCatalog.getString('Appellation'),
                width: 150,
                textAlign: 'center'
            },
            {
                field: 'UtazasiKoltseg',
                headerText: gettextCatalog.getString('TravelCosts'),
                width: 130,
                textAlign: 'center'
            },
            {
                field: 'Etkezes',
                headerText: gettextCatalog.getString('Meal'),
                width: 120,
                textAlign: 'center'
            },
            {
                field: 'Szallas',
                headerText: gettextCatalog.getString('Accommodation'),
                width: 120,
                textAlign: 'center'
            },
            {
                field: 'NevezesiDij',
                headerText: gettextCatalog.getString('EntryFee'),
                width: 120,
                textAlign: 'center'
            },
            {
                field: 'KikuldetesiKoltseg',
                headerText: gettextCatalog.getString('DelegacyCost'),
                width: 120,
                textAlign: 'center'
            },
            {
                field: 'Egyeb',
                headerText: gettextCatalog.getString('Other'),
                width: 120,
                textAlign: 'center'
            },
            {
                field: 'Osszesen',
                headerText: gettextCatalog.getString('Total'),
                width: 120,
                textAlign: 'center'
            },
            {
                field: 'ElolegOsszege',
                headerText: gettextCatalog.getString('AmountOfAdvance'),
                width: 130,
                textAlign: 'center'
            },
        ];

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItems,
            allowPaging: true,
            pageSettings: $rootScope.pageSettings,
            allowTextWrap: true,
            allowSorting: false,
            allowExcelExport: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            enableHover: false,
            allowSelection: false,
            columns: vm.columns,
            rowTemplate: '#rowtemplate',
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile(grid, $scope);
                }
            },

        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        activate();

        function activate() {
            authenticationService.getRight('MEGTIDEGENKOLTSTERV').then(function (result) {
                if (result !== true) {
                    log.permissionError(true);
                } else {
                    getSections();
                    setDropDowns();
                }
            });
        }

        function setDropDowns() {
            var promises = [paramHelper.getParams([], [
                'awayBudgetPlanSummary.sectionId',
                'awayBudgetPlanSummary.ageGroupId',
                'awayBudgetPlanSummary.coachId',
                'awayBudgetPlanSummary.onlyStartDate',
            ])
            ];
            $q.all(promises).then(function (results) {
                vm.sectionId = results[0]['awayBudgetPlanSummary.sectionId'];
                vm.ageGroupId = results[0]['awayBudgetPlanSummary.ageGroupId'];
                vm.coachId = results[0]['awayBudgetPlanSummary.coachId'];
                if (results[0]['awayBudgetPlanSummary.onlyStartDate']) {
                    $timeout(function () {
                        angular.element('#onlyStartDate').ejCheckBox({checked: results[0]['awayBudgetPlanSummary.onlyStartDate']});
                        $scope.$apply();
                    }, 0);
                }
            });
        }

        function getSections() {
            dataservice.sectionDropDownList(0, true)
                .then(function (data) {
                    if (data.itemsList && data.itemsList.length > 1) {
                        data.itemsList.unshift({value: 0, text: gettextCatalog.getString('All')});
                    }
                    vm.sectionList = data.itemsList;
                });
        }

        // Run after data bounded
        function sectionDataBound() {
            if (vm.sectionList && vm.sectionList.length === 1) {
                angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.sectionList[0].value);
            } else {
                angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.sectionId);
            }
        }

        // Run after section selected
        function sectionSelect(args) {
            getAgeGroups(args.value);
            getActualCoachesList(0);
        }

        function getAgeGroups(sectionId) {
            return dataservice.ageGroupDropDownList(sectionId).then(function (data) {
                if (data.itemsList && data.itemsList.length !== 1) {
                    data.itemsList.unshift({text: gettextCatalog.getString('All'), value: 0});
                }
                vm.ageGroupList = data.itemsList;
            });
        }

        // Run after data bounded
        function ageGroupDataBound() {
            if (vm.ageGroupList && vm.ageGroupList.length === 1) {
                angular.element('#ageGroupDropDown').ejDropDownList('selectItemByValue', vm.ageGroupList[0].value);
            } else {
                angular.element('#ageGroupDropDown').ejDropDownList('selectItemByValue', vm.ageGroupId);
                if (vm.ageGroupId) {
                    getActualCoachesList(0);
                }
            }
        }

        // Run after age group selected
        function ageGroupSelect(args) {
            getActualCoachesList(args.value);
        }

        function getActualCoachesList(ageGroupId) {
            return dataservice.coachDropDownList(vm.sectionId, ageGroupId).then(function (data) {
                if (data.itemsList && data.itemsList.length !== 1) {
                    data.itemsList.unshift({text: gettextCatalog.getString('All'), value: 0});
                }
                vm.coachList = data.itemsList;
            });
        }

        // Run after data bounded
        function coachDataBound() {
            if (vm.coachList && vm.coachList.length === 1) {
                angular.element('#coachDropDown').ejDropDownList('selectItemByValue', vm.coachList[0].value);
            } else {
                angular.element('#coachDropDown').ejDropDownList('selectItemByValue', vm.coachId);
            }
        }

        // Run after age coach selected
        function coachSelect(args) {
            vm.coachId = args.value;
        }

        function getMonday(d, plusDay) {
            d = new Date(d);
            var day = d.getDay();
            var diff = d.getDate() - day + (day === 0 ? -6 : 1) + plusDay; // adjust when day is sunday
            return new Date(d.setDate(diff));
        }

        function show() {
            //vm.onlyStartDate = angular.element('#onlyStartDate').ejCheckBox('isChecked');
            $scope.$broadcast('submitted');
            if ($scope.form.$valid === false) {
                log.errorMsg(gettextCatalog.getString('RequiredFieldsError'));
                return;
            }
            paramHelper.setParams([
                {'awayBudgetPlanSummary.sectionId': vm.sectionId},
                {'awayBudgetPlanSummary.ageGroupId': vm.ageGroupId},
                {'awayBudgetPlanSummary.coachId': vm.coachId},
                {'awayBudgetPlanSummary.onlyStartDate': vm.onlyStartDate}
            ]);
            dataservice.KoltsegtervOsszesitoKimutatas(vm.sectionId, vm.ageGroupId, vm.coachId, vm.selectdateFrom, vm.selectdateTo, vm.onlyStartDate).then(function (data) {
                grid.dataSource = data.itemsList;
            });
        }

        function openAthlete(id) {
            $q.all([authenticationService.getRight('MEGTSPORTLIST')]).then(function (results) {
                if (results[0]) {
                    paramHelper.setParams([{'athleteModify.sportoloId': id}]);
                    $state.go('athletes.athletesManagement.athleteModify.dataSheet');
                } else {
                    log.permissionError();
                }
            });
        }

        function openCoach(edzoId) {
            $q.all([authenticationService.getRight('MODFELH'), authenticationService.getRight('MEGTFELH')]).then(function (results) {
                if (results[0] || results[1]) {
                    paramHelper.setParams([{'newUser.userId': edzoId}]);
                    $state.go('settings.userManagement.modifyUser');
                } else {
                    log.permissionError();
                }
            });
        }

        function onlyStartDateChanged(args) {
            $timeout(function () {
                vm.onlyStartDate = args.value;
                $scope.$apply();
            }, 100);
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.reports.awayBudgetPlanSummary')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'reports.awayBudgetPlanSummary',
                config: {
                    url: '/awayBudgetPlanSummary',
                    templateUrl: 'app/reports/awayBudgetPlanSummary/awayBudgetPlanSummary.html',
                    controller: 'AwayBudgetPlanSummaryController',
                    controllerAs: 'vm',
                    title: 'AwayBudgetPlanSummary',
                    settings: {
                        navId: 2174,
                        level: 2,
                        order: 17,
                        orderTitle_hu: 'Idegenbeli költségterv összesítő kimutatás',
                        orderTitle_en: 'Away Budget Plan Summary',
                        parentId: 4,
                        content: 'AwayBudgetPlanSummary',
                        activatorPermission: '"MEGTIDEGENKOLTSTERV"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.reports.centralReport')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'reports.centralReport',
                config: {
                    title: 'centralReport',
                    url: '/centralReport',
                    templateUrl: 'app/reports/centralReport/centralReport.html',
                    settings: {
                        navId: 234,
                        level: 2,
                        order: 3,
                        orderTitle_hu: 'Központi felmérők',
                        orderTitle_en: 'Central tests',
                        parentId: 4,
                        content: 'CentralReport',
                        activatorPermission: ['"MEGTKPFELM"']
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    CentralReportAllInController.$inject = ["dataservice", "$q", "log", "paramHelper", "authenticationService", "$rootScope", "gettextCatalog", "$scope", "$timeout"];
    angular
        .module('app.reports.centralReport.centralReportAllIn')
        .controller('CentralReportAllInController', CentralReportAllInController);

    function CentralReportAllInController(dataservice, $q, log, paramHelper, authenticationService, $rootScope, gettextCatalog, $scope, $timeout) {
        var vm = this;
        $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('CentralReportAllIn');
        vm.years = [];
        vm.yearsBirth = dataservice.range(1960, new Date().getFullYear());
        vm.sexList = [
            {text: gettextCatalog.getString('All'), value: 'allgender'},
            {text: gettextCatalog.getString('Male'), value: 'male'},
            {text: gettextCatalog.getString('Female'), value: 'female'}
        ];
        vm.sectionList = [];
        vm.columns = [
            {
                textAlign: 'center', columns: [
                {
                    field: 'EvFelmeresi',
                    headerText: gettextCatalog.getString('TestYear'),
                    textAlign: 'left',
                    width: 120
                }, {
                    field: 'TestResztvevo',
                    headerText: gettextCatalog.getString('Participants'),
                    textAlign: 'left',
                    width: 120
                }]
            }, {
                headerText: gettextCatalog.getString('Height'), textAlign: 'center', columns: [
                    //column: 'TestOsszAtlag, TestAtlag',
                    {
                        field: 'TestOsszAtlag',
                        headerText: gettextCatalog.getString('AverageHeightOfAthlete'),
                        textAlign: 'left',
                        width: 120
                    }, {
                        field: 'TestAtlag',
                        headerText: gettextCatalog.getString('AverageRank'),
                        textAlign: 'left',
                        width: 120
                    }]
            }, {
                headerText: gettextCatalog.getString('VerticalJump'), textAlign: 'center', columns: [
                    // column: 'SulypontOsszAtlag, SulypontAtlag',
                    {
                        field: 'SulypontOsszAtlag',
                        headerText: gettextCatalog.getString('AverageVerticalJumpOfAthlete'),
                        textAlign: 'left',
                        width: 120
                    }, {
                        field: 'SulypontAtlag',
                        headerText: gettextCatalog.getString('AverageRank'),
                        textAlign: 'left',
                        width: 120
                    }]
            }, {
                headerText: gettextCatalog.getString('30mSprint'), textAlign: 'center', columns: [
                    // column: 'SprintOsszAtlag, SprintAtlag',
                    {
                        field: 'SprintOsszAtlag',
                        headerText: gettextCatalog.getString('AverageSprintAthlete'),
                        textAlign: 'left',
                        width: 120
                    }, {
                        field: 'SprintAtlag',
                        headerText: gettextCatalog.getString('AverageRank'),
                        textAlign: 'left',
                        width: 120
                    }]
            }, {
                headerText: gettextCatalog.getString('2800mRunning'), textAlign: 'center', columns: [
                    // column: 'MeterOsszAtlagStr, MeterAtlagStr',
                    {
                        field: 'MeterOsszAtlagStr',
                        headerText: gettextCatalog.getString('Average2800mRunning'),
                        textAlign: 'left',
                        width: 120
                    }, {
                        field: 'MeterAtlagStr',
                        headerText: gettextCatalog.getString('AverageRank'),
                        textAlign: 'left',
                        width: 120
                    }]
            }];
        vm.summaryRows = [{
            title: gettextCatalog.getString('Average'),
            columns: [
                {
                    type: 'average',
                    field: 'TestResztvevo',
                    footerTemplate: '${average}',
                    format: 'N0'
                }, {
                    type: 'average',
                    field: 'TestOsszAtlag',
                    footerTemplate: '${average}',
                    format: 'N0'
                }, {
                    type: 'average',
                    field: 'TestAtlag',
                    footerTemplate: '${average}',
                    format: 'N0'
                }, {
                    type: 'average',
                    field: 'SulypontOsszAtlag',
                    footerTemplate: '${average}',
                    format: 'N0'
                }, {
                    type: 'average',
                    field: 'SulypontAtlag',
                    footerTemplate: '${average}',
                    format: 'N0'
                }, {
                    type: 'average',
                    field: 'SprintOsszAtlag',
                    footerTemplate: '${average}',
                    format: 'N0'
                }, {
                    type: 'average',
                    field: 'SprintAtlag',
                    footerTemplate: '${average}',
                    format: 'N0'
                }]
        }];

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItems,
            allowPaging: true,
            allowTextWrap: true,
            allowSorting: true,
            allowExcelExport: true,
            locale: 'hu-HU',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            aggregates: vm.summaryRows,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile(grid, $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        vm.clearYear = clearYear;
        vm.sectionSelect = sectionSelect;
        vm.sectionDataBound = sectionDataBound;
        vm.ageGroupSelect = ageGroupSelect;
        vm.ageGroupDataBound = ageGroupDataBound;
        vm.coachSelect = coachSelect;
        vm.coachDataBound = coachDataBound;
        vm.getData = getData;
        vm.sexSelect = sexSelect;
        vm.birthDateChange = birthDateChange;
        vm.selectedBirthDate = 0;
        vm.selectedAgeGroup = 0;
        vm.selectedCoach = 0;
        vm.selectedSection = 0;
        vm.coachList = [];
        vm.ageGroupList = [];

        activate();

        function activate() {
            var promises = [authenticationService.getRight('MEGTKPFELM')];
            $q.all(promises).then(function (res) {
                if (!res[0]) {
                    log.permissionError(true);
                } else {
                    getSections();
                    getFelmerokDatumaiDropDownList();
                    setDropDowns();
                }
            })
                .catch(function () {
                    log.permissionError(true);
                });
        }

        function setDropDowns() {
            var promises = [paramHelper.getParams([], [
                'centralReportAllIn.sectionId',
                'centralReportAllIn.ageGroupId',
                'centralReportAllIn.coachId',
                'centralReportAllIn.birthDate',
                'centralReportAllIn.sex'
            ])
            ];
            $q.all(promises).then(function (results) {
                $timeout(function () {
                    vm.selectedSection = results[0]['centralReportAllIn.sectionId'];
                    vm.selectedAgeGroup = results[0]['centralReportAllIn.ageGroupId'];
                    vm.selectedCoach = results[0]['centralReportAllIn.coachId'];
                    vm.selectedBirthDate = results[0]['centralReportAllIn.birthDate'];
                    angular.element('#gender').ejDropDownList('selectItemByValue', results[0]['centralReportAllIn.sex']);
                }, 0);
            });
        }

        function clearYear() {
            vm.selectedBirthDate = undefined;
            $('#BirthDate').ejDropDownList('clearText');
        }

        function getData() {
            paramHelper.setParams([
                {'centralReportAllIn.sectionId': vm.selectedSection},
                {'centralReportAllIn.ageGroupId': vm.selectedAgeGroup},
                {'centralReportAllIn.coachId': vm.selectedCoach},
                {'centralReportAllIn.birthDate': vm.selectedBirthDate},
                {'centralReportAllIn.sex': vm.sex},
            ]);
            dataservice.getCentralReportAllIn(vm.selectedSection, vm.selectedAgeGroup, vm.selectedCoach, vm.selectedBirthDate, vm.sex)
                .then(function (data) {
                    grid.dataSource = data.itemsList;
                });
        }

        function sectionSelect(data) {
            vm.selectedSection = data.value;
            getAgeGroups(data.value);
            getCoaches(data.value, 0);
        }

        function sectionDataBound() {
            if (vm.sectionList.length === 1) {
                angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.sectionList[0].value);
            } else {
                angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.selectedSection);
            }
        }

        function ageGroupSelect(args) {
            vm.selectedAgeGroup = args.value;
            getCoaches(vm.selectedSection, args.value);
        }

        function ageGroupDataBound() {
            if (vm.ageGroupList.length === 1) {
                angular.element('#ageGroupDropDown').ejDropDownList('selectItemByValue', vm.ageGroupList[0].value);
            } else {
                angular.element('#ageGroupDropDown').ejDropDownList('selectItemByValue', vm.selectedAgeGroup);
                if (vm.selectedAgeGroup) {
                    getCoaches(vm.selectedSection, 0);
                }
            }
        }

        function coachDataBound() {
            if (vm.coachList.length === 1) {
                angular.element('#coachName').ejDropDownList('selectItemByValue', vm.coachList[0].value);
            } else {
                angular.element('#coachName').ejDropDownList('selectItemByValue', vm.selectedCoach);
            }
        }

        function coachSelect(args) {
            vm.selectedCoach = args.value;
        }

        function getSections() {
            dataservice.sectionDropDownList(0, true)
                .then(function (data) {
                    data.itemsList.unshift({value: 0, text: gettextCatalog.getString('All')});
                    vm.sectionList = data.itemsList;
                });
        }

        function getAgeGroups(sectionId) {
            return dataservice.ageGroupDropDownList(sectionId)
                .then(function (data) {
                    vm.ageGroupList = data.itemsList;
                    if (data.itemsList.length > 1) {
                        var all = {value: 0, text: gettextCatalog.getString('All')};
                        vm.ageGroupList.splice(0, 0, all);
                    }
                });
        }

        function getCoaches(sectionId, ageGroupId) {
            if (!ageGroupId || ageGroupId == -1) {
                ageGroupId = 0;
            }
            return dataservice.coachDropDownList(sectionId, ageGroupId)
                .then(function (data) {
                    vm.coachList = data.itemsList;
                    if (data.itemsList.length > 1) {
                        var all = {value: 0, text: gettextCatalog.getString('All')};
                        vm.coachList.splice(0, 0, all);
                    }
                });
        }

        function getFelmerokDatumaiDropDownList() {
            dataservice.getFelmerokDatumaiDropDownList()
                .then(function (data) {
                    vm.years = data.itemsList;
                });
        }

        function sexSelect(args) {
            vm.sex = args.value;
        }

        function birthDateChange(args) {
            vm.selectedBirthDate = args.value;
        }
    }
})();


(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.reports.centralReport.centralReportAllIn')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'reports.centralReport.centralReportAllIn',
                config: {
                    url: '/centralReportAllIn',
                    templateUrl: 'app/reports/centralReport/centralReportAllIn/centralReportAllIn.html',
                    controller: 'CentralReportAllInController',
                    controllerAs: 'vm',
                    title: 'CentralReportAllIn',
                    settings: {
                        navId: 31234,
                        level: 3,
                        order: 1,
                        orderTitle_hu: 'Központi felmérők összesített kimutatás',
                        orderTitle_en: 'Central Tests Aggregate Report',
                        parentId: 234,
                        content: 'CentralReportAllIn',
                        activatorPermission: '"MEGTKPFELM"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    CentralReportByRatingController.$inject = ["log", "dataservice", "$q", "$rootScope", "gettextCatalog", "authenticationService", "$scope", "$filter", "paramHelper", "$state"];
    angular
        .module('app.reports.centralReport.centralReportByRating')
        .controller('CentralReportByRatingController', CentralReportByRatingController);

    function CentralReportByRatingController(log, dataservice, $q, $rootScope, gettextCatalog, authenticationService, $scope, $filter, paramHelper, $state) {
        var vm = this;
        $rootScope.vm = vm;
        vm.openAthlete = openAthlete;
        vm.openCoach = openCoach;
        $rootScope.title = gettextCatalog.getString('CentralReportByRating');
        vm.tests = [];
        vm.sexList = [
            {text: gettextCatalog.getString('AllGender'), value: 'all'},
            {text: gettextCatalog.getString('Male'), value: 'male'},
            {text: gettextCatalog.getString('Female'), value: 'female'}
        ];

        vm.columns = [{
            field: 'SportoloNeve',
            headerText: gettextCatalog.getString('Name'),
            textAlign: 'left',
            template: '#cerebyratemplateDataColumn1',
            width: 120
        }, {
            field: 'SportoloDatum',
            headerText: gettextCatalog.getString('BirthDate'),
            textAlign: 'left',
            width: 120
        }, {
            field: 'SzakosztalyNeve',
            headerText: gettextCatalog.getString('Section'),
            textAlign: 'left',
            width: 120
        }, {
            field: 'KorosztalyNeve',
            headerText: gettextCatalog.getString('AgeGroup'),
            textAlign: 'left',
            width: 120
        }, {
            field: 'EdzoNeve',
            headerText: gettextCatalog.getString('Coach'),
            textAlign: 'left',
            template: '#cerebyratemplateDataColumn2',
            width: 120
        }, {
            field: 'SulypontLegjobb',
            headerText: gettextCatalog.getString('Best') + ' ' + gettextCatalog.getString('VerticalJump'),
            textAlign: 'left',
            width: 120
        }, {
            field: 'SprintLegjobb',
            headerText: gettextCatalog.getString('Best') + ' ' + gettextCatalog.getString('30mSprint'),
            textAlign: 'left',
            width: 120
        }, {
            field: 'MeterLegjobbStr',
            headerText: gettextCatalog.getString('2800mRunning'),
            textAlign: 'left',
            width: 120
        }];

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItems,
            allowPaging: true,
            allowTextWrap: true,
            allowSorting: true,
            allowExcelExport: true,
            locale: 'hu-HU',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile(grid, $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        // Date picker
        vm.defaultDateTest = 0;
        vm.selectedDateTest = '';
        vm.dateTestList = [];

        // Coach
        vm.defaultCoach = 0;
        vm.selectedCoach = vm.defaultCoach;
        vm.coachList = [];

        // Szakosztály
        vm.defaultSection = 0;
        vm.selectedSection = vm.defaultSection;
        vm.sectionList = [];

        // korosztály
        vm.defaultAgeGroup = 0;
        vm.selectedAgeGroup = vm.defaultAgeGroup;
        vm.ageGroupList = [];

        // Felmérési szám
        vm.defaultTestNumber = 0;
        vm.selectedTestNumber = vm.defaultTestNumber;
        vm.testNumberList = [];
        vm.buttonEnabled = false;

        vm.testNumber = -1;
        vm.sex = 'all';
        vm.dateTestSelest = dateTestSelest;
        vm.dateTestDataBound = dateTestDataBound;
        vm.coachDataBound = coachDataBound;
        vm.coachSelect = coachSelect;
        vm.sectionDataBound = sectionDataBound;
        vm.sectionSelect = sectionSelect;
        vm.ageGroupDataBound = ageGroupDataBound;
        vm.ageGroupSelect = ageGroupSelect;

        vm.getData = getData;

        activate();

        function activate() {
            var promises = [authenticationService.getRight('MEGTKPFELM')];
            $q.all(promises).then(function (res) {
                if (!res[0]) {
                    log.permissionError(true);
                } else {
                    getFelmerokDatumai2DropDownList();
                    getSections();
                    setDropDowns();
                }
            })
                .catch(function () {
                    log.permissionError(true);
                });
        }

        function setDropDowns() {
            var promises = [paramHelper.getParams([], [
                'centralReportByRating.sectionId',
                'centralReportByRating.ageGroupId',
                'centralReportByRating.coachId',
                'centralReportByRating.sex',
                'centralReportByRating.selectedDateTest'
            ])
            ];
            $q.all(promises).then(function (results) {
                vm.defaultSection = results[0]['centralReportByRating.sectionId'];
                vm.defaultAgeGroup = results[0]['centralReportByRating.ageGroupId'];
                vm.defaultCoach = results[0]['centralReportByRating.coachId'];
                vm.sex = results[0]['centralReportByRating.sex'];
            });
        }

        function getSections() {
            return dataservice.sectionDropDownList(vm.selectedCoach, true)
                .then(function (data) {
                    if (data.itemsList.length > 1) {
                        data.itemsList.unshift({value: 0, text: gettextCatalog.getString('All')});
                    }
                    vm.sectionList = data.itemsList;
                });
        }

        function getAgeGroups(sectionId) {
            if (!sectionId || sectionId < 1) {
                sectionId = 0;
            }
            return dataservice.ageGroupDropDownList(sectionId)
                .then(function (data) {
                    vm.ageGroupList = data.itemsList;
                    if (data.itemsList.length > 1) {
                        var all = {value: 0, text: gettextCatalog.getString('All')};
                        vm.ageGroupList.splice(0, 0, all);
                    }
                });
        }

        function getCoaches(sectionId, ageGroupId) {
            if (!ageGroupId || ageGroupId == -1) {
                ageGroupId = 0;
            }
            return dataservice.coachDropDownList(sectionId, ageGroupId)
                .then(function (data) {
                    vm.coachList = data.itemsList;
                    if (data.itemsList.length > 1) {
                        var all = {value: 0, text: gettextCatalog.getString('All')};
                        vm.coachList.splice(0, 0, all);
                    }
                });
        }

        function sectionSelect(args) {
            getAgeGroups(args.value);
            getCoaches(args.value, 0);
        }

        function ageGroupSelect(args) {
            getCoaches(vm.selectedSection, args.value);
        }

        function coachSelect() {
            // vm.selectedCoach = args.value;
        }

        function dateTestSelest(arg) {
            vm.selectedDateTest = arg.text;
            vm.buttonEnabled = true;
        }

        function getData() {
            // a syncfusion direktívák miatt
            $scope.$broadcast('submitted');
            if ($scope.form.$valid === false) {
                log.errorMsg(gettextCatalog.getString('RequiredFieldsError'));
            } else {
                paramHelper.setParams([
                    {'centralReportByRating.sectionId': vm.selectedSection},
                    {'centralReportByRating.ageGroupId': vm.selectedAgeGroup},
                    {'centralReportByRating.coachId': vm.selectedCoach},
                    {'centralReportByRating.sex': vm.sex},
                ]);
                vm.selectedDateTest = angular.element('#datepickerTest').ejDropDownList('getSelectedItem')[0].innerText;
                return dataservice.centralReportByRating(vm.selectedSection, vm.selectedAgeGroup, vm.selectedCoach, vm.sex, vm.selectedDateTest)
                    .then(function (data) {
                        var dataSource = data.itemsList;
                        grid.dataSource = $filter('dateStringFilter')(dataSource, 'SportoloDatum');
                    });
            }
        }

        function openAthlete(id) {
            $q.all([authenticationService.getRight('MEGTSPORTLIST'), authenticationService.getRight('MEGTSPORTLIST')]).then(function (results) {
                if (results[0] || results[1]) {
                    paramHelper.setParams([{'athleteModify.sportoloId': id}]);
                    $state.go('athletes.athletesManagement.athleteModify.dataSheet');
                } else {
                    log.permissionError();
                }
            });
        }

        function openCoach(edzoId) {
            $q.all([authenticationService.getRight('MODFELH'), authenticationService.getRight('MEGTFELH')]).then(function (results) {
                if (results[0] || results[1]) {
                    paramHelper.setParams([{'newUser.userId': edzoId}]);
                    $state.go('settings.userManagement.modifyUser');
                } else {
                    log.permissionError();
                }
            });
        }

        function getFelmerokDatumai2DropDownList() {
            dataservice.getFelmerokDatumai2DropDownList()
                .then(function (data) {
                    vm.dateTestList = data.itemsList;
                });
        }

        function sectionDataBound() {
            if (vm.sectionList.length === 1) {
                angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.sectionList[0].value);
            } else {
                angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.defaultSection);
            }
        }

        function ageGroupDataBound() {
            if (vm.sectionList.length === 1) {
                angular.element('#ageGroupDropDown').ejDropDownList('selectItemByValue', vm.ageGroupList[0].value);
            } else {
                angular.element('#ageGroupDropDown').ejDropDownList('selectItemByValue', vm.defaultAgeGroup);
                if (vm.selectedAgeGroup) {
                    getCoaches(vm.selectedSection, 0);
                }
            }
        }

        function coachDataBound() {
            if (vm.coachList.length === 1) {
                angular.element('#coachName').ejDropDownList('selectItemByValue', vm.coachList[0].value);
            } else {
                angular.element('#coachName').ejDropDownList('selectItemByValue', vm.defaultCoach);
            }
        }

        function dateTestDataBound() {
            if (vm.dateTestList.length === 1) {
                angular.element('#datepickerTest').ejDropDownList('selectItemByValue', vm.dateTestList[0].value);
            } else {
                angular.element('#datepickerTest').ejDropDownList('selectItemByValue', vm.defaultdatepickerTest);
            }
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.reports.centralReport.centralReportByRating')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'reports.centralReport.centralReportByRating',
                config: {
                    url: '/centralReportByRating',
                    templateUrl: 'app/reports/centralReport/centralReportByRating/centralReportByRating.html',
                    controller: 'CentralReportByRatingController',
                    controllerAs: 'vm',
                    title: 'CentralReportByRating',
                    settings: {
                        navId: 32234,
                        level: 3,
                        order: 2,
                        orderTitle_hu: 'Központi felmérők ranglista kimutatás',
                        orderTitle_en: 'Central Test Ranking List Report',
                        parentId: 234,
                        content: 'CentralReportByRating',
                        activatorPermission: '"MEGTKPFELM"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    DuplicatedAthletesController.$inject = ["log", "dataservice", "$q", "$rootScope", "gettextCatalog", "authenticationService", "$filter", "$scope", "paramHelper", "$state"];
    angular
        .module('app.reports.duplicatedAthletes')
        .controller('DuplicatedAthletesController', DuplicatedAthletesController);

    function DuplicatedAthletesController(log, dataservice, $q, $rootScope, gettextCatalog, authenticationService, $filter, $scope, paramHelper, $state) {
        var vm = this; $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('DuplicatedAthletesByNameAndSSN');

        vm.columns = [
            {field: 'SportolokID', isPrimaryKey: true, visible: false},
            {field: 'Nev', headerText: gettextCatalog.getString('Name'), textAlign: 'left', width: 150, templat: '#duplicatedcolumnTemplate1'},
            {field: 'SzuletesiIdo', headerText: gettextCatalog.getString('Birthdate'), textAlign: 'left', width: 150},
            {field: 'AnyjaNeve', headerText: gettextCatalog.getString('MothersName'), textAlign: 'left', width: 150},
            {field: 'RegisztraciosSzam', headerText: gettextCatalog.getString('Regisztracios'), textAlign: 'center', width: 150},
            {field: 'TajSzam', headerText: gettextCatalog.getString('SocialSecurityNumber'), textAlign: 'center', width: 150},
            {field: 'EdzoNeve', headerText: gettextCatalog.getString('Coach'), textAlign: 'left', width: 150, template: '#duplicatedcolumnTemplate2'},
            {field: 'Aktiv', headerText: gettextCatalog.getString('Active'), type: 'boolean', textAlign: 'center', width: 100, displayAsCheckBox: true}
        ];

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItems,
            allowPaging: true,
            allowSorting: true,
            allowTextWrap: true,
            allowExcelExport: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile(grid, $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        vm.goToAthlete = goToAthlete;
        vm.goToUser = goToUser;
        vm.InactivesChange = InactivesChange;
        vm.InactivesToo = false;

        // Activate page
        activate();

        function activate() {
            authenticationService.getRight('DUPLIKALTMEGT').then(function (result) {
                if (result !== true) {
                    log.permissionError(true);
                } else {
                    getDuplicatedAthletes();
                }
            });
        }

        function InactivesChange(arg) {
            getDuplicatedAthletes(arg.value);
        }

        function getDuplicatedAthletes(inactivesToo) {
            if (inactivesToo !== true) {
                inactivesToo = false;
            }
            dataservice.getDuplicatedAthletes(inactivesToo).then(function(data) {
                grid.dataSource = $filter('dateStringFilter')(data.itemsList, 'SzuletesiIdo');
            });
        }

        function goToAthlete(id) {
            $q.all([authenticationService.getRight('MEGTSPORTLIST')]).then(function (results) {
                if (results[0]) {
                    paramHelper.setParams([{'athleteModify.sportoloId': id}]);
                    $state.go('athletes.athletesManagement.athleteModify.dataSheet');
                } else {
                    log.permissionError();
                }
            });
        }

        function goToUser(edzoId) {
            authenticationService.getRight('MEGTFELH').then(function (result) {
                if (result !== true) {
                    log.permissionError();
                    return;
                }
                paramHelper.setParams([{'newUser.userId': edzoId}]);
                $state.go('settings.userManagement.modifyUser');
            });
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.reports.duplicatedAthletes')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'reports.duplicatedAthletes',
                config: {
                    url: '/duplicatedAthletes',
                    templateUrl: 'app/reports/duplicatedAthletes/duplicatedAthletes.html',
                    controller: 'DuplicatedAthletesController',
                    controllerAs: 'vm',
                    title: 'DuplicatedAthletes',
                    settings: {
                        navId: 2134,
                        level: 2,
                        order: 13,
                        orderTitle_hu: 'Duplázott sportolók kimutatás',
                        orderTitle_en: 'Duplicated Athletes Report',
                        parentId: 4,
                        content: 'DuplicatedAthletes',
                        activatorPermission: '"DUPLIKALTMEGT"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    ExpiringDocumentsController.$inject = ["log", "dataservice", "$q", "$rootScope", "gettextCatalog", "paramHelper", "authenticationService", "$scope", "$filter", "$state"];
    angular
        .module('app.reports.expiringDocuments')
        .controller('ExpiringDocumentsController', ExpiringDocumentsController);

    function ExpiringDocumentsController(log, dataservice, $q, $rootScope, gettextCatalog, paramHelper, authenticationService, $scope, $filter, $state) {
        var vm = this;
        $rootScope.vm = vm;
        vm.params = [];
        $rootScope.title = gettextCatalog.getString('ExpiringDocuments');
        vm.searchSPC = true;
        vm.searchPP = true;
        vm.searchPID = true;
        vm.sectionList = [];
        vm.ageGroupList = [];
        vm.coachList = [];
        vm.search = search;
        vm.openCoach = openCoach;
        vm.openAthlete = openAthlete;
        vm.sectionDataBound = sectionDataBound;
        vm.sectionSelect = sectionSelect;
        vm.ageGroupDataBound = ageGroupDataBound;
        vm.ageGroupSelect = ageGroupSelect;
        vm.coachDataBound = coachDataBound;
        vm.coachSelect = coachSelect;
        vm.selectdateTo = new Date(new Date().getFullYear(), new Date().getMonth() + 1);
        vm.SelectedSectionID = 0;
        vm.SelectedAgeGroupID = 0;
        vm.SelectedCoachID = 0;

        vm.columns = [
            {
                field: 'SportoloNeve',
                headerText: gettextCatalog.getString('Athlete'),
                textAlign: 'center',
                width: 120,
                template: '#exdotemplateDataColumn1'
            },
            {
                field: 'SportorvosiLejar',
                headerText: gettextCatalog.getString('SportPhysicalCertificateExpirationDate'),
                textAlign: 'left',
                width: 250
            },
            {
                field: 'UtlevelLejar',
                headerText: gettextCatalog.getString('PassportExpirationDate'),
                textAlign: 'left',
                width: 180
            },
            {
                field: 'SzemelyiLejar',
                headerText: gettextCatalog.getString('PersonalIDExpirationDate'),
                textAlign: 'left',
                width: 180
            },
            {
                field: 'SzakosztalyNeve',
                headerText: gettextCatalog.getString('Section'),
                textAlign: 'center',
                width: 125
            },
            {
                field: 'KorosztalyNeve',
                headerText: gettextCatalog.getString('AgeGroup'),
                textAlign: 'center',
                width: 120
            },
            {
                field: 'EdzoNeve',
                headerText: gettextCatalog.getString('Coach'),
                textAlign: 'center',
                width: 120,
                template: '#exdotemplateDataColumn2'
            }
        ];

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItems,
            allowPaging: true,
            allowTextWrap: true,
            allowSorting: true,
            allowExcelExport: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile(grid, $scope);
                }
            },
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        activate();

        function activate() {
            var promises = [authenticationService.getRight('LEJAROMEGT')];
            $q.all(promises).then(function (res) {
                if (!res[0]) {
                    log.permissionError(true);
                } else {
                    getSections();
                    getAgeGroups();
                    getCoaches();
                    setDropDowns();
                }
            })
                .catch(function () {
                    log.permissionError(true);
                });
        }

        function setDropDowns() {
            var promises = [paramHelper.getParams([], [
                'ed.section',
                'ed.agegroup',
                'ed.coach',
                'ed.to'
            ])
            ];
            $q.all(promises).then(function (results) {
                if (results[0]['ed.to'] != null) {
                    vm.selectdateTo = results[0]['ed.to'];
                    vm.savedSection = results[0]['ed.section'];
                    vm.savedAgegroup = results[0]['ed.agegroup'];
                    vm.savedCoach = results[0]['ed.coach'];
                }
            });
        }

        function search() {
            if (!vm.searchSPC && !vm.searchPP && !vm.searchPID) {
                swal({
                    title: gettextCatalog.getString('AtLeastOneConditionHaveToBeSelected'),
                    type: 'warning',
                    confirmButtonColor: '#DD6B55',
                    confirmButtonText: gettextCatalog.getString('Ok'),
                });
                return;
            }
            paramHelper.setParams([
                {'ed.section': vm.SelectedSectionID},
                {'ed.agegroup': vm.SelectedAgeGroupID},
                {'ed.coach': vm.SelectedCoachID},
                {'ed.to': vm.selectdateTo}
            ]);
            dataservice.getExpiringDocuments(vm.SelectedSectionID, vm.SelectedAgeGroupID, vm.SelectedCoachID, vm.selectdateTo, vm.searchSPC, vm.searchPP, vm.searchPID)
                .then(function (data) {
                    var athleteList = data.itemsList;
                    athleteList = $filter('dateStringFilter')(data.itemsList, 'SportorvosiLejar');
                    grid.dataSource = $filter('dateStringFilter')(athleteList, 'UtlevelLejar');
                });
        }

        function sectionSelect(args) {
            vm.SelectedCoachID = 0;
            vm.SelectedAgeGroupID = 0;
            vm.SelectedSectionID = args.value;
            if (args.value == -1) {
                vm.SelectedSectionID = 0;
            }
            getActualCoachesList();
            getAgeGroups();
            getTeamsList();
            vm.showDelButton = false;
        }

        function ageGroupSelect(args) {
            vm.SelectedCoachID = 0;
            vm.SelectedAgeGroupID = args.value;
            if (args.value == -1) {
                vm.SelectedAgeGroupID = 0;
            }
            getActualCoachesList();
            getTeamsList();
            vm.showDelButton = false;
        }

        function coachSelect(args) {
            vm.SelectedCoachID = args.value;
            if (args.value == -1) {
                vm.SelectedCoachID = 0;
            }
            vm.showDelButton = false;
        }

        function getSections() {
            dataservice.sectionDropDownList(0)
                .then(function (data) {
                    vm.sectionList = data.itemsList;
                    if (data.itemsList.length > 1) {
                        var all = {value: -1, text: gettextCatalog.getString('All')};
                        vm.sectionList.splice(0, 0, all);
                    }
                });
        }

        function getAgeGroups() {
            dataservice.ageGroupDropDownList(vm.SelectedSectionID)
                .then(function (data) {
                    vm.ageGroupList = data.itemsList;
                    var all = {value: -1, text: gettextCatalog.getString('All')};
                    vm.ageGroupList.splice(0, 0, all);
                });
        }

        function getActualCoachesList() {
            return dataservice.coachDropDownList(vm.SelectedSectionID, vm.SelectedAgeGroupID, new Date(2000, 1, 1), vm.selectdateTo)
                .then(function (data) {
                    vm.coachList = data.itemsList;
                    var all = {value: -1, text: gettextCatalog.getString('All')};
                    vm.coachList.splice(0, 0, all);
                });
        }

        function getCoaches() {
            return dataservice.coachSelect().then(
                function (data) {
                    vm.coachList = data.itemsList;
                    return vm.coachList;
                }
            );
        }

        function getTeamsList() {
            dataservice.teamsDropDownList(vm.SelectedSectionID, vm.SelectedAgeGroupID, vm.SelectedCoachID)
                .then(function (data) {
                    vm.teamsList = data.itemsList;
                    if (data.itemsList.length > 1) {
                        var all = {value: -1, text: gettextCatalog.getString('All')};
                        vm.teamsList.splice(0, 0, all);
                    }
                });
        }

        function openAthlete(id) {
            $q.all([authenticationService.getRight('MEGTSPORTLIST')]).then(function (results) {
                if (results[0]) {
                    paramHelper.setParams([{'athleteModify.sportoloId': id}]);
                    $state.go('athletes.athletesManagement.athleteModify.dataSheet');
                } else {
                    log.permissionError();
                }
            });
        }

        function openCoach() {
            $q.all([authenticationService.getRight('MODFELH'), authenticationService.getRight('MEGTFELH')]).then(function (results) {
                if (results[0] || results[1]) {
                    paramHelper.setParams([{'newUser.userId': 0}]);
                    $state.go('settings.userManagement.modifyUser');
                } else {
                    log.permissionError();
                }
            });
        }

        function sectionDataBound() {
            if (vm.savedSection > 0) {
                angular.element('#section').ejDropDownList('selectItemByValue', vm.savedSection);
            } else {
                if (vm.sectionList.length === 1) {
                    angular.element('#section').ejDropDownList('selectItemByValue', vm.sectionList[0]);
                } else if (vm.SelectedSectionID > 0) {
                    angular.element('#section').ejDropDownList('selectItemByValue', vm.SelectedSectionID);
                }
            }
        }

        function ageGroupDataBound() {
            if (vm.savedAgegroup > 0) {
                angular.element('#agegroup').ejDropDownList('selectItemByValue', vm.savedAgegroup);
            } else {
                if (vm.ageGroupList.length === 1) {
                    angular.element('#agegroup').ejDropDownList('selectItemByValue', vm.ageGroupList[0].value);
                } else if (vm.SelectedAgeGroupID > 0) {
                    angular.element('#agegroup').ejDropDownList('selectItemByValue', vm.SelectedAgeGroupID);
                }
            }
        }

        function coachDataBound() {
            if (vm.savedCoach > 0) {
                angular.element('#coach').ejDropDownList('selectItemByValue', vm.savedCoach);
            } else {
                if (vm.coachList.length === 1) {
                    angular.element('#coach').ejDropDownList('selectItemByValue', vm.coachList[0].value);
                } else if (vm.SelectedCoachID > 0) {
                    angular.element('#coach').ejDropDownList('selectItemByValue', vm.SelectedCoachID);
                }
            }
        }
    }
})();


(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.reports.expiringDocuments')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'reports.expiringDocuments',
                config: {
                    url: '/expiringDocuments',
                    templateUrl: 'app/reports/expiringDocuments/expiringDocuments.html',
                    controller: 'ExpiringDocumentsController',
                    controllerAs: 'vm',
                    title: 'ExpiringDocuments',
                    settings: {
                        navId: 2154,
                        level: 2,
                        order: 15,
                        orderTitle_hu: 'Hamarosan lejáró dokumentumok, igazolások',
                        orderTitle_en: 'Expiring documents and certificates',
                        parentId: 4,
                        content: 'ExpiringDocuments',
                        activatorPermission: '"LEJAROMEGT"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    HealthReportController.$inject = ["log", "dataservice", "$q", "$rootScope", "gettextCatalog", "authenticationService", "$scope", "$filter", "paramHelper", "$state"];
    angular
        .module('app.reports.healthReport')
        .controller('HealthReportController', HealthReportController);

    function HealthReportController(log, dataservice, $q, $rootScope, gettextCatalog, authenticationService, $scope, $filter, paramHelper, $state) {
        var vm = this;
        $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('HealthReport');
        vm.selectdateFrom = new Date(new Date().getFullYear(), new Date().getMonth() - 1);
        vm.selectdateTo = new Date();
        vm.mainType = -1;
        vm.subType = -1;
        vm.sectionList = [];
        vm.ageGroupList = [];
        vm.coachList = [];
        vm.healthMainType = [];
        vm.healthSubType = [];
        vm.filteredSubTypes = [];
        vm.sectionDataBound = sectionDataBound;
        vm.sectionSelect = sectionSelect;
        vm.ageGroupDataBound = ageGroupDataBound;
        vm.ageGroupSelect = ageGroupSelect;
        vm.coachDataBound = coachDataBound;
        vm.coachSelect = coachSelect;
        vm.openAthlete = openAthlete;
        vm.openCoach = openCoach;
        vm.show = show;
        vm.MainTypeSelect = MainTypeSelect;
        vm.mainTypeDataBound = mainTypeDataBound;
        vm.subTypeDataBound = subTypeDataBound;
        vm.goToModifyHealthEvent = goToModifyHealthEvent;
        vm.changeDateFrom = changeDateFrom;
        vm.changeDateTo = changeDateTo;

        vm.columns = [
            {field: 'Link', headerText: '', textAlign: 'center', width: 60, template: '#healthedit'},
            {field: 'SportoloNev', headerText: gettextCatalog.getString('Name'), textAlign: 'left', width: 120},
            {field: 'SzuletesiIdo', headerText: gettextCatalog.getString('BirthDate'), textAlign: 'left', width: 120},
            {field: 'KorcsoportNeve', headerText: gettextCatalog.getString('AgeGroup'), textAlign: 'left', width: 120},
            {field: 'EdzokNeve', headerText: gettextCatalog.getString('Coaches'), textAlign: 'left', width: 120},
            {field: 'MettolMeddig', headerText: gettextCatalog.getString('TimeInterval'), textAlign: 'left', width: 120},
            {field: 'FoTipus', headerText: gettextCatalog.getString('MainType'), textAlign: 'left', width: 120},
            {field: 'AlTipus', headerText: gettextCatalog.getString('SubType'), textAlign: 'left', width: 120}
        ];

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItems,
            allowPaging: true,
            allowSorting: true,
            allowTextWrap: true,
            allowExcelExport: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            beforePrint: $rootScope.beforePrintGrid,
            printComplete: $rootScope.printCompleteGrid,

            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile(grid, $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        activate();

        function activate() {
            authenticationService.getRight('HEALTHREPORT').then(function (result) {
                if (result !== true) {
                    log.permissionError(true);
                } else {
                    getSections();
                    getHealthMainTypes();
                    getHealthSubTypes();
                    setDropDowns();
                }
            });
        }

        function setDropDowns() {
            var promises = [paramHelper.getParams([], [
                'hr.section',
                'hr.agegroup',
                'hr.coach',
                'hr.from',
                'hr.to',
                'hr.main',
                'hr.sub'
            ])
            ];
            $q.all(promises).then(function (results) {
                vm.sectionId = results[0]['hr.section'];
                vm.ageGroupId = results[0]['hr.agegroup'];
                vm.coachId = results[0]['hr.coach'];
                vm.selectdateFrom = results[0]['hr.from'];
                vm.selectdateTo = results[0]['hr.to'];
                if (results[0]['hr.main']) {
                    vm.mainType = results[0]['hr.main'];
                }
                if (results[0]['hr.sub']) {
                    vm.subType = results[0]['hr.sub'];
                }
            });
        }

        function goToModifyHealthEvent(arg) {
            vm.selectedGridRow = ej.DataManager(grid.dataSource).executeLocal(new ej.Query().where('EgeszsegEsetId', 'equal', arg))[0];
            console.log('selectedGridRow', selectedGridRow);
            paramHelper.setParams([{
                'athleteModify.sportoloId': vm.selectedGridRow.SportoloId,
                'mofifyHealthAthleteId': vm.selectedGridRow.SportoloId,
                'mofifyHealthAthleteName': vm.selectedGridRow.SportoloNev,
                'mofifyHealthAthleteSocialSecurity': vm.selectedGridRow.taj,
                'mofifyHealthAthleteBirthDate': vm.selectedGridRow.SzuletesiIdo,
                'mofifyHealthId': vm.selectedGridRow.EgeszsegEsetId,
                'mofifyHealthKezeles': vm.selectedGridRow.kezeles,
                'mofifyHealthLeiras': vm.selectedGridRow.leiras,
                'mofifyHealthLetrehozas': vm.selectedGridRow.Letrehozas,
                'mofifyHealthMettol': vm.selectedGridRow.Mettol,
                'mofifyHealthMeddig': vm.selectedGridRow.Meddig,
                'mofifyHealthTipus': vm.selectedGridRow.FoTipus,
                'mofifyHealthAlTipus': vm.selectedGridRow.AlTipus,
                'fromState': 'report',
            }]);
            $state.go('athletes.athletesManagement.athleteModify.health.modifyHealthEvent');
        }

        function MainTypeSelect(arg) {
            var mainKey = vm.healthMainType.filter(function (MainType) {
                return MainType.text === arg.text;
            });
            if (mainKey[0] != undefined) {
                vm.filteredSubTypes = [];
                for (var i = 0; i < vm.healthSubType.length; i++) {
                    if (vm.healthSubType[i].Fotipus === mainKey[0].value) {
                        vm.filteredSubTypes.push(vm.healthSubType[i]);
                    }
                }
            }
        }

        function getHealthMainTypes() {
            dataservice.healthMainTypesList().then(function (response) {
                vm.healthMainType.push({text: gettextCatalog.getString('All'), value: -1});
                for (var i = 0; i < response.itemsList.length; i++) {
                    vm.healthMainType.push({text: response.itemsList[i].Nev, value: response.itemsList[i].Id});
                }
            });
        }

        function getHealthSubTypes() {
            dataservice.healthSubTypesList().then(function (response) {
                for (var i = 0; i < response.itemsList.length; i++) {
                    vm.healthSubType.push({
                        text: response.itemsList[i].AltipusNev,
                        value: response.itemsList[i].Id,
                        Fotipus: response.itemsList[i].FotipusId
                    });
                }
            });
        }

        function show() {
            $scope.$broadcast('submitted');
            if ($scope.form.$valid === false) {
                log.errorMsg(gettextCatalog.getString('RequiredFieldsError'));
                return;
            }
            paramHelper.setParams([
                {'hr.section': vm.sectionId},
                {'hr.agegroup': vm.ageGroupId},
                {'hr.coach': vm.coachId},
                {'hr.from': vm.selectdateFrom},
                {'hr.to': vm.selectdateTo},
                {'hr.main': vm.mainType},
                {'hr.sub': vm.subType}
            ]);
            dataservice.HealthReport(vm.selectdateFrom, vm.selectdateTo, vm.sectionId, vm.ageGroupId, vm.coachId, vm.mainType, vm.subType).then(function (data) {
                grid.dataSource = $filter('dateStringFilter')(data.itemsList, 'SzuletesiIdo');
            });
        }

        function openAthlete(id) {
            $q.all([authenticationService.getRight('MEGTSPORTLIST')]).then(function (results) {
                if (results[0]) {
                    paramHelper.setParams([{'athleteModify.sportoloId': id}]);
                    $state.go('athletes.athletesManagement.athleteModify.dataSheet');
                } else {
                    log.permissionError();
                }
            });
        }

        function openCoach(edzoId) {
            $q.all([authenticationService.getRight('MODFELH'), authenticationService.getRight('MEGTFELH')]).then(function (results) {
                if (results[0] || results[1]) {
                    paramHelper.setParams([{'newUser.userId': edzoId}]);
                    $state.go('settings.userManagement.modifyUser');
                } else {
                    log.permissionError();
                }
            });
        }

        function getSections() {
            return dataservice.sectionDropDownList(0, true).then(function (data) {
                vm.sectionList = data.itemsList;
                vm.sectionList.unshift({value: 0, text: gettextCatalog.getString('All')});
            });
        }

        function sectionDataBound() {
            if (vm.sectionList.length === 1) {
                vm.sectionId = vm.sectionList[0].value;
                angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.sectionList[0].value);
            } else {
                angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.sectionId);
            }
        }

        function sectionSelect(args) {
            vm.sectionId = args.value;
            vm.coachList = [];
            getAgeGroups();
        }

        function getAgeGroups() {
            return dataservice.ageGroupDropDownList(vm.sectionId).then(function (data) {
                if (data.itemsList.length !== 1) {
                    data.itemsList.unshift({text: gettextCatalog.getString('All'), value: -1});
                }
                vm.ageGroupList = data.itemsList;
            });
        }

        function ageGroupDataBound() {
            if (vm.ageGroupList.length === 1) {
                angular.element('#ageGroupDropDown').ejDropDownList('selectItemByValue', vm.ageGroupList[0].value);
            } else {
                angular.element('#ageGroupDropDown').ejDropDownList('selectItemByValue', vm.ageGroupId);
                if (vm.ageGroupId) {
                    getActualCoachesList(-1);
                }
            }
        }

        function mainTypeDataBound() {
            if (vm.ageGroupList.length === 1) {
                angular.element('#MainTypeDropDown').ejDropDownList('selectItemByValue', vm.healthMainType[0].value);
            } else {
                angular.element('#MainTypeDropDown').ejDropDownList('selectItemByValue', vm.mainType);
            }
        }

        function subTypeDataBound() {
            if (vm.ageGroupList.length === 1) {
                angular.element('#SubTypeDropDown').ejDropDownList('selectItemByValue', vm.filteredSubTypes[0].value);
            } else {
                angular.element('#SubTypeDropDown').ejDropDownList('selectItemByValue', vm.subType);
            }
        }

        function ageGroupSelect(args) {
            vm.ageGroupId = args.value;
            getActualCoachesList(args.value);
        }

        function getActualCoachesList(ageGroupId) {
            return dataservice.coachDropDownList(vm.sectionId, ageGroupId, vm.selectdateFrom, vm.selectdateTo).then(function (data) {
                if (data.itemsList.length !== 1) {
                    data.itemsList.unshift({text: gettextCatalog.getString('All'), value: -1});
                }
                vm.coachList = data.itemsList;
            });
        }

        function coachDataBound() {
            if (vm.coachList.length === 1) {
                angular.element('#coachDropDown').ejDropDownList('selectItemByValue', vm.coachList[0].value);
            } else {
                angular.element('#coachDropDown').ejDropDownList('selectItemByValue', vm.coachId);
            }
        }

        function coachSelect(args) {
            vm.coachId = args.value;
        }

        function changeDateFrom(args) {
            vm.selectdateFrom = args.value;
            getActualCoachesList(vm.ageGroupId);
        }

        function changeDateTo(args) {
            vm.selectdateTo = args.value;
            getActualCoachesList(vm.ageGroupId);
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.reports.healthReport')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'reports.healthReport',
                config: {
                    url: '/healthReport',
                    templateUrl: 'app/reports/healthReport/healthReport.html',
                    controller: 'HealthReportController',
                    controllerAs: 'vm',
                    title: 'HealthReport',
                    settings: {
                        navId: 2184,
                        level: 2,
                        order: 18,
                        orderTitle_hu: 'Egészségügyi adatok',
                        orderTitle_en: 'Health Data',
                        parentId: 4,
                        content: 'HealthReport',
                        activatorPermission: '"HEALTHREPORT"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    AnnualCompetitivePlansController.$inject = ["log", "dataservice", "$q", "$rootScope", "gettextCatalog", "paramHelper", "authenticationService", "$state", "$scope", "$filter"];
    angular
        .module('app.reports.managementReports.annualCompetitivePlans')
        .controller('AnnualCompetitivePlansController', AnnualCompetitivePlansController);

    function AnnualCompetitivePlansController(log, dataservice, $q, $rootScope, gettextCatalog, paramHelper, authenticationService, $state, $scope, $filter) {
        var vm = this; $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('AnnualCompetitivePlans');

        // Create variables
        vm.params = [];
        vm.sectionId = -1;
        vm.coachId = -1;
        vm.coachList = [];
        vm.sectionList = [];
        vm.dateToValue = new Date();
        vm.dateFromValue = new Date(new Date().setMonth(new Date().getMonth() - 6));
        // Grid's variables
        vm.columns = [
            {field: 'Link', headerText: '', template: '#ancoplcolumnTemplate1', textAlign: 'center', width: 60},
            {field: 'Egyeni', headerText: gettextCatalog.getString('Individual'), textAlign: 'center', width: 150, displayAsCheckBox: true},
            {field: 'SzakosztalyNeve', headerText: gettextCatalog.getString('Section'), textAlign: 'left', width: 150, template: '#ancopfiltersection'},
            {field: 'KorcsoportNeve', headerText: gettextCatalog.getString('AgeGroup'), textAlign: 'left', width: 150},
            {field: 'EdzoNeve', headerText: gettextCatalog.getString('Coach'), textAlign: 'left', width: 150, template: '#ancopopencoach'},
            {field: 'KeszitesDatum', headerText: gettextCatalog.getString('Date'), textAlign: 'left', width: 150},
            {field: 'EdzoLezarta', type: 'boolean', headerText: gettextCatalog.getString('Closed'), textAlign: 'center', width: 150, displayAsCheckBox: true},
            {field: 'EdzoLezartaDatum', headerText: gettextCatalog.getString('ClosedDate'), textAlign: 'left', width: 150},
            {field: 'SzakosztalyVezetoJovahagyta', type: 'boolean', headerText: gettextCatalog.getString('SectionLeaderSigned'), textAlign: 'center', width: 150, displayAsCheckBox: true},
            {field: 'SzakosztalyVezetoJovahagyva', headerText: gettextCatalog.getString('SectionLeaderSignedDate'), textAlign: 'left', width: 150}
        ];

        // Public functions
        vm.sectionSelect = sectionSelect;
        vm.sectionDataBound = sectionDataBound;
        vm.coachDataBound = coachDataBound;
        vm.search = search;
        vm.goToAnnualSeasonPlan = goToAnnualSeasonPlan;
        vm.openCoach = openCoach;
        vm.filterSection = filterSection;
        vm.coachSelect = coachSelect;
        vm.dateFromChange = dateFromChange;
        vm.dateToChange = dateToChange;

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItems,
            allowPaging: true,
            allowTextWrap: true,
            allowSorting: true,
            allowExcelExport: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            beforePrint: $rootScope.beforePrintGrid,
            printComplete: $rootScope.printCompleteGrid,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#Grid'), $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        // Activate page
        activate();

        function activate() {
            authenticationService.getRight('VEZETOIEV').then(function (result) {
                if (result !== true) {
                    log.permissionError(true);
                } else {
                    $q.all([authenticationService.getRight('MEGTEVVERST'), paramHelper.getParams([], ['annualCompetitivePlans.coachId', 'annualCompetitivePlans.sectionId', 'managementReports.annualCompetitivePlans.dateFrom', 'managementReports.annualCompetitivePlans.dateTo'])]).then(function (results) {
                        vm.MEGTEVVERST = results[0];
                        vm.dateFromValue = results[1]['managementReports.annualCompetitivePlans.dateFrom'] ? results[1]['managementReports.annualCompetitivePlans.dateFrom'] : vm.dateFromValue;
                        vm.dateToValue = results[1]['managementReports.annualCompetitivePlans.dateTo'] ? results[1]['managementReports.annualCompetitivePlans.dateTo'] : vm.dateToValue;
                        vm.params = results[1];
                    });
                    getSections();
                }
            });
        }

        // Get sections' list
        function getSections() {
            return dataservice.sectionDropDownList(0, true).then(function (data) {
                if (data.itemsList.length !== 1) {
                    data.itemsList.unshift({text: gettextCatalog.getString('All'), value: -1});
                }
                vm.sectionList = data.itemsList;
            });
        }

        // Run after data bounded
        function sectionDataBound() {
            if (vm.params['annualCompetitivePlans.sectionId']) {
                angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.params['annualCompetitivePlans.sectionId']);
                vm.params['annualCompetitivePlans.sectionId'] = null;
            } else if (vm.sectionList.length === 1) {
                angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.sectionList[0].value);
            } else {
                angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.sectionId);
            }
        }

        // Run after section selected
        function sectionSelect(args) {
            getActualCoachesList(args.value);
        }

        function filterSection(id) {
            vm.sectionId = id;
            search();
        }

        function getActualCoachesList(sectionId) {
            return dataservice.coachDropDownList(sectionId, 0, vm.dateFromValue, vm.dateToValue).then(function (data) {
                if (data.itemsList.length !== 1) {
                    data.itemsList.unshift({text: gettextCatalog.getString('All'), value: -1});
                }
                vm.coachList = data.itemsList;
            });
        }

        // Run after data bounded
        function coachDataBound() {
            if (vm.params['annualCompetitivePlans.coachId']) {
                angular.element('#coachDropDown').ejDropDownList('selectItemByValue', vm.params['annualCompetitivePlans.coachId']);
                vm.params['annualCompetitivePlans.coachId'] = null;
            } else if (vm.coachList.length === 1) {
                angular.element('#coachDropDown').ejDropDownList('selectItemByValue', vm.coachList[0].value);
            } else {
                angular.element('#coachDropDown').ejDropDownList('selectItemByValue', vm.coachId);
            }
        }

        function openCoach(edzoId) {
            $q.all([authenticationService.getRight('MODFELH'), authenticationService.getRight('MEGTFELH')]).then(function (results) {
                if (results[0] || results[1]) {
                    paramHelper.setParams([{'newUser.userId': edzoId}]);
                    $state.go('settings.userManagement.modifyUser');
                } else {
                    log.permissionError();
                }
            });
        }

        function coachSelect(args) {
            vm.coachId = args.value;
            search();
        }

        function search() {
            // a syncfusion direktívák miatt
            $scope.$broadcast('submitted');
            if ($scope.form.$valid === false) {
                log.errorMsg(gettextCatalog.getString('RequiredFieldsError'));
                return;
            }
            dataservice.getAnnualCompetitiveReports(vm.dateFromValue, vm.dateToValue, vm.sectionId, vm.coachId).then(function (data) {
                data.itemsList = $filter('dateStringFilter')(data.itemsList, 'EdzoLezartaDatum');
                data.itemsList = $filter('dateStringFilter')(data.itemsList, 'SzakosztalyVezetoJovahagyva');
                data.itemsList = $filter('dateStringFilter')(data.itemsList, 'KeszitesDatum');
                grid.dataSource = data.itemsList;
            });
            paramHelper.setParams([
            {
                'annualCompetitivePlans.sectionId': vm.sectionId
            },
            {
                'annualCompetitivePlans.coachId': vm.coachId
            },
                {'managementReports.annualCompetitivePlans.dateFrom': vm.dateFromValue},
                {'managementReports.annualCompetitivePlans.dateTo': vm.dateToValue}
            ]);
        }

        function goToAnnualSeasonPlan(args) {
            if (!vm.MEGTEVVERST) {
                log.permissionError();
                return;
            }
            paramHelper.setParams([
                {
                    'AnnualSeasonPlanReport.Id': args
                }]);
            $state.go('administration.annualSeasonPlan.annualSeasonPlanReportPage1');
        }

        function dateFromChange(args) {
            vm.dateFromValue = args.value;
            getActualCoachesList(vm.sectionId);
        }

        function dateToChange(args) {
            vm.dateToValue = args.value;
            getActualCoachesList(vm.sectionId);
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.reports.managementReports.annualCompetitivePlans')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'reports.managementReports.annualCompetitivePlans',
                config: {
                    url: '/annualCompetitivePlans',
                    templateUrl: 'app/reports/managementReports/annualCompetitivePlans/annualCompetitivePlans.html',
                    controller: 'AnnualCompetitivePlansController',
                    controllerAs: 'vm',
                    title: 'AnnualCompetitivePlans',
                    settings: {
                        navId: 35244,
                        level: 3,
                        order: 5,
                        orderTitle_hu: 'Éves versenyeztetési tervek',
                        orderTitle_en: 'Annual Competition Plans',
                        parentId: 244,
                        content: 'AnnualCompetitivePlans',
                        activatorPermission: '"VEZETOIEV"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.reports.managementReports')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'reports.managementReports',
                config: {
                    url: '/managementReports',
                    templateUrl: 'app/reports/managementReports/managementReports.html',
                    title: 'ManagementReports',
                    settings: {
                        navId: 244,
                        level: 2,
                        order: 4,
                        orderTitle_hu: 'Vezetői kimutatások',
                        orderTitle_en: 'Management Reports',
                        parentId: 4,
                        content: 'ManagementReports',
                        activatorPermission: '"VEZETOIHJ"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    MonthlyAttendanceReportsController.$inject = ["log", "dataservice", "$q", "$rootScope", "gettextCatalog", "authenticationService", "paramHelper", "$scope", "$filter", "$state"];
    angular
        .module('app.reports.managementReports.monthlyAttendanceReports')
        .controller('MonthlyAttendanceReportsController', MonthlyAttendanceReportsController);

    function MonthlyAttendanceReportsController(log, dataservice, $q, $rootScope, gettextCatalog, authenticationService, paramHelper, $scope, $filter, $state) {
        var vm = this;
        $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('MonthlyAttendance');

        // Create variables
        vm.params = [];
        vm.sectionId = -1;
        vm.coachId = -1;
        vm.coachList = [];
        vm.sectionList = [];
        vm.dateToValue = new Date();
        vm.dateFromValue = new Date(new Date().setMonth(new Date().getMonth() - 3));
        // Grid's variables
        vm.columns = [
            {field: 'Link', headerText: '', template: '#moatrecolumnTemplate1', width: 60, textAlign: 'center'},
            {field: 'SzakosztalyNeve', headerText: gettextCatalog.getString('Section'), width: 150, template: '#marsection'},
            {field: 'KorosztalyNeve', headerText: gettextCatalog.getString('AgeGroup'), width: 150},
            {field: 'EdzoNeve', headerText: gettextCatalog.getString('Coach'), width: 150, template: '#marcoach'},
            {field: 'Datum', headerText: gettextCatalog.getString('Date'), width: 150},
            {field: 'CsoportLetszam', headerText: gettextCatalog.getString('CsoportLetszam'), width: 150},
            {field: 'Erkezett', headerText: gettextCatalog.getString('Joined'), width: 150},
            {field: 'Tavozott', headerText: gettextCatalog.getString('Departed'), width: 150},
            {field: 'Edzo_Alairta', type: 'boolean', headerText: gettextCatalog.getString('CoachSigned'), width: 150, displayAsCheckBox: true, textAlign: 'center'},
            {field: 'Szakosztalyvezeto_Alairta', type: 'boolean', headerText: gettextCatalog.getString('SectionLeaderSigned'), width: 150, displayAsCheckBox: true, textAlign: 'center'}
        ];

        // Public functions
        vm.sectionSelect = sectionSelect;
        vm.sectionDataBound = sectionDataBound;
        vm.coachDataBound = coachDataBound;
        vm.search = search;
        vm.goToMonthlyAttendance = goToMonthlyAttendance;
        vm.openCoach = openCoach;
        vm.clickOnSection = clickOnSection;
        vm.coachSelect = coachSelect;
        vm.dateFromChange = dateFromChange;
        vm.dateToChange = dateToChange;

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItemsWithSearch,
            allowPaging: true,
            allowTextWrap: true,
            allowSorting: true,
            allowExcelExport: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            beforePrint: $rootScope.beforePrintGrid,
            printComplete: $rootScope.printCompleteGrid,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#Grid'), $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        // Activate page
        activate();

        function activate() {
            authenticationService.getRight('VEZETOIHJ').then(function (result) {
                if (result !== true) {
                    log.permissionError(true);
                } else {
                    $q.all([authenticationService.getRight('MEGTHAVIJEL'), paramHelper.getParams([], ['monthlyAttendanceReports.coachId', 'monthlyAttendanceReports.sectionId', 'managementReports.monthlyAttendanceReports.dateFrom', 'managementReports.monthlyAttendanceReports.dateTo'])]).then(function (results) {
                        vm.MEGTHAVIJEL = results[0];
                        vm.dateFromValue = results[1]['managementReports.monthlyAttendanceReports.dateFrom'] ? results[1]['managementReports.monthlyAttendanceReports.dateFrom'] : vm.dateFromValue;
                        vm.dateToValue = results[1]['managementReports.monthlyAttendanceReports.dateTo'] ? results[1]['managementReports.monthlyAttendanceReports.dateTo'] : vm.dateToValue;
                        vm.params = results[1];
                    });
                    getSections();
                }
            });
        }

        function openCoach(edzoId) {
            $q.all([authenticationService.getRight('MODFELH'), authenticationService.getRight('MEGTFELH')]).then(function (results) {
                if (results[0] || results[1]) {
                    paramHelper.setParams([{'newUser.userId': edzoId}]);
                    $state.go('settings.userManagement.modifyUser');
                } else {
                    log.permissionError();
                }
            });
        }

        function clickOnSection(id) {
            vm.sectionId = id;
            search();
        }

        // Get sections' list
        function getSections() {
            return dataservice.sectionDropDownList(0, true).then(function (data) {
                if (data.itemsList.length !== 1) {
                    data.itemsList.unshift({text: gettextCatalog.getString('All'), value: -1});
                }
                vm.sectionList = data.itemsList;
            });
        }

        // Run after data bounded
        function sectionDataBound() {
            if (vm.params['monthlyAttendanceReports.sectionId']) {
                angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.params['monthlyAttendanceReports.sectionId']);
                vm.params['monthlyAttendanceReports.sectionId'] = null;
            } else if (vm.sectionList.length === 1) {
                angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.sectionList[0].value);
            } else {
                angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.sectionId);
            }
        }

        // Run after section selected
        function sectionSelect(args) {
            getActualCoachesList(args.value);
        }

        function getActualCoachesList(sectionId) {
            return dataservice.coachDropDownList(sectionId, 0, vm.dateFromValue, vm.dateToValue).then(function (data) {
                if (data.itemsList.length !== 1) {
                    data.itemsList.unshift({text: gettextCatalog.getString('All'), value: -1});
                }
                vm.coachList = data.itemsList;
            });
        }

        // Run after data bounded
        function coachDataBound() {
            if (vm.params['monthlyAttendanceReports.coachId']) {
                angular.element('#coachDropDown').ejDropDownList('selectItemByValue', vm.params['monthlyAttendanceReports.coachId']);
                vm.params['monthlyAttendanceReports.coachId'] = null;
            } else if (vm.coachList.length === 1) {
                angular.element('#coachDropDown').ejDropDownList('selectItemByValue', vm.coachList[0].value);
            } else {
                angular.element('#coachDropDown').ejDropDownList('selectItemByValue', vm.coachId);
            }
        }

        function coachSelect(args) {
            vm.coachId = args.value;
            search();
        }

        function search() {
            // a syncfusion direktívák miatt
            $scope.$broadcast('submitted');
            if ($scope.form.$valid === false) {
                log.errorMsg(gettextCatalog.getString('RequiredFieldsError'));
                return;
            }
            dataservice.getMonthlyAttendanceReports(vm.dateFromValue, vm.dateToValue, vm.sectionId, vm.coachId).then(function (data) {
                grid.dataSource = $filter('dateStringFilter')(data.itemsList, 'Datum');
            });

            paramHelper.setParams([
                {
                    'monthlyAttendanceReports.sectionId': vm.sectionId
                },
                {
                    'monthlyAttendanceReports.coachId': vm.coachId
                },
                {'managementReports.monthlyAttendanceReports.dateFrom': vm.dateFromValue},
                {'managementReports.monthlyAttendanceReports.dateTo': vm.dateToValue}
            ]);
        }

        function goToMonthlyAttendance(attendanceId) {
            if (!vm.MEGTHAVIJEL) {
                log.permissionError();
                return;
            }
            paramHelper.setParams([
                {
                    'monthlyAttendance.id': attendanceId
                }
            ]);
            $state.go('administration.monthlyAttendance.monthlyAttendanceReport');
        }

        function dateFromChange(args) {
            vm.dateFromValue = args.value;
            getActualCoachesList(vm.sectionId);
        }

        function dateToChange(args) {
            vm.dateToValue = args.value;
            getActualCoachesList(vm.sectionId);
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.reports.managementReports.monthlyAttendanceReports')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'reports.managementReports.monthlyAttendanceReports',
                config: {
                    url: '/monthlyAttendanceReports',
                    templateUrl: 'app/reports/managementReports/monthlyAttendanceReports/monthlyAttendanceReports.html',
                    controller: 'MonthlyAttendanceReportsController',
                    controllerAs: 'vm',
                    title: 'MonthlyAttendance',
                    settings: {
                        navId: 32244,
                        level: 3,
                        order: 2,
                        orderTitle_hu: 'Havi jelenléti ívek',
                        orderTitle_en: 'Monthly Attendance Sheets',
                        parentId: 244,
                        content: 'MonthlyAttendance',
                        activatorPermission: '"VEZETOIHJ"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    MonthlyCompetitivePlansController2.$inject = ["log", "dataservice", "$q", "$rootScope", "gettextCatalog", "paramHelper", "authenticationService", "$state", "$scope", "$filter"];
    angular
        .module('app.reports.managementReports.monthlyCompetitivePlans')
        .controller('MonthlyCompetitivePlansController2', MonthlyCompetitivePlansController2);

    function MonthlyCompetitivePlansController2(log, dataservice, $q, $rootScope, gettextCatalog, paramHelper, authenticationService, $state, $scope, $filter) {
        var vm = this;
        $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('MonthlyCompetitivePlansManagementReport');

        // Create variables
        vm.promises = [];
        vm.coachId = -1;
        vm.sectionId = -1;
        vm.coachList = [];
        vm.sectionList = [];
        vm.dateToValue = new Date();
        vm.dateFromValue = new Date(new Date().setMonth(new Date().getMonth() - 3));
        // Grid's variables
        vm.columns = [
            {field: 'Link', headerText: '', template: '#mocomplcolumnTemplate1', width: 60, textAlign: 'center'},
            {field: 'SzakosztalyNeve', headerText: gettextCatalog.getString('Section'), width: 150},
            {
                field: 'EdzoNeve',
                headerText: gettextCatalog.getString('Coach'),
                template: '#mocomplcolumnTemplate2',
                width: 150
            },
            {field: 'ErvenyesDatum', headerText: gettextCatalog.getString('Date'), width: 150},
            {field: 'AlairtaDatum', headerText: gettextCatalog.getString('SignedDate'), width: 150},
            {
                field: 'JovahagytaDatum',
                headerText: gettextCatalog.getString('SectionLeaderSignedDate'), width: 150
            },
            {
                field: 'JovahagytaNeve',
                headerText: gettextCatalog.getString('SectionLeaderSigned'),
                template: '#mocomplcolumnTemplate3', width: 150
            }
        ];

        // Public functions
        vm.sectionSelect = sectionSelect;
        vm.sectionDataBound = sectionDataBound;
        vm.coachDataBound = coachDataBound;
        vm.search = search;
        vm.goToMonthlyCompetitivePlan = goToMonthlyCompetitivePlan;
        vm.openCoach = openCoach;
        vm.coachSelect = coachSelect;
        vm.dateFromChange = dateFromChange;
        vm.dateToChange = dateToChange;

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItemsWithSearch,
            allowPaging: true,
            allowTextWrap: true,
            allowSorting: true,
            allowExcelExport: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            beforePrint: $rootScope.beforePrintGrid,
            printComplete: $rootScope.printCompleteGrid,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#Grid'), $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        // Activate page
        activate();

        function activate() {
            $q.all([
                    authenticationService.getRight('VEZETOIHV'),
                    authenticationService.getRight('MEGTHAVIVERST'),
                    paramHelper.getParams([], [
                        'monthlyCompetitivePlans.coachId',
                        'monthlyCompetitivePlans.szakosztalyId', 'managementReports.monthlyCompetitivePlans.dateFrom', 'managementReports.monthlyCompetitivePlans.dateTo'])])
                .then(function (results) {
                    if (results[0] !== true) {
                        log.permissionError(true);
                    } else {
                        vm.MEGTHAVIVERST = results[1];
                        vm.dateFromValue = results[2]['managementReports.monthlyCompetitivePlans.dateFrom'] ? results[2]['managementReports.monthlyCompetitivePlans.dateFrom'] : vm.dateFromValue;
                        vm.dateToValue = results[2]['managementReports.monthlyCompetitivePlans.dateTo'] ? results[2]['managementReports.monthlyCompetitivePlans.dateTo'] : vm.dateToValue;
                        vm.promises = results[2];
                        getSections();
                    }
                });
        }

        // Get sections' list
        function getSections() {
            return dataservice.sectionDropDownList(0, true).then(function (data) {
                if (data.itemsList.length !== 1) {
                    data.itemsList.unshift({text: gettextCatalog.getString('All'), value: -1});
                }
                vm.sectionList = data.itemsList;
            });
        }

        // Run after data bounded
        function sectionDataBound() {
            if (vm.promises['monthlyCompetitivePlans.szakosztalyId']) {
                angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.promises['monthlyCompetitivePlans.szakosztalyId']);
                vm.promises['monthlyCompetitivePlans.szakosztalyId'] = null;
            } else if (vm.sectionList.length === 1) {
                angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.sectionList[0].value);
            } else {
                angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.sectionId);
            }
        }

        // Run after section selected
        function sectionSelect(args) {
            getActualCoachesList(args.value);
        }

        function getActualCoachesList(sectionId) {
            return dataservice.coachDropDownList(sectionId, 0, vm.dateFromValue, vm.dateToValue).then(function (data) {
                if (data.itemsList.length !== 1) {
                    data.itemsList.unshift({text: gettextCatalog.getString('All'), value: -1});
                }
                vm.coachList = data.itemsList;
            });
        }

        // Run after data bounded
        function coachDataBound() {
            if (vm.promises['monthlyCompetitivePlans.coachId']) {
                angular.element('#coachDropDown').ejDropDownList('selectItemByValue', vm.promises['monthlyCompetitivePlans.coachId']);
                vm.promises['monthlyCompetitivePlans.coachId'] = null;
            } else if (vm.coachList.length === 1) {
                angular.element('#coachDropDown').ejDropDownList('selectItemByValue', vm.coachList[0].value);
            } else {
                angular.element('#coachDropDown').ejDropDownList('selectItemByValue', vm.coachId);
            }
        }

        function coachSelect(args) {
            vm.coachId = args.value;
            search();
        }

        function search() {
            // a syncfusion direktívák miatt
            $scope.$broadcast('submitted');
            if ($scope.form.$valid === false) {
                log.errorMsg(gettextCatalog.getString('RequiredFieldsError'));
                return;
            }
            dataservice.getMonthlyCompetitiveReports(vm.dateFromValue, vm.dateToValue, vm.sectionId, vm.coachId).then(function (data) {
                data.itemsList = $filter('dateStringFilter')(data.itemsList, 'ErvenyesDatum');
                data.itemsList = $filter('dateStringFilter')(data.itemsList, 'JovahagytaDatum');
                grid.dataSource = $filter('dateStringFilter')(data.itemsList, 'AlairtaDatum');
            });
            paramHelper.setParams([
                {
                    'monthlyCompetitivePlans.szakosztalyId': vm.sectionId
                },
                {
                    'monthlyCompetitivePlans.coachId': vm.coachId
                },
                {'managementReports.monthlyCompetitivePlans.dateFrom': vm.dateFromValue},
                {'managementReports.monthlyCompetitivePlans.dateTo': vm.dateToValue}
            ]);
        }

        function goToMonthlyCompetitivePlan(planId, egyeni) {
            console.log(egyeni);
            if (!vm.MEGTHAVIVERST) {
                log.permissionError();
                return;
            }
            paramHelper.setParams([
                {
                    'competitiveMonthlyPlan.competitivePlanId': planId
                },
                {'competitiveMonthlyPlan.szakosztalyId': vm.sectionId},
                {'monthlyCompetitivePlan.coachId': vm.coachId},
                {'competitiveMonthlyPlan.egyeni': egyeni}
            ]);
            $state.go('administration.competitiveMonthlyPlan.competitiveMonthlyPlanReport');
        }

        function openCoach(edzoId) {
            $q.all([authenticationService.getRight('MODFELH'), authenticationService.getRight('MEGTFELH')]).then(function (results) {
                if (results[0] || results[1]) {
                    paramHelper.setParams([{'newUser.userId': edzoId}]);
                    $state.go('settings.userManagement.modifyUser');
                } else {
                    log.permissionError();
                }
            });
        }

        function dateFromChange(args) {
            vm.dateFromValue = args.value;
            getActualCoachesList(vm.sectionId);
        }

        function dateToChange(args) {
            vm.dateToValue = args.value;
            getActualCoachesList(vm.sectionId);
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.reports.managementReports.monthlyCompetitivePlans')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'reports.managementReports.monthlyCompetitivePlans',
                config: {
                    url: '/monthlyCompetitivePlans',
                    templateUrl: 'app/reports/managementReports/monthlyCompetitivePlans/monthlyCompetitivePlans.html',
                    controller: 'MonthlyCompetitivePlansController2',
                    controllerAs: 'vm',
                    title: 'MonthlyCompetitivePlansManagementReport',
                    settings: {
                        navId: 34244,
                        level: 3,
                        order: 4,
                        orderTitle_hu: 'Havi versenyeztetési tervek',
                        orderTitle_en: 'Monthly Competitive Plans',
                        parentId: 244,
                        content: 'MonthlyCompetitivePlansManagementReport'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    TrainingDiaryReportsController.$inject = ["log", "dataservice", "$q", "$rootScope", "gettextCatalog", "authenticationService", "paramHelper", "$scope", "$filter", "$state"];
    angular
        .module('app.reports.managementReports.trainingDiaryReports')
        .controller('TrainingDiaryReportsController', TrainingDiaryReportsController);

    function TrainingDiaryReportsController(log, dataservice, $q, $rootScope, gettextCatalog, authenticationService, paramHelper, $scope, $filter, $state) {
        var vm = this; $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('TrainingDiaryReports');

        vm.promises = [];
        vm.coachList = [];
        vm.sectionList = [];
        vm.ageGroupList = [];
        vm.dateToValue = new Date();
        vm.dateFromValue = new Date(new Date().setMonth(new Date().getMonth() - 3));

        vm.columns = [
            {field: 'Link', headerText: '', template: '#tdropentd', textAlign: 'center', width: 60},
            {field: 'SzakosztalyNeve', headerText: gettextCatalog.getString('Section'), width: 150},
            {field: 'KorosztalyNeve', headerText: gettextCatalog.getString('AgeGroup'), width: 150},
            {field: 'EdzoNeve', headerText: gettextCatalog.getString('Coach'), width: 150, template: '#tdrcoach'},
            {field: 'Datum', headerText: gettextCatalog.getString('Date'), width: 150},
            {field: 'EdzesNapokSzama', headerText: gettextCatalog.getString('NumberOfTrainingDays'), width: 150},
            {field: 'Edzo_Alairta', type: 'boolean', headerText: gettextCatalog.getString('CoachSigned'), textAlign: 'center', width: 150, displayAsCheckBox: true},
            {field: 'Szakosztalyvezeto_Alairta', type: 'boolean', headerText: gettextCatalog.getString('SectionLeaderSigned'), textAlign: 'center', width: 150, displayAsCheckBox: true}
        ];

        vm.sectionSelect = sectionSelect;
        vm.sectionDataBound = sectionDataBound;
        vm.coachDataBound = coachDataBound;
        vm.ageGroupSelect = ageGroupSelect;
        vm.ageGroupDataBound = ageGroupDataBound;
        vm.search = search;
        vm.openTrainingDiary = openTrainingDiary;
        vm.openCoach = openCoach;
        vm.coachSelect = coachSelect;
        vm.ageGroupId = -1;
        vm.sectionId = -1;
        vm.coachId = -1;
        vm.dateFromChange = dateFromChange;
        vm.dateToChange = dateToChange;

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItems,
            allowPaging: true,
            allowTextWrap: true,
            allowSorting: true,
            allowExcelExport: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            beforePrint: $rootScope.beforePrintGrid,
            printComplete: $rootScope.printCompleteGrid,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#Grid'), $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        activate();

        function activate() {
            $q.all([
                authenticationService.getRight('VEZETOIHJ'),
                authenticationService.getRight('MEGTHAVIJEL'),
                paramHelper.getParams([], [
                    'trainingDiaryReports.dateFromValue',
                    'trainingDiaryReports.dateToValue',
                    'trainingDiaryReports.sectionId',
                    'trainingDiaryReports.coachId',
                    'trainingDiaryReports.ageGroupId'])]).then(function (results) {
                        if (results[0] !== true) {
                            log.permissionError(true);
                        } else {
                            vm.MEGTHAVIJEL = results[1];
                            vm.promises = results[2];
                            if (vm.promises['trainingDiaryReports.dateFromValue']) {
                                vm.dateFromValue = vm.promises['trainingDiaryReports.dateFromValue'];
                            }
                            if (vm.promises['weeklyTrainingPlans.dateToValue']) {
                                vm.dateToValue = vm.promises['trainingDiaryReports.dateToValue'];
                            }

                            getSections();
                            setDropDowns();
                        }
                    });
        }

        function setDropDowns() {
            var promises = [paramHelper.getParams([], [
                'trainingDiaryReports.dateFromValue',
                'trainingDiaryReports.dateToValue',
                'trainingDiaryReports.sectionId',
                'trainingDiaryReports.coachId',
                'trainingDiaryReports.ageGroupId'
            ])];
            $q.all(promises).then(function (results) {
                vm.sectionId = results[0]['trainingDiaryReports.sectionId'];
                vm.ageGroupId = results[0]['trainingDiaryReports.ageGroupId'];
                vm.coachId = results[0]['trainingDiaryReports.coachId'];
                vm.dateFromValue = results[0]['trainingDiaryReports.dateFromValue'];
                vm.dateToValue = results[0]['trainingDiaryReports.dateToValue'];
            });
        }

        function ageGroupDataBound() {
            if (vm.ageGroupList.length === 1) {
                angular.element('#ageGroupDropDown').ejDropDownList('selectItemByValue', vm.ageGroupList[0].value);
            } else {
                angular.element('#ageGroupDropDown').ejDropDownList('selectItemByValue', vm.ageGroupId);
            }
        }

        function ageGroupSelect(args) {
            vm.ageGroupId = args.value;
        }

        function getAgeGroups(coachId) {
            dataservice.ageGroupSelectBetweenDates(coachId, vm.sectionId, vm.dateFromValue, vm.dateToValue).then(function (data) {
                vm.ageGroupList = data.itemsList;
                vm.ageGroupList.unshift({text: gettextCatalog.getString('All'), value: -1});
            });
        }

        function openCoach(edzoId) {
            $q.all([authenticationService.getRight('MODFELH'), authenticationService.getRight('MEGTFELH')]).then(function (results) {
                if (results[0] || results[1]) {
                    paramHelper.setParams([{'newUser.userId': edzoId}]);
                    $state.go('settings.userManagement.modifyUser');
                } else {
                    log.permissionError();
                }
            });
        }

        function getSections() {
            return dataservice.sectionDropDownList(0, true).then(function (data) {
                if (data.itemsList.length !== 1) {
                    data.itemsList.unshift({text: gettextCatalog.getString('All'), value: -1});
                }
                vm.sectionList = data.itemsList;
            });
        }

        function sectionDataBound() {
            if (vm.sectionList.length === 1) {
                angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.sectionList[0].value);
            } else {
                angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.sectionId);
            }
        }

        function sectionSelect(args) {
            getActualCoachesList(args.value);
            getAgeGroups(0);
        }

        function getActualCoachesList(sectionId) {
            return dataservice.coachDropDownList(sectionId, 0, vm.dateFromValue, vm.dateToValue).then(function (data) {
                if (data.itemsList.length !== 1) {
                    data.itemsList.unshift({text: gettextCatalog.getString('All'), value: -1});
                }
                vm.coachList = data.itemsList;
            });
        }

        function coachDataBound() {
            if (vm.coachList.length === 1) {
                angular.element('#coachDropDown').ejDropDownList('selectItemByValue', vm.coachList[0].value);
            } else {
                angular.element('#coachDropDown').ejDropDownList('selectItemByValue', vm.coachId);
                if (vm.coachId) {
                    getAgeGroups(0);
                }
            }
        }

        function coachSelect(args) {
            getAgeGroups(args.value);
        }

        function search() {
            $scope.$broadcast('submitted');
            if ($scope.form.$valid === false) {
                log.errorMsg(gettextCatalog.getString('RequiredFieldsError'));
                return;
            }
            dataservice.getTrainingDiaryReports(vm.dateFromValue, vm.dateToValue, vm.sectionId, vm.coachId, vm.ageGroupId).then(function (data) {
                grid.dataSource = $filter('dateStringFilter')(data.itemsList, 'Datum');
            });

            paramHelper.setParams(
                [
                    {'trainingDiaryReports.dateFromValue': vm.dateFromValue},
                    {'trainingDiaryReports.dateToValue': vm.dateToValue},
                    {'trainingDiaryReports.sectionId': vm.sectionId},
                    {'trainingDiaryReports.coachId': vm.coachId},
                    {'trainingDiaryReports.ageGroupId': vm.ageGroupId},
                ]);
        }

        function openTrainingDiary(attendanceId) {
            if (!vm.MEGTHAVIJEL) {
                log.permissionError();
                return;
            }
            paramHelper.setParams([{'HaviJelenletiFejId': attendanceId}]);
            $state.go('administration.trainingDiary');
        }

        function dateFromChange(args) {
            vm.dateFromValue = args.value;
            getActualCoachesList(vm.sectionId);
        }

        function dateToChange(args) {
            vm.dateToValue = args.value;
            getActualCoachesList(vm.sectionId);
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.reports.managementReports.trainingDiaryReports')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'reports.managementReports.trainingDiaryReports',
                config: {
                    url: '/trainingDiaryReports',
                    templateUrl: 'app/reports/managementReports/trainingDiaryReports/trainingDiaryReports.html',
                    controller: 'TrainingDiaryReportsController',
                    controllerAs: 'vm',
                    title: 'TrainingDiaryReports',
                    settings: {
                        navId: 31244,
                        level: 3,
                        order: 1,
                        orderTitle_hu: 'Képzési naplók',
                        orderTitle_en: 'Training Diaries',
                        parentId: 244,
                        content: 'TrainingDiaryReports',
                        activatorPermission: '"MEGTHAVIJEL"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    WeeklyTrainingPlansController.$inject = ["log", "dataservice", "$q", "$rootScope", "gettextCatalog", "paramHelper", "authenticationService", "$state", "$scope", "$filter", "$timeout"];
    angular
        .module('app.reports.managementReports.weeklyTrainingPlans')
        .controller('WeeklyTrainingPlansController', WeeklyTrainingPlansController);

    function WeeklyTrainingPlansController(log, dataservice, $q, $rootScope, gettextCatalog, paramHelper, authenticationService, $state, $scope, $filter, $timeout) {
        var vm = this;
        $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('WeeklyTrainingPlans');

        // Create variables
        vm.coachList = [];
        vm.sectionList = [];

        vm.dateToValue = getMonday(new Date(), 6);
        vm.dateFromValue = getMonday(new Date(), 0);
        // Grid's variables
        vm.columns = [
            {field: 'Link', headerText: '', template: '#wetrplcolumnTemplate1', textAlign: 'center', width: 60},
            {field: 'SzakosztalyNeve', headerText: gettextCatalog.getString('Section'), textAlign: 'left', width: 150},
            {field: 'EdzoNeve', headerText: gettextCatalog.getString('Coach'), textAlign: 'left', template: '#wetrplcolumnTemplate2', width: 150},
            {field: 'KorcsoportNeve', headerText: gettextCatalog.getString('AgeGroup'), textAlign: 'left', width: 150},
            {field: 'HetSzama', headerText: gettextCatalog.getString('WeekNumber'), textAlign: 'left', width: 150},
            {field: 'Makrociklus', headerText: gettextCatalog.getString('MacroCycleNumber'), textAlign: 'left', width: 150},
            {field: 'Hetfo', headerText: gettextCatalog.getString('Monday'), textAlign: 'left', width: 150},
            {field: 'Vasarnap', headerText: gettextCatalog.getString('Sunday'), textAlign: 'left', width: 150}
        ];

        // Public functions
        vm.sectionSelect = sectionSelect;
        vm.sectionDataBound = sectionDataBound;
        vm.coachDataBound = coachDataBound;
        vm.search = search;
        vm.goToWeeklyTrainingPlan = goToWeeklyTrainingPlan;
        vm.openCoach = openCoach;
        vm.coachSelect = coachSelect;

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItemsWithSearch,
            allowPaging: true,
            allowTextWrap: true,
            allowSorting: true,
            allowExcelExport: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            beforePrint: $rootScope.beforePrintGrid,
            printComplete: $rootScope.printCompleteGrid,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#Grid'), $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        // Activate page
        activate();

        function getMonday(d, plusDay) {
            d = new Date(d);
            var day = d.getDay();
            var diff = d.getDate() - day + (day == 0 ? -6 : 1) + plusDay; // adjust when day is sunday
            return new Date(d.setDate(diff));
        }

        function activate() {
            authenticationService.getRight('VEZETOIHE').then(function (result) {
                if (result !== true) {
                    log.permissionError(true);
                } else {
                    Promise.all([authenticationService.getRight('MEGTHETIEDZTERV'), paramHelper.getParams([], ['managementReports.weeklyTrainingPlans.szakosztalyId', 'managementReports.weeklyTrainingPlans.coachId', 'managementReports.weeklyTrainingPlans.dateFrom', 'managementReports.weeklyTrainingPlans.dateTo'])])
                        .then((results) => {
                            vm.MEGTHETIEDZTERV = results[0];
                            vm.sectionId = results[1]['managementReports.weeklyTrainingPlans.szakosztalyId'];
                            vm.coachId = results[1]['managementReports.weeklyTrainingPlans.coachId'];
                            vm.dateFromValue = results[1]['managementReports.weeklyTrainingPlans.dateFrom'] ? results[1]['managementReports.weeklyTrainingPlans.dateFrom'] : vm.dateFromValue;
                            vm.dateToValue = results[1]['managementReports.weeklyTrainingPlans.dateTo'] ? results[1]['managementReports.weeklyTrainingPlans.dateTo'] : vm.dateToValue;
                            $timeout(function () {
                                angular.element('#datepickerFrom').ejDatePicker({value: vm.dateFromValue});
                                angular.element('#datepickerTo').ejDatePicker({value: vm.dateToValue});
                            }, 0);
                            getSections();
                        });
                }
            });
        }

        // Get sections' list
        function getSections() {
            return dataservice.sectionDropDownList(0, true).then(function (data) {
                if (data.itemsList.length !== 1) {
                    data.itemsList.unshift({text: gettextCatalog.getString('All'), value: -1});
                }
                vm.sectionList = data.itemsList;
            });
        }

        vm.dateFromDB = function () {
            console.log('vm.dateFromDB');
        };

        // Run after data bounded
        function sectionDataBound() {
            if (vm.sectionList.length === 1) {
                angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.sectionList[0].value);
            } else {
                angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.sectionId);
            }
        }

        // Run after section selected
        function sectionSelect(args) {
            getActualCoachesList(args.value, vm.dateFromValue, vm.dateToValue);
        }

        vm.dateChange = function (args) {
            getActualCoachesList(vm.sectionId, args.value, vm.dateToValue);
        };

        vm.dateChange2 = function (args) {
            getActualCoachesList(vm.sectionId, vm.dateFromValue, args.value);
        };

        function getActualCoachesList(sectionId, dateFrom, dateTo) {
            return dataservice.coachDropDownList(sectionId, 0, dateFrom, dateTo).then(function (data) {
                if (data.itemsList.length > 1) {
                    data.itemsList.unshift({text: gettextCatalog.getString('All'), value: -1});
                }
                vm.coachList = data.itemsList;
            });
        }

        // Run after data bounded
        function coachDataBound() {
            if (vm.coachList.length === 1) {
                angular.element('#coachDropDown').ejDropDownList('selectItemByValue', vm.coachList[0].value);
            } else {
                angular.element('#coachDropDown').ejDropDownList('selectItemByValue', vm.coachId);
            }
        }

        function coachSelect(args) {
            vm.coachId = args.value;
            search();
        }

        function search() {
            // a syncfusion direktívák miatt
            $scope.$broadcast('submitted');
            if ($scope.form.$valid === false) {
                log.errorMsg(gettextCatalog.getString('RequiredFieldsError'));
                return;
            }
            dataservice.getWeeklyTrainingPlans(vm.dateFromValue, vm.dateToValue, vm.sectionId, vm.coachId).then(function (data) {
                data.itemsList = $filter('dateStringFilter')(data.itemsList, 'Hetfo');
                grid.dataSource = $filter('dateStringFilter')(data.itemsList, 'Vasarnap');
            });
            paramHelper.setParams([
                {'weeklyTrainingPlans.szakosztalyId': vm.sectionId},
                {'weeklyTrainingPlans.coachId': vm.coachId},
                {'managementReports.weeklyTrainingPlans.szakosztalyId': vm.sectionId},
                {'managementReports.weeklyTrainingPlans.coachId': vm.coachId},
                {'managementReports.weeklyTrainingPlans.dateFrom': vm.dateFromValue},
                {'managementReports.weeklyTrainingPlans.dateTo': vm.dateToValue}
            ]);
        }

        function goToWeeklyTrainingPlan(trainingPlanId) {
            if (!vm.MEGTHETIEDZTERV) {
                log.permissionError();
                return;
            }
            paramHelper.setParams([
                {
                    'weeklyTrainingPlan.trainingPlanId': trainingPlanId
                },
                {
                    'weeklyTrainingPlans.szakosztalyId': vm.sectionId
                },
                {
                    'weeklyTrainingPlans.coachId': vm.coachId
                }
            ]);
            $state.go('administration.weeklyTrainingPlan.weeklyTrainingPlanReport');
        }

        function openCoach(edzoId) {
            $q.all([authenticationService.getRight('MODFELH'), authenticationService.getRight('MEGTFELH')]).then(function (results) {
                if (results[0] || results[1]) {
                    paramHelper.setParams([{'newUser.userId': edzoId}]);
                    $state.go('settings.userManagement.modifyUser');
                } else {
                    log.permissionError();
                }
            });
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.reports.managementReports.weeklyTrainingPlans')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'reports.managementReports.weeklyTrainingPlans',
                config: {
                    url: '/weeklyTrainingPlans',
                    templateUrl: 'app/reports/managementReports/weeklyTrainingPlans/weeklyTrainingPlans.html',
                    controller: 'WeeklyTrainingPlansController',
                    controllerAs: 'vm',
                    title: 'WeeklyTrainingPlans',
                    settings: {
                        navId: 33244,
                        level: 3,
                        order: 3,
                        orderTitle_hu: 'Heti edzéstervek',
                        orderTitle_en: 'Weekly Training Plans',
                        parentId: 244,
                        content: 'WeeklyTrainingPlans',
                        activatorPermission: '"VEZETOIHE"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    MonthlyCompetitivePlansController.$inject = ["log", "dataservice", "$rootScope", "gettextCatalog", "authenticationService", "paramHelper", "$state", "$scope", "$q", "$filter"];
    angular
        .module('app.reports.monthlyCompetitivePlans')
        .controller('MonthlyCompetitivePlansController', MonthlyCompetitivePlansController);

    function MonthlyCompetitivePlansController(log, dataservice, $rootScope, gettextCatalog, authenticationService, paramHelper, $state, $scope, $q, $filter) {
        var vm = this;
        $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('MonthlyCompetitivePlans');

        // Create variables
        vm.coachList = [];
        vm.sectionList = [];
        vm.dateToValue = new Date();
        vm.dateFromValue = new Date(new Date().setMonth(new Date().getMonth() - 3));
        vm.savedSectionId = 0;
        vm.savedCoachId = 0;
        vm.sectionSelect = sectionSelect;
        vm.sectionDataBound = sectionDataBound;
        vm.coachDataBound = coachDataBound;
        vm.search = search;
        vm.goToMonthlyCompetitivePlan = goToMonthlyCompetitivePlan;
        vm.openCoach = openCoach;
        vm.dateFromChange = dateFromChange;
        vm.dateToChange = dateToChange;
        // Grid's variables
        vm.columns = [
            {field: 'SportoloId', isPrimaryKey: true, visible: false},
            {field: 'Link', headerText: '', textAlign: 'center', width: 60, template: '#moncompplacolumnTemplate1'},
            {field: 'SzakosztalyNeve', headerText: gettextCatalog.getString('Section'), textAlign: 'left', width: 150},
            {
                field: 'EdzoNeve',
                headerText: gettextCatalog.getString('Coach'),
                textAlign: 'left',
                width: 150,
                template: '#monthlyCompetitivePlanscolumnTemplate1'
            },
            {field: 'ErvenyesDatum', headerText: gettextCatalog.getString('Date'), textAlign: 'left', width: 150},
            {field: 'AlairtaDatum', headerText: gettextCatalog.getString('SignedDate'), textAlign: 'left', width: 150},
            {
                field: 'JovahagytaDatum', headerText: gettextCatalog.getString('ApprovalDate'), textAlign: 'left',
                width: 150
            },
            {
                field: 'JovahagytaNeve',
                headerText: gettextCatalog.getString('Approval'),
                textAlign: 'left',
                width: 150,
                template: '#monthlyCompetitivePlanscolumnTemplate2'
            }
        ];

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItems,
            allowPaging: true,
            allowTextWrap: true,
            allowSorting: true,
            allowExcelExport: true,
            locale: 'hu-HU',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            gridLines: 'Both',
            beforePrint: $rootScope.beforePrintGrid,
            printComplete: $rootScope.printCompleteGrid,

            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile(grid, $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        // Activate page
        activate();

        function activate() {
            authenticationService.getRight('KMHAVIVERSTERV').then(function (result) {
                if (result !== true) {
                    log.permissionError(true);
                } else {
                    $q.all([authenticationService.getRight('MEGTHAVIVERST'), paramHelper.getParams([], ['mcp.coach', 'mcp.section'])]).then(function (results) {
                        vm.MEGTHAVIVERST = results[0];
                        vm.sectionId = results[1]['mcp.section'];
                        vm.coachId = results[1]['mcp.coach'] === null ? -1 : results[1]['mcp.coach'];
                    });
                    setDropDowns();
                    getSections();
                }
            });
        }

        function setDropDowns() {
            var promises = [paramHelper.getParams([], [
                'mcp.section',
                'mcp.coach',
                'mcp.from',
                'mcp.to',
            ])
            ];
            $q.all(promises).then(function (results) {
                if (results[0]['mcp.section'] > 0) {
                    vm.savedSectionId = results[0]['mcp.section'];
                    vm.savedCoachId = results[0]['mcp.coach'];
                    vm.dateFromValue = results[0]['mcp.from'];
                    vm.dateToValue = results[0]['mcp.to'];
                }
            });
        }

        // Get sections' list
        function getSections() {
            return dataservice.sectionDropDownList(0, true).then(function (data) {
                if (data.itemsList.length !== 1) {
                    data.itemsList.unshift({text: gettextCatalog.getString('All'), value: -1});
                }
                vm.sectionList = data.itemsList;
            });
        }

        // Run after data bounded
        function sectionDataBound() {
            if (vm.savedSectionId > 0) {
                vm.sectionId = vm.savedSectionId;
                angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.sectionId);
            } else {
                if (vm.sectionList.length === 1) {
                    angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.sectionList[0].value);
                } else {
                    angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.sectionId);
                }
            }
        }

        // Run after section selected
        function sectionSelect(args) {
            getActualCoachesList(args.value);
        }

        function getActualCoachesList(sectionId) {
            return dataservice.coachDropDownList(sectionId, 0, vm.dateFromValue, vm.dateToValue).then(function (data) {
                if (data.itemsList.length !== 1) {
                    data.itemsList.unshift({text: gettextCatalog.getString('All'), value: -1});
                }
                vm.coachList = data.itemsList;
            });
        }

        // Run after data bounded
        function coachDataBound() {
            if (vm.savedCoachId > 0) {
                vm.coachId = vm.savedCoachId;
                angular.element('#coachDropDown').ejDropDownList('selectItemByValue', vm.coachId);
            } else {
                if (vm.coachList.length === 1) {
                    angular.element('#coachDropDown').ejDropDownList('selectItemByValue', vm.coachList[0].value);
                } else {
                    angular.element('#coachDropDown').ejDropDownList('selectItemByValue', vm.coachId);
                }
            }
        }

        function search() {
            // a syncfusion direktívák miatt
            $scope.$broadcast('submitted');
            if ($scope.form.$valid === false) {
                log.errorMsg(gettextCatalog.getString('RequiredFieldsError'));
                return;
            }
            paramHelper.setParams([
                {'mcp.section': vm.sectionId},
                {'mcp.coach': vm.coachId},
                {'mcp.from': vm.dateFromValue},
                {'mcp.to': vm.dateToValue}
            ]);
            dataservice.getMonthlyCompetitivePlans(vm.dateFromValue, vm.dateToValue, vm.sectionId, vm.coachId).then(function (data) {
                data.itemsList = $filter('dateStringFilter')(data.itemsList, 'ErvenyesDatum');
                data.itemsList = $filter('dateStringFilter')(data.itemsList, 'AlairtaDatum');
                data.itemsList = $filter('dateStringFilter')(data.itemsList, 'JovahagytaDatum');
                grid.dataSource = data.itemsList;
            });
        }

        function goToMonthlyCompetitivePlan(planId) {
            var result = $.grep(grid.currentViewData, function (e) {
                return e.planId == planId;
            });
            if (!vm.MEGTHAVIVERST) {
                log.permissionError();
                return;
            }
            paramHelper.setParams([
                {
                    'competitiveMonthlyPlan.edzoId': result[0].EdzoId
                },
                {
                    'competitiveMonthlyPlan.edzoNev': result[0].EdzoNeve
                },
                {
                    'competitiveMonthlyPlan.szakosztalyNev': result[0].szakosztalyNev
                },
                {
                    'competitiveMonthlyPlan.szakosztalyId': result[0].SzakosztalyId
                },
                {
                    'competitiveMonthlyPlan.competitivePlanId': result[0].planId
                },
                {
                    'competitiveMonthlyPlan.egyeni': result[0].egyeni
                }
            ]);
            $state.go('administration.competitiveMonthlyPlan.competitiveMonthlyPlanReport');
        }

        function openCoach(edzoId) {
            $q.all([authenticationService.getRight('MODFELH'), authenticationService.getRight('MEGTFELH')]).then(function (results) {
                if (results[0] || results[1]) {
                    paramHelper.setParams([{'newUser.userId': edzoId}]);
                    $state.go('settings.userManagement.modifyUser');
                } else {
                    log.permissionError();
                }
            });
        }

        function dateFromChange(args) {
            vm.dateFromValue = args.value;
            getActualCoachesList(vm.sectionId);
        }

        function dateToChange(args) {
            vm.dateToValue = args.value;
            getActualCoachesList(vm.sectionId);
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.reports.monthlyCompetitivePlans')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'reports.monthlyCompetitivePlans',
                config: {
                    url: '/monthlyCompetitivePlans',
                    templateUrl: 'app/reports/monthlyCompetitivePlans/monthlyCompetitivePlans.html',
                    controller: 'MonthlyCompetitivePlansController',
                    controllerAs: 'vm',
                    title: 'MonthlyCompetitivePlans',
                    settings: {
                        navId: 274,
                        level: 2,
                        order: 7,
                        orderTitle_hu: 'Havi versenyeztetési tervek',
                        orderTitle_en: 'Monthly Competitive Plans',
                        parentId: 4,
                        content: 'MonthlyCompetitivePlans',
                        activatorPermission: '"KMHAVIVERSTERV"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    PlayUpAndDownController.$inject = ["log", "dataservice", "$q", "$rootScope", "gettextCatalog", "authenticationService", "$scope", "$filter", "paramHelper", "$state"];
    angular
        .module('app.reports.playUpAndDown')
        .controller('PlayUpAndDownController', PlayUpAndDownController);

    function PlayUpAndDownController(log, dataservice, $q, $rootScope, gettextCatalog, authenticationService, $scope, $filter, paramHelper, $state) {
        var vm = this;
        $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('PlayUpAndDown');

        vm.sectionList = [];
        vm.ageGroupList = [];
        vm.coachList = [];
        vm.sectionDataBound = sectionDataBound;
        vm.sectionSelect = sectionSelect;
        vm.ageGroupDataBound = ageGroupDataBound;
        vm.ageGroupSelect = ageGroupSelect;
        vm.coachDataBound = coachDataBound;
        vm.coachSelect = coachSelect;
        vm.openAthlete = openAthlete;
        vm.openCoach = openCoach;
        vm.show = show;

        vm.columns = [
            {field: 'SportolokID', isPrimaryKey: true, visible: false},
            {
                field: 'EdzoNeve',
                headerText: gettextCatalog.getString('Coach'),
                textAlign: 'left',
                width: 150,
                template: '#puadcoach'
            },
            {
                field: 'Nev',
                headerText: gettextCatalog.getString('Name'),
                textAlign: 'left',
                width: 150,
                template: '#puadath'
            },
            {field: 'SzuletesiIdo', headerText: gettextCatalog.getString('Birthdate'), textAlign: 'left', width: 150},
            {
                field: 'Aktiv',
                headerText: gettextCatalog.getString('Active'),
                type: 'boolean',
                displayAsCheckBox: true,
                textAlign: 'center',
                width: 150
            },
            {field: 'KorcsoportNeve', headerText: gettextCatalog.getString('AgeGroup'), textAlign: 'left', width: 150},
            {field: 'Tagdij', headerText: gettextCatalog.getString('SportServiceFee'), textAlign: 'left', width: 150},
            {
                field: 'Oktatasidij',
                headerText: gettextCatalog.getString('EducationalFee'),
                textAlign: 'left',
                width: 150
            },
            {field: 'Egyenleg', headerText: gettextCatalog.getString('PaidAmount'), textAlign: 'left', width: 150},
        ];

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItems,
            allowPaging: true,
            allowSorting: true,
            allowTextWrap: true,
            allowExcelExport: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile(grid, $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        // Activate page
        activate();

        function activate() {
            authenticationService.getRight('KMATFELJATSZ').then(function (result) {
                if (result !== true) {
                    log.permissionError(true);
                } else {
                    getSections();
                    setDropDowns();
                }
            });
        }

        function setDropDowns() {
            var promises = [paramHelper.getParams([], [
                'puad.section',
                'puad.agegroup',
                'puad.coach'
            ])
            ];
            $q.all(promises).then(function (results) {
                console.log('setDropDowns', results[0]);
                vm.sectionId = results[0]['puad.section'];
                vm.sectionIdValue = results[0]['puad.section'];
                vm.ageGroupId = results[0]['puad.agegroup'];
                vm.ageGroupIdValue = results[0]['puad.agegroup'];
                vm.coachId = results[0]['puad.coach'];
                vm.coachIdValue = results[0]['puad.coach'];
            });
        }

        function openAthlete(id) {
            $q.all([authenticationService.getRight('MEGTSPORTLIST')]).then(function (results) {
                if (results[0]) {
                    paramHelper.setParams([{'athleteModify.sportoloId': id}]);
                    $state.go('athletes.athletesManagement.athleteModify.dataSheet');
                } else {
                    log.permissionError();
                }
            });
        }

        function openCoach(edzoId) {
            $q.all([authenticationService.getRight('MODFELH'), authenticationService.getRight('MEGTFELH')]).then(function (results) {
                if (results[0] || results[1]) {
                    paramHelper.setParams([{'newUser.userId': edzoId}]);
                    $state.go('settings.userManagement.modifyUser');
                } else {
                    log.permissionError();
                }
            });
        }

        // Get sections' list
        function getSections() {
            return dataservice.sectionDropDownList(0, true).then(function (data) {
                vm.sectionList = data.itemsList;
            });
        }

        // Run after data bounded
        function sectionDataBound() {
            if (vm.sectionList.length === 1) {
                vm.sectionId = vm.sectionList[0].value;
                angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.sectionList[0].value);
            } else {
                angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.sectionId);
            }
        }

        // Run after section selected
        function sectionSelect(args) {
            vm.sectionId = args.value;
            vm.coachList = [];
            vm.ageGroupId = -1;
            getAgeGroups();
        }

        // Get age groups' list
        function getAgeGroups() {
            return dataservice.ageGroupDropDownList(vm.sectionId).then(function (data) {
                if (data.itemsList.length !== 1) {
                    data.itemsList.unshift({text: gettextCatalog.getString('All'), value: -1});
                }
                vm.ageGroupList = data.itemsList;
            });
        }

        // Run after data bounded
        function ageGroupDataBound() {
            if (vm.ageGroupList.length === 1) {
                angular.element('#ageGroupDropDown').ejDropDownList('selectItemByValue', vm.ageGroupList[0].value);
            } else {
                angular.element('#ageGroupDropDown').ejDropDownList('selectItemByValue', vm.ageGroupId);
                if (!vm.ageGroupId) {
                    getActualCoachesList(0);
                }
            }
        }

        function ageGroupSelect(args) {
            getActualCoachesList(args.value);
        }

        function getActualCoachesList(agegroup) {
            if (!agegroup) {
                agegroup = 0;
            }
            return dataservice.coachDropDownList(vm.sectionId, agegroup).then(function (data) {
                if (data.itemsList.length !== 1) {
                    data.itemsList.unshift({text: gettextCatalog.getString('All'), value: -1});
                }
                vm.coachList = data.itemsList;
            });
        }

        // Run after data bounded
        function coachDataBound() {
            if (vm.coachList.length === 1) {
                angular.element('#coachDropDown').ejDropDownList('selectItemByValue', vm.coachList[0].value);
            } else {
                angular.element('#coachDropDown').ejDropDownList('selectItemByValue', vm.coachId);
            }
        }

        // Run after age group selected
        function coachSelect(args) {
            vm.coachId = args.value;
        }

        function show() {
            $scope.$broadcast('submitted');
            if ($scope.form.$valid === false) {
                log.errorMsg(gettextCatalog.getString('RequiredFieldsError'));
                return;
            }
            paramHelper.setParams([
                {'puad.section': vm.sectionId},
                {'puad.agegroup': vm.ageGroupId},
                {'puad.coach': vm.coachId}
            ]);
            dataservice.getUpAndDownPlayers(vm.sectionId, vm.ageGroupId, vm.coachId).then(function (data) {
                grid.dataSource = $filter('dateStringFilter')(data.itemsList, 'SzuletesiIdo');
            });
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.reports.playUpAndDown')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'reports.playUpAndDown',
                config: {
                    url: '/playUpAndDown',
                    templateUrl: 'app/reports/playUpAndDown/playUpAndDown.html',
                    controller: 'PlayUpAndDownController',
                    controllerAs: 'vm',
                    title: 'PlayUpAndDown',
                    settings: {
                        navId: 2104,
                        level: 2,
                        order: 10,
                        orderTitle_hu: 'Át/Feljátszó sportolók',
                        orderTitle_en: 'Play Up Athletes',
                        parentId: 4,
                        content: 'PlayUpAndDown',
                        activatorPermission: '"KMATFELJATSZ"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    RaceResultsReportController.$inject = ["log", "logger", "dataservice", "$q", "$rootScope", "gettextCatalog", "paramHelper", "authenticationService", "$scope", "$filter", "$state", "$timeout"];
    angular
        .module('app.reports.raceResultsReport')
        .controller('RaceResultsReportController', RaceResultsReportController);

    function RaceResultsReportController(log, logger, dataservice, $q, $rootScope, gettextCatalog, paramHelper, authenticationService, $scope, $filter, $state, $timeout) {
        var vm = this;
        $rootScope.vm = vm;
        vm.params = [];
        $rootScope.title = gettextCatalog.getString('RaceResultsReport');

        // Create variables
        vm.searched = '';
        vm.requestedData = {
            Csapat: {CsapatId: undefined, CsapatNev: undefined}, // Csapat neve
            Szakosztaly: {SzakosztalyId: 0, SzakosztalyNev: undefined},
            Korcsoport: {KorcsoportId: undefined, KorcsoportNev: undefined},
            Edzo: {EdzoId: undefined, EdzoNev: undefined}, // int Edző (UserId)
            Sportolo: {SportoloId: undefined, SportoloNev: undefined, SzuletesiIdo: undefined}, // Sportoló adatai
            EredmenySzoveg: undefined, // Eredmény (szöveg input mező)
            DatumTol: undefined, // DateTime? Dátumtól
            DatumIg: undefined, // DateTime? Dátumig
            Helyszin: undefined, // string Helyszín
            Helyezes: undefined, // string Helyezés
            Ertekeles: undefined, // string Értékelés
            Jellege: undefined, // string Jellege
            Verseny: undefined, // string Verseny
            Eredmeny: undefined, // int Edzői értékelés (Eredmeny = -2 => 1; Eredmeny = 2 => 5 )
            Foto: undefined, // (megjeleníteni kell kiválaszás esetén)
            SportoloKereses: true
        };
        // For print
        vm.reportParameters = {};
        vm.reportParameters2 = {};
        // section
        vm.sectionList = [];
        // age group
        vm.ageGroupList = [];
        // team
        vm.teamsList = [];
        vm.selectedTeamId = undefined;
        // coach
        vm.coachList = [];
        vm.selectedCoachList;
        vm.birthDate = undefined;
        vm.selectdateTo = new Date();
        vm.requestedData.DatumIg = new Date();

        vm.coachRating = undefined; // Edzo ertekelese
        vm.athleteData = {
            Id: undefined,
            IdSzakosztaly: undefined, // Int32
            Korcsoport: undefined, // Int32
            JelenlegiEdzo: undefined, // int
            Nev: undefined, // String
            SzuletesiIdo: undefined // DateTime
        };

        vm.reportDatasGrid = [];
        vm.reportDatasGrid[0] = vm.reportData1;
        vm.reportDatasGrid[1] = vm.reportData2;
        vm.reportDatasGrid[2] = vm.reportData3;

        // GRID
        vm.pageData = 1;
        vm.actionBegin = actionBegin;
        vm.schoolGridSelectedRowData = {};
        vm.columnsAthlete = [
            {
                field: 'Link',
                headerText: '',
                textAlign: 'center',
                width: '60',
                template: '#rareretemplateDataColumn3'
            },
            {
                field: 'SportoloNev',
                headerText: gettextCatalog.getString('AthleteName'),
                textAlign: 'center',
                width: '150',
                template: '#rareretemplateDataColumn1'
            },
            {
                field: 'EredmenySzoveg',
                headerText: gettextCatalog.getString('ResultText'),
                textAlign: 'left',
                width: '350'
            },
            {
                field: 'EredmenyPont',
                headerText: gettextCatalog.getString('ResultScore'),
                textAlign: 'center',
                width: '150'
            },
            {
                field: 'EredmenyIdo',
                headerText: gettextCatalog.getString('ResultTime'),
                textAlign: 'center',
                width: '150'
            },
            {
                field: 'EredmenyTavolsag',
                headerText: gettextCatalog.getString('ResultDistance'),
                textAlign: 'center',
                width: '150'
            },
            {
                field: 'SzakosztalyNeve',
                headerText: gettextCatalog.getString('Section'),
                textAlign: 'center',
                width: '100'
            },
            {
                field: 'KorcsoportNeve',
                headerText: gettextCatalog.getString('AgeGroup'),
                textAlign: 'center',
                width: '100'
            },
            {
                field: 'DatumTol',
                headerText: gettextCatalog.getString('DateFrom'),
                textAlign: 'center',
                width: '90'
            },
            {field: 'DatumIg', headerText: gettextCatalog.getString('DateTo'), textAlign: 'center', width: '90'},
            {
                field: 'Helyszin',
                headerText: gettextCatalog.getString('Location'),
                textAlign: 'center',
                width: '140'
            },
            {
                field: 'Helyezes',
                headerText: gettextCatalog.getString('Helyezes'),
                textAlign: 'center',
                width: '120'
            },
            {field: 'VersenyLeiras', headerText: gettextCatalog.getString('VersenyLeiras'), width: '250'},
            {
                field: 'Ertekeles',
                headerText: gettextCatalog.getString('CoachRating'),
                textAlign: 'center',
                width: '400'
            },
            {
                field: 'Jellege',
                headerText: gettextCatalog.getString('Jellege'),
                textAlign: 'center',
                width: '250'
            },
            {field: 'Eredmeny', headerText: gettextCatalog.getString('Result'), textAlign: 'center', width: '90'}, //int Edzői értékelés (Eredmeny = -2 => 1;Eredmeny =2=> 5 )
            {
                field: 'Versenyszam',
                headerText: gettextCatalog.getString('Versenyszam'),
                textAlign: 'center',
                width: '200'
            },
            {
                field: 'EdzoNeve',
                headerText: gettextCatalog.getString('Coach'),
                textAlign: 'center',
                width: '110',
                template: '#rareretemplateDataColumn2'
            },
            {
                headerText: gettextCatalog.getString('Print'),
                textAlign: 'center',
                width: '100',
                template: '#rareretemplateDataColumn4'
            }
        ];
        vm.columnsTeam = [

            {field: 'Link', headerText: '', width: '60', template: '#rareretemplateDataColumn7', textAlign: 'center'},
            {
                field: 'CsapatNev',
                headerText: gettextCatalog.getString('TeamName'),
                width: '150',
                template: '#rareretemplateDataColumn5'
            },
            {field: 'EredmenySzoveg', headerText: gettextCatalog.getString('ResultText'), width: '350'},
            {field: 'SzakosztalyNeve', headerText: gettextCatalog.getString('Section'), width: '100'},
            {field: 'KorcsoportNeve', headerText: gettextCatalog.getString('AgeGroup'), width: '100'},
            {field: 'DatumTol', headerText: gettextCatalog.getString('DateFrom'), width: '90'},
            {field: 'DatumIg', headerText: gettextCatalog.getString('DateTo'), width: '90'},
            {field: 'Helyszin', headerText: gettextCatalog.getString('Location'), width: '140'},
            {field: 'Helyezes', headerText: gettextCatalog.getString('AthleteRanking'), width: '120'},
            {field: 'VersenyLeiras', headerText: gettextCatalog.getString('VersenyLeiras'), width: '250'},
            {field: 'Ertekeles', headerText: gettextCatalog.getString('CoachRating'), width: '400'},
            {field: 'Jellege', headerText: gettextCatalog.getString('Jellege'), width: '250'},
            {field: 'Eredmeny', headerText: gettextCatalog.getString('Result'), textAlign: 'center', width: '90'}, //int Edzői értékelés (Eredmeny = -2 => 1;Eredmeny =2=> 5 )
            {
                field: 'Versenyszam',
                headerText: gettextCatalog.getString('Versenyszam'),
                textAlign: 'center',
                width: '200'
            },
            {
                field: 'EdzoNeve',
                headerText: gettextCatalog.getString('Coach'),
                width: '110',
                template: '#rareretemplateDataColumn6'
            },
            {field: 'Print', headerText: gettextCatalog.getString('Print'), width: '100', template: '#rareretemplateDataColumn8'}
        ];

        // Public functions
        vm.clearYear = clearYear;
        vm.clearTeam = clearTeam;
        vm.clearSection = clearSection;
        vm.clearAgeGroup = clearAgeGroup;
        vm.clearCoach = clearCoach;
        vm.clearSelectdateFrom = clearSelectdateFrom;
        vm.clearSelectdateTo = clearSelectdateTo;

        vm.openCoach = openCoach;
        vm.radioButtonChecked = radioButtonChecked;
        vm.radioButtonClear = radioButtonClear;
        // Buttons for Grid
        vm.searchTeam = searchTeam; // Grid data change button
        vm.searchAthlete = searchAthlete; // Grid data change button
        vm.openAthlete = openAthlete;
        vm.openTeam = openTeam;

        // sectionDropDown
        vm.sectionDataBound = sectionDataBound; // Public
        vm.sectionSelect = sectionSelect; // Public
        // ageGroupDropDown
        vm.ageGroupDataBound = ageGroupDataBound; // Public
        vm.ageGroupSelect = ageGroupSelect; // Public
        // teamDropDown
        vm.teamsDataBound = teamsDataBound; // Public
        vm.teamsSelect = teamsSelect; // Public
        // coach
        vm.coachDropDownListDataBound = coachDropDownListDataBound;
        vm.coachSelect = coachSelect;
        // date pickers
        vm.selectdateFromChange = selectdateFromChange;
        vm.selectdateToChange = selectdateToChange;
        vm.selectBirthDate = selectBirthDate;

        vm.selectdCoach = '';
        vm.deleteResult = deleteResult;
        vm.open = open;
        vm.printAthleteResult = printAthleteResult;
        vm.printTeamResult = printTeamResult;

        vm.SelectedSectionID = 0;
        vm.SelectedAgeGroupID = 0;
        vm.SelectedCoachID = 0;
        vm.SelectedTeamID = 0;
        vm.isAdmin = false;
        vm.showDelButton = false;
        vm.selectedRowData = {};
        vm.nameChange = nameChange;

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItemsWithSearch,
            allowPaging: true,
            allowTextWrap: true,
            allowSorting: true,
            allowExcelExport: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columnsAthlete,
            beforePrint: function (args) {
                $rootScope.beforePrintGrid(args, ['Link', 'Print']);
            },
            printComplete: function (args) {
                $rootScope.printCompleteGrid(args, ['Link', 'Print']);
            },
            rowSelected: function () {
                $timeout(function () {
                    vm.showDelButton = true;
                }, 10);
            },
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#Grid'), $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        var grid2 = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItemsWithSearch,
            allowPaging: true,
            allowTextWrap: true,
            allowSorting: true,
            allowExcelExport: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columnsTeam,
            beforePrint: function (args) {
                $rootScope.beforePrintGrid(args, ['Link', 'Print']);
            },
            printComplete: function (args) {
                $rootScope.printCompleteGrid(args, ['Link', 'Print']);
            },
            rowSelected: function () {
                $timeout(function () {
                    vm.showDelButton = true;
                }, 10);
            },
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#Grid2'), $scope);
                }
            }
        });
        grid2.appendTo('#Grid2');
        grid2.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        activate();

        function activate() {
            $q.all([
                paramHelper.getParams([], ['raceResultsReport.athleteData', 'teamID']),
                authenticationService.getRight('KMVERSEREDM')
            ]).then(function (results) {
                if (!results[1]) {
                    log.permissionError(true);
                } else {
                    vm.params = results;
                    paramHelper.removeParam('raceResultsReport.athleteData'); // Clear athleteData
                    paramHelper.removeParam('teamID'); // Clear teamID
                    if (results[0]['teamID']) {
                        vm.SelectedTeamID = results[0]['teamID'];
                        getResultTeam();
                        // Clear();
                    } else if (results[0]['raceResultsReport.athleteData']) {
                        vm.athleteData = results[0]['raceResultsReport.athleteData'];
                        vm.athleteData.Nev = results[0]['raceResultsReport.athleteData'].Nev;
                        vm.requestedData.Sportolo.SportoloId = results[0]['raceResultsReport.athleteData'].SportolokId;
                        getActualCoachesList();
                        searchAthlete();
                        //Clear();
                    } else {
                        vm.SelectedSectionID = 0;
                        vm.SelectedAgeGroupID = 0;
                        vm.SelectedCoachID = 0;
                        vm.SelectedTeamID = 0;
                    }
                    $timeout(function () {
                        //angular.element('#birthDate').ejDropDownList('selectItemByValue', new Date(data.ErvenyessegTol).getFullYear() + ' / ' + new Date(data.ErvenyessegIg).getFullYear());
                        vm.birthDate = vm.athleteData.SzuletesiIdo;
                    }, 0);

                    getSections();
                    getAgeGroups();
                    getCoaches();
                    getTeamsList();
                }
            });
        }

        function nameChange() {
            vm.requestedData.Sportolo.SportoloId = null;
        }

        function searchAthlete() {
            vm.searched = 'athlete';
            vm.requestedData.SportoloKereses = true;
            vm.requestedData.Sportolo.SportoloNev = vm.athleteData.Nev;
            vm.requestedData.Szakosztaly.SzakosztalyId = vm.SelectedSectionID;
            vm.requestedData.Korcsoport.KorcsoportId = vm.SelectedAgeGroupID;
            vm.requestedData.Edzo.EdzoId = vm.SelectedCoachID;
            vm.requestedData.Csapat.CsapatId = vm.SelectedTeamID;
            vm.requestedData.Sportolo.SzuletesiIdo = vm.birthDate;
            dataservice.getResultsReports(vm.requestedData)
                .then(function (data) {
                    data.itemsList = $filter('dateStringFilter')(data.itemsList, 'SzuletesiIdo');
                    data.itemsList = $filter('dateStringFilter')(data.itemsList, 'DatumTol');
                    data.itemsList = $filter('dateStringFilter')(data.itemsList, 'DatumIg');
                    grid.dataSource = $filter('valueChangeFromObject')(data.itemsList, 'Eredmeny');
                    vm.isAdmin = data.isAdmin;
                });
            angular.element('#hidedContent').css('height', '500px');
            angular.element('#hidedContent2').css('height', '0px');
        }

        function getResultTeam() {
            vm.requestedData.SportoloKereses = false;
            vm.requestedData.Sportolo.SportoloNev = vm.athleteData.Nev;
            vm.requestedData.Szakosztaly.SzakosztalyId = vm.SelectedSectionID;
            vm.requestedData.Korcsoport.KorcsoportId = vm.SelectedAgeGroupID;
            vm.requestedData.Edzo.EdzoId = vm.SelectedCoachID;
            vm.requestedData.Csapat.CsapatId = vm.SelectedTeamID;
            dataservice.getResultsReports(vm.requestedData).then(function (data) {
                data.itemsList = $filter('dateStringFilter')(data.itemsList, 'DatumTol');
                data.itemsList = $filter('dateStringFilter')(data.itemsList, 'DatumIg');
                grid2.dataSource = $filter('valueChangeFromObject')(data.itemsList, 'Eredmeny');
                vm.isAdmin = data.isAdmin;
            });
            angular.element('#hidedContent').css('height', '0px');
            angular.element('#hidedContent2').css('height', '500px');
        }

        function sectionSelect(args) {
            vm.SelectedCoachID = 0;
            vm.SelectedAgeGroupID = 0;
            vm.SelectedSectionID = args.value;
            if (args.value == -1) {
                vm.SelectedSectionID = 0;
            }
            getActualCoachesList();
            getAgeGroups();
            getTeamsList();
            vm.showDelButton = false;
        }

        function ageGroupSelect(args) {
            vm.SelectedCoachID = 0;
            vm.SelectedAgeGroupID = args.value;
            if (args.value == -1) {
                vm.SelectedAgeGroupID = 0;
            }
            getActualCoachesList();
            getTeamsList();
            vm.showDelButton = false;
        }

        function coachSelect(args) {
            vm.SelectedCoachID = args.value;
            if (args.value == -1) {
                vm.SelectedCoachID = 0;
            }
            vm.showDelButton = false;
        }

        function teamsSelect(args) {
            vm.SelectedTeamID = args.value;
            if (args.value == -1) {
                vm.SelectedTeamID = 0;
            }
            vm.requestedData.Csapat.CsapatNev = angular.element('#Team').data('ejDropDownList').currentValue;
            angular.element('#coach').ejDropDownList('selectItemByValue', 0);
            vm.requestedData.Edzo.EdzoId = undefined;
            vm.requestedData.Edzo.EdzoNev = undefined;
            vm.showDelButton = false;
        }

        function getSections() {
            dataservice.sectionDropDownList(0, true)
                .then(function (data) {
                    vm.sectionList = data.itemsList;
                    if (data.itemsList.length > 1) {
                        var all = {value: -1, text: gettextCatalog.getString('All')};
                        vm.sectionList.splice(0, 0, all);
                    }
                });
        }

        function getAgeGroups() {
            dataservice.ageGroupDropDownList(vm.SelectedSectionID)
                .then(function (data) {
                    vm.ageGroupList = data.itemsList;
                    if (data.itemsList.length > 1) {
                        var all = {value: -1, text: gettextCatalog.getString('All')};
                        vm.ageGroupList.splice(0, 0, all);
                    }
                });
        }

        function getActualCoachesList() {
            return dataservice.coachDropDownList(vm.SelectedSectionID, vm.SelectedAgeGroupID, vm.requestedData.DatumTol, vm.requestedData.DatumIg) // Need the section id (szakosztály)
                .then(function (data) {
                    vm.coachList = data.itemsList;
                    if (data.itemsList.length > 1) {
                        var all = {value: -1, text: gettextCatalog.getString('All')};
                        vm.coachList.splice(0, 0, all);
                    }
                });
        }

        function getCoaches() { // getCoaches - EdzoFelhasznalokDropdownSelect.  use this, when not yet selected section and age group
            return dataservice.coachSelect().then(
                function (data) {
                    vm.coachList = data.itemsList;
                    return vm.coachList;
                }
            );
        }

        function getTeamsList() {
            dataservice.teamsDropDownList(vm.SelectedSectionID, vm.SelectedAgeGroupID, vm.SelectedCoachID)
                .then(function (data) {
                    vm.teamsList = data.itemsList;
                    if (data.itemsList.length > 1) {
                        var all = {value: -1, text: gettextCatalog.getString('All')};
                        vm.teamsList.splice(0, 0, all);
                    }
                });
        }

        function selectdateFromChange(args) {
            vm.requestedData.DatumTol = args.value; // DateTime? Dátumtól
            vm.requestedData.DatumTol = args.value;
            getActualCoachesList();
        }

        function selectdateToChange(args) {
            vm.requestedData.DatumIg = args.value; // DateTime? Dátumig
            vm.requestedData.DatumIg = args.value;
            getActualCoachesList();
        }

        function selectBirthDate(args) {
            vm.birthDate = args.value; // DateTime?
            vm.requestedData.Sportolo.SzuletesiIdo = args.value;
        }

        function openAthlete(id) {
            $q.all([authenticationService.getRight('MEGTSPORTLIST')]).then(function (results) {
                if (results[0]) {
                    paramHelper.setParams([{'athleteModify.sportoloId': id}]);
                    $state.go('athletes.athletesManagement.athleteModify.dataSheet');
                } else {
                    log.permissionError();
                }
            });
        }

        function openCoach(edzoId) {
            $q.all([authenticationService.getRight('MODFELH'), authenticationService.getRight('MEGTFELH')]).then(function (results) {
                if (results[0] || results[1]) {
                    paramHelper.setParams([{'newUser.userId': edzoId}]);
                    $state.go('settings.userManagement.modifyUser');
                } else {
                    log.permissionError();
                }
            });
        }

        function openTeam(id) {
            $q.all([authenticationService.getRight('MEGTCSOPORT')]).then(function (results) {
                if (results[0]) {
                    paramHelper.setParams([
                        {'teams.sectionId': '0'},
                        {'teams.ageGroupId': '0'},
                        {'teams.team': id}
                    ]);
                    $state.go('athletes.teams.teamMembersList');
                } else {
                    log.permissionError();
                }
            });
        }

        function open(id) {
            if (vm.requestedData.SportoloKereses === true) {
                $q.all([authenticationService.getRight('MEGTEERJEL')]).then(function (results) {
                    if (results[0]) {
                        paramHelper.setParams([{'resultReportAthletes.Id': id}]);
                        $state.go('administration.resultReportAthletes');
                    } else {
                        log.permissionError();
                    }
                });
            } else {
                $q.all([authenticationService.getRight('MEGTCSERJEL')]).then(function (results) {
                    if (results[0]) {
                        paramHelper.setParams([{'resultReportTeam.Id': id}]);
                        $state.go('administration.resultReportTeam');
                    } else {
                        log.permissionError();
                    }
                });
            }
        }

        function radioButtonChecked(args) {
            vm.requestedData.Eredmeny = args.model.value; // Edzo ertekelese - Eredmeny int Edzői értékelés (Eredmeny = -2 => 1; Eredmeny = 2 => 5 )
        }

        function radioButtonClear() {
            vm.requestedData.Eredmeny = undefined;
        }

        function searchTeam() {
            vm.searched = 'team';
            getResultTeam();
            angular.element('#hidedContent').css('height', '0px');
            angular.element('#hidedContent2').css('height', '500px');
        }

        function actionBegin(args) {
            if (args.requestType && (args.requestType === 'paging' || args.requestType === 'sorting')) {
                args.cancel = true;
                args.previousPage = args.currentPage;
            }
        }

        function deleteResult() {
            var csapatEredmeny = undefined;
            var resultReportID = 0;
            vm.selectedRowsInGrid1 = grid.getSelectedRecords();
            vm.selectedRowsInGrid2 = grid2.getSelectedRecords();
            if (!vm.selectedRowsInGrid1[0] && !vm.selectedRowsInGrid2[0]) {
                csapatEredmeny = '';
            } else if (!vm.selectedRowsInGrid2[0] && vm.selectedRowsInGrid1[0]) {
                csapatEredmeny = false;
                resultReportID = vm.selectedRowsInGrid1[0].Id;
            } else if (!vm.selectedRowsInGrid1[0] && vm.selectedRowsInGrid2[0]) {
                csapatEredmeny = true;
                resultReportID = vm.selectedRowsInGrid2[0].Id;
            }
            swal({
                title: gettextCatalog.getString('Are you sure you want to delete the selected result report?'),
                text: gettextCatalog.getString('You will not be able to recover the deleted result report!'),
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: gettextCatalog.getString('Yes, delete this result report'),
                cancelButtonText: gettextCatalog.getString('Cancel'),
                closeOnConfirm: false,
                closeOnCancel: false
            }).then(function (isConfirm) {
                if (isConfirm.value) {
                    return dataservice.deleteResultsReport(resultReportID, csapatEredmeny)
                        .then(function () {
                            vm.showDelButton = false;
                            log.successMsg(gettextCatalog.getString('ResultReportDeleted'));
                            swal(gettextCatalog.getString('Deleted!'), '', 'success');
                            if (vm.requestedData.SportoloKereses === true) {
                                searchAthlete();
                            } else {
                                getResultTeam();
                            }
                        });
                }
            });
        }

        function Clear() {
            vm.requestedData = {
                Csapat: {CsapatId: undefined, CsapatNev: undefined}, // Csapat neve
                Szakosztaly: {SzakosztalyId: 0, SzakosztalyNev: undefined},
                Korcsoport: {KorcsoportId: undefined, KorcsoportNev: undefined},
                Edzo: {EdzoId: undefined, EdzoNev: undefined}, // int Edző (UserId)
                Sportolo: {SportoloId: undefined, SportoloNev: undefined, SzuletesiIdo: undefined}, // Sportoló adatai
                EredmenySzoveg: undefined, // Eredmény (szöveg input mező)
                DatumTol: undefined, // DateTime? Dátumtól
                DatumIg: undefined, // DateTime? Dátumig
                Helyszin: undefined, // string Helyszín
                Helyezes: undefined, // string Helyezés
                Ertekeles: undefined, // string Értékelés
                Jellege: undefined, // string Jellege
                Eredmeny: undefined, // int Edzői értékelés (Eredmeny = -2 => 1; Eredmeny = 2 => 5 )
                Foto: undefined, // (megjeleníteni kell kiválaszás esetén)
                SportoloKereses: true
            };
            vm.SelectedSectionID = 0;
            vm.SelectedAgeGroupID = 0;
            vm.SelectedCoachID = 0;
            vm.SelectedTeamID = 0;
        }

        function printAthleteResult(id) {
            new ej2.data.DataManager(grid.dataSource).executeQuery(new ej2.data.Query().where('Id', 'equal', id)).then(function (data) {
                $timeout(function () {
                    vm.reportParameters = {
                        nev: data.result[0].SportoloNev === null ? '' : data.result[0].SportoloNev,
                        szak: data.result[0].SzakosztalyId === null ? '' : data.result[0].SzakosztalyId,
                        kor: data.result[0].KorcsoportId === null ? '' : data.result[0].KorcsoportId,
                        dTol: data.result[0].DatumTol === null ? '' : data.result[0].DatumTol,
                        dIg: data.result[0].DatumIg === null ? '' : data.result[0].DatumIg,
                        eredmeny: data.result[0].Eredmeny === null ? '' : data.result[0].Eredmeny, // int Edzői értékelés (Eredmeny = -2 => 1; Eredmeny = 2 => 5 )
                        eIdo: data.result[0].EredmenyIdo === null ? '' : data.result[0].EredmenyIdo,
                        ePont: data.result[0].EredmenyPont === null ? '' : data.result[0].EredmenyPont,
                        eSzoveg: data.result[0].EredmenySzoveg === null ? '' : data.result[0].EredmenySzoveg, // Eredmény (szöveg input mező)
                        helyezes: data.result[0].Helyezes === null ? '' : data.result[0].Helyezes,
                        ertekeles: data.result[0].Ertekeles === null ? '' : data.result[0].Ertekeles
                    };

                    var dialogObj = angular.element('#printDialogA').data('ejDialog');
                    dialogObj.open();
                }, 100);
            });
        }

        function printTeamResult(id) {
            new ej2.data.DataManager(grid2.dataSource).executeQuery(new ej2.data.Query().where('Id', 'equal', id)).then(function (data) {
                $timeout(function () {
                    vm.reportParameters2 = {
                        nev: data.result[0].CsapatNev === null ? '' : data.result[0].CsapatNev,
                        szak: data.result[0].SzakosztalyId === null ? '' : data.result[0].SzakosztalyId,
                        kor: data.result[0].KorcsoportId === null ? '' : data.result[0].KorcsoportId,
                        dTol: data.result[0].DatumTol === null ? '' : data.result[0].DatumTol,
                        dIg: data.result[0].DatumIg === null ? '' : data.result[0].DatumIg,
                        helyezes: data.result[0].Helyezes === null ? '' : data.result[0].Helyezes,
                        ertekeles: data.result[0].Ertekeles === null ? '' : data.result[0].Ertekeles,
                        id: data.result[0].Id === null ? '' : data.result[0].Id
                    };

                    var dialogObj = angular.element('#printDialogT').data('ejDialog');
                    dialogObj.open();
                }, 1000);
            });
        }

        function teamsDataBound() {
            if (vm.teamsList.length === 1) {
                angular.element('#Team').ejDropDownList('selectItemByValue', vm.teamsList[0].value);
                vm.requestedData.Csapat.CsapatId = vm.teamsList[0].value;
            } else {
                angular.element('#Team').ejDropDownList('selectItemByValue', vm.SelectedTeamID);
                vm.requestedData.Csapat.CsapatId = vm.SelectedTeamID;
            }
        }

        function ageGroupDataBound() {
            if (vm.ageGroupList.length === 1) {
                angular.element('#ageGroup').ejDropDownList('selectItemByValue', vm.ageGroupList[0].value);
                vm.requestedData.Korcsoport.KorcsoportId = vm.ageGroupList[0].value;
            } else if (vm.athleteData.Korcsoport > 0) {
                angular.element('#ageGroup').ejDropDownList('selectItemByValue', vm.athleteData.Korcsoport);
                vm.requestedData.Korcsoport.KorcsoportId = vm.athleteData.Korcsoport;
            }
        }

        function coachDropDownListDataBound() {
            if (vm.coachList.length === 1) {
                angular.element('#coach').ejDropDownList('selectItemByValue', vm.coachList[0].value);
                vm.requestedData.Edzo.EdzoId = vm.coachList[0].value;
            } else if (vm.athleteData.JelenlegiEdzo > 0) {
                angular.element('#coach').ejDropDownList('selectItemByValue', vm.athleteData.JelenlegiEdzo);
            }
        }

        function sectionDataBound() {
            if (vm.sectionList.length === 1) {
                //angular.element('#section').ejDropDownList('selectItemByValue', vm.sectionList[0].value);
                vm.requestedData.Szakosztaly.SzakosztalyId = vm.sectionList[0].value;
            } else if (vm.athleteData.IdSzakosztaly > 0) {
                angular.element('#section').ejDropDownList('selectItemByValue', vm.athleteData.IdSzakosztaly);
                vm.requestedData.Szakosztaly.SzakosztalyId = vm.athleteData.IdSzakosztaly;
            }
        }

        function clearYear() {
            vm.selectedBirthDate = undefined;
            angular.element('#birthDate').ejDatePicker({value: new Date('')});
        }

        function clearTeam() {
            vm.SelectedTeamID = undefined;
            angular.element('#Team').ejDropDownList({selectedIndex: -1});
        }

        function clearSection() {
            vm.SelectedSectionID = undefined;
            angular.element('#section').ejDropDownList({selectedIndex: -1});
        }

        function clearAgeGroup() {
            vm.SelectedAgeGroupID = undefined;
            angular.element('#ageGroup').ejDropDownList({selectedIndex: -1});
        }

        function clearCoach() {
            vm.SelectedCoachID = undefined;
            angular.element('#coach').ejDropDownList({selectedIndex: -1});
        }

        function clearSelectdateFrom() {
            vm.selectdateFrom = undefined;
            angular.element('#selectdateFrom').ejDatePicker({value: new Date('')});
            getActualCoachesList();
        }

        function clearSelectdateTo() {
            vm.selectdateTo = undefined;
            angular.element('#selectdateTo').ejDatePicker({value: new Date('')});
            getActualCoachesList();
        }
    }
})();


(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.reports.raceResultsReport')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'reports.raceResultsReport',
                config: {
                    url: '/raceResultsReport',
                    templateUrl: 'app/reports/raceResultsReport/raceResultsReport.html',
                    controller: 'RaceResultsReportController',
                    controllerAs: 'vm',
                    title: 'RaceResultsReport',
                    settings: {
                        navId: 2114,
                        level: 2,
                        order: 11,
                        orderTitle_hu: 'Versenyeredmények',
                        orderTitle_en: 'Competition Results',
                        parentId: 4,
                        content: 'RaceResultsReport',
                        activatorPermission: '"KMVERSEREDM"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.reports')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'reports',
                config: {
                    title: 'Reports',
                    url: '/reports',
                    templateUrl: 'app/reports/reports.html',
                    settings: {
                        navId: 4,
                        level: 1,
                        order: 4,
                        parentId: 0,
                        content: 'Reports',
                        activatorPermission: ['"HIANYZASMEGT"', '"KMEVESJELEDZO"', '"KMEVESJELSZO"', '"KMEVESJELSP"', '"TomAntr"', '"ESZKNYILVMEGT"',
                                              '"ESZKNYILVMEGT"', '"AssetManagement"', '"AthleteTransfer"', '"MEGTIDEGENKOLTSTERV"', '"MEGTKPFELM"',
                                              '"DUPLIKALTMEGT"', '"LEJAROMEGT"', '"HEALTHREPORT"', '"VEZETOIHJ"', '"VEZETOIEV"', '"VEZETOIHJ"',
                                              '"MEGTHAVIJEL"', '"VEZETOIHE"', '"KMHAVIVERSTERV"', '"KMATFELJATSZ"', '"KMVERSEREDM"', '"MEGTSPFELM"',
                                              '"EDZLATSTAT"', '"MEGTHETIEDZTERVKIMUT"', '"UTAZTERVMEGT"', '"KMSPORTELETKOR"', '"KMSPORTEDZO"',
                                              '"KMSPORTALAK"', '"KMSPORTSZAK"', '"KMSPORTALAKSZO"', '"SPJELENLETINELK"', '"KMBELEPEDZO"',
                                               '"KMBELSZAK"', '"KMKILEPEDZO"', '"KMKILSZAK"']
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    SportSpecificReportController.$inject = ["log", "dataservice", "$rootScope", "gettextCatalog", "authenticationService", "$scope", "$filter", "$state", "paramHelper", "$q"];
    angular
        .module('app.reports.sportSpecificReport')
        .controller('SportSpecificReportController', SportSpecificReportController);

    function SportSpecificReportController(log, dataservice, $rootScope, gettextCatalog, authenticationService, $scope, $filter, $state, paramHelper, $q) {
        var vm = this;
        $rootScope.title = gettextCatalog.getString('SportSpecificReport');
        vm.dateFromValue = new Date(new Date().getFullYear(), 0, 1);
        vm.dateToValue = new Date(new Date().getFullYear(), 11, 31);
        vm.sectionList = [];
        vm.ageGroupList = [];
        vm.tipusList = [];
        vm.sectionId = 0;
        vm.ageGroupId = 0;
        vm.tipusId = 0;
        vm.querycellinfo = querycellinfo;
        vm.sectionDataBound = sectionDataBound;
        vm.ageGroupDataBound = ageGroupDataBound;
        vm.tipusDataBound = tipusDataBound;
        vm.sectionSelect = sectionSelect;
        vm.ageGroupSelect = ageGroupSelect;
        vm.tipusSelect = tipusSelect;
        vm.getData = getData;
        vm.dataList = [];
        vm.dataFelmeroElem = [];
        vm.testdata = [];
        vm.test = [];
        vm.columns = [
            {field: 'SportoloID', headerText: 'Id', textAlign: 'left', isPrimaryKey: true, visible: false},
            {field: 'SportoloNeve', headerText: gettextCatalog.getString('AthleteName'), textAlign: 'left', width: 80},
            {field: 'datum', headerText: gettextCatalog.getString('Date'), textAlign: 'left', width: 80}
        ];

        var Grid2 = new ej2.grids.Grid({
            dataSource: vm.test,
            columns: vm.columns,
            toolbar: $rootScope.toolbarItems,
            allowPaging: false,
            allowSorting: false,
            allowTextWrap: false,
            allowExcelExport: false,
            locale: 'hu-HU',
            gridLines: 'Both',
            queryCellInfo: function (arg) {
                var cellIndex = -1;
                if (arg.column.field) {
                    cellIndex = parseInt(arg.column.field.replace('c', ''));
                    if (!(cellIndex >= 0)) {
                        return;
                    }
                }
                var cell = angular.element(arg.cell);
                if (vm.testdata && vm.testdata.length > 0 && cellIndex >= 0) {
                    var rowIndex = getRowIndex(arg.data.SportoloID, arg.data.datum);
                    if (vm.testdata[rowIndex].Colors[cellIndex] && vm.testdata[rowIndex].Colors[cellIndex].length > 0) {
                        cell.css('background-color', vm.testdata[rowIndex].Colors[cellIndex]);
                    }
                }
            }
        });

        Grid2.appendTo('#Grid2');

        activate();

        function activate() {
            authenticationService.getRight('MEGTSPFELM').then(function (result) {
                if (result !== true) {
                    log.permissionError(true);
                } else {
                    $q.all([
                        getSections(),
                        authenticationService.getRight('MEGTSPFELM'),
                        paramHelper.getParams([], ['sportSpecificReport.SportoloID'])
                    ]).then(function (results) {
                        console.log('results', results);
                    }).catch(function () {
                        log.unknownError();
                    });
                }
            }).catch(function () {
                log.unknownError();
            });
        }

        function resetColumns() {
            vm.columns = [
                {field: 'SportoloID', headerText: 'Id', textAlign: 'left', isPrimaryKey: true, visible: false},
                {field: 'SportoloNeve', headerText: gettextCatalog.getString('AthleteName'), textAlign: 'left', width: 80},
                {field: 'datum', headerText: gettextCatalog.getString('Date'), textAlign: 'left', width: 80}
            ];
        }

        function getData() {
            if (!(vm.tipusId > 0)) {
                return;
            }
            vm.testdata = [];
            vm.test = [];
            vm.dataFelmeroElem = [];
            dataservice.getFelmeroElemList(vm.tipusId).then(function (elemResponse) {
                vm.dataFelmeroElem = elemResponse.itemsList;
                console.log('getFelmeroElemList() elemResponse', elemResponse);
                resetColumns();
                dataservice.getSportagSpecReport(vm.tipusId, vm.ageGroupId, vm.sectionId, vm.dateFromValue, vm.dateToValue).then(function(data) {
                    vm.testdata = data.itemsList;
                    console.log('getSportagSpecReport() data', data);
                    vm.test = [];
                    for (var i = 0; i < vm.testdata.length; i++) {
                        var line = {};
                        line.SportoloID = vm.testdata[i].SportoloID;
                        line.SportoloNeve = vm.testdata[i].SportoloNeve;
                        line.datum = vm.testdata[i].datum;
                        for (var c = 0; c < vm.dataFelmeroElem.length; c++) {
                            var fieldName = 'c' + c;
                            line[fieldName] = '';
                        }
                        vm.test.push(line);
                    }
                    var strArr = [];
                    resetColumns();
                    for (var i = 0; i < vm.dataFelmeroElem.length; i++) {
                        var fieldName = vm.dataFelmeroElem[i].fieldName;
                        strArr.push(fieldName);
                        vm.columns.push({field: vm.dataFelmeroElem[i].fieldName, headerText: vm.dataFelmeroElem[i].Nev, textAlign: 'center', width: 120});
                        for (var j = 0; j < vm.test.length; j++) {
                            vm.test[j][strArr[i]] = vm.testdata[j].Adatok1D[i];
                        }
                    }
                    Grid2.dataSource = vm.test;
                    Grid2.columns = vm.columns;
                    Grid2.refreshColumns();
                    Grid2.refresh();
                });
            });
        }

        function querycellinfo(arg) {
            var $element = angular.element(arg.cell);
            if (vm.testdata && vm.testdata.length > 0 && arg.cell.cellIndex >= 3) {
                var rowIndex = getRowIndex(arg.data.SportoloID, arg.data.datum);
                if (vm.testdata[rowIndex].Colors[arg.cell.cellIndex - 3] && vm.testdata[rowIndex].Colors[arg.cell.cellIndex - 3].length > 0) {
                    $element.css('background-color', vm.testdata[rowIndex].Colors[arg.cell.cellIndex - 3]);
                }
            }
        }

        function getRowIndex(SportoloID, datum) {
            //console.log('getRowIndex('+SportoloID+','+datum+') vm.testdata' , vm.testdata);
            for (var i = 0; i < vm.testdata.length; i++) {
                if (vm.testdata[i].SportoloID == SportoloID && vm.testdata[i].datum == datum) {
                    return i;
                }
            }
            return -1;
        }

        function getSections() {
            return dataservice.sectionDropDownList().then(function (data) {
                vm.sectionList = data.itemsList;
            });
        }

        function getAgeGroups() {
            return dataservice.ageGroupDropDownList(vm.sectionId).then(function (data) {
                vm.ageGroupList = data.itemsList;
                vm.ageGroupList.unshift({text: gettextCatalog.getString('All'), value: 0});
            });
        }

        function getTipusList() {
            return dataservice.felmeroElemFejDropDownList(vm.sectionId).then(function(data) {
                vm.tipusList = data.itemsList;
            });
        }

        function sectionDataBound() {
            if (vm.sectionList.length === 1) {
                vm.sectionId = vm.sectionList[0].value;
                angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.sectionList[0].value);
            } else {
                angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.sectionId);
            }
        }

        function ageGroupDataBound() {
            if (vm.ageGroupList.length === 1) {
                angular.element('#ageGroupDropDown').ejDropDownList('selectItemByValue', vm.ageGroupList[0].value);
            } else {
                angular.element('#ageGroupDropDown').ejDropDownList('selectItemByValue', vm.ageGroupId);
            }
        }

        function tipusDataBound() {
            if (vm.tipusList.length === 1) {
                angular.element('#tipusDropDown').ejDropDownList('selectItemByValue', vm.tipusList[0].value);
            } else {
                angular.element('#tipusDropDown').ejDropDownList('selectItemByValue', vm.tipusId);
            }
        }

        function sectionSelect(args) {
            vm.sectionId = args.value;
            vm.tipusId = -1;
            getAgeGroups();
            getTipusList();
        }

        function ageGroupSelect(args) {
            vm.ageGroupId = args.value;
            getData();
        }

        function tipusSelect(args) {
            vm.tipusId = args.value;
            getData();
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.reports.sportSpecificReport')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'reports.sportSpecificReport',
                config: {
                    url: '/sportSpecificReport',
                    templateUrl: 'app/reports/sportSpecificReport/sportSpecificReport.html',
                    controller: 'SportSpecificReportController',
                    controllerAs: 'vm',
                    title: 'SportSpecificReport',
                    settings: {
                        navId: 2194,
                        level: 2,
                        order: 19,
                        orderTitle_hu: 'Sportágspecifikus felmérő kimutatás',
                        orderTitle_en: 'Sport Specific Test Report',
                        parentId: 4,
                        content: 'SportSpecificReport',
                        activatorPermission: '"MEGTSPFELM"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    ActiveAthletesByAgeController.$inject = ["log", "dataservice", "$rootScope", "gettextCatalog", "authenticationService", "$scope", "$state", "paramHelper"];
    angular
        .module('app.reports.statisticalReports.activeAthletesByAge')
        .controller('ActiveAthletesByAgeController', ActiveAthletesByAgeController);

    function ActiveAthletesByAgeController(log, dataservice, $rootScope, gettextCatalog, authenticationService, $scope, $state, paramHelper) {
        var vm = this;
        $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('ActiveAthletesByAge');
        vm.sectionList = [];

        vm.columnWith = 100;
        vm.columns = [
            {field: 'SzuletesiEv', headerText: gettextCatalog.getString('BirthYear'), width: vm.columnWith, cssClass: 'rotate90degreegridheader4', template: '#aaba_year'},
            {field: 'Szam', headerText: gettextCatalog.getString('NumberOfAthletes'), width: vm.columnWith, cssClass: 'rotate90degreegridheader4'},
            {field: 'SzamFiu', headerText: gettextCatalog.getString('NumberOfBoys'), width: vm.columnWith, cssClass: 'rotate90degreegridheader4'},
            {field: 'SzamLany', headerText: gettextCatalog.getString('NumberOfGirls'), width: vm.columnWith, cssClass: 'rotate90degreegridheader4'}
        ];

        vm.Date = new Date();
        vm.selectedSection = 0;
        vm.openSection = openSection;
        vm.openBirthYear = openBirthYear;

        vm.showEachSections = false;
        vm.accessibleSections = [];
        vm.accessibleSectionsStr = [];
        vm.checkboxChanged = checkboxChanged;
        vm.checkboxEnabled = true;
        vm.checked = false;
        vm.userId = -1;
        vm.isSectionLeader = false;
        vm.isAdmin = false;
        vm.sectionList = [];
        vm.griddata = [];

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItems,
            allowPaging: true,
            allowTextWrap: true,
            allowSorting: true,
            allowExcelExport: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#Grid'), $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        activate();

        function activate() {
            authenticationService.getRight('KMSPORTELETKOR').then(function (results) {
                if (results !== true) {
                    log.permissionError(true);
                } else {
                    getSectionList().then(function () {
                        initColumns();
                        getNumbers(vm.Date);
                    });
                }
            });
        }

        function getSectionList() {
            return dataservice.sectionDropDownListAll()
                .then(function (data) {
                    vm.sectionList = data.itemsList;
                });
        }

        function getNumbers(date) {
            dataservice.activeAthletesByAge(date, vm.selectedSection)
                .then(function (data) {
                    grid.dataSource = data.itemsList;
                    vm.userId = data.userId;
                    vm.isAdmin = data.isAdmin;
                    vm.isSectionLeader = data.isSectionLeader;
                    vm.accessibleSections = data.felhasznaloSzakosztalyai;
                    vm.accessibleSectionsStr = data.felhasznaloSzakosztalyaiStr;
                    vm.yearListFull = data.itemsList;
                });
        }

        function openSection(sectionID, year) {
            var sectionBelongsToUser = false;
            for (var i = 0; i < vm.accessibleSections.length; i++) {
                if (vm.accessibleSections[i] == sectionID) {
                    sectionBelongsToUser = true;
                    break;
                }
            }
            if (sectionBelongsToUser || vm.isAdmin) {
                var yearint = parseInt(year);
                paramHelper.setParams([
                    {'sectionID': sectionID},
                    {'year': yearint}
                ]);
                $state.go('reports.statisticalReports.athletesByBirthYear');
            } else {
                log.warningMsg('You do not have permission to access the selected section details!');
            }
        }

        function openBirthYear(year) {
            paramHelper.setParams([
                {'year': year}
            ]);
            $state.go('reports.statisticalReports.athletesByYear');
        }

        function checkboxChanged(args) {
            vm.showEachSections = args.value;
            filterAthletes();
        }

        function initColumns() {
            for (var i = 0; i < vm.sectionList.length; i++) {
                switch (vm.sectionList[i].value) {
                    case 1:
                        vm.columns.push({field: '_sz_01', headerText: vm.sectionList[i].text, width: vm.columnWith, cssClass: 'rotate90degreegridheader4', template: '#aaba_ops01'});
                        break;
                    case 2:
                        vm.columns.push({field: '_sz_02', headerText: vm.sectionList[i].text, width: vm.columnWith, cssClass: 'rotate90degreegridheader4', template: '#aaba_ops02'});
                        break;
                    case 3:
                        vm.columns.push({field: '_sz_03', headerText: vm.sectionList[i].text, width: vm.columnWith, cssClass: 'rotate90degreegridheader4', template: '#aaba_ops03'});
                        break;
                    case 4:
                        vm.columns.push({field: '_sz_04', headerText: vm.sectionList[i].text, width: vm.columnWith, cssClass: 'rotate90degreegridheader4', template: '#aaba_ops04'});
                        break;
                    case 5:
                        vm.columns.push({field: '_sz_05', headerText: vm.sectionList[i].text, width: vm.columnWith, cssClass: 'rotate90degreegridheader4', template: '#aaba_ops05'});
                        break;
                    case 6:
                        vm.columns.push({field: '_sz_06', headerText: vm.sectionList[i].text, width: vm.columnWith, cssClass: 'rotate90degreegridheader4', template: '#aaba_ops06'});
                        break;
                    case 7:
                        vm.columns.push({field: '_sz_07', headerText: vm.sectionList[i].text, width: vm.columnWith, cssClass: 'rotate90degreegridheader4', template: '#aaba_ops07'});
                        break;
                    case 8:
                        vm.columns.push({field: '_sz_08', headerText: vm.sectionList[i].text, width: vm.columnWith, cssClass: 'rotate90degreegridheader4', template: '#aaba_ops08'});
                        break;
                    case 9:
                        vm.columns.push({field: '_sz_09', headerText: vm.sectionList[i].text, width: vm.columnWith, cssClass: 'rotate90degreegridheader4', template: '#aaba_ops09'});
                        break;
                    case 10:
                        vm.columns.push({field: '_sz_10', headerText: vm.sectionList[i].text, width: vm.columnWith, cssClass: 'rotate90degreegridheader4', template: '#aaba_ops10'});
                        break;
                    case 11:
                        vm.columns.push({field: '_sz_11', headerText: vm.sectionList[i].text, width: vm.columnWith, cssClass: 'rotate90degreegridheader4', template: '#aaba_ops11'});
                        break;
                    case 12:
                        vm.columns.push({field: '_sz_12', headerText: vm.sectionList[i].text, width: vm.columnWith, cssClass: 'rotate90degreegridheader4', template: '#aaba_ops12'});
                        break;
                    case 13:
                        vm.columns.push({field: '_sz_13', headerText: vm.sectionList[i].text, width: vm.columnWith, cssClass: 'rotate90degreegridheader4', template: '#aaba_ops13'});
                        break;
                    case 14:
                        vm.columns.push({field: '_sz_14', headerText: vm.sectionList[i].text, width: vm.columnWith, cssClass: 'rotate90degreegridheader4', template: '#aaba_ops14'});
                        break;
                    case 15:
                        vm.columns.push({field: '_sz_15', headerText: vm.sectionList[i].text, width: vm.columnWith, cssClass: 'rotate90degreegridheader4', template: '#aaba_ops15'});
                        break;
                    case 16:
                        vm.columns.push({field: '_sz_16', headerText: vm.sectionList[i].text, width: vm.columnWith, cssClass: 'rotate90degreegridheader4', template: '#aaba_ops16'});
                        break;
                    case 17:
                        vm.columns.push({field: '_sz_17', headerText: vm.sectionList[i].text, width: vm.columnWith, cssClass: 'rotate90degreegridheader4', template: '#aaba_ops17'});
                        break;
                    case 18:
                        vm.columns.push({field: '_sz_18', headerText: vm.sectionList[i].text, width: vm.columnWith, cssClass: 'rotate90degreegridheader4', template: '#aaba_ops18'});
                        break;
                    case 19:
                        vm.columns.push({field: '_sz_19', headerText: vm.sectionList[i].text, width: vm.columnWith, cssClass: 'rotate90degreegridheader4', template: '#aaba_ops19'});
                        break;
                    case 20:
                        vm.columns.push({field: '_sz_20', headerText: vm.sectionList[i].text, width: vm.columnWith, cssClass: 'rotate90degreegridheader4', template: '#aaba_ops20'});
                        break;
                    case 21:
                        vm.columns.push({field: '_sz_21', headerText: vm.sectionList[i].text, width: vm.columnWith, cssClass: 'rotate90degreegridheader4', template: '#aaba_ops21'});
                        break;
                    case 22:
                        vm.columns.push({field: '_sz_22', headerText: vm.sectionList[i].text, width: vm.columnWith, cssClass: 'rotate90degreegridheader4', template: '#aaba_ops22'});
                        break;
                    case 23:
                        vm.columns.push({field: '_sz_23', headerText: vm.sectionList[i].text, width: vm.columnWith, cssClass: 'rotate90degreegridheader4', template: '#aaba_ops23'});
                        break;
                    case 24:
                        vm.columns.push({field: '_sz_24', headerText: vm.sectionList[i].text, width: vm.columnWith, cssClass: 'rotate90degreegridheader4', template: '#aaba_ops24'});
                        break;
                    case 25:
                        vm.columns.push({field: '_sz_25', headerText: vm.sectionList[i].text, width: vm.columnWith, cssClass: 'rotate90degreegridheader4', template: '#aaba_ops25'});
                        break;
                    case 26:
                        vm.columns.push({field: '_sz_26', headerText: vm.sectionList[i].text, width: vm.columnWith, cssClass: 'rotate90degreegridheader4', template: '#aaba_ops26'});
                        break;
                    case 27:
                        vm.columns.push({field: '_sz_27', headerText: vm.sectionList[i].text, width: vm.columnWith, cssClass: 'rotate90degreegridheader4', template: '#aaba_ops27'});
                        break;
                    case 28:
                        vm.columns.push({field: '_sz_28', headerText: vm.sectionList[i].text, width: vm.columnWith, cssClass: 'rotate90degreegridheader4', template: '#aaba_ops28'});
                        break;
                    case 29:
                        vm.columns.push({field: '_sz_29', headerText: vm.sectionList[i].text, width: vm.columnWith, cssClass: 'rotate90degreegridheader4', template: '#aaba_ops29'});
                        break;
                    case 30:
                        vm.columns.push({field: '_sz_30', headerText: vm.sectionList[i].text, width: vm.columnWith, cssClass: 'rotate90degreegridheader4', template: '#aaba_ops30'});
                        break;
                    case 31:
                        vm.columns.push({field: '_sz_31', headerText: vm.sectionList[i].text, width: vm.columnWith, cssClass: 'rotate90degreegridheader4', template: '#aaba_ops31'});
                        break;
                    case 32:
                        vm.columns.push({field: '_sz_32', headerText: vm.sectionList[i].text, width: vm.columnWith, cssClass: 'rotate90degreegridheader4', template: '#aaba_ops32'});
                        break;
                    case 33:
                        vm.columns.push({field: '_sz_33', headerText: vm.sectionList[i].text, width: vm.columnWith, cssClass: 'rotate90degreegridheader4', template: '#aaba_ops33'});
                        break;
                    case 34:
                        vm.columns.push({field: '_sz_34', headerText: vm.sectionList[i].text, width: vm.columnWith, cssClass: 'rotate90degreegridheader4', template: '#aaba_ops34'});
                        break;
                    case 35:
                        vm.columns.push({field: '_sz_35', headerText: vm.sectionList[i].text, width: vm.columnWith, cssClass: 'rotate90degreegridheader4', template: '#aaba_ops35'});
                        break;
                    case 36:
                        vm.columns.push({field: '_sz_36', headerText: vm.sectionList[i].text, width: vm.columnWith, cssClass: 'rotate90degreegridheader4', template: '#aaba_ops36'});
                        break;
                    case 37:
                        vm.columns.push({field: '_sz_37', headerText: vm.sectionList[i].text, width: vm.columnWith, cssClass: 'rotate90degreegridheader4', template: '#aaba_ops37'});
                        break;
                    case 38:
                        vm.columns.push({field: '_sz_38', headerText: vm.sectionList[i].text, width: vm.columnWith, cssClass: 'rotate90degreegridheader4', template: '#aaba_ops38'});
                        break;
                    case 39:
                        vm.columns.push({field: '_sz_39', headerText: vm.sectionList[i].text, width: vm.columnWith, cssClass: 'rotate90degreegridheader4', template: '#aaba_ops39'});
                        break;
                    case vm.columnWith:
                        vm.columns.push({field: '_sz_vm.columnWith', headerText: vm.sectionList[i].text, width: vm.columnWith, cssClass: 'rotate90degreegridheader4', template: '#aaba_opsvm.columnWith'});
                        break;
                }
            }
            grid.refreshColumns();
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.reports.statisticalReports.activeAthletesByAge')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'reports.statisticalReports.activeAthletesByAge',
                config: {
                    url: '/activeAthletesByAge',
                    templateUrl: 'app/reports/statisticalReports/activeAthletesByAge/activeAthletesByAge.html',
                    controller: 'ActiveAthletesByAgeController',
                    controllerAs: 'vm',
                    title: 'ActiveAthletesByAge',
                    settings: {
                        navId: 37214,
                        level: 3,
                        order: 7,
                        orderTitle_hu: 'Aktív sportolók kor szerint',
                        orderTitle_en: 'Number of Active Athletes by Age',
                        parentId: 214,
                        content: 'ActiveAthletesByAge',
                        activatorPermission: '"KMSPORTELETKOR"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    ActiveAthletesByCoachController.$inject = ["log", "dataservice", "$q", "$rootScope", "gettextCatalog", "authenticationService", "$scope", "$state", "paramHelper"];
    angular
        .module('app.reports.statisticalReports.activeAthletesByCoach')
        .controller('ActiveAthletesByCoachController', ActiveAthletesByCoachController);

    function ActiveAthletesByCoachController(log, dataservice, $q, $rootScope, gettextCatalog, authenticationService, $scope, $state, paramHelper) {
        var vm = this;
        $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('AthletesByCoach');
        vm.sectionList = [];
        vm.athleteList = [];
        vm.columns = [{
            field: 'EdzoNeve',
            headerText: gettextCatalog.getString('CoachName'), template: '#acatbycotemplateDataColumn1', width: 100
        }, {
            field: 'SzakosztalyNeve',
            headerText: gettextCatalog.getString('Section'), template: '#acatbycotemplateDataColumn2', width: 100
        }, {
            field: 'Szam',
            headerText: gettextCatalog.getString('NumberOfAthletes'),
            template: '#acatbycotemplateDataColumn3',
            width: 100
        }, {
            field: 'SzamFiu',
            headerText: gettextCatalog.getString('NumberOfBoys'), template: '#acatbycotemplateDataColumn4', width: 100
        }, {
            field: 'SzamLany',
            headerText: gettextCatalog.getString('NumberOfGirls'), template: '#acatbycotemplateDataColumn5', width: 100
        }];
        vm.queryDate = new Date();
        vm.dateChange = dateChange;
        vm.openCoach = openCoach;
        vm.openSection = openSection;
        vm.openAthleteListByCoach = openAthleteListByCoach;

        vm.sectionList = [];
        vm.athleteListFull = [];
        vm.showEachSections = false;
        vm.accessibleSections = [];
        vm.checkboxChanged = checkboxChanged;
        vm.checkboxEnabled = true;
        vm.checkboxchangedonce = false;
        vm.checked = false;
        vm.userId = -1;
        vm.isSectionLeader = false;
        vm.isAdmin = false;

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItems,
            allowPaging: true,
            allowTextWrap: true,
            allowSorting: true,
            allowExcelExport: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#Grid'), $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        activate();

        function activate() {
            authenticationService.getRight('KMSPORTEDZO').then(function (results) {
                if (results !== true) {
                    log.permissionError(true);
                } else {
                    getNumbers(vm.queryDate);
                }
            });
        }

        function checkboxChanged(args) {
            vm.showEachSections = args.value;
            filterAthletes();
        }

        function filterAthletes() {
            vm.athleteList = [];
            if (!vm.showEachSections) {
                for (var i = 0; i < vm.athleteListFull.length; i++) {
                    for (var s = 0; s < vm.accessibleSections.length; s++) {
                        if (vm.athleteListFull[i].SzakosztalyId == vm.accessibleSections[s]) {
                            vm.athleteList.push(vm.athleteListFull[i]);
                        }
                    }
                }
            } else {
                vm.athleteList = vm.athleteListFull;
                grid.dataSource = vm.athleteList;
            }
        }

        function getNumbers(date) {
            dataservice.athletesByCoach(date)
                .then(function (data) {
                    vm.userId = data.userId;
                    vm.isAdmin = data.isAdmin;
                    vm.isSectionLeader = data.isSectionLeader;
                    vm.athleteListFull = data.itemsList;
                    vm.accessibleSections = data.felhasznaloSzakosztalyai;
                    if (data.isAdmin == true) {
                        vm.checked = true;
                    }
                    filterAthletes();
                });
        }

        function openSection(sectionId) {
            new ej2.data.DataManager(grid.dataSource).executeQuery(new ej2.data.Query().where('SzakosztalyId', 'equal', sectionId)).then(function (data) {
                var sectionName = data.result[0].SzakosztalyNeve;

                var sectionBelongsToUser = false;
                for (var i = 0; i < vm.accessibleSections.length; i++) {
                    if (vm.accessibleSections[i] == sectionId) {
                        sectionBelongsToUser = true;
                        break;
                    }
                }
                if (sectionBelongsToUser || vm.isAdmin) {
                    paramHelper.setParams([
                        {'state': 'activeAthletes'},
                        {'sectionId': sectionId},
                        {'sectionName': sectionName},
                        {'dateFrom': vm.queryDate},
                        {'dateTo': vm.queryDate},
                        {'gender': 'allgender'}
                    ]);
                    $state.go('reports.statisticalReports.listAthletes');
                } else {
                    log.htmlWarning(gettextCatalog.getString('You do not have permission to access the selected section details!') + '<br><br>' + gettextCatalog.getString(sectionName));
                }
            });
        }

        function openAthleteListByCoach(coachId, sectionId, gender2) {
            new ej2.data.DataManager(grid.dataSource).executeQuery(new ej2.data.Query().where('SzakosztalyId', 'equal', sectionId)).then(function (data) {
                var sectionName = data.result[0].SzakosztalyNeve;
                var coachName = data.result[0].EdzoNeve;
                var gender = gender2 === 0 ? 'allgender' : (gender2 === 1 ? 'male' : 'female');

                var sectionBelongsToUser = false;
                for (var i = 0; i < vm.accessibleSections.length; i++) {
                    if (vm.accessibleSections[i] == sectionId) {
                        sectionBelongsToUser = true;
                        break;
                    }
                }
                if (sectionBelongsToUser || vm.isAdmin) {
                    paramHelper.setParams([
                        {'state': 'athletesByCoach'},
                        {'coachId': coachId},
                        {'sectionId': sectionId},
                        {'gender': gender},
                        {'coachName': coachName},
                        {'dateFrom': vm.queryDate},
                        {'dateTo': vm.queryDate}
                    ]);
                    $state.go('reports.statisticalReports.listAthletes');
                } else {
                    log.htmlWarning(gettextCatalog.getString('You do not have permission to access the selected section details!') + '<br><br>' + gettextCatalog.getString(sectionName));
                }
            });
        }

        function openCoach(edzoId) {
            $q.all([authenticationService.getRight('MODFELH'), authenticationService.getRight('MEGTFELH')]).then(function (results) {
                if (results[0] || results[1]) {
                    paramHelper.setParams([{'newUser.userId': edzoId}]);
                    $state.go('settings.userManagement.modifyUser');
                } else {
                    log.permissionError();
                }
            });
        }

        function dateChange() {
            getNumbers(vm.queryDate);
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.reports.statisticalReports.activeAthletesByCoach')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'reports.statisticalReports.activeAthletesByCoach',
                config: {
                    url: '/activeAthletesByCoach',
                    templateUrl: 'app/reports/statisticalReports/activeAthletesByCoach/activeAthletesByCoach.html',
                    controller: 'ActiveAthletesByCoachController',
                    controllerAs: 'vm',
                    title: 'AthletesByCoach',
                    settings: {
                        navId: 34214,
                        level: 3,
                        order: 4,
                        orderTitle_hu: 'Sportolók száma edzőnként',
                        orderTitle_en: 'Number of Active Athletes by Coaches',
                        parentId: 214,
                        content: 'AthletesByCoach',
                        activatorPermission: '"KMSPORTEDZO"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    ActiveAthletesByMonthController.$inject = ["log", "dataservice", "$rootScope", "gettextCatalog", "authenticationService", "$scope", "$state", "paramHelper", "$filter"];
    angular
        .module('app.reports.statisticalReports.activeAthletesByMonth')
        .controller('ActiveAthletesByMonthController', ActiveAthletesByMonthController);

    function ActiveAthletesByMonthController(log, dataservice, $rootScope, gettextCatalog, authenticationService, $scope, $state, paramHelper, $filter) {
        var vm = this;
        $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('ActiveAthletesByMonth');
        vm.sectionList = [];

        initColumns();

        vm.DateFrom = new Date();
        vm.DateFrom.setMonth(vm.DateFrom.getMonth() - 1);
        vm.DateTo = new Date();
        vm.dateFromChanged = dateFromChanged;
        vm.dateToChanged = dateToChanged;
        vm.openSection = openSection;
        vm.openAthletes = openAthletes;
        vm.openJoined = openJoined;
        vm.openLeaving = openLeaving;

        vm.accessibleSections = [];
        vm.accessibleSectionsStr = [];
        vm.userId = -1;
        vm.isSectionLeader = false;
        vm.isAdmin = false;

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItems,
            allowPaging: true,
            allowTextWrap: true,
            allowSorting: true,
            allowExcelExport: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#Grid'), $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        activate();

        function activate() {
            authenticationService.getRight('KMSPORTALAK').then(function (results) {
                if (results !== true) {
                    log.permissionError(true);
                } else {
                    getSectionList().then(function () {
                        getNumbers(vm.DateFrom, vm.DateTo);
                        initColumns();
                    });
                }
            });
        }

        function initColumns() {
            vm.columns = [
                {field: 'SzuletesiEv', headerText: gettextCatalog.getString('Month'), textAlign: 'left', width: 115, cssClass: 'rotate90degreegridheader4'},
                {field: 'Szam', headerText: gettextCatalog.getString('NumberOfAthletes'), textAlign: 'left', width: 100, cssClass: 'rotate90degreegridheader4', template: '#aabm_allgender'},
                {field: 'SzamFiu', headerText: gettextCatalog.getString('NumberOfBoys'), textAlign: 'left', width: 100, cssClass: 'rotate90degreegridheader4', template: '#aabm_male'},
                {field: 'SzamLany', headerText: gettextCatalog.getString('NumberOfGirls'), textAlign: 'left', width: 100, cssClass: 'rotate90degreegridheader4', template: '#aabm_female'},
                {field: 'SzamErkezett', headerText: gettextCatalog.getString('Belepett'), textAlign: 'left', width: 100, cssClass: 'rotate90degreegridheader4', template: '#aabm_joined'},
                {field: 'SzamKilepett', headerText: gettextCatalog.getString('Kilepett'), textAlign: 'left', width: 100, cssClass: 'rotate90degreegridheader4', template: '#aabm_leaving'}
            ];
            for (var i = 0; i < vm.sectionList.length; i++) {
                vm.columns.push({field: 'c' + vm.sectionList[i].value, headerText: vm.sectionList[i].text, textAlign: 'left', width: 100, cssClass: 'rotate90degreegridheader4', template: '#aabm_ops' + vm.sectionList[i].value});
                if (i === (vm.sectionList.length - 1)) {
                    grid.columns = vm.columns;
                    grid.refreshColumns();
                }
            }
        }

        function getNumbers(dateFrom, dateTo) {
            dateFrom = $filter('dateToISOFilter')(dateFrom);
            dateTo = $filter('dateToISOFilter')(dateTo);
            dataservice.activeAthletesByMonth(dateFrom, dateTo)
                .then(function (data) {
                    vm.accessibleSections = data.felhasznaloSzakosztalyai;
                    vm.accessibleSectionsStr = data.felhasznaloSzakosztalyaiStr;
                    vm.userId = data.userId;
                    vm.isAdmin = data.isAdmin;
                    vm.isSectionLeader = data.isSectionLeader;
                    grid.dataSource = $filter('dateStringFilter')(data.itemsList, 'SzuletesiIdo');
                });
        }

        function openAthletes(id, gender2) {
            new ej2.data.DataManager(grid.dataSource).executeQuery(new ej2.data.Query().where('id', 'equal', id)).then(function (data) {
                var date = data.result[0].datum;
                var gender = gender2 === 0 ? 'allgender' : (gender2 === 1 ? 'male' : 'female');

                paramHelper.setParams([
                    {'state': 'monthlyStat'},
                    {'sectionId': 0},
                    {'sectionName': gettextCatalog.getString('All sections')},
                    {'dateFrom': date},
                    {'dateTo': date},
                    {'gender': gender}
                ]);
                $state.go('reports.statisticalReports.listAthletes');
            });
        }

        function openLeaving(id) {
            new ej2.data.DataManager(grid.dataSource).executeQuery(new ej2.data.Query().where('id', 'equal', id)).then(function (data) {
                var date = data.result[0].datum;

                authenticationService.getRight('SPSZAMALAKRESZL').then(function (results) {
                    if (results !== true) {
                        log.permissionError();
                    } else {
                        paramHelper.setParams([
                            {'state': 'monthlyStatLeaving'},
                            {'sectionId': 0},
                            {'dateFrom': date},
                            {'dateTo': date},
                            {'gender': 'allgender'}
                        ]);
                        $state.go('reports.statisticalReports.listAthletes');
                    }
                });
            });
        }

        function openJoined(id) {
            new ej2.data.DataManager(grid.dataSource).executeQuery(new ej2.data.Query().where('id', 'equal', id)).then(function (data) {
                var date = data.result[0].datum;

                authenticationService.getRight('SPSZAMALAKRESZL').then(function (results) {
                    if (results !== true) {
                        log.permissionError();
                    } else {
                        paramHelper.setParams([
                            {'state': 'monthlyStatJoined'},
                            {'sectionId': 0},
                            {'dateFrom': date},
                            {'dateTo': date},
                            {'gender': 'allgender'}
                        ]);
                        $state.go('reports.statisticalReports.listAthletes');
                    }
                });
            });
        }

        function openSection(sectionID, id) {
            new ej2.data.DataManager(grid.dataSource).executeQuery(new ej2.data.Query().where('id', 'equal', id)).then(function (data) {
                var date = data.result[0].datum;

                var sectionBelongsToUser = false;
                for (var i = 0; i < vm.accessibleSections.length; i++) {
                    if (vm.accessibleSections[i] == sectionID) {
                        sectionBelongsToUser = true;
                        break;
                    }
                }
                if (sectionBelongsToUser || vm.isAdmin) {
                    paramHelper.setParams([
                        {'sectionID': sectionID},
                        {'date': (date)}
                    ]);
                    $state.go('reports.statisticalReports.activeAthletesInSectionByMonth');
                } else {
                    log.warningMsg('You do not have permission to access the selected section details!');
                }
            });
        }

        function dateFromChanged(data) {
            getNumbers(data.value, vm.DateTo);
        }

        function dateToChanged(data) {
            getNumbers(vm.DateFrom, data.value);
        }

        function getSectionList() {
            return dataservice.sectionDropDownListAll()
                .then(function (data) {
                    vm.sectionList = data.itemsList;
                });
        }

        function ParseDate(strDate) { // "2016. június" --> Date
            var idxOfSpace = strDate.indexOf(' ');
            var strYear = strDate.slice(0, idxOfSpace - 1);
            var strMonth = strDate.slice(idxOfSpace + 1, idxOfSpace + 4);
            var year = parseInt(strYear);
            var month = 0;
            switch (strMonth) {
                case 'jan' :
                    month = 1;
                    break;
                case 'feb' :
                    month = 2;
                    break;
                case 'már' :
                    month = 3;
                    break;
                case 'ápr' :
                    month = 4;
                    break;
                case 'máj' :
                    month = 5;
                    break;
                case 'jún' :
                    month = 6;
                    break;
                case 'júl' :
                    month = 7;
                    break;
                case 'aug' :
                    month = 8;
                    break;
                case 'sze' :
                    month = 9;
                    break;
                case 'okt' :
                    month = 10;
                    break;
                case 'nov' :
                    month = 11;
                    break;
                case 'dec' :
                    month = 12;
                    break;
            }
            return new Date(year, month - 1, 1, 3);
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.reports.statisticalReports.activeAthletesByMonth')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'reports.statisticalReports.activeAthletesByMonth',
                config: {
                    url: '/activeAthletesByMonth',
                    templateUrl: 'app/reports/statisticalReports/activeAthletesByMonth/activeAthletesByMonth.html',
                    controller: 'ActiveAthletesByMonthController',
                    controllerAs: 'vm',
                    title: 'ActiveAthletesByMonth',
                    settings: {
                        navId: 38214,
                        level: 3,
                        order: 8,
                        orderTitle_hu: 'Sportolók számának alakulása',
                        orderTitle_en: 'Number of Active Athletes by Month',
                        parentId: 214,
                        content: 'ActiveAthletesByMonth',
                        activatorPermission: '"KMSPORTALAK"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    ActiveAthletesBySectionController.$inject = ["log", "dataservice", "$rootScope", "gettextCatalog", "authenticationService", "$scope", "$state", "paramHelper"];
    angular
        .module('app.reports.statisticalReports.activeAthletesBySection')
        .controller('ActiveAthletesBySectionController', ActiveAthletesBySectionController);

    function ActiveAthletesBySectionController(log, dataservice, $rootScope, gettextCatalog, authenticationService, $scope, $state, paramHelper) {
        var vm = this;
        $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('ActiveAthletesBySection');
        vm.athleteList = [];
        vm.queryDate = new Date();
        vm.dateChange = dateChange;
        vm.openSection = openSection;

        vm.columns = [{
            field: 'SzakosztalyNeve',
            headerText: gettextCatalog.getString('Section')
        }, {
            field: 'Szam',
            headerText: gettextCatalog.getString('NumberOfAthletes'), template: '#acatbysetemplateDataColumn1'
        }, {
            field: 'SzamFiu',
            headerText: gettextCatalog.getString('NumberOfBoys'), template: '#acatbysetemplateDataColumn2'
        }, {
            field: 'SzamLany',
            headerText: gettextCatalog.getString('NumberOfGirls'), template: '#acatbysetemplateDataColumn3'
        }];

        vm.sectionList = [];
        vm.athleteListFull = [];
        vm.showEachSections = false;
        vm.accessibleSections = [];
        vm.checkboxChanged = checkboxChanged;
        vm.checkboxEnabled = true;
        vm.checkboxchangedonce = false;
        vm.checked = false;
        vm.isAdmin = false;

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItems,
            allowPaging: true,
            allowTextWrap: true,
            allowSorting: true,
            allowExcelExport: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#Grid'), $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        activate();

        function openSection(SectionId, gender) {
            new ej2.data.DataManager(grid.dataSource).executeQuery(new ej2.data.Query().where('SzakosztalyId', 'equal', SectionId)).then(function (data) {
                var SectionName = data.result[0].SzakosztalyNeve;
                var accessGranted = false;
                for (var i = 0; i < vm.accessibleSections.length; i++) {
                    if (vm.accessibleSections[i] === SectionId) {
                        accessGranted = true;
                        break;
                    }
                }
                if (accessGranted || vm.isAdmin) {
                    paramHelper.setParams([
                        {'state': 'activeAthletes'},
                        {'sectionId': SectionId},
                        {'sectionName': SectionName},
                        {'dateFrom': vm.queryDate},
                        {'dateTo': vm.queryDate},
                        {'gender': gender === 0 ? 'allgender' : (gender === 1 ? 'male' : 'female')}
                    ]);
                    $state.go('reports.statisticalReports.listAthletes');
                } else {
                    log.htmlWarning(gettextCatalog.getString('You do not have permission to access the selected section details!') + '<br><br>' + gettextCatalog.getString(SectionName));
                }
            });
        }

        function activate() {
            authenticationService.getRight('KMSPORTSZAK').then(function (results) {
                if (results !== true) {
                    log.permissionError(true);
                } else {
                    getNumbers(vm.queryDate);
                }
            });
        }

        function checkboxChanged(args) {
            vm.showEachSections = args.value;
            filterSections();
        }

        function filterSections() {
            vm.athleteList = [];
            if (!vm.showEachSections) {
                for (var i = 0; i < vm.athleteListFull.length; i++) {
                    for (var s = 0; s < vm.accessibleSections.length; s++) {
                        if (vm.athleteListFull[i].SzakosztalyId == vm.accessibleSections[s]) {
                            vm.athleteList.push(vm.athleteListFull[i]);
                        }
                    }
                }
            } else {
                vm.athleteList = vm.athleteListFull;
                grid.dataSource = vm.athleteListFull;
            }
        }

        function getNumbers(date) {
            dataservice.athletesBySection(date)
                .then(function (data) {
                    vm.athleteListFull = data.itemsList;
                    vm.accessibleSections = data.felhasznaloSzakosztalyai;
                    vm.isAdmin = data.isAdmin;
                    if (data.isAdmin == true) {
                        vm.checked = true;
                    }
                    filterSections();
                });
        }

        function dateChange(data) {
            getNumbers(data.value);
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.reports.statisticalReports.activeAthletesBySection')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'reports.statisticalReports.activeAthletesBySection',
                config: {
                    url: '/activeAthletesBySection',
                    templateUrl: 'app/reports/statisticalReports/activeAthletesBySection/activeAthletesBySection.html',
                    controller: 'ActiveAthletesBySectionController',
                    controllerAs: 'vm',
                    title: 'ActiveAthletesBySection',
                    settings: {
                        navId: 31214,
                        level: 3,
                        order: 1,
                        orderTitle_hu: 'Aktív sportolók szakosztály szerint',
                        orderTitle_en: 'Number of Active Athletes by Sections',
                        parentId: 214,
                        content: 'ActiveAthletesBySection',
                        activatorPermission: '"KMSPORTSZAK"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    ActiveAthletesInSectionByMonthController.$inject = ["log", "dataservice", "$q", "$rootScope", "gettextCatalog", "authenticationService", "$scope", "$state", "paramHelper", "$filter", "$timeout"];
    angular
        .module('app.reports.statisticalReports.activeAthletesInSectionByMonth')
        .controller('ActiveAthletesInSectionByMonthController', ActiveAthletesInSectionByMonthController);

    function ActiveAthletesInSectionByMonthController(log, dataservice, $q, $rootScope, gettextCatalog, authenticationService, $scope, $state, paramHelper, $filter, $timeout) {
        var vm = this;
        $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('ActiveAthletesInSectionByMonth');
        vm.sectionList = [];
        vm.columns = [{
            field: 'SzuletesiEv',
            headerText: gettextCatalog.getString('Month'),
            width: 60
        }, {
            field: 'Szam',
            headerText: gettextCatalog.getString('NumberOfAthletes'), template: '#acatinsebymotemplateDataColumn1',
            width: 60
        }, {
            field: 'SzamFiu',
            headerText: gettextCatalog.getString('NumberOfBoys'), template: '#acatinsebymotemplateDataColumn2',
            width: 60
        }, {
            field: 'SzamLany',
            headerText: gettextCatalog.getString('NumberOfGirls'), template: '#acatinsebymotemplateDataColumn3',
            width: 60
        }, {
            field: 'SzamErkezett',
            headerText: gettextCatalog.getString('Joined'),
            width: 60
        }, {
            field: 'SzamKilepett',
            headerText: gettextCatalog.getString('Leave'),
            width: 60
        }, {
            field: 'SzamAtjott',
            headerText: gettextCatalog.getString('MoveIn'),
            width: 60
        }, {
            field: 'SzamAtment',
            headerText: gettextCatalog.getString('MoveOut'),
            width: 60
        }];
        vm.dateFrom = new Date();
        vm.dateFrom.setMonth(vm.dateFrom.getMonth() - 1);
        vm.dateTo = new Date();
        vm.dateFromChanged = dateFromChanged;
        vm.dateToChanged = dateToChanged;
        vm.sectionList = [];
        vm.sectionValue = '';
        vm.selectedSectionName = '';
        vm.sectionDataBound = sectionDataBound;
        vm.sectionSelect = sectionSelect;
        vm.selectedSectionID = '';
        vm.showOnlyOneMonth = false;
        vm.openAthletes = openAthletes;
        vm.openBoys = openBoys;
        vm.openGirls = openGirls;
        vm.date = '';
        vm.sectionId = '';

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItems,
            allowPaging: true,
            allowTextWrap: true,
            allowSorting: true,
            allowExcelExport: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#Grid'), $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        activate();

        function getSections() {
            return dataservice.sectionDropDownList(0, true)
                .then(function (data) {
                    vm.sectionList = data.itemsList;
                });
        }

        function sectionDataBound() {
            if (vm.sectionList.length === 1) {
                angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.sectionList[0].value);
                vm.selectedSectionName = vm.sectionList[0].value;
                vm.sectionId = vm.sectionList[0].value;
            } else {
                angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.sectionId);
            }
        }

        function ParseDate(strDate) { // "2016. június" --> Date
            var idxOfSpace = strDate.indexOf(' ');
            var strYear = strDate.slice(0, idxOfSpace - 1);
            var strMonth = strDate.slice(idxOfSpace + 1, idxOfSpace + 4);
            var year = parseInt(strYear);
            var month = 0;
            switch (strMonth) {
                case 'jan' :
                    month = 1;
                    break;
                case 'feb' :
                    month = 2;
                    break;
                case 'már' :
                    month = 3;
                    break;
                case 'ápr' :
                    month = 4;
                    break;
                case 'máj' :
                    month = 5;
                    break;
                case 'jún' :
                    month = 6;
                    break;
                case 'júl' :
                    month = 7;
                    break;
                case 'aug' :
                    month = 8;
                    break;
                case 'sze' :
                    month = 9;
                    break;
                case 'okt' :
                    month = 10;
                    break;
                case 'nov' :
                    month = 11;
                    break;
                case 'dec' :
                    month = 12;
                    break;
            }
            return new Date(year, month - 1, 1, 2);
        }

        function activate() {
            authenticationService.getRight('KMSPORTALAKSZO').then(function (results) {
                if (results !== true) {
                    log.permissionError(true);
                } else {
                    $q.all([getSections(), paramHelper.getParams([], ['sectionID', 'date'])]).then(function (results) {
                        vm.params = results[1];
                        paramHelper.removeParam('sectionID');
                        paramHelper.removeParam('date');
                        if (vm.params.sectionID != null && vm.params.date != null) {
                            var date = vm.params.date.slice(0, 10);
                            var SectionItem = ej.DataManager(vm.sectionList).executeLocal(new ej.Query().where('value', 'equal', vm.params.sectionID))[0];
                            if (!SectionItem) {
                                $rootScope.back();
                            } else {
                                vm.selectedSectionName = SectionItem.text;
                                $rootScope.title = gettextCatalog.getString('ActiveAthletesInSectionByMonth') + ' (' + gettextCatalog.getString(vm.selectedSectionName) + ', ' + $filter('dateYearMonthLongStrFilter')(date) + ')';
                            }
                            $timeout(function () {
                                vm.dateFrom = date;
                                vm.dateTo = date;
                                vm.sectionValue = vm.params.sectionID;
                                if (SectionItem) {
                                    getNumbers(date, date, SectionItem.text, vm.params.sectionID);
                                }
                            }, 0);
                        }
                    });
                }
            });
        }

        function getNumbers(date1, date2, sectionName, sectionId) {
            if (!sectionName) {
                return;
            }
            dataservice.activeAthletesInSectionByMonth(date1, date2, sectionName, sectionId)
                .then(function (data) {
                    grid.dataSource = data.itemsList;
                });
        }

        function openAthletes(id) {
            new ej2.data.DataManager(grid.dataSource).executeQuery(new ej2.data.Query().where('id', 'equal', id)).then(function (data) {
                var date = data.result[0].SzuletesiEv;

                paramHelper.setParams([
                    {'state': 'monthlyStat'},
                    {'sectionId': vm.selectedSectionID},
                    {'sectionName': vm.selectedSectionName},
                    {'dateFrom': ParseDate(date)},
                    {'dateTo': ParseDate(date)},
                    {'gender': 'allgender'}
                ]);
                $state.go('reports.statisticalReports.listAthletes');
            });
        }

        function openBoys(id) {
            new ej2.data.DataManager(grid.dataSource).executeQuery(new ej2.data.Query().where('id', 'equal', id)).then(function (data) {
                var date = data.result[0].SzuletesiEv;

                paramHelper.setParams([
                    {'state': 'monthlyStat'},
                    {'sectionId': vm.selectedSectionID},
                    {'sectionName': vm.selectedSectionName},
                    {'dateFrom': ParseDate(date)},
                    {'dateTo': ParseDate(date)},
                    {'gender': 'male'}
                ]);
                $state.go('reports.statisticalReports.listAthletes');
            });
        }

        function openGirls(id) {
            new ej2.data.DataManager(grid.dataSource).executeQuery(new ej2.data.Query().where('id', 'equal', id)).then(function (data) {
                var date = data.result[0].SzuletesiEv;

                paramHelper.setParams([
                    {'state': 'monthlyStat'},
                    {'sectionId': vm.selectedSectionID},
                    {'sectionName': vm.selectedSectionName},
                    {'dateFrom': ParseDate(date)},
                    {'dateTo': ParseDate(date)},
                    {'gender': 'female'}
                ]);
                $state.go('reports.statisticalReports.listAthletes');
            });
        }

        function sectionSelect(args) {
            vm.selectedSectionName = args.text.toString();
            vm.selectedSectionID = args.value;
            vm.showOnlyOneMonth = false;
            getNumbers(vm.dateFrom, vm.dateTo, vm.selectedSectionName, vm.selectedSectionID);
        }

        function dateFromChanged(data) {
            if (data && data.value && vm.dateTo) {
                vm.showOnlyOneMonth = false;
                getNumbers(data.value, vm.dateTo, vm.selectedSectionName, vm.selectedSectionID);
            }
        }

        function dateToChanged(data) {
            if (data && data.value && vm.dateTo) {
                vm.showOnlyOneMonth = false;
                getNumbers(vm.dateFrom, data.value, vm.selectedSectionName, vm.selectedSectionID);
            }
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.reports.statisticalReports.activeAthletesInSectionByMonth')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'reports.statisticalReports.activeAthletesInSectionByMonth',
                config: {
                    url: '/activeAthletesInSectionByMonth',
                    templateUrl: 'app/reports/statisticalReports/activeAthletesInSectionByMonth/activeAthletesInSectionByMonth.html',
                    controller: 'ActiveAthletesInSectionByMonthController',
                    controllerAs: 'vm',
                    title: 'ActiveAthletesInSectionByMonth',
                    settings: {
                        navId: 39214,
                        level: 3,
                        order: 9,
                        orderTitle_hu: 'Sportolók számának alakulása szakosztályonként',
                        orderTitle_en: 'Alteration of Number of Athletes by Sections',
                        parentId: 214,
                        content: 'ActiveAthletesInSectionByMonth',
                        activatorPermission: '"KMSPORTALAKSZO"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    AthletesByBirthYearController.$inject = ["log", "dataservice", "$q", "$rootScope", "gettextCatalog", "authenticationService", "$scope", "$state", "paramHelper"];
    angular
        .module('app.reports.statisticalReports.athletesByBirthYear')
        .controller('AthletesByBirthYearController', AthletesByBirthYearController);

    function AthletesByBirthYearController(log, dataservice, $q, $rootScope, gettextCatalog, authenticationService, $scope, $state, paramHelper) {
        var vm = this;
        $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('AthletesByBirthYear');
        vm.sectionList = [];

        vm.columns = [{
            field: 'SzuletesiEv',
            headerText: gettextCatalog.getString('BirthYear'),
            textAlign: 'left'
        }, {
            field: 'Szam',
            headerText: gettextCatalog.getString('NumberOfAthletes'),
            textAlign: 'left',
            template: '#atbybiyetemplateDataColumn1'
        }, {
            field: 'SzamFiu',
            headerText: gettextCatalog.getString('NumberOfBoys'),
            textAlign: 'left',
            template: '#atbybiyetemplateDataColumn2'
        }, {
            field: 'SzamLany',
            headerText: gettextCatalog.getString('NumberOfGirls'),
            textAlign: 'left',
            template: '#atbybiyetemplateDataColumn3'
        }];

        vm.Date = new Date();
        vm.selectedSection = 0;
        vm.listAthletes = listAthletes;
        var SectionName = '';

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItems,
            allowPaging: true,
            allowTextWrap: true,
            allowSorting: true,
            allowExcelExport: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#Grid'), $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        activate();

        function activate() {
            authenticationService.getRight('KMSPORTELETKOR').then(function (results) {
                if (results !== true) {
                    log.permissionError(true);
                } else {
                    $q.all([paramHelper.getParams([], ['sectionID', 'year'])]).then(function (results) {
                        // Ha paraméter nélkül érkezik akkor tovább arra az oldalra ahol a gridben kattintva eljuthat ide újra
                        if (results[0].sectionID == null || results[0].year == null) {
                            $state.go('reports.statisticalReports.activeAthletesByAge');
                        } else {
                            vm.params = results[0];
                            vm.selectedSection = vm.params.sectionID;
                            getSections();
                            getNumbers(vm.params.year, vm.params.sectionID);
                        }
                    });
                }
            });
        }

        function listAthletes(year, gender2) {
            new ej2.data.DataManager(grid.dataSource).executeQuery(new ej2.data.Query().where('SzuletesiEv', 'equal', year)).then(function () {
                var gender = gender2 === 0 ? 'allgender' : (gender2 === 1 ? 'male' : 'female');

                paramHelper.setParams([
                    {'state': 'activeAthletesByBirthYear'},
                    {'year': year},
                    {'sectionId': vm.selectedSection},
                    {'sectionName': SectionName},
                    {'dateFrom': null},
                    {'dateTo': null},
                    {'gender': gender}
                ]);
                $state.go('reports.statisticalReports.listAthletes');
            });
        }

        function getNumbers(year, sectionId) {
            var date = new Date(year, 0, 1); // First day of year
            dataservice.activeAthletesByAge(date, sectionId)
                .then(function (data) {
                    grid.dataSource = data.itemsList;
                });
        }

        function getSections() {
            return dataservice.sectionDropDownList(0)
                .then(function (data) {
                    vm.sectionList = data.itemsList;
                    SectionName = ej.DataManager(vm.sectionList).executeLocal(new ej.Query().where('value', 'equal', vm.selectedSection))[0].text;
                    $rootScope.title = gettextCatalog.getString('activeAthletesByBirthYear') + ' (' + gettextCatalog.getString(SectionName) + ', ' + vm.params.year + ')';
                });
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.reports.statisticalReports.athletesByBirthYear')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'reports.statisticalReports.athletesByBirthYear',
                config: {
                    url: '/athletesByBirthYear',
                    templateUrl: 'app/reports/statisticalReports/athletesByBirthYear/athletesByBirthYear.html',
                    controller: 'AthletesByBirthYearController',
                    controllerAs: 'vm',
                    title: 'AthletesByBirthYear',
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    AthletesByYearController.$inject = ["log", "dataservice", "$q", "$rootScope", "gettextCatalog", "authenticationService", "$scope", "$state", "paramHelper", "$filter"];
    angular
        .module('app.reports.statisticalReports.athletesByYear')
        .controller('AthletesByYearController', AthletesByYearController);

    function AthletesByYearController(log, dataservice, $q, $rootScope, gettextCatalog, authenticationService, $scope, $state, paramHelper, $filter) {
        var vm = this;
        $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('AthletesByYear');

        vm.sectionList = [];

        vm.columns = [{
            field: 'Nev',
            headerText: gettextCatalog.getString('Name'),
            width: 150,
            textAlign: 'left',
            template: '#atbyyetemplateDataColumn1'
        }, {
            field: 'SzuletesiIdo',
            headerText: gettextCatalog.getString('BirthDate'),
            width: 150,
            textAlign: 'left'
        }, {
            field: 'Aktiv',
            headerText: gettextCatalog.getString('Active'),
            width: 50,
            textAlign: 'left',
            displayAsCheckBox: true
        }, {
            field: 'EdzoNeve',
            headerText: gettextCatalog.getString('Coach'),
            width: 150,
            textAlign: 'left',
            template: '#atbyyetemplateDataColumn3'
        }, {
            field: 'SzakosztalyNeve',
            headerText: gettextCatalog.getString('Section'),
            width: 150,
            textAlign: 'left'
        }, {
            field: 'KorcsoportNeve',
            headerText: gettextCatalog.getString('AgeGroup'),
            width: 150,
            textAlign: 'left'
        }, {
            field: 'Tagdij',
            headerText: gettextCatalog.getString('PayedSportServiceFee'),
            width: 150,
            textAlign: 'left'
        }, {
            field: 'Oktatasidij',
            headerText: gettextCatalog.getString('PayedEducationalFee'),
            width: 150,
            textAlign: 'left'
        }, {
            field: 'Egyenleg',
            headerText: gettextCatalog.getString('Balance'),
            width: 150,
            textAlign: 'left'
        }, {
            field: 'Megjegyzes',
            headerText: gettextCatalog.getString('Comment'),
            width: 150,
            textAlign: 'left'
        }];

        vm.Date = new Date();
        vm.selectedSection = 0;
        vm.goToAthlete = goToAthlete;
        vm.goToCoach = goToCoach;

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItems,
            allowPaging: true,
            allowTextWrap: true,
            allowSorting: true,
            allowExcelExport: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#Grid'), $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        activate();

        function activate() {
            authenticationService.getRight('KMSPORTELETKOR').then(function (results) {
                if (results !== true) {
                    log.permissionError(true);
                } else {
                    $q.all([paramHelper.getParams([], ['year'])]).then(function (results) {
                        vm.params = results[0];
                        getNumbers(vm.params.year, 0);
                    });
                }
            });
        }

        function goToAthlete(id) {
            $q.all([authenticationService.getRight('MEGTSPORTLIST')]).then(function (results) {
                if (results[0]) {
                    paramHelper.setParams([{'athleteModify.sportoloId': id}]);
                    $state.go('athletes.athletesManagement.athleteModify.dataSheet');
                } else {
                    log.permissionError();
                }
            });
        }

        function goToCoach(coachId) {
            $q.all([authenticationService.getRight('MEGTFELH')]).then(function (results) {
                if (results[0]) {
                    paramHelper.setParams([
                        {'newUser.userId': coachId}
                    ]);
                    $state.go('settings.userManagement.modifyUser');
                } else {
                    log.permissionError();
                }
            });
        }

        function getNumbers(year, sectionID) {
            dataservice.activeAthletesBornAtSpecificYear(year, sectionID)
                .then(function (data) {
                    grid.dataSource = $filter('dateStringFilter')(data.itemsList, 'SzuletesiIdo');
                });
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.reports.statisticalReports.athletesByYear')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'reports.statisticalReports.athletesByYear',
                config: {
                    url: '/athletesByYear',
                    templateUrl: 'app/reports/statisticalReports/athletesByYear/athletesByYear.html',
                    controller: 'AthletesByYearController',
                    controllerAs: 'vm',
                    title: 'AthletesByYear',
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    AthletesNotPresentOnMonthlyAttendanceController.$inject = ["log", "dataservice", "$q", "$rootScope", "gettextCatalog", "authenticationService", "$scope", "$state", "paramHelper", "$timeout"];
    angular
        .module('app.reports.statisticalReports.athletesNotPresentOnMonthlyAttendance')
        .controller('AthletesNotPresentOnMonthlyAttendanceController', AthletesNotPresentOnMonthlyAttendanceController);

    function AthletesNotPresentOnMonthlyAttendanceController(log, dataservice, $q, $rootScope, gettextCatalog, authenticationService, $scope, $state, paramHelper, $timeout) {
        var vm = this;
        $rootScope.vm = vm; // jshint ignore: line

        // Page title
        $rootScope.title = gettextCatalog.getString('AthletesNotPresentOnMonthlyAttendance');

        // Grid's details
        vm.data = [];
        vm.header = [];
        vm.reportParameters = {};
        vm.DateFrom = new Date();
        vm.DateFrom.setMonth(vm.DateFrom.getMonth() - 1);
        vm.DateTo = new Date();
        vm.dateFromChanged = dateFromChanged;
        vm.dateToChanged = dateToChanged;
        vm.sectionList = [];
        vm.sectionValue = '';
        vm.selectedSectionId = -1;
        vm.selectedSectionName = '';
        vm.sectionDataBound = sectionDataBound;
        vm.sectionSelect = sectionSelect;
        vm.sectionId = '';
        vm.numberOfMonths = 0;
        vm.isAdmin = false;
        vm.isSectionLeader = false;
        vm.accessibleSections = [];
        vm.goToAthlete = goToAthlete;
        vm.goToCoach = goToCoach;

        vm.columns = [];

        var grid;

        activate();

        function activate() {
            authenticationService.getRight('SPJELENLETINELK').then(function (results) {
                if (results !== true) {
                    log.permissionError(true);
                } else {
                    getSections().then(function () {
                        $timeout(function () {
                            if (vm.sectionList.length > 0) {
                                vm.sectionValue = vm.sectionList[0].value;
                            }
                        }, 0);
                    });
                }
            });
        }

        function goToAthlete(id) {
            $q.all([authenticationService.getRight('MEGTSPORTLIST'), authenticationService.getRight('MEGTSPORTLIST')]).then(function (results) {
                if (results[0] || results[1]) {
                    paramHelper.setParams([{'athleteModify.sportoloId': id}]);
                    $state.go('athletes.athletesManagement.athleteModify.dataSheet');
                } else {
                    log.permissionError();
                }
            });
        }

        function goToCoach(coachId) {
            paramHelper.setParams([
                {'newUser.userId': coachId}
            ]);
            $state.go('settings.userManagement.modifyUser');
        }

        function getSections() {
            return dataservice.sectionDropDownList(0, true)
                .then(function (data) {
                    vm.sectionList = data.itemsList;
                });
        }

        function sectionDataBound() {
            if (vm.sectionList.length === 1) {
                angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.sectionList[0].value);
                vm.selectedSectionId = vm.sectionList[0].value;
            } else {
                angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.sectionId);
                vm.selectedSectionId = vm.sectionId;
            }
        }

        function getNumbers(dateFrom, dateTo, sectionId) {
            if (!sectionId) {
                return;
            }
            if (sectionId == -1) { // -1 jelenti az összes szakosztályt itt, 0-ra keresi az összeset
                sectionId = 0;
                vm.selectedSectionId = 0;
            }
            dataservice.athletesNotPresentOnMonthlyAttendance(dateFrom, dateTo, sectionId)
                .then(function (data) {
                    setColumns();
                    vm.isSectionLeader = data.isSectionLeader;
                    vm.accessibleSections = data.felhasznaloSzakosztalyai;
                    vm.data = data.itemsList;
                    vm.header = data.header;
                    vm.isAdmin = data.isAdmin;
                    vm.honapokszama = data.honapokszama;
                    var allSection = {value: -1, text: gettextCatalog.getString('All')};
                    if (vm.isAdmin && vm.sectionList.length > 1 && vm.sectionList[0].value != -1) {
                        vm.sectionList.unshift({value: '-1', text: gettextCatalog.getString('All')});
                    }
                    var columnWidth = 100;
                    for (var i = 0; i < vm.honapokszama; i++) {
                        switch (i) {
                            case 0:
                                vm.columns.push({headerText: data.header.t01, textAlign: 'center', width: columnWidth, field: 'h01'});
                                break;
                            case 1:
                                vm.columns.push({headerText: data.header.t02, textAlign: 'center', width: columnWidth, field: 'h02'});
                                break;
                            case 2:
                                vm.columns.push({headerText: data.header.t03, textAlign: 'center', width: columnWidth, field: 'h03'});
                                break;
                            case 3:
                                vm.columns.push({headerText: data.header.t04, textAlign: 'center', width: columnWidth, field: 'h04'});
                                break;
                            case 4:
                                vm.columns.push({headerText: data.header.t05, textAlign: 'center', width: columnWidth, field: 'h05'});
                                break;
                            case 5:
                                vm.columns.push({headerText: data.header.t06, textAlign: 'center', width: columnWidth, field: 'h06'});
                                break;
                            case 6:
                                vm.columns.push({headerText: data.header.t07, textAlign: 'center', width: columnWidth, field: 'h07'});
                                break;
                            case 7:
                                vm.columns.push({headerText: data.header.t08, textAlign: 'center', width: columnWidth, field: 'h08'});
                                break;
                            case 8:
                                vm.columns.push({headerText: data.header.t09, textAlign: 'center', width: columnWidth, field: 'h09'});
                                break;
                            case 9:
                                vm.columns.push({headerText: data.header.t10, textAlign: 'center', width: columnWidth, field: 'h10'});
                                break;
                            case 10:
                                vm.columns.push({headerText: data.header.t11, textAlign: 'center', width: columnWidth, field: 'h11'});
                                break;
                            case 11:
                                vm.columns.push({headerText: data.header.t12, textAlign: 'center', width: columnWidth, field: 'h12'});
                                break;
                        }
                    }
                    if (!grid) {
                        grid = new ej2.grids.Grid({
                            dataSource: [],
                            toolbar: $rootScope.toolbarItems,
                            allowPaging: true,
                            allowTextWrap: true,
                            allowSorting: true,
                            allowExcelExport: true,
                            locale: 'hu-HU',
                            gridLines: 'Both',
                            pageSettings: $rootScope.pageSettings,
                            columns: vm.columns,
                            rowDataBound: function (args) {
                                $rootScope.compile(args.row, $scope);
                            },
                            actionComplete: function (args) {
                                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                                    $rootScope.compile($('#Grid'), $scope);
                                }
                            }
                        });
                        grid.appendTo('#Grid');
                        grid.toolbarClick = function (args) {
                            $rootScope.toolbarClick(args, grid);
                        };
                    } else {
                        grid.columns = vm.columns;
                        grid.refreshColumns();
                    }
                    grid.dataSource = data.itemsList;
                });
        }

        function sectionSelect(args) {
            vm.selectedSectionId = args.value;
            vm.selectedSectionName = args.text;
            getNumbers(vm.DateFrom, vm.DateTo, vm.selectedSectionId);
        }

        function dateFromChanged(data) {
            getNumbers(data.value, vm.DateTo, vm.selectedSectionId);
        }

        function dateToChanged(data) {
            getNumbers(vm.DateFrom, data.value, vm.selectedSectionId);
        }

        function setColumns() {
            vm.columns = [{
                field: 'MezoSportoloNev',
                headerText: gettextCatalog.getString('Name'),
                textAlign: 'center',
                width: 100,
                template: '#anpomaathlete'
            }, {
                field: 'MezoSzakosztalyNev',
                headerText: gettextCatalog.getString('Szakosztaly'),
                textAlign: 'center',
                width: 100
            }, {
                field: 'MezoKorcsoportNev',
                headerText: gettextCatalog.getString('Korcsoport'),
                textAlign: 'center',
                width: 100
            }, {
                field: 'MezoEdzoNev',
                headerText: gettextCatalog.getString('Edzo'),
                textAlign: 'center',
                width: 100,
                template: '#anpomacoach'
            }];
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.reports.statisticalReports.athletesNotPresentOnMonthlyAttendance')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'reports.statisticalReports.athletesNotPresentOnMonthlyAttendance',
                config: {
                    url: '/athletesNotPresentOnMonthlyAttendance',
                    templateUrl: 'app/reports/statisticalReports/athletesNotPresentOnMonthlyAttendance/athletesNotPresentOnMonthlyAttendance.html',
                    controller: 'AthletesNotPresentOnMonthlyAttendanceController',
                    controllerAs: 'vm',
                    title: 'AthletesNotPresentOnMonthlyAttendance',
                    settings: {
                        navId: 310214,
                        level: 3,
                        order: 10,
                        orderTitle_hu: 'Havi jelenlétin nem szereplő sportolók',
                        orderTitle_en: 'Athletes not Presented on Monthly Attendance Sheet',
                        parentId: 214,
                        content: 'AthletesNotPresentOnMonthlyAttendance',
                        activatorPermission: '"SPJELENLETINELK"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    JoinedAthletesByCoachController.$inject = ["log", "dataservice", "$q", "$rootScope", "gettextCatalog", "authenticationService", "$scope", "$state", "paramHelper"];
    angular
        .module('app.reports.statisticalReports.joinedAthletesByCoach')
        .controller('JoinedAthletesByCoachController', JoinedAthletesByCoachController);

    function JoinedAthletesByCoachController(log, dataservice, $q, $rootScope, gettextCatalog, authenticationService, $scope, $state, paramHelper) {
        var vm = this;
        $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('JoinedAthletesByCoach');
        vm.sectionList = [];
        vm.athleteList = [];
        vm.columns = [{
            field: 'EdzoNeve',
            headerText: gettextCatalog.getString('CoachName'), template: '#joatbycotemplateDataColumn1',
            textAlign: 'left'
        }, {
            field: 'SzakosztalyNeve',
            headerText: gettextCatalog.getString('Section'), template: '#joatbycotemplateDataColumn2',
            textAlign: 'left'
        }, {
            field: 'Szam',
            headerText: gettextCatalog.getString('NumberOfAthletes'), template: '#joatbycotemplateDataColumn3',
            textAlign: 'left'
        }, {
            field: 'SzamFiu',
            headerText: gettextCatalog.getString('NumberOfBoys'), template: '#joatbycotemplateDataColumn4',
            textAlign: 'left'
        }, {
            field: 'SzamLany',
            headerText: gettextCatalog.getString('NumberOfGirls'), template: '#joatbycotemplateDataColumn5',
            textAlign: 'left'
        }];
        vm.DateFrom = new Date();
        vm.DateFrom.setMonth(vm.DateFrom.getMonth() - 1);
        vm.DateTo = new Date();
        vm.dateFromChanged = dateFromChanged;
        vm.dateToChanged = dateToChanged;
        vm.openCoach = openCoach;
        vm.openSection = openSection;
        vm.openCoachesJoinedAthletes = openCoachesJoinedAthletes;

        vm.sectionList = [];
        vm.athleteListFull = [];
        vm.showEachSections = false;
        vm.accessibleSections = [];
        vm.checkboxChanged = checkboxChanged;
        vm.checkboxEnabled = true;
        vm.checkboxchangedonce = false;
        vm.checked = false;
        vm.userId = -1;
        vm.isSectionLeader = false;
        vm.isAdmin = false;

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItemsWithSearch,
            allowPaging: true,
            allowTextWrap: true,
            allowSorting: true,
            allowExcelExport: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#Grid'), $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        activate();

        function openCoachesJoinedAthletes(coachId, sectionId, gender2) {
            new ej2.data.DataManager(grid.dataSource).executeQuery(new ej2.data.Query().where('SzakosztalyId', 'equal', sectionId)).then(function (data) {
                var sectionName = data.result[0].SzakosztalyNeve;
                var coachName = data.result[0].EdzoNeve;
                var gender = gender2 === 0 ? 'allgender' : (gender2 === 1 ? 'male' : 'female');

                var sectionBelongsToUser = false;
                for (var i = 0; i < vm.accessibleSections.length; i++) {
                    if (vm.accessibleSections[i] == sectionId) {
                        sectionBelongsToUser = true;
                        break;
                    }
                }
                if (sectionBelongsToUser || vm.isAdmin) {
                    paramHelper.setParams([
                        {'state': 'joinedAthletesToCoach'},
                        {'dateFrom': vm.DateFrom},
                        {'dateTo': vm.DateTo},
                        {'coachId': coachId},
                        {'coachName': coachName},
                        {'gender': gender}
                    ]);
                    $state.go('reports.statisticalReports.listAthletes');
                } else {
                    log.htmlWarning(gettextCatalog.getString('You do not have permission to access the selected section details!') + '<br><br>' + gettextCatalog.getString(sectionName));
                }
            });
        }

        function openSection(sectionId) {
            new ej2.data.DataManager(grid.dataSource).executeQuery(new ej2.data.Query().where('SzakosztalyId', 'equal', sectionId)).then(function (data) {
                var sectionName = data.result[0].SzakosztalyNeve;

                var sectionBelongsToUser = false;
                for (var i = 0; i < vm.accessibleSections.length; i++) {
                    if (vm.accessibleSections[i] == sectionId) {
                        sectionBelongsToUser = true;
                        break;
                    }
                }
                if (sectionBelongsToUser || vm.isAdmin) {
                    paramHelper.setParams([
                        {'state': 'joinedAthletes'},
                        {'sectionId': sectionId},
                        {'sectionName': sectionName},
                        {'dateFrom': vm.DateFrom},
                        {'dateTo': vm.DateTo},
                        {'gender': 'allgender'}
                    ]);
                    $state.go('reports.statisticalReports.listAthletes');
                } else {
                    log.htmlWarning(gettextCatalog.getString('You do not have permission to access the selected section details!') + '<br><br>' + gettextCatalog.getString(sectionName));
                }
            });
        }

        function openCoach(edzoId) {
            $q.all([authenticationService.getRight('MODFELH'), authenticationService.getRight('MEGTFELH')]).then(function (results) {
                if (results[0] || results[1]) {
                    paramHelper.setParams([{'newUser.userId': edzoId}]);
                    $state.go('settings.userManagement.modifyUser');
                } else {
                    log.permissionError();
                }
            });
        }

        function getNumbers(dateFrom, dateTo) {
            dataservice.joinedAthletesByCoach(dateFrom, dateTo)
                .then(function (data) {
                    vm.userId = data.userId;
                    vm.isAdmin = data.isAdmin;
                    vm.isSectionLeader = data.isSectionLeader;
                    vm.athleteListFull = data.itemsList;
                    vm.accessibleSections = data.felhasznaloSzakosztalyai;
                    if (data.isAdmin == true) {
                        vm.checked = true;
                    }
                    filterAthletes();
                });
        }

        function checkboxChanged(args) {
            vm.showEachSections = args.value;
            filterAthletes();
        }

        function filterAthletes() {
            vm.athleteList = [];
            if (!vm.showEachSections) {
                for (var i = 0; i < vm.athleteListFull.length; i++) {
                    for (var s = 0; s < vm.accessibleSections.length; s++) {
                        if (vm.athleteListFull[i].SzakosztalyId == vm.accessibleSections[s]) {
                            vm.athleteList.push(vm.athleteListFull[i]);
                        }
                    }
                }
            } else {
                vm.athleteList = vm.athleteListFull;
                grid.dataSource = vm.athleteList;
            }
        }

        function dateFromChanged(data) {
            getNumbers(data.value, vm.DateTo);
        }

        function dateToChanged(data) {
            getNumbers(vm.DateFrom, data.value);
        }

        function activate() {
            authenticationService.getRight('KMBELEPEDZO').then(function (results) {
                if (results !== true) {
                    log.permissionError(true);
                } else {
                    getNumbers(vm.DateFrom, vm.DateTo);
                }
            });
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.reports.statisticalReports.joinedAthletesByCoach')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'reports.statisticalReports.joinedAthletesByCoach',
                config: {
                    url: '/joinedAthletesByCoach',
                    templateUrl: 'app/reports/statisticalReports/joinedAthletesByCoach/joinedAthletesByCoach.html',
                    controller: 'JoinedAthletesByCoachController',
                    controllerAs: 'vm',
                    title: 'JoinedAthletesByCoach',
                    settings: {
                        navId: 36214,
                        level: 3,
                        order: 6,
                        orderTitle_hu: 'Belépők száma edzőnként',
                        orderTitle_en: 'Number of New Athletes by Coaches',
                        parentId: 214,
                        content: 'JoinedAthletesByCoach',
                        activatorPermission: '"KMBELEPEDZO"'
                    }
                }
            }
        ];
    }
})();

(function() {
    'use strict';

    JoinedAthletesBySection.$inject = ["log", "dataservice", "$rootScope", "gettextCatalog", "authenticationService", "$scope", "$state", "paramHelper"];
    angular
        .module('app.reports.statisticalReports.joinedAthletesBySection')
        .controller('JoinedAthletesBySection', JoinedAthletesBySection);

    function JoinedAthletesBySection(log, dataservice, $rootScope, gettextCatalog, authenticationService, $scope, $state, paramHelper) {
        var vm = this; $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('JoinedAthletesBySection');
        vm.sectionList = [];
        vm.athleteList = [];
        vm.accessibleSections = [];
        vm.columns = [
        {
            field: 'SzakosztalyNeve',
            headerText: gettextCatalog.getString('Section')
        }, {
            field: 'SzamErkezett',
            headerText: gettextCatalog.getString('NumberOfAthletes'), template: '#joatbysetemplateDataColumn1'
        }, {
            field: 'SzamBelepettFiuk',
            headerText: gettextCatalog.getString('NumberOfBoys'), template: '#joatbysetemplateDataColumn2'
        }, {
            field: 'SzamBelepettLanyok',
            headerText: gettextCatalog.getString('NumberOfGirls'), template: '#joatbysetemplateDataColumn3'
        }];
        vm.DateFrom = new Date();
        vm.DateFrom.setMonth(vm.DateFrom.getMonth() - 1);
        vm.DateTo = new Date();
        vm.DateFromChanged = DateFromChanged;
        vm.DateToChanged = DateToChanged;
        vm.openSection = openSection;

        vm.sectionList = [];
        vm.athleteListFull = [];
        vm.showEachSections = false;
        vm.accessibleSections = [];
        vm.checkboxChanged = checkboxChanged;
        vm.checkboxEnabled = true;
        vm.checkboxchangedonce = false;
        vm.checked = false;
        vm.isAdmin = false;

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItemsWithSearch,
            allowPaging: true,
            allowTextWrap: true,
            allowSorting: true,
            allowExcelExport: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#Grid'), $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        activate();

        function checkboxChanged(args) {
            vm.showEachSections = args.value;
            filterSections();
        }

        function filterSections() {
            vm.athleteList = [];
            if (!vm.showEachSections) {
                for (var i = 0; i < vm.athleteListFull.length; i++) {
                    for (var s = 0; s < vm.accessibleSections.length; s++) {
                        if (vm.athleteListFull[i].SzakosztalyId == vm.accessibleSections[s]) {
                            vm.athleteList.push(vm.athleteListFull[i]);
                        }
                    }
                }
            } else {
                vm.athleteList = vm.athleteListFull;
            }
            grid.dataSource = vm.athleteList;
        }

        function openSection(SectionId, gender2) {
            new ej2.data.DataManager(grid.dataSource).executeQuery(new ej2.data.Query().where('SzakosztalyId', 'equal', SectionId)).then(function (data) {
                var SectionName = data.result[0].SzakosztalyNeve;
                var gender = gender2 === 0 ? 'allgender' : (gender2 === 1 ? 'male' : 'female');

                var sectionBelongsToUser = false;
                for (var i = 0; i < vm.accessibleSections.length; i++) {
                    if (vm.accessibleSections[i] == SectionId) {
                        sectionBelongsToUser = true;
                        break;
                    }
                }
                if (sectionBelongsToUser || vm.isAdmin) {
                    paramHelper.setParams([
                        {'state': 'joinedAthletes'},
                        {'sectionId': SectionId},
                        {'sectionName': SectionName},
                        {'dateFrom': vm.DateFrom},
                        {'dateTo': vm.DateTo},
                        {'gender': gender}
                    ]);
                    $state.go('reports.statisticalReports.listAthletes');
                } else {
                    log.htmlWarning(gettextCatalog.getString('You do not have permission to access the selected section details!') + '<br><br>' + gettextCatalog.getString(SectionName));
                }
            });
        }

        function activate() {
            authenticationService.getRight('KMBELSZAK').then(function(results) {
                if (results !== true) {
                    log.permissionError(true);
                } else {
                    getSections();
                    getNumbers(vm.DateFrom, vm.DateTo);
                }
            });
        }

        function getNumbers(date, date2) {
            dataservice.joinedAthletesBySection(date, date2)
                .then(function(data) {
                    vm.athleteListFull = data.itemsList;
                    vm.accessibleSections = data.felhasznaloSzakosztalyai;
                    vm.isAdmin = data.isAdmin;
                    if (data.isAdmin == true) {
                        vm.checked = true;
                    }
                    filterSections();
                });
        }

        function DateFromChanged(data) {
            getNumbers(data.value, vm.DateTo);
        }

        function DateToChanged(data) {
            getNumbers(vm.DateFrom, data.value);
        }

        function getSections() {
            dataservice.sectionDropDownList(0)
                .then(function(data) {
                    data.itemsList.unshift({
                        value: '0',
                        text: gettextCatalog.getString('All')
                    });
                    vm.sectionList = data.itemsList;
                });
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.reports.statisticalReports.joinedAthletesBySection')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'reports.statisticalReports.joinedAthletesBySection',
                config: {
                    url: '/joinedAthletesBySection',
                    templateUrl: 'app/reports/statisticalReports/joinedAthletesBySection/joinedAthletesBySection.html',
                    controller: 'JoinedAthletesBySection',
                    controllerAs: 'vm',
                    title: 'JoinedAthletesBySection',
                    settings: {
                        navId: 33214,
                        level: 3,
                        order: 3,
                        orderTitle_hu: 'Belépők száma szakosztályonként',
                        orderTitle_en: 'Number of New Athletes by Sections',
                        parentId: 214,
                        content: 'JoinedAthletesBySection',
                        activatorPermission: '"KMBELSZAK"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    LeavingAthletesByCoachController.$inject = ["log", "dataservice", "$rootScope", "gettextCatalog", "authenticationService", "$scope", "$state", "paramHelper", "$q"];
    angular
        .module('app.reports.statisticalReports.leavingAthletesByCoach')
        .controller('LeavingAthletesByCoachController', LeavingAthletesByCoachController);

    function LeavingAthletesByCoachController(log, dataservice, $rootScope, gettextCatalog, authenticationService, $scope, $state, paramHelper, $q) {
        var vm = this;
        $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('LeavingAthletesByCoach');
        vm.sectionList = [];
        vm.athleteList = [];
        vm.columns = [{
            field: 'EdzoNeve',
            headerText: gettextCatalog.getString('CoachName'), template: '#leatbycotemplateDataColumn1', width: 100
        }, {
            field: 'SzakosztalyNeve',
            headerText: gettextCatalog.getString('Section'), template: '#leatbycotemplateDataColumn2', width: 100
        }, {
            field: 'Szam',
            headerText: gettextCatalog.getString('NumberOfAthletes'), template: '#leatbycotemplateDataColumn3', width: 100
        }, {
            field: 'SzamFiu',
            headerText: gettextCatalog.getString('NumberOfBoys'), template: '#leatbycotemplateDataColumn4', width: 100
        }, {
            field: 'SzamLany',
            headerText: gettextCatalog.getString('NumberOfGirls'), template: '#leatbycotemplateDataColumn5', width: 100
        }];
        vm.DateFrom = new Date();
        vm.DateFrom.setMonth(vm.DateFrom.getMonth() - 1);
        vm.DateTo = new Date();
        vm.dateFromChanged = dateFromChanged;
        vm.dateToChanged = dateToChanged;
        vm.openCoach = openCoach;
        vm.openSection = openSection;
        vm.openCoachesLeavingAthletes = openCoachesLeavingAthletes;

        vm.sectionList = [];
        vm.athleteListFull = [];
        vm.showEachSections = false;
        vm.accessibleSections = [];
        vm.checkboxChanged = checkboxChanged;
        vm.checkboxEnabled = true;
        vm.checkboxchangedonce = false;
        vm.checked = false;
        vm.userId = -1;
        vm.isSectionLeader = false;
        vm.isAdmin = false;

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItems,
            allowPaging: true,
            allowTextWrap: true,
            allowSorting: true,
            allowExcelExport: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#Grid'), $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        activate();

        function openCoachesLeavingAthletes(coachId, sectionId, gender2) {
            new ej2.data.DataManager(grid.dataSource).executeQuery(new ej2.data.Query().where('SzakosztalyId', 'equal', sectionId)).then(function (data) {
                var sectionName = data.result[0].SzakosztalyNeve;
                var coachName = data.result[0].EdzoNeve;
                var gender = gender2 === 0 ? 'allgender' : (gender2 === 1 ? 'male' : 'female');

                var sectionBelongsToUser = false;
                for (var i = 0; i < vm.accessibleSections.length; i++) {
                    if (vm.accessibleSections[i] == sectionId) {
                        sectionBelongsToUser = true;
                        break;
                    }
                }
                if (sectionBelongsToUser || vm.isAdmin) {
                    paramHelper.setParams([
                        {'state': 'leavingAthletesFromCoach'},
                        {'dateFrom': vm.DateFrom},
                        {'dateTo': vm.DateTo},
                        {'coachId': coachId},
                        {'coachName': coachName},
                        {'gender': gender}
                    ]);
                    $state.go('reports.statisticalReports.listAthletes');
                } else {
                    log.htmlWarning(gettextCatalog.getString('You do not have permission to access the selected section details!') + '<br><br>' + gettextCatalog.getString(sectionName));
                }
            });
        }

        function openCoach(edzoId) {
            $q.all([authenticationService.getRight('MODFELH'), authenticationService.getRight('MEGTFELH')]).then(function (results) {
                if (results[0] || results[1]) {
                    paramHelper.setParams([{'newUser.userId': edzoId}]);
                    $state.go('settings.userManagement.modifyUser');
                } else {
                    log.permissionError();
                }
            });
        }

        function openSection(sectionId) {
            new ej2.data.DataManager(grid.dataSource).executeQuery(new ej2.data.Query().where('SzakosztalyId', 'equal', sectionId)).then(function (data) {
                var sectionName = data.result[0].SzakosztalyNeve;

                var sectionBelongsToUser = false;
                for (var i = 0; i < vm.accessibleSections.length; i++) {
                    if (vm.accessibleSections[i] == sectionId) {
                        sectionBelongsToUser = true;
                        break;
                    }
                }
                if (sectionBelongsToUser || vm.isAdmin) {
                    paramHelper.setParams([
                        {'state': 'leavingAthletes'},
                        {'sectionId': sectionId},
                        {'sectionName': sectionName},
                        {'dateFrom': vm.DateFrom},
                        {'dateTo': vm.DateTo},
                        {'gender': 'allgender'}
                    ]);
                    $state.go('reports.statisticalReports.listAthletes');
                } else {
                    log.htmlWarning(gettextCatalog.getString('You do not have permission to access the selected section details!') + '<br><br>' + gettextCatalog.getString(sectionName));
                }
            });
        }

        function activate() {
            authenticationService.getRight('KMKILEPEDZO').then(function (results) {
                if (results !== true) {
                    log.permissionError(true);
                } else {
                    getNumbers(vm.DateFrom, vm.DateTo);
                }
            });
        }

        function checkboxChanged(args) {
            vm.showEachSections = args.value;
            filterAthletes();
        }

        function filterAthletes() {
            vm.athleteList = [];
            if (!vm.showEachSections) {
                for (var i = 0; i < vm.athleteListFull.length; i++) {
                    for (var s = 0; s < vm.accessibleSections.length; s++) {
                        if (vm.athleteListFull[i].SzakosztalyId == vm.accessibleSections[s]) {
                            vm.athleteList.push(vm.athleteListFull[i]);
                        }
                    }
                }
            } else {
                vm.athleteList = vm.athleteListFull;
                grid.dataSource = vm.athleteList;
            }
        }

        function getNumbers(dateFrom, dateTo) {
            dataservice.leavingAthletesByCoach(dateFrom, dateTo)
                .then(function (data) {
                    vm.userId = data.userId;
                    vm.isAdmin = data.isAdmin;
                    vm.isSectionLeader = data.isSectionLeader;
                    vm.athleteListFull = data.itemsList;
                    vm.accessibleSections = data.felhasznaloSzakosztalyai;
                    vm.isAdmin = data.isAdmin;
                    if (data.isAdmin == true) {
                        vm.checked = true;
                    }
                    filterAthletes();
                });
        }

        function dateFromChanged(data) {
            getNumbers(data.value, vm.DateTo);
        }

        function dateToChanged(data) {
            getNumbers(vm.DateFrom, data.value);
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.reports.statisticalReports.leavingAthletesByCoach')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'reports.statisticalReports.leavingAthletesByCoach',
                config: {
                    url: '/leavingAthletesByCoach',
                    templateUrl: 'app/reports/statisticalReports/leavingAthletesByCoach/leavingAthletesByCoach.html',
                    controller: 'LeavingAthletesByCoachController',
                    controllerAs: 'vm',
                    title: 'LeavingAthletesByCoach',
                    settings: {
                        navId: 35214,
                        level: 3,
                        order: 5,
                        orderTitle_hu: 'Kilépők széma edzőnként',
                        orderTitle_en: 'Number of Left Athletes by Coaches',
                        parentId: 214,
                        content: 'LeavingAthletesByCoach',
                        activatorPermission: '"KMKILEPEDZO"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    LeavingAthletesBySection.$inject = ["log", "dataservice", "$rootScope", "gettextCatalog", "authenticationService", "$scope", "$state", "paramHelper"];
    angular
        .module('app.reports.statisticalReports.leavingAthletesBySection')
        .controller('LeavingAthletesBySection', LeavingAthletesBySection);

    function LeavingAthletesBySection(log, dataservice, $rootScope, gettextCatalog, authenticationService, $scope, $state, paramHelper) {
        var vm = this;
        $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('LeavingAthletesBySection');
        vm.sectionList = [];
        vm.athleteList = [];
        vm.accessibleSections = [];
        vm.columns = [
            {
                field: 'SzakosztalyNeve',
                headerText: gettextCatalog.getString('Section')
            }, {
                field: 'SzamKilepett',
                headerText: gettextCatalog.getString('NumberOfAthletes'), template: '#leatbysetemplateDataColumn1'
            }, {
                field: 'SzamFiu',
                headerText: gettextCatalog.getString('NumberOfBoys'), template: '#leatbysetemplateDataColumn2'
            }, {
                field: 'SzamLany',
                headerText: gettextCatalog.getString('NumberOfGirls'), template: '#leatbysetemplateDataColumn3'
            }];
        vm.queryDate = new Date();
        vm.queryDate.setMonth(vm.queryDate.getMonth() - 1);
        vm.queryDate2 = new Date();
        vm.dateChange = dateChange;
        vm.dateChange2 = dateChange2;
        vm.openSection = openSection;
        vm.athleteListFull = [];
        vm.showEachSections = false;
        vm.accessibleSections = [];
        vm.checkboxChanged = checkboxChanged;
        vm.checkboxEnabled = true;
        vm.checkboxchangedonce = false;
        vm.checked = false;
        vm.isAdmin = false;

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItems,
            allowPaging: true,
            allowTextWrap: true,
            allowSorting: true,
            allowExcelExport: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#Grid'), $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        activate();

        function openSection(SectionId, gender2) {
            new ej2.data.DataManager(grid.dataSource).executeQuery(new ej2.data.Query().where('SzakosztalyId', 'equal', SectionId)).then(function (data) {
                var SectionName = data.result[0].SzakosztalyNeve;
                var gender = gender2 === 0 ? 'allgender' : (gender2 === 1 ? 'male' : 'female');

                var sectionBelongsToUser = false;
                for (var i = 0; i < vm.accessibleSections.length; i++) {
                    if (vm.accessibleSections[i] == SectionId) {
                        sectionBelongsToUser = true;
                        break;
                    }
                }
                if (sectionBelongsToUser || vm.isAdmin) {
                    paramHelper.setParams([
                        {'state': 'leavingAthletes'},
                        {'sectionId': SectionId},
                        {'sectionName': SectionName},
                        {'dateFrom': vm.queryDate},
                        {'dateTo': vm.queryDate2},
                        {'gender': gender}
                    ]);
                    $state.go('reports.statisticalReports.listAthletes');
                } else {
                    log.htmlWarning(gettextCatalog.getString('You do not have permission to access the selected section details!') + '<br><br>' + gettextCatalog.getString(SectionName));
                }
            });
        }

        function activate() {
            authenticationService.getRight('KMKILSZAK').then(function (results) {
                if (results !== true) {
                    log.permissionError(true);
                } else {
                    getSections();
                    getNumbers(vm.queryDate, vm.queryDate2);
                }
            });
        }

        function getNumbers(date, date2) {
            dataservice.leavingAthletesBySection(date, date2)
                .then(function (data) {
                    vm.athleteListFull = data.itemsList;
                    vm.accessibleSections = data.felhasznaloSzakosztalyai;
                    vm.isAdmin = data.isAdmin;
                    if (data.isAdmin == true) {
                        vm.checked = true;
                    }
                    filterSections();
                });
        }

        function dateChange(data) {
            getNumbers(data.value, vm.queryDate2);
        }

        function dateChange2(data) {
            getNumbers(vm.queryDate, data.value);
        }

        function checkboxChanged(args) {
            vm.showEachSections = args.value;
            filterSections();
        }

        function filterSections() {
            vm.athleteList = [];
            if (!vm.showEachSections) {
                for (var i = 0; i < vm.athleteListFull.length; i++) {
                    for (var s = 0; s < vm.accessibleSections.length; s++) {
                        if (vm.athleteListFull[i].SzakosztalyId == vm.accessibleSections[s]) {
                            vm.athleteList.push(vm.athleteListFull[i]);
                        }
                    }
                }
            } else {
                vm.athleteList = vm.athleteListFull;
                grid.dataSource = vm.athleteList;
            }
        }

        function getSections() {
            dataservice.sectionDropDownList(0)
                .then(function (data) {
                    data.itemsList.unshift({
                        value: '0',
                        text: gettextCatalog.getString('All')
                    });
                    vm.sectionList = data.itemsList;
                });
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.reports.statisticalReports.leavingAthletesBySection')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'reports.statisticalReports.leavingAthletesBySection',
                config: {
                    url: '/leavingAthletesBySection',
                    templateUrl: 'app/reports/statisticalReports/leavingAthletesBySection/leavingAthletesBySection.html',
                    controller: 'LeavingAthletesBySection',
                    controllerAs: 'vm',
                    title: 'LeavingAthletesBySection',
                    settings: {
                        navId: 32214,
                        level: 3,
                        order: 2,
                        orderTitle_hu: 'Kilépők száma szakosztályonként',
                        orderTitle_en: 'Number of Left Athletes by Sections',
                        parentId: 214,
                        content: 'LeavingAthletesBySection',
                        activatorPermission: '"KMKILSZAK"'

                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    ListAthletesController.$inject = ["log", "$state", "dataservice", "authenticationService", "$q", "gettextCatalog", "$rootScope", "paramHelper", "$scope", "$filter"];
    angular
        .module('app.reports.statisticalReports.listAthletes')
        .controller('ListAthletesController', ListAthletesController);

    function ListAthletesController(log, $state, dataservice, authenticationService, $q, gettextCatalog, $rootScope, paramHelper, $scope, $filter) {
        var vm = this; $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('listAthletes');
        vm.params = [];
        vm.openAthlete = openAthlete;
        vm.openSportServiceFee = openSportServiceFee;
        vm.openCoach = openCoach;
        vm.athleteList = [];
        vm.columns = [];

        setColumns();

        function setColumns() {
            vm.columns = [];
            vm.columns = [{
                field: 'Nev',
                headerText: gettextCatalog.getString('Name'),
                width: 150,
                textAlign: 'left',
                template: '#laopenath'
            }, {
                field: 'SzuletesiIdo',
                headerText: gettextCatalog.getString('BirthDate'),
                width: 100,
                textAlign: 'center'
            }, {
                field: 'Aktiv',
                headerText: gettextCatalog.getString('Active'),
                width: 50,
                textAlign: 'left',
                displayAsCheckBox: true
            }, {
                field: 'EdzoNeve',
                headerText: gettextCatalog.getString('Coach'),
                width: 150,
                textAlign: 'left',
                template: '#laopencoach'
            }, {
                field: 'SzakosztalyNeve',
                headerText: gettextCatalog.getString('Section'),
                width: 150,
                textAlign: 'left'
            }, {
                field: 'KorcsoportNeve',
                headerText: gettextCatalog.getString('AgeGroup'),
                width: 150,
                textAlign: 'left'
            }, {
                field: 'Megjegyzes',
                headerText: gettextCatalog.getString('Comment'),
                width: 150,
                textAlign: 'left'
            }];
        }

        var Grid2 = new ej2.grids.Grid({
            dataSource: vm.athleteList,
            columns: vm.columns,
            toolbar: $rootScope.toolbarItemsWithSearch,
            allowPaging: true,
            allowTextWrap: true,
            allowSorting: true,
            allowExcelExport: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#Grid2'), $scope);
                }
            }
        });

        Grid2.appendTo('#Grid2');
        Grid2.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, Grid2);
        };

        //0: mindkettő, 1: belépés dátuma, 2: kilépés dátuma
        function addColumns(args) {
            if (args === 0 || args === 1) {
                vm.columns.push({field: 'edzosportoloiIdoszakTol', headerText: gettextCatalog.getString('EnteringDate'), width: 100, textAlign: 'center'});
            }
            if (args === 0 || args === 2) {
                vm.columns.push({field: 'edzosportoloiIdoszakIg', headerText: gettextCatalog.getString('ExitingDate'), width: 100, textAlign: 'center'});
            }
            vm.columns.push({field: 'Tagdij', headerText: gettextCatalog.getString('PayedSportServiceFee'), width: 240, textAlign: 'left'});
            vm.columns.push({field: 'Oktatasidij', headerText: gettextCatalog.getString('PayedEducationalFee'), width: 240, textAlign: 'left'});
            vm.columns.push({field: 'Egyenleg', headerText: gettextCatalog.getString('Balance'), width: 150, textAlign: 'left', template: '#laopenfee'});
        }

        activate();

        function activate() {
            $q.all([paramHelper.getParams([], ['state', 'sectionId', 'sectionName', 'dateFrom', 'dateTo', 'gender', 'coachId', 'coachName', 'year'])]).then(function (results) {
                if (results[0].state == null) {
                    $state.go('dashboard');
                }
                vm.params = results[0];
                paramHelper.removeParam('state');
                paramHelper.removeParam('sectionId');
                paramHelper.removeParam('sectionName');
                paramHelper.removeParam('dateFrom');
                paramHelper.removeParam('dateTo');
                paramHelper.removeParam('gender');
                paramHelper.removeParam('coachId');
                paramHelper.removeParam('coachName');
                paramHelper.removeParam('year');
                setTitle(vm.params.state, vm.params.sectionName, vm.params.coachName, vm.params.gender, vm.params.dateFrom, vm.params.dateTo, vm.params.year);
                if (vm.params.state == 'leavingAthletes') {
                    checkRight('KMKILSZAK');
                    addColumns(2);
                    getList(vm.params.gender);
                } else if (vm.params.state == 'joinedAthletes') {
                    checkRight('KMBELSZAK');
                    addColumns(1);
                    getList(vm.params.gender);
                } else if (vm.params.state == 'activeAthletes') {
                    checkRight('KMSPORTSZAK');
                    getList(vm.params.gender);
                } else if (vm.params.state == 'monthlyStatJoined') {
                    checkRight('SPSZAMALAKRESZL');
                    addColumns(0);
                    getMonthlyListJoined();
                } else if (vm.params.state == 'monthlyStatLeaving') {
                    checkRight('SPSZAMALAKRESZL');
                    addColumns(2);
                    getMonthlyListLeaving();
                } else if (vm.params.state == 'athletesByCoach') {
                    checkRight('KMSPORTEDZO');
                    getActiveAthleteListByCoach(vm.params.coachId, vm.params.sectionId, vm.params.dateFrom, vm.params.gender);
                } else if (vm.params.state == 'leavingAthletesFromCoach') {
                    checkRight('KMKILEPEDZO');
                    addColumns(2);
                    getLeavingAthletesFromCoach(vm.params.gender);
                } else if (vm.params.state == 'joinedAthletesToCoach') {
                    checkRight('KMBELEPEDZO');
                    addColumns(1);
                    getJoinedAthletesToCoach(vm.params.gender);
                } else if (vm.params.state == 'monthlyStat') {
                    checkRight('KMSPORTALAK');
                    addColumns(0);
                    vm.params.dateFrom = vm.params.dateFrom.slice(0, 10);
                    getMonthlyListActive(vm.params.gender);
                    vm.params.dateFrom = $filter('dateYearMonthLongStrFilter')(vm.params.dateFrom);
                    $rootScope.title = gettextCatalog.getString('Sportolok Szamanak Alakulasa') + ' (' + gettextCatalog.getString(vm.params.sectionName) + ', ' + gettextCatalog.getString(vm.params.gender) + ', ' + vm.params.dateFrom + ')';
                } else if (vm.params.state == 'activeAthletesByBirthYear') {
                    checkRight('KMSPORTELETKOR');
                    getActiveAthletesByBirthYear(vm.params.sectionId, vm.params.year, vm.params.gender);
                    $rootScope.title = gettextCatalog.getString('activeAthletesByBirthYear') + ' (' + gettextCatalog.getString(vm.params.sectionName) + ', ' + gettextCatalog.getString(vm.params.gender) + ', ' + vm.params.year + ')';
                }
            });
        }

        function checkRight(right) {
            authenticationService.getRight(right).then(function(results) {
                if (results !== true) {
                    log.permissionError(true);
                }
            });
        }

        function setTitle(state, sectionname, coachname, gender, datefrom, dateto, year) {
            var titleText = ' (';
            if (sectionname && sectionname.length > 0) {
                titleText += sectionname + ', ';
            }
            if (coachname && coachname.length > 0) {
                titleText += coachname + ', ';
            }
            if (gender) {
                switch (gender){
                    case 'allgender': titleText += gettextCatalog.getString('allgender'); break;
                    case 'male': titleText += gettextCatalog.getString('male'); break;
                    case 'female': titleText += gettextCatalog.getString('female'); break;
                }
            }
            if (datefrom == dateto) {
                dateto = undefined;
            }
            if (datefrom) {
                titleText += ', ' + datefrom;
            }
            if (dateto) {
                titleText += ' - ' + dateto;
            }
            if (year) {
                titleText + year;
            }
            titleText += ')';
            switch (state){
                case 'activeAthletes': $rootScope.title = gettextCatalog.getString('activeAthletesBySection') + titleText;break;
                case 'leavingAthletes': $rootScope.title = gettextCatalog.getString('leavingAthletesBySection') + titleText;break;
                case 'joinedAthletes': $rootScope.title = gettextCatalog.getString('joinedAthletesBySection') + titleText;break;
                case 'monthlyStatJoined': $rootScope.title = gettextCatalog.getString('joinedAthletesInMonth') + ' (' + $filter('dateYearMonthLongStrFilter')(vm.params.dateFrom) + ')';break;
                case 'monthlyStatLeaving': $rootScope.title = gettextCatalog.getString('leavingAthletesInMonth') + ' (' + $filter('dateYearMonthLongStrFilter')(vm.params.dateFrom) + ')';break;
                case 'athletesByCoach': $rootScope.title = gettextCatalog.getString('AthletesByCoach') + titleText;break;
                case 'leavingAthletesFromCoach': $rootScope.title = gettextCatalog.getString('leavingAthletesFromCoach') + titleText;break;
                case 'joinedAthletesToCoach': $rootScope.title = gettextCatalog.getString('joinedAthletesToCoach') + titleText;break;
                case 'monthlyStat': $rootScope.title = gettextCatalog.getString('monthlyStat') + ' (' + sectionname + ', ' + gender + ', ' + $filter('dateYearMonthLongStrFilter')(vm.params.dateFrom) + ')'; break;
                case 'activeAthletesByBirthYear': $rootScope.title = gettextCatalog.getString('activeAthletesByBirthYear') + titleText;break;
            }
        }

        function refresh() {
            Grid2.columns = vm.columns;
            Grid2.refreshColumns();
            Grid2.dataSource = vm.athleteList;
            Grid2.refresh();
        }

        function nullFilter(arr, prop) {
            arr.forEach(function(e) {
                if (e[prop] === null) {
                    e[prop] = '';
                }
            });
            return arr;
        }

        function getList(gender) {
            dataservice.listAthletes(vm.params.dateFrom, vm.params.dateTo, vm.params.state, vm.params.sectionId, gender).then(function(data) {
                vm.athleteList = data.itemsList;
                vm.athleteList = $filter('dateStringFilter')(vm.athleteList, 'SzuletesiIdo');
                vm.athleteList = $filter('dateStringFilter')(vm.athleteList, 'edzosportoloiIdoszakTol');
                vm.athleteList = $filter('dateStringFilter')(vm.athleteList, 'edzosportoloiIdoszakIg');
                vm.athleteList = nullFilter(vm.athleteList, 'Egyenleg');
                refresh();
            });
        }

        function getActiveAthletesByBirthYear(sectionId, year, gender) {
            dataservice.activeAthletesByBirthYear(sectionId, year, gender).then(function(data) {
                vm.athleteList = data.itemsList;
                vm.athleteList = $filter('dateStringFilter')(vm.athleteList, 'SzuletesiIdo');
                vm.athleteList = $filter('dateStringFilter')(vm.athleteList, 'edzosportoloiIdoszakTol');
                vm.athleteList = $filter('dateStringFilter')(vm.athleteList, 'edzosportoloiIdoszakIg');
                vm.athleteList = nullFilter(vm.athleteList, 'Egyenleg');
                refresh();
            });
        }

        function getActiveAthleteListByCoach(coachId, sectionId, dateFrom, gender) {
            dataservice.activeAthletesByCoach(coachId, sectionId, dateFrom, gender).then(function(data) {
                vm.athleteList = data.itemsList;
                vm.athleteList = $filter('dateStringFilter')(vm.athleteList, 'SzuletesiIdo');
                vm.athleteList = $filter('dateStringFilter')(vm.athleteList, 'edzosportoloiIdoszakTol');
                vm.athleteList = $filter('dateStringFilter')(vm.athleteList, 'edzosportoloiIdoszakIg');
                vm.athleteList = nullFilter(vm.athleteList, 'Egyenleg');
                refresh();
            });
        }

        function getMonthlyListActive(gender) {
            dataservice.ActiveAthletesInASpecificMonth(vm.params.dateFrom, vm.params.dateFrom, vm.params.sectionId, gender).then(function(data) {
                vm.athleteList = data.itemsList;
                vm.athleteList = $filter('dateStringFilter')(vm.athleteList, 'SzuletesiIdo');
                vm.athleteList = $filter('dateStringFilter')(vm.athleteList, 'edzosportoloiIdoszakTol');
                vm.athleteList = $filter('dateStringFilter')(vm.athleteList, 'edzosportoloiIdoszakIg');
                vm.athleteList = nullFilter(vm.athleteList, 'Egyenleg');
                refresh();
            });
        }

        function getMonthlyListJoined() {
            dataservice.JoinedAthletesInASpecificMonth(vm.params.dateFrom).then(function(data) {
                vm.athleteList = data.itemsList;
                vm.athleteList = $filter('dateStringFilter')(vm.athleteList, 'SzuletesiIdo');
                vm.athleteList = $filter('dateStringFilter')(vm.athleteList, 'edzosportoloiIdoszakTol');
                vm.athleteList = $filter('dateStringFilter')(vm.athleteList, 'edzosportoloiIdoszakIg');
                vm.athleteList = nullFilter(vm.athleteList, 'Egyenleg');
                refresh();
            });
        }

        function getMonthlyListLeaving() {
            dataservice.LeavingAthletesInASpecificMonth(vm.params.dateFrom).then(function(data) {
                vm.athleteList = data.itemsList;
                vm.athleteList = $filter('dateStringFilter')(vm.athleteList, 'SzuletesiIdo');
                vm.athleteList = $filter('dateStringFilter')(vm.athleteList, 'edzosportoloiIdoszakTol');
                vm.athleteList = $filter('dateStringFilter')(vm.athleteList, 'edzosportoloiIdoszakIg');
                vm.athleteList = nullFilter(vm.athleteList, 'Egyenleg');
                refresh();
            });
        }

        function getLeavingAthletesFromCoach(gender) {
            dataservice.leavingAthletesFromASpecificCoach(vm.params.coachId, vm.params.dateFrom, vm.params.dateTo, gender).then(function(data) {
                vm.athleteList = data.itemsList;
                vm.athleteList = $filter('dateStringFilter')(vm.athleteList, 'SzuletesiIdo');
                vm.athleteList = $filter('dateStringFilter')(vm.athleteList, 'edzosportoloiIdoszakTol');
                vm.athleteList = $filter('dateStringFilter')(vm.athleteList, 'edzosportoloiIdoszakIg');
                vm.athleteList = nullFilter(vm.athleteList, 'Egyenleg');
                refresh();
            });
        }

        function getJoinedAthletesToCoach(gender) {
            dataservice.joinedAthletesToASpecificCoach(vm.params.coachId, vm.params.dateFrom, vm.params.dateTo, gender).then(function(data) {
                vm.athleteList = data.itemsList;
                vm.athleteList = $filter('dateStringFilter')(vm.athleteList, 'SzuletesiIdo');
                vm.athleteList = $filter('dateStringFilter')(vm.athleteList, 'edzosportoloiIdoszakTol');
                vm.athleteList = $filter('dateStringFilter')(vm.athleteList, 'edzosportoloiIdoszakIg');
                vm.athleteList = nullFilter(vm.athleteList, 'Egyenleg');
                refresh();
            });
        }

        function openSportServiceFee(SportolokID) {
            var promises = [authenticationService.getRight('MEGTTAGDNYILV'), authenticationService.getRight('MEGTOKTDNYILV')];
            $q.all(promises).then(function (results) {
                if (results[0] !== true || results[1] !== true) {
                    log.permissionError();
                } else {
                    paramHelper.setParams([
                        {'sportServiceFeeRegister.athleteID': SportolokID}
                    ]);
                    $state.go('business.sportServiceFeeRegister');
                }
            });
        }

        function openAthlete(id) {
            $q.all([authenticationService.getRight('MEGTSPORTLIST')]).then(function (results) {
                if (results[0]) {
                    paramHelper.setParams([{'athleteModify.sportoloId': id}]);
                    $state.go('athletes.athletesManagement.athleteModify.dataSheet');
                } else {
                    log.permissionError();
                }
            });
        }

        function openCoach(edzoId) {
            $q.all([authenticationService.getRight('MODFELH'), authenticationService.getRight('MEGTFELH')]).then(function (results) {
                if (results[0] || results[1]) {
                    paramHelper.setParams([{'newUser.userId': edzoId}]);
                    $state.go('settings.userManagement.modifyUser');
                } else {
                    log.permissionError();
                }
            });
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.reports.statisticalReports.listAthletes')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'reports.statisticalReports.listAthletes',
                config: {
                    url: '/listAthletes',
                    templateUrl: 'app/reports/statisticalReports/listAthletes/listAthletes.html',
                    controller: 'ListAthletesController',
                    controllerAs: 'vm',
                    title: 'listAthletes'
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.reports.statisticalReports')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'reports.statisticalReports',
                config: {
                    title: 'statisticalReports',
                    url: '/statisticalReports',
                    templateUrl: 'app/reports/statisticalReports/statisticalReports.html',
                    settings: {
                        navId: 214,
                        level: 2,
                        order: 1,
                        orderTitle_hu: 'Statisztikai kimutatások',
                        orderTitle_en: 'Statistical Reports',
                        parentId: 4,
                        content: 'StatisticalReports'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    TrainingAttendanceReportController.$inject = ["log", "dataservice", "$rootScope", "gettextCatalog", "authenticationService", "$scope", "$filter", "$state", "paramHelper", "$q"];
    angular
        .module('app.reports.trainingAttendanceReport')
        .controller('TrainingAttendanceReportController', TrainingAttendanceReportController);

    function TrainingAttendanceReportController(log, dataservice, $rootScope, gettextCatalog, authenticationService, $scope, $filter, $state, paramHelper, $q) {
        var vm = this; $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('TrainingAttendanceReport');

        // Create variables
        vm.dateFromValue = new Date(new Date().getFullYear(), 0, 1);
        vm.dateToValue = new Date(new Date().getFullYear(), 11, 31);
        vm.coachId = 0;
        vm.coachList = [];
        vm.coachDataBound = coachDataBound;
        vm.show = show;
        vm.goToAthlete = goToAthlete;

        vm.columns = [
            {field: 'SportolokID', isPrimaryKey: true, visible: false},
            {field: 'SportoloNeve', headerText: gettextCatalog.getString('Athlete'), textAlign: 'left', width: 150,
                template: '#trainingAttendanceReportcolumnTemplate'},
            {field: 'SzuletesiDatum', headerText: gettextCatalog.getString('Birthdate'), textAlign: 'left', width: 150},
            {field: 'EdzesekSzama', headerText: gettextCatalog.getString('Attendance'), textAlign: 'left', width: 150},
            {field: 'JelenletOsszMinden', headerText: gettextCatalog.getString('AllAttendance'), textAlign: 'left', width: 150},
            {field: 'OsszEdzesekSzama', headerText: '*' + gettextCatalog.getString('Trainings'), textAlign: 'left', width: 150},
            {field: 'JelenletSzazalek', headerText: '*' + gettextCatalog.getString('AttendancePercentage'), textAlign: 'left', width: 150}
        ];

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItems,
            allowPaging: true,
            allowSorting: true,
            allowTextWrap: true,
            allowExcelExport: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile(grid, $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        // Activate page
        activate();

        function activate() {
            authenticationService.getRight('EDZLATSTAT').then(function (result) {
                if (result !== true) {
                    log.permissionError(true);
                } else {
                    getCoachList();
                    setDropDowns();
                }
            });
        }

        function setDropDowns() {
            var promises = [paramHelper.getParams([], [
            'tar.from',
            'tar.to',
            'tar.coach'
            ])
            ];
            $q.all(promises).then(function (results) {
                vm.dateFromValue = results[0]['tar.from'];
                vm.dateToValue = results[0]['tar.to'];
                vm.coachId = results[0]['tar.coach'];
            });
        }

        function getCoachList() {
            return dataservice.coachSelect().then(function (data) {
                vm.coachList = data.itemsList;
            });
        }

        // Run after data bounded
        function coachDataBound() {
            if (vm.coachList.length === 1) {
                angular.element('#coachDropDown').ejDropDownList('selectItemByValue', vm.coachList[0].value);
            } else {
                angular.element('#coachDropDown').ejDropDownList('selectItemByValue', vm.coachId);
            }
        }

        function show() {
            $scope.$broadcast('submitted');
            if ($scope.form.$valid === false) {
                log.errorMsg(gettextCatalog.getString('RequiredFieldsError'));
                return;
            }
            paramHelper.setParams([
                {'tar.from': vm.dateFromValue},
                {'tar.to': vm.dateToValue},
                {'tar.coach': vm.coachId}
            ]);
            dataservice.getTrainingAttendances(vm.dateFromValue, vm.dateToValue, vm.coachId).then(function (data) {
                grid.dataSource = $filter('dateStringFilter')(data.itemsList, 'SzuletesiDatum');
            });
        }

        function goToAthlete(id) {
            $q.all([authenticationService.getRight('MEGTSPORTLIST')]).then(function (results) {
                if (results[0]) {
                    paramHelper.setParams([{'athleteModify.sportoloId': id}]);
                    $state.go('athletes.athletesManagement.athleteModify.dataSheet');
                } else {
                    log.permissionError();
                }
            });
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.reports.trainingAttendanceReport')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'reports.trainingAttendanceReport',
                config: {
                    url: '/trainingAttendanceReport',
                    templateUrl: 'app/reports/trainingAttendanceReport/trainingAttendanceReport.html',
                    controller: 'TrainingAttendanceReportController',
                    controllerAs: 'vm',
                    title: 'TrainingAttendanceReport',
                    settings: {
                        navId: 254,
                        level: 2,
                        order: 5,
                        orderTitle_hu: 'Edzéslátogatás statisztika',
                        orderTitle_en: 'Training Visit Statistic',
                        parentId: 4,
                        content: 'TrainingAttendanceReport',
                        activatorPermission: '"EDZLATSTAT"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    weeklyTrainingReportController.$inject = ["log", "dataservice", "$q", "$rootScope", "gettextCatalog", "authenticationService", "$scope", "$filter", "paramHelper", "$state"];
    angular
        .module('app.reports.weeklyTrainingReport')
        .controller('weeklyTrainingReportController', weeklyTrainingReportController);

    function weeklyTrainingReportController(log, dataservice, $q, $rootScope, gettextCatalog, authenticationService, $scope, $filter, paramHelper, $state) {
        var vm = this;
        $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('weeklyTrainingReport');

        vm.place = '';
        vm.sectionList = [];
        vm.places = [];
        vm.sectionId = 0;
        vm.ageGroupList = [];
        vm.ageGroupId = 0;
        vm.coachList = [];
        vm.coachId = 0;
        vm.showWeeks = false;
        vm.onlyStartDate = false;
        vm.selectdateFrom = getMonday(new Date(), 0);
        vm.selectdateTo = getMonday(new Date(), 6);

        vm.sectionDataBound = sectionDataBound;
        vm.sectionSelect = sectionSelect;
        vm.ageGroupDataBound = ageGroupDataBound;
        vm.ageGroupSelect = ageGroupSelect;
        vm.coachDataBound = coachDataBound;
        vm.coachSelect = coachSelect;
        vm.openAthlete = openAthlete;
        vm.openCoach = openCoach;
        vm.show = show;
        vm.openPlan = openPlan;
        vm.showWeeksChange = showWeeksChange;
        vm.savedParams = {sectionId: 0, ageGroupId: 0, coachId: 0};

        vm.dateFromChange = dateFromChange;
        vm.dateToChange = dateToChange;

        vm.columns = [
            {field: 'Link', headerText: '', template: '#wtro', textAlign: 'center', width: 60},
            {field: 'szakosztaly', headerText: gettextCatalog.getString('Section'), textAlign: 'center', width: 150},
            {field: 'korosztaly', headerText: gettextCatalog.getString('AgeGroup'), textAlign: 'center', width: 150},
            {field: 'edzo', headerText: gettextCatalog.getString('Coach'), textAlign: 'center', width: 150},
            {field: 'helyszin', headerText: gettextCatalog.getString('Place'), textAlign: 'center', width: 150},
            {field: 'hetszama', headerText: gettextCatalog.getString('FelkHetSzam'), textAlign: 'center', width: 150},
            {field: 'nap', headerText: gettextCatalog.getString('Date'), textAlign: 'center', width: 150},
            {field: 'tol', headerText: gettextCatalog.getString('From'), textAlign: 'center', width: 150},
            {field: 'ig', headerText: gettextCatalog.getString('To'), textAlign: 'center', width: 150},
        ];

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItems,
            allowPaging: true,
            allowTextWrap: true,
            allowSorting: true,
            allowExcelExport: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            beforePrint: $rootScope.beforePrintGrid,
            printComplete: $rootScope.printCompleteGrid,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#Grid'), $scope);
                }
            },
            rowSelected: function (args) {
                vm.selectedRowId = args.data.Id;
                vm.delEnabled = vm.MODHETIEDZTERV;
                $scope.$apply();
            },
            rowDeselected: function () {
                vm.delEnabled = false;
                vm.selectedRowId = -1;
                $scope.$apply();
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        function getMonday(d, plusDay) {
            d = new Date(d);
            var day = d.getDay();
            var diff = d.getDate() - day + (day == 0 ? -6 : 1) + plusDay; // adjust when day is sunday
            return new Date(d.setDate(diff));
        }

        activate();

        function activate() {
            authenticationService.getRight('MEGTHETIEDZTERVKIMUT').then(function (result) {
                if (result !== true) {
                    log.permissionError(true);
                } else {
                    getSections();
                    getPlaces();
                    setDropDowns();
                }
            });
        }

        function setDropDowns() {
            var promises = [paramHelper.getParams([], [
                'wtr.sectionId',
                'wtr.ageGroupId',
                'wtr.coachId',
                'wtr.showWeeks',
                'wtr.place'
            ])];
            $q.all(promises).then(function (results) {
                vm.sectionId = results[0]['wtr.sectionId'];
                vm.ageGroupId = results[0]['wtr.ageGroupId'];
                vm.coachId = results[0]['wtr.coachId'];
                vm.place = results[0]['wtr.place'];
                angular.element('#ShowWeeks').ejCheckBox({checked: results[0]['wtr.showWeeks']});
            });
        }

        function initColumns(weekly) {
            if (weekly) {
                grid.columns = [
                    {field: 'Link', headerText: '', template: '#wtro', textAlign: 'center', width: 60},
                    {field: 'szakosztaly', headerText: gettextCatalog.getString('Section'), textAlign: 'center', width: 150},
                    {field: 'korosztaly', headerText: gettextCatalog.getString('AgeGroup'), textAlign: 'center', width: 150},
                    {field: 'edzo', headerText: gettextCatalog.getString('Coach'), textAlign: 'center', width: 150},
                    {field: 'helyszin', headerText: gettextCatalog.getString('Place'), textAlign: 'center', width: 150},
                    {field: 'hetszama', headerText: gettextCatalog.getString('FelkHetSzam'), textAlign: 'center', width: 150},
                    {field: 'nap', headerText: gettextCatalog.getString('Monday'), textAlign: 'center', width: 150},
                ];
                grid.refreshColumns();
            } else {
                grid.columns = [
                    {field: 'Link', headerText: '', template: '#wtro', textAlign: 'center', width: 60},
                    {field: 'szakosztaly', headerText: gettextCatalog.getString('Section'), textAlign: 'center', width: 150},
                    {field: 'korosztaly', headerText: gettextCatalog.getString('AgeGroup'), textAlign: 'center', width: 150},
                    {field: 'edzo', headerText: gettextCatalog.getString('Coach'), textAlign: 'center', width: 150},
                    {field: 'helyszin', headerText: gettextCatalog.getString('Place'), textAlign: 'center', width: 150},
                    {field: 'hetszama', headerText: gettextCatalog.getString('FelkHetSzam'), textAlign: 'center', width: 150},
                    {field: 'nap', headerText: gettextCatalog.getString('Date'), textAlign: 'center', width: 150},
                    {field: 'tol', headerText: gettextCatalog.getString('From'), textAlign: 'center', width: 150},
                    {field: 'ig', headerText: gettextCatalog.getString('To'), textAlign: 'center', width: 150},
                ];
                grid.refreshColumns();
            }
        }

        function getPlaces() {
            dataservice.WeeklyTrainingPlaces().then(function (data) {
                vm.places = data.data;
            });
        }

        function getSections() {
            dataservice.sectionDropDownList(0)
                .then(function (data) {
                    if (data.itemsList.length > 1) {
                        data.itemsList.unshift({value: 0, text: gettextCatalog.getString('All')});
                    }
                    vm.sectionList = data.itemsList;
                });
        }

        function sectionDataBound() {
            if (vm.sectionList.length === 1) {
                angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.sectionList[0].value);
            } else {
                angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.sectionId);
            }
        }

        function sectionSelect(args) {
            getAgeGroups(args.value);
            getActualCoachesList(0);
        }

        function getAgeGroups(sectionId) {
            return dataservice.ageGroupDropDownList(sectionId).then(function (data) {
                if (data.itemsList.length !== 1) {
                    data.itemsList.unshift({text: gettextCatalog.getString('All'), value: 0});
                }
                vm.ageGroupList = data.itemsList;
            });
        }

        function ageGroupDataBound() {
            if (vm.ageGroupList.length === 1) {
                angular.element('#ageGroupDropDown').ejDropDownList('selectItemByValue', vm.ageGroupList[0].value);
            } else {
                angular.element('#ageGroupDropDown').ejDropDownList('selectItemByValue', vm.ageGroupId);
                if (vm.ageGroupId) {
                    getActualCoachesList(0);
                }
            }
        }

        function ageGroupSelect(args) {
            getActualCoachesList(args.value);
        }

        function getActualCoachesList(ageGroupId) {
            return dataservice.coachDropDownList(vm.sectionId, ageGroupId, vm.selectdateFrom, vm.selectdateTo).then(function (data) {
                if (data.itemsList.length !== 1) {
                    data.itemsList.unshift({text: gettextCatalog.getString('All'), value: 0});
                }
                vm.coachList = data.itemsList;
            });
        }

        function coachDataBound() {
            if (vm.coachList.length === 1) {
                angular.element('#coachDropDown').ejDropDownList('selectItemByValue', vm.coachList[0].value);
            } else {
                angular.element('#coachDropDown').ejDropDownList('selectItemByValue', vm.coachId);
            }
        }

        function coachSelect(args) {
            vm.coachId = args.value;
        }

        function show() {
            $scope.$broadcast('submitted');
            if ($scope.form.$valid === false) {
                log.errorMsg(gettextCatalog.getString('RequiredFieldsError'));
                return;
            }
            if (vm.place == null) {
                vm.place = '';
            }
            if (vm.showWeeks == null) {
                vm.showWeeks = false;
            }
            paramHelper.setParams([{
                'wtr.sectionId': vm.sectionId,
                'wtr.ageGroupId': vm.ageGroupId,
                'wtr.coachId': vm.coachId,
                'wtr.selectdateFrom': vm.selectdateFrom,
                'wtr.selectdateTo': vm.selectdateTo,
                'wtr.showWeeks': vm.showWeeks,
                'wtr.place': vm.place
            }]);
            dataservice.getWeeklyTrainingList(vm.sectionId, vm.ageGroupId, vm.coachId, vm.selectdateFrom, vm.selectdateTo, vm.showWeeks, vm.place).then(function (data) {
                grid.dataSource = $filter('dateStringFilter')(data.itemsList, 'nap');
                initColumns(vm.showWeeks);
            });
        }

        function openAthlete(id) {
            $q.all([authenticationService.getRight('MEGTSPORTLIST')]).then(function (results) {
                if (results[0]) {
                    paramHelper.setParams([{'athleteModify.sportoloId': id}]);
                    $state.go('athletes.athletesManagement.athleteModify.dataSheet');
                } else {
                    log.permissionError();
                }
            });
        }

        function openCoach(edzoId) {
            $q.all([authenticationService.getRight('MODFELH'), authenticationService.getRight('MEGTFELH')]).then(function (results) {
                if (results[0] || results[1]) {
                    paramHelper.setParams([{'newUser.userId': edzoId}]);
                    $state.go('settings.userManagement.modifyUser');
                } else {
                    log.permissionError();
                }
            });
        }

        function openPlan(trainingPlanId) {
            authenticationService.getRight('MEGTHETIEDZTERV').then(function (result) {
                if (result !== true) {
                    log.permissionError();
                } else {
                    dataservice.weeklyTrainingPlanSelectByIdNew(trainingPlanId).then(function (data) {
                        paramHelper.setParams([
                            {'weeklyTrainingPlan.edzoId': data.retValue.IdEdzo},
                            {'weeklyTrainingPlan.szakosztalyId': data.retValue.IdSzakosztaly},
                            {'weeklyTrainingPlan.korosztalyId': data.retValue.IdKorosztaly},
                            {'weeklyTrainingPlan.ev': 0},
                            {'weeklyTrainingPlan.trainingPlanId': trainingPlanId},
                            {'weeklyTrainingPlan.edzoNev': data.retValue.EdzoNev},
                            {'weeklyTrainingPlan.szakosztalyNev': data.retValue.SzakosztalyNev},
                            {'weeklyTrainingPlan.korosztalyNev': data.retValue.KorosztalyNev},
                            {'weeklyTrainingPlan.szoveg': ''}
                        ]);
                        $state.go('administration.weeklyTrainingPlan.weeklyTrainingPlanReport');
                    });
                }
            });
        }

        function showWeeksChange(arg) {
            vm.showWeeks = arg.value;
        }

        function dateFromChange(args) {
            vm.selectdateFrom = args.value;
            getActualCoachesList(0);
        }

        function dateToChange(args) {
            vm.selectdateTo = args.value;
            getActualCoachesList(0);
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.reports.weeklyTrainingReport')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'reports.weeklyTrainingReport',
                config: {
                    url: '/weeklyTrainingReport',
                    templateUrl: 'app/reports/weeklyTrainingReport/weeklyTrainingReport.html',
                    controller: 'weeklyTrainingReportController',
                    controllerAs: 'vm',
                    title: 'weeklyTrainingReport',
                    settings: {
                        navId: 2204,
                        level: 2,
                        order: 20,
                        orderTitle_hu: 'Heti edzésterv kimutatás',
                        orderTitle_en: 'Weekly Training Report',
                        parentId: 4,
                        content: 'weeklyTrainingReport',
                        activatorPermission: '"MEGTHETIEDZTERVKIMUT"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    WeeklyTravelReportController.$inject = ["log", "dataservice", "$q", "$rootScope", "gettextCatalog", "authenticationService", "$scope", "$filter", "paramHelper", "$state"];
    angular
        .module('app.reports.weeklyTravelReport')
        .controller('WeeklyTravelReportController', WeeklyTravelReportController);

    function WeeklyTravelReportController(log, dataservice, $q, $rootScope, gettextCatalog, authenticationService, $scope, $filter, paramHelper, $state) {
        var vm = this; $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('WeeklyTravelReport');

        vm.typeList = [
            {value: 1, text: gettextCatalog.getString('Plan')},
            {value: 2, text: gettextCatalog.getString('Fact')},
            {value: 3, text: gettextCatalog.getString('All')}
        ];

        vm.typeId = 3;
        vm.sectionList = [];
        vm.sectionId = 0;
        vm.ageGroupList = [];
        vm.ageGroupId = 0;
        vm.coachList = [];
        vm.coachId = 0;
        vm.datasource = [];
        vm.onlyStartDate = false;
        vm.selectdateFrom = getMonday(new Date(), 0);
        vm.selectdateTo = getMonday(new Date(), 6);
        vm.showOrder = 1;
        vm.typeDataBound = typeDataBound;
        vm.sectionDataBound = sectionDataBound;
        vm.sectionSelect = sectionSelect;
        vm.ageGroupDataBound = ageGroupDataBound;
        vm.ageGroupSelect = ageGroupSelect;
        vm.coachDataBound = coachDataBound;
        vm.busOwnersDataBound = busOwnersDataBound;
        vm.busOwnerSelect = busOwnerSelect;
        vm.typeSelect = typeSelect;
        vm.coachSelect = coachSelect;
        vm.show = show;
        vm.radioButtonChecked = radioButtonChecked;
        vm.openPlan = openPlan;
        vm.busOwners = [];
        vm.busOwnerId = '-1';
        vm.fromDateChange = fromDateChange;
        vm.toDateChange = toDateChange;

        vm.columns = [
            {field: 'Id', isPrimaryKey: true, visible: false},
            {field: 'Link', headerText: '', template: '#WTRPlanOpenTemplate', textAlign: 'center', width: 60},
            {field: 'VersenySorszam', headerText: gettextCatalog.getString('VersenySorszam'), width: 120, textAlign: 'center'},
            {field: 'SzakosztalyNeve', headerText: gettextCatalog.getString('SzakosztalyNeve'), width: 150, textAlign: 'center'},
            {field: 'VersenyNeve', headerText: gettextCatalog.getString('VersenyNeve'), width: 150, textAlign: 'center'},
            {field: 'VersenyHelye', headerText: gettextCatalog.getString('VersenyHelye'), width: 150, textAlign: 'center'},
            {field: 'SzallitoJarmuTipusa', headerText: gettextCatalog.getString('JarmuTipus'), width: 150, textAlign: 'center'},
            {field: 'SzallitoJarmuTulajdonos', headerText: gettextCatalog.getString('JarmuTulajdonos'), width: 150, textAlign: 'center'},
            {field: 'JarmuKiallasIdopontja', headerText: gettextCatalog.getString('JarmuKiallasIdopontja'), width: 150, textAlign: 'center'},
            {field: 'JarmuKiallasHelye', headerText: gettextCatalog.getString('JarmuKiallasHelye'), width: 150, textAlign: 'center'},
            {field: 'VisszaindulasIdopontja', headerText: gettextCatalog.getString('VisszaindulasIdopontja'), width: 150, textAlign: 'center'},
            {field: 'FelelosEdzoNeve', headerText: gettextCatalog.getString('FelelosEdzoNeve'), width: 150, textAlign: 'center'},
            {field: 'EdzoElerhetosege', headerText: gettextCatalog.getString('EdzoElerhetosege'), width: 150, textAlign: 'center'},
            {field: 'Vegleges', headerText: gettextCatalog.getString('Final'), displayAsCheckBox: true, width: 150, textAlign: 'center'}
        ];

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItems,
            allowPaging: true,
            allowSorting: true,
            allowTextWrap: true,
            allowExcelExport: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            beforePrint: $rootScope.beforePrintGrid,
            printComplete: $rootScope.printCompleteGrid,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#Grid'), $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        function getMonday(d, plusDay) {
            d = new Date(d);
            var day = d.getDay();
            var diff = d.getDate() - day + (day == 0 ? -6 : 1) + plusDay; // adjust when day is sunday
            return new Date(d.setDate(diff));
        }

        activate();

        function activate() {
            authenticationService.getRight('UTAZTERVMEGT').then(function (result) {
                if (result !== true) {
                    log.permissionError(true);
                } else {
                    getSections();
                    getBusOwners();
                    setDropDowns();
                }
            });
        }

        function setDropDowns() {
            var promises = [paramHelper.getParams([], [
                'weeklyTrainingPlans.sectionId',
                'weeklyTrainingPlans.ageGroupId',
                'weeklyTrainingPlans.coachId',
                'weeklyTrainingPlans.onlyStartDate',
                'weeklyTrainingPlans.typeId',
                'weeklyTrainingPlans.busOwnerId'
            ])];
            $q.all(promises).then(function (results) {
                vm.sectionId = results[0]['weeklyTrainingPlans.sectionId'] ? results[0]['weeklyTrainingPlans.sectionId'] : vm.sectionId;
                vm.ageGroupId = results[0]['weeklyTrainingPlans.ageGroupId'] ? results[0]['weeklyTrainingPlans.ageGroupId'] : vm.ageGroupId;
                vm.coachId = results[0]['weeklyTrainingPlans.coachId'] ? results[0]['weeklyTrainingPlans.coachId'] : vm.coachId;
                vm.onlyStartDate = results[0]['weeklyTrainingPlans.onlyStartDate'] != null ? results[0]['weeklyTrainingPlans.onlyStartDate'] : vm.onlyStartDate;
                vm.typeId = results[0]['weeklyTrainingPlans.typeId'] ? results[0]['weeklyTrainingPlans.typeId'] : vm.typeId;
                vm.busOwnerId = results[0]['weeklyTrainingPlans.busOwnerId'] ? results[0]['weeklyTrainingPlans.busOwnerId'] : vm.busOwnerId;
                angular.element('#onlyStartDate').ejCheckBox({checked: vm.onlyStartDate});
            });
        }

        function getBusOwners() {
            dataservice.IdegenKoltsegTervBuszTulaj().then(function (response) {
                vm.busOwners = [{value: '-1', text: ''}];
                for (var i = 0; i < response.data.length; i++) {
                    vm.busOwners.push({value: response.data[i], text: response.data[i]});
                }
            });
        }

        function getSections() {
            dataservice.sectionDropDownList(0, true)
                .then(function (data) {
                    if (data.itemsList.length > 1) {
                        data.itemsList.unshift({value: 0, text: gettextCatalog.getString('All')});
                    }
                    vm.sectionList = data.itemsList;
                });
        }

        // Run after data bounded
        function sectionDataBound() {
            if (vm.sectionList.length === 1) {
                vm.sectionId = vm.sectionList[0].value;
                angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.sectionList[0].value);
            } else {
                angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.sectionId);
            }
        }

        // Run after section selected
        function sectionSelect(args) {
            vm.sectionId = args.value;
            getAgeGroups(args.value);
        }

        function getAgeGroups(sectionId) {
            return dataservice.ageGroupDropDownList(sectionId).then(function (data) {
                if (data.itemsList.length !== 1) {
                    data.itemsList.unshift({text: gettextCatalog.getString('All'), value: 0});
                }
                vm.ageGroupList = data.itemsList;
            });
        }

        // Run after data bounded
        function ageGroupDataBound() {
            if (vm.ageGroupList.length === 1) {
                angular.element('#ageGroupDropDown').ejDropDownList('selectItemByValue', vm.ageGroupList[0].value);
            } else {
                angular.element('#ageGroupDropDown').ejDropDownList('selectItemByValue', vm.ageGroupId);
                if (vm.ageGroupId) {
                    getActualCoachesList(0);
                }
            }
        }

        // Run after age group selected
        function ageGroupSelect(args) {
            vm.ageGroupId = args.value;
            getActualCoachesList(args.value);
        }

        function getActualCoachesList(ageGroupId) {
            return dataservice.coachDropDownList(vm.sectionId, ageGroupId, vm.selectdateFrom, vm.selectdateTo).then(function (data) {
                if (data.itemsList.length !== 1) {
                    data.itemsList.unshift({text: gettextCatalog.getString('All'), value: 0});
                }
                vm.coachList = data.itemsList;
            });
        }

        // Run after data bounded
        function coachDataBound() {
            if (vm.coachList.length === 1) {
                angular.element('#coachDropDown').ejDropDownList('selectItemByValue', vm.coachList[0].value);
            } else {
                angular.element('#coachDropDown').ejDropDownList('selectItemByValue', vm.coachId);
            }
        }

        // Run after age coach selectedplayUpAndDown
        function coachSelect(args) {
            vm.coachId = args.value;
        }
        function typeDataBound() {
            angular.element('#typeDropDown').ejDropDownList('selectItemByValue', vm.typeId);
        }

        function typeSelect(args) {
            vm.typeId = args.value;
        }

        function busOwnersDataBound() {
            if (vm.busOwners.length === 1) {
                angular.element('#BusOwnerDropDown').ejDropDownList('selectItemByValue', vm.busOwners[0].value);
            } else {
                angular.element('#BusOwnerDropDown').ejDropDownList('selectItemByValue', vm.busOwnerId);
            }
        }

        function busOwnerSelect(args) {
            vm.busOwnerId = args.value;
        }

        function show() {
            $scope.$broadcast('submitted');
            if ($scope.form.$valid === false) {
                log.errorMsg(gettextCatalog.getString('RequiredFieldsError'));
                return;
            }
            dataservice.getWeeklyTravelList(vm.sectionId, vm.ageGroupId, vm.coachId, vm.selectdateFrom, vm.selectdateTo, vm.onlyStartDate, vm.typeId, vm.busOwnerId).then(function (data) {
                grid.dataSource = data.itemsList;
            });
            paramHelper.setParams(
                [
                    {'weeklyTrainingPlans.sectionId': vm.sectionId},
                    {'weeklyTrainingPlans.ageGroupId': vm.ageGroupId},
                    {'weeklyTrainingPlans.coachId': vm.coachId},
                    {'weeklyTrainingPlans.onlyStartDate': vm.onlyStartDate},
                    {'weeklyTrainingPlans.typeId': vm.typeId},
                    {'weeklyTrainingPlans.busOwnerId': vm.busOwnerId}
                ]);
        }

        function radioButtonChecked(args) {
            vm.showOrder = args.model.value;
        }

        function openPlan(Id) {
            $q.all([authenticationService.getRight('MEGTIDEGENKOLTSTERV')]).then(function (results) {
                if (results[0]) {
                    paramHelper.setParams([{'awayBudgetPlan.planId': Id}]);
                    $state.go('administration.awayBudgetPlan.awayBudgetPlanCreate');
                } else {
                    log.permissionError();
                }
            });
        }

        function fromDateChange(args) {
            vm.selectdateFrom = args.value;
            getActualCoachesList(0);
        }

        function toDateChange(args) {
            vm.selectdateTo = args.value;
            getActualCoachesList(0);
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.reports.weeklyTravelReport')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'reports.weeklyTravelReport',
                config: {
                    url: '/weeklyTravelReport',
                    templateUrl: 'app/reports/weeklyTravelReport/weeklyTravelReport.html',
                    controller: 'WeeklyTravelReportController',
                    controllerAs: 'vm',
                    title: 'WeeklyTravelReport',
                    settings: {
                        navId: 2174,
                        level: 2,
                        order: 17,
                        orderTitle_hu: 'Utazási összesítő kimutatás',
                        orderTitle_en: 'Travel Report',
                        parentId: 4,
                        content: 'WeeklyTravelReport',
                        activatorPermission: '"UTAZTERVMEGT"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    ScheduleController.$inject = ["log", "dataservice", "$q", "$rootScope", "gettextCatalog", "paramHelper", "authenticationService", "$filter", "DOMAIN", "$timeout", "$scope"];
    angular
        .module('app.schedule')
        .controller('ScheduleController', ScheduleController);

    function ScheduleController(log, dataservice, $q, $rootScope, gettextCatalog, paramHelper, authenticationService, $filter, DOMAIN, $timeout, $scope) {
        var vm = this; $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('Schedule');

        vm.unnamedEvent = gettextCatalog.getString('unnamedEvent');
        // Create variables
        vm.eventColor = '#000000';
        vm.trainingColor = '#169c5f';
        vm.sectionResources = [];
        vm.ageGroupResources = [];
        vm.categoryResources = [
            {text: gettextCatalog.getString('Event'), id: 1, color: vm.eventColor, fontColor: '#000000'},
            {text: gettextCatalog.getString('Training'), id: 2, color: vm.trainingColor, fontColor: '#ffffff'}
        ];
        vm.trainingText = gettextCatalog.getString('Training');
        vm.appointments = [];

        vm.SPORTOLO = null;
        vm.SZULO = null;
        vm.sectionDropDownVisible = true;
        vm.training = false;
        vm.saveThis = {};

        // Public functions
        vm.getSections = getSections;
        vm.sectionDataBound = sectionDataBound;
        vm.sectionSelect = sectionSelect;
        vm.print = print;
        vm.exportAllToIcs = exportAllToIcs;
        vm.trainingCheckboxChanged = trainingCheckboxChanged;

        // Felhasználó kiválasztás
        vm.RecipientsIds = [];
        vm.RecipientsNames = '';
        vm.RecipientsNamesArr = [];
        vm.recipientsText = gettextCatalog.getString('recipients');
        vm.clearText = gettextCatalog.getString('clear');
        vm.showRecipientsText = gettextCatalog.getString('showRecipients');

        vm.searchUser = searchUser;
        vm.searchAthlete = searchAthlete;
        vm.searchParent = searchParent;
        vm.searchUserGroup = searchUserGroup;
        vm.searchSection = searchSection;
        vm.searchTeamsAthletes = searchTeamsAthletes;
        vm.searchTeamsParents = searchTeamsParents;
        vm.searchAgeGroupAthletes = searchAgeGroupAthletes;
        vm.searchAgeGroupParents = searchAgeGroupParents;

        vm.parentsCheckboxChanged = parentsCheckboxChanged;
        vm.athleteCheckboxChanged = athleteCheckboxChanged;
        vm.userCheckboxChanged = userCheckboxChanged;
        vm.usersGroupCheckboxChanged = usersGroupCheckboxChanged;
        vm.sectionsCheckboxChanged = sectionsCheckboxChanged;
        vm.teamsCheckboxChanged = teamsCheckboxChanged;
        vm.teamParentsCheckboxChanged = teamParentsCheckboxChanged;
        vm.ageGroupsCheckboxChanged = ageGroupsCheckboxChanged;
        vm.ageGroupsParentsCheckboxChanged = ageGroupsParentsCheckboxChanged;
        vm.ageGroupDataBound = ageGroupDataBound;
        vm.ageGroupSelect = ageGroupSelect;

        vm.usersList = [];
        vm.athletesList = [];
        vm.parentsList = [];
        vm.usersGroupList = [];
        vm.sectionsList = [];
        vm.teamsAthletesList = [];
        vm.teamParentsList = [];
        vm.ageGroupsList = [];
        vm.ageGroupsParentsList = [];

        vm.usersListAll = [];
        vm.athletesListAll = [];
        vm.parentsListAll = [];
        vm.usersGroupListAll = [];
        vm.sectionsListAll = [];
        vm.teamsAthletesListAll = [];
        vm.teamParentsListAll = [];
        vm.ageGroupsListAll = [];
        vm.ageGroupsParentsListAll = [];

        vm.alertSettings = {};
        initAlertSettings();

        vm.processedTabs = 0;

        vm.showDirectory = showDirectory;
        vm.toolbarPopupClick = toolbarPopupClick;

        vm.toolbarPopupItems = [
            {empid: 1, tooltiptext: gettextCatalog.getString('Ok'), spriteCss: 'msgtools Accept'},
            {empid: 2, tooltiptext: gettextCatalog.getString('Cancel'), spriteCss: 'msgtools Back'}
        ];

        function initAlertSettings() {
            vm.alertSettings = {};
            vm.alertSettings.users = [];
            vm.alertSettings.athletes = [];
            vm.alertSettings.parents = [];
            vm.alertSettings.usergroups = [];
            vm.alertSettings.sections = [];
            vm.alertSettings.teamsathletes = [];
            vm.alertSettings.teamsparents = [];
            vm.alertSettings.agegroupsathletes = [];
            vm.alertSettings.agegroupsparents = [];
        }

        function getUsers() {
            dataservice.CimjegyzekMobil().then(function (data) {
                data.data.lista.forEach(function (element) {
                    switch (element.usersof){
                        case 'users':
                            vm.usersList = element.itemsList;
                            vm.usersListAll = element.itemsList;
                            break;
                        case 'athletes':
                            vm.athletesList = element.itemsList;
                            vm.athletesListAll = element.itemsList;
                            break;
                        case 'parents':
                            vm.parentsList = element.itemsList;
                            vm.parentsListAll = element.itemsList;
                            break;
                        case 'usergroups':
                            vm.usersGroupList = element.itemsList;
                            vm.usersGroupListAll = element.itemsList;
                            break;
                        case 'sections':
                            vm.sectionsList = element.itemsList;
                            vm.sectionsListAll = element.itemsList;
                            break;
                        case 'teamsathletes':
                            vm.teamsAthletesList = element.itemsList;
                            vm.teamsAthletesListAll = element.itemsList;
                            break;
                        case 'teamsparents':
                            vm.teamParentsList = element.itemsList;
                            vm.teamParentsListAll = element.itemsList;
                            break;
                        case 'agegroupsathletes':
                            vm.ageGroupsList = element.itemsList;
                            vm.ageGroupsListAll = element.itemsList;
                            break;
                        case 'agegroupsparents':
                            vm.ageGroupsParentsList = element.itemsList;
                            vm.ageGroupsParentsListAll = element.itemsList;
                            break;
                    }
                });
            });
        }

        function showRecipients() {
            var obj = {};
            obj.Ids = vm.RecipientsIds;
            obj.Message = '-';
            dataservice.getNamesByIds(obj).then(function (data) {
                var txt = '';
                for (var i = 0; i < data.data.length; i++) {
                    txt += data.data[i];
                    if (i < data.data.length - 1 && data.data.length > 1) {
                        txt += ', ';
                    }
                }
                swal({
                    title: gettextCatalog.getString('recipients'),
                    text: txt,
                    type: 'info',
                    showCancelButton: false,
                    confirmButtonColor: '#DD6B55',
                    confirmButtonText: gettextCatalog.getString('Ok')
                });
            });
        }

        function clearRecipients() {
            initAlertSettings();
            vm.RecipientsIds = [];
            vm.RecipientsNames = '';
            vm.RecipientsNamesArr = [];
            vm.emptyGroupList = '';
            $timeout(function () {
                $scope.$apply();
            }, 10);
        }

        function recipientsSettings(tab) {
            var itemstemp = [];
            switch (tab) {
                case 0:
                    itemstemp = angular.element('#usersListBox').ejListBox('getCheckedItems');
                    if (itemstemp.length > 0) {
                        addRecipientNames(itemstemp, 'users');
                    }
                    break;
                case 1:
                    itemstemp = angular.element('#athletesListBox').ejListBox('getCheckedItems');
                    if (itemstemp.length > 0) {
                        addRecipientNames(itemstemp, 'athletes');
                    }
                    break;
                case 2:
                    itemstemp = angular.element('#parentsListBox').ejListBox('getCheckedItems');
                    if (itemstemp.length > 0) {
                        addRecipientNames(itemstemp, 'parents');
                    }
                    break;
                case 3:
                    itemstemp = angular.element('#usersGroupListBox').ejListBox('getCheckedItems');
                    if (itemstemp.length > 0) {
                        addRecipientsFromGroup('usergroupmember', itemstemp);
                    }
                    break;
                case 4:
                    itemstemp = angular.element('#sectionsListBox').ejListBox('getCheckedItems');
                    if (itemstemp.length > 0) {
                        addRecipientsFromGroup('sectionmembers', itemstemp);
                    }
                    break;
                case 5:
                    itemstemp = angular.element('#teamsAthletesListBox').ejListBox('getCheckedItems');
                    if (itemstemp.length > 0) {
                        addRecipientsFromGroup('teammembers', itemstemp);
                    }
                    break;
                case 6:
                    itemstemp = angular.element('#teamParentsListBox').ejListBox('getCheckedItems');
                    if (itemstemp.length > 0) {
                        addRecipientsFromGroup('teammembersparents', itemstemp);
                    }
                    break;
                case 7:
                    itemstemp = angular.element('#ageGroupsListBox').ejListBox('getCheckedItems');
                    if (itemstemp.length > 0) {
                        addRecipientsFromGroup('agegroupsmembers', itemstemp);
                    }
                    break;
                case 8:
                    itemstemp = angular.element('#ageGroupsParentsListBox').ejListBox('getCheckedItems');
                    if (itemstemp.length > 0) {
                        addRecipientsFromGroup('agegroupsmembersparents', itemstemp);
                    }
                    break;
            }
            $scope.$apply();
        }

        function getUserIdsOfGroup(usersof, id, name) {
            var idlist = [];
            idlist.push(id);
            return dataservice.getUserIdsOfGroup(usersof, idlist).then(function (data) {
                if (data.data.length == 0) {
                    vm.emptyGroupList += name + '<br>';
                    return false;
                }
                for (var i = 0; i < data.data.length; i++) {
                    vm.RecipientsIds.push(data.data[i]);
                }
                switch (usersof){
                    case 'usergroupmember':
                        vm.alertSettings.usergroups.push(id);
                        break;
                    case 'sectionmembers':
                        vm.alertSettings.sections.push(id);
                        break;
                    case 'teammembers':
                        vm.alertSettings.teamsathletes.push(id);
                        break;
                    case 'teammembersparents':
                        vm.alertSettings.teamsparents.push(id);
                        break;
                    case 'agegroupsmembers':
                        vm.alertSettings.agegroupsathletes.push(id);
                        break;
                    case 'agegroupsmembersparents':
                        vm.alertSettings.agegroupsparents.push(id);
                        break;
                }
                return name;
            });
        }

        function addRecipientsFromGroup(group, temp) {
            for (var i = 0; i < temp.length; i++) {
                var t = temp[i].data;
                $q.all([getUserIdsOfGroup(group, temp[i].data.value, temp[i].data.text)]).then(function (results) {
                    if (results != false && noDuplicates(results)) {
                        if (vm.RecipientsNames.length > 0) {
                            vm.RecipientsNames += '; ';
                        }
                        vm.RecipientsNames += results;
                        vm.RecipientsNamesArr.push(results);
                    }
                    vm.processedTabs++;
                });
            }
        }

        function addRecipientNames(items, tab) {
            angular.forEach(items, function(value) {
                switch (tab){
                    case 'users':
                        vm.alertSettings.users.push(value.data.value);
                        break;
                    case 'athletes':
                        vm.alertSettings.athletes.push(value.data.value);
                        break;
                    case 'parents':
                        vm.alertSettings.parents.push(value.data.value);
                        break;
                }
                vm.RecipientsIds.push(value.data.value);
                if (noDuplicates(value.text)) {
                    if (vm.RecipientsNames.length > 0) {
                        vm.RecipientsNames += '; ';
                    }
                    vm.RecipientsNames += value.text;
                    vm.RecipientsNamesArr.push(value.text);
                }
            });
            vm.processedTabs++;
        }

        function noDuplicates(newName) {
            for (var i = 0; i < vm.RecipientsNamesArr.length; i++) {
                if (vm.RecipientsNamesArr[i] == newName) {
                    return false;
                }
            }
            return true;
        }

        function getNumberOfCheckedTabs() {
            var itemstemp = [];
            var cnt = 0;
            if (angular.element('#usersListBox').ejListBox('getCheckedItems').length > 0) {
                cnt++;
            }
            if (angular.element('#athletesListBox').ejListBox('getCheckedItems').length > 0) {
                cnt++;
            }
            if (angular.element('#parentsListBox').ejListBox('getCheckedItems').length > 0) {
                cnt++;
            }
            if (angular.element('#usersGroupListBox').ejListBox('getCheckedItems').length > 0) {
                cnt++;
            }
            if (angular.element('#sectionsListBox').ejListBox('getCheckedItems').length > 0) {
                cnt++;
            }
            if (angular.element('#teamsAthletesListBox').ejListBox('getCheckedItems').length > 0) {
                cnt++;
            }
            if (angular.element('#teamParentsListBox').ejListBox('getCheckedItems').length > 0) {
                cnt++;
            }
            if (angular.element('#ageGroupsListBox').ejListBox('getCheckedItems').length > 0) {
                cnt++;
            }
            if (angular.element('#ageGroupsParentsListBox').ejListBox('getCheckedItems').length > 0) {
                cnt++;
            }
            return cnt;
        }

        function toolbarPopupClick(params) {
            vm.processedTabs = 0;
            clearRecipients();
            angular.element('#directory').data('ejDialog').close();
            if (params.currentTarget.id == '1') {
                var tabs = getNumberOfCheckedTabs();
                for (var t = 0; t <= 9; t++) {
                    recipientsSettings(t);
                }
                WaitForRecipientsIds(tabs);
            }
        }

        function WaitForRecipientsIds(tabs) {
            if (vm.processedTabs >= tabs) {
                showRecipients();
                vm.saveThis.alertUsers = vm.RecipientsIds;
                vm.saveThis.alertSettings = vm.alertSettings;
                vm.saveThis.alertSettingsJSON = JSON.stringify(vm.alertSettings);
                switch (vm.saveOrModify){
                    case 'modify':modifyEvent();break;
                    case 'save':
                    default: saveEvent();break;
                }
            } else {
                setTimeout(function() {
                    WaitForRecipientsIds(tabs);
                }, 10);
            }
        }

        function showDirectory(arg) {
            if (vm.saveThis.Id < 0) {
                log.errorMsg(gettextCatalog.getString('WeeklyTrainingEventCannotBeModified'));
                return;
            }
            vm.saveOrModify = arg;
            angular.element('#directory').data('ejDialog').open();
        }

        function searchByName(arr, name) {
            if (!name || name.length == 0) {
                return arr;
            }
            var result = [];
            arr.forEach(function (user) {
                if (user.text.toUpperCase().indexOf(name.toUpperCase()) !== -1) {
                    result.push(user);
                }
            });
            return result;
        }

        function searchUser() {
            angular.element('#chkSelectAllUsers').ejCheckBox({checked: false});
            vm.usersList = searchByName(vm.usersListAll, vm.searchUserParam);
        }

        function searchAthlete() {
            angular.element('#chkSelectAllAthletes').ejCheckBox({checked: false});
            vm.athletesList = searchByName(vm.athletesListAll, vm.searchAthleteParam);
        }

        function searchParent() {
            angular.element('#chkSelectAllParents').ejCheckBox({checked: false});
            vm.parentsList = searchByName(vm.parentsListAll, vm.searchParentParam);
        }

        function searchUserGroup() {
            angular.element('#chkSelectAllUserGroup').ejCheckBox({checked: false});
            vm.usersGroupList = searchByName(vm.usersGroupListAll, vm.searchUserGroupParam);
        }

        function searchSection() {
            angular.element('#chkSelectAllSections').ejCheckBox({checked: false});
            vm.sectionsList = searchByName(vm.sectionsListAll, vm.searchSectionParam);
        }

        function searchTeamsAthletes() {
            angular.element('#chkSelectAllTeams').ejCheckBox({checked: false});
            vm.teamsAthletesList = searchByName(vm.teamsAthletesListAll, vm.searchTeamsAthletesParam);
        }

        function searchTeamsParents() {
            angular.element('#chkSelectAllTeamParents').ejCheckBox({checked: false});
            vm.teamParentsList = searchByName(vm.teamParentsListAll, vm.searchTeamsParentParam);
        }

        function searchAgeGroupAthletes() {
            angular.element('#chkSelectAllAgeGroups').ejCheckBox({checked: false});
            vm.ageGroupsList = searchByName(vm.ageGroupsListAll, vm.searchAgeGroupsAthletesParam);
        }

        function searchAgeGroupParents() {
            angular.element('#chkSelectAllAgeGroupsParents').ejCheckBox({checked: false});
            vm.ageGroupsParentsList = searchByName(vm.ageGroupsParentsListAll, vm.searchAgeGroupsParentParam);
        }

        function userCheckboxChanged(args) {
            for (var i = 0; i < vm.usersList.length; i++) {
                if (args.value) {
                    angular.element('#usersListBox').ejListBox('checkItemByIndex', i);
                } else {
                    angular.element('#usersListBox').ejListBox('uncheckItemByIndex', i);
                }
            }
        }

        function athleteCheckboxChanged(args) {
            for (var i = 0; i < vm.athletesList.length; i++) {
                if (args.value) {
                    angular.element('#athletesListBox').ejListBox('checkItemByIndex', i);
                } else {
                    angular.element('#athletesListBox').ejListBox('uncheckItemByIndex', i);
                }
            }
        }

        function parentsCheckboxChanged(args) {
            for (var i = 0; i < vm.parentsList.length; i++) {
                if (args.value) {
                    angular.element('#parentsListBox').ejListBox('checkItemByIndex', i);
                } else {
                    angular.element('#parentsListBox').ejListBox('uncheckItemByIndex', i);
                }
            }
        }

        function usersGroupCheckboxChanged(args) {
            for (var i = 0; i < vm.usersGroupList.length; i++) {
                if (args.value) {
                    angular.element('#usersGroupListBox').ejListBox('checkItemByIndex', i);
                } else {
                    angular.element('#usersGroupListBox').ejListBox('uncheckItemByIndex', i);
                }
            }
        }

        function sectionsCheckboxChanged(args) {
            for (var i = 0; i < vm.sectionsList.length; i++) {
                if (args.value) {
                    angular.element('#sectionsListBox').ejListBox('checkItemByIndex', i);
                } else {
                    angular.element('#sectionsListBox').ejListBox('uncheckItemByIndex', i);
                }
            }
        }

        function teamsCheckboxChanged(args) {
            for (var i = 0; i < vm.teamsAthletesList.length; i++) {
                if (args.value) {
                    angular.element('#teamsAthletesListBox').ejListBox('checkItemByIndex', i);
                } else {
                    angular.element('#teamsAthletesListBox').ejListBox('uncheckItemByIndex', i);
                }
            }
        }

        function teamParentsCheckboxChanged(args) {
            for (var i = 0; i < vm.teamParentsList.length; i++) {
                if (args.value) {
                    angular.element('#teamParentsListBox').ejListBox('checkItemByIndex', i);
                } else {
                    angular.element('#teamParentsListBox').ejListBox('uncheckItemByIndex', i);
                }
            }
        }

        function ageGroupsCheckboxChanged(args) {
            for (var i = 0; i < vm.ageGroupsList.length; i++) {
                if (args.value) {
                    angular.element('#ageGroupsListBox').ejListBox('checkItemByIndex', i);
                } else {
                    angular.element('#ageGroupsListBox').ejListBox('uncheckItemByIndex', i);
                }
            }
        }

        function ageGroupsParentsCheckboxChanged(args) {
            for (var i = 0; i < vm.ageGroupsParentsList.length; i++) {
                if (args.value) {
                    angular.element('#ageGroupsParentsListBox').ejListBox('checkItemByIndex', i);
                } else {
                    angular.element('#ageGroupsParentsListBox').ejListBox('uncheckItemByIndex', i);
                }
            }
        }

        activate();

        function activate() {
            var accessGranted = false;
            authenticationService.getRight('MEGTESEMNAPT').then(function(results) {
                if (results !== true) {
                    log.permissionError(true);
                    return;
                }

                $q.all([
                    paramHelper.getParams([], ['eventsCalendar.sectionId', 'eventsCalendar.ageGroupId']),
                    getSections(),
                    authenticationService.getLanguage(),
                    authenticationService.getRight('MEGTESEMNAPT'),
                    authenticationService.getRight('MODESEMNAPT'),
                    authenticationService.getRight('UJESEMNAPT'),
                    getSectionResources(),
                    getAgeGroupResources(),
                    authenticationService.getRight('SPORTOLO'),
                    authenticationService.getRight('SZULO')])
                    .then(function (results) {
                        if (results[3] !== true) {
                            log.permissionError(true);
                            return;
                        }
                        if (results[0]['eventsCalendar.sectionId']) {
                            vm.sectionId = results[0]['eventsCalendar.sectionId'];
                        } else {
                            vm.sectionId = 0;
                        }
                        if (results[0]['eventsCalendar.ageGroupId']) {
                            vm.ageGroupId = results[0]['eventsCalendar.ageGroupId'];
                        } else {
                            vm.ageGroupId = 0;
                        }

                        vm.language = results[2];
                        vm.MODESEMNAPT = results[4];
                        vm.UJESEMNAPT = results[5];

                        createSchedule();

                        vm.SPORTOLO = results[8];
                        vm.SZULO = results[9];

                        setSectionVisible();

                        getUsers();
                        getEvents();
                    });
            });
        }

        function setSectionVisible() {
            vm.sectionDropDownVisible = !(vm.SZULO || vm.SPORTOLO);
        }

        function getSectionResources() {
            return dataservice.getSectionResources().then(function (data) {
                vm.sections = data.itemsList;
                vm.sectionResources = data.itemsList;
            });
        }

        function getAgeGroupResources() {
            return dataservice.getAgeGroupResources().then(function (data) {
                vm.ageGroupResources = data.itemsList;
            });
        }

        function getSections() {
            return dataservice.sectionDropDownList().then(function (data) {
                vm.selectedRowData = {};
                if (data.itemsList.length > 1) {
                    data.itemsList.unshift({value: '0', text: gettextCatalog.getString('All')});
                }
                vm.sectionList = data.itemsList;
            });
        }

        function sectionDataBound() {
            if (vm.sectionList.length === 1) {
                angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.sectionList[0].value);
            } else {
                angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.sectionId);
            }
        }

        function sectionSelect(args) {
            paramHelper.setParams([{'eventsCalendar.sectionId': args.value}]);
            vm.ageGroupId = 0;
            getAgeGroups(args.value);
        }

        function getAgeGroups(sectionId) {
            dataservice.ageGroupDropDownList(sectionId)
                .then(function (data) {
                    if (data.itemsList.length > 1) {
                        data.itemsList.unshift({value: 0, text: gettextCatalog.getString('All')});
                    }
                    vm.ageGroupList = data.itemsList;
                    $('#ageGroupDropDown').ejDropDownList({dataSource: data.itemsList});
                });
        }

        function ageGroupDataBound() {
            console.log(vm.ageGroupId);
            if (vm.ageGroupList.length === 1) {
                vm.ageGroupId = vm.ageGroupList[0].value;
                angular.element('#ageGroupDropDown').ejDropDownList('selectItemByValue', vm.ageGroupId);
            } else {
                angular.element('#ageGroupDropDown').ejDropDownList('selectItemByValue', vm.ageGroupId);
            }
        }

        function ageGroupSelect(args) {
            paramHelper.setParams([{'eventsCalendar.ageGroupId': args.value}]);
            vm.ageGroupId = args.value;
            getEvents();
        }

        function getEvents() {
            dataservice.getEvents(vm.date, vm.view, vm.sectionId, vm.training, vm.ageGroupId).then(function (data) {
                vm.appointments = [];
                vm.appointments = data.itemsList;
                vm.appointments = $filter('dateEventFilter')(vm.appointments, vm.view);
                showSchedule();
                clearRecipients();
            });
        }

        function showSchedule() {
            angular.element('#Schedule1').ejSchedule({
                appointmentSettings: {
                    dataSource: vm.appointments
                }
            });
        }

        function createSchedule() {
            angular.element('#Schedule1').ejSchedule({
                appointmentTemplateId: '#apptemplate',
                width: '100%',
                height: '600px',
                views: ['Day', 'Week', 'Month', 'Agenda'],
                currentView: 'Month',
                timeZone: 'UTC +00:00',
                allowDragDrop: false,
                readOnly: !(vm.MODESEMNAPT || vm.UJESEMNAPT),
                timeMode: ej.Schedule.TimeMode.Hour24,
                enableAppointmentResize: false,
                showAppointmentNavigator: false,
                showQuickWindow: false,
                showLocationField: true,
                showTimeZoneFields: false,
                firstDayOfWeek: 'Monday',
                timeZoneCollection: {
                    dataSource: [{
                        text: 'UTC +00:00',
                        id: '1',
                        value: 'UTC +00:00'
                    }]
                },
                categorizeSettings: {
                    enable: true,
                    allowMultiple: false,
                    dataSource: vm.categoryResources,
                    text: 'text', id: 'id', color: 'color', fontColor: 'fontColor'
                },
                highlightBusinessHours: false,
                tooltipSettings: {
                    enable: true
                },
                resources: [
                    {
                        field: 'SectionId',
                        title: gettextCatalog.getString('Section'),
                        name: 'SectionId',
                        allowMultiple: false,
                        resourceSettings: {
                            dataSource: vm.sectionResources,
                            text: 'text',
                            id: 'id',
                            color: 'color',
                            groupId: 'groupId'
                        }
                    },
                    {
                        field: 'AgeGroupId',
                        title: gettextCatalog.getString('AgeGroup'),
                        name: 'AgeGroupId',
                        allowMultiple: false,
                        resourceSettings: {
                            dataSource: vm.ageGroupResources,
                            text: 'text',
                            id: 'id',
                            color: 'color',
                            groupId: 'groupId'
                        }
                    }
                ],
                contextMenuSettings: {
                    enable: true,
                    menuItems: {
                        appointment: [
                            {id: 'open', text: gettextCatalog.getString('OpenAppointment')},
                            {id: 'delete', text: gettextCatalog.getString('DeleteAppointment')},
                            {id: 'export', text: gettextCatalog.getString('ExportToICS')}
                        ],
                        cells: [
                            {id: 'new', text: gettextCatalog.getString('NewAppointment')},
                            {id: 'recurrence', text: gettextCatalog.getString('NewRecurringAppointment')},
                            {id: 'today', text: gettextCatalog.getString('Today')},
                            {id: 'gotodate', text: gettextCatalog.getString('GoToDate')},
                            {id: 'settings', text: gettextCatalog.getString('Settings')},
                            {id: 'view', text: gettextCatalog.getString('View'), parentId: 'settings'},
                            {id: 'timemode', text: gettextCatalog.getString('TimeMode'), parentId: 'settings'},
                            {id: 'view_Day', text: gettextCatalog.getString('Daily'), parentId: 'view'},
                            {id: 'view_Week', text: gettextCatalog.getString('Weekly'), parentId: 'view'},
                            {id: 'view_Month', text: gettextCatalog.getString('Monthly'), parentId: 'view'},
                            {id: 'view_Agenda', text: gettextCatalog.getString('Agenda'), parentId: 'view'},
                            {id: 'timemode_Hour12', text: gettextCatalog.getString('12Hours'), parentId: 'timemode'},
                            {id: 'timemode_Hour24', text: gettextCatalog.getString('24Hours'), parentId: 'timemode'},
                            {id: 'businesshours', text: gettextCatalog.getString('BusinessHours'), parentId: 'settings'}
                        ]
                    }
                },
                prioritySettings: {
                    enable: true,
                    dataSource: [
                       {text: gettextCatalog.getString('No'), value: 0},
                       {text: gettextCatalog.getString('Yes'), value: 1}],
                    text: 'text', value: 'value',
                    template: '<div class=\'${value}\'></div>'
                },
                appointmentSettings: {
                    applyTimeOffset: false,
                    dataSource: vm.appointments,
                    id: 'Id',
                    location: 'Location',
                    subject: 'Subject',
                    startTime: 'StartTime',
                    startTimeZone: 'StartTimeZone',
                    endTime: 'EndTime',
                    endTimeZone: 'EndTimeZone',
                    description: 'Description',
                    allDay: 'AllDay',
                    recurrence: 'Recurrence',
                    recurrenceId: 'RecurrenceId',
                    recurrenceRule: 'RecurrenceRule',
                    resourceFields: 'SectionId,AgeGroupId',
                    categorize: 'Categorize',
                    priority: 'priority'
                },
                menuItemClick: exportToIcs,
                appointmentWindowOpen: appointmentWindowOpen,
                beforeAppointmentCreate: saveAppointment,
                beforeAppointmentChange: changeAppointment,
                beforeAppointmentRemove: removeAppointment,
                navigation: navigation,
                create: onCreate,
                locale: vm.language,
            });
        }

        function setAlertUsers(alertSettings, tab) {
            var array = alertSettings[tab];
            if (!array || array.length == 0) {
                return;
            }
            var index = -1;
            array.forEach(function (id) {
                switch (tab){
                    case 'users':
                        index = $filter('getIndex')(vm.usersListAll, 'value', id);
                        angular.element('#usersListBox').ejListBox('checkItemByIndex', index);
                        break;
                    case 'athletes':
                        index = $filter('getIndex')(vm.athletesListAll, 'value', id);
                        angular.element('#athletesListBox').ejListBox('checkItemByIndex', index);
                        break;
                    case 'parents':
                        index = $filter('getIndex')(vm.parentsListAll, 'value', id);
                        angular.element('#parentsListBox').ejListBox('checkItemByIndex', index);
                        break;
                    case 'usergroups':
                        index = $filter('getIndex')(vm.usersGroupListAll, 'value', id);
                        angular.element('#usersGroupListBox').ejListBox('checkItemByIndex', index);
                        break;
                    case 'sections':
                        index = $filter('getIndex')(vm.sectionsListAll, 'value', id);
                        angular.element('#sectionsListBox').ejListBox('checkItemByIndex', index);
                        break;
                    case 'teamsathletes':
                        index = $filter('getIndex')(vm.teamsAthletesListAll, 'value', id);
                        angular.element('#teamsAthletesListBox').ejListBox('checkItemByIndex', index);
                        break;
                    case 'teamsparents':
                        index = $filter('getIndex')(vm.teamParentsListAll, 'value', id);
                        angular.element('#teamParentsListBox').ejListBox('checkItemByIndex', index);
                        break;
                    case 'agegroupsathletes':
                        index = $filter('getIndex')(vm.ageGroupsListAll, 'value', id);
                        angular.element('#ageGroupsListBox').ejListBox('checkItemByIndex', index);
                        break;
                    case 'agegroupsparents':
                        index = $filter('getIndex')(vm.ageGroupsParentsListAll, 'value', id);
                        angular.element('#ageGroupsParentsListBox').ejListBox('checkItemByIndex', index);
                        break;
                }
            });
        }

        function appointmentWindowOpen(arg) {
            clearRecipients();
            if (arg.hasOwnProperty('appointment')) {
                if (arg.appointment.hasOwnProperty('alertSettings')) {
                    Object.getOwnPropertyNames(arg.appointment.alertSettings).forEach(function (property) {
                        setAlertUsers(arg.appointment.alertSettings, property);
                    });
                    $timeout(function () {
                        if (arg.appointment.alertUsers && arg.appointment.alertUsers.length > 0) {
                            angular.element('#Schedule1priority').ejDropDownList('selectItemByIndex', 1);
                        } else {
                            angular.element('#Schedule1priority').ejDropDownList('selectItemByIndex', 0);
                        }
                        $scope.$apply();
                    }, 100);
                }
            }
            var resData = this.model.resources[0].resourceSettings.dataSource;
            this['_appointmentAddWindow'].find('.owner_' + 0).ejAutocomplete({
                focusOut: function (argument) {
                    var flag = false;
                    for (var i = 0; i < resData.length; i++) {
                        if (argument.value === resData[i].text) {
                            flag = true;
                        }
                    }
                    if (!flag) {
                        log.errorMsg('SelectedSectionDoesnExist');
                    }
                }
            });
            var resData2 = this.model.resources[1].resourceSettings.dataSource;
            this['_appointmentAddWindow'].find('.owner_' + 1).ejAutocomplete({
                focusOut: function (argument) {
                    var flag = false;
                    for (var i = 0; i < resData2.length; i++) {
                        if (argument.value === resData2[i].text) {
                            flag = true;
                        }
                    }
                    if (!flag) {
                        log.errorMsg('SelectedAgeGroupDoesnExist');
                    }
                }
            });
        }

        function onCreate() {
        }

        function exportToIcs(args) {
            if (args.events.ID == 'export') {
                var obj = $('#Schedule1').data('ejSchedule');
                // exportSchedule() method will send a post to the server-side to call a specified action.
                obj.exportSchedule(DOMAIN.baseURL + DOMAIN.webService + 'ExportToICS', null, args.targetInfo.Id);
            }
        }

        function exportAllToIcs(e) {
            var obj = $('#Schedule1').data('ejSchedule');
            // Calls the server-side action ExportToICS
            obj.exportSchedule(DOMAIN.baseURL + DOMAIN.webService + 'ExportToICS', null, null);
            e.cancel = true;
        }

        function navigation(args) {
            vm.date = args.currentDate;
            vm.view = args.currentView;
            getEvents();
        }

        function saveAppointment(args) {
            console.log('saveAppointment', args);
            if (vm.UJESEMNAPT) {
                vm.saveThis = {};
                if (args.appointment[0] === undefined) {
                    vm.saveThis = jQuery.extend({}, args.appointment);
                    vm.saveThis.StartTime = moment(vm.saveThis.StartTime).format('YYYY-MM-DD HH:mm');
                    vm.saveThis.EndTime = moment(vm.saveThis.EndTime).format('YYYY-MM-DD HH:mm');
                    if (vm.saveThis.Subject === '') {
                        vm.saveThis.Subject = vm.unnamedEvent;
                    }
                    var obj = ej.DataManager(vm.categoryResources).executeLocal(new ej.Query().where('id', 'equal', vm.saveThis.Categorize))[0];
                    vm.saveThis.Categorize = obj !== undefined ? obj.id : 1;
                } else {
                    vm.saveThis = jQuery.extend({}, args.appointment[0]);
                    var resData = this.model.resources[0].resourceSettings.dataSource;
                    var resData2 = this.model.resources[1].resourceSettings.dataSource;
                    var value = vm.saveThis.Schedule1_ownerfield_0 === '' ? (vm.saveThis.SectionId ? vm.saveThis.SectionId : 0) : vm.saveThis.Schedule1_ownerfield_0;
                    var value2 = vm.saveThis.Schedule1_ownerfield_1 === '' ? (vm.saveThis.AgeGroupId ? vm.saveThis.AgeGroupId : 0) : vm.saveThis.Schedule1_ownerfield_1;
                    var flag = false;
                    var flag2 = false;
                    for (var i = 0; i < resData.length; i++) {
                        if (value == resData[i].text || value === resData[i].value) {
                            flag = true;
                        }
                    }
                    for (var i = 0; i < resData2.length; i++) {
                        if (value2 == resData2[i].text || value2 === resData2[i].value) {
                            flag2 = true;
                        }
                    }
                    if (!flag) {
                        log.errorMsg('SelectedSectionDoesnExist');
                        args.cancel = true;
                    } else if (!flag2) {
                        log.errorMsg('SelectedAgeGroupDoesnExist');
                        args.cancel = true;
                    } else {
                        vm.saveThis.StartTime = moment(vm.saveThis.StartTime).format('YYYY-MM-DD HH:mm');
                        vm.saveThis.EndTime = moment(vm.saveThis.EndTime).format('YYYY-MM-DD HH:mm');
                        if (vm.saveThis.Subject === '') {
                            vm.saveThis.Subject = vm.unnamedEvent;
                        }
                        var obj = ej.DataManager(vm.categoryResources).executeLocal(new ej.Query().where('id', 'equal', vm.saveThis.Categorize))[0];
                        vm.saveThis.Categorize = obj !== undefined ? obj.id : 1;
                    }
                    // Felhasználók értesítése
                    if (vm.saveThis.priority == '1') {
                        showDirectory('save');
                    } else {
                        saveEvent();
                    }
                }
            } else {
                args.cancel = true;
                log.permissionError();
            }
        }

        function modifyEvent() {
            if (vm.saveThis.Id < 0) {
                log.errorMsg(gettextCatalog.getString('WeeklyTrainingEventCannotBeModified'));
                return;
            }
            dataservice.modifyEvent(vm.saveThis).then(function () {
                log.successMsg('Saved');
                getEvents();
            });
        }

        function saveEvent() {
            dataservice.saveEvent(vm.saveThis).then(function () {
                log.successMsg('Saved');
                getEvents();
            });
        }

        function changeAppointment(args) {
            if (vm.MODESEMNAPT) {
                vm.saveThis = jQuery.extend({}, args.appointment.changed[0]);
                vm.saveThis.StartTime = moment(vm.saveThis.StartTime).format('YYYY-MM-DD HH:mm');
                vm.saveThis.EndTime = moment(vm.saveThis.EndTime).format('YYYY-MM-DD HH:mm');
                var obj = ej.DataManager(vm.categoryResources).executeLocal(new ej.Query().where('id', 'equal', vm.saveThis.Categorize))[0];
                vm.saveThis.Categorize = obj !== undefined ? obj.id : 1;
                // Felhasználók értesítése
                if (vm.saveThis.priority == '1') {
                    showDirectory('modify');
                } else {
                    modifyEvent();
                }
            } else {
                args.cancel = true;
                log.permissionError();
            }
        }

        function removeAppointment(args) {
            if (args.appointment.Id < 0) {
                log.errorMsg(gettextCatalog.getString('WeeklyTrainingEventCannotBeModified'));
                args.cancel = true;
                return;
            }
            var removeDate = null;
            var year = -1;
            var month = -1;
            var day = -1;
            if (args.currentAction == 'deleteOccurrence') {
                removeDate = args.appointment.StartTime;
                year = removeDate.getFullYear();
                month = removeDate.getMonth();
                day = removeDate.getDate();
            }
            dataservice.removeEvent(args.appointment.Id, year, month, day).then(function () {
                getEvents();
            });
        }

        function print() {
            var schObj = angular.element('#Schedule1').data('ejSchedule');
            schObj.print();
        }

        function trainingCheckboxChanged(args) {
            vm.training = args.value;
            getEvents();
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.schedule')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'eventsCalendar',
                config: {
                    url: '/schedule',
                    templateUrl: 'app/schedule/schedule.html',
                    controller: 'ScheduleController',
                    controllerAs: 'vm',
                    title: 'EventsCalendar',
                    settings: {
                        navId: 6,
                        level: 1,
                        order: 6,
                        parentId: 0,
                        content: 'EventsCalendar',
                        permission: ['0', '1', '2', '3', '4', '5', '6'],
                        activatorPermission: '"MEGTESEMNAPT"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.search.athletes')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'search.athletes',
                config: {
                    url: '/athletes',
                    templateUrl: 'app/search/athletes/athletes.html',
                    title: 'SearchAthletes'
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    MemberListController.$inject = ["log", "dataservice", "$q", "$rootScope", "gettextCatalog", "VIEW_DATA", "$scope", "$state", "authenticationService", "paramHelper", "$filter"];
    angular
        .module('app.search.athletes.memberList')
        .controller('MemberListController', MemberListController);

    function MemberListController(log, dataservice, $q, $rootScope, gettextCatalog, VIEW_DATA, $scope, $state, authenticationService, paramHelper, $filter) {
        var vm = this; $rootScope.vm = vm;
        vm.athleteList = [];
        $rootScope.title = gettextCatalog.getString('SearchMemberList');
        vm.countyList = VIEW_DATA.dropDownList.counties;
        vm.courseList = VIEW_DATA.dropDownList.course;
        vm.classList = VIEW_DATA.dropDownList.class;

        // Create variables
        vm.leftrightboth = [
            {text: gettextCatalog.getString(''), value: undefined},
            {text: gettextCatalog.getString('Left'), value: 'Left'},
            {text: gettextCatalog.getString('Right'), value: 'Right'},
            {text: gettextCatalog.getString('Both'), value: 'Both'}
        ];
        vm.genderList = [
            {text: gettextCatalog.getString(''), value: undefined},
            {text: gettextCatalog.getString('Male'), value: 'Male'},
            {text: gettextCatalog.getString('Female'), value: 'Female'}
        ];
        vm.yesno = [
            {text: gettextCatalog.getString(''), value: undefined},
            {text: gettextCatalog.getString('Yes'), value: true},
            {text: gettextCatalog.getString('No'), value: false}
        ];
        vm.muv_EGYEZIK_NEMEGYZIK = [
            {text: gettextCatalog.getString(''), value: undefined},
            {text: gettextCatalog.getString('Egyezik'), value: 'Egyezik'},
            {text: gettextCatalog.getString('Nem egyezik'), value: 'Nem egyezik'}
        ];
        vm.muv_KIJELOLVE_NINCSKIJELOLVE = [
            {text: gettextCatalog.getString(''), value: undefined},
            {text: gettextCatalog.getString('Kijelölve'), value: 'Kijelölve'},
            {text: gettextCatalog.getString('Nincs kijelölve'), value: 'Nincs kijelölve'}
        ];
        vm.muv_E_NEME_TART_NEMT = [
            {text: gettextCatalog.getString(''), value: undefined},
            {text: gettextCatalog.getString('Tartalmazza'), value: 'Tartalmazza'},
            {text: gettextCatalog.getString('Nem tartalmazza'), value: 'Nem tartalmazza'},
            {text: gettextCatalog.getString('Egyezik'), value: 'Egyezik'},
            {text: gettextCatalog.getString('Nem egyezik'), value: 'Nem egyezik'}
        ];
        vm.muv_TAG_NEMTAG = [
            {text: gettextCatalog.getString(''), value: undefined},
            {text: gettextCatalog.getString('Tagja'), value: 'Tagja'},
            {text: gettextCatalog.getString('Nem tagja'), value: 'Nem tagja'}
        ];
        vm.muv_KIJ_NINCSKIJ = [
            {text: gettextCatalog.getString(''), value: undefined},
            {text: gettextCatalog.getString('Kijelölve'), value: 'Kijelölve'}
            /*,{text: gettextCatalog.getString('Nincs kijelölve'), value: 'Nincs kijelölve'}*/
        ];
        vm.muv_DATE = [
            {text: gettextCatalog.getString(''), value: undefined},
            {text: gettextCatalog.getString('Date_Before'), value: '<='},
            {text: gettextCatalog.getString('Date_After'), value: '>='},
            {text: gettextCatalog.getString('Date_At'), value: '='},
            {text: gettextCatalog.getString('Date_NotAt'), value: '≠'},
            {text: gettextCatalog.getString('Date_Between'), value: 'Között'}
        ];
        vm.muv_REL_KOZ = [
            {text: gettextCatalog.getString(''), value: undefined},
            {text: gettextCatalog.getString('Less than'), value: '<='},
            {text: gettextCatalog.getString('Greater than'), value: '>='},
            {text: gettextCatalog.getString('Equals'), value: '='},
            {text: gettextCatalog.getString('Not equal'), value: '≠'},
            {text: gettextCatalog.getString('Between'), value: 'Között'}
        ];

        vm.nameChange = nameChange;
        function nameChange () {
            vm.query.muvnev = 'Tartalmazza';
            vm.NameNotMatchingChecked = false;
            vm.NameExactMatchChecked = false;
        }

        vm.NameExactMatch = NameExactMatch;
        function NameExactMatch (arg) {
            if (arg.value == true) {
                vm.NameNotMatchingChecked = false;
                vm.query.muvnev = 'Egyezik';
            }
        }

        vm.NameNotMatching = NameNotMatching;
        function NameNotMatching (arg) {
            if (arg.value == true) {
                vm.NameExactMatchChecked = false;
                vm.query.muvnev = 'Nem egyezik';
            }
        }

        vm.MemberOfSection = MemberOfSection;
        function MemberOfSection (arg) {
            if (arg.value == true) {
                vm.NotMemberOfSectionChecked = false;
                vm.query.muvszakosztaly = 'Tagja';
            }
        }

        vm.NotMemberOfSection = NotMemberOfSection;
        function NotMemberOfSection (arg) {
            if (arg.value == true) {
                vm.MemberOfSectionChecked = false;
                vm.query.muvszakosztaly = 'Nem tagja';
            }
        }

        vm.MemberOfAgeGroup = MemberOfAgeGroup;
        function MemberOfAgeGroup (arg) {
            if (arg.value == true) {
                vm.NotMemberOfAgeGroupChecked = false;
                vm.query.muvkorosztaly = 'Tagja';
            }
        }

        vm.NotMemberOfAgeGroup = NotMemberOfAgeGroup;
        function NotMemberOfAgeGroup (arg) {
            if (arg.value == true) {
                vm.MemberOfAgeGroupChecked = false;
                vm.query.muvkorosztaly = 'Nem tagja';
            }
        }

        vm.BelongsToCoach = BelongsToCoach;
        function BelongsToCoach (arg) {
            if (arg.value == true) {
                vm.NotBelongsToCoachChecked = false;
                vm.query.muvedzo = 'Egyezik';
            }
        }

        vm.NotBelongsToCoach = NotBelongsToCoach;
        function NotBelongsToCoach (arg) {
            if (arg.value == true) {
                vm.BelongsToCoachChecked = false;
                vm.query.muvedzo = 'Nem egyezik';
            }
        }

        vm.ContactNotMatching = ContactNotMatching;
        function ContactNotMatching(arg) {
            var msg = '';
            if (arg.value == true) {
                swal({
                    title: gettextCatalog.getString('Query will exclude athletes with the given contact details'),
                    text: msg,
                    type: 'warning',
                    confirmButtonText: gettextCatalog.getString('Ok')
                });
            }
        }

        vm.SchoolNotMatching = SchoolNotMatching;
        function SchoolNotMatching(arg) {
            var msg = '';
            if (arg.value == true) {
                swal({
                    title: gettextCatalog.getString('Query will exclude athletes with the given school details'),
                    text: msg,
                    type: 'warning',
                    confirmButtonText: gettextCatalog.getString('Ok')
                });
            }
        }

        vm.ParentNotMatching = ParentNotMatching;
        function ParentNotMatching(arg) {
            var msg = '';
            if (arg.value == true) {
                vm.query.muvanyjaMagTol = '=';
                vm.query.muvapaMagTol = '=';
                swal({
                    title: gettextCatalog.getString('Query will exclude athletes with the given parent details'),
                    text: msg,
                    type: 'warning',
                    confirmButtonText: gettextCatalog.getString('Ok')
                });
            }
        }

        vm.BodyShapeNotMatching = BodyShapeNotMatching;
        function BodyShapeNotMatching(arg) {
            var msg = '';
            if (arg.value == true) {
                swal({
                    title: gettextCatalog.getString('Query will exclude athletes with the given bodyshape details'),
                    text: msg,
                    type: 'warning',
                    confirmButtonText: gettextCatalog.getString('Ok')
                });
            }
        }

        vm.IdNumbersNotMatching = IdNumbersNotMatching;
        function IdNumbersNotMatching(arg) {
            var msg = '';
            if (arg.value == true) {
                swal({
                    title: gettextCatalog.getString('Query will exclude athletes with the given id numbers'),
                    text: msg,
                    type: 'warning',
                    confirmButtonText: gettextCatalog.getString('Ok')
                });
            }
        }

        vm.columns = [{field: 'Nev', headerText: gettextCatalog.getString('Name'), textAlign: 'left', width: '150'}];

        vm.query = {};
        vm.sectionList = [];
        vm.ageGroupList = [];
        vm.coachList = [];
        vm.SelectedSectionID = 0;
        vm.SelectedAgeGroupID = 0;
        vm.SelectedCoachID = 0;
        vm.SelectedTeamID = 0;

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItems,
            editSettings: {allowEditing: false, allowAdding: false, allowDeleting: false},
            allowTextWrap: true,
            allowSorting: true,
            allowScrolling: true,
            allowPaging: true,
            allowExcelExport: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            columns: vm.columns,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile(angular.element('#Grid'), $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        vm.resetQueryDetails = resetQueryDetails;
        resetQueryDetails();

        activate();

        function activate() {
            var promises = [authenticationService.getRight('SPORTOLOKERESO')];
            $q.all(promises)
                .then(function (results) {
                    if (results[0] !== true) {
                        log.permissionError(true);
                    } else {
                        getSections();
                        getAgeGroups();
                        getCoaches();
                    }
                });
        }

        vm.goToAthlete = goToAthlete;
        function goToAthlete(id) {
            $q.all([authenticationService.getRight('MEGTSPORTLIST')]).then(function (results) {
                if (results[0]) {
                    paramHelper.setParams([{'athleteModify.sportoloId': id}]);
                    $state.go('athletes.athletesManagement.athleteModify.dataSheet');
                } else {
                    log.permissionError();
                }
            });
        }

        vm.sectionSelect = sectionSelect;
        function sectionSelect(args) {
            vm.MemberOfSectionChecked = args.value > 0;
            vm.SelectedCoachID = 0;
            vm.SelectedAgeGroupID = 0;
            vm.SelectedSectionID = args.value;
            if (args.value == -1) {
                vm.SelectedSectionID = 0;
            }
            getActualCoachesList();
            getAgeGroups();
        }

        vm.ageGroupSelect = ageGroupSelect;
        function ageGroupSelect(args) {
            vm.MemberOfAgeGroupChecked = true;
            vm.SelectedCoachID = 0;
            vm.SelectedAgeGroupID = args.value;
            if (args.value == -1) {
                vm.SelectedAgeGroupID = 0;
            }
            getActualCoachesList();
        }

        vm.coachSelect = coachSelect;
        function coachSelect(args) {
            vm.BelongsToCoachChecked = true;
            vm.SelectedCoachID = args.value;
            if (args.value == -1) {
                vm.SelectedCoachID = 0;
            }
        }

        function getSections() {
            dataservice.sectionDropDownList(0)
                .then(function (data) {
                    vm.sectionList = data.itemsList;
                    if (data.itemsList.length > 1) {
                        var all = {value: -1, text: gettextCatalog.getString('')};
                        vm.sectionList.splice(0, 0, all);
                    }
                });
        }

        function getAgeGroups() {
            dataservice.ageGroupDropDownList(vm.SelectedSectionID)
                .then(function (data) {
                    vm.ageGroupList = data.itemsList;
                    if (data.itemsList.length > 0) {
                        var all = {value: -1, text: gettextCatalog.getString('')};
                        vm.ageGroupList.splice(0, 0, all);
                    }
                });
        }

        function getActualCoachesList() {
            return dataservice.coachDropDownList(vm.SelectedSectionID, vm.SelectedAgeGroupID) // Need the section id (szakosztály)
                .then(function (data) {
                    vm.coachList = data.itemsList;
                    if (data.itemsList.length > 1) {
                        var all = {value: -1, text: gettextCatalog.getString('')};
                        vm.coachList.splice(0, 0, all);
                    }
                });
        }

        function getCoaches() {
            return dataservice.coachSelect().then(
                function (data) {
                    vm.coachList = data.itemsList;
                    return vm.coachList;
                }
            );
        }

        vm.search = search;
        function search() {
            initGrid();
            initData();
            dataservice.searchMemberList(vm.query).then(function (results) {
                grid.dataSource = $filter('dateStringFilter')(results.itemsList, 'SzuletesiIdo');
            });
        }

        function resetQueryDetails () {
            // string, datetime, int?
            vm.query.nev = undefined;
            vm.query.szakosztalyId = undefined;
            vm.query.korosztalyId = undefined;
            vm.query.edzoId = undefined;
            vm.query.tol = undefined;
            vm.query.ig = undefined;
            vm.query.neme = undefined;
            vm.query.allamp = undefined;
            vm.query.vspTol = undefined;
            vm.query.vspIg = undefined;
            vm.query.lakcimMegye = undefined;
            vm.query.lakcimIrSzam = undefined;
            vm.query.lakcimVaros = undefined;
            vm.query.lakcimUtca = undefined;
            vm.query.lakcimHazszam = undefined;
            vm.query.elerh = undefined;
            vm.query.iskNev = undefined;
            vm.query.iskIrSzam = undefined;
            vm.query.iskVaros = undefined;
            vm.query.iskUtca = undefined;
            vm.query.iskHazszam = undefined;
            vm.query.igNeve = undefined;
            vm.query.testnev = undefined;
            vm.query.testnevElerh = undefined;
            vm.query.evfolyam = undefined;
            vm.query.osztaly = undefined;
            vm.query.anyjaNeve = undefined;
            vm.query.anyjaElerh = undefined;
            vm.query.anyjaMagTol = undefined;
            vm.query.anyjaMagIg = undefined;
            vm.query.anyjaSpMult = undefined;
            vm.query.apaNeve = undefined;
            vm.query.apaElerh = undefined;
            vm.query.apaMagTol = undefined;
            vm.query.apaMagIg = undefined;
            vm.query.apaSpMult = undefined;
            vm.query.testMagTol = undefined;
            vm.query.testMagIg = undefined;
            vm.query.testsulyTol = undefined;
            vm.query.testSulyIg = undefined;
            vm.query.bmi = undefined;
            vm.query.bmiig = undefined;
            vm.query.ugyKez = undefined;
            vm.query.ugyLab = undefined;
            vm.query.szemIgSzam = undefined;
            vm.query.tajSzam = undefined;
            vm.query.adoSzam = undefined;
            vm.query.utlevelSzam = undefined;
            vm.query.egyeb = undefined;
            vm.query.aktiv = undefined;
            vm.query.havidijas = undefined;
            vm.query.oktdijas = undefined;
            vm.query.dsiKezdTol = undefined;
            vm.query.dsiKezdIg = undefined;
            vm.query.kiDatTol = undefined;
            vm.query.kiDatIg = undefined;
            vm.query.kilepIndoka = undefined;
            vm.query.eddigiEdzoi = undefined;
            vm.query.eddigiSpEgyes = undefined;
            vm.query.edzesKezdTol = undefined;
            vm.query.edzesKezdIg = undefined;
            vm.query.email = undefined;
            vm.query.regSzam = undefined;
            vm.query.osztFoNeve = undefined;
            vm.query.anyjaLeanyNeve = undefined;
            vm.query.pubVegeTol = undefined;
            vm.query.pubVegeIg = undefined;
            vm.query.szuloFogl = undefined;
            vm.query.gyereksport = undefined;
            vm.query.fajiEredet = undefined;
            vm.query.szunidElfogl = undefined;
            vm.query.valSportagak = undefined;
            vm.query.leanykoriNev = undefined;
            vm.query.papucsMerete = undefined;
            vm.query.melegitoMerete = undefined;
            vm.query.furdokopenyMerete = undefined;
            vm.query.kabatMerete = undefined;
            vm.query.pancelNadragMerete = undefined;
            vm.query.poloMerete = undefined;
            vm.query.sortMerete = undefined;
            vm.query.cipoMerete = undefined;
            vm.query.uszonadragMerete = undefined;

            vm.query.acttestMagTol = undefined;
            vm.query.acttestMagIg = undefined;
            vm.query.acttestSulyTol = undefined;
            vm.query.testactSulyIg = undefined;
            vm.query.actbmi = undefined;
            vm.query.actbmiig = undefined;

            // Müvelet, Egyezik, Nem egyezik, Tartalmazza, Nem tartalmazza stb
            vm.query.muvnev = undefined;
            vm.query.muvszakosztaly = undefined;
            vm.query.muvkorosztaly = undefined;
            vm.query.muvedzo = undefined;
            vm.query.muvtol = undefined;
            vm.query.muvig = undefined;
            //vm.query.muvneme = undefined;
            vm.query.muvneme = 'Egyezik';
            vm.query.muvallamp = 'Tartalmazza';
            vm.query.muvvspTol = undefined;
            vm.query.muvvspIg = undefined;
            vm.query.muvlakcimMegye = undefined;
            vm.query.muvlakcimIrSzam = undefined;
            vm.query.muvlakcimVaros = undefined;
            vm.query.muvlakcimUtca = undefined;
            vm.query.muvlakcimHazszam = undefined;
            vm.query.muvelerh = undefined;
            vm.query.muviskNev = undefined;
            vm.query.muviskIrSzam = undefined;
            vm.query.muviskVaros = undefined;
            vm.query.muviskUtca = undefined;
            vm.query.muviskHazszam = undefined;
            vm.query.muvigNeve = undefined;
            vm.query.muvtestnev = undefined;
            vm.query.muvtestnevElerh = undefined;
            vm.query.muvevfolyam = undefined;
            vm.query.muvosztaly = undefined;
            vm.query.muvanyjaNeve = undefined;
            vm.query.muvanyjaElerh = undefined;
            vm.query.muvanyjaMagTol = undefined;
            vm.query.muvanyjaMagIg = undefined;
            vm.query.muvanyjaSpMult = undefined;
            vm.query.muvapaNeve = undefined;
            vm.query.muvapaElerh = undefined;
            vm.query.muvapaMagTol = undefined;
            vm.query.muvapaMagIg = undefined;
            vm.query.muvapaSpMult = undefined;
            vm.query.muvtestMagTol = undefined;
            vm.query.muvtestMagIg = undefined;
            vm.query.muvtestsulyTol = undefined;
            vm.query.muvtestSulyIg = undefined;
            vm.query.muvugyKez = undefined;
            vm.query.muvugyLab = undefined;
            vm.query.muvszemIgSzam = undefined;
            vm.query.muvtajSzam = undefined;
            vm.query.muvadoSzam = undefined;
            vm.query.muvutlevelSzam = undefined;
            vm.query.muvegyeb = undefined;
            vm.query.muvaktiv = 'Kijelölve';
            vm.query.muvhavidijas = undefined;
            vm.query.muvoktdijas = undefined;
            vm.query.muvdsiKezdTol = undefined;
            vm.query.muvdsiKezdIg = undefined;
            vm.query.muvkiDatTol = undefined;
            vm.query.muvkiDatIg = undefined;
            vm.query.muvkilepIndoka = undefined;
            vm.query.muveddigiEdzoi = undefined;
            vm.query.muveddigiSpEgyes = undefined;
            vm.query.muvedzesKezdTol = undefined;
            vm.query.muvedzesKezdIg = undefined;
            vm.query.muvemail = undefined;
            vm.query.muvregSzam = undefined;
            vm.query.muvosztFoNeve = undefined;
            vm.query.muvanyjaLeanyNeve = undefined;
            vm.query.muvpubVegeTol = undefined;
            vm.query.muvpubVegeIg = undefined;
            vm.query.muvszuloFogl = undefined;
            vm.query.muvgyereksport = undefined;
            vm.query.muvfajiEredet = undefined;
            vm.query.muvszunidElfogl = undefined;
            vm.query.muvvalSportagak = undefined;
            vm.query.muvleanykoriNev = 'Tartalmazza';
            //vm.query.muvleanykoriNev = undefined;
            vm.query.muvbmi = undefined;
            vm.query.muvacttestMagTol = undefined;
            vm.query.muvacttestSulyTol = undefined;
            vm.query.muvactbmi = undefined;

            vm.query.muvpapucsMerete = undefined;
            vm.query.muvmelegitoMerete = undefined;
            vm.query.muvfurdokopenyMerete = undefined;
            vm.query.muvkabatMerete = undefined;
            vm.query.muvpancelNadragMerete = undefined;
            vm.query.muvpoloMerete = undefined;
            vm.query.muvsortMerete = undefined;
            vm.query.muvcipoMerete = undefined;
            vm.query.muvuszonadragMerete = undefined;

            vm.query.anyjaFoglalkozasa = undefined;
            vm.query.muvanyjaFoglalkozasa = undefined;
            vm.query.apaFoglalkozasa = undefined;
            vm.query.muvapaFoglalkozasa = undefined;

            // BOOL
            vm.query.kellnev = undefined;
            vm.query.kelltestiAdottsagok = undefined;
            vm.query.kellAzonositok = undefined;
            vm.query.kelliskCim = undefined;
            vm.query.kelllakcim = undefined;
            vm.query.kellpapucs = undefined;
            vm.query.kellmelegito = undefined;
            vm.query.kellfurdokopeny = undefined;
            vm.query.kellkabat = undefined;
            vm.query.kellpancelNadrag = undefined;
            vm.query.kellpolo = undefined;
            vm.query.kellsort = undefined;
            vm.query.kellcipo = undefined;
            vm.query.kelluszonadrag = undefined;
            vm.query.kellmegjegyzes = undefined;
            vm.query.kellszulhelyorszag = undefined;
            vm.query.kellszulhelyvaros = undefined;
            vm.query.kellaktiv = undefined;
            vm.query.kellszakosztalyId = undefined;
            vm.query.kellkorosztalyId = undefined;
            vm.query.kelledzoId = undefined;
            vm.query.kelltol = undefined;
            vm.query.kellig = undefined;
            vm.query.kellneme = undefined;
            vm.query.kellSzulHely = undefined;
            vm.query.kellallamp = undefined;
            vm.query.kellvspTol = undefined;
            vm.query.kellvspIg = undefined;
            vm.query.kelllakcimMegye = undefined;
            vm.query.kelllakcimIrSzam = undefined;
            vm.query.kelllakcimVaros = undefined;
            vm.query.kelllakcimUtca = undefined;
            vm.query.kelllakcimHazszam = undefined;
            vm.query.kellelerh = undefined;
            vm.query.kelliskNev = undefined;
            vm.query.kelliskIrSzam = undefined;
            vm.query.kelliskVaros = undefined;
            vm.query.kelliskUtca = undefined;
            vm.query.kelliskHazszam = undefined;
            vm.query.kelligNeve = undefined;
            vm.query.kelltestnev = undefined;
            vm.query.kelltestnevElerh = undefined;
            vm.query.kellevfolyam = undefined;
            vm.query.kellosztaly = undefined;
            vm.query.kellanyjaNeve = undefined;
            vm.query.kellanyjaElerh = undefined;
            vm.query.kellanyjaMagTol = undefined;
            vm.query.kellanyjaMagIg = undefined;
            vm.query.kellanyjaSpMult = undefined;
            vm.query.kellapaNeve = undefined;
            vm.query.kellapaElerh = undefined;
            vm.query.kellapaMagTol = undefined;
            vm.query.kellapaMagIg = undefined;
            vm.query.kellapaSpMult = undefined;
            vm.query.kelltestMagTol = undefined;
            vm.query.kelltestMagIg = undefined;
            vm.query.kelltestsulyTol = undefined;
            vm.query.kelltestSulyIg = undefined;
            vm.query.kellugyKez = undefined;
            vm.query.kellugyLab = undefined;
            vm.query.kellszemIgSzam = undefined;
            vm.query.kelltajSzam = undefined;
            vm.query.kelladoSzam = undefined;
            vm.query.kellutlevelSzam = undefined;
            vm.query.kellegyeb = undefined;
            vm.query.kellaktiv = undefined;
            vm.query.kellhavidijas = undefined;
            vm.query.kelloktdijas = undefined;
            vm.query.kellNyilvSzam = undefined;
            vm.query.kellDSIKezd = undefined;
            vm.query.kellEddigiEdzo = undefined;
            vm.query.kellEddigiSp = undefined;
            vm.query.kellTagdijas = undefined;
            vm.query.kellEmail = undefined;
            vm.query.kellEdzJaras = undefined;
            vm.query.kellGyermSp = undefined;
            vm.query.kellFajiEredet = undefined;
            vm.query.kellSzunidei = undefined;
            vm.query.kellLeanykNev = undefined;
            vm.query.kellKilepesDatum = undefined;
            vm.query.kellKilepesIndok = undefined;
            vm.query.kellpapucsMerete = undefined;
            vm.query.kellmelegitoMerete = undefined;
            vm.query.kellfurdokopenyMerete = undefined;
            vm.query.kellkabatMerete = undefined;
            vm.query.kellpancelNadragMerete = undefined;
            vm.query.kellpoloMerete = undefined;
            vm.query.kellsortMerete = undefined;
            vm.query.kellAnyjaLeanykoriNeve = undefined;
            vm.query.kellAnyjaAdatai = undefined;
            vm.query.kellApjaAdatai = undefined;
            vm.query.kellbmi = undefined;
            vm.query.kellof = undefined;

            // CHECKBOX bools
            vm.NameExactMatchChecked = false;
            vm.NameNotMatchingChecked = false;
            vm.MemberOfSectionChecked = false;
            vm.NotMemberOfSectionChecked = false;
            vm.MemberOfAgeGroupChecked = false;
            vm.NotMemberOfAgeGroupChecked = false;
            vm.BelongsToCoachChecked = false;
            vm.NotBelongsToCoachChecked = false;

            // OFFSET
            vm.query.kezdo = undefined;
            vm.query.darab = undefined;
        }

        function initData() {
            // CONTACT DETAILS
            if (vm.ContactNotMatchingChecked == true) {
                if (vm.query.lakcimMegye) {
                    vm.query.muvlakcimMegye = 'Nem tartalmazza';
                }
                if (vm.query.lakcimIrSzam) {
                    vm.query.muvlakcimIrSzam = 'Nem tartalmazza';
                }
                if (vm.query.lakcimVaros) {
                    vm.query.muvlakcimVaros = 'Nem tartalmazza';
                }
                if (vm.query.lakcimUtca) {
                    vm.query.muvlakcimUtca = 'Nem tartalmazza';
                }
                if (vm.query.lakcimHazszam) {
                    vm.query.muvlakcimHazszam = 'Nem tartalmazza';
                }
                if (vm.query.elerh) {
                    vm.query.muvelerh = 'Nem tartalmazza';
                }
                if (vm.query.email) {
                    vm.query.muvemail = 'Nem tartalmazza';
                }
            } else {
                if (vm.query.lakcimMegye) {
                    vm.query.muvlakcimMegye = 'Tartalmazza';
                }
                if (vm.query.lakcimIrSzam) {
                    vm.query.muvlakcimIrSzam = 'Tartalmazza';
                }
                if (vm.query.lakcimVaros) {
                    vm.query.muvlakcimVaros = 'Tartalmazza';
                }
                if (vm.query.lakcimUtca) {
                    vm.query.muvlakcimUtca = 'Tartalmazza';
                }
                if (vm.query.lakcimHazszam) {
                    vm.query.muvlakcimHazszam = 'Tartalmazza';
                }
                if (vm.query.elerh) {
                    vm.query.muvelerh = 'Tartalmazza';
                }
                if (vm.query.email) {
                    vm.query.muvemail = 'Tartalmazza';
                }
            }

            // SCHOOL DETAILS
            if (vm.SchoolNotMatchingChecked == true) {
                if (vm.query.iskNev) {
                    vm.query.muviskNev = 'Nem tartalmazza';
                }
                if (vm.query.iskIrSzam) {
                    vm.query.muviskIrSzam = 'Nem tartalmazza';
                }
                if (vm.query.iskVaros) {
                    vm.query.muviskVaros = 'Nem tartalmazza';
                }
                if (vm.query.iskUtca) {
                    vm.query.muviskUtca = 'Nem tartalmazza';
                }
                if (vm.query.iskHazszam) {
                    vm.query.muviskHazszam = 'Nem tartalmazza';
                }
                if (vm.query.igNeve) {
                    vm.query.muvigNeve = 'Nem tartalmazza';
                }
                if (vm.query.testnev) {
                    vm.query.muvtestnev = 'Nem tartalmazza';
                }
                if (vm.query.testnevElerh) {
                    vm.query.muvtestnevElerh = 'Nem tartalmazza';
                }
                if (vm.query.testnevEmail) {
                    vm.query.muvtestnevEmail = 'Nem tartalmazza';
                }
                if (vm.query.evfolyam) {
                    vm.query.muvevfolyam = 'Nem tartalmazza';
                }
                if (vm.query.osztaly) {
                    vm.query.muvosztaly = 'Nem tartalmazza';
                }
                if (vm.query.regszam) {
                    vm.query.muvregszam = 'Nem tartalmazza';
                }
                if (vm.query.osztFoNeve) {
                    vm.query.muvosztFoNeve = 'Nem tartalmazza';
                }
                if (vm.query.OfTel) {
                    vm.query.muvOfTel = 'Nem tartalmazza';
                }
                if (vm.query.OfEmail) {
                    vm.query.muvOfEmail = 'Nem tartalmazza';
                }
            } else {
                if (vm.query.iskNev) {
                    vm.query.muviskNev = 'Tartalmazza';
                }
                if (vm.query.iskIrSzam) {
                    vm.query.muviskIrSzam = 'Tartalmazza';
                }
                if (vm.query.iskVaros) {
                    vm.query.muviskVaros = 'Tartalmazza';
                }
                if (vm.query.iskUtca) {
                    vm.query.muviskUtca = 'Tartalmazza';
                }
                if (vm.query.iskHazszam) {
                    vm.query.muviskHazszam = 'Tartalmazza';
                }
                if (vm.query.igNeve) {
                    vm.query.muvigNeve = 'Tartalmazza';
                }
                if (vm.query.testnev) {
                    vm.query.muvtestnev = 'Tartalmazza';
                }
                if (vm.query.testnevElerh) {
                    vm.query.muvtestnevElerh = 'Tartalmazza';
                }
                if (vm.query.testnevEmail) {
                    vm.query.muvtestnevEmail = 'Tartalmazza';
                }
                if (vm.query.evfolyam) {
                    vm.query.muvevfolyam = 'Tartalmazza';
                }
                if (vm.query.osztaly) {
                    vm.query.muvosztaly = 'Tartalmazza';
                }
                if (vm.query.regszam) {
                    vm.query.muvregszam = 'Tartalmazza';
                }
                if (vm.query.osztFoNeve) {
                    vm.query.muvosztFoNeve = 'Tartalmazza';
                }
                if (vm.query.kilepIndoka) {
                    vm.query.muvkilepIndoka = 'Tartalmazza';
                }
                if (vm.query.eddigiEdzoi) {
                    vm.query.muveddigiEdzoi = 'Tartalmazza';
                }
                if (vm.query.eddigiSpEgyes) {
                    vm.query.muveddigiSpEgyes = 'Tartalmazza';
                }
                if (vm.query.OfTel) {
                    vm.query.muvOfTel = 'Tartalmazza';
                }
                if (vm.query.OfEmail) {
                    vm.query.muvOfEmail = 'Tartalmazza';
                }
            }

            // PARENT DETAILS
            if (vm.ParentNotMatchingChecked == true) {
                if (vm.query.anyjaNeve) {
                    vm.query.muvanyjaNeve = 'Nem tartalmazza';
                }
                if (vm.query.anyjaElerh) {
                    vm.query.muvanyjaElerh = 'Nem tartalmazza';
                }
                if (vm.query.anyjaSpMult) {
                    vm.query.muvanyjaSpMult = 'Nem tartalmazza';
                }
                if (vm.query.anyjaLeanyNeve) {
                    vm.query.muvanyjaLeanyNeve = 'Nem tartalmazza';
                }
                if (vm.query.anyjaFoglalkozasa) {
                    vm.query.muvanyjaFoglalkozasa = 'Nem tartalmazza';
                }
                if (vm.query.apaNeve) {
                    vm.query.muvapaNeve = 'Nem tartalmazza';
                }
                if (vm.query.apaElerh) {
                    vm.query.muvapaElerh = 'Nem tartalmazza';
                }
                if (vm.query.apaSpMult) {
                    vm.query.muvapaSpMult = 'Nem tartalmazza';
                }
                if (vm.query.apaFoglalkozasa) {
                    vm.query.muvapaFoglalkozasa = 'Nem tartalmazza';
                }
                if (vm.query.anyjaMagTol) {
                    vm.query.muvanyjaMagTol = '≠';
                }
                if (vm.query.apaMagTol) {
                    vm.query.muvapaMagTol = '≠';
                }
                if (vm.query.AnyaMunkahely) {
                    vm.query.muvAnyaMunkahely = 'Nem tartalmazza';
                }
                if (vm.query.ApaMunkahely) {
                    vm.query.muvApaMunkahely = 'Nem tartalmazza';
                }
                if (vm.query.AnyaEmail) {
                    vm.query.muvAnyaEmail = 'Nem tartalmazza';
                }
                if (vm.query.ApaEmail) {
                    vm.query.muvApaEmail = 'Nem tartalmazza';
                }
            } else {
                if (vm.query.anyjaNeve) {
                    vm.query.muvanyjaNeve = 'Tartalmazza';
                }
                if (vm.query.anyjaElerh) {
                    vm.query.muvanyjaElerh = 'Tartalmazza';
                }
                if (vm.query.anyjaSpMult) {
                    vm.query.muvanyjaSpMult = 'Tartalmazza';
                }
                if (vm.query.anyjaLeanyNeve) {
                    vm.query.muvanyjaLeanyNeve = 'Tartalmazza';
                }
                if (vm.query.anyjaFoglalkozasa) {
                    vm.query.muvanyjaFoglalkozasa = 'Tartalmazza';
                }
                if (vm.query.apaNeve) {
                    vm.query.muvapaNeve = 'Tartalmazza';
                }
                if (vm.query.apaElerh) {
                    vm.query.muvapaElerh = 'Tartalmazza';
                }
                if (vm.query.apaSpMult) {
                    vm.query.muvapaSpMult = 'Tartalmazza';
                }
                if (vm.query.apaFoglalkozasa) {
                    vm.query.muvapaFoglalkozasa = 'Tartalmazza';
                }
                if (vm.query.AnyaMunkahely) {
                    vm.query.muvAnyaMunkahely = 'Tartalmazza';
                }
                if (vm.query.ApaMunkahely) {
                    vm.query.muvApaMunkahely = 'Tartalmazza';
                }
                if (vm.query.AnyaEmail) {
                    vm.query.muvAnyaEmail = 'Tartalmazza';
                }
                if (vm.query.ApaEmail) {
                    vm.query.muvApaEmail = 'Tartalmazza';
                }
            }

            // BODYSHAPE
            if (vm.BodyShapeNotMatchingChecked == true) {
                if (vm.query.testMagTol) {
                    vm.query.muvtestMagTol = '≠';
                }
                if (vm.query.testsulyTol) {
                    vm.query.muvtestsulyTol = '≠';
                }
                if (vm.query.bmi) {
                    vm.query.muvbmi = '≠';
                }
                if (vm.query.acttestMagTol) {
                    vm.query.muvacttestMagTol = '≠';
                }
                if (vm.query.acttestSulyTol) {
                    vm.query.muvacttestSulyTol = '≠';
                }
                if (vm.query.actbmi) {
                    vm.query.muvactbmi = '≠';
                }
                if (vm.query.ugyKez) {
                    vm.query.muvugyKez = 'Nem egyezik';
                }
                if (vm.query.ugyLab) {
                    vm.query.muvugyLab = 'Nem egyezik';
                }
            }

            // ID
            if (vm.IdNumbersNotMatchingChecked == true) {
                if (vm.query.szemIgSzam) {
                    vm.query.muvszemIgSzam = 'Nem tartalmazza';
                }
                if (vm.query.tajSzam) {
                    vm.query.muvtajSzam = 'Nem tartalmazza';
                }
                if (vm.query.adoSzam) {
                    vm.query.muvadoSzam = 'Nem tartalmazza';
                }
                if (vm.query.utlevelSzam) {
                    vm.query.muvutlevelSzam = 'Nem tartalmazza';
                }
            } else {
                if (vm.query.szemIgSzam) {
                    vm.query.muvszemIgSzam = 'Tartalmazza';
                }
                if (vm.query.tajSzam) {
                    vm.query.muvtajSzam = 'Tartalmazza';
                }
                if (vm.query.adoSzam) {
                    vm.query.muvadoSzam = 'Tartalmazza';
                }
                if (vm.query.utlevelSzam) {
                    vm.query.muvutlevelSzam = 'Tartalmazza';
                }
            }

            if (vm.query.egyeb) {
                vm.query.muvegyeb = 'Tartalmazza';
            }
            if (vm.query.havidijas) {
                vm.query.muvhavidijas = 'Kijelölve';
            }
            if (vm.query.oktdijas) {
                vm.query.muvoktdijas = 'Kijelölve';
            }
            if (vm.query.gyereksport) {
                vm.query.muvgyereksport = 'Tartalmazza';
            }
            if (vm.query.szunidElfogl) {
                vm.query.muvszunidElfogl = 'Tartalmazza';
            }
            if (vm.query.valSportagak) {
                vm.query.muvvalSportagak = 'Tartalmazza';
            }
        }

        function initGrid() {
            vm.columns = [];
            vm.columns.push({field: 'Nev', headerText: gettextCatalog.getString('Name'), textAlign: 'left', width: '150', template: '#searchmemberlistgotoathlete'});
            vm.columns.push({field: 'SzuletesiIdo', headerText: gettextCatalog.getString('BirthDate'), textAlign: 'left', width: '150', format: 'yMd'});
            if (vm.query.kellSzulHely) {
                vm.query.kellszulhelyvaros = true;
                vm.query.kellszulhelyorszag = true;
                vm.columns.push({field: 'SzuletesiHelyOrszag', headerText: gettextCatalog.getString('BirthCountry'), textAlign: 'left', width: '150'});
                vm.columns.push({field: 'SzuletesiHelyVaros', headerText: gettextCatalog.getString('BirthCity'), textAlign: 'left', width: '150'});
            }
            // ÁLTALÁNOS
            if (vm.query.kellszakosztalyId) {
                vm.columns.push({field: 'SzakosztalyNeve', headerText: gettextCatalog.getString('Section'), textAlign: 'left', width: '150'});
            }
            if (vm.query.kellkorosztalyId) {
                vm.columns.push({field: 'KorcsoportNeve', headerText: gettextCatalog.getString('AgeGroup'), textAlign: 'center', width: '150'});
            }
            if (vm.query.kelledzoId) {
                vm.columns.push({field: 'EdzoNeve', headerText: gettextCatalog.getString('Coach'), textAlign: 'left', width: '150'});
            }
            if (vm.query.kellmegjegyzes) {
                vm.columns.push({field: 'Megjegyzes', headerText: gettextCatalog.getString('Comment'), textAlign: 'left', width: '150'});
            }
            if (vm.query.kellneme) {
                vm.columns.push({field: 'Neme', headerText: gettextCatalog.getString('Gender'), textAlign: 'left', width: '150'});
            }
            if (vm.query.kellaktiv) {
                vm.columns.push({field: 'Aktiv', headerText: gettextCatalog.getString('Active'), textAlign: 'left', width: '150'});
            }
            if (vm.query.kellallamp) {
                vm.columns.push({field: 'Allampolgarsag', headerText: gettextCatalog.getString('Citizenship'), textAlign: 'left', width: '150'});
            }
            if (vm.query.kellvspTol) {
                vm.columns.push({field: 'VersSportKezd', headerText: gettextCatalog.getString('CompetitiveSportStart'), textAlign: 'left', width: '150'});
            }
            if (vm.query.kellLeanykNev) {
                vm.columns.push({field: 'LeanykoriNeve', headerText: gettextCatalog.getString('MaidenName'), textAlign: 'left', width: '150'});
            }
            // KAPCSOLAT
            if (vm.query.kelllakcim) {
                vm.query.kelllakcimMegye = true;
                vm.query.kelllakcimVaros = true;
                vm.query.kelllakcimIrSzam = true;
                vm.query.kelllakcimUtca = true;
                vm.query.kelllakcimHazszam = true;
                vm.columns.push({field: 'lakcim', headerText: gettextCatalog.getString('Address'), textAlign: 'left', width: '150'});
            }
            if (vm.query.kellelerh) {
                vm.columns.push({field: 'Elerhetoseg', headerText: gettextCatalog.getString('Contact'), textAlign: 'left', width: '150'});
            }
            if (vm.query.kellEmail) {
                vm.columns.push({field: 'Email', headerText: gettextCatalog.getString('Email'), textAlign: 'left', width: '150'});
            }
            // ISKOLA
            if (vm.query.kelliskNev) {
                vm.columns.push({field: 'IskolaNeve', headerText: gettextCatalog.getString('SchoolName'), textAlign: 'left', width: '150'});
            }
            if (vm.query.kelliskCim) {
                vm.query.kelliskVaros = true;
                vm.query.kelliskIrSzam = true;
                vm.query.kelliskUtca = true;
                vm.query.kelliskHazszam = true;
                vm.columns.push({field: 'iskolacim', headerText: gettextCatalog.getString('SchoolAddress'), textAlign: 'left', width: '150'});
            }
            if (vm.query.kelligNeve) {
                vm.columns.push({field: 'IskolaIgazgatoNeve', headerText: gettextCatalog.getString('Director'), textAlign: 'left', width: '150'});
            }
            if (vm.query.kellof) {
                vm.columns.push({field: 'Of', headerText: gettextCatalog.getString('ClassMaster'), textAlign: 'left', width: '150'});
                vm.columns.push({field: 'OfTel', headerText: gettextCatalog.getString('ClassMasterTel'), textAlign: 'left', width: '150'});
                vm.columns.push({field: 'OfEmail', headerText: gettextCatalog.getString('ClassMasterEmail'), textAlign: 'left', width: '150'});
            }
            if (vm.query.kelltestnev) {
                vm.columns.push({field: 'TestneveloNeve', headerText: gettextCatalog.getString('GymTeacher'), textAlign: 'left', width: '150'});
            }
            if (vm.query.kelltestnevElerh) {
                vm.columns.push({field: 'TestneveloElerhetosege', headerText: gettextCatalog.getString('GymTeacherContact'), textAlign: 'left', width: '150'});
                vm.columns.push({field: 'TestneveloEmail', headerText: gettextCatalog.getString('GymTeacherEmail'), textAlign: 'left', width: '150'});
            }
            if (vm.query.kellevfolyam || vm.query.kellosztaly) {
                vm.query.kellevfolyam = true;
                vm.query.kellosztaly = true;
                vm.columns.push({field: 'evfolyamosztaly', headerText: gettextCatalog.getString('SchoolYearClass'), textAlign: 'left', width: '150'});
            }
            if (vm.query.kellDSIKezd) {
                vm.columns.push({field: 'DSITagsagKezd', headerText: gettextCatalog.getString('MembershipStart'), textAlign: 'left', width: '150', type: 'date', format: '{0:yyyy.MM.dd.}'});
            }
            if (vm.query.kellKilepesDatum) {
                vm.query.kellKilepesIndok = true;
                vm.columns.push({field: 'KilepesDatuma', headerText: gettextCatalog.getString('MembershipEnd'), textAlign: 'left', width: '150', type: 'date', format: '{0:yyyy.MM.dd.}'});
                vm.columns.push({field: 'KilepesIndoka', headerText: gettextCatalog.getString('CauseOfLeaving'), textAlign: 'left', width: '150'});
            }
            if (vm.query.kellEddigiEdzo) {
                vm.columns.push({field: 'EddigiEdzoi', headerText: gettextCatalog.getString('FormerCoaches'), textAlign: 'center', width: '150'});
            }
            if (vm.query.kellEddigiSp) {
                vm.columns.push({field: 'EddigiSpEgy', headerText: gettextCatalog.getString('FormerSportOrganizationMemberships'), textAlign: 'center', width: '150'});
            }
            if (vm.query.kellNyilvSzam) {
                vm.columns.push({field: 'NyilvantartasiSzam', headerText: gettextCatalog.getString('RegistrationNumber'), textAlign: 'center', width: '150'});
            }
            if (vm.query.kellEdzJaras) {
                vm.columns.push({field: 'EdzesreJarasKezd', headerText: gettextCatalog.getString('TrainingStart'), textAlign: 'left', width: '150', type: 'date', format: '{0:yyyy.MM.dd.}'});
            }
            //  SZÜLŐK ADATAI
            if (vm.query.kellAnyjaAdatai) {
                vm.query.kellanyjaNeve = true;
                vm.query.kellAnyjaLeanykoriNeve = true;
                vm.query.kellanyjaElerh = true;
                vm.query.kellanyjaMagTol = true;
                vm.query.kellanyjaSpMult = true;
                vm.columns.push({field: 'AnyjaNeve', headerText: gettextCatalog.getString('MothersName'), textAlign: 'center', width: '150'});
                vm.columns.push({field: 'AnyjaLeanykoriNeve', headerText: gettextCatalog.getString('MothersMaidenName'), textAlign: 'center', width: '150'});
                vm.columns.push({field: 'Szulo1Elerhetosege', headerText: gettextCatalog.getString('MotherContact'), textAlign: 'left', width: '150'});
                vm.columns.push({field: 'AnyaEmail', headerText: gettextCatalog.getString('MotherEmail'), textAlign: 'left', width: '150'});
                vm.columns.push({field: 'AnyaMunkahely', headerText: gettextCatalog.getString('MothersWorkplace'), textAlign: 'left', width: '150'});
                vm.columns.push({field: 'AnyjaTestmagassaga', headerText: gettextCatalog.getString('MotherHeight'), textAlign: 'left', width: '150'});
                vm.columns.push({field: 'SportoloiMultAnya', headerText: gettextCatalog.getString('MotherSportHistory'), textAlign: 'left', width: '150'});
                vm.columns.push({field: 'anyjafoglalkozasa', headerText: gettextCatalog.getString('MothersJob'), textAlign: 'left', width: '150'});
            }
            if (vm.query.kellApjaAdatai) {
                vm.query.kellapaNeve = true;
                vm.query.kellapaElerh = true;
                vm.query.kellapaMagTol = true;
                vm.query.kellapaSpMult = true;
                vm.columns.push({field: 'SzuloNeve', headerText: gettextCatalog.getString('FathersName'), textAlign: 'left', width: '150'});
                vm.columns.push({field: 'Szulo2Elerhetosege', headerText: gettextCatalog.getString('FatherContact'), textAlign: 'left', width: '150'});
                vm.columns.push({field: 'ApaEmail', headerText: gettextCatalog.getString('FatherEmail'), textAlign: 'left', width: '150'});
                vm.columns.push({field: 'ApaMunkahely', headerText: gettextCatalog.getString('FathersWorkplace'), textAlign: 'left', width: '150'});
                vm.columns.push({field: 'ApjaTestmagassaga', headerText: gettextCatalog.getString('FatherHeight'), textAlign: 'left', width: '150'});
                vm.columns.push({field: 'SportoloiMultApa', headerText: gettextCatalog.getString('FatherSportHistory'), textAlign: 'left', width: '150'});
                vm.columns.push({field: 'apjafoglalkozasa', headerText: gettextCatalog.getString('FathersJob'), textAlign: 'left', width: '150'});
            }
            // TESTI ADOTTSÁGOK
            if (vm.query.kelltestiAdottsagok) {
                vm.query.kelltestMagTol = true;
                vm.query.kelltestsulyTol = true;
                vm.query.kellugyKez = true;
                vm.query.kellugyLab = true;
                vm.query.kellbmi = true;
                vm.columns.push({field: 'Testmagassag', headerText: gettextCatalog.getString('Height'), textAlign: 'left', width: '150'});
                vm.columns.push({field: 'TestsulyStr', headerText: gettextCatalog.getString('Weight'), textAlign: 'left', width: '150'});
                vm.columns.push({field: 'bmi', headerText: gettextCatalog.getString('BodyMassIndex'), textAlign: 'left', width: '150'});
                vm.columns.push({field: 'AktTestmagassag', headerText: gettextCatalog.getString('ActualHeight'), textAlign: 'left', width: '150'});
                vm.columns.push({field: 'AktTestsuly', headerText: gettextCatalog.getString('ActualWeight'), textAlign: 'left', width: '150'});
                vm.columns.push({field: 'actbmi', headerText: gettextCatalog.getString('ActualBodyMassIndex'), textAlign: 'left', width: '150'});
                vm.columns.push({field: 'UgyesebbKez', headerText: gettextCatalog.getString('BetterHand'), textAlign: 'left', width: '150'});
                vm.columns.push({field: 'UgyesebbLab', headerText: gettextCatalog.getString('BetterFoot'), textAlign: 'left', width: '150'});
                vm.columns.push({field: 'FajiEredet', headerText: gettextCatalog.getString('RacialOrigin'), textAlign: 'left', width: '150'});
                vm.columns.push({field: 'PubertasVege', headerText: gettextCatalog.getString('EndOfPuberty'), textAlign: 'left', width: '150'});
            }
            //  ID
            if (vm.query.kellAzonositok) {
                vm.query.kellszemIgSzam = true;
                vm.query.kelltajSzam = true;
                vm.query.kelladoSzam = true;
                vm.query.kellutlevelSzam = true;
                vm.columns.push({field: 'SzemIgSzam', headerText: gettextCatalog.getString('PersonalID'), textAlign: 'left', width: '150'});
                vm.columns.push({field: 'TAJSzam', headerText: gettextCatalog.getString('SocialSecurityNumber'), textAlign: 'left', width: '150'});
                vm.columns.push({field: 'AdoSzam', headerText: gettextCatalog.getString('TaxNumber'), textAlign: 'left', width: '150'});
                vm.columns.push({field: 'UtlevelSzam', headerText: gettextCatalog.getString('PassportNumber'), textAlign: 'left', width: '150'});
            }
            // OTHERS
            if (vm.query.kellTagdijas || vm.query.kellhavidijas || vm.query.kelloktdijas) { // Díjfizetés
                vm.query.kellTagdijas = true;
                vm.query.kelloktdijas = true;
                vm.columns.push({field: 'Tagdijas', headerText: gettextCatalog.getString('DuesOrEducationFee'), textAlign: 'left', width: '150'});
                vm.columns.push({field: 'Tagdij', headerText: gettextCatalog.getString('Dues'), textAlign: 'left', width: '150'});
            }
            if (vm.query.kellGyermSp) {
                vm.columns.push({field: 'GyermekkoriSport', headerText: gettextCatalog.getString('ChildhoodSport'), textAlign: 'left', width: '150'});
            }
            if (vm.query.kellSzunidei) {
                vm.columns.push({field: 'SzunideiElfogl', headerText: gettextCatalog.getString('VacationActivity'), textAlign: 'left', width: '150'});
            }
            // RUHA
            if (vm.query.kellpapucs) {
                vm.query.kellpapucsMerete = true;
                vm.columns.push({field: 'papucsMerete', headerText: gettextCatalog.getString('SlipperSize'), textAlign: 'left', width: '150'});
            }
            if (vm.query.kellmelegito) {
                vm.query.kellmelegitoMerete = true;
                vm.columns.push({field: 'melegitoMerete', headerText: gettextCatalog.getString('JoggingSize'), textAlign: 'left', width: '150'});
            }
            if (vm.query.kellfurdokopeny) {
                vm.query.kellfurdokopenyMerete = true;
                vm.columns.push({field: 'furdokopenyMerete', headerText: gettextCatalog.getString('BathrobeSize'), textAlign: 'left', width: '150'});
            }
            if (vm.query.kellkabat) {
                vm.query.kellkabatMerete = true;
                vm.columns.push({field: 'kabatMerete', headerText: gettextCatalog.getString('JacketSize'), textAlign: 'left', width: '150'});
            }
            if (vm.query.kellpancelNadrag) {
                vm.query.kellpancelNadragMerete = true;
                vm.columns.push({field: 'pancelNadragMerete', headerText: gettextCatalog.getString('ArmorPantsSize'), textAlign: 'left', width: '150'});
            }
            if (vm.query.kellpolo) {
                vm.query.kellpoloMerete = true;
                vm.columns.push({field: 'poloMerete', headerText: gettextCatalog.getString('ShirtSize'), textAlign: 'left', width: '150'});
            }
            if (vm.query.kellsort) {
                vm.query.kellsortMerete = true;
                vm.columns.push({field: 'sortMerete', headerText: gettextCatalog.getString('ShortsSize'), textAlign: 'left', width: '150'});
            }
            if (vm.query.kellcipo) {
                vm.query.kellcipoMerete = true;
                vm.columns.push({field: 'cipoMerete', headerText: gettextCatalog.getString('ShoeSize'), textAlign: 'left', width: '150'});
            }
            if (vm.query.kelluszonadrag) {
                vm.query.kelluszonadragMerete = true;
                vm.columns.push({field: 'uszonadragMerete', headerText: gettextCatalog.getString('SwimmingPantSize'), textAlign: 'left', width: '150'});
            }
            grid.columns = vm.columns;
            grid.refreshColumns();
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.search.athletes.memberList')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'search.athletes.memberList',
                config: {
                    url: '/memberList',
                    templateUrl: 'app/search/athletes/memberList/memberList.html',
                    controller: 'MemberListController',
                    controllerAs: 'vm',
                    title: 'SearchMemberList',
                    settings: {
                        navId: 22170,
                        level: 2,
                        order: 2,
                        orderTitle_hu: 'Részletes sportoló kereső',
                        orderTitle_en: 'Detailed Athlete Search',
                        parentId: 170,
                        content: 'SearchMemberList',
                        activatorPermission: '"SPORTOLOKERESO"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    SimpleController.$inject = ["log", "dataservice", "$q", "$rootScope", "gettextCatalog", "VIEW_DATA", "$filter", "authenticationService", "paramHelper", "$state", "$scope", "$timeout"];
    angular
        .module('app.search.athletes.simple')
        .controller('SimpleController', SimpleController);

    function SimpleController(log, dataservice, $q, $rootScope, gettextCatalog, VIEW_DATA, $filter, authenticationService, paramHelper, $state, $scope, $timeout) {
        var vm = this;
        $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('SearchAthletesSimple');

        // Create variables
        vm.athleteList = [];
        vm.sexList = [
            {
                text: gettextCatalog.getString('Man'),
                value: true
            },
            {
                text: gettextCatalog.getString('Woman'),
                value: false
            }
        ];
        vm.countyList = VIEW_DATA.dropDownList.counties;
        vm.courseList = VIEW_DATA.dropDownList.course;
        vm.classList = VIEW_DATA.dropDownList.class;
        vm.betterHandList = [
            {
                text: gettextCatalog.getString('Left'),
                value: 1
            },
            {
                text: gettextCatalog.getString('Right'),
                value: 2
            },
            {
                text: gettextCatalog.getString('Both'),
                value: 3
            }
        ];
        vm.betterFootList = [
            {
                text: gettextCatalog.getString('Left'),
                value: 1
            },
            {
                text: gettextCatalog.getString('Right'),
                value: 2
            },
            {
                text: gettextCatalog.getString('Both'),
                value: 3
            }
        ];
        vm.columns = [
            {
                field: 'Nev',
                headerText: gettextCatalog.getString('Name'),
                textAlign: 'left',
                width: '150',
                template: '#simplecolumnTemplate1'
            },
            {
                field: 'SzakosztalyNeve',
                headerText: gettextCatalog.getString('Section'),
                textAlign: 'left',
                width: '150'
            },
            {
                field: 'EdzoNeve',
                headerText: gettextCatalog.getString('Coach'),
                textAlign: 'left',
                width: '150',
                template: '#simplecolumnTemplate2'
            },
            {
                field: 'SzuletesiIdo',
                headerText: gettextCatalog.getString('BirthDate'),
                textAlign: 'left',
                width: '150'
            },
            {
                field: 'KorcsoportNeve',
                headerText: gettextCatalog.getString('AgeGroup'),
                textAlign: 'left',
                width: '150'
            },
            {field: 'Megjegyzes', headerText: gettextCatalog.getString('Comment'), textAlign: 'left', width: '150'},
            {
                field: 'Tagdijas',
                headerText: gettextCatalog.getString('SportServiceFeeAthlete'),
                textAlign: 'center',
                width: '200',
                type: 'boolean',
                displayAsCheckBox: true
            },
            {field: 'Tagdij', headerText: gettextCatalog.getString('SportServiceFee'), textAlign: 'left', width: '200'},
            {
                field: 'Aktiv',
                headerText: gettextCatalog.getString('Active'),
                textAlign: 'center',
                width: '150',
                type: 'boolean',
                displayAsCheckBox: true
            },
            {
                field: 'SzuletesiHelyOrszag',
                headerText: gettextCatalog.getString('BirthCountry'),
                textAlign: 'left',
                width: '150'
            },
            {
                field: 'SzuletesiHelyVaros',
                headerText: gettextCatalog.getString('BirthCity'),
                textAlign: 'left',
                width: '150'
            },
            {
                field: 'Allampolgarsag',
                headerText: gettextCatalog.getString('Citizenship'),
                textAlign: 'left',
                width: '150'
            },
            {
                field: 'VersSportKezd',
                headerText: gettextCatalog.getString('CompetitiveSportStart'),
                textAlign: 'left',
                width: '175'
            },
            {field: 'LakcimMegye', headerText: gettextCatalog.getString('County'), textAlign: 'left', width: '150'},
            {field: 'LakcimIrSzam', headerText: gettextCatalog.getString('ZipCode'), textAlign: 'left', width: '150'},
            {field: 'LakcimVaros', headerText: gettextCatalog.getString('City'), textAlign: 'left', width: '150'},
            {field: 'LakcimUtca', headerText: gettextCatalog.getString('Street'), textAlign: 'left', width: '150'},
            {
                field: 'LakcimHazszam',
                headerText: gettextCatalog.getString('StreetNumber'),
                textAlign: 'left',
                width: '150'
            },
            {field: 'Elerhetoseg', headerText: gettextCatalog.getString('Contact'), textAlign: 'left', width: '150'},
            {field: 'IskolaNeve', headerText: gettextCatalog.getString('SchoolName'), textAlign: 'left', width: '150'},
            {
                field: 'IskolaIrSzam',
                headerText: gettextCatalog.getString('SchoolZipCode'),
                textAlign: 'left',
                width: '150'
            },
            {
                field: 'IskolaVaros',
                headerText: gettextCatalog.getString('SchoolCity'),
                textAlign: 'left',
                width: '150'
            },
            {
                field: 'IskolaUtca',
                headerText: gettextCatalog.getString('SchoolStreet'),
                textAlign: 'left',
                width: '150'
            },
            {
                field: 'IskolaHazszam',
                headerText: gettextCatalog.getString('SchoolStreetNumber'),
                textAlign: 'left',
                width: '150'
            },
            {
                field: 'IskolaIgazgatoNeve',
                headerText: gettextCatalog.getString('Director'),
                textAlign: 'left',
                width: '150'
            },
            {
                field: 'TestneveloNeve',
                headerText: gettextCatalog.getString('GymTeacher'),
                textAlign: 'left',
                width: '150'
            },
            {
                field: 'TestneveloElerhetosege',
                headerText: gettextCatalog.getString('GymTeacherContact'),
                textAlign: 'left',
                width: '175'
            },
            {
                field: 'TestneveloEmail',
                headerText: gettextCatalog.getString('GymTeacherEmail'),
                textAlign: 'left',
                width: '175'
            },
            {
                field: 'IskolaEvfolyam',
                headerText: gettextCatalog.getString('SchoolCourse'),
                textAlign: 'left',
                width: '150'
            },
            {
                field: 'IskolaOsztaly',
                headerText: gettextCatalog.getString('SchoolClass'),
                textAlign: 'left',
                width: '150'
            },
            {
                field: 'OsztalyFonokNeve',
                headerText: gettextCatalog.getString('ClassMaster'),
                textAlign: 'left',
                width: '150'
            },
            {
                field: 'OfEmail',
                headerText: gettextCatalog.getString('ClassMasterEmail'),
                textAlign: 'left',
                width: '150'
            },
            {
                field: 'OfTel',
                headerText: gettextCatalog.getString('ClassMasterTel'),
                textAlign: 'left',
                width: '150'
            },
            {
                field: 'AnyjaNeve',
                headerText: gettextCatalog.getString('MothersName'),
                textAlign: 'left',
                width: '150'
            },
            {
                field: 'Szulo1Elerhetosege',
                headerText: gettextCatalog.getString('MotherContact'),
                textAlign: 'left',
                width: '150'
            },
            {
                field: 'AnyaEmail',
                headerText: gettextCatalog.getString('MotherEmail'),
                textAlign: 'left',
                width: '150'
            },
            {
                field: 'AnyaMunkahely',
                headerText: gettextCatalog.getString('MothersWorkplace'),
                textAlign: 'left',
                width: '150'
            },
            {
                field: 'AnyjaTestmagassaga',
                headerText: gettextCatalog.getString('MotherHeight'),
                textAlign: 'center',
                width: '150'
            },
            {
                field: 'SportoloiMultAnya',
                headerText: gettextCatalog.getString('MotherSportHistory'),
                textAlign: 'left',
                width: '175'
            },
            {field: 'SzuloNeve', headerText: gettextCatalog.getString('FathersName'), textAlign: 'left', width: '150'},
            {
                field: 'Szulo2Elerhetosege',
                headerText: gettextCatalog.getString('FatherContact'),
                textAlign: 'left',
                width: '150'
            },
            {
                field: 'ApaEmail',
                headerText: gettextCatalog.getString('FatherEmail'),
                textAlign: 'left',
                width: '150'
            },
            {
                field: 'ApaMunkahely',
                headerText: gettextCatalog.getString('FathersWorkplace'),
                textAlign: 'left',
                width: '150'
            },
            {
                field: 'ApjaTestmagassaga',
                headerText: gettextCatalog.getString('FatherHeight'),
                textAlign: 'center',
                width: '150'
            },
            {
                field: 'SportoloiMultApa',
                headerText: gettextCatalog.getString('FatherSportHistory'),
                textAlign: 'left',
                width: '175'
            },
            {field: 'Testmagassag', headerText: gettextCatalog.getString('Height'), textAlign: 'center', width: '150'},
            {field: 'Testsuly', headerText: gettextCatalog.getString('Weight'), textAlign: 'center', width: '150'},
            {
                field: 'UgyesebbKez',
                headerText: gettextCatalog.getString('BetterHand'),
                textAlign: 'left',
                width: '150'
            },
            {
                field: 'UgyesebbLab',
                headerText: gettextCatalog.getString('BetterFoot'),
                textAlign: 'left',
                width: '150'
            },
            {
                field: 'SzemIgSzam',
                headerText: gettextCatalog.getString('IdentityNumber'),
                textAlign: 'left',
                width: '200'
            },
            {
                field: 'TAJSzam',
                headerText: gettextCatalog.getString('SocialSecurityNumber'),
                textAlign: 'left',
                width: '150'
            },
            {field: 'AdoSzam', headerText: gettextCatalog.getString('TaxNumber'), textAlign: 'left', width: '150'},
            {
                field: 'UtlevelSzam',
                headerText: gettextCatalog.getString('PassportNumber'),
                textAlign: 'left',
                width: '150'
            },
            {
                field: 'PapucsMerete',
                headerText: gettextCatalog.getString('SlipperSize'),
                textAlign: 'center',
                width: '150'
            },
            {
                field: 'MelegitoMerete',
                headerText: gettextCatalog.getString('JoggingSuitSize'),
                textAlign: 'center',
                width: '150'
            },
            {
                field: 'FurdokopenyMerete',
                headerText: gettextCatalog.getString('BathrobeSize'),
                textAlign: 'center',
                width: '160'
            },
            {field: 'KabatMerete', headerText: gettextCatalog.getString('CoatSize'), textAlign: 'center', width: '150'},
            {
                field: 'PancelNadragMerete',
                headerText: gettextCatalog.getString('ArmorPantSize'),
                textAlign: 'center',
                width: '175'
            },
            {
                field: 'PoloMerete',
                headerText: gettextCatalog.getString('TShirtSize'),
                textAlign: 'center',
                width: '150'
            },
            {
                field: 'SortMerete',
                headerText: gettextCatalog.getString('ShortDressSize'),
                textAlign: 'center',
                width: '150'
            },
            {
                field: 'CipoMerete',
                headerText: gettextCatalog.getString('ShoeSize'),
                textAlign: 'center',
                width: '150'
            },
            {
                field: 'UszoNadragMerete',
                headerText: gettextCatalog.getString('SwimmingPantSize'),
                textAlign: 'center',
                width: '150'
            }
        ];

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItems,
            editSettings: {allowEditing: false, allowAdding: false, allowDeleting: false},
            allowTextWrap: true,
            allowSorting: true,
            allowScrolling: true,
            allowPaging: true,
            allowExcelExport: true,
            pageSettings: $rootScope.pageSettings,
            locale: 'hu-HU',
            gridLines: 'Both',
            columns: vm.columns,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile(grid, $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        // Public functions
        vm.sectionDataBound = sectionDataBound;
        vm.sectionSelect = sectionSelect;
        vm.ageGroupDataBound = ageGroupDataBound;
        vm.ageGroupSelect = ageGroupSelect;
        vm.coachDataBound = coachDataBound;
        vm.coachSelect = coachSelect;
        vm.search = search;
        vm.reset = reset;
        vm.clearSection = clearSection;
        vm.clearCoach = clearCoach;
        vm.clearAgeGroup = clearAgeGroup;
        vm.clearCounty = clearCounty;
        vm.clearCourse = clearCourse;
        vm.clearClass = clearClass;
        vm.cleaSex = cleaSex;
        vm.goToAthlete = goToAthlete;
        vm.goToUser = goToUser;

        vm.formData = {
            active: true,
            inactive: false,
            sportServiceFee: true,
            educationalFee: true
        };

        // Activate page
        activate();

        function activate() {
            var promises = [
                authenticationService.getRight('SPORTOLOKERESO'),
                paramHelper.getParams([], ['search.simple.formdata'])
            ];
            $q.all(promises)
                .then(function (results) {
                    if (results[0] !== true) {
                        log.permissionError(true);
                    } else {
                        if (results[1] && results[1]['search.simple.formdata']) {
                            $timeout(function () {
                                vm.formData = results[1]['search.simple.formdata'];
                                $scope.$apply();
                            }, 500);
                            $timeout(function () {
                                getSections();
                                getAgeGroups();
                                getCoaches();
                                $timeout(function () {
                                    search();
                                }, 500);
                            }, 500);
                        }
                    }
                });
        }

        function getSections() {
            return dataservice.sectionDropDownList(0).then(function (data) {
                vm.sectionList = data.itemsList;
            });
        }

        function sectionDataBound() {
            if (vm.sectionList.length === 1) {
                angular.element('#sectionId').ejDropDownList('selectItemByValue', vm.sectionList[0].value);
                vm.formData.sectionId = vm.sectionList[0].value;
            } else {
                angular.element('#sectionId').ejDropDownList('selectItemByValue', vm.formData.sectionId);
            }
        }

        function sectionSelect(args) {
            vm.formData.sectionId = args.value;
            getAgeGroups(args.value);
        }

        function getAgeGroups(sectionId) {
            if (!sectionId) {
                sectionId = 0;
            }
            return dataservice.ageGroupDropDownListForSearch(sectionId)
                .then(function (data) {
                    vm.ageGroupList = data.itemsList;
                });
        }

        function ageGroupDataBound() {
            if (vm.ageGroupList.length === 1) {
                angular.element('#ageGroupId').ejDropDownList('selectItemByValue', vm.ageGroupList[0].value);
                vm.formData.ageGroupId = vm.ageGroupList[0].value;
            } else {
                angular.element('#ageGroupId').ejDropDownList('selectItemByValue', vm.formData.ageGroupId);
            }
        }

        function ageGroupSelect(args) {
            vm.formData.ageGroupId = args.value;
            getCoaches();
        }

        function getCoaches() {
            return dataservice.coachSelect()
                .then(function (data) {
                    vm.coachList = data.itemsList;
                });
        }

        function coachDataBound() {
            if (vm.coachList.length === 1) {
                angular.element('#coachId').ejDropDownList('selectItemByValue', vm.coachList[0].value);
                vm.formData.coachId = vm.coachList[0].value;
            } else {
                angular.element('#coachId').ejDropDownList('selectItemByValue', vm.formData.coachId);
            }
        }

        function coachSelect(args) {
            vm.formData.coachId = args.value;
        }

        function search() {
            console.log('vm.formData SEARCH', vm.formData);
            paramHelper.setParams([{'search.simple.formdata': vm.formData}]);
            dataservice.searchAthlete(vm.formData).then(function (data) {
                data.itemsList = $filter('dateStringFilter')(data.itemsList, 'SzuletesiIdo');
                data.itemsList = $filter('dateStringFilter')(data.itemsList, 'VersSportKezd');
                vm.athleteList = data.itemsList;
                grid.dataSource = vm.athleteList;
            });
        }

        function reset() {
            vm.formData = {};
        }

        function cleaSex() {
            vm.formData.sex = undefined;
            $('#sex').ejDropDownList('clearText');
        }

        function clearSection() {
            vm.formData.sectionId = undefined;
            $('#sectionId').ejDropDownList('clearText');
            getAgeGroups(0);
            getAgeGroups(0);
        }

        function clearAgeGroup() {
            vm.formData.ageGroupId = undefined;
            $('#ageGroupId').ejDropDownList('clearText');
        }

        function clearCoach() {
            vm.formData.coachId = undefined;
            $('#coachId').ejDropDownList('clearText');
        }

        function clearCounty() {
            vm.formData.county = undefined;
            $('#county').ejDropDownList('clearText');
        }

        function clearCourse() {
            vm.formData.course = undefined;
            $('#course').ejDropDownList('clearText');
        }

        function clearClass() {
            vm.formData.class = undefined;
            $('#class').ejDropDownList('clearText');
        }

        function goToAthlete(id) {
            $q.all([authenticationService.getRight('MEGTSPORTLIST'), authenticationService.getRight('MEGTSPORTLIST')]).then(function (results) {
                if (results[0] || results[1]) {
                    paramHelper.setParams([{'athleteModify.sportoloId': id}]);
                    $state.go('athletes.athletesManagement.athleteModify.dataSheet');
                } else {
                    log.permissionError();
                }
            });
        }

        function goToUser(edzoId) {
            authenticationService.getRight('MEGTFELH').then(function (result) {
                if (result !== true) {
                    log.permissionError();
                    return;
                }
                paramHelper.setParams([{'newUser.userId': edzoId}]);
                $state.go('settings.userManagement.modifyUser');
            });
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.search.athletes.simple')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'search.athletes.simple',
                config: {
                    url: '/simple',
                    templateUrl: 'app/search/athletes/simple/simple.html',
                    controller: 'SimpleController',
                    controllerAs: 'vm',
                    title: 'SearchAthletesSimple',
                    settings: {
                        navId: 21170,
                        level: 2,
                        order: 1,
                        orderTitle_hu: 'Sportoló kereső',
                        orderTitle_en: 'Athlete Search',
                        parentId: 170,
                        content: 'SearchAthletesSimple',
                        activatorPermission: '"SPORTOLOKERESO"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.search')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'search',
                config: {
                    url: '/search',
                    templateUrl: 'app/search/search.html',
                    title: 'Search',
                    settings: {
                        navId: 170,
                        level: 1,
                        order: 7,
                        parentId: 0,
                        content: 'Search',
                        activatorPermission: ['"EDZOKERESO"', '"SPORTOLOKERESO"']
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    SearchUsersController.$inject = ["log", "dataservice", "$q", "$rootScope", "gettextCatalog", "$filter", "authenticationService", "paramHelper", "$state", "$scope"];
    angular
        .module('app.search.user.searchuser')
        .controller('SearchUsersController', SearchUsersController);

    function SearchUsersController(log, dataservice, $q, $rootScope, gettextCatalog, $filter, authenticationService, paramHelper, $state, $scope) {
        var vm = this; $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('SearchUsers');

        // Create variables
        vm.userList = [];
        vm.yesno = [
            {text: gettextCatalog.getString(''), value: null},
            {text: gettextCatalog.getString('Yes'), value: true},
            {text: gettextCatalog.getString('No'), value: false}
        ];
        vm.genderList = [
            {text: gettextCatalog.getString(''), value: undefined},
            {text: gettextCatalog.getString('Male'), value: 'Male'},
            {text: gettextCatalog.getString('Female'), value: 'Female'}
        ];
        vm.columns = [
            {field: 'Id', headerText: gettextCatalog.getString('Id'), textAlign: 'left', width: '90'},
            {field: 'Nev', headerText: gettextCatalog.getString('LoginName'), textAlign: 'left', width: '150', template: '#searchusergotouser'},
            {field: 'TeljesNev', headerText: gettextCatalog.getString('FullName'), textAlign: 'left', width: '150'},
            {field: 'SzulIdo', headerText: gettextCatalog.getString('BirthDate'), textAlign: 'left', width: '120', type: 'date', format: 'yMd'},
            {field: 'Lakcim', headerText: gettextCatalog.getString('Address'), textAlign: 'left', width: '150'},
            {field: 'FelhasznaloCsoport', headerText: gettextCatalog.getString('Usergroup'), textAlign: 'left', width: '150'},
            {field: 'Elerhetosege', headerText: gettextCatalog.getString('Contact'), textAlign: 'left', width: '150'},
            {field: 'Aktiv', headerText: gettextCatalog.getString('Active'), textAlign: 'left', width: '70', type: 'boolean', displayAsCheckBox: true}
        ];

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItems,
            editSettings: {allowEditing: false, allowAdding: false, allowDeleting: false},
            allowTextWrap: true,
            allowSorting: true,
            allowScrolling: true,
            allowExcelExport: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            columns: vm.columns,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile(angular.element('#Grid'), $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        // Public functions
        vm.search = search;
        vm.reset = reset;
        vm.goToUser = goToUser;

        vm.formData = {};
        vm.usergroups = [];

        resetQueryDetails ();

        function resetQueryDetails () {
            vm.formData.nev = undefined;
            vm.formData.loginNev = undefined;
            vm.formData.idCsoport = undefined;
            vm.formData.szulHelyOrszag = undefined;
            vm.formData.szulHelyVaros = undefined;
            vm.formData.szulTol = undefined;
            vm.formData.szulIg = undefined;
            vm.formData.email = undefined;
            vm.formData.lakcim = undefined;
            vm.formData.elerhetoseg = undefined;
            vm.formData.neme = undefined;
            vm.formData.allamp = undefined;
            vm.formData.anyjaNeve = undefined;
            vm.formData.edzKep = undefined;
            vm.formData.foallMh = undefined;
            vm.formData.magTol = undefined;
            vm.formData.magIg = undefined;
            vm.formData.testTol = undefined;
            vm.formData.testIg = undefined;
            vm.formData.szemSzam = undefined;
            vm.formData.tajSzam = undefined;
            vm.formData.utlevel = undefined;
            vm.formData.aktiv = undefined;
            vm.formData.egyeniSport = false;
            vm.formData.csapatSport = false;
        }

        // Activate page
        activate();

        function activate() {
            var promises = [authenticationService.getRight('EDZOKERESO'), paramHelper.getParams([], ['search.user.formdata'])];
            getUserGroups();
            $q.all(promises)
                .then(function (results) {
                    if (results[0] !== true) {
                        log.permissionError(true);
                    }
                    if (results[1] && results[1]['search.user.formdata']) {
                        vm.formData = results[1]['search.user.formdata'];
                        search();
                    }
                });
        }

        function getUserGroups() {
            return dataservice.userGroupList()
                .then(function (data) {
                    vm.usergroups = data.itemsList;
                    vm.usergroups.unshift({value: undefined, text: ''});
                });
        }

        function search() {
            paramHelper.setParams([{'search.user.formdata': vm.formData}]);
            vm.userList = [];
            dataservice.searchUser(vm.formData).then(function (data) {
                data.itemsList = $filter('dateStringFilter')(data.itemsList, 'SzulIdo');
                vm.userList = data.itemsList;
                grid.dataSource = vm.userList;
                grid.refresh();
            });
        }

        function goToUser(edzoId) {
            authenticationService.getRight('MEGTFELH').then(function (result) {
                if (result !== true) {
                    log.permissionError();
                    return;
                }
                paramHelper.setParams([{'newUser.userId': edzoId}]);
                $state.go('settings.userManagement.modifyUser');
            });
        }

        function reset() {
            resetQueryDetails();
        }

        vm.userGroupDatabound = userGroupDatabound;
        function userGroupDatabound () {
            if (vm.usergroups.length === 1) {
                angular.element('#usergroup').ejDropDownList('selectItemByValue', vm.usergroups[0].value);
                vm.formData.idCsoport = vm.usergroups[0].value;
            } else {
                angular.element('#usergroup').ejDropDownList('selectItemByValue', vm.formData.idCsoport);
            }
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.search.user.searchuser')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'search.user.searchuser',
                config: {
                    url: '/searchuser',
                    templateUrl: 'app/search/user/searchuser/searchuser.html',
                    controller: 'SearchUsersController',
                    controllerAs: 'vm',
                    title: 'SearchUsers',
                    settings: {
                        navId: 23170,
                        level: 2,
                        order: 3,
                        orderTitle_hu: 'Felhasználó kereső',
                        orderTitle_en: 'User Search',
                        parentId: 170,
                        content: 'SearchUsers',
                        activatorPermission: '"EDZOKERESO"'

                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.search.user')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'search.user',
                config: {
                    url: '/user',
                    templateUrl: 'app/search/user/user.html',
                    title: 'SearchUser'
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    AgeGroupChangeController.$inject = ["logger", "log", "dataservice", "$q", "$rootScope", "gettextCatalog", "paramHelper", "authenticationService", "$filter", "$scope", "$state"];
    angular
        .module('app.settings.ageGroupChange')
        .controller('AgeGroupChangeController', AgeGroupChangeController);

    function AgeGroupChangeController(logger, log, dataservice, $q, $rootScope, gettextCatalog, paramHelper, authenticationService, $filter, $scope, $state) {
        var vm = this; $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('AgeGroupChange');

        // Create variables
        // Dropdownlist's sources
        vm.actualSectionList = [];
        vm.actualCoachList = [];
        vm.sectionList = [];
        vm.coachList = [];
        vm.atletesList = [];
        vm.ageGroupList = [];

        // Grid's variables
        vm.columns = [
            {field: 'Link', type: 'checkbox', textAlign: 'center', width: 55},
            {field: 'Nev', headerText: gettextCatalog.getString('Name'), textAlign: 'left', template: '#agegroupchangecolumnTemplate2'},
            {field: 'EdzoNeve', headerText: gettextCatalog.getString('CoachName'), textAlign: 'left', template: '#agegroupchangecolumnTemplate1'},
            {field: 'SzakosztalyNeve', headerText: gettextCatalog.getString('Section'), textAlign: 'left'},
            {field: 'SzuletesiIdo', headerText: gettextCatalog.getString('BirthDate'), textAlign: 'left', format: 'yyyy-MM-dd'},
            {field: 'KorcsoportNeve', headerText: gettextCatalog.getString('AgeGroup'), textAlign: 'left'},
            {field: 'Megjegyzes', headerText: gettextCatalog.getString('Comment'), textAlign: 'left'},
            {field: 'Tagdij', headerText: gettextCatalog.getString('SportServiceFee'), textAlign: 'left'},
            {field: 'Oktatasidij', headerText: gettextCatalog.getString('SchoolFee'), textAlign: 'left'},
            {field: 'Egyenleg', headerText: gettextCatalog.getString('Balance'), textAlign: 'left'},
            {field: 'Aktiv', headerText: gettextCatalog.getString('Active'), textAlign: 'center', type: 'boolean', template: '#checkboxTemplateAktiv'},
            {field: 'jelenKorcsoportbanMikortolVan', headerText: gettextCatalog.getString('InAgeGroupFromDate'), textAlign: 'left', format: 'yyyy-MM-dd'}
        ];

        // Other variables
        vm.dateValue = new Date();
        vm.date = vm.dateValue;
        vm.athleteData = {};
        vm.actualSectionId = undefined;
        vm.actualCoachId = undefined;
        vm.actualAthleteId = undefined;
        vm.NOACTUALATHLETE = false;
        vm.which = 1;
        vm.backPath = '';

        // Public functions
        vm.actualSectionDataBound = actualSectionDataBound;
        vm.actualSectionSelect = actualSectionSelect;
        vm.actualCoachDataBound = actualCoachDataBound;
        vm.actualCoachSelect = actualCoachSelect;
        vm.dateChange = dateChange;
        vm.ageGroupDataBound = ageGroupDataBound;
        vm.ageGroupSelect = ageGroupSelect;
        vm.transferAthletes = transferAthletes;
        vm.openCoach = openCoach;
        vm.goToAthlete = goToAthlete;

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItemsWithSearch,
            allowPaging: true,
            allowTextWrap: true,
            allowSorting: true,
            allowExcelExport: true,
            allowDeleting: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            beforePrint: $rootScope.beforePrintGrid,
            printComplete: $rootScope.printCompleteGrid,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile(angular.element('#Grid'), $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        // Activate page
        activate();

        function activate() {
            var promises = [
                authenticationService.getRight('MEGTEDZVALT'),
                authenticationService.getRight('MEGTKORVALT'),
                authenticationService.getRight('UJEDZVALT'),
                paramHelper.getParams([], [
                    'ageGroupChange.athleteData',
                    'ageGroupChange.which'])
            ];
            $q.all(promises).then(function (results) {
                vm.NOACTUALATHLETE = true;

                if (results[3]['ageGroupChange.athleteData'] !== null && angular.isDefined(results[3]['ageGroupChange.athleteData'])) {
                    vm.athleteData = results[3]['ageGroupChange.athleteData'];
                    vm.actualAthleteId = vm.athleteData.SportolokID;
                    vm.backPath = results[3]['ageGroupChange.backPath'];
                    paramHelper.removeParam('ageGroupChange.athleteData'); // Clear athleteData
                } else {
                    vm.actualAthleteId = 0;
                }
                if (angular.isDefined(results[3]['ageGroupChange.which'])) {
                    vm.which = results[3]['ageGroupChange.which'];
                }
                if (results[0] !== true && results[1] !== true) {
                    log.permissionError(true);
                } else if (vm.actualAthleteId > 0) {
                    vm.UJEDZVALT = results[2];
                    if (vm.which == 1) {
                        vm.actualSectionId = vm.athleteData.IdSzakosztaly;
                        vm.actualCoachId = vm.athleteData.JelenlegiEdzo;
                    } else {
                        vm.actualSectionId = vm.athleteData.MasodlagosSzakosztaly;
                        vm.actualCoachId = vm.athleteData.MasodlagosSzakosztalyEdzoId;
                    }
                    athletesSelect();
                    getAgeGroups();
                    vm.NOACTUALATHLETE = false;
                } else {
                    vm.UJEDZVALT = results[2];
                    getActualSections();
                }
            });
        }

        /**
         * Betölti a szakosztályok listáját
         * @author Richard Keki
         * @returns {promise} A http promisszal tér vissza
         */
        function getActualSections() {
            return dataservice.sectionDropDownList(0)
                .then(function (data) {
                    vm.actualSectionList = data.itemsList;
                    if (vm.actualSectionId > 0) {
                        vm.defaultSection = vm.actualSectionId; // Set default section
                        angular.element('#actualSectionDropDown').ejDropDownList({enabled: false});
                        grid.selectRow(0);
                    }
                });
        }

        /**
         * Szakosztályok betöltése után beállítja az alapértelmezett szakosztályt
         * @author Richard Keki
         */
        function actualSectionDataBound() {
            if (vm.actualSectionList.length === 1) {
                angular.element('#actualSectionDropDown').ejDropDownList('selectItemByValue', vm.actualSectionList[0].value);
                vm.actualSectionId = vm.actualSectionList[0].value;
            } else {
                angular.element('#actualSectionDropDown').ejDropDownList('selectItemByValue', vm.defaultSection);
                vm.actualSectionId = vm.defaultSection;
            }
        }

        /**
         * Szakosztály kiválasztásakor fut le és lekéri a szakosztály korosztályait
         * @author Richard Keki
         */
        function actualSectionSelect(args) {
            vm.actualSectionId = args.value;
            vm.actualCoachId = 0;
            getActualCoaches();
            if (vm.NOACTUALATHLETE) {
                athletesSelect();
            }
        }

        /**
         * Betölti az edzőket
         * @author Richard Keki
         * @returns {promise} A http promisszal tér vissza
         */
        function getActualCoaches() {
            return dataservice.coachDropDownList(vm.actualSectionId)
                .then(function (data) {
                    vm.actualCoachList = data.itemsList;
                });
        }

        /**
         * Edzők betöltése után beállítja az alapértelmezett edzőt
         * @author Richard Keki
         */
        function actualCoachDataBound() {
            if (vm.actualCoachList.length === 1) {
                angular.element('#actualCoachDropDown').ejDropDownList('selectItemByValue', vm.actualCoachList[0].value);
                vm.actualCoachId = vm.actualCoachList[0].value;
            } else if (vm.athleteData.JelenlegiEdzo > 0) {
                vm.actualCoachId = vm.athleteData.JelenlegiEdzo;
                angular.element('#actualCoachDropDown').ejDropDownList('selectItemByValue', vm.actualCoachId);
            }
        }

        function actualCoachSelect(args) {
            vm.actualCoachId = args.value;
            if (vm.NOACTUALATHLETE) {
                athletesSelect();
            }
            getAgeGroups();
        }

        function athletesSelect() {
            return dataservice.getAthletes(vm.actualSectionId, vm.actualCoachId, vm.actualAthleteId)
                .then(function (data) {
                    vm.atletesList = $filter('dateStringFilter')(data.itemsList, 'jelenKorcsoportbanMikortolVan');
                    vm.atletesList = $filter('dateStringFilter')(data.itemsList, 'SzuletesiIdo');
                    grid.dataSource = vm.atletesList;
                });
        }

        function dateChange(args) {
            vm.date = args.value;
        }

        function getAgeGroups() {
            return dataservice.ageGroupSelect(vm.actualCoachId, vm.actualSectionId)
                .then(function (data) {
                    vm.ageGroupList = data.itemsList;
                });
        }

        function ageGroupDataBound() {
            if (vm.ageGroupList.length === 1) {
                angular.element('#ageGroupDropDown').ejDropDownList('selectItemByValue', vm.ageGroupList[0].value);
                vm.selectedAgeGroupId = vm.ageGroupList[0].value;
            }
        }

        // Run after age group selected
        function ageGroupSelect(args) {
            vm.ageGroupId = args.value;
        }

        function transferAthletes() {
            if (vm.UJEDZVALT !== true) {
                log.permissionError();
                return;
            }
            // a syncfusion direktívák miatt
            $scope.$broadcast('submitted');
            if ($scope.form.$valid === false) {
                log.errorMsg(gettextCatalog.getString('RequiredFieldsError'));
                return;
            }
            if (vm.actualAthleteId > 0) {
                grid.selectRow(0);
            }
            vm.selectedRows = grid.getSelectedRecords();
            if (vm.selectedRows.length !== 0) {
                if (vm.actualSectionId !== 0 && vm.actualCoachId !== 0 && vm.ageGroupId) {
                    swal({
                        title: gettextCatalog.getString('AreYouSureToChangeAgeGroup'),
                        type: 'warning',
                        showCancelButton: true,
                        confirmButtonText: gettextCatalog.getString('OK'),
                        cancelButtonText: gettextCatalog.getString('Cancel'),
                        closeOnConfirm: false
                    }).then(function (confirm) {
                        if (confirm.value) {
                            dataservice.transferAthletes(vm.selectedRows, vm.actualCoachId, vm.actualSectionId, vm.ageGroupId, vm.date, true).then(function () {
                                athletesSelect();
                                log.successMsg(gettextCatalog.getString('TransferCompleted'));
                            });
                            swal.close();
                            if (vm.actualAthleteId > 0) {
                                $rootScope.back();
                            }
                        } else {
                            swal.close();
                        }
                    });
                } else {
                    log.errorMsg(gettextCatalog.getString('YouHaveToSelectTransferDestination'), gettextCatalog.getString('NoSelected'));
                }
            } else {
                log.errorMsg(gettextCatalog.getString('YouHaveToSelectLeastAthlete'), gettextCatalog.getString('NoSelectedAthlete'));
            }
        }

        function goToAthlete(id) {
            $q.all([authenticationService.getRight('MEGTSPORTLIST')]).then(function (results) {
                if (results[0]) {
                    paramHelper.setParams([{'athleteModify.sportoloId': id}]);
                    $state.go('athletes.athletesManagement.athleteModify.dataSheet');
                } else {
                    log.permissionError();
                }
            });
        }

        function openCoach(edzoId) {
            $q.all([authenticationService.getRight('MODFELH'), authenticationService.getRight('MEGTFELH')]).then(function (results) {
                if (results[0] || results[1]) {
                    paramHelper.setParams([{'newUser.userId': edzoId}]);
                    $state.go('settings.userManagement.modifyUser');
                } else {
                    log.permissionError();
                }
            });
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.settings.ageGroupChange')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'settings.ageGroupChange',
                config: {
                    url: '/ageGroupChange',
                    templateUrl: 'app/settings/ageGroupChange/ageGroupChange.html',
                    controller: 'AgeGroupChangeController',
                    controllerAs: 'vm',
                    title: 'AgeGroupChange',
                    settings: {
                        navId: 265,
                        level: 2,
                        order: 6,
                        orderTitle_hu: 'Korosztályváltás',
                        orderTitle_en: 'Change Age Groups',
                        parentId: 5,
                        content: 'AgeGroupChange',
                        activatorPermission: '"MEGTEDZVALT"'

                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    AthleteTransferController.$inject = ["log", "dataservice", "$q", "$rootScope", "gettextCatalog", "paramHelper", "authenticationService", "$filter", "$state", "$scope"];
    angular
        .module('app.settings.athleteTransfer')
        .controller('AthleteTransferController', AthleteTransferController);

    function AthleteTransferController(log, dataservice, $q, $rootScope, gettextCatalog, paramHelper, authenticationService, $filter, $state, $scope) {
        var vm = this;
        $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('AthleteTransfer');

        // Create variables
        // Dropdownlist's sources
        vm.actualSectionList = [];
        vm.actualCoachList = [];
        vm.sectionList = [];
        vm.coachList = [];
        vm.ageGroupList = [];
        vm.athleteData = undefined;
        vm.selectedRows = [];
        vm.columns = [
            {field: 'Link', type: 'checkbox', textAlign: 'center', width: 100},
            {
                field: 'Nev',
                headerText: gettextCatalog.getString('Name'),
                textAlign: 'left',
                template: '#athltransfercolumnTemplate2',
                width: 100
            },
            {
                field: 'EdzoNeve',
                headerText: gettextCatalog.getString('CoachName'),
                textAlign: 'left',
                template: '#athltransfercolumnTemplate1',
                width: 100
            },
            {field: 'SzakosztalyNeve', headerText: gettextCatalog.getString('Section'), textAlign: 'left', width: 100},
            {
                field: 'SzuletesiIdo',
                headerText: gettextCatalog.getString('BirthDate'),
                textAlign: 'left',
                format: '{0:yyyy-MM-dd}',
                width: 100
            },
            {field: 'KorcsoportNeve', headerText: gettextCatalog.getString('AgeGroup'), textAlign: 'left', width: 100},
            {field: 'Megjegyzes', headerText: gettextCatalog.getString('Comment'), textAlign: 'left', width: 100},
            {field: 'Tagdij', headerText: gettextCatalog.getString('SportServiceFee'), textAlign: 'left', width: 100},
            {field: 'Oktatasidij', headerText: gettextCatalog.getString('SchoolFee'), textAlign: 'left', width: 100},
            {field: 'Egyenleg', headerText: gettextCatalog.getString('Balance'), textAlign: 'left', width: 100},
            {field: 'Aktiv', headerText: gettextCatalog.getString('Active'), textAlign: 'center', width: 100, type: 'boolean', displayAsCheckBox: true},
            {
                field: 'jelenKorcsoportbanMikortolVan',
                headerText: gettextCatalog.getString('InAgeGroupFromDate'),
                textAlign: 'left',
                format: '{0:yyyy-MM-dd}',
                width: 100
            }
        ];

        var Grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItems,
            allowPaging: true,
            allowSorting: true,
            allowExcelExport: true,
            allowTextWrap: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            selectionSettings: {type: 'multiple', mode: 'Both'},
            beforePrint: $rootScope.beforePrintGrid,
            printComplete: $rootScope.printCompleteGrid,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile(Grid, $scope);
                }
            },
            rowSelected: function () {
                vm.selectedRows = $rootScope.getSelectedItems(Grid);
            },
            dataBound: function () {
                if (Grid.dataSource.length === 1) {
                    Grid.selectRow(0);
                }
            }
        });
        Grid.appendTo('#Grid');
        Grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, Grid);
        };

        //Other variables
        vm.dateValue = new Date();
        vm.date = vm.dateValue;

        vm.athleteData = undefined;
        vm.actualAthleteId = 0;
        vm.actualSectionId = undefined;
        vm.actualCoachId = 0;

        //Public functions
        vm.actualSectionDataBound = actualSectionDataBound;
        vm.actualSectionSelect = actualSectionSelect;
        vm.actualCoachDataBound = actualCoachDataBound;
        vm.actualCoachSelect = actualCoachSelect;
        vm.dateChange = dateChange;
        vm.sectionDataBound = sectionDataBound;
        vm.sectionSelect = sectionSelect;
        vm.coachDataBound = coachDataBound;
        vm.coachSelect = coachSelect;
        vm.ageGroupDataBound = ageGroupDataBound;
        vm.ageGroupSelect = ageGroupSelect;
        vm.transferAthletes = transferAthletes;
        vm.openCoach = openCoach;
        vm.goToAthlete = goToAthlete;
        vm.previousState = ''; // athleteNew és athleteModify felületekről érkezhet

        //Activate page
        activate();

        function activate() {
            var promises = [authenticationService.getRight('MEGTEDZVALT'), authenticationService.getRight('MEGTKORVALT'), paramHelper.getParams([], ['athleteTransfer.athleteData', 'previousState']), authenticationService.getRight('UJEDZVALT')];
            $q.all(promises).then(function (results) {
                vm.UJEDZVALT = results[3];
                if (results[2] ['athleteTransfer.athleteData']) {
                    vm.previousState = results[2]['previousState'];
                    vm.athleteData = results[2] ['athleteTransfer.athleteData'];
                    vm.actualAthleteId = vm.athleteData.SportolokID;
                    paramHelper.removeParam('athleteTransfer.athleteData'); // Clear paramHelper's athleteData
                } else {
                    vm.actualAthleteId = 0;
                }

                if (results[0] !== true && results[1] !== true && results[3] !== true) {
                    log.permissionError(true);
                } else if (vm.actualAthleteId > 0) {
                    if (vm.athleteData.ModifyCoach === 1) {
                        vm.actualSectionId = vm.athleteData.IdSzakosztaly;
                        vm.actualCoachId = vm.athleteData.JelenlegiEdzo;
                    } else if (vm.athleteData.ModifyCoach === 2) {
                        vm.actualSectionId = vm.athleteData.MasodlagosSzakosztaly;
                        vm.actualCoachId = vm.athleteData.MasodlagosSzakosztalyEdzoId;
                    }
                    athletesSelect();
                    getActualSections();
                    getSections();
                    getActualCoaches();
                } else {
                    getActualSections();
                    getSections();
                }
            });
        }

        /**
         * Betölti a szakosztályok listáját
         * @author Richard Keki
         * @returns {promise} A http promisszal tér vissza
         */
        function getActualSections() {
            return dataservice.sectionDropDownList(vm.actualCoachId)
                .then(function (data) {
                    vm.actualSectionList = data.itemsList;
                    if (vm.actualSectionId > 0) {
                        vm.defaultSection = vm.actualSectionId; // Set default section
                        angular.element('#actualSectionDropDown').ejDropDownList({enabled: false});
                        Grid.selectRow(0);
                    }
                });
        }

        /**
         * Szakosztályok betöltése után beállítja az alapértelmezett szakosztályt
         * @author Richard Keki
         */
        function actualSectionDataBound() {
            if (vm.actualSectionList.length === 1) {
                angular.element('#actualSectionDropDown').ejDropDownList('selectItemByValue', vm.actualSectionList[0].value);
                vm.actualSectionId = vm.actualSectionList[0].value;
            } else {
                angular.element('#actualSectionDropDown').ejDropDownList('selectItemByValue', vm.actualSectionId);
            }
        }

        /**
         * Szakosztály kiválasztásakor fut le és lekéri a szakosztály korosztályait
         * @author Richard Keki
         */
        function actualSectionSelect(args) {
            vm.actualSectionId = args.value;
            vm.actualCoachId = 0;
            getActualCoaches();
            if (vm.actualAthleteId == 0) {
                athletesSelect();
            }
        }

        /**
         * Betölti az edzőket
         * @author Richard Keki
         * @returns {promise} A http promisszal tér vissza
         */
        function getActualCoaches() {
            return dataservice.coachDropDownList(vm.actualSectionId)
                .then(function (data) {
                    vm.actualCoachList = data.itemsList;
                    vm.actualCoachList.unshift({value: '-1', text: gettextCatalog.getString('All')});
                    if (vm.actualAthleteId > 0) {
                        angular.element('#actualCoachDropDown').ejDropDownList({enabled: false});
                    }
                });
        }

        /**
         * Edzők betöltése után beállítja az alapértelmezett edzőt
         * @author Richard Keki
         */
        function actualCoachDataBound() {
            if (vm.actualCoachList.length === 1) {
                angular.element('#actualCoachDropDown').ejDropDownList('selectItemByValue', vm.actualCoachList[0].value);
                vm.actualCoachId = vm.actualCoachList[0].value;
            } else if (vm.athleteData !== undefined) {
                if (vm.athleteData.ModifyCoach == 1 && vm.athleteData.JelenlegiEdzo > 0) {
                    vm.actualCoachId = vm.athleteData.JelenlegiEdzo;
                    angular.element('#actualCoachDropDown').ejDropDownList('selectItemByValue', vm.actualCoachId);
                } else if (vm.athleteData.ModifyCoach == 2 && vm.athleteData.MasodlagosSzakosztalyEdzoId > 0) {
                    vm.actualCoachId = vm.athleteData.MasodlagosSzakosztalyEdzoId;
                    angular.element('#actualCoachDropDown').ejDropDownList('selectItemByValue', vm.actualCoachId);
                }
            }
        }

        function actualCoachSelect(args) {
            vm.actualCoachId = args.value;
            if (vm.actualAthleteId == 0) {
                athletesSelect();
            }
        }

        function athletesSelect() {
            return dataservice.getAthletesEV(vm.actualSectionId, (vm.actualCoachId == -1 ? 0 : vm.actualCoachId), vm.actualAthleteId, true)
                .then(function (data) {
                    Grid.dataSource = $filter('dateStringFilter')(data.itemsList, 'jelenKorcsoportbanMikortolVan');
                    Grid.dataSource = $filter('dateStringFilter')(data.itemsList, 'SzuletesiIdo');
                });
        }

        function dateChange(args) {
            vm.date = args.value;
        }

        /**
         * Betölti a szakosztályok listáját
         * @author Richard Keki
         * @returns {promise} A http promisszal tér vissza
         */
        function getSections() {
            return dataservice.sectionDropDownList(0)
                .then(function (data) {
                    vm.sectionList = data.itemsList;
                });
        }

        /**
         * Szakosztályok betöltése után beállítja az alapértelmezett szakosztályt
         * @author Richard Keki
         */
        function sectionDataBound() {
            if (vm.sectionList.length === 1) {
                angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.sectionList[0].value);
                vm.sectionId = vm.sectionList[0].value;
            }
        }

        /**
         * Szakosztály kiválasztásakor fut le és lekéri a szakosztály korosztályait
         * @author Richard Keki
         */
        function sectionSelect(args) {
            vm.sectionId = args.value;
            vm.coachId = 0;
            vm.ageGroupId = 0;
            vm.ageGroupList = [];
            getcoaches();
        }

        /**
         * Betölti az edzőket
         * @author Richard Keki
         * @returns {promise} A http promisszal tér vissza
         */
        function getcoaches() {
            return dataservice.coachDropDownList(vm.sectionId)
                .then(function (data) {
                    vm.coachList = data.itemsList;
                });
        }

        /**
         * Edzők betöltése után beállítja az alapértelmezett edzőt
         * @author Richard Keki
         */
        function coachDataBound() {
            if (vm.coachList.length === 1) {
                angular.element('#coachDropDown').ejDropDownList('selectItemByValue', vm.coachList[0].value);
                vm.coachId = vm.coachList[0].value;
            }
        }

        function coachSelect(args) {
            vm.coachId = args.value;
            vm.ageGroupId = 0;
            getAgeGroups();
        }

        function getAgeGroups() {
            return dataservice.ageGroupSelect(vm.coachId, vm.sectionId)
                .then(function (data) {
                    vm.ageGroupList = data.itemsList;
                });
        }

        function ageGroupDataBound() {
            if (vm.ageGroupList.length === 1) {
                angular.element('#ageGroupDropDown').ejDropDownList('selectItemByValue', vm.ageGroupList[0].value);
                vm.selectedAgeGroupId = vm.ageGroupList[0].value;
            }
        }

        // Run after age group selected
        function ageGroupSelect(args) {
            vm.ageGroupId = args.value;
        }

        function transferAthletes() {
            if (vm.UJEDZVALT !== true) {
                log.permissionError();
                return;
            }
            if (vm.selectedRows.length !== 0) {
                if (vm.sectionId !== 0 && vm.coachId !== 0 && vm.ageGroupId) {
                    var message = '';
                    angular.forEach(vm.selectedRows, function (value) {
                        if (value.EdzoId === vm.coachId) {
                            message += value.Nev + '<br>';
                        }
                    });
                    if (message !== '') {
                        log.htmlError(gettextCatalog.getString('DestinationCoachSame') + '<br>' + message);
                    } else {
                        swal({
                            title: gettextCatalog.getString('AreYouSureToTransferAthletes'),
                            text: gettextCatalog.getString('AreYouSureToTransferAthletesText'),
                            type: 'warning',
                            showCancelButton: true,
                            confirmButtonText: gettextCatalog.getString('OK'),
                            cancelButtonText: gettextCatalog.getString('Cancel'),
                            closeOnConfirm: false
                        }).then(function (args) {
                            if (args.value) {
                                dataservice.transferAthletes(vm.selectedRows, vm.coachId, vm.sectionId, vm.ageGroupId, vm.date).then(function () {
                                    athletesSelect();
                                    Grid.refresh();

                                    swal.close();
                                    paramHelper.setParams([{'athleteModify.sportoloId': vm.actualAthleteId}]);

                                    if (vm.previousState !== '') {
                                        $state.go(vm.previousState);
                                    }
                                });
                            }
                        });
                    }
                } else {
                    log.errorMsg(gettextCatalog.getString('YouHaveToSelectTransferDestination'));
                }
            } else {
                log.errorMsg(gettextCatalog.getString('YouHaveToSelectLeastAthlete'));
            }
        }

        function goToAthlete(id) {
            $q.all([authenticationService.getRight('MEGTSPORTLIST')]).then(function (results) {
                if (results[0]) {
                    paramHelper.setParams([{'athleteModify.sportoloId': id}]);
                    $state.go('athletes.athletesManagement.athleteModify.dataSheet');
                } else {
                    log.permissionError();
                }
            });
        }

        function openCoach(edzoId) {
            $q.all([authenticationService.getRight('MODFELH'), authenticationService.getRight('MEGTFELH')]).then(function (results) {
                if (results[0] || results[1]) {
                    paramHelper.setParams([{'newUser.userId': edzoId}]);
                    $state.go('settings.userManagement.modifyUser');
                } else {
                    log.permissionError();
                }
            });
        }
    }
})
();


(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.settings.athleteTransfer')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'settings.athleteTransfer',
                config: {
                    url: '/athleteTransfer',
                    templateUrl: 'app/settings/athleteTransfer/athleteTransfer.html',
                    controller: 'AthleteTransferController',
                    controllerAs: 'vm',
                    title: 'AthleteTransfer',
                    settings: {
                        navId: 255,
                        level: 2,
                        order: 5,
                        orderTitle_hu: 'Edzőváltás',
                        orderTitle_en: 'Change Coach',
                        parentId: 5,
                        content: 'AthleteTransfer',
                        activatorPermission: '"MEGTEDZVALT"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    CreateSportSpecificTestController.$inject = ["log", "$q", "paramHelper", "dataservice", "$rootScope", "gettextCatalog", "authenticationService", "$scope", "logger", "$timeout"];
    angular
        .module('app.settings.createSportSpecificTest')
        .controller('CreateSportSpecificTestController', CreateSportSpecificTestController);

    function CreateSportSpecificTestController(log, $q, paramHelper, dataservice, $rootScope, gettextCatalog, authenticationService, $scope, logger, $timeout) {
        var vm = this;
        $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('CreateSportSpecificTest');
        vm.columnsFelmeroElemFej = [
            {field: 'Id_FEF', isPrimaryKey: true, isIdentity: true, visible: false},
            {field: 'FelmeroNeve', headerText: gettextCatalog.getString('FelmeroNeve'), textAlign: 'left', width: 250},
            {
                field: 'Aktiv',
                headerText: gettextCatalog.getString('Active'),
                textAlign: 'center',
                width: 30,
                displayAsCheckBox: true
            }
        ];
        vm.columnsFelmeroElem = [
            {field: 'Id_FE', isPrimaryKey: true, isIdentity: true, visible: false},
            {
                field: 'Nev',
                headerText: gettextCatalog.getString('FelmeroElemNeve'),
                textAlign: 'left',
                allowEditing: true,
                width: 220
            }
        ];
        vm.FEEditEnable = true;
        vm.NewFelmeroTipus = NewFelmeroTipus;
        vm.SaveFelmeroTipusok = SaveFelmeroTipusok;
        vm.CopyFelmeroTipus = CopyFelmeroTipus;
        vm.DeleteFelmeroTipus = DeleteFelmeroTipus;
        vm.SelectFelmeroTipus = SelectFelmeroTipus;
        vm.ActivateFelmeroTipus = ActivateFelmeroTipus;
        vm.InactivateFelmeroTipus = InactivateFelmeroTipus;
        vm.SaveFelmeroElemek = SaveFelmeroElemek;
        vm.DiscardFelmeroElem = DiscardFelmeroElem;
        vm.SelectFelmeroElem = SelectFelmeroElem;
        vm.setDefaultColors = setDefaultColors;
        vm.clearColors = clearColors;
        vm.dataFelmeroElemFej = [];
        vm.dataFelmeroElem = [];
        vm.sectionList = [];
        vm.sectionSelect = sectionSelect;
        vm.sectionValue = undefined;
        vm.felmNev = '';
        vm.selectedFelmeroElemFej = undefined;
        vm.selectedFelmeroElem = undefined;
        vm.newFefItemIndex = -1;
        vm.newFeItemIndex = -1;
        vm.felmeroTipusKijelolve = false;
        vm.newTestName = '';
        vm.editableHint = '';
        vm.saveOrDiscardeHint = '';
        vm.modified = false;
        vm.selectedSection = undefined;
        vm.sectionDataBound = sectionDataBound;
        vm.applyColor = applyColor;
        vm.copyButtonEnabled = false;
        vm.deleteButtonEnabled = false;
        vm.selectedFEFRowIndex = undefined;
        vm.selectedFelmeroIsActive = undefined;
        vm.UJSPFELM = false;
        vm.MEGTSPFELM = false;
        vm.typeHint = [];
        vm.typeHint.push(gettextCatalog.getString('SportSpecificTestTypeHint'));
        vm.typeHint.push('');
        vm.typeHint.push(gettextCatalog.getString('SportSpecificTestTypeHint0'));
        vm.typeHint.push(gettextCatalog.getString('SportSpecificTestTypeHint1'));
        vm.typeHint.push(gettextCatalog.getString('SportSpecificTestTypeHint2'));
        vm.typeHint.push(gettextCatalog.getString('SportSpecificTestTypeHint3'));
        vm.typeHint.push(gettextCatalog.getString('SportSpecificTestTypeHint4'));
        vm.typeHint.push(gettextCatalog.getString('SportSpecificTestTypeHint5'));
        vm.typeHint.push(gettextCatalog.getString('SportSpecificTestTypeHint6'));
        vm.selectedFelmeroElemIndex = -1;
        vm.felmElemNev = '';
        vm.defcolor1 = '#990000';
        vm.defcolor12 = '#ff0000';
        vm.defcolor23 = '#ff8000';
        vm.defcolor34 = '#ffff00';
        vm.defcolor45 = '#c4ff00';
        vm.defcolor5 = '#4dff00';
        vm.num0 = -999;
        vm.num6 = 999;
        vm.num1 = 0;
        vm.num2 = 25;
        vm.num3 = 50;
        vm.num4 = 75;
        vm.num5 = 100;
        vm.defnum1 = 0;
        vm.defnum2 = 25;
        vm.defnum3 = 50;
        vm.defnum4 = 75;
        vm.defnum5 = 100;
        vm.defnum1mmss = '01:00';
        vm.defnum2mmss = '02:00';
        vm.defnum3mmss = '03:00';
        vm.defnum4mmss = '04:00';
        vm.defnum5mmss = '05:00';
        vm.defnum1hhmmss = '01:00:00';
        vm.defnum2hhmmss = '02:00:00';
        vm.defnum3hhmmss = '03:00:00';
        vm.defnum4hhmmss = '04:00:00';
        vm.defnum5hhmmss = '05:00:00';
        vm.colordivenabled = false;
        vm.int = false;
        vm.double = false;
        vm.mmss = false;
        vm.hhmmss = false;
        vm.saveBeforeColorWarning = false;
        var GridFelmeroTipus2 = null;
        var GridFelmeroElem2 = null;
        vm.PreloadFelmeroElemFej = -1;
        var types = [
            {text: gettextCatalog.getString('NumberInteger'), value: gettextCatalog.getString('NumberInteger')},
            {text: gettextCatalog.getString('NumberFraction'), value: gettextCatalog.getString('NumberFraction')},
            {text: gettextCatalog.getString('Text'), value: gettextCatalog.getString('Text')},
            {
                text: gettextCatalog.getString('TimeHourMinuteSecHundredthOfASec'),
                value: gettextCatalog.getString('TimeHourMinuteSecHundredthOfASec')
            },
            {
                text: gettextCatalog.getString('TimeMinuteSecHundredthOfASec'),
                value: gettextCatalog.getString('TimeMinuteSecHundredthOfASec')
            },
            {
                text: gettextCatalog.getString('TimeSecHundredthOfASec'),
                value: gettextCatalog.getString('TimeSecHundredthOfASec')
            }
        ];

        activate();

        CreateGridFelmeroTipus2();

        CreateGridFelmeroElem2();

        function activate() {
            var promises = [
                paramHelper.getParams([], ['sectionId', 'FelmeroElemFej']),
                authenticationService.getRight('UJSPFELM'),
                authenticationService.getRight('MEGTSPFELM'),
                getSections()
            ];
            $q.all(promises).then(function (results) {
                vm.UJSPFELM = results[1];
                vm.MEGTSPFELM = results[2];
                resetColumnsFelmeroElem(true);
                if (!vm.MEGTSPFELM) {
                    log.permissionError(true);
                }
                if (!vm.UJSPFELM) {
                    $timeout(function () {
                        GridFelmeroElem2.toolbar = ['Edit', 'Update', 'Cancel'];
                    }, 1000);
                }
                vm.sectionValue = results[0].sectionId;
                vm.selectedSection = results[0].sectionId;
                vm.FelmeroElemFej = results[0].FelmeroElemFej;
                vm.PreloadFelmeroElemFej = results[0].FelmeroElemFej;
                paramHelper.removeParam('sectionId');
                paramHelper.removeParam('FelmeroElemFej');
                if (vm.selectedSection > 0) {
                    if (vm.FelmeroElemFej == 0) {
                        NewFelmeroTipus();
                    }
                }
            });
        }

        function CreateGridFelmeroTipus2() {
            GridFelmeroTipus2 = new ej2.grids.Grid({
                dataSource: vm.dataFelmeroElemFej,
                columns: vm.columnsFelmeroElemFej,
                allowPaging: false,
                allowSorting: false,
                allowTextWrap: false,
                allowExcelExport: false,
                allowSelection: true,
                editSettings: {
                    allowEditing: true, allowAdding: false, allowDeleting: false
                },
                selectionSettings: {type: 'Single', mode: 'Row'},
                locale: 'hu-HU',
                gridLines: 'Both',
                rowSelected: function (args) {
                    console.log('Tipus Select', args);
                    SelectFelmeroTipus(args);
                },
                dataBound: function () {
                    if (vm.PreloadFelmeroElemFej > 0) {
                        var idx = getFelmeroElemFejIndex(vm.PreloadFelmeroElemFej);
                        GridFelmeroTipus2.selectRow(idx);
                    }
                },
                actionComplete: function (args) {
                    if (args.requestType == 'save') {
                        SaveFelmeroTipusok();
                    }
                }
            });
            GridFelmeroTipus2.appendTo('#GridFelmeroTipus2');
        }

        function CreateGridFelmeroElem2() {
            GridFelmeroElem2 = new ej2.grids.Grid({
                dataSource: vm.dataFelmeroElem,
                columns: vm.columnsFelmeroElem,
                toolbar: ['Add', 'Edit', 'Update', 'Cancel', 'Delete'],
                allowPaging: false,
                allowSorting: false,
                allowTextWrap: false,
                allowExcelExport: false,
                editSettings: {
                    allowEditing: true, allowAdding: true, allowDeleting: true, mode: 'Inline', showConfirmDialog: false
                },
                locale: 'hu-HU',
                gridLines: 'Both',
                rowSelected: function (args) {
                    SelectFelmeroElem(args);
                },
                actionComplete: function (args) {
                    if (args.requestType == 'add') {
                        vm.colordivenabled = false;
                        $scope.$apply();
                    }
                    if (args.requestType == 'save' && (args.action == 'add' || args.action == 'save')) {
                        if (!args.data.TipusStr) {
                            log.errorMsg(gettextCatalog.getString('TypeIsIncorrect') + ' ' + gettextCatalog.getString('AtLine') + ': ' + args.data.Nev);
                            args.cancel = true;
                        }
                        if (!args.data.Sorrend) {
                            var max = getMaxSorrend();
                            if (max) {
                                max = parseInt(max);
                            } else {
                                max = 0;
                            }
                            args.data.Sorrend = max + 1;
                            GridFelmeroElem2.refresh();
                        }
                    }
                }
            });
            GridFelmeroElem2.appendTo('#GridFelmeroElem2');
        }

        function resetColumnsFelmeroElem(editable) {
            vm.columnsFelmeroElem = [];
            if (editable) {
                if (vm.UJSPFELM) {
                    GridFelmeroElem2.toolbar = ['Add', 'Edit', 'Update', 'Cancel', 'Delete'];
                } else {
                    GridFelmeroElem2.toolbar = [];
                }
                vm.columnsFelmeroElem = [
                    {field: 'Id_FE', isPrimaryKey: true, isIdentity: true, visible: false},
                    {
                        field: 'FelmeroElemFejId',
                        textAlign: 'left',
                        allowEditing: false,
                        visible: false
                    },
                    {
                        field: 'Nev',
                        headerText: gettextCatalog.getString('FelmeroElemNeve'),
                        textAlign: 'left',
                        allowEditing: true,
                        width: 220
                    },
                    {
                        field: 'TipusStr',
                        allowEditing: true,
                        headerText: gettextCatalog.getString('Type'),
                        textAlign: 'left',
                        width: 120,
                        editType: 'dropdownedit',
                        edit: {
                            params: {
                                fields: {value: 'value', text: 'text'},
                                dataSource: types,
                                query: new ej2.data.Query()
                            }
                        }
                    },
                    {
                        field: 'ElvartEredmeny',
                        headerText: gettextCatalog.getString('ExpectedResult'),
                        textAlign: 'left',
                        allowEditing: true,
                        width: 150
                    },
                    {
                        field: 'Sorrend',
                        headerText: gettextCatalog.getString('Order'),
                        textAlign: 'left',
                        allowEditing: true,
                        width: 50
                    }
                ];
            } else {
                if (vm.UJSPFELM) {
                    GridFelmeroElem2.toolbar = ['Edit', 'Update', 'Cancel'];
                } else {
                    GridFelmeroElem2.toolbar = [];
                }
                GridFelmeroElem2.refresh();
                vm.columnsFelmeroElem = [
                    {field: 'Id_FE', isPrimaryKey: true, isIdentity: true, visible: false},
                    {
                        field: 'FelmeroElemFejId',
                        headerText: gettextCatalog.getString('FelmeroElemFejId'),
                        textAlign: 'left',
                        allowEditing: false,
                        visible: false
                    },
                    {
                        field: 'Nev',
                        headerText: gettextCatalog.getString('FelmeroElemNeve'),
                        textAlign: 'left',
                        allowEditing: true,
                        width: 220
                    },
                    {
                        field: 'TipusStr',
                        headerText: gettextCatalog.getString('Type'),
                        textAlign: 'left',
                        allowEditing: false,
                        width: 120
                    },
                    {
                        field: 'ElvartEredmeny',
                        headerText: gettextCatalog.getString('ExpectedResult'),
                        textAlign: 'left',
                        allowEditing: false,
                        width: 150
                    },
                    {
                        field: 'Sorrend',
                        headerText: gettextCatalog.getString('Order'),
                        textAlign: 'left',
                        allowEditing: false,
                        width: 50
                    }
                ];
            }
            GridFelmeroElem2.columns = vm.columnsFelmeroElem;
        }

        function NewFelmeroTipus() {
            if (!vm.UJSPFELM) {
                log.permissionError();
            } else {
                swal({
                    title: gettextCatalog.getString('SportSpecificTestTypeName'),
                    type: 'info',
                    input: 'text',
                    showCancelButton: true,
                    confirmButtonColor: '#DD6B55',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    confirmButtonText: gettextCatalog.getString('Ok'),
                    cancelButtonText: gettextCatalog.getString('Cancel')
                }).then(function (inputValue) {
                    if (inputValue.dismiss === 'cancel' || inputValue.dismiss === 'esc') {
                        return;
                    }
                    if (!inputValue || !inputValue.value || inputValue.value.length < 1 || inputValue.value.length > 50) {
                        log.errorMsg(gettextCatalog.getString('SportSpecificTestTypeNameMustBeAtLeast2CharactersLong'));
                    } else {
                        vm.dataFelmeroElemFej.push({
                            FelmeroNeve: inputValue.value,
                            Aktiv: true,
                            SzakosztalyId: vm.sectionValue,
                            Id_FEF: vm.newFefItemIndex--
                        });
                        GridFelmeroTipus2.dataSource = vm.dataFelmeroElemFej;
                        SaveFelmeroTipusok();
                    }
                });
            }
        }

        function DeleteFelmeroTipus() {
            if (!vm.UJSPFELM) {
                log.permissionError();
            } else {
                swal({
                    title: gettextCatalog.getString('Are you sure you want to delete the selected test type?'),
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#DD6B55',
                    confirmButtonText: gettextCatalog.getString('Yes, delete this test type'),
                    cancelButtonText: gettextCatalog.getString('Cancel'),
                }).then(function (isConfirm) {
                    if (isConfirm.value) {
                        dataservice.deleteFelmeroElemFej(vm.selectedFelmeroElemFej).then(function () {
                            vm.selectedFelmeroElemFej = undefined;
                            LoadFelmeroTipusok(vm.sectionValue);
                        });
                    }
                });
            }
        }

        function CopyFelmeroTipus() {
            if (!vm.UJSPFELM) {
                log.permissionError();
            } else {
                var HTMLtext = '<div style="margin-top: 10px;" ><label class="col-lg-6" style="text-align: left; margin-top:5px;">' + gettextCatalog.getString('Section') +
                    '</label><input class="col-lg-6 col-lg-offset-6" id="sectionDropDownSwal" ej-dropdownlist></div>' +
                    '<div style="margin-top: 10px;"><label class="col-lg-6" style="text-align: left; margin-top:5px;">' + gettextCatalog.getString('FelmeroNeve') +
                    '</label><input id="copyfelmeroneve" name="copyfelmeroneve"></div>';
                swal({
                    title: gettextCatalog.getString('CreateCopyOfSportSpecific'),
                    html: HTMLtext,
                    type: 'question',
                    showCancelButton: true,
                    confirmButtonColor: '#DD6B55',
                    confirmButtonText: gettextCatalog.getString('Ok'),
                    cancelButtonText: gettextCatalog.getString('Cancel'),
                }).then(function (isConfirm) {
                    if (isConfirm.value) {
                        var copyName = document.getElementById('copyfelmeroneve').value;
                        if (copyName.length > 0 && vm.athleteDataSwalSzakosztaly > 0) {
                            if (copyName.length <= 1 || copyName.length > 50) {
                                log.errorMsg(gettextCatalog.getString('SportSpecificTestTypeNameMustBeAtLeast2CharactersLong'));
                                return;
                            }
                            dataservice.FelmeroTipusMasolas(vm.selectedFelmeroElemFej, vm.athleteDataSwalSzakosztaly, copyName).then(function () {
                                vm.sectionValue = vm.athleteDataSwalSzakosztaly;
                            });
                        } else {
                            log.errorMsg('FillTheRequiredFieldsSectionAndTestName');
                        }
                    }
                }).then(function () {
                });
                angular.element('#sectionDropDownSwal').ejDropDownList({
                    dataSource: vm.sectionList,
                    select: selectSectionDropDownSwal,
                    value: vm.athleteDataSwalSzakosztaly,
                    databound: sectionSwalDatabound,
                    width: '100%'
                });
            }
        }

        function SaveFelmeroTipusok() {
            if (!vm.UJSPFELM) {
                log.permissionError();
            } else {
                dataservice.saveFelmeroElemFej(vm.dataFelmeroElemFej).then(function () {
                    LoadFelmeroTipusok(vm.sectionValue);
                    vm.selectedFelmeroElemFej = undefined;
                });
            }
        }

        function LoadFelmeroTipusok(section) {
            dataservice.getFelmeroElemFejList(section).then(function (arg) {
                vm.dataFelmeroElemFej = arg.itemsList;
                GridFelmeroTipus2.dataSource = vm.dataFelmeroElemFej;
                if (vm.FelmeroElemFej > 0) {
                    vm.FelmeroElemFej = -1;
                }
            });
        }

        function SelectFelmeroTipus(args) {
            console.log('SelectFelmeroTipus', args);
            log.infoMsg(gettextCatalog.getString('DetailsAreShownInTheGridBelow'));
            vm.selectedFelmeroIsActive = args.data.Aktiv;
            vm.selectedFEFRowIndex = args.rowIndex;
            vm.FEEditEnable = !args.data.Used;
            if (args.data.Used) {
                resetColumnsFelmeroElem(false);
                vm.editableHint = gettextCatalog.getString('ThisTestTypeIsReadOnlyBecouseOneOrMoreTestsAreBasedOnThisTestType');
                GridFelmeroElem2.toolbar = [];
                if (vm.UJSPFELM) {
                    GridFelmeroElem2.toolbar = ['Edit', 'Update', 'Cancel'];
                }
            } else {
                resetColumnsFelmeroElem(true);
                vm.editableHint = '';
                GridFelmeroElem2.toolbar = ['Add', 'Edit', 'Update', 'Cancel', 'Delete'];
            }
            vm.felmNev = args.data.FelmeroNeve;
            vm.selectedFelmeroElemFej = args.data.Id_FEF;
            vm.felmeroTipusKijelolve = true;
            vm.copyButtonEnabled = true;
            vm.deleteButtonEnabled = vm.FEEditEnable;
            LoadFelmeroElemek(vm.selectedFelmeroElemFej);
        }

        function ActivateFelmeroTipus() {
            vm.dataFelmeroElemFej[vm.selectedFEFRowIndex].Aktiv = true;
            GridFelmeroTipus2.dataSource = vm.dataFelmeroElemFej;
            SaveFelmeroTipusok();
            vm.selectedFEFRowIndex = -1;
            vm.felmeroTipusKijelolve = false;
            vm.copyButtonEnabled = false;
            vm.deleteButtonEnabled = false;
            vm.felmeroTipusKijelolve = false;
        }

        function InactivateFelmeroTipus() {
            vm.dataFelmeroElemFej[vm.selectedFEFRowIndex].Aktiv = false;
            GridFelmeroTipus2.dataSource = vm.dataFelmeroElemFej;
            SaveFelmeroTipusok();
            vm.selectedFEFRowIndex = -1;
            vm.felmeroTipusKijelolve = false;
            vm.copyButtonEnabled = false;
            vm.deleteButtonEnabled = false;
            vm.felmeroTipusKijelolve = false;
        }

        function DiscardFelmeroElem() {
            vm.colordivenabled = false;
            vm.copyButtonEnabled = true;
            enableFelmeroTipusGrid(true);
            LoadFelmeroElemek(vm.selectedFelmeroElemFej);
        }

        function SelectFelmeroElem(args) {
            console.log('SelectFelmeroElem', args);
            enableFelmeroTipusGrid(false);
            vm.felmeroTipusKijelolve = false;
            vm.saveBeforeColorWarning = false;
            vm.felmElemNev = args.data.Nev;
            if (!(args.data.Id_FE) || args.data.Id_FE < 0) {
                vm.colordivenabled = false;
                $scope.$apply();
                vm.saveBeforeColorWarning = true;
                return;
            }
            vm.selectedFelmeroElem = args.data.Id_FE;
            vm.selectedFelmeroElemIndex = getFelmeroElemIndex(args.data.Id_FE);

            switch (args.data.Tipus) {
                case 1:
                    vm.int = true;
                    vm.double = false;
                    vm.mmss = false;
                    vm.hhmmss = false;
                    break;
                case 2:
                    vm.int = false;
                    vm.double = true;
                    vm.mmss = false;
                    vm.hhmmss = false;
                    break;
                case 6:
                    vm.int = false;
                    vm.double = true;
                    vm.mmss = false;
                    vm.hhmmss = false;
                    break;
                case 5: // MMSS
                    vm.int = false;
                    vm.double = false;
                    vm.mmss = true;
                    vm.hhmmss = false;
                    break;
                case 4: // HHMMSS
                    vm.int = false;
                    vm.double = false;
                    vm.mmss = false;
                    vm.hhmmss = true;
                    break;
            }
            if (args.data.Tipus == 1 || args.data.Tipus == 2 || args.data.Tipus == 6) {
                if (vm.dataFelmeroElem[vm.selectedFelmeroElemIndex].num1) {
                    vm.num1 = vm.dataFelmeroElem[vm.selectedFelmeroElemIndex].num1;
                } else {
                    vm.num1 = vm.defnum1;
                }
                if (vm.dataFelmeroElem[vm.selectedFelmeroElemIndex].num2) {
                    vm.num2 = vm.dataFelmeroElem[vm.selectedFelmeroElemIndex].num2;
                } else {
                    vm.num2 = vm.defnum2;
                }
                if (vm.dataFelmeroElem[vm.selectedFelmeroElemIndex].num3) {
                    vm.num3 = vm.dataFelmeroElem[vm.selectedFelmeroElemIndex].num3;
                } else {
                    vm.num3 = vm.defnum3;
                }
                if (vm.dataFelmeroElem[vm.selectedFelmeroElemIndex].num4) {
                    vm.num4 = vm.dataFelmeroElem[vm.selectedFelmeroElemIndex].num4;
                } else {
                    vm.num4 = vm.defnum4;
                }
                if (vm.dataFelmeroElem[vm.selectedFelmeroElemIndex].num5) {
                    vm.num5 = vm.dataFelmeroElem[vm.selectedFelmeroElemIndex].num5;
                } else {
                    vm.num5 = vm.defnum5;
                }
            } else if (args.data.Tipus == 4) {
                if (vm.dataFelmeroElem[vm.selectedFelmeroElemIndex].num1) {
                    vm.num1 = vm.dataFelmeroElem[vm.selectedFelmeroElemIndex].num1;
                } else {
                    vm.num1 = vm.defnum1hhmmss;
                }
                if (vm.dataFelmeroElem[vm.selectedFelmeroElemIndex].num2) {
                    vm.num2 = vm.dataFelmeroElem[vm.selectedFelmeroElemIndex].num2;
                } else {
                    vm.num2 = vm.defnum2hhmmss;
                }
                if (vm.dataFelmeroElem[vm.selectedFelmeroElemIndex].num3) {
                    vm.num3 = vm.dataFelmeroElem[vm.selectedFelmeroElemIndex].num3;
                } else {
                    vm.num3 = vm.defnum3hhmmss;
                }
                if (vm.dataFelmeroElem[vm.selectedFelmeroElemIndex].num4) {
                    vm.num4 = vm.dataFelmeroElem[vm.selectedFelmeroElemIndex].num4;
                } else {
                    vm.num4 = vm.defnum4hhmmss;
                }
                if (vm.dataFelmeroElem[vm.selectedFelmeroElemIndex].num5) {
                    vm.num5 = vm.dataFelmeroElem[vm.selectedFelmeroElemIndex].num5;
                } else {
                    vm.num5 = vm.defnum5hhmmss;
                }
            } else if (args.data.Tipus == 5) {
                if (vm.dataFelmeroElem[vm.selectedFelmeroElemIndex].num1) {
                    vm.num1 = vm.dataFelmeroElem[vm.selectedFelmeroElemIndex].num1;
                } else {
                    vm.num1 = vm.defnum1mmss;
                }
                if (vm.dataFelmeroElem[vm.selectedFelmeroElemIndex].num2) {
                    vm.num2 = vm.dataFelmeroElem[vm.selectedFelmeroElemIndex].num2;
                } else {
                    vm.num2 = vm.defnum2mmss;
                }
                if (vm.dataFelmeroElem[vm.selectedFelmeroElemIndex].num3) {
                    vm.num3 = vm.dataFelmeroElem[vm.selectedFelmeroElemIndex].num3;
                } else {
                    vm.num3 = vm.defnum3mmss;
                }
                if (vm.dataFelmeroElem[vm.selectedFelmeroElemIndex].num4) {
                    vm.num4 = vm.dataFelmeroElem[vm.selectedFelmeroElemIndex].num4;
                } else {
                    vm.num4 = vm.defnum4mmss;
                }
                if (vm.dataFelmeroElem[vm.selectedFelmeroElemIndex].num5) {
                    vm.num5 = vm.dataFelmeroElem[vm.selectedFelmeroElemIndex].num5;
                } else {
                    vm.num5 = vm.defnum5mmss;
                }
            }
            if (vm.dataFelmeroElem[vm.selectedFelmeroElemIndex].color1) {
                vm.color1 = vm.dataFelmeroElem[vm.selectedFelmeroElemIndex].color1;
            } else {
                vm.color1 = '#ffffff';
            }
            if (vm.dataFelmeroElem[vm.selectedFelmeroElemIndex].color12) {
                vm.color12 = vm.dataFelmeroElem[vm.selectedFelmeroElemIndex].color12;
            } else {
                vm.color12 = '#ffffff';
            }
            if (vm.dataFelmeroElem[vm.selectedFelmeroElemIndex].color23) {
                vm.color23 = vm.dataFelmeroElem[vm.selectedFelmeroElemIndex].color23;
            } else {
                vm.color23 = '#ffffff';
            }
            if (vm.dataFelmeroElem[vm.selectedFelmeroElemIndex].color34) {
                vm.color34 = vm.dataFelmeroElem[vm.selectedFelmeroElemIndex].color34;
            } else {
                vm.color34 = '#ffffff';
            }
            if (vm.dataFelmeroElem[vm.selectedFelmeroElemIndex].color45) {
                vm.color45 = vm.dataFelmeroElem[vm.selectedFelmeroElemIndex].color45;
            } else {
                vm.color45 = '#ffffff';
            }
            if (vm.dataFelmeroElem[vm.selectedFelmeroElemIndex].color5) {
                vm.color5 = vm.dataFelmeroElem[vm.selectedFelmeroElemIndex].color5;
            } else {
                vm.color5 = '#ffffff';
            }
            vm.colordivenabled = (args.data.Tipus != 3);
            $scope.$apply();
        }

        function SaveFelmeroElemek() {
            GridFelmeroElem2.endEdit();
            GridFelmeroElem2.closeEdit();
            GridFelmeroElem2.editModule.endEdit();
            GridFelmeroElem2.editModule.batchSave();
            if (!vm.UJSPFELM) {
                log.permissionError();
                return;
            }
            vm.saveBeforeColorWarning = false;
            vm.colordivenabled = false;
            vm.dataFelmeroElem = GridFelmeroElem2.dataSource;
            if (vm.dataFelmeroElem.length == 0) {
                log.errorMsg(gettextCatalog.getString('TestMustNotBeEmpty'));
                return;
            }
            for (var i = 0; i < vm.dataFelmeroElem.length; i++) {
                vm.dataFelmeroElem[i].FelmeroElemFejId = vm.selectedFelmeroElemFej;
                switch (vm.dataFelmeroElem[i].TipusStr) {
                    case gettextCatalog.getString('NumberInteger'):
                        vm.dataFelmeroElem[i].Tipus = 1;
                        break;
                    case gettextCatalog.getString('NumberFraction'):
                        vm.dataFelmeroElem[i].Tipus = 2;
                        break;
                    case gettextCatalog.getString('Text'):
                        vm.dataFelmeroElem[i].Tipus = 3;
                        break;
                    case gettextCatalog.getString('TimeHourMinuteSecHundredthOfASec'):
                        vm.dataFelmeroElem[i].Tipus = 4;
                        break;
                    case gettextCatalog.getString('TimeMinuteSecHundredthOfASec'):
                        vm.dataFelmeroElem[i].Tipus = 5;
                        break;
                    case gettextCatalog.getString('TimeSecHundredthOfASec'):
                        vm.dataFelmeroElem[i].Tipus = 6;
                        break;
                    default:
                        log.errorMsg(gettextCatalog.getString('TypeIsIncorrect') + ' ' + gettextCatalog.getString('AtLine') + ': ' + vm.dataFelmeroElem[i].Nev);
                        return;
                }
                if (vm.dataFelmeroElem[i].Sorrend == undefined || vm.dataFelmeroElem[i].Sorrend == null) {
                    log.errorMsg(gettextCatalog.getString('OrderMustNotBeEmpty') + ' ' + gettextCatalog.getString('AtLine') + ': ' + vm.dataFelmeroElem[i].Nev);
                    return;
                }
                if (!(vm.dataFelmeroElem[i].Sorrend >= 0)) {
                    log.errorMsg(gettextCatalog.getString('OrderMustBeInteger') + ' ' + gettextCatalog.getString('AtLine') + ': ' + vm.dataFelmeroElem[i].Nev);
                    return;
                }
                if (!vm.dataFelmeroElem[i].Nev || (vm.dataFelmeroElem[i].Nev && (vm.dataFelmeroElem[i].Nev.length < 2 || vm.dataFelmeroElem[i].Nev.length > 50))) {
                    log.errorMsg(gettextCatalog.getString('TestNameMustBeBetween2and50Characters') + ' ' + gettextCatalog.getString('AtLine') + ': ' + vm.dataFelmeroElem[i].Nev);
                    return;
                }
                if (vm.dataFelmeroElem[i].ElvartEredmeny && vm.dataFelmeroElem[i].ElvartEredmeny.length > 50) {
                    log.errorMsg(gettextCatalog.getString('ExpectedResultMustBeAtMost50Characters') + ' ' + gettextCatalog.getString('AtLine') + ': ' + vm.dataFelmeroElem[i].Nev);
                    return;
                }
                for (var j = 0; j < vm.dataFelmeroElem.length; j++) {
                    if (i != j && vm.dataFelmeroElem[i].Sorrend == vm.dataFelmeroElem[j].Sorrend) {
                        log.errorMsg(gettextCatalog.getString('DuplicatesInOrder') + ' ' + gettextCatalog.getString('AtLine') + ': ' + vm.dataFelmeroElem[i].Nev + ', ' + vm.dataFelmeroElem[j].Nev);
                        return;
                    }
                    if (i != j && vm.dataFelmeroElem[i].Nev == vm.dataFelmeroElem[j].Nev) {
                        log.errorMsg(gettextCatalog.getString('DuplicatesNames') + ' ' + gettextCatalog.getString('AtLine') + ': ' + vm.dataFelmeroElem[i].Nev);
                        return;
                    }
                }
            }
            console.log('vm.dataFelmeroElem', vm.dataFelmeroElem);
            dataservice.saveFelmeroElem(vm.dataFelmeroElem).then(function () {
                vm.felmeroTipusKijelolve = false;
                enableFelmeroTipusGrid(true);
                LoadFelmeroElemek(vm.selectedFelmeroElemFej);
                log.successMsg('SaveCompleted');
            });
        }

        function LoadFelmeroElemek(FEF_ID) {
            if (!FEF_ID) {
                return;
            }
            dataservice.getFelmeroElemList(FEF_ID).then(function (arg) {
                vm.dataFelmeroElem = arg.itemsList;
                for (var i = 0; i < vm.dataFelmeroElem.length; i++) {
                    switch (vm.dataFelmeroElem[i].Tipus) {
                        case 1:
                            vm.dataFelmeroElem[i].TipusStr = gettextCatalog.getString('NumberInteger');
                            break;
                        case 2:
                            vm.dataFelmeroElem[i].TipusStr = gettextCatalog.getString('NumberFraction');
                            break;
                        case 3:
                            vm.dataFelmeroElem[i].TipusStr = gettextCatalog.getString('Text');
                            break;
                        case 4:
                            vm.dataFelmeroElem[i].TipusStr = gettextCatalog.getString('TimeHourMinuteSecHundredthOfASec');
                            break;
                        case 5:
                            vm.dataFelmeroElem[i].TipusStr = gettextCatalog.getString('TimeMinuteSecHundredthOfASec');
                            break;
                        case 6:
                            vm.dataFelmeroElem[i].TipusStr = gettextCatalog.getString('TimeSecHundredthOfASec');
                            break;
                        default:
                            vm.dataFelmeroElem[i].TipusStr = 'x';
                    }
                }
                GridFelmeroElem2.dataSource = vm.dataFelmeroElem;
                if (!vm.UJSPFELM) {
                    GridFelmeroElem2.editSettings = {
                        allowEditing: false, allowAdding: false, allowDeleting: false
                    };
                }
                $timeout(function () {
                    GridFelmeroElem2.refresh();
                }, 100);
            });
        }

        function getMaxSorrend() {
            var maxSorrend = -1;
            for (var i = 0; i < vm.dataFelmeroElem.length; i++) {
                if (vm.dataFelmeroElem[i].Sorrend > maxSorrend) {
                    maxSorrend = vm.dataFelmeroElem[i].Sorrend;
                }
            }
            return maxSorrend;
        }

        function enableFelmeroTipusGrid(arg) {
            angular.element('#section').ejDropDownList({
                enabled: arg
            });
            var activateButton = angular.element('#activateFelmeroElemFej').data('ejButton');
            var inactivateButton = angular.element('#inactivateFelmeroElemFej').data('ejButton');
            GridFelmeroTipus2.editSettings.allowEditing = arg;
            GridFelmeroTipus2.allowSelection = arg;

            $timeout(function () {
                if (arg) {
                    GridFelmeroTipus2.selectRow(vm.selectedFEFRowIndex);

                    if (activateButton) {
                        activateButton.enable();
                    }
                    if (inactivateButton) {
                        inactivateButton.enable();
                    }
                } else {
                    //GridFelmeroTipus2.selectionSettings = {type: 'none', mode: 'none'};
                    if (activateButton && !vm.selectedFelmeroIsActive && vm.felmeroTipusKijelolve) {
                        activateButton.disable();
                    }
                    if (inactivateButton && vm.selectedFelmeroIsActive && vm.felmeroTipusKijelolve) {
                        inactivateButton.disable();
                    }
                }
                vm.copyButtonEnabled = arg && vm.felmeroTipusKijelolve;
                vm.deleteButtonEnabled = arg && vm.FEEditEnable;
                angular.element('#saveFelmeroElem').ejButton({enabled: !arg});
                angular.element('#discardFelmeroElem').ejButton({enabled: !arg});
                angular.element('#newFelmeroElemFej').ejButton({enabled: arg});
                //vm.colordivenabled = !arg;
            }, 100);
        }

        function getSections() {
            dataservice.sectionDropDownList(0, true).then(function (data) {
                vm.sectionList = data.itemsList;
            });
        }

        function sectionSelect(arg) {
            vm.felmeroTipusKijelolve = false;
            vm.selectedFelmeroElemFej = undefined;
            LoadFelmeroTipusok(arg.value);
        }

        function sectionDataBound() {
            if (vm.sectionList.length === 1) {
                angular.element('#section').ejDropDownList('selectItemByValue', vm.sectionList[0].value);
                vm.selectedSection = vm.sectionList[0].value;
            } else {
                angular.element('#section').ejDropDownList('selectItemByValue', vm.selectedSection);
            }
        }

        function sectionSwalDatabound() {
            if (vm.sectionList.length === 1) {
                angular.element('#sectionDropDownSwal').ejDropDownList('selectItemByValue', vm.sectionList[0].value);
            } else {
                angular.element('#sectionDropDownSwal').ejDropDownList('selectItemByValue', vm.athleteDataSwalSzakosztaly);
            }
        }

        function selectSectionDropDownSwal(arg) {
            vm.athleteDataSwalSzakosztaly = arg.value;
            vm.coachListSwal = [];
            angular.element('#secondSectionDropDownSwalDiv').addClass('ng-hide');
        }

        function applyColor() {
            $timeout(function () {
                if (vm.selectedFelmeroElemIndex >= 0) {
                    vm.dataFelmeroElem[vm.selectedFelmeroElemIndex].num1 = vm.num1;
                    vm.dataFelmeroElem[vm.selectedFelmeroElemIndex].num2 = vm.num2;
                    vm.dataFelmeroElem[vm.selectedFelmeroElemIndex].num3 = vm.num3;
                    vm.dataFelmeroElem[vm.selectedFelmeroElemIndex].num4 = vm.num4;
                    vm.dataFelmeroElem[vm.selectedFelmeroElemIndex].num5 = vm.num5;
                    vm.dataFelmeroElem[vm.selectedFelmeroElemIndex].color1 = vm.color1;
                    vm.dataFelmeroElem[vm.selectedFelmeroElemIndex].color12 = vm.color12;
                    vm.dataFelmeroElem[vm.selectedFelmeroElemIndex].color23 = vm.color23;
                    vm.dataFelmeroElem[vm.selectedFelmeroElemIndex].color34 = vm.color34;
                    vm.dataFelmeroElem[vm.selectedFelmeroElemIndex].color45 = vm.color45;
                    vm.dataFelmeroElem[vm.selectedFelmeroElemIndex].color5 = vm.color5;
                } else {
                    swal({
                        title: gettextCatalog.getString('PleaseSelectFelmeroElem'),
                        type: 'info',
                        confirmButtonColor: '#DD6B55',
                        confirmButtonText: gettextCatalog.getString('Ok')
                    });
                }
            }, 100);
        }

        function setDefaultColors() {
            vm.dataFelmeroElem[vm.selectedFelmeroElemIndex].color1 = vm.defcolor1;
            vm.dataFelmeroElem[vm.selectedFelmeroElemIndex].color12 = vm.defcolor12;
            vm.dataFelmeroElem[vm.selectedFelmeroElemIndex].color23 = vm.defcolor23;
            vm.dataFelmeroElem[vm.selectedFelmeroElemIndex].color34 = vm.defcolor34;
            vm.dataFelmeroElem[vm.selectedFelmeroElemIndex].color45 = vm.defcolor45;
            vm.dataFelmeroElem[vm.selectedFelmeroElemIndex].color5 = vm.defcolor5;
            vm.color1 = vm.defcolor1;
            vm.color12 = vm.defcolor12;
            vm.color23 = vm.defcolor23;
            vm.color34 = vm.defcolor34;
            vm.color45 = vm.defcolor45;
            vm.color5 = vm.defcolor5;
            $scope.$apply();
        }

        function clearColors() {
            vm.dataFelmeroElem[vm.selectedFelmeroElemIndex].color1 = '#ffffff';
            vm.dataFelmeroElem[vm.selectedFelmeroElemIndex].color12 = '#ffffff';
            vm.dataFelmeroElem[vm.selectedFelmeroElemIndex].color23 = '#ffffff';
            vm.dataFelmeroElem[vm.selectedFelmeroElemIndex].color34 = '#ffffff';
            vm.dataFelmeroElem[vm.selectedFelmeroElemIndex].color45 = '#ffffff';
            vm.dataFelmeroElem[vm.selectedFelmeroElemIndex].color5 = '#ffffff';
            vm.color1 = '#ffffff';
            vm.color12 = '#ffffff';
            vm.color23 = '#ffffff';
            vm.color34 = '#ffffff';
            vm.color45 = '#ffffff';
            vm.color5 = '#ffffff';
            $scope.$apply();
        }

        function getFelmeroElemIndex(felmeroElemId) {
            for (var i = 0; i < vm.dataFelmeroElem.length; i++) {
                if (vm.dataFelmeroElem[i].Id_FE == felmeroElemId) {
                    return i;
                }
            }
            return -1;
        }

        function getFelmeroElemFejIndex(felmeroElemFejId) {
            for (var i = 0; i < vm.dataFelmeroElemFej.length; i++) {
                if (vm.dataFelmeroElemFej[i].Id_FEF == felmeroElemFejId) {
                    return i;
                }
            }
            return -1;
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.settings.createSportSpecificTest')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'settings.createSportSpecificTest',
                config: {
                    url: '/createSportSpecificTest',
                    templateUrl: 'app/settings/createSportSpecificTest/createSportSpecificTest.html',
                    controller: 'CreateSportSpecificTestController',
                    controllerAs: 'vm',
                    title: 'CreateSportSpecificTest',
                    settings: {
                        navId: 275,
                        level: 2,
                        order: 7,
                        orderTitle_hu: 'Sportágspecifikus felmérőtípusok',
                        orderTitle_en: 'Sport Specific Test',
                        parentId: 5,
                        content: 'CreateSportSpecificTest',
                        activatorPermission: '"MEGTSPFELM"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    EditHealthTypeController.$inject = ["$q", "paramHelper", "gettextCatalog", "$state", "dataservice", "logger", "authenticationService", "$rootScope", "$scope", "log", "$timeout"];
    angular
        .module('app.settings.editHealthType')
        .controller('EditHealthTypeController', EditHealthTypeController);

    function EditHealthTypeController($q, paramHelper, gettextCatalog, $state, dataservice, logger, authenticationService, $rootScope, $scope, log, $timeout) {
        var vm = this;
        $rootScope.vm = vm;

        // Page title
        $rootScope.title = gettextCatalog.getString('EditHealthType');

        vm.mainTypeColumns = [
            {field: 'Link', type: 'checkbox', textAlign: 'center', width: 100},
            {field: 'Id', visible: false, isPrimaryKey: true},
            {
                field: 'Nev',
                headerText: gettextCatalog.getString('Name'),
                textAlign: 'left',
                validationRules: {required: true},
                validationMessage: {required: gettextCatalog.getString('HealthEventType')}
            }
        ];

        var mainTypeGrid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItems,
            allowPaging: true,
            allowSorting: true,
            allowExcelExport: true,
            allowTextWrap: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            height: (window.innerHeight - 550),
            pageSettings: $rootScope.pageSettings.pageSize,
            columns: vm.mainTypeColumns,
            beforePrint: function (args) {
                $rootScope.beforePrintGrid(args, ['Link']);
            },
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile(mainTypeGrid, $scope);
                }
            },
            rowSelecting: function (args) {
                if (!args.data) {
                    return;
                }
                mainTypeGrid.clearSelection();
                vm.selectedMainTypeRow = args.data;
                vm.editDeleteMainTypeEnabled = vm.EGESZSMOD;
                vm.addNewSubType = vm.EGESZSMOD;
                vm.editDeleteSubTypeEnabled = false;
                SearchSubTypeBySelectedRow(args.data.Id);
                $timeout(function () {
                    $scope.$apply();
                }, 0);
            },
            rowDeselected: function () {
                var rowSelect = $rootScope.gridSelectedRowIndex(mainTypeGrid);
                if (rowSelect.length === 0) {
                    vm.editDeleteMainTypeEnabled = false;
                    vm.addNewSubType = false;
                    subTypeGrid.dataSource = [];
                    $timeout(function () {
                        $scope.$apply();
                    }, 0);
                }
            },
            checkBoxChange: function (args) {
                $rootScope.checkBoxChangeOnlyOne(args, mainTypeGrid);
            }
        });
        mainTypeGrid.appendTo('#MainTypeGrid');
        mainTypeGrid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, mainTypeGrid);
        };

        vm.subTypeColumns = [
            {field: 'Link', type: 'checkbox', textAlign: 'center', width: 100},
            {field: 'Id', visible: false, isPrimaryKey: true},
            {
                field: 'AltipusNev',
                headerText: gettextCatalog.getString('Name'),
                textAlign: 'left',
                validationRules: {required: true},
                validationMessage: {required: gettextCatalog.getString('HealthEventType')}
            }
        ];

        var subTypeGrid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItems,
            allowPaging: true,
            allowSorting: true,
            allowExcelExport: true,
            allowTextWrap: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            height: (window.innerHeight - 550),
            pageSettings: $rootScope.pageSettings.pageSize,
            columns: vm.subTypeColumns,
            selectionSettings: {type: 'multiple', mode: 'Both'},
            beforePrint: $rootScope.beforePrintGrid,
            printComplete: $rootScope.printCompleteGrid,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile(subTypeGrid, $scope);
                }
            },
            rowSelecting: function (args) {
                subTypeGrid.clearSelection();
                vm.selectedSubTypeRow = args.data;
                vm.editDeleteSubTypeEnabled = vm.EGESZSMOD;
                $timeout(function () {
                    $scope.$apply();
                }, 0);
            },
            rowDeselected: function () {
                var rowSelect = $rootScope.gridSelectedRowIndex(subTypeGrid);
                if (rowSelect.length === 0) {
                    vm.editDeleteSubTypeEnabled = false;
                    $timeout(function () {
                        $scope.$apply();
                    }, 0);
                }
            },
            checkBoxChange: function (args) {
                $rootScope.checkBoxChangeOnlyOne(args, subTypeGrid);
            }
        });
        subTypeGrid.appendTo('#SubTypeGrid');
        subTypeGrid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, subTypeGrid);
        };

        vm.editDeleteMainTypeEnabled = false;
        vm.editDeleteSubTypeEnabled = false;
        vm.addNewSubType = false;
        vm.AddSubType = AddSubType;
        vm.AddMainType = AddMainType;
        vm.DeleteMainType = DeleteMainType;
        vm.DeleteSubType = DeleteSubType;
        vm.EditMainType = EditMainType;
        vm.EditSubType = EditSubType;
        vm.SearchSubTypeBySelectedRow = SearchSubTypeBySelectedRow;

        vm.EGESZSMOD = false;

        activate();

        function activate() {
            $q.all([authenticationService.getRight('EGESZSMEGT'), authenticationService.getRight('EGESZSMOD')]).then(function (data) {
                $timeout(function () {
                    if (!data[0]) {
                        log.permissionError(true);
                    }
                    vm.EGESZSMOD = data[1];
                }, 10);
                if (data[0] || data[1] || data[2]) {
                    getMainType();
                } else {
                    log.permissionError(true);
                }
            });
        }

        function getMainType() {
            vm.editDeleteMainTypeEnabled = false;
            vm.addNewSubType = false;
            dataservice.healthMainTypesList().then(function (data) {
                mainTypeGrid.dataSource = data.itemsList;
            });
        }

        function SearchSubTypeBySelectedRow(arg) {
            dataservice.healthSubTypesList().then(function (data) {
                var subTypes = data.itemsList;
                subTypeGrid.dataSource = [];
                for (var i = 0; i < subTypes.length; i++) {
                    if (subTypes[i].FotipusId === arg) {
                        subTypeGrid.dataSource.push(subTypes[i]);
                    }
                }
            });
        }

        function AddMainType() {
            swal({
                title: gettextCatalog.getString('CreateNewMainTypeTemplate'),
                type: 'info',
                input: 'text',
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                allowOutsideClick: false,
                allowEscapeKey: false,
                confirmButtonText: gettextCatalog.getString('Ok'),
                cancelButtonText: gettextCatalog.getString('Cancel'),
            }).then(function (inputValue) {
                if (inputValue.dismiss === 'cancel' || inputValue.dismiss === 'esc') {
                    return;
                }
                if (!inputValue || !inputValue.value || inputValue.value.length < 1) {
                    log.errorMsg(gettextCatalog.getString('AddMainTypeNameEmpty'));
                } else {
                    dataservice.HealthMainTypeManager({Id: -1, Nev: inputValue.value}).then(function (response) {
                        if (response.statusText = 'OK') {
                            log.successMsg(gettextCatalog.getString('saveSuccess'));
                            getMainType();
                        }
                    });
                }
            });
        }

        function EditMainType() {
            swal({
                title: gettextCatalog.getString('EditNewMainTypeTemplate'),
                type: 'info',
                input: 'text',
                inputValue: vm.selectedMainTypeRow.Nev,
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: gettextCatalog.getString('Ok'),
                cancelButtonText: gettextCatalog.getString('Cancel'),
            }).then(function (inputValue) {
                if (!inputValue || !inputValue.value || inputValue.value.length < 1 || inputValue.dismiss === 'cancel' || inputValue.dismiss === 'esc') {
                    log.errorMsg(gettextCatalog.getString('AddMainTypeNameEmpty'));
                } else {
                    dataservice.HealthMainTypeManager({
                        Id: vm.selectedMainTypeRow.Id,
                        Nev: inputValue.value
                    }).then(function (response) {
                        if (response.statusText = 'OK') {
                            log.successMsg(gettextCatalog.getString('saveSuccess'));
                        }
                        getMainType();
                    });
                }
            });
        }

        function DeleteMainType() {
            var warningText = '';
            if (subTypeGrid.dataSource.length > 0) {
                warningText = gettextCatalog.getString('This will delete all subType too.');
            }
            swal({
                title: gettextCatalog.getString('Are you sure you want to delete the selected mainType?'),
                type: 'warning',
                html: '<b style="color: red;">' + warningText + '</b>',
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: gettextCatalog.getString('Yes, delete this mainType'),
                cancelButtonText: gettextCatalog.getString('Cancel'),
                closeOnConfirm: false,
                closeOnCancel: false
            }).then(function (isConfirm) {
                if (isConfirm.value) {
                    dataservice.deleteHealthMainType({mainTypeId: vm.selectedMainTypeRow.Id}).then(function () {
                        vm.addNewSubType = false;
                        vm.editDeleteSubTypeEnabled = false;
                        getMainType()();
                    });
                }
            });
        }

        function AddSubType() {
            swal({
                title: gettextCatalog.getString('CreateNeSubTypeTemplate'),
                type: 'info',
                input: 'text',
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: gettextCatalog.getString('Ok'),
                cancelButtonText: gettextCatalog.getString('Cancel'),
            }).then(function (inputValue) {
                if (!inputValue || inputValue.value.length < 1 || inputValue.dismiss === 'cancel' || inputValue.dismiss === 'esc') {
                    log.errorMsg(gettextCatalog.getString('AddSubTypeNameEmpty'));
                } else {
                    dataservice.HealthSubTypeManager({
                        Id: -1,
                        AltipusNev: inputValue.value,
                        FotipusId: vm.selectedMainTypeRow.Id
                    }).then(function () {
                        log.successMsg(gettextCatalog.getString('saveSuccess'));
                        vm.editDeleteSubTypeEnabled = false;
                        SearchSubTypeBySelectedRow(vm.selectedMainTypeRow.Id);
                    });
                }
            });
        }

        function EditSubType() {
            swal({
                title: gettextCatalog.getString('EditSubTypeTemplate'),
                type: 'info',
                input: 'text',
                inputValue: vm.selectedSubTypeRow.AltipusNev,
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: gettextCatalog.getString('Ok'),
                cancelButtonText: gettextCatalog.getString('Cancel'),
            }).then(function (inputValue) {
                if (!inputValue || !inputValue.value || inputValue.value.length < 1 || inputValue.dismiss === 'cancel' || inputValue.dismiss === 'esc') {
                    log.errorMsg(gettextCatalog.getString('AddSubTypeNameEmpty'));
                } else {
                    dataservice.HealthSubTypeManager({
                        Id: vm.selectedSubTypeRow.Id,
                        FotipusId: vm.selectedMainTypeRow.Id,
                        AltipusNev: inputValue.value
                    }).then(function () {
                        log.successMsg(gettextCatalog.getString('saveSuccess'));
                        vm.editDeleteSubTypeEnabled = false;
                        SearchSubTypeBySelectedRow(vm.selectedMainTypeRow.Id);
                    });
                }
            });
        }

        function DeleteSubType() {
            swal({
                title: gettextCatalog.getString('Are you sure you want to delete the selected subType?'),
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: gettextCatalog.getString('Yes, delete this subType'),
                cancelButtonText: gettextCatalog.getString('Cancel'),
                closeOnConfirm: false,
                closeOnCancel: false
            }).then(function (isConfirm) {
                if (isConfirm.value) {
                    dataservice.deleteHealthSubType({subTypeId: vm.selectedSubTypeRow.Id}).then(function () {
                        vm.editDeleteSubTypeEnabled = false;
                        SearchSubTypeBySelectedRow(vm.selectedMainTypeRow.Id);
                    });
                }
            });
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.settings.editHealthType')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'settings.editHealthType',
                config: {
                    url: '/editHealthType',
                    templateUrl: 'app/settings/editHealthType/editHealthType.html',
                    controller: 'EditHealthTypeController',
                    controllerAs: 'vm',
                    title: 'EditHealthType',
                    settings: {
                        navId: 295,
                        level: 2,
                        order: 9,
                        orderTitle_hu: 'Egészségügyi bejegyzés típusok kezelése',
                        orderTitle_en: 'Health Entry Type Management',
                        parentId: 5,
                        content: 'EditHealthType',
                        activatorPermission: '"EGESZSMEGT"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    EditSectionController.$inject = ["log", "$q", "paramHelper", "dataservice", "$rootScope", "gettextCatalog", "authenticationService", "$state", "$scope", "$timeout"];
    angular
        .module('app.settings.editSection')
        .controller('EditSectionController', EditSectionController);

    function EditSectionController(log, $q, paramHelper, dataservice, $rootScope, gettextCatalog, authenticationService, $state, $scope, $timeout) {
        var vm = this;
        $rootScope.vm = vm;

        $rootScope.title = '';
        vm.sectionLeaders = [];
        vm.sectionLeaders2 = [];
        vm.editSectionId = 0;
        vm.leader1DataBound = leader1DataBound;
        vm.leader2DataBound = leader2DataBound;
        vm.save = save;

        vm.section = {
            Aktiv: true,
            Csapat: false,
            Egyeni: false,
            Editable: true,
            SzakosztalyID: -1,
            SzakosztalyNeve: '',
            SzakosztalyVezeto1: '',
            SzakosztalyVezeto2: '',
            SzakosztalyVezetoId1: null,
            SzakosztalyVezetoId2: null,
            Szin: '#FFFFFF',
            SzovegSzin: '#000000',
            RuhaPapucs: false,
            RuhaCipo: false,
            RuhaMelegito: false,
            RuhaFurdokopeny: false,
            RuhaKabat: false,
            RuhaPancelnadrag: false,
            RuhaPolo: false,
            RuhaSort: false,
            RuhaUszonadrag: false
        };

        activate();

        function activate() {
            var promises = [
                paramHelper.getParams([], ['editSection.SectionId']),
                authenticationService.getRight('SZAKOSZTALY'),
                authenticationService.getRight('SZAKOSZTVEZ'),
                authenticationService.getRight('ADMIN'),
                getSectionLeaders()
            ];
            $q.all(promises).then(function (results) {
                if (results[1] !== true || (results[2] !== true && results[3] !== true)) {
                    console.log('permissionError');
                    log.permissionError(true);
                    return;
                }
                vm.editSectionLeader = results[2] || results[3];
                vm.editSectionId = results[0]['editSection.SectionId'];
                if (vm.editSectionId > 0) {
                    $rootScope.title = gettextCatalog.getString('EditSection');
                    getSectionData(vm.editSectionId);
                } else {
                    $rootScope.title = gettextCatalog.getString('AddSection');
                }
            });
        }

        function leader1DataBound() {
            if (vm.section.SzakosztalyVezetoId1 > 0) {
                angular.element('#leader1DropDown').ejDropDownList('selectItemByValue', vm.section.SzakosztalyVezetoId1);
            } else {
                angular.element('#leader1DropDown').ejDropDownList('selectItemByValue', vm.sectionLeaders[0].value);
            }
        }

        function leader2DataBound() {
            if (vm.section.SzakosztalyVezetoId2 > 0) {
                angular.element('#leader2DropDown').ejDropDownList('selectItemByValue', vm.section.SzakosztalyVezetoId2);
            } else {
                angular.element('#leader2DropDown').ejDropDownList('selectItemByValue', vm.sectionLeaders2[0].value);
            }
        }

        function getSectionLeaders() {
            dataservice.getSectionLeaders().then(function (response) {
                vm.sectionLeaders = response.itemsList;
                vm.sectionLeaders2 = [];
                vm.sectionLeaders2.push({value: -1, text: gettextCatalog.getString('None')});
                vm.sectionLeaders.forEach(function (section) {
                    vm.sectionLeaders2.push(section);
                });
            });
        }

        function getSectionData(id) {
            dataservice.getSectionData(id).then(function (response) {
                vm.section = response.itemsList[0];
                $timeout(function () {
                    if (!(vm.section.SzakosztalyVezetoId2 > 0)) {
                        angular.element('#leader2DropDown').ejDropDownList('selectItemByValue', -1);
                    }
                }, 333);
            });
        }

        function save() {
            $scope.$broadcast('submitted');
            if ($scope.form.$valid === false) {
                log.errorMsg(gettextCatalog.getString('RequiredFieldsError'));
                return;
            }
            if (!(vm.section.Egyeni || vm.section.Csapat)) {
                log.htmlError(gettextCatalog.getString('PleaseSelectIndividualOrTeamSport'));
                return;
            }
            if (!vm.section.SzakosztalyNeve || vm.section.SzakosztalyNeve.trim().length < 4) {
                log.errorMsg(gettextCatalog.getString('MinimumLength4Character'), gettextCatalog.getString('PleaseTypeSectionName'));
                return;
            }
            dataservice.editSection(vm.section).then(function (result) {
                if (result.data.Error && result.data.Error.length > 0) {
                    if (result.data.Error != null) {
                        log.htmlError(result.data.Error.toString());
                        return;
                    }
                }
                log.successMsg(gettextCatalog.getString('SaveSuccessed'));
                $state.go('athletes.sections');
            });
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.settings.editSection')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'settings.editSection',
                config: {
                    url: '/editSection',
                    templateUrl: 'app/settings/editSection/editSection.html',
                    controller: 'EditSectionController',
                    controllerAs: 'vm',
                    title: 'EditSection'
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    AddSchoolController.$inject = ["log", "$state", "dataservice", "authenticationService", "gettextCatalog", "$rootScope", "$scope"];
    angular
        .module('app.settings.schoolManagement.addSchool')
        .controller('AddSchoolController', AddSchoolController);

    function AddSchoolController(log, $state, dataservice, authenticationService, gettextCatalog, $rootScope, $scope) {
        var vm = this; $rootScope.vm = vm;
        vm.params = [];
        vm.newSchool = {};
        vm.saveSchool = saveSchool;

        // Page title
        $rootScope.title = gettextCatalog.getString('AddSchool');

        activate();

        function activate() {
            authenticationService.getRight('UJISKOLA').then(function (results) {
                if (results !== true) {
                    log.permissionError();
                }
            });
        }

        function saveSchool() {
            vm.newSchool.Id = -1;
            $scope.$broadcast('submitted');
            if ($scope.form.$valid === false) {
                log.errorMsg(gettextCatalog.getString('RequiredFieldsError'));
                return;
            }
            return dataservice.addSchool(vm.newSchool).then(function () {
                    log.successMsg(gettextCatalog.getString('SchoolSaved'));
                    $state.go('settings.schoolManagement.schoolList');
                });
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.settings.schoolManagement.addSchool')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'settings.schoolManagement.addSchool',
                config: {
                    url: '/addSchool',
                    templateUrl: 'app/settings/schoolManagement/addSchool/addSchool.html',
                    controller: 'AddSchoolController',
                    controllerAs: 'vm',
                    title: 'AddSchool',
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    editSchoolController.$inject = ["log", "$state", "dataservice", "authenticationService", "$q", "gettextCatalog", "$rootScope", "paramHelper", "$scope"];
    angular
        .module('app.settings.schoolManagement.editSchool')
        .controller('editSchoolController', editSchoolController);

    function editSchoolController(log, $state, dataservice, authenticationService, $q, gettextCatalog, $rootScope, paramHelper, $scope) {
        var vm = this; $rootScope.vm = vm;
        vm.params = [];
        vm.ModifySchool = ModifySchool;

        // Page title
        $rootScope.title = gettextCatalog.getString('editSchool');

        activate();

        function activate() {
            authenticationService.getRight('UJISKOLA').then(function (results) {
                if (results !== true) {
                    log.permissionError();
                } else {
                    $q.all([paramHelper.getParams([], ['schoolManagement.editSchool'])]).then(function (results) {
                        vm.params = results[0]['schoolManagement.editSchool'];
                    });
                }
            });
        }

        function ModifySchool() {
            $scope.$broadcast('submitted');
            if ($scope.form.$valid === false) {
                log.errorMsg(gettextCatalog.getString('RequiredFieldsError'));
                return;
            }
            return dataservice.editSchool(vm.params).then(function () {
                log.successMsg(gettextCatalog.getString('SchoolModified'));
                $state.go('settings.schoolManagement.schoolList');
            });
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.settings.schoolManagement.editSchool')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'settings.schoolManagement.editSchool',
                config: {
                    url: '/editSchool',
                    templateUrl: 'app/settings/schoolManagement/editSchool/editSchool.html',
                    controller: 'editSchoolController',
                    controllerAs: 'vm',
                    title: 'editSchool',
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    SchoolListController.$inject = ["dataservice", "logger", "authenticationService", "gettextCatalog", "$rootScope", "$q", "$state", "paramHelper", "$scope", "$timeout", "log"];
    angular
        .module('app.settings.schoolManagement.schoolList')
        .controller('SchoolListController', SchoolListController);

    function SchoolListController(dataservice, logger, authenticationService, gettextCatalog, $rootScope, $q, $state, paramHelper, $scope, $timeout, log) {
        var vm = this; $rootScope.vm = vm;

        // Page title
        $rootScope.title = gettextCatalog.getString('SchoolManagement');

        vm.selectedSchoolObject = '';
        vm.data = [];
        vm.editedRow = {};
        vm.editSchoolButtonEnabled = false;

        // Grid's details
        vm.columns = [
            {field: 'Id', visible: false, isPrimaryKey: true},
            {
                field: 'IskolaNeve',
                headerText: gettextCatalog.getString('SchoolsName'),
                textAlign: 'left',
                validationRules: {required: true},
                validationMessage: {required: gettextCatalog.getString('SchoolsNameIsRequired')}
            },
            {field: 'IskolaIrSzam', headerText: 'Ir.szám', textAlign: 'left'},
            {
                field: 'IskolaVaros',
                headerText: gettextCatalog.getString('City'),
                textAlign: 'left',
                validationRules: {required: true},
                validationMessage: {required: gettextCatalog.getString('SchoolsCityIsRequired')}
            },
            {field: 'IskolaUtca', headerText: gettextCatalog.getString('Street'), textAlign: 'left'},
            {field: 'IskolaHazszam', headerText: gettextCatalog.getString('StreetNumber'), textAlign: 'left'},
            {field: 'IskolaIgazgatoNeve', headerText: gettextCatalog.getString('Director'), textAlign: 'left'}];

        // Public functions
        vm.selectedRow = selectedRow;
        vm.EndAdd = EndAdd;
        vm.EndEdit = EndEdit;
        vm.BeginEdit = BeginEdit;
        vm.EndDelete = EndDelete;
        vm.goToAddSchool = goToAddSchool;
        vm.goToEditSchool = goToEditSchool;
        vm.DeleteSchool = DeleteSchool;

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItemsWithSearch,
            allowPaging: true,
            allowTextWrap: true,
            allowSorting: true,
            allowExcelExport: true,
            allowDeleting: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            rowSelected: vm.selectedRow,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile(angular.element('#Grid'), $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        activate();

        function activate() {
            $q.all([authenticationService.getRight('UJISKOLA')])
                .then(function (results) {
                    if (results[0] !== true) {
                        log.permissionError(true);
                    } else {
                        dataservice.selectSchools()
                            .then(function (data) {
                                vm.data = data.itemsList;
                                grid.dataSource = vm.data;
                            });
                    }
                });
        }

        function goToAddSchool() {
            authenticationService.getRight('UJISKOLA').then(function (results) {
                if (results !== true) {
                    log.permissionError();
                } else {
                    $state.go('settings.schoolManagement.addSchool');
                }
            });
        }

        function goToEditSchool() {
            authenticationService.getRight('UJISKOLA').then(function (results) {
                if (results !== true) {
                    log.permissionError();
                } else {
                    paramHelper.setParams([{'schoolManagement.editSchool': vm.selectedSchoolObject.data}]);
                    $state.go('settings.schoolManagement.editSchool');
                }
            });
        }

        function DeleteSchool() {
            authenticationService.getRight('UJISKOLA').then(function (results) {
                if (results !== true) {
                    log.permissionError();
                } else {
                    swal({title: gettextCatalog.getString('Are you sure you want to delete the selected school?'),
                        text: gettextCatalog.getString('You will not be able to recover this school!'),
                        type: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#DD6B55',
                        confirmButtonText: gettextCatalog.getString('Yes, delete this school'),
                        cancelButtonText: gettextCatalog.getString('Cancel'),
                        closeOnConfirm: false,
                        closeOnCancel: false
                    }).then(function(isConfirm) {
                        if (isConfirm.value) {
                            return dataservice.deleteSchool(vm.selectedSchoolObject.data.Id).then(function () {
                                log.successMsg(gettextCatalog.getString('SchoolDeleted'));
                                log.htmlSuccess(gettextCatalog.getString('Deleted!'), vm.selectedSchoolObject.data.IskolaNeve + ' ' + gettextCatalog.getString('has been deleted!'));
                                activate();
                            });
                        }
                    });
                }
            });
        }

        function selectedRow(args) {
            vm.selectedSchoolObject = args;
            vm.editSchoolButtonEnabled = args != null;
            $scope.$apply();
        }

        function EndAdd(args) {
            args.data.Id = -1;
            return dataservice.addSchool(args.data).then(function () {
                log.successMsg(gettextCatalog.getString('SchoolSaved'));
            })
                .catch(function () {
                    log.errorMsg(gettextCatalog.getString('UnexpectedError'));
                });
        }

        function BeginEdit(args) {
            vm.editedRow = args.model.currentViewData[args.model.selectedRowIndex];
        }

        function EndEdit(args) {
            return dataservice.editSchool(args.data).then(function () {
                log.successMsg(gettextCatalog.getString('SchoolModified'));
            });
        }

        function EndDelete(args) {
            return dataservice.deleteSchool(args.data.Id).then(function () {
                log.successMsg(gettextCatalog.getString('SchoolDeleted'));
            })
                .catch(function () {
                    log.errorMsg(gettextCatalog.getString('UnexpectedError'));
                });
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.settings.schoolManagement.schoolList')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'settings.schoolManagement.schoolList',
                config: {
                    url: '/schoolList',
                    templateUrl: 'app/settings/schoolManagement/schoolList/schoolList.html',
                    controller: 'SchoolListController',
                    controllerAs: 'vm',
                    title: 'SchoolManagement',
                    settings: {
                        navId: 285,
                        level: 2,
                        order: 8,
                        orderTitle_hu: 'Iskolai adminisztáció',
                        orderTitle_en: 'School Administration',
                        parentId: 5,
                        content: 'SchoolManagement',
                        activatorPermission: '"UJISKOLA"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.settings.schoolManagement')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'settings.schoolManagement',
                config: {
                    url: '/schoolManagement',
                    templateUrl: 'app/settings/schoolManagement/schoolManagement.html',
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.settings')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'settings',
                config: {
                    url: '/settings',
                    templateUrl: 'app/settings/settings.html',
                    title: 'Settings',
                    settings: {
                        navId: 5,
                        level: 1,
                        order: 5,
                        parentId: 0,
                        content: 'Settings',
                        activatorPermission: ['"MEGTEDZVALT"', '"MEGTEDZVALT"', '"MEGTSPFELM"', '"EGESZSMEGT"', '"EditSection"', '"AddSchool"', '"editSchool"', '"UJISKOLA"',
                                              '"BEALLITAS"', '"MEGTFELHCSOP"', '"MEGTFELH"', '"MEGTFELHJOG"', '"SPTARTMEGT"']
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    SystemSettingsController.$inject = ["log", "dataservice", "$q", "$rootScope", "gettextCatalog", "authenticationService", "$timeout"];
    angular
        .module('app.settings.systemSettings')
        .controller('SystemSettingsController', SystemSettingsController);

    function SystemSettingsController(log, dataservice, $q, $rootScope, gettextCatalog, authenticationService, $timeout) {
        var vm = this;
        $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('SystemSettings');

        // Create variables
        vm.socialSecurityNumberRequiredValue = false;
        vm.athleteRegistrationNumberRequiredValue = false;

        // Public functions
        vm.languageSelect = languageSelect;
        vm.expDocNotificationSelect = expDocNotificationSelect;
        vm.saveSystemSettings = saveSystemSettings;
        vm.saveSystemSettingValue = saveSystemSettingValue;
        vm.nf1Select = nf1Select;
        //vm.nf2Select = nf2Select; function nf2Select() {}
        vm.nf1databound = nf1databound;
        vm.nf2databound = nf2databound;
        vm.valasztottNyelv = undefined;
        vm.selectedExpDocGroup = 0;
        vm.NYELVEK = [];
        vm.expNotiList = [
            {value: 0, text: gettextCatalog.getString('Administrators')},
            {value: 1, text: gettextCatalog.getString('SectionLeader')},
            {value: 2, text: gettextCatalog.getString('Trainer')},
            {value: 3, text: gettextCatalog.getString('EconomicColleague')}
        ];
        vm.attendanceList = [
            {value: 0, text: gettextCatalog.getString('provenabsenceText')},
            {value: 1, text: gettextCatalog.getString('injuryText')},
            {value: 2, text: gettextCatalog.getString('Verseny')},
            {value: 3, text: gettextCatalog.getString('sicknessText')}
        ];
        vm.nf1list = [
            {value: 1, text: gettextCatalog.getString('Weekly')},
            {value: 2, text: gettextCatalog.getString('EverySecondWeek')},
            {value: 3, text: gettextCatalog.getString('Monthly')},
            {value: 4, text: gettextCatalog.getString('EverySecondMonth')},
            {value: 5, text: gettextCatalog.getString('EveryThirdMonth')}
        ];
        vm.nfWeeklyList = [
            {value: 1, text: gettextCatalog.getString('Monday')},
            {value: 2, text: gettextCatalog.getString('Tuesday')},
            {value: 3, text: gettextCatalog.getString('Wednesday')},
            {value: 4, text: gettextCatalog.getString('Thursday')},
            {value: 5, text: gettextCatalog.getString('Friday')},
            {value: 6, text: gettextCatalog.getString('Saturday')},
            {value: 0, text: gettextCatalog.getString('Sunday')}
        ];
        vm.nfDayList = [];
        for (var d = 1; d <= 31; d++) {
            vm.nfDayList.push({value: d, text: d.toString()});
        }
        vm.nf2list = [];
        vm.nf1 = -1;
        vm.nf2 = -1;
        vm.expNotiChecked = [];
        var JelenletTipus =
        {
            IgazoltHianyzas: 0,
            Serules: 1,
            Verseny: 2,
            Betegseg: 3
        };
        // Default beállítások
        vm.attendanceChecked = [JelenletTipus.IgazoltHianyzas, JelenletTipus.Serules, JelenletTipus.Betegseg];
        vm.languageSelected = false;
        activate();

        function activate() {
            $q.all([authenticationService.getRight('BEALLITAS')]).then(function (result) {
                if (result[0] !== true) {
                    log.permissionError(true);
                } else {
                    var promises = [
                        getSystemSettings('TAJKOTELEZO'),
                        getSystemSettings('SNYSZKOTELEZO'),
                        getSystemSettings('BEFSSZKULON'),
                        getSystemSettings('FOLAPOLVASATLANOK'),
                        getSystemSettings('FOLAPNYOMTATAS'),
                        getSystemSettings('FOLAPELFOGADASRAVAROJELENLETIK'),
                        getSystemSettings('FOLAPELFOGADASRAVAROHAVITERVEK'),
                        getSystemSettings('FOLAPELFOGADASRAVAROEVESTERVEK'),
                        getSystemSettings('FOLAPKIFIZETETLENTAGDIJAK'),
                        getSystemSettings('FOLAPLINKEK'),
                        getSystemSettings('FOLAPLEJARO'),
                        getSystemSettings('SPORTMINKOTELEZO'),
                        getSystemSettings('SPKORVALTTART'),
                        getSystemSettings('HAVIEDZTERVJOVAHAGYKOT'),
                        getSystemSettings('HETIEDZTERVJOVAHAGYKOT'),
                        getSystemSettings('ESZKSPORTOLOKILEP'),
                        getSystemSettings('ESZKUSERKILEP'),
                        getSystemSettingsValue('LEJARODOCERTESITESTKAPNAK'),
                        getSystemSettings('FOLAPELFOGADASRAVAROHETITERV'),
                        getSystemSettings('NINCSOKTDIJ'),
                        getSystemSettings('INAKTIVMENUREJTES'),
                        getSystemSettingsValue('TAGDIJERTESGYAKORISAG'),
                        getSystemSettingsValue('HETIEDZTURELMI'),
                        getSystemSettingsValue('JELENLETNEKSZAMIT')
                    ];
                    $q.all(promises).then(function (results) {
                        vm.socialSecurityNumberRequiredValue = results[0];
                        vm.athleteRegistrationNumberRequiredValue = results[1];
                        vm.paymentNumberSeparatelyValue = results[2];
                        vm.FOLAPOLVASATLANOK = results[3];
                        vm.FOLAPNYOMTATAS = results[4];
                        vm.FOLAPELFOGADASRAVAROJELENLETIK = results[5];
                        vm.FOLAPELFOGADASRAVAROHAVITERVEK = results[6];
                        vm.FOLAPELFOGADASRAVAROEVESTERVEK = results[7];
                        vm.FOLAPKIFIZETETLENTAGDIJAK = results[8];
                        vm.FOLAPLINKEK = results[9];
                        vm.FOLAPLEJARO = results[10];
                        vm.SPORTMINKOTELEZO = results[11];
                        vm.SPKORVALTTART = results[12];
                        vm.HAVIEDZTERVJOVAHAGYKOT = results[13];
                        vm.HETIEDZTERVJOVAHAGYKOT = results[14];
                        vm.ESZKSPORTOLOKILEP = results[15];
                        vm.ESZKUSERKILEP = results[16];
                        if (results[17]) {
                            vm.expNotiChecked = JSON.parse(results[17]);
                            vm.LEJARODOCERTESITESTKAPNAK = JSON.parse(results[17]);
                        }
                        vm.FOLAPELFOGADASRAVAROHETITERV = results[18];
                        vm.NINCSOKTDIJ = results[19];
                        vm.INAKTIVMENUREJTES = results[20];
                        if (results[21]) {
                            var tagdijErtesites = JSON.parse(results[21]);
                            if (tagdijErtesites) {
                                vm.nf1 = tagdijErtesites.nf1;
                                vm.nf2 = tagdijErtesites.nf2;
                            }
                            angular.element('#nf1').ejDropDownList('selectItemByValue', vm.nf1);
                            angular.element('#nf2').ejDropDownList('selectItemByValue', vm.nf2);
                        }
                        vm.HETIEDZTURELMI = results[22];
                        if (!vm.HETIEDZTURELMI) {
                            vm.HETIEDZTURELMI = 365;
                        }
                        if (results[23]) {
                            vm.attendanceChecked = JSON.parse(results[23]);
                            vm.JELENLETNEKSZAMIT = JSON.parse(results[23]);
                        } else {
                            vm.JELENLETNEKSZAMIT = [JelenletTipus.IgazoltHianyzas, JelenletTipus.Serules, JelenletTipus.Betegseg];
                        }
                        getAvailableLanguages();
                        $timeout(function () {
                            angular.element('#expNotiList').ejListBox({checkedIndices: vm.LEJARODOCERTESITESTKAPNAK});
                            angular.element('#attendanceList').ejListBox({checkedIndices: vm.JELENLETNEKSZAMIT});
                        }, 500);
                    });
                }
            });
        }

        function nf1databound() {
            if (vm.nf1 > 0) {
                angular.element('#nf1').ejDropDownList('selectItemByValue', vm.nf1);
                nf1Select({value: vm.nf1});
            }
        }

        function nf1Select(arg) {
            var ds2 = [];
            switch (arg.value){
                case 1:
                case 2:
                    jQuery.extend(ds2, vm.nfWeeklyList);
                    break;
                case 3:
                case 4:
                case 5:
                    jQuery.extend(ds2, vm.nfDayList);
                    break;
            }
            vm.nf2list = ds2;
        }

        function nf2databound() {
            if (vm.nf2 > 0) {
                angular.element('#nf2').ejDropDownList('selectItemByValue', vm.nf2);
            }
        }

        function languageSelect(arg) {
            vm.languageSelected = true;
            getKedvezmenyNevek(arg.value);
            getOktatasiKedvezmenyNevek(arg.value);
        }

        function expDocNotificationSelect(arg) {
            vm.selectedExpDocGroup = arg.value;
        }

        function getKedvezmenyNevek(language) {
            vm.kedvezmeny1 = undefined;
            vm.kedvezmeny2 = undefined;
            vm.kedvezmeny3 = undefined;
            vm.kedvezmeny4 = undefined;
            vm.kedvezmeny5 = undefined;
            dataservice.KedvezmenyNevek(language).then(function (response) {
                if (response.itemsList.length > 0) {
                    for (var i = 0; i < response.itemsList.length; i++) {
                        switch (response.itemsList[i].value) {
                            case 'K1':
                                vm.kedvezmeny1 = response.itemsList[i].text;
                                break;
                            case 'K2':
                                vm.kedvezmeny2 = response.itemsList[i].text;
                                break;
                            case 'K3':
                                vm.kedvezmeny3 = response.itemsList[i].text;
                                break;
                            case 'K4':
                                vm.kedvezmeny4 = response.itemsList[i].text;
                                break;
                            case 'K5':
                                vm.kedvezmeny5 = response.itemsList[i].text;
                                break;
                        }
                    }
                }
            });
        }

        function getOktatasiKedvezmenyNevek(language) {
            vm.kedvezmenyokt1 = undefined;
            vm.kedvezmenyokt2 = undefined;
            vm.kedvezmenyokt3 = undefined;
            vm.kedvezmenyokt4 = undefined;
            vm.kedvezmenyokt5 = undefined;
            dataservice.OktatasiKedvezmenyNevek(language).then(function (response) {
                if (response.itemsList.length > 0) {
                    for (var i = 0; i < response.itemsList.length; i++) {
                        switch (response.itemsList[i].value) {
                            case 'OK1':
                                vm.kedvezmenyokt1 = response.itemsList[i].text;
                                break;
                            case 'OK2':
                                vm.kedvezmenyokt2 = response.itemsList[i].text;
                                break;
                            case 'OK3':
                                vm.kedvezmenyokt3 = response.itemsList[i].text;
                                break;
                            case 'OK4':
                                vm.kedvezmenyokt4 = response.itemsList[i].text;
                                break;
                            case 'OK5':
                                vm.kedvezmenyokt5 = response.itemsList[i].text;
                                break;
                        }
                    }
                }
            });
        }

        function saveKedvezmenyNevek() {
            dataservice.KedvezmenyNevekMentes(vm.valasztottNyelv, vm.kedvezmeny1, vm.kedvezmeny2, vm.kedvezmeny3, vm.kedvezmeny4, vm.kedvezmeny5, vm.kedvezmenyokt1, vm.kedvezmenyokt2, vm.kedvezmenyokt3, vm.kedvezmenyokt4, vm.kedvezmenyokt5)
                .then(function () {
                });
        }

        function getAvailableLanguages() {
            dataservice.getAvailableLanguages().then(function (response) {
                vm.NYELVEK = response.itemsList;
            });
        }

        function getSystemSettings(valtozo) {
            return dataservice.getSystemSettings(valtozo).then(function (response) {
                return response.retValue;
            });
        }

        function getSystemSettingsValue(valtozo) {
            return dataservice.getSystemSettingsValue(valtozo).then(function (response) {
                if (response.hasOwnProperty('retValue')) {
                    return response.retValue;
                }
                return null;
            });
        }

        function saveSystemSettings() {
            var ExpCheckedArray = [];
            $('#expNotiList').ejListBox('getCheckedItems').forEach(function (chk) {
                ExpCheckedArray.push(chk.index);
            });
            vm.LEJARODOCERTESITESTKAPNAK = JSON.stringify(ExpCheckedArray);
            var attendanceArray = [];
            $('#attendanceList').ejListBox('getCheckedItems').forEach(function (chk) {
                attendanceArray.push(chk.index);
            });
            vm.JELENLETNEKSZAMIT = JSON.stringify(attendanceArray);
            vm.TAGDIJERTESGYAKORISAG = JSON.stringify({nf1: vm.nf1, nf2: vm.nf2});
            $q.all([
                saveSystemSetting('TAJKOTELEZO', vm.socialSecurityNumberRequiredValue),
                saveSystemSetting('SNYSZKOTELEZO', vm.athleteRegistrationNumberRequiredValue),
                saveSystemSetting('BEFSSZKULON', vm.paymentNumberSeparatelyValue),
                saveSystemSetting('FOLAPOLVASATLANOK', vm.FOLAPOLVASATLANOK),
                saveSystemSetting('FOLAPNYOMTATAS', vm.FOLAPNYOMTATAS),
                saveSystemSetting('FOLAPELFOGADASRAVAROJELENLETIK', vm.FOLAPELFOGADASRAVAROJELENLETIK),
                saveSystemSetting('FOLAPELFOGADASRAVAROHAVITERVEK', vm.FOLAPELFOGADASRAVAROHAVITERVEK),
                saveSystemSetting('FOLAPELFOGADASRAVAROEVESTERVEK', vm.FOLAPELFOGADASRAVAROEVESTERVEK),
                saveSystemSetting('FOLAPKIFIZETETLENTAGDIJAK', vm.FOLAPKIFIZETETLENTAGDIJAK),
                saveSystemSetting('FOLAPLINKEK', vm.FOLAPLINKEK),
                saveSystemSetting('FOLAPLEJARO', vm.FOLAPLEJARO),
                saveSystemSetting('SPORTMINKOTELEZO', vm.SPORTMINKOTELEZO),
                saveSystemSetting('SPKORVALTTART', vm.SPKORVALTTART),
                saveSystemSetting('HAVIEDZTERVJOVAHAGYKOT', vm.HAVIEDZTERVJOVAHAGYKOT),
                saveSystemSetting('HETIEDZTERVJOVAHAGYKOT', vm.HETIEDZTERVJOVAHAGYKOT),
                saveSystemSetting('ESZKSPORTOLOKILEP', vm.ESZKSPORTOLOKILEP),
                saveSystemSetting('ESZKUSERKILEP', vm.ESZKUSERKILEP),
                saveSystemSettingValue('LEJARODOCERTESITESTKAPNAK', vm.LEJARODOCERTESITESTKAPNAK),
                saveSystemSetting('FOLAPELFOGADASRAVAROHETITERV', vm.FOLAPELFOGADASRAVAROHETITERV),
                saveSystemSetting('NINCSOKTDIJ', vm.NINCSOKTDIJ),
                saveSystemSetting('INAKTIVMENUREJTES', vm.INAKTIVMENUREJTES),
                saveSystemSettingValue('TAGDIJERTESGYAKORISAG', vm.TAGDIJERTESGYAKORISAG),
                saveSystemSettingValue('HETIEDZTURELMI', vm.HETIEDZTURELMI),
                saveSystemSettingValue('JELENLETNEKSZAMIT', vm.JELENLETNEKSZAMIT)
            ]).then(function () {
                    $rootScope.INAKTIVMENUREJTES = vm.INAKTIVMENUREJTES;
                    log.successMsg(gettextCatalog.getString('SavedSuccessful'));
                })
                .catch(function () {
                    log.errorMsg(gettextCatalog.getString('SaveUnsuccessful'));
                });
            if (vm.languageSelected) {
                saveKedvezmenyNevek();
            }
        }

        function saveSystemSetting(valtozo, ertek) {
            return dataservice.saveSystemSettings(valtozo, ertek).then(function () {
            });
        }

        function saveSystemSettingValue(valtozo, ertek) {
            return dataservice.saveSystemSettingsValue(valtozo, ertek).then(function () {
            });
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.settings.systemSettings')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'settings.systemSettings',
                config: {
                    url: '/systemSettings',
                    templateUrl: 'app/settings/systemSettings/systemSettings.html',
                    controller: 'SystemSettingsController',
                    controllerAs: 'vm',
                    title: 'SystemSettings',
                    settings: {
                        navId: 2105,
                        level: 2,
                        order: 10,
                        orderTitle_hu: 'Rendszerbeállítások',
                        orderTitle_en: 'System Settings',
                        parentId: 5,
                        content: 'SystemSettings',
                        activatorPermission: '"BEALLITAS"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    UserGroupsManagementController.$inject = ["$q", "paramHelper", "gettextCatalog", "$state", "dataservice", "logger", "authenticationService", "$rootScope", "$scope", "log", "$timeout"];
    angular
        .module('app.settings.userGroupsManagement')
        .controller('UserGroupsManagementController', UserGroupsManagementController);

    function UserGroupsManagementController($q, paramHelper, gettextCatalog, $state, dataservice, logger, authenticationService, $rootScope, $scope, log, $timeout) {
        var vm = this; $rootScope.vm = vm;

        // Page title
        $rootScope.title = gettextCatalog.getString('UserGroups');

        vm.data = [];
        vm.newgrouptitle = gettextCatalog.getString('AddNewUserGroup');
        vm.editgrouptitle = gettextCatalog.getString('EditUserGroup');

        vm.columns = [
            {field: 'Id', visible: false, isPrimaryKey: true},
            {field: 'Nev', headerText: gettextCatalog.getString('Name'), textAlign: 'left', validationRules: {required: true}, validationMessage: {required: gettextCatalog.getString('GroupNameRequrired')}},
            {field: 'Leiras', headerText: gettextCatalog.getString('Description'), textAlign: 'left'}
        ];

        vm.deleteGroupEnabled = false;
        vm.setGroupRightsEnabled = false;
        vm.selectedGroupId = -1;
        vm.EndAdd = EndAdd;
        vm.EndEdit = EndEdit;
        vm.selectedRow = selectedRow;
        vm.DeleteGroup = DeleteGroup;
        vm.ManageRights = ManageRights;
        vm.EditGroup = EditGroup;
        vm.AddGroup = AddGroup;
        vm.newgroupCancel = newgroupCancel;
        vm.newgroupSave = newgroupSave;
        vm.editgroupCancel = editgroupCancel;
        vm.editgroupSave = editgroupSave;

        vm.MEGTFELHCSOP = false;
        vm.MODFELHCSOP = false;
        vm.UJFELHCSOP = false;
        vm.MEGTFELHJOG = false;

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItems,
            allowPaging: true,
            allowTextWrap: true,
            allowSorting: true,
            allowExcelExport: true,
            allowDeleting: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            rowSelected: vm.selectedRow,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile(angular.element('#Grid'), $scope);
                }
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        activate();

        function activate() {
            $q.all([authenticationService.getRight('MEGTFELHCSOP'), authenticationService.getRight('MODFELHCSOP'), authenticationService.getRight('UJFELHCSOP'), authenticationService.getRight('MEGTFELHJOG')]).then(function (data) {
                $timeout(function () {
                    vm.MEGTFELHCSOP = data[0];
                    vm.MODFELHCSOP = data[1];
                    vm.UJFELHCSOP = data[2];
                    vm.MEGTFELHJOG = data[3];
                }, 10);
                if (data[0] || data[1] || data[2]) {
                    getUserGroupList();
                } else {
                    log.permissionError(true);
                }
            });
        }

        function AddGroup() {
            vm.newgroup = {};
            var dialogObj = angular.element('#newgroup').data('ejDialog');
            dialogObj.open();
        }

        function newgroupCancel() {
            var dialogObj = angular.element('#newgroup').data('ejDialog');
            dialogObj.close();
        }

        function newgroupSave() {
            var dialogObj = angular.element('#newgroup').data('ejDialog');
            if (vm.newgroup && vm.newgroup.Nev) {
                vm.newgroup.Id = -1;
                dialogObj.close();
                dataservice.addUserGroup(vm.newgroup).then(function () {
                    log.successMsg(gettextCatalog.getString('saveSuccess'));
                    vm.deleteGroupEnabled = false;
                    activate();
                });
            } else {
                dialogObj.close();
                log.errorMsg(gettextCatalog.getString('NewUserGroupMustHaveNameAndType'));
            }
        }

        function editgroupCancel() {
            var dialogObj = angular.element('#editgroup').data('ejDialog');
            dialogObj.close();
        }

        function editgroupSave() {
            var dialogObj = angular.element('#editgroup').data('ejDialog');
            dialogObj.close();
            dataservice.editUserGroup(vm.editgroup).then(function () {
                log.successMsg(gettextCatalog.getString('saveSuccess'));
                vm.deleteGroupEnabled = false;
                activate();
            });
        }

        function DeleteGroup() {
            swal({
                title: gettextCatalog.getString('Are you sure you want to delete the selected user group?'),
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                confirmButtonText: gettextCatalog.getString('Yes, delete this user group'),
                cancelButtonText: gettextCatalog.getString('Cancel'),
                closeOnConfirm: false,
                closeOnCancel: false
            }).then(function (isConfirm) {
                if (isConfirm.value) {
                    return dataservice.deleteUserGroup(vm.selectedGroupId).then(function () {
                        activate();
                    });
                }
            });
        }

        function ManageRights() {
            paramHelper.setParams([{'usergroupid': vm.selectedGroupId}]);
            $state.go('settings.userRights');
        }

        function EditGroup() {
            var dialogObj = angular.element('#editgroup').data('ejDialog');
            dialogObj.open();
        }

        function selectedRow(args) {
            vm.editgroup = args.data;
            vm.selectedGroupId = args.data.Id;
            vm.deleteGroupEnabled = args != null && vm.MODFELHCSOP;
            vm.setGroupRightsEnabled = args != null && vm.MEGTFELHJOG;
            $scope.$apply();
        }

        function getUserGroupList() {
            dataservice.getUserGroupList().then(function (data) {
                vm.data = data.itemsList;
                grid.dataSource = vm.data;
            });
        }

        function EndEdit(args) {
            dataservice.editUserGroup(args.data).then(function () {
                getUserGroupList();
                log.successMsg(gettextCatalog.getString('saveSuccess'));
            });
        }

        function EndAdd(args) {
            args.data.Id = -1;
            dataservice.addUserGroup(args.data).then(function () {
                log.successMsg(gettextCatalog.getString('saveSuccess'));
            });
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.settings.userGroupsManagement')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'settings.userGroupsManagement',
                config: {
                    url: '/userGroups',
                    templateUrl: 'app/settings/userGroups/userGroupsManagement.html',
                    controller: 'UserGroupsManagementController',
                    controllerAs: 'vm',
                    title: 'UserGroupsManagement',
                    settings: {
                        navId: 225,
                        level: 2,
                        order: 2,
                        orderTitle_hu: 'Felhasználói csoportok kezelése',
                        orderTitle_en: 'User Groups Management',
                        parentId: 5,
                        content: 'UserGroupsManagement',
                        activatorPermission: '"MEGTFELHCSOP"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    modifyUserController.$inject = ["$q", "log", "VIEW_DATA", "dataservice", "DOMAIN", "authenticationService", "$rootScope", "AUTH_EVENTS", "$scope", "gettextCatalog", "paramHelper", "$state", "$filter", "$timeout"];
    angular
        .module('app.settings.userManagement.modifyUser')
        .controller('modifyUserController', modifyUserController);

    function modifyUserController($q, log, VIEW_DATA, dataservice, DOMAIN, authenticationService, $rootScope, AUTH_EVENTS, $scope, gettextCatalog, paramHelper, $state, $filter, $timeout) {
        var vm = this;
        $rootScope.vm = vm; // jshint ignore: line

        // Page title
        $rootScope.title = gettextCatalog.getString('ModifyUser');

        // Dropdowns
        vm.autoSave = true;
        vm.sectionLeaderChangeEnable = false;
        vm.sectionLeaderList = [];
        vm.ageGroupList = [];
        vm.weightList = dataservice.range(VIEW_DATA.dropDownList.weight.downThreshold, VIEW_DATA.dropDownList.weight.upThreshold);
        vm.heightList = dataservice.range(VIEW_DATA.dropDownList.centimetre.downThreshold, VIEW_DATA.dropDownList.centimetre.upThreshold);
        vm.sexList = [{
            text: gettextCatalog.getString('Man'),
            value: 1
        },
            {
                text: gettextCatalog.getString('Woman'),
                value: 0
            }
        ];
        vm.userGroupList = [];

        // Default variables
        vm.noImg = DOMAIN.baseURL + DOMAIN.userImage;
        vm.photoUrl = vm.noImg;
        vm.passwordAgain = undefined;
        vm.colorValue = '#000000';
        vm.activeValue = true;
        vm.formData = {
            id: undefined,
            name: undefined,
            userGroupId: undefined,
            loginName: undefined,
            email: undefined,
            password: undefined,
            passwordExpiryDate: undefined,
            fileData: null,
            fileName: null,
            address: undefined,
            contact: undefined,
            socialSecurityNumber: undefined,
            color: '#000000',
            monthlyAttendanceRegister: undefined,
            activeUser: true,
            mainWorkPlace: undefined,
            qualifications: undefined,
            country: undefined,
            city: undefined,
            birthDate: undefined,
            citizenship: undefined,
            mothersName: undefined,
            height: undefined,
            weight: undefined,
            identityCardNumber: undefined,
            sex: undefined,
            passportNumber: undefined,
            otherInformation: undefined,
            autoSave: true
        };

        vm.changeUserGroup = changeUserGroup;
        vm.colorChanged = colorChanged;
        vm.monthlyAttendanceRegisterChanged = monthlyAttendanceRegisterChanged;
        vm.activeChange = activeChange;
        vm.autoSaveCheckboxChanged = autoSaveCheckboxChanged;
        vm.sectionLeaderChecked = sectionLeaderChecked;
        vm.changeHeight = changeHeight;
        vm.changeWeight = changeWeight;
        vm.changeSex = changeSex;
        vm.sectionLeader = false;

        vm.selectedItems = [0, 1];
        vm.saveUser = saveUser;
        // Image cropper variables
        vm.cropper = {};
        vm.cropper.sourceImage = null;
        vm.cropper.croppedImage = null;
        vm.bounds = {};
        vm.bounds.left = 0;
        vm.bounds.right = 0;
        vm.bounds.top = 0;
        vm.bounds.bottom = 0;
        vm.cropDialogTitle = gettextCatalog.getString('ChooseImageTitle');

        vm.newAsset = {};
        vm.TakeBackComment = '';
        vm.IssueComment = '';
        vm.chooseEnabled = false;
        vm.takebackEnabled = false;
        vm.issuedAssets = [];
        vm.selectedAssets = [];
        vm.types = [];
        vm.assetColumns = [
            {field: 'EszkozId', visible: false, isPrimaryKey: true, width: 100},
            {type: 'checkbox', textAlign: 'center', width: 100},
            {field: 'Megnevezes', headerText: gettextCatalog.getString('Megnevezes'), textAlign: 'left', width: 150},
            {field: 'Leiras', headerText: gettextCatalog.getString('Leiras'), textAlign: 'left', width: 100},
            {field: 'Azonosito', headerText: gettextCatalog.getString('Azonosito'), textAlign: 'left', width: 100},
            {field: 'Meret', headerText: gettextCatalog.getString('Meret'), textAlign: 'left', width: 100},
            {field: 'Ar', headerText: gettextCatalog.getString('Ar'), textAlign: 'left', width: 100}
        ];

        var usersAssetGrid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItems,
            allowPaging: true,
            allowSorting: true,
            allowExcelExport: true,
            allowTextWrap: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.assetColumns,
            selectionSettings: {type: 'multiple', mode: 'Both'},
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile(usersAssetGrid, $scope);
                }
            },
            rowSelected: function () {
                var rowSelect = $rootScope.gridSelectedRowIndex(usersAssetGrid);
                if (rowSelect.length > 0) {
                    vm.takebackEnabled = true;
                    $timeout(function () {
                        $scope.$apply();
                    }, 0);
                }
            },
            rowDeselected: function () {
                var rowSelect = $rootScope.gridSelectedRowIndex(usersAssetGrid);
                if (rowSelect.length == 0) {
                    vm.takebackEnabled = false;
                    $timeout(function () {
                        $scope.$apply();
                    }, 0);
                }
            }
        });
        usersAssetGrid.appendTo('#UsersAssetGrid');
        usersAssetGrid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, usersAssetGrid);
        };

        var AssetGrid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItems,
            allowPaging: true,
            allowSorting: true,
            allowExcelExport: true,
            allowTextWrap: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.assetColumns,
            selectionSettings: {type: 'multiple', mode: 'Both'},
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile(AssetGrid, $scope);
                }
            },
            rowSelected: function () {
                var rowSelect = $rootScope.gridSelectedRowIndex(AssetGrid);
                if (rowSelect.length > 0) {
                    vm.chooseEnabled = true;
                    $timeout(function () {
                        $scope.$apply();
                    }, 0);
                }
            },
            rowDeselected: function () {
                var rowSelect = $rootScope.gridSelectedRowIndex(AssetGrid);
                if (rowSelect.length == 0) {
                    vm.chooseEnabled = false;
                    $timeout(function () {
                        $scope.$apply();
                    }, 0);
                }
            }
        });
        AssetGrid.appendTo('#AssetGrid');
        AssetGrid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, AssetGrid);
        };

        vm.IssueAsset = IssueAsset;
        vm.Issue = Issue;
        vm.IssueNewAsset = IssueNewAsset;
        vm.TakeBack = TakeBack;
        vm.deleteImg = deleteImg;
        vm.openCropDialog = openCropDialog;
        vm.doneCropDialog = doneCropDialog;
        vm.closeCropDialog = closeCropDialog;
        vm.goToFiles = goToFiles;
        vm.socialSecurityNumberRequiredValue = false;
        vm.SPORTOLOADATLAP = false;
        vm.SZULOADATLAP = false;
        vm.GAZDASAGIADATLAP = false;
        vm.LIMITEDUSER = false;
        vm.SZAKOSZTVEZADATLAP = false;
        vm.EDZOADATLAP = false;
        vm.ESZKMOZG = false;

        activate();

        function activate() {
            $q.all([paramHelper.getParams(['newUser.userId'], []),
                authenticationService.getRight('MODFELH'),
                authenticationService.getRight('EDZO'),
                authenticationService.getAuthData(),
                authenticationService.getRight('ADMIN'),
                authenticationService.getRight('MODFELH'),
                authenticationService.getRight('MEGTFELH'),
                authenticationService.getRight('SZULO'),
                authenticationService.getRight('SPORTOLO'),
                authenticationService.getRight('SZAKOSZTVEZ'),
                authenticationService.getRight('ESZKMOZG'),
                getSectionLeaderListBox(),
                getAgeGroupTreeView()
            ])
                .then(function (results1) {
                    if (results1[1] !== true && results1[6] !== true && results1[7] !== true && results1[8] !== true) {
                        log.permissionError(true);
                    } else {
                        $q.all([getUsersUserGroup(results1[0]['newUser.userId'])]).then(function (results2) {
                            $q.all([getUserGroupDropDownList(results2[0])]).then(function () {
                                vm.GROUP = results2[0];
                                vm.EDZO = results1[2];
                                vm.ADMIN = results1[4];
                                vm.MODFELH = results1[5];
                                vm.SZULO = results1[7];
                                vm.SPORTOLO = results1[8];
                                vm.SZAKOSZTVEZ = results1[9];
                                vm.ESZKMOZG = results1[10];
                                vm.user = results1[3];
                                vm.userId = results1[0]['newUser.userId'];
                                getUser(results1[0]['newUser.userId']);
                                IssuedAssets(vm.userId);
                                getSystemSettings('TAJKOTELEZO');
                            });
                        });
                    }
                });
        }

        function getUserGroupDropDownList(group) {
            if (!group || group == '') {
                group = 'showall';
            }
            return dataservice.getFullUserGroupList(group)
                .then(function (data) {
                    vm.userGroupList = data.itemsList;
                });
        }

        function getSystemSettings(arg) {
            dataservice.getSystemSettings(arg).then(function (response) {
                vm.socialSecurityNumberRequiredValue = response.retValue;
            });
        }

        function getUsersUserGroup(userid) {
            return dataservice.UsersUserGroup(userid)
                .then(function (data) {
                    vm.LIMITEDUSER = false;
                    for (var i = 0; i < data.data.length; i++) {
                        switch (data.data[i]) {
                            case 'SZULO':
                                vm.SZULOADATLAP = true;
                                vm.LIMITEDUSER = true;
                                break;
                            case 'SPORTOLO':
                                vm.SPORTOLOADATLAP = true;
                                vm.LIMITEDUSER = true;
                                break;
                            case 'GAZDASAGI':
                                vm.GAZDASAGIADATLAP = true;
                                break;
                            case 'SZAKOSZTVEZ':
                                vm.SZAKOSZTVEZADATLAP = true;
                                break;
                            case 'EDZO':
                                vm.EDZOADATLAP = true;
                                break;
                            default:
                        }
                    }
                    return data.data;
                });
        }

        function getUser(userId) {
            return dataservice.getUserData(userId)
                .then(function (data) {
                    angular.element('#sex').ejDropDownList('selectItemByValue', data.retValue.ferfib);
                    data.retValue.birthDate = $filter('datetimeFilter')(data.retValue.birthDate);
                    data.retValue.passwordExpiryDate = $filter('dateStringFilter')(data.retValue.passwordExpiryDate);
                    vm.formData = data.retValue;
                    angular.element('#userGroup').ejDropDownList('selectItemByValue', vm.formData.userGroupId);
                    vm.photoUrl = DOMAIN.baseURL + DOMAIN.profileImgBaseUrl + vm.formData.fileName;
                    vm.colorValue = vm.formData.color;
                    angular.forEach(vm.sectionLeaderList, function (section, sectionIndex) {
                        angular.forEach(vm.formData.sectionsLeader, function (sectionId) {
                            if (section.value === sectionId) {
                                angular.element('#sectionListBox').ejListBox('checkItemByIndex', sectionIndex);
                            }
                        });
                    });
                    angular.forEach(vm.formData.ageGroups, function (ageGroup) {
                        angular.element('#ageGroupTreeView').ejTreeView('checkNode', angular.element('#' + ageGroup));
                    });
                    angular.element('#activeCheckBox').ejCheckBox({checked: data.retValue.activeUser});
                    angular.element('#monthlyAttendanceRegister').ejCheckBox({checked: data.retValue.monthlyAttendanceRegister});
                    vm.sectionLeaderChangeEnable = true;
                });
        }

        function changeUserGroup(args) {
            vm.formData.userGroupId = args.value;
            dataservice.getSectionHasSectionLeaderRight(vm.formData.userGroupId)
                .then(function (data) {
                    if (data.retValue) {
                        angular.element('#sectionListBox').ejListBox('enable');
                    } else {
                        angular.element('#sectionListBox').ejListBox('disable');
                    }
                });
            dataservice.getSectionHasCoachRight(vm.formData.userGroupId)
                .then(function (data) {
                    if (data.retValue) {
                        angular.element('#ageGroupTreeView').ejTreeView({enabled: true});
                    } else {
                        angular.element('#ageGroupTreeView').ejTreeView({enabled: false});
                    }
                });
        }

        function colorChanged(args) {
            vm.formData.color = args.value;
        }

        function monthlyAttendanceRegisterChanged(args) {
            vm.formData.monthlyAttendanceRegister = args.value;
        }

        function activeChange(args) {
            vm.formData.activeUser = args.value;
        }

        function autoSaveCheckboxChanged(args) {
            vm.formData.autoSave = args.value;
        }

        function getSectionLeaderListBox() {
            return dataservice.getSectionLeaderListBox()
                .then(function (data) {
                    vm.sectionLeaderList = data.itemsList;
                });
        }

        function sectionLeaderChecked(args) {
            if (vm.sectionLeaderChangeEnable) {
                if (args.isChecked === true) {
                    if (!args.data.VezetoNev) {
                        args.data.VezetoNev = gettextCatalog.getString('PrimarySectionLeader');
                    }
                    if (!args.data.VezetoNev2) {
                        args.data.VezetoNev2 = gettextCatalog.getString('SecondarySectionLeader');
                    }
                    swal({
                        title: gettextCatalog.getString('ReplaceQuestion'),
                        html: '<p>' + gettextCatalog.getString('WhichLeaderDoYouWantToReplace') + '</p><p>' + gettextCatalog.getString('ActualSectionLeadersText') + ': </p><div><button class="cts-button" id="leader1">' + args.data.VezetoNev + '</button>' + '<button class="cts-button" id="leader2">' + args.data.VezetoNev2 + '</button></div><div style="text-align: center;"><br><br><button class="cts-button auto-width" id="cancel-button">' + gettextCatalog.getString('Cancel') + '</button></div>',
                        showCancelButton: false,
                        showConfirmButton: false,
                        closeOnCancel: false,
                        allowOutsideClick: false
                    });
                    angular.element('#leader1').ejButton({
                        click: function () {
                            replaceLeader(args.index, 1);
                            swal.close();
                        }
                    });
                    angular.element('#leader2').ejButton({
                        click: function () {
                            replaceLeader(args.index, 2);
                            swal.close();
                        }
                    });
                    angular.element('#cancel-button').ejButton({
                        click: function () {
                            angular.element('#sectionListBox').ejListBox('uncheckItemByIndex', args.index);
                            swal.close();
                        }
                    });
                } else {
                    vm.sectionLeaderList[args.index].replace = 3;
                }
            }
        }

        function replaceLeader(index, replace) {
            vm.sectionLeaderList[index].replace = replace;
        }

        function getAgeGroupTreeView() {
            return dataservice.getAgeGroupTreeView()
                .then(function (data) {
                    vm.ageGroupList = data.itemsList;
                });
        }

        function changeHeight(args) {
            vm.formData.height = args.value;
        }

        function changeWeight(args) {
            vm.formData.weight = args.value;
        }

        function changeSex(args) {
            vm.formData.sex = args.value;
        }

        function saveUser() {
            if (vm.MODFELH || (vm.SZULOADATLAP && vm.SZULO) || (vm.SPORTOLOADATLAP && vm.SPORTOLO)) {
                // a syncfusion direktívák miatt
                $scope.$broadcast('submitted');
                if ($scope.form.$valid === false) {
                    log.errorMsg(gettextCatalog.getString('RequiredFieldsError'), gettextCatalog.getString('FillTheRequiredFields'));
                } else {
                    if (vm.formData.password != '') {
                        if (vm.formData.password != vm.passwordAgain) {
                            log.errorMsg(gettextCatalog.getString('PasswordsDontMatch'));
                            return;
                        }
                    }
                    // kiválasztott korosztályok
                    vm.formData.ageGroupList = [];
                    var tmp = angular.element('#ageGroupTreeView').ejTreeView('getCheckedNodesIndex');
                    angular.forEach(tmp, function (value) {
                        if (vm.ageGroupList[value].hasChild === false) {
                            vm.formData.ageGroupList.push(vm.ageGroupList[value]);
                        }
                    });
                    // szakosztály, amiknek a vezetője
                    vm.formData.sectionsLeaderList = vm.sectionLeaderList;
                    // kép küldése, ha választott
                    if (angular.element('#fileName').val() !== '' && vm.cropper.croppedImage !== null) {
                        vm.formData.fileData = vm.cropper.croppedImage;
                        vm.formData.fileName = angular.element('#fileName').val();
                    }
                    vm.formData.socialSecurityNumber = angular.element('#socialSecurityNumber').ejMaskEdit('get_StrippedValue');
                    dataservice.modifyUser(vm.formData).then(function (data) {
                        if (data) {
                            var currentId = parseInt(authenticationService.getAuthData().id);
                            if (currentId === vm.formData.id) {
                                $rootScope.$broadcast(AUTH_EVENTS.refreshProfilePic, data.image);
                            }
                            log.successMsg('UserModified');
                            if (vm.SPORTOLOADATLAP || vm.SZULOADATLAP) {
                                $rootScope.back();
                            } else {
                                $state.go('settings.userManagement.userList');
                            }
                        }
                    });
                }
            } else {
                log.permissionError();
            }
        }

        function goToFiles() {
            if (vm.MODFELH) {
                paramHelper.setParams([{'files.tipus': 'Felhasznalok'}, {'files.tablaId': vm.formData.id}]);
                $state.go('other.files');
            } else {
                log.permissionError();
            }
        }

        function openCropDialog() {
            angular.element('#dialogContainer').css('visibility', 'visible');
            angular.element('#cropDialog').ejDialog('open');
        }

        function closeCropDialog() {
            angular.element('#dialogContainer').css('visibility', 'hidden');
            angular.element('#cropDialog').ejDialog('close');
        }

        function doneCropDialog() {
            vm.photoUrl = vm.cropper.croppedImage;
            angular.element('#cropDialog').ejDialog('close');
        }

        function deleteImg() {
            swal({
                title: gettextCatalog.getString('DeleteProfileImg'),
                text: gettextCatalog.getString('AreYouSureYouWantToDeleteTheProfileImg'),
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: gettextCatalog.getString('Yes'),
                cancelButtonText: gettextCatalog.getString('No')
            }).then(function (isConfirm) {
                if (isConfirm.value) {
                    angular.element('#fileName').val('');
                    var nem = vm.formData.ferfib ? 'male' : 'female';
                    vm.formData.fileName = 'coach_' + nem + '_' + Math.ceil(Math.random() * (8 - 1) + 1) + '.png';
                    vm.photoUrl = DOMAIN.baseURL + DOMAIN.profileImgBaseUrl + vm.formData.fileName;
                    dataservice.DeleteUserAvatar(vm.userId, vm.formData.fileName);
                    $scope.$apply();
                }
            });
        }

        function IssuedAssets(userid) {
            dataservice.IssuedAssets(0, userid).then(function (response) {
                usersAssetGrid.dataSource = response.data;
            });
        }

        function getSelectedAssets() {
            var row = $rootScope.getSelectedItems(usersAssetGrid);
            usersAssetGrid.refresh();
            return vm.selectedAssets;
        }

        function getSelectedAssetIds(selectGrid) {
            var selectedAssets = $rootScope.getSelectedItems(selectGrid);
            var assetIds = [];
            selectedAssets.forEach(function (asset) {
                assetIds.push(asset.EszkozId);
            });
            return assetIds;
        }

        function IssueAsset() {
            if (vm.ESZKMOZG) {
                angular.element('#issueDialog').data('ejDialog').open();
                dataservice.AssetsByType(0, 'issuable').then(function (data) {
                    AssetGrid.dataSource = data.data;
                });
                dataservice.assetTypeList().then(function (data) {
                    vm.types = data.itemsList;
                    vm.types.forEach(function (item) {
                        item.value = item.TipusId;
                        item.text = item.TipusNev;
                    });
                });
            } else {
                log.permissionError();
            }
        }

        function IssueNewAsset() {
            angular.element('#issueDialog').data('ejDialog').close();
            vm.chooseEnabled = false;
            var HTMLtext = createHtmlSwalContent([
                {id: 'Megnevezes', text: gettextCatalog.getString('Megnevezes'), value: ''},
                {id: 'Leiras', text: gettextCatalog.getString('Leiras'), value: ''},
                {id: 'Azonosito', text: gettextCatalog.getString('Azonosito'), value: ''},
                {id: 'Meret', text: gettextCatalog.getString('Meret'), value: ''},
                {id: 'Ar', text: gettextCatalog.getString('Ar'), value: ''},
                {id: 'darab', text: gettextCatalog.getString('NumberMassAdd'), value: ''},
                {id: 'AssetType', text: gettextCatalog.getString('AssetType'), value: '', ac: true}
            ]);
            swal({
                title: gettextCatalog.getString('CreateAsset'),
                html: HTMLtext,
                type: 'info',
                showCancelButton: true,
                confirmButtonColor: '#DD6B55',
                allowOutsideClick: false,
                allowEscapeKey: false,
                confirmButtonText: gettextCatalog.getString('Ok'),
                cancelButtonText: gettextCatalog.getString('Cancel'),
                preConfirm: function () {
                    return new Promise(function (resolve) {
                        var TipusNev = document.getElementById('AutoCompleteSwal').value;
                        var Megnevezes = document.getElementById('Megnevezes').value;
                        if (!TipusNev || TipusNev.length === 0) {
                            swal.showValidationError(gettextCatalog.getString('AssetTypeNameMustNotBeEmpty'));
                        }
                        if (!Megnevezes || Megnevezes.length === 0) {
                            swal.showValidationError(gettextCatalog.getString('AssetNameMustNotBeEmpty'));
                        }
                        resolve();
                    });
                }
            }).then(function (isConfirm) {
                if (isConfirm.value) {
                    vm.newAsset.EszkozId = -1;
                    vm.newAsset.TipusId = 0;
                    vm.newAsset.TipusNev = '';
                    vm.newAsset.Megnevezes = document.getElementById('Megnevezes').value;
                    vm.newAsset.Leiras = document.getElementById('Leiras').value;
                    vm.newAsset.Azonosito = document.getElementById('Azonosito').value;
                    vm.newAsset.Meret = document.getElementById('Meret').value;
                    vm.newAsset.Ar = document.getElementById('Ar').value;
                    vm.newAsset.darab = document.getElementById('darab').value;
                    vm.newAsset.TipusNev = document.getElementById('AutoCompleteSwal').value;

                    dataservice.AssetManager(vm.newAsset).then(function (response) {
                        dataservice.AssetIssue(response.data.EszkozIdk, vm.userId, 0, vm.IssueComment).then(function () {
                            vm.IssueComment = '';
                            log.successMsg('IssuedSuccessfully');
                            IssuedAssets(vm.userId);
                        });
                    });
                }
            });
            angular.element('#AutoCompleteSwal').ejAutocomplete({
                dataSource: vm.types,
                change: function (arg) {
                    vm.newAsset.TipusId = 0;
                    vm.newAsset.TipusNev = arg.value;
                },
                value: vm.newAsset.TipusId,
                width: '100%'
            });
        }

        function Issue() {
            vm.chooseEnabled = false;
            vm.IssueComment = '';
            angular.element('#issueDialog').data('ejDialog').close();
            dataservice.AssetIssue(getSelectedAssetIds(AssetGrid), vm.userId, 0, vm.IssueComment).then(function () {
                log.successMsg('IssuedSuccessfully');
                IssuedAssets(vm.userId);
            });
        }

        function TakeBack() {
            vm.takebackEnabled = false;
            dataservice.AssetTakeBack(getSelectedAssetIds(usersAssetGrid), vm.TakeBackComment).then(function () {
                vm.TakeBackComment = '';
                log.successMsg('TakenBackSuccessfully');
                IssuedAssets(vm.userId);
            });
        }

        function createHtmlSwalContent(arr) {
            var HTMLtext = '<div style="margin-top: 10px;" >';
            arr.forEach(function (item) {
                HTMLtext += '<div class="row">';
                HTMLtext += '<label class="col-lg-6" style="text-align: left; margin-top:5px;">' + item.text + '</label>';
                if (item.hasOwnProperty('ac')) {
                    HTMLtext += '<input class="col-lg-6 col-lg-offset-6" id="AutoCompleteSwal" ej-autocomplete></input><br>';
                } else if (item.hasOwnProperty('dd')) {
                    HTMLtext += '<input class="col-lg-6 col-lg-offset-6" id="DropDownSwal" ej-dropdownlist></input><br>';
                } else {
                    if (item.value && item.value.length > 0) {
                        HTMLtext += '<input type="text" value="' + item.value + '" id="' + item.id + '"></input><br>';
                    } else {
                        HTMLtext += '<input type="text" value="" id="' + item.id + '"></input><br>';
                    }
                }
                HTMLtext += '</div>';
            });
            HTMLtext += '</div><br>';
            return HTMLtext;
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.settings.userManagement.modifyUser')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'settings.userManagement.modifyUser',
                config: {
                    url: '/modifyUser',
                    templateUrl: 'app/settings/userManagement/modifyUser/modifyUser.html',
                    controller: 'modifyUserController',
                    controllerAs: 'vm',
                    title: 'ModifyUser'
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    newUserController.$inject = ["$q", "log", "VIEW_DATA", "dataservice", "DOMAIN", "authenticationService", "$rootScope", "$scope", "gettextCatalog", "paramHelper", "$state"];
    angular
        .module('app.settings.userManagement.newUser')
        .controller('newUserController', newUserController);

    function newUserController($q, log, VIEW_DATA, dataservice, DOMAIN, authenticationService, $rootScope, $scope, gettextCatalog, paramHelper, $state) {
        var vm = this; $rootScope.vm = vm; // jshint ignore: line

        // Page title
        $rootScope.title = gettextCatalog.getString('NewUser');

        // Dropdowns
        vm.sectionLeaderList = [];
        vm.ageGroupList = [];
        vm.weightList = dataservice.range(VIEW_DATA.dropDownList.weight.downThreshold, VIEW_DATA.dropDownList.weight.upThreshold);
        vm.heightList = dataservice.range(VIEW_DATA.dropDownList.centimetre.downThreshold, VIEW_DATA.dropDownList.centimetre.upThreshold);
        vm.sexList = [{
                text: gettextCatalog.getString('Man'),
                value: 1
            },
            {
                text: gettextCatalog.getString('Woman'),
                value: 0
            }
        ];
        vm.userGroupList = [];
        vm.selectedItems = [0, 1];

        // Default variables
        vm.noImg = DOMAIN.baseURL + DOMAIN.userImage;
        vm.photoUrl = vm.noImg;
        vm.displayPhoto = vm.photoUrl;
        vm.passwordAgain = undefined;
        vm.colorValue = '#000000';
        vm.activeValue = true;
        vm.sectionLeader = false;
        vm.formData = {
            name: undefined,
            userGroupId: undefined,
            loginName: undefined,
            email: undefined,
            password: undefined,
            passwordExpiryDate: undefined,
            fileData: null,
            fileName: null,
            address: undefined,
            contact: undefined,
            socialSecurityNumber: undefined,
            color: '#000000',
            monthlyAttendanceRegister: true,
            activeUser: true,
            mainWorkPlace: undefined,
            qualifications: undefined,
            country: undefined,
            city: undefined,
            birthDate: undefined,
            citizenship: undefined,
            mothersName: undefined,
            height: undefined,
            weight: undefined,
            identityCardNumber: undefined,
            sex: undefined,
            passportNumber: undefined,
            otherInformation: undefined
        };

        vm.changeUserGroup = changeUserGroup;
        vm.colorChanged = colorChanged;
        vm.monthlyAttendanceRegisterChanged = monthlyAttendanceRegisterChanged;
        vm.activeChange = activeChange;
        vm.sectionLeaderChecked = sectionLeaderChecked;
        vm.changeHeight = changeHeight;
        vm.changeWeight = changeWeight;
        vm.changeSex = changeSex;
        vm.saveUser = saveUser;

        // Image cropper variables
        vm.cropper = {};
        vm.cropper.sourceImage = null;
        vm.cropper.croppedImage = null;
        vm.bounds = {};
        vm.bounds.left = 0;
        vm.bounds.right = 0;
        vm.bounds.top = 0;
        vm.bounds.bottom = 0;
        vm.cropDialogTitle = gettextCatalog.getString('ChooseImageTitle');

        vm.deleteImg = deleteImg;
        vm.openCropDialog = openCropDialog;
        vm.doneCropDialog = doneCropDialog;
        vm.closeCropDialog = closeCropDialog;
        vm.socialSecurityNumberRequiredValue = false;

        vm.generateAvatar = generateAvatar;

        activate();

        function generateAvatar(nem) {
            var ava = 'coach_'+ nem + '_' + Math.ceil(Math.random() * (8 - 1) + 1) + '.png';
            if (ava == vm.photoUrl) {
                generateAvatar(nem);
            }
            return ava;
        }

        function activate() {
            $q.all([paramHelper.getParams([], []), authenticationService.getRight('UJFELH'), getUserGroupDropDownList(), getSectionLeaderListBox(), getAgeGroupTreeView()])
                .then(function (results) {
                    if (results[1] !== true) {
                        log.permissionError();
                    } else {
                        vm.UJFELH = results[1];
                        getSystemSettings('TAJKOTELEZO');
                    }
                });
        }

        function getUserGroupDropDownList() {
            dataservice.getFullUserGroupList()
                .then(function (data) {
                    vm.userGroupList = data.itemsList;
                });
        }

        function getSystemSettings(arg) {
            dataservice.getSystemSettings(arg).then(function (response) {
                vm.socialSecurityNumberRequiredValue = response.retValue;
            });
        }

        function changeUserGroup(args) {
            vm.formData.userGroupId = args.value;
            dataservice.getSectionHasSectionLeaderRight(vm.formData.userGroupId)
            .then(function (data) {
                if (data.retValue) {
                    angular.element('#sectionListBox').ejListBox('enable');
                } else {
                    angular.element('#sectionListBox').ejListBox('disable');
                }
            });
        }

        function colorChanged(args) {
            vm.formData.color = args.value;
        }

        function monthlyAttendanceRegisterChanged(args) {
            vm.formData.monthlyAttendanceRegister = args.value;
        }

        function activeChange(args) {
            vm.formData.activeUser = args.value;
        }

        function getSectionLeaderListBox() {
            dataservice.getSectionLeaderListBox()
                .then(function (data) {
                    vm.sectionLeaderList = data.itemsList;
                });
        }

        function sectionLeaderChecked(args) {
            if (args.isChecked === true) {
                if (!args.data.VezetoNev) {
                    args.data.VezetoNev = gettextCatalog.getString('PrimarySectionLeader');
                }
                if (!args.data.VezetoNev2) {
                    args.data.VezetoNev2 = gettextCatalog.getString('SecondarySectionLeader');
                }
                swal({
                    title: gettextCatalog.getString('ReplaceQuestion'),
                    html: '<p>' + gettextCatalog.getString('WhichLeaderDoYouWantToReplace') + '</p>' + '<div><button class="cts-button" id="leader1">' + args.data.VezetoNev + '</button>' + '<button class="cts-button" id="leader2">' + args.data.VezetoNev2 + '</button></div><div style="text-align: center;"><button class="cts-button auto-width" id="cancel-button">' + gettextCatalog.getString('Cancel') + '</button></div>',
                    showCancelButton: false,
                    showConfirmButton: false,
                    closeOnCancel: false,
                    allowOutsideClick: false
                });
                angular.element('#leader1').ejButton({
                    click: function () {
                        replaceLeader(args.index, 1);
                        swal.close();
                    }
                });
                angular.element('#leader2').ejButton({
                    click: function () {
                        replaceLeader(args.index, 2);
                        swal.close();
                    }
                });
                angular.element('#cancel-button').ejButton({
                    click: function () {
                        angular.element('#sectionListBox').ejListBox('uncheckItemByIndex', args.index);
                        swal.close();
                    }
                });
            } else {
                vm.sectionLeaderList[args.index].replace = 3;
            }
        }

        function replaceLeader(index, replace) {
            vm.sectionLeaderList[index].replace = replace;
        }

        function getAgeGroupTreeView() {
            dataservice.getAgeGroupTreeView()
                .then(function (data) {
                    vm.ageGroupList = data.itemsList;
                });
        }

        function changeHeight(args) {
            vm.formData.height = args.value;
        }

        function changeWeight(args) {
            vm.formData.weight = args.value;
        }

        function changeSex(args) {
            if (vm.cropper.sourceImage == null || vm.photoUrl == vm.noImg) {
                var nem = args.value ? 'male' : 'female';
                vm.photoUrl = generateAvatar(nem);
                vm.displayPhoto = DOMAIN.baseURL + DOMAIN.profileImgBaseUrl + vm.photoUrl;
            }
            vm.formData.sex = args.value;
        }

        function saveUser() {
            if (vm.UJFELH) {
                // a syncfusion direktívák miatt
                $scope.$broadcast('submitted');
                if ($scope.form.$valid === false) {
                    log.errorMsg('FillTheRequiredFields');
                } else {
                    if (vm.formData.password != '') {
                        if (vm.formData.password != vm.passwordAgain) {
                            log.errorMsg(gettextCatalog.getString('PasswordsDontMatch'));
                            return;
                        }
                    }
                    // kiválasztott korosztályok
                    vm.formData.ageGroupList = [];
                    var tmp = angular.element('#ageGroupTreeView').ejTreeView('getCheckedNodesIndex');
                    angular.forEach(tmp, function (value) {
                        if (vm.ageGroupList[value].hasChild === false) {
                            vm.formData.ageGroupList.push(vm.ageGroupList[value]);
                        }
                    });
                    // szakosztály, amiknek a vezetője
                    vm.formData.sectionsLeaderList = vm.sectionLeaderList;
                    // kép küldése, ha választott
                    vm.formData.fileName = vm.photoUrl;
                    if (angular.element('#fileName').val() !== '' && vm.cropper.croppedImage !== null) {
                        vm.formData.fileData = vm.cropper.croppedImage;
                        vm.formData.fileName = angular.element('#fileName').val();
                    }
                    if (vm.photoUrl === (DOMAIN.baseURL + DOMAIN.noImage)) {
                        vm.formData.fileData = null;
                        vm.formData.fileName = 'noImg.jpg';
                    }
                    vm.formData.socialSecurityNumber = angular.element('#socialSecurityNumber').ejMaskEdit('get_StrippedValue');
                    dataservice.addUser(vm.formData)
                        .then(function () {
                            log.successMsg('UserAdded');
                            $state.go('settings.userManagement.userList');
                        });
                }
            } else {
                log.permissionError();
            }
        }

        function openCropDialog() {
            angular.element('#dialogContainer').css('visibility', 'visible');
            angular.element('#cropDialog').ejDialog('open');
        }

        function closeCropDialog() {
            angular.element('#dialogContainer').css('visibility', 'hidden');
            angular.element('#cropDialog').ejDialog('close');
        }

        function doneCropDialog() {
            vm.photoUrl = vm.cropper.croppedImage;
            vm.displayPhoto = vm.photoUrl;
            angular.element('#cropDialog').ejDialog('close');
        }

        function deleteImg() {
            swal({
                title: gettextCatalog.getString('DeleteProfileImg'),
                text: gettextCatalog.getString('AreYouSureYouWantToDeleteTheProfileImg'),
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: gettextCatalog.getString('Yes'),
                cancelButtonText: gettextCatalog.getString('No')
            }).then(function (isConfirm) {
                if (isConfirm.value) {
                    angular.element('#fileName').val('');
                    if (vm.formData.sex != null) {
                        var nem = vm.formData.sex == 1 ? 'male' : 'female';
                        vm.photoUrl = generateAvatar(nem);
                        vm.displayPhoto = DOMAIN.baseURL + DOMAIN.profileImgBaseUrl + vm.photoUrl;
                        vm.cropper.sourceImage = null;
                    } else {
                        vm.photoUrl = vm.noImg;
                        vm.displayPhoto = vm.photoUrl;
                        vm.cropper.sourceImage = null;
                    }
                    $scope.$apply();
                }
            });
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.settings.userManagement.newUser')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'settings.userManagement.newUser',
                config: {
                    url: '/newUser',
                    templateUrl: 'app/settings/userManagement/newUser/newUser.html',
                    controller: 'newUserController',
                    controllerAs: 'vm',
                    title: 'NewUser'
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    userManagementController.$inject = ["logger", "log", "$q", "$state", "dataservice", "authenticationService", "$rootScope", "gettextCatalog", "paramHelper", "$scope"];
    angular
        .module('app.settings.userManagement.userList')
        .controller('UserManagementController', userManagementController);

    function userManagementController(logger, log, $q, $state, dataservice, authenticationService, $rootScope, gettextCatalog, paramHelper, $scope) {
        var vm = this;
        $rootScope.vm = vm; // jshint ignore: line

        // Page title
        $rootScope.title = gettextCatalog.getString('UserManagement');

        // Grid's details
        vm.columns = [
            {
                field: 'TeljesNev',
                headerText: gettextCatalog.getString('Name'),
                textAlign: 'left',
                template: '#uslitemplateDataColumn1', width: 122
            },
            {field: 'Login', headerText: gettextCatalog.getString('Username'), textAlign: 'left', width: 122},
            {
                field: 'CsoportNeve',
                headerText: gettextCatalog.getString('Group'),
                textAlign: 'left',
                template: '#uslitemplateDataColumn2', width: 122
            },
            {
                field: 'Aktiv',
                headerText: gettextCatalog.getString('Active'),
                textAlign: 'center',
                type: 'boolean',
                displayAsCheckBox: true, width: 122
            },
            {field: 'Elerhetosege', headerText: gettextCatalog.getString('Contact'), textAlign: 'left', width: 122},
            {field: 'Email', headerText: gettextCatalog.getString('Email'), textAlign: 'left', width: 122},
            {
                field: 'HaviJelenletiKorosztalyonkent',
                headerText: gettextCatalog.getString('MonthlyAttendanceByAgeGroups'),
                textAlign: 'center',
                type: 'boolean',
                displayAsCheckBox: true, width: 122
            }
        ];

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItemsWithSearch,
            allowPaging: true,
            allowSorting: true,
            allowExcelExport: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#UsersAssetGrid'), $scope);
                }
            },
            rowSelecting: function (args) {
                grid.clearSelection();
                vm.selectedRowData = args.data;
                vm.thereIsSelectedTeam = true;
            },
            checkBoxChange: function (args) {
                $rootScope.checkBoxChangeOnlyOne(args, grid);
            }
        });
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };

        // Public functions
        vm.goToNewUser = goToNewUser;
        vm.goToGroup = goToGroup;
        vm.goToUser = goToUser;
        vm.goToUser2 = goToUser2;
        vm.details = details;

        activate();

        function activate() {
            $q.all([authenticationService.getRight('UJFELH'), authenticationService.getRight('MODFELH'), authenticationService.getRight('MEGTFELH')])
                .then(function (results) {
                    if (results[2] !== true) {
                        log.permissionError(true);
                    } else {
                        vm.UJFELH = results[0];
                        vm.MODFELH = results[1];
                        vm.MEGTFELH = results[2];
                        setTimeout(function () {
                            getUsers();
                        }, 100);
                    }
                });
        }

        function getUsers() {
            dataservice.usersListSelect()
                .then(function (data) {
                    grid.dataSource = data.itemsList;
                    grid.appendTo('#Grid');
                });
        }

        function details() {
            log.infoMsg('Details');
        }

        function goToNewUser() {
            if (vm.UJFELH) {
                $state.go('settings.userManagement.newUser');
            } else {
                log.permissionError();
            }
        }

        function goToUser() {
            if (vm.MODFELH) {
                if (vm.selectedRowData && vm.selectedRowData.Id) {
                    paramHelper.setParams([{'newUser.userId': vm.selectedRowData.Id}]);
                    $state.go('settings.userManagement.modifyUser');
                } else {
                    log.errorMsg('YouHaveToSelectUser');
                }
            } else {
                log.permissionError();
            }
        }

        function goToUser2(userId) {
            if (vm.MODFELH || vm.MEGTFELH) {
                if (userId) {
                    paramHelper.setParams([{'newUser.userId': userId}]);
                    $state.go('settings.userManagement.modifyUser');
                }
            } else {
                log.permissionError();
            }
        }

        function goToGroup(group) {
            paramHelper.setParams([{'usergroupid': group}]);
            $state.go('settings.userRights');
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.settings.userManagement.userList')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'settings.userManagement.userList',
                config: {
                    url: '/userList',
                    templateUrl: 'app/settings/userManagement/userList/userList.html',
                    controller: 'UserManagementController',
                    controllerAs: 'vm',
                    title: 'UserManagement',
                    settings: {
                        navId: 215,
                        level: 2,
                        order: 1,
                        orderTitle_hu: 'Felhasználó kezelés',
                        orderTitle_en: 'Editing User',
                        parentId: 5,
                        content: 'UserManagement',
                        activatorPermission: '"MEGTFELH"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.settings.userManagement')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'settings.userManagement',
                config: {
                    url: '/userManagement',
                    templateUrl: 'app/settings/userManagement/userManagement.html'
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    userSettingsController.$inject = ["$q", "log", "VIEW_DATA", "dataservice", "DOMAIN", "$timeout", "authenticationService", "$rootScope", "AUTH_EVENTS", "$scope", "gettextCatalog", "paramHelper", "$state", "$filter"];
    angular
        .module('app.settings.userManagement.userSettings')
        .controller('userSettingsController', userSettingsController);

    function userSettingsController($q, log, VIEW_DATA, dataservice, DOMAIN, $timeout, authenticationService, $rootScope, AUTH_EVENTS, $scope, gettextCatalog, paramHelper, $state, $filter) {
        var vm = this;
        $rootScope.vm = vm; // jshint ignore: line

        // Page title
        $rootScope.title = gettextCatalog.getString('UserSettings');

        // Dropdowns
        vm.sectionLeaderChangeEnable = false;
        vm.ageGroupList = [];
        vm.weightList = dataservice.range(VIEW_DATA.dropDownList.weight.downThreshold, VIEW_DATA.dropDownList.weight.upThreshold);
        vm.heightList = dataservice.range(VIEW_DATA.dropDownList.centimetre.downThreshold, VIEW_DATA.dropDownList.centimetre.upThreshold);

        // Default variables
        vm.noImg = DOMAIN.baseURL + DOMAIN.userImage;
        vm.photoUrl = vm.noImg;
        vm.passwordAgain = undefined;
        vm.recordPerPageList = $rootScope.gridPageSizes;
        vm.formData = {
            id: undefined,
            name: undefined,
            email: false,
            password: undefined,
            fileData: null,
            fileName: null,
            contact: undefined,
            country: undefined,
            city: undefined,
            birthDate: undefined,
            citizenship: undefined,
            mothersName: undefined,
            height: undefined,
            weight: undefined,
            otherInformation: undefined,
            gridRecordPerPage: undefined
        };
        vm.bounds = {};
        vm.bounds.left = 0;
        vm.bounds.right = 0;
        vm.bounds.top = 0;
        vm.bounds.bottom = 0;
        vm.cropDialogTitle = gettextCatalog.getString('ChooseImageTitle');

        vm.changeHeight = changeHeight;
        vm.changeWeight = changeWeight;
        vm.closeCropDialog = closeCropDialog;
        vm.openCropDialog = openCropDialog;
        vm.doneCropDialog = doneCropDialog;
        vm.sectionLeader = false;

        vm.selectedItems = [0, 1];
        vm.saveUser = saveUser;
        // Image cropper variables
        vm.cropper = {};
        vm.cropper.sourceImage = null;
        vm.cropper.croppedImage = null;
        vm.cropDialogTitle = gettextCatalog.getString('ChooseImageTitle');

        vm.types = [];
        vm.recordPerPageSelect = recordPerPageSelect;

        vm.deleteImg = deleteImg;

        activate();

        function activate() {
            $q.all([authenticationService.getRight('SAJATADATMODOSIT'),
                authenticationService.getRight('MODFELH')]).then(function (results) {
                if (results[0] !== true) {
                    log.permissionError(true);
                } else {
                    vm.LIMITEDUSER = !results[1];
                    if (results[1] !== true) {
                        document.getElementById('generalFieldset').disabled = true;
                        document.getElementById('personalFieldset').disabled = true;
                    }
                    vm.userId = authenticationService.getAuthData().id;
                    vm.modifyPermission = results[0];
                    getUser(vm.userId);
                }
            });
        }

        function getUser(userId) {
            return dataservice.getUserDataMin(userId)
                .then(function (data) {
                    angular.element('#sex').ejDropDownList('selectItemByValue', data.retValue.ferfib);
                    data.retValue.birthDate = $filter('datetimeFilter')(data.retValue.birthDate);
                    vm.formData = data.retValue;

                    if (vm.formData.fileName && vm.formData.fileName != 'no_image.png') {
                        vm.photoUrl = DOMAIN.baseURL + DOMAIN.profileImgBaseUrl + vm.formData.fileName;
                    } else {
                        vm.photoUrl = vm.noImg;
                    }
                    vm.sectionLeaderChangeEnable = true;

                    angular.element('#GridRowNB').ejDropDownList('selectItemByValue', vm.formData.gridRecordPerPage);
                    $timeout(function () {
                        $scope.$apply();
                    }, 100);
                });
        }

        function recordPerPageSelect(args) {
            vm.formData.gridRecordPerPage = args.value;
        }

        function changeHeight(args) {
            vm.formData.height = args.value;
        }

        function changeWeight(args) {
            vm.formData.weight = args.value;
        }

        function saveUser() {
            if (vm.modifyPermission) {
                // a syncfusion direktívák miatt
                $scope.$broadcast('submitted');
                if ($scope.form.$valid === false && !vm.LIMITEDUSER) {
                    log.errorMsg(gettextCatalog.getString('RequiredFieldsError'), gettextCatalog.getString('FillTheRequiredFields'));
                } else {
                    if (vm.formData.password != '') {
                        if (vm.formData.password != vm.passwordAgain) {
                            log.errorMsg(gettextCatalog.getString('PasswordsDontMatch'));
                            return;
                        }
                    }

                    // kép küldése, ha választott
                    if (angular.element('#fileName').val() !== '' && vm.cropper.croppedImage !== null) {
                        vm.formData.fileData = vm.cropper.croppedImage;
                        vm.formData.fileName = angular.element('#fileName').val();
                    }
                    dataservice.modifyUserMin(vm.formData).then(function (data) {
                        if (data) {
                            var currentId = parseInt(authenticationService.getAuthData().id);
                            if (currentId === vm.formData.id) {
                                $rootScope.$broadcast(AUTH_EVENTS.refreshProfilePic, data.image);
                            }
                            paramHelper.setParams([{'gridRecordPerPage': vm.formData.gridRecordPerPage}]);
                            $rootScope.pageSettings.pageSize = parseInt(vm.formData.gridRecordPerPage);
                            log.successMsg('UserModified');
                            $rootScope.back();
                        }
                    });
                }
            } else {
                log.permissionError();
            }
        }

        function openCropDialog() {
            angular.element('#dialogContainer').css('visibility', 'visible');
            angular.element('#cropDialog').ejDialog('open');
        }

        function closeCropDialog() {
            angular.element('#dialogContainer').css('visibility', 'hidden');
            angular.element('#cropDialog').ejDialog('close');
        }

        function doneCropDialog() {
            vm.photoUrl = vm.cropper.croppedImage;
            angular.element('#cropDialog').ejDialog('close');
        }

        function deleteImg() {
            swal({
                title: gettextCatalog.getString('DeleteProfileImg'),
                text: gettextCatalog.getString('AreYouSureYouWantToDeleteTheProfileImg'),
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: gettextCatalog.getString('Yes'),
                cancelButtonText: gettextCatalog.getString('No')
            }).then(function (isConfirm) {
                if (isConfirm.value) {
                    angular.element('#fileName').val('');
                    vm.formData.fileName = 'oldDeleted';
                    vm.photoUrl = vm.noImg;
                    $scope.$apply();
                }
            });
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.settings.userManagement.userSettings')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'settings.userManagement.userSettings',
                config: {
                    url: '/userSettings',
                    templateUrl: 'app/settings/userManagement/userSettings/userSettings.html',
                    controller: 'userSettingsController',
                    controllerAs: 'vm',
                    title: 'UserSettings'
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    UserRightsController.$inject = ["dataservice", "log", "authenticationService", "gettextCatalog", "$rootScope", "$q", "paramHelper"];
    angular
        .module('app.settings.userRights')
        .controller('UserRightsController', UserRightsController);

    function UserRightsController(dataservice, log, authenticationService, gettextCatalog, $rootScope, $q, paramHelper) {
        var vm = this;
        $rootScope.vm = vm;

        // Page title
        $rootScope.title = gettextCatalog.getString('UserRights');

        vm.userGroupList = [];
        vm.selectedUserGroup = -1;
        vm.changeEventActive = false;
        vm.defaultUserGroup = undefined;

        // public functions
        vm.userGroupDataBound = userGroupDataBound;
        vm.userGroupSelect = userGroupSelect;
        vm.groupRightsChange = groupRightsChange;

        vm.accessRights = [];
        vm.checkedIndices = [];

        activate();

        function activate() {
            $q.all([authenticationService.getRight('MEGTFELHJOG')]).then(function (results) {
                if (results[0] !== true) {
                    log.permissionError(true);
                } else {
                    getUserGroupDropDownList().then(function () {
                        paramHelper.getParams([], ['usergroupid']).then(function (results) {
                            if (results.usergroupid) {
                                vm.selectedUserGroup = results.usergroupid;
                                vm.defaultUserGroup = results.usergroupid;
                                paramHelper.removeParam('usergroupid');
                            }
                        });
                    });
                }
            });
        }

        // Jogosultsági csoportok lekérése
        function getUserGroupDropDownList() {
            return dataservice.getUserGroupDropDownList()
                .then(function (data) {
                    vm.userGroupList = data.itemsList;
                    angular.element('#userGroupDropDown').ejDropDownList('selectItemByValue', 6);
                });
        }

        // Jogok lekérése
        function getAccessRights() {
            dataservice.getAccessRights().then(function (data) {
                vm.accessRights = data.itemsList;
                getAndSetUserGroupRights(vm.selectedUserGroup);
            });
        }

        function userGroupDataBound() {
            if (vm.defaultUserGroup) {
                angular.element('#userGroupDropDown').ejDropDownList('selectItemByValue', vm.defaultUserGroup);
                vm.selectedUserGroup = vm.defaultUserGroup;
            } else {
                angular.element('#userGroupDropDown').ejDropDownList('selectItemByValue', vm.userGroupList[0].value);
                vm.selectedUserGroup = vm.userGroupList[0].value;
            }
            if (vm.userGroupList.length >= 1) {
                getAccessRights();
            }
        }

        // Jogosultsági csoport kiválasztás esemény
        function userGroupSelect(selectedGroup) {
            vm.changeEventActive = false;
            if (vm.accessRights.length > 0) {
                getAndSetUserGroupRights(selectedGroup.value);
            }
        }

        // Beállított jogosuoltságok lekérése és beállítása
        function getAndSetUserGroupRights(selectedUserGroup) {
            return dataservice.getUserGroupRights(selectedUserGroup).then(function (data) {
                // ListBox takarítása
                ejListBoxEnable();
                vm.checkedIndices = [];
                vm.changeEventActive = false; // change refresh disable

                // Jogosultságok indexének megkeresése
                angular.forEach(data.itemsList, function (right) {
                    vm.checkedIndices.push(vm.accessRights.findIndex(function (item, index) {
                        return item.value === this.IdJog ? index : false;
                    }, right));
                });

                // Jogosultságok beállítása
                angular.element('#groupRightsList').ejListBox({checkedIndices: vm.checkedIndices});
                vm.changeEventActive = true; // change refresh enable
            });
        }

        // ListBox elemek aktiválása
        function ejListBoxEnable() {
            for (var index = 0; index < vm.accessRights.length; index++) {
                angular.element('#groupRightsList').ejListBox('enableItemByIndex', index);
            }
        }

        // Jogosultság checkbox megváltozik
        function groupRightsChange(changed) {
            if (vm.changeEventActive) {
                var shortName = changed.data.shortName;
                var name = changed.text;
                switch (shortName) {
                    case 'SPORTOLO':
                        setSpecialPermission(gettextCatalog.getString('SZULOjog') + ', ' + gettextCatalog.getString('ADMINjog') + ', ' + gettextCatalog.getString('EDZOjog') + ', ' + gettextCatalog.getString('GAZDASAGIjog') + ', ' + gettextCatalog.getString('TECHIGAZGATOjog') + ', ' + ' ' + gettextCatalog.getString('SZAKOSZTVEZjog'), changed);
                        break;
                    case 'SZULO':
                        setSpecialPermission(gettextCatalog.getString('SPORTOLOjog') + ', ' + gettextCatalog.getString('ADMINjog') + ', ' + gettextCatalog.getString('EDZOjog') + ', ' + gettextCatalog.getString('GAZDASAGIjog') + ', ' + gettextCatalog.getString('TECHIGAZGATOjog') + ', ' + ' ' + gettextCatalog.getString('SZAKOSZTVEZjog'), changed);
                        break;
                    case 'ADMIN':
                    case 'EDZO':
                    case 'GAZDASAGI':
                    case 'TECHIGAZGATO':
                    case 'SZAKOSZTVEZ':
                        setSpecialPermission(gettextCatalog.getString('SZULOjog') + ', ' + gettextCatalog.getString('SPORTOLOjog'), changed);
                        break;
                    default:
                        setUserGroupRight(vm.selectedUserGroup, changed);
                }
            }
        }

        function setUserGroupRight(selectedUserGroup, item) {
            vm.changeEventActive = false;
            return dataservice.setUserGroupRight(selectedUserGroup, item.value, item.isChecked).then(function (data) {
                if (data.retValue !== true) {
                    if (item.isChecked) {
                        angular.element('#groupRightsList').ejListBox('uncheckItemByIndex', item.index);
                    } else {
                        angular.element('#groupRightsList').ejListBox('checkItemByIndex', item.index);
                    }
                }
                vm.changeEventActive = true;
            }, function () {
                if (item.isChecked === true) {
                    $('#groupRightsList').ejListBox('uncheckItemByIndex', item.index);
                } else {
                    $('#groupRightsList').ejListBox('checkItemByIndex', item.index);
                }
                vm.changeEventActive = true;
            });
        }

        function setSpecialPermission(name, changed) {
            if (changed.isChecked) {
                swal({
                    title: gettextCatalog.getString('DoYouWantToSetSpecielPermission?'),
                    text: gettextCatalog.getString('YourPermissionWillBe') + ' ' + name,
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#DD6B55',
                    confirmButtonText: gettextCatalog.getString('YesSetPermission'),
                    cancelButtonText: gettextCatalog.getString('Cancel')
                    //closeOnConfirm: false,
                    //closeOnCancel: false
                }).then(function (isConfirm) {
                    if (!isConfirm.value) {
                        angular.element('#groupRightsList').ejListBox('uncheckItemByIndex', changed.index);
                    } else if (isConfirm.value) {
                        angular.element('#groupRightsList').ejListBox('checkItemByIndex', changed.index);
                        setUserGroupRight(vm.selectedUserGroup, changed).then(function () {
                            getAndSetUserGroupRights(vm.selectedUserGroup);
                        });
                    }
                });
            } else {
                setUserGroupRight(vm.selectedUserGroup, changed);
            }
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.settings.userRights')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'settings.userRights',
                config: {
                    url: '/userRights',
                    templateUrl: 'app/settings/userRights/userRights.html',
                    controller: 'UserRightsController',
                    controllerAs: 'vm',
                    title: 'UserRights',
                    settings: {
                        navId: 235,
                        level: 2,
                        order: 3,
                        orderTitle_hu: 'Felhasználói csoport jogosultságok',
                        orderTitle_en: 'Group Permissions',
                        parentId: 5,
                        content: 'UserRights',
                        activatorPermission: '"MEGTFELHJOG"'
                    }
                }
            }
        ];
    }
})();

(function () {
    'use strict';

    UsersBelongingToAthletesController.$inject = ["logger", "log", "dataservice", "$q", "$rootScope", "gettextCatalog", "authenticationService", "$scope", "paramHelper", "$state"];
    angular
        .module('app.settings.usersBelongingToAthletes')
        .controller('UsersBelongingToAthletesController', UsersBelongingToAthletesController);

    function UsersBelongingToAthletesController(logger, log, dataservice, $q, $rootScope, gettextCatalog, authenticationService, $scope, paramHelper, $state) {
        var vm = this; $rootScope.vm = vm;
        $rootScope.title = gettextCatalog.getString('UsersBelongingToAthletes');

        activate();

        vm.columns = [
            {field: 'UserName', headerText: gettextCatalog.getString('UserName'), textAlign: 'left', template: '#usbetoattemplateDataColumn1'},
            {field: 'UserTeljesNev', headerText: gettextCatalog.getString('UserFullName'), textAlign: 'left'},
            {field: 'szerep', headerText: gettextCatalog.getString('szerep'), textAlign: 'left'},
            {field: 'csoport', headerText: gettextCatalog.getString('User group'), textAlign: 'left'},
            {field: 'szakosztaly', headerText: gettextCatalog.getString('PrimarySection'), textAlign: 'left'},
            {field: 'korosztaly', headerText: gettextCatalog.getString('PrimaryAgeGroup'), textAlign: 'left'},
            {field: 'SportoloNeve', headerText: gettextCatalog.getString('SportoloNeve'), textAlign: 'left', template: '#usbetoattemplateDataColumn2'},
            {field: 'Link', headerText: gettextCatalog.getString('unlinkUserFromAthlete'), textAlign: 'left', template: '#usbetoattemplateDataColumn3'}
        ];

        var grid = new ej2.grids.Grid({
            dataSource: [],
            toolbar: $rootScope.toolbarItems,
            allowPaging: true,
            allowSorting: true,
            allowTextWrap: true,
            allowExcelExport: true,
            locale: 'hu-HU',
            gridLines: 'Both',
            pageSettings: $rootScope.pageSettings,
            columns: vm.columns,
            beforePrint: $rootScope.beforePrintGrid,
            printComplete: $rootScope.printCompleteGrid,
            rowDataBound: function (args) {
                $rootScope.compile(args.row, $scope);
            },
            actionComplete: function (args) {
                if (args.requestType === 'paging' || args.requestType === 'refresh') {
                    $rootScope.compile($('#Grid'), $scope);
                }
            },
            rowSelecting: function () {
                grid.clearSelection();
            },
            checkBoxChange: function (args) {
                $rootScope.checkBoxChangeOnlyOne(args, grid);
            }
        });
        grid.appendTo('#Grid');
        grid.toolbarClick = function (args) {
            $rootScope.toolbarClick(args, grid);
        };
        vm.sectionId = 0;
        vm.sectionIdValue = undefined;
        vm.ageGroupId = 0;
        vm.ageGroupIdValue = undefined;
        vm.sectionList = [];
        vm.ageGroupList = [];
        vm.sectionDataBound = sectionDataBound;
        vm.sectionSelect = sectionSelect;
        vm.ageGroupDataBound = ageGroupDataBound;
        vm.ageGroupSelect = ageGroupSelect;
        vm.unlinkUserFromAthlete = unlinkUserFromAthlete;
        vm.openUser = openUser;
        vm.openAthlete = openAthlete;
        vm.getParentAndAthleteUsers = getParentAndAthleteUsers;

        function activate() {
            $q.all([authenticationService.getRight('SPTARTMEGT'), paramHelper.getParams([], ['usersBelongingToAthletes.SzakosztalyId', 'usersBelongingToAthletes.KorcsoportId'])]).then(function (result) {
                if (result[0] !== true) {
                    log.permissionError(true);
                } else {
                    getSections();
                }
                if (result[1]['usersBelongingToAthletes.SzakosztalyId']) {
                    vm.sectionId = result[1]['usersBelongingToAthletes.SzakosztalyId'];
                }
                if (result[1]['usersBelongingToAthletes.KorcsoportId']) {
                    vm.ageGroupId = result[1]['usersBelongingToAthletes.KorcsoportId'];
                }
            });
        }

        function getSections() {
            dataservice.sectionDropDownList().then(function (data) {
                vm.sectionList = data.itemsList;
            });
        }

        function sectionDataBound() {
            if (vm.sectionList.length === 1) {
                vm.sectionId = vm.sectionList[0].value;
                angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.sectionList[0].value);
            } else {
                angular.element('#sectionDropDown').ejDropDownList('selectItemByValue', vm.sectionId);
            }
        }

        function sectionSelect(args) {
            vm.sectionId = args.value;
            getAgeGroups();
        }

        function getAgeGroups() {
            dataservice.ageGroupDropDownList(vm.sectionId).then(function (data) {
                vm.ageGroupList = data.itemsList;
                if (data.itemsList.length > 1) {
                    vm.ageGroupList.unshift({value: -1, text: gettextCatalog.getString('All')});
                }
            });
        }

        function ageGroupDataBound() {
            if (vm.ageGroupList.length > 0) {
                angular.element('#ageGroupDropDown').ejDropDownList('selectItemByValue', vm.ageGroupList[0].value);
            }
        }

        function ageGroupSelect(args) {
            vm.ageGroupId = args.value;
        }

        function getParentAndAthleteUsers() {
            $scope.$broadcast('submitted');
            if ($scope.form.$valid === false) {
                log.errorMsg('RequiredFieldsError');
            }
            paramHelper.setParams([
                {'usersBelongingToAthletes.SzakosztalyId': vm.sectionId},
                {'usersBelongingToAthletes.KorosztalyId': vm.ageGroupId},
            ]);
            dataservice.getParentAndAthleteUsers(vm.sectionId, vm.ageGroupId).then(function (data) {
                grid.dataSource = data.itemsList;
            });
        }

        function unlinkUserFromAthlete(userid, sportoloid, szerep) {
            if (szerep == 0) {
                swal({
                    title: gettextCatalog.getString('Are you sure you want to unlink and delete the selected user?'),
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#DD6B55',
                    confirmButtonText: gettextCatalog.getString('Yes'),
                    cancelButtonText: gettextCatalog.getString('Cancel'),
                }).then(function (isConfirm) {
                    if (isConfirm.value) {
                        return dataservice.unlinkUserFromAthlete(userid, sportoloid).then(function () {
                            log.successMsg(gettextCatalog.getString('UserUnlinkedAndDeleted'));
                            getParentAndAthleteUsers();
                        });
                    }
                });
            } else {
                swal({
                    title: gettextCatalog.getString('Are you sure you want to unlink the selected user?'),
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#DD6B55',
                    confirmButtonText: gettextCatalog.getString('Yes'),
                    cancelButtonText: gettextCatalog.getString('Cancel'),
                }).then(function (isConfirm) {
                    if (isConfirm.value) {
                        return dataservice.unlinkUserFromAthlete(userid, sportoloid).then(function () {
                            log.successMsg(gettextCatalog.getString('UserUnlinked'));
                            getParentAndAthleteUsers();
                        });
                    }
                });
            }
        }

        function openUser(userid) {
            $q.all([authenticationService.getRight('MODFELH'), authenticationService.getRight('MEGTFELH')]).then(function (results) {
                if (results[0] || results[1]) {
                    paramHelper.setParams([{'newUser.userId': userid},
                    {'usersBelongingToAthletes.SzakosztalyId': vm.sectionId},
                    {'usersBelongingToAthletes.KorosztalyId': vm.ageGroupId}]);
                    $state.go('settings.userManagement.modifyUser');
                } else {
                    log.permissionError();
                }
            });
        }

        function openAthlete(id) {
            $q.all([authenticationService.getRight('MEGTSPORTLIST')]).then(function (results) {
                if (results[0]) {
                    paramHelper.setParams([{'athleteModify.sportoloId': id},
                    {'usersBelongingToAthletes.SzakosztalyId': vm.sectionId},
                    {'usersBelongingToAthletes.KorosztalyId': vm.ageGroupId}]);
                    $state.go('athletes.athletesManagement.athleteModify.dataSheet');
                } else {
                    log.permissionError();
                }
            });
        }
    }
})();

(function () {
    'use strict';

    appRun.$inject = ["routerHelper"];
    angular
        .module('app.settings.usersBelongingToAthletes')
        .run(appRun);

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [
            {
                state: 'settings.usersBelongingToAthletes',
                config: {
                    url: '/usersBelongingToAthletes',
                    templateUrl: 'app/settings/usersBelongingToAthletes/usersBelongingToAthletes.html',
                    controller: 'UsersBelongingToAthletesController',
                    controllerAs: 'vm',
                    title: 'UsersBelongingToAthletes',
                    settings: {
                        navId: 245,
                        level: 2,
                        order: 4,
                        orderTitle_hu: 'Sportolókhoz tartozó felhasználók',
                        orderTitle_en: 'Users Belonging to Athletes',
                        parentId: 5,
                        content: 'UsersBelongingToAthletes',
                        activatorPermission: '"SPTARTMEGT"'
                    }
                }
            }
        ];
    }
})();

angular.module('app.core').run(['$templateCache', function($templateCache) {$templateCache.put('app/administration/administration.html','<div ui-view></div>');
$templateCache.put('app/athleteDashboard/athleteDashboard.html','<section class=mainbar><div class=container-fluid><div class=row><div class=widget><div class=widget-head><h2 class=page-title>{{title}}</h2></div><div class=widget-content></div><div class=widget-foot><div class=clearfix></div></div></div></div></div></section>');
$templateCache.put('app/athletes/athletes.html','<div ui-view></div>');
$templateCache.put('app/business/business.html','<div ui-view></div>');
$templateCache.put('app/core/404.html','<section id=dashboard-view class=mainbar><div class=container-fluid><div class=row><div class=widget><div class=widget-head><h2 class=page-title>"404 - Page Not Found"</h2></div><div class="widget-content text-center text-info"><div class=container-fluid>Az \xE1ltalad keresett oldal nem tal\xE1lhat\xF3!<br><a data-ng-click=back()>Vissza</a> | <a data-ng-if="vm.userPermission === \'5\'" ui-sref=parentDashboard>Kezd\u0151lap</a> <a data-ng-if="vm.userPermission !== \'5\'" ui-sref=dashboard>Kezd\u0151lap</a></div></div><div class=widget-foot><div class=clearfix></div></div></div></div></div></section>');
$templateCache.put('app/dashboard/dashboard.html','<section id=dashboard-view class=mainbar><div class=container-fluid><div class=row style="margin-top: 2em;" data-ng-if="vm.datagridExpiringDocuments.length>0 && vm.FOLAPLEJARO"><div class=col-md-12><div class="panel panel-danger"><div class=panel-heading><h2 class=page-title translate>Documents expiring inside a month</h2></div><div class=panel-body><div><div id=gridExpiringDocuments name=gridExpiringDocuments class=slim-grid></div></div></div></div></div></div><div class=row style="margin-top: 2em;" ng-if=vm.FOLAPELFOGADASRAVAROJELENLETIK><div class=col-md-12><div class=widget><div class=widget-head><h2 class=page-title translate>Monthly presence summarising ones waiting for approval</h2></div><div class=widget-content ng-if="vm.dataMonthlyAttendance.length > 0"><div id=gridMonthlyAttendance name=gridMonthlyAttendance class=slim-grid></div></div><div ng-if="vm.dataMonthlyAttendance.length === 0"><label translate>There are not monthly presence summarising ones waiting for approval.</label></div></div></div></div><div class=row style="margin-top: 2em;" ng-if=vm.FOLAPELFOGADASRAVAROHAVITERVEK><div class=col-md-12><div class=widget><div class=widget-head><h2 class=page-title translate>Monthly competition plans waiting for approval</h2></div><div ng-if="vm.dataMonthlyCompetitionPlan.length > 0" class=widget-content allow-collapse=true><div id=gridMonthlyMonthlyCompetitionPlan name=gridMonthlyMonthlyCompetitionPlan class=slim-grid></div></div><div ng-if="vm.dataMonthlyCompetitionPlan.length === 0"><label translate>There are not monthly competition plans waiting for approval.</label></div></div></div></div><div class=row style="margin-top: 2em;" ng-if=vm.FOLAPELFOGADASRAVAROHETITERV><div class=col-md-12><div class=widget><div class=widget-head><h2 class=page-title translate>Weekly competition plans waiting for approval</h2></div><div ng-if="vm.dataWeeklyCompetitionPlan.length > 0" class=widget-content allow-collapse=true><div id=gridWeeklyCompetitionPlan name=gridWeeklyCompetitionPlan class=slim-grid></div></div><div ng-if="vm.dataWeeklyCompetitionPlan.length === 0"><label translate>There are no weekly competition plans waiting for approval.</label></div></div></div></div><div class=row style="margin-top: 2em;" ng-if=vm.FOLAPELFOGADASRAVAROEVESTERVEK><div class=col-md-12><div class=widget><div class=widget-head><h2 class=page-title translate>Year competition plans waiting for approval</h2></div><div ng-if="vm.dataYearlyCompetitionPlan.length>0" class=widget-content allow-collapse=true><div id=gridYearlyCompetitionPlan name=gridYearlyCompetitionPlan class=slim-grid></div></div><div ng-if="vm.dataYearlyCompetitionPlan.length===0"><label translate>There are not year competition plans waiting for approval.</label></div></div></div></div><div class=row style="margin-top: 2em;" ng-if=vm.FOLAPKIFIZETETLENTAGDIJAK><div class=col-md-12><div class=widget><div class=widget-head><h2 class=page-title translate>Sport service fees not paid</h2></div><div ng-if="vm.dataUnpaidFees.length>0" class=widget-content allow-collapse=true><div id=gridUnpaidFees name=gridUnpaidFees></div></div><div ng-if="vm.dataUnpaidFeesTrainer.length>0" class=widget-content allow-collapse=true><div id=gridUnpaidFeesTrainer name=gridUnpaidFeesTrainer class=slim-grid></div></div><div ng-if="vm.dataUnpaidFees.length===0 && vm.dataUnpaidFeesTrainer.length===0"><label translate>There are not sport service fees not paid.</label></div></div></div></div><div id=folaplinkek data-ng-if=vm.FOLAPLINKEK><div class=row style="margin-top: 2em;"><div class=col-md-12><div id=popup><div id=newlink ej-dialog e-height=450px e-minheight=450px e-maxheight=450px e-title={{vm.LinkData}} e-showoninit=false e-enablemodal=true e-enableresize=false e-allowkeyboardnavigation=false e-closeonescape=true e-isresponsive=true e-content=#popup e-enableanimation=true e-showroundedcorner=false><div class=col-md-12><form name=form class=popup><cts-text-box name=LinkAddress label=LinkAddress data-ng-model=vm.newLink.Hivatkozas></cts-text-box><cts-text-box name=LinkDesc label=LinkDesc data-ng-model=vm.newLink.Link></cts-text-box><cts-text-area name=linkComment label=LinkComment data-ng-model=vm.newLink.Megjegyzes></cts-text-area></form><hr><div class=form-group style="text-align: center;"><button class="btn cts-button" id=done data-ng-click=vm.newLinkSave() type=button translate>Save</button> <button class="btn cts-button cancel" id=cancel data-ng-click=vm.closenewLinksWindow() type=button translate>Cancel</button></div></div></div></div><div id=popup><div id=editLinks ej-dialog e-height=450px e-minheight=450px e-maxheight=500px e-title={{vm.LinkData}} e-showoninit=false e-enablemodal=true e-enableresize=false e-allowkeyboardnavigation=false e-closeonescape=true e-isresponsive=true e-content=#popup e-enableanimation=true e-showroundedcorner=false e-target=#folaplinkek><div class=col-md-12><form name=form class=popup><cts-text-box name=LinkAddress label=LinkAddress data-ng-model=vm.editedLink.Hivatkozas></cts-text-box><cts-text-box name=LinkDesc label=LinkDesc data-ng-model=vm.editedLink.Link></cts-text-box><cts-text-area name=linkComment label=LinkComment data-ng-model=vm.editedLink.Megjegyzes></cts-text-area></form><hr><div class=form-group style="text-align: center;"><button class="btn cts-button" id=done data-ng-click=vm.editLinkSave() type=button translate>Save</button> <button class="btn cts-button cancel" id=cancel data-ng-click=vm.closeeditLinksWindow() type=button translate>Cancel</button></div></div></div></div><div class=widget><div class=widget-head><h2 class=page-title translate>Useful links</h2></div><div class=widget-content><form class=filter name=form><div class=button-wrapper><button id=addNewLinkbtn class=cts-button style=float:right; ej-button e-click=vm.addNewLink data-ng-if=vm.FOLAPLINKEK translate>AddNewLink</button></div></form><div id=gridLinks name=gridLinks class=slim-grid></div></div></div></div></div></div></div></section><script id=templateColumnETHetiEdzo type=text/x-template><a data-ng-click="vm.goToNewUser(${edzoid})">${edzo}</a></script><script id=datemplateDataColumn1 type=text/x-template><a data-ng-click="vm.goToNewUser(${EdzoId})">${EdzoNeve}</a></script><script id=datemplateDataColumn2 type=text/x-template><a data-ng-click="vm.goToNewAthletes(${SportoloId})">${SportoloNeve}</a></script><script id=datemplateDataColumn3 type=text/x-template><a data-ng-click="vm.goToNewUser(${IdEdzo})">${Edzo}</a></script><script id=datemplateDataColumn4 type=text/x-template><a data-ng-click="vm.goToMonthlyAttendance(${Id})"><i class="fa fa-eye" style="font-size: 1.5em;"></i></a></script><script id=datemplateDataColumn5 type=text/x-template><a data-ng-click="vm.goToNewUser(${EdzoId})">${Edzo}</a></script><script id=datemplateDataColumn6 type=text/x-template><a data-ng-click="vm.goToMonthlyCompetitonPlan(${Id}, ${EdzoId}, ${SzakosztalyId})" ><i class="fa fa-eye" style="font-size: 1.5em;"></i></a></script><script id=datemplateDataColumn7 type=text/x-template><a data-ng-click="vm.goToNewUser(${EdzoId})">${Edzo}</a></script><script id=datemplateDataColumn8 type=text/x-template><a data-ng-click="vm.goToAnnualSeasonPlan(${Id})"><i class="fa fa-eye" style="font-size: 1.5em;"></i></a></script><script id=datemplateDataColumn9 type=text/x-template><a data-ng-click="vm.goToNewUser(${EdzoId})">${EdzoNeve}</a></script><script id=datemplateDataColumn10 type=text/x-template><a data-ng-click="vm.openSportServiceFeeRegister(${SzakosztalyId},${EdzoId})" translate>PayIn</a></script><script id=datemplateDataColumn11 type=text/x-template><a data-ng-click="vm.openSportServiceFeeArrears(${SzakosztalyId},${EdzoId})"><i class="fa fa-eye" style="font-size: 1.5em;"></i></a></script><script id=datemplateDataColumn12 type=text/x-template><a data-ng-click="vm.goToNewAthletes(${SportoloId})">${SportoloNeve}</a></script><script id=datemplateDataColumn13 type=text/x-template><div class="form-group cts-form-group chkbox"> <input id="${SportoloId}" ej-checkbox e-enabled="false" e-checked="${Aktiv}"> </div></script><script id=datemplateDataColumn14 type=text/x-template><a href="${Link}" target="_blank">${Hivatkozas}</a></script><script id=datemplateDataColumn15 type=text/x-template><a data-ng-click="vm.editLink(${Id})" translate>Edit</a> &nbsp;&nbsp; <a data-ng-click="vm.deleteLink(${Id})" translate>Delete</a></script><script id=templateColumnETHetiLink type=text/x-template><a data-ng-click="vm.openWeeklyPlan(${tervid})"><i class="fa fa-eye" style="font-size: 1.5em;"></i></a></script><div id=printDialog><report report-name=TFolapReport report-parameters=vm.reportParameters></report></div>');
$templateCache.put('app/login/login.html','<div ng-if=!vm.isAuthenticated class=profile-background><div class=loginInfo><div class=HappyNewYearText><translate>HappyNewYear</translate></div><div class=NewYearChange><span>201</span> <span class=LastYear>8</span> <span class=NewYear>9</span><div class=Balloon></div></div><div class=Fireworks><div class=f1><span><i></i></span> <span><i></i></span> <span><i></i></span></div><div class=f2><span><i></i></span> <span><i></i></span> <span><i></i></span></div><div class=f3><span><i></i></span> <span><i></i></span> <span><i></i></span></div><div class=f4><span><i></i></span> <span><i></i></span> <span><i></i></span></div></div></div><div class=loginShowDiv><div class=login-center><div class=container-fluid><div class="card-container card"><span class=loginTitle><translate>AccountLogin</translate></span> <span data-ng-show=vm.sessionTimeout class=sessionTimeout>Munkamenet lej\xE1rt!</span><form role=form class=form-horizontal name=vm.frmLogin id=frmLogin novalidate data-ng-submit=vm.login()><div class=form-group id=wrongUnameOrPwd style="display: none; color: #A94442"><span class="col-xs-12 text-center" style="font-size: 0.8em;"><i class="glyphicon glyphicon-exclamation-sign"></i><translate>UnknownUser</translate></span></div><div class=form-group><input id=loginName type=text class="form-control baseInputStyle" ng-enter=vm.login() placeholder="{{\'Username\'|translate}}" name=loginName data-ng-change=vm.changeLoginName() data-ng-model=vm.loginName autofocus ng-maxlength=30 ng-required-err-type=requiredUserName data-ng-blur=vm.loginFocusOut() required></div><div class=form-group><input id=password type=password class="form-control baseInputStyle password" data-ng-change=vm.changeLoginName() ng-enter=vm.login() placeholder="{{\'Password\'|translate}}" name=password data-ng-model=vm.password ng-required-err-type=requiredPassword required></div><div class=form-group><input id=availableLang class=dropDownlist placeholder="{{\'Languages\'|translate}}" ej-dropdownlist e-change=vm.changeLanguage e-template=vm.languageTemplate e-width=100% e-datasource=vm.availableLanguages></div><div class=form-group><button class="btn btn-primary col-xs-12" type=submit translate>Login</button></div></form></div></div></div></div><script type=text/javascript>\r\n        //Background Image Move on Mousemove - START\r\n        /*\r\n        $(\'.profile-background\').mousemove(function (e) {\r\n            console.log(e);\r\n            var moveX = (e.pageX * -1 / 15);\r\n            var moveY = (e.pageY * -1 / 15);\r\n            $(this).css(\'background-position\', moveX + \'px \' + moveY + \'px\')\r\n        });\r\n        */\r\n        //Background Image Move on Mousemove - END\r\n        $(function() {\r\n            var movementStrength = 25;\r\n            var height = movementStrength / $(window).height();\r\n            var width = movementStrength / $(window).width();\r\n            $(".profile-background").mousemove(function(e){\r\n                console.log(e);\r\n                var pageX = e.pageX - ($(window).width() / 2);\r\n                var pageY = e.pageY - ($(window).height() / 2);\r\n                var newvalueX = width * pageX * -1 - 25;\r\n                var newvalueY = height * pageY * -1 - 50;\r\n                $(\'.profile-background\').css("background-position", newvalueX+"px "+newvalueY+"px");\r\n            });\r\n        });\r\n    </script></div>');
$templateCache.put('app/layout/shell.html','<div ng-controller="ShellController as vm"><header data-ng-if=vm.isAuthenticated class=clearfix><nav class="navbar navbar-fixed-top navbar-inverse"><div class=container-fluid style="padding: 0 15px 0 0;"><h1 class=navbar-brand style="overflow: hidden"><a data-ng-click=vm.goToDashboard() style="overflow: hidden;display: block;"><div class=cts-logo style="overflow: hidden; float: left; text-align: center; margin: 0; padding: 0;"><img class=logo src=images/logo_min.png style="float:left; height: 55px; margin: 5px 0 0 0; padding: 0 0 0 0; vertical-align: top;"><img src=images/felirat_min.png style="float:left; height: 55px; margin: 5px 0 0 0; padding: 0 15px 0 0; vertical-align: top;"> <img class=logo ng-src=/images/partnerlogo.png onerror="this.style.display=\'none\'" style="position:absolute; top:0; left:50%; height: 75px; margin: 5px 0 0 0; padding: 0 0 0 0; vertical-align: top; transform: translate(-50%,0);" data-ng-class="{\'small-logo\': vm.partnerLogoSmall === true}"></div></a></h1><div class=pull-right><ul class="nav pull-right"><li class=dropdown><a class=dropdown-toggle data-toggle=dropdown aria-haspopup=true aria-expanded=false id=userNav><span><img class="img-rounded profile-image" id=profile-img ng-src={{vm.pictureBasePath}}{{vm.authData.picture}}></span>{{vm.authData.userFullName}}<span class=caret></span></a> <a class=dropdown-toggle data-toggle=dropdown aria-haspopup=true aria-expanded=false id=userNavSM><span><img class="img-rounded profile-image" id=profile-img ng-src={{vm.pictureBasePath}}{{vm.authData.picture}}></span></a><ul class=dropdown-menu><li><a data-ng-click=vm.goToProfile()><i class="glyphicon glyphicon-user"></i><translate>Profile</translate></a></li><li><a ng-click=vm.openPasswordDialog()><i class="glyphicon glyphicon-lock"></i><translate>ChangePassword</translate></a></li><li role=separator class=divider></li><li><a data-ng-click=vm.logout()><i class="glyphicon glyphicon-log-out"></i><translate>Logout</translate></a></li></ul></li></ul></div></div></nav></header><section style="overflow: inherit;"><div data-ng-class="{sideMenuOpened: sideMenuOpened, sideMenuClosed: !sideMenuOpened}" class=sidebar-include data-ng-if=vm.isAuthenticated ng-include="\'app/layout/sidebar.html\'" style="position: fixed; z-index: 10; float: left; height: 100%;"></div><div id=mainContent ui-view data-ng-class="{sideMenuOpenedContent: sideMenuOpened, sideMenuClosedContent: !sideMenuOpened}"></div></section></div>');
$templateCache.put('app/layout/sidebar.html','<div ng-controller="SidebarController as vm" style="height: 100%;"><ht-sidebar when-done-animating=vm.sidebarReady()><div><button data-ng-class="{sideMenuOpenedButton: !sideMenuOpened, sideMenuClosedButton: sideMenuOpened}" class=btn style="position:absolute; border-radius: 0; top: 0px; right: 0px; width: 50px; height: 43px; background-color: #333333; z-index: 999;" data-ng-click=sideMenuClose()><img src=images/menuClose.png style="width: 100%;"></button> <button data-ng-class="{sideMenuOpenedButton: sideMenuOpened, sideMenuClosedButton: !sideMenuOpened}" class=btn data-ng-click=sideMenuOpen() style="position: absolute; top: 0px; right: -40px; background-color: #333333; height: 43px; width: 50px;"><img src=images/menuOpen.png style="width: 100%;"></button></div><div class=sidebar-filler></div><div class=sidebar-dropdown><a href=# translate>Menu</a></div><div class=sidebar-inner style="height: calc(100% - 64px); overflow-x: hidden;overflow-y: auto;"><ul class=navi><li class={{vm.isCurrent(r)}} data-ng-repeat="r in navRoutes" data-ng-class="{\'open\': vm.level1Open === r.settings.navId, \'disabledMenuItem\': r.settings.activatorPermission && !vm.checkPermissionGroup(r.settings.activatorPermission)}" data-ng-if="((vm.permission == 6 && r.settings.content == \'AthleteDashboard\') || (vm.permission == 5 && r.settings.content == \'ParentDashboard\')) || ((vm.permission >= 5 && r.settings.permission && vm.checkPermissionGroup(r.settings.activatorPermission)) || (vm.permission < 5 && (!r.settings.permission || (r.settings.activatorPermission && vm.checkPermissionGroup(r.settings.activatorPermission))))) && ((!r.settings || !r.settings.activatorPermission ) || !INAKTIVMENUREJTES || (vm.authenticated === true && vm.rights && vm.checkPermissionGroup(r.settings.activatorPermission)))"><a data-ng-click="vm.menuItemClicked(r, 1)">{{r.settings.content|translate}} <span class=counterBadge ng-if="r.settings.content == \'MessageCenter\' && vm.messageCount > 0">{{vm.messageCount}}</span></a><ul data-ng-if="r.settings.childRoutes !== undefined && r.settings.childRoutes.length !== 0"><li class="fade-selection-animation {{vm.isCurrent(s)}}" data-ng-repeat="s in r.settings.childRoutes" data-ng-class="{\'open\': vm.level2Open === s.settings.navId, \'disabledMenuItem\': s.settings.activatorPermission && (!vm.checkPermissionGroup(s.settings.activatorPermission) || vm.rights.indexOf(s.settings.activatorPermission) < 0)}" data-ng-if="(!vm.noEducationalFee || (vm.noEducationalFee && s.settings.permission != 7)) && ((!s.settings || !s.settings.activatorPermission ) || !INAKTIVMENUREJTES || (vm.authenticated === true && vm.rights && vm.rights.indexOf(s.settings.activatorPermission) >= 0))"><a data-ng-click="vm.menuItemClicked(s, 2)">{{s.settings.content|translate}}</a><ul data-ng-if="s.settings.childRoutes !== undefined && s.settings.childRoutes.length !== 0"><li class="fade-selection-animation {{vm.isCurrent(t)}}" data-ng-repeat="t in s.settings.childRoutes" data-ng-class="{\'disabledMenuItem\': vm.rights.indexOf(t.settings.activatorPermission) < 0}" data-ng-if="((!t.settings || !t.settings.activatorPermission ) || !INAKTIVMENUREJTES || (vm.authenticated === true && vm.rights && vm.rights.indexOf(t.settings.activatorPermission) >= 0))"><a data-ng-click="vm.menuItemClicked(t, 3)">{{t.settings.content|translate}}</a></li></ul></li></ul></li></ul></div></ht-sidebar></div>');
$templateCache.put('app/messageCenter/messageCenter.html','<section class=mainbar><div class=container-fluid><div class=row><div class=widget><div ui-view></div></div></div></div></section>');
$templateCache.put('app/other/other.html','<section class=mainbar><div class=container-fluid><div class=row><div class=widget><div ui-view></div></div></div></div></section>');
$templateCache.put('app/paint/paint.html','<section class=mainbar><div class=container-fluid><div class=row><div class=widget><div class=widget-head><h2 class=page-title>{{title}}</h2></div><div class="widget-content paint"><div><form class=filter novalidate name=form enctype=multipart/form-data><div class=button-wrapper style="padding: 0;"><button data-ng-click=vm.deleteAll() style="background: url(\'/images/new.png\'); background-size: cover; width: 40px; height: 40px; margin-top: 1.25em;"></button> <button data-ng-click=vm.save() data-ng-disabled=!vm.checkBoxEnabled style="background: url(\'/images/save.png\'); background-size: cover; width: 40px; height: 40px; margin-top: 1.25em;"></button> <button data-ng-click=vm.deletePaint() data-ng-disabled=!vm.deleteEnabled style="background: url(\'/images/trash.png\'); background-size: cover; width: 40px; height: 40px; margin-top: 1.25em;"></button></div><cts-dropdown-list name=sectionDropDown label=Section value=vm.sectionId datasource=vm.sectionList databound=vm.sectionDataBound select=vm.sectionSelect validation-rules="{required: true}" enabled=vm.sectionDropDownEnabled></cts-dropdown-list><cts-dropdown-list name=agegroupDropDown label=AgeGroup value=vm.agegroupId datasource=vm.ageGroupList databound=vm.agegroupDataBound select=vm.agegroupSelect validation-rules="{required: false}" enabled=vm.sectionDropDownEnabled></cts-dropdown-list><cts-text-box name=paintName label=Name data-ng-model=vm.paintName validation-rules="{required: true}" owndisabled=!vm.sectionDropDownEnabled></cts-text-box><cts-check-box name=publicCheckBox label="{{\'Public\'|translate}}" checked=vm.public change=vm.publicCheckboxChanged enabled=vm.checkBoxEnabled></cts-check-box></form></div><div class="row pull-left" style="margin-bottom: 0.5em;"><button data-ng-click=vm.undo() data-ng-disabled="!(vm.stateId > 0) || !vm.checkBoxEnabled" style="background: url(\'/images/undo.png\'); background-size: cover; width: 40px; height: 40px;"></button> <button data-ng-click=vm.redo() data-ng-disabled="!vm.redoEnable || !vm.checkBoxEnabled" style="background: url(\'/images/redo.png\'); background-size: cover; width: 40px; height: 40px;"></button> <button style="background: url(\'/images/pipe.png\'); background-size: cover; width: 20px; height: 40px; border-color: #fff !important;cursor: default;"></button> <button data-ng-class="{active: vm.activeMode === 0}" data-ng-click=vm.pen() data-ng-disabled="vm.activeMode === 0 || !vm.checkBoxEnabled" style="background: url(\'/images/pen.png\'); background-size: cover; width: 40px; height: 40px;"></button> <button data-ng-class="{active: vm.activeMode === 1}" data-ng-click=vm.select() data-ng-disabled="vm.activeMode === 1 || !vm.checkBoxEnabled" style="background: url(\'/images/select.png\'); background-size: cover; width: 40px; height: 40px;"></button> <button data-ng-click=vm.deleteObject() data-ng-disabled="vm.activeMode === 0 || !vm.clickedElement || !vm.checkBoxEnabled" style="background: url(\'/images/delete.png\'); background-size: cover; width: 40px; height: 40px;"></button> <button data-ng-class="{active: vm.activeMode === 2}" data-ng-click=vm.resizeObject() data-ng-disabled="(vm.activeMode === 2 || !vm.checkBoxEnabled) || vm.enabledResizeRotate === false" style="background: url(\'/images/resize.png\'); background-size: cover; width: 40px; height: 40px;"></button> <button data-ng-class="{active: vm.activeMode === 3}" data-ng-click=vm.rotateObject() data-ng-disabled="(vm.activeMode === 3 || !vm.checkBoxEnabled) || vm.enabledResizeRotate === false" style="background: url(\'/images/rotate.png\'); background-size: cover; width: 40px; height: 40px;"></button> <button class=white-border data-ng-click=vm.addRect() data-ng-disabled="vm.activeMode === 0 || !vm.checkBoxEnabled" style="background: url(\'/images/rect.png\'); background-size: cover; width: 40px; height: 40px;"></button> <button class=white-border data-ng-click=vm.addTriangle() data-ng-disabled="vm.activeMode === 0 || !vm.checkBoxEnabled" style="background: url(\'/images/triangle.png\'); background-size: cover; width: 40px; height: 40px;"></button> <button class=white-border data-ng-click=vm.addPentagon() data-ng-disabled="vm.activeMode === 0 || !vm.checkBoxEnabled" style="background: url(\'/images/sokszog.png\'); background-size: cover; width: 40px; height: 40px;"></button> <button class=white-border data-ng-click=vm.addCircle() data-ng-disabled="vm.activeMode === 0 || !vm.checkBoxEnabled" style="background: url(\'/images/circle.png\'); background-size: cover; width: 40px; height: 40px;"></button> <button class=white-border data-ng-click=vm.addLine() data-ng-disabled="vm.activeMode === 0 || !vm.checkBoxEnabled" style="background: url(\'/images/line.png\') no-repeat center center; background-size: contain; width: 40px; height: 40px;"></button> <button class=white-border data-ng-click=vm.addDashedLine() data-ng-disabled="vm.activeMode === 0 || !vm.checkBoxEnabled" style="background: url(\'/images/dline.png\') no-repeat center center; background-size: contain; width: 40px; height: 40px;"></button> <button class=white-border data-ng-click=vm.addDashedLine2() data-ng-disabled="vm.activeMode === 0 || !vm.checkBoxEnabled" style="background: url(\'/images/dline2.png\') no-repeat center center; background-size: contain; width: 40px; height: 40px;"></button> <button class=white-border data-ng-click=vm.addArrow() data-ng-disabled="vm.activeMode === 0 || !vm.checkBoxEnabled" style="background: url(\'/images/arrow.png\') no-repeat center center; background-size: contain; width: 40px; height: 40px;"></button> <button class=white-border data-ng-click=vm.addSine() data-ng-disabled="vm.activeMode === 0 || !vm.checkBoxEnabled" style="background: url(\'/images/sine.png\') no-repeat center center; background-size: contain; width: 40px; height: 40px;"></button> <button class=white-border data-ng-click=vm.addFootball() data-ng-disabled="vm.activeMode === 0 || !vm.checkBoxEnabled" style="background: url(\'/images/football_ball.png\'); background-size: cover; width: 40px; height: 40px;"></button> <button class=white-border data-ng-click=vm.addBasketball() data-ng-disabled="vm.activeMode === 0 || !vm.checkBoxEnabled" style="background: url(\'/images/basketball_ball.png\'); background-size: cover; width: 40px; height: 40px;"></button> <button class=white-border data-ng-click=vm.addHandball() data-ng-disabled="vm.activeMode === 0 || !vm.checkBoxEnabled" style="background: url(\'/images/handball_ball.png\'); background-size: cover; width: 40px; height: 40px;"></button> <button class=white-border data-ng-click=vm.addHockeyPuck() data-ng-disabled="vm.activeMode === 0 || !vm.checkBoxEnabled" style="background: url(\'/images/hockey_puck.png\') no-repeat center center; background-size: 20px 20px; width: 40px; height: 40px;"></button> <button class=white-border data-ng-click=vm.addCone() data-ng-disabled="vm.activeMode === 0 || !vm.checkBoxEnabled" style="background: url(\'/images/cone.png\'); background-size: cover; width: 40px; height: 40px;"></button> <button class=white-border data-ng-click=vm.addGoal1() data-ng-disabled="vm.activeMode === 0 || !vm.checkBoxEnabled" style="background: url(\'/images/goal1.png\'); background-size: cover; width: 20px; height: 40px;"></button></div><div class=row style="clear: both;"><div class=pull-left><input type=text id=Background></div><div class=pull-left style="margin-left: 1em;"><input type=text id=LineSize></div><div class=pull-left style="margin-left: 1em;"><input type=text id=Color></div><div class=pull-left style="margin-left: 1em;"><input type=text id=TextColor></div><button class=pull-left data-ng-click=vm.getColor() data-ng-disabled="vm.activeMode === 0 || !vm.clickedElement || (vm.clickedElement && !vm.clickedElement.color) || !vm.checkBoxEnabled" style="background: url(\'/images/eyedropper.png\'); background-size: cover; width: 40px; height: 40px; margin-top: 0; margin-left: 1em;"></button><form style="margin-left: 0.5em; overflow: hidden; float: left;"><input type=text class=form-control data-ng-model=vm.label data-ng-disabled="vm.clickedElement === null" style="width: 20em; margin-top: 0.3em; float: left;" placeholder="{{\'Label\'|translate}}"> <button data-ng-click=vm.changedLabel() data-ng-disabled="vm.clickedElement === null || !vm.checkBoxEnabled" style="background: url(\'/images/save.png\'); background-size: cover; width: 40px; height: 40px; float: left; margin-left: 0.5em;"></button></form></div><div class=row style="margin-bottom: 0.5em;"><button data-ng-click=vm.saveAnimation() data-ng-disabled=!vm.checkBoxEnabled style="background: url(\'/images/saveAnimation.png\'); background-size: cover; width: 40px; height: 40px;"></button> <button data-ng-click=vm.addAnimation() data-ng-disabled=!vm.checkBoxEnabled style="background: url(\'/images/addAnimation.png\'); background-size: cover; width: 40px; height: 40px;"></button> <button data-ng-click=vm.deleteAnimation() data-ng-disabled=!vm.checkBoxEnabled style="background: url(\'/images/deleteAnimation.png\'); background-size: cover; width: 40px; height: 40px;"></button> <button data-ng-click=vm.play(3) data-ng-disabled="vm.animationStates.length < 2 || !vm.checkBoxEnabled" style="background: url(\'/images/play1.png\'); background-size: cover; width: 40px; height: 40px;"></button> <button data-ng-click=vm.play(2) data-ng-disabled="vm.animationStates.length < 2 || !vm.checkBoxEnabled" style="background: url(\'/images/play2.png\'); background-size: cover; width: 40px; height: 40px;"></button> <button data-ng-click=vm.play(1) data-ng-disabled="vm.animationStates.length < 2 || !vm.checkBoxEnabled" style="background: url(\'/images/play3.png\'); background-size: cover; width: 40px; height: 40px;"></button></div><div class=row style="margin-bottom: 0.5em;"><button data-ng-click=vm.selectAnimation($index) data-ng-disabled=!vm.checkBoxEnabled data-ng-repeat="animation in vm.animationStates track by $index" style="width: 40px; height: 40px;">{{$index + 1}}</button></div><div id=canvasWrapper><canvas id=canvas style="background-color: #FAFAFA;">This text is displayed if your browser does not support HTML5 Canvas.</canvas></div><div class=col-sm-12 style="text-align: center"><button type=reset class=cts-button ej-button e-click=back translate>Back</button></div></div><div class=widget-foot><div class=clearfix></div></div></div></div></div></section>');
$templateCache.put('app/parentDashboard/parentDashboard.html','<section class=mainbar><div class=container-fluid><div class=row><div class=widget><div class=widget-head><h2 class=page-title>{{title}}</h2></div><div class=widget-content><cts-dropdown-list name=athletesofuser label=Athlete datasource=vm.athletesofuser value=vm.selectedAthlete ng-if=vm.SZULO></cts-dropdown-list><div class=button-wrapper><button class=cts-button data-ng-if="vm.selectedAthlete>0 || vm.SPORTOLO" ej-button e-click=vm.modifyAthleteData translate>ModifyAthleteData</button></div></div><div class=widget-foot><div class=clearfix></div></div></div></div></div></section>');
$templateCache.put('app/parentMonthlyAttendance/parentMonthlyAttendance.html','<section class=mainbar><div class=container-fluid><div class=row><div class=widget><div class=widget-head><h2 class=page-title>{{title}}</h2></div><div class=widget-content><div class=row><h2 translate>HianyzasBejelentese</h2><form name=form class=filter><cts-dropdown-list name=athleteDropDown value=vm.athleteId label=Athlete datasource=vm.athleteList databound=vm.athleteDataBound select=vm.athleteSelect validation-rules="{required: true}"></cts-dropdown-list><cts-date-picker name=datepicker label=HianyzasNapja value=vm.dateValue validation-rules="{required: true}"></cts-date-picker><div class=button-wrapper><button class=cts-button ej-button e-click=vm.saveDate translate>Igazolom</button></div></form></div><div class=row><div class=col-xs-12><h2 translate>Hianyzasok</h2><div id=Grid name=Grid></div></div></div></div><div class=widget-foot><div class=clearfix></div></div></div></div></div></section>');
$templateCache.put('app/reports/reports.html','<section class=mainbar><div class=container-fluid><div class=row><div class=widget><div ui-view></div></div></div></div></section>');
$templateCache.put('app/search/search.html','<div ui-view></div>');
$templateCache.put('app/schedule/schedule.html','<section class=mainbar><div class=container-fluid><div class=row><div id=popup><div id=directory ej-dialog e-height=690px e-minheight=690px e-maxheight=690px e-width=900px e-title={{vm.EditMessageText}} e-showoninit=false e-enablemodal=true e-enableresize=false e-allowkeyboardnavigation=false e-closeonescape=true e-isresponsive=true e-content=#popup e-enableanimation=true e-showroundedcorner=false><div id=toolbarPopup ej-toolbar e-datasource=vm.toolbarPopupItems e-fields-tooltiptext=tooltiptext e-enable-separator=true e-fields-id=empid e-fields-spritecssclass=spriteCss e-click=vm.toolbarPopupClick></div><div id=defaultTab ej-tab><ul><li><a href=#users><img src=../images/Uzenetek/Users.png><span translate>Users</span></a></li><li><a ng-hide=vm.SZULOUSER href=#athletes><img src=../images/Uzenetek/athletes.png><span translate>Athletes</span></a></li><li><a ng-hide="vm.SZULOUSER || vm.SPORTOLOUSER" href=#parents><img src=../images/Uzenetek/Parents.png><span translate>Parents</span></a></li><li><a ng-hide="vm.SZULOUSER || vm.SPORTOLOUSER" href=#usergroups><img src=../images/Uzenetek/UserGroups.png><span translate>UserGroups</span></a></li><li><a ng-hide="vm.SZULOUSER || vm.SPORTOLOUSER" href=#sections><img src=../images/Uzenetek/sections.png><span translate>SectionsCoaches</span></a></li><li><a ng-hide="vm.SZULOUSER || vm.SPORTOLOUSER" href=#teams><img src=../images/Uzenetek/Team.png><span translate>Team\'s athletes</span></a></li><li><a ng-hide="vm.SZULOUSER || vm.SPORTOLOUSER" href=#teamParents><img src=../images/Uzenetek/Parents.png><span translate>Team\'s athletes parents</span></a></li><li><a ng-hide="vm.SZULOUSER || vm.SPORTOLOUSER" href=#ageGroups><img src=../images/Uzenetek/agegroup.png><span translate>Agegroup\'s athletes</span></a></li><li><a ng-hide="vm.SZULOUSER || vm.SPORTOLOUSER" href=#ageGroupsParents><img src=../images/Uzenetek/Parents.png><span translate>Agegroup\'s athletes parents</span></a></li></ul><div id=users><form name=formUser class=popup><div class=row><div class=col-xs-4><div class=row style=margin-top:20px;><cts-horizontal-check-box name=chkSelectAllUsers label=SelectAll checked=false change=vm.userCheckboxChanged></cts-horizontal-check-box></div></div><div class=col-xs-8><cts-text-box ng-model=vm.searchUserParam label=Search change=vm.searchUser></cts-text-box></div></div><div class=row><cts-list-box name=usersListBox style=margin-top:-25px label css-class=scroller-fix datasource=vm.usersList show-checkbox=true check-change=vm.usersListChecked></cts-list-box></div></form></div><div id=athletes ng-hide=vm.SZULOUSER><form name=formAthlete class=popup><div class=row><div class=col-xs-4><div class=row style=margin-top:20px;><cts-horizontal-check-box name=chkSelectAllAthletes label=SelectAll checked=false change=vm.athleteCheckboxChanged></cts-horizontal-check-box></div></div><div class=col-xs-8><cts-text-box ng-model=vm.searchAthleteParam label=Search change=vm.searchAthlete></cts-text-box></div></div><div class=row><cts-list-box name=athletesListBox style=margin-top:-25px label css-class=scroller-fix datasource=vm.athletesList show-checkbox=true></cts-list-box></div></form></div><div id=usergroups><form name=formUserGroup class=popup><div class=row><div class=col-xs-4><div class=row style=margin-top:20px;><cts-horizontal-check-box name=chkSelectAllUserGroup label=SelectAll checked=false change=vm.usersGroupCheckboxChanged></cts-horizontal-check-box></div></div><div class=col-xs-8><cts-text-box ng-model=vm.searchUserGroupParam label=Search change=vm.searchUserGroup></cts-text-box></div></div><div class=row><cts-list-box name=usersGroupListBox style=margin-top:-25px label css-class=scroller-fix datasource=vm.usersGroupList show-checkbox=true></cts-list-box></div></form></div><div id=sections><form name=formSections class=popup><div class=row><div class=col-xs-4><div class=row style=margin-top:20px;><cts-horizontal-check-box name=chkSelectAllSections change=vm.sectionsCheckboxChanged label=SelectAll checked=false></cts-horizontal-check-box></div></div><div class=col-xs-8><cts-text-box ng-model=vm.searchSectionParam change=vm.searchSection label=Search></cts-text-box></div></div><div class=row><cts-list-box name=sectionsListBox datasource=vm.sectionsList style=margin-top:-25px label css-class=scroller-fix show-checkbox=true></cts-list-box></div></form></div><div id=parents><form name=formParents class=popup><div class=row><div class=col-xs-4><div class=row style=margin-top:20px;><cts-horizontal-check-box name=chkSelectAllParents change=vm.parentsCheckboxChanged label=SelectAll checked=false></cts-horizontal-check-box></div></div><div class=col-xs-8><cts-text-box ng-model=vm.searchParentParam change=vm.searchParent label=Search></cts-text-box></div></div><div class=row><cts-list-box name=parentsListBox datasource=vm.parentsList style=margin-top:-25px label css-class=scroller-fix show-checkbox=true></cts-list-box></div></form></div><div id=teams><form name=formTeams class=popup><div class=row><div class=col-xs-4><div class=row style=margin-top:20px;><cts-horizontal-check-box name=chkSelectAllTeams change=vm.teamsCheckboxChanged label=SelectAll checked=false></cts-horizontal-check-box></div></div><div class=col-xs-8><cts-text-box ng-model=vm.searchTeamsAthletesParam change=vm.searchTeamsAthletes label=Search></cts-text-box></div></div><div class=row><cts-list-box name=teamsAthletesListBox datasource=vm.teamsAthletesList style=margin-top:-25px label css-class=scroller-fix show-checkbox=true></cts-list-box></div></form></div><div id=teamParents><form name=formTeamParents class=popup><div class=row><div class=col-xs-4><div class=row style=margin-top:20px;><cts-horizontal-check-box name=chkSelectAllTeamParents change=vm.teamParentsCheckboxChanged label=SelectAll checked=false></cts-horizontal-check-box></div></div><div class=col-xs-8><cts-text-box ng-model=vm.searchTeamsParentParam change=vm.searchTeamsParents label=Search></cts-text-box></div></div><div class=row><cts-list-box name=teamParentsListBox datasource=vm.teamParentsList style=margin-top:-25px label css-class=scroller-fix show-checkbox=true></cts-list-box></div></form></div><div id=ageGroups><form name=formAgeGroups class=popup><div class=row><div class=col-xs-4><div class=row style=margin-top:20px;><cts-horizontal-check-box name=chkSelectAllAgeGroups change=vm.ageGroupsCheckboxChanged label=SelectAll checked=false></cts-horizontal-check-box></div></div><div class=col-xs-8><cts-text-box ng-model=vm.searchAgeGroupsAthletesParam change=vm.searchAgeGroupAthletes label=Search></cts-text-box></div></div><div class=row><cts-list-box name=ageGroupsListBox datasource=vm.ageGroupsList style=margin-top:-25px label css-class=scroller-fix show-checkbox=true></cts-list-box></div></form></div><div id=ageGroupsParents><form name=formAgeGroupsParents class=popup><div class=row><div class=col-xs-4><div class=row style=margin-top:20px;><cts-horizontal-check-box name=chkSelectAllAgeGroupsParents change=vm.ageGroupsParentsCheckboxChanged label=SelectAll checked=false></cts-horizontal-check-box></div></div><div class=col-xs-8><cts-text-box ng-model=vm.searchAgeGroupsParentParam change=vm.searchAgeGroupParents label=Search></cts-text-box></div></div><div class=row><cts-list-box name=ageGroupsParentsListBox datasource=vm.ageGroupsParentsList style=margin-top:-25px label css-class=scroller-fix show-checkbox=true></cts-list-box></div></form></div></div></div></div><div class=widget><ht-widget-header title={{title}} text-id=scheduleHelp right-text=rightText></ht-widget-header><div class=widget-content><form class=filter name=form><div class=row><cts-dropdown-list name=sectionDropDown label=Section value=vm.sectionId datasource=vm.sectionList databound=vm.sectionDataBound select=vm.sectionSelect ng-show=vm.sectionDropDownVisible></cts-dropdown-list><cts-dropdown-list name=ageGroupDropDown label=AgeGroup datasource=vm.ageGroupList databound=vm.ageGroupDataBound select=vm.ageGroupSelect></cts-dropdown-list><cts-check-box name=trainingCheckBox label=OnlyTrainings checked=vm.training change=vm.trainingCheckboxChanged style="width: 250px;"></cts-check-box></div><div class=row><div class=button-wrapper><button type=button class=cts-button ej-button e-click=vm.print translate>Print</button> <button type=button class=cts-button ej-button e-click=vm.exportAllToIcs translate>Export</button></div></div></form><script id=apptemplate type=text/x-template>{{if Categorize !== "2"}} <div class="max-size-workcells" style="background-color: {{:Color}}; color:{{:FontColor}}"> {{else}} <div class="max-size-workcells" style="background-color: #169c5f; color:#ffffff;"> {{/if}} <div style="float:left; margin: 0 5px 0 0;"> {{if AllDay === false}} {{:(\'0\' + StartTime.getHours()).slice(-2) + ":" + (\'0\' + StartTime.getMinutes()).slice(-2)}} {{/if}} </div> <div> {{if Subject !== \'\'}} <div style="text-overflow: ellipsis;overflow: hidden;">{{:Subject}}</div> {{else}} <div>N\xE9vtelen esem\xE9ny</div> {{/if}} </div> </div> </div></script><div id=Schedule1></div><div style="margin-top: 1rem; text-align: center;"><span data-ng-style="{\'background-color\': vm.trainingColor}" style="display: inline-block; margin-left: 0.25rem; padding: 0.25rem; color: #ffffff; min-width: 115px; text-align: center;">{{vm.trainingText}}</span> <span data-ng-repeat="(key, value) in vm.sections" data-ng-style="{\'background-color\': value.color, \'color\': value.color2}" style="display: inline-block; margin: 0.25rem; padding: 0.25rem; min-width: 115px; text-align: center;">{{value.text}}</span></div></div><div class=widget-foot><div class=clearfix></div></div></div></div></div></section>');
$templateCache.put('app/settings/settings.html','<div ui-view></div>');
$templateCache.put('app/administration/annualSeasonPlan/annualSeasonPlan.html','<section class=mainbar><div class=container-fluid><div class=row><div class=widget><div ui-view></div></div></div></div></section>');
$templateCache.put('app/administration/assetManagement/assetManagement.html','<section class=mainbar><div class=container-fluid><div class=row><div class=widget><ht-widget-header title={{title}} text-id=assetManagementHelp right-text=rightText></ht-widget-header><div class=widget-content><div class=col-md-12><label translate>AssetTypes</label><form class=filter><div style="overflow: hidden;"><div class=button-wrapper><button class=cts-button ej-button e-click=vm.AddAssetType id=AddAssetTypeBtn e-enabled=vm.AddAssetTypeEnabled translate>AddAssetType</button> <button class=cts-button ej-button e-click=vm.EditAssetType id=EditAssetTypeBtn e-enabled=vm.EditAssetTypeEnabled translate>EditAssetType</button> <button class=cts-button ej-button e-click=vm.DeleteAssetType id=DeleteAssetTypeBtn e-enabled=vm.DeleteAssetTypeEnabled translate>DeleteAssetType</button></div></div></form><div id=TypeGrid2></div></div><div class=col-md-12 style="margin-top: 25px;"><label translate>Assets</label><form class=filter><div style="overflow: hidden;"><cts-dropdown-list name=ShowAssets datasource=vm.assetFilterList value=vm.filter select=vm.filterSelect></cts-dropdown-list><div class=button-wrapper><button class=cts-button ej-button e-click=vm.AddAsset id=AddAssetBtn e-enabled=vm.AddAssetEnabled translate>Add</button> <button class=cts-button ej-button e-click=vm.EditAsset id=EditAssetBtn e-enabled=vm.EditAssetEnabled translate>Edit</button> <button class=cts-button ej-button e-click=vm.DeleteAsset id=DeleteAssetBtn e-enabled=vm.DeleteAssetEnabled translate>Delete</button> <button class=cts-button ej-button e-click=vm.UndeleteAsset id=UndeleteAssetBtn e-enabled=vm.UndeleteAssetEnabled translate>UndeleteAsset</button> <button class=cts-button ej-button e-click=vm.IssuePopup id=IssueBtn e-enabled=vm.IssueEnabled translate>Issue</button> <button class=cts-button ej-button e-click=vm.TakeBack id=TakeBackBtn e-enabled=vm.TakeBackEnabled translate>TakeBack</button> <button class=cts-button ej-button e-click=vm.SelectAll id=SelectAllBtn translate>SelectAll</button> <button class=cts-button ej-button e-click=vm.clearSelection id=UnselectAllBtn translate>UnselectAll</button></div></div></form><div id=AssetGrid2></div></div></div></div></div></div></section><div id=popup><div id=issueDialog ej-dialog e-title="Eszk\xF6z\xF6k kiad\xE1sa" e-showoninit=false e-enablemodal=true e-enableresize=false e-minheight=445px e-maxheight=635px e-allowkeyboardnavigation=false e-width=900px e-closeonescape=true e-isresponsive=true e-enableanimation=true e-showroundedcorner=false e-target=.mainbar style="overflow: auto !important;"><div class=row><div style="width:50%; float:left;"><cts-dropdown-list name=IssueTo label=IssueTo datasource=vm.athletecoachList value=vm.issueto select=vm.issueToSelect></cts-dropdown-list></div><div style="width:50%; float:right;" ng-if=vm.issueToAthlete><cts-dropdown-list name=sectionorusergroup label=Section value=vm.groupId datasource=vm.groupList databound=vm.dropdownDataBound select=vm.groupSelect></cts-dropdown-list></div><div style="width:50%; float:right;" ng-if=vm.issueToCoach><cts-dropdown-list name=sectionorusergroup label=UserGroup value=vm.groupId datasource=vm.groupList databound=vm.dropdownDataBound select=vm.groupSelect></cts-dropdown-list></div><div style=margin-bottom:20px; ng-if=vm.chooseEnabled><button class=cts-button ej-button e-click=vm.Issue id=IssueBtn2 translate>Issue</button></div></div><div class=row><div id=AthleteGrid2 ng-show=vm.issueToAthlete style=width:800px></div><div id=CoachGrid2 ng-show=vm.issueToCoach style=width:800px></div></div></div></div>');
$templateCache.put('app/administration/competitiveMonthlyPlan/competitiveMonthlyPlan.html','<section class=mainbar><div class=container-fluid><div class=row><div class=widget><div ui-view></div></div></div></div></section>');
$templateCache.put('app/administration/awayBudgetPlan/awayBudgetPlan.html','<section class=mainbar><div class=container-fluid><div class=row><div class=widget><div ui-view></div></div></div></div></section>');
$templateCache.put('app/administration/dailyAttendance/dailyAttendance.html','<style>\r\n.presence1_off {\r\n    background: url(../images/dailyAttendance/presence1_off.png);\r\n    width: 48px;\r\n    height: 48px;\r\n    background-size: 48px 48px;\r\n}\r\n\r\n.presence1_on {\r\n    background: url(../images/dailyAttendance/presence1_on.png);\r\n    width: 48px;\r\n    height: 48px;\r\n    background-size: 48px 48px;\r\n}\r\n\r\n.presence2_off {\r\n    background: url(../images/dailyAttendance/presence2_off.png);\r\n    width: 48px;\r\n    height: 48px;\r\n    background-size: 48px 48px;\r\n}\r\n\r\n.presence2_on {\r\n    background: url(../images/dailyAttendance/presence2_on.png);\r\n    width: 48px;\r\n    height: 48px;\r\n    background-size: 48px 48px;\r\n}\r\n\r\n.presence3_off {\r\n    background: url(../images/dailyAttendance/presence3_off.png);\r\n    width: 48px;\r\n    height: 48px;\r\n    background-size: 48px 48px;\r\n}\r\n\r\n.presence3_on {\r\n    background: url(../images/dailyAttendance/presence3_on.png);\r\n    width: 48px;\r\n    height: 48px;\r\n    background-size: 48px 48px;\r\n}\r\n\r\n.presence1 {\r\n    background: url(../images/dailyAttendance/presence1.png);\r\n    width: 48px;\r\n    height: 48px;\r\n    background-size: 48px 48px;\r\n}\r\n\r\n.presence0 {\r\n    background: url(../images/dailyAttendance/presence0.png);\r\n    width: 48px;\r\n    height: 48px;\r\n    background-size: 48px 48px;\r\n}\r\n\r\n.absence0 {\r\n    background: url(../images/dailyAttendance/absence0.png);\r\n    width: 48px;\r\n    height: 48px;\r\n    background-size: 48px 48px;\r\n}\r\n\r\n.absence1 {\r\n    background: url(../images/dailyAttendance/absence1.png);\r\n    width: 48px;\r\n    height: 48px;\r\n    background-size: 48px 48px;\r\n}\r\n\r\n.competition0 {\r\n    background: url(../images/dailyAttendance/competition0.png);\r\n    width: 48px;\r\n    height: 48px;\r\n    background-size: 48px 48px;\r\n}\r\n\r\n.competition1 {\r\n    background: url(../images/dailyAttendance/competition1.png);\r\n    width: 48px;\r\n    height: 48px;\r\n    background-size: 48px 48px;\r\n}\r\n\r\n.holiday0 {\r\n    background: url(../images/dailyAttendance/holiday0.png);\r\n    width: 48px;\r\n    height: 48px;\r\n    background-size: 48px 48px;\r\n}\r\n\r\n.holiday1 {\r\n    background: url(../images/dailyAttendance/holiday1.png);\r\n    width: 48px;\r\n    height: 48px;\r\n    background-size: 48px 48px;\r\n}\r\n\r\n.sickness0 {\r\n    background: url(../images/dailyAttendance/sickness0.png);\r\n    width: 48px;\r\n    height: 48px;\r\n    background-size: 48px 48px;\r\n}\r\n\r\n.sickness1 {\r\n    background: url(../images/dailyAttendance/sickness1.png);\r\n    width: 48px;\r\n    height: 48px;\r\n    background-size: 48px 48px;\r\n}\r\n\r\n.injury0 {\r\n    background: url(../images/dailyAttendance/injury0.png);\r\n    width: 48px;\r\n    height: 48px;\r\n    background-size: 48px 48px;\r\n}\r\n\r\n.injury1 {\r\n    background: url(../images/dailyAttendance/injury1.png);\r\n    width: 48px;\r\n    height: 48px;\r\n    background-size: 48px 48px;\r\n}\r\n\r\n.proven0 {\r\n    background: url(../images/dailyAttendance/proven0.png);\r\n    width: 48px;\r\n    height: 48px;\r\n    background-size: 48px 48px;\r\n}\r\n\r\n.proven1 {\r\n    background: url(../images/dailyAttendance/proven1.png);\r\n    width: 48px;\r\n    height: 48px;\r\n    background-size: 48px 48px;\r\n}\r\n\r\n.dotdotdot {\r\n    background: url(../images/dailyAttendance/dotdotdot.png);\r\n    width: 48px;\r\n    height: 48px;\r\n    background-size: 48px 48px;\r\n}\r\n\r\n.clear {\r\n    background: url(../images/dailyAttendance/clear.png);\r\n    width: 48px;\r\n    height: 48px;\r\n    background-size: 48px 48px;\r\n}\r\n</style><section class=mainbar><div class=container-fluid><div class=row><div class=widget><ht-widget-header title={{title}} text-id=dailyAttendanceHelp right-text=rightText></ht-widget-header><div class=widget-content ng-click="vm.DDClick(-1,\'open\')"><form class=filter name=form><div class=row><cts-dropdown-list name=sectionDropDown label=Section value=vm.sectionId datasource=vm.sectionList databound=vm.sectionDataBound select=vm.sectionSelect validation-rules="{required: true}"></cts-dropdown-list><cts-dropdown-list data-ng-if=vm.allAgeGroupfill name=ageGroupDropDown label=AgeGroup value=vm.ageGroupId datasource=vm.ageGroupList databound=vm.ageGroupDataBound select=vm.ageGroupSelect validation-rules="{required: true}"></cts-dropdown-list><div class=button-wrapper><button class=cts-button ej-button e-click=vm.loadAttendance translate>ChooseIt</button> <button class=cts-button ej-button e-click=vm.refreshAthletes ng-if="vm.editedAttendance.fej.Id>0" translate>RefreshAthletes</button></div></div></form><br><div id=containerDiv class=container-fluid style=margin-bottom:0;><div class=col-lg-6><table class=table style="width: 100%"><tr ng-repeat="item in vm.editedAttendance.tetelek" ng-if=item.activeToday><td style="width: 100%;text-align: right;"><div style="vertical-align: center; margin-bottom: 1em; border:1px red;" id=IMG_{{item.IdSportolo}}><table style="vertical-align: center"><tr><td rowspan=2><img ng-src={{item.img}} height=96 class=img-rounded style="margin-right: 10px;"></td><td style="vertical-align: bottom; text-align: left; font-weight: bold;">{{item.SportoloNev}}</td></tr><tr><td style="vertical-align: top; text-align: left; font-style: italic; text-indent: 15px;">({{item.SzuletesiDatum}})</td></tr></table></div><div style="vertical-align: center"><label style=margin-left:0; ng-click="vm.iconClicked(item.RowNumber-1, vm.b.PRESENCE)" title={{vm.presenceText}}><div ng-if="item.selectedIcon <= vm.b.ABSENCE || item.selectedIcon == vm.b.NOTPRESSED" ng-click="vm.DDClick(item.IdSportolo,\'close\')"><div ng-if="item.today == \' \'"><div class=presence1_on ng-if="item.selectedIcon == vm.b.PRESENCE"></div><div class=presence0 ng-if="item.selectedIcon != vm.b.PRESENCE"></div></div><div ng-if="item.today == 1"><div class=presence1_on ng-if="item.selectedIcon == vm.b.PRESENCE"></div><div class=presence1_off ng-if="item.selectedIcon != vm.b.PRESENCE"></div></div><div ng-if="item.today == 2"><div class=presence2_on ng-if="item.selectedIcon == vm.b.PRESENCE"></div><div class=presence2_off ng-if="item.selectedIcon != vm.b.PRESENCE"></div></div><div ng-if="item.today == 3"><div class=presence3_on ng-if="item.selectedIcon == vm.b.PRESENCE"></div><div class=presence3_off ng-if="item.selectedIcon != vm.b.PRESENCE"></div></div></div><div ng-if="item.selectedIcon > vm.b.ABSENCE && item.selectedIcon != vm.b.NOTPRESSED" ng-click="vm.DDClick(item.IdSportolo,\'close\')"><div class=presence0></div></div></label><label style=margin-left:1em; ng-click="vm.iconClicked(item.RowNumber-1, vm.b.ABSENCE)" title={{vm.absenceText}}><div class=absence1 ng-if="item.selectedIcon == vm.b.ABSENCE" ng-click="vm.DDClick(item.IdSportolo,\'close\')"></div><div class=absence0 ng-if="item.selectedIcon != vm.b.ABSENCE" ng-click="vm.DDClick(item.IdSportolo,\'close\')"></div></label><label class=dropdown style=margin-left:1em id=DDL{{item.IdSportolo}}><div aria-haspopup=true aria-expanded=true ng-click="vm.DDClick(item.IdSportolo,\'toggle\')"><div class=dotdotdot ng-if="item.selectedIcon <= vm.b.ABSENCE || item.selectedIcon == vm.b.NOTPRESSED"></div><div class=proven1 ng-if="item.selectedIcon == vm.b.PROVENABSENCE"></div><div class=competition1 ng-if="item.selectedIcon == vm.b.COMPETITION"></div><div class=sickness1 ng-if="item.selectedIcon == vm.b.SICKNESS"></div><div class=injury1 ng-if="item.selectedIcon == vm.b.INJURY"></div><div class=holiday1 ng-if="item.selectedIcon == vm.b.HOLIDAY"></div></div><ul class=dropdown-menu style="min-width: 0; left:-20px;"><li ng-click="vm.DDClick(item.IdSportolo,\'close\')"><a ng-click="vm.iconClicked(item.RowNumber-1, vm.b.PROVENABSENCE)" title={{vm.provenabsenceText}}><div class=proven0 ng-if="item.selectedIcon != vm.b.PROVENABSENCE"></div><div class=proven1 ng-if="item.selectedIcon == vm.b.PROVENABSENCE"></div></a></li><li ng-click="vm.DDClick(item.IdSportolo,\'close\')"><a ng-click="vm.iconClicked(item.RowNumber-1, vm.b.COMPETITION)" title={{vm.competitionText}}><div class=competition0 ng-if="item.selectedIcon != vm.b.COMPETITION"></div><div class=competition1 ng-if="item.selectedIcon == vm.b.COMPETITION"></div></a></li><li ng-click="vm.DDClick(item.IdSportolo,\'close\')"><a ng-click="vm.iconClicked(item.RowNumber-1, vm.b.SICKNESS)" title={{vm.sicknessText}}><div class=sickness0 ng-if="item.selectedIcon != vm.b.SICKNESS"></div><div class=sickness1 ng-if="item.selectedIcon == vm.b.SICKNESS"></div></a></li><li ng-click="vm.DDClick(item.IdSportolo,\'close\')"><a ng-click="vm.iconClicked(item.RowNumber-1, vm.b.INJURY)" title={{vm.injuryText}}><div class=injury0 ng-if="item.selectedIcon != vm.b.INJURY"></div><div class=injury1 ng-if="item.selectedIcon == vm.b.INJURY"></div></a></li><li ng-click="vm.DDClick(item.IdSportolo,\'close\')"><a ng-click="vm.iconClicked(item.RowNumber-1, vm.b.HOLIDAY)" title={{vm.holidayText}}><div class=holiday0 ng-if="item.selectedIcon != vm.b.HOLIDAY"></div><div class=holiday1 ng-if="item.selectedIcon == vm.b.HOLIDAY"></div></a></li></ul></label></div></td></tr></table><div ng-if=vm.thereIsIncativeAthlete><hr><label translate>AthletesPresentOnMonthlyAttendanceButIncativeToday</label><table class="table table-striped" style="width: 100%"><tr ng-repeat="item in vm.editedAttendance.tetelek" ng-if=!item.activeToday><td style="width: 20%">{{item.SportoloNev}} ({{item.SzuletesiDatum}})</td></tr></table></div></div></div><div class="col-sm-12 back" style="text-align: center"><button class=cts-button ej-button e-click=vm.saveAttendance ng-if="vm.editedAttendance.tetelek.length>0 && vm.allowEdit === true" translate>Save</button> <button class=cts-button ej-button e-click=back translate>Back</button></div><div data-ng-hide=true><div class=presence1_off></div><div class=presence1_on></div><div class=presence2_off></div><div class=presence2_on></div><div class=presence3_off></div><div class=presence3_on></div><div class=presence1></div><div class=presence0></div><div class=absence0></div><div class=absence1></div><div class=competition0></div><div class=competition1></div><div class=holiday0></div><div class=holiday1></div><div class=sickness0></div><div class=sickness1></div><div class=injury0></div><div class=injury1></div><div class=proven0></div><div class=proven1></div><div class=dotdotdot></div><div class=clear></div></div></div><div class=widget-foot><div class=clearfix></div></div></div></div></div></section>');
$templateCache.put('app/administration/exercises/exercises.html','<section class=mainbar><div class=container-fluid><div class=row><div class=widget><div ui-view></div></div></div></div></section>');
$templateCache.put('app/administration/monthlyAttendance/monthlyAttendance.html','<section class=mainbar><div class=container-fluid><div class=row><div class=widget><div ui-view></div></div></div></div></section>');
$templateCache.put('app/administration/monthlyTrainingPlan/monthlyTrainingPlan.html','<section class=mainbar><div class=container-fluid><div class=row><div class=widget><div ui-view></div></div></div></div></section>');
$templateCache.put('app/administration/quickCompetitionResults/quickCompetitionResults.html','<section class=mainbar><div class=container-fluid><div class=row><div class=widget><ht-widget-header title={{title}} text-id=quickCompetitionResultsHelp right-text=rightText></ht-widget-header><div class=widget-content><form class=filter name=form><div class=row><cts-dropdown-list name=sectionDropDown label=Section value=vm.sectionId datasource=vm.sectionList databound=vm.sectionDataBound select=vm.sectionSelect validation-rules="{required: true}"></cts-dropdown-list><cts-dropdown-list name=ageGroupDropDown label=AgeGroup value=vm.ageGroupId datasource=vm.ageGroupList databound=vm.ageGroupDataBound change=vm.ageGropChange select=vm.ageGroupSelect></cts-dropdown-list></div><div class=row style=margin-top:2rem><script type=text/x-template id=qcrname><a data-ng-click="vm.openAthlete(${SportoloId})">${SportoloNev}</a></script><div id=Grid></div></div><div class=button-wrapper><button type=button id=save class=cts-button ej-button e-click=vm.save translate>Save</button></div></form></div><div class=widget-foot><div class=clearfix></div></div></div></div></div></section>');
$templateCache.put('app/administration/resultReportAthletes/resultReportAthletes.html','<section class=mainbar><div class=container-fluid><div class=row><div class=widget><div id=popup><div id=searchWindow ej-dialog e-height=435px e-minheight=435px e-maxheight=435px e-min-width=600px e-title="Kor\xE1bbi eredm\xE9nyjelent\u0151 m\xE1sol\xE1sa" e-showoninit=false e-enablemodal=true e-enableresize=false e-allowkeyboardnavigation=false e-closeonescape=true e-isresponsive=true e-content=#popup e-enableanimation=true e-width=60% e-showroundedcorner=false><div class=col-xs-12><div class=text-center><div id=GridPopup name=GridPopup></div><div class=form-group style="margin-top: 20px"><button class=cts-button id=cancel data-ng-click=vm.closeEarlierResultReportAthletesWindow() type=button>M\xE9gsem</button> <button class=cts-button id=done data-ng-click=vm.selectEarlierResultReportAthletesWindow() type=button>Rendben</button></div></div></div></div></div><ht-widget-header title={{title}} text-id=resultReportAthletesHelp right-text=rightText></ht-widget-header><div class=widget-content><form name=form class=form novalidate id=form><div class=col-md-6><div style="overflow: hidden;"><cts-dropdown-list name=maSzakosztaly label=Section value=vm.editedReportResult.SzakosztalyId datasource=vm.sectionList databound=vm.sectionDataBound select=vm.sectionSelect validation-rules="{required: true}" enabled=vm.editable></cts-dropdown-list><cts-dropdown-list name=maKorosztaly label=AgeGroup value=vm.editedReportResult.KorcsoportId datasource=vm.ageGroupList databound=vm.ageGroupDataBound select=vm.ageGroupSelect validation-rules="{required: true}" enabled=vm.editable></cts-dropdown-list></div><div style="overflow: hidden;"><cts-dropdown-list name=maSportolo label=Athlete value=vm.editedReportResult.SportoloId datasource=vm.athleteList databound=vm.athleteDataBound select=vm.athleteSelect validation-rules="{required: true}" enabled=vm.editable></cts-dropdown-list><cts-dropdown-list name=maTarsSportolo label=PartnerAthlete value=vm.editedReportResult.TarsEredmenySportolo datasource=vm.athleteListPartner1 databound=vm.athleteDataBoundPartner select=vm.athleteSelectPartner enabled=vm.editable ng-if="vm.editedReportResult.SportoloId>0" clear=vm.clearTars1></cts-dropdown-list><cts-dropdown-list name=maTarsSportolo2 label=PartnerAthlete2 value=vm.editedReportResult.TarsEredmenySportolo2 datasource=vm.athleteListPartner2 databound=vm.athleteDataBoundPartner2 select=vm.athleteSelectPartner2 enabled=vm.editable ng-if="vm.editedReportResult.TarsEredmenySportolo>0" clear=vm.clearTars2></cts-dropdown-list><cts-dropdown-list name=maTarsSportolo3 label=PartnerAthlete3 value=vm.editedReportResult.TarsEredmenySportolo3 datasource=vm.athleteListPartner3 databound=vm.athleteDataBoundPartner3 select=vm.athleteSelectPartner3 enabled=vm.editable ng-if="vm.editedReportResult.TarsEredmenySportolo2>0" clear=vm.clearTars3></cts-dropdown-list></div><div style="overflow: hidden;"><cts-date-picker name=datepickerTol label=DateFrom value=vm.editedReportResult.DatumTol validation-rules="{required: true}" enabled=vm.editable></cts-date-picker><cts-date-picker name=datepickerIg label=DateTo value=vm.editedReportResult.DatumIg enabled=vm.editable></cts-date-picker></div><div style="overflow: hidden;"><cts-text-area name=txEredmSzoveg label=Result(Text) ng-model=vm.editedReportResult.EredmenySzoveg disabled=!vm.editable></cts-text-area></div><div style="overflow: hidden;"><cts-numeric-text-box name=txEredmPontGol label=Result(ScoreGoal) cts-placeholder=ResultScoreGoal value=vm.editedReportResult.EredmenyPont decimalplaces=2 enabled=vm.editable></cts-numeric-text-box><cts-mask-box name=txEredmIdo label=Result(time) value=vm.editedReportResult.EredmenyIdo mask-format=99:99:99.999 enabled=vm.editable title=hh:mm:ss.ttt></cts-mask-box></div><div style="overflow: hidden;"><cts-text-box name=txEredmCm label=Result(Cm) ng-model=vm.editedReportResult.EredmenyTavolsag change=vm.cmChange disabled=!vm.editable></cts-text-box><cts-text-box name=txEredmM label=Result(M) ng-model=vm.editedReportResult.EredmenyTavolsagM change=vm.mChange disabled=!vm.editable></cts-text-box><cts-text-box name=txHelyezes label=Position ng-model=vm.editedReportResult.Helyezes validation-rules="{required: true}" disabled=!vm.editable></cts-text-box></div><div style="overflow: hidden;"><cts-auto-complete name=maVersenyJelleg label=CharacterOfACompetition value=vm.editedReportResult.Jellege datasource=vm.competitionList validation-rules="{required: true}" enabled=vm.editable></cts-auto-complete><cts-text-box name=txVersenyNeve label=CompetitionName ng-model=vm.editedReportResult.VersenyLeiras validation-rules="{required: true}" disabled=!vm.editable></cts-text-box></div><div style="overflow: hidden;"><cts-text-box name=txVersenyszam label=Event ng-model=vm.editedReportResult.Versenyszam addnewtext=true disabled=!vm.editable></cts-text-box><cts-text-area name=txSzovegesErtekeles label="textual valuation" ng-model=vm.editedReportResult.Ertekeles disabled=!vm.editable></cts-text-area></div><div style="overflow: hidden;"><cts-text-box name=txLocation label=Location ng-model=vm.editedReportResult.Helyszin addnewtext=true disabled=!vm.editable></cts-text-box><cts-rating name=mosRating label=Rating value=vm.editedReportResult.Eredmeny enabled=vm.editable></cts-rating><label>*<span translate>MustSpecifyAtLeastOne</span>!</label></div></div><div class=col-md-6><button id=olderReportsCopy class=cts-button ej-button e-enabled=vm.editable style=float:right; e-click=vm.goToOlderAnnualSeasonPlanReports data-ng-enabled=vm.editable translate>OlderResultReportCopy</button><div><br><label translate>picture</label><br><div><div class=profileImg><img ng-src={{vm.editedReportResult.Foto}} style="height:350px;width: auto;"></div><div><button type=button class=cts-button ej-button e-enabled=vm.editable data-ng-disabled=!vm.editable data-ng-click=vm.openCropDialog() translate>Modify</button> <button type=button class=cts-button ej-button e-enabled=vm.editable data-ng-disabled=!vm.editable data-ng-click=vm.deleteImg() translate>Delete</button></div></div><div><br><label translate>textual valuation</label><br><div id=Grid name=Grid></div><br><div id=UploadDefault></div></div></div></div></form></div><div class=widget-foot style="text-align: center"><button type=reset class=cts-button ej-button e-enabled=vm.CanCreateNew data-ng-disabled=!vm.CanCreateNew data-ng-click=vm.createResultReport() style="margin-top: 5px; float: left" translate>New</button> <button type=button class=cts-button ej-button data-ng-click=vm.modifyResultReport() e-enabled=vm.CanModify data-ng-disabled=!vm.CanModify style="margin-top: 5px; margin-left:5px; float: left" translate>Modify</button> <button type=submit form=form class=cts-button ej-button e-enabled=vm.editable data-ng-disabled=!vm.editable data-ng-click=vm.saveResultReport() style="margin-top: 5px;" translate>Save</button> <button type=button class=cts-button ej-button data-ng-click=back() style="margin-top: 5px;" translate>Back</button></div></div></div></div></section><div id=dialogContainer class=dialogContainer><div class=modalCell><div id=cropDialog class=cropDialog ej-dialog e-title=vm.cropDialogTitle e-width=650 e-showoninit=false e-enablemodal=true e-enableresize=false e-allowkeyboardnavigation=false e-closeonescape=true e-close=vm.closeCropDialog e-isresponsive=true e-enableanimation=true e-content=#dialogContainer e-showroundedcorner=false><div class=text-center><div class=modal-body><div><label for=fileName class="cts-button pull-left">{{\'ChooseImage\'|translate}}</label> <input style="display: none;" type=file accept=image/* img-cropper-fileread image=vm.cropper.sourceImage id=fileName><div><canvas id=canvas width=600 height=600 image-cropper image=vm.cropper.sourceImage cropped-image=vm.cropper.croppedImage crop-width=600 crop-height=600 keep-aspect=true touch-radius=30 crop-area-bounds=vm.bounds min-width=50 min-height=50></canvas></div></div></div><div class=modal-footer><button class="cts-button pull-left" data-ng-disabled=!vm.cropper.croppedImage style="min-width: 100px" data-ng-click=vm.doneCropDialog() type=button>{{\'OK\'|translate}}</button> <button class="cts-button pull-left" data-ng-click=vm.closeCropDialog() type=button style="margin-left: 5px; min-width: 100px;">{{\'Cancel\'|translate}}</button></div></div></div></div></div><script id=rereattemplateDataColumn1 type=text/x-template><a href="${Filenev}" target="_blank">${Megnevezes}</a></script>');
$templateCache.put('app/administration/resultReportTeam/resultReportTeam.html','<section class=mainbar><div class=container-fluid><div id=popup><div id=searchWindow ej-dialog e-height=435px e-minheight=435px e-maxheight=435px e-min-width=600px e-title="Kor\xE1bbi eredm\xE9nyjelent\u0151 m\xE1sol\xE1sa" e-showoninit=false e-enablemodal=true e-enableresize=false e-allowkeyboardnavigation=false e-closeonescape=true e-isresponsive=true e-content=#popup e-enableanimation=true e-width=60% e-showroundedcorner=false><div class=col-md-12><div class=text-center>l<div id=GridPopup name=GridPopup></div><div class=form-group style="margin-top: 20px"><button class=cts-button id=cancel data-ng-click=vm.closeEarlierResultReportTeamWindow() type=button>M\xE9gsem</button> <button class=cts-button id=done data-ng-click=vm.selectEarlierResultReportTeamWindow() type=button>Rendben</button></div></div></div></div></div><div class=row><div class=widget><ht-widget-header title={{title}} text-id=resultReportTeamHelp right-text=rightText></ht-widget-header><div class=widget-content><form name=form class=form novalidate id=form><div class=col-md-12><div class=col-md-6><div style="overflow: hidden;"><cts-dropdown-list name=maSzakosztaly label=Section value=vm.editedReportResult.SzakosztalyId datasource=vm.sectionList databound=vm.sectionDataBound select=vm.sectionSelect validation-rules="{required: true}" enabled=vm.editable></cts-dropdown-list><cts-dropdown-list name=maKorosztaly label=AgeGroup value=vm.editedReportResult.KorcsoportId datasource=vm.ageGroupList databound=vm.ageGroupDataBound select=vm.ageGroupSelect validation-rules="{required: true}" enabled=vm.editable></cts-dropdown-list></div><div style="overflow: hidden;"><cts-dropdown-list name=maCsapat label=Team value=vm.editedReportResult.CsapatId datasource=vm.teamList databound=vm.teamDataBound select=vm.teamSelect validation-rules="{required: true}" enabled=vm.editable></cts-dropdown-list></div><div style="overflow: hidden;"><cts-date-picker name=datepickerTol label=DateFrom value=vm.editedReportResult.DatumTol validation-rules="{required: true}" enabled=vm.editable></cts-date-picker><cts-date-picker name=datepickerIg label=DateTo value=vm.editedReportResult.DatumIg enabled=vm.editable></cts-date-picker></div><div style="overflow: hidden;"><cts-text-area name=txEredmSzoveg label=Result ng-model=vm.editedReportResult.EredmenySzoveg disabled=!vm.editable validation-rules="{required: true}"></cts-text-area></div><div style="overflow: hidden;"><cts-text-box name=txHelyezes label=Position ng-model=vm.editedReportResult.Helyezes validation-rules="{required: true}" disabled=!vm.editable></cts-text-box></div><div style="overflow: hidden;"><cts-auto-complete name=maVersenyJelleg label=CharacterOfACompetition value=vm.editedReportResult.Jellege datasource=vm.competitionList validation-rules="{required: true}" enabled=vm.editable></cts-auto-complete><cts-text-box name=txVersenyNeve label=CompetitionName ng-model=vm.editedReportResult.VersenyLeiras validation-rules="{required: true}" disabled=!vm.editable></cts-text-box></div><div style="overflow: hidden;"><cts-text-box name=txVersenyszam label=Event ng-model=vm.editedReportResult.Versenyszam addnewtext=true disabled=!vm.editable></cts-text-box><cts-text-area name=txSzovegesErtekeles label="textual valuation" ng-model=vm.editedReportResult.Ertekeles disabled=!vm.editable></cts-text-area></div><div style="overflow: hidden;"><cts-text-box name=txLocation label=Location ng-model=vm.editedReportResult.Helyszin addnewtext=true disabled=!vm.editable></cts-text-box><cts-rating name=mosRating label=Rating value=vm.editedReportResult.Eredmeny enabled=vm.editable></cts-rating></div></div><div class=col-md-6><button id=olderReportsCopy type=button class=cts-button ej-button e-enabled=vm.editable style=float:right; e-click=vm.goToOlderAnnualSeasonPlanReports data-ng-enabled=vm.editable translate>OlderResultReportCopy</button><div><br><label translate>picture</label><br><div><div class=profileImg><img ng-src={{vm.editedReportResult.Foto}} style="height:350px;width: auto;"></div><div><button type=button class=cts-button ej-button e-enabled=vm.editable data-ng-disabled=!vm.editable data-ng-click=vm.openCropDialog() translate>Modify</button> <button type=button class=cts-button ej-button e-enabled=vm.editable data-ng-disabled=!vm.editable data-ng-click=vm.deleteImg() translate>Delete</button></div></div><div><br><label translate>textual valuation</label><br><div id=Grid name=Grid style=margin-top:5px;></div><br><div id=UploadDefault></div></div></div></div></div><div class=col-md-12><div id=GridAthletes name=GridAthletes></div><div style="overflow: hidden;"><button type=button class=cts-button ej-button e-enabled=vm.editable data-ng-disabled=!vm.editable data-ng-click=vm.removeAthletesFromResultReport() style="margin-top: 20px; margin-left: 5px; float: left" translate>Remove</button></div></div></form><div class=col-md-12><form class=filter><div><br><hr><p translate>\xC1tj\xE1tsz\xF3 sportol\xF3k hozz\xE1ad\xE1sa/t\xF6rl\xE9se:</p></div><div class=row><cts-dropdown-list name=korosztaly label=AgeGroup value=vm.AtjatszoAgeGroup datasource=vm.AtjatszoAgeGroupList select=vm.atjatszoAgeGroupSelect></cts-dropdown-list><button type=button class=cts-button ej-button e-enabled=vm.editable data-ng-disabled=!vm.editable data-ng-click=vm.addAtjatszok() style="margin-top: 20px; float: left" translate>Add</button></div><div class=row><div id=GridAtjatszo></div></div></form></div></div><div class=widget-foot style="text-align: center"><button type=button class=cts-button ej-button e-enabled=vm.CanCreateNew data-ng-disabled=!vm.CanCreateNew data-ng-click=vm.createResultReport() style="margin-top: 5px; float: left" translate>New</button> <button type=button class=cts-button ej-button data-ng-click=vm.modifyResultReport() e-enabled=vm.CanModify data-ng-disabled=!vm.CanModify style="margin-top: 5px; margin-left:5px; float: left" translate>Modify</button> <button type=submit form=form class=cts-button ej-button e-enabled=vm.editable data-ng-disabled=!vm.editable data-ng-click=vm.saveResultReport() style="margin-top: 5px;" translate>Save</button> <button type=button class=cts-button ej-button data-ng-click=back() style="margin-top: 5px;" translate>Back</button></div></div><div id=dialogContainer class=dialogContainer><div class=modalCell><div id=cropDialog class=cropDialog ej-dialog e-title=vm.cropDialogTitle e-width=650 e-showoninit=false e-enablemodal=true e-enableresize=false e-allowkeyboardnavigation=false e-closeonescape=true e-close=vm.closeCropDialog e-isresponsive=true e-enableanimation=true e-content=#dialogContainer e-showroundedcorner=false><div class=text-center><div class=modal-body><div><label for=fileName class="cts-button pull-left">{{\'ChooseImage\'|translate}}</label> <input style="display: none;" type=file accept=image/* img-cropper-fileread image=vm.cropper.sourceImage id=fileName><div><canvas id=canvas width=600 height=600 image-cropper image=vm.cropper.sourceImage cropped-image=vm.cropper.croppedImage crop-width=600 crop-height=600 keep-aspect=true touch-radius=30 crop-area-bounds=vm.bounds min-width=50 min-height=50 style="margin-top: 5px;"></canvas></div></div></div><div class=modal-footer><button class="cts-button pull-left" style="min-width: 100px;" data-ng-disabled=!vm.cropper.croppedImage data-ng-click=vm.doneCropDialog() type=button>{{\'OK\'|translate}}</button> <button class="cts-button pull-left" data-ng-click=vm.closeCropDialog() type=button style="margin-left: 5px; min-width: 100px;">{{\'Cancel\'|translate}}</button></div></div></div></div></div><script id=reretetemplateDataColumn1 type=text/x-template><a href="${Filenev}" target="_blank">${Megnevezes}</a></script></div></div></section>');
$templateCache.put('app/administration/sportSpecificTest/sportSpecificTest.html','<section class=mainbar><div class=container-fluid><div class=row><div class=widget><div ui-view></div></div></div></div></section>');
$templateCache.put('app/administration/trainingDiary/trainingDiary.html','<section class=mainbar><div class=container-fluid><div class=row><div class=widget><ht-widget-header title={{title}} text-id=trainingDiaryHelp right-text=rightText></ht-widget-header><div class=widget-content><form class=filter name=form><div class=row><cts-dropdown-list name=edzo label=Coach value=vm.selectedCoach datasource=vm.coachList enabled=false></cts-dropdown-list><cts-dropdown-list name=szakosztaly label=Section value=vm.selectedSection datasource=vm.sectionList enabled=false></cts-dropdown-list><cts-dropdown-list data-ng-if="vm.selectedAgeGroup>0" name=korosztaly label=AgeGroup value=vm.selectedAgeGroup datasource=vm.ageGroupList enabled=false></cts-dropdown-list></div><div class=row><cts-dropdown-list name=ev label=Year value=vm.yearValue datasource=vm.years enabled=false></cts-dropdown-list><cts-dropdown-list name=honap label=Month value=vm.monthValue datasource=vm.months enabled=false></cts-dropdown-list><cts-date-picker name=MadeOn label=MadeOn value=vm.keszult></cts-date-picker><div class=button-wrapper ng-if=!vm.lezart><button type=button id=add class=cts-button ej-button e-click=vm.addRow e-enabled=vm.addEnabled translate>AddNewEntryForThisDay</button> <button type=button id=add class=cts-button ej-button e-click=vm.removeRow e-enabled=vm.removeEnabled translate>RemoveEntryForThisDay</button></div></div><div class=row><div id=Grid></div></div></form><div class="col-sm-12 back" style="text-align: center"><button class=cts-button ej-button e-click=vm.Save ng-if=!vm.lezart translate>Save</button> <button class=cts-button ej-button e-click=back translate>Back</button> <button class=cts-button ej-button e-click=vm.print translate>Print</button></div></div><div class=widget-foot><div class=clearfix></div></div><div id=printDialog><report report-name=TKepzesiNaplo report-parameters=vm.reportParameters></report></div></div></div></div></section>');
$templateCache.put('app/administration/test/test.html','<section class=mainbar><div class=container-fluid><div class=row><div class=widget><div ui-view></div></div></div></div></section>');
$templateCache.put('app/administration/trainingPlan/trainingPlan.html','<section class=mainbar><div class=container-fluid><div class=row><div class=widget><div ui-view></div></div></div></div></section>');
$templateCache.put('app/administration/weeklyTrainingPlan/weeklyTrainingPlan.html','<section class=mainbar><div class=container-fluid><div class=row><div class=widget><div ui-view></div></div></div></div></section>');
$templateCache.put('app/athletes/ageGroups/ageGroups.html','<section class=mainbar><div class=container-fluid><div class=row><div class=widget><div ui-view></div></div></div></div></section>');
$templateCache.put('app/athletes/athletesManagement/athletesManagement.html','<section class=mainbar><div class=container-fluid><div class=row><div class=widget><div ui-view style="position: relative; overflow: hidden;"></div></div></div></div></section>');
$templateCache.put('app/athletes/sections/sections.html','<section class=mainbar><div class=container-fluid><div class=row><div class=widget><ht-widget-header title={{title}} text-id=sectionListHelp right-text=rightText></ht-widget-header><div class="widget-content form"><form class=filter name=form><div class=row><div style="overflow: hidden;"><div class=button-wrapper><button id=AddSection class=cts-button ej-button e-click=vm.AddSection translate>AddSection</button> <button id=EditSection class=cts-button ej-button e-click=vm.EditSection translate>EditSection</button></div></div></div></form><div id=Grid class="slim-grid no-print-first-col"></div></div></div></div></div></section>');
$templateCache.put('app/athletes/teams/teams.html','<section class=mainbar><div class=container-fluid><div class=row><div class=widget><div ui-view></div></div></div></div></section>');
$templateCache.put('app/business/annualEducationalFeeByCoach/annualEducationalFeeByCoach.html','<section class=mainbar><div class=container-fluid><div class=row><div class=widget><ht-widget-header title={{title}} text-id=annualEducationalFeeByCoachHelp right-text=rightText></ht-widget-header><div class=widget-content><form class=filter name=form><div class=row><cts-dropdown-list name=yearDropDown label=Year value=vm.year datasource=vm.yearList databound=vm.yearDataBound select=vm.yearSelect></cts-dropdown-list><div class=button-wrapper><button class=cts-button ej-button e-click=vm.getDatas translate>GetDatas</button></div></div></form><div class=row><script type=text/x-template id=annualeducationalfeebycoachcolumnTemplate><a data-ng-click="vm.openCoach(${Id})">${EdzoNeve}</a></script><div id=Grid></div></div></div><div class=widget-foot><div class=clearfix></div></div></div></div></div></section>');
$templateCache.put('app/business/annualEducationalFeeByAthletes/annualEducationalFeeByAthletes.html','<section class=mainbar><div class=container-fluid><div class=row><div class=widget><ht-widget-header title={{title}} text-id=annualEducationalFeeByAthletesHelp right-text=rightText></ht-widget-header><div class=widget-content><form class=filter name=form><div class=row><cts-dropdown-list name=yearDropDown label=Year value=vm.year datasource=vm.yearList databound=vm.yearDataBound select=vm.yearSelect></cts-dropdown-list><div class=button-wrapper><button class=cts-button ej-button e-click=vm.getDatas translate>GetDatas</button></div></div></form><div class=row><script type=text/x-template id=annualeducationalfeebyathletecolumnTemplate1><a data-ng-click="vm.goToAthlete(${SportolokID})">${SportoloNeve}</a></script><script type=text/x-template id=annualeducationalfeebyathletecolumnTemplate2><a data-ng-click="vm.openCoach(${Id})">${EdzoNeve}</a></script><div id=Grid></div></div></div><div class=widget-foot><div class=clearfix></div></div></div></div></div></section>');
$templateCache.put('app/business/annualEducationalFeeByOneSection/annualEducationalFeeByOneSection.html','<section class=mainbar><div class=container-fluid><div class=row><div class=widget><ht-widget-header title={{title}} text-id=annualEducationalFeeByOneSectionHelp right-text=rightText></ht-widget-header><div class=widget-content><form class=filter name=form><div class=row><cts-dropdown-list name=sectionDropDown label=Section datasource=vm.sectionList select=vm.sectionSelect></cts-dropdown-list></div></form><script type=text/x-template id=annualeducationalfeebyonesectioncolumnTemplate><a data-ng-click="vm.openCoach(${Id})">${EdzoNeve}</a></script><div class=row><div id=Grid></div></div></div><div class=widget-foot><div class=clearfix></div></div></div></div></div></section>');
$templateCache.put('app/business/annualEducationalFeeBySection/annualEducationalFeeBySection.html','<section class=mainbar><div class=container-fluid><div class=row><div class=widget><ht-widget-header title={{title}} text-id=annualEducationalFeeBySectionHelp right-text=rightText></ht-widget-header><div class=widget-content><form class=filter name=form><div class=row><cts-dropdown-list name=yearDropDown label=Year value=vm.year datasource=vm.yearList databound=vm.yearDataBound select=vm.yearSelect></cts-dropdown-list><div class=button-wrapper><button class=cts-button ej-button e-click=vm.getDatas translate>GetDatas</button></div></div></form><div class=row><div id=Grid></div></div></div><div class=widget-foot><div class=clearfix></div></div></div></div></div></section>');
$templateCache.put('app/business/annualSportServiceFeeByAthletes/annualSportServiceFeeByAthletes.html','<section class=mainbar><div class=container-fluid><div class=row><div class=widget><ht-widget-header title={{title}} text-id=annualSportServiceFeeByAthletesHelp right-text=rightText></ht-widget-header><div class=widget-content><form class=filter name=form><div class=row><cts-dropdown-list name=yearDropDown label=Year value=vm.year datasource=vm.yearList databound=vm.yearDataBound select=vm.yearSelect></cts-dropdown-list><div class=button-wrapper><button class=cts-button ej-button e-click=vm.getDatas translate>GetDatas</button></div></div></form><div class=row><script type=text/x-template id=annualsportservicefeebyathletecolumnTemplate1><a data-ng-click="vm.goToAthlete(${SportolokID})">${SportoloNeve}</a></script><script type=text/x-template id=annualsportservicefeebyathletecolumnTemplate2><a data-ng-click="vm.openCoach(${Id})">${EdzoNeve}</a></script><div id=Grid></div></div></div><div class=widget-foot><div class=clearfix></div></div></div></div></div></section>');
$templateCache.put('app/business/annualSportServiceFeeByCoach/annualSportServiceFeeByCoach.html','<section class=mainbar><div class=container-fluid><div class=row><div class=widget><ht-widget-header title={{title}} text-id=annualSportServiceFeeByCoachHelp right-text=rightText></ht-widget-header><div class=widget-content><form class=filter name=form><div class=row><cts-dropdown-list name=yearDropDown label=Year value=vm.year datasource=vm.yearList databound=vm.yearDataBound select=vm.yearSelect></cts-dropdown-list><div class=button-wrapper><button class=cts-button ej-button e-click=vm.getDatas translate>GetDatas</button></div></div></form><div class=row><script type=text/x-jsrender id=annualsportservicefeebycoachcolumnTemplate><a class=\'bind\' data-ng-click=\'vm.openCoach(${Id})\'>${EdzoNeve}</a></script><div id=Grid></div></div></div><div class=widget-foot><div class=clearfix></div></div></div></div></div></section>;');
$templateCache.put('app/business/annualSportServiceFeeByOneSection/annualSportServiceFeeByOneSection.html','<section class=mainbar><div class=container-fluid><div class=row><div class=widget><ht-widget-header title={{title}} text-id=annualSportServiceFeeByOneSectionHelp right-text=rightText></ht-widget-header><div class=widget-content><form class=filter name=form><div class=row><cts-dropdown-list name=sectionDropDown label=Section datasource=vm.sectionList select=vm.sectionSelect></cts-dropdown-list></div></form><script type=text/x-template id=annualsportservicefeebyonesectioncolumnTemplate><a data-ng-click="vm.openCoach(${Id})">${EdzoNeve}</a></script><div class=row><div id=Grid class=slim-grid name=Grid></div></div></div><div class=widget-foot><div class=clearfix></div></div></div></div></div></section>');
$templateCache.put('app/business/annualSportServiceFeeBySection/annualSportServiceFeeBySection.html','<section class=mainbar><div class=container-fluid><div class=row><div class=widget><ht-widget-header title={{title}} text-id=annualSportServiceFeeBySectionHelp right-text=rightText></ht-widget-header><div class=widget-content><form class=filter name=form><div class=row><cts-dropdown-list name=yearDropDown label=Year value=vm.year datasource=vm.yearList databound=vm.yearDataBound select=vm.yearSelect></cts-dropdown-list><div class=button-wrapper><button class=cts-button ej-button e-click=vm.getDatas translate>GetDatas</button></div></div></form><div class=row><div id=Grid></div></div></div><div class=widget-foot><div class=clearfix></div></div></div></div></div></section>');
$templateCache.put('app/business/checkPrintingExport/checkPrintingExport.html','<section class=mainbar><div class=container-fluid><div class=row><div class=widget><ht-widget-header title={{title}} text-id=checkPrintExportHelp right-text=rightText></ht-widget-header><div class=widget-content><form class=filter name=form><div class=row><cts-date-picker name=datefrom label=DateFrom value=vm.dateFromValue change=vm.dateFromChange validation-rules="{required: true}"></cts-date-picker><cts-date-picker name=dateto label=DateTo value=vm.dateToValue change=vm.dateToChange validation-rules="{required: true}"></cts-date-picker></div><div class=row><cts-dropdown-list name=sectionDropDown label=Section datasource=vm.sectionList databound=vm.sectionDataBound select=vm.sectionSelect value=vm.sectionId validation-rules="{required: true}"></cts-dropdown-list><cts-dropdown-list name=coachDropDown label=Coach datasource=vm.coachList value=vm.coachId databound=vm.coachDataBound select=vm.coachSelect validation-rules="{required: true}"></cts-dropdown-list><div class=button-wrapper><button class=cts-button ej-button e-click=vm.getDatas translate>GetDatas</button></div></div></form><div class=row><script type=text/x-template id=checkprintingexportcolumnTemplate1><a data-ng-click="vm.goToAthlete(${Id})">${SportoloNeve}</a></script><script type=text/x-template id=checkprintingexportcolumnTemplate2><a data-ng-click="vm.openCoach(${IdEdzo})">${Edzo}</a></script><div id=Grid class=slim-grid></div></div><div class="col-sm-12 back" style="text-align: center"><button class=cts-button ej-button e-click=vm.addNumbers data-ng-if="vm.showAddNumber === true" translate>AddNumber</button> <button class=cts-button ej-button e-click=back translate>Back</button></div></div><div class=widget-foot><div class=clearfix></div></div></div></div></div></section>');
$templateCache.put('app/business/checkPayment/checkPayment.html','<section class=mainbar><div class=container-fluid><div class=row><div class=widget><ht-widget-header title={{title}} text-id=checkPaymentHelp right-text=rightText></ht-widget-header><div class=widget-content><form class=filter name=form novalidate><div class=row><cts-text-box name=checkNumber label=PayerId data-ng-model=vm.checkNumber validation-rules="{required: true}"></cts-text-box><cts-numeric-text-box name=payment label=Payment value=vm.payment validation-rules="{required: true}"></cts-numeric-text-box><div class=button-wrapper><button type=submit class=cts-button ej-button e-click=vm.getCheck translate>GetCheck</button></div></div><div class=row data-ng-if="vm.hasCheck === true"><cts-text-box name=athletesName label=AthletesName data-ng-model=vm.actualPayment.Versenyzo owndisabled=true></cts-text-box><cts-text-box name=section label=Section data-ng-model=vm.actualPayment.Szakosztaly owndisabled=true></cts-text-box></div><div class=row data-ng-if="vm.hasCheck === true"><cts-text-box name=coach label=Coach data-ng-model=vm.actualPayment.Edzo owndisabled=true></cts-text-box><cts-text-box name=amount label=PaidAmount data-ng-model=vm.actualPayment.Osszeg owndisabled=true></cts-text-box><div class=button-wrapper><button type=button class=cts-button ej-button e-click=vm.pay translate>Pay</button> <button type=button class=cts-button ej-button e-click=vm.removePayment translate>RemovePayment</button></div></div></form><div class=row><div id=Grid class=slim-grid></div></div><div class="col-sm-12 back" style="text-align: center"><button class=cts-button ej-button e-click=vm.save translate>Save</button> <button class=cts-button ej-button e-click=back translate>Back</button></div></div><div class=widget-foot><div class=clearfix></div></div></div></div></div></section>');
$templateCache.put('app/business/csvPayment/csvPayment.html','<section class=mainbar><div class=container-fluid><div class=row><div class=widget><ht-widget-header title={{title}} text-id=csvPaymentHelp right-text=rightText></ht-widget-header><div class=widget-content><div id=step1 ng-show="vm.step == 1"><form class=filter name=form id=csvuploadform novalidate><label translate>Step 1. Select CSV File!</label><div class=row><div class=col-sm-5><div class=posupload translate>Selectfile</div><div class=button-wrapper><div id=UploadButton></div></div></div></div></form></div><div id=step2 class=row ng-show="vm.step == 2"><label style=margin-bottom:2em; translate>Step 2. Select Header Row!</label><div id=WGrid2></div><label style=margin-bottom:2em; translate>Note: Not all lines are displayed in this grid!</label><div class=button-wrapper style=margin-top:2em;><button class=cts-button ej-button e-click=vm.noHeader translate>noHeader</button></div></div><div id=step3 class=row ng-show="vm.step >= 3 && vm.step <= 7"><label ng-if="vm.step == 3" style=margin-bottom:2em; translate>Step 3. Select ENCODING!</label> <label ng-if="vm.step == 4" style=margin-bottom:2em; translate>Step 4. Select Comment Column!</label> <label ng-if="vm.step == 5" style=margin-bottom:2em; translate>Step 5. Select Date Column!</label> <label ng-if="vm.step == 6" style=margin-bottom:2em; translate>Step 6. Select Depositor Column!</label> <label ng-if="vm.step == 7" style=margin-bottom:2em; translate>Step 7. Select Amount Column!</label><div id=WGrid3></div><label style=margin-bottom:2em; translate>Note: Not all lines are displayed in this grid!</label><div class=button-wrapper style=margin-top:2em;><button ng-if="vm.step == 6" class=cts-button ej-button e-click=vm.noDepositor translate>noDepositor</button></div></div><div class=row ng-show="vm.step == 8"><label style=margin-bottom:2em; translate>Step 8. To save time CSV Settings can be saved.</label><div class="col-sm-12 back" style="text-align: center"><button class=cts-button ej-button e-click=vm.StartAgain translate>StartAgain</button> <button class=cts-button ej-button e-click=vm.SaveSettings translate>SaveSettings</button> <button class=cts-button ej-button e-click=vm.Continue translate>Continue</button></div></div><div class=row ng-show="vm.step == 9"><label style=margin-bottom:2em; translate>Step 9. Select CSV Process mode!</label><div class="listbox frame"><ul id=modes ej-listbox e-datasource=vm.processModes e-fields-text=modeName e-height=200px e-select=vm.modeSelect e-width=350px></ul></div></div><div class=row ng-show="vm.step >= 10"><label ng-if="vm.step == 10" style=margin-bottom:2em; translate>Step 10. Check the checkboxes next to payments!</label> <label ng-if="vm.step == 11" style=margin-bottom:2em; translate>Step 11. Please print unprocessed payments and process them manually!</label><div class=row><div id=GridFinal></div></div></div><div class=row><div class="col-sm-12 back" style="text-align: center" data-ng-if="vm.data.length !== 0"><div ng-if="vm.step == 10"><button class=cts-button ej-button e-click=back translate>Back</button> <button class=cts-button ej-button e-click=vm.StartAgain translate>Cancel</button> <button class=cts-button ej-button e-click=vm.save e-enabled=vm.saveEnabled translate>Save</button></div><div ng-if="vm.step == 11"><div class=row><label ng-if="vm.step == 11" style=margin-bottom:2em; translate>Note: Now only the unprocessed payments are shown in the list above!</label></div><div class=row><button class=cts-button ej-button e-click=back translate>Back</button></div></div></div></div></div><div class=widget-foot><div class=clearfix></div></div></div></div></div></section>');
$templateCache.put('app/business/dailyEducationalFeePayments/dailyEducationalFeePayments.html','<section class=mainbar><div class=container-fluid><div class=row><div class=widget><ht-widget-header title={{title}} text-id=dailyEducationalFeePaymentsHelp right-text=rightText></ht-widget-header><div class=widget-content><form class=filter name=form><div class=row><cts-dropdown-list name=coachDropDown label=Coach value=vm.coachId datasource=vm.coachList databound=vm.coachDataBound select=vm.coachSelect validation-rules="{required: true}"></cts-dropdown-list><cts-dropdown-list name=number label=Number value=vm.selectedNumber datasource=vm.numberList databound=vm.numberDataBound select=vm.numberSelect validation-rules="{required: true}"></cts-dropdown-list><cts-date-picker name=datepick label=Date value=vm.dateValue change=vm.dateChange enabled=vm.dateEnabled validation-rules="{required: true}"></cts-date-picker><div class=button-wrapper><button class=cts-button ej-button e-click=vm.getAthletes translate>GetDatas</button></div></div><div class=row><cts-dropdown-list name=sectionDropDown label=Section value=vm.selectedSection datasource=vm.sectionList databound=vm.sectionDataBound select=vm.sectionSelect validation-rules="{required: true}"></cts-dropdown-list></div></form><div class=row><script type=text/x-template id=dailyeducationalfeepaymentscolumnTemplate1><a data-ng-click="vm.goToAthlete(${Versenyzo_Id})">${Versenyzo_Nev}</a></script><script type=text/x-template id=dailyeducationalfeepaymentscolumnTemplate2><a data-ng-click="vm.openCoach(${EdzoId})">${EdzoNeve}</a></script><div id=Grid></div></div><div class="col-sm-12 back" style="text-align: center"><button class=cts-button ej-button e-click=vm.addNumbers data-ng-if="vm.showAddNumber === true" translate>AddNumber</button> <button class=cts-button ej-button e-click=vm.print translate>Print</button> <button class=cts-button ej-button e-click=back translate>Back</button></div></div><div class=widget-foot><div class=clearfix></div></div></div></div></div></section><div id=printDialog><report report-name=TNapiTagdijBefizetesek report-parameters=vm.reportParameters></report></div>');
$templateCache.put('app/business/dailyEducationalFeesPerCoach/dailyEducationalFeesPerCoach.html','<section class=mainbar><div class=container-fluid><div class=row><div class=widget><ht-widget-header title={{title}} text-id=dailyEducationalFeesPerCoachHelp right-text=rightText></ht-widget-header><div class=widget-content><form class=filter novalidate name=form enctype=multipart/form-data><div class=row><div style="overflow: hidden;"><cts-dropdown-list name=coachDropDown label=Coach value=vm.coachIdValue datasource=vm.coachList databound=vm.coachDataBound select=vm.selectCoach validation-rules="{required: true}"></cts-dropdown-list></div><div style="overflow: hidden;"><cts-date-picker name=yearDropDownFrom label=DateFrom value=vm.datumTol validation-rules="{required: true}"></cts-date-picker><cts-date-picker name=yearDropDownTo label=DateTo value=vm.datumIg validation-rules="{required: true}"></cts-date-picker></div><div class=button-wrapper><button id=lekeres class=cts-button type=submit ej-button e-click=vm.getFeeDatas translate>GetDatas</button></div></div></form><div class=row><div id=Grid></div></div><div class=row><div class=col-md-4></div></div></div><div class=widget-foot><div class=clearfix></div></div></div></div></div></section>');
$templateCache.put('app/business/dailySportServiceFeePayments/dailySportServiceFeePayments.html','<section class=mainbar><div class=container-fluid><div class=row><div class=widget><ht-widget-header title={{title}} text-id=dailySpoerServicePaymentsHelp right-text=rightText></ht-widget-header><div class=widget-content><form class=filter name=form><div class=row><cts-dropdown-list name=coachDropDown label=Coach value=vm.coachId datasource=vm.coachList databound=vm.coachDataBound select=vm.coachSelect validation-rules="{required: true}"></cts-dropdown-list><cts-dropdown-list name=number label=Number value=vm.selectedNumber datasource=vm.numberList databound=vm.numberDataBound select=vm.numberSelect validation-rules="{required: true}"></cts-dropdown-list><cts-date-picker name=datepick label=Date value=vm.dateValue change=vm.dateChange enabled=vm.dateEnabled validation-rules="{required: true}"></cts-date-picker><div class=button-wrapper><button class=cts-button ej-button e-click=vm.getAthletes translate>GetDatas</button></div></div><div class=row><cts-dropdown-list name=sectionDropDown label=Section value=vm.selectedSection datasource=vm.sectionList databound=vm.sectionDataBound select=vm.sectionSelect validation-rules="{required: true}"></cts-dropdown-list></div></form><div class=row><script type=text/x-template id=dailysportservicefeepaymentscolumnTemplate1><a data-ng-click="vm.goToAthlete(${Versenyzo_Id})">${Versenyzo_Nev}</a></script><script type=text/x-template id=dailysportservicefeepaymentscolumnTemplate2><a data-ng-click="vm.openCoach(${EdzoId})">${EdzoNeve}</a></script><div id=Grid></div></div><div class="col-sm-12 back" style="text-align: center"><button class=cts-button ej-button e-click=vm.addNumbers data-ng-if="vm.showAddNumber === true" translate>AddNumber</button> <button class=cts-button ej-button e-click=vm.print translate>Print</button> <button class=cts-button ej-button e-click=back translate>Back</button></div></div><div class=widget-foot><div class=clearfix></div></div></div></div></div></section><div id=printDialog><report report-name=TNapiTagdijBefizetesek report-parameters=vm.reportParameters></report></div>');
$templateCache.put('app/business/dailySportServiceFeesPerCoach/dailySportServiceFeesPerCoach.html','<section class=mainbar><div class=container-fluid><div class=row><div class=widget><ht-widget-header title={{title}} text-id=dailySportServiceFeesPerCoachHelp right-text=rightText></ht-widget-header><div class=widget-content><form class=filter novalidate name=form enctype=multipart/form-data><div class=row><div style="overflow: hidden;"><cts-dropdown-list name=coachDropDown label=Coach value=vm.coachIdValue datasource=vm.coachList databound=vm.coachDataBound select=vm.selectCoach validation-rules="{required: true}"></cts-dropdown-list></div><div style="overflow: hidden;"><cts-date-picker name=yearDropDownFrom label=DateFrom value=vm.datumTol validation-rules="{required: true}"></cts-date-picker><cts-date-picker name=yearDropDownTo label=DateTo value=vm.datumIg validation-rules="{required: true}"></cts-date-picker></div><div class=button-wrapper><button id=lekeres class=cts-button type=submit ej-button e-click=vm.getFeeDatas translate>GetDatas</button></div></div></form><div class=row><div id=Grid name=Grid></div></div></div><div class=widget-foot><div class=clearfix></div></div></div></div></div></section>');
$templateCache.put('app/business/educationalFeeRegister/educationalFeeRegister.html','<section class=mainbar><div class=container-fluid><div class=row><div class=widget><ht-widget-header title={{title}} text-id=educationalFeeRegisterHelp right-text=rightText></ht-widget-header><div class=widget-content><form class=filter name=form><div class=row><cts-dropdown-list name=coachDropDown label=Coach value=vm.coachId datasource=vm.coachList databound=vm.coachDataBound select=vm.coachSelect validation-rules="{required: true}"></cts-dropdown-list><cts-dropdown-list name=sectionDropDown label=Section value=vm.sectionId datasource=vm.sectionList databound=vm.sectionDataBound select=vm.sectionSelect validation-rules="{required: true}"></cts-dropdown-list><cts-dropdown-list name=yearDropDownList label=Year value=vm.year datasource=vm.yearList databound=vm.yearDataBound select=vm.yearSelect validation-rules="{required: true}"></cts-dropdown-list><div class="form-group cts-form-group"><label translate>Month</label><div class=input-group><input type=text id=monthDropDownList name=monthDropDownList></div></div><div class=button-wrapper><button class=cts-button ej-button e-click=vm.getAthletes translate>GetDatas</button></div></div></form><div class=col-sm-12><script type=text/x-template id=educationalfeeregistercolumnTemplate1><a data-ng-click="vm.goToAthlete(${Versenyzo_Id})">${Versenyzo_Nev}</a></script><script type=text/x-template id=educationalfeeregistercolumnTemplate2><a data-ng-click="vm.openCoach(${EdzoId})">${EdzoNeve}</a></script><div style="position: fixed; z-index: 10000; top: 70px; left: 45%; background-color: forestgreen; color: white; border: 2px solid forestgreen; -webkit-border-radius: 5px;-moz-border-radius: 5px;border-radius: 5px;" data-ng-if=vm.AthleteUnderEditing><h2>{{vm.AthleteUnderEditingText}}: {{vm.AthleteUnderEditing}}</h2></div><div id=Grid class=slim-grid></div><div id=remarks><div class=col-sm-12 style="margin-top:10px; float:left;text-align:left; margin-right:-10px;"><p translate>NotationSportServiceFeeRegister</p></div><div class=col-sm-12><p><span translate>EducationalFee</span>: {{vm.EducationalFee}}</p><p><span translate>{{vm.kedvezmenyNevek[0]}}</span>: {{vm.sectionFees[0].KedvezmenyesOD}}</p><p><span translate>{{vm.kedvezmenyNevek[1]}}</span>: {{vm.sectionFees[0].KedvezmenyesOD2}}</p><p><span translate>{{vm.kedvezmenyNevek[2]}}</span>: {{vm.sectionFees[0].KedvezmenyesOD3}}</p><p><span translate>{{vm.kedvezmenyNevek[3]}}</span>: {{vm.sectionFees[0].KedvezmenyesOD4}}</p><p><span translate>{{vm.kedvezmenyNevek[4]}}</span>: {{vm.sectionFees[0].KedvezmenyesOD5}}</p></div></div></div><div class="col-sm-12 back" style="text-align: center"><button class=cts-button ej-button e-click=vm.saveWithoutNumbers data-ng-if="vm.atletesList.length !== 0" translate>Save</button> <button class=cts-button ej-button e-click=vm.saveWithNumbers data-ng-if="vm.atletesList.length !== 0" translate>SaveWithNumbers</button> <button class=cts-button ej-button e-click=vm.goToDailyPayments data-ng-if="vm.atletesList.length !== 0" translate>DailyPayments</button> <button class=cts-button ej-button e-click=back translate>Back</button></div></div></div><div class=widget-foot><div class=clearfix></div></div></div></div></section>');
$templateCache.put('app/business/monthlyAttendanceArrears/monthlyAttendanceArrears.html','<section class=mainbar><div class=container-fluid><div class=row><div class=widget><ht-widget-header title={{title}} text-id=monthlyAttendanceArrearsHelp right-text=rightText></ht-widget-header><div class=widget-content><div class=row><script type=text/x-template id=monthlyattendancearrearscolumnTemplate><a data-ng-click="vm.openCoach(${Edzo_Id})">${EdzoNeve}</a></script><div id=Grid class=slim-grid></div></div></div><div class=widget-foot><div class=clearfix></div></div></div></div></div></section>');
$templateCache.put('app/business/modifyFees/modifyFees.html','<section class=mainbar><div class=container-fluid><div class=row><div class=col-xs-12><div class=widget><ht-widget-header title={{title}} text-id=modifyFeesHelp right-text=rightText></ht-widget-header><script id=pagerTemplate type=text/x-template><div style="width: 100px"> <p style="float: left; margin:0; padding:0; line-height: 28px">Items per page:</p> <input style="float: left" type="text" ej-numerictextbox id="txtPageNumber" e-width="70px" stype="border: none; cursor: text" e-value="vm.pageSize"/> </div></script><div class=widget-content><div class=row><div id=Grid name=Grid></div></div></div></div></div></div><div class=row><form name=form style="margin-top: 2em;"><div class=col-md-4><div class=widget><div class=widget-head><h2 class=page-title translate>FeeSettings</h2></div><div class="widget-content text-center text-info" style="min-height: 100px; height:150px; max-height: 150px; overflow-y: auto"><cts-numeric-text-box name=toleranceDays label=ToleranceDays value=vm.toleranceDays validation-rules="{required: true, minlength: 1, maxlength: 300}"></cts-numeric-text-box></div><div class=widget-foot><button class=cts-button ej-button data-ng-click=vm.saveData() translate>Save</button><div class=clearfix></div></div></div></div><div class=col-md-4><div class=widget><div class=widget-head><h2 class=page-title translate>MeteOutSave</h2></div><div class="widget-content text-center text-info" style="min-height: 100px; height:150px; max-height: 150px; overflow-y: auto"><cts-date-picker name=fromDate label=FromDate value=vm.fromDate></cts-date-picker><cts-check-box name=onlyNew label=onlyNew checked=vm.onlyNew></cts-check-box></div><div class=widget-foot><button class=cts-button ej-button data-ng-click=vm.meteOut() translate>MeteOut</button><div class=clearfix></div></div></div></div><div class=col-md-4><div class=widget><div class=widget-head><h2 class=page-title translate>YearClosing</h2></div><div class="widget-content text-center text-info" style="min-height: 100px; height:150px; max-height: 150px; overflow-y: auto"><cts-dropdown-list name=ddlYear label=Year datasource=vm.nonClosedYears value=vm.selectedYear select=vm.yearSelect></cts-dropdown-list><label data-ng-if=vm.yearclosed translate>YearIsAlreadyClosed</label></div><div class=widget-foot><button class=cts-button ej-button translate e-click=vm.closeYear e-enabled=vm.closeYearEnabled>Close Year</button><div class=clearfix></div></div></div></div><div class=row><div class=col-md-4></div></div></form></div></div></section>');
$templateCache.put('app/business/sportServiceFeeArrears/sportServiceFeeArrears.html','<section class=mainbar><div class=container-fluid><div class=row><div class=widget><ht-widget-header title={{title}} text-id=sportServiceFeeArrearsHelp right-text=rightText></ht-widget-header><div class=widget-content><form class=filter name=form><div class=row><cts-dropdown-list name=coachDropDown label=Coach value=vm.coachId datasource=vm.coachList databound=vm.coachDataBound select=vm.coachSelect validation-rules="{required: true}"></cts-dropdown-list><cts-dropdown-list name=sectionDropDown label=Section value=vm.selectedSection datasource=vm.sectionList databound=vm.sectionDataBound select=vm.sectionSelect validation-rules="{required: true}"></cts-dropdown-list><cts-dropdown-list name=yearDropDownList label=Year value=vm.year datasource=vm.yearList databound=vm.yearDataBound select=vm.yearSelect validation-rules="{required: true}"></cts-dropdown-list><div class=button-wrapper><button class=cts-button ej-button e-click=vm.getAthletes translate>GetDatas</button></div></div></form><div class=row><script type=text/x-template id=feearrearscolumnTemplate1><a data-ng-click="vm.goToAthlete(${VersenyzoId})">${VersenyzoNeve}</a></script><script type=text/x-template id=feearrearscolumnTemplate2><a data-ng-click="vm.openCoach(${EdzoId})">${EdzoNeve}</a></script><div id=Grid></div></div></div><div class=widget-foot><div class=clearfix></div></div></div></div></div></section>');
$templateCache.put('app/business/sportServiceFeeRegister/sportServiceFeeRegister.html','<section class=mainbar><div class=container-fluid><div class=row><div class=widget><ht-widget-header title={{title}} text-id=sportServiceFeeRegisterHelp right-text=rightText></ht-widget-header><div class=widget-content><form class=filter name=form><div class=row><cts-dropdown-list name=coachDropDown label=Coach value=vm.coachId datasource=vm.coachList databound=vm.coachDataBound select=vm.coachSelect validation-rules="{required: true}"></cts-dropdown-list><cts-dropdown-list name=sectionDropDown label=Section value=vm.sectionId datasource=vm.sectionList databound=vm.sectionDataBound select=vm.sectionSelect validation-rules="{required: true}"></cts-dropdown-list><cts-dropdown-list name=yearDropDownList label=Year value=vm.year datasource=vm.yearList databound=vm.yearDataBound select=vm.yearSelect validation-rules="{required: true}"></cts-dropdown-list><div class="form-group cts-form-group"><label translate>Month</label><div class=input-group><input type=text id=monthDropDownList name=monthDropDownList></div></div><div class=button-wrapper><button class=cts-button ej-button e-click=vm.getAthletes translate>GetDatas</button></div></div></form><div class=col-sm-12><script type=text/x-template id=sportservicefeeregistercolumnTemplate1><a data-ng-click="vm.goToAthlete(${Versenyzo_Id})">${Versenyzo_Nev}</a></script><script type=text/x-template id=sportservicefeeregistercolumnTemplate2><a data-ng-click="vm.openCoach(${EdzoId})">${EdzoNeve}</a></script><div style="position: fixed; z-index: 10000; top: 70px; left: 45%; background-color: forestgreen; color: white; border: 2px solid forestgreen; -webkit-border-radius: 5px;-moz-border-radius: 5px;border-radius: 5px;" data-ng-if=vm.AthleteUnderEditing><h2>{{vm.AthleteUnderEditingText}}: {{vm.AthleteUnderEditing}}</h2></div><div id=Grid class=slim-grid></div><div id=remarks><div class=col-sm-12 style="margin-top:10px; float:left;text-align:left; margin-right:-10px;"><p translate>NotationSportServiceFeeRegister</p></div><div class=col-sm-12><p><span translate>SportServiceFee</span>: {{vm.SportServiceFee}}</p><p><span translate>{{vm.kedvezmenyNevek[0]}}</span>: {{vm.sectionFees[0].KedvezmenyesTD}}</p><p><span translate>{{vm.kedvezmenyNevek[1]}}</span>: {{vm.sectionFees[0].KedvezmenyesTD2}}</p><p><span translate>{{vm.kedvezmenyNevek[2]}}</span>: {{vm.sectionFees[0].KedvezmenyesTD3}}</p><p><span translate>{{vm.kedvezmenyNevek[3]}}</span>: {{vm.sectionFees[0].KedvezmenyesTD4}}</p><p><span translate>{{vm.kedvezmenyNevek[4]}}</span>: {{vm.sectionFees[0].KedvezmenyesTD5}}</p></div></div></div><div class="col-sm-12 back" style="text-align: center"><button class=cts-button ej-button e-click=vm.saveWithoutNumbers data-ng-if="vm.atletesList.length !== 0" translate>Save</button> <button class=cts-button ej-button e-click=vm.saveWithNumbers data-ng-if="vm.atletesList.length !== 0" translate>SaveWithNumbers</button> <button class=cts-button ej-button e-click=vm.goToDailyPayments data-ng-if="vm.atletesList.length !== 0" translate>DailyPayments</button> <button class=cts-button ej-button e-click=back translate>Back</button></div></div></div><div class=widget-foot><div class=clearfix></div></div></div></div></section>');
$templateCache.put('app/messageCenter/messageCenter/messageCenter.html','<ht-widget-header title={{title}} text-id=messageCenterHelp right-text=rightText></ht-widget-header><div class=widget-content><form name=form class=filter><div id=mainPage-message-wrapper class=widget-content style="margin: 0; padding: 0 !important;"><div class=col-lg-3 id=message-list style="height: 600px; padding: 0 !important;"><div class=message-list-item ng-repeat="mess in vm.dataMessages" data-ng-click=vm.messageClicked($index) data-ng-class="{selected: (mess.TargyId === vm.openedMessageTargyId), \'unread\': mess.Olvasott === false}"><div class=message-list-item-main><span class=message-list-item-date>{{mess.MobilDatum}}</span><p ng-class="{\'message-list-item-header\': mess.Olvasott === false}">{{mess.Kivel}}</p><p ng-class="{\'message-list-item-header\': mess.Olvasott === false}" class=message-list-item-short-message>{{mess.Uzenet}}</p></div></div></div><div class=col-lg-9 style="height: 600px"><div id=toolbar ej-toolbar e-datasource=vm.toolbarItems e-fields-tooltiptext=tooltiptext e-enable-separator=true e-fields-id=empid e-fields-spritecssclass=spriteCss e-click=vm.toolbarClick style="float: right; width: 100%; height: 80px;"></div><div id=message-detail style="height: 400px;"><div ng-if="vm.SelectedMessageDateSource!=null" ng-repeat="Message in vm.SelectedMessageDateSource track by $index" ng-init="$last ? vm.finished() : angular.noop()"><div class=messenger-message-item ng-class="{\'sender\': Message.Kuldott === true}"><p class=nev>{{Message.Felado}}</p><div><img class=felado data-ng-src={{vm.profileImgBaseUrl}}{{Message.FeladoKep}}><div class=message-wrapper><p class=message>{{Message.Uzenet}}</p><div class=message-images><div data-ng-repeat="image in Message.images" class=message-image><a href={{vm.messageImagesUrl}}{{image}}><img data-ng-src={{vm.messageImagesUrl}}{{image}}></a></div></div><p class=datum>{{Message.MobilDatum}}</p></div></div></div></div></div><cts-text-area id=text type=submit tabindex=-1 name=message label=Message data-ng-model=vm.Message css="padding-left:0; padding-right:0; width: 100%;"></cts-text-area></div><div id=printDiv name=printDiv class=col-sm-6 data-ng-show=false><div ng-if="vm.SelectedMessageDateSource!=null" ng-repeat="Message in vm.SelectedMessageDateSource" ng-init="$last ? vm.finished() : angular.noop()" style="max-width: 500px; align-items: center;"><div class=messenger-message-item ng-class="{\'sender\': Message.Kuldott === true}"><p class=nev>{{Message.Felado}}</p><div><img class=felado data-ng-src={{vm.profileImgBaseUrl}}{{Message.FeladoKep}}><div class=message-wrapper><p class=message>{{Message.Uzenet}}</p><p class=datum>{{Message.MobilDatum}}</p></div><img class=kuldo data-ng-src={{vm.profileImgBaseUrl}}{{Message.FeladoKep}}></div></div></div></div></div></form></div><div class=widget-foot><div class=clearfix></div></div><script id=mecetemplateDataColumn1 type=text/x-template><span> ${if(Olvasott)} <img src="../images/Uzenetek/olvasott.png"/> ${else} <img src="../images/Uzenetek/olvasatlan.png"/> ${/if} </span></script>');
$templateCache.put('app/messageCenter/sentMessages/sentMessages.html','<div class=widget-head><h2 class=page-title>{{title}}</h2></div><div class=widget-content><form name=form class=filter><div id=toolbar ej-toolbar e-datasource=vm.toolbarItems e-fields-tooltiptext=tooltiptext e-enable-separator=true e-fields-id=empid e-fields-spritecssclass=spriteCss e-click=vm.toolbarClick></div><div class=col-xs-5><div id=Grid style="margin-left:-15px; width: 400px !important;" name=gridMessages></div></div><div id=printDiv name=printDiv class=col-xs-7 data-ng-show=false><div class=col-xs-12 ng-if=vm.SelectedMessage.Id><div class=col-xs-6><p style=margin-top:15px translate>Addressee</p><label>{{vm.SelectedMessage.CimzettNev}}</label></div><div class=col-xs-6><p style=margin-top:15px translate>Date</p><label>{{vm.SelectedMessage.Datum}}</label></div></div><br><div class=col-xs-12 ng-if=vm.SelectedMessage.Id><p style=margin-top:15px translate>Message</p><b><p name=message css="padding-left:0; padding-right:0; width: 100%;"><pre>\r\n                {{vm.SelectedMessage.Uzenet}}\r\n                </pre></p></b></div></div><div class=col-xs-7><div class=col-xs-12 ng-if=vm.SelectedMessage.Id><div class=col-xs-6><p style=margin-top:15px translate>Addressee</p><label>{{vm.SelectedMessage.CimzettNev}}</label></div><div class=col-xs-6><p style=margin-top:15px translate>Date</p><label>{{vm.SelectedMessage.Datum}}</label></div></div><br><div class=col-xs-12 ng-if=vm.SelectedMessage.Id><p style=margin-top:15px translate>Message</p><b><p name=message class=text-left><pre>{{vm.SelectedMessage.Uzenet}}</pre></p></b></div></div></form></div><div class=widget-foot><div class=clearfix></div></div><script id=mecetemplateDataColumn1 type=text/x-template><span> ${if(Olvasott)} <img src="../images/Uzenetek/olvasott.png" /> ${else} <img src="../images/Uzenetek/olvasatlan.png" /> ${/if} </span></script>');
$templateCache.put('app/messageCenter/newMessage/newMessage.html','<div class=widget-head><h2 class=page-title>{{title}}</h2></div><div class=widget-content><form name=form class=filter><div id=toolbar ej-toolbar e-datasource=vm.toolbarItems e-fields-tooltiptext=tooltiptext e-enable-separator=true e-fields-id=empid e-fields-spritecssclass=spriteCss e-click=vm.toolbarClick></div><div style=margin-top:20px class=col-xs-12><div id=recipients></div></div><div class=col-xs-11></div><div class=col-xs-12><cts-text-area name=message label=Message data-ng-model=vm.Message rows=20 css="padding-left:0; padding-right:0; width: 100%; margin-top:10px"></cts-text-area></div></form></div><div class=widget-foot><div class=clearfix></div></div>');
$templateCache.put('app/other/files/files.html','<div class=widget-head><h2 class=page-title>{{vm.title}}</h2></div><div class=widget-content><div class=col-xs-6><div id=Grid name=Grid></div></div><div class=col-xs-6 style=margin-top:15px><div class=clearfix></div><div style="overflow: hidden"><div class=posupload translate>Selectfile</div><br><div id=UploadDefault></div></div><div class=col-xs-6><button class="btn btn-primary post left-padding" id=delete data-ng-click=vm.deleteFile() type=button translate style="margin-top:20px; margin-left: -15px">Delete</button></div></div></div><div class=widget-foot style="text-align: center"><button type=button class=cts-button ej-button data-ng-click=back() style="margin-top: 5px;" translate>Back</button></div><script id=fitemplateDataColumn1 type=text/x-template><a href="${Filenev}" target="_blank">${Megnevezes}</a></script>');
$templateCache.put('app/reports/absenceReport/absenceReport.html','<ht-widget-header title={{title}} text-id=absenceReportHelp right-text=rightText></ht-widget-header><div class="widget-content form"><form name=form class=filter><div style="overflow: hidden;"><cts-dropdown-list name=section label=Section value=vm.SelectedSectionID datasource=vm.sectionList databound=vm.sectionDataBound select=vm.sectionSelect></cts-dropdown-list><cts-dropdown-list name=coach label=Coach value=vm.SelectedCoachID datasource=vm.coachList databound=vm.coachDropDownListDataBound select=vm.coachSelect></cts-dropdown-list><cts-date-picker name=selectdateFrom label=DateFrom value=vm.selectdateFrom change=vm.fromDateSelect validation-rules="{required: true}"></cts-date-picker><cts-date-picker name=selectdateTo label=DateTo value=vm.selectdateTo change=vm.toDateSelect validation-rules="{required: true}"></cts-date-picker><div class=button-wrapper><button class=cts-button ej-button e-click=vm.search translate>Search</button></div></div></form><div class=col-lg-12><script id=abretemplateDataColumn1 type=text/x-template><a data-ng-click="vm.openAthlete(${SportoloID})">${SportoloNeve}</a></script><script id=abretemplateDataColumn2 type=text/x-template><a data-ng-click="vm.openCoach(${EdzoID})">${EdzoNeve}</a></script><div id=Grid name=Grid></div></div>*<label translate>PercentageCalculationAndTotalNumberOfTrainingsIsPreciseOnlyWhenWholeMonthIsSelected</label></div><div class=widget-foot><div class=clearfix></div></div>');
$templateCache.put('app/reports/annualPresenceReports/annualPresenceReports.html','<div ui-view></div>');
$templateCache.put('app/reports/anthropometryTestPrinting/anthropometryTestPrinting.html','<ht-widget-header title={{title}} text-id=anthropometryTestPrintingHelp right-text=rightText></ht-widget-header><div class=widget-content><form class=filter name=form><div class=row><cts-date-picker name=datepickerFrom label=From value=vm.dateFromValue validation-rules="{required: true}"></cts-date-picker><cts-date-picker name=datepickerTo label=To value=vm.dateToValue validation-rules="{required: true}"></cts-date-picker><div class=button-wrapper><button id=search class=cts-button ej-button e-click=vm.search translate>Search</button> <button id=print class=cts-button ej-button e-click=vm.printSelection e-enabled=vm.printEnabled translate>Print</button></div></div></form><div class=row><script type=text/x-template id=anthropometryTestPrintingcolumnTemplate><a data-ng-click="vm.goToAthlete(${SportoloId})">${SportoloNeve}</a></script><div id=Grid name=Grid class=slim-grid></div></div></div><div class=widget-foot><div class=clearfix></div></div><div id=printDialoganthtest><report report-name=TAntropometriaNyomtatasReport report-parameters=vm.reportParameters></report></div>');
$templateCache.put('app/reports/assetInventoryReportByType/AssetInventoryReportByType.html','<ht-widget-header title={{title}} text-id=assetInventoryReportByTypeHelp right-text=rightText></ht-widget-header><div class=widget-content><form class=filter name=form><div class=row><cts-dropdown-list style="width: auto" name=AssetTypeDropDown label=AssetType value=vm.assetTypeId field-value=TipusId field-text=TipusNev datasource=vm.assetTypeList databound=vm.AssetTypeDataBound select=vm.assetTypeSelect></cts-dropdown-list><cts-check-box name=Active label=Active checked=vm.active enabled=vm.checkboxEnabled></cts-check-box><cts-check-box name=Expend label=Kiadva checked=vm.expend enabled=vm.checkboxEnabled></cts-check-box><cts-check-box name=All label=All checked=vm.all change=vm.selectAll></cts-check-box><div class=button-wrapper><button id=lekeres class=cts-button ej-button e-click=vm.show translate>Show</button></div></div></form><div class=row><div id=Grid name=Grid></div></div></div><div class=widget-foot><div class=clearfix></div></div>');
$templateCache.put('app/reports/assetInventoryReports/assetInventoryReports.html','<div ui-view></div>');
$templateCache.put('app/reports/assetInventoryReportByUsers/assetInventoryReportByUsers.html','<ht-widget-header title={{title}} text-id=assetInventoryReportByUserHelp right-text=rightText></ht-widget-header><div class=widget-content><div class=row><form class=filter name=form><cts-dropdown-list name=searchType label=SearchType value=vm.sectionIdValue datasource=vm.athletecoachList databound=vm.searchTypeDateBound select=vm.searchTypeSelect></cts-dropdown-list><cts-dropdown-list name=sectionDropDown label=Section value=vm.sectionId datasource=vm.sectionList databound=vm.sectionDataBound enabled=vm.searchTypeAthlete select=vm.sectionSelect></cts-dropdown-list><cts-dropdown-list name=ageGroupDropDown label=AgeGroup value=vm.ageGroupId datasource=vm.ageGroupList databound=vm.ageGroupDataBound enabled=vm.searchTypeAthlete select=vm.ageGroupSelect></cts-dropdown-list><div class=button-wrapper><button style="width:30%; float:left;" id=lekeres class=cts-button ej-button e-click=vm.show translate>Show</button></div></form></div><div class=row><div id=Grid></div></div></div><div class=widget-foot><div class=clearfix></div></div>');
$templateCache.put('app/reports/athleteTransfer/athleteTransfer.html','<ht-widget-header title={{title}} text-id=athleteTransferReportHelp right-text=rightText></ht-widget-header><div class=widget-content><form class=filter name=form><div class=row><cts-dropdown-list name=sectionDropDown label=Section value=vm.sectionId datasource=vm.sectionList databound=vm.sectionDataBound select=vm.sectionSelect></cts-dropdown-list><cts-dropdown-list name=coachDropDown label=Coach value=vm.coachId datasource=vm.coachList databound=vm.coachDataBound></cts-dropdown-list><div class=button-wrapper><button id=search class=cts-button ej-button e-click=vm.search translate>GetDatas</button></div></div></form><div class=row><script type=text/x-template id=attrcolumnTemplate1><a data-ng-click="vm.goToNewUser(${EdzoId})">${EdzoNeve}</a></script><script type=text/x-template id=columnTemplate2><a data-ng-click="vm.goToNewAthlete(${SportoloId})">${SportoloNeve}</a></script><div id=Grid name=Grid></div></div></div><div class=widget-foot><div class=clearfix></div></div>');
$templateCache.put('app/reports/awayBudgetPlanSummary/awayBudgetPlanSummary.html','<ht-widget-header title={{title}} text-id=awayBudgetPlanSummaryHelp right-text=rightText></ht-widget-header><div class=widget-content><form class=filter name=form><div class=row><cts-dropdown-list name=sectionDropDown label=Section value=vm.sectionId datasource=vm.sectionList databound=vm.sectionDataBound select=vm.sectionSelect validation-rules="{required: true}"></cts-dropdown-list><cts-dropdown-list name=ageGroupDropDown label=AgeGroup value=vm.ageGroupId datasource=vm.ageGroupList databound=vm.ageGroupDataBound select=vm.ageGroupSelect></cts-dropdown-list><cts-dropdown-list name=coachDropDown label=Coach value=vm.coachId datasource=vm.coachList databound=vm.coachDataBound select=vm.coachSelect></cts-dropdown-list></div><div class=row><cts-date-picker name=datepickerFrom label=From value=vm.selectdateFrom validation-rules="{required: true}"></cts-date-picker><cts-date-picker name=datepickerTo label=To value=vm.selectdateTo validation-rules="{required: true}"></cts-date-picker><cts-check-box name=onlyStartDate label=OnlyStartDate checked=vm.onlyStartDate change=vm.onlyStartDateChanged></cts-check-box><div class=button-wrapper><button id=lekeres class=cts-button ej-button e-click=vm.show translate>Show</button></div></div></form><script id=rowtemplate type=text/x-template><tr role="row" class="e-row ng-scope"> ${if (Megnevezes == \'Terv\')} <td class="e-rowcell" style="width: 90px;" rowspan="4">${VersenySorszam}</td> <td class="e-rowcell" style="width: 125px;" rowspan="4">${Szakosztaly}</td> <td class="e-rowcell" style="width: 135px;">${NevHelyCsopRsz}</td> <td class="e-rowcell" style="width: 150px;" rowspan="4">${VersenyKezdesIdopont}</td> <td class="e-rowcell" style="width: 150px;" rowspan="4">${VersenyBefejezesIdopont}</td> <td class="e-rowcell" style="width: 150px;">${Megnevezes}</td> <td class="e-rowcell" style="width: 130px;">${UtazasiKoltseg}</td> <td class="e-rowcell" style="width: 120px;">${Etkezes}</td> <td class="e-rowcell" style="width: 120px;">${Szallas}</td> <td class="e-rowcell" style="width: 120px;">${NevezesiDij}</td> <td class="e-rowcell" style="width: 120px;">${KikuldetesiKoltseg}</td> <td class="e-rowcell" style="width: 120px;">${Egyeb}</td> <td class="e-rowcell" style="width: 120px;">${Osszesen}</td> <td class="e-rowcell" style="width: 120px;" rowspan="3">${ElolegOsszege}</td> ${/if} ${if (Megnevezes == \'Teny\')} <td style="border-left: 1px solid #e0e0e0;" class="e-rowcell" style="width: 135px; ">${NevHelyCsopRsz}</td> <td class="e-rowcell" style="width: 150px;">${Megnevezes}</td> <td class="e-rowcell" style="width: 130px;">${UtazasiKoltseg}</td> <td class="e-rowcell" style="width: 120px;">${Etkezes}</td> <td class="e-rowcell" style="width: 120px;">${Szallas}</td> <td class="e-rowcell" style="width: 120px;">${NevezesiDij}</td> <td class="e-rowcell" style="width: 120px;">${KikuldetesiKoltseg}</td> <td class="e-rowcell" style="width: 120px;">${Egyeb}</td> <td class="e-rowcell" style="width: 120px;">${Osszesen}</td> ${/if} ${if (Megnevezes == \'Szolg.\')} <td style="border-left: 1px solid #e0e0e0;" class="e-rowcell" style="width: 135px;">${NevHelyCsopRsz}</td> <td class="e-rowcell" style="width: 150px;">${Megnevezes}</td> <td class="e-rowcell" style="width: 130px;">${UtazasiKoltseg}</td> <td class="e-rowcell" style="width: 120px;">${Etkezes}</td> <td class="e-rowcell" style="width: 120px;">${Szallas}</td> <td class="e-rowcell" style="width: 120px;">${NevezesiDij}</td> <td class="e-rowcell" style="width: 120px;">${KikuldetesiKoltseg}</td> <td class="e-rowcell" style="width: 120px;">${Egyeb}</td> <td class="e-rowcell" style="width: 120px;">${Osszesen}</td> ${/if} ${if (Megnevezes == \'Megjegyz\xE9s\')} <td style="border-left: 1px solid #e0e0e0;" class="e-rowcell" style="width: 135px;">${NevHelyCsopRsz}</td> <td class="e-rowcell" style="width: 150px;">${Megnevezes}</td> <td class="e-rowcell" style="width: 130px;" colspan="8">${UtazasiKoltseg}</td> ${/if} </tr></script><div class=row><div id=Grid name=Grid style="overflow: hidden"></div></div></div><div class=widget-foot><div class=clearfix></div></div>');
$templateCache.put('app/reports/centralReport/centralReport.html','<div ui-view></div>');
$templateCache.put('app/reports/duplicatedAthletes/duplicatedAthletes.html','<ht-widget-header title={{title}} text-id=duplicatedAthletesHelp right-text=rightText></ht-widget-header><div class=widget-content><form class=filter name=form><div class=row><cts-check-box name=InactivesToo label=SearchInInactivesToo checked=vm.InactivesToo change=vm.InactivesChange></cts-check-box></div></form><script type=text/x-template id=duplicatedcolumnTemplate1><a data-ng-click="vm.goToAthlete(${SportolokID})">${Nev}</a></script><script type=text/x-template id=duplicatedcolumnTemplate2><a data-ng-click="vm.goToUser(${EdzoId})">${EdzoNeve}</a></script><div id=Grid name=Grid></div></div><div class=widget-foot><div class=clearfix></div></div>');
$templateCache.put('app/reports/expiringDocuments/expiringDocuments.html','<ht-widget-header title={{title}} text-id=expiringDocumentsHelp right-text=rightText></ht-widget-header><div class="widget-content form"><form name=form class=filter><div style="overflow: hidden;"><cts-dropdown-list name=section label=Section datasource=vm.sectionList databound=vm.sectionDataBound select=vm.sectionSelect></cts-dropdown-list><cts-dropdown-list name=agegroup label=AgeGroup datasource=vm.ageGroupList databound=vm.ageGroupDataBound select=vm.ageGroupSelect></cts-dropdown-list><cts-dropdown-list name=coach label=Coach datasource=vm.coachList databound=vm.coachDataBound select=vm.coachSelect></cts-dropdown-list></div><div style="overflow: hidden;"><cts-date-picker name=selectdateTo label=DateTo value=vm.selectdateTo validation-rules="{required: true}"></cts-date-picker><cts-check-box name=spc label=SearchForExpiringSportPhysicalCertificate checked=vm.searchSPC></cts-check-box><cts-check-box name=passp label=SearchForExpiringPassort checked=vm.searchPP></cts-check-box><cts-check-box name=pid label=SearchForExpiringPersonalIdentity checked=vm.searchPID></cts-check-box><div class=button-wrapper><button class=cts-button ej-button e-click=vm.search translate>Search</button></div></div></form><div class=row><script id=exdotemplateDataColumn1 type=text/x-template><a data-ng-click="vm.openAthlete(${SportoloID})">${SportoloNeve}</a></script><script id=exdotemplateDataColumn2 type=text/x-template><a data-ng-click="vm.openCoach(${EdzoID})">${EdzoNeve}</a></script><div id=Grid></div></div></div><div class=widget-foot><div class=clearfix></div></div>');
$templateCache.put('app/reports/healthReport/healthReport.html','<ht-widget-header title={{title}} text-id=healthReportHelp right-text=rightText></ht-widget-header><div class=widget-content><form class=filter name=form><div class=row><cts-dropdown-list name=sectionDropDown label=Section value=vm.sectionId datasource=vm.sectionList databound=vm.sectionDataBound select=vm.sectionSelect validation-rules="{required: true}"></cts-dropdown-list><cts-dropdown-list name=ageGroupDropDown label=AgeGroup value=vm.ageGroupId datasource=vm.ageGroupList databound=vm.ageGroupDataBound select=vm.ageGroupSelect></cts-dropdown-list><cts-dropdown-list name=coachDropDown label=Coach value=vm.coachId datasource=vm.coachList databound=vm.coachDataBound select=vm.coachSelect></cts-dropdown-list></div><div class=row><cts-date-picker name=selectdateFrom label=DateFrom value=vm.selectdateFrom change=vm.changeDateFrom validation-rules="{required: true}"></cts-date-picker><cts-date-picker name=selectdateTo label=DateTo value=vm.selectdateTo change=vm.changeDateTo validation-rules="{required: true}"></cts-date-picker></div><div class=row><cts-dropdown-list name=MainTypeDropDown label=MainType value=vm.mainType datasource=vm.healthMainType select=vm.MainTypeSelect databound=vm.mainTypeDataBound validation-rules="{required: false}"></cts-dropdown-list><cts-dropdown-list name=SubTypeDropDown label=SubType value=vm.subType datasource=vm.filteredSubTypes databound=vm.subTypeDataBound validation-rules="{required: false}"></cts-dropdown-list></div><div class=button-wrapper><button id=lekeres class=cts-button ej-button e-click=vm.show translate>Show</button></div></form><div class=row><script type=text/x-template id=healthedit><a data-ng-click="vm.goToModifyHealthEvent(${EgeszsegEsetId})"><i class="fa fa-eye" style="font-size: 1.5em;"></i></a></script><div id=Grid name=Grid></div></div></div><div class=widget-foot><div class=clearfix></div></div>');
$templateCache.put('app/reports/monthlyCompetitivePlans/monthlyCompetitivePlans.html','<ht-widget-header title={{title}} text-id=monthlyCompetitivePlansHelp right-text=rightText></ht-widget-header><div class=widget-content><form class=filter name=form><div class=row><cts-date-picker name=datepickerFrom label=From value=vm.dateFromValue change=vm.dateFromChange validation-rules="{required: true}"></cts-date-picker><cts-date-picker name=datepickerTo label=To value=vm.dateToValue change=vm.dateToChange validation-rules="{required: true}"></cts-date-picker></div><div class=row><cts-dropdown-list name=sectionDropDown label=Section value=vm.sectionId datasource=vm.sectionList databound=vm.sectionDataBound select=vm.sectionSelect validation-rules="{required: true}"></cts-dropdown-list><cts-dropdown-list name=coachDropDown label=Coach value=vm.coachId datasource=vm.coachList databound=vm.coachDataBound></cts-dropdown-list><div class=button-wrapper><button id=search class=cts-button ej-button e-click=vm.search translate>GetDatas</button></div></div></form><div class=row><script type=text/x-template id=moncompplacolumnTemplate1><a data-ng-click="vm.goToMonthlyCompetitivePlan(${planId})" translate><i class="fa fa-eye" style="font-size: 1.5em;"></i></a></script><script type=text/x-template id=monthlyCompetitivePlanscolumnTemplate1><a data-ng-click="vm.openCoach(${EdzoId})">${EdzoNeve}</a></script><script type=text/x-template id=monthlyCompetitivePlanscolumnTemplate2><a data-ng-click="vm.openCoach(${JovahagytaId})">${JovahagytaNeve}</a></script><div id=Grid name=Grid></div></div></div><div class=widget-foot><div class=clearfix></div></div>');
$templateCache.put('app/reports/managementReports/managementReports.html','<div ui-view></div>');
$templateCache.put('app/reports/playUpAndDown/playUpAndDown.html','<ht-widget-header title={{title}} text-id=playUpAbdDownHelp right-text=rightText></ht-widget-header><div class=widget-content><form class=filter name=form><div class=row><cts-dropdown-list name=sectionDropDown label=Section value=vm.sectionId datasource=vm.sectionList databound=vm.sectionDataBound select=vm.sectionSelect validation-rules="{required: true}"></cts-dropdown-list><cts-dropdown-list name=ageGroupDropDown label=AgeGroup value=vm.ageGroupId datasource=vm.ageGroupList databound=vm.ageGroupDataBound select=vm.ageGroupSelect></cts-dropdown-list><cts-dropdown-list name=coachDropDown label=Coach value=vm.coachId datasource=vm.coachList databound=vm.coachDataBound select=vm.coachSelect></cts-dropdown-list><div class=button-wrapper><button id=lekeres class=cts-button ej-button e-click=vm.show translate>Show</button></div></div></form><script type=text/x-template id=puadath><a data-ng-click="vm.openAthlete(${SportolokID})">${Nev}</a></script><script type=text/x-template id=puadcoach><a data-ng-click="vm.openCoach(${EdzoId})">${EdzoNeve}</a></script><div class=row><div id=Grid name=Grid></div></div></div><div class=widget-foot><div class=clearfix></div></div>');
$templateCache.put('app/reports/raceResultsReport/raceResultsReport.html','<ht-widget-header title={{title}} text-id=raceResultsReportHelp right-text=rightText></ht-widget-header><div class="widget-content form"><form name=form class=filter><div style="overflow: hidden;"><cts-text-box name=name label=Name data-ng-model=vm.athleteData.Nev change=vm.nameChange enabled=false></cts-text-box><cts-date-picker name=birthDate label=BirthDate value=vm.birthDate clear=vm.clearYear change=vm.selectBirthDate></cts-date-picker><cts-dropdown-list name=Team label=Team datasource=vm.teamsList databound=vm.teamsDataBound clear=vm.clearTeam select=vm.teamsSelect></cts-dropdown-list><cts-date-picker name=selectdateFrom label=DateFrom value=vm.selectdateFrom clear=vm.clearSelectdateFrom change=vm.selectdateFromChange></cts-date-picker></div><div style="overflow: hidden;"><cts-dropdown-list name=section label=Section datasource=vm.sectionList databound=vm.sectionDataBound clear=vm.clearSection select=vm.sectionSelect></cts-dropdown-list><cts-dropdown-list name=ageGroup label=AgeGroup datasource=vm.ageGroupList databound=vm.ageGroupDataBound clear=vm.clearAgeGroup select=vm.ageGroupSelect></cts-dropdown-list><cts-dropdown-list name=coach label=Coach datasource=vm.coachList databound=vm.coachDropDownListDataBound clear=vm.clearCoach select=vm.coachSelect></cts-dropdown-list><cts-date-picker name=selectdateTo label=DateTo value=vm.selectdateTo clear=vm.clearSelectdateTo change=vm.selectdateToChange></cts-date-picker></div><div style="overflow: hidden;"><cts-text-box name=athleteRatings label=CoachRating data-ng-model=vm.requestedData.Ertekeles></cts-text-box><cts-text-box name=athleteRanking label=AthleteRanking data-ng-model=vm.requestedData.Helyezes></cts-text-box><cts-text-box name=athleteResults label=ResultText data-ng-model=vm.requestedData.EredmenySzoveg></cts-text-box><div class="form-group cts-form-group"><label for=coachRating><label translate>CoachRating</label></label><div id=coachRating><div class=radioBtn><input type=radio ej-radiobutton name=large id=Radio1 value=-2 e-change=vm.radioButtonChecked> <label for=Radio1 class=labelBtn>1</label></div><div class=radioBtn><input type=radio ej-radiobutton name=large id=Radio2 value=-1 e-change=vm.radioButtonChecked> <label for=Radio2 class=labelBtn>2</label></div><div class=radioBtn><input type=radio ej-radiobutton name=large id=Radio3 value=0 e-change=vm.radioButtonChecked> <label for=Radio3 class=labelBtn>3</label></div><div class=radioBtn><input type=radio ej-radiobutton name=large id=Radio4 value=1 e-change=vm.radioButtonChecked> <label for=Radio4 class=labelBtn>4</label></div><div class=radioBtn><input type=radio ej-radiobutton name=large id=Radio5 value=2 e-change=vm.radioButtonChecked> <label for=Radio5 class=labelBtn>5</label></div><div class=radioBtn><input type=radio ej-radiobutton name=large id=Radio6 value=2 e-change=vm.radioButtonClear> <label for=Radio6 class=labelBtn>-</label></div></div></div></div><div style="overflow: hidden;"><cts-text-box name=location label=Location data-ng-model=vm.requestedData.Helyszin></cts-text-box><cts-text-box name=competitionType label=Jellege data-ng-model=vm.requestedData.Jellege></cts-text-box><cts-text-box name=competition label=VersenyLeiras data-ng-model=vm.requestedData.VersenyLeiras></cts-text-box><cts-text-box name=Versenyszam label=Versenyszam data-ng-model=vm.requestedData.Versenyszam></cts-text-box></div><div class=button-wrapper style="text-align: center; margin-top: 1.5em;"><button class=cts-button ej-button e-click=vm.searchTeam translate>SearchTeam</button> <button class=cts-button ej-button e-click=vm.searchAthlete translate>SearchAthlete</button> <button id=deleteResult class=cts-button e-enabled=vm.showDelButton ej-button e-click=vm.deleteResult translate>deleteResult</button></div><script id=rareretemplateDataColumn1 type=text/x-template><a data-ng-click="vm.openAthlete(${SportoloId})">${SportoloNev}</a></script><script id=rareretemplateDataColumn2 type=text/x-template><a data-ng-click="vm.openCoach(${EdzoId})">${EdzoNeve}</a></script><script id=rareretemplateDataColumn3 type=text/x-template><a data-ng-click="vm.open(${Id})" translate><i class="fa fa-eye" style="font-size: 1.5em;"></a></script><script id=rareretemplateDataColumn4 type=text/x-template><a data-ng-click="vm.printAthleteResult(${Id})" translate>Print</a></script></form><div class=row style="margin-top: 2em; clear: both;"><div data-ng-show="vm.searched === \'athlete\'"><div class=col-lg-12><div id=Grid class=slim-grid></div></div></div><script id=rareretemplateDataColumn5 type=text/x-template><a data-ng-click="vm.openTeam(${CsapatId})">${CsapatNev}</a></script><script id=rareretemplateDataColumn6 type=text/x-template><a data-ng-click="vm.openCoach(${EdzoId})">${EdzoNeve}</a></script><script id=rareretemplateDataColumn7 type=text/x-template><a data-ng-click="vm.open(${Id})"><i class="fa fa-eye" style="font-size: 1.5em;"></i></a></script><script id=rareretemplateDataColumn8 type=text/x-template><a data-ng-click="vm.printTeamResult(${Id})" translate>Print</a></script><div data-ng-show="vm.searched === \'team\'"><div class=col-lg-12><div id=Grid2 class=slim-grid></div></div></div><div class=col-lg-12 style="text-align: center; margin-top: 1.5em;"><button class=cts-button ej-button e-click=back translate>Back</button></div></div></div><div class=widget-foot><div class=clearfix></div></div><div id=printDialogA ej-dialog e-height=95% e-width=95% e-showoninit=false e-enablemodal=true e-position-x=0 e-position-y=0 e-target=#mainContent e-enableresize=false><report report-name=TVersenyeredmenySportoloReport report-parameters=vm.reportParameters></report></div><div id=printDialogT ej-dialog e-height=95% e-width=95% e-showoninit=false e-enablemodal=true e-position-x=0 e-position-y=0 e-target=#mainContent e-enableresize=false><report report-name=TVersenyeredmenyCsapatReport report-parameters=vm.reportParameters2></report></div>');
$templateCache.put('app/reports/sportSpecificReport/sportSpecificReport.html','<ht-widget-header title={{title}} text-id=sportSpecificReportHelp right-text=rightText></ht-widget-header><div class=widget-content><form class=filter name=form><div class=row><cts-dropdown-list name=sectionDropDown label=Section value=vm.sectionIdValue datasource=vm.sectionList databound=vm.sectionDataBound select=vm.sectionSelect validation-rules="{required: true}"></cts-dropdown-list><cts-dropdown-list name=ageGroupDropDown label=AgeGroup value=vm.ageGroupIdValue datasource=vm.ageGroupList databound=vm.ageGroupDataBound select=vm.ageGroupSelect validation-rules="{required: true}"></cts-dropdown-list><cts-dropdown-list name=tipusDropDown label=FelmeroTipus value=vm.tipusIdValue datasource=vm.tipusList databound=vm.tipusDataBound select=vm.tipusSelect validation-rules="{required: true}"></cts-dropdown-list></div><div class=row><cts-date-picker name=datepickerFrom label=From value=vm.dateFromValue change=vm.getData validation-rules="{required: true}"></cts-date-picker><cts-date-picker name=datepickerTo label=To value=vm.dateToValue change=vm.getData validation-rules="{required: true}"></cts-date-picker></div></form><div class=col-lg-12><div id=Grid2></div></div></div><div class=widget-foot><div class=clearfix></div></div>');
$templateCache.put('app/reports/trainingAttendanceReport/trainingAttendanceReport.html','<ht-widget-header title={{title}} text-id=trainingAttendanceReportHelp right-text=rightText></ht-widget-header><div class=widget-content><form class=filter name=form><div class=row><cts-date-picker name=datepickerFrom label=From value=vm.dateFromValue validation-rules="{required: true}"></cts-date-picker><cts-date-picker name=datepickerTo label=To value=vm.dateToValue validation-rules="{required: true}"></cts-date-picker><cts-dropdown-list name=coachDropDown label=Coach value=vm.coachId datasource=vm.coachList databound=vm.coachDataBound validation-rules="{required: true}"></cts-dropdown-list><div class=button-wrapper><button type=submit id=search class=cts-button ej-button e-click=vm.show translate>Show</button></div></div></form><div class=row><script type=text/x-template id=trainingAttendanceReportcolumnTemplate><a data-ng-click="vm.goToAthlete(${SportoloID})">${SportoloNeve}</a></script><div id=Grid name=Grid></div>*<label translate>PercentageCalculationAndTotalNumberOfTrainingsIsPreciseOnlyWhenWholeMonthIsSelected</label></div></div><div class=widget-foot><div class=clearfix></div></div>');
$templateCache.put('app/reports/statisticalReports/statisticalReports.html','<div ui-view></div>');
$templateCache.put('app/reports/weeklyTrainingReport/weeklyTrainingReport.html','<ht-widget-header title={{title}} text-id=weeklyTreiningReportHelp right-text=rightText></ht-widget-header><div class=widget-content><form class=filter name=form><div class=row><cts-dropdown-list name=sectionDropDown label=Section value=vm.sectionId datasource=vm.sectionList databound=vm.sectionDataBound select=vm.sectionSelect validation-rules="{required: true}"></cts-dropdown-list><cts-dropdown-list name=ageGroupDropDown label=AgeGroup value=vm.ageGroupId datasource=vm.ageGroupList databound=vm.ageGroupDataBound select=vm.ageGroupSelect></cts-dropdown-list><cts-dropdown-list name=coachDropDown label=Coach value=vm.coachId datasource=vm.coachList databound=vm.coachDataBound select=vm.coachSelect></cts-dropdown-list></div><div class=row><cts-date-picker name=datepickerFrom label=From value=vm.selectdateFrom change=vm.dateFromChange validation-rules="{required: true}"></cts-date-picker><cts-date-picker name=datepickerTo label=To value=vm.selectdateTo change=vm.dateToChange validation-rules="{required: true}"></cts-date-picker></div><div class=row><cts-auto-complete name=Place label=Place value=vm.place validation-rules="{required: false}" datasource=vm.places></cts-auto-complete><cts-check-box name=ShowWeeks label=ShowWeeks checked=vm.showWeeks change=vm.showWeeksChange></cts-check-box><div class=button-wrapper><button id=lekeres class=cts-button ej-button e-click=vm.show translate>Show</button></div></div></form><div class=row><script type=text/x-template id=wtro><a data-ng-click="vm.openPlan(${hetiedzestervid})"><i class="fa fa-eye" style="font-size: 1.5em;"></i></a></script><div id=Grid name=Grid></div></div></div><div class=widget-foot><div class=clearfix></div></div>');
$templateCache.put('app/reports/weeklyTravelReport/weeklyTravelReport.html','<ht-widget-header title={{title}} text-id=weeklyTravelReportHelp right-text=rightText></ht-widget-header><div class=widget-content><form class=filter name=form><div class=row><cts-dropdown-list name=sectionDropDown label=Section value=vm.sectionId datasource=vm.sectionList databound=vm.sectionDataBound select=vm.sectionSelect validation-rules="{required: true}"></cts-dropdown-list><cts-dropdown-list name=ageGroupDropDown label=AgeGroup value=vm.ageGroupId datasource=vm.ageGroupList databound=vm.ageGroupDataBound select=vm.ageGroupSelect></cts-dropdown-list><cts-dropdown-list name=coachDropDown label=Coach value=vm.coachId datasource=vm.coachList databound=vm.coachDataBound select=vm.coachSelect></cts-dropdown-list></div><div class=row><cts-date-picker name=datepickerFrom label=From value=vm.selectdateFrom change=vm.fromDateChange validation-rules="{required: true}"></cts-date-picker><cts-date-picker name=datepickerTo label=To value=vm.selectdateTo change=vm.toDateChange validation-rules="{required: true}"></cts-date-picker><cts-dropdown-list name=typeDropDown label=Type value=vm.typeId datasource=vm.typeList databound=vm.typeDataBound select=vm.typeSelect></cts-dropdown-list></div><div class=row><cts-dropdown-list name=BusOwnerDropDown label=BusOwner value=vm.busOwnerId datasource=vm.busOwners databound=vm.busOwnersDataBound select=vm.busOwnerSelect></cts-dropdown-list><cts-check-box name=onlyStartDate label=OnlyStartDate checked=vm.onlyStartDate></cts-check-box></div><div class=row><div class=button-wrapper><button id=lekeres class=cts-button ej-button e-click=vm.show translate>Show</button></div></div></form><script type=text/x-template id=WTRPlanOpenTemplate><a data-ng-click="vm.openPlan(${Id})"><i class="fa fa-eye" style="font-size: 1.5em;"></i></a></script><div class=row><div id=Grid name=Grid></div></div></div><div class=widget-foot><div class=clearfix></div></div>');
$templateCache.put('app/search/user/user.html','<section class=mainbar><div class=container-fluid><div class=row><div class=widget><div ui-view></div></div></div></div></section>');
$templateCache.put('app/search/athletes/athletes.html','<section class=mainbar><div class=container-fluid><div class=row><div class=widget><div ui-view></div></div></div></div></section>');
$templateCache.put('app/settings/ageGroupChange/ageGroupChange.html','<section class=mainbar><div class=container-fluid><div class=row><div class=widget><ht-widget-header title={{title}} text-id=ageGroupChangeHelp right-text=rightText></ht-widget-header><div class=widget-content><form class=filter name=form><div class=row><div ng-if="vm.actualAthleteId>0 && vm.which==1" class="form-group cts-form-group"><label for=actualSection>{{"ActualSection"|translate}}</label> <label id=actualSection style="text-align: left; padding-left: 12px">{{vm.athleteData.SzakosztalyNev}}</label></div><div ng-if="vm.actualAthleteId>0 && vm.which==2" class="form-group cts-form-group"><label for=actualSection>{{"ActualSection"|translate}}</label> <label id=actualSection style="text-align: left; padding-left: 12px">{{vm.athleteData.MasodlagosSzakosztalyNev}}</label></div><cts-dropdown-list ng-if="vm.actualAthleteId==0" name=actualSectionDropDown value=vm.actualSectionId label=ActualSection datasource=vm.actualSectionList databound=vm.actualSectionDataBound select=vm.actualSectionSelect validation-rules="{required: true}"></cts-dropdown-list><div ng-if="vm.actualAthleteId>0 && vm.which==1" class="form-group cts-form-group"><label for=actualCoach>{{"ActualCoach"|translate}}</label> <label id=actualCoach style="text-align: left; padding-left: 12px">{{vm.athleteData.JelenlegiEdzoNev}}</label></div><div ng-if="vm.actualAthleteId>0 && vm.which==2" class="form-group cts-form-group"><label for=actualCoach>{{"ActualCoach"|translate}}</label> <label id=actualCoach style="text-align: left; padding-left: 12px">{{vm.athleteData.MasodlagosSzakosztalyEdzoNev}}</label></div><cts-dropdown-list ng-if="vm.actualAthleteId==0" name=actualCoachDropDown value=vm.actualCoachId label=ActualCoach datasource=vm.actualCoachList databound=vm.actualCoachDataBound select=vm.actualCoachSelect validation-rules="{required: true}"></cts-dropdown-list></div><div class=row><cts-date-picker name=datepick label=DateTransfer value=vm.dateValue change=vm.dateChange validation-rules="{required: true}"></cts-date-picker><cts-dropdown-list name=ageGroupDropDown value=vm.ageGroupId label=NewAgeGroup datasource=vm.ageGroupList databound=vm.ageGroupDataBound select=vm.ageGroupSelect validation-rules="{required: true}"></cts-dropdown-list><div class=button-wrapper><button type=submit class=cts-button ej-button e-click=vm.transferAthletes translate>Transfer</button></div></div></form><div class=row><script type=text/x-template id=agegroupchangecolumnTemplate1><a data-ng-click="vm.openCoach(${EdzoId})">${EdzoNeve}</a></script><script type=text/x-template id=agegroupchangecolumnTemplate2><a data-ng-click="vm.goToAthlete(${SportolokId})">${Nev}</a></script><div id=Grid></div></div></div><div class=widget-foot><div class=clearfix></div></div></div></div></div></section><script id=checkboxTemplateAktiv type=text/x-template><input data-ng-if="\'${Aktiv}\' === \'true\'" type="checkbox" checked="checked" disabled/> <input data-ng-if="\'${Aktiv}\' !== \'true\'" type="checkbox" disabled/></script>');
$templateCache.put('app/settings/athleteTransfer/athleteTransfer.html','<section class=mainbar><div class=container-fluid><div class=row><div class=widget><ht-widget-header title={{title}} text-id=athleteTransferHelp right-text=rightText></ht-widget-header><div class=widget-content><form class=filter name=form><div class=row><cts-dropdown-list name=actualSectionDropDown value=vm.actualSectionId label=ActualSection datasource=vm.actualSectionList databound=vm.actualSectionDataBound select=vm.actualSectionSelect validation-rules="{required: true}"></cts-dropdown-list><cts-dropdown-list name=actualCoachDropDown value=vm.actualCoachId label=ActualCoach datasource=vm.actualCoachList databound=vm.actualCoachDataBound select=vm.actualCoachSelect></cts-dropdown-list></div><div class=row><cts-dropdown-list name=sectionDropDown value=vm.sectionId label=Section datasource=vm.sectionList databound=vm.sectionDataBound select=vm.sectionSelect validation-rules="{required: true}"></cts-dropdown-list><cts-dropdown-list name=coachDropDown value=vm.coachId label=Coach datasource=vm.coachList databound=vm.coachDataBound select=vm.coachSelect validation-rules="{required: true}"></cts-dropdown-list><cts-dropdown-list name=ageGroupDropDown value=vm.ageGroupId label=AgeGroup datasource=vm.ageGroupList databound=vm.ageGroupDataBound select=vm.ageGroupSelect validation-rules="{required: true}"></cts-dropdown-list></div><div class=row><cts-date-picker name=datepick label=DateTransfer value=vm.dateValue change=vm.dateChange></cts-date-picker><div class=button-wrapper><button class=cts-button ej-button e-click=vm.transferAthletes translate>Transfer</button></div></div></form><script type=text/x-template id=athltransfercolumnTemplate1><a data-ng-click="vm.openCoach(${EdzoId})">${EdzoNeve}</a></script><script type=text/x-template id=athltransfercolumnTemplate2><a data-ng-click="vm.goToAthlete(${SportolokId})">${Nev}</a></script><div class=row><div id=Grid name=Grid></div></div></div><div class=widget-foot><div class=clearfix></div></div></div></div></div></section>');
$templateCache.put('app/settings/createSportSpecificTest/createSportSpecificTest.html','<style>\r\n.flex-container {\r\n    display: -webkit-flex;\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n}\r\n.flex-item {\r\n    width: 80px;\r\n    height: 50px;\r\n    margin: 3px;\r\n}\r\n.flex-iteminf {\r\n    width: 20px;\r\n    height: 50px;\r\n    margin: 3px;\r\n    margin-top: 25px;\r\n}\r\n.flex-itemcp {\r\n    width: 80px;\r\n    height: 50px;\r\n    margin: 3px;\r\n    margin-top: 4px;\r\n    margin-right:-41px;\r\n}\r\n</style><section class=mainbar><div class=container-fluid><div class=row><div class=widget><ht-widget-header title={{title}} text-id=createSportSpecificTestHelp right-text=rightText></ht-widget-header><div class=widget-content><form class=filter name=form><div class=row><cts-dropdown-list name=section label=Section datasource=vm.sectionList value=vm.sectionValue select=vm.sectionSelect databound=vm.sectionDataBound></cts-dropdown-list><div class=button-wrapper><div ng-if=vm.UJSPFELM><button id=newFelmeroElemFej class=cts-button ej-button e-click=vm.NewFelmeroTipus data-ng-if="vm.sectionValue>0" translate>NewSportSpecificTestTemplate</button></div></div></div></form><div data-ng-show="vm.sectionValue > 0"><label translate>FelmeroTipusokSzakosztalyonkent</label><div id=GridFelmeroTipus2></div><br><div class=button-wrapper ng-if=vm.UJSPFELM><button id=copyFelmeroElemFej class=cts-button ej-button e-click=vm.CopyFelmeroTipus e-enabled=vm.copyButtonEnabled translate>copyFelmeroElemFej</button> <button id=deleteFelmeroElemFej class=cts-button ej-button e-click=vm.DeleteFelmeroTipus e-enabled=vm.deleteButtonEnabled translate>deleteFelmeroElemFej</button> <button id=activateFelmeroElemFej class=cts-button ej-button e-click=vm.ActivateFelmeroTipus ng-if="!vm.selectedFelmeroIsActive && vm.felmeroTipusKijelolve" translate>activate</button> <button id=inactivateFelmeroElemFej class=cts-button ej-button e-click=vm.InactivateFelmeroTipus ng-if="vm.selectedFelmeroIsActive && vm.felmeroTipusKijelolve" translate>inactivate</button></div></div><div data-ng-show="vm.selectedFelmeroElemFej > 0" style="margin-top: 25px;"><label>{{vm.felmNev}} &nbsp;</label><label translate>FelmeroElemei</label><div id=GridFelmeroElem2></div><div class="alert alert-warning" ng-if=vm.saveBeforeColorWarning><label translate>PleaseSaveFelmeroElemBeforeChoosingColors</label></div><label ng-if=vm.colordivenabled style=margin-top:20px;>{{vm.felmElemNev}} &nbsp;</label><label ng-if=vm.colordivenabled translate>FelmeroElemSzinei</label><div class="panel panel-default" ng-if=vm.colordivenabled><div><p style="padding: 1em 1em 0; margin: 0;"><span style="background-color: {{vm.color1}}; padding: 0.25em 2em;">-\u221E - {{vm.num1}}</span> <span style="background-color: {{vm.color12}}; padding: 0.25em 2em;">{{vm.num1 + 1}} - {{vm.num2}}</span> <span style="background-color: {{vm.color23}}; padding: 0.25em 2em;">{{vm.num2 + 1}} - {{vm.num3}}</span> <span style="background-color: {{vm.color34}}; padding: 0.25em 2em;">{{vm.num3 + 1}} - {{vm.num4}}</span> <span style="background-color: {{vm.color45}}; padding: 0.25em 2em;">{{vm.num4 + 1}} - {{vm.num5}}</span> <span style="background-color: {{vm.color5}}; padding: 0.25em 2em;">{{vm.num5 + 1}} - +\u221E</span></p></div><div class=flex-container><div class=flex-iteminf><label>-\u221E<label></label></label></div><div class=flex-itemcp><cts-color-picker name=colorPick1 value=vm.color1 select=vm.applyColor></cts-color-picker></div><div class=flex-item><cts-numeric-text-box value=vm.num1 change=vm.applyColor ng-if=vm.int></cts-numeric-text-box><cts-numeric-text-box value=vm.num1 change=vm.applyColor ng-if=vm.double decimalplaces=3></cts-numeric-text-box><cts-mask-box value=vm.num1 change=vm.applyColor mask-format=99:99 title=mm:ss ng-if=vm.mmss enabled=true></cts-mask-box><cts-mask-box value=vm.num1 change=vm.applyColor mask-format=99:99:99 title=hh:mm:ss ng-if=vm.hhmmss enabled=true></cts-mask-box></div><div class=flex-itemcp><cts-color-picker name=colorPick12 value=vm.color12 select=vm.applyColor></cts-color-picker></div><div class=flex-item><cts-numeric-text-box value=vm.num2 change=vm.applyColor ng-if=vm.int></cts-numeric-text-box><cts-numeric-text-box value=vm.num2 change=vm.applyColor ng-if=vm.double decimalplaces=3></cts-numeric-text-box><cts-mask-box value=vm.num2 change=vm.applyColor mask-format=99:99 title=mm:ss ng-if=vm.mmss enabled=true></cts-mask-box><cts-mask-box value=vm.num2 change=vm.applyColor mask-format=99:99:99 title=hh:mm:ss ng-if=vm.hhmmss enabled=true></cts-mask-box></div><div class=flex-itemcp><cts-color-picker name=colorPick23 value=vm.color23 select=vm.applyColor></cts-color-picker></div><div class=flex-item><cts-numeric-text-box value=vm.num3 change=vm.applyColor ng-if=vm.int></cts-numeric-text-box><cts-numeric-text-box value=vm.num3 change=vm.applyColor ng-if=vm.double decimalplaces=3></cts-numeric-text-box><cts-mask-box value=vm.num3 change=vm.applyColor mask-format=99:99 title=mm:ss ng-if=vm.mmss enabled=true></cts-mask-box><cts-mask-box value=vm.num3 change=vm.applyColor mask-format=99:99:99 title=hh:mm:ss ng-if=vm.hhmmss enabled=true></cts-mask-box></div><div class=flex-itemcp><cts-color-picker name=colorPick34 value=vm.color34 select=vm.applyColor></cts-color-picker></div><div class=flex-item><cts-numeric-text-box value=vm.num4 change=vm.applyColor ng-if=vm.int></cts-numeric-text-box><cts-numeric-text-box value=vm.num4 change=vm.applyColor ng-if=vm.double decimalplaces=3></cts-numeric-text-box><cts-mask-box value=vm.num4 change=vm.applyColor mask-format=99:99 title=mm:ss ng-if=vm.mmss enabled=true></cts-mask-box><cts-mask-box value=vm.num4 change=vm.applyColor mask-format=99:99:99 title=hh:mm:ss ng-if=vm.hhmmss enabled=true></cts-mask-box></div><div class=flex-itemcp><cts-color-picker name=colorPick45 value=vm.color45 select=vm.applyColor></cts-color-picker></div><div class=flex-item><cts-numeric-text-box value=vm.num5 change=vm.applyColor ng-if=vm.int></cts-numeric-text-box><cts-numeric-text-box value=vm.num5 change=vm.applyColor ng-if=vm.double decimalplaces=3></cts-numeric-text-box><cts-mask-box value=vm.num5 change=vm.applyColor mask-format=99:99 title=mm:ss ng-if=vm.mmss enabled=true></cts-mask-box><cts-mask-box value=vm.num5 change=vm.applyColor mask-format=99:99:99 title=hh:mm:ss ng-if=vm.hhmmss enabled=true></cts-mask-box></div><div class=flex-itemcp><cts-color-picker name=colorPick5 value=vm.color5 select=vm.applyColor></cts-color-picker></div><div class=flex-iteminf><label>+\u221E<label></label></label></div></div><div class=button-wrapper style="margin-left: 50px;margin-bottom: 30px;"><button id=clearColors class=cts-button ej-button e-click=vm.clearColors e-enabled=true translate>clearColors</button> <button id=setDefaultColors class=cts-button ej-button e-click=vm.setDefaultColors e-enabled=true translate>setDefaultColors</button></div></div><label>{{vm.editableHint}}</label> <label>{{vm.saveOrDiscardeHint}}</label><br><div class=button-wrapper ng-if=vm.UJSPFELM><button id=saveFelmeroElem class=cts-button ej-button e-click=vm.SaveFelmeroElemek e-enabled=vm.modified translate>saveFelmeroElem</button> <button id=discardFelmeroElem class=cts-button ej-button e-click=vm.DiscardFelmeroElem e-enabled=vm.modified translate>discardFelmeroElem</button></div></div><br><br><div class=well><div ng-repeat="hint in vm.typeHint"><label style=color:rgb(128,128,128)>{{hint}}</label></div></div></div><div class=widget-foot><div class=clearfix></div></div></div></div></div></section>');
$templateCache.put('app/settings/editHealthType/editHealthType.html','<section class=mainbar><div class=container-fluid><div class=row><div class=widget><ht-widget-header title={{title}} text-id=editHealthTypeHelp right-text=rightText></ht-widget-header><script id=pagerTemplate type=text/x-template><div style="width: 100px"> <p style="float: left; margin:0; padding:0; line-height: 28px">Items per page:</p> <input style="float: left" type="text" ej-numerictextbox id="txtPageNumber" e-width="70px" stype="border: none; cursor: text" e-value="vm.pageSize"/> </div></script><div class=widget-content><div class=col-md-6><form class=filter><div class=row><div style="margin-top: 2em;" class="button-wrapper no-margin-top"><button class=cts-button ej-button e-click=vm.AddMainType id=addMainType e-enabled=vm.EGESZSMOD translate>addMainType</button> <button class=cts-button ej-button e-click=vm.EditMainType id=editeMainType e-enabled=vm.editDeleteMainTypeEnabled translate>editMainType</button> <button class=cts-button ej-button e-click=vm.DeleteMainType id=deleteMainType e-enabled=vm.editDeleteMainTypeEnabled translate>deleteMainType</button></div></div></form><div><div id=MainTypeGrid name=MainTypeGrid></div></div></div><div class=col-md-6><form class=filter><div class=row><div style="margin-top: 2em;" class="button-wrapper no-margin-top"><button class=cts-button ej-button e-click=vm.AddSubType id=addSubType e-enabled=vm.addNewSubType translate>addSubType</button> <button class=cts-button ej-button e-click=vm.EditSubType id=editeSubType e-enabled=vm.editDeleteSubTypeEnabled translate>editSubType</button> <button class=cts-button ej-button e-click=vm.DeleteSubType id=deleteSubType e-enabled=vm.editDeleteSubTypeEnabled translate>deleteSubType</button></div></div></form><div id=SubTypeGrid name=SubTypeGrid></div></div></div></div></div></div></section>');
$templateCache.put('app/settings/editSection/editSection.html','<section class=mainbar><div class=container-fluid><div class=row><div class=widget><div class=widget-head><h2 class=page-title>{{title}}</h2></div><div class="widget-content form"><form novalidate id=form name=form enctype=multipart/form-data><div class=row><div class=col-lg-8><cts-text-box name=Section label=Section ng-model=vm.section.SzakosztalyNeve validation-rules="{required: true, minlength: 4 }"></cts-text-box><cts-dropdown-list name=leader1DropDown label=PrimarySectionLeader value=vm.section.SzakosztalyVezetoId1 datasource=vm.sectionLeaders databound=vm.leader1DataBound select=vm.leader1Select validation-rules="{required: true}"></cts-dropdown-list><cts-dropdown-list name=leader2DropDown label=SecondarySectionLeader value=vm.section.SzakosztalyVezetoId2 datasource=vm.sectionLeaders2 databound=vm.leader2DataBound select=vm.leader2Select validation-rules="{required: true}"></cts-dropdown-list></div></div><div class=row><div class=col-lg-8><cts-check-box label=Active checked=vm.section.Aktiv></cts-check-box><cts-check-box label=IndividualSport checked=vm.section.Egyeni></cts-check-box><cts-check-box label=TeamSport checked=vm.section.Csapat></cts-check-box></div></div><hr><div class=row><div class=col-md-12 style="text-align: center;"><label translate>TextColor</label></div><div class=col-lg-8 style="clear: both;"><cts-color-picker name=TextColor label=TextColor value=vm.section.SzovegSzin style=margin-top:5px;></cts-color-picker><cts-color-picker name=BackgroundColor label=BackgroundColor value=vm.section.Szin style=margin-top:5px;></cts-color-picker></div></div><hr><div class=row><div class=col-md-12 style="text-align: center;"><label style=margin-left:40px; translate>ClothesUsedInSection</label></div><div class=col-lg-8><cts-check-box label=Slippers checked=vm.section.RuhaPapucs></cts-check-box><cts-check-box label=Shoe checked=vm.section.RuhaCipo></cts-check-box><cts-check-box label=Jogging checked=vm.section.RuhaMelegito></cts-check-box><cts-check-box label=BathRobe checked=vm.section.RuhaFurdokopeny></cts-check-box><cts-check-box label=Coat checked=vm.section.RuhaKabat></cts-check-box></div></div><hr><div class=row><div class=col-lg-8><cts-check-box label=ArmorPant checked=vm.section.RuhaPancelnadrag></cts-check-box><cts-check-box label=Shirt checked=vm.section.RuhaPolo></cts-check-box><cts-check-box label=Short checked=vm.section.RuhaSort></cts-check-box><cts-check-box label=SwimmingPant checked=vm.section.RuhaUszonadrag></cts-check-box></div></div></form><div class="col-sm-12 back" style="text-align: center; margin-bottom:15px;"><button class=cts-button ej-button e-click=vm.save type=submit form=form translate>Save</button> <button class=cts-button ej-button e-click=back translate>Back</button></div></div><div class=widget-foot><div class=clearfix></div></div></div></div></div></section>');
$templateCache.put('app/settings/schoolManagement/schoolManagement.html','<section class=mainbar><div class=container-fluid><div class=row><div class=widget><div ui-view></div></div></div></div></section>');
$templateCache.put('app/settings/systemSettings/systemSettings.html','<section class=mainbar><div class=container-fluid><div class=row><div class=widget><ht-widget-header title={{title}} text-id=systemSettingsHelp right-text=rightText></ht-widget-header><div class="widget-content form"><form novalidate name=form enctype=multipart/form-data><div class=row><div class=col-lg-6><cts-check-box name=socialSecurityNumberRequired label=SocialSecurityNumberRequired checked=vm.socialSecurityNumberRequiredValue></cts-check-box><cts-check-box name=athleteRegistrationNumberRequired label=AthleteRegistrationNumberRequired checked=vm.athleteRegistrationNumberRequiredValue></cts-check-box><cts-check-box name=paymentNumberSeparately label=PaymentNumberSeparately checked=vm.paymentNumberSeparatelyValue></cts-check-box><cts-check-box name=SPORTMINKOTELEZO label=AthleteRequiredMinDatas checked=vm.SPORTMINKOTELEZO></cts-check-box><cts-check-box name=SPKORVALTTART label=AthleteTransferWithDebit checked=vm.SPKORVALTTART></cts-check-box><cts-check-box name=HAVIEDZTERVJOVAHAGYKOT label=MonthlyTrainingPlanApproveRequired checked=vm.HAVIEDZTERVJOVAHAGYKOT></cts-check-box><cts-check-box name=HETIEDZTERVJOVAHAGYKOT label=WeeklyTrainingPlanApproveRequired checked=vm.HETIEDZTERVJOVAHAGYKOT></cts-check-box><cts-check-box name=ESZKSPORTOLOKILEP label=AbleToExitAthleteWithAsset checked=vm.ESZKSPORTOLOKILEP></cts-check-box><cts-check-box name=ESZKUSERKILEP label=AbleToExitUserWithAsset checked=vm.ESZKUSERKILEP></cts-check-box><cts-check-box name=NINCSOKTDIJ label=NINCSOKTDIJ checked=vm.NINCSOKTDIJ></cts-check-box><cts-check-box name=INAKTIVMENUREJTES label=INAKTIVMENUREJTES checked=vm.INAKTIVMENUREJTES></cts-check-box></div><div class=col-lg-6><cts-check-box name=FOLAPOLVASATLANOK label=FOLAPOLVASATLANOK checked=vm.FOLAPOLVASATLANOK></cts-check-box><cts-check-box name=FOLAPNYOMTATAS label=FOLAPNYOMTATAS checked=vm.FOLAPNYOMTATAS></cts-check-box><cts-check-box name=FOLAPELFOGADASRAVAROJELENLETIK label=FOLAPELFOGADASRAVAROJELENLETIK checked=vm.FOLAPELFOGADASRAVAROJELENLETIK></cts-check-box><cts-check-box name=FOLAPELFOGADASRAVAROHAVITERVEK label=FOLAPELFOGADASRAVAROHAVITERVEK checked=vm.FOLAPELFOGADASRAVAROHAVITERVEK></cts-check-box><cts-check-box name=FOLAPELFOGADASRAVAROHETITERV label=FOLAPELFOGADASRAVAROHETITERV checked=vm.FOLAPELFOGADASRAVAROHETITERV></cts-check-box><cts-check-box name=FOLAPELFOGADASRAVAROEVESTERVEK label=FOLAPELFOGADASRAVAROEVESTERVEK checked=vm.FOLAPELFOGADASRAVAROEVESTERVEK></cts-check-box><cts-check-box name=FOLAPKIFIZETETLENTAGDIJAK label=FOLAPKIFIZETETLENTAGDIJAK checked=vm.FOLAPKIFIZETETLENTAGDIJAK></cts-check-box><cts-check-box name=FOLAPLINKEK label=FOLAPLINKEK checked=vm.FOLAPLINKEK></cts-check-box><cts-check-box name=FOLAPLEJARO label=FOLAPLEJARO checked=vm.FOLAPLEJARO></cts-check-box></div></div><div class=row><div class=col-sm-6><div class=row><label class=col-lg-12 style="text-align: center; margin-bottom: 25px" translate>ReducedFeeNames</label></div><cts-dropdown-list name=languages label=Languages value=vm.valasztottNyelv datasource=vm.NYELVEK select=vm.languageSelect></cts-dropdown-list><cts-text-box name=k1 label=ReducedFee1 data-ng-model=vm.kedvezmeny1></cts-text-box><cts-text-box name=k2 label=ReducedFee2 data-ng-model=vm.kedvezmeny2></cts-text-box><cts-text-box name=k3 label=ReducedFee3 data-ng-model=vm.kedvezmeny3></cts-text-box><cts-text-box name=k4 label=ReducedFee4 data-ng-model=vm.kedvezmeny4></cts-text-box><cts-text-box name=k5 label=ReducedFee5 data-ng-model=vm.kedvezmeny5></cts-text-box><cts-text-box name=ok1 label=ReducedEducationalFee1 data-ng-model=vm.kedvezmenyokt1></cts-text-box><cts-text-box name=ok2 label=ReducedEducationalFee2 data-ng-model=vm.kedvezmenyokt2></cts-text-box><cts-text-box name=ok3 label=ReducedEducationalFee3 data-ng-model=vm.kedvezmenyokt3></cts-text-box><cts-text-box name=ok4 label=ReducedEducationalFee4 data-ng-model=vm.kedvezmenyokt4></cts-text-box><cts-text-box name=ok5 label=ReducedEducationalFee5 data-ng-model=vm.kedvezmenyokt5></cts-text-box></div><div class=col-sm-6><div class=row><label class=col-lg-12 style="text-align: center; margin-bottom: 25px" translate>ExpiredDocNotificationGroup</label></div><div align=left style=margin-right:100px;><div class=row><cts-list-box name=expNotiList label css-class=scroller-fix datasource=vm.expNotiList show-checkbox=true checkedindices=vm.expNotiChecked height=170></cts-list-box></div><div class=row><div class=row><label class=col-lg-12 style="text-align: center; margin-bottom: 25px" translate>ExpiredDocNotificationFrequencyForParentsAndAthletes</label></div><cts-dropdown-list name=nf1 label=NotificationFrequency value=vm.nf1 datasource=vm.nf1list select=vm.nf1Select databound=vm.nf1databound></cts-dropdown-list><cts-dropdown-list name=nf2 label=NotificationOn value=vm.nf2 datasource=vm.nf2list select=vm.nf2Select databound=vm.nf2databound></cts-dropdown-list></div></div><div class=row><label class=col-lg-12 style="text-align: center; margin-bottom: 25px" translate>DeadlineSettings</label></div><div align=left style=margin-right:100px;><cts-numeric-text-box name=WtpGracePeriod label=WtpGracePeriod value=vm.HETIEDZTURELMI validation-rules="{required: false, minlength: -365, maxlength: 365}"></cts-numeric-text-box></div></div></div><div class=row><div class=col-sm-6></div><div class=col-sm-6><div class=row><div class=row><label class=col-lg-12 style="text-align: center; margin-bottom: 25px" translate>CountsAsAttendance</label></div><div style=margin-right:100px;><cts-list-box name=attendanceList label css-class=scroller-fix datasource=vm.attendanceList show-checkbox=true checkedindices=vm.attendanceChecked height=170></cts-list-box></div></div></div></div><div class=col-sm-12 style="text-align: center"><button class=cts-button ej-button e-click=vm.saveSystemSettings translate>Save</button> <button class=cts-button ej-button e-click=back translate>Cancel</button></div></form></div><div class=widget-foot><div class=clearfix></div></div></div></div></div></section>');
$templateCache.put('app/settings/userGroups/userGroupsManagement.html','<section class=mainbar><div class=container-fluid><div class=row><div id=popup><div id=newgroup ej-dialog e-height=385px e-minheight=385px e-maxheight=385px e-title={{vm.newgrouptitle}} e-showoninit=false e-enablemodal=true e-enableresize=false e-allowkeyboardnavigation=false e-closeonescape=true e-isresponsive=true e-content=#popup e-enableanimation=true e-showroundedcorner=false><div class=col-md-12><form name=form class=popup><cts-text-box name=newgroupName label=Name data-ng-model=vm.newgroup.Nev></cts-text-box><cts-text-box name=newgroupDesc label=Description data-ng-model=vm.newgroup.Leiras></cts-text-box></form><hr><div class=form-group style="text-align: center;"><button class=cts-button id=cancel data-ng-click=vm.newgroupCancel() type=button translate>Cancel</button> <button class=cts-button id=done data-ng-click=vm.newgroupSave() type=button translate>Save</button></div></div></div></div><div id=popup><div id=editgroup ej-dialog e-height=385px e-minheight=385px e-maxheight=385px e-title={{vm.editgrouptitle}} e-showoninit=false e-enablemodal=true e-enableresize=false e-allowkeyboardnavigation=false e-closeonescape=true e-isresponsive=true e-content=#popup e-enableanimation=true e-showroundedcorner=false><div class=col-md-12><form name=form class=popup><cts-text-box name=editgroupName label=Name data-ng-model=vm.editgroup.Nev></cts-text-box><cts-text-box name=editgroupDesc label=Description data-ng-model=vm.editgroup.Leiras></cts-text-box></form><hr><div class=form-group style="text-align: center;"><button class=cts-button id=cancel data-ng-click=vm.editgroupCancel() type=button translate>Cancel</button> <button class=cts-button id=done data-ng-click=vm.editgroupSave() type=button translate>Save</button></div></div></div></div><div class=widget><ht-widget-header title={{title}} text-id=userGroupsHelp right-text=rightText></ht-widget-header><script id=pagerTemplate type=text/x-template><div style="width: 100px"> <p style="float: left; margin:0; padding:0; line-height: 28px">Items per page:</p> <input style="float: left" type="text" ej-numerictextbox id="txtPageNumber" e-width="70px" stype="border: none; cursor: text" e-value="vm.pageSize" /> </div></script><div class=widget-content><form class=filter><div class=row><div class="button-wrapper no-margin-top"><button class=cts-button ej-button e-click=vm.AddGroup id=addGroup e-enabled=vm.UJFELHCSOP translate>addGroup</button> <button class=cts-button ej-button e-click=vm.EditGroup id=deleteGroup e-enabled=vm.deleteGroupEnabled translate>editGroup</button> <button class=cts-button ej-button e-click=vm.DeleteGroup id=deleteGroup e-enabled=vm.deleteGroupEnabled translate>deleteGroup</button> <button class=cts-button ej-button e-click=vm.ManageRights id=manageRights e-enabled=vm.setGroupRightsEnabled translate>manageRights</button></div></div></form><div><div id=Grid name=Grid></div></div></div><div class=widget-foot><div class=clearfix></div></div></div></div></div></section>');
$templateCache.put('app/settings/userManagement/userManagement.html','<section class=mainbar><div class=container-fluid><div class=row><div class=widget><div ui-view></div></div></div></div></section>');
$templateCache.put('app/settings/userRights/userRights.html','<section class=mainbar><div class=container-fluid><div class=row><div class=widget><ht-widget-header title={{title}} text-id=userRightsHelp right-text=rightText></ht-widget-header><div class="widget-content form"><div class=row><div class="col-md-12 col-lg-8"><form class=listboxkozepre><cts-dropdown-list name=userGroupDropDown label="User group" value=vm.selectedUserGroup datasource=vm.userGroupList databound=vm.userGroupDataBound select=vm.userGroupSelect></cts-dropdown-list><cts-list-box enabled=vm.changeEventActive name=groupRightsList label="User group rights" css-class=scroller-fix datasource=vm.accessRights show-checkbox=true check-change=vm.groupRightsChange checkedindices=vm.checkedIndices height=400></cts-list-box></form></div></div></div><div class=widget-foot><div class=clearfix></div></div></div></div></div></section>');
$templateCache.put('app/settings/usersBelongingToAthletes/usersBelongingToAthletes.html','<section class=mainbar><div class=container-fluid><div class=row><div class=widget><ht-widget-header title={{title}} text-id=usersBelongingToAthletesHelp right-text=rightText></ht-widget-header><div class="widget-content form"><form class=filter name=form><div class=row><div style="overflow: hidden;"><cts-dropdown-list name=sectionDropDown label=Section datasource=vm.sectionList value=vm.sectionIdValue databound=vm.sectionDataBound select=vm.sectionSelect validation-rules="{required: true}"></cts-dropdown-list><cts-dropdown-list name=ageGroupDropDown label=AgeGroup value=vm.ageGroupIdValue datasource=vm.ageGroupList databound=vm.ageGroupDataBound select=vm.ageGroupSelect validation-rules="{required: true}"></cts-dropdown-list><div class=button-wrapper><button id=addTeam class=cts-button ej-button e-click=vm.getParentAndAthleteUsers translate>GetDatas</button></div></div></div></form><script id=usbetoattemplateDataColumn1 type=text/x-template><a data-ng-click="vm.openUser(${UserID})">${UserName}</a></script><script id=usbetoattemplateDataColumn2 type=text/x-template><a data-ng-click="vm.openAthlete(${SportoloID})">${SportoloNeve}</a></script><script id=usbetoattemplateDataColumn3 type=text/x-template><a data-ng-click="vm.unlinkUserFromAthlete(${UserID},${SportoloID},${szerepint})" translate="">unlinkUserFromAthlete</a></script><div id=Grid></div></div></div></div></div></section>');
$templateCache.put('app/administration/annualSeasonPlan/annualSeasonPlanList/annualSeasonPlanList.html','<ht-widget-header title={{title}} text-id=annualSeasonPlanListHelp right-text=rightText></ht-widget-header><div class=widget-content><form name=form class=filter><div style="overflow: hidden;"><cts-dropdown-list name=maEv label=Year value=vm.selectedYear datasource=vm.yearList databound=vm.yearDataBound select=vm.yearSelect validation-rules="{required: true}"></cts-dropdown-list></div><div id=Grid name=Grid></div></form></div><div class=widget-foot><button class=cts-button style="margin-top: 5px;" ej-button data-ng-click=back() translate>Back</button><div class=clearfix></div></div><script id=ansepllitemplateDataColumn1 type=text/x-template><input type="checkbox" data-ng-if="\'${EgyeniTerv}\' === \'true\'" checked="checked" disabled/> <input type="checkbox" data-ng-if="\'${EgyeniTerv}\' !== \'true\'" disabled/></script><script id=ansepllitemplateDataColumn2 type=text/x-template><a data-ng-click="vm.goToNewAgeGroup(${IdKorosztaly})">${KorosztalyNeve}</a></script><script id=ansepllitemplateDataColumn3 type=text/x-template><a data-ng-click="vm.goToNewCoach(${IdEdzo})">${EdzoNeve}</a></script><script id=ansepllitemplateDataColumn4 type=text/x-template><input data-ng-if="\'${EdzoLezarta}\' === \'true\'" type="checkbox" checked="checked" disabled/> <input data-ng-if="\'${EdzoLezarta}\' !== \'true\'" type="checkbox" disabled/></script><script id=ansepllitemplateDataColumn5 type=text/x-template><input data-ng-if="\'${SzakosztalyvezetoJovahagyta}\' === \'true\'" type="checkbox" checked="checked" disabled/> <input data-ng-if="\'${SzakosztalyvezetoJovahagyta}\' !== \'true\'" type="checkbox" disabled/></script><script id=ansepllitemplateDataColumn6 type=text/x-template><a data-ng-click="vm.goToAnnualSeasonPlan(${Id})"><i class="fa fa-eye" style="font-size: 1.5em;"></i></a></script>');
$templateCache.put('app/administration/annualSeasonPlan/annualSeasonPlanReportPage1/annualSeasonPlanReportPage1.html','<ht-widget-header title={{title}} text-id=annualSeasonPlanReportPageHelp right-text=rightText></ht-widget-header><div class=widget-content><form name=form class=filter><div style="overflow: hidden;"><cts-dropdown-list name=maEdzo label=Coach value=vm.selectedCoach datasource=vm.coachList databound=vm.coachDataBound select=vm.coachSelect validation-rules="{required: true}"></cts-dropdown-list><br><button type=button id=olderReports class=cts-button style=float:right; ej-button e-click=vm.goToOlderAnnualSeasonPlanReports translate>OlderAnnualSeasonReports</button></div><div style="overflow: hidden;"><cts-dropdown-list name=maSzakosztaly label=Section value=vm.selectedSection datasource=vm.sectionList databound=vm.sectionDataBound select=vm.sectionSelect validation-rules="{required: true}"></cts-dropdown-list><cts-text-box name=teKapcsolat label=Contact data-ng-model=vm.coachContact owndisabled=true></cts-text-box><cts-dropdown-list name=maKorabbi style="float:right; margin-right:-15px" label=JumpToPage value=vm.jumpedPage datasource=vm.JumpPageList databound=vm.jumpPageDataBound select=vm.jumpPageSelect data-ng-hide=vm.noAnnualSeasonPlan></cts-dropdown-list></div><div style="overflow: hidden;"><cts-dropdown-list name=maKorosztaly label=AgeGroup value=vm.selectedAgeGroup datasource=vm.ageGroupList databound=vm.ageGroupDataBound select=vm.ageGroupSelect validation-rules="{required: true}"></cts-dropdown-list><cts-text-box name=teEmail label=Email data-ng-model=vm.coachEmail owndisabled=true></cts-text-box></div><div style="overflow: hidden;"><cts-dropdown-list name=maEv label=Year value=vm.selectedYear datasource=vm.years select=vm.yearSelect validation-rules="{required: true}"></cts-dropdown-list><br><button type=button id=annualSeasonPlanReportSelect class=cts-button ej-button e-click=vm.annualSeasonPlanReportSelect style=margin-left:15px translate>Select</button> <button type=button id=annualSeasonPlanReportCreate class=cts-button e-enabled=vm.noAnnualSeasonPlan ej-button e-click=vm.annualSeasonPlanReportCreate translate>CreateNewAnnualSeasonPlanReport</button></div><div class="alert alert-danger" data-ng-show=vm.noAnnualSeasonPlan translate>ThereIsntAnnualSeasonPlanReport</div><div class="alert alert-info" data-ng-show=vm.hasAnnualSeasonPlan translate>ThereIsAnnualSeasonPlanReport</div><div class="alert alert-warning" data-ng-show=vm.hasSignedAnnualSeasonPlan translate>TherIsSignedAnnualSeasonPlanReport</div><div class="alert alert-success" data-ng-show=vm.hasAcceptedAnnualSeasonPlan translate>ThereIsSignedAndAcceptedAnnualSeasonPlanReport</div><label translate>TheMostImportantDataOfAGroupsMembers</label><div id=Grid name=Grid></div></form></div><div class=widget-foot><button type=button class=cts-button style="margin-top: 5px;" ej-button data-ng-click=vm.refreshData() data-ng-show=vm.hasAnnualSeasonPlan translate>RefreshData</button> <button type=submit class=cts-button style="margin-top: 5px; float: right" ej-button data-ng-click=vm.goToNextPage() data-ng-show="vm.hasAnnualSeasonPlan || vm.hasSignedAnnualSeasonPlan || vm.hasAcceptedAnnualSeasonPlan" translate>NextPage</button></div><script id=anseplrepa1templateDataColumn1 type=text/x-template><a data-ng-click="vm.goToNewAthlete(${IdSportolo})">${SportoloNeve}</a></script>');
$templateCache.put('app/administration/annualSeasonPlan/annualSeasonPlanReportPage2/annualSeasonPlanReportPage2.html','<ht-widget-header title={{title}} text-id=annualSeasonPlanReportPage2Help right-text=rightText></ht-widget-header><div class=widget-content><form name=form class=filter><div style="overflow: hidden;"><div style="overflow: hidden;"><label translate>AthleteStartOfOfficialTrainingAndPastTrainers</label><cts-dropdown-list name=maKorabbi style=float:right; label=JumpToPage value=vm.jumpedPage datasource=vm.JumpPageList databound=vm.jumpPageDataBound select=vm.jumpPageSelect></cts-dropdown-list></div><label translate>PreconditioningAndCompetitionPast</label><div id=Grid name=Grid></div></div></form></div><div class=widget-foot style="text-align: center"><button type=submit class=cts-button style="margin-top: 5px; float: left" ej-button data-ng-click=vm.goToPreviousPage() translate>PreviousPage</button> <button type=button class=cts-button style="margin-top: 5px;" ej-button data-ng-click=vm.refreshData() data-ng-hide=vm.disable translate>RefreshData</button> <button type=submit class=cts-button style="margin-top: 5px; float: right" ej-button data-ng-click=vm.goToNextPage() translate>NextPage</button><div class=clearfix></div></div><script id=anseplrepa2templateDataColumn1 type=text/x-template><a data-ng-click="vm.goToNewAthlete(${IdSportolo})">${SportoloNeve}</a></script>');
$templateCache.put('app/administration/annualSeasonPlan/annualSeasonPlanReportPage3/annualSeasonPlanReportPage3.html','<ht-widget-header title={{title}} text-id=annualSeasonPlanReportPage3Help right-text=rightText></ht-widget-header><div class=widget-content><form name=form class=filter><div style="overflow: hidden;"><div style="overflow: hidden;"><cts-dropdown-list name=maKorabbi style=float:right; label=JumpToPage value=vm.jumpedPage datasource=vm.JumpPageList databound=vm.jumpPageDataBound select=vm.jumpPageSelect></cts-dropdown-list></div><label translate>PreparationAndCompetitionPast</label><br><label translate>OutstandingResults</label><div id=Grid name=Grid></div></div></form></div><div class=widget-foot style="text-align: center"><button type=button class=cts-button style="margin-top: 5px; float: left" ej-button data-ng-click=vm.goToPreviousPage() translate>PreviousPage</button> <button type=button class=cts-button style="margin-top: 5px;" ej-button data-ng-click=vm.newAthletesNewRow() data-ng-hide=vm.disable translate>NewAthletesNewRow</button> <button disabled id=oldNew type=button class=cts-button style="margin-top: 5px; margin-left: 20px;" ej-button data-ng-click=vm.oldAthletesNewRow() data-ng-hide=vm.disable translate>OldAthletesNewRow</button> <button type=button class=cts-button style="margin-top: 5px; margin-left: 20px;" ej-button data-ng-click=vm.search() data-ng-hide=vm.disable translate>Search</button> <button type=button class=cts-button style="margin-top: 5px; margin-left: 20px;" ej-button data-ng-click=vm.search2() data-ng-hide=vm.disable translate>Search same</button> <button type=button class=cts-button style="margin-top: 5px; float: right" ej-button data-ng-click=vm.goToNextPage() translate>NextPage</button><div class=clearfix></div></div><div id=popup><div id=searchWindow ej-dialog e-height=270px e-minheight=270px e-maxheight=435px e-title="V\xE1lassza ki a kiemelked\u0151 eredm\xE9nyt a list\xE1b\xF3l!" e-showoninit=false e-enablemodal=true e-enableresize=false e-allowkeyboardnavigation=false e-closeonescape=true e-isresponsive=true e-content=#popup e-enableanimation=true e-width=800px e-showroundedcorner=false e-position-y=20% e-position-x=25%><div class=col-md-12><div class=text-center><div id=GridPopup name=GridPopup></div><div class=form-group style="margin-top: 10px"><button type=button class="btn btn-primary post pull-right" id=cancel data-ng-click=vm.closeOutstandingResultsWindow()>M\xE9gsem</button> <button ng-if=!vm.same type=submit class="btn btn-primary post left-padding" id=done data-ng-click=vm.selectOutstandingResults(false)>Rendben</button> <button ng-if=vm.same type=submit class="btn btn-primary post left-padding" id=done data-ng-click=vm.selectOutstandingResults(true)>Rendben</button></div></div></div></div></div>');
$templateCache.put('app/administration/annualSeasonPlan/annualSeasonPlanReportPage4/annualSeasonPlanReportPage4.html','<ht-widget-header title={{title}} text-id=annualSeasonPlanReportPage4Help right-text=rightText></ht-widget-header><div class=widget-content><form name=form class=filter><div style="overflow: hidden;"><div style="overflow: hidden;"><label translate>CapitalObjectives</label><cts-dropdown-list name=maKorabbi style=float:right; label=JumpToPage value=vm.jumpedPage datasource=vm.JumpPageList databound=vm.jumpPageDataBound select=vm.jumpPageSelect></cts-dropdown-list></div><label translate>NumberOfWeeklyTrainings</label><div style="overflow: hidden;"><cts-numeric-text-box name=teSpSpec label=SpSpec value=vm.data.HetiEdzesSportag change=vm.numberChange enabled=vm.editable></cts-numeric-text-box></div><div style="overflow: hidden;"><cts-numeric-text-box name=teAddTraining label=AdditionalTraining value=vm.data.HetiEdzesKiegeszito change=vm.numberChange enabled=vm.editable></cts-numeric-text-box></div><div style="overflow: hidden;"><cts-numeric-text-box name=teWeeklyTotal label=WeeklyTotalTraining value=vm.data.HetiEdzesOsszesen enabled=false></cts-numeric-text-box></div><hr><div style="overflow: hidden;"><cts-text-area name=comment label=TechnicalTrainingObjectives data-ng-model=vm.data.TechKepzesFeladatok owndisabled=vm.disable css="padding-left:0; padding-right:0; width: 100%;"></cts-text-area><div><div id=uploadbox1 style="float: right; margin-top:-15px; margin-left: 10px;" data-ng-hide="vm.data.TechKepzesFeladatokFile && vm.editable"></div><button type=button class=cts-button style="float: right; margin-top:-15px; margin-left: 10px;" ej-button e-click=vm.openTechnicalTrainingObjectives data-ng-show=vm.data.TechKepzesFeladatokFile translate>OpenDocument</button> <button type=button class=cts-button style="float: right; margin-top:-15px; margin-left: 10px;" ej-button e-click=vm.removeTechnicalTrainingObjectives data-ng-show=vm.data.TechKepzesFeladatokFile e-enabled=vm.editable translate>RemoveDocument</button></div></div><div style="overflow: hidden;"><cts-text-area name=comment label=SportSpecificTrainingObjectives data-ng-model=vm.data.SportagSpecFeladatok owndisabled=vm.disable css="padding-left:0; padding-right:0; width: 100%;"></cts-text-area><div><div id=uploadbox6 style="float: right; margin-top:-15px; margin-left: 10px;" data-ng-hide="vm.data.SportagSpecFeladatokFile && vm.editable"></div><button type=button class=cts-button style="float: right; margin-top:-15px; margin-left: 10px;" ej-button e-click=vm.openSportSpecificTrainingObjectives data-ng-show=vm.data.SportagSpecFeladatokFile translate>OpenDocument</button> <button type=button class=cts-button style="float: right; margin-top:-15px; margin-left: 10px;" ej-button e-click=vm.removeSportSpecificTrainingObjectives data-ng-show=vm.data.SportagSpecFeladatokFile e-enabled=vm.editable translate>RemoveDocument</button></div></div><div style="overflow: hidden;"><cts-text-area name=comment label=TacticalTrainingObjectives data-ng-model=vm.data.TaktikaiKepzesFeladatok owndisabled=vm.disable css="padding-left:0; padding-right:0; width: 100%;"></cts-text-area><div><div id=uploadbox2 style="float: right; margin-top:-15px; margin-left: 10px;" data-ng-hide="vm.data.TaktikaiKepzesFeladatokFile && vm.editable"></div><button type=button class=cts-button style="float: right; margin-top:-15px; margin-left: 10px;" ej-button e-click=vm.openTacticalTrainingObjectives data-ng-show=vm.data.TaktikaiKepzesFeladatokFile translate>OpenDocument</button> <button type=button class=cts-button style="float: right; margin-top:-15px; margin-left: 10px;" ej-button e-click=vm.removeTacticalTrainingObjectives data-ng-show=vm.data.TaktikaiKepzesFeladatokFile e-enabled=vm.editable translate>RemoveDocument</button></div></div><div style="overflow: hidden;"><cts-text-area name=comment label=AbilitydevelopmentObjectives data-ng-model=vm.data.KepessegFejlFeladatok owndisabled=vm.disable css="padding-left:0; padding-right:0; width: 100%;"></cts-text-area><div><div id=uploadbox3 style="float: right; margin-top:-15px; margin-left: 10px;" data-ng-hide="vm.data.KepessegFejlFeladatokFile && vm.editable"></div><button type=button class=cts-button style="float: right; margin-top:-15px; margin-left: 10px;" ej-button e-click=vm.openAbilitydevelopmentObjectives data-ng-show=vm.data.KepessegFejlFeladatokFile translate>OpenDocument</button> <button type=button class=cts-button style="float: right; margin-top:-15px; margin-left: 10px;" ej-button e-click=vm.removeAbilitydevelopmentObjectives data-ng-show=vm.data.KepessegFejlFeladatokFile e-enabled=vm.editable translate>RemoveDocument</button></div></div><div style="overflow: hidden;"><cts-text-area name=comment label=EducationalObjectivesAndTasks data-ng-model=vm.data.NevelesiFeladatok owndisabled=vm.disable css="padding-left:0; padding-right:0; width: 100%;"></cts-text-area><div><div id=uploadbox4 style="float: right; margin-top:-15px; margin-left: 10px;" data-ng-hide="vm.data.NevelesiFeladatokFile && vm.editable"></div><button type=button class=cts-button style="float: right; margin-top:-15px; margin-left: 10px;" ej-button e-click=vm.openEducationalObjectives data-ng-show=vm.data.NevelesiFeladatokFile translate>OpenDocument</button> <button type=button class=cts-button style="float: right; margin-top:-15px; margin-left: 10px;" ej-button e-click=vm.removeEducationalObjectives data-ng-show=vm.data.NevelesiFeladatokFile e-enabled=vm.editable translate>RemoveDocument</button></div></div><div style="overflow: hidden; margin-bottom: 20px"><cts-text-area name=comment label=EfficiencyObjectives data-ng-model=vm.data.EredmenyessegiFeladatok owndisabled=vm.disable css="padding-left:0; padding-right:0; width: 100%;"></cts-text-area><div><div id=uploadbox5 style="float: right; margin-top:-15px; margin-left: 10px;" data-ng-hide="vm.data.EredmenyessegiFeladatokFile && vm.editable"></div><button type=button class=cts-button style="float: right; margin-top:-15px; margin-left: 10px;" ej-button e-click=vm.openEfficiencyObjectives data-ng-show=vm.data.EredmenyessegiFeladatokFile translate>OpenDocument</button> <button type=button class=cts-button style="float: right; margin-top:-15px; margin-left: 10px;" ej-button e-click=vm.removeEfficiencyObjectives data-ng-show=vm.data.EredmenyessegiFeladatokFile e-enabled=vm.editable translate>RemoveDocument</button></div></div></div></form></div><div class=widget-foot style="text-align: center"><button type=button class=cts-button style="margin-top: 5px; float: left" ej-button data-ng-click=vm.goToPreviousPage() translate>PreviousPage</button> <button type=button class=cts-button style="margin-top: 5px; margin-left: 20px;" ej-button data-ng-click=vm.search() data-ng-hide=vm.disable translate>CopyFromOlderAnnualSeasonPlan</button> <button type=submit class=cts-button style="margin-top: 5px; float: right" ej-button data-ng-click=vm.goToNextPage() translate>NextPage</button><div class=clearfix></div></div><div id=popup><div id=searchWindow ej-dialog e-height=435px e-minheight=435px e-maxheight=435px e-title="Kor\xE1bbi versenyeztet\xE9si tervek" e-showoninit=false e-enablemodal=true e-enableresize=false e-allowkeyboardnavigation=false e-closeonescape=true e-isresponsive=true e-content=#popup e-enableanimation=true e-width=800px e-showroundedcorner=false e-position-y=25% e-position-x=50%><div class=col-md-12><div class=text-center><div id=GridPopup name=GridPopup></div><div class=form-group style="margin-top: 10px"><button type=button class="btn btn-primary post pull-right" id=cancel data-ng-click=vm.closeEarlierAnnualSeasonPlanWindow() translate>Cancel</button> <button type=button class="btn btn-primary post left-padding" id=done data-ng-click=vm.selectEarlierAnnualSeasonPlan() translate>OK</button></div></div></div></div></div>');
$templateCache.put('app/administration/annualSeasonPlan/annualSeasonPlanReportPage5/annualSeasonPlanReportPage5.html','<ht-widget-header title={{title}} text-id=annualSeasonPlanReportPage5Help right-text=rightText></ht-widget-header><div class=widget-content><form name=form class=filter><div style="overflow: hidden;"><div style="overflow: hidden;"><cts-dropdown-list name=maKorabbi style=float:right; label=JumpToPage value=vm.jumpedPage datasource=vm.JumpPageList databound=vm.jumpPageDataBound select=vm.jumpPageSelect></cts-dropdown-list></div><label translate>CompetitionPlansAndObjectives</label><div id=Grid name=Grid></div></div></form></div><div class=widget-foot style="text-align: center"><button type=button class=cts-button style="margin-top: 5px; float: left" ej-button data-ng-click=vm.goToPreviousPage() translate>PreviousPage</button> <button type=button class=cts-button style="margin-top: 5px;" ej-button data-ng-click=vm.newRow() data-ng-hide=!vm.editable translate>NewRow</button> <button type=button class=cts-button style="margin-top: 5px; margin-left: 20px;" ej-button data-ng-click=vm.removeRow() data-ng-hide=!vm.editable translate>RemoveRow</button> <button type=button class=cts-button style="margin-top: 5px; margin-left: 20px;" ej-button data-ng-click=vm.search() data-ng-hide=!vm.editable translate>CopyFromOldCompetitionPlan</button> <button type=submit class=cts-button style="margin-top: 5px; float: right" ej-button data-ng-click=vm.goToNextPage() translate>NextPage</button><div class=clearfix></div></div><div id=popup><div id=searchWindow ej-dialog e-height=270px e-minheight=270px e-maxheight=435px e-title="Kor\xE1bbi versenyeztet\xE9si tervek" e-showoninit=false e-enablemodal=true e-enableresize=false e-allowkeyboardnavigation=false e-closeonescape=true e-isresponsive=true e-content=#popup e-enableanimation=true e-width=800px e-showroundedcorner=false><div class=col-md-12><div class=text-center><div id=GridPopup name=GridPopup></div><div class=form-group style="margin-top: 10px"><button type=button class="btn btn-primary post pull-right" id=cancel data-ng-click=vm.closeOutstandingResultsWindow() translate>Cancel</button> <button type=button class="btn btn-primary post left-padding" id=done data-ng-click=vm.selectOutstandingResults() translate>OK</button></div></div></div></div></div>');
$templateCache.put('app/administration/annualSeasonPlan/annualSeasonPlanReportPage6/annualSeasonPlanReportPage6.html','<ht-widget-header title={{title}} text-id=annualSeasonPlanReportPage6Help right-text=rightText></ht-widget-header><div class=widget-content><form name=form class=filter><div style="overflow: hidden;"><cts-dropdown-list name=maKorabbi style=float:right; label=JumpToPage value=vm.jumpedPage datasource=vm.JumpPageList databound=vm.jumpPageDataBound select=vm.jumpPageSelect></cts-dropdown-list></div><label translate>YearlyTablePlan</label><div id=Grid></div><div id=Grid2 name=Grid2></div><cts-text-area name=comment label=OtherObjectivesPlansTasks data-ng-model=vm.head.EgyebCelkituzesek disabled=!vm.editable css="padding-left:0; padding-right:0; width: 100%;"></cts-text-area></form></div><div class=widget-foot style="text-align: center"><button type=button class=cts-button style="margin-top: 5px; float: left" ej-button data-ng-click=vm.goToPreviousPage() translate>PreviousPage</button> <button type=button class=cts-button style="margin-top: 5px; margin-left: 20px;" ej-button data-ng-click=vm.closePlan() data-ng-show=vm.editable translate>CloseYearlyPlan</button> <button type=button class=cts-button style="margin-top: 5px; margin-left: 20px;" ej-button data-ng-click=vm.rejectPlan() data-ng-hide="vm.editable || vm.closed" translate>RejectYearlyPlan</button> <button type=button class=cts-button style="margin-top: 5px; margin-left: 20px;" ej-button data-ng-click=vm.acceptPlan() data-ng-hide="vm.editable || vm.closed" translate>AcceptYearlyPlan</button> <button type=button class=cts-button style="margin-top: 5px; margin-left: 20px;" ej-button data-ng-click=vm.gotoMainPage() translate>Close</button> <button type=button class=cts-button style="margin-top: 5px; margin-left: 20px;" ej-button data-ng-click=vm.print() translate>Print</button> <button type=button class=cts-button style="margin-top: 5px; margin-left: 40px;" ej-button data-ng-click=vm.refreshCompetition() data-ng-show=vm.editable translate>RefreshCompetition</button> <button type=button class=cts-button style="margin-top: 5px; margin-left: 20px; float: right;" ej-button data-ng-click=vm.savePlan() data-ng-show=vm.editable translate>Save</button><div class=clearfix></div></div><div id=popup><div id=rejectAttendanceWindow ej-dialog e-height=215px e-minheight=215px e-maxheight=215px e-title="\xC9ves versenyeztet\xE9si terv visszautas\xEDt\xE1sa" e-showoninit=false e-enablemodal=true e-enableresize=false e-allowkeyboardnavigation=false e-closeonescape=true e-isresponsive=true e-content=#popup e-enableanimation=true e-showroundedcorner=false e-target=.widget-content><div class=col-md-12><div class=text-center><p class=dialog-hide-elemet style="color: darkgray;" id=expiresLabel>Adja meg a visszautas\xEDt\xE1s ok\xE1t:</p><form style=height:100px;><div class=form-group><textarea class=form-control data-ng-model=vm.rejectAttendanceText style="height:80px; max-height: 80px; min-height: 80px;"></textarea></div></form><div class=form-group><button type=button class="btn btn-primary post pull-right" id=cancel data-ng-click=vm.closerejectingWindow()>M\xE9gsem</button> <button type=button class="btn btn-primary post left-padding" id=done data-ng-click=vm.rejectAttendance()>Rendben</button></div></div></div></div></div><div id=printDialog><report report-name=TEvesVersTerv report-parameters=vm.reportParameters></report></div>');
$templateCache.put('app/administration/competitiveMonthlyPlan/competitiveMonthlyPlanList/competitiveMonthlyPlanList.html','<ht-widget-header title={{title}} text-id=competitionMonthlyPlanListHelp right-text=rightText></ht-widget-header><div class=widget-content><form name=form class=filter><div style="overflow: hidden"><cts-dropdown-list name=maEdzo label=Coach value=vm.selectedCoach datasource=vm.coachList select=vm.coachChanged validation-rules="{required: true}"></cts-dropdown-list><cts-dropdown-list name=maSzakosztaly label=Section value=vm.selectedSection datasource=vm.sectionList databound=vm.sectionDataBound select=vm.sectionChanged validation-rules="{required: true}"></cts-dropdown-list><cts-dropdown-list name=maEv label=Year value=vm.selectedYear select=vm.yearChanged datasource=vm.years databound=vm.yearDataBound validation-rules="{required: true}"></cts-dropdown-list></div></form><script type=text/x-template id=coachColumnTemplate><a data-ng-click="vm.goToNewUser(${EdzoId})">${Edzo}</a></script><script type=text/x-template id=openDeleteColumnTemplate><a data-ng-click="vm.goToCompetitiveMonthlyPlan(${Id})"><i class="fa fa-eye" style="font-size: 1.5em;"></i></a></script><div id=Grid name=Grid></div><div class=col-xs-9><hr><button class=cts-button ej-button data-ng-if="vm.selectedCoach!==undefined && vm.selectedCoach!==null && vm.selectedCoach!==0 && vm.selectedSection!==undefined && vm.selectedSection!==null && vm.selectedSection!==0 && vm.selectedSection!==null && vm.allowAddNew.individual" data-ng-click="vm.goToNewCompetitiveMonthlyPlan(\'egyeni\')" translate>\xDAj havi versenyterv k\xE9sz\xEDt\xE9se (egy\xE9ni)</button> <button class=cts-button ej-button data-ng-if="vm.selectedCoach!==undefined && vm.selectedCoach!==null && vm.selectedCoach!==0 && vm.selectedSection!==undefined && vm.selectedSection!==null && vm.selectedSection!==0 && vm.selectedSection!==null && vm.allowAddNew.teams" data-ng-click="vm.goToNewCompetitiveMonthlyPlan(\'csapat\')" translate>\xDAj havi versenyterv k\xE9sz\xEDt\xE9se (csapat)</button></div></div><div class=widget-foot><div class=clearfix></div></div>');
$templateCache.put('app/administration/competitiveMonthlyPlan/competitiveMonthlyPlanReport/competitiveMonthlyPlanReport.html','<div class=widget-head><h2 class=page-title>{{title}}</h2></div><div class=widget-content><div id=popup><div id=searchWindow ej-dialog e-height=435px e-minheight=435px e-maxheight=435px e-minwidth=600px e-title="Kor\xE1bbi versenyeztet\xE9si terv m\xE1sol\xE1sa" e-showoninit=false e-enablemodal=true e-enableresize=false e-allowkeyboardnavigation=false e-closeonescape=true e-isresponsive=true e-content=#popup e-enableanimation=true e-width=80% e-showroundedcorner=false><div class=col-md-12><div class=text-center><div id=GridPopup name=GridPopup></div><div class=form-group style="margin-top: 10px"><button class=cts-button id=cancel data-ng-click=vm.closeEarlierCompetitvePlanWindow() type=button>M\xE9gsem</button> <button class=cts-button id=done data-ng-click=vm.selectEarlierCompetitvePlanWindow() type=button>Rendben</button></div></div></div></div></div><form name=form class=filter><div style="overflow: hidden;"><cts-text-box name=txEdzo label=Coach ng-model=vm.editedMonthlyPlan.fej.EdzoNeve owndisabled=true></cts-text-box><cts-text-box name=txSzakosztaly label=Section ng-model=vm.editedMonthlyPlan.fej.SzakosztalyNeve owndisabled=true></cts-text-box><cts-text-box name=txTipusI label=Type owndisabled=true ng-model=vm.individualText ng-if=vm.egyeni></cts-text-box><cts-text-box name=txTipusT label=Type owndisabled=true ng-model=vm.teamText ng-if=!vm.egyeni></cts-text-box><button id=olderReports style=margin-top:20px class=cts-button ej-button e-click=vm.goToOlderMonthlyCompetitiveReports data-ng-hide={{vm.editedMonthlyPlan.fej.Vegleges}} translate>OlderMonthlyCompetitveReports</button></div><div style="overflow: hidden;"><cts-dropdown-list name=maEv label=Year value=vm.selectedYear datasource=vm.years select=vm.yearSelect databound=vm.yearDatabound enabled="vm.Id===0"></cts-dropdown-list><cts-dropdown-list name=maHonap label=Month value=vm.selectedMonth datasource=vm.months select=vm.monthSelect databound=vm.monthDatabound enabled="vm.Id===0"></cts-dropdown-list></div><br><div style="overflow: hidden;"><div class="alert alert-info" data-ng-show=vm.noMonthlyPlan translate>ThereIsntMonthlyPlanReport</div><div class="alert alert-info" data-ng-show=vm.hasMonthlyPlan translate>ThereIsMonthlyPlanReport</div><div class="alert alert-info" data-ng-show=vm.hasSignedMonthlyPlan translate>TherIsSignedMonthlyPlanReport</div><div class="alert alert-info" data-ng-show=vm.hasAcceptedMonthlyPlan translate>ThereIsSignedAndAcceptedAMonthlyPlanReport</div><cts-text-box name="Finalized on" label="Finalized on" data-ng-model=vm.leadvaStr css="padding-left:0; padding-right:0; width: 100%;" owndisabled=true></cts-text-box><cts-text-box name="Accepted on" label="Accepted on" data-ng-model=vm.elfogadvaStr css="padding-left:0; padding-right:0; width: 100%;" owndisabled=true></cts-text-box></div><div class=row><p><span translate>LastEditedValue</span>: {{vm.editedColumnValue}}<button id=CopyCellToColumn class=cts-button e-enabled={{vm.readOnlyMonthlyPlan}} ej-button e-click=vm.CopyCellToColumn style="margin-left: 2em;" translate>CopyCellToColumn</button></p></div><div class=row style="position: relative;"><div style="position: fixed; z-index: 10000; top: 70px; left: 45%; background-color: forestgreen; color: white; border: 2px solid forestgreen; -webkit-border-radius: 5px;-moz-border-radius: 5px;border-radius: 5px;" data-ng-if=vm.AthleteUnderEditing><h2>{{vm.AthleteUnderEditingText}}: {{vm.AthleteUnderEditing}}</h2></div><div id=GridNew name=GridNew class=slim-grid></div></div><br><cts-text-area name=comment label=Comment data-ng-model=vm.editedMonthlyPlan.fej.Megjegyzes owndisabled=vm.readOnlyMonthlyPlan css="padding-left:0; padding-right:0; width: 100%;" validation-rules="{maxLenght: 255}"></cts-text-area><div class=col-sm-12 style="text-align: center"><button data-ng-if="vm.editedMonthlyPlan.fej.Id>0 && !vm.leadvaStr.length>0" class=cts-button ej-button e-click=vm.closeMonthlyPlan translate>MonthlyPlanReportClose</button> <button data-ng-if="vm.editedMonthlyPlan.fej.Id>0 && vm.leadvaStr.length>0" class=cts-button ej-button e-click=vm.acceptMonthlyPlan translate>SectionLeaderApprove</button> <button data-ng-if="vm.editedMonthlyPlan.fej.Id>0 && vm.leadvaStr.length>0" class=cts-button ej-button e-click=vm.rejectMonthlyPlan translate>Deny</button> <button class=cts-button ej-button e-click=vm.printMonthlyPlan translate>Print</button> <button class=cts-button ej-button e-enabled=vm.saveButton e-click=vm.saveMonthlyPlan translate>Save</button> <button class=cts-button ej-button e-click=back translate>Close</button> <button data-ng-if="vm.editedMonthlyPlan.fej.Id>0 && !vm.leadvaStr.length>0" class=cts-button ej-button e-click=vm.deletePlan translate>Delete</button></div></form><br><br><div class=button-wrapper><button id=ShowYearlyPlan class=cts-button ej-button e-enabled=vm.MEGTEVVERST data-toggle=collapse data-target=#yearlyplan translate>ShowYearlyPlan</button></div><div id=yearlyplan class=collapse><div style="overflow: hidden;"><cts-dropdown-list name=AgeGroupForAnnual label=AgeGroupForAnnual select=vm.ageGroupSelect datasource=vm.coachsAgeGroups></cts-dropdown-list></div><br><div id=GridYear name=GridYear></div></div><div id=popup><div id=rejectAttendanceWindow ej-dialog e-height=235px e-minheight=235px e-maxheight=235px e-title="Havi vers enyeztet\xE9si terv visszautas\xEDt\xE1sa" e-showoninit=false e-enablemodal=true e-enableresize=false e-allowkeyboardnavigation=false e-allowsorting=true e-closeonescape=true e-isresponsive=true e-content=#popup e-enableanimation=true e-showroundedcorner=false><div class=col-md-12><div class=text-center><p class=dialog-hide-elemet style="color: darkgray;" id=expiresLabel translate>ReasonForRejection</p><form style=height:100px;><div class=form-group><textarea class=form-control data-ng-model=vm.rejectMonthlyPlanText style="height:80px; max-height: 80px; min-height: 80px;"></textarea></div></form><div class=form-group><button class="btn btn-primary post pull-right" id=cancel data-ng-click=vm.closerejectingWindow() type=button translate>M\xE9gsem</button> <button class="btn btn-primary post left-padding" id=done data-ng-click=vm.rejectMonthlyPlanOk() type=button translate>Rendben</button></div></div></div></div></div></div><div class=widget-foot><div class=clearfix></div></div><div data-ng-if="vm.egyeni==true" id=printDialogE><report report-name=THaviVersenytervEgyeni2 report-parameters=vm.reportParameters></report></div><div data-ng-if="vm.egyeni!=true" id=printDialogCS><report report-name=THaviVersenytervCsapat2 report-parameters=vm.reportParameters></report></div><script type=text/x-template id=cmpropenathlete><a data-ng-click="vm.openAthlete(${SportoloId})">${KorosztalySportolo}</a></script><script type=text/x-template id=cmpropenteam><a data-ng-click="vm.openTeam(${CsapatId},${KorosztalyId},${SzakosztalyId})">${KorosztalyCsapat}</a></script><script type=text/x-template id=columnTemplate1><div><cts-text-box/><button type="button">|</button></div></script>');
$templateCache.put('app/administration/awayBudgetPlan/awayBudgetPlanList/awayBudgetPlanList.html','<ht-widget-header title={{title}} text-id=awayBudgetPlanListHelp right-text=rightText></ht-widget-header><div class=widget-content><form class=filter name=form><div class=row><cts-dropdown-list name=sectionDropDown label=Section value=vm.sectionId datasource=vm.sectionList databound=vm.sectionDataBound select=vm.sectionSelect validation-rules="{required: true}"></cts-dropdown-list><cts-dropdown-list name=ageGroupDropDown label=AgeGroup value=vm.ageGroupId datasource=vm.ageGroupList databound=vm.ageGroupDataBound select=vm.ageGroupSelect></cts-dropdown-list><cts-dropdown-list name=coachDropDown label=Coach value=vm.coachId datasource=vm.coachList databound=vm.coachDataBound select=vm.coachSelect></cts-dropdown-list><cts-dropdown-list name=typeDropDown label=Type value=vm.typeId datasource=vm.typeList databound=vm.typeDataBound select=vm.typeSelect validation-rules="{required: true}"></cts-dropdown-list></div><div class=row><cts-date-picker name=DateFrom label=DateFrom value=vm.dateFrom validation-rules="{required: true}"></cts-date-picker><cts-date-picker name=DateTo label=DateTo value=vm.dateTo validation-rules="{required: true}"></cts-date-picker><cts-auto-complete name=competitionPlace label=CompetitionPlace value=vm.competitionPlace datasource=vm.competitionPlaceList multi-select=true show-popup-button=true></cts-auto-complete><cts-check-box name=onlyStartDate label=OnlyStartDate checked=vm.onlyStartDate></cts-check-box></div><div class=row><div class=button-wrapper><button type=button id=search class=cts-button ej-button e-click=vm.search translate>Search</button> <button type=button id=create class=cts-button ej-button e-click=vm.create translate>Create</button> <button type=button id=delete class=cts-button ej-button e-click=vm.delete translate>Delete</button></div></div><div class=row style=margin-top:2rem><script type=text/x-template id=PlanOpenTemplate><a data-ng-click="vm.openPlan(${Id})"><i class="fa fa-eye" style="font-size: 1.5em;"></i></a></script><div id=Grid name=Grid></div></div></form></div><div class=widget-foot><div class=clearfix></div></div>');
$templateCache.put('app/administration/awayBudgetPlan/awayBudgetPlanCreate/awayBudgetPlanCreate.html','<div class=widget-head><h2 class=page-title>{{title}}</h2></div><div class="widget-content form"><form name=form novalidate><div class=row><div class=col-xs-9 style=margin-top:1em;><h3 style="text-align: center;">{{vm.title}}</h3></div><div class=col-xs-3><div class=button-wrapper><button class=cts-button ej-button e-click=vm.openPlan ng-if="(vm.terv != true && vm.teny)" translate>OpenPlan</button> <button class=cts-button ej-button e-click=vm.openFact ng-if="(vm.teny != true && vm.tenyId > 0)" translate>OpenFact</button></div></div></div><div class=row style=margin-top:2em;><div class=col-lg-5><cts-dropdown-list name=sectionDropDown label=Section value=vm.data.SzakosztalyId datasource=vm.sectionList databound=vm.sectionDataBound select=vm.sectionSelect validation-rules="{required: true}" enabled=vm.allowEdit></cts-dropdown-list><cts-dropdown-list name=coachDropDown label=Coach value=vm.data.EdzoIdValue datasource=vm.coachList databound=vm.coachDataBound select=vm.edzoSelect validation-rules="{required: true}" enabled=vm.allowEdit></cts-dropdown-list></div><div class=col-lg-5><cts-dropdown-list name=ageGroupDropDown label=AgeGroup value=vm.data.KorosztalyId datasource=vm.ageGroupList databound=vm.ageGroupDataBound select=vm.ageGroupSelect validation-rules="{required: true}" enabled=vm.allowEdit></cts-dropdown-list></div><div class=col-lg-5><cts-text-box name=coachContact label=CoachContact data-ng-model=vm.EdzoElerhetosege owndisabled=true></cts-text-box></div></div><hr><div class=row><div class=col-lg-5><cts-text-box name=competitionName label=CompetitionName data-ng-model=vm.data.VersenyNeve validation-rules="{required: true, maxlength: 100}" owndisabled=!vm.allowEdit></cts-text-box></div><div class=col-lg-5><cts-text-box name=competitionPlace label=CompetitionPlace data-ng-model=vm.data.VersenyHelye validation-rules="{required: true, maxlength: 100}" owndisabled=!vm.allowEdit></cts-text-box></div></div><div class=row><div class=col-lg-5><cts-date-picker name=CompetitionStart label=CompetitionStart value=vm.data.VersenyKezdete validation-rules="{required: true}" enabled=vm.allowEdit></cts-date-picker></div><div class=col-lg-5><cts-date-picker name=CompetitionEnd label=CompetitionEnd value=vm.data.VisszaindulasIdopontja validation-rules="{required: true}" enabled=vm.allowEdit></cts-date-picker></div></div><div class=row><div class=col-lg-5><cts-text-box name=CompetitionDepartmentPlace label=CompetitionDepartmentPlace data-ng-model=vm.data.BuszKiallasHelye validation-rules="{required: true, maxlength: 100}" owndisabled=!vm.allowEdit></cts-text-box></div><div class=col-lg-5><cts-date-time-picker name=CompetitionDepartmentTime label=CompetitionDepartmentTime value=vm.data.BuszKiallasIdopontja interval=15 validation-rules="{required: true}" enabled=vm.allowEdit></cts-date-time-picker></div></div><div class=row><div class=col-lg-5><cts-auto-complete name=Bus label=Bus value=vm.data.SzallitoJarmu datasource=vm.busLists validation-rules="{required: true, maxlength: 50}" owndisabled=!vm.allowEdit show-popup-button=true></cts-auto-complete></div><div class=col-lg-5><cts-auto-complete name=BusOwner label=BusOwner validation-rules="{required: true, maxlength: 50}" value=vm.data.SzallitoJarmuTulajdonos datasource=vm.busOwners owndisabled=!vm.allowEdit style="width: 100%" show-popup-button=true></cts-auto-complete></div></div><div class=row><div class=col-lg-5><cts-numeric-text-box name=Advance label=Advance value=vm.data.ElolegOsszege validation-rules="{required: true}" enabled=vm.allowEdit></cts-numeric-text-box></div><div class=col-lg-5></div></div><h3 style="text-align: center;margin: 2em;" translate>DetailedBudget</h3><div><table style="width: 100%;"><thead><tr style="padding-bottom: 0.75em;"><th style="width: 12.5%"></th><th style="width: 12.5%" translate>TravelCost</th><th style="width: 12.5%" translate>Meal</th><th style="width: 12.5%" translate>Accommodation</th><th style="width: 12.5%" translate>RegistrationFee</th><th style="width: 12.5%" translate>SecondmentCost</th><th style="width: 12.5%" translate>Other</th><th style="width: 12.5%" translate>Sum</th></tr></thead><tbody><tr style="vertical-align: middle;"><td translate style="text-align: right; padding: 0.75em 1em 0.75em 0; vertical-align: middle;">Amount</td><td><cts-numeric-text-box name=TravelCostAmount label=TravelCostAmount value=vm.data.UtazasiKoltsegOsszeg validation-rules="{required: true}" enabled=vm.allowEdit inputonly=true change=vm.UtazasiKoltsegOsszegChange></cts-numeric-text-box></td><td><cts-numeric-text-box name=MealAmount label=MealAmount value=vm.data.EtkezesOsszeg validation-rules="{required: true}" enabled=vm.allowEdit inputonly=true change=vm.EtkezesOsszegChange></cts-numeric-text-box></td><td><cts-numeric-text-box name=AccommodationAmount label=AccommodationAmount value=vm.data.SzallasOsszeg validation-rules="{required: true}" enabled=vm.allowEdit inputonly=true change=vm.SzallasOsszegChange < cts-numeric-text-box></cts-numeric-text-box></td><td><cts-numeric-text-box name=RegistrationFeeAmount label=RegistrationFeeAmount value=vm.data.NevezesiOsszeg validation-rules="{required: true}" enabled=vm.allowEdit inputonly=true change=vm.NevezesiOsszegChange></cts-numeric-text-box></td><td><cts-numeric-text-box name=SecondmentCostAmount label=SecondmentCostAmount value=vm.data.KikuldetesiKoltsegOsszeg validation-rules="{required: true}" enabled=vm.allowEdit inputonly=true change=vm.KikuldetesiKoltsegOsszegChange></cts-numeric-text-box></td><td><cts-numeric-text-box name=OtherAmount label=OtherAmount value=vm.data.EgyebOsszeg validation-rules="{required: true}" enabled=vm.allowEdit inputonly=true change=vm.EgyebOsszegChange></cts-numeric-text-box></td><td><cts-numeric-text-box name=Sum label=Sum value=vm.data.OsszesenOszeg validation-rules="{required: false}" enabled=false inputonly=true></cts-numeric-text-box></td></tr><tr><td translate style="text-align: right; padding: 0.75em 1em 0.75em 0; vertical-align: middle;">Provider</td><td><cts-text-box name=TravelCostProvider label=TravelCostProvider data-ng-model=vm.data.UtazasiKoltsegSzolgaltato owndisabled=!vm.allowEdit inputonly=true></cts-text-box></td><td><cts-text-box name=MealProvider label=MealProvider data-ng-model=vm.data.EtkezesSzolgaltato owndisabled=!vm.allowEdit inputonly=true></cts-text-box></td><td><cts-text-box name=AccommodationProvider label=AccommodationProvider data-ng-model=vm.data.SzallasSzolgaltato owndisabled=!vm.allowEdit inputonly=true></cts-text-box></td><td><cts-text-box name=RegistrationFeeProvider label=RegistrationFeeProvider data-ng-model=vm.data.NevezesiDijSzolgaltato owndisabled=!vm.allowEdit inputonly=true></cts-text-box></td><td><cts-text-box name=SecondmentCostProvider label=SecondmentCostProvider data-ng-model=vm.data.KikuldetesiKoltsegSzolgaltato owndisabled=!vm.allowEdit inputonly=true></cts-text-box></td><td><cts-text-box name=OtherProvider label=OtherProvider data-ng-model=vm.data.EgyebSzolgaltato owndisabled=!vm.allowEdit inputonly=true></cts-text-box></td><td></td></tr><tr><td translate style="text-align: right; padding: 0.25em 1em 0.75em 0; vertical-align: middle;">Divide</td><td style="padding: 0.25em 1em 0.75em 0;"><button type=button id=TravelCostDivide class=cts-button ej-button e-enabled=vm.allowEdit e-click=vm.travelCostDivide e-width=100% translate>TravelCostDivide</button></td><td style="padding: 0.25em 1em 0.75em 0;"><button type=button id=MealDivide class=cts-button ej-button e-enabled=vm.allowEdit e-click=vm.mealDivide e-width=100% translate>MealDivide</button></td><td style="padding: 0.25em 1em 0.75em 0;"><button type=button id=AccommodationDivide class=cts-button ej-button e-enabled=vm.allowEdit e-click=vm.accommodationDivide e-width=100% translate>AccommodationDivide</button></td><td style="padding: 0.25em 1em 0.75em 0;"><button type=button id=RegistrationFeeDivide class=cts-button ej-button e-enabled=vm.allowEdit e-click=vm.registrationFeeDivide e-width=100% translate>RegistrationFeeDivide</button></td><td style="padding: 0.25em 1em 0.75em 0;"><button type=button id=SecondmentCostDivide class=cts-button ej-button e-enabled=vm.allowEdit e-click=vm.secondmentCostDivide e-width=100% translate>SecondmentCostDivide</button></td><td style="padding: 0.25em 1em 0.75em 0;"><button type=button id=OtherDivide class=cts-button ej-button e-enabled=vm.allowEdit e-click=vm.otherDivide e-width=100% translate>OtherDivide</button></td></tr><tr><td translate style="text-align: right; padding: 0.25em 1em 0.75em 0; vertical-align: middle;">Comment</td><td colspan=7><cts-text-area name=Comment label=Comment data-ng-model=vm.data.Megjegyzes css="padding-left:0; padding-right:0; width: 100%;" disabled=!vm.allowEdit inputonly=true></cts-text-area></td></tr></tbody></table></div><h3 style="text-align: center;margin: 2em;" translate>DetailedPeople</h3><div class=row ng-show=vm.allowEdit><div class=col-lg-8><div class="form-group cts-form-group"><label translate>MoreAgeGroups</label><div class=input-group><input type=text id=MoreAgeGroups name=MoreAgeGroups></div></div></div><div class=col-lg-8><div class="form-group cts-form-group"><label translate>Athlete</label><div class=input-group><input type=text id=AthleteDropDownMS name=AthleteDropDownMS></div></div></div><div class=col-lg-4><button type=button id=AddAthlete class=cts-button ej-button e-click=vm.addAthlete e-enabled=vm.allowEdit translate>Add</button> <button type=button id=AddAllAthlete class=cts-button ej-button e-click=vm.addAllAthlete e-enabled=vm.allowEdit translate>AddAll</button></div><div class=col-lg-8><div class="form-group cts-form-group"><label translate>User</label><div class=input-group><input type=text id=UserDropDownMS name=UserDropDownMS></div></div></div><div class=col-lg-4><button type=button id=AddUser class=cts-button ej-button e-click=vm.addUser e-enabled=vm.allowEdit translate>Add</button></div><div class=col-lg-8><cts-text-box name=OtherPersonName label=OtherPersonName data-ng-model=vm.otherPersonName owndisabled=!vm.allowEdit></cts-text-box><cts-numeric-text-box name=OtherPersonYear label=OtherPersonYear value=vm.otherPersonYear enabled=vm.allowEdit></cts-numeric-text-box></div><div class=col-lg-4><button type=button id=AddOther class=cts-button ej-button e-click=vm.addOtherPersonName e-enabled=vm.allowEdit translate>Add</button></div><div class=col-lg-12><button type=button id=DeleteSelected class=cts-button ej-button e-click=vm.deleteSelected e-enabled=vm.allowEdit translate>DeleteSelected</button></div></div><div class=row style=margin-top:0.5rem><div id=Grid></div></div><div class=button-wrapper style="text-align: center; margin-top: 2em; width: 100%;"><div class=row><button type=submit name=saveAwayBudgetPlan id=search class=cts-button ej-button e-click=vm.save e-enabled=vm.allowEdit translate>Save</button> <button type=button id=delete class=cts-button ej-button e-click=vm.deletePlan ng-if="vm.data.Id > 0 && !vm.forceDisableEdit && !vm.teny && vm.allowEdit" translate>DeletePlan</button> <button class=cts-button ej-button e-click=vm.print translate>Print</button> <button class=cts-button ej-button e-click=vm.excel ng-if="vm.data.Id>0" translate>Excel Export</button></div><div class=row><button class=cts-button ej-button e-click=vm.close ng-if=vm.allowClose translate>ClosePlan</button> <button class=cts-button ej-button e-click=vm.open ng-if="vm.allowOpen && vm.forceDisableEdit == false" translate>ReOpenPlan</button> <button class=cts-button ej-button ng-if="vm.allowOpen && vm.forceDisableEdit == true && vm.teny == false" e-enabled=false translate>UnableToReOpenPlan</button> <button class=cts-button ej-button e-click=vm.finalize ng-if="vm.allowFinalize == true && vm.forceDisableEdit == false" translate>Finalize</button></div><div class=row ng-hide="vm.terv && vm.tenyId > 0"><button ej-button class=cts-button e-enabled=vm.Accept1Enabled e-click=vm.IWillAccept1 ng-if="vm.allowIWillAccept1 && !vm.allowAccept1 && !vm.allowUndoAccept1" translate>IWillAccept1</button> <button ej-button class=cts-button e-enabled=vm.Accept1Enabled e-click=vm.accept1 ng-if="!vm.allowIWillAccept1 && vm.allowAccept1 && !vm.allowUndoAccept1" translate>Accept1</button> <button ej-button class=cts-button e-enabled=vm.UndoAccept1Enabled e-click=vm.UndoAccept1 ng-if="!vm.allowIWillAccept1 && !vm.allowAccept1 && vm.allowUndoAccept1" translate>UndoAccept1</button> <button ej-button class=cts-button e-enabled=false ng-if="!vm.allowIWillAccept1 && !vm.allowAccept1 && !vm.allowUndoAccept1" translate>UnableAccept1</button> <button ej-button class=cts-button e-enabled=vm.Accept2Enabled e-click=vm.IWillAccept2 ng-if="vm.allowIWillAccept2 && !vm.allowAccept2 && !vm.allowUndoAccept2" translate>IWillAccept2</button> <button ej-button class=cts-button e-enabled=vm.Accept2Enabled e-click=vm.accept2 ng-if="!vm.allowIWillAccept2 && vm.allowAccept2 && !vm.allowUndoAccept2" translate>Accept2</button> <button ej-button class=cts-button e-enabled=vm.UndoAccept2Enabled e-click=vm.UndoAccept2 ng-if="!vm.allowIWillAccept2 && !vm.allowAccept2 && vm.allowUndoAccept2" translate>UndoAccept2</button> <button ej-button class=cts-button e-enabled=false ng-if="!vm.allowIWillAccept2 && !vm.allowAccept2 && !vm.allowUndoAccept2" translate>UnableAccept2</button> <button ej-button class=cts-button e-enabled=vm.Accept3Enabled e-click=vm.IWillAccept3 ng-if="vm.allowIWillAccept3 && !vm.allowAccept3 && !vm.allowUndoAccept3" translate>IWillAccept3</button> <button ej-button class=cts-button e-enabled=vm.Accept3Enabled e-click=vm.accept3 ng-if="!vm.allowIWillAccept3 && vm.allowAccept3 && !vm.allowUndoAccept3" translate>Accept3</button> <button ej-button class=cts-button e-enabled=vm.UndoAccept3Enabled e-click=vm.UndoAccept3 ng-if="!vm.allowIWillAccept3 && !vm.allowAccept3 && vm.allowUndoAccept3" translate>UndoAccept3</button> <button ej-button class=cts-button e-enabled=false ng-if="!vm.allowIWillAccept3 && !vm.allowAccept3 && !vm.allowUndoAccept3" translate>UnableAccept3</button></div></div><div class=row><table class=table><tbody><tr><td><label>Szakmai j\xF3v\xE1hagy\xF3:</label></td><td>{{vm.subtitle1}}</td></tr><tr><td><label>Gazdas\xE1gi j\xF3v\xE1hagy\xF3:</label></td><td>{{vm.subtitle2}}</td></tr><tr><td><label>Vezet\u0151i j\xF3v\xE1hagy\xF3:</label></td><td>{{vm.subtitle3}}</td></tr></tbody></table></div></form></div><div class=widget-foot><div class=clearfix></div></div><div id=printDialog style="height: 100%;"><report report-name=TIdegenbeliKoltsegvetesiTervReport report-parameters=vm.reportParameters style="height: 100%;"></report></div>');
$templateCache.put('app/administration/exercises/exercisesList/exercisesList.html','<div class=widget-head><h2 class=page-title>{{title}}</h2></div><div class=widget-content><form class=filter name=form><div class=row><cts-dropdown-list name=sectionDropDown label=Section value=vm.SzakosztalyId datasource=vm.sectionList databound=vm.sectionDataBound select=vm.sectionSelect validation-rules="{required: true}"></cts-dropdown-list><cts-dropdown-list name=ageGroupDropDown label=AgeGroup value=vm.KorosztalyId datasource=vm.ageGroupList databound=vm.ageGroupDataBound select=vm.ageGroupSelect validation-rules="{required: true}"></cts-dropdown-list><cts-dropdown-list name=coachDropDown label=Coach value=vm.EdzoId datasource=vm.coachList databound=vm.coachDataBound select=vm.coachSelect></cts-dropdown-list><cts-auto-complete name=BodyParts label=BodyParts value=vm.bodyPartValue validation-rules="{required: false}" datasource=vm.autoComplete.Testresz multi-select=true show-popup-button=true></cts-auto-complete><cts-auto-complete name=ExercisesType label=Type value=vm.TypeValue validation-rules="{required: false}" datasource=vm.autoComplete.Tipus multi-select=true show-popup-button=true></cts-auto-complete><cts-auto-complete name=individualTeam label=individualTeam value=vm.individualTeamValue validation-rules="{required: false}" datasource=vm.autoComplete.Jellege multi-select=true show-popup-button=true></cts-auto-complete><cts-auto-complete name=ExercisesAsset label=Assets value=vm.AssetValue validation-rules="{required: false}" datasource=vm.autoComplete.Felszerelesek multi-select=true show-popup-button=true></cts-auto-complete><cts-auto-complete name=Difficulty label=Difficulty value=vm.difficultyValue validation-rules="{required: false}" datasource=vm.autoComplete.Nehezseg multi-select=true show-popup-button=true></cts-auto-complete><cts-auto-complete name=Time label=TimeLength value=vm.timeValue validation-rules="{required: false}" datasource=vm.autoComplete.Ido multi-select=true show-popup-button=true></cts-auto-complete><cts-auto-complete name=NecessaryArea label=Space value=vm.necessaryAreaValue validation-rules="{required: false}" datasource=vm.autoComplete.SzuksegesTerulet multi-select=true show-popup-button=true></cts-auto-complete><cts-check-box name=Video label=Video checked=vm.withVideo></cts-check-box><cts-check-box name=Pattern label=Pattern checked=vm.withPattern></cts-check-box><cts-check-box name=Paint label=Paint checked=vm.withPaint></cts-check-box></div><div class=row><div class=button-wrapper><button type=submit ej-button class=cts-button e-click=vm.create translate>Create</button> <button class=cts-button ej-button e-click=vm.getDatas translate>Show</button></div></div></form><div class=row style=margin-top:1rem><div id=Grid name=Grid></div><script type=text/x-template id=teamlistcolumnTemplate3><a data-ng-click="vm.deleteExercise(${GyakorlatId})" ng-show="vm.MODGYAKORLAT" translate>Delete</a></script><script id=imagetemplateGrid type=text/x-handlebars-template><div height="64px" max-width="64px" class="thumbnail-item" href="${Mintakep}"><img src="${Mintakep}" align="center" height="64px" max-width="64px"/></div></script><script type=text/x-template id=wtpropentemp><div><a data-ng-click="vm.goToExercise(${GyakorlatId})">${Nev}</a></div></script></div></div><div class=widget-foot><div class=clearfix></div></div>');
$templateCache.put('app/administration/monthlyAttendance/monthlyAttendanceList/monthlyAttendanceList.html','<ht-widget-header title={{title}} text-id=monthlyAttendanceListHelp right-text=rightText></ht-widget-header><div class=widget-content><form name=form class=filter><div style="overflow: hidden"><cts-dropdown-list name=maEdzo label=Coach value=vm.selectedCoach datasource=vm.coachList select=vm.coachChanged validation-rules="{required: true}"></cts-dropdown-list><cts-dropdown-list name=maEv label=Year value=vm.selectedYear datasource=vm.years select=vm.yearChanged validation-rules="{required: true}"></cts-dropdown-list><cts-dropdown-list name=maHonap label=Month value=vm.selectedMonth datasource=vm.months cts-placeholder=AllMonth validation-rules="{required: true}"></cts-dropdown-list><cts-dropdown-list name=maMode label=Mode value=vm.selectedMode datasource=vm.modeList></cts-dropdown-list><div class=button-wrapper><button type=submit class=cts-button ej-button data-ng-click=vm.refreshData() translate>Keres</button></div></div></form><div id=Grid name=Grid></div><div class="col-sm-12 col-md-12 col-lg-12"><hr><button class=cts-button ej-button data-ng-show="(!vm.hasSignedAttendance && !vm.hasAcceptedAttendance) && vm.HJFELVIHET" data-ng-click=vm.createNewAttendance() translate>\xDAj havi jelenl\xE9ti \xF6sszes\xEDt\u0151 k\xE9sz\xEDt\xE9se</button> <button class=cts-button style=margin-right:20px; ej-button data-ng-click=back() translate>Bez\xE1r\xE1s</button></div></div><div class=widget-foot><div class=clearfix></div></div><script id=moatlitemplateDataColumn1 type=text/x-template><a data-ng-click="vm.goToNewAgeGroup(${IdKorosztaly})">${Korosztaly}</a></script><script id=moatlitemplateDataColumn2 type=text/x-template><a data-ng-click="vm.goToNewUser(${IdEdzo})">${Edzo}</a></script><script id=moatlitemplateDataColumn3 type=text/x-template><input data-ng-if="\'${EdzoLezarta}\' === \'true\'" type="checkbox" checked="checked" disabled/> <input data-ng-if="\'${EdzoLezarta}\' !== \'true\'" type="checkbox" disabled/></script><script id=moatlitemplateDataColumn4 type=text/x-template><input data-ng-if="\'${SzakvezJovahagyta}\' === \'true\'" type="checkbox" checked="checked" disabled/> <input data-ng-if="\'${SzakvezJovahagyta}\' !== \'true\'" type="checkbox" disabled/></script><script id=moatlitemplateDataColumn5 type=text/x-template><a data-ng-click="vm.goToMonthlyAttendance(${Id})"><i class="fa fa-eye" style="font-size: 1.5em;"></i></a></script>');
$templateCache.put('app/administration/exercises/exercisesCreate/exercisesCreate.html','<div class=widget-head><h2 class=page-title>{{title}}</h2></div><div class="widget-content form"><form novalidate name=form enctype=multipart/form-data><div class=row><div class=col-lg-6><h4 style="text-align: center; margin-bottom: 1.5em;" translate>ExerciseDetails</h4><cts-text-box name=exerciseName label=ExerciseName data-ng-model=vm.formdata.exerciseName validation-rules="{required: true, maxlength: 50}"></cts-text-box><cts-dropdown-list name=sectionId label=Section value=vm.formdata.sectionId datasource=vm.sectionList validation-rules="{required: true}" databound=vm.sectionDataBound select=vm.sectionSelect></cts-dropdown-list><cts-dropdown-list name=ageGroupId label=AgeGroup value=vm.formdata.ageGroupId datasource=vm.ageGroupList validation-rules="{required: true}" databound=vm.ageGroupDataBound select=vm.ageGroupSelect></cts-dropdown-list><cts-dropdown-list name=coachId label=Coach value=vm.formdata.coachId datasource=vm.coachList databound=vm.coachDataBound select=vm.coachSelect validation-rules="{required: true}"></cts-dropdown-list><cts-auto-complete name=bodyParts label=BodyParts value=vm.formdata.bodyParts datasource=vm.bodyPartsList show-popup-button=true change=vm.bodyPartsChange validation-rules="{required: true}" multi-select=true allow-add-new=true addnewtext=vm.addNewText></cts-auto-complete><cts-auto-complete name=type label=Type value=vm.formdata.type datasource=vm.typeList show-popup-button=true change=vm.typeChange validation-rules="{required: true}" multi-select=true allow-add-new=true addnewtext=vm.addNewText></cts-auto-complete><cts-auto-complete name=individualTeam label=IndividualTeam value=vm.formdata.individualTeam datasource=vm.individualTeamList show-popup-button=true change=vm.individualTeamChange validation-rules="{required: true, maxlength: 50}" multi-select=true allow-add-new=true addnewtext=vm.addNewText></cts-auto-complete><cts-numeric-text-box name=time label=TimeLength value=vm.formdata.time></cts-numeric-text-box><cts-numeric-text-box name=difficulty label=Difficulty value=vm.formdata.difficulty></cts-numeric-text-box><cts-text-box name=players label=Players data-ng-model=vm.formdata.players validation-rules="{maxlength: 20}"></cts-text-box><cts-text-box name=space label=Space data-ng-model=vm.formdata.space></cts-text-box><cts-auto-complete name=asserts label=Asserts value=vm.formdata.asserts datasource=vm.assertsList show-popup-button=true change=vm.assertsChange multi-select=true allow-add-new=true addnewtext=vm.addNewText></cts-auto-complete><cts-text-box name=youtube label=Youtube data-ng-model=vm.youtube change=vm.youtubeChanged></cts-text-box><div class="form-group cts-form-group"><label></label><div class=input-group><button type=button class="btn btn-link" style="padding-left: 0; padding-top: 0;" data-ng-click=vm.deleteVideo() translate>DeleteVideo</button></div></div><cts-dropdown-list name=paintId label=PaintLabel value=vm.formdata.paintId datasource=vm.paintList databound=vm.paintDataBound select=vm.paintSelect open=vm.openPaint></cts-dropdown-list><div class="form-group cts-form-group"><label></label><div class=input-group><button type=button class="btn btn-link" style="padding-left: 0; padding-top: 0;" data-ng-click=vm.goToCreatePaint() translate>NewPaint</button></div></div><cts-check-box name=public label=Public change=vm.publicChanged></cts-check-box><cts-text-area width=100% label=Description rows=5 cols=30 ng-model=vm.formdata.Leiras></cts-text-area></div><div class=col-xs-6><h4 style="text-align: center; margin-bottom: 1em;" translate data-ng-show=vm.formdata.youtube>YoutubeVideo</h4><div id=playerWrapper class=auto-clear style="text-align: center;" data-ng-show=vm.formdata.youtube></div><h4 style="text-align: center; margin-bottom: 1em;" translate>UploadedImages</h4><div class=auto-clear><div class=col-xs-12><div class="col-xs-12 col-md-6 col-lg-4" ng-repeat="image in vm.formdata.savedImageList track by $index" style="margin-bottom: 2em; width: 235px;"><label style="overflow: hidden; -ms-text-overflow: ellipsis;text-overflow: ellipsis;white-space: nowrap;">{{image.fileName}}</label><div style="height: 100%;"><a class=gallery-item href={{image.fileUrl}}><img src={{image.fileUrl}} style="width: 100%;"></a></div><div style="text-align: center;"><button class="btn cts-button" translate style="float: left;" ng-click=vm.makeToThumb($index) ng-disabled="image.thumbnail == true"><img style="height: 24px; width: 24px;" src={{imageThumb}}></button> <button class="btn cts-button" translate style="float: right;" ng-click=vm.deleteExistingImg($index)><img style="height: 24px; width: 24px;" src={{dustbin}}></button></div></div></div></div><div class=col-xs-12><div class=dropzone file-dropzone style="height: 150px; width: 100%; border: 2px dashed #333333; position: relative;"><p style="position: absolute; top: 60px; text-align: center; width: 100%;" translate>ImageDropZoneText</p><label for=addFile style="position: absolute; top: 80px; width: 100%; text-align: center;"><div class="btn cts-button"><i class="fa fa-file-image-o" aria-hidden=true></i> <span translate>AddImages</span></div></label></div><input id=addFile name=addFile type=file ng-file-select=vm.onFileSelect($files) style="display: none;" multiple accept=.jpg,.jpeg,.bmp,.png,.gif></div><div class=col-xs-12><h4 style="margin-top: 2em; text-align: center;" translate>UploadingImages</h4></div><div class=auto-clear><div class="col-xs-12 col-md-6 col-lg-4" ng-repeat="image in files track by $index" style="margin-bottom: 2em;"><label style="overflow: hidden; -ms-text-overflow: ellipsis;text-overflow: ellipsis;white-space: nowrap;">{{files[$index].name}}</label><div style="height: 100%;"><img ng-src={{imageDatas[$index]}} style="width: 100%;"></div><div style="text-align: center;"><button class="btn cts-button" translate style="width: 100%;" ng-click=vm.deleteImg($index) ng-class="{fullWidthThis: image.thumbnail == true}"><img style="height: 24px; width: 24px;" src={{dustbin}}></button></div></div></div></div><div class=col-xs-12><div class=col-sm-12 style="text-align: center; margin-top: 2em;"><button type=submit class=cts-button ej-button e-click=vm.save translate>Save</button> <button type=reset class=cts-button ej-button e-click=back translate>Back</button></div></div></div></form></div><div class=widget-foot><div class=clearfix></div></div>');
$templateCache.put('app/administration/monthlyAttendance/monthlyAttendanceReport/monthlyAttendanceReport.html','<div class=widget><ht-widget-header title={{title}} text-id=monthlyAttendanceHelp right-text=rightText></ht-widget-header><div class=widget-content><form name=form class=filter><div style="overflow: hidden;"><cts-dropdown-list name=maEdzo label=Coach value=vm.selectedCoach datasource=vm.coachList databound=vm.coachDataBound select=vm.coachSelect validation-rules="{required: true}"></cts-dropdown-list><cts-dropdown-list name=maSzakosztaly label=Section value=vm.selectedSection datasource=vm.sectionList databound=vm.sectionDataBound select=vm.sectionSelect validation-rules="{required: true}"></cts-dropdown-list><cts-dropdown-list data-ng-if=vm.allAgeGroupfill name=maKorosztaly label=AgeGroup value=vm.selectedAgeGroup datasource=vm.ageGroupList databound=vm.ageGroupDataBound select=vm.ageGroupSelect validation-rules="{required: true}"></cts-dropdown-list><div class=button-wrapper><button id=olderReports class=cts-button ej-button e-click=vm.goToOlderMonthlyAttendanceReports translate>OlderMonthlyAttendanceReports</button></div></div><div><cts-dropdown-list name=maEv label=Year value=vm.selectedYear datasource=vm.years select=vm.yearSelect validation-rules="{required: true}" databound=vm.yearDataBound></cts-dropdown-list><cts-dropdown-list name=maHonap label=Month value=vm.selectedMonth datasource=vm.months select=vm.monthSelect validation-rules="{required: true}" databound=vm.monthDataBound></cts-dropdown-list><div class=button-wrapper><button id=attendanceSelect class=cts-button ej-button e-click=vm.attendanceSelect translate>ChooseIt</button></div></div><div><cts-check-box name=autoSaveCheckBox label=AutoSave checked=vm.autoSave data-ng-if="vm.autoSave != undefined" change=vm.autoSaveCheckboxChanged></cts-check-box></div><div class="alert alert-info" data-ng-show="vm.noAttendance && vm.editedAttendance.tetelek.length > 0" translate>ThereIsntAttendanceReport</div><div class="alert alert-info" data-ng-show="vm.hasAttendance && vm.editedAttendance.tetelek.length > 0" translate>ThereIsAttendanceReport</div><div class="alert alert-info" data-ng-show="vm.hasSignedAttendance && vm.editedAttendance.tetelek.length > 0" translate>TherIsSignedAttendanceReport</div><div class="alert alert-info" data-ng-show="vm.hasAcceptedAttendance && vm.editedAttendance.tetelek.length > 0" translate>ThereIsSignedAndAcceptedAttendanceReport</div><div class="alert alert-info" data-ng-show="vm.noAttendance && vm.editedAttendance.tetelek.length <= 0" translate>NoAthletesInSelectedMonthlyAttendanceReport</div><div data-ng-show="vm.editedAttendance.tetelek.length > 0"><table class=attendance-report-table><thead><tr><th translate>Day</th><th translate>Monday</th><th translate>Tuesday</th><th translate>Wednesday</th><th translate>Thursday</th><th translate>Friday</th><th translate>Saturday</th><th translate>Sunday</th></tr></thead><tbody><tr><td translate>Place</td><td><input type=text class=form-control name=maHetfoHely id=maHetfoHely data-ng-model=vm.dayz.HetfoHely data-ng-disabled=vm.readOnlyAttendance></td><td><input type=text class=form-control name=maKeddHely id=maKeddHely data-ng-model=vm.dayz.KeddHely data-ng-disabled=vm.readOnlyAttendance></td><td><input type=text class=form-control name=maSzerdaHely id=maSzerdaHely data-ng-model=vm.dayz.SzerdaHely data-ng-disabled=vm.readOnlyAttendance></td><td><input type=text class=form-control name=maCsutHely id=maCsutHely data-ng-model=vm.dayz.CsutortokHely data-ng-disabled=vm.readOnlyAttendance></td><td><input type=text class=form-control name=maPentekHely id=maPentekHely data-ng-model=vm.dayz.PentekHely data-ng-disabled=vm.readOnlyAttendance></td><td><input type=text class=form-control name=maSzombatHely id=maSzombatHely data-ng-model=vm.dayz.SzombatHely data-ng-disabled=vm.readOnlyAttendance></td><td><input type=text class=form-control name=mavasarnapHely id=maVasarnapHely data-ng-model=vm.dayz.VasarnapHely data-ng-disabled=vm.readOnlyAttendance></td></tr><tr><td translate>Time</td><td><input type=text class=form-control name=maHetfoIdo id=maHetfoIdo data-ng-model=vm.dayz.HetfoIdo data-ng-disabled=vm.readOnlyAttendance></td><td><input type=text class=form-control name=maKeddIdo id=maKeddIdo data-ng-model=vm.dayz.KeddIdo data-ng-disabled=vm.readOnlyAttendance></td><td><input type=text class=form-control name=maSzerdaIdo id=maSzerdaIdo data-ng-model=vm.dayz.SzerdaIdo data-ng-disabled=vm.readOnlyAttendance></td><td><input type=text class=form-control name=maCsutIdo id=maCsutIdo data-ng-model=vm.dayz.CsutortokIdo data-ng-disabled=vm.readOnlyAttendance></td><td><input type=text class=form-control name=maPentekIdo id=maPentekIdo data-ng-model=vm.dayz.PentekIdo data-ng-disabled=vm.readOnlyAttendance></td><td><input type=text class=form-control name=maSzombatIdo id=maSzombatIdo data-ng-model=vm.dayz.SzombatIdo data-ng-disabled=vm.readOnlyAttendance></td><td><input type=text class=form-control name=mavasarnapIdo id=maVasarnapIdo data-ng-model=vm.dayz.VasarnapIdo data-ng-disabled=vm.readOnlyAttendance></td></tr></tbody></table><form name=formsetforall class=filter><div style="overflow: hidden;" ng-if=!vm.editedAttendance.fej.EdzoAlairta><cts-numeric-text-box name=pmtn label=PlannedMonthlyTrainingsNumbers value=vm.plannedTrainings></cts-numeric-text-box><div class=button-wrapper><button id=SetForAll class=cts-button ej-button e-click=vm.SetForAll translate>SetForAll</button></div></div></form><div class=attendance-report-div><p><span translate>NumberOfAthletes</span>: {{vm.editedAttendance.fej.CsoportLetszam}}</p><p><span translate>Entered</span>: {{vm.editedAttendance.fej.Erkezett}}</p><p><span translate>Leave</span>: {{vm.editedAttendance.fej.Tavozott}}</p></div><div class=attendance-report-div><p><span translate>LastEditedValue</span>: {{vm.editedColumnValue}} <button id=CopyCellToColumn class=cts-button ej-button e-click=vm.CopyCellToColumn style="margin-left: 2em;" translate>CopyCellToColumn</button></p></div><script type=text/x-template id=columnTemplate><a data-ng-click="vm.goToNewAthlete(${IdSportolo})">${SportoloNev}</a></script><div class=row><div style="position: fixed; z-index: 10000; top: 70px; left: 45%; background-color: forestgreen; color: white; border: 2px solid forestgreen; -webkit-border-radius: 5px;-moz-border-radius: 5px;border-radius: 5px;" data-ng-if=vm.AthleteUnderEditing><h2>{{vm.AthleteUnderEditingText}}: {{vm.AthleteUnderEditing}}</h2></div><div id=GridNew name=GridNew class=slim-grid></div></div><div class=col-sm-6 style="margin-top:10px; margin-left: -15px"><p><b><span translate>SumPresence</span>: {{vm.presencePercentSum}}%</b></p></div><div class=col-sm-6 style="margin-top:10px; float:right;text-align:right; margin-right:-10px;"><p translate>NotationMonthlyAttendanceReport</p></div><cts-text-area name=comment label=Comment data-ng-model=vm.editedAttendance.fej.Megjegyzes disabled=vm.readOnlyAttendance css="padding-left:0; padding-right:0; width: 100%; margin-top:10px"></cts-text-area><div class=col-sm-12 style="text-align: center"><button class=cts-button ej-button data-ng-if=vm.closeButton e-click=vm.CopyTimeAndPlaceFromWeeklyPlan translate>CopyTimeAndPlaceFromWeeklyPlan</button> <button class=cts-button ej-button data-ng-if=vm.closeButton e-click=vm.closeMonthlyAttendance translate>AttendanceReportClose</button> <button class=cts-button ej-button data-ng-if=vm.acceptButton e-click=vm.acceptMonthlyAttendance translate>SectionLeaderApprove</button> <button class=cts-button ej-button data-ng-if=vm.rejectButton e-click=vm.rejectMonthlyAttendance translate>Deny</button> <button class=cts-button ej-button e-click=vm.print data-ng-if="vm.editedAttendance.fej.Id>0" translate>Print</button><button class=cts-button ej-button data-ng-if=vm.saveButton e-click=vm.saveAttendance e-enabled=vm.saveButtonEnabled translate>Save</button> <button class=cts-button ej-button data-ng-if="vm.editedAttendance.fej.Id>0" e-click=vm.openTrainingDiary translate>openTrainingDiary</button></div></div></form><div id=popup><div id=rejectAttendanceWindow ej-dialog e-height=235px e-minheight=235px e-maxheight=235px e-title="Havi jelenl\xE9ti \xF6sszes\xEDt\u0151 visszautas\xEDt\xE1sa" e-showoninit=false e-enablemodal=true e-enableresize=false e-allowkeyboardnavigation=false e-closeonescape=true e-isresponsive=true e-content=#popup e-enableanimation=true e-showroundedcorner=false><div class=col-md-12><div class=text-center><p class=dialog-hide-elemet style="color: darkgray;" id=expiresLabel>Adja meg a visszautas\xEDt\xE1s ok\xE1t:</p><form style=height:100px;><div class=form-group><textarea class=form-control data-ng-model=vm.rejectAttendanceText style="height:80px; max-height: 80px; min-height: 80px;"></textarea></div></form><div class=form-group><button class="btn btn-danger post pull-right" id=cancel data-ng-click=vm.closerejectingWindow() type=button>M\xE9gsem</button> <button class="btn btn-primary post left-padding" id=done data-ng-click=vm.rejectAttendance() type=button>Rendben</button></div></div></div></div></div></div><div class=widget-foot><div class=clearfix></div></div></div><div id=printDialog><report report-name=THaviJelenleti report-parameters=vm.reportParameters></report></div><script id=datetemplate type=text/x-template><div style="">Order Date</div></script><style>\r\n    .e-columnheader .e-headercell .e-headercelldiv {\r\n        height: 170px;\r\n        text-align: left !important;\r\n        display: table-cell;\r\n    }\r\n\r\n    .e-columnheader .e-headercell .e-headercelldiv #gridheaderverticalcenter {\r\n        margin-top: 85px;\r\n        margin-bottom: -85px;\r\n    }\r\n\r\n    .e-columnheader .e-headercell .e-headercelldiv .e-headertext {\r\n        vertical-align: center;\r\n    }\r\n\r\n    .e-grid .e-headercelldiv {\r\n        line-height: 0 !important;\r\n    }\r\n</style>');
$templateCache.put('app/administration/monthlyTrainingPlan/monthlyTrainingPlanList/monthlyTrainingPlanList.html','<ht-widget-header title={{title}} text-id=monthlyTrainingPlanListHelp right-text=rightText></ht-widget-header><div class=widget-content><form name=form class=filter><div style="overflow: hidden"><cts-dropdown-list name=maEdzo label=Coach value=vm.selectedCoach datasource=vm.coachList select=vm.coachChanged databound=vm.coachDataBound validation-rules="{required: true}"></cts-dropdown-list><cts-dropdown-list name=maSzakosztaly label=Section value=vm.selectedSection datasource=vm.sectionList databound=vm.sectionDataBound select=vm.sectionChanged validation-rules="{required: true}"></cts-dropdown-list><cts-dropdown-list name=maKorosztaly label=AgeGroup value=vm.selectedAgeGroup datasource=vm.ageGroupList databound=vm.ageGroupDataBound validation-rules="{required: true}" select=vm.ageGroupChanged></cts-dropdown-list><cts-dropdown-list name=maEv label=Year datasource=vm.years value=vm.selectedYear select=vm.yearChanged validation-rules="{required: true}"></cts-dropdown-list><cts-text-box name=txTartalom label=textSearch ng-model=vm.textSearch></cts-text-box><div class=button-wrapper><button type=submit e-height=34px ej-button class=cts-button data-ng-click=vm.refreshData() translate>Search</button></div></div></form><div id=Grid name=Grid></div><div class=col-xs-12><hr><button class=cts-button e-height=34px ej-button data-ng-click=vm.createNewWeeklyTrainingPlan() translate>New</button> <button data-ng-disabled=!vm.delEnabled class=cts-button e-height=34px ej-button e-enabled=vm.delEnabled data-ng-click=vm.deleteWeeklyTrainingPlan() translate>deleteWeeklyTrainingPlan</button> <button class=cts-button e-height=34px ej-button data-ng-click=back() translate>Back</button></div></div><div class=widget-foot><div class=clearfix></div></div><script id=motrpllitemplateDataColumn1 type=text/x-template><a data-ng-click="vm.goToNewUser(${EdzoId})">${Edzo}</a></script><script id=motrpllitemplateDataColumn2 type=text/x-template><a data-ng-click="vm.goToNewAgeGroup(${IdKorcsoport})">${Korosztaly}</a></script><script id=motrpllitemplateDataColumn3 type=text/x-template><a data-ng-click="vm.goToWeeklyTrainingPlan(${Id})" ><i class="fa fa-eye" style="font-size: 1.5em;"></i></a></script><script id=motrpllitemplateDataColumn4 type=text/x-template><input data-ng-if="\'${Jovahagyott}\' === \'true\'" type="checkbox" checked="checked" disabled/> <input data-ng-if="\'${Jovahagyott}\' !== \'true\'" type="checkbox" disabled/></script>');
$templateCache.put('app/administration/monthlyTrainingPlan/monthlyTrainingPlanReport/monthlyTrainingPlanReport.html','<div class=widget-head><h2 class=page-title>{{title}}</h2></div><div id=popup><div id=searchWindow ej-dialog e-height=435px e-minheight=435px e-maxheight=900px e-minwidth=600px e-title="Kor\xE1bbi heti edz\xE9s terv m\xE1sol\xE1sa" e-showoninit=false e-enablemodal=true e-enableresize=false e-allowkeyboardnavigation=false e-closeonescape=true e-isresponsive=true e-content=#popup e-enableanimation=true e-width=60% e-showroundedcorner=false><div class=col-md-12><div class=text-center><div id=GridPopup name=GridPopup></div><div class=form-group style="margin-top: 20px"><button class="cts-button post" id=cancel data-ng-click=vm.closeEarlierMonthlyPlanWindow() type=button translate>Cancel</button> <button class="cts-button post" id=done data-ng-click=vm.selectEarlierMonthlyPlanWindow() type=button translate>Rendben</button></div></div></div></div></div><div class=widget-content><form name=form class=filter><div style="overflow: hidden; text-align:right; margin-right:15px"><button class=cts-button id=korabbiMasol data-ng-show=vm.copyEnabled data-ng-click=vm.copyFromOldPlan() type=button translate>OlderMonthlyCompetitveReports</button></div><div style="overflow: hidden;"><cts-text-box name=txEdzo label=Coach ng-model=vm.editedMTP.EdzoNev owndisabled=true></cts-text-box><cts-text-box name=txSzakosztaly label=Section ng-model=vm.editedMTP.SzakosztalyNev owndisabled=true></cts-text-box><cts-text-box name=txKorosztaly label=AgeGroup ng-model=vm.editedMTP.KorosztalyNev owndisabled=true></cts-text-box></div><hr><div style="overflow: hidden;"><cts-numeric-text-box name=txMakrociklus label=Makrociklus value=vm.editedMTP.Makrociklus disabled=false validation-rules="{required: true}"></cts-numeric-text-box><cts-numeric-text-box name=txTervEdzesszam label=PlannedNumberOfTrainings value=vm.editedMTP.TervezettEdzesszam disabled=false validation-rules="{required: true}"></cts-numeric-text-box><cts-dropdown-list name=maEv label=Year value=vm.editedMTP.Ev datasource=vm.years validation-rules="{required: true}"></cts-dropdown-list><cts-dropdown-list name=maHonap label=Month value=vm.editedMTP.HonapSzama datasource=vm.months validation-rules="{required: true}"></cts-dropdown-list></div><br><p class=text-center translate>NAPDATUMEDZESTERV</p><table class="attendance-report-table table-no-margin"><thead><tr><th translate class=text-center>TrainingPlan</th></tr></thead><tbody><tr><td><cts-text-area name=HetfoDe ng-model=vm.editedMTP.Tartalom css="padding-left:0; padding-right:0; width: 100%;"></cts-text-area></td></tr><tr></tr></tbody></table><p data-ng-if=vm.JOVAHAGYOTT translate>MonthlyTraningPlanApproved</p><div class=form-group><button class="cts-button post pull-left" id=mentes data-ng-click=vm.save() type=button translate>Save</button> <button class="cts-button post pull-left" id=SectionLeaderApprove data-ng-if=vm.HAVIEDZTERVJOVAHAGY data-ng-click=vm.SectionLeaderApprove() type=button translate>SectionLeaderApprove</button> <button class="cts-button post pull-left" id=vissza data-ng-click=back() type=button translate>Back</button> <button class="cts-button post pull-left" id=fileok ng-if="vm.trainingPlanId>0" data-ng-click=vm.files() type=button translate>Files</button> <button class="cts-button post pull-left" id=print data-ng-click=vm.print() type=button data-ng-show="vm.trainingPlanId>0" translate>Print</button></div><label style=margin-top:2em;>{{vm.numberOfPaintsLabel}}</label></form></div><div class=widget-foot><div class=clearfix></div></div><div id=printDialog><report report-name=THaviEdzesTervReport report-parameters=vm.reportParameters></report></div>');
$templateCache.put('app/administration/sportSpecificTest/newSportSpecificTest/newSportSpecificTest.html','<div class=widget-head><h2 class=page-title>{{title}}</h2></div><div class=widget-content><form class=filter name=form><div class=row><cts-dropdown-list name=sectionDropDown label=Section value=vm.sectionIdValue datasource=vm.sectionList databound=vm.sectionDataBound enabled=false></cts-dropdown-list><cts-dropdown-list name=ageGroupDropDown label=AgeGroup value=vm.ageGroupIdValue datasource=vm.ageGroupList databound=vm.ageGroupDataBound enabled=false></cts-dropdown-list><cts-dropdown-list name=coachDropDown label=Coach value=vm.coachIdValue datasource=vm.coachList databound=vm.coachDataBound enabled=false></cts-dropdown-list></div><div class=row><cts-dropdown-list name=felmeroTipusDropDown label=FelmeroTipus value=vm.felmeroElemFejIdValue datasource=vm.felmeroElemFejList databound=vm.felmeroDataBound validation-rules="{required: true}" enabled="vm.felmeroFejId<0 && !vm.test.length>0"></cts-dropdown-list><cts-date-picker name=datepicker label=Date value=vm.dateValue validation-rules="{required: true}" enabled="vm.felmeroFejId<0"></cts-date-picker><div class=button-wrapper><button class=cts-button ej-button e-click=vm.CreateTest data-ng-if=vm.createButtonEnabled translate>Create</button></div></div><div class=row><div class=button-wrapper><button class=cts-button ej-button e-click=vm.CreateTestType data-ng-if="!vm.test.length>0" translate>CreateNewSportSpecificTestTemplate</button> <button class=cts-button ej-button e-click=vm.EditTestType data-ng-if=vm.editTestTypeButtonEnabled translate>EditTestType</button></div></div><script type=text/x-template id=sstname><a data-ng-click="vm.openAthlete({{:SportoloID}})">{{:SportoloNeve}}</a></script><div style="overflow: hidden;" data-ng-show="vm.test.length>0"><cts-text-area name=coachRating label=CoachRating data-ng-model=vm.edzoertekeles css="padding-left:0; padding-right:0; width: 100%;" validation-rules="{required: false, maxlength: 200}" owndisabled=!vm.UJSPFELM></cts-text-area></div><div class=row data-ng-show="vm.test.length>0"><div id=Grid2></div><label>{{vm.cellHint}}</label></div><div class="col-sm-12 back" style="text-align: center"><button class=cts-button data-ng-if="vm.test.length>0 && vm.UJSPFELM" ej-button e-click=vm.SaveTest translate>Save</button> <button class=cts-button ej-button e-click=back translate>Back</button> <button class=cts-button data-ng-if="vm.felmeroFejId>0 && vm.UJSPFELM" ej-button e-click=vm.DeleteTest translate>Delete</button></div><div class="col-sm-12 back" style="text-align: center"><cts-check-box label=ShowColors change=vm.colorCheckBoxChange checked=vm.showColors data-ng-if="vm.felmeroFejId>0"></cts-check-box></div></form></div><div class=widget-foot><div class=clearfix></div></div>');
$templateCache.put('app/administration/sportSpecificTest/newSportSpecificTestList/newSportSpecificTestList.html','<ht-widget-header title={{title}} text-id=newSportSpecificTestListHelp right-text=rightText></ht-widget-header><div class=widget-content><form class=filter name=form><div class=row><div ng-if="vm.Highlight==-1" style="overflow: hidden;"><cts-dropdown-list name=sectionDropDown label=Section value=vm.sectionId datasource=vm.sectionList databound=vm.sectionDataBound select=vm.sectionSelect validation-rules="{required: true}"></cts-dropdown-list><cts-dropdown-list name=ageGroupDropDown label=AgeGroup value=vm.ageGroupId datasource=vm.ageGroupList databound=vm.ageGroupDataBound select=vm.ageGroupSelect validation-rules="{required: true}"></cts-dropdown-list><cts-dropdown-list name=coachDropDown label=Coach value=vm.coachId datasource=vm.coachList databound=vm.coachDataBound select=vm.coachSelect validation-rules="{required: true}"></cts-dropdown-list></div><div style="overflow: hidden;"><cts-date-picker name=datefrom label=DateFrom change=vm.dateFromChange value=vm.dateFrom validation-rules="{required: true}"></cts-date-picker><cts-date-picker name=dateto label=DateTo change=vm.dateToChange value=vm.dateTo validation-rules="{required: true}"></cts-date-picker></div><div ng-if="vm.Highlight==-1" style="overflow: hidden;"><div class=button-wrapper><button id=addFelmero class=cts-button ej-button e-click=vm.newTest translate>NewTest</button></div></div></div><script type=text/x-template id=sstlTest><a data-ng-click="vm.goToTest(${SzakosztalyId},${KorcsoportId},${EdzoId},${FelmeroElemFejId},${Id_FF})">${Datum}</a></script><script type=text/x-template id=sstlCoach><a data-ng-click="vm.goToUser(${EdzoId})">${EdzoNev}</a></script><script type=text/x-template id=sstlOpen><a data-ng-click="vm.goToTest(${SzakosztalyId},${KorcsoportId},${EdzoId},${FelmeroElemFejId},${Id_FF})"><i class="fa fa-eye" style="font-size: 1.5em;"></i></a></script><div class=row><div id=Grid name=Grid></div></div></form></div><div class=widget-foot><div class=clearfix></div></div>');
$templateCache.put('app/administration/test/newTest/newTest.html','<div class=widget-head><h2 class=page-title>{{title}}</h2></div><div class=widget-content><form class=filter name=form><div class=row><cts-date-picker name=datepicker label=TestsDate value=vm.dateValue validation-rules="{required: true}"></cts-date-picker><div class=button-wrapper><button class=cts-button ej-button e-click=vm.getTestAthletesList translate>GetAthletes</button></div></div><script type=text/x-template id=minSelect><span><b> ${if (f30mSprint1 > 0)} ${if (f30mSprint2 > 0)} ${if (f30mSprint1 < f30mSprint2)} ${if (f30mSprint3 > 0)} ${if (f30mSprint1 < f30mSprint3)} ${f30mSprint1} ${else} ${f30mSprint3} ${/if} ${else} ${f30mSprint1} ${/if} ${else} ${if (f30mSprint3 > 0)} ${if (f30mSprint2 < f30mSprint3)} ${f30mSprint2} ${else} ${f30mSprint3} ${/if} ${else} ${f30mSprint2} ${/if} ${/if} ${else} ${if (f30mSprint3 > 0)} ${if (f30mSprint1 < f30mSprint3)} ${f30mSprint1} ${else} ${f30mSprint3} ${/if} ${else} ${f30mSprint1} ${/if} ${/if} ${else} ${if (f30mSprint2 > 0)} ${if (f30mSprint3 > 0)} ${if (f30mSprint2 < f30mSprint3)} ${f30mSprint2} ${else} ${f30mSprint3} ${/if} ${else} ${f30mSprint2} ${/if} ${else} ${if (f30mSprint3 > 0)} ${f30mSprint3} ${else} 0 ${/if} ${/if} ${/if} </b></span></script><script type=text/x-template id=maxSelect><span><b> ${if (sulypontEmelkedes1 > 0)} ${if (sulypontEmelkedes2 > 0)} ${if (sulypontEmelkedes1 > sulypontEmelkedes2)} ${if (sulypontEmelkedes3 > 0)} ${if (sulypontEmelkedes1 > sulypontEmelkedes3)} ${else} ${sulypontEmelkedes3} ${/if} ${else} ${sulypontEmelkedes1} ${/if} ${else} ${if (sulypontEmelkedes3 > 0)} ${if (sulypontEmelkedes2 > sulypontEmelkedes3)} ${sulypontEmelkedes2} ${else} ${sulypontEmelkedes3} ${/if} ${else} ${sulypontEmelkedes2} ${/if} ${/if} ${else} ${if (sulypontEmelkedes3 > 0)} ${if (sulypontEmelkedes1 > sulypontEmelkedes3)} ${sulypontEmelkedes1} ${else} ${sulypontEmelkedes3} ${/if} ${else} ${sulypontEmelkedes1} ${/if} ${/if} ${else} ${if (sulypontEmelkedes2 > 0)} ${if (sulypontEmelkedes3 > 0)} ${if (sulypontEmelkedes2 > sulypontEmelkedes3)} ${sulypontEmelkedes2} ${else} ${sulypontEmelkedes3} ${/if} ${else} ${sulypontEmelkedes2} ${/if} ${else} ${if (sulypontEmelkedes3 > 0)} ${sulypontEmelkedes3} ${else} 0 ${/if} ${/if} ${/if} </b></span></script><script type=text/x-template id=newtestcolumnTemplate1><a data-ng-click="vm.goToAthlete(${sportoloId})">${sportoloNeve}</a></script><div class=row><div id=Grid class=slim-grid></div></div><div class="col-sm-12 back" style="text-align: center"><button class=cts-button ej-button e-click=vm.saveGrid translate>Save</button><button class=cts-button ej-button e-click=back translate>Back</button></div></form></div><div class=widget-foot><div class=clearfix></div></div>');
$templateCache.put('app/administration/test/testList/testList.html','<div class=widget-head><h2 class=page-title>{{title}}</h2></div><div class=widget-content><form class=filter name=form><div class=row><cts-dropdown-list name=testDates label=testDates value=vm.testDateValue datasource=vm.testDates databound=vm.testDatesDataBound select=vm.testDatesSelect validation-rules="{required: true}"></cts-dropdown-list><div class=button-wrapper><button class=cts-button ej-button e-click=vm.getTest translate>Open</button> <button class=cts-button ej-button e-click=vm.newTest translate>NewTest</button></div></div></form></div><div class=widget-foot><div class=clearfix></div></div>');
$templateCache.put('app/administration/test/testResults/testResults.html','<ht-widget-header title={{title}} text-id=testResultsHelp right-text=rightText></ht-widget-header><div class=widget-content><form class=filter name=form><div class=row><cts-date-picker name=datepicker label=Date value=vm.dateValue enabled=vm.enabledDatepicker validation-rules="{required: true}"></cts-date-picker></div><script type=text/x-template id=minSelect><span><b> ${if (f30mSprint1 > 0)} ${if (f30mSprint2 > 0)} ${if (f30mSprint1 < f30mSprint2)} ${if (f30mSprint3 > 0)} ${if (f30mSprint1 < f30mSprint3)} ${f30mSprint1} ${else} ${f30mSprint3} ${/if} ${else} ${f30mSprint1} ${/if} ${else} ${if (f30mSprint3 > 0)} ${if (f30mSprint2 < f30mSprint3)} ${f30mSprint2} ${else} ${f30mSprint3} ${/if} ${else} ${f30mSprint2} ${/if} ${/if} ${else} ${if (f30mSprint3 > 0)} ${if (f30mSprint1 < f30mSprint3)} ${f30mSprint1} ${else} ${f30mSprint3} ${/if} ${else} ${f30mSprint1} ${/if} ${/if} ${else} ${if (f30mSprint2 > 0)} ${if (f30mSprint3 > 0)} ${if (f30mSprint2 < f30mSprint3)} ${f30mSprint2} ${else} ${f30mSprint3} ${/if} ${else} ${f30mSprint2} ${/if} ${else} ${if (f30mSprint3 > 0)} ${f30mSprint3} ${else} 0 ${/if} ${/if} ${/if} </b></span></script><script type=text/x-template id=maxSelect><span><b> ${if (sulypontEmelkedes1 > 0)} ${if (sulypontEmelkedes2 > 0)} ${if (sulypontEmelkedes1 > sulypontEmelkedes2)} ${if (sulypontEmelkedes3 > 0)} ${if (sulypontEmelkedes1 > sulypontEmelkedes3)} ${else} ${sulypontEmelkedes3} ${/if} ${else} ${sulypontEmelkedes1} ${/if} ${else} ${if (sulypontEmelkedes3 > 0)} ${if (sulypontEmelkedes2 > sulypontEmelkedes3)} ${sulypontEmelkedes2} ${else} ${sulypontEmelkedes3} ${/if} ${else} ${sulypontEmelkedes2} ${/if} ${/if} ${else} ${if (sulypontEmelkedes3 > 0)} ${if (sulypontEmelkedes1 > sulypontEmelkedes3)} ${sulypontEmelkedes1} ${else} ${sulypontEmelkedes3} ${/if} ${else} ${sulypontEmelkedes1} ${/if} ${/if} ${else} ${if (sulypontEmelkedes2 > 0)} ${if (sulypontEmelkedes3 > 0)} ${if (sulypontEmelkedes2 > sulypontEmelkedes3)} ${sulypontEmelkedes2} ${else} ${sulypontEmelkedes3} ${/if} ${else} ${sulypontEmelkedes2} ${/if} ${else} ${if (sulypontEmelkedes3 > 0)} ${sulypontEmelkedes3} ${else} 0 ${/if} ${/if} ${/if} </b></span></script><script type=text/x-template id=testresultscolumnTemplate1><a data-ng-click="vm.goToAthlete(${sportoloId})">${sportoloNeve}</a></script><div class=row><div id=Grid name=Grid></div></div><div class="col-sm-12 back" style="text-align: center"><button class=cts-button ej-button e-click=vm.saveGrid translate>Save</button><button class=cts-button ej-button e-click=back translate>Back</button></div></form></div><div class=widget-foot><div class=clearfix></div></div>');
$templateCache.put('app/administration/trainingPlan/trainingPlanCreate/trainingPlanCreate.html','<ht-widget-header title={{title}} text-id=trainingPlanCreateHelp right-text=rightText></ht-widget-header><div class="widget-content form"><div class=col-lg-8><form novalidate id=form name=form enctype=multipart/form-data><cts-dropdown-list name=trainingSectionDropDown label=Section value=vm.trainingSectionId datasource=vm.trainingSectionList databound=vm.trainingSectionDataBound select=vm.trainingSectionSelect enabled=vm.allowSave></cts-dropdown-list><cts-dropdown-list name=trainingAgeGroupDropDown label=AgeGroup value=vm.trainingAgeGroupId datasource=vm.trainingAgeGroupList databound=vm.trainingAgeGroupDataBound select=vm.trainingAgeGroupSelect enabled=vm.allowSave></cts-dropdown-list><cts-text-box name=TrainingName label=TrainingName ng-model=vm.trainingName validation-rules="{required: true, maxlength: 50}" owndisabled=!vm.allowSave></cts-text-box><cts-text-box name=TrainingDescription label=Description ng-model=vm.trainingDescription owndisabled=!vm.allowSave></cts-text-box><cts-check-box name=Public label=Public checked=vm.public enabled=vm.allowSave></cts-check-box><div class="cts-form-group gorm-group"><label translate>TrainingTimeLength</label><div><p>{{vm.timeLength}}</p></div></div></form></div><div class=col-md-12><div id=MainGrid name=MainGrid></div><h3 style="text-align: center" translate>TrainingSearch</h3><form class=filter name=Form2><cts-dropdown-list name=sectionDropDown label=Section value=vm.sectionId datasource=vm.sectionList databound=vm.sectionDataBound select=vm.sectionSelect></cts-dropdown-list><cts-dropdown-list name=ageGroupDropDown label=AgeGroup value=vm.ageGroupId datasource=vm.ageGroupList databound=vm.ageGroupDataBound select=vm.ageGroupSelect></cts-dropdown-list><cts-dropdown-list name=coachDropDown label=Coach value=vm.coachId datasource=vm.coachList databound=vm.coachDataBound select=vm.coachSelect></cts-dropdown-list><cts-auto-complete name=BodyParts label=BodyParts value=vm.bodyPartValue validation-rules="{required: false}" datasource=vm.autoComplete.Testresz multi-select=true show-popup-button=true></cts-auto-complete><cts-auto-complete name=ExercisesType label=Type value=vm.TypeValue validation-rules="{required: false}" datasource=vm.autoComplete.Tipus multi-select=true show-popup-button=true></cts-auto-complete><cts-auto-complete name=individualTeam label=individualTeam value=vm.individualTeamValue validation-rules="{required: false}" datasource=vm.autoComplete.Jellege multi-select=true show-popup-button=true></cts-auto-complete><cts-auto-complete name=ExercisesAsset label=Assets value=vm.AssetValue validation-rules="{required: false}" datasource=vm.autoComplete.Felszerelesek multi-select=true show-popup-button=true></cts-auto-complete><cts-auto-complete name=Difficulty label=Difficulty value=vm.difficultyValue validation-rules="{required: false}" datasource=vm.autoComplete.Nehezseg multi-select=true show-popup-button=true></cts-auto-complete><cts-auto-complete name=Time label=TimeLength value=vm.timeValue validation-rules="{required: false}" datasource=vm.autoComplete.Ido multi-select=true show-popup-button=true></cts-auto-complete><cts-auto-complete name=NecessaryArea label=Space value=vm.necessaryAreaValue validation-rules="{required: false}" datasource=vm.autoComplete.SzuksegesTerulet multi-select=true show-popup-button=true></cts-auto-complete><cts-check-box name=Video label=Video checked=vm.withVideo></cts-check-box><cts-check-box name=Pattern label=Pattern checked=vm.withPattern></cts-check-box><cts-check-box name=Paint label=Paint checked=vm.withPaint></cts-check-box></form><div id=TrainingGrid name=TrainingGrid class=slim-grid></div><div class=button-wrapper style="margin-top: 1em"><button id=lekeres class=cts-button ej-button e-click=vm.showExercises translate>Show</button> <button id=add class=cts-button ej-button e-enabled=vm.addEnabled e-click=vm.addRow translate>AddSelected</button> <button ej-button e-enabled=vm.addNewPermission class=cts-button e-click=vm.createNewTrainingPlan translate>NewTrainingPlan</button></div><div class=row><div class=col-lg-12 style="text-align: center; margin: 1em"><button type=submit class=cts-button ej-button e-click=vm.save e-enabled=vm.allowSave form=form translate>Save</button> <button type=reset class=cts-button ej-button e-click=back translate>Back</button></div></div><script id=imagetemplateGrid type=text/x-handlebars-template><div height="64px" max-width="64px" class="thumbnail-item" href="${Mintakep}"><img src="${Mintakep}" align="center" height="64px" max-width="64px"/></div></script><script type=text/x-template id=wtpropentemp><div><a data-ng-click="vm.openTemplate(${GyakorlatId})">${Nev}</a></div></script></div></div><div class=widget-foot><div class=clearfix></div></div>');
$templateCache.put('app/administration/trainingPlan/trainingPlanList/trainingPlanList.html','<div class=widget-head><h2 class=page-title>{{title}}</h2></div><div class=widget-content><div class=row><form class=filter><cts-dropdown-list name=sectionDropDown label=Section value=vm.sectionId datasource=vm.sectionList databound=vm.sectionDataBound select=vm.sectionSelect></cts-dropdown-list><cts-dropdown-list name=ageGroupDropDown label=AgeGroup value=vm.ageGroupId datasource=vm.ageGroupList databound=vm.ageGroupDataBound select=vm.ageGroupSelect></cts-dropdown-list><cts-dropdown-list name=coachDropDown label=Coach value=vm.coachId datasource=vm.coachList databound=vm.coachDataBound select=vm.coachSelect></cts-dropdown-list><div class=button-wrapper><button class=cts-button ej-button e-click=vm.search translate>Search</button></div></form><div id=Grid name=Grid></div><div class=col-xs-12><hr><button ej-button e-enabled=vm.addNewPermission class=cts-button e-height=34px e-click=vm.createNewTrainingPlan translate>New</button> <button e-enabled=vm.deletePermission ej-button class=cts-button e-height=34px e-click=vm.deleteTrainingPlan translate>Delete</button></div></div><script id=wtro type=text/x-template><a data-ng-click="vm.openTrainingPlan(${EdzesFejId})"><i class="fa fa-eye" style="font-size: 1.5em;"></i></a></script><script id=imagetemplateGrid type=text/x-handlebars-template><div height="64px" max-width="64px" class="thumbnail-item" href="${Mintakep}" ><img src="${Mintakep}" align="center" height="64px" max-width="64px"/></div></script><script type=text/x-template id=wtpropentemp><div><a data-ng-click="vm.openTemplate(${GyakorlatId})">${Nev}</a></div></script></div><div class=widget-foot><div class=clearfix></div></div>');
$templateCache.put('app/administration/weeklyTrainingPlan/weeklyTrainingPlanList/weeklyTrainingPlanList.html','<ht-widget-header title={{title}} text-id=weeklyTrainingPlanListHelp right-text=rightText></ht-widget-header><div class=widget-content><form name=form class=filter><div style="overflow: hidden"><cts-dropdown-list name=maEdzo label=Coach value=vm.selectedCoach datasource=vm.coachList select=vm.coachChanged databound=vm.coachDataBound validation-rules="{required: true}"></cts-dropdown-list><cts-dropdown-list name=maSzakosztaly label=Section value=vm.selectedSection datasource=vm.sectionList databound=vm.sectionDataBound select=vm.sectionChanged validation-rules="{required: true}"></cts-dropdown-list><cts-dropdown-list name=maKorosztaly label=AgeGroup value=vm.selectedAgeGroup datasource=vm.ageGroupList databound=vm.ageGroupDataBound select=vm.ageGroupChanged validation-rules="{required: true}"></cts-dropdown-list><cts-dropdown-list name=maEv label=Year datasource=vm.years select=vm.yearChanged></cts-dropdown-list><cts-text-box name=txTartalom label=textSearch ng-model=vm.textSearch></cts-text-box><div class=button-wrapper><button type=submit e-height=34px ej-button class=cts-button data-ng-click=vm.refreshData() translate>Keres</button></div></div></form><div id=Grid name=Grid></div><div class=col-xs-12><hr><button class=cts-button e-height=34px ej-button data-ng-click=vm.createNewWeeklyTrainingPlan() translate>New</button> <button data-ng-disabled=!vm.delEnabled class=cts-button e-height=34px ej-button data-ng-click=vm.deleteWeeklyTrainingPlan() e-enabled=vm.delEnabled translate>Delete</button> <button class=cts-button e-height=34px ej-button data-ng-click=back() translate>Close</button></div></div><div class=widget-foot><div class=clearfix></div></div><script id=wetrpllitemplateDataColumn1 type=text/x-template><a data-ng-click="vm.goToNewUser(${IdEdzo})">${Edzo}</a></script><script id=wetrpllitemplateDataColumn2 type=text/x-template><a data-ng-click="vm.goToNewAgeGroup(${IdKorosztaly})">${Korosztaly}</a></script><script id=wetrpllitemplateDataColumn3 type=text/x-template><a data-ng-click="vm.goToWeeklyTrainingPlan(${Id})"><i class="fa fa-eye" style="font-size: 1.5em;"></i></a></script><script id=wetrpllitemplateDataColumn4 type=text/x-template><input data-ng-if="\'${Jovahagyott}\' === \'true\'" type="checkbox" checked="checked" disabled/> <input data-ng-if="\'${Jovahagyott}\' !== \'true\'" type="checkbox" disabled/></script>');
$templateCache.put('app/administration/trainingPlan/trainingPlanTemplate/trainingPlanTemplate.html','<div class=widget-head><h2 class=page-title>{{title}}</h2></div><div class=widget-content><form name=form class=form novalidate enctype=multipart/form-data><div class=col-lg-8><cts-dropdown-list name=trainingSectionDropDown label=Section value=vm.trainingSectionId datasource=vm.trainingSectionList databound=vm.trainingSectionDataBound select=vm.trainingSectionSelect enabled=false></cts-dropdown-list><cts-dropdown-list name=trainingAgeGroupDropDown label=AgeGroup value=vm.trainingAgeGroupId datasource=vm.trainingAgeGroupList databound=vm.trainingAgeGroupDataBound select=vm.trainingAgeGroupSelect enabled=false></cts-dropdown-list><cts-text-box name=TrainingName label=TrainingName ng-model=vm.trainingName validation-rules="{required: true}" disabled=true></cts-text-box><cts-text-box name=TrainingDescription label=Description ng-model=vm.trainingDescription disabled=true></cts-text-box><cts-check-box name=Public label=Public checked=vm.public enabled=false></cts-check-box><div class="cts-form-group gorm-group"><label translate>TrainingTimeLength</label><div><p>{{vm.timeLength}}</p></div></div></div></form><script id=imagetemplateGrid type=text/x-handlebars-template><div height="64px" max-width="64px" class="thumbnail-item" href="${Mintakep}"><img src="${Mintakep}" align="center" height="64px" max-width="64px"/></div></script><script type=text/x-template id=wtpropentemp><div><a data-ng-click="vm.openTemplate(${GyakorlatId})">${Nev}</a></div></script><div class="panel-body col-lg-12"><div id=GridTraining name=GridTraining></div></div><div class=row><div class=col-lg-12 style="text-align: center; margin: 1em"><button type=reset class=cts-button ej-button e-click=back translate>Back</button></div></div></div><div class=widget-foot><div class=clearfix></div></div>');
$templateCache.put('app/administration/weeklyTrainingPlan/weeklyTrainingPlanReport/weeklyTrainingPlanReport.html','<div class=widget-head><h2 class=page-title>{{title}}</h2></div><div id=popup><div id=searchWindow ej-dialog e-height=435px e-minheight=435px e-maxheight=435px e-minwidth=600px e-title="Kor\xE1bbi heti edz\xE9s terv m\xE1sol\xE1sa" e-showoninit=false e-enablemodal=true e-enableresize=false e-allowkeyboardnavigation=false e-closeonescape=true e-isresponsive=true e-content=#popup e-enableanimation=true e-width=60% e-showroundedcorner=false><div class=col-md-12><div class=text-center><div id=GridPopup name=GridPopup></div><div class=form-group style="margin-top: 20px"><button class="cts-button post" id=cancel data-ng-click=vm.closeEarlierWeeklyPlanWindow() type=button translate>Cancel</button> <button class="cts-button post" id=done data-ng-click=vm.selectEarlierWeeklyPlanWindow() type=button translate>Rendben</button></div></div></div></div></div><div class=widget-content><form name=form class=filter><div style="overflow: hidden;"><cts-text-box name=txEdzo label=Coach ng-model=vm.editedWTP.EdzoNev owndisabled=true></cts-text-box><cts-text-box name=txSzakosztaly label=Section ng-model=vm.editedWTP.SzakosztalyNev owndisabled=true></cts-text-box><cts-text-box name=txKorosztaly label=AgeGroup ng-model=vm.editedWTP.KorosztalyNev owndisabled=true></cts-text-box><cts-text-box name=txEv label=Made ng-model=vm.editedWTP.Keszult owndisabled=true></cts-text-box></div><hr><div style="overflow: hidden;"><cts-date-picker name=deHetfo label=Monday value=vm.editedWTP.Hetfo enabled=!vm.JOVAHAGYOTT validation-rules="{required: true}" change=vm.MondayChange></cts-date-picker><cts-text-box name=deVasarnap label=Sunday ng-model=vm.editedWTP.Vasarnap owndisabled=true></cts-text-box><cts-numeric-text-box name=txMakrociklus label=Makrociklus value=vm.editedWTP.Makrociklus enabled=!vm.JOVAHAGYOTT validation-rules="{required: true}"></cts-numeric-text-box><cts-numeric-text-box name=txHetSzama label=FelkHetSzam value=vm.editedWTP.HetSzama enabled=!vm.JOVAHAGYOTT validation-rules="{required: true}"></cts-numeric-text-box></div><hr><label translate>NAPDATUMEDZESTERV</label><div class=container-fluid><div class=row><div style="padding: 1em;"><div style="float:left; margin-bottom:15px;"><button type=button class=cts-button ej-button e-click=vm.addNew e-enabled="vm.editEnabled == false && vm.JOVAHAGYOTT == false" id=addBtn translate>Add</button></div><div style="float:right; margin-bottom:15px;"><button ej-button class=cts-button id=korabbiMasol e-click=vm.copyFromOldPlan e-enabled="vm.JOVAHAGYOTT == false" type=button translate>OlderMonthlyCompetitveReports</button></div></div></div><script type=text/x-template id=wtpropentemp><a data-ng-click="vm.openTemplate({{:EdzesFejId}})">{{:Sablon}}</a></script><div id=Grid name=Grid></div></div><div class=container-fluid ng-show=vm.editEnabled><hr><label translate>TrainingDetails</label><div class=row style="padding: 2em 0;"><div class=col-md-3 style=margin-top:-14px;><div style="margin-top: 1em;"><div><label translate>Days</label><div ng-if=!vm.JOVAHAGYOTT><input ej-dropdownlist id=Napok e-value=vm.edit.NapSzam e-datasource=vm.days e-databound=vm.NapokDataBound e-select=vm.NapSelect e-width=100%></div><div ng-if=vm.JOVAHAGYOTT><input ej-dropdownlist id=Napok e-value=vm.edit.NapSzam e-datasource=vm.days e-databound=vm.NapokDataBound e-select=vm.NapSelect e-enabled=false e-width=100%></div></div></div><div style="margin-top: 1em;"><label translate>Place</label> <input id=Hely class=form-control type=text data-ng-model=vm.edit.Hely e-width=100% ng-if=!vm.JOVAHAGYOTT> <input class=form-control type=text data-ng-model=vm.edit.Hely e-width=100% ng-if=vm.JOVAHAGYOTT disabled></div><div style="margin-top: 1em;"><label translate>From</label><div ng-if=!vm.JOVAHAGYOTT><input id=Tol ej-timepicker e-timeformat=HH:mm e-value=vm.edit.Tol e-width=100%></div><div ng-if=vm.JOVAHAGYOTT><input class=form-control type=text data-ng-model=vm.edit.Tol e-width=100% disabled></div></div><div style="margin-top: 1em;"><label translate>To</label><div ng-if=!vm.JOVAHAGYOTT><input id=Ig ej-timepicker e-timeformat=HH:mm e-value=vm.edit.Ig e-width=100%></div><div ng-if=vm.JOVAHAGYOTT><input class=form-control type=text data-ng-model=vm.edit.Ig e-width=100% disabled></div></div></div><div class=col-md-3><label translate>Map</label><iframe id=map style=width:100%;height:15em; frameborder=0 scrolling=no marginheight=0 marginwidth=0 ng-src={{vm.Helyek}}></iframe></div><div class=col-md-6><label translate>Description</label><div ng-if=!vm.JOVAHAGYOTT><textarea rows=10 style=resize:none; class="form-control textarea" data-ng-model=vm.edit.Leiras></textarea></div><div ng-if=vm.JOVAHAGYOTT><textarea rows=10 style=resize:none; class="form-control textarea" data-ng-model=vm.edit.Leiras disabled></textarea></div></div></div><div ng-if="vm.edit.EdzesFejId>0"><label translate>OpenTrainingTemplate</label><a style=margin-left:7px; ng-click=vm.openTemplate()>{{vm.edit.Sablon}}</a></div><div class=row><div style="padding: 1em;"><button type=button class=cts-button ej-button e-click=vm.ok id=ok e-enabled="vm.JOVAHAGYOTT == false" translate>Ok</button> <button type=button class=cts-button ej-button e-click=vm.cancel id=cancel translate>Cancel</button> <button type=button class=cts-button ej-button e-click=vm.del e-enabled=vm.deleteBtnEnabled id=deleteBtn translate>Delete</button> <button type=button class=cts-button ej-button e-click=vm.chooseTraining e-enabled="vm.JOVAHAGYOTT == false" id=ct name=ct translate>ChooseTraining</button> <button type=button class=cts-button ej-button e-click=vm.claimAsset id=ca e-enabled=vm.caBtnEnabled translate>ClaimAsset</button></div></div><hr></div><div class=row><hr><label translate>AthletesOnWeeklyPlan</label><div style="padding: 1em;"><button type=button class=cts-button ej-button e-click=vm.selectAll id=selectAll e-enabled="vm.JOVAHAGYOTT == false" translate>SelectAll</button> <button type=button class=cts-button ej-button e-click=vm.deleteSelection id=unselectAll e-enabled="vm.JOVAHAGYOTT == false" translate>UnselectAll</button></div><cts-list-box name=athletesList label=Athletes css-class=scroller-fix datasource=vm.athletes show-checkbox=true check-change=vm.athletesChange checkedindices=vm.checkedIndices height=vm.athleteListHeight enabled=!vm.JOVAHAGYOTT style="width: 100%;"></cts-list-box><hr></div><p data-ng-if=vm.JOVAHAGYOTT translate>WeeklyTraningPlanApproved</p><div class=form-group><button class="cts-button post left-padding" id=mentes data-ng-disabled=vm.JOVAHAGYOTT data-ng-click=vm.save(false) type=button translate>Save</button> <button class="cts-button post left-padding" id=SectionLeaderApprove data-ng-if=vm.HETIEDZTERVJOVAHAGY data-ng-click=vm.SectionLeaderApprove() type=button translate>SectionLeaderApprove</button> <button class="cts-button post left-padding" id=vissza data-ng-click=vm.back() type=button translate>Back</button> <button class="cts-button post left-padding" id=fileok ng-if="vm.trainingPlanId>0" data-ng-click=vm.files() type=button translate>Files</button> <button class="cts-button post left-padding" id=print data-ng-click=vm.print() type=button data-ng-show="vm.trainingPlanId>0" translate>Print</button></div></form></div><div class=widget-foot><div class=clearfix></div></div><div id=printDialog><report report-name=THetiEdzesTerv report-parameters=vm.reportParameters></report></div><div id=printDialog2><report report-name=TEszkozIgenyek report-parameters=vm.reportParameters2></report></div><script>\r\n    var searchBox = undefined;\r\n\r\n    function initAutocomplete() {\r\n        console.log(\'initAutocomplete\');\r\n        searchBox = new google.maps.places.SearchBox(document.getElementById(\'Hely\'));\r\n        searchBox.addListener(\'places_changed\', function () {\r\n            var places = searchBox.getPlaces();\r\n            if (places.length == 0) {\r\n                return;\r\n            }\r\n            console.log(\'places\',places);\r\n            var name;\r\n            if (places[0].url)\r\n            {\r\n                document.getElementById(\'map\').src = places[0].url + \'&output=embed\';\r\n            } else {\r\n                name = places[0].name;\r\n                document.getElementById(\'map\').src = \'https://maps.google.com/?q=\' + name + \'&output=embed\';\r\n            }\r\n            console.log(\'name\',name);\r\n            if (name) {\r\n                $(\'#Hely\').val(name);\r\n            }\r\n        });\r\n    }\r\n</script><script src="https://maps.googleapis.com/maps/api/js?key=AIzaSyBqa3knjWCrkKD0OS3XIBNlPanwR2Z8cP8&libraries=places&callback=initAutocomplete" async defer></script><div id=popup2><div id=ChooseTrainingWindow ej-dialog e-height=635px e-minheight=635px e-maxheight=635px e-title="Edz\xE9s sablon v\xE1laszt\xE1sa" e-showoninit=false e-enablemodal=true e-backgroundscroll=true e-enableresize=true e-allowkeyboardnavigation=true e-closeonescape=true e-isresponsive=true e-content=#popup2 e-enableanimation=true e-width=800px e-showroundedcorner=false e-target=.widget-content><div class=row><div class=col-sm-12 style=margin-bottom:15px;><label translate>EdzesSablonok</label> <input id=TrainingTemplate ej-autocomplete></div></div><div class=row><div class=col-md-8><label translate>EdzesTetelek</label><div id=GridEdzesTetelek name=GridEdzesTetelek></div></div><div class=col-md-4><label translate>Description</label> <textarea rows=5 style=resize:none; class="form-control textarea" data-ng-model=vm.EdzesTetelLeiras disabled></textarea></div></div><div class=form-group style="margin-top: 10px"><button class=cts-button id=cancel data-ng-click=vm.chooseTrainingCancel() type=button translate>Cancel</button> <button class=cts-button id=cancel data-ng-click=vm.createTrainingTemplate() type=button translate>CreateTrainingTemplate</button> <button class=cts-button id=done data-ng-click="vm.chooseTrainingAccept(\'copy\')" type=button ng-if="vm.editedWTP.Id > 0" translate>AcceptCopy</button> <button class=cts-button id=done data-ng-click="vm.chooseTrainingAccept(\'append\')" type=button translate>AcceptAppend</button></div></div></div>');
$templateCache.put('app/athletes/ageGroups/addAgeGroup/addAgeGroup.html','<div class=widget-head><h2 class=page-title>{{title}}</h2></div><div class="widget-content form"><form novalidate name=form enctype=multipart/form-data><div class=row><div class=col-lg-8><cts-dropdown-list name=sectionDropDown label=Section value=vm.formData.SectionId datasource=vm.sectionList databound=vm.sectionDataBound select=vm.sectionSelect validation-rules="{required: true}"></cts-dropdown-list><cts-text-box name=ageGroupName label=AgeGroup data-ng-model=vm.formData.AgeGroupName validation-rules="{required: true}"></cts-text-box><cts-dropdown-list name=yearFromDropDown label=yearFrom value=vm.formData.SelectedYearFrom datasource=vm.yearList change=vm.yearFromDropDownChanged></cts-dropdown-list><cts-dropdown-list name=yearToDropDown label=yearTo value=vm.formData.SelectedYearTo datasource=vm.yearListTo change=vm.yearToDropDownChanged clear=vm.clearDropdown></cts-dropdown-list><cts-color-picker name=colorPick label=CalendarColor value=vm.formData.Color change=vm.colorChanged validation-rules="{required: true}"></cts-color-picker><cts-text-box name=comment label=Comment data-ng-model=vm.formData.Comment></cts-text-box><cts-check-box name=activeCheckBox label=ActiveAgeGroup checked=vm.formData.ActiveAgeGroup change=vm.activeCheckboxChanged></cts-check-box></div></div><div class=col-sm-12 style="text-align: center"><button type=submit class=cts-button ej-button e-click=vm.saveAgeGroup translate>Save</button> <button type=reset class=cts-button ej-button e-click=back translate>Cancel</button></div></form></div><div class=widget-foot><div class=clearfix></div></div>');
$templateCache.put('app/athletes/ageGroups/ageGroupMembersList/ageGroupMembersList.html','<div class=widget-head><h2 class=page-title>{{title}}</h2></div><div class=widget-content><form class=filter name=form><div class=row><div class=button-wrapper style="float: left;"><button class=cts-button id=addToTheNewAgeGroup ej-button e-click=vm.goToAgeGroupChange translate>ChangeAgeGroup</button></div></div></form><script id=aggrmelitemplateDataColumn1 type=text/x-template><a data-ng-click="vm.goToNewAthlete(${SportolokID})">${Nev}</a></script><script id=aggrmelitemplateDataColumn2 type=text/x-template><a data-ng-click="vm.goToNewUser(${EdzoId})">${EdzoNeve}</a></script><div class=row><div id=Grid class=slim-grid></div></div><div class="col-sm-12 back" style="text-align: center"><button type=reset class=cts-button ej-button e-click=back translate>Back</button></div></div><div class=widget-foot><div class=clearfix></div></div>');
$templateCache.put('app/athletes/ageGroups/ageGroupsList/ageGroupsList.html','<ht-widget-header title={{title}} text-id=ageGroupListHelp right-text=rightText></ht-widget-header><div class=widget-content><form class=filter name=form><div class=row><cts-dropdown-list name=sectionDropDown label=Section value=vm.sectionId datasource=vm.sectionList databound=vm.sectionDataBound select=vm.sectionSelect></cts-dropdown-list><div class=button-wrapper><button type=button class=cts-button ej-button e-click=vm.copyAllAgeGroup id=copyAllAgeGroup translate>CopyAllAgeGroup</button> <button type=button class=cts-button ej-button e-click=vm.goToAddAgeGroup id=addTeam translate>AddAgeGroup</button> <button type=button class=cts-button ej-button e-click=vm.goToModifyAgeGroupButton id=modifyAgeGroup e-enabled=vm.thereIsSelectedAgeGroup translate>ModifyAgeGroup</button> <button type=button class=cts-button ej-button e-click=vm.goToAgeGroupMembersList id=ageGroupMembersList e-enabled=vm.thereIsSelectedAgeGroup translate>MembersOfAgeGroup</button></div></div></form><script id=templateData type=text/x-template><a data-ng-click="vm.goToModifyAgeGroup(${id})">${nev}</a></script><div class=row><div id=Grid class="slim-grid no-print-first-col"></div></div></div><div class=widget-foot><div class=clearfix></div></div>');
$templateCache.put('app/athletes/ageGroups/modifyAgeGroup/modifyAgeGroup.html','<div class=widget-head><h2 class=page-title>{{title}}</h2></div><div class="widget-content form"><form novalidate name=form enctype=multipart/form-data><div class=row><div class=col-lg-8><cts-dropdown-list name=sectionDropDown label=Section value=vm.formData.sectionId datasource=vm.sectionList databound=vm.sectionDataBound select=vm.sectionSelect validation-rules="{required: true}" enabled=false></cts-dropdown-list><cts-text-box name=ageGroupName label=AgeGroup data-ng-model=vm.formData.ageGroupName validation-rules="{required: true}" owndisabled=!vm.MODKOROKEZ></cts-text-box><cts-dropdown-list name=yearFromDropDown label=yearFrom value=vm.formData.selectedYearFrom datasource=vm.yearList change=vm.yearFromDropDownChanged enabled=vm.MODKOROKEZ></cts-dropdown-list><cts-dropdown-list name=yearToDropDown label=yearTo value=vm.formData.selectedYearTo datasource=vm.yearListTo change=vm.yearToDropDownChanged enabled=vm.MODKOROKEZ clear=vm.clearDropdown></cts-dropdown-list><cts-color-picker name=colorPick label=CalendarColor value=vm.formData.color change=vm.colorChanged validation-rules="{required: true}" enabled=vm.MODKOROKEZ></cts-color-picker><cts-text-box name=comment label=Comment data-ng-model=vm.formData.comment owndisabled=!vm.MODKOROKEZ></cts-text-box><cts-check-box name=activeCheckBox label=ActiveAgeGroup checked=vm.formData.activeAgeGroup change=vm.activeCheckboxChanged enabled=vm.MODKOROKEZ></cts-check-box></div></div><div class=col-sm-12 style="text-align: center"><button type=submit class=cts-button ej-button e-click=vm.modifyAgeGroup data-ng-if=vm.MODKOROKEZ translate>Modify</button> <button type=reset class=cts-button ej-button e-click=back translate>Cancel</button></div></form></div><div class=widget-foot><div class=clearfix></div></div>');
$templateCache.put('app/athletes/athletesManagement/athleteModify/athleteModify.html','<div class=widget-head style="padding-left: 0.2em;padding-right: 0.2em;"><h2 style="text-align: center;">{{title}} <span data-ng-click=vm.openAthleteMenu() style="cursor: pointer;float: left;"><span style="float: left;"><div id=AthleteMenuButton class="hamburger hamburger--spring"><span class=hamburger-box><span class=hamburger-inner></span></span></div></span> <span style="float: left;">Men\xFC</span></span> <span data-ng-click=vm.openPrintMenu() style="cursor: pointer;float: right;"><img src=images/print.png style="width: 27px; margin-right: 0.75em; float: right"></span></h2></div><div id=athleteModifyWidgetContent class="widget-content form"><div id=athleteMenu data-ng-class="{\'is-activate\': vm.athleteMenuOpened}"><ul><li data-ng-repeat="item in vm.athleteMenuItems" id={{item.name}} data-ng-if="item.enabled == true"><a data-ng-click=vm.openAthletePage(item) data-ng-class="{disabled: item.enabled === false}">{{item.name}}</a></li></ul></div><div id=printMenu data-ng-class="{\'is-activate\': vm.printMenuOpened}"><ul><li data-ng-repeat="item in vm.printMenuItems" id={{item.name}}><a data-ng-click=vm.printPage(item) data-ng-class="{disabled: item.enabled === false}">{{item.name}}</a></li></ul></div><div ui-view style="min-height: 700px;"></div></div><div class=widget-foot><div class=clearfix></div></div><div id=printDialogDatasheet><report report-name=TSportoloAdatlapNyomtatasReport report-parameters=vm.reportParameters></report></div><div id=printDialogSchoolRequesting><report report-name=TIskolaiKikeroReport report-parameters=vm.reportParametersSchoolRequesting></report></div><div id=printDialogHealth><report report-name=TEgeszseg report-parameters=vm.reportParametersEgeszsegProfil></report></div>');
$templateCache.put('app/athletes/athletesManagement/athleteNew/athleteNew.html','<div class=widget-head><h2>{{title}}</h2></div><div class="widget-content form"><form name=form novalidate enctype=multipart/form-data prevent-enter-submit><div class=row><div class=col-lg-12><div ej-accordion e-enablemultipleopen=true e-selecteditems=vm.selectedItems id=accordion name=accordion><h3><a href=# translate>AthleteDatasheet</a></h3><fieldset class=col-lg-8><cts-text-box name=name label=Name data-ng-model=vm.athleteData.Nev validation-rules="{required: true, minlength: 5, maxlength: 80}"></cts-text-box><cts-dropdown-list name=gender label=Sex value=vm.athleteData.Neme datasource=vm.sexList select=vm.sexSelect validation-rules="{required: true}"></cts-dropdown-list><div class="form-group cts-form-group"><label translate>profilePic</label><div><div class=profileImg><img ng-src={{vm.displayPhoto}} id=profilePic><div style="position: relative;"><button class=cts-button type=button data-ng-click=vm.openCropDialog() translate>Modify</button> <button class="cts-button cancel" type=button data-ng-click=vm.deleteImg() data-ng-disabled="vm.photoUrl === vm.noImage" translate>Delete</button></div></div></div></div><div class="form-group cts-form-group"><label for=sectionValue>{{"Section"|translate}}</label> <label id=sectionValue style="text-align: left; padding-left: 12px">{{vm.athleteData.SzakosztalyNev}}</label></div><cts-dropdown-list name=ageGroupDropDown label=AgeGroup value=vm.athleteData.Korcsoport datasource=vm.ageGroupList databound=vm.ageGroupDataBound validation-rules="{required: true}" select=vm.ageGroupSelect></cts-dropdown-list><cts-dropdown-list name=coachName label=CoachName value=vm.athleteData.JelenlegiEdzo datasource=vm.coachList select=vm.coachSelect databound=vm.coachDropDownListDataBound validation-rules="{required: true}"></cts-dropdown-list><cts-dropdown-list name=secondSectionDropDown label=SecondSection value=vm.athleteData.MasodlagosSzakosztaly datasource=vm.secondSectionList databound=vm.secondSelectedSectionId validation-rules="{required: false}" clear=vm.clearSecondSection enabled=vm.ADMIN select=vm.secondSectionSelect></cts-dropdown-list><cts-dropdown-list name=secondAgeGroupDropDown label=SecondAgeGroup value=vm.athleteData.MasodlagosKorcsoport datasource=vm.secondAgeGroupList databound=vm.secondAgeGroupDataBound validation-rules="{required: false}" clear=vm.clearSecondAgeGroup enabled=vm.ADMIN select=vm.secondAgeGroupSelect></cts-dropdown-list><cts-dropdown-list name=secondCoachName label=SecondCoachName value=vm.athleteData.MasodlagosEdzo datasource=vm.secondCoachList select=vm.secondCoachSelect databound=vm.secondCoachDropDownListDataBound clear=vm.clearSecondCoach enabled=vm.ADMIN validation-rules="{required: false}"></cts-dropdown-list><cts-text-box name=bpcountry label=BirthPlaceCountry cts-placeholder=BirthPlaceCountry data-ng-model=vm.athleteData.SzuletesiHelyOrszag validation-rules="{required: true}"></cts-text-box><cts-text-box name=bpcity label=BirthPlaceCity cts-placeholder=BirthPlaceCity data-ng-model=vm.athleteData.SzuletesiHelyVaros validation-rules="{required: true}"></cts-text-box><cts-date-picker name=birthDate label=BirthDate value=vm.athleteData.SzuletesiIdo validation-rules="{required: true}"></cts-date-picker><cts-text-box name=motherBirthName data-ng-if=!vm.athleteRequiredMinimumDatas label=MotherBirthName data-ng-model=vm.athleteData.AnyjaLeanykoriNeve validation-rules="{required: true, minlength: 5, maxlength: 30}"></cts-text-box><cts-text-box name=motherBirthName data-ng-if=vm.athleteRequiredMinimumDatas label=MotherBirthName data-ng-model=vm.athleteData.AnyjaLeanykoriNeve validation-rules="{required: false, maxlength: 30}"></cts-text-box><cts-text-box name=citizenship data-ng-if=!vm.athleteRequiredMinimumDatas label=Citizenship data-ng-model=vm.athleteData.Allampolgarsag validation-rules="{required: true}"></cts-text-box><cts-text-box name=citizenship data-ng-if=vm.athleteRequiredMinimumDatas label=Citizenship data-ng-model=vm.athleteData.Allampolgarsag validation-rules="{required: false}"></cts-text-box><cts-numeric-text-box name=athleteHeightDropDown data-ng-if=!vm.athleteRequiredMinimumDatas label=Height value=vm.athleteData.Testmagassag validation-rules="{required: true, minlength: 1}"></cts-numeric-text-box><cts-numeric-text-box name=athleteHeightDropDown data-ng-if=vm.athleteRequiredMinimumDatas label=Height value=vm.athleteData.Testmagassag validation-rules="{required: false}"></cts-numeric-text-box><cts-numeric-text-box name=athleteWeightDropDown data-ng-if=!vm.athleteRequiredMinimumDatas label=Weight value=vm.athleteData.Testsuly validation-rules="{required: true, minlength: 1}"></cts-numeric-text-box><cts-numeric-text-box name=athleteWeightDropDown data-ng-if=vm.athleteRequiredMinimumDatas label=Weight value=vm.athleteData.Testsuly validation-rules="{required: false}"></cts-numeric-text-box><cts-dropdown-list name=betterHandDropDown data-ng-if=!vm.athleteRequiredMinimumDatas label=BetterHand value=vm.athleteData.UgyesebbKezB datasource=vm.betterHandList select=vm.betterHandSelect validation-rules="{required: true}"></cts-dropdown-list><cts-dropdown-list name=betterHandDropDown data-ng-if=vm.athleteRequiredMinimumDatas label=BetterHand value=vm.athleteData.UgyesebbKezB datasource=vm.betterHandList select=vm.betterHandSelect validation-rules="{required: false}"></cts-dropdown-list><cts-dropdown-list name=betterFoot data-ng-if=!vm.athleteRequiredMinimumDatas label=BetterFoot value=vm.athleteData.UgyesebbLabB datasource=vm.betterFootList select=vm.betterFootSelect validation-rules="{required: true}"></cts-dropdown-list><cts-dropdown-list name=betterFoot data-ng-if=vm.athleteRequiredMinimumDatas label=BetterFoot value=vm.athleteData.UgyesebbLabB datasource=vm.betterFootList select=vm.betterFootSelect validation-rules="{required: false}"></cts-dropdown-list><cts-date-picker name=startSportDate data-ng-if=!vm.athleteRequiredMinimumDatas value=vm.athleteData.VersSportKezd label=StartSportDate validation-rules="{required: true}"></cts-date-picker><cts-date-picker name=startSportDate data-ng-if=vm.athleteRequiredMinimumDatas value=vm.athleteData.VersSportKezd label=StartSportDate validation-rules="{required: false}"></cts-date-picker><cts-date-picker name=startMemberDate value=vm.athleteData.DSITagsagKezdete label=StartMemberDate validation-rules="{required: true}"></cts-date-picker><cts-check-box name=active label=Active enabled=false checked=vm.athleteData.Aktiv change=vm.activeChange></cts-check-box><cts-text-box-taj-szam data-ng-if=vm.socialSecurityNumberRequiredValue name=socialSecurityNumber label=SocialSecurityNumber data-ng-model=vm.athleteData.TAJSzam validation-rules="{required: true}"></cts-text-box-taj-szam><cts-text-box-taj-szam data-ng-if=!vm.socialSecurityNumberRequiredValue name=socialSecurityNumber label=SocialSecurityNumber data-ng-model=vm.athleteData.TAJSzam validation-rules="{required: false}"></cts-text-box-taj-szam><cts-date-picker name=medicalCertificateExpirationDate label=medicalCertificateExpirationDate value=vm.athleteData.SportorvosIgazolasLejarat></cts-date-picker><cts-text-area name=coachDetails data-ng-if=!vm.athleteRequiredMinimumDatas label=CoachDetails data-ng-model=vm.athleteData.EddigiEdzoi css="padding-left:0; padding-right:0; width: 100%;" validation-rules="{required: true, maxlength: 4096}"></cts-text-area><cts-text-area name=coachDetails data-ng-if=vm.athleteRequiredMinimumDatas label=CoachDetails data-ng-model=vm.athleteData.EddigiEdzoi css="padding-left:0; padding-right:0; width: 100%;" validation-rules="{required: false, maxlength: 4096}"></cts-text-area><cts-dropdown-list name=feeOfEducation label=FeeOfEducation value=vm.athleteData.TagdijasText datasource=vm.feeOfEducationList databound=vm.feeOfEducationBound enabled=vm.noSelectedAthlete></cts-dropdown-list><cts-text-box data-ng-if=vm.athleteRegistrationNumberRequiredValue name=athleteRegistrationnumber label=AthleteRegistrationNumber data-ng-model=vm.athleteData.RegisztraciosSzam validation-rules="{required: true }"></cts-text-box><cts-text-box data-ng-if=!vm.athleteRegistrationNumberRequiredValue name=athleteRegistrationnumber label=AthleteRegistrationNumber data-ng-model=vm.athleteData.RegisztraciosSzam validation-rules="{required: false }"></cts-text-box><div class="cts-form-group form-group"><div class="col-lg-6 col-lg-offset-6"><button class=cts-button type=button id=regnumgen ej-button e-click=vm.generateRegNum translate>GenerateRegNum</button></div></div><cts-text-box name=JatekEngedelySzama label=JatekEngedelySzama data-ng-model=vm.athleteData.JatekEngedelySzama></cts-text-box></fieldset><h3><a href=# translate>Contact</a></h3><fieldset class="panel col-lg-8"><cts-dropdown-list name=county data-ng-if=!vm.athleteRequiredMinimumDatas label=County cts-placeholder=County value=vm.athleteData.LakcimMegye datasource=vm.countyList databound=vm.countyDataBound select=vm.countySelect validation-rules="{required: true}"></cts-dropdown-list><cts-text-box name=zipCode data-ng-if=!vm.athleteRequiredMinimumDatas label=zipCode cts-placeholder=zipCode data-ng-model=vm.athleteData.LakcimIrSzam validation-rules="{required: true, minlength: 2, maxlength: 10}"></cts-text-box><cts-text-box name=city data-ng-if=!vm.athleteRequiredMinimumDatas label=City cts-placeholder=City data-ng-model=vm.athleteData.LakcimVaros validation-rules="{required: true, minlength: 2, maxlength: 50}"></cts-text-box><cts-text-box name=street data-ng-if=!vm.athleteRequiredMinimumDatas label=Street cts-placeholder=Street data-ng-model=vm.athleteData.LakcimUtca validation-rules="{required: true, minlength: 1, maxlength: 50}"></cts-text-box><cts-text-box name=streetNumber data-ng-if=!vm.athleteRequiredMinimumDatas label=StreetNumber cts-placeholder=StreetNumber data-ng-model=vm.athleteData.LakcimHazszam validation-rules="{required: true, minlength: 1, maxlength: 50}"></cts-text-box><cts-dropdown-list name=county data-ng-if=vm.athleteRequiredMinimumDatas label=County cts-placeholder=County value=vm.athleteData.LakcimMegye datasource=vm.countyList databound=vm.countyDataBound select=vm.countySelect validation-rules="{required: false}"></cts-dropdown-list><cts-text-box name=zipCode data-ng-if=vm.athleteRequiredMinimumDatas label=zipCode cts-placeholder=zipCode data-ng-model=vm.athleteData.LakcimIrSzam validation-rules="{required: false, maxlength: 10}"></cts-text-box><cts-text-box name=city data-ng-if=vm.athleteRequiredMinimumDatas label=City cts-placeholder=City data-ng-model=vm.athleteData.LakcimVaros validation-rules="{required: false, maxlength: 50}"></cts-text-box><cts-text-box name=street data-ng-if=vm.athleteRequiredMinimumDatas label=Street cts-placeholder=Street data-ng-model=vm.athleteData.LakcimUtca validation-rules="{required: false, maxlength: 50}"></cts-text-box><cts-text-box name=streetNumber data-ng-if=vm.athleteRequiredMinimumDatas label=StreetNumber cts-placeholder=StreetNumber data-ng-model=vm.athleteData.LakcimHazszam validation-rules="{required: false, maxlength: 50}"></cts-text-box><cts-text-box name=phoneNumber data-ng-if=!vm.athleteRequiredMinimumDatas label=phoneNumber data-ng-model=vm.athleteData.Elerhetoseg validation-rules="{required: true}"></cts-text-box><cts-text-box name=phoneNumber data-ng-if=vm.athleteRequiredMinimumDatas label=phoneNumber data-ng-model=vm.athleteData.Elerhetoseg validation-rules="{required: false}"></cts-text-box><cts-text-box-email name=eMail label=Email data-ng-model=vm.athleteData.EmailCim></cts-text-box-email></fieldset><h3><a href=# translate>IdentificationNumbers</a></h3><fieldset class="panel col-lg-8"><cts-text-box name=personalId label=PersonalId data-ng-model=vm.athleteData.SzemIgSzam></cts-text-box><cts-date-picker name=personalIdExpiration label=PersonalIdExpiration value=vm.athleteData.SzemelyiErvenyessege></cts-date-picker><cts-text-box-tax-id name=taxId label=taxId data-ng-model=vm.athleteData.AdoSzam></cts-text-box-tax-id><cts-text-box-passport-number name=passportNumber label=PassportNumber data-ng-model=vm.athleteData.UtlevelSzam></cts-text-box-passport-number><cts-date-picker name=passportExpiration label=PassportExpiration value=vm.athleteData.UtlevelErvenyessege></cts-date-picker></fieldset><h3><a href=# translate>ClothesSizes</a></h3><fieldset class="panel col-lg-8"><div><cts-text-box name=slippersSize label=SlippersSize data-ng-model=vm.athleteData.PapucsMerete ng-show=vm.RUHA.PAPUCS></cts-text-box></div><div><cts-text-box name=shoeSize label=ShoeSize data-ng-model=vm.athleteData.CipoMerete ng-show=vm.RUHA.CIPO></cts-text-box></div><div><cts-text-box name=joggingSuitSize label=JoggingSize data-ng-model=vm.athleteData.MelegitoMerete ng-show=vm.RUHA.MELEGITO></cts-text-box></div><div><cts-text-box name=bathrobeSize label=BathrobeSize data-ng-model=vm.athleteData.FurdokopenyMerete ng-show=vm.RUHA.FURDOKOPENY></cts-text-box></div><div><cts-text-box name=coatSize label=CoatSize data-ng-model=vm.athleteData.KabatMerete ng-show=vm.RUHA.KABAT></cts-text-box></div><div><cts-text-box name=armorPantSize label=ArmorPantSize data-ng-model=vm.athleteData.PancelNadragMerete ng-show=vm.RUHA.PANCELNADRAG></cts-text-box></div><div><cts-text-box name=tShirtSize label=TShirtSize data-ng-model=vm.athleteData.PoloMerete ng-show=vm.RUHA.POLO></cts-text-box></div><div><cts-text-box name=shortDressSize label=ShortsSize data-ng-model=vm.athleteData.SortMerete ng-show=vm.RUHA.SORT></cts-text-box></div><div><cts-text-box name=swimmingPantSize label=SwimmingPantSize data-ng-model=vm.athleteData.UszoNadragMerete ng-show=vm.RUHA.USZONADRAG></cts-text-box></div></fieldset><h3><a href=# translate>SchoolDatas</a></h3><fieldset class=col-sm-12><div class="panel col-lg-8"><div class="col-lg-12 col-lg-offset-6"><button class=cts-button type=button id=changeSchool ej-button e-click=vm.selectSchools translate>SelectSchool</button></div></div><br><div class=hidedContent id=hidedContent><div class=form-group><div class=slim-grid id=Grid></div></div></div><br><div class="panel col-lg-8"><cts-text-box name=schoolName label=SchoolName data-ng-model=vm.athleteData.IskolaNeve change=vm.schoolNameChanged data-ng-model-options="{debounce: 500}"></cts-text-box><cts-text-box name=schoolZipCode label=SchoolZipCode data-ng-model=vm.athleteData.IskolaIrSzam></cts-text-box><cts-text-box name=schoolCity label=SchoolCity data-ng-model=vm.athleteData.IskolaVaros></cts-text-box><cts-text-box name=schoolStreet label=SchoolStreet data-ng-model=vm.athleteData.IskolaUtca></cts-text-box><cts-text-box name=schoolStreetNumber label=SchoolStreetNumber data-ng-model=vm.athleteData.IskolaHazszam></cts-text-box><cts-text-box name=directorName label=DirectorName data-ng-model=vm.athleteData.IskolaIgazgatoNeve></cts-text-box><cts-auto-complete name=classMaster label=ClassMaster value=vm.athleteData.OsztalyFonokNeve datasource=vm.classMasterDatasource emptyresulttext=vm.emptyResultText show-popup-button=true change=vm.selectOf></cts-auto-complete><cts-text-box name=classMasterTel label=ClassMasterTel data-ng-model=vm.athleteData.OfTel></cts-text-box><cts-text-box-email name=classMasterEmail label=ClassMasterEmail data-ng-model=vm.athleteData.OfEmail></cts-text-box-email><cts-auto-complete name=gymTeacher label=GymTeacher value=vm.athleteData.TestneveloNeve datasource=vm.gymTeacherDatasource emptyresulttext=vm.emptyResultText show-popup-button=true change=vm.selectTesiTanar></cts-auto-complete><cts-text-box name=gymTeacherContact label=GymTeacherContact data-ng-model=vm.athleteData.TestneveloElerhetosege></cts-text-box><cts-text-box-email name=gymTeacherEmail label=GymTeacherEmail data-ng-model=vm.athleteData.TestneveloEmail></cts-text-box-email><cts-dropdown-list name=course label=Course value=vm.athleteData.IskolaEvfolyam datasource=vm.courseList select=vm.courseSelect></cts-dropdown-list><cts-dropdown-list name=class label=Class value=vm.athleteData.IskolaOsztaly datasource=vm.classList select=vm.classSelect></cts-dropdown-list></div></fieldset><h3><a href=# translate>ParentDatas</a></h3><fieldset class="panel col-lg-8"><cts-auto-complete name=motherName label=MothersName value=vm.athleteData.AnyjaNeve datasource=vm.motherNames emptyresulttext=vm.emptyResultText show-popup-button=true disabled=!vm.allowEdit validation-rules="{required: false, minlength: 5, maxlength: 30}" change=vm.selectMother></cts-auto-complete><cts-text-box name=motherContact label=MotherContact data-ng-model=vm.athleteData.Szulo1Elerhetosege validation-rules="{required: false, minlength: 5, maxlength: 30}"></cts-text-box><cts-text-box-email name=motherEmail label=MotherEmail data-ng-model=vm.athleteData.AnyaEmail disabled=!vm.allowEdit></cts-text-box-email><cts-numeric-text-box name=motherHeightDropDown label=Height value=vm.athleteData.AnyjaTestmagassaga validation-rules="{required: false}"></cts-numeric-text-box><cts-text-area name=MotherSportHistory label=MotherSportHistory data-ng-model=vm.athleteData.SportoloiMultAnya css="padding-left:0; padding-right:0; width: 100%;" validation-rules="{required: false, maxlength: 4096}"></cts-text-area><cts-text-box name=mothersJob label=MothersJob data-ng-model=vm.athleteData.AnyjaFoglalkozasa validation-rules="{required: false, maxlength: 30}"></cts-text-box><cts-text-box name=mothersWorkplace label=MothersWorkplace data-ng-model=vm.athleteData.AnyaMunkahely validation-rules="{required: false}"></cts-text-box><cts-auto-complete name=fatherName label=FatherName value=vm.athleteData.SzuloNeve datasource=vm.fatherNames emptyresulttext=vm.emptyResultText show-popup-button=true disabled=!vm.allowEdit validation-rules="{required: false, minlength: 5, maxlength: 30}" change=vm.selectFather></cts-auto-complete><cts-text-box name=fatherContact label=FatherContact data-ng-model=vm.athleteData.Szulo2Elerhetosege validation-rules="{required: false, minlength: 5, maxlength: 30}"></cts-text-box><cts-text-box-email name=fatherEmail label=FatherEmail data-ng-model=vm.athleteData.ApaEmail disabled=!vm.allowEdit></cts-text-box-email><cts-numeric-text-box name=fatherHeightDropDown label=Height value=vm.athleteData.ApjaTestmagassaga validation-rules="{required: false}"></cts-numeric-text-box><cts-text-area name=MotherSportHistory label=FatherSportHistory data-ng-model=vm.athleteData.SportoloiMultApa css="padding-left:0; padding-right:0; width: 100%;" validation-rules="{required: false, maxlength: 4096}"></cts-text-area><cts-text-box name=fathersJob label=FathersJob data-ng-model=vm.athleteData.ApjaFoglalkozasa validation-rules="{required: false, maxlength: 30}"></cts-text-box><cts-text-box name=fathersWorkplace label=FathersWorkplace data-ng-model=vm.athleteData.ApaMunkahely validation-rules="{required: false}"></cts-text-box></fieldset><h3><a href=# translate>OtherDatas</a></h3><fieldset class="panel col-lg-8"><cts-numeric-text-box name=AtigazolasiDij label=AtigazolasiDij value=vm.athleteData.AtigazolasiDij validation-rules="{required: false}"></cts-numeric-text-box><cts-date-picker name=trainingStart label=TrainingStart value=vm.athleteData.EdzesreJarasKezdete validation-rules="{required: false}"></cts-date-picker><cts-text-area name=Notes label=Notes data-ng-model=vm.athleteData.Megjegyzes css="padding-left:0; padding-right:0; width: 100%;" validation-rules="{required: false, maxlength: 4096}"></cts-text-area><cts-text-area name=SportAssociation label=SportAssociation data-ng-model=vm.athleteData.EddigiSpEgyesuletei css="padding-left:0; padding-right:0; width: 100%;" validation-rules="{required: false, maxlength: 4096}"></cts-text-area><cts-text-box name=childAgeSport label=ChildageSport data-ng-model=vm.athleteData.GyermekkoriSport validation-rules="{required: false, minlength: 1, maxlength: 30}"></cts-text-box><cts-text-box name=origin label=Origin data-ng-model=vm.athleteData.FajiEredet validation-rules="{required: false, minlength: 3, maxlength: 30}"></cts-text-box><cts-text-box name=howSpentFreeTime label=HowSpentFreeTime data-ng-model=vm.athleteData.SzunideiElfoglaltsag validation-rules="{required: false, minlength: 1, maxlength: 30}"></cts-text-box><cts-text-box name=birthName label=BirthName data-ng-model=vm.athleteData.LeanykoriNev validation-rules="{required: false, minlength: 5, maxlength: 30}"></cts-text-box><cts-date-picker name=pubertasEndTime label=PubertasEndTime value=vm.athleteData.PubertasVege validation-rules="{required: false}"></cts-date-picker></fieldset></div></div></div><div class=col-lg-12 style="text-align: center; margin-top: 1.5em;"><button type=submit class=cts-button ej-button e-click=vm.save translate>Save</button> <button type=reset class=cts-button ej-button e-click=back translate>Cancel</button></div></form></div><div class=widget-foot><div class=clearfix></div></div><div id=dialogContainer class=dialogContainer><div class=modalCell><div id=cropDialog class=cropDialog ej-dialog e-title=vm.cropDialogTitle e-width=350 e-showoninit=false e-enablemodal=true e-enableresize=false e-allowkeyboardnavigation=false e-closeonescape=true e-close=vm.closeCropDialog e-isresponsive=true e-enableanimation=true e-content=#dialogContainer e-showroundedcorner=false><div class=text-center><div class=modal-body><div><label for=fileName class="cts-button pull-left" translate>ChooseImage</label> <input style="display: none;" type=file accept=image/* img-cropper-fileread image=vm.cropper.sourceImage id=fileName><div><canvas id=canvas width=300 height=300 image-cropper min-width=50 min-height=50 image=vm.cropper.sourceImage cropped-image=vm.cropper.croppedImage crop-width=300 crop-height=300 keep-aspect=true touch-radius=30 crop-area-bounds=vm.bounds></canvas></div></div></div><div class=modal-footer><button class="cts-button pull-left" data-ng-disabled=!vm.cropper.croppedImage data-ng-click=vm.doneCropDialog() type=submit style="min-width: 100px;">{{\'OK\'|translate}}</button> <button class="cts-button pull-left" data-ng-click=vm.closeCropDialog() type=button style="min-width: 100px; margin-left: 5px;">{{\'Cancel\'|translate}}</button></div></div></div></div></div>');
$templateCache.put('app/athletes/athletesManagement/athletesList/athletesList.html','<ht-widget-header title={{title}} text-id=athleteListHelp right-text=rightText></ht-widget-header><div class=widget-content><form class=filter name=form><div class=row><cts-dropdown-list name=sectionDropDown label=Section value=vm.selectedSectionId datasource=vm.sectionList databound=vm.sectionDataBound select=vm.sectionSelect></cts-dropdown-list><cts-dropdown-list name=ageGroupDropDown label=AgeGroup value=vm.selectedAgeGroupId datasource=vm.ageGroupList databound=vm.ageGroupDataBound select=vm.ageGroupSelect></cts-dropdown-list><cts-check-box name=active label=OnlyInactives enabled=vm.checkboxEnabled checked=vm.inactiveAthletes change=vm.inactiveChange></cts-check-box></div><div class=row><div class=button-wrapper><button class=cts-button id=newAthletes ej-button e-click=vm.goToNewAthlete translate>NewAthlete</button><button class=cts-button id=modifyAthletes ej-button e-click=vm.modifyAthletesButton translate>ModifyAthletes</button><button class=cts-button id=goneAthletes ej-button e-click=vm.goneAthletesBtn translate>goneAthletes</button><button class=cts-button id=competitionResult ej-button e-click=vm.competitionResult translate>RaceResultsReport</button></div></div></form><script id=templateDataRow1 type=text/x-template><a data-ng-click="vm.modifyAthletes(${SportolokId})">${Nev}</a></script><script id=templateDataRow2 type=text/x-template><a data-ng-click="vm.goToUser(${EdzoId})">${EdzoNeve}</a></script><div class=col-sm-12><div id=Grid class="slim-grid no-print-first-col"></div></div></div>');
$templateCache.put('app/athletes/teams/addTeam/addTeam.html','<div class=widget-head><h2 class=page-title>{{title}}</h2></div><div class="widget-content form"><form novalidate name=form enctype=multipart/form-data><div class=row><div class=col-lg-6><cts-text-box name=TeamName label=TeamName data-ng-model=vm.formData.TeamName validation-rules="{required: true, maxlength: 200}"></cts-text-box><cts-text-box name=Comment label=Comment data-ng-model=vm.formData.Comment validation-rules="{maxlength: 255}"></cts-text-box><cts-dropdown-list name=SectionId label=Section value=vm.formdata.SectionId datasource=vm.sectionList databound=vm.sectionDataBound select=vm.sectionSelect validation-rules="{required: true}"></cts-dropdown-list><cts-dropdown-list name=AgeGroupId label=AgeGroup value=vm.formdata.AgeGroupId datasource=vm.ageGroupList databound=vm.ageGroupDataBound select=vm.ageGroupSelect validation-rules="{required: true}"></cts-dropdown-list><cts-dropdown-list name=CoachId label=Coach value=vm.formdata.CoachId datasource=vm.coachList databound=vm.coachDataBound select=vm.coachSelect validation-rules="{required: true}"></cts-dropdown-list></div><div class="col-sm-12 col-md-12 col-lg-6 overflow-hidden pull-lg-left"><div class=image-preview style="width: 210px;"><img ng-src={{vm.photoUrl}} id=profileImg class="thumb pull-left" style="clear: both; margin-bottom: 2px;"> <button type=button data-ng-click=vm.openCropDialog() class="cts-button pull-left" style="display: block; clear: both; float: left; margin-right: 2px;" translate>Modify</button> <button type=button data-ng-disabled="vm.noImg === vm.photoUrl" data-ng-click=vm.deleteImg() id=deleteImgBtn class="cts-button pull-left" style="display: block; float: left" translate>Delete</button></div></div><div class=col-sm-12 style="text-align: center"><button type=submit class=cts-button ej-button e-click=vm.simpleSave translate>Save</button> <button type=submit class=cts-button ej-button e-click=vm.saveTeamAndAddMembers e-enabled=vm.MEGTCSOPORT translate>SaveAndManageTeamMember</button> <button type=reset class=cts-button ej-button e-click=back translate>Cancel</button></div></div></form></div><div class=widget-foot><div class=clearfix></div></div><div id=dialogContainer class=dialogContainer><div class=modalCell><div id=cropDialog class=cropDialog ej-dialog e-title=vm.cropDialogTitle e-width=350 e-showoninit=false e-enablemodal=true e-enableresize=false e-allowkeyboardnavigation=false e-closeonescape=true e-close=vm.closeCropDialog e-isresponsive=true e-enableanimation=true e-content=#dialogContainer e-showroundedcorner=false><div class=text-center><div class=modal-body><div><label for=FileName class="cts-button pull-left">{{\'ChooseImage\'|translate}}</label> <input style="display: none;" type=file accept=image/* img-cropper-fileread image=vm.cropper.sourceImage id=FileName><div><canvas id=canvas width=300 height=300 image-cropper image=vm.cropper.sourceImage cropped-image=vm.cropper.croppedImage crop-width=300 crop-height=300 keep-aspect=true touch-radius=30 crop-area-bounds=vm.bounds min-width=50 min-height=50></canvas></div></div></div><div class=modal-footer><button class="cts-button pull-left" data-ng-disabled=!vm.cropper.croppedImage data-ng-click=vm.doneCropDialog() type=button style="min-width: 100px;">{{\'OK\'|translate}}</button> <button class="cts-button pull-right pull-left" data-ng-click=vm.closeCropDialog() type=button style="min-width: 100px; margin-left: 5px;">{{\'Cancel\'|translate}}</button></div></div></div></div></div>');
$templateCache.put('app/athletes/teams/addTeamMember/addTeamMember.html','<div class=widget-head><h2 class=page-title>{{title}}</h2></div><div class=widget-content><form class=filter name=form><div class=row><div class=button-wrapper><button type=button class=cts-button ej-button e-click=vm.addTeamMemberToTeam id=addTeamMember translate>AddToTeam</button></div></div></form><script id=adtemetemplateDataColumn1 type=text/x-template><a data-ng-click="vm.goToNewAthlete(${Id})">${Name}</a></script><div class=row><div id=Grid class="slim-grid no-print-first-col"></div></div><div class="col-sm-12 back" style="text-align: center"><button type=reset class=cts-button ej-button e-click=back translate>Back</button></div></div><div class=widget-foot><div class=clearfix></div></div>');
$templateCache.put('app/athletes/teams/modifyTeam/modifyTeam.html','<div class=widget-head><h2 class=page-title>{{title}}</h2></div><div class="widget-content form"><form novalidate name=form enctype=multipart/form-data><div class=row><div class=col-lg-6><cts-text-box name=TeamName label=TeamName data-ng-model=vm.formData.TeamName validation-rules="{required: true, maxlength: 200}" owndisabled=!vm.MODCSOPORT></cts-text-box><cts-text-box name=Comment label=Comment data-ng-model=vm.formData.Comment validation-rules="{maxlength: 255}" owndisabled=!vm.MODCSOPORT></cts-text-box><cts-dropdown-list name=sectionDropDown label=Section value=vm.formdata.SectionId datasource=vm.sectionList databound=vm.sectionDataBound select=vm.sectionSelect validation-rules="{required: true}" enabled=vm.MODCSOPORT></cts-dropdown-list><cts-dropdown-list name=ageGroupDropDown label=AgeGroup value=vm.formdata.AgeGroupId datasource=vm.ageGroupList databound=vm.ageGroupDataBound select=vm.ageGroupSelect validation-rules="{required: true}" enabled=vm.MODCSOPORT></cts-dropdown-list><cts-dropdown-list name=coachDropDown label=Coach value=vm.formdata.CoachId datasource=vm.coachList databound=vm.coachDataBound select=vm.coachSelect validation-rules="{required: true}" enabled=vm.MODCSOPORT></cts-dropdown-list><cts-check-box name=activeCheckBox label=Active checked=vm.formdata.ActiveTeam change=vm.activeCheckboxChanged enabled=vm.MODCSOPORT></cts-check-box></div><div class="col-sm-12 col-md-12 col-lg-6 overflow-hidden pull-lg-left"><div class=image-preview style="width: 210px;"><img ng-src={{vm.photoUrl}} id=profileImg class="thumb pull-left" style="clear: both; margin-bottom: 2px;"> <button data-ng-if=vm.MODCSOPORT data-ng-click=vm.openCropDialog() class="cts-button pull-left" style="display: block; clear: both; float: left; margin-right: 2px;" translate>Modify</button> <button data-ng-if=vm.MODCSOPORT data-ng-disabled="vm.noImg === vm.photoUrl" data-ng-click=vm.deleteImg() id=deleteImgBtn class="cts-button pull-left" style="display: block; float: left" translate>Delete</button></div></div><div class=col-sm-12 style="text-align: center"><button type=submit data-ng-if=vm.MODCSOPORT class=cts-button ej-button e-click=vm.simpleModifyTeam translate>Modify</button> <button name=modifyTeamAndAddMembersButton type=button data-ng-if=vm.MODCSOPORT class=cts-button ej-button e-enabled=vm.modifyTeamAndAddMembersButtonEnabled e-click=vm.modifyTeamAndAddMembers translate>ModifyAndManageTeamMember</button> <button type=reset class=cts-button ej-button e-click=back translate>Cancel</button></div></div></form></div><div class=widget-foot><div class=clearfix></div></div><div id=dialogContainer class=dialogContainer><div class=modalCell><div id=cropDialog class=cropDialog ej-dialog e-title=vm.cropDialogTitle e-width=350 e-showoninit=false e-enablemodal=true e-enableresize=false e-allowkeyboardnavigation=false e-closeonescape=true e-close=vm.closeCropDialog e-isresponsive=true e-enableanimation=true e-content=#dialogContainer e-showroundedcorner=false><div class=text-center><div class=modal-body><div><label for=FileName class="cts-button pull-left">{{\'ChooseImage\'|translate}}</label> <input style="display: none;" type=file accept=image/* img-cropper-fileread image=vm.cropper.sourceImage id=FileName><div><canvas id=canvas width=300 height=300 image-cropper image=vm.cropper.sourceImage cropped-image=vm.cropper.croppedImage crop-width=300 crop-height=300 keep-aspect=true touch-radius=30 crop-area-bounds=vm.bounds min-width=50 min-height=50></canvas></div></div></div><div class=modal-footer><button class="cts-button pull-left" data-ng-disabled=!vm.cropper.croppedImage style="min-width: 100px;" data-ng-click=vm.doneCropDialog() type=button>{{\'OK\'|translate}}</button> <button class="cts-button pull-left" data-ng-click=vm.closeCropDialog() type=button style="margin-left: 5px; min-width: 100px;">{{\'Cancel\'|translate}}</button></div></div></div></div></div>');
$templateCache.put('app/athletes/teams/teamList/teamList.html','<ht-widget-header title={{title}} text-id=teamListHelp right-text=rightText></ht-widget-header><div class=widget-content><form class=filter name=form><div class=row><cts-dropdown-list name=sectionDropDown label=Section value=vm.sectionId datasource=vm.sectionList change=vm.sectionChange></cts-dropdown-list><cts-dropdown-list name=ageGroupDropDown label=AgeGroup value=vm.ageGroupId datasource=vm.ageGroupList change=vm.ageGroupChange></cts-dropdown-list><cts-check-box name=active label=InactivesToo enabled=vm.checkboxEnabled checked=vm.inactiveTeams change=vm.inactiveChange></cts-check-box><div class=button-wrapper><button type=button id=addTeam class=cts-button ej-button e-click=vm.goToAddTeam translate>NewTeam</button> <button type=button id=modifyTeam class=cts-button ej-button e-click=vm.goToModifyTeam translate>Modify</button> <button type=button id=deleteTeam class=cts-button ej-button e-click=vm.deleteTeam translate>Delete</button> <button type=button id=teamMembersList class=cts-button ej-button e-click=vm.goToTeamMembersList translate>TeamMembers</button> <button type=button id=teamResults class=cts-button ej-button e-click=vm.openTeamResults translate>TeamResults</button></div></div></form><script type=text/x-template id=teamlistcolumnTemplate1><a data-ng-click="vm.goToTeamMembersList(${szakosztalyId}, ${korosztalyId}, ${csapatId}, ${aktiv})">${csapatNev}</a></script><script type=text/x-template id=teamlistcolumnTemplate2><a data-ng-click="vm.openCoach(${edzoId})">${edzoNeve}</a></script><div class=row><div id=Grid class="slim-grid no-print-first-col"></div></div></div><div class=widget-foot><div class=clearfix></div></div>');
$templateCache.put('app/athletes/teams/teamMembersList/teamMembersList.html','<div class=widget-head><h2 class=page-title>{{title}}</h2></div><div class=widget-content><form class=filter name=form><div class=row><cts-date-picker name=datepick label=TeamMemberDate value=vm.dateValue change=vm.dateChange></cts-date-picker><div class=button-wrapper><button type=button class=cts-button ej-button e-click=vm.goToAddTeamMember id=addTeamMember translate>AddTeamMember</button> <button type=button class=cts-button ej-button e-click=vm.deleteTeamMember id=deleteTeamMember translate>DeleteTeamMembers</button></div></div></form><script id=temelitemplateDataColumn1 type=text/x-template><a data-ng-click="vm.goToNewAthlete(${Id})">${Name}</a></script><div class=row><div id=Grid class="slim-grid no-print-first-col"></div></div><div class="col-sm-12 back" style="text-align: center"><button type=reset class=cts-button ej-button e-click=back translate>Back</button></div></div><div class=widget-foot><div class=clearfix></div></div>');
$templateCache.put('app/reports/annualPresenceReports/annualPresenceReportsBySections/annualPresenceReportsBySections.html','<ht-widget-header title={{title}} text-id=annualPresenceReportsBySectionsHelp right-text=rightText></ht-widget-header><div class=widget-content><form name=form novalidate class=filter><div style="overflow: hidden;"><cts-dropdown-list name=maEv label=StartYear value=vm.selectedYear datasource=vm.years validation-rules="{required: true}"></cts-dropdown-list><cts-dropdown-list name=maHonap label=StartMonth value=vm.selectedMonth datasource=vm.months validation-rules="{required: true}"></cts-dropdown-list><cts-dropdown-list name=maSzakosztaly databound=vm.sectionDataBound label=Section value=vm.selectedSection datasource=vm.sectionList required select=vm.sectionSelect validation-rules="{required: true}"></cts-dropdown-list><div class=button-wrapper><button id=reportSelect class=cts-button ej-button e-click=vm.reportSelect translate>Select</button></div></div><script type=text/x-template id=columnTemplate><a data-ng-click="vm.goToNewCoach(${VersenyzoId})">${VersenyzoNeve}</a></script><div><div id=Grid name=Grid></div></div></form></div><div class=widget-foot><div class=clearfix></div></div>');
$templateCache.put('app/reports/annualPresenceReports/annualPresenceReportsBySportSchool/annualPresenceReportsBySportSchool.html','<ht-widget-header title={{title}} text-id=annualPresenceReportsBySportSchoolHelp right-text=rightText></ht-widget-header><div class=widget-content><form name=form class=filter><div style="overflow: hidden;"><cts-dropdown-list name=maEv label=StartYear value=vm.selectedYear datasource=vm.years validation-rules="{required: true}"></cts-dropdown-list><cts-dropdown-list name=maHonap label=StartMonth value=vm.selectedMonth datasource=vm.months validation-rules="{required: true}" < cts-dropdown-list><div class=button-wrapper><button id=reportSelect class=cts-button ej-button e-click=vm.reportSelect translate>Select</button></div></cts-dropdown-list></div><div class=row><div id=Grid name=Grid></div></div></form></div><div class=widget-foot><div class=clearfix></div></div>');
$templateCache.put('app/reports/annualPresenceReports/annualPresenceReportsByTrainers/annualPresenceReportsByTrainers.html','<ht-widget-header title={{title}} text-id=annualPresenceReportsByTrainersHelp right-text=rightText></ht-widget-header><div class=widget-content><form name=form class=filter><div class=row><cts-dropdown-list name=maEv label=StartYear value=vm.selectedYear datasource=vm.years validation-rules="{required: true}"></cts-dropdown-list><cts-dropdown-list name=maHonap label=StartMonth value=vm.selectedMonth datasource=vm.months validation-rules="{required: true}"></cts-dropdown-list></div><div class=row><cts-dropdown-list name=maSzakosztaly label=Section value=vm.selectedSection datasource=vm.sectionList select=vm.sectionSelect databound=vm.sectionDataBound validation-rules="{required: true}"></cts-dropdown-list><cts-dropdown-list name=maKorosztaly label=AgeGroup value=vm.selectedAgeGroup datasource=vm.ageGroupList select=vm.ageGroupSelect databound=vm.ageGroupDataBound validation-rules="{required: true}"></cts-dropdown-list><cts-dropdown-list name=maEdzo label=Coach value=vm.selectedCoach datasource=vm.coachList select=vm.coachSelect databound=vm.coachDataBound validation-rules="{required: true}"></cts-dropdown-list></div><div class=button-wrapper><button id=reportSelect class=cts-button ej-button e-click=vm.reportSelect translate>Select</button></div></form><div class=row><div id=Grid name=Grid></div></div></div><div class=widget-foot><div class=clearfix></div></div>');
$templateCache.put('app/reports/centralReport/centralReportAllIn/centralReportAllIn.html','<ht-widget-header title={{title}} text-id=centralReportAllInHelp right-text=rightText></ht-widget-header><div class=widget-content><form class=filter name=form><div class=row><cts-dropdown-list name=sectionDropDown label=Section value=vm.selectedSection datasource=vm.sectionList databound=vm.sectionDataBound select=vm.sectionSelect></cts-dropdown-list><cts-dropdown-list name=ageGroupDropDown label=AgeGroup value=vm.selectedAgeGroup datasource=vm.ageGroupList databound=vm.ageGroupDataBound validation-rules="{required: false}" select=vm.ageGroupSelect></cts-dropdown-list><cts-dropdown-list name=coachName label=CoachName value=vm.selectedCoach datasource=vm.coachList databound=vm.coachDataBound select=vm.coachSelect validation-rules="{required: false}"></cts-dropdown-list></div><div class=row><cts-dropdown-list name=BirthDate label=BirthDate value=vm.selectedBirthDate datasource=vm.yearsBirth select=vm.birthDateChange clear=vm.clearYear validation-rules="{required: false}"></cts-dropdown-list><cts-dropdown-list name=gender label=Sex value=vm.sex datasource=vm.sexList select=vm.sexSelect validation-rules="{required: false}"></cts-dropdown-list><div class=button-wrapper><button id=search class=cts-button ej-button e-click=vm.getData translate>GetDatas</button></div></div></form><div class=row><div id=Grid name=Grid></div></div></div><div class=widget-foot><div class=clearfix></div></div>');
$templateCache.put('app/reports/centralReport/centralReportByRating/centralReportByRating.html','<ht-widget-header title={{title}} text-id=centralReportByRatingHelp right-text=rightText></ht-widget-header><div class=widget-content><form class=filter name=form><div class=row><cts-dropdown-list name=sectionDropDown label=Section value=vm.selectedSection datasource=vm.sectionList databound=vm.sectionDataBound validation-rules="{required: false}" select=vm.sectionSelect></cts-dropdown-list><cts-dropdown-list name=ageGroupDropDown label=AgeGroup value=vm.selectedAgeGroup datasource=vm.ageGroupList databound=vm.ageGroupDataBound validation-rules="{required: false}" select=vm.ageGroupSelect></cts-dropdown-list><cts-dropdown-list name=coachName label=CoachName value=vm.selectedCoach datasource=vm.coachList select=vm.coachSelect databound=vm.coachDataBound validation-rules="{required: false}"></cts-dropdown-list></div><div class=row><cts-dropdown-list name=gender label=Sex value=vm.sex datasource=vm.sexList select=vm.sexSelect validation-rules="{required: false}" databound=vm.sexDataBound></cts-dropdown-list><cts-dropdown-list name=datepickerTest label=Test value=vm.selectedDateTest datasource=vm.dateTestList select=vm.dateTestSelest databound=vm.dateTestDataBound validation-rules="{required: true}"></cts-dropdown-list><div class=button-wrapper><button id=search class=cts-button ej-button e-click=vm.getData e-enabled=vm.buttonEnabled translate>GetDatas</button></div></div></form><div class=row><script id=cerebyratemplateDataColumn1 type=text/x-template><a data-ng-click="vm.openAthlete(${SportoloID})">${SportoloNeve}</a></script><script id=cerebyratemplateDataColumn2 type=text/x-template><a data-ng-click="vm.openCoach(${EdzoID})">${EdzoNeve}</a></script><div id=Grid name=Grid></div></div></div><div class=widget-foot><div class=clearfix></div></div>');
$templateCache.put('app/reports/managementReports/annualCompetitivePlans/annualCompetitivePlans.html','<ht-widget-header title={{title}} text-id=annualCompetitivePlansHelp right-text=rightText></ht-widget-header><div class=widget-content><form class=filter name=form><div class=row><cts-date-picker name=datepickerFrom label=From value=vm.dateFromValue change=vm.dateFromChange validation-rules="{required: true}"></cts-date-picker><cts-date-picker name=datepickerTo label=To value=vm.dateToValue change=vm.dateToChange validation-rules="{required: true}"></cts-date-picker></div><div class=row><cts-dropdown-list name=sectionDropDown label=Section value=vm.sectionId datasource=vm.sectionList databound=vm.sectionDataBound select=vm.sectionSelect></cts-dropdown-list><cts-dropdown-list name=coachDropDown label=Coach value=vm.coachId datasource=vm.coachList databound=vm.coachDataBound select=vm.coachSelect></cts-dropdown-list><div class=button-wrapper><button id=search class=cts-button ej-button e-click=vm.search translate>GetDatas</button></div></div></form><div class=row><script type=text/x-template id=ancoplcolumnTemplate1><a data-ng-click="vm.goToAnnualSeasonPlan(${Id})"><i class="fa fa-eye" style="font-size: 1.5em;"></i></a></script><script type=text/x-template id=ancopopencoach><a data-ng-click="vm.openCoach(${IdEzdo})">${EdzoNeve}</a></script><script type=text/x-template id=ancopfiltersection><a data-ng-click="vm.filterSection(${IdSzakosztaly})">${SzakosztalyNeve}</a></script><div id=Grid class="slim-grid no-print-last-col"></div></div></div><div class=widget-foot><div class=clearfix></div></div>');
$templateCache.put('app/reports/managementReports/monthlyAttendanceReports/monthlyAttendanceReports.html','<ht-widget-header title={{title}} text-id=monthlyAttendaceReportsHelp right-text=rightText></ht-widget-header><div class=widget-content><form class=filter name=form><div class=row><cts-date-picker name=datepickerFrom label=From value=vm.dateFromValue change=vm.dateFromChange validation-rules="{required: true}"></cts-date-picker><cts-date-picker name=datepickerTo label=To value=vm.dateToValue change=vm.dateToChange validation-rules="{required: true}"></cts-date-picker></div><div class=row><cts-dropdown-list name=sectionDropDown label=Section value=vm.sectionId datasource=vm.sectionList databound=vm.sectionDataBound select=vm.sectionSelect></cts-dropdown-list><cts-dropdown-list name=coachDropDown label=Coach value=vm.coachId datasource=vm.coachList databound=vm.coachDataBound select=vm.coachSelect></cts-dropdown-list><div class=button-wrapper><button id=search class=cts-button ej-button e-click=vm.search translate>GetDatas</button></div></div></form><div class=row><script type=text/x-template id=marsection><a data-ng-click="vm.clickOnSection(${Szakosztaly_Id})">${SzakosztalyNeve}</a></script><script type=text/x-template id=marcoach><a data-ng-click="vm.openCoach(${Edzo_Id})">${EdzoNeve}</a></script><script type=text/x-template id=moatrecolumnTemplate1><a data-ng-click="vm.goToMonthlyAttendance(${attendaceId})"><i class="fa fa-eye" style="font-size: 1.5em;"></i></a></script><div id=Grid class="slim-grid no-print-last-col"></div></div></div><div class=widget-foot><div class=clearfix></div></div>');
$templateCache.put('app/reports/managementReports/monthlyCompetitivePlans/monthlyCompetitivePlans.html','<ht-widget-header title={{title}} text-id=monthlyCompetitivePlansManagementReportHelp right-text=rightText></ht-widget-header><div class=widget-content><form class=filter name=form><div class=row><cts-date-picker name=datepickerFrom label=From value=vm.dateFromValue change=vm.dateFromChange validation-rules="{required: true}"></cts-date-picker><cts-date-picker name=datepickerTo label=To value=vm.dateToValue change=vm.dateToChange validation-rules="{required: true}"></cts-date-picker></div><div class=row><cts-dropdown-list name=sectionDropDown label=Section value=vm.sectionId datasource=vm.sectionList databound=vm.sectionDataBound select=vm.sectionSelect></cts-dropdown-list><cts-dropdown-list name=coachDropDown label=Coach value=vm.coachId datasource=vm.coachList databound=vm.coachDataBound select=vm.coachSelect></cts-dropdown-list><div class=button-wrapper><button id=search class=cts-button ej-button e-click=vm.search translate>GetDatas</button></div></div></form><div class=row><script type=text/x-template id=mocomplcolumnTemplate1><a data-ng-click="vm.goToMonthlyCompetitivePlan(${Id.Id}, ${Id.Egyeni})"><i class="fa fa-eye" style="font-size: 1.5em;"></i></a></script><script type=text/x-template id=mocomplcolumnTemplate2><a data-ng-click="vm.openCoach(${EdzoId})">${EdzoNeve}</a></script><script type=text/x-template id=mocomplcolumnTemplate3><a data-ng-click="vm.openCoach(${JovahagytaId})">${JovahagytaNeve}</a></script><div id=Grid class="slim-grid no-print-last-col"></div></div></div><div class=widget-foot><div class=clearfix></div></div>');
$templateCache.put('app/reports/managementReports/trainingDiaryReports/trainingDiaryReports.html','<ht-widget-header title={{title}} text-id=trainingDiaryReportsHelp right-text=rightText></ht-widget-header><div class=widget-content><form class=filter name=form><div class=row><cts-date-picker name=datepickerFrom label=From value=vm.dateFromValue change=vm.dateFromChange validation-rules="{required: true}"></cts-date-picker><cts-date-picker name=datepickerTo label=To value=vm.dateToValue change=vm.dateToChange validation-rules="{required: true}"></cts-date-picker></div><div class=row><cts-dropdown-list name=sectionDropDown label=Section value=vm.sectionId datasource=vm.sectionList databound=vm.sectionDataBound select=vm.sectionSelect></cts-dropdown-list><cts-dropdown-list name=coachDropDown label=Coach value=vm.coachId datasource=vm.coachList databound=vm.coachDataBound select=vm.coachSelect></cts-dropdown-list><cts-dropdown-list name=ageGroupDropDown label=AgeGroup value=vm.ageGroupId datasource=vm.ageGroupList databound=vm.ageGroupDataBound select=vm.ageGroupSelect></cts-dropdown-list><div class=button-wrapper><button id=search class=cts-button ej-button e-click=vm.search translate>GetDatas</button></div></div></form><div class=row><script type=text/x-template id=tdrcoach><a data-ng-click="vm.openCoach(${Edzo_Id})">${EdzoNeve}</a></script><script type=text/x-template id=tdropentd><a data-ng-click="vm.openTrainingDiary(${attendaceId})"><i class="fa fa-eye" style="font-size: 1.5em;"></i></a></script><div id=Grid class="slim-grid no-print-last-col"></div></div></div><div class=widget-foot><div class=clearfix></div></div>');
$templateCache.put('app/reports/managementReports/weeklyTrainingPlans/weeklyTrainingPlans.html','<ht-widget-header title={{title}} text-id=weeklyTrainingPlansHelp right-text=rightText></ht-widget-header><div class=widget-content><form class=filter name=form><div class=row><cts-date-picker name=datepickerFrom label=From value=vm.dateFromValue validation-rules="{required: true}" change=vm.dateChange></cts-date-picker><cts-date-picker name=datepickerTo label=To value=vm.dateToValue validation-rules="{required: true}" change=vm.dateChange2></cts-date-picker></div><div class=row><cts-dropdown-list name=sectionDropDown label=Section value=vm.sectionId datasource=vm.sectionList databound=vm.sectionDataBound select=vm.sectionSelect></cts-dropdown-list><cts-dropdown-list name=coachDropDown label=Coach value=vm.coachId datasource=vm.coachList databound=vm.coachDataBound select=vm.coachSelect></cts-dropdown-list><div class=button-wrapper><button id=search class=cts-button ej-button e-click=vm.search translate>GetDatas</button></div></div></form><div class=row><script type=text/x-template id=wetrplcolumnTemplate1><a data-ng-click="vm.goToWeeklyTrainingPlan(${Id})"><i class="fa fa-eye" style="font-size: 1.5em;"></i></a></script><script type=text/x-template id=wetrplcolumnTemplate2><a data-ng-click="vm.openCoach(${EdzoId})">${EdzoNeve}</a></script><div id=Grid class="slim-grid no-print-last-col"></div></div></div><div class=widget-foot><div class=clearfix></div></div>');
$templateCache.put('app/reports/statisticalReports/activeAthletesByAge/activeAthletesByAge.html','<ht-widget-header title={{title}} text-id=activeAthletesByAgeHelp right-text=rightText></ht-widget-header><div class=widget-content><script type=text/x-template id=aaba_year><a data-ng-click="vm.openBirthYear(${SzuletesiEv})">${SzuletesiEv}</a></script><script type=text/x-template id=aaba_ops01><a data-ng-click="vm.openSection(${1},${SzuletesiEv})">${_sz_01}</a></script><script type=text/x-template id=aaba_ops02><a data-ng-click="vm.openSection(${2},${SzuletesiEv})">${_sz_02}</a></script><script type=text/x-template id=aaba_ops03><a data-ng-click="vm.openSection(${3},${SzuletesiEv})">${_sz_03}</a></script><script type=text/x-template id=aaba_ops04><a data-ng-click="vm.openSection(${4},${SzuletesiEv})">${_sz_04}</a></script><script type=text/x-template id=aaba_ops05><a data-ng-click="vm.openSection(${5},${SzuletesiEv})">${_sz_05}</a></script><script type=text/x-template id=aaba_ops06><a data-ng-click="vm.openSection(${6},${SzuletesiEv})">${_sz_06}</a></script><script type=text/x-template id=aaba_ops07><a data-ng-click="vm.openSection(${7},${SzuletesiEv})">${_sz_07}</a></script><script type=text/x-template id=aaba_ops08><a data-ng-click="vm.openSection(${8},${SzuletesiEv})">${_sz_08}</a></script><script type=text/x-template id=aaba_ops09><a data-ng-click="vm.openSection(${9},${SzuletesiEv})">${_sz_09}</a></script><script type=text/x-template id=aaba_ops10><a data-ng-click="vm.openSection(${10},${SzuletesiEv})">${_sz_10}</a></script><script type=text/x-template id=aaba_ops11><a data-ng-click="vm.openSection(${11},${SzuletesiEv})">${_sz_11}</a></script><script type=text/x-template id=aaba_ops12><a data-ng-click="vm.openSection(${12},${SzuletesiEv})">${_sz_12}</a></script><script type=text/x-template id=aaba_ops13><a data-ng-click="vm.openSection(${13},${SzuletesiEv})">${_sz_13}</a></script><script type=text/x-template id=aaba_ops14><a data-ng-click="vm.openSection(${14},${SzuletesiEv})">${_sz_14}</a></script><script type=text/x-template id=aaba_ops15><a data-ng-click="vm.openSection(${15},${SzuletesiEv})">${_sz_15}</a></script><script type=text/x-template id=aaba_ops16><a data-ng-click="vm.openSection(${16},${SzuletesiEv})">${_sz_16}</a></script><script type=text/x-template id=aaba_ops17><a data-ng-click="vm.openSection(${17},${SzuletesiEv})">${_sz_17}</a></script><script type=text/x-template id=aaba_ops18><a data-ng-click="vm.openSection(${18},${SzuletesiEv})">${_sz_18}</a></script><script type=text/x-template id=aaba_ops19><a data-ng-click="vm.openSection(${19},${SzuletesiEv})">${_sz_19}</a></script><script type=text/x-template id=aaba_ops20><a data-ng-click="vm.openSection(${20},${SzuletesiEv})">${_sz_20}</a></script><script type=text/x-template id=aaba_ops21><a data-ng-click="vm.openSection(${21},${SzuletesiEv})">${_sz_21}</a></script><script type=text/x-template id=aaba_ops22><a data-ng-click="vm.openSection(${22},${SzuletesiEv})">${_sz_22}</a></script><script type=text/x-template id=aaba_ops23><a data-ng-click="vm.openSection(${23},${SzuletesiEv})">${_sz_23}</a></script><script type=text/x-template id=aaba_ops24><a data-ng-click="vm.openSection(${24},${SzuletesiEv})">${_sz_24}</a></script><script type=text/x-template id=aaba_ops25><a data-ng-click="vm.openSection(${25},${SzuletesiEv})">${_sz_25}</a></script><script type=text/x-template id=aaba_ops26><a data-ng-click="vm.openSection(${26},${SzuletesiEv})">${_sz_26}</a></script><script type=text/x-template id=aaba_ops27><a data-ng-click="vm.openSection(${27},${SzuletesiEv})">${_sz_27}</a></script><script type=text/x-template id=aaba_ops28><a data-ng-click="vm.openSection(${28},${SzuletesiEv})">${_sz_28}</a></script><script type=text/x-template id=aaba_ops29><a data-ng-click="vm.openSection(${29},${SzuletesiEv})">${_sz_29}</a></script><script type=text/x-template id=aaba_ops30><a data-ng-click="vm.openSection(${30},${SzuletesiEv})">${_sz_30}</a></script><script type=text/x-template id=aaba_ops31><a data-ng-click="vm.openSection(${31},${SzuletesiEv})">${_sz_31}</a></script><script type=text/x-template id=aaba_ops32><a data-ng-click="vm.openSection(${32},${SzuletesiEv})">${_sz_32}</a></script><script type=text/x-template id=aaba_ops33><a data-ng-click="vm.openSection(${33},${SzuletesiEv})">${_sz_33}</a></script><script type=text/x-template id=aaba_ops34><a data-ng-click="vm.openSection(${34},${SzuletesiEv})">${_sz_34}</a></script><script type=text/x-template id=aaba_ops35><a data-ng-click="vm.openSection(${35},${SzuletesiEv})">${_sz_35}</a></script><script type=text/x-template id=aaba_ops36><a data-ng-click="vm.openSection(${36},${SzuletesiEv})">${_sz_36}</a></script><script type=text/x-template id=aaba_ops37><a data-ng-click="vm.openSection(${37},${SzuletesiEv})">${_sz_37}</a></script><script type=text/x-template id=aaba_ops38><a data-ng-click="vm.openSection(${38},${SzuletesiEv})">${_sz_38}</a></script><script type=text/x-template id=aaba_ops39><a data-ng-click="vm.openSection(${39},${SzuletesiEv})">${_sz_39}</a></script><script type=text/x-template id=aaba_ops40><a data-ng-click="vm.openSection(${40},${SzuletesiEv})">${_sz_40}</a></script><div class=form-group><div class=col-sm-12><div id=Grid class=slim-grid></div></div></div></div><div class=widget-foot><div class=clearfix></div></div>');
$templateCache.put('app/reports/statisticalReports/activeAthletesByCoach/activeAthletesByCoach.html','<ht-widget-header title={{title}} text-id=activeAthletesByCoachHelp right-text=rightText></ht-widget-header><div class=widget-content><form class=filter><div class=row><cts-date-picker name=datepicker label=Date change=vm.dateChange value=vm.queryDate></cts-date-picker><cts-check-box name=active label=ShowAll enabled=vm.checkboxEnabled change=vm.checkboxChanged checked=vm.checked></cts-check-box></div></form><script id=acatbycotemplateDataColumn1 type=text/x-template><a data-ng-click="vm.openCoach(${EdzoId},${SzakosztalyId})">${EdzoNeve}</a></script><script id=acatbycotemplateDataColumn2 type=text/x-template><a data-ng-click="vm.openSection(${SzakosztalyId})">${SzakosztalyNeve}</a></script><script id=acatbycotemplateDataColumn3 type=text/x-template><a data-ng-click="vm.openAthleteListByCoach(${EdzoId},${SzakosztalyId},0)">${Szam}</a></script><script id=acatbycotemplateDataColumn4 type=text/x-template><a data-ng-click="vm.openAthleteListByCoach(${EdzoId},${SzakosztalyId},1)">${SzamFiu}</a></script><script id=acatbycotemplateDataColumn5 type=text/x-template><a data-ng-click="vm.openAthleteListByCoach(${EdzoId},${SzakosztalyId},2)">${SzamLany}</a></script><div class=form-group><div class=col-sm-12><div id=Grid class=slim-grid></div></div></div></div><div class=widget-foot><div class=clearfix></div></div>');
$templateCache.put('app/reports/statisticalReports/activeAthletesByMonth/activeAthletesByMonth.html','<ht-widget-header title={{title}} text-id=activeAthletesByMonthHelp right-text=rightText></ht-widget-header><div class=widget-content><form class=filter><div class=row><cts-date-picker name=datepicker1 label=DateFrom change=vm.dateFromChanged value=vm.DateFrom></cts-date-picker><cts-date-picker name=datepicker2 label=DateTo change=vm.dateToChanged value=vm.DateTo></cts-date-picker></div></form><script type=text/x-template id=aabm_allgender><a data-ng-click="vm.openAthletes(${id},0)">${Szam}</a></script><script type=text/x-template id=aabm_male><a data-ng-click="vm.openAthletes(${id},1)">${SzamFiu}</a></script><script type=text/x-template id=aabm_female><a data-ng-click="vm.openAthletes(${id},2)">${SzamLany}</a></script><script type=text/x-template id=aabm_joined><a data-ng-click="vm.openJoined(${id})">${SzamErkezett}</a></script><script type=text/x-template id=aabm_leaving><a data-ng-click="vm.openLeaving(${id})">${SzamKilepett}</a></script><script type=text/x-template id=aabm_ops1><a data-ng-click="vm.openSection(${1},${id})">${c1}</a></script><script type=text/x-template id=aabm_ops2><a data-ng-click="vm.openSection(${2},${id})">${c2}</a></script><script type=text/x-template id=aabm_ops3><a data-ng-click="vm.openSection(${3},${id})">${c3}</a></script><script type=text/x-template id=aabm_ops4><a data-ng-click="vm.openSection(${4},${id})">${c4}</a></script><script type=text/x-template id=aabm_ops5><a data-ng-click="vm.openSection(${5},${id})">${c5}</a></script><script type=text/x-template id=aabm_ops6><a data-ng-click="vm.openSection(${6},${id})">${c6}</a></script><script type=text/x-template id=aabm_ops7><a data-ng-click="vm.openSection(${7},${id})">${c7}</a></script><script type=text/x-template id=aabm_ops8><a data-ng-click="vm.openSection(${8},${id})">${c8}</a></script><script type=text/x-template id=aabm_ops9><a data-ng-click="vm.openSection(${9},${id})">${c9}</a></script><script type=text/x-template id=aabm_ops10><a data-ng-click="vm.openSection(${10},${id})">${c10}</a></script><script type=text/x-template id=aabm_ops11><a data-ng-click="vm.openSection(${11},${id})">${c11}</a></script><script type=text/x-template id=aabm_ops12><a data-ng-click="vm.openSection(${12},${id})">${c12}</a></script><script type=text/x-template id=aabm_ops13><a data-ng-click="vm.openSection(${13},${id})">${c13}</a></script><script type=text/x-template id=aabm_ops14><a data-ng-click="vm.openSection(${14},${id})">${c14}</a></script><script type=text/x-template id=aabm_ops15><a data-ng-click="vm.openSection(${15},${id})">${c15}</a></script><script type=text/x-template id=aabm_ops16><a data-ng-click="vm.openSection(${16},${id})">${c16}</a></script><script type=text/x-template id=aabm_ops17><a data-ng-click="vm.openSection(${17},${id})">${c17}</a></script><script type=text/x-template id=aabm_ops18><a data-ng-click="vm.openSection(${18},${id})">${c18}</a></script><script type=text/x-template id=aabm_ops19><a data-ng-click="vm.openSection(${19},${id})">${c19}</a></script><script type=text/x-template id=aabm_ops20><a data-ng-click="vm.openSection(${20},${id})">${c20}</a></script><script type=text/x-template id=aabm_ops21><a data-ng-click="vm.openSection(${21},${id})">${c21}</a></script><script type=text/x-template id=aabm_ops22><a data-ng-click="vm.openSection(${22},${id})">${c22}</a></script><script type=text/x-template id=aabm_ops23><a data-ng-click="vm.openSection(${23},${id})">${c23}</a></script><script type=text/x-template id=aabm_ops24><a data-ng-click="vm.openSection(${24},${id})">${c24}</a></script><script type=text/x-template id=aabm_ops25><a data-ng-click="vm.openSection(${25},${id})">${c25}</a></script><script type=text/x-template id=aabm_ops26><a data-ng-click="vm.openSection(${26},${id})">${c26}</a></script><script type=text/x-template id=aabm_ops27><a data-ng-click="vm.openSection(${27},${id})">${c27}</a></script><script type=text/x-template id=aabm_ops28><a data-ng-click="vm.openSection(${28},${id})">${c28}</a></script><script type=text/x-template id=aabm_ops29><a data-ng-click="vm.openSection(${29},${id})">${c29}</a></script><script type=text/x-template id=aabm_ops30><a data-ng-click="vm.openSection(${30},${id})">${c30}</a></script><script type=text/x-template id=aabm_ops31><a data-ng-click="vm.openSection(${31},${id})">${c31}</a></script><script type=text/x-template id=aabm_ops32><a data-ng-click="vm.openSection(${32},${id})">${c32}</a></script><script type=text/x-template id=aabm_ops33><a data-ng-click="vm.openSection(${33},${id})">${c33}</a></script><script type=text/x-template id=aabm_ops34><a data-ng-click="vm.openSection(${34},${id})">${c34}</a></script><script type=text/x-template id=aabm_ops35><a data-ng-click="vm.openSection(${35},${id})">${c35}</a></script><script type=text/x-template id=aabm_ops36><a data-ng-click="vm.openSection(${36},${id})">${c36}</a></script><script type=text/x-template id=aabm_ops37><a data-ng-click="vm.openSection(${37},${id})">${c37}</a></script><script type=text/x-template id=aabm_ops38><a data-ng-click="vm.openSection(${38},${id})">${c38}</a></script><script type=text/x-template id=aabm_ops39><a data-ng-click="vm.openSection(${39},${id})">${c39}</a></script><script type=text/x-template id=aabm_ops40><a data-ng-click="vm.openSection(${40},${id})">${c40}</a></script><div class=form-group><div class=col-sm-12><div id=Grid class=slim-grid></div></div></div></div><div class=widget-foot><div class=clearfix></div></div>');
$templateCache.put('app/reports/statisticalReports/activeAthletesBySection/activeAthletesBySection.html','<ht-widget-header title={{title}} text-id=activeAthletesBySectionHelp right-text=rightText></ht-widget-header><div class=widget-content><form class=filter><div class=row><cts-date-picker name=datepicker label=Date change=vm.dateChange value=vm.queryDate></cts-date-picker><div class=button-wrapper><cts-check-box name=active label=ShowAll enabled=vm.checkboxEnabled change=vm.checkboxChanged checked=vm.checked></cts-check-box></div></div></form><script id=acatbysetemplateDataColumn1 type=text/x-template><a data-ng-click="vm.openSection(${SzakosztalyId}, 0)">${Szam}</a></script><script id=acatbysetemplateDataColumn2 type=text/x-template><a data-ng-click="vm.openSection(${SzakosztalyId}, 1)">${SzamFiu}</a></script><script id=acatbysetemplateDataColumn3 type=text/x-template><a data-ng-click="vm.openSection(${SzakosztalyId}, 2)">${SzamLany}</a></script><div class=form-group><div class=col-sm-12><div id=Grid class=slim-grid></div></div></div></div><div class=widget-foot><div class=clearfix></div></div>');
$templateCache.put('app/reports/statisticalReports/activeAthletesInSectionByMonth/activeAthletesInSectionByMonth.html','<ht-widget-header title={{title}} text-id=activeAthletesInSectionByMonthHelp right-text=rightText></ht-widget-header><div class=widget-content><form class=filter><div class=row><cts-dropdown-list name=sectionDropDown label=Section value=vm.sectionValue datasource=vm.sectionList databound=vm.sectionDataBound select=vm.sectionSelect></cts-dropdown-list><cts-date-picker name=datepicker1 label=DateFrom change=vm.dateFromChanged value=vm.dateFrom></cts-date-picker><cts-date-picker name=datepicker2 label=DateTo change=vm.dateToChanged value=vm.dateTo></cts-date-picker></div></form><script id=acatinsebymotemplateDataColumn1 type=text/x-template><a data-ng-click="vm.openAthletes(${id})">${Szam}</a></script><script id=acatinsebymotemplateDataColumn2 type=text/x-template><a data-ng-click="vm.openBoys(${id})">${SzamFiu}</a></script><script id=acatinsebymotemplateDataColumn3 type=text/x-template><a data-ng-click="vm.openGirls(${id})">${SzamLany}</a></script><div class=form-group><div class=col-sm-12><div id=Grid class=slim-grid></div></div></div></div><div class=widget-foot><div class=clearfix></div></div>');
$templateCache.put('app/reports/statisticalReports/athletesByBirthYear/athletesByBirthYear.html','<div class=widget-head><h2 class=page-title>{{title}}</h2></div><div class=widget-content><form class=filter><div class=row></div></form><script id=atbybiyetemplateDataColumn1 type=text/x-template><a data-ng-click="vm.listAthletes(${SzuletesiEv},0)">${Szam}</a></script><script id=atbybiyetemplateDataColumn2 type=text/x-template><a data-ng-click="vm.listAthletes(${SzuletesiEv},1)">${SzamFiu}</a></script><script id=atbybiyetemplateDataColumn3 type=text/x-template><a data-ng-click="vm.listAthletes(${SzuletesiEv},2)">${SzamLany}</a></script><div class=form-group><div class=col-sm-12><div id=Grid class=slim-grid></div></div></div></div><div class=widget-foot><div class=clearfix></div></div>');
$templateCache.put('app/reports/statisticalReports/athletesByYear/athletesByYear.html','<div class=widget-head><h2 class=page-title>{{title}}</h2></div><div class=widget-content><form class=filter><div class=row></div></form><script id=atbyyetemplateDataColumn1 type=text/x-template><a data-ng-click="vm.goToAthlete(${SportolokID})">${Nev}</a></script><script id=atbyyetemplateDataColumn3 type=text/x-template><a data-ng-click="vm.goToCoach(${EdzoId})">${EdzoNeve}</a></script><div class=form-group><div class=col-sm-12><div id=Grid class=slim-grid></div></div></div></div><div class=widget-foot><div class=clearfix></div></div>');
$templateCache.put('app/reports/statisticalReports/athletesNotPresentOnMonthlyAttendance/athletesNotPresentOnMonthlyAttendance.html','<ht-widget-header title={{title}} text-id=athletesNotPresentOnMonthlyAttendanceHelp right-text=rightText></ht-widget-header><div class=widget-content><form class=filter><div class=row><cts-dropdown-list name=sectionDropDown label=Section value=vm.sectionValue datasource=vm.sectionList databound=vm.sectionDataBound select=vm.sectionSelect></cts-dropdown-list><cts-date-picker name=datepicker1 label=DateFrom change=vm.dateFromChanged value=vm.DateFrom></cts-date-picker><cts-date-picker name=datepicker2 label=DateTo change=vm.dateToChanged value=vm.DateTo></cts-date-picker></div></form><script type=text/x-template id=anpomaathlete><a data-ng-click="vm.goToAthlete(${IdSportolo})">${MezoSportoloNev}</a></script><script type=text/x-template id=anpomacoach><a data-ng-click="vm.goToCoach(${IdEdzo})">${MezoEdzoNev}</a></script><div class=form-group><div class=col-sm-12><div id=Grid class=slim-grid></div><label translate>hintAthletesNotPresentOnMonthlyAttendance</label></div></div></div><div class=widget-foot><div class=clearfix></div></div>');
$templateCache.put('app/reports/statisticalReports/joinedAthletesByCoach/joinedAthletesByCoach.html','<ht-widget-header title={{title}} text-id=joinedAthletesByCoachHelp right-text=rightText></ht-widget-header><div class=widget-content><form class=filter><div class=row><cts-date-picker name=datepicker1 label=DateFrom change=vm.dateFromChanged value=vm.DateFrom></cts-date-picker><cts-date-picker name=datepicker2 label=DateTo change=vm.dateToChanged value=vm.DateTo></cts-date-picker><cts-check-box name=active label=ShowAll enabled=vm.checkboxEnabled change=vm.checkboxChanged checked=vm.checked></cts-check-box></div></form><script id=joatbycotemplateDataColumn1 type=text/x-template><a data-ng-click="vm.openCoach(${EdzoId})">${EdzoNeve}</a></script><script id=joatbycotemplateDataColumn2 type=text/x-template><a data-ng-click="vm.openSection(${SzakosztalyId})">${SzakosztalyNeve}</a></script><script id=joatbycotemplateDataColumn3 type=text/x-template><a data-ng-click="vm.openCoachesJoinedAthletes(${EdzoId},${SzakosztalyId},0)">${Szam}</a></script><script id=joatbycotemplateDataColumn4 type=text/x-template><a data-ng-click="vm.openCoachesJoinedAthletes(${EdzoId},${SzakosztalyId},1)">${SzamFiu}</a></script><script id=joatbycotemplateDataColumn5 type=text/x-template><a data-ng-click="vm.openCoachesJoinedAthletes(${EdzoId},${SzakosztalyId},2)">${SzamLany}</a></script><div class=form-group><div class=col-sm-12><div id=Grid class=slim-grid></div></div></div></div><div class=widget-foot><div class=clearfix></div></div>');
$templateCache.put('app/reports/statisticalReports/joinedAthletesBySection/joinedAthletesBySection.html','<ht-widget-header title={{title}} text-id=joinedAthletesBySectionHelp right-text=rightText></ht-widget-header><div class=widget-content><form class=filter><div class=row><cts-date-picker name=datepicker1 label=DateFrom change=vm.DateFromChanged value=vm.DateFrom></cts-date-picker><cts-date-picker name=datepicker2 label=DateTo change=vm.DateToChanged value=vm.DateTo></cts-date-picker><cts-check-box name=active label=ShowAll enabled=vm.checkboxEnabled change=vm.checkboxChanged checked=vm.checked></cts-check-box></div></form><script id=joatbysetemplateDataColumn1 type=text/x-template><a data-ng-click="vm.openSection(${SzakosztalyId}, 0)">${SzamErkezett}</a></script><script id=joatbysetemplateDataColumn2 type=text/x-template><a data-ng-click="vm.openSection(${SzakosztalyId}, 1)">${SzamBelepettFiuk}</a></script><script id=joatbysetemplateDataColumn3 type=text/x-template><a data-ng-click="vm.openSection(${SzakosztalyId}, 2)">${SzamBelepettLanyok}</a></script><div class=form-group><div class=col-sm-12><div id=Grid class=slim-grid></div></div></div></div><div class=widget-foot><div class=clearfix></div></div>');
$templateCache.put('app/reports/statisticalReports/leavingAthletesByCoach/leavingAthletesByCoach.html','<ht-widget-header title={{title}} text-id=leavingAthletesByCoachHelp right-text=rightText></ht-widget-header><div class=widget-content><form class=filter><div class=row><cts-date-picker name=datepicker1 label=DateFrom change=vm.dateFromChanged value=vm.DateFrom></cts-date-picker><cts-date-picker name=datepicker2 label=DateTo change=vm.dateToChanged value=vm.DateTo></cts-date-picker><cts-check-box name=active label=ShowAll enabled=vm.checkboxEnabled change=vm.checkboxChanged checked=vm.checked></cts-check-box></div></form><script id=leatbycotemplateDataColumn1 type=text/x-template><a data-ng-click="vm.openCoach(${EdzoId})">${EdzoNeve}</a></script><script id=leatbycotemplateDataColumn2 type=text/x-template><a data-ng-click="vm.openSection(${SzakosztalyId})">${SzakosztalyNeve}</a></script><script id=leatbycotemplateDataColumn3 type=text/x-template><a data-ng-click="vm.openCoachesLeavingAthletes(${EdzoId},${SzakosztalyId},0)">${Szam}</a></script><script id=leatbycotemplateDataColumn4 type=text/x-template><a data-ng-click="vm.openCoachesLeavingAthletes(${EdzoId},${SzakosztalyId},1)">${SzamFiu}</a></script><script id=leatbycotemplateDataColumn5 type=text/x-template><a data-ng-click="vm.openCoachesLeavingAthletes(${EdzoId},${SzakosztalyId},2)">${SzamLany}</a></script><div class=form-group><div class=col-sm-12><div id=Grid class=slim-grid></div></div></div></div><div class=widget-foot><div class=clearfix></div></div>');
$templateCache.put('app/reports/statisticalReports/leavingAthletesBySection/leavingAthletesBySection.html','<ht-widget-header title={{title}} text-id=leavingAthletesBySectionHelp right-text=rightText></ht-widget-header><div class=widget-content><form class=filter><div class=row><cts-date-picker name=datepicker1 label=DateFrom change=vm.dateChange value=vm.queryDate></cts-date-picker><cts-date-picker name=datepicker2 label=DateTo change=vm.dateChange2 value=vm.queryDate2></cts-date-picker><cts-check-box name=active label=ShowAll enabled=vm.checkboxEnabled change=vm.checkboxChanged checked=vm.checked></cts-check-box></div></form><script id=leatbysetemplateDataColumn1 type=text/x-template><a data-ng-click="vm.openSection(${SzakosztalyId}, 0)">${SzamKilepett}</a></script><script id=leatbysetemplateDataColumn2 type=text/x-template><a data-ng-click="vm.openSection(${SzakosztalyId}, 1)">${SzamFiu}</a></script><script id=leatbysetemplateDataColumn3 type=text/x-template><a data-ng-click="vm.openSection(${SzakosztalyId}, 2)">${SzamLany}</a></script><div class=form-group><div class=col-sm-12><div id=Grid class=slim-grid></div></div></div></div><div class=widget-foot><div class=clearfix></div></div>');
$templateCache.put('app/reports/statisticalReports/listAthletes/listAthletes.html','<div class=widget-head><h2 class=page-title>{{title}}</h2></div><div class=widget-content><script type=text/x-template id=laopenath><a data-ng-click="vm.openAthlete(${SportolokID})">${Nev}</a></script><script type=text/x-template id=laopencoach><a data-ng-click="vm.openCoach(${EdzoId})">${EdzoNeve}</a></script><script type=text/x-template id=laopenfee><a data-ng-click="vm.openSportServiceFee(${SportolokID})">${Egyenleg}</a></script><div class=form-group><div class=col-sm-12><div id=Grid2></div></div></div></div><div class=widget-foot><div class=clearfix></div></div>');
$templateCache.put('app/search/user/searchuser/searchuser.html','<ht-widget-header title={{title}} text-id=searchUserHelp right-text=rightText></ht-widget-header><div class=widget-content><form class=filter name=form><div class=row><div ej-accordion e-enablemultipleopen=true id=accordion><h3><a href=# translate>General</a></h3><fieldset><div class=row><cts-text-box name=name label=FullName data-ng-model=vm.formData.nev></cts-text-box><cts-text-box name=username label=Username data-ng-model=vm.formData.loginNev></cts-text-box></div><div class=row><cts-dropdown-list name=usergroup label="User group" datasource=vm.usergroups databound=vm.userGroupDatabound value=vm.formData.idCsoport></cts-dropdown-list><cts-dropdown-list name=gender label=Gender datasource=vm.genderList value=vm.formData.neme></cts-dropdown-list></div><div class=row><cts-text-box name=pobcountry label="Place of birth (Country)" data-ng-model=vm.formData.szulHelyOrszag></cts-text-box><cts-text-box name=pobcity label="Place of birth (City)" data-ng-model=vm.formData.szulHelyVaros></cts-text-box></div><div class=row><cts-date-picker name=birthDateFrom label=BirthDateFrom value=vm.formData.szulTol></cts-date-picker><cts-date-picker name=birthDateTo label=birthDateTo value=vm.formData.szulIg></cts-date-picker></div><div class=row><cts-dropdown-list name=active label="Active user" datasource=vm.yesno value=vm.formData.aktiv></cts-dropdown-list><cts-text-box name=Nationality label=Nationality data-ng-model=vm.formData.allamp></cts-text-box></div><div class=row><cts-check-box name=isc label="Individual sport coach" checked=vm.formData.egyeniSport></cts-check-box><cts-check-box name=tsc label="Team sport coach" checked=vm.formData.csapatSport></cts-check-box></div></fieldset><h3><a href=# translate>Contact</a></h3><fieldset><div class=row><cts-text-box name=email label=Email data-ng-model=vm.formData.email></cts-text-box><cts-text-box name=address label=Address data-ng-model=vm.formData.lakcim></cts-text-box></div><div class=row><cts-text-box name=contact label=Contact data-ng-model=vm.formData.elerhetoseg></cts-text-box><cts-text-box name=mothersname label="Mother\'s name" data-ng-model=vm.formData.anyjaNeve></cts-text-box></div><div class=row><cts-text-box name=CoachQualification label="Coach qualification" data-ng-model=vm.formData.edzKep></cts-text-box><cts-text-box name=MainWorkplace label="Main workplace" data-ng-model=vm.formData.foallMh></cts-text-box></div></fieldset><h3><a href=# translate>ID numbers and bodyShape</a></h3><fieldset><div class=row><cts-text-box name=personalID label=PersonalID data-ng-model=vm.formData.szemSzam></cts-text-box></div><div class=row><cts-text-box-taj-szam name=SocialSecurityNumber label=SocialSecurityNumber data-ng-model=vm.formData.tajSzam></cts-text-box-taj-szam></div><div class=row><cts-text-box name=PassportNumber label=PassportNumber data-ng-model=vm.formData.utlevel></cts-text-box></div><div class=row><cts-text-box name=HeightFrom label="Height (From)" data-ng-model=vm.formData.magTol></cts-text-box><cts-text-box name=HeightTo label="Height (To)" data-ng-model=vm.formData.magIg></cts-text-box></div><div class=row><cts-text-box name=WeightFrom label="Weight (From)" data-ng-model=vm.formData.testTol></cts-text-box><cts-text-box name=WeightTo label="Weight (To)" data-ng-model=vm.formData.testIg></cts-text-box></div></fieldset></div><div class=button-wrapper><button type=submit id=search class=cts-button ej-button e-click=vm.search translate>Search</button> <button type=reset id=reset class=cts-button ej-button e-click=vm.reset translate>ResetForm</button></div></div></form><script type=text/x-template id=searchusergotouser><a data-ng-click="vm.goToUser(${Id})">${Nev}</a></script><div class=col-sm-12><div id=Grid></div></div></div><div class=widget-foot><div class=clearfix></div></div>');
$templateCache.put('app/search/athletes/memberList/memberList.html','<ht-widget-header title={{title}} text-id=memberListHelp right-text=rightText></ht-widget-header><div class=widget-content><form class=filter name=form><div class=row><label><span translate>SearchWithTheFollowingParameters</span></label><div ej-accordion e-enablemultipleopen=true id=accordion><h3><a href=# translate>General</a></h3><fieldset><div class=row><cts-text-box name=Name label=AthleteName data-ng-model=vm.query.nev change=vm.nameChange></cts-text-box><cts-check-box name=NameExactMatch label=exactMatch change=vm.NameExactMatch checked=vm.NameExactMatchChecked enabled="vm.query.nev.length>0"></cts-check-box><cts-check-box name=NotMatching label=notMatching change=vm.NameNotMatching checked=vm.NameNotMatchingChecked enabled="vm.query.nev.length>0"></cts-check-box></div><div class=row><cts-dropdown-list name=active label=activeAthlete datasource=vm.yesno value=vm.query.aktiv></cts-dropdown-list></div><div class=row><cts-dropdown-list name=sectionId label=Section datasource=vm.sectionList value=vm.query.szakosztalyId select=vm.sectionSelect></cts-dropdown-list><cts-check-box name=MemberOfSection label=memberOfSection change=vm.MemberOfSection checked=vm.MemberOfSectionChecked enabled="vm.query.szakosztalyId>0"></cts-check-box><cts-check-box name=NotMemberOfSection label=notMemberOfSection change=vm.NotMemberOfSection checked=vm.NotMemberOfSectionChecked enabled="vm.query.szakosztalyId>0"></cts-check-box></div><div class=row><cts-dropdown-list name=korosztalyId label=AgeGroup datasource=vm.ageGroupList value=vm.query.korosztalyId select=vm.ageGroupSelect></cts-dropdown-list><cts-check-box name=MemberOfAgeGroup label=memberOfAgegroup change=vm.MemberOfAgeGroup checked=vm.MemberOfAgeGroupChecked></cts-check-box><cts-check-box name=NotMemberOfAgeGroup label=notMemberOfAgegroup change=vm.NotMemberOfAgeGroup checked=vm.NotMemberOfAgeGroupChecked></cts-check-box></div><div class=row><cts-dropdown-list name=edzoId label=Coach datasource=vm.coachList value=vm.query.edzoId select=vm.coachSelect></cts-dropdown-list><cts-check-box name=BelongsToCoach label=belongsToCoach change=vm.BelongsToCoach checked=vm.BelongsToCoachChecked></cts-check-box><cts-check-box name=NotBelongsToCoach label=notBelongsToCoach change=vm.NotBelongsToCoach checked=vm.NotBelongsToCoachChecked></cts-check-box></div><div class=row><cts-date-picker name=birthDateFrom label=BirthDateFrom value=vm.query.tol></cts-date-picker><cts-dropdown-list name=muvtol datasource=vm.muv_DATE value=vm.query.muvtol></cts-dropdown-list><cts-date-picker name=birthDateTo label=birthDateTo value=vm.query.ig data-ng-if="vm.query.muvtol===\'K\xF6z\xF6tt\'"></cts-date-picker></div><div class=row><cts-dropdown-list name=neme label=gender datasource=vm.genderList value=vm.query.neme></cts-dropdown-list></div><div class=row><cts-text-box name=Nationality label=Nationality data-ng-model=vm.query.allamp></cts-text-box></div><div class=row><cts-date-picker name=versenySportKezdeteTol label=competitiveSportFrom value=vm.query.vspTol></cts-date-picker><cts-dropdown-list name=muvvspTol datasource=vm.muv_DATE value=vm.query.muvvspTol></cts-dropdown-list><cts-date-picker name=versenySportKezdeteTol label=competitiveSportTo value=vm.query.vspIg data-ng-if="vm.query.muvvspTol===\'K\xF6z\xF6tt\'"></cts-date-picker></div><div class=row><cts-text-box name=leanykoriNev label=MaidenName data-ng-model=vm.query.leanykoriNev></cts-text-box></div></fieldset><h3><a href=# translate>Contact</a></h3><fieldset><div class=row><cts-text-box name=lakcimMegye label=County data-ng-model=vm.query.lakcimMegye></cts-text-box></div><div class=row><cts-text-box name=lakcimIrSzam label=ZipCode data-ng-model=vm.query.lakcimIrSzam></cts-text-box></div><div class=row><cts-text-box name=lakcimVaros label=City data-ng-model=vm.query.lakcimVaros></cts-text-box></div><div class=row><cts-text-box name=lakcimUtca label=Street data-ng-model=vm.query.lakcimUtca></cts-text-box></div><div class=row><cts-text-box name=lakcimHazszam label=housenumber data-ng-model=vm.query.lakcimHazszam></cts-text-box></div><div class=row><cts-text-box name=elerhetoseg label=Contact data-ng-model=vm.query.elerh></cts-text-box></div><div class=row><cts-text-box name=email label=Email data-ng-model=vm.query.email></cts-text-box></div><div class=row><cts-check-box name=NotMatchingContact label=contactNotMatching change=vm.ContactNotMatching checked=vm.ContactNotMatchingChecked></cts-check-box></div></fieldset><h3><a href=# translate>School</a></h3><fieldset><div class=row><cts-text-box name=SchoolName label=SchoolName data-ng-model=vm.query.iskNev></cts-text-box></div><div class=row><cts-text-box name=SchoolZIP label=SchoolZipCode data-ng-model=vm.query.iskIrSzam></cts-text-box></div><div class=row><cts-text-box name=SchoolVaros label=SchoolCity data-ng-model=vm.query.iskVaros></cts-text-box></div><div class=row><cts-text-box name=SchoolUtca label=SchoolStreet data-ng-model=vm.query.iskUtca></cts-text-box></div><div class=row><cts-text-box name=SchoolHazszam label=SchoolHouseNumber data-ng-model=vm.query.iskHazszam></cts-text-box></div><div class=row><cts-text-box name=SchoolPrincipal label=SchoolNameOfPrincipal data-ng-model=vm.query.igNeve></cts-text-box></div><div class=row><cts-text-box name=SchoolTestneveloNeve label=SchoolPETeacherName data-ng-model=vm.query.testnev></cts-text-box></div><div class=row><cts-text-box name=SchoolTestneveloElerh label=SchoolPETeacherContact data-ng-model=vm.query.testnevElerh></cts-text-box></div><div class=row><cts-text-box name=SchoolTestneveloEmail label=GymTeacherEmail data-ng-model=vm.query.testnevEmail></cts-text-box></div><div class=row><cts-text-box name=SchoolEvfolyam label=SchoolYear data-ng-model=vm.query.evfolyam></cts-text-box></div><div class=row><cts-text-box name=SchoolOsztaly label=SchoolClass data-ng-model=vm.query.osztaly></cts-text-box></div><div class=row><cts-text-box name=SchoolOsztFoNev label=SchoolHeadTeacherName data-ng-model=vm.query.osztFoNeve></cts-text-box></div><div class=row><cts-text-box name=SchoolOsztFoTel label=ClassMasterTel data-ng-model=vm.query.OfTel></cts-text-box></div><div class=row><cts-text-box name=SchoolOsztFoEmail label=ClassMasterEmail data-ng-model=vm.query.OfEmail></cts-text-box></div><div class=row><cts-check-box name=NotMatchingSchool label=schoolNotMatching change=vm.SchoolNotMatching checked=vm.SchoolNotMatchingChecked></cts-check-box></div></fieldset><h3><a href=# translate>ParentDatas</a></h3><fieldset><div class=row><cts-text-box name=MotherName label=motherName data-ng-model=vm.query.anyjaNeve></cts-text-box></div><div class=row><cts-text-box name=MotherContact label=motherContact data-ng-model=vm.query.anyjaElerh></cts-text-box></div><div class=row><cts-text-box name=MotherEmail label=MotherEmail data-ng-model=vm.query.AnyaEmail></cts-text-box></div><div class=row><cts-numeric-text-box name=MotherHeightFrom label=motherHeightFrom value=vm.query.anyjaMagTol></cts-numeric-text-box><cts-dropdown-list name=muvanyjaMagTol label="" datasource=vm.muv_REL_KOZ value=vm.query.muvanyjaMagTol></cts-dropdown-list><cts-numeric-text-box name=MotherHeightTo label=motherHeightTo value=vm.query.anyjaMagIg data-ng-if="vm.query.muvanyjaMagTol===\'K\xF6z\xF6tt\' && !vm.ParentNotMatchingChecked"></cts-numeric-text-box></div><div class=row><cts-text-box name=MotherSport label=motherAthletesPast data-ng-model=vm.query.anyjaSpMult></cts-text-box></div><div class=row><cts-text-box name=MotherMaidenName label=motherMaidenName data-ng-model=vm.query.anyjaLeanyNeve></cts-text-box></div><div class=row><cts-text-box name=MotherJob label=motherJob data-ng-model=vm.query.anyjaFoglalkozasa></cts-text-box><cts-text-box name=MothersWorkplace label=MothersWorkplace data-ng-model=vm.query.AnyaMunkahely></cts-text-box></div><div class=row><cts-text-box name=FatherName label=FatherName data-ng-model=vm.query.apaNeve></cts-text-box></div><div class=row><cts-text-box name=FatherContact label=FatherContact data-ng-model=vm.query.apaElerh></cts-text-box></div><div class=row><cts-text-box name=FatherEmail label=FatherEmail data-ng-model=vm.query.ApaEmail></cts-text-box></div><div class=row><cts-numeric-text-box name=FatherHeightFrom label=FatherHeightFrom value=vm.query.apaMagTol></cts-numeric-text-box><cts-dropdown-list name=muvapaMagTol label="" datasource=vm.muv_REL_KOZ value=vm.query.muvapaMagTol></cts-dropdown-list><cts-numeric-text-box name=FatherHeightTo label=FatherHeightTo value=vm.query.apaMagIg data-ng-if="vm.query.muvapaMagTol===\'K\xF6z\xF6tt\' && !vm.ParentNotMatchingChecked"></cts-numeric-text-box></div><div class=row><cts-text-box name=FatherSport label=fatherAthletePast data-ng-model=vm.query.apaSpMult></cts-text-box></div><div class=row><cts-text-box name=FatherJob label=fatherJob data-ng-model=vm.query.apaFoglalkozasa></cts-text-box><cts-text-box name=FathersWorkplace label=FathersWorkplace data-ng-model=vm.query.AnyaMunkahely></cts-text-box></div><div class=row><cts-check-box name=NotMatchingParent label=parentNotMatching change=vm.ParentNotMatching checked=vm.ParentNotMatchingChecked></cts-check-box></div></fieldset><h3><a href=# translate>BodyShape</a></h3><fieldset><div class=row><cts-numeric-text-box name=HeightFrom label=HeightFrom value=vm.query.testMagTol></cts-numeric-text-box><cts-dropdown-list name=muvtestMagTol label="" datasource=vm.muv_REL_KOZ value=vm.query.muvtestMagTol></cts-dropdown-list><cts-numeric-text-box name=HeightTo label=HeightTo value=vm.query.testMagIg data-ng-if="vm.query.muvtestMagTol===\'K\xF6z\xF6tt\'"></cts-numeric-text-box></div><div class=row><cts-numeric-text-box name=WeightFrom label=WeightFrom value=vm.query.testsulyTol></cts-numeric-text-box><cts-dropdown-list name=testsulyTol label="" datasource=vm.muv_REL_KOZ value=vm.query.muvtestsulyTol></cts-dropdown-list><cts-numeric-text-box name=WeightTo label=WeightTo value=vm.query.testSulyIg data-ng-if="vm.query.muvtestsulyTol===\'K\xF6z\xF6tt\'"></cts-numeric-text-box></div><div class=row><cts-numeric-text-box name=BMI label=BMIfrom value=vm.query.bmi></cts-numeric-text-box><cts-dropdown-list name=muvbmi label="" datasource=vm.muv_REL_KOZ value=vm.query.muvbmi></cts-dropdown-list><cts-numeric-text-box name=BMIig label=BMIto value=vm.query.bmiig data-ng-if="vm.query.muvbmi===\'K\xF6z\xF6tt\'"></cts-numeric-text-box></div><div class=row><cts-numeric-text-box name=ActHeightFrom label=actualHeightFrom value=vm.query.acttestMagTol></cts-numeric-text-box><cts-dropdown-list name=muvacttestMagTol label="" datasource=vm.muv_REL_KOZ value=vm.query.muvacttestMagTol></cts-dropdown-list><cts-numeric-text-box name=ActHeightTo label=actualHeightTo value=vm.query.acttestMagIg data-ng-if="vm.query.muvacttestMagTol===\'K\xF6z\xF6tt\'"></cts-numeric-text-box></div><div class=row><cts-numeric-text-box name=ActWeightFrom label=actualWeightFrom value=vm.query.acttestSulyTol></cts-numeric-text-box><cts-dropdown-list name=muvacttestSulyTol label="" datasource=vm.muv_REL_KOZ value=vm.query.muvacttestSulyTol></cts-dropdown-list><cts-numeric-text-box name=ActWeightTo label=actualWeightTo value=vm.query.acttestSulyIg data-ng-if="vm.query.muvacttestSulyTol===\'K\xF6z\xF6tt\'"></cts-numeric-text-box></div><div class=row><cts-numeric-text-box name=ActBMI label=actualBMIfrom value=vm.query.actbmi></cts-numeric-text-box><cts-dropdown-list name=muvactbmi label="" datasource=vm.muv_REL_KOZ value=vm.query.muvactbmi></cts-dropdown-list><cts-numeric-text-box name=ActBMIig label=actualBMIto value=vm.query.actbmiig data-ng-if="vm.query.muvactbmi===\'K\xF6z\xF6tt\'"></cts-numeric-text-box></div><div class=row><cts-dropdown-list name=BetterHand label=BetterHand datasource=vm.leftrightboth value=vm.query.ugyKez></cts-dropdown-list><cts-dropdown-list name=muvugyKez datasource=vm.muv_EGYEZIK_NEMEGYZIK value=vm.query.muvugyKez></cts-dropdown-list></div><div class=row><cts-dropdown-list name=BetterFoot label=BetterFoot datasource=vm.leftrightboth value=vm.query.ugyLab></cts-dropdown-list><cts-dropdown-list name=muvugyLab datasource=vm.muv_EGYEZIK_NEMEGYZIK value=vm.query.muvugyLab></cts-dropdown-list></div><div class=row><cts-check-box name=NotMatchingBodyShape label=bodyshapeNotMatching change=vm.BodyShapeNotMatching checked=vm.BodyShapeNotMatchingChecked></cts-check-box></div></fieldset><h3><a href=# translate>IdNumbers</a></h3><fieldset><div class=row><cts-text-box name=personalID label=PersonalID data-ng-model=vm.query.szemIgSzam></cts-text-box></div><div class=row><cts-text-box-taj-szam name=SocialSecurityNumber label=SocialSecurityNumber data-ng-model=vm.query.tajSzam></cts-text-box-taj-szam></div><div class=row><cts-text-box name=TaxNumber label=TaxNumber data-ng-model=vm.query.adoSzam></cts-text-box></div><div class=row><cts-text-box name=PassportNumber label=PassportNumber data-ng-model=vm.query.utlevelSzam></cts-text-box></div><div class=row><cts-text-box name=SchoolRegSzam label=SchoolRegistrationNumber data-ng-model=vm.query.regszam></cts-text-box></div><div class=row><cts-check-box name=NotMatchingIdNumbers label=idNumbersNotMatching change=vm.IdNumbersNotMatching checked=vm.IdNumbersNotMatchingChecked></cts-check-box></div></fieldset><h3><a href=# translate>Others</a></h3><fieldset><div class=row><cts-text-box name=Other label=Others data-ng-model=vm.query.egyeb></cts-text-box></div><div class=row><cts-dropdown-list name=havidijas label=HaviDijas datasource=vm.yesno value=vm.query.havidijas></cts-dropdown-list></div><div class=row><cts-dropdown-list name=oktdijas label=oktataDijas datasource=vm.yesno value=vm.query.oktdijas></cts-dropdown-list></div><div class=row><cts-text-box name=ChildhoodSport label=ChildhoodSport data-ng-model=vm.query.gyereksport></cts-text-box></div><div class=row><cts-text-box name=VacationActivity label=VacationActivity data-ng-model=vm.query.szunidElfogl></cts-text-box></div><div class=row><cts-text-box name=ChosenSports label=ChosenSports data-ng-model=vm.query.valSportagak></cts-text-box></div><div class=row><cts-date-picker name=SchoolKezdeteTol label=registrationTimeFrom value=vm.query.dsiKezdTol></cts-date-picker><cts-dropdown-list name=muvdsiKezdTol datasource=vm.muv_REL_KOZ value=vm.query.muvdsiKezdTol></cts-dropdown-list><cts-date-picker name=SchoolKezdeteIg label=registrationTimeTo value=vm.query.dsiKezdIg data-ng-if="vm.query.muvdsiKezdTol===\'K\xF6z\xF6tt\'"></cts-date-picker></div><div class=row><cts-date-picker name=SchoolKilepesTol label=exitTimeFrom value=vm.query.kiDatTol></cts-date-picker><cts-dropdown-list name=muvkiDatTol datasource=vm.muv_REL_KOZ value=vm.query.muvkiDatTol></cts-dropdown-list><cts-date-picker name=SchoolKilepesIg label=exitTimeTo value=vm.query.kiDatIg data-ng-if="vm.query.muvkiDatTol===\'K\xF6z\xF6tt\'"></cts-date-picker></div><div class=row><cts-text-box name=SchoolKilepesIndoka label=exitReason data-ng-model=vm.query.kilepIndoka></cts-text-box></div><div class=row><cts-text-box name=SchoolEddigiEdzoi label=FormerCoaches data-ng-model=vm.query.eddigiEdzoi></cts-text-box></div><div class=row><cts-text-box name=SchoolSportEgyesuletei label=fromerSportclubMemberships data-ng-model=vm.query.eddigiSpEgyes></cts-text-box></div><div class=row><cts-date-picker name=SchoolEdzesKezdTol label=trainingStartFrom value=vm.query.edzesKezdTol></cts-date-picker><cts-dropdown-list name=muvedzesKezdTol datasource=vm.muv_REL_KOZ value=vm.query.muvedzesKezdTol></cts-dropdown-list><cts-date-picker name=SchoolEdzesKezdIg label=trainingStartTo value=vm.query.edzesKezdIg data-ng-if="vm.query.muvedzesKezdTol===\'K\xF6z\xF6tt\'"></cts-date-picker></div></fieldset><h3><a href=# translate>ClothesSizes</a></h3><fieldset><div class=row><cts-text-box name=SlippersSize label=SlipperSize data-ng-model=vm.query.papucsMerete></cts-text-box></div><div class=row><cts-text-box name=JoggingSize label=JoggingSize data-ng-model=vm.query.melegitoMerete></cts-text-box></div><div class=row><cts-text-box name=BathrobeSize label=BathrobeSize data-ng-model=vm.query.furdokopenyMerete></cts-text-box></div><div class=row><cts-text-box name=CoatSize label=CoatSize data-ng-model=vm.query.kabatMerete></cts-text-box></div><div class=row><cts-text-box name=ArmorPantsSize label=ArmorPantsSize data-ng-model=vm.query.pancelNadragMerete></cts-text-box></div><div class=row><cts-text-box name=ShirtSize label=ShirtSize data-ng-model=vm.query.poloMerete></cts-text-box></div><div class=row><cts-text-box name=ShortsSize label=ShortsSize data-ng-model=vm.query.sortMerete></cts-text-box></div><div class=row><cts-text-box name=ShortsSize label=ShortsSize data-ng-model=vm.query.cipoMerete></cts-text-box></div><div class=row><cts-text-box name=ShortsSize label=ShortsSize data-ng-model=vm.query.uszonadragMerete></cts-text-box></div></fieldset></div><br><label><span translate>ColumnsOfResultTable</span></label><form class=filter name=form><div class=row><div ej-accordion e-enablemultipleopen=true id=accordion><h3><a href=# translate>General</a></h3><fieldset><div class=row><cts-check-box name=G1SzulHely label=BirthPlace checked=vm.query.kellSzulHely></cts-check-box><cts-check-box name=G1Szakosztaly label=Section checked=vm.query.kellszakosztalyId></cts-check-box><cts-check-box name=G1Korosztaly label=AgeGroup checked=vm.query.kellkorosztalyId></cts-check-box><cts-check-box name=G1Edzo label=Coach checked=vm.query.kelledzoId></cts-check-box><cts-check-box name=G1Neme label=Sex checked=vm.query.kellneme></cts-check-box><cts-check-box name=G1Nationality label=Nationality checked=vm.query.kellallamp></cts-check-box><cts-check-box name="G1Le\xE1nykori N\xE9v" label=MaidenName checked=vm.query.kellLeanykNev></cts-check-box><cts-check-box name=G1Aktiv label=Active checked=vm.query.kellaktiv></cts-check-box><cts-check-box name=G1Megjegyz\xE9s label=Comment checked=vm.query.kellmegjegyzes></cts-check-box></div></fieldset><h3><a href=# translate>Contact</a></h3><fieldset><div class=row><cts-check-box name=G2KellLakcim label=Address checked=vm.query.kelllakcim></cts-check-box><cts-check-box name=G2KellElerhetoseg label=Contact checked=vm.query.kellelerh></cts-check-box><cts-check-box name=G2KellEmail label=Email checked=vm.query.kellEmail></cts-check-box></div></fieldset><h3><a href=# translate>School</a></h3><fieldset><div class=row><cts-check-box name=G3__01 label=SchoolName checked=vm.query.kelliskNev></cts-check-box><cts-check-box name=G3__03 label=SchoolAddress checked=vm.query.kelliskCim></cts-check-box><cts-check-box name=G3__06 label=SchoolDirectorName checked=vm.query.kelligNeve></cts-check-box><cts-check-box name=G3__10 label=ClassMaster checked=vm.query.kellof></cts-check-box><cts-check-box name=G3__07 label=GymTeacher checked=vm.query.kelltestnev></cts-check-box><cts-check-box name=G3__08 label=GymTeacherContact checked=vm.query.kelltestnevElerh></cts-check-box><cts-check-box name=G3__09 label=CoursePerClass checked=vm.query.kellevfolyam></cts-check-box></div></fieldset><h3><a href=# translate>Parent\'s details</a></h3><fieldset><div class=row><cts-check-box name=G4mother label=MothersDetails checked=vm.query.kellAnyjaAdatai></cts-check-box><cts-check-box name=G4father label=FathersDetails checked=vm.query.kellApjaAdatai></cts-check-box></div></fieldset><h3><a href=# translate>Others</a></h3><fieldset><div class=row><cts-check-box name=G5 label=PhysicalConditions checked=vm.query.kelltestiAdottsagok></cts-check-box><cts-check-box name=G6 label=IDNumbers checked=vm.query.kellAzonositok></cts-check-box><cts-check-box name=G7_1 label=Fees checked=vm.query.kellhavidijas></cts-check-box><cts-check-box name=G7_2 label=ChildhoodSport checked=vm.query.kellGyermSp></cts-check-box><cts-check-box name=G7_3 label=VacationActivity checked=vm.query.kellSzunidei></cts-check-box><cts-check-box name=G3__11 label=StartMemberDate checked=vm.query.kellDSIKezd></cts-check-box><cts-check-box name=G3__12 label=TimeAndCauseOfLeaving checked=vm.query.kellKilepesDatum></cts-check-box><cts-check-box name=G3__14 label=CoachDetails checked=vm.query.kellEddigiEdzo></cts-check-box><cts-check-box name=G3__15 label=SportAssociation checked=vm.query.kellEddigiSp></cts-check-box><cts-check-box name=G3__16 label=RegistrationNumber checked=vm.query.kellNyilvSzam></cts-check-box><cts-check-box name=G3__17 label=SportServiceFee checked=vm.query.kellTagdijas></cts-check-box><cts-check-box name=G3__18 label=TrainingStart checked=vm.query.kellEdzJaras></cts-check-box></div></fieldset><h3><a href=# translate>Clothes</a></h3><fieldset><div class=row><cts-check-box name=G8_1 label=SlippersDetails checked=vm.query.kellpapucs></cts-check-box><cts-check-box name=G8_2 label=JoggingDetails checked=vm.query.kellmelegito></cts-check-box><cts-check-box name=G8_3 label=BathRobeDetails checked=vm.query.kellfurdokopeny></cts-check-box><cts-check-box name=G8_4 label=CoatDetails checked=vm.query.kellkabat></cts-check-box><cts-check-box name=G8_5 label=ArmorPantsDetails checked=vm.query.kellpancelNadrag></cts-check-box><cts-check-box name=G8_6 label=ShirtDetails checked=vm.query.kellpolo></cts-check-box><cts-check-box name=G8_7 label=ShortsDetails checked=vm.query.kellsort></cts-check-box><cts-check-box name=G8_7 label=ShoeDetails checked=vm.query.kellcipo></cts-check-box><cts-check-box name=G8_7 label=SwimmingPantDetails checked=vm.query.kelluszonadrag></cts-check-box></div></fieldset></div></div></form><div class=button-wrapper><button type=submit id=search class=cts-button ej-button e-click=vm.search translate>Search</button> <button type=reset id=reset class=cts-button ej-button e-click=vm.resetQueryDetails translate>ResetForm</button></div></div></form><script type=text/x-template id=searchmemberlistgotoathlete><a data-ng-click="vm.goToAthlete(${SportolokID})">${Nev}</a></script><div class=col-sm-12><div id=Grid></div></div></div><div class=widget-foot><div class=clearfix></div></div>');
$templateCache.put('app/search/athletes/simple/simple.html','<ht-widget-header title={{title}} text-id=simpleHelp right-text=rightText></ht-widget-header><div class=widget-content><form class=filter name=form><div class=row><div ej-accordion e-enablemultipleopen=true id=accordion><h3><a href=# translate>General</a></h3><fieldset><div class=row><cts-text-box name=name label=Name data-ng-model=vm.formData.name></cts-text-box><cts-dropdown-list name=sex label=Sex datasource=vm.sexList value=vm.formData.sex change=vm.changeSex clear=vm.cleaSex></cts-dropdown-list><cts-text-box name=citizenship label=Citizenship data-ng-model=vm.formData.citizenship></cts-text-box></div><div class=row><cts-dropdown-list name=sectionId label=Section value=vm.formData.sectionId databound=vm.sectionDataBound datasource=vm.sectionList select=vm.sectionSelect clear=vm.clearSection></cts-dropdown-list><cts-dropdown-list name=ageGroupId label=AgeGroup value=vm.formData.ageGroupId databound=vm.ageGroupDataBound datasource=vm.ageGroupList clear=vm.clearAgeGroup></cts-dropdown-list><cts-dropdown-list name=coachId label=Coach value=vm.formData.coachId databound=vm.coachDataBound datasource=vm.coachList clear=vm.clearCoach></cts-dropdown-list></div><div class=row><cts-text-box name=birthPlace label=BirthPlace data-ng-model=vm.formData.birthPlace></cts-text-box><cts-date-picker name=birthDateFrom label=BirthDateFrom value=vm.formData.birthDateFrom></cts-date-picker><cts-date-picker name=birthDateTo label=BirthDateTo value=vm.formData.birthDateTo></cts-date-picker></div><div class=row><cts-date-picker name=competitiveSportStart label=CompetitiveSportStart value=vm.formData.competitiveSportStart></cts-date-picker><cts-date-picker name=competitiveSportEnd label=CompetitiveSportEnd value=vm.formData.competitiveSportEnd></cts-date-picker></div></fieldset><h3><a href=# translate>Contact</a></h3><fieldset><div class=row><cts-dropdown-list name=county label=County value=vm.formData.county datasource=vm.countyList clear=vm.clearCounty></cts-dropdown-list><cts-text-box name=zipCode label=zipCode data-ng-model=vm.formData.zipCode></cts-text-box><cts-text-box name=city label=City data-ng-model=vm.formData.city></cts-text-box></div><div class=row><cts-text-box name=street label=Street data-ng-model=vm.formData.street></cts-text-box><cts-text-box name=streetNumber label=StreetNumber data-ng-model=vm.formData.StreeNumber></cts-text-box></div><div class=row><cts-text-box name=phoneNumber label=phoneNumber data-ng-model=vm.formData.contact></cts-text-box><cts-text-box-email name=email label=Email data-ng-model=vm.formData.email></cts-text-box-email></div></fieldset><h3><a href=# translate>School</a></h3><fieldset><div class=row><cts-text-box name=schoolName label=SchoolName data-ng-model=vm.formData.schoolName></cts-text-box></div><div class=row><cts-text-box name=schoolZipCode label=SchoolZipCode data-ng-model=vm.formData.schoolZipCode></cts-text-box><cts-text-box name=schoolCity label=SchoolCity data-ng-model=vm.formData.schoolCity></cts-text-box><cts-text-box name=schoolStreet label=SchoolStreet data-ng-model=vm.formData.schoolStreet></cts-text-box><cts-text-box name=schoolStreetNumber label=SchoolStreetNumber data-ng-model=vm.formData.schoolStreetNumber></cts-text-box></div><div class=row><cts-text-box name=directorName label=DirectorName data-ng-model=vm.formData.directorName></cts-text-box><cts-text-box name=classMaster label=ClassMaster data-ng-model=vm.formData.classMaster></cts-text-box><cts-text-box name=classMasterEmail label=ClassMasterEmail data-ng-model=vm.formData.OfEmail></cts-text-box><cts-text-box name=classMasterTel label=ClassMasterTel data-ng-model=vm.formData.OfTel></cts-text-box><cts-text-box name=gymTeacher label=GymTeacher data-ng-model=vm.formData.gymTeacher></cts-text-box><cts-text-box name=gymTeacherContact label=GymTeacherContact data-ng-model=vm.formData.gymTeacherContact></cts-text-box><cts-text-box name=gymTeacherEmail label=GymTeacherEmail data-ng-model=vm.formData.TestneveloEmail></cts-text-box></div><div class=row><cts-dropdown-list name=course label=Course value=vm.formData.course clear=vm.clearCourse datasource=vm.courseList></cts-dropdown-list><cts-dropdown-list name=class label=Class value=vm.formData.schoolClass clear=vm.clearClass datasource=vm.classList></cts-dropdown-list></div></fieldset><h3><a href=# translate>ParentDatas</a></h3><fieldset><div class=row><cts-text-box name=motherName label=MothersName data-ng-model=vm.formData.mothersName></cts-text-box><cts-text-box name=motherContact label=MotherContact data-ng-model=vm.formData.motherContact></cts-text-box><cts-text-box name=motherEmail label=MotherEmail data-ng-model=vm.formData.AnyaEmail></cts-text-box></div><div class=row><cts-numeric-text-box name=motherHeightFrom label=MotherHeightFrom value=vm.formData.motherHeightFrom></cts-numeric-text-box><cts-numeric-text-box name=motherHeightTo label=MotherHeightTo value=vm.formData.motherHeightTo></cts-numeric-text-box><cts-text-box name=MotherSportHistory label=MotherSportHistory data-ng-model=vm.formData.motherSportHistory></cts-text-box><cts-text-box name=mothersJob label=MothersJob data-ng-model=vm.formData.mothersJob></cts-text-box><cts-text-box name=mothersWorkplace label=MothersWorkplace data-ng-model=vm.formData.AnyaMunkahely></cts-text-box></div><div class=row><cts-text-box name=fatherName label=FatherName data-ng-model=vm.formData.fatherName></cts-text-box><cts-text-box name=fatherContact label=FatherContact data-ng-model=vm.formData.fatherContact></cts-text-box><cts-text-box name=fatherEmail label=FatherEmail data-ng-model=vm.formData.ApaEmail></cts-text-box></div><div class=row><cts-numeric-text-box name=fatherHeightFrom label=FatherHeightFrom value=vm.formData.fatherHeightFrom></cts-numeric-text-box><cts-numeric-text-box name=fatherHeightTo label=FatherHeightTo value=vm.formData.fatherHeightTo></cts-numeric-text-box><cts-text-box name=MotherSportHistory label=FatherSportHistory data-ng-model=vm.formData.fatherSportHistory></cts-text-box><cts-text-box name=fathersJob label=FathersJob data-ng-model=vm.formData.fatherJob></cts-text-box><cts-text-box name=fathersWorkplace label=FathersWorkplace data-ng-model=vm.formData.ApaMunkahely></cts-text-box></div></fieldset><h3><a href=# translate>BodyShape</a></h3><fieldset><div class=row><cts-numeric-text-box name=athleteHeightFrom label=HeightFrom value=vm.formData.heightFrom></cts-numeric-text-box><cts-numeric-text-box name=athleteHeightTo label=HeightTo value=vm.formData.heightTo></cts-numeric-text-box></div><div class=row><cts-numeric-text-box name=athleteWeightFrom label=WeightFrom value=vm.formData.weightFrom></cts-numeric-text-box><cts-numeric-text-box name=athleteWeightTo label=WeightTo value=vm.formData.weightTo></cts-numeric-text-box></div><div class=row><cts-dropdown-list name=betterHand label=BetterHand value=vm.formData.betterHand datasource=vm.betterHandList></cts-dropdown-list><cts-dropdown-list name=betterFoot label=BetterFoot value=vm.formData.betterFoot datasource=vm.betterFootList></cts-dropdown-list></div></fieldset><h3><a href=# translate>IdNumbers</a></h3><fieldset><div class=row><cts-text-box name=personalId label=PersonalId data-ng-model=vm.formData.identityNumber></cts-text-box><cts-text-box-taj-szam name=socialSecurityNumber label=SocialSecurityNumber data-ng-model=vm.formData.socialSecurityNumber></cts-text-box-taj-szam><cts-text-box-tax-id name=taxId label=taxId data-ng-model=vm.formData.taxNumber></cts-text-box-tax-id><cts-text-box-passport-number name=passportNumber label=PassportNumber data-ng-model=vm.formData.passportNumber></cts-text-box-passport-number></div></fieldset><h3><a href=# translate>Others</a></h3><fieldset><div class=row><cts-text-area name=Notes label=Notes data-ng-model=vm.formData.notes></cts-text-area><cts-check-box name=active label=Active checked=vm.formData.active></cts-check-box><cts-check-box name=inactive label=Inactive checked=vm.formData.inactive></cts-check-box><cts-check-box name=sportServiceFee label=SportServiceFee checked=vm.formData.sportServiceFee></cts-check-box><cts-check-box name=educationalFee label=EducationalFee checked=vm.formData.educationalFee></cts-check-box></div></fieldset><h3><a href=# translate>ClothesSizes</a></h3><fieldset><cts-text-box name=slippersSize label=SlipperSize data-ng-model=vm.formData.slipperSize></cts-text-box><cts-text-box name=joggingSuitSize label=JoggingSuitSize data-ng-model=vm.formData.joggingSuitSize></cts-text-box><cts-text-box name=bathrobeSize label=BathrobeSize data-ng-model=vm.formData.bathrobeSize></cts-text-box><cts-text-box name=coatSize label=CoatSize data-ng-model=vm.formData.coatSize></cts-text-box><cts-text-box name=armorPantSize label=ArmorPantSize data-ng-model=vm.formData.armorPantSize></cts-text-box><cts-text-box name=tShirtSize label=TShirtSize data-ng-model=vm.formData.tShirtSize></cts-text-box><cts-text-box name=shortDressSize label=ShortDressSize data-ng-model=vm.formData.shortDressSize></cts-text-box><cts-text-box name=shoeSize label=ShoeSize data-ng-model=vm.formData.shoeSize></cts-text-box><cts-text-box name=swimmingPantSize label=SwimmingPantSize data-ng-model=vm.formData.swimmingPantSize></cts-text-box></fieldset></div><div class=button-wrapper><button type=submit id=search class=cts-button ej-button e-click=vm.search translate>Search</button> <button type=reset id=reset class=cts-button ej-button e-click=vm.reset translate>ResetForm</button></div></div></form><script type=text/x-template id=simplecolumnTemplate1><a data-ng-click="vm.goToAthlete(${SportolokID})">${Nev}</a></script><script type=text/x-template id=simplecolumnTemplate2><a data-ng-click="vm.goToUser(${EdzoId})">${EdzoNeve}</a></script><div class=col-sm-12><div id=Grid></div></div></div><div class=widget-foot><div class=clearfix></div></div>');
$templateCache.put('app/settings/schoolManagement/addSchool/addSchool.html','<div class=widget-head><h2>{{title}}</h2></div><form novalidate name=form enctype=multipart/form-data><div class=row><div class=col-lg-8><br><cts-text-box name=SchoolName label=SchoolName data-ng-model=vm.newSchool.IskolaNeve validation-rules="{required: true, maxlength:100}"></cts-text-box><cts-text-box name=SchoolZipCode label=SchoolZipCode data-ng-model=vm.newSchool.IskolaIrSzam validation-rules="{required: false, maxlength:5}"></cts-text-box><cts-text-box name=SchoolCity label=SchoolCity data-ng-model=vm.newSchool.IskolaVaros validation-rules="{required: true, maxlength:50}"></cts-text-box><cts-text-box name=SchoolStreet label=SchoolStreet data-ng-model=vm.newSchool.IskolaUtca validation-rules="{required: false, maxlength:60}"></cts-text-box><cts-text-box name=SchoolHouseNumber label=SchoolHouseNumber data-ng-model=vm.newSchool.IskolaHazszam validation-rules="{required: false, maxlength:20}"></cts-text-box><cts-text-box name=SchoolDirectorName label=SchoolDirectorName data-ng-model=vm.newSchool.IskolaIgazgatoNeve validation-rules="{required: false, maxlength:60}"></cts-text-box></div><div class=col-lg-12 style="text-align: center; margin-top: 1.5em;"><button class=cts-button ej-button e-click=vm.saveSchool translate>Save</button> <button class=cts-button ej-button e-click=back translate>Cancel</button></div></div></form><div class=widget-foot><div class=clearfix></div></div>');
$templateCache.put('app/settings/schoolManagement/editSchool/editSchool.html','<div class=widget-head><h2>{{title}}</h2></div><form novalidate name=form enctype=multipart/form-data><div class=row><div class=col-lg-8><br><cts-text-box name=SchoolName label=SchoolName data-ng-model=vm.params.IskolaNeve validation-rules="{required: true, maxlength:100}"></cts-text-box><cts-text-box name=SchoolZipCode label=SchoolZipCode data-ng-model=vm.params.IskolaIrSzam validation-rules="{required: false, maxlength:5}"></cts-text-box><cts-text-box name=SchoolCity label=SchoolCity data-ng-model=vm.params.IskolaVaros validation-rules="{required: true, maxlength:50}"></cts-text-box><cts-text-box name=SchoolStreet label=SchoolStreet data-ng-model=vm.params.IskolaUtca validation-rules="{required: false, maxlength:60}"></cts-text-box><cts-text-box name=SchoolHouseNumber label=SchoolHouseNumber data-ng-model=vm.params.IskolaHazszam validation-rules="{required: false, maxlength:20}"></cts-text-box><cts-text-box name=SchoolDirectorName label=SchoolDirectorName data-ng-model=vm.params.IskolaIgazgatoNeve validation-rules="{required: false, maxlength:60}"></cts-text-box></div><div class=col-lg-12 style="text-align: center; margin-top: 1.5em;"><button class=cts-button ej-button e-click=vm.ModifySchool translate>Save</button> <button class=cts-button ej-button e-click=back translate>Cancel</button></div></div></form><div class=widget-foot><div class=clearfix></div></div>');
$templateCache.put('app/settings/schoolManagement/schoolList/schoolList.html','<ht-widget-header title={{title}} text-id=schoolListHelp right-text=rightText></ht-widget-header><script id=pagerTemplate type=text/x-template><div style="width: 100px"> <p style="float: left; margin:0; padding:0; line-height: 28px">Items per page:</p> <input style="float: left" type="text" ej-numerictextbox id="txtPageNumber" e-width="70px" stype="border: none; cursor: text" e-value="vm.pageSize"/> </div></script><div class=widget-content><button class=cts-button ej-button e-click=vm.goToAddSchool id=addSchool translate>addSchool</button> <button class=cts-button ej-button e-click=vm.goToEditSchool id=editSchool e-enabled=vm.editSchoolButtonEnabled translate>editSchool</button> <button class=cts-button ej-button e-click=vm.DeleteSchool id=deleteSchool e-enabled=vm.editSchoolButtonEnabled translate>deleteSchool</button><div class=row><br><div id=Grid name=Grid></div></div></div>');
$templateCache.put('app/settings/userManagement/modifyUser/modifyUser.html','<div class=widget-head><h2 class=page-title>{{title}}</h2></div><div class="widget-content form"><form name=form novalidate enctype=multipart/form-data><div class=row><div class=col-lg-12><div ej-accordion e-enablemultipleopen=true e-selecteditems=vm.selectedItems id=accordion><h3><a href=# translate>UserInformation</a></h3><fieldset class=col-lg-8><cts-text-box name=name label=Name data-ng-model=vm.formData.name validation-rules="{required: true, minlength: 3, maxlength: 80}"></cts-text-box><cts-dropdown-list name=userGroup label=UserGroup datasource=vm.userGroupList value=vm.formData.userGroupId change=vm.changeUserGroup validation-rules="{required: true, minlength: 1, maxlength: 50}"></cts-dropdown-list><cts-text-box name=loginName label=LoginName data-ng-model=vm.formData.loginName validation-rules="{required: true, minlength: 2, maxlength: 30}"></cts-text-box><cts-text-box type=email name=email label=EmailAddress data-ng-model=vm.formData.email validation-rules="{required: true, minlength: 7, maxlength: 50}" data-ng-if=!vm.LIMITEDUSER></cts-text-box><cts-text-box type=email name=email label=EmailAddress data-ng-model=vm.formData.email validation-rules="{required: false}" data-ng-if=vm.LIMITEDUSER></cts-text-box><cts-text-box type=password name=password label=Password data-ng-model=vm.formData.password validation-rules="{required: false, minlength: 5, maxlength: 10}"></cts-text-box><cts-text-box type=password name=passwordAgain label=PassordAgain data-ng-model=vm.passwordAgain validation-rules="{required: false, minlength: 5, maxlength: 10}"></cts-text-box><cts-date-picker name=passwordExpiryDate label=PasswordExpiryDate value=vm.formData.passwordExpiryDate></cts-date-picker><div class="form-group cts-form-group"><label translate>profilePic</label><div><div class=profileImg><img ng-src={{vm.photoUrl}} id=profilePic><div style="position: relative;"><button type=button class="btn cts-button" data-ng-click=vm.openCropDialog() translate>Modify</button> <button type=button class="btn cts-button cancel" data-ng-click=vm.deleteImg() data-ng-disabled="vm.photoUrl === vm.noImage" translate>Delete</button></div></div></div></div><cts-text-box name=address label=Address data-ng-model=vm.formData.address validation-rules="{required: true, minlength: 1, maxlength: 50}" data-ng-if=!vm.LIMITEDUSER></cts-text-box><cts-text-box name=address label=Address data-ng-model=vm.formData.address validation-rules="{required: false}" data-ng-if=vm.LIMITEDUSER></cts-text-box><cts-text-area name=contact label=Contact data-ng-model=vm.formData.contact validation-rules="{required: true, minlength: 1, maxlength: 1000}" data-ng-if=!vm.LIMITEDUSER></cts-text-area><cts-text-area name=contact label=Contact data-ng-model=vm.formData.contact validation-rules="{required: false}" data-ng-if=vm.LIMITEDUSER></cts-text-area><cts-text-box-taj-szam name=socialSecurityNumber label=SocialSecurityNumber data-ng-model=vm.formData.socialSecurityNumber validation-rules="{required: true, minlength: 9, maxlength: 11}" data-ng-if="!vm.LIMITEDUSER && vm.socialSecurityNumberRequiredValue"></cts-text-box-taj-szam><cts-text-box-taj-szam name=socialSecurityNumber label=SocialSecurityNumber data-ng-model=vm.formData.socialSecurityNumber validation-rules="{required: false}" data-ng-if="!vm.LIMITEDUSER && !vm.socialSecurityNumberRequiredValue"></cts-text-box-taj-szam><cts-text-box-taj-szam name=socialSecurityNumber label=SocialSecurityNumber data-ng-model=vm.formData.socialSecurityNumber validation-rules="{required: false}" data-ng-if=vm.LIMITEDUSER></cts-text-box-taj-szam><cts-color-picker name=colorPick label=CalendarColor value=vm.colorValue change=vm.colorChanged validation-rules="{required: true}"></cts-color-picker><cts-check-box name=monthlyAttendanceRegister label=monthlyAttendanceRegister change=vm.monthlyAttendanceRegisterChanged></cts-check-box><cts-check-box name=autoSaveCheckBox label=AutoSave checked=vm.formData.autoSave change=vm.autoSaveCheckboxChanged></cts-check-box><cts-dropdown-list name=sex label=Sex datasource=vm.sexList value=vm.formData.sex change=vm.changeSex validation-rules="{required: true}"></cts-dropdown-list><cts-check-box name=activeCheckBox label=Active checked=vm.activeValue change=vm.activeChange></cts-check-box></fieldset><h3><a href=# translate>ProfessionalInformation</a></h3><fieldset class=col-lg-8><cts-list-box name=sectionListBox label=SectionLeaderHere css-class=scroller-fix datasource=vm.sectionLeaderList show-checkbox=true check-change=vm.sectionLeaderChecked ng-show=vm.SZAKOSZTVEZADATLAP></cts-list-box><div ng-show=vm.EDZOADATLAP class="form-group cts-form-group"><label for=ageGroupTreeView translate>CoachHere</label><div class=input-group><div id=ageGroupTreeView name=ageGroupTreeView ej-treeview e-fields-datasource=vm.ageGroupList e-showcheckbox=true placeholder={{CoachHere|translate}} e-enabled=true e-height=200></div></div></div><cts-text-area name=mainWorkPlace label=MainWorkPlace data-ng-model=vm.formData.mainWorkPlace validation-rules="{required: true, maxlength: 500}" data-ng-if=!vm.LIMITEDUSER></cts-text-area><cts-text-area name=mainWorkPlace label=MainWorkPlace data-ng-model=vm.formData.mainWorkPlace validation-rules="{required: false}" data-ng-if=vm.LIMITEDUSER></cts-text-area><cts-text-area name=qualifications label=Qualifications data-ng-model=vm.formData.qualifications validation-rules="{required: true, maxlength: 500}" data-ng-if=!vm.LIMITEDUSER></cts-text-area><cts-text-area name=qualifications label=Qualifications data-ng-model=vm.formData.qualifications validation-rules="{required: false}" data-ng-if=vm.LIMITEDUSER></cts-text-area></fieldset><h3><a href=# translate>PersonalInformation</a></h3><fieldset class=col-lg-8><cts-text-box name=country label=BirthPlace cts-placeholder=Country data-ng-model=vm.formData.country></cts-text-box><cts-text-box name=city cts-placeholder=City data-ng-model=vm.formData.city></cts-text-box><cts-date-picker name=birthDate label=BirthDate value=vm.formData.birthDate></cts-date-picker><cts-text-box name=citizenship label=Citizenship data-ng-model=vm.formData.citizenship></cts-text-box><cts-text-box name=mothersName label=MothersName data-ng-model=vm.formData.mothersName></cts-text-box><cts-numeric-text-box name=heightDropDown label=Height datasource=vm.heightList value=vm.formData.height change=vm.changeHeight></cts-numeric-text-box><cts-numeric-text-box name=weightDropDown label=Weight datasource=vm.weightList value=vm.formData.weight change=vm.changeWeight></cts-numeric-text-box><cts-text-box name=identityCardNumber label=IdentityCardNumber data-ng-model=vm.formData.identityCardNumber></cts-text-box><cts-text-box name=passportNumber label=PassportNumber data-ng-model=vm.formData.passportNumber></cts-text-box><cts-text-area name=otherInformation label=OtherInformation data-ng-model=vm.formData.otherInformation></cts-text-area></fieldset><h3><a href=# translate>IssuedAssets</a></h3><fieldset class=col-lg-10><div class=col-sm-12 style="margin-top: 1.5em;"><div class=row><div id=UsersAssetGrid></div></div><div class=col-sm-12 style="text-align: center; margin-top: 1.5em;"><div style="width:50%; float:left;text-align:right"><cts-text-box name=TakeBackComment ng-if=vm.takebackEnabled label=TakeBackAssetComment data-ng-model=vm.TakeBackComment validation-rules="{required: false, minlength: 0, maxlength: 200}"></cts-text-box></div><div style="width:50%; float:right;"><button e-enabled=vm.takebackEnabled type=button class=cts-button ej-button e-click=vm.TakeBack translate>TakeBack</button></div></div></div></fieldset></div></div></div><div class=col-sm-12 style="text-align: center; margin-top: 1.5em;"><button type=submit class=cts-button ej-button e-click=vm.saveUser translate>Save</button> <button type=reset class=cts-button ej-button e-click=back translate>Cancel</button> <button type=button class=cts-button ej-button e-click=vm.goToFiles translate>Contracts</button> <button type=button class=cts-button e-enabled=vm.formData.activeUser ej-button e-click=vm.IssueAsset translate>IssueAsset</button></div></form></div><div class=widget-foot><div class=clearfix></div></div><div id=dialogContainer class=dialogContainer><div class=modalCell><div id=cropDialog class=cropDialog ej-dialog e-title=vm.cropDialogTitle e-width=350 e-showoninit=false e-enablemodal=true e-enableresize=false e-allowkeyboardnavigation=false e-closeonescape=true e-close=vm.closeCropDialog e-isresponsive=true e-enableanimation=true e-content=#dialogContainer e-showroundedcorner=false><div class=text-center><div class=modal-body><div><label for=fileName class="cts-button pull-left">{{\'ChooseImage\'|translate}}</label> <input style="display: none;" type=file accept=image/* img-cropper-fileread image=vm.cropper.sourceImage id=fileName><div><canvas id=canvas width=300 height=300 image-cropper image=vm.cropper.sourceImage cropped-image=vm.cropper.croppedImage crop-width=300 crop-height=300 keep-aspect=true touch-radius=30 crop-area-bounds=vm.bounds min-width=50 min-height=50></canvas></div></div></div><div class=modal-footer><button class="cts-button pull-left" data-ng-disabled=!vm.cropper.croppedImage data-ng-click=vm.doneCropDialog() type=button style="min-width: 100px;">{{\'OK\'|translate}}</button> <button class="cts-button pull-left" data-ng-click=vm.closeCropDialog() type=button style="min-width: 100px; margin-left: 5px;">{{\'Cancel\'|translate}}</button></div></div></div></div></div><div id=popup><div id=issueDialog ej-dialog e-title="Eszk\xF6z\xF6k kiad\xE1sa felhaszn\xE1l\xF3nak" e-showoninit=false e-enablemodal=true e-enableresize=false e-height=690px e-minheight=690px e-maxheight=690px e-allowkeyboardnavigation=false e-width=900px e-closeonescape=true e-isresponsive=true e-enableanimation=true e-showroundedcorner=false e-target=.widget-content><div class=col-sm-12 style="text-align: center; margin-top: 1.5em;"><cts-text-box name=IssueComment ng-if="vm.assets.length>0" label=IssueAssetComment data-ng-model=vm.IssueComment validation-rules="{required: false, minlength: 0, maxlength: 200}"></cts-text-box><button class=cts-button ej-button e-click=vm.Issue id=IssueBtn e-enabled=vm.chooseEnabled translate>Issue</button> <button class=cts-button ej-button e-click=vm.IssueNewAsset id=IssueNewBtn translate>IssueNew</button></div><div class=col-sm-12 style="text-align: center; margin-top: 1.5em;"><div id=AssetGrid name=AssetGrid></div></div></div></div>');
$templateCache.put('app/settings/userManagement/newUser/newUser.html','<div class=widget-head><h2 class=page-title>{{title}}</h2></div><div class="widget-content form"><form name=form novalidate enctype=multipart/form-data><div class=row><div class=col-lg-12><div ej-accordion e-enablemultipleopen=true e-selecteditems=vm.selectedItems id=accordion><h3><a href=# translate>UserInformation</a></h3><fieldset class=col-lg-8><cts-text-box name=name label=Name data-ng-model=vm.formData.name validation-rules="{required: true, minlength: 5, maxlength: 80}"></cts-text-box><cts-dropdown-list name=sex label=Sex datasource=vm.sexList value=vm.formData.sex change=vm.changeSex validation-rules="{required: true}"></cts-dropdown-list><cts-dropdown-list name=userGroup label=UserGroup datasource=vm.userGroupList value=vm.formData.userGroupId change=vm.changeUserGroup validation-rules="{required: true}"></cts-dropdown-list><cts-text-box name=loginName label=LoginName data-ng-model=vm.formData.loginName validation-rules="{required: true, minlength: 2, maxlength: 30}"></cts-text-box><cts-text-box type=email name=email label=EmailAddress data-ng-model=vm.formData.email validation-rules="{required: true, minlength: 7, maxlength: 30}"></cts-text-box><cts-text-box type=password name=password label=Password data-ng-model=vm.formData.password validation-rules="{required: true, minlength: 5, maxlength: 10}"></cts-text-box><cts-text-box type=password name=passwordAgain label=PassordAgain data-ng-model=vm.passwordAgain validation-rules="{required: true, minlength: 5, maxlength: 10}"></cts-text-box><cts-date-picker name=passwordExpiryDate label=PasswordExpiryDate value=vm.formData.passwordExpiryDate></cts-date-picker><div class="form-group cts-form-group"><label translate>profilePic</label><div><div class=profileImg><img ng-src={{vm.displayPhoto}} id=profilePic><div style="position: relative;"><button type=button class=cts-button data-ng-click=vm.openCropDialog() translate>Modify</button> <button type=button class="cts-button cancel" data-ng-click=vm.deleteImg() data-ng-disabled="vm.photoUrl === vm.noImage" translate>Delete</button></div></div></div></div><cts-text-box name=address label=Address data-ng-model=vm.formData.address validation-rules="{required: true, maxlength: 50}"></cts-text-box><cts-text-area name=contact label=Contact data-ng-model=vm.formData.contact validation-rules="{required: true, maxlength: 100}"></cts-text-area><cts-text-box-taj-szam name=socialSecurityNumber label=SocialSecurityNumber data-ng-model=vm.formData.socialSecurityNumber data-ng-if=vm.socialSecurityNumberRequiredValue validation-rules="{required: true, minlength: 9, maxlength: 11}"></cts-text-box-taj-szam><cts-text-box-taj-szam name=socialSecurityNumber label=SocialSecurityNumber data-ng-model=vm.formData.socialSecurityNumber data-ng-if=!vm.socialSecurityNumberRequiredValue validation-rules="{required: false}"></cts-text-box-taj-szam><cts-check-box name=monthlyAttendanceRegister label=monthlyAttendanceRegister change=vm.monthlyAttendanceRegisterChanged></cts-check-box><cts-check-box name=activeCheckBox label=Active checked=vm.activeValue change=vm.activeChange></cts-check-box></fieldset><h3><a href=# translate>ProfessionalInformation</a></h3><fieldset class=col-lg-8><cts-list-box name=sectionListBox label=SectionLeaderHere css-class=scroller-fix datasource=vm.sectionLeaderList show-checkbox=true check-change=vm.sectionLeaderChecked></cts-list-box><div class="form-group cts-form-group"><label for=ageGroupTreeView translate>CoachHere</label><div class=input-group><div id=ageGroupTreeView name=ageGroupTreeView ej-treeview e-fields-datasource=vm.ageGroupList e-showcheckbox=true placeholder={{CoachHere|translate}} e-height=200></div></div></div><cts-text-area name=mainWorkPlace label=MainWorkPlace data-ng-model=vm.formData.mainWorkPlace validation-rules="{required: true, maxlength: 500}"></cts-text-area><cts-text-area name=qualifications label=Qualifications data-ng-model=vm.formData.qualifications validation-rules="{required: true, maxlength: 500}"></cts-text-area></fieldset><h3><a href=# translate>PersonalInformation</a></h3><fieldset class=col-lg-8><cts-text-box name=country label=BirthPlace cts-placeholder=Country data-ng-model=vm.formData.country></cts-text-box><cts-text-box name=city cts-placeholder=City data-ng-model=vm.formData.city></cts-text-box><cts-date-picker name=birthDate label=BirthDate value=vm.formData.birthDate></cts-date-picker><cts-text-box name=citizenship label=Citizenship data-ng-model=vm.formData.citizenship></cts-text-box><cts-text-box name=mothersName label=MothersName data-ng-model=vm.formData.mothersName></cts-text-box><cts-numeric-text-box name=heightDropDown label=Height datasource=vm.heightList value=vm.formData.height change=vm.changeHeight></cts-numeric-text-box><cts-numeric-text-box name=weightDropDown label=Weight datasource=vm.weightList value=vm.formData.weight change=vm.changeWeight></cts-numeric-text-box><cts-text-box name=identityCardNumber label=IdentityCardNumber data-ng-model=vm.formData.identityCardNumber></cts-text-box><cts-text-box name=passportNumber label=PassportNumber data-ng-model=vm.formData.passportNumber></cts-text-box><cts-text-area name=otherInformation label=OtherInformation data-ng-model=vm.formData.otherInformation></cts-text-area></fieldset></div></div></div><div class=col-sm-12 style="text-align: center; margin-top: 1.5em;"><button type=submit class=cts-button ej-button e-click=vm.saveUser translate>Save</button> <button type=reset class=cts-button ej-button e-click=back translate>Cancel</button></div></form></div><div class=widget-foot><div class=clearfix></div></div><div id=dialogContainer class=dialogContainer><div class=modalCell><div id=cropDialog class=cropDialog ej-dialog e-title=vm.cropDialogTitle e-width=350 e-showoninit=false e-enablemodal=true e-enableresize=false e-allowkeyboardnavigation=false e-closeonescape=true e-close=vm.closeCropDialog e-isresponsive=true e-enableanimation=true e-content=#dialogContainer e-showroundedcorner=false><div class=text-center><div class=modal-body><div><label for=fileName class="cts-button pull-left">{{\'ChooseImage\'|translate}}</label> <input style="display: none;" type=file accept=image/* img-cropper-fileread image=vm.cropper.sourceImage id=fileName><div><canvas id=canvas width=300 height=300 image-cropper image=vm.cropper.sourceImage cropped-image=vm.cropper.croppedImage crop-width=300 crop-height=300 keep-aspect=true touch-radius=30 crop-area-bounds=vm.bounds min-width=50 min-height=50></canvas></div></div></div><div class=modal-footer><button class="cts-button pull-left" data-ng-disabled=!vm.cropper.croppedImage style="min-width: 100px;" data-ng-click=vm.doneCropDialog() type=button>{{\'OK\'|translate}}</button> <button class="cts-button pull-left" data-ng-click=vm.closeCropDialog() type=button style="margin-left: 5px; min-width: 100px;">{{\'Cancel\'|translate}}</button></div></div></div></div></div>');
$templateCache.put('app/settings/userManagement/userList/userList.html','<ht-widget-header title={{title}} text-id=userListHelp right-text=rightText></ht-widget-header><div class=widget-content><form class=filter><div class=row><div class="button-wrapper no-margin-top"><button id=NewUser class=cts-button ej-button e-click=vm.goToNewUser data-ng-enabled=vm.UJFELH translate>NewUser</button> <button id=SelectedDetails class=cts-button ej-button e-click=vm.goToUser data-ng-enabled=vm.MODFELH translate>Modify</button></div></div></form><script id=uslitemplateDataColumn1 type=text/x-template><a data-ng-click="vm.goToUser2(${Id})">${TeljesNev}</a></script><script id=uslitemplateDataColumn2 type=text/x-template><a data-ng-click="vm.goToGroup(${CsoportId})">${CsoportNeve}</a></script><script id=pagerTemplate type=text/x-template><div style="width: 100px"> <p style="float: left; margin:0; padding:0; line-height: 28px">Items per page:</p> <input style="float: left" type="text" ej-numerictextbox id="txtPageNumber" e-width="70px" stype="border: none; cursor: text" e-value="vm.pageSize" /> </div></script><div class=row data-ng-if="vm.userList.length !== 0"><div id=Grid class=slim-grid></div></div></div><div class=widget-foot><div class=clearfix></div></div>');
$templateCache.put('app/settings/userManagement/userSettings/userSettings.html','<div class=widget-head><h2 class=page-title>{{title}}</h2></div><div class="widget-content form"><form name=form novalidate enctype=multipart/form-data><div class=row><div class=col-lg-12><div ej-accordion e-enablemultipleopen=true e-selecteditems=vm.selectedItems id=accordion><h3><a href=# translate>SurfaceSettings</a></h3><fieldset class=col-lg-8><div><cts-check-box name=autoSaveInCheckBox label=AutoSaveInmonthlyAttendance checked=vm.formData.autoSave change=vm.autoSaveCheckboxChanged></cts-check-box></div><div><cts-dropdown-list name=GridRowNB label=gridRecordPerPage datasource=vm.recordPerPageList select=vm.recordPerPageSelect></cts-dropdown-list></div></fieldset><h3><a href=# translate>UserInformation</a></h3><fieldset id=generalFieldset name=generalFieldset class=col-lg-8><cts-text-box name=name label=Name data-ng-model=vm.formData.name validation-rules="{required: true, minlength: 3, maxlength: 80}"></cts-text-box><cts-text-box type=email name=email label=EmailAddress data-ng-model=vm.formData.email validation-rules="{required: true, minlength: 7, maxlength: 50}" data-ng-if=!vm.LIMITEDUSER></cts-text-box><cts-text-box type=email name=email label=EmailAddress data-ng-model=vm.formData.email validation-rules="{required: false}" data-ng-if=vm.LIMITEDUSER></cts-text-box><cts-text-box type=password name=password label=Password data-ng-model=vm.formData.password validation-rules="{required: false, minlength: 5, maxlength: 10}"></cts-text-box><cts-text-box type=password name=passwordAgain label=PassordAgain data-ng-model=vm.passwordAgain validation-rules="{required: false, minlength: 5, maxlength: 10}"></cts-text-box><div class="form-group cts-form-group"><label translate>profilePic</label><div><div class=profileImg><img ng-src={{vm.photoUrl}} id=profilePic> <button type=button class="btn btn-primary" data-ng-click=vm.openCropDialog() translate>Modify</button> <button type=button class="btn btn-primary" data-ng-click=vm.deleteImg() data-ng-disabled="vm.photoUrl === vm.noImage" translate>Delete</button></div></div></div><cts-text-area name=contact label=Contact data-ng-model=vm.formData.contact validation-rules="{required: true, minlength: 1, maxlength: 1000}" data-ng-if=!vm.LIMITEDUSER></cts-text-area><cts-text-area name=contact label=Contact data-ng-model=vm.formData.contact validation-rules="{required: false}" data-ng-if=vm.LIMITEDUSER></cts-text-area></fieldset><h3><a href=# translate>PersonalInformation</a></h3><fieldset id=personalFieldset name=personalFieldset class=col-lg-8><cts-text-box name=country label=BirthPlace cts-placeholder=Country data-ng-model=vm.formData.country></cts-text-box><cts-text-box name=city cts-placeholder=City data-ng-model=vm.formData.city></cts-text-box><cts-date-picker name=birthDate label=BirthDate value=vm.formData.birthDate></cts-date-picker><cts-text-box name=citizenship label=Citizenship data-ng-model=vm.formData.citizenship></cts-text-box><cts-text-box name=mothersName label=MothersName data-ng-model=vm.formData.mothersName></cts-text-box><cts-numeric-text-box name=heightDropDown label=Height datasource=vm.heightList value=vm.formData.height change=vm.changeHeight></cts-numeric-text-box><cts-numeric-text-box name=weightDropDown label=Weight datasource=vm.weightList value=vm.formData.weight change=vm.changeWeight></cts-numeric-text-box><cts-text-area name=otherInformation label=OtherInformation data-ng-model=vm.formData.otherInformation></cts-text-area></fieldset></div></div><div class=col-sm-12 style="text-align: center; margin-top: 1.5em;"><button type=submit class=cts-button ej-button e-click=vm.saveUser translate>Save</button> <button type=reset class=cts-button ej-button e-click=back translate>Cancel</button></div></div></form></div><div class=widget-foot><div class=clearfix></div></div><div id=dialogContainer class=dialogContainer><div class=modalCell><div id=cropDialog class=cropDialog ej-dialog e-title=vm.cropDialogTitle e-width=350 e-showoninit=false e-enablemodal=true e-enableresize=false e-allowkeyboardnavigation=false e-closeonescape=true e-close=vm.closeCropDialog e-isresponsive=true e-enableanimation=true e-content=#dialogContainer e-showroundedcorner=false><div class=text-center><div class=modal-body><div><label for=fileName class="cts-button pull-left">{{\'ChooseImage\'|translate}}</label> <input style="display: none;" type=file accept=image/* img-cropper-fileread image=vm.cropper.sourceImage id=fileName><div><canvas id=canvas width=300 height=300 image-cropper image=vm.cropper.sourceImage cropped-image=vm.cropper.croppedImage crop-width=300 crop-height=300 keep-aspect=true touch-radius=30 crop-area-bounds=vm.bounds min-width=50 min-height=50></canvas></div></div></div><div class=modal-footer><button class="cts-button pull-left" data-ng-disabled=!vm.cropper.croppedImage data-ng-click=vm.doneCropDialog() type=button style="min-width: 100px;">{{\'OK\'|translate}}</button> <button class="cts-button pull-left" data-ng-click=vm.closeCropDialog() type=button style="min-width: 100px; margin-left: 5px;">{{\'Cancel\'|translate}}</button></div></div></div></div></div>');
$templateCache.put('app/athletes/athletesManagement/athleteModify/anthropometry/anthropometry.html','<form class=filter name=form novalidate><div class=row style="margin-bottom: 1.5em;"><div class=button-wrapper><button type=button class=cts-button ej-button e-click=vm.newAnthropometryTest translate>NewAnthropometryTest</button> <button type=button class=cts-button ej-button e-click=vm.oldAnthropometryTest translate>OldAnthropometryTests</button></div></div><div class=row style="margin-bottom: 3em;"><div class=col-sm-12><p><b translate>AthletesData:</b></p></div><div class=col-sm-6><cts-text-box name=athletesName label=AthletesName data-ng-model=vm.formData.SportoloNeve validation-rules="{required: true}" style="width: 100%;"></cts-text-box><cts-text-box name=athletesAddress label=AthletesAddress data-ng-model=vm.formData.SportoloLakcim style="width: 100%;"></cts-text-box><cts-date-picker name=birthDate label=BirthDate value=vm.formData.SzuletesiIdo style="width: 100%;"></cts-date-picker><cts-date-picker name=endOfPuberty label=EndOfPuberty value=vm.formData.PubertaskorVege style="width: 100%;"></cts-date-picker></div><div class=col-sm-6><cts-text-area name=chosenSports label=ChosenSports data-ng-model=vm.formData.ValasztottSportagak style="width: 100%;"></cts-text-area></div></div><div class=row style="margin-bottom: 3em;"><div class=col-sm-12><p><b translate>testDetails:</b></p></div><div class=col-sm-4><cts-text-box name=testsName label=TestsName data-ng-model=vm.formData.Felmeres style="width: 100%"></cts-text-box><cts-text-box name=group label=Group data-ng-model=vm.formData.Csoport style="width: 100%;"></cts-text-box><cts-date-picker name=testsDate label=TestsDate value=vm.formData.MeresDatuma style="width: 100%;" validation-rules="{required: true}"></cts-date-picker></div><div class=col-sm-4><div class="form-group cts-form-group" style="width: 100%;"><label translate>Logo</label><div><div class=profileImg><img ng-src={{vm.photoUrl}} id=profilePic> <button type=button class="btn btn-primary" data-ng-click=vm.openCropDialog() translate>Modify</button> <button type=button class="btn btn-primary" data-ng-click=vm.deleteImg() data-ng-disabled="vm.photoUrl === vm.noImage" translate>Delete</button></div></div></div></div><div class=col-sm-4><cts-text-area name=clubsNameAddress label=ClubsNameAddress data-ng-model=vm.formData.VizsgalatotKeroNeveCime style="width: 100%;"></cts-text-area></div></div><div class=row style="margin-bottom: 3em;"><div class=col-sm-9><div class=row><p><b translate>habitDatas:</b></p></div><div class=row><div class=col-sm-3><cts-numeric-text-box name=TTM label=TTM value=vm.formData.TTM tab-index=1 validation-rules="{required: true, minlength: 40, maxlength: 250}" focusout=vm.focusOut style="width: 100%;" decimalplaces=2></cts-numeric-text-box></div><div class=col-sm-3><cts-numeric-text-box name=VAS label=VAS value=vm.formData.VAS tab-index=5 validation-rules="{required: true, minlength: 15, maxlength: 60}" focusout=vm.focusOut style="width: 100%;" decimalplaces=2></cts-numeric-text-box></div><div class=col-sm-3><cts-numeric-text-box name=MKK label=MKK value=vm.formData.MKK tab-index=9 validation-rules="{required: true, minlength: 40, maxlength: 150}" focusout=vm.focusOut style="width: 100%;" decimalplaces=2></cts-numeric-text-box></div><div class=col-sm-3><cts-numeric-text-box name=KZK label=KZK value=vm.formData.KZK tab-index=14 validation-rules="{required: true, minlength: 10, maxlength: 40}" focusout=vm.focusOut style="width: 100%;" decimalplaces=2></cts-numeric-text-box></div></div><div class=row><div class=col-sm-3><cts-numeric-text-box name=TTS label=TTS value=vm.formData.TTS tab-index=2 validation-rules="{required: true, minlength: 15, maxlength: 150}" focusout=vm.focusOut style="width: 100%;" decimalplaces=2></cts-numeric-text-box></div><div class=col-sm-3><cts-numeric-text-box name=MKS label=MKS value=vm.formData.MKS tab-index=6 validation-rules="{required: true, minlength: 15, maxlength: 50}" focusout=vm.focusOut style="width: 100%;" decimalplaces=2></cts-numeric-text-box></div><div class=col-sm-3><cts-numeric-text-box name=FFK label=FFK value=vm.formData.FFK tab-index=10 validation-rules="{required: true, minlength: 10, maxlength: 50}" focusout=vm.focusOut style="width: 100%;" decimalplaces=2></cts-numeric-text-box></div><div class=col-sm-3><cts-numeric-text-box name=COK label=COK value=vm.formData.COK tab-index=15 validation-rules="{required: true, minlength: 20, maxlength: 80}" focusout=vm.focusOut style="width: 100%;" decimalplaces=2></cts-numeric-text-box></div></div><div class=row><div class=col-sm-3><cts-numeric-text-box name=HUS label=HUS value=vm.formData.HUS tab-index=3 validation-rules="{required: true, minlength: 3, maxlength: 15}" focusout=vm.focusOut style="width: 100%;" decimalplaces=2></cts-numeric-text-box></div><div class=col-sm-3><cts-numeric-text-box name=MMG label=MMG value=vm.formData.MMG tab-index=7 validation-rules="{required: true, minlength: 3, maxlength: 30}" focusout=vm.focusOut style="width: 100%;" decimalplaces=2></cts-numeric-text-box></div><div class=col-sm-3><cts-numeric-text-box name=FK label=FK value=vm.formData.FK tab-index=11 validation-rules="{required: true, minlength: 10, maxlength: 50}" focusout=vm.focusOut style="width: 100%;" decimalplaces=2></cts-numeric-text-box></div><div class=col-sm-3><cts-numeric-text-box name=ASK label=ASK value=vm.formData.ASK tab-index=16 validation-rules="{required: true, minlength: 15, maxlength: 60}" focusout=vm.focusOut style="width: 100%;" decimalplaces=2></cts-numeric-text-box></div></div><div class=row><div class=col-sm-3><cts-numeric-text-box name=TDS label=TDS value=vm.formData.TDS tab-index=4 validation-rules="{required: true, minlength: 5, maxlength: 20}" focusout=vm.focusOut style="width: 100%;" decimalplaces=2></cts-numeric-text-box></div><div class=col-sm-3><cts-numeric-text-box name=CRS label=CRS value=vm.formData.CRS tab-index=8 validation-rules="{required: true, minlength: 19, maxlength: 60}" focusout=vm.focusOut style="width: 100%;" decimalplaces=2></cts-numeric-text-box></div><div class=col-sm-3><cts-numeric-text-box name=AKK label=AKK value=vm.formData.AKK tab-index=12 validation-rules="{required: true, minlength: 10, maxlength: 40}" focusout=vm.focusOut style="width: 100%;" decimalplaces=2></cts-numeric-text-box></div><div class=col-sm-3><cts-numeric-text-box name=BOK label=BOK value=vm.formData.BOK tab-index=17 validation-rules="{required: true, minlength: 10, maxlength: 40}" focusout=vm.focusOut style="width: 100%;" decimalplaces=2></cts-numeric-text-box></div></div><div class=row><div class="col-sm-3 col-sm-offset-6"><cts-numeric-text-box name=CUK label=CUK value=vm.formData.CUK tab-index=13 validation-rules="{required: true, minlength: 7, maxlength: 30}" focusout=vm.focusOut style="width: 100%;" decimalplaces=2></cts-numeric-text-box></div></div><div class=row><div class=col-sm-3><cts-numeric-text-box name=BR label=BR value=vm.formData.BR tab-index=18 validation-rules="{required: true, minlength: 1, maxlength: 40}" focusout=vm.focusOut style="width: 100%;" decimalplaces=2></cts-numeric-text-box></div><div class=col-sm-3><cts-numeric-text-box name=TR label=TR value=vm.formData.TR tab-index=19 validation-rules="{required: true, minlength: 1, maxlength: 50}" focusout=vm.focusOut style="width: 100%;" decimalplaces=2></cts-numeric-text-box></div><div class=col-sm-3><cts-numeric-text-box name=LPR label=LPR value=vm.formData.LR tab-index=20 validation-rules="{required: true, minlength: 1, maxlength: 50}" focusout=vm.focusOut style="width: 100%;" decimalplaces=2></cts-numeric-text-box></div><div class=col-sm-3><cts-numeric-text-box name=CSR label=CSR value=vm.formData.CSR tab-index=21 validation-rules="{required: true, minlength: 1, maxlength: 50}" focusout=vm.focusOut style="width: 100%;" decimalplaces=2></cts-numeric-text-box></div></div><div class=row><div class=col-sm-3><cts-numeric-text-box name=HR label=HR value=vm.formData.HR tab-index=22 validation-rules="{required: true, minlength: 1, maxlength: 60}" focusout=vm.focusOut style="width: 100%;" decimalplaces=2></cts-numeric-text-box></div><div class=col-sm-3><cts-numeric-text-box name=COR label=COR value=vm.formData.COR tab-index=23 validation-rules="{required: true, minlength: 1, maxlength: 60}" focusout=vm.focusOut style="width: 100%;" decimalplaces=2></cts-numeric-text-box></div><div class=col-sm-3><cts-numeric-text-box name=MSR label=MSR value=vm.formData.MSR tab-index=24 validation-rules="{required: true, minlength: 1, maxlength: 60}" focusout=vm.focusOut style="width: 100%;" decimalplaces=2></cts-numeric-text-box></div></div></div><div class=col-sm-2><div class=row><p><b translate>H-C komp.:</b></p></div><div class=row><cts-numeric-text-box name=endomorfia label=Endomorph value=vm.formData.Endomorfia style="width: 100%;" decimalplaces=2 enabled=vm.ANTRKIERT></cts-numeric-text-box></div><div class=row><cts-numeric-text-box name=mezomorfia label=Mesomorph value=vm.formData.Mezomorfia style="width: 100%;" decimalplaces=2 enabled=vm.ANTRKIERT></cts-numeric-text-box></div><div class=row><cts-numeric-text-box name=ektomorfia label=Ectomorph value=vm.formData.Ektomorfia style="width: 100%;" decimalplaces=2 enabled=vm.ANTRKIERT></cts-numeric-text-box></div><div class=row style="margin-top: 109px;"><p style="text-overflow: ellipsis;white-space: nowrap;overflow: hidden;"><b translate>Conradindexes:</b></p></div><div class=row><cts-numeric-text-box name=metrikus label=Metric value=vm.formData.MetrikusConradIndex style="width: 100%;" decimalplaces=2 enabled=vm.ANTRKIERT></cts-numeric-text-box></div><div class=row><cts-numeric-text-box name=plasztikus label=Plastic value=vm.formData.PlasztikusConradIndex style="width: 100%;" decimalplaces=2 enabled=vm.ANTRKIERT></cts-numeric-text-box></div></div></div><div class=row style="margin-bottom: 3em;"><div class=row><p><b translate>Drinkwaterfunctions:</b></p></div><div class=row><div style=float:left;width:11.11%;><cts-numeric-text-box name=DFDC label=DC value=vm.formData.DFDC style="width: 100%;" decimalplaces=2 enabled=vm.ANTRKIERT></cts-numeric-text-box></div><div style=float:left;width:11.11%;margin-left:11.11%;><cts-numeric-text-box name=DFTZSSzazalek label=TZSPercent value=vm.formData.DFTZSSzazalek style="width: 100%;" decimalplaces=2 enabled=vm.ANTRKIERT></cts-numeric-text-box></div><div style=float:left;width:11.11%;><cts-numeric-text-box name=DFTTS label=TTS value=vm.formData.DFTTS style="width: 100%;" decimalplaces=2 enabled=vm.ANTRKIERT></cts-numeric-text-box></div><div style=float:left;width:11.11%;><cts-numeric-text-box name=DFDelta label=Delta value=vm.formData.DFDelta style="width: 100%;" decimalplaces=2 enabled=vm.ANTRKIERT></cts-numeric-text-box></div><div style=float:left;width:11.11%;><cts-numeric-text-box name=DFBZS label=BZS value=vm.formData.DFBZS style="width: 100%;" decimalplaces=2 enabled=vm.ANTRKIERT></cts-numeric-text-box></div><div style=float:left;width:11.11%;><cts-numeric-text-box name=DFBCS label=BCS value=vm.formData.DFBCS style="width: 100%;" decimalplaces=2 enabled=vm.ANTRKIERT></cts-numeric-text-box></div><div style=float:left;width:11.11%;><cts-numeric-text-box name=DFBI label=BI value=vm.formData.DFBI style="width: 100%;" decimalplaces=2 enabled=vm.ANTRKIERT></cts-numeric-text-box></div><div style=float:left;width:11.11%;><cts-numeric-text-box name=DFBZSR label=BZSR value=vm.formData.DFBZSR style="width: 100%;" decimalplaces=2 enabled=vm.ANTRKIERT></cts-numeric-text-box></div></div><div class=row><div style=float:left;width:11.11%;><cts-numeric-text-box name=DFBF label=BF value=vm.formData.DFBF style="width: 100%;" decimalplaces=2 enabled=vm.ANTRKIERT></cts-numeric-text-box></div><div style=float:left;width:11.11%;><cts-numeric-text-box name=DFDCBF label=DC-BF value=vm.formData.DFDCBF style="width: 100%;" decimalplaces=2 enabled=vm.ANTRKIERT></cts-numeric-text-box></div><div style=float:left;width:11.11%;><cts-numeric-text-box name=DFVTM label=VTM value=vm.formData.DFVTM style="width: 100%;" decimalplaces=2 enabled=vm.ANTRKIERT></cts-numeric-text-box></div><div style=float:left;width:11.11%;><cts-numeric-text-box name=DFBTTS label=BTTS value=vm.formData.DFBTTS style="width: 100%;" decimalplaces=2 enabled=vm.ANTRKIERT></cts-numeric-text-box></div><div style=float:left;width:11.11%;><cts-numeric-text-box name=DFDELTASzazalek label=DELTAPercent value=vm.formData.DFDELTASzazalek style="width: 100%;" decimalplaces=2 enabled=vm.ANTRKIERT></cts-numeric-text-box></div><div style=float:left;width:11.11%;><cts-numeric-text-box name=DFBZSSzazalek label=BZSPercent value=vm.formData.DFBZSSzazalek style="width: 100%;" decimalplaces=2 enabled=vm.ANTRKIERT></cts-numeric-text-box></div><div style=float:left;width:11.11%;><cts-numeric-text-box name=DFBCSSzazalek label=BCSPercent value=vm.formData.DFBCSSzazalek style="width: 100%;" decimalplaces=2 enabled=vm.ANTRKIERT></cts-numeric-text-box></div><div style=float:left;width:11.11%;><cts-numeric-text-box name=DFBISzazalek label=BIPercent value=vm.formData.DFBISzazalek style="width: 100%;" decimalplaces=2 enabled=vm.ANTRKIERT></cts-numeric-text-box></div><div style=float:left;width:11.11%;><cts-numeric-text-box name=DFBZSRSzazalek label=VBZSRPercent value=vm.formData.DFBZSRSzazalek style="width: 100%;" decimalplaces=2 enabled=vm.ANTRKIERT></cts-numeric-text-box></div></div></div><div class=row style="margin-bottom: 3em;"><div class=row><p><b translate>Rating:</b></p></div><cts-text-box name=testalkat label=Physique data-ng-model=vm.formData.Testalkat disabled=!vm.ANTRKIERT></cts-text-box><cts-text-box name=sulyfelesleg label=Overweight data-ng-model=vm.formData.Sulyfelesleg disabled=!vm.ANTRKIERT></cts-text-box><cts-text-box name=erosithetoseg label=Hardenability data-ng-model=vm.formData.Erosithetoseg disabled=!vm.ANTRKIERT></cts-text-box><cts-text-box name=varhatoTestmagassag label=HeightForAge data-ng-model=vm.formData.VarhatoTestmagassag disabled=!vm.ANTRKIERT></cts-text-box></div><div class=row><div class=row><p><b translate>NotionSuggession:</b></p></div><div class=col-sm-6><cts-text-area name=szakertoiVelemeny label=ExpertOpinion data-ng-model=vm.formData.SzakertoiVelemeny style="width: 100%;" disabled=!vm.ANTRKIERT></cts-text-area></div><div class=col-sm-6><cts-text-area name=ajanlottSportagak label=RecommendedSports data-ng-model=vm.formData.AjanlottSportagak style="width: 100%;" disabled=!vm.ANTRKIERT></cts-text-area></div></div></form><div class="col-sm-12 back" style="text-align: center"><button type=submit class=cts-button ej-button e-click=vm.saveForm tabindex=25 translate>Save</button> <button type=reset class=cts-button ej-button e-click=back translate>Back</button> <button class=cts-button id=print ej-button e-click=vm.print type=button data-ng-if=vm.REGIFELMERES translate>Print</button></div><div id=printDialoganthtest2><report report-name=TAntropometriaNyomtatasReport report-parameters=vm.reportParameters></report></div><div id=dialogContainer class=dialogContainer><div class=modalCell><div id=cropDialog class=cropDialog ej-dialog e-title=vm.cropDialogTitle e-width=350 e-showoninit=false e-enablemodal=true e-enableresize=false e-allowkeyboardnavigation=false e-closeonescape=true e-close=vm.closeCropDialog e-isresponsive=true e-enableanimation=true e-content=#dialogContainer e-showroundedcorner=false><div class=text-center><div class=modal-body><div><label for=fileName class="cts-button pull-left">{{\'ChooseImage\'|translate}}</label> <input style="display: none;" type=file accept=image/* img-cropper-fileread image=vm.cropper.sourceImage id=fileName><div><canvas id=canvas width=300 height=300 image-cropper image=vm.cropper.sourceImage cropped-image=vm.cropper.croppedImage crop-width=300 crop-height=300 keep-aspect=true touch-radius=30 crop-area-bounds=vm.bounds min-width=50 min-height=50></canvas></div></div></div><div class=modal-footer><button class="cts-button pull-left" data-ng-disabled=!vm.cropper.croppedImage style="min-width: 100px;" data-ng-click=vm.doneCropDialog() type=button>{{\'OK\'|translate}}</button> <button class="cts-button pull-left" data-ng-click=vm.closeCropDialog() type=button style="margin-left: 5px; min-width: 100px;">{{\'Cancel\'|translate}}</button></div></div></div></div><div id=oldAnthropometryTestsWindow ej-dialog e-title=vm.oldAnthropometryTestTitle e-showoninit=false e-enablemodal=true e-enableresize=false e-allowkeyboardnavigation=false e-closeonescape=true e-isresponsive=true e-close=vm.closeWindow e-content=#dialogContainer e-enableanimation=true e-width=800px e-showroundedcorner=false><div class=modal-body><div class=text-center><div id=GridPopup class=slim-grid></div></div></div><div class=text-center><button class=cts-button id=done ej-button e-click=vm.selectTest type=button>Rendben</button> <button class=cts-button id=cancel ej-button e-click=vm.closeWindow type=button>M\xE9gsem</button></div></div></div>');
$templateCache.put('app/athletes/athletesManagement/athleteModify/athleteFees/athleteFees.html','<div class=row><script type=text/x-template id=feearrearscolumnTemplate1><a data-ng-click="vm.goToAthlete(${VersenyzoId})">${VersenyzoNeve}</a></script><script type=text/x-template id=feearrearscolumnTemplate2><a data-ng-click="vm.openCoach(${EdzoId})">${EdzoNeve}</a></script><div id=Grid class=slim-grid></div></div>');
$templateCache.put('app/athletes/athletesManagement/athleteModify/athleteLog/athleteLog.html','<form name=form class=filter><div style="overflow: hidden;"><cts-date-picker name=datepickerfrom label=DateFrom change=vm.dateFromChanged value=vm.dateFrom></cts-date-picker><cts-date-picker name=datepickerto label=DateTo change=vm.dateToChanged value=vm.dateTo></cts-date-picker></div></form><div id=Grid class=slim-grid></div>');
$templateCache.put('app/athletes/athletesManagement/athleteModify/athletesAssets/athletesAssets.html','<div class=row id=kiadottoldal><h4 translate style="padding-left: 1em;">AthletesAssets</h4><div class=col-sm-12 style="margin-top: 1.5em;"><div id=AthletesAssetGrid class=slim-grid></div><div class=col-sm-12 style="margin-top: 1.5em;"><div style="width:50%; float:left; text-align:right; padding-right: 0.5em;"><cts-text-box name=TakeBackComment label=TakeBackAssetComment data-ng-model=vm.TakeBackComment validation-rules="{required: false, minlength: 0, maxlength: 200}"></cts-text-box></div><div style="width:50%; float:right; margin-top:20px;"><button type=button class=cts-button ej-button e-click=vm.TakeBack translate>TakeBack</button> <button type=button class=cts-button ej-button e-click=vm.IssueAsset translate>IssueAsset</button></div></div></div></div><div id=popup><div id=issueDialog ej-dialog e-title="Eszk\xF6z\xF6k kiad\xE1sa sportol\xF3nak" e-showoninit=false e-enablemodal=true e-enableresize=false e-height=690px e-minheight=690px e-maxheight=690px e-allowkeyboardnavigation=false e-width=900px e-closeonescape=true e-isresponsive=true e-enableanimation=true e-showroundedcorner=false e-target=#kiadottoldal><div class=col-xs-12 style="text-align: center; margin: 1.5em 0;"><cts-text-box name=IssueComment label=IssueAssetComment data-ng-model=vm.IssueComment validation-rules="{required: false, minlength: 0, maxlength: 200}"></cts-text-box><button class=cts-button ej-button e-click=vm.Issue id=IssueBtn translate>Issue</button> <button class=cts-button ej-button e-click=vm.IssueNewAsset id=IssueNewBtn translate>IssueNew</button></div><div class=col-xs-12><div id=AssetGrid class=slim-grid></div></div></div></div>');
$templateCache.put('app/athletes/athletesManagement/athleteModify/athletesBodyStat/athletesBodyStat.html','<div id=Tooltip1 style="display: none;"><div id=icon><div id=tticon></div></div><div id=value><div><label id=date>&nbsp;#point.x#</label><br><label id=tt1>&nbsp;#point.y#</label></div></div></div><div style=height:800px ej-chart id=Chart name=Chart data-ng-if="vm.data.length > 0" e-title-text=vm.chartText e-commonseriesoptions-marker-shape=circle e-commonseriesoptions-marker-size-height=5 e-commonseriesoptions-marker-size-width=5 e-commonseriesoptions-marker-visible=true e-commonseriesoptions-tooltip-visible=true e-commonseriesoptions-tooltip-template=Tooltip1 e-primaryxaxis-labelrotation=315><e-series><e-series e-name=vm.cm e-datasource=vm.data e-xname=datum e-yname=cm type=line fill=#00B711></e-series><e-series e-name=vm.kg e-datasource=vm.data e-xname=datum e-yname=kg type=line fill=#E63311></e-series><e-series e-name=vm.bmi e-datasource=vm.data e-xname=datum e-yname=bmi type=line fill=#0080FF></e-series></e-series></div>');
$templateCache.put('app/athletes/athletesManagement/athleteModify/athletesSportSpecificTestList/athletesSportSpecificTestList.html','<form class=filter name=form><div class=row><div style="overflow: hidden;"><cts-date-picker name=datefrom label=DateFrom change=vm.dateFromChange value=vm.dateFrom validation-rules="{required: true}"></cts-date-picker><cts-date-picker name=dateto label=DateTo change=vm.dateToChange value=vm.dateTo validation-rules="{required: true}"></cts-date-picker></div></div><script type=text/x-template id=sstlCoach><a data-ng-click="vm.goToUser(${EdzoId})">${EdzoNev}</a></script><script type=text/x-template id=sstlOpen><a data-ng-click="vm.goToTest(${SzakosztalyId},${KorcsoportId},${EdzoId},${FelmeroElemFejId},${Id_FF})">{{\'Megnyit\xE1s\'|translate}}</a></script><div class=row><div id=Grid class=slim-grid></div></div></form>');
$templateCache.put('app/athletes/athletesManagement/athleteModify/centralReportOfAthlete/centralReportOfAthlete.html','<div class=row><div id=Grid class=slim-grid></div></div>');
$templateCache.put('app/athletes/athletesManagement/athleteModify/competitionResultsChart/competitionResultsChart.html','<form class=filter name=form style="overflow: hidden;"><div class=row><cts-dropdown-list name=section label=Section datasource=vm.sectionList databound=vm.sectionDataBound change=vm.sectionSelect value=vm.sectionId></cts-dropdown-list><cts-dropdown-list name=ageGroup label=AgeGroup datasource=vm.ageGroupList databound=vm.ageGroupDataBound change=vm.ageGroupSelect value=vm.ageGroupId></cts-dropdown-list><cts-dropdown-list name=discipline label=Discipline datasource=vm.disciplineList databound=vm.disciplineDataBound change=vm.disciplineSelect value=vm.discipline></cts-dropdown-list></div><div class=row><cts-date-picker name=selectdateFrom label=DateFrom value=vm.selectdateFrom change=vm.selectdateFromChange></cts-date-picker><cts-date-picker name=selectdateTo label=DateTo value=vm.selectdateTo change=vm.selectdateToChange></cts-date-picker></div><div class=button-wrapper><button class=cts-button ej-button e-click=vm.filter translate>Filter</button></div></form><div class=row><div class=col-md-6><div style="height:400px; clear: both;" id=Chart1 name=Chart1></div></div><div class=col-md-6><div style="height:400px; clear: both;" id=Chart2 name=Chart2></div></div><div class=col-md-6><div style="height:400px; clear: both;" id=Chart3 name=Chart3></div></div><div class=col-md-6><div style="height:400px; clear: both;" id=Chart4 name=Chart4></div></div></div>');
$templateCache.put('app/athletes/athletesManagement/athleteModify/dataSheet/dataSheet.html','<form name=form novalidate enctype=multipart/form-data prevent-enter-submit><div class=row><div class=col-lg-12><div ej-accordion e-enablemultipleopen=true e-selecteditems=vm.selectedItems id=accordion name=accordion><h3><a href=# translate>AthleteDatasheet</a></h3><fieldset class=col-lg-8><cts-text-box name=name label=Name data-ng-model=vm.athleteData.Nev validation-rules="{required: true, minlength: 5, maxlength: 80}" disabled=!vm.allowEdit></cts-text-box><cts-dropdown-list name=gender label=Sex value=vm.sexNum datasource=vm.sexList select=vm.sexSelect databound=vm.sexDatabound validation-rules="{required: true}" enabled=vm.allowEdit></cts-dropdown-list><div class="form-group cts-form-group"><label translate>profilePic</label><div><div class=profileImg><img ng-src={{vm.photoUrl}} id=profilePic><div style="position: relative;"><button ng-show="vm.displayButtons && vm.allowEdit" class=cts-button type=button data-ng-click=vm.openCropDialog() translate>Modify</button> <button ng-show="vm.displayButtons && vm.allowEdit" class="cts-button cancel" type=button data-ng-click=vm.deleteImg() data-ng-disabled="vm.photoUrl === vm.noImage" translate>Delete</button></div></div></div></div><div class="form-group cts-form-group"><label for=sectionValue>{{"Section"|translate}}</label> <label id=sectionValue style="text-align: left; padding-left: 12px">{{vm.athleteData.SzakosztalyNev}}</label></div><div class="form-group cts-form-group"><label for=ageGroupValue>{{"AgeGroup"|translate}}</label> <label id=ageGroupValue style="text-align: left; padding-left: 12px">{{vm.athleteData.KorcsoportNeve}}</label></div><div ng-if=vm.MODKOROKEZ ng-show=vm.displayButtons class="cts-form-group form-group"><div class="col-md-8 col-md-offset-4"><button class=cts-button type=button id=changeAgeGroup ej-button e-click=vm.changeAgeGroup ng-show=vm.allowEdit translate>ChangeAgeGroup</button></div></div><div class="form-group cts-form-group"><label for=coachName>{{"CoachName"|translate}}</label> <label id=coachName style="text-align: left; padding-left: 12px">{{vm.athleteData.JelenlegiEdzoNev}}</label></div><div class="cts-form-group form-group" ng-if="vm.UJEDZVALT && vm.allowEdit" ng-show=vm.displayButtons><div class="col-md-8 col-md-offset-4"><button class=cts-button type=button id=changeCoach ej-button e-click=vm.selectCoachBtn translate>ChangeCoach</button></div></div><div ng-if=vm.isSecondCoach class="form-group cts-form-group"><label for=secondSection>{{"SecondSection"|translate}}</label> <label id=secondSection style="text-align: left; padding-left: 12px">{{vm.athleteData.MasodlagosSzakosztalyNev}}</label></div><cts-dropdown-list data-ng-if="!vm.SPORTOLO && !vm.isSecondCoach" name=secondSectionDropDown label=SecondSection value=athleteData.MasodlagosSzakosztaly datasource=vm.secondSectionList select=vm.secondSectionSelect clear=vm.clearSecondSection validation-rules="{required: false}" enabled=vm.allowEdit></cts-dropdown-list><div ng-if=vm.isSecondCoach class="form-group cts-form-group"><label for=secondAgeGroup>{{"SecondAgeGroup"|translate}}</label> <label id=secondAgeGroup style="text-align: left; padding-left: 12px">{{vm.athleteData.MasodlagosKorcsoportNev}}</label></div><cts-dropdown-list data-ng-if="!vm.SPORTOLO && !vm.isSecondCoach" name=secondAgeGroupDropDown label=SecondAgeGroup value=vm.athleteData.MasodlagosKorcsoport datasource=vm.secondAgeGroupList select=vm.secondAgeGroupSelect clear=vm.clearSecondAgeGroup validation-rules="{required: false}" enabled=vm.allowEdit></cts-dropdown-list><div ng-if="vm.isSecondCoach && vm.athleteData.MasodlagosbolKileptetett == false" ng-show=vm.displayButtons class="cts-form-group form-group"><div class="col-md-8 col-md-offset-4"><button class=cts-button type=button id=changeSecondAgeGroup ej-button e-click=vm.changeSecondAgeGroup e-enabled=vm.isSecondCoach translate>ChangeSecondAgeGroup</button></div></div><div ng-if="vm.isSecondCoach && vm.allowEdit" class="form-group cts-form-group"><label for=secondCoachName>{{"SecondCoachName"|translate}}</label> <label id=secondCoachName style="text-align: left; padding-left: 12px">{{vm.athleteData.MasodlagosSzakosztalyEdzoNev}}</label></div><div ng-if=vm.athleteData.MasodlagosbolKileptetett id=dateSpan class="form-group cts-form-group"><label for=secondExitDate>Kil\xE9ptet\xE9s d\xE1tuma</label> <label id=secondExitDate style="text-align: left; padding-left: 12px">{{vm.athleteData.MasodlagosbolKileptetesDatuma}}</label></div><cts-dropdown-list data-ng-if="!vm.SPORTOLO && !vm.isSecondCoach" name=secondCoachNameDropDown label=SecondCoachName value=vm.athleteData.MasodlagosSzakosztalyEdzoId datasource=vm.secondCoachList clear=vm.clearSecondCoach validation-rules="{required: false}" enabled=vm.allowEdit></cts-dropdown-list><div ng-if="vm.isSecondCoachChange && vm.allowEdit && vm.athleteData.MasodlagosbolKileptetett == false" ng-show=vm.displayButtons class="cts-form-group form-group"><div class="col-md-8 col-md-offset-4"><button class=cts-button type=button id=changeSecondCoach ej-button e-click=vm.selectSecondCoachBtn e-enabled=vm.isSecondCoach translate>ChangeSecondCoach</button> <button class=cts-button type=button id=changeSecondCoach ej-button e-click=vm.exitingSecondSectionBtn e-enabled=vm.isSecondCoach translate>ExitingSecondSection</button></div></div><cts-text-box name=bpcountry label=BirthPlaceCountry cts-placeholder=BirthPlaceCountry data-ng-model=vm.athleteData.SzuletesiHelyOrszag validation-rules="{required: true}" disabled=!vm.allowEdit></cts-text-box><cts-text-box name=bpcity label=BirthPlaceCity cts-placeholder=BirthPlaceCity data-ng-model=vm.athleteData.SzuletesiHelyVaros validation-rules="{required: true}" disabled=!vm.allowEdit></cts-text-box><cts-date-picker name=birthDate label=BirthDate value=vm.athleteData.SzuletesiIdo validation-rules="{required: true}" enabled=vm.allowEdit></cts-date-picker><cts-text-box name=motherBirthName data-ng-if=!vm.athleteRequiredMinimumDatas label=MotherBirthName data-ng-model=vm.athleteData.AnyjaLeanykoriNeve validation-rules="{required: true, minlength: 5, maxlength: 30}" disabled=!vm.allowEdit></cts-text-box><cts-text-box name=motherBirthName data-ng-if=vm.athleteRequiredMinimumDatas label=MotherBirthName data-ng-model=vm.athleteData.AnyjaLeanykoriNeve validation-rules="{required: false, maxlength: 30}" disabled=!vm.allowEdit></cts-text-box><cts-text-box name=citizenship data-ng-if=!vm.athleteRequiredMinimumDatas label=Citizenship data-ng-model=vm.athleteData.Allampolgarsag validation-rules="{required: true}" disabled=!vm.allowEdit></cts-text-box><cts-text-box name=citizenship data-ng-if=vm.athleteRequiredMinimumDatas label=Citizenship data-ng-model=vm.athleteData.Allampolgarsag validation-rules="{required: false}" disabled=!vm.allowEdit></cts-text-box><cts-numeric-text-box name=athleteHeightDropDown data-ng-if=!vm.athleteRequiredMinimumDatas label=Height value=vm.athleteData.Testmagassag datasource=vm.heightList select=vm.changeHeight validation-rules="{required: true}" enabled=vm.allowEdit></cts-numeric-text-box><cts-numeric-text-box name=athleteHeightDropDown data-ng-if=vm.athleteRequiredMinimumDatas label=Height value=vm.athleteData.Testmagassag datasource=vm.heightList select=vm.changeHeight validation-rules="{required: false}" enabled=vm.allowEdit></cts-numeric-text-box><cts-numeric-text-box name=currentHeight label=CurrentHeight enabled=false value=vm.athleteData.AktTestmagassag></cts-numeric-text-box><cts-numeric-text-box name=athleteWeightDropDown data-ng-if=!vm.athleteRequiredMinimumDatas label=Weight value=vm.athleteData.Testsuly datasource=vm.weightList select=vm.changeWeight validation-rules="{required: true}" enabled=vm.allowEdit></cts-numeric-text-box><cts-numeric-text-box name=athleteWeightDropDown data-ng-if=vm.athleteRequiredMinimumDatas label=Weight value=vm.athleteData.Testsuly datasource=vm.weightList select=vm.changeWeight validation-rules="{required: false}" enabled=vm.allowEdit></cts-numeric-text-box><cts-numeric-text-box name=currentWeight label=CurrentWeight enabled=false value=vm.athleteData.AktTestsuly></cts-numeric-text-box><cts-dropdown-list name=betterHandDropDown data-ng-if=!vm.athleteRequiredMinimumDatas label=BetterHand value=vm.athleteData.UgyesebbKezT datasource=vm.betterHandList select=vm.betterHandSelect change=vm.betterHandSelect validation-rules="{required: true}" enabled=vm.allowEdit></cts-dropdown-list><cts-dropdown-list name=betterHandDropDown data-ng-if=vm.athleteRequiredMinimumDatas label=BetterHand value=vm.athleteData.UgyesebbKezT datasource=vm.betterHandList select=vm.betterHandSelect change=vm.betterHandSelect validation-rules="{required: false}" enabled=vm.allowEdit></cts-dropdown-list><cts-dropdown-list name=betterFoot data-ng-if=!vm.athleteRequiredMinimumDatas label=BetterFoot value=vm.athleteData.UgyesebbLabT datasource=vm.betterFootList select=vm.betterFootSelect change=vm.betterFootSelect validation-rules="{required: true}" enabled=vm.allowEdit></cts-dropdown-list><cts-dropdown-list name=betterFoot data-ng-if=vm.athleteRequiredMinimumDatas label=BetterFoot value=vm.athleteData.UgyesebbLabT datasource=vm.betterFootList select=vm.betterFootSelect change=vm.betterFootSelect validation-rules="{required: false}" enabled=vm.allowEdit></cts-dropdown-list><cts-date-picker name=startSportDate data-ng-if=!vm.athleteRequiredMinimumDatas value=vm.athleteData.VersSportKezd label=StartSportDate validation-rules="{required: true}" enabled=vm.allowEdit></cts-date-picker><cts-date-picker name=startSportDate data-ng-if=vm.athleteRequiredMinimumDatas value=vm.athleteData.VersSportKezd label=StartSportDate validation-rules="{required: false}" enabled=vm.allowEdit></cts-date-picker><cts-date-picker name=startMemberDate value=vm.athleteData.DSITagsagKezdete label=StartMemberDate validation-rules="{required: true}" enabled="vm.allowEdit && !vm.SPORTOLO"></cts-date-picker><cts-check-box name=active label=Active enabled=false checked=vm.athleteData.Aktiv></cts-check-box><cts-text-box-taj-szam name=socialSecurityNumber data-ng-if="vm.socialSecurityNumberRequiredValue && vm.allowEdit" label=SocialSecurityNumber data-ng-model=vm.athleteData.TAJSzam validation-rules="{required: true}"></cts-text-box-taj-szam><cts-text-box-taj-szam name=socialSecurityNumber data-ng-if="!vm.socialSecurityNumberRequiredValue && vm.allowEdit" label=SocialSecurityNumber data-ng-model=vm.athleteData.TAJSzam validation-rules="{required: false}"></cts-text-box-taj-szam><cts-text-box data-ng-if="vm.athleteRegistrationNumberRequiredValue && vm.allowEdit" name=athleteRegistrationnumber label=AthleteRegistrationNumber data-ng-model=vm.athleteData.RegisztraciosSzam validation-rules="{required: true}"></cts-text-box><cts-date-picker name=medicalCertificateExpirationDate label=medicalCertificateExpirationDate value=vm.athleteData.SportorvosIgazolasLejarat enabled="vm.allowEdit && !vm.SPORTOLO"></cts-date-picker><cts-text-area ng-show="vm.allowEdit && !vm.SPORTOLO" data-ng-if=!vm.athleteRequiredMinimumDatas name=coachDetails label=CoachDetails data-ng-model=vm.athleteData.EddigiEdzoi css="padding-left:0; padding-right:0; width: 100%;" validation-rules="{required: true, maxlength: 4096}" owndisabled=!vm.allowEdit></cts-text-area><cts-text-area ng-show="vm.allowEdit && !vm.SPORTOLO" data-ng-if=vm.athleteRequiredMinimumDatas name=coachDetails label=CoachDetails data-ng-model=vm.athleteData.EddigiEdzoi css="padding-left:0; padding-right:0; width: 100%;" validation-rules="{required: false, maxlength: 4096}" owndisabled=!vm.allowEdit></cts-text-area><div class="form-group cts-form-group"><label for=feeOfEducation>{{"FeeOfEducation"|translate}}</label> <label id=feeOfEducation style="text-align: left; padding-left: 12px">{{vm.feeOfEducationValue}}</label></div><div class="cts-form-group form-group" ng-show=vm.displayButtons><div class="col-md-8 col-md-offset-4"><button class=cts-button type=button id=changeFee ej-button e-click=vm.changeFeeOfEducationBtn ng-show="vm.allowEdit && !vm.SPORTOLO" translate>ChangeFeeBtn</button></div></div><cts-text-box data-ng-if="!vm.athleteRegistrationNumberRequiredValue && vm.allowEdit" name=athleteRegistrationnumber label=AthleteRegistrationNumber data-ng-model=vm.athleteData.RegisztraciosSzam validation-rules="{required: false}"></cts-text-box><div class="cts-form-group form-group" ng-show=vm.displayButtons><div class="col-md-8 col-md-offset-4"><button class=cts-button type=button id=regnumgen ej-button e-click=vm.generateRegNum ng-show="vm.allowEdit && !vm.SPORTOLO" translate>GenerateRegNum</button></div></div><cts-text-box name=JatekEngedelySzama label=JatekEngedelySzama data-ng-model=vm.athleteData.JatekEngedelySzama disabled=!vm.allowEdit></cts-text-box></fieldset><h3><a href=# translate>Contact</a></h3><fieldset class="panel col-lg-8"><cts-dropdown-list name=county data-ng-if=!vm.athleteRequiredMinimumDatas label=County cts-placeholder=County value=vm.athleteData.LakcimMegye datasource=vm.countyList databound=vm.countyDataBound select=vm.countySelect validation-rules="{required: true}" enabled=vm.allowEdit></cts-dropdown-list><cts-dropdown-list name=county data-ng-if=vm.athleteRequiredMinimumDatas label=County cts-placeholder=County value=vm.athleteData.LakcimMegye datasource=vm.countyList databound=vm.countyDataBound select=vm.countySelect validation-rules="{required: false}" enabled=vm.allowEdit></cts-dropdown-list><cts-text-box name=zipCode data-ng-if=!vm.athleteRequiredMinimumDatas label=zipCode cts-placeholder=zipCode data-ng-model=vm.athleteData.LakcimIrSzam validation-rules="{required: true, minlength: 2, maxlength: 10}" disabled=!vm.allowEdit></cts-text-box><cts-text-box name=zipCode data-ng-if=vm.athleteRequiredMinimumDatas label=zipCode cts-placeholder=zipCode data-ng-model=vm.athleteData.LakcimIrSzam validation-rules="{required: false, maxlength: 10}" disabled=!vm.allowEdit></cts-text-box><cts-text-box name=city data-ng-if=!vm.athleteRequiredMinimumDatas label=City cts-placeholder=City data-ng-model=vm.athleteData.LakcimVaros validation-rules="{required: true, minlength: 2, maxlength: 50}" disabled=!vm.allowEdit></cts-text-box><cts-text-box name=city data-ng-if=vm.athleteRequiredMinimumDatas label=City cts-placeholder=City data-ng-model=vm.athleteData.LakcimVaros validation-rules="{required: false, maxlength: 50}" disabled=!vm.allowEdit></cts-text-box><cts-text-box name=street data-ng-if=!vm.athleteRequiredMinimumDatas label=Street cts-placeholder=Street data-ng-model=vm.athleteData.LakcimUtca validation-rules="{required: true, minlength: 1, maxlength: 50}" disabled=!vm.allowEdit></cts-text-box><cts-text-box name=street data-ng-if=vm.athleteRequiredMinimumDatas label=Street cts-placeholder=Street data-ng-model=vm.athleteData.LakcimUtca validation-rules="{required: false, maxlength: 50}" disabled=!vm.allowEdit></cts-text-box><cts-text-box name=streetNumber data-ng-if=!vm.athleteRequiredMinimumDatas label=StreetNumber cts-placeholder=StreetNumber data-ng-model=vm.athleteData.LakcimHazszam validation-rules="{required: true, minlength: 1, maxlength: 50}" disabled=!vm.allowEdit></cts-text-box><cts-text-box name=streetNumber data-ng-if=vm.athleteRequiredMinimumDatas label=StreetNumber cts-placeholder=StreetNumber data-ng-model=vm.athleteData.LakcimHazszam validation-rules="{required: false, maxlength: 50}" disabled=!vm.allowEdit></cts-text-box><cts-text-box name=phoneNumber data-ng-if=!vm.athleteRequiredMinimumDatas label=phoneNumber data-ng-model=vm.athleteData.Elerhetoseg validation-rules="{required: true}" disabled=!vm.allowEdit></cts-text-box><cts-text-box name=phoneNumber data-ng-if=vm.athleteRequiredMinimumDatas label=phoneNumber data-ng-model=vm.athleteData.Elerhetoseg validation-rules="{required: false}" disabled=!vm.allowEdit></cts-text-box><cts-text-box-email name=eMail label=Email data-ng-model=vm.athleteData.EmailCim enabled=vm.allowEdit></cts-text-box-email></fieldset><h3><a href=# translate>IdentificationNumbers</a></h3><fieldset class="panel col-lg-8"><cts-text-box name=personalId label=PersonalId data-ng-model=vm.athleteData.SzemIgSzam disabled=!vm.allowEdit></cts-text-box><cts-date-picker name=personalIdExpiration label=PersonalIdExpiration value=vm.athleteData.SzemelyiErvenyessege enabled=vm.allowEdit></cts-date-picker><cts-text-box name=taxId label=taxId data-ng-model=vm.athleteData.AdoSzam disabled=!vm.allowEdit></cts-text-box><cts-text-box name=passportNumber label=PassportNumber data-ng-model=vm.athleteData.UtlevelSzam disabled=!vm.allowEdit></cts-text-box><cts-date-picker name=passportExpiration label=PassportExpiration value=vm.athleteData.UtlevelErvenyessege enabled=vm.allowEdit></cts-date-picker></fieldset><h3><a href=# translate>ClothesSizes</a></h3><fieldset class="panel col-lg-8"><div><cts-text-box name=slippersSize label=SlipperSize ng-show=vm.RUHA.PAPUCS data-ng-model=vm.athleteData.PapucsMerete disabled=!vm.allowEdit></cts-text-box></div><div><cts-text-box name=shoeSize label=ShoeSize data-ng-model=vm.athleteData.CipoMerete ng-show=vm.RUHA.CIPO disabled=!vm.allowEdit></cts-text-box></div><div><cts-text-box name=joggingSuitSize label=JoggingSize ng-show=vm.RUHA.MELEGITO data-ng-model=vm.athleteData.MelegitoMerete disabled=!vm.allowEdit></cts-text-box></div><div><cts-text-box name=bathrobeSize label=BathrobeSize ng-show=vm.RUHA.FURDOKOPENY data-ng-model=vm.athleteData.FurdokopenyMerete disabled=!vm.allowEdit></cts-text-box></div><div><cts-text-box name=coatSize label=CoatSize data-ng-model=vm.athleteData.KabatMerete ng-show=vm.RUHA.KABAT disabled=!vm.allowEdit></cts-text-box></div><div><cts-text-box name=armorPantSize label=ArmorPantSize ng-show=vm.RUHA.PANCELNADRAG data-ng-model=vm.athleteData.PancelNadragMerete disabled=!vm.allowEdit></cts-text-box></div><div><cts-text-box name=tShirtSize label=TShirtSize data-ng-model=vm.athleteData.PoloMerete ng-show=vm.RUHA.POLO disabled=!vm.allowEdit></cts-text-box></div><div><cts-text-box name=shortDressSize label=ShortsSize ng-show=vm.RUHA.SORT data-ng-model=vm.athleteData.SortMerete disabled=!vm.allowEdit></cts-text-box></div><div><cts-text-box name=swimmingPantSize label=SwimmingPantSize ng-show=vm.RUHA.USZONADRAG data-ng-model=vm.athleteData.UszoNadragMerete disabled=!vm.allowEdit></cts-text-box></div></fieldset><h3><a href=# translate>SchoolDatas</a></h3><fieldset class=col-sm-12><div class="panel col-lg-8" ng-show=vm.displayButtons><div class="col-lg-12 col-lg-offset-6"><button class=cts-button type=button id=changeSchool ej-button e-click=vm.selectSchools ng-if=vm.allowEdit translate>SelectSchool</button></div></div><div class=hidedContent id=hidedContent><div class=slim-grid id=Grid></div></div><div class="panel col-lg-8"><cts-text-box name=schoolName label=SchoolName data-ng-model=vm.athleteData.IskolaNeve change=vm.schoolNameChanged data-ng-model-options="{debounce: 500}" validation-rules="{required: false, maxlength: 100}"></cts-text-box><cts-text-box name=schoolZipCode label=SchoolZipCode data-ng-model=vm.athleteData.IskolaIrSzam validation-rules="{required: false, maxlength: 5}"></cts-text-box><cts-text-box name=schoolCity label=SchoolCity data-ng-model=vm.athleteData.IskolaVaros></cts-text-box><cts-text-box name=schoolStreet label=SchoolStreet data-ng-model=vm.athleteData.IskolaUtca></cts-text-box><cts-text-box name=schoolStreetNumber label=SchoolStreetNumber data-ng-model=vm.athleteData.IskolaHazszam></cts-text-box><cts-text-box name=directorName label=DirectorName data-ng-model=vm.athleteData.IskolaIgazgatoNeve></cts-text-box><cts-auto-complete name=classMaster label=ClassMaster value=vm.athleteData.OsztalyFonokNeve datasource=vm.classMasterDatasource emptyresulttext=vm.emptyResultText show-popup-button=true change=vm.selectOf></cts-auto-complete><cts-text-box name=classMasterTel label=ClassMasterTel data-ng-model=vm.athleteData.OfTel></cts-text-box><cts-text-box-email name=classMasterEmail label=ClassMasterEmail enabled=vm.allowEdit data-ng-model=vm.athleteData.OfEmail></cts-text-box-email><cts-auto-complete name=gymTeacher label=GymTeacher value=vm.athleteData.TestneveloNeve datasource=vm.gymTeacherDatasource emptyresulttext=vm.emptyResultText show-popup-button=true change=vm.selectTesiTanar></cts-auto-complete><cts-text-box name=gymTeacherContact label=GymTeacherContact data-ng-model=vm.athleteData.TestneveloElerhetosege></cts-text-box><cts-text-box-email name=gymTeacherEmail label=GymTeacherEmail enabled=vm.allowEdit data-ng-model=vm.athleteData.TestneveloEmail></cts-text-box-email><cts-dropdown-list name=course label=Course value=vm.athleteData.IskolaEvfolyam datasource=vm.courseList enabled=vm.allowEdit></cts-dropdown-list><cts-dropdown-list name=class label=Class value=vm.athleteData.IskolaOsztaly datasource=vm.classList enabled=vm.allowEdit></cts-dropdown-list></div></fieldset><h3><a href=# translate>ParentDatas</a></h3><fieldset class="panel col-lg-8"><cts-auto-complete name=motherName label=MothersName value=vm.athleteData.AnyjaNeve datasource=vm.motherNames emptyresulttext=vm.emptyResultText show-popup-button=true enabled=vm.allowEdit validation-rules="{required: false, minlength: 5, maxlength: 30}" change=vm.selectMother></cts-auto-complete><cts-text-box name=motherContact label=MotherContact data-ng-model=vm.athleteData.Szulo1Elerhetosege disabled=!vm.allowEdit validation-rules="{required: false, minlength: 5, maxlength: 30}"></cts-text-box><cts-text-box-email name=motherEmail label=MotherEmail data-ng-model=vm.athleteData.AnyaEmail enabled=vm.allowEdit></cts-text-box-email><cts-numeric-text-box name=motherHeightDropDown label=Height value=vm.athleteData.AnyjaTestmagassaga validation-rules="{required: false}" enabled=vm.allowEdit></cts-numeric-text-box><cts-text-area name=MotherSportHistory label=MotherSportHistory data-ng-model=vm.athleteData.SportoloiMultAnya css="padding-left:0; padding-right:0; width: 100%;" owndisabled=!vm.allowEdit validation-rules="{required: false, maxlength: 4096}"></cts-text-area><cts-text-box name=mothersJob label=MothersJob data-ng-model=vm.athleteData.AnyjaFoglalkozasa validation-rules="{required: false, maxlength: 30}" disabled=!vm.allowEdit></cts-text-box><cts-text-box name=mothersWorkplace label=MothersWorkplace data-ng-model=vm.athleteData.AnyaMunkahely validation-rules="{required: false}" disabled=!vm.allowEdit></cts-text-box><cts-auto-complete name=fatherName label=FatherName value=vm.athleteData.SzuloNeve datasource=vm.fatherNames emptyresulttext=vm.emptyResultText show-popup-button=true enabled=vm.allowEdit validation-rules="{required: false, minlength: 5, maxlength: 30}" change=vm.selectFather></cts-auto-complete><cts-text-box name=fatherContact label=FatherContact data-ng-model=vm.athleteData.Szulo2Elerhetosege disabled=!vm.allowEdit validation-rules="{required: false, minlength: 5, maxlength: 30}"></cts-text-box><cts-text-box-email name=fatherEmail label=FatherEmail data-ng-model=vm.athleteData.ApaEmail enabled=vm.allowEdit></cts-text-box-email><cts-numeric-text-box name=fatherHeightDropDown label=Height value=vm.athleteData.ApjaTestmagassaga validation-rules="{required: false}" enabled=vm.allowEdit></cts-numeric-text-box><cts-text-area name=fatherSportHistory label=FatherSportHistory data-ng-model=vm.athleteData.SportoloiMultApa css="padding-left:0; padding-right:0; width: 100%;" validation-rules="{required: false, maxlength: 4096}" owndisabled=!vm.allowEdit></cts-text-area><cts-text-box name=fathersJob label=FathersJob data-ng-model=vm.athleteData.ApjaFoglalkozasa validation-rules="{required: false, maxlength: 30}" disabled=!vm.allowEdit></cts-text-box><cts-text-box name=fathersWorkplace label=FathersWorkplace data-ng-model=vm.athleteData.ApaMunkahely validation-rules="{required: false}" disabled=!vm.allowEdit></cts-text-box></fieldset><h3><a href=# translate>OtherDatas</a></h3><fieldset class="panel col-lg-8"><cts-numeric-text-box name=AtigazolasiDij label=AtigazolasiDij value=vm.athleteData.AtigazolasiDij validation-rules="{required: false}" enabled=vm.allowEdit></cts-numeric-text-box><cts-date-picker name=trainingStart label=TrainingStart value=vm.athleteData.EdzesreJarasKezdete validation-rules="{required: false}" enabled=vm.allowEdit></cts-date-picker><cts-text-area name=Notes label=Notes data-ng-model=vm.athleteData.Megjegyzes css="padding-left:0; padding-right:0; width: 100%;" validation-rules="{required: false, maxlength: 4096}" owndisabled=!vm.allowEdit></cts-text-area><cts-text-area name=SportAssociation label=SportAssociation data-ng-model=vm.athleteData.EddigiSpEgyesuletei css="padding-left:0; padding-right:0; width: 100%;" validation-rules="{required: false, maxlength: 4096}" owndisabled=!vm.allowEdit></cts-text-area><cts-text-box name=childAgeSport label=ChildageSport data-ng-model=vm.athleteData.GyermekkoriSport validation-rules="{required: false, minlength: 1, maxlength: 30}" disabled=!vm.allowEdit></cts-text-box><cts-text-box name=origin label=Origin data-ng-model=vm.athleteData.FajiEredet validation-rules="{required: false, minlength: 3, maxlength: 30}" disabled=!vm.allowEdit></cts-text-box><cts-text-box name=howSpentFreeTime label=HowSpentFreeTime data-ng-model=vm.athleteData.SzunideiElfoglaltsag validation-rules="{required: false, minlength: 1, maxlength: 30}" disabled=!vm.allowEdit></cts-text-box><cts-text-box name=birthName label=BirthName data-ng-model=vm.athleteData.LeanykoriNev validation-rules="{required: false, minlength: 5, maxlength: 30}" disabled=!vm.allowEdit></cts-text-box><cts-date-picker name=pubertasEndTime label=PubertasEndTime value=vm.athleteData.PubertasVege validation-rules="{required: false}" enabled=vm.allowEdit></cts-date-picker><cts-text-area name=AthleteExitNote label=AthleteExitNote data-ng-model=vm.athleteData.KilepesIndoka css="padding-left:0; padding-right:0; width: 100%;" validation-rules="{required: false, maxlength: 4096}" owndisabled=true></cts-text-area><cts-date-picker name=athleteExitTime label=athleteExitTime value=vm.athleteData.KilepesDatuma data-ng-model=vm.athleteData.KilepesDatuma enabled=false validation-rules="{required: false}"></cts-date-picker><cts-date-picker name=athleteReEnterTime label=athleteReEnterTime value=vm.athleteData.VisszalepesDatuma data-ng-model=vm.athleteData.VisszalepesDatuma enabled=false validation-rules="{required: false}"></cts-date-picker></fieldset><h3><a href=# translate>AthleteMoveStory</a></h3><fieldset class=col-sm-12><script id=atmotemplateDataColumn1 type=text/x-template><a data-ng-click="vm.openCoach(${EdzoId})">${Edzo}</a></script><div class=col-sm-12><div class=slim-grid id=Grid123></div></div></fieldset><h3><a href=# translate>UsersBelongingToAthlete</a></h3><fieldset class=col-sm-12><div class=col-sm-12 data-ng-if="!vm.SPORTOLO && !vm.SZULO && vm.allowEdit"><ul id=userRegMenuEvents ej-menu e-isresponsive=false data-ng-if=vm.UJFELH><li><a data-ng-click=vm.createLoginForAthlete() translate>CreateLoginForAthlete</a></li><li><a data-ng-click=vm.createLoginForParents() translate>CreateLoginForParents</a></li><li><a data-ng-click=vm.createLoginForExistingParent() translate>CreateLoginForExistingParent</a></li></ul></div><script id=atmotemplateDataColumn4 type=text/x-template><a data-ng-click="vm.openCoach(${UserID})">${UserTeljesNev}</a></script><script id=atmotemplateDataColumn5 type=text/x-template><a data-ng-click="vm.unlinkUserFromAthlete(${UserID},${SportoloID},${szerepint})" translate>unlinkUserFromAthlete</a></script><div class=form-group><div class=col-sm-12><div class=slim-grid id=GridUsersOfAthlete></div></div></div></fieldset></div></div></div><div class=col-lg-12 ng-show=vm.displayButtons style="text-align: center; margin-top: 1.5em;"><button type=submit class=cts-button ej-button e-click=vm.save translate>Save</button> <button type=reset class=cts-button ej-button e-click=back translate>Cancel</button></div></form><div id=dialogContainer class=dialogContainer><div class=modalCell><div id=cropDialog class=cropDialog ej-dialog e-title=vm.cropDialogTitle e-width=350 e-showoninit=false e-enablemodal=true e-enableresize=false e-allowkeyboardnavigation=false e-closeonescape=true e-close=vm.closeCropDialog e-isresponsive=true e-enableanimation=true e-content=#dialogContainer e-showroundedcorner=false><div class=text-center><div class=modal-body><div><label for=fileName class="cts-button pull-left" translate>ChooseImage</label> <input style="display: none;" type=file accept=image/* img-cropper-fileread image=vm.cropper.sourceImage id=fileName><div><canvas id=canvas width=300 height=300 image-cropper min-width=50 min-height=50 image=vm.cropper.sourceImage cropped-image=vm.cropper.croppedImage crop-width=300 crop-height=300 keep-aspect=true touch-radius=30 crop-area-bounds=vm.bounds></canvas></div></div></div><div class=modal-footer><button class="cts-button pull-left" data-ng-disabled=!vm.cropper.croppedImage data-ng-click=vm.doneCropDialog() type=submit style="min-width: 100px;">{{\'OK\'|translate}}</button> <button class="cts-button pull-left" data-ng-click=vm.closeCropDialog() type=button style="min-width: 100px; margin-left: 5px;">{{\'Cancel\'|translate}}</button></div></div></div></div></div>');
$templateCache.put('app/athletes/athletesManagement/athleteModify/files/files.html','<div class=col-xs-6><script id=fitemplateDataColumn1 type=text/x-template><a href="${Filenev}" target="_blank">${Megnevezes}</a></script><div id=Grid class=slim-grid></div></div><div class=col-xs-6 style=margin-top:15px><div class=clearfix></div><div style="overflow: hidden"><div class=posupload translate>Selectfile</div><br><div id=UploadDefault></div></div><div class=col-xs-6><button class="btn btn-primary post left-padding" id=delete data-ng-click=vm.deleteFile() type=button translate style="margin-top:20px; margin-left: -15px">Delete</button></div></div>');
$templateCache.put('app/athletes/athletesManagement/athleteModify/health/health.html','<div ui-view></div>');
$templateCache.put('app/athletes/athletesManagement/athleteModify/psychology/psychology.html','<div ui-view></div>');
$templateCache.put('app/athletes/athletesManagement/athleteModify/raceResultsReport/raceResultsReport.html','<script id=rareretemplateDataColumn1 type=text/x-template><a data-ng-click="vm.openAthlete(${SportoloId})">${SportoloNev}</a></script><script id=rareretemplateDataColumn2 type=text/x-template><a data-ng-click="vm.openCoach(${EdzoId})">${EdzoNeve}</a></script><script id=rareretemplateDataColumn3 type=text/x-template><a data-ng-click="vm.openResultReportAthletes(${Id})" translate>OpenIt</a></script><script id=rareretemplateDataColumn4 type=text/x-template><a data-ng-click="vm.printAthleteResult(${Id})" translate>Print</a></script><div class=row><h4 translate style="padding-left: 1em;">AthleteResults</h4><div class=col-lg-12><div id=Grid class=slim-grid></div></div></div><div class=row style="margin-top: 2em;"><h4 translate style="padding-left: 1em;">TeamResults</h4><script id=rareretemplateDataColumn5 type=text/x-template><a data-ng-click="vm.openTeam(${CsapatId})">${CsapatNev}</a></script><script id=rareretemplateDataColumn6 type=text/x-template><a data-ng-click="vm.openCoach(${EdzoId})">${EdzoNeve}</a></script><script id=rareretemplateDataColumn7 type=text/x-template><a data-ng-click="vm.openResultReportTeam(${Id})" translate>OpenIt</a></script><script id=rareretemplateDataColumn8 type=text/x-template><a data-ng-click="vm.printTeamResult(${Id})" translate>Print</a></script><div class=col-lg-12><div id=Grid2 class=slim-grid></div></div></div><div id=printDialogA ej-dialog e-height=95% e-width=95% e-showoninit=false e-enablemodal=true e-position-x=0 e-position-y=0 e-target=#mainContent e-enableresize=false><report report-name=TVersenyeredmenySportoloReport report-parameters=vm.reportParameters></report></div><div id=printDialogT ej-dialog e-height=95% e-width=95% e-showoninit=false e-enablemodal=true e-position-x=0 e-position-y=0 e-target=#mainContent e-enableresize=false><report report-name=TVersenyeredmenyCsapatReport report-parameters=vm.reportParameters></report></div>');
$templateCache.put('app/athletes/athletesManagement/athleteModify/trainingVisitReport/trainingVisitReport.html','<form name=form class=filter><div style="overflow: hidden;"><cts-dropdown-list name=maEv label=Year value=vm.selectedYear datasource=vm.years></cts-dropdown-list><div class=button-wrapper><button id=reportSelect class=cts-button ej-button e-click=vm.reportSelect translate>Select</button></div></div><script type=text/x-template id=AthleteColumnTemplate><a data-ng-click="vm.modifyAthletes(${VersenyzoId}, ${SzakosztalyId}, ${KorosztalyId})">${VersenyzoNeve}</a></script><div id=Grid class=slim-grid></div><div translate>TheReportContainsTheClosedDatas</div></form>');
$templateCache.put('app/athletes/athletesManagement/athleteModify/health/modifyHealthEvent/modifyHealthEvent.html','<form name=form class=filter><div style="overflow: hidden"><cts-text-box name=atheleteName label=Name ng-model=vm.athleteName validation-rules="{required: true}" disabled=true></cts-text-box><cts-text-box name=atheleteSocialSecurity label=SocialSecurityNumber ng-model=vm.athleteSocialSecurity disabled=true></cts-text-box><cts-text-box name=atheleteBirthDate label=BirthDate ng-model=vm.athleteBirthDate disabled=true></cts-text-box></div><div style="overflow: hidden"><cts-date-picker name=datepickerTol label=DateFrom value=vm.params.Mettol change=vm.dateFromChange validation-rules="{required: true}"></cts-date-picker><cts-date-picker name=datepickerIg label=DateTo value=vm.params.Meddig change=vm.dateToChange validation-rules="{required: false}"></cts-date-picker></div><div style="overflow: hidden"><cts-auto-complete name=MainType label=HealthEventType value=vm.params.Tipus change=vm.MainTypeSelected validation-rules="{required: true}" datasource=vm.healthMainType style="width: 100%" show-popup-button=true></cts-auto-complete><cts-auto-complete name=SubType label=HealthEventSubType value=vm.params.AlTipus datasource=vm.SubType style="width: 100%" show-popup-button=true></cts-auto-complete></div><div style="overflow: hidden"><cts-text-area name=description label=Description data-ng-model=vm.params.Leiras css="padding-left:10; padding-right:10; width: 50%;" validation-rules="{required: true, maxlength: 8192}" rows=15></cts-text-area><cts-text-area name=therapy label=Therapy data-ng-model=vm.params.Kezeles css="padding-left:10; padding-right:10; width: 50%;" validation-rules="{required: true, maxlength: 8192}" rows=15></cts-text-area></div><div class=button-wrapper><button type=submit id=saveDatas class=cts-button ej-button e-click=vm.saveDatas translate>Save</button> <button type=button id=documents class=cts-button ej-button e-click=vm.fileUpload translate>Documents</button> <button type=button id=back class=cts-button ej-button e-click=back translate>Back</button></div></form>');
$templateCache.put('app/athletes/athletesManagement/athleteModify/health/healthList/healthList.html','<form name=form class=filter><div style="overflow: hidden"><cts-text-box name=atheleteName label=Athlete ng-model=vm.athleteName owndisabled=true></cts-text-box><cts-text-box name=atheleteSocialSecurity label=SocialSecurityNumber ng-model=vm.athleteSocialSecurity disabled=true></cts-text-box><cts-text-box name=atheleteBirthDate label=BirthDate ng-model=vm.athleteBirthDate disabled=true></cts-text-box></div><div style="overflow: hidden"><cts-date-picker name=datepickerTol label=DateFrom value=vm.dateFrom change=vm.dateFromChange></cts-date-picker><cts-date-picker name=datepickerIg label=DateTo value=vm.dateTo change=vm.dateToChange></cts-date-picker><div class=button-wrapper style="clear: both;"><button ej-button id=addData class=cts-button type=button e-click=vm.goToNewHealthEvent e-enabled=vm.allowAddNew translate>AddNewEntry</button></div></div><script type=text/x-template id=healteditcolumnTemplate><a data-ng-click="vm.goToModifyHealthEvent(${Id})">{{vm.editText}}</a></script><div id=Grid class=slim-grid></div><div class=button-wrapper style="clear: both;"><button type=submit class=cts-button ej-button e-click=vm.backToDatasheet translate>Back</button></div></form>');
$templateCache.put('app/athletes/athletesManagement/athleteModify/health/newHealthEvent/newHealthEvent.html','<form name=form class=filter novalidate><div style="overflow: hidden"><cts-text-box name=atheleteName label=Name ng-model=vm.athleteName owndisabled=true></cts-text-box><cts-text-box name=atheleteSocialSecurity label=SocialSecurityNumber ng-model=vm.athleteSocialSecurity disabled=true></cts-text-box><cts-text-box name=atheleteBirthDate label=athleteBirthDate ng-model=vm.athleteBirthDate disabled=true></cts-text-box></div><div style="overflow: hidden"><cts-date-picker name=datepickerTol label=DateFrom value=vm.params.Mettol validation-rules="{required: true}"></cts-date-picker><cts-date-picker name=datepickerIg label=DateTo value=vm.params.Meddig validation-rules="{required: false}"></cts-date-picker><cts-auto-complete name=MainType label=HealthEventType value=vm.params.Tipus change=vm.MainTypeSelected validation-rules="{required: true}" datasource=vm.healthMainType style="width: 100%" show-popup-button=true></cts-auto-complete><cts-auto-complete name=SubType label=HealthEventSubType value=vm.params.AlTipus datasource=vm.SubType style="width: 100%" show-popup-button=true></cts-auto-complete></div><div style="overflow: hidden"><cts-text-area name=description label=Description data-ng-model=vm.params.Leiras css="padding-left:10; padding-right:10; width: 50%;" validation-rules="{required: true, maxlength: 8192}" rows=15></cts-text-area><cts-text-area name=therapy label=Therapy data-ng-model=vm.params.Kezeles css="padding-left:10; padding-right:10; width: 50%;" validation-rules="{required: true, maxlength: 8192}" rows=15></cts-text-area></div><div class=button-wrapper><button type=submit id=saveDatas class=cts-button ej-button e-click=vm.saveDatas translate>Save</button> <button type=button id=documents class=cts-button ej-button e-click=vm.fileUpload translate>Documents</button> <button type=button id=back class=cts-button ej-button e-click=back translate>Back</button></div></form>');
$templateCache.put('app/athletes/athletesManagement/athleteModify/psychology/performanceMotivationTest/performanceMotivationTest.html','<div class=psycho-test><div class=psycho-test-body><div class=description translate>PerformanceMotivationTestDescription</div><table><tr class=question-wrapper data-ng-repeat="question in vm.questions" data-ng-class="{\'not-filled\': vm.answers[$index] === -1}"><td class=question-index>{{$index + 1}}</td><td class=question>{{question}}</td><td class=answer data-ng-class="{selected: vm.answers[$index] === 1}" data-ng-click="vm.answers[$index] = 1"><span>1</span></td><td class=answer data-ng-class="{selected: vm.answers[$index] === 2}" data-ng-click="vm.answers[$index] = 2"><span>2</span></td><td class=answer data-ng-class="{selected: vm.answers[$index] === 3}" data-ng-click="vm.answers[$index] = 3"><span>3</span></td><td class=answer data-ng-class="{selected: vm.answers[$index] === 4}" data-ng-click="vm.answers[$index] = 4"><span>4</span></td><td class=answer data-ng-class="{selected: vm.answers[$index] === 5}" data-ng-click="vm.answers[$index] = 5"><span>5</span></td></tr></table><div class=col-sm-12 style="text-align: center"><button class=cts-button ej-button e-click=vm.saveSurvey translate>Save</button> <button class=cts-button ej-button e-click=back translate>Back</button></div></div></div>');
$templateCache.put('app/athletes/athletesManagement/athleteModify/psychology/performanceMotivationTestEvaluation/performanceMotivationTestEvaluation.html','<div class=psycho-test><div class=psycho-test-body><div class=test-header><p>{{\'Name\'|translate}}: {{vm.sportolo.nev}}</p><p>{{\'BirthDate\'|translate}}: {{vm.sportolo.szuletesiDatum}}</p><p>{{\'HisHerMothersName\'|translate}}: {{vm.sportolo.anyjaNeve}}</p><p>{{\'DateOfCompletion\'|translate}}: {{vm.kitoltesDatuma}}</p><p data-ng-if="vm.edit === true">{{\'DateOfEvaluation\'|translate}}: {{vm.kiertekelesDatuma}}</p></div><table class=test-survey><tr class=question-wrapper data-ng-repeat="question in vm.questions" data-ng-class="{\'not-filled\': vm.answers[$index] === -1}"><td class=question-index>{{$index + 1}}</td><td class=question>{{question}}</td><td class=answer data-ng-class="{selected: vm.answers[$index] === 1}"><span>1</span></td><td class=answer data-ng-class="{selected: vm.answers[$index] === 2}"><span>2</span></td><td class=answer data-ng-class="{selected: vm.answers[$index] === 3}"><span>3</span></td><td class=answer data-ng-class="{selected: vm.answers[$index] === 4}"><span>4</span></td><td class=answer data-ng-class="{selected: vm.answers[$index] === 5}"><span>5</span></td></tr></table><div class=test-evaluation style="margin-bottom: 1rem;"><p>{{\'Procrastination\'|translate}}: {{vm.kiertekelesSzam[0]}}</p><p>{{\'FearOfSuccess\'|translate}}: {{vm.kiertekelesSzam[1]}}</p><p style="margin-bottom: 1em !important;">{{\'Toughness\'|translate}}: {{vm.kiertekelesSzam[2]}}</p><textarea ej-rte e-width=100% id=rteSample rows=10 cols=30></textarea></div><div class=col-sm-12 style="text-align: center"><button class=cts-button ej-button e-click=vm.saveEval translate>Save</button> <button class=cts-button ej-button e-click=back translate>Back</button></div></div></div>');
$templateCache.put('app/athletes/athletesManagement/athleteModify/psychology/pieronTest/pieronTest.html','<div class="psycho-test pieron"><div class=psycho-test-body><div class=description><label for=testTime style="float: left; margin-right: 1em; margin-top: 0.3em" translate>TestsTime</label> <input id=testTime ej-numerictextbox e-value=vm.time e-minvalue=1 e-maxvalue=15 e-change=vm.timeChanged type=text style="float:left; margin-top: 0.15em;"> <button class=cts-button ej-button e-click=vm.startInterval data-ng-if="vm.started === false" style="margin-left: 1em;" translate>Start</button> <button class=cts-button ej-button e-click=vm.stopInterval data-ng-if="vm.started === true && vm.finished === false" style="margin-left: 1em;" translate>Stop</button> <button class=cts-button ej-button e-click=vm.saveSurvey data-ng-if="vm.started === true && vm.finished === true" style="margin-left: 1em;" translate>Save</button> <button class=cts-button ej-button e-click=back style="margin-left: 1em;" translate>Back</button></div><h2 data-ng-if="vm.started === true && vm.finished === false" style="margin: 1em 0; clear: both;" translate>PieronTestStarted</h2><p style="margin-bottom: 1em; margin-top: 0.5em;"><span translate>TimeLeft</span>: {{vm.timeLeftMinutes}}:{{vm.timeLeftSeconds}}</p><p><span translate>FindThese</span>: <img src=images/pieron1.png><img src=images/pieron4.png><img src=images/pieron7.png><img src=images/pieron5.png></p><table class=pieron-table style="margin-top: 1em;"><tr class=question-wrapper data-ng-repeat="question in vm.questions" data-ng-class="{\'not-filled\': vm.answers[$index] === -1}"><td class=answer data-ng-repeat="image in question" data-ng-class="{selected: vm.answers[$parent.$index][$index] === 1, \'selected-green\': vm.answers[$parent.$index][$index] === 2 || vm.answers[$parent.$index][$index] === 3, \'selected-red\': vm.answers[$parent.$index][$index] === -1 || vm.answers[$parent.$index][$index] === 4, \'selected-minutes-good\': vm.answers[$parent.$index][$index] === 3, \'selected-minutes-bad\': vm.answers[$parent.$index][$index] === 4, \'selected-minutes\': vm.answers[$parent.$index][$index] === 5}" data-ng-click="vm.clicked($parent.$index, $index)"><span><img src={{image.url}}></span></td></tr></table></div></div>');
$templateCache.put('app/athletes/athletesManagement/athleteModify/psychology/pieronTestEvaluation/pieronTestEvaluation.html','<div class="psycho-test pieron"><div class=psycho-test-body><div class=test-header><p>{{\'Name\'|translate}}: {{vm.sportolo.nev}}</p><p>{{\'BirthDate\'|translate}}: {{vm.sportolo.szuletesiDatum}}</p><p>{{\'HisHerMothersName\'|translate}}: {{vm.sportolo.anyjaNeve}}</p><p style="margin-bottom: 1em !important;">{{\'Age\'|translate}}: {{vm.age}}</p><p>{{\'DateOfCompletion\'|translate}}: {{vm.kitoltesDatuma}}</p><p data-ng-if="vm.edit === true">{{\'DateOfEvalueation\'|translate}}: {{vm.kiertekelesDatuma}}</p></div><table class=pieron-table style="margin-top: 1em;"><tr class=question-wrapper data-ng-repeat="question in vm.questions" data-ng-class="{\'not-filled\': vm.answers[$index] === -1}"><td class=answer data-ng-repeat="image in question" data-ng-class="{selected: vm.answers[$parent.$index][$index] === 1, \'selected-green\': vm.answers[$parent.$index][$index] === 2 || vm.answers[$parent.$index][$index] === 3, \'selected-red\': vm.answers[$parent.$index][$index] === -1 || vm.answers[$parent.$index][$index] === 4, \'selected-minutes-good\': vm.answers[$parent.$index][$index] === 3, \'selected-minutes-bad\': vm.answers[$parent.$index][$index] === 4, \'selected-minutes\': vm.answers[$parent.$index][$index] === 5}" data-ng-click="vm.clicked($parent.$index, $index)"><span><img src={{image.url}}></span></td></tr></table><div class=test-evaluation style="margin-bottom: 1rem;"><p>{{\'Seen\'|translate}}: {{vm.seen}} - {{vm.ertek[0]}}</p><p>{{\'tNumber\'|translate}}: {{vm.tNumber}} - {{vm.ertek[1]}}</p><p>{{\'wrongAnswersNumber\'|translate}}: {{vm.wrongAnswersNumber}}</p><textarea ej-rte e-width=100% id=rteSample rows=10 cols=30></textarea></div><div class=col-sm-12 style="text-align: center"><button class=cts-button ej-button e-click=vm.saveEval translate>Save</button> <button class=cts-button ej-button e-click=back translate>Back</button></div></div></div>');
$templateCache.put('app/athletes/athletesManagement/athleteModify/psychology/summary/summary.html','<div class=button-wrapper style="margin-bottom: 1rem;"><div class=dropdown><button class="btn btn-primary dropdown-toggle" type=button id=dropdownMenu data-toggle=dropdown aria-haspopup=true aria-expanded=true><i class="glyphicon glyphicon-plus"></i> <span translate>NewPsychologyTest</span> <span class=caret></span></button><ul class=dropdown-menu aria-labelledby=dropdownMenu><li><a data-ng-click=vm.goToPerformanceMotivation() translate>PerformanceMotivation</a></li><li><a data-ng-click=vm.goToTenessee() translate>Tenessee</a></li><li><a data-ng-click=vm.goToPieron() translate>Pieron</a></li><li><a href=images/wartegg.jpg target=_blank data-ng-click=vm.addWartegTest() download translate>Wartegg</a></li></ul></div></div><script id=sutemplateDataColumn1 type=text/x-template><a data-ng-click="vm.goToShowFilledTest(${Id}, ${typeId}, false)" >{{vm.open}}</a></script><script id=sutemplateDataColumn2 type=text/x-template><span >${dateOfAssessment}</span></script><script id=sutemplateDataColumn3 type=text/x-template><span ><a data-ng-click="vm.goToShowFilledTest(${Id}, ${typeId}, true, ${documentOfAssessmentBool})">${documentOfAssessment}</a></span></script><div class=row><div id=Grid class=slim-grid></div></div>');
$templateCache.put('app/athletes/athletesManagement/athleteModify/psychology/tenesseeSelfImageScale/tenesseeSelfImageScale.html','<div class=psycho-test><div class=psycho-test-body><div class=description translate>TenesseeSelfImageScaleDescription</div><table><tr class=question-wrapper data-ng-repeat="question in vm.questions" data-ng-class="{\'not-filled\': vm.answers[$index] === -1}"><td class=question-index>{{$index + 1}}</td><td class=question>{{question}}</td><td class=answer data-ng-class="{selected: vm.answers[$index] === 1}" data-ng-click="vm.answers[$index] = 1"><span>1</span></td><td class=answer data-ng-class="{selected: vm.answers[$index] === 2}" data-ng-click="vm.answers[$index] = 2"><span>2</span></td><td class=answer data-ng-class="{selected: vm.answers[$index] === 3}" data-ng-click="vm.answers[$index] = 3"><span>3</span></td><td class=answer data-ng-class="{selected: vm.answers[$index] === 4}" data-ng-click="vm.answers[$index] = 4"><span>4</span></td><td class=answer data-ng-class="{selected: vm.answers[$index] === 5}" data-ng-click="vm.answers[$index] = 5"><span>5</span></td></tr></table><div class=col-sm-12 style="text-align: center"><button class=cts-button ej-button e-click=vm.saveSurvey translate>Save</button> <button class=cts-button ej-button e-click=back translate>Back</button></div></div></div>');
$templateCache.put('app/athletes/athletesManagement/athleteModify/psychology/tenesseeSelfImageScaleEvaluation/tenesseeSelfImageScaleEvaluation.html','<div class=psycho-test><div class=psycho-test-body><table><tr class=question-wrapper data-ng-repeat="question in vm.questions"><td class=question-index>{{$index + 1}}</td><td class=question>{{question}}</td><td class=answer data-ng-class="{selected: vm.answers[$index] === 1}"><span>1</span></td><td class=answer data-ng-class="{selected: vm.answers[$index] === 2}"><span>2</span></td><td class=answer data-ng-class="{selected: vm.answers[$index] === 3}"><span>3</span></td><td class=answer data-ng-class="{selected: vm.answers[$index] === 4}"><span>4</span></td><td class=answer data-ng-class="{selected: vm.answers[$index] === 5}"><span>5</span></td></tr></table><br><div class=test-evaluation style="margin-bottom: 1rem;"><p>{{\'Testkep\'|translate}}: {{vm.kiertekelesSzam[0]}} ( <b>{{vm.kiertekelesSzamMagyarazat[0]}}</b> )</p><p>{{\'MoralisEnkep\'|translate}}: {{vm.kiertekelesSzam[1]}} ( <b>{{vm.kiertekelesSzamMagyarazat[1]}}</b> )</p><p>{{\'IndividualisEnkep\'|translate}}: {{vm.kiertekelesSzam[2]}} ( <b>{{vm.kiertekelesSzamMagyarazat[2]}}</b>)</p><p>{{\'CsaladiEnkep\'|translate}}: {{vm.kiertekelesSzam[3]}} ( <b>{{vm.kiertekelesSzamMagyarazat[3]}}</b> )</p><p>{{\'SzocialisEnkep\'|translate}}: {{vm.kiertekelesSzam[4]}} ( <b>{{vm.kiertekelesSzamMagyarazat[4]}}</b> )</p><p>{{\'Enkep\'|translate}}: {{vm.kiertekelesSzam[5]}} ( <b>{{vm.kiertekelesSzamMagyarazat[5]}}</b> )</p><p style="margin-bottom: 1em !important;">{{\'Onkritika\'|translate}}: {{vm.kiertekelesSzam[5]}}</p><textarea ej-rte e-width=100% id=rteSample rows=10 cols=30></textarea></div><div class=col-sm-12 style="text-align: center"><button class=cts-button ej-button e-click=vm.saveEval translate>Save</button> <button class=cts-button ej-button e-click=back translate>Back</button></div></div></div>');
$templateCache.put('app/athletes/athletesManagement/athleteModify/psychology/wartegg/wartegg.html','<div class=widget-head><h2 class=page-title>{{title}}</h2></div><div class=widget-content><div class="col-sm-12 col-md-12 col-lg-12"><form style="text-align:center; width:100%"><img data-ng-show=vm.kiertekelt src={{vm.kepfajl}} style="width:500px; margin:0 0 1rem 0;" alt=wartegg.jpg> <input data-ng-show=!vm.kiertekelt name=file id=file type=file style="margin:0 0 1rem 0;"> <textarea ej-rte e-width=100% id=rteSample rows=10 cols=30 e-enabled=vm.allowEdit></textarea><div style="margin-top: 1rem;"><button class=cts-button ej-button e-click=vm.upload e-enabled=vm.allowEdit translate>Save</button> <button class=cts-button ej-button e-click=back translate>Back</button></div></form></div></div>');}]);